var RV = Object.defineProperty;
var DV = (e, t, n) => t in e ? RV(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var qs = (e, t, n) => (DV(e, typeof t != "symbol" ? t + "" : t, n), n);
import * as Ee from "react";
import tt, { Children as Ad, isValidElement as Ol, createContext as ea, useContext as Yn, useRef as Ve, useEffect as st, useCallback as Q, useState as He, useId as Lo, useLayoutEffect as Cc, useMemo as bt, useInsertionEffect as lS, forwardRef as Ke, createElement as uS, cloneElement as Yo, memo as PV, useSyncExternalStore as EV, Fragment as Ml, PureComponent as TV, Component as NV } from "react";
import { __unsafe_useEmotionCache as kV, Global as bh, ThemeProvider as VV, ThemeContext as OV, keyframes as Md, jsx as nt, css as cS } from "@emotion/react";
import FV from "@emotion/styled";
import { createPortal as G3 } from "react-dom";
import { schAloftPriceJSON as qn, AloftDate as rr, AloftTime as wi, AloftArea as Dt, AloftPrice as Yt, AloftCount as gt, schAloftTimeJSON as BV, schAloftAreaJSON as Aa } from "@aloft/shared-objects";
var di = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function yh(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var m5 = { exports: {} }, a1 = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Cv;
function HV() {
  if (Cv)
    return a1;
  Cv = 1;
  var e = tt, t = Symbol.for("react.element"), n = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, o = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, a = { key: !0, ref: !0, __self: !0, __source: !0 };
  function i(l, u, d) {
    var f, h = {}, p = null, g = null;
    d !== void 0 && (p = "" + d), u.key !== void 0 && (p = "" + u.key), u.ref !== void 0 && (g = u.ref);
    for (f in u)
      r.call(u, f) && !a.hasOwnProperty(f) && (h[f] = u[f]);
    if (l && l.defaultProps)
      for (f in u = l.defaultProps, u)
        h[f] === void 0 && (h[f] = u[f]);
    return { $$typeof: t, type: l, key: p, ref: g, props: h, _owner: o.current };
  }
  return a1.Fragment = n, a1.jsx = i, a1.jsxs = i, a1;
}
var i1 = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var bv;
function GV() {
  return bv || (bv = 1, process.env.NODE_ENV !== "production" && function() {
    var e = tt, t = Symbol.for("react.element"), n = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), a = Symbol.for("react.profiler"), i = Symbol.for("react.provider"), l = Symbol.for("react.context"), u = Symbol.for("react.forward_ref"), d = Symbol.for("react.suspense"), f = Symbol.for("react.suspense_list"), h = Symbol.for("react.memo"), p = Symbol.for("react.lazy"), g = Symbol.for("react.offscreen"), C = Symbol.iterator, v = "@@iterator";
    function y(B) {
      if (B === null || typeof B != "object")
        return null;
      var Ae = C && B[C] || B[v];
      return typeof Ae == "function" ? Ae : null;
    }
    var M = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function x(B) {
      {
        for (var Ae = arguments.length, Oe = new Array(Ae > 1 ? Ae - 1 : 0), ut = 1; ut < Ae; ut++)
          Oe[ut - 1] = arguments[ut];
        _("error", B, Oe);
      }
    }
    function _(B, Ae, Oe) {
      {
        var ut = M.ReactDebugCurrentFrame, It = ut.getStackAddendum();
        It !== "" && (Ae += "%s", Oe = Oe.concat([It]));
        var Kt = Oe.map(function(Vt) {
          return String(Vt);
        });
        Kt.unshift("Warning: " + Ae), Function.prototype.apply.call(console[B], console, Kt);
      }
    }
    var L = !1, R = !1, k = !1, P = !1, N = !1, O;
    O = Symbol.for("react.module.reference");
    function H(B) {
      return !!(typeof B == "string" || typeof B == "function" || B === r || B === a || N || B === o || B === d || B === f || P || B === g || L || R || k || typeof B == "object" && B !== null && (B.$$typeof === p || B.$$typeof === h || B.$$typeof === i || B.$$typeof === l || B.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      B.$$typeof === O || B.getModuleId !== void 0));
    }
    function $(B, Ae, Oe) {
      var ut = B.displayName;
      if (ut)
        return ut;
      var It = Ae.displayName || Ae.name || "";
      return It !== "" ? Oe + "(" + It + ")" : Oe;
    }
    function ne(B) {
      return B.displayName || "Context";
    }
    function ie(B) {
      if (B == null)
        return null;
      if (typeof B.tag == "number" && x("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof B == "function")
        return B.displayName || B.name || null;
      if (typeof B == "string")
        return B;
      switch (B) {
        case r:
          return "Fragment";
        case n:
          return "Portal";
        case a:
          return "Profiler";
        case o:
          return "StrictMode";
        case d:
          return "Suspense";
        case f:
          return "SuspenseList";
      }
      if (typeof B == "object")
        switch (B.$$typeof) {
          case l:
            var Ae = B;
            return ne(Ae) + ".Consumer";
          case i:
            var Oe = B;
            return ne(Oe._context) + ".Provider";
          case u:
            return $(B, B.render, "ForwardRef");
          case h:
            var ut = B.displayName || null;
            return ut !== null ? ut : ie(B.type) || "Memo";
          case p: {
            var It = B, Kt = It._payload, Vt = It._init;
            try {
              return ie(Vt(Kt));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var re = Object.assign, ve = 0, ue, j, K, ce, U, q, ge;
    function X() {
    }
    X.__reactDisabledLog = !0;
    function he() {
      {
        if (ve === 0) {
          ue = console.log, j = console.info, K = console.warn, ce = console.error, U = console.group, q = console.groupCollapsed, ge = console.groupEnd;
          var B = {
            configurable: !0,
            enumerable: !0,
            value: X,
            writable: !0
          };
          Object.defineProperties(console, {
            info: B,
            log: B,
            warn: B,
            error: B,
            group: B,
            groupCollapsed: B,
            groupEnd: B
          });
        }
        ve++;
      }
    }
    function me() {
      {
        if (ve--, ve === 0) {
          var B = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: re({}, B, {
              value: ue
            }),
            info: re({}, B, {
              value: j
            }),
            warn: re({}, B, {
              value: K
            }),
            error: re({}, B, {
              value: ce
            }),
            group: re({}, B, {
              value: U
            }),
            groupCollapsed: re({}, B, {
              value: q
            }),
            groupEnd: re({}, B, {
              value: ge
            })
          });
        }
        ve < 0 && x("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var de = M.ReactCurrentDispatcher, Le;
    function Ie(B, Ae, Oe) {
      {
        if (Le === void 0)
          try {
            throw Error();
          } catch (It) {
            var ut = It.stack.trim().match(/\n( *(at )?)/);
            Le = ut && ut[1] || "";
          }
        return `
` + Le + B;
      }
    }
    var Ne = !1, ye;
    {
      var ke = typeof WeakMap == "function" ? WeakMap : Map;
      ye = new ke();
    }
    function oe(B, Ae) {
      if (!B || Ne)
        return "";
      {
        var Oe = ye.get(B);
        if (Oe !== void 0)
          return Oe;
      }
      var ut;
      Ne = !0;
      var It = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var Kt;
      Kt = de.current, de.current = null, he();
      try {
        if (Ae) {
          var Vt = function() {
            throw Error();
          };
          if (Object.defineProperty(Vt.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(Vt, []);
            } catch (Qn) {
              ut = Qn;
            }
            Reflect.construct(B, [], Vt);
          } else {
            try {
              Vt.call();
            } catch (Qn) {
              ut = Qn;
            }
            B.call(Vt.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Qn) {
            ut = Qn;
          }
          B();
        }
      } catch (Qn) {
        if (Qn && ut && typeof Qn.stack == "string") {
          for (var Et = Qn.stack.split(`
`), or = ut.stack.split(`
`), xn = Et.length - 1, Dn = or.length - 1; xn >= 1 && Dn >= 0 && Et[xn] !== or[Dn]; )
            Dn--;
          for (; xn >= 1 && Dn >= 0; xn--, Dn--)
            if (Et[xn] !== or[Dn]) {
              if (xn !== 1 || Dn !== 1)
                do
                  if (xn--, Dn--, Dn < 0 || Et[xn] !== or[Dn]) {
                    var zn = `
` + Et[xn].replace(" at new ", " at ");
                    return B.displayName && zn.includes("<anonymous>") && (zn = zn.replace("<anonymous>", B.displayName)), typeof B == "function" && ye.set(B, zn), zn;
                  }
                while (xn >= 1 && Dn >= 0);
              break;
            }
        }
      } finally {
        Ne = !1, de.current = Kt, me(), Error.prepareStackTrace = It;
      }
      var La = B ? B.displayName || B.name : "", pr = La ? Ie(La) : "";
      return typeof B == "function" && ye.set(B, pr), pr;
    }
    function lt(B, Ae, Oe) {
      return oe(B, !1);
    }
    function Re(B) {
      var Ae = B.prototype;
      return !!(Ae && Ae.isReactComponent);
    }
    function _t(B, Ae, Oe) {
      if (B == null)
        return "";
      if (typeof B == "function")
        return oe(B, Re(B));
      if (typeof B == "string")
        return Ie(B);
      switch (B) {
        case d:
          return Ie("Suspense");
        case f:
          return Ie("SuspenseList");
      }
      if (typeof B == "object")
        switch (B.$$typeof) {
          case u:
            return lt(B.render);
          case h:
            return _t(B.type, Ae, Oe);
          case p: {
            var ut = B, It = ut._payload, Kt = ut._init;
            try {
              return _t(Kt(It), Ae, Oe);
            } catch {
            }
          }
        }
      return "";
    }
    var on = Object.prototype.hasOwnProperty, $e = {}, Zt = M.ReactDebugCurrentFrame;
    function Pt(B) {
      if (B) {
        var Ae = B._owner, Oe = _t(B.type, B._source, Ae ? Ae.type : null);
        Zt.setExtraStackFrame(Oe);
      } else
        Zt.setExtraStackFrame(null);
    }
    function yt(B, Ae, Oe, ut, It) {
      {
        var Kt = Function.call.bind(on);
        for (var Vt in B)
          if (Kt(B, Vt)) {
            var Et = void 0;
            try {
              if (typeof B[Vt] != "function") {
                var or = Error((ut || "React class") + ": " + Oe + " type `" + Vt + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof B[Vt] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw or.name = "Invariant Violation", or;
              }
              Et = B[Vt](Ae, Vt, ut, Oe, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (xn) {
              Et = xn;
            }
            Et && !(Et instanceof Error) && (Pt(It), x("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", ut || "React class", Oe, Vt, typeof Et), Pt(null)), Et instanceof Error && !(Et.message in $e) && ($e[Et.message] = !0, Pt(It), x("Failed %s type: %s", Oe, Et.message), Pt(null));
          }
      }
    }
    var jt = Array.isArray;
    function An(B) {
      return jt(B);
    }
    function Rn(B) {
      {
        var Ae = typeof Symbol == "function" && Symbol.toStringTag, Oe = Ae && B[Symbol.toStringTag] || B.constructor.name || "Object";
        return Oe;
      }
    }
    function Er(B) {
      try {
        return Ar(B), !1;
      } catch {
        return !0;
      }
    }
    function Ar(B) {
      return "" + B;
    }
    function oa(B) {
      if (Er(B))
        return x("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Rn(B)), Ar(B);
    }
    var fr = M.ReactCurrentOwner, De = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Xt, Nn, Kn;
    Kn = {};
    function Jr(B) {
      if (on.call(B, "ref")) {
        var Ae = Object.getOwnPropertyDescriptor(B, "ref").get;
        if (Ae && Ae.isReactWarning)
          return !1;
      }
      return B.ref !== void 0;
    }
    function aa(B) {
      if (on.call(B, "key")) {
        var Ae = Object.getOwnPropertyDescriptor(B, "key").get;
        if (Ae && Ae.isReactWarning)
          return !1;
      }
      return B.key !== void 0;
    }
    function ks(B, Ae) {
      if (typeof B.ref == "string" && fr.current && Ae && fr.current.stateNode !== Ae) {
        var Oe = ie(fr.current.type);
        Kn[Oe] || (x('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', ie(fr.current.type), B.ref), Kn[Oe] = !0);
      }
    }
    function Vs(B, Ae) {
      {
        var Oe = function() {
          Xt || (Xt = !0, x("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", Ae));
        };
        Oe.isReactWarning = !0, Object.defineProperty(B, "key", {
          get: Oe,
          configurable: !0
        });
      }
    }
    function uo(B, Ae) {
      {
        var Oe = function() {
          Nn || (Nn = !0, x("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", Ae));
        };
        Oe.isReactWarning = !0, Object.defineProperty(B, "ref", {
          get: Oe,
          configurable: !0
        });
      }
    }
    var _a = function(B, Ae, Oe, ut, It, Kt, Vt) {
      var Et = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: B,
        key: Ae,
        ref: Oe,
        props: Vt,
        // Record the component responsible for creating this element.
        _owner: Kt
      };
      return Et._store = {}, Object.defineProperty(Et._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(Et, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: ut
      }), Object.defineProperty(Et, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: It
      }), Object.freeze && (Object.freeze(Et.props), Object.freeze(Et)), Et;
    };
    function Pc(B, Ae, Oe, ut, It) {
      {
        var Kt, Vt = {}, Et = null, or = null;
        Oe !== void 0 && (oa(Oe), Et = "" + Oe), aa(Ae) && (oa(Ae.key), Et = "" + Ae.key), Jr(Ae) && (or = Ae.ref, ks(Ae, It));
        for (Kt in Ae)
          on.call(Ae, Kt) && !De.hasOwnProperty(Kt) && (Vt[Kt] = Ae[Kt]);
        if (B && B.defaultProps) {
          var xn = B.defaultProps;
          for (Kt in xn)
            Vt[Kt] === void 0 && (Vt[Kt] = xn[Kt]);
        }
        if (Et || or) {
          var Dn = typeof B == "function" ? B.displayName || B.name || "Unknown" : B;
          Et && Vs(Vt, Dn), or && uo(Vt, Dn);
        }
        return _a(B, Et, or, It, ut, fr.current, Vt);
      }
    }
    var Gi = M.ReactCurrentOwner, Wl = M.ReactDebugCurrentFrame;
    function Ro(B) {
      if (B) {
        var Ae = B._owner, Oe = _t(B.type, B._source, Ae ? Ae.type : null);
        Wl.setExtraStackFrame(Oe);
      } else
        Wl.setExtraStackFrame(null);
    }
    var Do;
    Do = !1;
    function Os(B) {
      return typeof B == "object" && B !== null && B.$$typeof === t;
    }
    function Po() {
      {
        if (Gi.current) {
          var B = ie(Gi.current.type);
          if (B)
            return `

Check the render method of \`` + B + "`.";
        }
        return "";
      }
    }
    function Ec(B) {
      {
        if (B !== void 0) {
          var Ae = B.fileName.replace(/^.*[\\\/]/, ""), Oe = B.lineNumber;
          return `

Check your code at ` + Ae + ":" + Oe + ".";
        }
        return "";
      }
    }
    var zl = {};
    function Ul(B) {
      {
        var Ae = Po();
        if (!Ae) {
          var Oe = typeof B == "string" ? B : B.displayName || B.name;
          Oe && (Ae = `

Check the top-level render call using <` + Oe + ">.");
        }
        return Ae;
      }
    }
    function Xl(B, Ae) {
      {
        if (!B._store || B._store.validated || B.key != null)
          return;
        B._store.validated = !0;
        var Oe = Ul(Ae);
        if (zl[Oe])
          return;
        zl[Oe] = !0;
        var ut = "";
        B && B._owner && B._owner !== Gi.current && (ut = " It was passed a child from " + ie(B._owner.type) + "."), Ro(B), x('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', Oe, ut), Ro(null);
      }
    }
    function Yl(B, Ae) {
      {
        if (typeof B != "object")
          return;
        if (An(B))
          for (var Oe = 0; Oe < B.length; Oe++) {
            var ut = B[Oe];
            Os(ut) && Xl(ut, Ae);
          }
        else if (Os(B))
          B._store && (B._store.validated = !0);
        else if (B) {
          var It = y(B);
          if (typeof It == "function" && It !== B.entries)
            for (var Kt = It.call(B), Vt; !(Vt = Kt.next()).done; )
              Os(Vt.value) && Xl(Vt.value, Ae);
        }
      }
    }
    function co(B) {
      {
        var Ae = B.type;
        if (Ae == null || typeof Ae == "string")
          return;
        var Oe;
        if (typeof Ae == "function")
          Oe = Ae.propTypes;
        else if (typeof Ae == "object" && (Ae.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        Ae.$$typeof === h))
          Oe = Ae.propTypes;
        else
          return;
        if (Oe) {
          var ut = ie(Ae);
          yt(Oe, B.props, "prop", ut, B);
        } else if (Ae.PropTypes !== void 0 && !Do) {
          Do = !0;
          var It = ie(Ae);
          x("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", It || "Unknown");
        }
        typeof Ae.getDefaultProps == "function" && !Ae.getDefaultProps.isReactClassApproved && x("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Fs(B) {
      {
        for (var Ae = Object.keys(B.props), Oe = 0; Oe < Ae.length; Oe++) {
          var ut = Ae[Oe];
          if (ut !== "children" && ut !== "key") {
            Ro(B), x("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", ut), Ro(null);
            break;
          }
        }
        B.ref !== null && (Ro(B), x("Invalid attribute `ref` supplied to `React.Fragment`."), Ro(null));
      }
    }
    var ql = {};
    function $i(B, Ae, Oe, ut, It, Kt) {
      {
        var Vt = H(B);
        if (!Vt) {
          var Et = "";
          (B === void 0 || typeof B == "object" && B !== null && Object.keys(B).length === 0) && (Et += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var or = Ec(It);
          or ? Et += or : Et += Po();
          var xn;
          B === null ? xn = "null" : An(B) ? xn = "array" : B !== void 0 && B.$$typeof === t ? (xn = "<" + (ie(B.type) || "Unknown") + " />", Et = " Did you accidentally export a JSX literal instead of a component?") : xn = typeof B, x("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", xn, Et);
        }
        var Dn = Pc(B, Ae, Oe, It, Kt);
        if (Dn == null)
          return Dn;
        if (Vt) {
          var zn = Ae.children;
          if (zn !== void 0)
            if (ut)
              if (An(zn)) {
                for (var La = 0; La < zn.length; La++)
                  Yl(zn[La], B);
                Object.freeze && Object.freeze(zn);
              } else
                x("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Yl(zn, B);
        }
        if (on.call(Ae, "key")) {
          var pr = ie(B), Qn = Object.keys(Ae).filter(function(Hs) {
            return Hs !== "key";
          }), Bs = Qn.length > 0 ? "{key: someKey, " + Qn.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!ql[pr + Bs]) {
            var Zi = Qn.length > 0 ? "{" + Qn.join(": ..., ") + ": ...}" : "{}";
            x(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Bs, pr, Zi, pr), ql[pr + Bs] = !0;
          }
        }
        return B === r ? Fs(Dn) : co(Dn), Dn;
      }
    }
    function Tc(B, Ae, Oe) {
      return $i(B, Ae, Oe, !0);
    }
    function Nc(B, Ae, Oe) {
      return $i(B, Ae, Oe, !1);
    }
    var Ia = Nc, kc = Tc;
    i1.Fragment = r, i1.jsx = Ia, i1.jsxs = kc;
  }()), i1;
}
process.env.NODE_ENV === "production" ? m5.exports = HV() : m5.exports = GV();
var A = m5.exports;
function Sh(e) {
  return e != null && typeof e == "object" && "nodeType" in e && e.nodeType === Node.ELEMENT_NODE;
}
function $V() {
  return !!(globalThis != null && globalThis.document);
}
function dS(e) {
  return e.parentElement && dS(e.parentElement) ? !0 : e.hidden;
}
function ZV(e) {
  const t = e.getAttribute("contenteditable");
  return t !== "false" && t != null;
}
function jV(e) {
  return !!e.getAttribute("disabled") || !!e.getAttribute("aria-disabled");
}
function WV(e) {
  var t;
  return ((t = fS(e)) == null ? void 0 : t.defaultView) ?? window;
}
function fS(e) {
  return Sh(e) ? e.ownerDocument : document;
}
function zV(e) {
  return fS(e).activeElement;
}
function UV(e, ...t) {
  if (e == null)
    throw new TypeError("Cannot convert undefined or null to object");
  const n = { ...e };
  for (const r of t)
    if (r != null)
      for (const o in r)
        Object.prototype.hasOwnProperty.call(r, o) && (o in n && delete n[o], n[o] = r[o]);
  return n;
}
const Qe = (e) => e ? "" : void 0, vi = (e) => e ? !0 : void 0;
function p5(e) {
  return Array.isArray(e);
}
function cr(e) {
  const t = typeof e;
  return e != null && (t === "object" || t === "function") && !p5(e);
}
function XV(e) {
  const t = e == null ? 0 : e.length;
  return t ? e[t - 1] : void 0;
}
function YV(e) {
  const t = parseFloat(e.toString()), n = e.toString().replace(String(t), "");
  return { unitless: !n, value: t, unit: n };
}
function g5(e) {
  if (e == null)
    return e;
  const { unitless: t } = YV(e);
  return t || typeof e == "number" ? `${e}px` : e;
}
const hS = (e, t) => parseInt(e[1], 10) > parseInt(t[1], 10) ? 1 : -1, $3 = (e) => Object.fromEntries(Object.entries(e).sort(hS));
function yv(e) {
  const t = $3(e);
  return Object.assign(Object.values(t), t);
}
function qV(e) {
  const t = Object.keys($3(e));
  return new Set(t);
}
function Sv(e) {
  if (!e)
    return e;
  e = g5(e) ?? e;
  const t = -0.02;
  return typeof e == "number" ? `${e + t}` : e.replace(/(\d+\.?\d*)/u, (n) => `${parseFloat(n) + t}`);
}
function _1(e, t) {
  const n = ["@media screen"];
  return e && n.push("and", `(min-width: ${g5(e)})`), t && n.push("and", `(max-width: ${g5(t)})`), n.join(" ");
}
function JV(e) {
  if (!e)
    return null;
  e.base = e.base ?? "0px";
  const t = yv(e), n = Object.entries(e).sort(hS).map(([a, i], l, u) => {
    let [, d] = u[l + 1] ?? [];
    return d = parseFloat(d) > 0 ? Sv(d) : void 0, {
      _minW: Sv(i),
      breakpoint: a,
      minW: i,
      maxW: d,
      maxWQuery: _1(null, d),
      minWQuery: _1(i),
      minMaxQuery: _1(i, d)
    };
  }), r = qV(e), o = Array.from(r.values());
  return {
    keys: r,
    normalized: t,
    isResponsive(a) {
      const i = Object.keys(a);
      return i.length > 0 && i.every((l) => r.has(l));
    },
    asObject: $3(e),
    asArray: yv(e),
    details: n,
    get(a) {
      return n.find((i) => i.breakpoint === a);
    },
    media: [
      null,
      ...t.map((a) => _1(a)).slice(1)
    ],
    /**
     * Converts the object responsive syntax to array syntax
     *
     * @example
     * toArrayValue({ base: 1, sm: 2, md: 3 }) // => [1, 2, 3]
     */
    toArrayValue(a) {
      if (!cr(a))
        throw new Error("toArrayValue: value must be an object");
      const i = o.map((l) => a[l] ?? null);
      for (; XV(i) === null; )
        i.pop();
      return i;
    },
    /**
     * Converts the array responsive syntax to object syntax
     *
     * @example
     * toObjectValue([1, 2, 3]) // => { base: 1, sm: 2, md: 3 }
     */
    toObjectValue(a) {
      if (!Array.isArray(a))
        throw new Error("toObjectValue: value must be an array");
      return a.reduce(
        (i, l, u) => {
          const d = o[u];
          return d != null && l != null && (i[d] = l), i;
        },
        {}
      );
    }
  };
}
function Ah(...e) {
  return function(...n) {
    e.forEach((r) => r == null ? void 0 : r(...n));
  };
}
function qe(...e) {
  return function(n) {
    e.some((r) => (r == null || r(n), n == null ? void 0 : n.defaultPrevented));
  };
}
function mS(e) {
  return Ad.toArray(e).filter(
    (t) => Ol(t)
  );
}
function Z3(e) {
  const t = Object.assign({}, e);
  for (let n in t)
    t[n] === void 0 && delete t[n];
  return t;
}
function KV(e, t) {
  return `${e} returned \`undefined\`. Seems you forgot to wrap component within ${t}`;
}
function mn(e = {}) {
  const {
    name: t,
    strict: n = !0,
    hookName: r = "useContext",
    providerName: o = "Provider",
    errorMessage: a,
    defaultValue: i
  } = e, l = ea(i);
  l.displayName = t;
  function u() {
    var f;
    const d = Yn(l);
    if (!d && n) {
      const h = new Error(
        a ?? KV(r, o)
      );
      throw h.name = "ContextError", (f = Error.captureStackTrace) == null || f.call(Error, h, u), h;
    }
    return d;
  }
  return [l.Provider, u, l];
}
const ze = (...e) => e.filter(Boolean).join(" "), pS = (e) => e.hasAttribute("tabindex"), QV = (e) => pS(e) && e.tabIndex === -1;
function c2(e) {
  if (!Sh(e) || dS(e) || jV(e))
    return !1;
  const { localName: t } = e;
  if (["input", "select", "textarea", "button"].indexOf(t) >= 0)
    return !0;
  const r = {
    a: () => e.hasAttribute("href"),
    audio: () => e.hasAttribute("controls"),
    video: () => e.hasAttribute("controls")
  };
  return t in r ? r[t]() : ZV(e) ? !0 : pS(e);
}
function eO(e) {
  return e ? Sh(e) && c2(e) && !QV(e) : !1;
}
const tO = [
  "input:not(:disabled):not([disabled])",
  "select:not(:disabled):not([disabled])",
  "textarea:not(:disabled):not([disabled])",
  "embed",
  "iframe",
  "object",
  "a[href]",
  "area[href]",
  "button:not(:disabled):not([disabled])",
  "[tabindex]",
  "audio[controls]",
  "video[controls]",
  "*[tabindex]:not([aria-disabled])",
  "*[contenteditable]"
], nO = tO.join(), rO = (e) => e.offsetWidth > 0 && e.offsetHeight > 0;
function gS(e) {
  const t = Array.from(
    e.querySelectorAll(nO)
  );
  return t.unshift(e), t.filter((n) => c2(n) && rO(n));
}
function oO(e, t, n, r) {
  const o = typeof t == "string" ? t.split(".") : [t];
  for (r = 0; r < o.length && e; r += 1)
    e = e[o[r]];
  return e === void 0 ? n : e;
}
const aO = (e) => {
  const t = /* @__PURE__ */ new WeakMap();
  return (r, o, a, i) => {
    if (typeof r > "u")
      return e(r, o, a);
    t.has(r) || t.set(r, /* @__PURE__ */ new Map());
    const l = t.get(r);
    if (l.has(o))
      return l.get(o);
    const u = e(r, o, a, i);
    return l.set(o, u), u;
  };
}, vS = aO(oO), iO = (e) => e.default || e;
function CS(e) {
  const { wasSelected: t, enabled: n, isSelected: r, mode: o = "unmount" } = e;
  return !!(!n || r || o === "keepMounted" && t);
}
function sO(e) {
  const t = parseFloat(e);
  return typeof t != "number" || Number.isNaN(t) ? 0 : t;
}
function bS(e, t) {
  let n = sO(e);
  const r = 10 ** (t ?? 10);
  return n = Math.round(n * r) / r, t ? n.toFixed(t) : n.toString();
}
function Av(e) {
  if (!Number.isFinite(e))
    return 0;
  let t = 1, n = 0;
  for (; Math.round(e * t) / t !== e; )
    t *= 10, n += 1;
  return n;
}
function lO(e, t, n) {
  return e == null ? e : (n < t && console.warn("clamp: max cannot be less than min"), Math.min(Math.max(e, t), n));
}
function Mh(e, t = []) {
  const n = Object.assign({}, e);
  for (const r of t)
    r in n && delete n[r];
  return n;
}
function yS(e, t) {
  const n = {};
  for (const r of t)
    r in e && (n[r] = e[r]);
  return n;
}
function j3(e, t) {
  return Array.isArray(e) ? e.map((n) => n === null ? null : t(n)) : cr(e) ? Object.keys(e).reduce((n, r) => (n[r] = t(e[r]), n), {}) : e != null ? t(e) : null;
}
const uO = (e) => typeof e == "function";
function Wo(e, ...t) {
  return uO(e) ? e(...t) : e;
}
function cO(e) {
  const t = e.ownerDocument.defaultView || window, { overflow: n, overflowX: r, overflowY: o } = t.getComputedStyle(e);
  return /auto|scroll|overlay|hidden/.test(n + o + r);
}
function dO(e) {
  return e.localName === "html" ? e : e.assignedSlot || e.parentElement || e.ownerDocument.documentElement;
}
function SS(e) {
  return ["html", "body", "#document"].includes(e.localName) ? e.ownerDocument.body : Sh(e) && cO(e) ? e : SS(dO(e));
}
function AS(e, t) {
  const n = {}, r = {};
  for (const [o, a] of Object.entries(e))
    t.includes(o) ? n[o] = a : r[o] = a;
  return [n, r];
}
function fO(e, ...t) {
  const n = Object.getOwnPropertyDescriptors(e), r = Object.keys(n), o = (i) => {
    const l = {};
    for (let u = 0; u < i.length; u++) {
      const d = i[u];
      n[d] && (Object.defineProperty(l, d, n[d]), delete n[d]);
    }
    return l;
  }, a = (i) => o(Array.isArray(i) ? i : r.filter(i));
  return t.map(a).concat(o(r));
}
function Mv(e, t, n = {}) {
  const { stop: r, getKey: o } = n;
  function a(i, l = []) {
    if (cr(i) || Array.isArray(i)) {
      const u = {};
      for (const [d, f] of Object.entries(i)) {
        const h = (o == null ? void 0 : o(d)) ?? d, p = [...l, h];
        if (r != null && r(i, p))
          return t(i, l);
        u[h] = a(f, p);
      }
      return u;
    }
    return t(i, l);
  }
  return a(e);
}
const xd = (e) => {
  const { condition: t, message: n } = e;
  t && process.env.NODE_ENV !== "production" && console.warn(n);
};
var d2 = { exports: {} };
d2.exports;
(function(e, t) {
  var n = 200, r = "__lodash_hash_undefined__", o = 800, a = 16, i = 9007199254740991, l = "[object Arguments]", u = "[object Array]", d = "[object AsyncFunction]", f = "[object Boolean]", h = "[object Date]", p = "[object Error]", g = "[object Function]", C = "[object GeneratorFunction]", v = "[object Map]", y = "[object Number]", M = "[object Null]", x = "[object Object]", _ = "[object Proxy]", L = "[object RegExp]", R = "[object Set]", k = "[object String]", P = "[object Undefined]", N = "[object WeakMap]", O = "[object ArrayBuffer]", H = "[object DataView]", $ = "[object Float32Array]", ne = "[object Float64Array]", ie = "[object Int8Array]", re = "[object Int16Array]", ve = "[object Int32Array]", ue = "[object Uint8Array]", j = "[object Uint8ClampedArray]", K = "[object Uint16Array]", ce = "[object Uint32Array]", U = /[\\^$.*+?()[\]{}|]/g, q = /^\[object .+?Constructor\]$/, ge = /^(?:0|[1-9]\d*)$/, X = {};
  X[$] = X[ne] = X[ie] = X[re] = X[ve] = X[ue] = X[j] = X[K] = X[ce] = !0, X[l] = X[u] = X[O] = X[f] = X[H] = X[h] = X[p] = X[g] = X[v] = X[y] = X[x] = X[L] = X[R] = X[k] = X[N] = !1;
  var he = typeof di == "object" && di && di.Object === Object && di, me = typeof self == "object" && self && self.Object === Object && self, de = he || me || Function("return this")(), Le = t && !t.nodeType && t, Ie = Le && !0 && e && !e.nodeType && e, Ne = Ie && Ie.exports === Le, ye = Ne && he.process, ke = function() {
    try {
      var V = Ie && Ie.require && Ie.require("util").types;
      return V || ye && ye.binding && ye.binding("util");
    } catch {
    }
  }(), oe = ke && ke.isTypedArray;
  function lt(V, Z, ee) {
    switch (ee.length) {
      case 0:
        return V.call(Z);
      case 1:
        return V.call(Z, ee[0]);
      case 2:
        return V.call(Z, ee[0], ee[1]);
      case 3:
        return V.call(Z, ee[0], ee[1], ee[2]);
    }
    return V.apply(Z, ee);
  }
  function Re(V, Z) {
    for (var ee = -1, Ze = Array(V); ++ee < V; )
      Ze[ee] = Z(ee);
    return Ze;
  }
  function _t(V) {
    return function(Z) {
      return V(Z);
    };
  }
  function on(V, Z) {
    return V == null ? void 0 : V[Z];
  }
  function $e(V, Z) {
    return function(ee) {
      return V(Z(ee));
    };
  }
  var Zt = Array.prototype, Pt = Function.prototype, yt = Object.prototype, jt = de["__core-js_shared__"], An = Pt.toString, Rn = yt.hasOwnProperty, Er = function() {
    var V = /[^.]+$/.exec(jt && jt.keys && jt.keys.IE_PROTO || "");
    return V ? "Symbol(src)_1." + V : "";
  }(), Ar = yt.toString, oa = An.call(Object), fr = RegExp(
    "^" + An.call(Rn).replace(U, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  ), De = Ne ? de.Buffer : void 0, Xt = de.Symbol, Nn = de.Uint8Array, Kn = De ? De.allocUnsafe : void 0, Jr = $e(Object.getPrototypeOf, Object), aa = Object.create, ks = yt.propertyIsEnumerable, Vs = Zt.splice, uo = Xt ? Xt.toStringTag : void 0, _a = function() {
    try {
      var V = Ql(Object, "defineProperty");
      return V({}, "", {}), V;
    } catch {
    }
  }(), Pc = De ? De.isBuffer : void 0, Gi = Math.max, Wl = Date.now, Ro = Ql(de, "Map"), Do = Ql(Object, "create"), Os = function() {
    function V() {
    }
    return function(Z) {
      if (!ia(Z))
        return {};
      if (aa)
        return aa(Z);
      V.prototype = Z;
      var ee = new V();
      return V.prototype = void 0, ee;
    };
  }();
  function Po(V) {
    var Z = -1, ee = V == null ? 0 : V.length;
    for (this.clear(); ++Z < ee; ) {
      var Ze = V[Z];
      this.set(Ze[0], Ze[1]);
    }
  }
  function Ec() {
    this.__data__ = Do ? Do(null) : {}, this.size = 0;
  }
  function zl(V) {
    var Z = this.has(V) && delete this.__data__[V];
    return this.size -= Z ? 1 : 0, Z;
  }
  function Ul(V) {
    var Z = this.__data__;
    if (Do) {
      var ee = Z[V];
      return ee === r ? void 0 : ee;
    }
    return Rn.call(Z, V) ? Z[V] : void 0;
  }
  function Xl(V) {
    var Z = this.__data__;
    return Do ? Z[V] !== void 0 : Rn.call(Z, V);
  }
  function Yl(V, Z) {
    var ee = this.__data__;
    return this.size += this.has(V) ? 0 : 1, ee[V] = Do && Z === void 0 ? r : Z, this;
  }
  Po.prototype.clear = Ec, Po.prototype.delete = zl, Po.prototype.get = Ul, Po.prototype.has = Xl, Po.prototype.set = Yl;
  function co(V) {
    var Z = -1, ee = V == null ? 0 : V.length;
    for (this.clear(); ++Z < ee; ) {
      var Ze = V[Z];
      this.set(Ze[0], Ze[1]);
    }
  }
  function Fs() {
    this.__data__ = [], this.size = 0;
  }
  function ql(V) {
    var Z = this.__data__, ee = pr(Z, V);
    if (ee < 0)
      return !1;
    var Ze = Z.length - 1;
    return ee == Ze ? Z.pop() : Vs.call(Z, ee, 1), --this.size, !0;
  }
  function $i(V) {
    var Z = this.__data__, ee = pr(Z, V);
    return ee < 0 ? void 0 : Z[ee][1];
  }
  function Tc(V) {
    return pr(this.__data__, V) > -1;
  }
  function Nc(V, Z) {
    var ee = this.__data__, Ze = pr(ee, V);
    return Ze < 0 ? (++this.size, ee.push([V, Z])) : ee[Ze][1] = Z, this;
  }
  co.prototype.clear = Fs, co.prototype.delete = ql, co.prototype.get = $i, co.prototype.has = Tc, co.prototype.set = Nc;
  function Ia(V) {
    var Z = -1, ee = V == null ? 0 : V.length;
    for (this.clear(); ++Z < ee; ) {
      var Ze = V[Z];
      this.set(Ze[0], Ze[1]);
    }
  }
  function kc() {
    this.size = 0, this.__data__ = {
      hash: new Po(),
      map: new (Ro || co)(),
      string: new Po()
    };
  }
  function B(V) {
    var Z = Kl(this, V).delete(V);
    return this.size -= Z ? 1 : 0, Z;
  }
  function Ae(V) {
    return Kl(this, V).get(V);
  }
  function Oe(V) {
    return Kl(this, V).has(V);
  }
  function ut(V, Z) {
    var ee = Kl(this, V), Ze = ee.size;
    return ee.set(V, Z), this.size += ee.size == Ze ? 0 : 1, this;
  }
  Ia.prototype.clear = kc, Ia.prototype.delete = B, Ia.prototype.get = Ae, Ia.prototype.has = Oe, Ia.prototype.set = ut;
  function It(V) {
    var Z = this.__data__ = new co(V);
    this.size = Z.size;
  }
  function Kt() {
    this.__data__ = new co(), this.size = 0;
  }
  function Vt(V) {
    var Z = this.__data__, ee = Z.delete(V);
    return this.size = Z.size, ee;
  }
  function Et(V) {
    return this.__data__.get(V);
  }
  function or(V) {
    return this.__data__.has(V);
  }
  function xn(V, Z) {
    var ee = this.__data__;
    if (ee instanceof co) {
      var Ze = ee.__data__;
      if (!Ro || Ze.length < n - 1)
        return Ze.push([V, Z]), this.size = ++ee.size, this;
      ee = this.__data__ = new Ia(Ze);
    }
    return ee.set(V, Z), this.size = ee.size, this;
  }
  It.prototype.clear = Kt, It.prototype.delete = Vt, It.prototype.get = Et, It.prototype.has = or, It.prototype.set = xn;
  function Dn(V, Z) {
    var ee = Gc(V), Ze = !ee && Hc(V), Ot = !ee && !Ze && f0(V), un = !ee && !Ze && !Ot && m0(V), xt = ee || Ze || Ot || un, Nt = xt ? Re(V.length, String) : [], Jt = Nt.length;
    for (var Tr in V)
      (Z || Rn.call(V, Tr)) && !(xt && // Safari 9 has enumerable `arguments.length` in strict mode.
      (Tr == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      Ot && (Tr == "offset" || Tr == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      un && (Tr == "buffer" || Tr == "byteLength" || Tr == "byteOffset") || // Skip index properties.
      a0(Tr, Jt))) && Nt.push(Tr);
    return Nt;
  }
  function zn(V, Z, ee) {
    (ee !== void 0 && !tu(V[Z], ee) || ee === void 0 && !(Z in V)) && Qn(V, Z, ee);
  }
  function La(V, Z, ee) {
    var Ze = V[Z];
    (!(Rn.call(V, Z) && tu(Ze, ee)) || ee === void 0 && !(Z in V)) && Qn(V, Z, ee);
  }
  function pr(V, Z) {
    for (var ee = V.length; ee--; )
      if (tu(V[ee][0], Z))
        return ee;
    return -1;
  }
  function Qn(V, Z, ee) {
    Z == "__proto__" && _a ? _a(V, Z, {
      configurable: !0,
      enumerable: !0,
      value: ee,
      writable: !0
    }) : V[Z] = ee;
  }
  var Bs = r0();
  function Zi(V) {
    return V == null ? V === void 0 ? P : M : uo && uo in Object(V) ? o0(V) : l0(V);
  }
  function Hs(V) {
    return Gs(V) && Zi(V) == l;
  }
  function qd(V) {
    if (!ia(V) || Bc(V))
      return !1;
    var Z = $c(V) ? fr : q;
    return Z.test(d0(V));
  }
  function Jd(V) {
    return Gs(V) && h0(V.length) && !!X[Zi(V)];
  }
  function Rm(V) {
    if (!ia(V))
      return s0(V);
    var Z = qa(V), ee = [];
    for (var Ze in V)
      Ze == "constructor" && (Z || !Rn.call(V, Ze)) || ee.push(Ze);
    return ee;
  }
  function Kd(V, Z, ee, Ze, Ot) {
    V !== Z && Bs(Z, function(un, xt) {
      if (Ot || (Ot = new It()), ia(un))
        Dm(V, Z, xt, ee, Kd, Ze, Ot);
      else {
        var Nt = Ze ? Ze(eu(V, xt), un, xt + "", V, Z, Ot) : void 0;
        Nt === void 0 && (Nt = un), zn(V, xt, Nt);
      }
    }, p0);
  }
  function Dm(V, Z, ee, Ze, Ot, un, xt) {
    var Nt = eu(V, ee), Jt = eu(Z, ee), Tr = xt.get(Jt);
    if (Tr) {
      zn(V, ee, Tr);
      return;
    }
    var gr = un ? un(Nt, Jt, ee + "", V, Z, xt) : void 0, hr = gr === void 0;
    if (hr) {
      var ru = Gc(Jt), ou = !ru && f0(Jt), Zc = !ru && !ou && m0(Jt);
      gr = Jt, ru || ou || Zc ? Gc(Nt) ? gr = Nt : Nm(Nt) ? gr = Em(Nt) : ou ? (hr = !1, gr = e0(Jt, !0)) : Zc ? (hr = !1, gr = Vc(Jt, !0)) : gr = [] : km(Jt) || Hc(Jt) ? (gr = Nt, Hc(Nt) ? gr = Vm(Nt) : (!ia(Nt) || $c(Nt)) && (gr = Oc(Jt))) : hr = !1;
    }
    hr && (xt.set(Jt, gr), Ot(gr, Jt, Ze, un, xt), xt.delete(Jt)), zn(V, ee, gr);
  }
  function Pm(V, Z) {
    return u0(Tm(V, Z, g0), V + "");
  }
  var Qd = _a ? function(V, Z) {
    return _a(V, "toString", {
      configurable: !0,
      enumerable: !1,
      value: pn(Z),
      writable: !0
    });
  } : g0;
  function e0(V, Z) {
    if (Z)
      return V.slice();
    var ee = V.length, Ze = Kn ? Kn(ee) : new V.constructor(ee);
    return V.copy(Ze), Ze;
  }
  function t0(V) {
    var Z = new V.constructor(V.byteLength);
    return new Nn(Z).set(new Nn(V)), Z;
  }
  function Vc(V, Z) {
    var ee = Z ? t0(V.buffer) : V.buffer;
    return new V.constructor(ee, V.byteOffset, V.length);
  }
  function Em(V, Z) {
    var ee = -1, Ze = V.length;
    for (Z || (Z = Array(Ze)); ++ee < Ze; )
      Z[ee] = V[ee];
    return Z;
  }
  function n0(V, Z, ee, Ze) {
    var Ot = !ee;
    ee || (ee = {});
    for (var un = -1, xt = Z.length; ++un < xt; ) {
      var Nt = Z[un], Jt = Ze ? Ze(ee[Nt], V[Nt], Nt, ee, V) : void 0;
      Jt === void 0 && (Jt = V[Nt]), Ot ? Qn(ee, Nt, Jt) : La(ee, Nt, Jt);
    }
    return ee;
  }
  function Jl(V) {
    return Pm(function(Z, ee) {
      var Ze = -1, Ot = ee.length, un = Ot > 1 ? ee[Ot - 1] : void 0, xt = Ot > 2 ? ee[2] : void 0;
      for (un = V.length > 3 && typeof un == "function" ? (Ot--, un) : void 0, xt && i0(ee[0], ee[1], xt) && (un = Ot < 3 ? void 0 : un, Ot = 1), Z = Object(Z); ++Ze < Ot; ) {
        var Nt = ee[Ze];
        Nt && V(Z, Nt, Ze, un);
      }
      return Z;
    });
  }
  function r0(V) {
    return function(Z, ee, Ze) {
      for (var Ot = -1, un = Object(Z), xt = Ze(Z), Nt = xt.length; Nt--; ) {
        var Jt = xt[V ? Nt : ++Ot];
        if (ee(un[Jt], Jt, un) === !1)
          break;
      }
      return Z;
    };
  }
  function Kl(V, Z) {
    var ee = V.__data__;
    return Fc(Z) ? ee[typeof Z == "string" ? "string" : "hash"] : ee.map;
  }
  function Ql(V, Z) {
    var ee = on(V, Z);
    return qd(ee) ? ee : void 0;
  }
  function o0(V) {
    var Z = Rn.call(V, uo), ee = V[uo];
    try {
      V[uo] = void 0;
      var Ze = !0;
    } catch {
    }
    var Ot = Ar.call(V);
    return Ze && (Z ? V[uo] = ee : delete V[uo]), Ot;
  }
  function Oc(V) {
    return typeof V.constructor == "function" && !qa(V) ? Os(Jr(V)) : {};
  }
  function a0(V, Z) {
    var ee = typeof V;
    return Z = Z ?? i, !!Z && (ee == "number" || ee != "symbol" && ge.test(V)) && V > -1 && V % 1 == 0 && V < Z;
  }
  function i0(V, Z, ee) {
    if (!ia(ee))
      return !1;
    var Ze = typeof Z;
    return (Ze == "number" ? nu(ee) && a0(Z, ee.length) : Ze == "string" && Z in ee) ? tu(ee[Z], V) : !1;
  }
  function Fc(V) {
    var Z = typeof V;
    return Z == "string" || Z == "number" || Z == "symbol" || Z == "boolean" ? V !== "__proto__" : V === null;
  }
  function Bc(V) {
    return !!Er && Er in V;
  }
  function qa(V) {
    var Z = V && V.constructor, ee = typeof Z == "function" && Z.prototype || yt;
    return V === ee;
  }
  function s0(V) {
    var Z = [];
    if (V != null)
      for (var ee in Object(V))
        Z.push(ee);
    return Z;
  }
  function l0(V) {
    return Ar.call(V);
  }
  function Tm(V, Z, ee) {
    return Z = Gi(Z === void 0 ? V.length - 1 : Z, 0), function() {
      for (var Ze = arguments, Ot = -1, un = Gi(Ze.length - Z, 0), xt = Array(un); ++Ot < un; )
        xt[Ot] = Ze[Z + Ot];
      Ot = -1;
      for (var Nt = Array(Z + 1); ++Ot < Z; )
        Nt[Ot] = Ze[Ot];
      return Nt[Z] = ee(xt), lt(V, this, Nt);
    };
  }
  function eu(V, Z) {
    if (!(Z === "constructor" && typeof V[Z] == "function") && Z != "__proto__")
      return V[Z];
  }
  var u0 = c0(Qd);
  function c0(V) {
    var Z = 0, ee = 0;
    return function() {
      var Ze = Wl(), Ot = a - (Ze - ee);
      if (ee = Ze, Ot > 0) {
        if (++Z >= o)
          return arguments[0];
      } else
        Z = 0;
      return V.apply(void 0, arguments);
    };
  }
  function d0(V) {
    if (V != null) {
      try {
        return An.call(V);
      } catch {
      }
      try {
        return V + "";
      } catch {
      }
    }
    return "";
  }
  function tu(V, Z) {
    return V === Z || V !== V && Z !== Z;
  }
  var Hc = Hs(function() {
    return arguments;
  }()) ? Hs : function(V) {
    return Gs(V) && Rn.call(V, "callee") && !ks.call(V, "callee");
  }, Gc = Array.isArray;
  function nu(V) {
    return V != null && h0(V.length) && !$c(V);
  }
  function Nm(V) {
    return Gs(V) && nu(V);
  }
  var f0 = Pc || Om;
  function $c(V) {
    if (!ia(V))
      return !1;
    var Z = Zi(V);
    return Z == g || Z == C || Z == d || Z == _;
  }
  function h0(V) {
    return typeof V == "number" && V > -1 && V % 1 == 0 && V <= i;
  }
  function ia(V) {
    var Z = typeof V;
    return V != null && (Z == "object" || Z == "function");
  }
  function Gs(V) {
    return V != null && typeof V == "object";
  }
  function km(V) {
    if (!Gs(V) || Zi(V) != x)
      return !1;
    var Z = Jr(V);
    if (Z === null)
      return !0;
    var ee = Rn.call(Z, "constructor") && Z.constructor;
    return typeof ee == "function" && ee instanceof ee && An.call(ee) == oa;
  }
  var m0 = oe ? _t(oe) : Jd;
  function Vm(V) {
    return n0(V, p0(V));
  }
  function p0(V) {
    return nu(V) ? Dn(V, !0) : Rm(V);
  }
  var Cn = Jl(function(V, Z, ee, Ze) {
    Kd(V, Z, ee, Ze);
  });
  function pn(V) {
    return function() {
      return V;
    };
  }
  function g0(V) {
    return V;
  }
  function Om() {
    return !1;
  }
  e.exports = Cn;
})(d2, d2.exports);
var hO = d2.exports;
const zo = /* @__PURE__ */ yh(hO);
function ur(e, t = []) {
  const n = Ve(e);
  return st(() => {
    n.current = e;
  }), Q((...r) => {
    var o;
    return (o = n.current) == null ? void 0 : o.call(n, ...r);
  }, t);
}
function hl(e, t, n, r) {
  const o = ur(n);
  return st(() => {
    const a = typeof e == "function" ? e() : e ?? document;
    if (!(!n || !a))
      return a.addEventListener(t, o, r), () => {
        a.removeEventListener(t, o, r);
      };
  }, [t, e, r, o, n]), () => {
    const a = typeof e == "function" ? e() : e ?? document;
    a == null || a.removeEventListener(t, o, r);
  };
}
function MS(e) {
  const { isOpen: t, ref: n } = e, [r, o] = He(t), [a, i] = He(!1);
  return st(() => {
    a || (o(t), i(!0));
  }, [t, a, r]), hl(
    () => n.current,
    "animationend",
    () => {
      o(t);
    }
  ), {
    present: !(t ? !1 : !r),
    onComplete() {
      var f;
      const u = WV(n.current), d = new u.CustomEvent("animationend", { bubbles: !0 });
      (f = n.current) == null || f.dispatchEvent(d);
    }
  };
}
function xS(e) {
  const {
    value: t,
    defaultValue: n,
    onChange: r,
    shouldUpdate: o = (p, g) => p !== g
  } = e, a = ur(r), i = ur(o), [l, u] = He(n), d = t !== void 0, f = d ? t : l, h = ur(
    (p) => {
      const C = typeof p == "function" ? p(f) : p;
      i(f, C) && (d || u(C), a(C));
    },
    [d, a, f, i]
  );
  return [f, h];
}
function mO(e = {}) {
  const {
    onChange: t,
    precision: n,
    defaultValue: r,
    value: o,
    step: a = 1,
    min: i = Number.MIN_SAFE_INTEGER,
    max: l = Number.MAX_SAFE_INTEGER,
    keepWithinRange: u = !0
  } = e, d = ur(t), [f, h] = He(() => r == null ? "" : Gp(r, a, n) ?? ""), p = typeof o < "u", g = p ? o : f, C = wS(as(g), a), v = n ?? C, y = Q(
    (H) => {
      H !== g && (p || h(H.toString()), d == null || d(H.toString(), as(H)));
    },
    [d, p, g]
  ), M = Q(
    (H) => {
      let $ = H;
      return u && ($ = lO($, i, l)), bS($, v);
    },
    [v, u, l, i]
  ), x = Q(
    (H = a) => {
      let $;
      g === "" ? $ = as(H) : $ = as(g) + H, $ = M($), y($);
    },
    [M, a, y, g]
  ), _ = Q(
    (H = a) => {
      let $;
      g === "" ? $ = as(-H) : $ = as(g) - H, $ = M($), y($);
    },
    [M, a, y, g]
  ), L = Q(() => {
    let H;
    r == null ? H = "" : H = Gp(r, a, n) ?? i, y(H);
  }, [r, n, a, y, i]), R = Q(
    (H) => {
      const $ = Gp(H, a, v) ?? i;
      y($);
    },
    [v, a, y, i]
  ), k = as(g);
  return {
    isOutOfRange: k > l || k < i,
    isAtMax: k === l,
    isAtMin: k === i,
    precision: v,
    value: g,
    valueAsNumber: k,
    update: y,
    reset: L,
    increment: x,
    decrement: _,
    clamp: M,
    cast: R,
    setValue: h
  };
}
function as(e) {
  return parseFloat(e.toString().replace(/[^\w.-]+/g, ""));
}
function wS(e, t) {
  return Math.max(Av(t), Av(e));
}
function Gp(e, t, n) {
  const r = as(e);
  if (Number.isNaN(r))
    return;
  const o = wS(r, t);
  return bS(r, n ?? o);
}
function wd(e = {}) {
  const {
    onClose: t,
    onOpen: n,
    isOpen: r,
    id: o
  } = e, a = ur(n), i = ur(t), [l, u] = He(e.defaultIsOpen || !1), d = r !== void 0 ? r : l, f = r !== void 0, h = Lo(), p = o ?? `disclosure-${h}`, g = Q(() => {
    f || u(!1), i == null || i();
  }, [f, i]), C = Q(() => {
    f || u(!0), a == null || a();
  }, [f, a]), v = Q(() => {
    d ? g() : C();
  }, [d, C, g]);
  function y(x = {}) {
    return {
      ...x,
      "aria-expanded": d,
      "aria-controls": p,
      onClick(_) {
        var L;
        (L = x.onClick) == null || L.call(x, _), v();
      }
    };
  }
  function M(x = {}) {
    return {
      ...x,
      hidden: !d,
      id: p
    };
  }
  return {
    isOpen: d,
    onOpen: C,
    onClose: g,
    onToggle: v,
    isControlled: f,
    getButtonProps: y,
    getDisclosureProps: M
  };
}
const Ci = globalThis != null && globalThis.document ? Cc : st, Ss = (e, t) => {
  const n = Ve(!1), r = Ve(!1);
  st(() => {
    if (n.current && r.current)
      return e();
    r.current = !0;
  }, t), st(() => (n.current = !0, () => {
    n.current = !1;
  }), []);
};
function pO(e) {
  const t = e.current;
  if (!t)
    return !1;
  const n = zV(t);
  return !n || t.contains(n) ? !1 : !!eO(n);
}
function _S(e, t) {
  const { shouldFocus: n, visible: r, focusRef: o } = t, a = n && !r;
  Ss(() => {
    if (!a || pO(e))
      return;
    const i = (o == null ? void 0 : o.current) || e.current;
    let l;
    if (i)
      return l = requestAnimationFrame(() => {
        i.focus({ preventScroll: !0 });
      }), () => {
        cancelAnimationFrame(l);
      };
  }, [a, e, o]);
}
const gO = {
  preventScroll: !0,
  shouldFocus: !1
};
function vO(e, t = gO) {
  const { focusRef: n, preventScroll: r, shouldFocus: o, visible: a } = t, i = CO(e) ? e.current : e, l = o && a, u = Ve(l), d = Ve(a);
  Ci(() => {
    !d.current && a && (u.current = l), d.current = a;
  }, [a, l]);
  const f = Q(() => {
    if (!(!a || !i || !u.current) && (u.current = !1, !i.contains(document.activeElement)))
      if (n != null && n.current)
        requestAnimationFrame(() => {
          var h;
          (h = n.current) == null || h.focus({ preventScroll: r });
        });
      else {
        const h = gS(i);
        h.length > 0 && requestAnimationFrame(() => {
          h[0].focus({ preventScroll: r });
        });
      }
  }, [a, r, i, n]);
  Ss(() => {
    f();
  }, [f]), hl(i, "transitionend", f);
}
function CO(e) {
  return "current" in e;
}
function bO(e) {
  return "current" in e;
}
const IS = () => typeof window < "u";
function yO() {
  const e = navigator.userAgentData;
  return (e == null ? void 0 : e.platform) ?? navigator.platform;
}
const SO = (e) => IS() && e.test(navigator.vendor), AO = (e) => IS() && e.test(yO()), MO = () => AO(/mac|iphone|ipad|ipod/i), xO = () => MO() && SO(/apple/i);
function wO(e) {
  const { ref: t, elements: n, enabled: r } = e, o = () => {
    var a;
    return ((a = t.current) == null ? void 0 : a.ownerDocument) ?? document;
  };
  hl(o, "pointerdown", (a) => {
    var d, f;
    if (!xO() || !r)
      return;
    const i = ((f = (d = a.composedPath) == null ? void 0 : d.call(a)) == null ? void 0 : f[0]) ?? a.target, u = (n ?? [t]).some((h) => {
      const p = bO(h) ? h.current : h;
      return (p == null ? void 0 : p.contains(i)) || p === i;
    });
    o().activeElement !== i && u && (a.preventDefault(), i.focus());
  });
}
function _O(e, t) {
  const n = Lo();
  return bt(
    () => e || [t, n].filter(Boolean).join("-"),
    [e, t, n]
  );
}
function IO(e, ...t) {
  const n = _O(e);
  return bt(() => t.map((r) => `${r}-${n}`), [n, t]);
}
function LO(e, t) {
  const n = ur(e);
  st(() => {
    let r = null;
    const o = () => n();
    return t !== null && (r = window.setInterval(o, t)), () => {
      r && window.clearInterval(r);
    };
  }, [t, n]);
}
function RO(e, t) {
  if (e != null) {
    if (typeof e == "function") {
      e(t);
      return;
    }
    try {
      e.current = t;
    } catch {
      throw new Error(`Cannot assign value '${t}' to ref '${e}'`);
    }
  }
}
function In(...e) {
  return (t) => {
    e.forEach((n) => {
      RO(n, t);
    });
  };
}
function DO(...e) {
  return bt(() => In(...e), e);
}
function LS(e) {
  const { ref: t, handler: n, enabled: r = !0 } = e, o = ur(n), i = Ve({
    isPointerDown: !1,
    ignoreEmulatedMouseEvents: !1
  }).current;
  st(() => {
    if (!r)
      return;
    const l = (h) => {
      $p(h, t) && (i.isPointerDown = !0);
    }, u = (h) => {
      if (i.ignoreEmulatedMouseEvents) {
        i.ignoreEmulatedMouseEvents = !1;
        return;
      }
      i.isPointerDown && n && $p(h, t) && (i.isPointerDown = !1, o(h));
    }, d = (h) => {
      i.ignoreEmulatedMouseEvents = !0, n && i.isPointerDown && $p(h, t) && (i.isPointerDown = !1, o(h));
    }, f = RS(t.current);
    return f.addEventListener("mousedown", l, !0), f.addEventListener("mouseup", u, !0), f.addEventListener("touchstart", l, !0), f.addEventListener("touchend", d, !0), () => {
      f.removeEventListener("mousedown", l, !0), f.removeEventListener("mouseup", u, !0), f.removeEventListener("touchstart", l, !0), f.removeEventListener("touchend", d, !0);
    };
  }, [n, t, o, i, r]);
}
function $p(e, t) {
  var r, o;
  const n = ((r = e.composedPath) == null ? void 0 : r.call(e)[0]) ?? e.target;
  return n && !RS(n).contains(n) ? !1 : !((o = t.current) != null && o.contains(n));
}
function RS(e) {
  return (e == null ? void 0 : e.ownerDocument) ?? document;
}
function PO(e, t) {
  const n = ur(e);
  st(() => {
    if (t == null)
      return;
    let r = null;
    return r = window.setTimeout(() => {
      n();
    }, t), () => {
      r && window.clearTimeout(r);
    };
  }, [t, n]);
}
const sr = {
  open: (e, t) => `${e}[data-open], ${e}[open], ${e}[data-state=open] ${t}`,
  closed: (e, t) => `${e}[data-closed], ${e}[data-state=closed] ${t}`,
  hover: (e, t) => `${e}:hover ${t}, ${e}[data-hover] ${t}`,
  focus: (e, t) => `${e}:focus ${t}, ${e}[data-focus] ${t}`,
  focusVisible: (e, t) => `${e}:focus-visible ${t}`,
  focusWithin: (e, t) => `${e}:focus-within ${t}`,
  active: (e, t) => `${e}:active ${t}, ${e}[data-active] ${t}`,
  disabled: (e, t) => `${e}:disabled ${t}, ${e}[data-disabled] ${t}`,
  invalid: (e, t) => `${e}:invalid ${t}, ${e}[data-invalid] ${t}`,
  checked: (e, t) => `${e}:checked ${t}, ${e}[data-checked] ${t}`,
  indeterminate: (e, t) => `${e}:indeterminate ${t}, ${e}[aria-checked=mixed] ${t}, ${e}[data-indeterminate] ${t}`,
  readOnly: (e, t) => `${e}:read-only ${t}, ${e}[readonly] ${t}, ${e}[data-read-only] ${t}`,
  expanded: (e, t) => `${e}:read-only ${t}, ${e}[aria-expanded=true] ${t}, ${e}[data-expanded] ${t}`,
  placeholderShown: (e, t) => `${e}:placeholder-shown ${t}`
}, Ea = (e) => DS((t) => e(t, "&"), "[role=group]", "[data-group]", ".group"), ii = (e) => DS((t) => e(t, "~ &"), "[data-peer]", ".peer"), DS = (e, ...t) => t.map(e).join(", "), Zu = {
  /**
   * Styles for CSS selector `&:hover`
   */
  _hover: "&:hover, &[data-hover]",
  /**
   * Styles for CSS Selector `&:active`
   */
  _active: "&:active, &[data-active]",
  /**
   * Styles for CSS selector `&:focus`
   *
   */
  _focus: "&:focus, &[data-focus]",
  /**
   * Styles for the highlighted state.
   */
  _highlighted: "&[data-highlighted]",
  /**
   * Styles to apply when a child of this element has received focus
   * - CSS Selector `&:focus-within`
   */
  _focusWithin: "&:focus-within, &[data-focus-within]",
  /**
   * Styles to apply when this element has received focus via tabbing
   * - CSS Selector `&:focus-visible`
   */
  _focusVisible: "&:focus-visible, &[data-focus-visible]",
  /**
   * Styles to apply when this element is disabled. The passed styles are applied to these CSS selectors:
   * - `&[aria-disabled=true]`
   * - `&:disabled`
   * - `&[data-disabled]`
   * - `&[disabled]`
   */
  _disabled: "&:disabled, &[disabled], &[aria-disabled=true], &[data-disabled]",
  /**
   * Styles for CSS Selector `&:readonly`
   */
  _readOnly: "&[aria-readonly=true], &[readonly], &[data-readonly]",
  /**
   * Styles for CSS selector `&::before`
   *
   * NOTE:When using this, ensure the `content` is wrapped in a backtick.
   * @example
   * ```jsx
   * <Box _before={{content:`""` }}/>
   * ```
   */
  _before: "&::before",
  /**
   * Styles for CSS selector `&::after`
   *
   * NOTE:When using this, ensure the `content` is wrapped in a backtick.
   * @example
   * ```jsx
   * <Box _after={{content:`""` }}/>
   * ```
   */
  _after: "&::after",
  /**
   * Styles for CSS selector `&:empty`
   */
  _empty: "&:empty, &[data-empty]",
  /**
   * Styles to apply when the ARIA attribute `aria-expanded` is `true`
   * - CSS selector `&[aria-expanded=true]`
   */
  _expanded: "&[aria-expanded=true], &[data-expanded], &[data-state=expanded]",
  /**
   * Styles to apply when the ARIA attribute `aria-checked` is `true`
   * - CSS selector `&[aria-checked=true]`
   */
  _checked: "&[aria-checked=true], &[data-checked], &[data-state=checked]",
  /**
   * Styles to apply when the ARIA attribute `aria-grabbed` is `true`
   * - CSS selector `&[aria-grabbed=true]`
   */
  _grabbed: "&[aria-grabbed=true], &[data-grabbed]",
  /**
   * Styles for CSS Selector `&[aria-pressed=true]`
   * Typically used to style the current "pressed" state of toggle buttons
   */
  _pressed: "&[aria-pressed=true], &[data-pressed]",
  /**
   * Styles to apply when the ARIA attribute `aria-invalid` is `true`
   * - CSS selector `&[aria-invalid=true]`
   */
  _invalid: "&[aria-invalid=true], &[data-invalid]",
  /**
   * Styles for the valid state
   * - CSS selector `&[data-valid], &[data-state=valid]`
   */
  _valid: "&[data-valid], &[data-state=valid]",
  /**
   * Styles for CSS Selector `&[aria-busy=true]` or `&[data-loading=true]`.
   * Useful for styling loading states
   */
  _loading: "&[data-loading], &[aria-busy=true]",
  /**
   * Styles to apply when the ARIA attribute `aria-selected` is `true`
   *
   * - CSS selector `&[aria-selected=true]`
   */
  _selected: "&[aria-selected=true], &[data-selected]",
  /**
   * Styles for CSS Selector `[hidden=true]`
   */
  _hidden: "&[hidden], &[data-hidden]",
  /**
   * Styles for CSS Selector `&:-webkit-autofill`
   */
  _autofill: "&:-webkit-autofill",
  /**
   * Styles for CSS Selector `&:nth-child(even)`
   */
  _even: "&:nth-of-type(even)",
  /**
   * Styles for CSS Selector `&:nth-child(odd)`
   */
  _odd: "&:nth-of-type(odd)",
  /**
   * Styles for CSS Selector `&:first-of-type`
   */
  _first: "&:first-of-type",
  /**
   * Styles for CSS selector `&::first-letter`
   *
   * NOTE: This selector is only applied for block-level elements and not preceded by an image or table.
   * @example
   * ```jsx
   * <Text _firstLetter={{ textDecoration: 'underline' }}>Once upon a time</Text>
   * ```
   */
  _firstLetter: "&::first-letter",
  /**
   * Styles for CSS Selector `&:last-of-type`
   */
  _last: "&:last-of-type",
  /**
   * Styles for CSS Selector `&:not(:first-of-type)`
   */
  _notFirst: "&:not(:first-of-type)",
  /**
   * Styles for CSS Selector `&:not(:last-of-type)`
   */
  _notLast: "&:not(:last-of-type)",
  /**
   * Styles for CSS Selector `&:visited`
   */
  _visited: "&:visited",
  /**
   * Used to style the active link in a navigation
   * Styles for CSS Selector `&[aria-current=page]`
   */
  _activeLink: "&[aria-current=page]",
  /**
   * Used to style the current step within a process
   * Styles for CSS Selector `&[aria-current=step]`
   */
  _activeStep: "&[aria-current=step]",
  /**
   * Styles to apply when the ARIA attribute `aria-checked` is `mixed`
   * - CSS selector `&[aria-checked=mixed]`
   */
  _indeterminate: "&:indeterminate, &[aria-checked=mixed], &[data-indeterminate], &[data-state=indeterminate]",
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is open
   */
  _groupOpen: Ea(sr.open),
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is closed
   */
  _groupClosed: Ea(sr.closed),
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is hovered
   */
  _groupHover: Ea(sr.hover),
  /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` is hovered
   */
  _peerHover: ii(sr.hover),
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is focused
   */
  _groupFocus: Ea(sr.focus),
  /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` is focused
   */
  _peerFocus: ii(sr.focus),
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` has visible focus
   */
  _groupFocusVisible: Ea(sr.focusVisible),
  /**
   * Styles to apply when a sibling element with `.peer`or `data-peer` has visible focus
   */
  _peerFocusVisible: ii(sr.focusVisible),
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is active
   */
  _groupActive: Ea(sr.active),
  /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` is active
   */
  _peerActive: ii(sr.active),
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is disabled
   */
  _groupDisabled: Ea(sr.disabled),
  /**
   *  Styles to apply when a sibling element with `.peer` or `data-peer` is disabled
   */
  _peerDisabled: ii(sr.disabled),
  /**
   *  Styles to apply when a parent element with `.group`, `data-group` or `role=group` is invalid
   */
  _groupInvalid: Ea(sr.invalid),
  /**
   *  Styles to apply when a sibling element with `.peer` or `data-peer` is invalid
   */
  _peerInvalid: ii(sr.invalid),
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is checked
   */
  _groupChecked: Ea(sr.checked),
  /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` is checked
   */
  _peerChecked: ii(sr.checked),
  /**
   *  Styles to apply when a parent element with `.group`, `data-group` or `role=group` has focus within
   */
  _groupFocusWithin: Ea(sr.focusWithin),
  /**
   *  Styles to apply when a sibling element with `.peer` or `data-peer` has focus within
   */
  _peerFocusWithin: ii(sr.focusWithin),
  /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` has placeholder shown
   */
  _peerPlaceholderShown: ii(sr.placeholderShown),
  /**
   * Styles for CSS Selector `&::placeholder`.
   */
  _placeholder: "&::placeholder, &[data-placeholder]",
  /**
   * Styles for CSS Selector `&:placeholder-shown`.
   */
  _placeholderShown: "&:placeholder-shown, &[data-placeholder-shown]",
  /**
   * Styles for CSS Selector `&:fullscreen`.
   */
  _fullScreen: "&:fullscreen, &[data-fullscreen]",
  /**
   * Styles for CSS Selector `&::selection`
   */
  _selection: "&::selection",
  /**
   * Styles for CSS Selector `[dir=rtl] &`
   * It is applied when a parent element or this element has `dir="rtl"`
   */
  _rtl: "[dir=rtl] &, &[dir=rtl]",
  /**
   * Styles for CSS Selector `[dir=ltr] &`
   * It is applied when a parent element or this element has `dir="ltr"`
   */
  _ltr: "[dir=ltr] &, &[dir=ltr]",
  /**
   * Styles for CSS Selector `@media (prefers-color-scheme: dark)`
   * It is used when the user has requested the system use a light or dark color theme.
   */
  _mediaDark: "@media (prefers-color-scheme: dark)",
  /**
   * Styles for CSS Selector `@media (prefers-reduced-motion: reduce)`
   * It is used when the user has requested the system to reduce the amount of animations.
   */
  _mediaReduceMotion: "@media (prefers-reduced-motion: reduce)",
  /**
   * Styles for when `data-theme` is applied to any parent of
   * this component or element.
   */
  _dark: ".chakra-ui-dark &:not([data-theme]),[data-theme=dark] &:not([data-theme]),&[data-theme=dark]",
  /**
   * Styles for when `data-theme` is applied to any parent of
   * this component or element.
   */
  _light: ".chakra-ui-light &:not([data-theme]),[data-theme=light] &:not([data-theme]),&[data-theme=light]",
  /**
   * Styles for the CSS Selector `&[data-orientation=horizontal]`
   */
  _horizontal: "&[data-orientation=horizontal]",
  /**
   * Styles for the CSS Selector `&[data-orientation=vertical]`
   */
  _vertical: "&[data-orientation=vertical]",
  /**
   * Styles for the CSS Selector `&[data-open], &[open], &[data-state=open]`
   */
  _open: "&[data-open], &[open], &[data-state=open]",
  /**
   * Styles for the CSS Selector `&[data-closed], &[data-state=closed]`
   */
  _closed: "&[data-closed], &[data-state=closed]",
  /**
   * Styles for the CSS Selector `&[data-complete]`
   */
  _complete: "&[data-complete]",
  /**
   * Styles for the CSS Selector `&[data-incomplete]`
   */
  _incomplete: "&[data-incomplete]",
  /**
   * Styles for the CSS Selector `&[data-current]`
   */
  _current: "&[data-current]"
}, PS = Object.keys(
  Zu
), EO = (e) => /!(important)?$/.test(e), xv = (e) => typeof e == "string" ? e.replace(/!(important)?$/, "").trim() : e, TO = (e, t) => (n) => {
  const r = String(t), o = EO(r), a = xv(r), i = e ? `${e}.${a}` : a;
  let l = cr(n.__cssMap) && i in n.__cssMap ? n.__cssMap[i].varRef : t;
  return l = xv(l), o ? `${l} !important` : l;
};
function W3(e) {
  const { scale: t, transform: n, compose: r } = e;
  return (a, i) => {
    const l = TO(t, a)(i);
    let u = (n == null ? void 0 : n(l, i)) ?? l;
    return r && (u = r(u, i)), u;
  };
}
const nf = (...e) => (t) => e.reduce((n, r) => r(n), t);
function Bo(e, t) {
  return (n) => {
    const r = { property: n, scale: e };
    return r.transform = W3({
      scale: e,
      transform: t
    }), r;
  };
}
const NO = ({ rtl: e, ltr: t }) => (n) => n.direction === "rtl" ? e : t;
function kO(e) {
  const { property: t, scale: n, transform: r } = e;
  return {
    scale: n,
    property: NO(t),
    transform: n ? W3({
      scale: n,
      compose: r
    }) : r
  };
}
const ES = [
  "rotate(var(--chakra-rotate, 0))",
  "scaleX(var(--chakra-scale-x, 1))",
  "scaleY(var(--chakra-scale-y, 1))",
  "skewX(var(--chakra-skew-x, 0))",
  "skewY(var(--chakra-skew-y, 0))"
];
function VO() {
  return [
    "translateX(var(--chakra-translate-x, 0))",
    "translateY(var(--chakra-translate-y, 0))",
    ...ES
  ].join(" ");
}
function OO() {
  return [
    "translate3d(var(--chakra-translate-x, 0), var(--chakra-translate-y, 0), 0)",
    ...ES
  ].join(" ");
}
const FO = {
  "--chakra-blur": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-brightness": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-contrast": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-grayscale": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-hue-rotate": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-invert": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-saturate": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-sepia": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-drop-shadow": "var(--chakra-empty,/*!*/ /*!*/)",
  filter: [
    "var(--chakra-blur)",
    "var(--chakra-brightness)",
    "var(--chakra-contrast)",
    "var(--chakra-grayscale)",
    "var(--chakra-hue-rotate)",
    "var(--chakra-invert)",
    "var(--chakra-saturate)",
    "var(--chakra-sepia)",
    "var(--chakra-drop-shadow)"
  ].join(" ")
}, BO = {
  backdropFilter: [
    "var(--chakra-backdrop-blur)",
    "var(--chakra-backdrop-brightness)",
    "var(--chakra-backdrop-contrast)",
    "var(--chakra-backdrop-grayscale)",
    "var(--chakra-backdrop-hue-rotate)",
    "var(--chakra-backdrop-invert)",
    "var(--chakra-backdrop-opacity)",
    "var(--chakra-backdrop-saturate)",
    "var(--chakra-backdrop-sepia)"
  ].join(" "),
  "--chakra-backdrop-blur": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-brightness": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-contrast": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-grayscale": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-hue-rotate": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-invert": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-opacity": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-saturate": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-sepia": "var(--chakra-empty,/*!*/ /*!*/)"
};
function HO(e) {
  return {
    "--chakra-ring-offset-shadow": "var(--chakra-ring-inset) 0 0 0 var(--chakra-ring-offset-width) var(--chakra-ring-offset-color)",
    "--chakra-ring-shadow": "var(--chakra-ring-inset) 0 0 0 calc(var(--chakra-ring-width) + var(--chakra-ring-offset-width)) var(--chakra-ring-color)",
    "--chakra-ring-width": e,
    boxShadow: [
      "var(--chakra-ring-offset-shadow)",
      "var(--chakra-ring-shadow)",
      "var(--chakra-shadow, 0 0 #0000)"
    ].join(", ")
  };
}
const GO = {
  "row-reverse": {
    space: "--chakra-space-x-reverse",
    divide: "--chakra-divide-x-reverse"
  },
  "column-reverse": {
    space: "--chakra-space-y-reverse",
    divide: "--chakra-divide-y-reverse"
  }
}, v5 = {
  "to-t": "to top",
  "to-tr": "to top right",
  "to-r": "to right",
  "to-br": "to bottom right",
  "to-b": "to bottom",
  "to-bl": "to bottom left",
  "to-l": "to left",
  "to-tl": "to top left"
}, $O = new Set(Object.values(v5)), C5 = /* @__PURE__ */ new Set([
  "none",
  "-moz-initial",
  "inherit",
  "initial",
  "revert",
  "unset"
]), ZO = (e) => e.trim();
function jO(e, t) {
  if (e == null || C5.has(e))
    return e;
  if (!(b5(e) || C5.has(e)))
    return `url('${e}')`;
  const o = /(^[a-z-A-Z]+)\((.*)\)/g.exec(e), a = o == null ? void 0 : o[1], i = o == null ? void 0 : o[2];
  if (!a || !i)
    return e;
  const l = a.includes("-gradient") ? a : `${a}-gradient`, [u, ...d] = i.split(",").map(ZO).filter(Boolean);
  if ((d == null ? void 0 : d.length) === 0)
    return e;
  const f = u in v5 ? v5[u] : u;
  d.unshift(f);
  const h = d.map((p) => {
    if ($O.has(p))
      return p;
    const g = p.indexOf(" "), [C, v] = g !== -1 ? [p.substr(0, g), p.substr(g + 1)] : [p], y = b5(v) ? v : v && v.split(" "), M = `colors.${C}`, x = M in t.__cssMap ? t.__cssMap[M].varRef : C;
    return y ? [
      x,
      ...Array.isArray(y) ? y : [y]
    ].join(" ") : x;
  });
  return `${l}(${h.join(", ")})`;
}
const b5 = (e) => typeof e == "string" && e.includes("(") && e.includes(")"), WO = (e, t) => jO(e, t ?? {});
function zO(e) {
  return /^var\(--.+\)$/.test(e);
}
const UO = (e) => {
  const t = parseFloat(e.toString()), n = e.toString().replace(String(t), "");
  return { unitless: !n, value: t, unit: n };
}, Ta = (e) => (t) => `${e}(${t})`, Ut = {
  filter(e) {
    return e !== "auto" ? e : FO;
  },
  backdropFilter(e) {
    return e !== "auto" ? e : BO;
  },
  ring(e) {
    return HO(Ut.px(e));
  },
  bgClip(e) {
    return e === "text" ? { color: "transparent", backgroundClip: "text" } : { backgroundClip: e };
  },
  transform(e) {
    return e === "auto" ? VO() : e === "auto-gpu" ? OO() : e;
  },
  vh(e) {
    return e === "$100vh" ? "var(--chakra-vh)" : e;
  },
  px(e) {
    if (e == null)
      return e;
    const { unitless: t } = UO(e);
    return t || typeof e == "number" ? `${e}px` : e;
  },
  fraction(e) {
    return typeof e != "number" || e > 1 ? e : `${e * 100}%`;
  },
  float(e, t) {
    const n = { left: "right", right: "left" };
    return t.direction === "rtl" ? n[e] : e;
  },
  degree(e) {
    if (zO(e) || e == null)
      return e;
    const t = typeof e == "string" && !e.endsWith("deg");
    return typeof e == "number" || t ? `${e}deg` : e;
  },
  gradient: WO,
  blur: Ta("blur"),
  opacity: Ta("opacity"),
  brightness: Ta("brightness"),
  contrast: Ta("contrast"),
  dropShadow: Ta("drop-shadow"),
  grayscale: Ta("grayscale"),
  hueRotate: (e) => Ta("hue-rotate")(Ut.degree(e)),
  invert: Ta("invert"),
  saturate: Ta("saturate"),
  sepia: Ta("sepia"),
  bgImage(e) {
    return e == null || b5(e) || C5.has(e) ? e : `url(${e})`;
  },
  outline(e) {
    const t = String(e) === "0" || String(e) === "none";
    return e !== null && t ? { outline: "2px solid transparent", outlineOffset: "2px" } : { outline: e };
  },
  flexDirection(e) {
    const { space: t, divide: n } = GO[e] ?? {}, r = { flexDirection: e };
    return t && (r[t] = 1), n && (r[n] = 1), r;
  }
}, W = {
  borderWidths: Bo("borderWidths"),
  borderStyles: Bo("borderStyles"),
  colors: Bo("colors"),
  borders: Bo("borders"),
  gradients: Bo("gradients", Ut.gradient),
  radii: Bo("radii", Ut.px),
  space: Bo("space", nf(Ut.vh, Ut.px)),
  spaceT: Bo("space", nf(Ut.vh, Ut.px)),
  degreeT(e) {
    return { property: e, transform: Ut.degree };
  },
  prop(e, t, n) {
    return {
      property: e,
      scale: t,
      ...t && {
        transform: W3({ scale: t, transform: n })
      }
    };
  },
  propT(e, t) {
    return { property: e, transform: t };
  },
  sizes: Bo("sizes", nf(Ut.vh, Ut.px)),
  sizesT: Bo("sizes", nf(Ut.vh, Ut.fraction)),
  shadows: Bo("shadows"),
  logical: kO,
  blur: Bo("blur", Ut.blur)
}, Hf = {
  background: W.colors("background"),
  backgroundColor: W.colors("backgroundColor"),
  backgroundImage: W.gradients("backgroundImage"),
  backgroundSize: !0,
  backgroundPosition: !0,
  backgroundRepeat: !0,
  backgroundAttachment: !0,
  backgroundClip: { transform: Ut.bgClip },
  bgSize: W.prop("backgroundSize"),
  bgPosition: W.prop("backgroundPosition"),
  bg: W.colors("background"),
  bgColor: W.colors("backgroundColor"),
  bgPos: W.prop("backgroundPosition"),
  bgRepeat: W.prop("backgroundRepeat"),
  bgAttachment: W.prop("backgroundAttachment"),
  bgGradient: W.gradients("backgroundImage"),
  bgClip: { transform: Ut.bgClip }
};
Object.assign(Hf, {
  bgImage: Hf.backgroundImage,
  bgImg: Hf.backgroundImage
});
const en = {
  border: W.borders("border"),
  borderWidth: W.borderWidths("borderWidth"),
  borderStyle: W.borderStyles("borderStyle"),
  borderColor: W.colors("borderColor"),
  borderRadius: W.radii("borderRadius"),
  borderTop: W.borders("borderTop"),
  borderBlockStart: W.borders("borderBlockStart"),
  borderTopLeftRadius: W.radii("borderTopLeftRadius"),
  borderStartStartRadius: W.logical({
    scale: "radii",
    property: {
      ltr: "borderTopLeftRadius",
      rtl: "borderTopRightRadius"
    }
  }),
  borderEndStartRadius: W.logical({
    scale: "radii",
    property: {
      ltr: "borderBottomLeftRadius",
      rtl: "borderBottomRightRadius"
    }
  }),
  borderTopRightRadius: W.radii("borderTopRightRadius"),
  borderStartEndRadius: W.logical({
    scale: "radii",
    property: {
      ltr: "borderTopRightRadius",
      rtl: "borderTopLeftRadius"
    }
  }),
  borderEndEndRadius: W.logical({
    scale: "radii",
    property: {
      ltr: "borderBottomRightRadius",
      rtl: "borderBottomLeftRadius"
    }
  }),
  borderRight: W.borders("borderRight"),
  borderInlineEnd: W.borders("borderInlineEnd"),
  borderBottom: W.borders("borderBottom"),
  borderBlockEnd: W.borders("borderBlockEnd"),
  borderBottomLeftRadius: W.radii("borderBottomLeftRadius"),
  borderBottomRightRadius: W.radii("borderBottomRightRadius"),
  borderLeft: W.borders("borderLeft"),
  borderInlineStart: {
    property: "borderInlineStart",
    scale: "borders"
  },
  borderInlineStartRadius: W.logical({
    scale: "radii",
    property: {
      ltr: ["borderTopLeftRadius", "borderBottomLeftRadius"],
      rtl: ["borderTopRightRadius", "borderBottomRightRadius"]
    }
  }),
  borderInlineEndRadius: W.logical({
    scale: "radii",
    property: {
      ltr: ["borderTopRightRadius", "borderBottomRightRadius"],
      rtl: ["borderTopLeftRadius", "borderBottomLeftRadius"]
    }
  }),
  borderX: W.borders(["borderLeft", "borderRight"]),
  borderInline: W.borders("borderInline"),
  borderY: W.borders(["borderTop", "borderBottom"]),
  borderBlock: W.borders("borderBlock"),
  borderTopWidth: W.borderWidths("borderTopWidth"),
  borderBlockStartWidth: W.borderWidths("borderBlockStartWidth"),
  borderTopColor: W.colors("borderTopColor"),
  borderBlockStartColor: W.colors("borderBlockStartColor"),
  borderTopStyle: W.borderStyles("borderTopStyle"),
  borderBlockStartStyle: W.borderStyles("borderBlockStartStyle"),
  borderBottomWidth: W.borderWidths("borderBottomWidth"),
  borderBlockEndWidth: W.borderWidths("borderBlockEndWidth"),
  borderBottomColor: W.colors("borderBottomColor"),
  borderBlockEndColor: W.colors("borderBlockEndColor"),
  borderBottomStyle: W.borderStyles("borderBottomStyle"),
  borderBlockEndStyle: W.borderStyles("borderBlockEndStyle"),
  borderLeftWidth: W.borderWidths("borderLeftWidth"),
  borderInlineStartWidth: W.borderWidths("borderInlineStartWidth"),
  borderLeftColor: W.colors("borderLeftColor"),
  borderInlineStartColor: W.colors("borderInlineStartColor"),
  borderLeftStyle: W.borderStyles("borderLeftStyle"),
  borderInlineStartStyle: W.borderStyles("borderInlineStartStyle"),
  borderRightWidth: W.borderWidths("borderRightWidth"),
  borderInlineEndWidth: W.borderWidths("borderInlineEndWidth"),
  borderRightColor: W.colors("borderRightColor"),
  borderInlineEndColor: W.colors("borderInlineEndColor"),
  borderRightStyle: W.borderStyles("borderRightStyle"),
  borderInlineEndStyle: W.borderStyles("borderInlineEndStyle"),
  borderTopRadius: W.radii(["borderTopLeftRadius", "borderTopRightRadius"]),
  borderBottomRadius: W.radii([
    "borderBottomLeftRadius",
    "borderBottomRightRadius"
  ]),
  borderLeftRadius: W.radii(["borderTopLeftRadius", "borderBottomLeftRadius"]),
  borderRightRadius: W.radii([
    "borderTopRightRadius",
    "borderBottomRightRadius"
  ])
};
Object.assign(en, {
  rounded: en.borderRadius,
  roundedTop: en.borderTopRadius,
  roundedTopLeft: en.borderTopLeftRadius,
  roundedTopRight: en.borderTopRightRadius,
  roundedTopStart: en.borderStartStartRadius,
  roundedTopEnd: en.borderStartEndRadius,
  roundedBottom: en.borderBottomRadius,
  roundedBottomLeft: en.borderBottomLeftRadius,
  roundedBottomRight: en.borderBottomRightRadius,
  roundedBottomStart: en.borderEndStartRadius,
  roundedBottomEnd: en.borderEndEndRadius,
  roundedLeft: en.borderLeftRadius,
  roundedRight: en.borderRightRadius,
  roundedStart: en.borderInlineStartRadius,
  roundedEnd: en.borderInlineEndRadius,
  borderStart: en.borderInlineStart,
  borderEnd: en.borderInlineEnd,
  borderTopStartRadius: en.borderStartStartRadius,
  borderTopEndRadius: en.borderStartEndRadius,
  borderBottomStartRadius: en.borderEndStartRadius,
  borderBottomEndRadius: en.borderEndEndRadius,
  borderStartRadius: en.borderInlineStartRadius,
  borderEndRadius: en.borderInlineEndRadius,
  borderStartWidth: en.borderInlineStartWidth,
  borderEndWidth: en.borderInlineEndWidth,
  borderStartColor: en.borderInlineStartColor,
  borderEndColor: en.borderInlineEndColor,
  borderStartStyle: en.borderInlineStartStyle,
  borderEndStyle: en.borderInlineEndStyle
});
const XO = {
  color: W.colors("color"),
  textColor: W.colors("color"),
  fill: W.colors("fill"),
  stroke: W.colors("stroke"),
  accentColor: W.colors("accentColor"),
  textFillColor: W.colors("textFillColor")
}, f2 = {
  alignItems: !0,
  alignContent: !0,
  justifyItems: !0,
  justifyContent: !0,
  flexWrap: !0,
  flexDirection: { transform: Ut.flexDirection },
  flex: !0,
  flexFlow: !0,
  flexGrow: !0,
  flexShrink: !0,
  flexBasis: W.sizes("flexBasis"),
  justifySelf: !0,
  alignSelf: !0,
  order: !0,
  placeItems: !0,
  placeContent: !0,
  placeSelf: !0,
  gap: W.space("gap"),
  rowGap: W.space("rowGap"),
  columnGap: W.space("columnGap")
};
Object.assign(f2, {
  flexDir: f2.flexDirection
});
const Go = {
  width: W.sizesT("width"),
  inlineSize: W.sizesT("inlineSize"),
  height: W.sizes("height"),
  blockSize: W.sizes("blockSize"),
  boxSize: W.sizes(["width", "height"]),
  minWidth: W.sizes("minWidth"),
  minInlineSize: W.sizes("minInlineSize"),
  minHeight: W.sizes("minHeight"),
  minBlockSize: W.sizes("minBlockSize"),
  maxWidth: W.sizes("maxWidth"),
  maxInlineSize: W.sizes("maxInlineSize"),
  maxHeight: W.sizes("maxHeight"),
  maxBlockSize: W.sizes("maxBlockSize"),
  overflow: !0,
  overflowX: !0,
  overflowY: !0,
  overscrollBehavior: !0,
  overscrollBehaviorX: !0,
  overscrollBehaviorY: !0,
  display: !0,
  aspectRatio: !0,
  hideFrom: {
    scale: "breakpoints",
    transform: (e, t) => {
      var o, a;
      return { [`@media screen and (min-width: ${((a = (o = t.__breakpoints) == null ? void 0 : o.get(e)) == null ? void 0 : a.minW) ?? e})`]: { display: "none" } };
    }
  },
  hideBelow: {
    scale: "breakpoints",
    transform: (e, t) => {
      var o, a;
      return { [`@media screen and (max-width: ${((a = (o = t.__breakpoints) == null ? void 0 : o.get(e)) == null ? void 0 : a._minW) ?? e})`]: { display: "none" } };
    }
  },
  verticalAlign: !0,
  boxSizing: !0,
  boxDecorationBreak: !0,
  float: W.propT("float", Ut.float),
  objectFit: !0,
  objectPosition: !0,
  visibility: !0,
  isolation: !0
};
Object.assign(Go, {
  w: Go.width,
  h: Go.height,
  minW: Go.minWidth,
  maxW: Go.maxWidth,
  minH: Go.minHeight,
  maxH: Go.maxHeight,
  overscroll: Go.overscrollBehavior,
  overscrollX: Go.overscrollBehaviorX,
  overscrollY: Go.overscrollBehaviorY
});
const YO = {
  filter: { transform: Ut.filter },
  blur: W.blur("--chakra-blur"),
  brightness: W.propT("--chakra-brightness", Ut.brightness),
  contrast: W.propT("--chakra-contrast", Ut.contrast),
  hueRotate: W.propT("--chakra-hue-rotate", Ut.hueRotate),
  invert: W.propT("--chakra-invert", Ut.invert),
  saturate: W.propT("--chakra-saturate", Ut.saturate),
  dropShadow: W.propT("--chakra-drop-shadow", Ut.dropShadow),
  backdropFilter: { transform: Ut.backdropFilter },
  backdropBlur: W.blur("--chakra-backdrop-blur"),
  backdropBrightness: W.propT(
    "--chakra-backdrop-brightness",
    Ut.brightness
  ),
  backdropContrast: W.propT("--chakra-backdrop-contrast", Ut.contrast),
  backdropHueRotate: W.propT(
    "--chakra-backdrop-hue-rotate",
    Ut.hueRotate
  ),
  backdropInvert: W.propT("--chakra-backdrop-invert", Ut.invert),
  backdropSaturate: W.propT("--chakra-backdrop-saturate", Ut.saturate)
}, qO = {
  ring: { transform: Ut.ring },
  ringColor: W.colors("--chakra-ring-color"),
  ringOffset: W.prop("--chakra-ring-offset-width"),
  ringOffsetColor: W.colors("--chakra-ring-offset-color"),
  ringInset: W.prop("--chakra-ring-inset")
}, JO = {
  appearance: !0,
  cursor: !0,
  resize: !0,
  userSelect: !0,
  pointerEvents: !0,
  outline: { transform: Ut.outline },
  outlineOffset: !0,
  outlineColor: W.colors("outlineColor")
}, TS = {
  gridGap: W.space("gridGap"),
  gridColumnGap: W.space("gridColumnGap"),
  gridRowGap: W.space("gridRowGap"),
  gridColumn: !0,
  gridRow: !0,
  gridAutoFlow: !0,
  gridAutoColumns: !0,
  gridColumnStart: !0,
  gridColumnEnd: !0,
  gridRowStart: !0,
  gridRowEnd: !0,
  gridAutoRows: !0,
  gridTemplate: !0,
  gridTemplateColumns: !0,
  gridTemplateRows: !0,
  gridTemplateAreas: !0,
  gridArea: !0
};
function KO(e, t, n, r) {
  const o = typeof t == "string" ? t.split(".") : [t];
  for (r = 0; r < o.length && e; r += 1)
    e = e[o[r]];
  return e === void 0 ? n : e;
}
const QO = (e) => {
  const t = /* @__PURE__ */ new WeakMap();
  return (r, o, a, i) => {
    if (typeof r > "u")
      return e(r, o, a);
    t.has(r) || t.set(r, /* @__PURE__ */ new Map());
    const l = t.get(r);
    if (l.has(o))
      return l.get(o);
    const u = e(r, o, a, i);
    return l.set(o, u), u;
  };
}, eF = QO(KO), tF = {
  border: "0px",
  clip: "rect(0, 0, 0, 0)",
  width: "1px",
  height: "1px",
  margin: "-1px",
  padding: "0px",
  overflow: "hidden",
  whiteSpace: "nowrap",
  position: "absolute"
}, nF = {
  position: "static",
  width: "auto",
  height: "auto",
  clip: "auto",
  padding: "0",
  margin: "0",
  overflow: "visible",
  whiteSpace: "normal"
}, Zp = (e, t, n) => {
  const r = {}, o = eF(e, t, {});
  for (const a in o)
    a in n && n[a] != null || (r[a] = o[a]);
  return r;
}, rF = {
  srOnly: {
    transform(e) {
      return e === !0 ? tF : e === "focusable" ? nF : {};
    }
  },
  layerStyle: {
    processResult: !0,
    transform: (e, t, n) => Zp(t, `layerStyles.${e}`, n)
  },
  textStyle: {
    processResult: !0,
    transform: (e, t, n) => Zp(t, `textStyles.${e}`, n)
  },
  apply: {
    processResult: !0,
    transform: (e, t, n) => Zp(t, e, n)
  }
}, H1 = {
  position: !0,
  pos: W.prop("position"),
  zIndex: W.prop("zIndex", "zIndices"),
  inset: W.spaceT("inset"),
  insetX: W.spaceT(["left", "right"]),
  insetInline: W.spaceT("insetInline"),
  insetY: W.spaceT(["top", "bottom"]),
  insetBlock: W.spaceT("insetBlock"),
  top: W.spaceT("top"),
  insetBlockStart: W.spaceT("insetBlockStart"),
  bottom: W.spaceT("bottom"),
  insetBlockEnd: W.spaceT("insetBlockEnd"),
  left: W.spaceT("left"),
  insetInlineStart: W.logical({
    scale: "space",
    property: { ltr: "left", rtl: "right" }
  }),
  right: W.spaceT("right"),
  insetInlineEnd: W.logical({
    scale: "space",
    property: { ltr: "right", rtl: "left" }
  })
};
Object.assign(H1, {
  insetStart: H1.insetInlineStart,
  insetEnd: H1.insetInlineEnd
});
const y5 = {
  boxShadow: W.shadows("boxShadow"),
  mixBlendMode: !0,
  blendMode: W.prop("mixBlendMode"),
  backgroundBlendMode: !0,
  bgBlendMode: W.prop("backgroundBlendMode"),
  opacity: !0
};
Object.assign(y5, {
  shadow: y5.boxShadow
});
const wn = {
  margin: W.spaceT("margin"),
  marginTop: W.spaceT("marginTop"),
  marginBlockStart: W.spaceT("marginBlockStart"),
  marginRight: W.spaceT("marginRight"),
  marginInlineEnd: W.spaceT("marginInlineEnd"),
  marginBottom: W.spaceT("marginBottom"),
  marginBlockEnd: W.spaceT("marginBlockEnd"),
  marginLeft: W.spaceT("marginLeft"),
  marginInlineStart: W.spaceT("marginInlineStart"),
  marginX: W.spaceT(["marginInlineStart", "marginInlineEnd"]),
  marginInline: W.spaceT("marginInline"),
  marginY: W.spaceT(["marginTop", "marginBottom"]),
  marginBlock: W.spaceT("marginBlock"),
  padding: W.space("padding"),
  paddingTop: W.space("paddingTop"),
  paddingBlockStart: W.space("paddingBlockStart"),
  paddingRight: W.space("paddingRight"),
  paddingBottom: W.space("paddingBottom"),
  paddingBlockEnd: W.space("paddingBlockEnd"),
  paddingLeft: W.space("paddingLeft"),
  paddingInlineStart: W.space("paddingInlineStart"),
  paddingInlineEnd: W.space("paddingInlineEnd"),
  paddingX: W.space(["paddingInlineStart", "paddingInlineEnd"]),
  paddingInline: W.space("paddingInline"),
  paddingY: W.space(["paddingTop", "paddingBottom"]),
  paddingBlock: W.space("paddingBlock")
};
Object.assign(wn, {
  m: wn.margin,
  mt: wn.marginTop,
  mr: wn.marginRight,
  me: wn.marginInlineEnd,
  marginEnd: wn.marginInlineEnd,
  mb: wn.marginBottom,
  ml: wn.marginLeft,
  ms: wn.marginInlineStart,
  marginStart: wn.marginInlineStart,
  mx: wn.marginX,
  my: wn.marginY,
  p: wn.padding,
  pt: wn.paddingTop,
  py: wn.paddingY,
  px: wn.paddingX,
  pb: wn.paddingBottom,
  pl: wn.paddingLeft,
  ps: wn.paddingInlineStart,
  paddingStart: wn.paddingInlineStart,
  pr: wn.paddingRight,
  pe: wn.paddingInlineEnd,
  paddingEnd: wn.paddingInlineEnd
});
const oF = {
  scrollBehavior: !0,
  scrollSnapAlign: !0,
  scrollSnapStop: !0,
  scrollSnapType: !0,
  // scroll margin
  scrollMargin: W.spaceT("scrollMargin"),
  scrollMarginTop: W.spaceT("scrollMarginTop"),
  scrollMarginBottom: W.spaceT("scrollMarginBottom"),
  scrollMarginLeft: W.spaceT("scrollMarginLeft"),
  scrollMarginRight: W.spaceT("scrollMarginRight"),
  scrollMarginX: W.spaceT(["scrollMarginLeft", "scrollMarginRight"]),
  scrollMarginY: W.spaceT(["scrollMarginTop", "scrollMarginBottom"]),
  // scroll padding
  scrollPadding: W.spaceT("scrollPadding"),
  scrollPaddingTop: W.spaceT("scrollPaddingTop"),
  scrollPaddingBottom: W.spaceT("scrollPaddingBottom"),
  scrollPaddingLeft: W.spaceT("scrollPaddingLeft"),
  scrollPaddingRight: W.spaceT("scrollPaddingRight"),
  scrollPaddingX: W.spaceT(["scrollPaddingLeft", "scrollPaddingRight"]),
  scrollPaddingY: W.spaceT(["scrollPaddingTop", "scrollPaddingBottom"])
}, aF = {
  fontFamily: W.prop("fontFamily", "fonts"),
  fontSize: W.prop("fontSize", "fontSizes", Ut.px),
  fontWeight: W.prop("fontWeight", "fontWeights"),
  lineHeight: W.prop("lineHeight", "lineHeights"),
  letterSpacing: W.prop("letterSpacing", "letterSpacings"),
  textAlign: !0,
  fontStyle: !0,
  textIndent: !0,
  wordBreak: !0,
  overflowWrap: !0,
  textOverflow: !0,
  textTransform: !0,
  whiteSpace: !0,
  isTruncated: {
    transform(e) {
      if (e === !0)
        return {
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap"
        };
    }
  },
  noOfLines: {
    static: {
      overflow: "hidden",
      textOverflow: "ellipsis",
      display: "-webkit-box",
      WebkitBoxOrient: "vertical",
      //@ts-ignore
      WebkitLineClamp: "var(--chakra-line-clamp)"
    },
    property: "--chakra-line-clamp"
  }
}, iF = {
  textDecorationColor: W.colors("textDecorationColor"),
  textDecoration: !0,
  textDecor: { property: "textDecoration" },
  textDecorationLine: !0,
  textDecorationStyle: !0,
  textDecorationThickness: !0,
  textUnderlineOffset: !0,
  textShadow: W.shadows("textShadow")
}, sF = {
  clipPath: !0,
  transform: W.propT("transform", Ut.transform),
  transformOrigin: !0,
  translateX: W.spaceT("--chakra-translate-x"),
  translateY: W.spaceT("--chakra-translate-y"),
  skewX: W.degreeT("--chakra-skew-x"),
  skewY: W.degreeT("--chakra-skew-y"),
  scaleX: W.prop("--chakra-scale-x"),
  scaleY: W.prop("--chakra-scale-y"),
  scale: W.prop(["--chakra-scale-x", "--chakra-scale-y"]),
  rotate: W.degreeT("--chakra-rotate")
}, lF = {
  listStyleType: !0,
  listStylePosition: !0,
  listStylePos: W.prop("listStylePosition"),
  listStyleImage: !0,
  listStyleImg: W.prop("listStyleImage")
}, uF = {
  transition: !0,
  transitionDelay: !0,
  animation: !0,
  willChange: !0,
  transitionDuration: W.prop("transitionDuration", "transition.duration"),
  transitionProperty: W.prop("transitionProperty", "transition.property"),
  transitionTimingFunction: W.prop(
    "transitionTimingFunction",
    "transition.easing"
  )
}, z3 = zo(
  {},
  Hf,
  en,
  XO,
  f2,
  Go,
  YO,
  qO,
  JO,
  TS,
  rF,
  H1,
  y5,
  wn,
  oF,
  aF,
  iF,
  sF,
  lF,
  uF
), cF = Object.assign({}, wn, Go, f2, TS, H1), NS = Object.keys(
  cF
), dF = [...Object.keys(z3), ...PS], fF = { ...z3, ...Zu }, hF = (e) => e in fF, mF = (e) => (t) => {
  if (!t.__breakpoints)
    return e;
  const { isResponsive: n, toArrayValue: r, media: o } = t.__breakpoints, a = {};
  for (const i in e) {
    let l = Wo(e[i], t);
    if (l == null)
      continue;
    if (l = cr(l) && n(l) ? r(l) : l, !Array.isArray(l)) {
      a[i] = l;
      continue;
    }
    const u = l.slice(0, o.length).length;
    for (let d = 0; d < u; d += 1) {
      const f = o == null ? void 0 : o[d];
      if (!f) {
        a[i] = l[d];
        continue;
      }
      a[f] = a[f] || {}, l[d] != null && (a[f][i] = l[d]);
    }
  }
  return a;
};
function pF(e) {
  const t = [];
  let n = "", r = !1;
  for (let o = 0; o < e.length; o++) {
    const a = e[o];
    a === "(" ? (r = !0, n += a) : a === ")" ? (r = !1, n += a) : a === "," && !r ? (t.push(n), n = "") : n += a;
  }
  return n = n.trim(), n && t.push(n), t;
}
function gF(e) {
  return /^var\(--.+\)$/.test(e);
}
const vF = (e, t) => e.startsWith("--") && typeof t == "string" && !gF(t), CF = (e, t) => {
  if (t == null)
    return t;
  const n = (i) => {
    var l, u;
    return (u = (l = e.__cssMap) == null ? void 0 : l[i]) == null ? void 0 : u.varRef;
  }, r = (i) => n(i) ?? i, [o, a] = pF(t);
  return t = n(o) ?? r(a) ?? r(t), t;
};
function bF(e) {
  const { configs: t = {}, pseudos: n = {}, theme: r } = e, o = (a, i = !1) => {
    var f;
    const l = Wo(a, r), u = mF(l)(r);
    let d = {};
    for (let h in u) {
      const p = u[h];
      let g = Wo(p, r);
      h in n && (h = n[h]), vF(h, g) && (g = CF(r, g));
      let C = t[h];
      if (C === !0 && (C = { property: h }), cr(g)) {
        d[h] = d[h] ?? {}, d[h] = zo(
          {},
          d[h],
          o(g, !0)
        );
        continue;
      }
      let v = ((f = C == null ? void 0 : C.transform) == null ? void 0 : f.call(C, g, r, l)) ?? g;
      v = C != null && C.processResult ? o(v, !0) : v;
      const y = Wo(C == null ? void 0 : C.property, r);
      if (!i && (C != null && C.static)) {
        const M = Wo(C.static, r);
        d = zo({}, d, M);
      }
      if (y && Array.isArray(y)) {
        for (const M of y)
          d[M] = v;
        continue;
      }
      if (y) {
        y === "&" && cr(v) ? d = zo({}, d, v) : d[y] = v;
        continue;
      }
      if (cr(v)) {
        d = zo({}, d, v);
        continue;
      }
      d[h] = v;
    }
    return d;
  };
  return o;
}
const kS = (e) => (t) => bF({
  theme: t,
  pseudos: Zu,
  configs: z3
})(e);
function vn(e) {
  return {
    definePartsStyle(t) {
      return t;
    },
    defineMultiStyleConfig(t) {
      return { parts: e, ...t };
    }
  };
}
function yF(e, t, n) {
  var r, o;
  return ((o = (r = e.__cssMap) == null ? void 0 : r[`${t}.${n}`]) == null ? void 0 : o.varRef) ?? n;
}
function SF(e, t) {
  if (Array.isArray(e))
    return e;
  if (cr(e))
    return t(e);
  if (e != null)
    return [e];
}
function AF(e, t) {
  for (let n = t + 1; n < e.length; n++)
    if (e[n] != null)
      return n;
  return -1;
}
function MF(e) {
  const t = e.__breakpoints;
  return function(r, o, a, i) {
    var p, g;
    if (!t)
      return;
    const l = {}, u = SF(a, t.toArrayValue);
    if (!u)
      return l;
    const d = u.length, f = d === 1, h = !!r.parts;
    for (let C = 0; C < d; C++) {
      const v = t.details[C], y = t.details[AF(u, C)], M = _1(v.minW, y == null ? void 0 : y._minW), x = Wo((p = r[o]) == null ? void 0 : p[u[C]], i);
      if (x) {
        if (h) {
          (g = r.parts) == null || g.forEach((_) => {
            zo(l, {
              [_]: f ? x[_] : { [M]: x[_] }
            });
          });
          continue;
        }
        if (!h) {
          f ? zo(l, x) : l[M] = x;
          continue;
        }
        l[M] = x;
      }
    }
    return l;
  };
}
function xF(e) {
  return (t) => {
    const { variant: n, size: r, theme: o } = t, a = MF(o);
    return zo(
      {},
      Wo(e.baseStyle ?? {}, t),
      a(e, "sizes", r, t),
      a(e, "variants", n, t)
    );
  };
}
function Ln(e) {
  return Mh(e, ["styleConfig", "size", "variant", "colorScheme"]);
}
function VS(e) {
  return cr(e) && e.reference ? e.reference : String(e);
}
const xh = (e, ...t) => t.map(VS).join(` ${e} `).replace(/calc/g, ""), wv = (...e) => `calc(${xh("+", ...e)})`, _v = (...e) => `calc(${xh("-", ...e)})`, S5 = (...e) => `calc(${xh("*", ...e)})`, Iv = (...e) => `calc(${xh("/", ...e)})`, Lv = (e) => {
  const t = VS(e);
  return t != null && !Number.isNaN(parseFloat(t)) ? String(t).startsWith("-") ? String(t).slice(1) : `-${t}` : S5(t, -1);
}, fi = Object.assign(
  (e) => ({
    add: (...t) => fi(wv(e, ...t)),
    subtract: (...t) => fi(_v(e, ...t)),
    multiply: (...t) => fi(S5(e, ...t)),
    divide: (...t) => fi(Iv(e, ...t)),
    negate: () => fi(Lv(e)),
    toString: () => e.toString()
  }),
  {
    add: wv,
    subtract: _v,
    multiply: S5,
    divide: Iv,
    negate: Lv
  }
);
function wF(e, t = "-") {
  return e.replace(/\s+/g, t);
}
function _F(e) {
  const t = wF(e.toString());
  return LF(IF(t));
}
function IF(e) {
  return e.includes("\\.") ? e : !Number.isInteger(parseFloat(e.toString())) ? e.replace(".", "\\.") : e;
}
function LF(e) {
  return e.replace(/[!-,/:-@[-^`{-~]/g, "\\$&");
}
function RF(e, t = "") {
  return [t, e].filter(Boolean).join("-");
}
function DF(e, t) {
  return `var(${e}${t ? `, ${t}` : ""})`;
}
function PF(e, t = "") {
  return _F(`--${RF(e, t)}`);
}
function at(e, t, n) {
  const r = PF(e, n);
  return {
    variable: r,
    reference: DF(r, t)
  };
}
function EF(e, t) {
  const n = {};
  for (const r of t) {
    if (Array.isArray(r)) {
      const [o, a] = r;
      n[o] = at(`${e}-${o}`, a);
      continue;
    }
    n[r] = at(`${e}-${r}`);
  }
  return n;
}
const TF = [
  "colors",
  "borders",
  "borderWidths",
  "borderStyles",
  "fonts",
  "fontSizes",
  "fontWeights",
  "gradients",
  "letterSpacings",
  "lineHeights",
  "radii",
  "space",
  "shadows",
  "sizes",
  "zIndices",
  "transition",
  "blur",
  "breakpoints"
];
function NF(e) {
  return yS(e, TF);
}
function kF(e) {
  return e.semanticTokens;
}
function VF(e) {
  const { __cssMap: t, __cssVars: n, __breakpoints: r, ...o } = e;
  return o;
}
function OF(e) {
  const t = NF(e), n = kF(e), r = (a) => (
    // @ts-ignore
    PS.includes(a) || a === "default"
  ), o = {};
  return Mv(t, (a, i) => {
    a != null && (o[i.join(".")] = { isSemantic: !1, value: a });
  }), Mv(
    n,
    (a, i) => {
      a != null && (o[i.join(".")] = { isSemantic: !0, value: a });
    },
    {
      stop: (a) => Object.keys(a).every(r)
    }
  ), o;
}
function Rv(e, t) {
  return at(String(e).replace(/\./g, "-"), void 0, t);
}
function FF(e) {
  var i;
  const t = OF(e), n = (i = e.config) == null ? void 0 : i.cssVarPrefix;
  let r = {};
  const o = {};
  function a(l, u) {
    const f = [String(l).split(".")[0], u].join(".");
    if (!t[f])
      return u;
    const { reference: p } = Rv(f, n);
    return p;
  }
  for (const [l, u] of Object.entries(t)) {
    const { isSemantic: d, value: f } = u, { variable: h, reference: p } = Rv(l, n);
    if (!d) {
      if (l.startsWith("space")) {
        const C = l.split("."), [v, ...y] = C, M = `${v}.-${y.join(".")}`, x = fi.negate(f), _ = fi.negate(p);
        o[M] = {
          value: x,
          var: h,
          varRef: _
        };
      }
      r[h] = f, o[l] = {
        value: f,
        var: h,
        varRef: p
      };
      continue;
    }
    const g = cr(f) ? f : { default: f };
    r = zo(
      r,
      Object.entries(g).reduce(
        (C, [v, y]) => {
          if (!y)
            return C;
          const M = a(l, `${y}`);
          if (v === "default")
            return C[h] = M, C;
          const x = (Zu == null ? void 0 : Zu[v]) ?? v;
          return C[x] = { [h]: M }, C;
        },
        {}
      )
    ), o[l] = {
      value: p,
      var: h,
      varRef: p
    };
  }
  return {
    cssVars: r,
    cssMap: o
  };
}
function BF(e) {
  const t = VF(e), {
    /**
     * This is more like a dictionary of tokens users will type `green.500`,
     * and their equivalent css variable.
     */
    cssMap: n,
    /**
     * The extracted css variables will be stored here, and used in
     * the emotion's <Global/> component to attach variables to `:root`
     */
    cssVars: r
  } = FF(t);
  return Object.assign(t, {
    __cssVars: { ...{
      "--chakra-ring-inset": "var(--chakra-empty,/*!*/ /*!*/)",
      "--chakra-ring-offset-width": "0px",
      "--chakra-ring-offset-color": "#fff",
      "--chakra-ring-color": "rgba(66, 153, 225, 0.6)",
      "--chakra-ring-offset-shadow": "0 0 #0000",
      "--chakra-ring-shadow": "0 0 #0000",
      "--chakra-space-x-reverse": "0",
      "--chakra-space-y-reverse": "0"
    }, ...r },
    __cssMap: n,
    __breakpoints: JV(t.breakpoints)
  }), t;
}
function rn(e, t = {}) {
  let n = !1;
  function r() {
    if (!n) {
      n = !0;
      return;
    }
    throw new Error(
      "[anatomy] .part(...) should only be called once. Did you mean to use .extend(...) ?"
    );
  }
  function o(...f) {
    r();
    for (const h of f)
      t[h] = u(h);
    return rn(e, t);
  }
  function a(...f) {
    for (const h of f)
      h in t || (t[h] = u(h));
    return rn(e, t);
  }
  function i() {
    return Object.fromEntries(
      Object.entries(t).map(([h, p]) => [h, p.selector])
    );
  }
  function l() {
    return Object.fromEntries(
      Object.entries(t).map(([h, p]) => [h, p.className])
    );
  }
  function u(f) {
    const g = `chakra-${(["container", "root"].includes(f ?? "") ? [e] : [e, f]).filter(Boolean).join("__")}`;
    return {
      className: g,
      selector: `.${g}`,
      toString: () => f
    };
  }
  return {
    parts: o,
    toPart: u,
    extend: a,
    selectors: i,
    classnames: l,
    get keys() {
      return Object.keys(t);
    },
    __type: {}
  };
}
const HF = rn("accordion").parts(
  "root",
  "container",
  "button",
  "panel",
  "icon"
), GF = rn("alert").parts(
  "title",
  "description",
  "container",
  "icon",
  "spinner"
), $F = rn("avatar").parts(
  "label",
  "badge",
  "container",
  "excessLabel",
  "group"
), ZF = rn("breadcrumb").parts(
  "link",
  "item",
  "container",
  "separator"
);
rn("button").parts();
const jF = rn("checkbox").parts(
  "control",
  "icon",
  "container",
  "label"
);
rn("progress").parts(
  "track",
  "filledTrack",
  "label"
);
const WF = rn("drawer").parts(
  "overlay",
  "dialogContainer",
  "dialog",
  "header",
  "closeButton",
  "body",
  "footer"
), zF = rn("editable").parts(
  "preview",
  "input",
  "textarea"
), UF = rn("form").parts(
  "container",
  "requiredIndicator",
  "helperText"
), XF = rn("formError").parts("text", "icon"), YF = rn("input").parts(
  "addon",
  "field",
  "element",
  "group"
), qF = rn("list").parts("container", "item", "icon"), JF = rn("menu").parts(
  "button",
  "list",
  "item",
  "groupTitle",
  "icon",
  "command",
  "divider"
), KF = rn("modal").parts(
  "overlay",
  "dialogContainer",
  "dialog",
  "header",
  "closeButton",
  "body",
  "footer"
), QF = rn("numberinput").parts(
  "root",
  "field",
  "stepperGroup",
  "stepper"
);
rn("pininput").parts("field");
const OS = rn("popover").parts(
  "content",
  "header",
  "body",
  "footer",
  "popper",
  "arrow",
  "closeButton"
), eB = rn("progress").parts(
  "label",
  "filledTrack",
  "track"
), tB = rn("radio").parts(
  "container",
  "control",
  "label"
), nB = rn("select").parts("field", "icon"), rB = rn("slider").parts(
  "container",
  "track",
  "thumb",
  "filledTrack",
  "mark"
), oB = rn("stat").parts(
  "container",
  "label",
  "helpText",
  "number",
  "icon"
), aB = rn("switch").parts(
  "container",
  "track",
  "thumb",
  "label"
), iB = rn("table").parts(
  "table",
  "thead",
  "tbody",
  "tr",
  "th",
  "td",
  "tfoot",
  "caption"
), sB = rn("tabs").parts(
  "root",
  "tab",
  "tablist",
  "tabpanel",
  "tabpanels",
  "indicator"
), lB = rn("tag").parts(
  "container",
  "label",
  "closeButton"
), uB = rn("card").parts(
  "container",
  "header",
  "body",
  "footer"
);
rn("stepper").parts(
  "stepper",
  "step",
  "title",
  "description",
  "indicator",
  "separator",
  "icon",
  "number"
);
const { definePartsStyle: cB, defineMultiStyleConfig: dB } = vn(HF.keys), fB = {
  borderTopWidth: "1px",
  borderColor: "inherit",
  _last: {
    borderBottomWidth: "1px"
  }
}, hB = {
  transitionProperty: "common",
  transitionDuration: "normal",
  fontSize: "md",
  _focusVisible: {
    boxShadow: "outline"
  },
  _hover: {
    bg: "blackAlpha.50"
  },
  _disabled: {
    opacity: 0.4,
    cursor: "not-allowed"
  },
  px: "4",
  py: "2"
}, mB = {
  pt: "2",
  px: "4",
  pb: "5"
}, pB = {
  fontSize: "1.25em"
}, gB = cB({
  container: fB,
  button: hB,
  panel: mB,
  icon: pB
}), vB = dB({ baseStyle: gB });
function sl(e, t, n) {
  return Math.min(Math.max(e, n), t);
}
class CB extends Error {
  constructor(t) {
    super(`Failed to parse color: "${t}"`);
  }
}
var I1 = CB;
function U3(e) {
  if (typeof e != "string")
    throw new I1(e);
  if (e.trim().toLowerCase() === "transparent")
    return [0, 0, 0, 0];
  let t = e.trim();
  t = _B.test(e) ? SB(e) : e;
  const n = AB.exec(t);
  if (n) {
    const i = Array.from(n).slice(1);
    return [...i.slice(0, 3).map((l) => parseInt(id(l, 2), 16)), parseInt(id(i[3] || "f", 2), 16) / 255];
  }
  const r = MB.exec(t);
  if (r) {
    const i = Array.from(r).slice(1);
    return [...i.slice(0, 3).map((l) => parseInt(l, 16)), parseInt(i[3] || "ff", 16) / 255];
  }
  const o = xB.exec(t);
  if (o) {
    const i = Array.from(o).slice(1);
    return [...i.slice(0, 3).map((l) => parseInt(l, 10)), parseFloat(i[3] || "1")];
  }
  const a = wB.exec(t);
  if (a) {
    const [i, l, u, d] = Array.from(a).slice(1).map(parseFloat);
    if (sl(0, 100, l) !== l)
      throw new I1(e);
    if (sl(0, 100, u) !== u)
      throw new I1(e);
    return [...IB(i, l, u), Number.isNaN(d) ? 1 : d];
  }
  throw new I1(e);
}
function bB(e) {
  let t = 5381, n = e.length;
  for (; n; )
    t = t * 33 ^ e.charCodeAt(--n);
  return (t >>> 0) % 2341;
}
const Dv = (e) => parseInt(e.replace(/_/g, ""), 36), yB = "1q29ehhb 1n09sgk7 1kl1ekf_ _yl4zsno 16z9eiv3 1p29lhp8 _bd9zg04 17u0____ _iw9zhe5 _to73___ _r45e31e _7l6g016 _jh8ouiv _zn3qba8 1jy4zshs 11u87k0u 1ro9yvyo 1aj3xael 1gz9zjz0 _3w8l4xo 1bf1ekf_ _ke3v___ _4rrkb__ 13j776yz _646mbhl _nrjr4__ _le6mbhl 1n37ehkb _m75f91n _qj3bzfz 1939yygw 11i5z6x8 _1k5f8xs 1509441m 15t5lwgf _ae2th1n _tg1ugcv 1lp1ugcv 16e14up_ _h55rw7n _ny9yavn _7a11xb_ 1ih442g9 _pv442g9 1mv16xof 14e6y7tu 1oo9zkds 17d1cisi _4v9y70f _y98m8kc 1019pq0v 12o9zda8 _348j4f4 1et50i2o _8epa8__ _ts6senj 1o350i2o 1mi9eiuo 1259yrp0 1ln80gnw _632xcoy 1cn9zldc _f29edu4 1n490c8q _9f9ziet 1b94vk74 _m49zkct 1kz6s73a 1eu9dtog _q58s1rz 1dy9sjiq __u89jo3 _aj5nkwg _ld89jo3 13h9z6wx _qa9z2ii _l119xgq _bs5arju 1hj4nwk9 1qt4nwk9 1ge6wau6 14j9zlcw 11p1edc_ _ms1zcxe _439shk6 _jt9y70f _754zsow 1la40eju _oq5p___ _x279qkz 1fa5r3rv _yd2d9ip _424tcku _8y1di2_ _zi2uabw _yy7rn9h 12yz980_ __39ljp6 1b59zg0x _n39zfzp 1fy9zest _b33k___ _hp9wq92 1il50hz4 _io472ub _lj9z3eo 19z9ykg0 _8t8iu3a 12b9bl4a 1ak5yw0o _896v4ku _tb8k8lv _s59zi6t _c09ze0p 1lg80oqn 1id9z8wb _238nba5 1kq6wgdi _154zssg _tn3zk49 _da9y6tc 1sg7cv4f _r12jvtt 1gq5fmkz 1cs9rvci _lp9jn1c _xw1tdnb 13f9zje6 16f6973h _vo7ir40 _bt5arjf _rc45e4t _hr4e100 10v4e100 _hc9zke2 _w91egv_ _sj2r1kk 13c87yx8 _vqpds__ _ni8ggk8 _tj9yqfb 1ia2j4r4 _7x9b10u 1fc9ld4j 1eq9zldr _5j9lhpx _ez9zl6o _md61fzm".split(" ").reduce((e, t) => {
  const n = Dv(t.substring(0, 3)), r = Dv(t.substring(3)).toString(16);
  let o = "";
  for (let a = 0; a < 6 - r.length; a++)
    o += "0";
  return e[n] = `${o}${r}`, e;
}, {});
function SB(e) {
  const t = e.toLowerCase().trim(), n = yB[bB(t)];
  if (!n)
    throw new I1(e);
  return `#${n}`;
}
const id = (e, t) => Array.from(Array(t)).map(() => e).join(""), AB = new RegExp(`^#${id("([a-f0-9])", 3)}([a-f0-9])?$`, "i"), MB = new RegExp(`^#${id("([a-f0-9]{2})", 3)}([a-f0-9]{2})?$`, "i"), xB = new RegExp(`^rgba?\\(\\s*(\\d+)\\s*${id(",\\s*(\\d+)\\s*", 2)}(?:,\\s*([\\d.]+))?\\s*\\)$`, "i"), wB = /^hsla?\(\s*([\d.]+)\s*,\s*([\d.]+)%\s*,\s*([\d.]+)%(?:\s*,\s*([\d.]+))?\s*\)$/i, _B = /^[a-z]+$/i, Pv = (e) => Math.round(e * 255), IB = (e, t, n) => {
  let r = n / 100;
  if (t === 0)
    return [r, r, r].map(Pv);
  const o = (e % 360 + 360) % 360 / 60, a = (1 - Math.abs(2 * r - 1)) * (t / 100), i = a * (1 - Math.abs(o % 2 - 1));
  let l = 0, u = 0, d = 0;
  o >= 0 && o < 1 ? (l = a, u = i) : o >= 1 && o < 2 ? (l = i, u = a) : o >= 2 && o < 3 ? (u = a, d = i) : o >= 3 && o < 4 ? (u = i, d = a) : o >= 4 && o < 5 ? (l = i, d = a) : o >= 5 && o < 6 && (l = a, d = i);
  const f = r - a / 2, h = l + f, p = u + f, g = d + f;
  return [h, p, g].map(Pv);
};
function LB(e, t, n, r) {
  return `rgba(${sl(0, 255, e).toFixed()}, ${sl(0, 255, t).toFixed()}, ${sl(0, 255, n).toFixed()}, ${parseFloat(sl(0, 1, r).toFixed(3))})`;
}
function RB(e, t) {
  const [n, r, o, a] = U3(e);
  return LB(n, r, o, a - t);
}
function DB(e) {
  const [t, n, r, o] = U3(e);
  let a = (i) => {
    const l = sl(0, 255, i).toString(16);
    return l.length === 1 ? `0${l}` : l;
  };
  return `#${a(t)}${a(n)}${a(r)}${o < 1 ? a(Math.round(o * 255)) : ""}`;
}
const PB = (e) => Object.keys(e).length === 0;
function EB(e, t, n, r, o) {
  for (t = t.split ? t.split(".") : t, r = 0; r < t.length; r++)
    e = e ? e[t[r]] : o;
  return e === o ? n : e;
}
const $r = (e, t, n) => {
  const r = EB(e, `colors.${t}`, t);
  try {
    return DB(r), r;
  } catch {
    return n ?? "#000000";
  }
}, TB = (e) => {
  const [t, n, r] = U3(e);
  return (t * 299 + n * 587 + r * 114) / 1e3;
}, NB = (e) => (t) => {
  const n = $r(t, e);
  return TB(n) < 128 ? "dark" : "light";
}, kB = (e) => (t) => NB(e)(t) === "dark", Ju = (e, t) => (n) => {
  const r = $r(n, e);
  return RB(r, 1 - t);
};
function Ev(e = "1rem", t = "rgba(255, 255, 255, 0.15)") {
  return {
    backgroundImage: `linear-gradient(
    45deg,
    ${t} 25%,
    transparent 25%,
    transparent 50%,
    ${t} 50%,
    ${t} 75%,
    transparent 75%,
    transparent
  )`,
    backgroundSize: `${e} ${e}`
  };
}
const VB = () => `#${Math.floor(Math.random() * 16777215).toString(16).padEnd(6, "0")}`;
function OB(e) {
  const t = VB();
  return !e || PB(e) ? t : e.string && e.colors ? BB(e.string, e.colors) : e.string && !e.colors ? FB(e.string) : e.colors && !e.string ? HB(e.colors) : t;
}
function FB(e) {
  let t = 0;
  if (e.length === 0)
    return t.toString();
  for (let r = 0; r < e.length; r += 1)
    t = e.charCodeAt(r) + ((t << 5) - t), t = t & t;
  let n = "#";
  for (let r = 0; r < 3; r += 1) {
    const o = t >> r * 8 & 255;
    n += `00${o.toString(16)}`.substr(-2);
  }
  return n;
}
function BB(e, t) {
  let n = 0;
  if (e.length === 0)
    return t[0];
  for (let r = 0; r < e.length; r += 1)
    n = e.charCodeAt(r) + ((n << 5) - n), n = n & n;
  return n = (n % t.length + t.length) % t.length, t[n];
}
function HB(e) {
  return e[Math.floor(Math.random() * e.length)];
}
function rt(e, t) {
  return (n) => n.colorMode === "dark" ? t : e;
}
function X3(e) {
  const { orientation: t, vertical: n, horizontal: r } = e;
  return t ? t === "vertical" ? n : r : {};
}
function FS(e) {
  return cr(e) && e.reference ? e.reference : String(e);
}
const wh = (e, ...t) => t.map(FS).join(` ${e} `).replace(/calc/g, ""), Tv = (...e) => `calc(${wh("+", ...e)})`, Nv = (...e) => `calc(${wh("-", ...e)})`, A5 = (...e) => `calc(${wh("*", ...e)})`, kv = (...e) => `calc(${wh("/", ...e)})`, Vv = (e) => {
  const t = FS(e);
  return t != null && !Number.isNaN(parseFloat(t)) ? String(t).startsWith("-") ? String(t).slice(1) : `-${t}` : A5(t, -1);
}, hi = Object.assign(
  (e) => ({
    add: (...t) => hi(Tv(e, ...t)),
    subtract: (...t) => hi(Nv(e, ...t)),
    multiply: (...t) => hi(A5(e, ...t)),
    divide: (...t) => hi(kv(e, ...t)),
    negate: () => hi(Vv(e)),
    toString: () => e.toString()
  }),
  {
    add: Tv,
    subtract: Nv,
    multiply: A5,
    divide: kv,
    negate: Vv
  }
);
function GB(e) {
  return !Number.isInteger(parseFloat(e.toString()));
}
function $B(e, t = "-") {
  return e.replace(/\s+/g, t);
}
function BS(e) {
  const t = $B(e.toString());
  return t.includes("\\.") ? e : GB(e) ? t.replace(".", "\\.") : e;
}
function ZB(e, t = "") {
  return [t, BS(e)].filter(Boolean).join("-");
}
function jB(e, t) {
  return `var(${BS(e)}${t ? `, ${t}` : ""})`;
}
function WB(e, t = "") {
  return `--${ZB(e, t)}`;
}
function dr(e, t) {
  const n = WB(e, t == null ? void 0 : t.prefix);
  return {
    variable: n,
    reference: jB(n, zB(t == null ? void 0 : t.fallback))
  };
}
function zB(e) {
  return typeof e == "string" ? e : e == null ? void 0 : e.reference;
}
const { definePartsStyle: _d, defineMultiStyleConfig: UB } = vn(GF.keys), xo = at("alert-fg"), _i = at("alert-bg"), XB = _d({
  container: {
    bg: _i.reference,
    px: "4",
    py: "3"
  },
  title: {
    fontWeight: "bold",
    lineHeight: "6",
    marginEnd: "2"
  },
  description: {
    lineHeight: "6"
  },
  icon: {
    color: xo.reference,
    flexShrink: 0,
    marginEnd: "3",
    w: "5",
    h: "6"
  },
  spinner: {
    color: xo.reference,
    flexShrink: 0,
    marginEnd: "3",
    w: "5",
    h: "5"
  }
});
function Y3(e) {
  const { theme: t, colorScheme: n } = e, r = Ju(`${n}.200`, 0.16)(t);
  return {
    light: `colors.${n}.100`,
    dark: r
  };
}
const YB = _d((e) => {
  const { colorScheme: t } = e, n = Y3(e);
  return {
    container: {
      [xo.variable]: `colors.${t}.600`,
      [_i.variable]: n.light,
      _dark: {
        [xo.variable]: `colors.${t}.200`,
        [_i.variable]: n.dark
      }
    }
  };
}), qB = _d((e) => {
  const { colorScheme: t } = e, n = Y3(e);
  return {
    container: {
      [xo.variable]: `colors.${t}.600`,
      [_i.variable]: n.light,
      _dark: {
        [xo.variable]: `colors.${t}.200`,
        [_i.variable]: n.dark
      },
      paddingStart: "3",
      borderStartWidth: "4px",
      borderStartColor: xo.reference
    }
  };
}), JB = _d((e) => {
  const { colorScheme: t } = e, n = Y3(e);
  return {
    container: {
      [xo.variable]: `colors.${t}.600`,
      [_i.variable]: n.light,
      _dark: {
        [xo.variable]: `colors.${t}.200`,
        [_i.variable]: n.dark
      },
      pt: "2",
      borderTopWidth: "4px",
      borderTopColor: xo.reference
    }
  };
}), KB = _d((e) => {
  const { colorScheme: t } = e;
  return {
    container: {
      [xo.variable]: "colors.white",
      [_i.variable]: `colors.${t}.600`,
      _dark: {
        [xo.variable]: "colors.gray.900",
        [_i.variable]: `colors.${t}.200`
      },
      color: xo.reference
    }
  };
}), QB = {
  subtle: YB,
  "left-accent": qB,
  "top-accent": JB,
  solid: KB
}, eH = UB({
  baseStyle: XB,
  variants: QB,
  defaultProps: {
    variant: "subtle",
    colorScheme: "blue"
  }
}), HS = {
  px: "1px",
  0.5: "0.125rem",
  1: "0.25rem",
  1.5: "0.375rem",
  2: "0.5rem",
  2.5: "0.625rem",
  3: "0.75rem",
  3.5: "0.875rem",
  4: "1rem",
  5: "1.25rem",
  6: "1.5rem",
  7: "1.75rem",
  8: "2rem",
  9: "2.25rem",
  10: "2.5rem",
  12: "3rem",
  14: "3.5rem",
  16: "4rem",
  20: "5rem",
  24: "6rem",
  28: "7rem",
  32: "8rem",
  36: "9rem",
  40: "10rem",
  44: "11rem",
  48: "12rem",
  52: "13rem",
  56: "14rem",
  60: "15rem",
  64: "16rem",
  72: "18rem",
  80: "20rem",
  96: "24rem"
}, tH = {
  max: "max-content",
  min: "min-content",
  full: "100%",
  "3xs": "14rem",
  "2xs": "16rem",
  xs: "20rem",
  sm: "24rem",
  md: "28rem",
  lg: "32rem",
  xl: "36rem",
  "2xl": "42rem",
  "3xl": "48rem",
  "4xl": "56rem",
  "5xl": "64rem",
  "6xl": "72rem",
  "7xl": "80rem",
  "8xl": "90rem",
  prose: "60ch"
}, nH = {
  sm: "640px",
  md: "768px",
  lg: "1024px",
  xl: "1280px"
}, GS = {
  ...HS,
  ...tH,
  container: nH
}, rH = (e) => typeof e == "function";
function Wr(e, ...t) {
  return rH(e) ? e(...t) : e;
}
const { definePartsStyle: $S, defineMultiStyleConfig: oH } = vn($F.keys), ju = at("avatar-border-color"), G1 = at("avatar-bg"), sd = at("avatar-font-size"), Ku = at("avatar-size"), aH = {
  borderRadius: "full",
  border: "0.2em solid",
  borderColor: ju.reference,
  [ju.variable]: "white",
  _dark: {
    [ju.variable]: "colors.gray.800"
  }
}, iH = {
  bg: G1.reference,
  fontSize: sd.reference,
  width: Ku.reference,
  height: Ku.reference,
  lineHeight: "1",
  [G1.variable]: "colors.gray.200",
  _dark: {
    [G1.variable]: "colors.whiteAlpha.400"
  }
}, sH = (e) => {
  const { name: t, theme: n } = e, r = t ? OB({ string: t }) : "colors.gray.400", o = kB(r)(n);
  let a = "white";
  return o || (a = "gray.800"), {
    bg: G1.reference,
    fontSize: sd.reference,
    color: a,
    borderColor: ju.reference,
    verticalAlign: "top",
    width: Ku.reference,
    height: Ku.reference,
    "&:not([data-loaded])": {
      [G1.variable]: r
    },
    [ju.variable]: "colors.white",
    _dark: {
      [ju.variable]: "colors.gray.800"
    }
  };
}, lH = {
  fontSize: sd.reference,
  lineHeight: "1"
}, uH = $S((e) => ({
  badge: Wr(aH, e),
  excessLabel: Wr(iH, e),
  container: Wr(sH, e),
  label: lH
}));
function Qi(e) {
  const t = e !== "100%" ? GS[e] : void 0;
  return $S({
    container: {
      [Ku.variable]: t ?? e,
      [sd.variable]: `calc(${t ?? e} / 2.5)`
    },
    excessLabel: {
      [Ku.variable]: t ?? e,
      [sd.variable]: `calc(${t ?? e} / 2.5)`
    }
  });
}
const cH = {
  "2xs": Qi(4),
  xs: Qi(6),
  sm: Qi(8),
  md: Qi(12),
  lg: Qi(16),
  xl: Qi(24),
  "2xl": Qi(32),
  full: Qi("100%")
}, dH = oH({
  baseStyle: uH,
  sizes: cH,
  defaultProps: {
    size: "md"
  }
}), Jn = EF("badge", ["bg", "color", "shadow"]), fH = {
  px: 1,
  textTransform: "uppercase",
  fontSize: "xs",
  borderRadius: "sm",
  fontWeight: "bold",
  bg: Jn.bg.reference,
  color: Jn.color.reference,
  boxShadow: Jn.shadow.reference
}, hH = (e) => {
  const { colorScheme: t, theme: n } = e, r = Ju(`${t}.500`, 0.6)(n);
  return {
    [Jn.bg.variable]: `colors.${t}.500`,
    [Jn.color.variable]: "colors.white",
    _dark: {
      [Jn.bg.variable]: r,
      [Jn.color.variable]: "colors.whiteAlpha.800"
    }
  };
}, mH = (e) => {
  const { colorScheme: t, theme: n } = e, r = Ju(`${t}.200`, 0.16)(n);
  return {
    [Jn.bg.variable]: `colors.${t}.100`,
    [Jn.color.variable]: `colors.${t}.800`,
    _dark: {
      [Jn.bg.variable]: r,
      [Jn.color.variable]: `colors.${t}.200`
    }
  };
}, pH = (e) => {
  const { colorScheme: t, theme: n } = e, r = Ju(`${t}.200`, 0.8)(n);
  return {
    [Jn.color.variable]: `colors.${t}.500`,
    _dark: {
      [Jn.color.variable]: r
    },
    [Jn.shadow.variable]: `inset 0 0 0px 1px ${Jn.color.reference}`
  };
}, gH = {
  solid: hH,
  subtle: mH,
  outline: pH
}, $1 = {
  baseStyle: fH,
  variants: gH,
  defaultProps: {
    variant: "subtle",
    colorScheme: "gray"
  }
}, { defineMultiStyleConfig: vH, definePartsStyle: CH } = vn(ZF.keys), jp = at("breadcrumb-link-decor"), bH = {
  transitionProperty: "common",
  transitionDuration: "fast",
  transitionTimingFunction: "ease-out",
  outline: "none",
  color: "inherit",
  textDecoration: jp.reference,
  [jp.variable]: "none",
  "&:not([aria-current=page])": {
    cursor: "pointer",
    _hover: {
      [jp.variable]: "underline"
    },
    _focusVisible: {
      boxShadow: "outline"
    }
  }
}, yH = CH({
  link: bH
}), SH = vH({
  baseStyle: yH
}), AH = {
  lineHeight: "1.2",
  borderRadius: "md",
  fontWeight: "semibold",
  transitionProperty: "common",
  transitionDuration: "normal",
  _focusVisible: {
    boxShadow: "outline"
  },
  _disabled: {
    opacity: 0.4,
    cursor: "not-allowed",
    boxShadow: "none"
  },
  _hover: {
    _disabled: {
      bg: "initial"
    }
  }
}, ZS = (e) => {
  const { colorScheme: t, theme: n } = e;
  if (t === "gray")
    return {
      color: rt("gray.800", "whiteAlpha.900")(e),
      _hover: {
        bg: rt("gray.100", "whiteAlpha.200")(e)
      },
      _active: { bg: rt("gray.200", "whiteAlpha.300")(e) }
    };
  const r = Ju(`${t}.200`, 0.12)(n), o = Ju(`${t}.200`, 0.24)(n);
  return {
    color: rt(`${t}.600`, `${t}.200`)(e),
    bg: "transparent",
    _hover: {
      bg: rt(`${t}.50`, r)(e)
    },
    _active: {
      bg: rt(`${t}.100`, o)(e)
    }
  };
}, MH = (e) => {
  const { colorScheme: t } = e, n = rt("gray.200", "whiteAlpha.300")(e);
  return {
    border: "1px solid",
    borderColor: t === "gray" ? n : "currentColor",
    ".chakra-button__group[data-attached][data-orientation=horizontal] > &:not(:last-of-type)": { marginEnd: "-1px" },
    ".chakra-button__group[data-attached][data-orientation=vertical] > &:not(:last-of-type)": { marginBottom: "-1px" },
    ...Wr(ZS, e)
  };
}, xH = {
  yellow: {
    bg: "yellow.400",
    color: "black",
    hoverBg: "yellow.500",
    activeBg: "yellow.600"
  },
  cyan: {
    bg: "cyan.400",
    color: "black",
    hoverBg: "cyan.500",
    activeBg: "cyan.600"
  }
}, wH = (e) => {
  const { colorScheme: t } = e;
  if (t === "gray") {
    const l = rt("gray.100", "whiteAlpha.200")(e);
    return {
      bg: l,
      color: rt("gray.800", "whiteAlpha.900")(e),
      _hover: {
        bg: rt("gray.200", "whiteAlpha.300")(e),
        _disabled: {
          bg: l
        }
      },
      _active: { bg: rt("gray.300", "whiteAlpha.400")(e) }
    };
  }
  const {
    bg: n = `${t}.500`,
    color: r = "white",
    hoverBg: o = `${t}.600`,
    activeBg: a = `${t}.700`
  } = xH[t] ?? {}, i = rt(n, `${t}.200`)(e);
  return {
    bg: i,
    color: rt(r, "gray.800")(e),
    _hover: {
      bg: rt(o, `${t}.300`)(e),
      _disabled: {
        bg: i
      }
    },
    _active: { bg: rt(a, `${t}.400`)(e) }
  };
}, _H = (e) => {
  const { colorScheme: t } = e;
  return {
    padding: 0,
    height: "auto",
    lineHeight: "normal",
    verticalAlign: "baseline",
    color: rt(`${t}.500`, `${t}.200`)(e),
    _hover: {
      textDecoration: "underline",
      _disabled: {
        textDecoration: "none"
      }
    },
    _active: {
      color: rt(`${t}.700`, `${t}.500`)(e)
    }
  };
}, IH = {
  bg: "none",
  color: "inherit",
  display: "inline",
  lineHeight: "inherit",
  m: "0",
  p: "0"
}, LH = {
  ghost: ZS,
  outline: MH,
  solid: wH,
  link: _H,
  unstyled: IH
}, RH = {
  lg: {
    h: "12",
    minW: "12",
    fontSize: "lg",
    px: "6"
  },
  md: {
    h: "10",
    minW: "10",
    fontSize: "md",
    px: "4"
  },
  sm: {
    h: "8",
    minW: "8",
    fontSize: "sm",
    px: "3"
  },
  xs: {
    h: "6",
    minW: "6",
    fontSize: "xs",
    px: "2"
  }
}, DH = {
  baseStyle: AH,
  variants: LH,
  sizes: RH,
  defaultProps: {
    variant: "solid",
    size: "md",
    colorScheme: "gray"
  }
}, { definePartsStyle: ml, defineMultiStyleConfig: PH } = vn(uB.keys), h2 = at("card-bg"), bi = at("card-padding"), jS = at("card-shadow"), Gf = at("card-radius"), WS = at("card-border-width", "0"), zS = at("card-border-color"), EH = ml({
  container: {
    [h2.variable]: "colors.chakra-body-bg",
    backgroundColor: h2.reference,
    boxShadow: jS.reference,
    borderRadius: Gf.reference,
    color: "chakra-body-text",
    borderWidth: WS.reference,
    borderColor: zS.reference
  },
  body: {
    padding: bi.reference,
    flex: "1 1 0%"
  },
  header: {
    padding: bi.reference
  },
  footer: {
    padding: bi.reference
  }
}), TH = {
  sm: ml({
    container: {
      [Gf.variable]: "radii.base",
      [bi.variable]: "space.3"
    }
  }),
  md: ml({
    container: {
      [Gf.variable]: "radii.md",
      [bi.variable]: "space.5"
    }
  }),
  lg: ml({
    container: {
      [Gf.variable]: "radii.xl",
      [bi.variable]: "space.7"
    }
  })
}, NH = {
  elevated: ml({
    container: {
      [jS.variable]: "shadows.base",
      _dark: {
        [h2.variable]: "colors.gray.700"
      }
    }
  }),
  outline: ml({
    container: {
      [WS.variable]: "1px",
      [zS.variable]: "colors.chakra-border-color"
    }
  }),
  filled: ml({
    container: {
      [h2.variable]: "colors.chakra-subtle-bg"
    }
  }),
  unstyled: {
    body: {
      [bi.variable]: 0
    },
    header: {
      [bi.variable]: 0
    },
    footer: {
      [bi.variable]: 0
    }
  }
}, kH = PH({
  baseStyle: EH,
  variants: NH,
  sizes: TH,
  defaultProps: {
    variant: "elevated",
    size: "md"
  }
}), { definePartsStyle: $f, defineMultiStyleConfig: VH } = vn(jF.keys), Z1 = at("checkbox-size"), OH = (e) => {
  const { colorScheme: t } = e;
  return {
    w: Z1.reference,
    h: Z1.reference,
    transitionProperty: "box-shadow",
    transitionDuration: "normal",
    border: "2px solid",
    borderRadius: "sm",
    borderColor: "inherit",
    color: "white",
    _checked: {
      bg: rt(`${t}.500`, `${t}.200`)(e),
      borderColor: rt(`${t}.500`, `${t}.200`)(e),
      color: rt("white", "gray.900")(e),
      _hover: {
        bg: rt(`${t}.600`, `${t}.300`)(e),
        borderColor: rt(`${t}.600`, `${t}.300`)(e)
      },
      _disabled: {
        borderColor: rt("gray.200", "transparent")(e),
        bg: rt("gray.200", "whiteAlpha.300")(e),
        color: rt("gray.500", "whiteAlpha.500")(e)
      }
    },
    _indeterminate: {
      bg: rt(`${t}.500`, `${t}.200`)(e),
      borderColor: rt(`${t}.500`, `${t}.200`)(e),
      color: rt("white", "gray.900")(e)
    },
    _disabled: {
      bg: rt("gray.100", "whiteAlpha.100")(e),
      borderColor: rt("gray.100", "transparent")(e)
    },
    _focusVisible: {
      boxShadow: "outline"
    },
    _invalid: {
      borderColor: rt("red.500", "red.300")(e)
    }
  };
}, FH = {
  _disabled: { cursor: "not-allowed" }
}, BH = {
  userSelect: "none",
  _disabled: { opacity: 0.4 }
}, HH = {
  transitionProperty: "transform",
  transitionDuration: "normal"
}, GH = $f((e) => ({
  icon: HH,
  container: FH,
  control: Wr(OH, e),
  label: BH
})), $H = {
  sm: $f({
    control: { [Z1.variable]: "sizes.3" },
    label: { fontSize: "sm" },
    icon: { fontSize: "3xs" }
  }),
  md: $f({
    control: { [Z1.variable]: "sizes.4" },
    label: { fontSize: "md" },
    icon: { fontSize: "2xs" }
  }),
  lg: $f({
    control: { [Z1.variable]: "sizes.5" },
    label: { fontSize: "lg" },
    icon: { fontSize: "2xs" }
  })
}, ls = VH({
  baseStyle: GH,
  sizes: $H,
  defaultProps: {
    size: "md",
    colorScheme: "blue"
  }
}), j1 = dr("close-button-size"), s1 = dr("close-button-bg"), ZH = {
  w: [j1.reference],
  h: [j1.reference],
  borderRadius: "md",
  transitionProperty: "common",
  transitionDuration: "normal",
  _disabled: {
    opacity: 0.4,
    cursor: "not-allowed",
    boxShadow: "none"
  },
  _hover: {
    [s1.variable]: "colors.blackAlpha.100",
    _dark: {
      [s1.variable]: "colors.whiteAlpha.100"
    }
  },
  _active: {
    [s1.variable]: "colors.blackAlpha.200",
    _dark: {
      [s1.variable]: "colors.whiteAlpha.200"
    }
  },
  _focusVisible: {
    boxShadow: "outline"
  },
  bg: s1.reference
}, jH = {
  lg: {
    [j1.variable]: "sizes.10",
    fontSize: "md"
  },
  md: {
    [j1.variable]: "sizes.8",
    fontSize: "xs"
  },
  sm: {
    [j1.variable]: "sizes.6",
    fontSize: "2xs"
  }
}, WH = {
  baseStyle: ZH,
  sizes: jH,
  defaultProps: {
    size: "md"
  }
}, { variants: zH, defaultProps: UH } = $1, XH = {
  fontFamily: "mono",
  fontSize: "sm",
  px: "0.2em",
  borderRadius: "sm",
  bg: Jn.bg.reference,
  color: Jn.color.reference,
  boxShadow: Jn.shadow.reference
}, YH = {
  baseStyle: XH,
  variants: zH,
  defaultProps: UH
}, qH = {
  w: "100%",
  mx: "auto",
  maxW: "prose",
  px: "4"
}, JH = {
  baseStyle: qH
}, KH = {
  opacity: 0.6,
  borderColor: "inherit"
}, QH = {
  borderStyle: "solid"
}, eG = {
  borderStyle: "dashed"
}, tG = {
  solid: QH,
  dashed: eG
}, nG = {
  baseStyle: KH,
  variants: tG,
  defaultProps: {
    variant: "solid"
  }
}, { definePartsStyle: M5, defineMultiStyleConfig: rG } = vn(WF.keys), Wp = at("drawer-bg"), zp = at("drawer-box-shadow");
function Cu(e) {
  return M5(e === "full" ? {
    dialog: { maxW: "100vw", h: "100vh" }
  } : {
    dialog: { maxW: e }
  });
}
const oG = {
  bg: "blackAlpha.600",
  zIndex: "modal"
}, aG = {
  display: "flex",
  zIndex: "modal",
  justifyContent: "center"
}, iG = (e) => {
  const { isFullHeight: t } = e;
  return {
    ...t && { height: "100vh" },
    zIndex: "modal",
    maxH: "100vh",
    color: "inherit",
    [Wp.variable]: "colors.white",
    [zp.variable]: "shadows.lg",
    _dark: {
      [Wp.variable]: "colors.gray.700",
      [zp.variable]: "shadows.dark-lg"
    },
    bg: Wp.reference,
    boxShadow: zp.reference
  };
}, sG = {
  px: "6",
  py: "4",
  fontSize: "xl",
  fontWeight: "semibold"
}, lG = {
  position: "absolute",
  top: "2",
  insetEnd: "3"
}, uG = {
  px: "6",
  py: "2",
  flex: "1",
  overflow: "auto"
}, cG = {
  px: "6",
  py: "4"
}, dG = M5((e) => ({
  overlay: oG,
  dialogContainer: aG,
  dialog: Wr(iG, e),
  header: sG,
  closeButton: lG,
  body: uG,
  footer: cG
})), fG = {
  xs: Cu("xs"),
  sm: Cu("md"),
  md: Cu("lg"),
  lg: Cu("2xl"),
  xl: Cu("4xl"),
  full: Cu("full")
}, hG = rG({
  baseStyle: dG,
  sizes: fG,
  defaultProps: {
    size: "xs"
  }
}), { definePartsStyle: mG, defineMultiStyleConfig: pG } = vn(zF.keys), gG = {
  borderRadius: "md",
  py: "1",
  transitionProperty: "common",
  transitionDuration: "normal"
}, vG = {
  borderRadius: "md",
  py: "1",
  transitionProperty: "common",
  transitionDuration: "normal",
  width: "full",
  _focusVisible: { boxShadow: "outline" },
  _placeholder: { opacity: 0.6 }
}, CG = {
  borderRadius: "md",
  py: "1",
  transitionProperty: "common",
  transitionDuration: "normal",
  width: "full",
  _focusVisible: { boxShadow: "outline" },
  _placeholder: { opacity: 0.6 }
}, bG = mG({
  preview: gG,
  input: vG,
  textarea: CG
}), yG = pG({
  baseStyle: bG
}), { definePartsStyle: SG, defineMultiStyleConfig: AG } = vn(UF.keys), Wu = at("form-control-color"), MG = {
  marginStart: "1",
  [Wu.variable]: "colors.red.500",
  _dark: {
    [Wu.variable]: "colors.red.300"
  },
  color: Wu.reference
}, xG = {
  mt: "2",
  [Wu.variable]: "colors.gray.600",
  _dark: {
    [Wu.variable]: "colors.whiteAlpha.600"
  },
  color: Wu.reference,
  lineHeight: "normal",
  fontSize: "sm"
}, wG = SG({
  container: {
    width: "100%",
    position: "relative"
  },
  requiredIndicator: MG,
  helperText: xG
}), _G = AG({
  baseStyle: wG
}), { definePartsStyle: IG, defineMultiStyleConfig: LG } = vn(XF.keys), zu = at("form-error-color"), RG = {
  [zu.variable]: "colors.red.500",
  _dark: {
    [zu.variable]: "colors.red.300"
  },
  color: zu.reference,
  mt: "2",
  fontSize: "sm",
  lineHeight: "normal"
}, DG = {
  marginEnd: "0.5em",
  [zu.variable]: "colors.red.500",
  _dark: {
    [zu.variable]: "colors.red.300"
  },
  color: zu.reference
}, PG = IG({
  text: RG,
  icon: DG
}), EG = LG({
  baseStyle: PG
}), TG = {
  fontSize: "md",
  marginEnd: "3",
  mb: "2",
  fontWeight: "medium",
  transitionProperty: "common",
  transitionDuration: "normal",
  opacity: 1,
  _disabled: {
    opacity: 0.4
  }
}, NG = {
  baseStyle: TG
}, kG = {
  fontFamily: "heading",
  fontWeight: "bold"
}, VG = {
  "4xl": {
    fontSize: ["6xl", null, "7xl"],
    lineHeight: 1
  },
  "3xl": {
    fontSize: ["5xl", null, "6xl"],
    lineHeight: 1
  },
  "2xl": {
    fontSize: ["4xl", null, "5xl"],
    lineHeight: [1.2, null, 1]
  },
  xl: {
    fontSize: ["3xl", null, "4xl"],
    lineHeight: [1.33, null, 1.2]
  },
  lg: {
    fontSize: ["2xl", null, "3xl"],
    lineHeight: [1.33, null, 1.2]
  },
  md: {
    fontSize: "xl",
    lineHeight: 1.2
  },
  sm: {
    fontSize: "md",
    lineHeight: 1.2
  },
  xs: {
    fontSize: "sm",
    lineHeight: 1.2
  }
}, OG = {
  baseStyle: kG,
  sizes: VG,
  defaultProps: {
    size: "xl"
  }
}, { definePartsStyle: pi, defineMultiStyleConfig: FG } = vn(YF.keys), Eu = at("input-height"), Tu = at("input-font-size"), Nu = at("input-padding"), ku = at("input-border-radius"), BG = pi({
  addon: {
    height: Eu.reference,
    fontSize: Tu.reference,
    px: Nu.reference,
    borderRadius: ku.reference
  },
  field: {
    width: "100%",
    height: Eu.reference,
    fontSize: Tu.reference,
    px: Nu.reference,
    borderRadius: ku.reference,
    minWidth: 0,
    outline: 0,
    position: "relative",
    appearance: "none",
    transitionProperty: "common",
    transitionDuration: "normal",
    _disabled: {
      opacity: 0.4,
      cursor: "not-allowed"
    }
  }
}), es = {
  lg: {
    [Tu.variable]: "fontSizes.lg",
    [Nu.variable]: "space.4",
    [ku.variable]: "radii.md",
    [Eu.variable]: "sizes.12"
  },
  md: {
    [Tu.variable]: "fontSizes.md",
    [Nu.variable]: "space.4",
    [ku.variable]: "radii.md",
    [Eu.variable]: "sizes.10"
  },
  sm: {
    [Tu.variable]: "fontSizes.sm",
    [Nu.variable]: "space.3",
    [ku.variable]: "radii.sm",
    [Eu.variable]: "sizes.8"
  },
  xs: {
    [Tu.variable]: "fontSizes.xs",
    [Nu.variable]: "space.2",
    [ku.variable]: "radii.sm",
    [Eu.variable]: "sizes.6"
  }
}, HG = {
  lg: pi({
    field: es.lg,
    group: es.lg
  }),
  md: pi({
    field: es.md,
    group: es.md
  }),
  sm: pi({
    field: es.sm,
    group: es.sm
  }),
  xs: pi({
    field: es.xs,
    group: es.xs
  })
};
function q3(e) {
  const { focusBorderColor: t, errorBorderColor: n } = e;
  return {
    focusBorderColor: t || rt("blue.500", "blue.300")(e),
    errorBorderColor: n || rt("red.500", "red.300")(e)
  };
}
const GG = pi((e) => {
  const { theme: t } = e, { focusBorderColor: n, errorBorderColor: r } = q3(e);
  return {
    field: {
      border: "1px solid",
      borderColor: "inherit",
      bg: "inherit",
      _hover: {
        borderColor: rt("gray.300", "whiteAlpha.400")(e)
      },
      _readOnly: {
        boxShadow: "none !important",
        userSelect: "all"
      },
      _invalid: {
        borderColor: $r(t, r),
        boxShadow: `0 0 0 1px ${$r(t, r)}`
      },
      _focusVisible: {
        zIndex: 1,
        borderColor: $r(t, n),
        boxShadow: `0 0 0 1px ${$r(t, n)}`
      }
    },
    addon: {
      border: "1px solid",
      borderColor: rt("inherit", "whiteAlpha.50")(e),
      bg: rt("gray.100", "whiteAlpha.300")(e)
    }
  };
}), $G = pi((e) => {
  const { theme: t } = e, { focusBorderColor: n, errorBorderColor: r } = q3(e);
  return {
    field: {
      border: "2px solid",
      borderColor: "transparent",
      bg: rt("gray.100", "whiteAlpha.50")(e),
      _hover: {
        bg: rt("gray.200", "whiteAlpha.100")(e)
      },
      _readOnly: {
        boxShadow: "none !important",
        userSelect: "all"
      },
      _invalid: {
        borderColor: $r(t, r)
      },
      _focusVisible: {
        bg: "transparent",
        borderColor: $r(t, n)
      }
    },
    addon: {
      border: "2px solid",
      borderColor: "transparent",
      bg: rt("gray.100", "whiteAlpha.50")(e)
    }
  };
}), ZG = pi((e) => {
  const { theme: t } = e, { focusBorderColor: n, errorBorderColor: r } = q3(e);
  return {
    field: {
      borderBottom: "1px solid",
      borderColor: "inherit",
      borderRadius: "0",
      px: "0",
      bg: "transparent",
      _readOnly: {
        boxShadow: "none !important",
        userSelect: "all"
      },
      _invalid: {
        borderColor: $r(t, r),
        boxShadow: `0px 1px 0px 0px ${$r(t, r)}`
      },
      _focusVisible: {
        borderColor: $r(t, n),
        boxShadow: `0px 1px 0px 0px ${$r(t, n)}`
      }
    },
    addon: {
      borderBottom: "2px solid",
      borderColor: "inherit",
      borderRadius: "0",
      px: "0",
      bg: "transparent"
    }
  };
}), jG = pi({
  field: {
    bg: "transparent",
    px: "0",
    height: "auto"
  },
  addon: {
    bg: "transparent",
    px: "0",
    height: "auto"
  }
}), WG = {
  outline: GG,
  filled: $G,
  flushed: ZG,
  unstyled: jG
}, tn = FG({
  baseStyle: BG,
  sizes: HG,
  variants: WG,
  defaultProps: {
    size: "md",
    variant: "outline"
  }
}), Up = at("kbd-bg"), zG = {
  [Up.variable]: "colors.gray.100",
  _dark: {
    [Up.variable]: "colors.whiteAlpha.100"
  },
  bg: Up.reference,
  borderRadius: "md",
  borderWidth: "1px",
  borderBottomWidth: "3px",
  fontSize: "0.8em",
  fontWeight: "bold",
  lineHeight: "normal",
  px: "0.4em",
  whiteSpace: "nowrap"
}, UG = {
  baseStyle: zG
}, XG = {
  transitionProperty: "common",
  transitionDuration: "fast",
  transitionTimingFunction: "ease-out",
  cursor: "pointer",
  textDecoration: "none",
  outline: "none",
  color: "inherit",
  _hover: {
    textDecoration: "underline"
  },
  _focusVisible: {
    boxShadow: "outline"
  }
}, YG = {
  baseStyle: XG
}, { defineMultiStyleConfig: qG, definePartsStyle: JG } = vn(qF.keys), KG = {
  marginEnd: "2",
  display: "inline",
  verticalAlign: "text-bottom"
}, QG = JG({
  icon: KG
}), e$ = qG({
  baseStyle: QG
}), { defineMultiStyleConfig: t$, definePartsStyle: n$ } = vn(JF.keys), Na = at("menu-bg"), Xp = at("menu-shadow"), r$ = {
  [Na.variable]: "#fff",
  [Xp.variable]: "shadows.sm",
  _dark: {
    [Na.variable]: "colors.gray.700",
    [Xp.variable]: "shadows.dark-lg"
  },
  color: "inherit",
  minW: "3xs",
  py: "2",
  zIndex: "dropdown",
  borderRadius: "md",
  borderWidth: "1px",
  bg: Na.reference,
  boxShadow: Xp.reference
}, o$ = {
  py: "1.5",
  px: "3",
  transitionProperty: "background",
  transitionDuration: "ultra-fast",
  transitionTimingFunction: "ease-in",
  _focus: {
    [Na.variable]: "colors.gray.100",
    _dark: {
      [Na.variable]: "colors.whiteAlpha.100"
    }
  },
  _active: {
    [Na.variable]: "colors.gray.200",
    _dark: {
      [Na.variable]: "colors.whiteAlpha.200"
    }
  },
  _expanded: {
    [Na.variable]: "colors.gray.100",
    _dark: {
      [Na.variable]: "colors.whiteAlpha.100"
    }
  },
  _disabled: {
    opacity: 0.4,
    cursor: "not-allowed"
  },
  bg: Na.reference
}, a$ = {
  mx: 4,
  my: 2,
  fontWeight: "semibold",
  fontSize: "sm"
}, i$ = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0
}, s$ = {
  opacity: 0.6
}, l$ = {
  border: 0,
  borderBottom: "1px solid",
  borderColor: "inherit",
  my: "2",
  opacity: 0.6
}, u$ = {
  transitionProperty: "common",
  transitionDuration: "normal"
}, c$ = n$({
  button: u$,
  list: r$,
  item: o$,
  groupTitle: a$,
  icon: i$,
  command: s$,
  divider: l$
}), d$ = t$({
  baseStyle: c$
}), { defineMultiStyleConfig: f$, definePartsStyle: x5 } = vn(KF.keys), Yp = at("modal-bg"), qp = at("modal-shadow"), h$ = {
  bg: "blackAlpha.600",
  zIndex: "modal"
}, m$ = (e) => {
  const { isCentered: t, scrollBehavior: n } = e;
  return {
    display: "flex",
    zIndex: "modal",
    justifyContent: "center",
    alignItems: t ? "center" : "flex-start",
    overflow: n === "inside" ? "hidden" : "auto",
    overscrollBehaviorY: "none"
  };
}, p$ = (e) => {
  const { isCentered: t, scrollBehavior: n } = e;
  return {
    borderRadius: "md",
    color: "inherit",
    my: t ? "auto" : "16",
    mx: t ? "auto" : void 0,
    zIndex: "modal",
    maxH: n === "inside" ? "calc(100% - 7.5rem)" : void 0,
    [Yp.variable]: "colors.white",
    [qp.variable]: "shadows.lg",
    _dark: {
      [Yp.variable]: "colors.gray.700",
      [qp.variable]: "shadows.dark-lg"
    },
    bg: Yp.reference,
    boxShadow: qp.reference
  };
}, g$ = {
  px: "6",
  py: "4",
  fontSize: "xl",
  fontWeight: "semibold"
}, v$ = {
  position: "absolute",
  top: "2",
  insetEnd: "3"
}, C$ = (e) => {
  const { scrollBehavior: t } = e;
  return {
    px: "6",
    py: "2",
    flex: "1",
    overflow: t === "inside" ? "auto" : void 0
  };
}, b$ = {
  px: "6",
  py: "4"
}, y$ = x5((e) => ({
  overlay: h$,
  dialogContainer: Wr(m$, e),
  dialog: Wr(p$, e),
  header: g$,
  closeButton: v$,
  body: Wr(C$, e),
  footer: b$
}));
function da(e) {
  return x5(e === "full" ? {
    dialog: {
      maxW: "100vw",
      minH: "$100vh",
      my: "0",
      borderRadius: "0"
    }
  } : {
    dialog: { maxW: e }
  });
}
const S$ = {
  xs: da("xs"),
  sm: da("sm"),
  md: da("md"),
  lg: da("lg"),
  xl: da("xl"),
  "2xl": da("2xl"),
  "3xl": da("3xl"),
  "4xl": da("4xl"),
  "5xl": da("5xl"),
  "6xl": da("6xl"),
  full: da("full")
}, A$ = f$({
  baseStyle: y$,
  sizes: S$,
  defaultProps: { size: "md" }
}), US = {
  letterSpacings: {
    tighter: "-0.05em",
    tight: "-0.025em",
    normal: "0",
    wide: "0.025em",
    wider: "0.05em",
    widest: "0.1em"
  },
  lineHeights: {
    normal: "normal",
    none: 1,
    shorter: 1.25,
    short: 1.375,
    base: 1.5,
    tall: 1.625,
    taller: "2",
    3: ".75rem",
    4: "1rem",
    5: "1.25rem",
    6: "1.5rem",
    7: "1.75rem",
    8: "2rem",
    9: "2.25rem",
    10: "2.5rem"
  },
  fontWeights: {
    hairline: 100,
    thin: 200,
    light: 300,
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
    extrabold: 800,
    black: 900
  },
  fonts: {
    heading: '-apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
    body: '-apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
    mono: 'SFMono-Regular,Menlo,Monaco,Consolas,"Liberation Mono","Courier New",monospace'
  },
  fontSizes: {
    "3xs": "0.45rem",
    "2xs": "0.625rem",
    xs: "0.75rem",
    sm: "0.875rem",
    md: "1rem",
    lg: "1.125rem",
    xl: "1.25rem",
    "2xl": "1.5rem",
    "3xl": "1.875rem",
    "4xl": "2.25rem",
    "5xl": "3rem",
    "6xl": "3.75rem",
    "7xl": "4.5rem",
    "8xl": "6rem",
    "9xl": "8rem"
  }
}, { defineMultiStyleConfig: M$, definePartsStyle: XS } = vn(QF.keys), J3 = dr("number-input-stepper-width"), YS = dr("number-input-input-padding"), x$ = hi(J3).add("0.5rem").toString(), Jp = dr("number-input-bg"), Kp = dr("number-input-color"), Qp = dr("number-input-border-color"), w$ = {
  [J3.variable]: "sizes.6",
  [YS.variable]: x$
}, _$ = (e) => {
  var t;
  return ((t = Wr(tn.baseStyle, e)) == null ? void 0 : t.field) ?? {};
}, I$ = {
  width: J3.reference
}, L$ = {
  borderStart: "1px solid",
  borderStartColor: Qp.reference,
  color: Kp.reference,
  bg: Jp.reference,
  [Kp.variable]: "colors.chakra-body-text",
  [Qp.variable]: "colors.chakra-border-color",
  _dark: {
    [Kp.variable]: "colors.whiteAlpha.800",
    [Qp.variable]: "colors.whiteAlpha.300"
  },
  _active: {
    [Jp.variable]: "colors.gray.200",
    _dark: {
      [Jp.variable]: "colors.whiteAlpha.300"
    }
  },
  _disabled: {
    opacity: 0.4,
    cursor: "not-allowed"
  }
}, R$ = XS((e) => ({
  root: w$,
  field: Wr(_$, e) ?? {},
  stepperGroup: I$,
  stepper: L$
}));
function rf(e) {
  var a, i;
  const t = (a = tn.sizes) == null ? void 0 : a[e], n = {
    lg: "md",
    md: "md",
    sm: "sm",
    xs: "sm"
  }, r = ((i = t.field) == null ? void 0 : i.fontSize) ?? "md", o = US.fontSizes[r];
  return XS({
    field: {
      ...t.field,
      paddingInlineEnd: YS.reference,
      verticalAlign: "top"
    },
    stepper: {
      fontSize: hi(o).multiply(0.75).toString(),
      _first: {
        borderTopEndRadius: n[e]
      },
      _last: {
        borderBottomEndRadius: n[e],
        mt: "-1px",
        borderTopWidth: 1
      }
    }
  });
}
const D$ = {
  xs: rf("xs"),
  sm: rf("sm"),
  md: rf("md"),
  lg: rf("lg")
}, P$ = M$({
  baseStyle: R$,
  sizes: D$,
  variants: tn.variants,
  defaultProps: tn.defaultProps
});
var Py;
const E$ = {
  ...(Py = tn.baseStyle) == null ? void 0 : Py.field,
  textAlign: "center"
}, T$ = {
  lg: {
    fontSize: "lg",
    w: 12,
    h: 12,
    borderRadius: "md"
  },
  md: {
    fontSize: "md",
    w: 10,
    h: 10,
    borderRadius: "md"
  },
  sm: {
    fontSize: "sm",
    w: 8,
    h: 8,
    borderRadius: "sm"
  },
  xs: {
    fontSize: "xs",
    w: 6,
    h: 6,
    borderRadius: "sm"
  }
};
var Ey;
const N$ = {
  outline: (e) => {
    var t, n;
    return ((n = Wr((t = tn.variants) == null ? void 0 : t.outline, e)) == null ? void 0 : n.field) ?? {};
  },
  flushed: (e) => {
    var t, n;
    return ((n = Wr((t = tn.variants) == null ? void 0 : t.flushed, e)) == null ? void 0 : n.field) ?? {};
  },
  filled: (e) => {
    var t, n;
    return ((n = Wr((t = tn.variants) == null ? void 0 : t.filled, e)) == null ? void 0 : n.field) ?? {};
  },
  unstyled: ((Ey = tn.variants) == null ? void 0 : Ey.unstyled.field) ?? {}
}, k$ = {
  baseStyle: E$,
  sizes: T$,
  variants: N$,
  defaultProps: tn.defaultProps
}, { defineMultiStyleConfig: V$, definePartsStyle: O$ } = vn(OS.keys), of = dr("popper-bg"), F$ = dr("popper-arrow-bg"), Ov = dr("popper-arrow-shadow-color"), B$ = {
  zIndex: "popover"
}, H$ = {
  [of.variable]: "colors.white",
  bg: of.reference,
  [F$.variable]: of.reference,
  [Ov.variable]: "colors.gray.200",
  _dark: {
    [of.variable]: "colors.gray.700",
    [Ov.variable]: "colors.whiteAlpha.300"
  },
  width: "xs",
  border: "1px solid",
  borderColor: "inherit",
  borderRadius: "md",
  boxShadow: "sm",
  zIndex: "inherit",
  _focusVisible: {
    outline: 0,
    boxShadow: "outline"
  }
}, G$ = {
  px: 3,
  py: 2,
  borderBottomWidth: "1px"
}, $$ = {
  px: 3,
  py: 2
}, Z$ = {
  px: 3,
  py: 2,
  borderTopWidth: "1px"
}, j$ = {
  position: "absolute",
  borderRadius: "md",
  top: 1,
  insetEnd: 2,
  padding: 2
}, W$ = O$({
  popper: B$,
  content: H$,
  header: G$,
  body: $$,
  footer: Z$,
  closeButton: j$
}), z$ = V$({
  baseStyle: W$
}), { defineMultiStyleConfig: U$, definePartsStyle: L1 } = vn(eB.keys), X$ = (e) => {
  const { colorScheme: t, theme: n, isIndeterminate: r, hasStripe: o } = e, a = rt(
    Ev(),
    Ev("1rem", "rgba(0,0,0,0.1)")
  )(e), i = rt(`${t}.500`, `${t}.200`)(e), l = `linear-gradient(
    to right,
    transparent 0%,
    ${$r(n, i)} 50%,
    transparent 100%
  )`;
  return {
    ...!r && o && a,
    ...r ? { bgImage: l } : { bgColor: i }
  };
}, Y$ = {
  lineHeight: "1",
  fontSize: "0.25em",
  fontWeight: "bold",
  color: "white"
}, q$ = (e) => ({
  bg: rt("gray.100", "whiteAlpha.300")(e)
}), J$ = (e) => ({
  transitionProperty: "common",
  transitionDuration: "slow",
  ...X$(e)
}), K$ = L1((e) => ({
  label: Y$,
  filledTrack: J$(e),
  track: q$(e)
})), Q$ = {
  xs: L1({
    track: { h: "1" }
  }),
  sm: L1({
    track: { h: "2" }
  }),
  md: L1({
    track: { h: "3" }
  }),
  lg: L1({
    track: { h: "4" }
  })
}, eZ = U$({
  sizes: Q$,
  baseStyle: K$,
  defaultProps: {
    size: "md",
    colorScheme: "blue"
  }
}), { defineMultiStyleConfig: tZ, definePartsStyle: Zf } = vn(tB.keys), nZ = (e) => {
  var n;
  const t = (n = Wr(ls.baseStyle, e)) == null ? void 0 : n.control;
  return {
    ...t,
    borderRadius: "full",
    _checked: {
      ...t == null ? void 0 : t._checked,
      _before: {
        content: '""',
        display: "inline-block",
        pos: "relative",
        w: "50%",
        h: "50%",
        borderRadius: "50%",
        bg: "currentColor"
      }
    }
  };
}, rZ = Zf((e) => {
  var t, n;
  return {
    label: (t = ls.baseStyle) == null ? void 0 : t.call(ls, e).label,
    container: (n = ls.baseStyle) == null ? void 0 : n.call(ls, e).container,
    control: nZ(e)
  };
}), oZ = {
  md: Zf({
    control: { w: "4", h: "4" },
    label: { fontSize: "md" }
  }),
  lg: Zf({
    control: { w: "5", h: "5" },
    label: { fontSize: "lg" }
  }),
  sm: Zf({
    control: { width: "3", height: "3" },
    label: { fontSize: "sm" }
  })
}, aZ = tZ({
  baseStyle: rZ,
  sizes: oZ,
  defaultProps: {
    size: "md",
    colorScheme: "blue"
  }
}), { defineMultiStyleConfig: iZ, definePartsStyle: sZ } = vn(nB.keys), af = at("select-bg");
var Ty;
const lZ = {
  ...(Ty = tn.baseStyle) == null ? void 0 : Ty.field,
  appearance: "none",
  paddingBottom: "1px",
  lineHeight: "normal",
  bg: af.reference,
  [af.variable]: "colors.white",
  _dark: {
    [af.variable]: "colors.gray.700"
  },
  "> option, > optgroup": {
    bg: af.reference
  }
}, uZ = {
  width: "6",
  height: "100%",
  insetEnd: "2",
  position: "relative",
  color: "currentColor",
  fontSize: "xl",
  _disabled: {
    opacity: 0.5
  }
}, cZ = sZ({
  field: lZ,
  icon: uZ
}), sf = {
  paddingInlineEnd: "8"
};
var Ny, ky, Vy, Oy, Fy, By, Hy, Gy;
const dZ = {
  lg: {
    ...(Ny = tn.sizes) == null ? void 0 : Ny.lg,
    field: {
      ...(ky = tn.sizes) == null ? void 0 : ky.lg.field,
      ...sf
    }
  },
  md: {
    ...(Vy = tn.sizes) == null ? void 0 : Vy.md,
    field: {
      ...(Oy = tn.sizes) == null ? void 0 : Oy.md.field,
      ...sf
    }
  },
  sm: {
    ...(Fy = tn.sizes) == null ? void 0 : Fy.sm,
    field: {
      ...(By = tn.sizes) == null ? void 0 : By.sm.field,
      ...sf
    }
  },
  xs: {
    ...(Hy = tn.sizes) == null ? void 0 : Hy.xs,
    field: {
      ...(Gy = tn.sizes) == null ? void 0 : Gy.xs.field,
      ...sf
    },
    icon: {
      insetEnd: "1"
    }
  }
}, fZ = iZ({
  baseStyle: cZ,
  sizes: dZ,
  variants: tn.variants,
  defaultProps: tn.defaultProps
}), eg = at("skeleton-start-color"), tg = at("skeleton-end-color"), hZ = {
  [eg.variable]: "colors.gray.100",
  [tg.variable]: "colors.gray.400",
  _dark: {
    [eg.variable]: "colors.gray.800",
    [tg.variable]: "colors.gray.600"
  },
  background: eg.reference,
  borderColor: tg.reference,
  opacity: 0.7,
  borderRadius: "sm"
}, mZ = {
  baseStyle: hZ
}, ng = at("skip-link-bg"), pZ = {
  borderRadius: "md",
  fontWeight: "semibold",
  _focusVisible: {
    boxShadow: "outline",
    padding: "4",
    position: "fixed",
    top: "6",
    insetStart: "6",
    [ng.variable]: "colors.white",
    _dark: {
      [ng.variable]: "colors.gray.700"
    },
    bg: ng.reference
  }
}, gZ = {
  baseStyle: pZ
}, { defineMultiStyleConfig: vZ, definePartsStyle: _h } = vn(rB.keys), xl = at("slider-thumb-size"), ld = at("slider-track-size"), fs = at("slider-bg"), CZ = (e) => {
  const { orientation: t } = e;
  return {
    display: "inline-block",
    position: "relative",
    cursor: "pointer",
    _disabled: {
      opacity: 0.6,
      cursor: "default",
      pointerEvents: "none"
    },
    ...X3({
      orientation: t,
      vertical: {
        h: "100%",
        px: fi(xl.reference).divide(2).toString()
      },
      horizontal: {
        w: "100%",
        py: fi(xl.reference).divide(2).toString()
      }
    })
  };
}, bZ = (e) => ({
  ...X3({
    orientation: e.orientation,
    horizontal: { h: ld.reference },
    vertical: { w: ld.reference }
  }),
  overflow: "hidden",
  borderRadius: "sm",
  [fs.variable]: "colors.gray.200",
  _dark: {
    [fs.variable]: "colors.whiteAlpha.200"
  },
  _disabled: {
    [fs.variable]: "colors.gray.300",
    _dark: {
      [fs.variable]: "colors.whiteAlpha.300"
    }
  },
  bg: fs.reference
}), yZ = (e) => {
  const { orientation: t } = e;
  return {
    ...X3({
      orientation: t,
      vertical: { left: "50%" },
      horizontal: { top: "50%" }
    }),
    w: xl.reference,
    h: xl.reference,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "absolute",
    outline: 0,
    zIndex: 1,
    borderRadius: "full",
    bg: "white",
    boxShadow: "base",
    border: "1px solid",
    borderColor: "transparent",
    transitionProperty: "transform",
    transitionDuration: "normal",
    _focusVisible: {
      boxShadow: "outline"
    },
    _active: {
      "--slider-thumb-scale": "1.15"
    },
    _disabled: {
      bg: "gray.300"
    }
  };
}, SZ = (e) => {
  const { colorScheme: t } = e;
  return {
    width: "inherit",
    height: "inherit",
    [fs.variable]: `colors.${t}.500`,
    _dark: {
      [fs.variable]: `colors.${t}.200`
    },
    bg: fs.reference
  };
}, AZ = _h((e) => ({
  container: CZ(e),
  track: bZ(e),
  thumb: yZ(e),
  filledTrack: SZ(e)
})), MZ = _h({
  container: {
    [xl.variable]: "sizes.4",
    [ld.variable]: "sizes.1"
  }
}), xZ = _h({
  container: {
    [xl.variable]: "sizes.3.5",
    [ld.variable]: "sizes.1"
  }
}), wZ = _h({
  container: {
    [xl.variable]: "sizes.2.5",
    [ld.variable]: "sizes.0.5"
  }
}), _Z = {
  lg: MZ,
  md: xZ,
  sm: wZ
}, IZ = vZ({
  baseStyle: AZ,
  sizes: _Z,
  defaultProps: {
    size: "md",
    colorScheme: "blue"
  }
}), ol = dr("spinner-size"), LZ = {
  width: [ol.reference],
  height: [ol.reference]
}, RZ = {
  xs: {
    [ol.variable]: "sizes.3"
  },
  sm: {
    [ol.variable]: "sizes.4"
  },
  md: {
    [ol.variable]: "sizes.6"
  },
  lg: {
    [ol.variable]: "sizes.8"
  },
  xl: {
    [ol.variable]: "sizes.12"
  }
}, DZ = {
  baseStyle: LZ,
  sizes: RZ,
  defaultProps: {
    size: "md"
  }
}, { defineMultiStyleConfig: PZ, definePartsStyle: qS } = vn(oB.keys), EZ = {
  fontWeight: "medium"
}, TZ = {
  opacity: 0.8,
  marginBottom: "2"
}, NZ = {
  verticalAlign: "baseline",
  fontWeight: "semibold"
}, kZ = {
  marginEnd: 1,
  w: "3.5",
  h: "3.5",
  verticalAlign: "middle"
}, VZ = qS({
  container: {},
  label: EZ,
  helpText: TZ,
  number: NZ,
  icon: kZ
}), OZ = {
  md: qS({
    label: { fontSize: "sm" },
    helpText: { fontSize: "sm" },
    number: { fontSize: "2xl" }
  })
}, FZ = PZ({
  baseStyle: VZ,
  sizes: OZ,
  defaultProps: {
    size: "md"
  }
}), { defineMultiStyleConfig: BZ, definePartsStyle: R1 } = vn([
  "stepper",
  "step",
  "title",
  "description",
  "indicator",
  "separator",
  "icon",
  "number"
]), mi = at("stepper-indicator-size"), Vu = at("stepper-icon-size"), Ou = at("stepper-title-font-size"), D1 = at("stepper-description-font-size"), l1 = at("stepper-accent-color"), HZ = R1(({ colorScheme: e }) => ({
  stepper: {
    display: "flex",
    justifyContent: "space-between",
    gap: "4",
    "&[data-orientation=vertical]": {
      flexDirection: "column",
      alignItems: "flex-start"
    },
    "&[data-orientation=horizontal]": {
      flexDirection: "row",
      alignItems: "center"
    },
    [l1.variable]: `colors.${e}.500`,
    _dark: {
      [l1.variable]: `colors.${e}.200`
    }
  },
  title: {
    fontSize: Ou.reference,
    fontWeight: "medium"
  },
  description: {
    fontSize: D1.reference,
    color: "chakra-subtle-text"
  },
  number: {
    fontSize: Ou.reference
  },
  step: {
    flexShrink: 0,
    position: "relative",
    display: "flex",
    gap: "2",
    "&[data-orientation=horizontal]": {
      alignItems: "center"
    },
    flex: "1",
    "&:last-of-type:not([data-stretch])": {
      flex: "initial"
    }
  },
  icon: {
    flexShrink: 0,
    width: Vu.reference,
    height: Vu.reference
  },
  indicator: {
    flexShrink: 0,
    borderRadius: "full",
    width: mi.reference,
    height: mi.reference,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    "&[data-status=active]": {
      borderWidth: "2px",
      borderColor: l1.reference
    },
    "&[data-status=complete]": {
      bg: l1.reference,
      color: "chakra-inverse-text"
    },
    "&[data-status=incomplete]": {
      borderWidth: "2px"
    }
  },
  separator: {
    bg: "chakra-border-color",
    flex: "1",
    "&[data-status=complete]": {
      bg: l1.reference
    },
    "&[data-orientation=horizontal]": {
      width: "100%",
      height: "2px",
      marginStart: "2"
    },
    "&[data-orientation=vertical]": {
      width: "2px",
      position: "absolute",
      height: "100%",
      maxHeight: `calc(100% - ${mi.reference} - 8px)`,
      top: `calc(${mi.reference} + 4px)`,
      insetStart: `calc(${mi.reference} / 2 - 1px)`
    }
  }
})), GZ = BZ({
  baseStyle: HZ,
  sizes: {
    xs: R1({
      stepper: {
        [mi.variable]: "sizes.4",
        [Vu.variable]: "sizes.3",
        [Ou.variable]: "fontSizes.xs",
        [D1.variable]: "fontSizes.xs"
      }
    }),
    sm: R1({
      stepper: {
        [mi.variable]: "sizes.6",
        [Vu.variable]: "sizes.4",
        [Ou.variable]: "fontSizes.sm",
        [D1.variable]: "fontSizes.xs"
      }
    }),
    md: R1({
      stepper: {
        [mi.variable]: "sizes.8",
        [Vu.variable]: "sizes.5",
        [Ou.variable]: "fontSizes.md",
        [D1.variable]: "fontSizes.sm"
      }
    }),
    lg: R1({
      stepper: {
        [mi.variable]: "sizes.10",
        [Vu.variable]: "sizes.6",
        [Ou.variable]: "fontSizes.lg",
        [D1.variable]: "fontSizes.md"
      }
    })
  },
  defaultProps: {
    size: "md",
    colorScheme: "blue"
  }
}), { defineMultiStyleConfig: $Z, definePartsStyle: jf } = vn(aB.keys), W1 = dr("switch-track-width"), pl = dr("switch-track-height"), rg = dr("switch-track-diff"), ZZ = hi.subtract(W1, pl), w5 = dr("switch-thumb-x"), u1 = dr("switch-bg"), jZ = (e) => {
  const { colorScheme: t } = e;
  return {
    borderRadius: "full",
    p: "0.5",
    width: [W1.reference],
    height: [pl.reference],
    transitionProperty: "common",
    transitionDuration: "fast",
    [u1.variable]: "colors.gray.300",
    _dark: {
      [u1.variable]: "colors.whiteAlpha.400"
    },
    _focusVisible: {
      boxShadow: "outline"
    },
    _disabled: {
      opacity: 0.4,
      cursor: "not-allowed"
    },
    _checked: {
      [u1.variable]: `colors.${t}.500`,
      _dark: {
        [u1.variable]: `colors.${t}.200`
      }
    },
    bg: u1.reference
  };
}, WZ = {
  bg: "white",
  transitionProperty: "transform",
  transitionDuration: "normal",
  borderRadius: "inherit",
  width: [pl.reference],
  height: [pl.reference],
  _checked: {
    transform: `translateX(${w5.reference})`
  }
}, zZ = jf((e) => ({
  container: {
    [rg.variable]: ZZ,
    [w5.variable]: rg.reference,
    _rtl: {
      [w5.variable]: hi(rg).negate().toString()
    }
  },
  track: jZ(e),
  thumb: WZ
})), UZ = {
  sm: jf({
    container: {
      [W1.variable]: "1.375rem",
      [pl.variable]: "sizes.3"
    }
  }),
  md: jf({
    container: {
      [W1.variable]: "1.875rem",
      [pl.variable]: "sizes.4"
    }
  }),
  lg: jf({
    container: {
      [W1.variable]: "2.875rem",
      [pl.variable]: "sizes.6"
    }
  })
}, XZ = $Z({
  baseStyle: zZ,
  sizes: UZ,
  defaultProps: {
    size: "md",
    colorScheme: "blue"
  }
}), { defineMultiStyleConfig: YZ, definePartsStyle: Uu } = vn(iB.keys), qZ = Uu({
  table: {
    fontVariantNumeric: "lining-nums tabular-nums",
    borderCollapse: "collapse",
    width: "full"
  },
  th: {
    fontFamily: "heading",
    fontWeight: "bold",
    textTransform: "uppercase",
    letterSpacing: "wider",
    textAlign: "start"
  },
  td: {
    textAlign: "start"
  },
  caption: {
    mt: 4,
    fontFamily: "heading",
    textAlign: "center",
    fontWeight: "medium"
  }
}), m2 = {
  "&[data-is-numeric=true]": {
    textAlign: "end"
  }
}, JZ = Uu((e) => {
  const { colorScheme: t } = e;
  return {
    th: {
      color: rt("gray.600", "gray.400")(e),
      borderBottom: "1px",
      borderColor: rt(`${t}.100`, `${t}.700`)(e),
      ...m2
    },
    td: {
      borderBottom: "1px",
      borderColor: rt(`${t}.100`, `${t}.700`)(e),
      ...m2
    },
    caption: {
      color: rt("gray.600", "gray.100")(e)
    },
    tfoot: {
      tr: {
        "&:last-of-type": {
          th: { borderBottomWidth: 0 }
        }
      }
    }
  };
}), KZ = Uu((e) => {
  const { colorScheme: t } = e;
  return {
    th: {
      color: rt("gray.600", "gray.400")(e),
      borderBottom: "1px",
      borderColor: rt(`${t}.100`, `${t}.700`)(e),
      ...m2
    },
    td: {
      borderBottom: "1px",
      borderColor: rt(`${t}.100`, `${t}.700`)(e),
      ...m2
    },
    caption: {
      color: rt("gray.600", "gray.100")(e)
    },
    tbody: {
      tr: {
        "&:nth-of-type(odd)": {
          "th, td": {
            borderBottomWidth: "1px",
            borderColor: rt(`${t}.100`, `${t}.700`)(e)
          },
          td: {
            background: rt(`${t}.100`, `${t}.700`)(e)
          }
        }
      }
    },
    tfoot: {
      tr: {
        "&:last-of-type": {
          th: { borderBottomWidth: 0 }
        }
      }
    }
  };
}), QZ = {
  simple: JZ,
  striped: KZ,
  unstyled: {}
}, ej = {
  sm: Uu({
    th: {
      px: "4",
      py: "1",
      lineHeight: "4",
      fontSize: "xs"
    },
    td: {
      px: "4",
      py: "2",
      fontSize: "sm",
      lineHeight: "4"
    },
    caption: {
      px: "4",
      py: "2",
      fontSize: "xs"
    }
  }),
  md: Uu({
    th: {
      px: "6",
      py: "3",
      lineHeight: "4",
      fontSize: "xs"
    },
    td: {
      px: "6",
      py: "4",
      lineHeight: "5"
    },
    caption: {
      px: "6",
      py: "2",
      fontSize: "sm"
    }
  }),
  lg: Uu({
    th: {
      px: "8",
      py: "4",
      lineHeight: "5",
      fontSize: "sm"
    },
    td: {
      px: "8",
      py: "5",
      lineHeight: "6"
    },
    caption: {
      px: "6",
      py: "2",
      fontSize: "md"
    }
  })
}, tj = YZ({
  baseStyle: qZ,
  variants: QZ,
  sizes: ej,
  defaultProps: {
    variant: "simple",
    size: "md",
    colorScheme: "gray"
  }
}), oo = at("tabs-color"), va = at("tabs-bg"), lf = at("tabs-border-color"), { defineMultiStyleConfig: nj, definePartsStyle: Ba } = vn(sB.keys), rj = (e) => {
  const { orientation: t } = e;
  return {
    display: t === "vertical" ? "flex" : "block"
  };
}, oj = (e) => {
  const { isFitted: t } = e;
  return {
    flex: t ? 1 : void 0,
    transitionProperty: "common",
    transitionDuration: "normal",
    _focusVisible: {
      zIndex: 1,
      boxShadow: "outline"
    },
    _disabled: {
      cursor: "not-allowed",
      opacity: 0.4
    }
  };
}, aj = (e) => {
  const { align: t = "start", orientation: n } = e;
  return {
    justifyContent: {
      end: "flex-end",
      center: "center",
      start: "flex-start"
    }[t],
    flexDirection: n === "vertical" ? "column" : "row"
  };
}, ij = {
  p: 4
}, sj = Ba((e) => ({
  root: rj(e),
  tab: oj(e),
  tablist: aj(e),
  tabpanel: ij
})), lj = {
  sm: Ba({
    tab: {
      py: 1,
      px: 4,
      fontSize: "sm"
    }
  }),
  md: Ba({
    tab: {
      fontSize: "md",
      py: 2,
      px: 4
    }
  }),
  lg: Ba({
    tab: {
      fontSize: "lg",
      py: 3,
      px: 4
    }
  })
}, uj = Ba((e) => {
  const { colorScheme: t, orientation: n } = e, r = n === "vertical", o = r ? "borderStart" : "borderBottom", a = r ? "marginStart" : "marginBottom";
  return {
    tablist: {
      [o]: "2px solid",
      borderColor: "inherit"
    },
    tab: {
      [o]: "2px solid",
      borderColor: "transparent",
      [a]: "-2px",
      _selected: {
        [oo.variable]: `colors.${t}.600`,
        _dark: {
          [oo.variable]: `colors.${t}.300`
        },
        borderColor: "currentColor"
      },
      _active: {
        [va.variable]: "colors.gray.200",
        _dark: {
          [va.variable]: "colors.whiteAlpha.300"
        }
      },
      _disabled: {
        _active: { bg: "none" }
      },
      color: oo.reference,
      bg: va.reference
    }
  };
}), cj = Ba((e) => {
  const { colorScheme: t } = e;
  return {
    tab: {
      borderTopRadius: "md",
      border: "1px solid",
      borderColor: "transparent",
      mb: "-1px",
      [lf.variable]: "transparent",
      _selected: {
        [oo.variable]: `colors.${t}.600`,
        [lf.variable]: "colors.white",
        _dark: {
          [oo.variable]: `colors.${t}.300`,
          [lf.variable]: "colors.gray.800"
        },
        borderColor: "inherit",
        borderBottomColor: lf.reference
      },
      color: oo.reference
    },
    tablist: {
      mb: "-1px",
      borderBottom: "1px solid",
      borderColor: "inherit"
    }
  };
}), dj = Ba((e) => {
  const { colorScheme: t } = e;
  return {
    tab: {
      border: "1px solid",
      borderColor: "inherit",
      [va.variable]: "colors.gray.50",
      _dark: {
        [va.variable]: "colors.whiteAlpha.50"
      },
      mb: "-1px",
      _notLast: {
        marginEnd: "-1px"
      },
      _selected: {
        [va.variable]: "colors.white",
        [oo.variable]: `colors.${t}.600`,
        _dark: {
          [va.variable]: "colors.gray.800",
          [oo.variable]: `colors.${t}.300`
        },
        borderColor: "inherit",
        borderTopColor: "currentColor",
        borderBottomColor: "transparent"
      },
      color: oo.reference,
      bg: va.reference
    },
    tablist: {
      mb: "-1px",
      borderBottom: "1px solid",
      borderColor: "inherit"
    }
  };
}), fj = Ba((e) => {
  const { colorScheme: t, theme: n } = e;
  return {
    tab: {
      borderRadius: "full",
      fontWeight: "semibold",
      color: "gray.600",
      _selected: {
        color: $r(n, `${t}.700`),
        bg: $r(n, `${t}.100`)
      }
    }
  };
}), hj = Ba((e) => {
  const { colorScheme: t } = e;
  return {
    tab: {
      borderRadius: "full",
      fontWeight: "semibold",
      [oo.variable]: "colors.gray.600",
      _dark: {
        [oo.variable]: "inherit"
      },
      _selected: {
        [oo.variable]: "colors.white",
        [va.variable]: `colors.${t}.600`,
        _dark: {
          [oo.variable]: "colors.gray.800",
          [va.variable]: `colors.${t}.300`
        }
      },
      color: oo.reference,
      bg: va.reference
    }
  };
}), mj = Ba({}), pj = {
  line: uj,
  enclosed: cj,
  "enclosed-colored": dj,
  "soft-rounded": fj,
  "solid-rounded": hj,
  unstyled: mj
}, gj = nj({
  baseStyle: sj,
  sizes: lj,
  variants: pj,
  defaultProps: {
    size: "md",
    variant: "line",
    colorScheme: "blue"
  }
}), { defineMultiStyleConfig: vj, definePartsStyle: gl } = vn(lB.keys), Fv = at("tag-bg"), Bv = at("tag-color"), og = at("tag-shadow"), Wf = at("tag-min-height"), zf = at("tag-min-width"), Uf = at("tag-font-size"), Xf = at("tag-padding-inline"), Cj = {
  fontWeight: "medium",
  lineHeight: 1.2,
  outline: 0,
  [Bv.variable]: Jn.color.reference,
  [Fv.variable]: Jn.bg.reference,
  [og.variable]: Jn.shadow.reference,
  color: Bv.reference,
  bg: Fv.reference,
  boxShadow: og.reference,
  borderRadius: "md",
  minH: Wf.reference,
  minW: zf.reference,
  fontSize: Uf.reference,
  px: Xf.reference,
  _focusVisible: {
    [og.variable]: "shadows.outline"
  }
}, bj = {
  lineHeight: 1.2,
  overflow: "visible"
}, yj = {
  fontSize: "lg",
  w: "5",
  h: "5",
  transitionProperty: "common",
  transitionDuration: "normal",
  borderRadius: "full",
  marginStart: "1.5",
  marginEnd: "-1",
  opacity: 0.5,
  _disabled: {
    opacity: 0.4
  },
  _focusVisible: {
    boxShadow: "outline",
    bg: "rgba(0, 0, 0, 0.14)"
  },
  _hover: {
    opacity: 0.8
  },
  _active: {
    opacity: 1
  }
}, Sj = gl({
  container: Cj,
  label: bj,
  closeButton: yj
}), Aj = {
  sm: gl({
    container: {
      [Wf.variable]: "sizes.5",
      [zf.variable]: "sizes.5",
      [Uf.variable]: "fontSizes.xs",
      [Xf.variable]: "space.2"
    },
    closeButton: {
      marginEnd: "-2px",
      marginStart: "0.35rem"
    }
  }),
  md: gl({
    container: {
      [Wf.variable]: "sizes.6",
      [zf.variable]: "sizes.6",
      [Uf.variable]: "fontSizes.sm",
      [Xf.variable]: "space.2"
    }
  }),
  lg: gl({
    container: {
      [Wf.variable]: "sizes.8",
      [zf.variable]: "sizes.8",
      [Uf.variable]: "fontSizes.md",
      [Xf.variable]: "space.3"
    }
  })
}, Mj = {
  subtle: gl((e) => {
    var t;
    return {
      container: (t = $1.variants) == null ? void 0 : t.subtle(e)
    };
  }),
  solid: gl((e) => {
    var t;
    return {
      container: (t = $1.variants) == null ? void 0 : t.solid(e)
    };
  }),
  outline: gl((e) => {
    var t;
    return {
      container: (t = $1.variants) == null ? void 0 : t.outline(e)
    };
  })
}, xj = vj({
  variants: Mj,
  baseStyle: Sj,
  sizes: Aj,
  defaultProps: {
    size: "md",
    variant: "subtle",
    colorScheme: "gray"
  }
});
var $y;
const wj = {
  ...($y = tn.baseStyle) == null ? void 0 : $y.field,
  paddingY: "2",
  minHeight: "20",
  lineHeight: "short",
  verticalAlign: "top"
};
var Zy;
const _j = {
  outline: (e) => {
    var t;
    return ((t = tn.variants) == null ? void 0 : t.outline(e).field) ?? {};
  },
  flushed: (e) => {
    var t;
    return ((t = tn.variants) == null ? void 0 : t.flushed(e).field) ?? {};
  },
  filled: (e) => {
    var t;
    return ((t = tn.variants) == null ? void 0 : t.filled(e).field) ?? {};
  },
  unstyled: ((Zy = tn.variants) == null ? void 0 : Zy.unstyled.field) ?? {}
};
var jy, Wy, zy, Uy;
const Ij = {
  xs: ((jy = tn.sizes) == null ? void 0 : jy.xs.field) ?? {},
  sm: ((Wy = tn.sizes) == null ? void 0 : Wy.sm.field) ?? {},
  md: ((zy = tn.sizes) == null ? void 0 : zy.md.field) ?? {},
  lg: ((Uy = tn.sizes) == null ? void 0 : Uy.lg.field) ?? {}
}, Lj = {
  baseStyle: wj,
  sizes: Ij,
  variants: _j,
  defaultProps: {
    size: "md",
    variant: "outline"
  }
}, uf = dr("tooltip-bg"), ag = dr("tooltip-fg"), Rj = dr("popper-arrow-bg"), Dj = {
  bg: uf.reference,
  color: ag.reference,
  [uf.variable]: "colors.gray.700",
  [ag.variable]: "colors.whiteAlpha.900",
  _dark: {
    [uf.variable]: "colors.gray.300",
    [ag.variable]: "colors.gray.900"
  },
  [Rj.variable]: uf.reference,
  px: "2",
  py: "0.5",
  borderRadius: "sm",
  fontWeight: "medium",
  fontSize: "sm",
  boxShadow: "md",
  maxW: "xs",
  zIndex: "tooltip"
}, Pj = {
  baseStyle: Dj
}, Ej = {
  Accordion: vB,
  Alert: eH,
  Avatar: dH,
  Badge: $1,
  Breadcrumb: SH,
  Button: DH,
  Checkbox: ls,
  CloseButton: WH,
  Code: YH,
  Container: JH,
  Divider: nG,
  Drawer: hG,
  Editable: yG,
  Form: _G,
  FormError: EG,
  FormLabel: NG,
  Heading: OG,
  Input: tn,
  Kbd: UG,
  Link: YG,
  List: e$,
  Menu: d$,
  Modal: A$,
  NumberInput: P$,
  PinInput: k$,
  Popover: z$,
  Progress: eZ,
  Radio: aZ,
  Select: fZ,
  Skeleton: mZ,
  SkipLink: gZ,
  Slider: IZ,
  Spinner: DZ,
  Stat: FZ,
  Switch: XZ,
  Table: tj,
  Tabs: gj,
  Tag: xj,
  Textarea: Lj,
  Tooltip: Pj,
  Card: kH,
  Stepper: GZ
}, Tj = {
  none: 0,
  "1px": "1px solid",
  "2px": "2px solid",
  "4px": "4px solid",
  "8px": "8px solid"
}, Nj = {
  base: "0em",
  sm: "30em",
  md: "48em",
  lg: "62em",
  xl: "80em",
  "2xl": "96em"
}, kj = {
  transparent: "transparent",
  current: "currentColor",
  black: "#000000",
  white: "#FFFFFF",
  whiteAlpha: {
    50: "rgba(255, 255, 255, 0.04)",
    100: "rgba(255, 255, 255, 0.06)",
    200: "rgba(255, 255, 255, 0.08)",
    300: "rgba(255, 255, 255, 0.16)",
    400: "rgba(255, 255, 255, 0.24)",
    500: "rgba(255, 255, 255, 0.36)",
    600: "rgba(255, 255, 255, 0.48)",
    700: "rgba(255, 255, 255, 0.64)",
    800: "rgba(255, 255, 255, 0.80)",
    900: "rgba(255, 255, 255, 0.92)"
  },
  blackAlpha: {
    50: "rgba(0, 0, 0, 0.04)",
    100: "rgba(0, 0, 0, 0.06)",
    200: "rgba(0, 0, 0, 0.08)",
    300: "rgba(0, 0, 0, 0.16)",
    400: "rgba(0, 0, 0, 0.24)",
    500: "rgba(0, 0, 0, 0.36)",
    600: "rgba(0, 0, 0, 0.48)",
    700: "rgba(0, 0, 0, 0.64)",
    800: "rgba(0, 0, 0, 0.80)",
    900: "rgba(0, 0, 0, 0.92)"
  },
  gray: {
    50: "#F7FAFC",
    100: "#EDF2F7",
    200: "#E2E8F0",
    300: "#CBD5E0",
    400: "#A0AEC0",
    500: "#718096",
    600: "#4A5568",
    700: "#2D3748",
    800: "#1A202C",
    900: "#171923"
  },
  red: {
    50: "#FFF5F5",
    100: "#FED7D7",
    200: "#FEB2B2",
    300: "#FC8181",
    400: "#F56565",
    500: "#E53E3E",
    600: "#C53030",
    700: "#9B2C2C",
    800: "#822727",
    900: "#63171B"
  },
  orange: {
    50: "#FFFAF0",
    100: "#FEEBC8",
    200: "#FBD38D",
    300: "#F6AD55",
    400: "#ED8936",
    500: "#DD6B20",
    600: "#C05621",
    700: "#9C4221",
    800: "#7B341E",
    900: "#652B19"
  },
  yellow: {
    50: "#FFFFF0",
    100: "#FEFCBF",
    200: "#FAF089",
    300: "#F6E05E",
    400: "#ECC94B",
    500: "#D69E2E",
    600: "#B7791F",
    700: "#975A16",
    800: "#744210",
    900: "#5F370E"
  },
  green: {
    50: "#F0FFF4",
    100: "#C6F6D5",
    200: "#9AE6B4",
    300: "#68D391",
    400: "#48BB78",
    500: "#38A169",
    600: "#2F855A",
    700: "#276749",
    800: "#22543D",
    900: "#1C4532"
  },
  teal: {
    50: "#E6FFFA",
    100: "#B2F5EA",
    200: "#81E6D9",
    300: "#4FD1C5",
    400: "#38B2AC",
    500: "#319795",
    600: "#2C7A7B",
    700: "#285E61",
    800: "#234E52",
    900: "#1D4044"
  },
  blue: {
    50: "#ebf8ff",
    100: "#bee3f8",
    200: "#90cdf4",
    300: "#63b3ed",
    400: "#4299e1",
    500: "#3182ce",
    600: "#2b6cb0",
    700: "#2c5282",
    800: "#2a4365",
    900: "#1A365D"
  },
  cyan: {
    50: "#EDFDFD",
    100: "#C4F1F9",
    200: "#9DECF9",
    300: "#76E4F7",
    400: "#0BC5EA",
    500: "#00B5D8",
    600: "#00A3C4",
    700: "#0987A0",
    800: "#086F83",
    900: "#065666"
  },
  purple: {
    50: "#FAF5FF",
    100: "#E9D8FD",
    200: "#D6BCFA",
    300: "#B794F4",
    400: "#9F7AEA",
    500: "#805AD5",
    600: "#6B46C1",
    700: "#553C9A",
    800: "#44337A",
    900: "#322659"
  },
  pink: {
    50: "#FFF5F7",
    100: "#FED7E2",
    200: "#FBB6CE",
    300: "#F687B3",
    400: "#ED64A6",
    500: "#D53F8C",
    600: "#B83280",
    700: "#97266D",
    800: "#702459",
    900: "#521B41"
  }
}, Vj = {
  none: "0",
  sm: "0.125rem",
  base: "0.25rem",
  md: "0.375rem",
  lg: "0.5rem",
  xl: "0.75rem",
  "2xl": "1rem",
  "3xl": "1.5rem",
  full: "9999px"
}, Oj = {
  xs: "0 0 0 1px rgba(0, 0, 0, 0.05)",
  sm: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
  base: "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
  md: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
  lg: "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
  xl: "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
  "2xl": "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
  outline: "0 0 0 3px rgba(66, 153, 225, 0.6)",
  inner: "inset 0 2px 4px 0 rgba(0,0,0,0.06)",
  none: "none",
  "dark-lg": "rgba(0, 0, 0, 0.1) 0px 0px 0px 1px, rgba(0, 0, 0, 0.2) 0px 5px 10px, rgba(0, 0, 0, 0.4) 0px 15px 40px"
}, Fj = {
  common: "background-color, border-color, color, fill, stroke, opacity, box-shadow, transform",
  colors: "background-color, border-color, color, fill, stroke",
  dimensions: "width, height",
  position: "left, right, top, bottom",
  background: "background-color, background-image, background-position"
}, Bj = {
  "ease-in": "cubic-bezier(0.4, 0, 1, 1)",
  "ease-out": "cubic-bezier(0, 0, 0.2, 1)",
  "ease-in-out": "cubic-bezier(0.4, 0, 0.2, 1)"
}, Hj = {
  "ultra-fast": "50ms",
  faster: "100ms",
  fast: "150ms",
  normal: "200ms",
  slow: "300ms",
  slower: "400ms",
  "ultra-slow": "500ms"
}, Gj = {
  property: Fj,
  easing: Bj,
  duration: Hj
}, $j = {
  hide: -1,
  auto: "auto",
  base: 0,
  docked: 10,
  dropdown: 1e3,
  sticky: 1100,
  banner: 1200,
  overlay: 1300,
  modal: 1400,
  popover: 1500,
  skipLink: 1600,
  toast: 1700,
  tooltip: 1800
}, Zj = {
  none: 0,
  sm: "4px",
  base: "8px",
  md: "12px",
  lg: "16px",
  xl: "24px",
  "2xl": "40px",
  "3xl": "64px"
}, jj = {
  breakpoints: Nj,
  zIndices: $j,
  radii: Vj,
  blur: Zj,
  colors: kj,
  ...US,
  sizes: GS,
  shadows: Oj,
  space: HS,
  borders: Tj,
  transition: Gj
}, Wj = {
  colors: {
    "chakra-body-text": { _light: "gray.800", _dark: "whiteAlpha.900" },
    "chakra-body-bg": { _light: "white", _dark: "gray.800" },
    "chakra-border-color": { _light: "gray.200", _dark: "whiteAlpha.300" },
    "chakra-inverse-text": { _light: "white", _dark: "gray.800" },
    "chakra-subtle-bg": { _light: "gray.100", _dark: "gray.700" },
    "chakra-subtle-text": { _light: "gray.600", _dark: "gray.400" },
    "chakra-placeholder-color": { _light: "gray.500", _dark: "whiteAlpha.400" }
  }
}, zj = {
  global: {
    body: {
      fontFamily: "body",
      color: "chakra-body-text",
      bg: "chakra-body-bg",
      transitionProperty: "background-color",
      transitionDuration: "normal",
      lineHeight: "base"
    },
    "*::placeholder": {
      color: "chakra-placeholder-color"
    },
    "*, *::before, &::after": {
      borderColor: "chakra-border-color"
    }
  }
}, Uj = [
  "borders",
  "breakpoints",
  "colors",
  "components",
  "config",
  "direction",
  "fonts",
  "fontSizes",
  "fontWeights",
  "letterSpacings",
  "lineHeights",
  "radii",
  "shadows",
  "sizes",
  "space",
  "styles",
  "transition",
  "zIndices"
];
function Xj(e) {
  return cr(e) ? Uj.every(
    (t) => Object.prototype.hasOwnProperty.call(e, t)
  ) : !1;
}
const Yj = "ltr", qj = {
  useSystemColorMode: !1,
  initialColorMode: "light",
  cssVarPrefix: "chakra"
}, JS = {
  semanticTokens: Wj,
  direction: Yj,
  ...jj,
  components: Ej,
  styles: zj,
  config: qj
}, K3 = ea({});
K3.displayName = "ColorModeContext";
function Q3() {
  const e = Yn(K3);
  if (e === void 0)
    throw new Error("useColorMode must be used within a ColorModeProvider");
  return e;
}
const cf = {
  light: "chakra-ui-light",
  dark: "chakra-ui-dark"
};
function Jj(e = {}) {
  const { preventTransition: t = !0, nonce: n } = e, r = {
    setDataset: (o) => {
      const a = t ? r.preventTransition() : void 0;
      document.documentElement.dataset.theme = o, document.documentElement.style.colorScheme = o, a == null || a();
    },
    setClassName(o) {
      document.body.classList.add(o ? cf.dark : cf.light), document.body.classList.remove(o ? cf.light : cf.dark);
    },
    query() {
      return window.matchMedia("(prefers-color-scheme: dark)");
    },
    getSystemTheme(o) {
      return r.query().matches ?? o === "dark" ? "dark" : "light";
    },
    addListener(o) {
      const a = r.query(), i = (l) => {
        o(l.matches ? "dark" : "light");
      };
      return typeof a.addListener == "function" ? a.addListener(i) : a.addEventListener("change", i), () => {
        typeof a.removeListener == "function" ? a.removeListener(i) : a.removeEventListener("change", i);
      };
    },
    preventTransition() {
      const o = document.createElement("style");
      return o.appendChild(
        document.createTextNode(
          "*{-webkit-transition:none!important;-moz-transition:none!important;-o-transition:none!important;-ms-transition:none!important;transition:none!important}"
        )
      ), n !== void 0 && (o.nonce = n), document.head.appendChild(o), () => {
        window.getComputedStyle(document.body), requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            document.head.removeChild(o);
          });
        });
      };
    }
  };
  return r;
}
const Kj = "chakra-ui-color-mode";
function Qj(e) {
  return {
    ssr: !1,
    type: "localStorage",
    get(t) {
      if (!(globalThis != null && globalThis.document))
        return t;
      let n;
      try {
        n = localStorage.getItem(e) || t;
      } catch {
      }
      return n || t;
    },
    set(t) {
      try {
        localStorage.setItem(e, t);
      } catch {
      }
    }
  };
}
const eW = Qj(Kj), Hv = () => {
}, tW = $V() ? Cc : st;
function Gv(e, t) {
  return e.type === "cookie" && e.ssr ? e.get(t) : t;
}
const KS = function(t) {
  const {
    value: n,
    children: r,
    options: {
      useSystemColorMode: o,
      initialColorMode: a,
      disableTransitionOnChange: i
    } = {},
    colorModeManager: l = eW
  } = t, u = kV(), d = a === "dark" ? "dark" : "light", [f, h] = He(
    () => Gv(l, d)
  ), [p, g] = He(
    () => Gv(l)
  ), { getSystemTheme: C, setClassName: v, setDataset: y, addListener: M } = bt(
    () => Jj({
      preventTransition: i,
      nonce: u == null ? void 0 : u.nonce
    }),
    [i, u == null ? void 0 : u.nonce]
  ), x = a === "system" && !f ? p : f, _ = Q(
    (k) => {
      const P = k === "system" ? C() : k;
      h(P), v(P === "dark"), y(P), l.set(P);
    },
    [l, C, v, y]
  );
  tW(() => {
    a === "system" && g(C());
  }, []), st(() => {
    const k = l.get();
    if (k) {
      _(k);
      return;
    }
    if (a === "system") {
      _("system");
      return;
    }
    _(d);
  }, [l, d, a, _]);
  const L = Q(() => {
    _(x === "dark" ? "light" : "dark");
  }, [x, _]);
  st(() => {
    if (o)
      return M(_);
  }, [o, M, _]);
  const R = bt(
    () => ({
      colorMode: n ?? x,
      toggleColorMode: n ? Hv : L,
      setColorMode: n ? Hv : _,
      forced: n !== void 0
    }),
    [x, L, _, n]
  );
  return /* @__PURE__ */ A.jsx(K3.Provider, { value: R, children: r });
};
KS.displayName = "ColorModeProvider";
const QS = String.raw, eA = QS`
  :root,
  :host {
    --chakra-vh: 100vh;
  }

  @supports (height: -webkit-fill-available) {
    :root,
    :host {
      --chakra-vh: -webkit-fill-available;
    }
  }

  @supports (height: -moz-fill-available) {
    :root,
    :host {
      --chakra-vh: -moz-fill-available;
    }
  }

  @supports (height: 100dvh) {
    :root,
    :host {
      --chakra-vh: 100dvh;
    }
  }
`, nW = () => /* @__PURE__ */ A.jsx(bh, { styles: eA }), rW = ({ scope: e = "" }) => /* @__PURE__ */ A.jsx(
  bh,
  {
    styles: QS`
      html {
        line-height: 1.5;
        -webkit-text-size-adjust: 100%;
        font-family: system-ui, sans-serif;
        -webkit-font-smoothing: antialiased;
        text-rendering: optimizeLegibility;
        -moz-osx-font-smoothing: grayscale;
        touch-action: manipulation;
      }

      body {
        position: relative;
        min-height: 100%;
        margin: 0;
        font-feature-settings: "kern";
      }

      ${e} :where(*, *::before, *::after) {
        border-width: 0;
        border-style: solid;
        box-sizing: border-box;
        word-wrap: break-word;
      }

      main {
        display: block;
      }

      ${e} hr {
        border-top-width: 1px;
        box-sizing: content-box;
        height: 0;
        overflow: visible;
      }

      ${e} :where(pre, code, kbd,samp) {
        font-family: SFMono-Regular, Menlo, Monaco, Consolas, monospace;
        font-size: 1em;
      }

      ${e} a {
        background-color: transparent;
        color: inherit;
        text-decoration: inherit;
      }

      ${e} abbr[title] {
        border-bottom: none;
        text-decoration: underline;
        -webkit-text-decoration: underline dotted;
        text-decoration: underline dotted;
      }

      ${e} :where(b, strong) {
        font-weight: bold;
      }

      ${e} small {
        font-size: 80%;
      }

      ${e} :where(sub,sup) {
        font-size: 75%;
        line-height: 0;
        position: relative;
        vertical-align: baseline;
      }

      ${e} sub {
        bottom: -0.25em;
      }

      ${e} sup {
        top: -0.5em;
      }

      ${e} img {
        border-style: none;
      }

      ${e} :where(button, input, optgroup, select, textarea) {
        font-family: inherit;
        font-size: 100%;
        line-height: 1.15;
        margin: 0;
      }

      ${e} :where(button, input) {
        overflow: visible;
      }

      ${e} :where(button, select) {
        text-transform: none;
      }

      ${e} :where(
          button::-moz-focus-inner,
          [type="button"]::-moz-focus-inner,
          [type="reset"]::-moz-focus-inner,
          [type="submit"]::-moz-focus-inner
        ) {
        border-style: none;
        padding: 0;
      }

      ${e} fieldset {
        padding: 0.35em 0.75em 0.625em;
      }

      ${e} legend {
        box-sizing: border-box;
        color: inherit;
        display: table;
        max-width: 100%;
        padding: 0;
        white-space: normal;
      }

      ${e} progress {
        vertical-align: baseline;
      }

      ${e} textarea {
        overflow: auto;
      }

      ${e} :where([type="checkbox"], [type="radio"]) {
        box-sizing: border-box;
        padding: 0;
      }

      ${e} input[type="number"]::-webkit-inner-spin-button,
      ${e} input[type="number"]::-webkit-outer-spin-button {
        -webkit-appearance: none !important;
      }

      ${e} input[type="number"] {
        -moz-appearance: textfield;
      }

      ${e} input[type="search"] {
        -webkit-appearance: textfield;
        outline-offset: -2px;
      }

      ${e} input[type="search"]::-webkit-search-decoration {
        -webkit-appearance: none !important;
      }

      ${e} ::-webkit-file-upload-button {
        -webkit-appearance: button;
        font: inherit;
      }

      ${e} details {
        display: block;
      }

      ${e} summary {
        display: list-item;
      }

      template {
        display: none;
      }

      [hidden] {
        display: none !important;
      }

      ${e} :where(
          blockquote,
          dl,
          dd,
          h1,
          h2,
          h3,
          h4,
          h5,
          h6,
          hr,
          figure,
          p,
          pre
        ) {
        margin: 0;
      }

      ${e} button {
        background: transparent;
        padding: 0;
      }

      ${e} fieldset {
        margin: 0;
        padding: 0;
      }

      ${e} :where(ol, ul) {
        margin: 0;
        padding: 0;
      }

      ${e} textarea {
        resize: vertical;
      }

      ${e} :where(button, [role="button"]) {
        cursor: pointer;
      }

      ${e} button::-moz-focus-inner {
        border: 0 !important;
      }

      ${e} table {
        border-collapse: collapse;
      }

      ${e} :where(h1, h2, h3, h4, h5, h6) {
        font-size: inherit;
        font-weight: inherit;
      }

      ${e} :where(button, input, optgroup, select, textarea) {
        padding: 0;
        line-height: inherit;
        color: inherit;
      }

      ${e} :where(img, svg, video, canvas, audio, iframe, embed, object) {
        display: block;
      }

      ${e} :where(img, video) {
        max-width: 100%;
        height: auto;
      }

      [data-js-focus-visible]
        :focus:not([data-focus-visible-added]):not(
          [data-focus-visible-disabled]
        ) {
        outline: none;
        box-shadow: none;
      }

      ${e} select::-ms-expand {
        display: none;
      }

      ${eA}
    `
  }
);
function oW(e) {
  const { cssVarsRoot: t, theme: n, children: r } = e, o = bt(() => BF(n), [n]);
  return /* @__PURE__ */ A.jsxs(VV, { theme: o, children: [
    /* @__PURE__ */ A.jsx(aW, { root: t }),
    r
  ] });
}
function aW({ root: e = ":host, :root" }) {
  const t = [e, "[data-theme]"].join(",");
  return /* @__PURE__ */ A.jsx(bh, { styles: (n) => ({ [t]: n.__cssVars }) });
}
mn({
  name: "StylesContext",
  errorMessage: "useStyles: `styles` is undefined. Seems you forgot to wrap the components in `<StylesProvider />` "
});
function iW(e) {
  return mn({
    name: `${e}StylesContext`,
    errorMessage: `useStyles: "styles" is undefined. Seems you forgot to wrap the components in "<${e} />" `
  });
}
function sW() {
  const { colorMode: e } = Q3();
  return /* @__PURE__ */ A.jsx(
    bh,
    {
      styles: (t) => {
        const n = vS(t, "styles.global"), r = Wo(n, { theme: t, colorMode: e });
        return r ? kS(r)(t) : void 0;
      }
    }
  );
}
const [lW, uW] = mn({
  strict: !1,
  name: "PortalManagerContext"
});
function tA(e) {
  const { children: t, zIndex: n } = e;
  return /* @__PURE__ */ A.jsx(lW, { value: { zIndex: n }, children: t });
}
tA.displayName = "PortalManager";
const nA = ea({
  getDocument() {
    return document;
  },
  getWindow() {
    return window;
  }
});
nA.displayName = "EnvironmentContext";
function rA(e) {
  const { children: t, environment: n, disabled: r } = e, o = Ve(null), a = bt(() => n || {
    getDocument: () => {
      var l;
      return ((l = o.current) == null ? void 0 : l.ownerDocument) ?? document;
    },
    getWindow: () => {
      var l;
      return ((l = o.current) == null ? void 0 : l.ownerDocument.defaultView) ?? window;
    }
  }, [n]), i = !r || !n;
  return /* @__PURE__ */ A.jsxs(nA.Provider, { value: a, children: [
    t,
    i && /* @__PURE__ */ A.jsx("span", { id: "__chakra_env", hidden: !0, ref: o })
  ] });
}
rA.displayName = "EnvironmentProvider";
const cW = (e) => {
  const {
    children: t,
    colorModeManager: n,
    portalZIndex: r,
    resetScope: o,
    resetCSS: a = !0,
    theme: i = {},
    environment: l,
    cssVarsRoot: u,
    disableEnvironment: d,
    disableGlobalStyle: f
  } = e, h = /* @__PURE__ */ A.jsx(
    rA,
    {
      environment: l,
      disabled: d,
      children: t
    }
  );
  return /* @__PURE__ */ A.jsx(oW, { theme: i, cssVarsRoot: u, children: /* @__PURE__ */ A.jsxs(
    KS,
    {
      colorModeManager: n,
      options: i.config,
      children: [
        a ? /* @__PURE__ */ A.jsx(rW, { scope: o }) : /* @__PURE__ */ A.jsx(nW, {}),
        !f && /* @__PURE__ */ A.jsx(sW, {}),
        r ? /* @__PURE__ */ A.jsx(tA, { zIndex: r, children: h }) : h
      ]
    }
  ) });
}, oA = ea({
  transformPagePoint: (e) => e,
  isStatic: !1,
  reducedMotion: "never"
}), Ih = ea({}), Id = ea(null), Lh = typeof document < "u", e4 = Lh ? Cc : st, aA = ea({ strict: !1 }), t4 = (e) => e.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase(), dW = "framerAppearId", iA = "data-" + t4(dW);
function fW(e, t, n, r) {
  const { visualElement: o } = Yn(Ih), a = Yn(aA), i = Yn(Id), l = Yn(oA).reducedMotion, u = Ve();
  r = r || a.renderer, !u.current && r && (u.current = r(e, {
    visualState: t,
    parent: o,
    props: n,
    presenceContext: i,
    blockInitialAnimation: i ? i.initial === !1 : !1,
    reducedMotionConfig: l
  }));
  const d = u.current;
  lS(() => {
    d && d.update(n, i);
  });
  const f = Ve(!!(n[iA] && !window.HandoffComplete));
  return e4(() => {
    d && (d.render(), f.current && d.animationState && d.animationState.animateChanges());
  }), st(() => {
    d && (d.updateFeatures(), !f.current && d.animationState && d.animationState.animateChanges(), f.current && (f.current = !1, window.HandoffComplete = !0));
  }), d;
}
function Fu(e) {
  return e && typeof e == "object" && Object.prototype.hasOwnProperty.call(e, "current");
}
function hW(e, t, n) {
  return Q(
    (r) => {
      r && e.mount && e.mount(r), t && (r ? t.mount(r) : t.unmount()), n && (typeof n == "function" ? n(r) : Fu(n) && (n.current = r));
    },
    /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */
    [t]
  );
}
function ud(e) {
  return typeof e == "string" || Array.isArray(e);
}
function Rh(e) {
  return e !== null && typeof e == "object" && typeof e.start == "function";
}
const n4 = [
  "animate",
  "whileInView",
  "whileFocus",
  "whileHover",
  "whileTap",
  "whileDrag",
  "exit"
], r4 = ["initial", ...n4];
function Dh(e) {
  return Rh(e.animate) || r4.some((t) => ud(e[t]));
}
function sA(e) {
  return !!(Dh(e) || e.variants);
}
function mW(e, t) {
  if (Dh(e)) {
    const { initial: n, animate: r } = e;
    return {
      initial: n === !1 || ud(n) ? n : void 0,
      animate: ud(r) ? r : void 0
    };
  }
  return e.inherit !== !1 ? t : {};
}
function pW(e) {
  const { initial: t, animate: n } = mW(e, Yn(Ih));
  return bt(() => ({ initial: t, animate: n }), [$v(t), $v(n)]);
}
function $v(e) {
  return Array.isArray(e) ? e.join(" ") : e;
}
const Zv = {
  animation: [
    "animate",
    "variants",
    "whileHover",
    "whileTap",
    "exit",
    "whileInView",
    "whileFocus",
    "whileDrag"
  ],
  exit: ["exit"],
  drag: ["drag", "dragControls"],
  focus: ["whileFocus"],
  hover: ["whileHover", "onHoverStart", "onHoverEnd"],
  tap: ["whileTap", "onTap", "onTapStart", "onTapCancel"],
  pan: ["onPan", "onPanStart", "onPanSessionStart", "onPanEnd"],
  inView: ["whileInView", "onViewportEnter", "onViewportLeave"],
  layout: ["layout", "layoutId"]
}, cd = {};
for (const e in Zv)
  cd[e] = {
    isEnabled: (t) => Zv[e].some((n) => !!t[n])
  };
function gW(e) {
  for (const t in e)
    cd[t] = {
      ...cd[t],
      ...e[t]
    };
}
const o4 = ea({}), lA = ea({}), vW = Symbol.for("motionComponentSymbol");
function CW({ preloadedFeatures: e, createVisualElement: t, useRender: n, useVisualState: r, Component: o }) {
  e && gW(e);
  function a(l, u) {
    let d;
    const f = {
      ...Yn(oA),
      ...l,
      layoutId: bW(l)
    }, { isStatic: h } = f, p = pW(l), g = r(l, h);
    if (!h && Lh) {
      p.visualElement = fW(o, g, f, t);
      const C = Yn(lA), v = Yn(aA).strict;
      p.visualElement && (d = p.visualElement.loadFeatures(
        // Note: Pass the full new combined props to correctly re-render dynamic feature components.
        f,
        v,
        e,
        C
      ));
    }
    return Ee.createElement(
      Ih.Provider,
      { value: p },
      d && p.visualElement ? Ee.createElement(d, { visualElement: p.visualElement, ...f }) : null,
      n(o, l, hW(g, p.visualElement, u), g, h, p.visualElement)
    );
  }
  const i = Ke(a);
  return i[vW] = o, i;
}
function bW({ layoutId: e }) {
  const t = Yn(o4).id;
  return t && e !== void 0 ? t + "-" + e : e;
}
function yW(e) {
  function t(r, o = {}) {
    return CW(e(r, o));
  }
  if (typeof Proxy > "u")
    return t;
  const n = /* @__PURE__ */ new Map();
  return new Proxy(t, {
    /**
     * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
     * The prop name is passed through as `key` and we can use that to generate a `motion`
     * DOM component with that name.
     */
    get: (r, o) => (n.has(o) || n.set(o, t(o)), n.get(o))
  });
}
const SW = [
  "animate",
  "circle",
  "defs",
  "desc",
  "ellipse",
  "g",
  "image",
  "line",
  "filter",
  "marker",
  "mask",
  "metadata",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "rect",
  "stop",
  "switch",
  "symbol",
  "svg",
  "text",
  "tspan",
  "use",
  "view"
];
function a4(e) {
  return (
    /**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */
    typeof e != "string" || /**
     * If it contains a dash, the element is a custom HTML webcomponent.
     */
    e.includes("-") ? !1 : (
      /**
       * If it's in our list of lowercase SVG tags, it's an SVG component
       */
      !!(SW.indexOf(e) > -1 || /**
       * If it contains a capital letter, it's an SVG component
       */
      /[A-Z]/.test(e))
    )
  );
}
const p2 = {};
function AW(e) {
  Object.assign(p2, e);
}
const Ld = [
  "transformPerspective",
  "x",
  "y",
  "z",
  "translateX",
  "translateY",
  "translateZ",
  "scale",
  "scaleX",
  "scaleY",
  "rotate",
  "rotateX",
  "rotateY",
  "rotateZ",
  "skew",
  "skewX",
  "skewY"
], Fl = new Set(Ld);
function uA(e, { layout: t, layoutId: n }) {
  return Fl.has(e) || e.startsWith("origin") || (t || n !== void 0) && (!!p2[e] || e === "opacity");
}
const so = (e) => !!(e && e.getVelocity), MW = {
  x: "translateX",
  y: "translateY",
  z: "translateZ",
  transformPerspective: "perspective"
}, xW = Ld.length;
function wW(e, { enableHardwareAcceleration: t = !0, allowTransformNone: n = !0 }, r, o) {
  let a = "";
  for (let i = 0; i < xW; i++) {
    const l = Ld[i];
    if (e[l] !== void 0) {
      const u = MW[l] || l;
      a += `${u}(${e[l]}) `;
    }
  }
  return t && !e.z && (a += "translateZ(0)"), a = a.trim(), o ? a = o(e, r ? "" : a) : n && r && (a = "none"), a;
}
const cA = (e) => (t) => typeof t == "string" && t.startsWith(e), dA = cA("--"), _5 = cA("var(--"), _W = /var\s*\(\s*--[\w-]+(\s*,\s*(?:(?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)+)?\s*\)/g, IW = (e, t) => t && typeof e == "number" ? t.transform(e) : e, As = (e, t, n) => Math.min(Math.max(n, e), t), Bl = {
  test: (e) => typeof e == "number",
  parse: parseFloat,
  transform: (e) => e
}, z1 = {
  ...Bl,
  transform: (e) => As(0, 1, e)
}, df = {
  ...Bl,
  default: 1
}, U1 = (e) => Math.round(e * 1e5) / 1e5, Ph = /(-)?([\d]*\.?[\d])+/g, fA = /(#[0-9a-f]{3,8}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2}(-?[\d\.]+%?)\s*[\,\/]?\s*[\d\.]*%?\))/gi, LW = /^(#[0-9a-f]{3,8}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2}(-?[\d\.]+%?)\s*[\,\/]?\s*[\d\.]*%?\))$/i;
function Rd(e) {
  return typeof e == "string";
}
const Dd = (e) => ({
  test: (t) => Rd(t) && t.endsWith(e) && t.split(" ").length === 1,
  parse: parseFloat,
  transform: (t) => `${t}${e}`
}), is = Dd("deg"), Ha = Dd("%"), ft = Dd("px"), RW = Dd("vh"), DW = Dd("vw"), jv = {
  ...Ha,
  parse: (e) => Ha.parse(e) / 100,
  transform: (e) => Ha.transform(e * 100)
}, Wv = {
  ...Bl,
  transform: Math.round
}, hA = {
  // Border props
  borderWidth: ft,
  borderTopWidth: ft,
  borderRightWidth: ft,
  borderBottomWidth: ft,
  borderLeftWidth: ft,
  borderRadius: ft,
  radius: ft,
  borderTopLeftRadius: ft,
  borderTopRightRadius: ft,
  borderBottomRightRadius: ft,
  borderBottomLeftRadius: ft,
  // Positioning props
  width: ft,
  maxWidth: ft,
  height: ft,
  maxHeight: ft,
  size: ft,
  top: ft,
  right: ft,
  bottom: ft,
  left: ft,
  // Spacing props
  padding: ft,
  paddingTop: ft,
  paddingRight: ft,
  paddingBottom: ft,
  paddingLeft: ft,
  margin: ft,
  marginTop: ft,
  marginRight: ft,
  marginBottom: ft,
  marginLeft: ft,
  // Transform props
  rotate: is,
  rotateX: is,
  rotateY: is,
  rotateZ: is,
  scale: df,
  scaleX: df,
  scaleY: df,
  scaleZ: df,
  skew: is,
  skewX: is,
  skewY: is,
  distance: ft,
  translateX: ft,
  translateY: ft,
  translateZ: ft,
  x: ft,
  y: ft,
  z: ft,
  perspective: ft,
  transformPerspective: ft,
  opacity: z1,
  originX: jv,
  originY: jv,
  originZ: ft,
  // Misc
  zIndex: Wv,
  // SVG
  fillOpacity: z1,
  strokeOpacity: z1,
  numOctaves: Wv
};
function i4(e, t, n, r) {
  const { style: o, vars: a, transform: i, transformOrigin: l } = e;
  let u = !1, d = !1, f = !0;
  for (const h in t) {
    const p = t[h];
    if (dA(h)) {
      a[h] = p;
      continue;
    }
    const g = hA[h], C = IW(p, g);
    if (Fl.has(h)) {
      if (u = !0, i[h] = C, !f)
        continue;
      p !== (g.default || 0) && (f = !1);
    } else
      h.startsWith("origin") ? (d = !0, l[h] = C) : o[h] = C;
  }
  if (t.transform || (u || r ? o.transform = wW(e.transform, n, f, r) : o.transform && (o.transform = "none")), d) {
    const { originX: h = "50%", originY: p = "50%", originZ: g = 0 } = l;
    o.transformOrigin = `${h} ${p} ${g}`;
  }
}
const s4 = () => ({
  style: {},
  transform: {},
  transformOrigin: {},
  vars: {}
});
function mA(e, t, n) {
  for (const r in t)
    !so(t[r]) && !uA(r, n) && (e[r] = t[r]);
}
function PW({ transformTemplate: e }, t, n) {
  return bt(() => {
    const r = s4();
    return i4(r, t, { enableHardwareAcceleration: !n }, e), Object.assign({}, r.vars, r.style);
  }, [t]);
}
function EW(e, t, n) {
  const r = e.style || {}, o = {};
  return mA(o, r, e), Object.assign(o, PW(e, t, n)), e.transformValues ? e.transformValues(o) : o;
}
function TW(e, t, n) {
  const r = {}, o = EW(e, t, n);
  return e.drag && e.dragListener !== !1 && (r.draggable = !1, o.userSelect = o.WebkitUserSelect = o.WebkitTouchCallout = "none", o.touchAction = e.drag === !0 ? "none" : `pan-${e.drag === "x" ? "y" : "x"}`), e.tabIndex === void 0 && (e.onTap || e.onTapStart || e.whileTap) && (r.tabIndex = 0), r.style = o, r;
}
const NW = /* @__PURE__ */ new Set([
  "animate",
  "exit",
  "variants",
  "initial",
  "style",
  "values",
  "variants",
  "transition",
  "transformTemplate",
  "transformValues",
  "custom",
  "inherit",
  "onBeforeLayoutMeasure",
  "onAnimationStart",
  "onAnimationComplete",
  "onUpdate",
  "onDragStart",
  "onDrag",
  "onDragEnd",
  "onMeasureDragConstraints",
  "onDirectionLock",
  "onDragTransitionEnd",
  "_dragX",
  "_dragY",
  "onHoverStart",
  "onHoverEnd",
  "onViewportEnter",
  "onViewportLeave",
  "globalTapTarget",
  "ignoreStrict",
  "viewport"
]);
function g2(e) {
  return e.startsWith("while") || e.startsWith("drag") && e !== "draggable" || e.startsWith("layout") || e.startsWith("onTap") || e.startsWith("onPan") || e.startsWith("onLayout") || NW.has(e);
}
let pA = (e) => !g2(e);
function kW(e) {
  e && (pA = (t) => t.startsWith("on") ? !g2(t) : e(t));
}
try {
  kW(require("@emotion/is-prop-valid").default);
} catch {
}
function VW(e, t, n) {
  const r = {};
  for (const o in e)
    o === "values" && typeof e.values == "object" || (pA(o) || n === !0 && g2(o) || !t && !g2(o) || // If trying to use native HTML drag events, forward drag listeners
    e.draggable && o.startsWith("onDrag")) && (r[o] = e[o]);
  return r;
}
function zv(e, t, n) {
  return typeof e == "string" ? e : ft.transform(t + n * e);
}
function OW(e, t, n) {
  const r = zv(t, e.x, e.width), o = zv(n, e.y, e.height);
  return `${r} ${o}`;
}
const FW = {
  offset: "stroke-dashoffset",
  array: "stroke-dasharray"
}, BW = {
  offset: "strokeDashoffset",
  array: "strokeDasharray"
};
function HW(e, t, n = 1, r = 0, o = !0) {
  e.pathLength = 1;
  const a = o ? FW : BW;
  e[a.offset] = ft.transform(-r);
  const i = ft.transform(t), l = ft.transform(n);
  e[a.array] = `${i} ${l}`;
}
function l4(e, {
  attrX: t,
  attrY: n,
  attrScale: r,
  originX: o,
  originY: a,
  pathLength: i,
  pathSpacing: l = 1,
  pathOffset: u = 0,
  // This is object creation, which we try to avoid per-frame.
  ...d
}, f, h, p) {
  if (i4(e, d, f, p), h) {
    e.style.viewBox && (e.attrs.viewBox = e.style.viewBox);
    return;
  }
  e.attrs = e.style, e.style = {};
  const { attrs: g, style: C, dimensions: v } = e;
  g.transform && (v && (C.transform = g.transform), delete g.transform), v && (o !== void 0 || a !== void 0 || C.transform) && (C.transformOrigin = OW(v, o !== void 0 ? o : 0.5, a !== void 0 ? a : 0.5)), t !== void 0 && (g.x = t), n !== void 0 && (g.y = n), r !== void 0 && (g.scale = r), i !== void 0 && HW(g, i, l, u, !1);
}
const gA = () => ({
  ...s4(),
  attrs: {}
}), u4 = (e) => typeof e == "string" && e.toLowerCase() === "svg";
function GW(e, t, n, r) {
  const o = bt(() => {
    const a = gA();
    return l4(a, t, { enableHardwareAcceleration: !1 }, u4(r), e.transformTemplate), {
      ...a.attrs,
      style: { ...a.style }
    };
  }, [t]);
  if (e.style) {
    const a = {};
    mA(a, e.style, e), o.style = { ...a, ...o.style };
  }
  return o;
}
function $W(e = !1) {
  return (n, r, o, { latestValues: a }, i) => {
    const u = (a4(n) ? GW : TW)(r, a, i, n), f = {
      ...VW(r, typeof n == "string", e),
      ...u,
      ref: o
    }, { children: h } = r, p = bt(() => so(h) ? h.get() : h, [h]);
    return uS(n, {
      ...f,
      children: p
    });
  };
}
function vA(e, { style: t, vars: n }, r, o) {
  Object.assign(e.style, t, o && o.getProjectionStyles(r));
  for (const a in n)
    e.style.setProperty(a, n[a]);
}
const CA = /* @__PURE__ */ new Set([
  "baseFrequency",
  "diffuseConstant",
  "kernelMatrix",
  "kernelUnitLength",
  "keySplines",
  "keyTimes",
  "limitingConeAngle",
  "markerHeight",
  "markerWidth",
  "numOctaves",
  "targetX",
  "targetY",
  "surfaceScale",
  "specularConstant",
  "specularExponent",
  "stdDeviation",
  "tableValues",
  "viewBox",
  "gradientTransform",
  "pathLength",
  "startOffset",
  "textLength",
  "lengthAdjust"
]);
function bA(e, t, n, r) {
  vA(e, t, void 0, r);
  for (const o in t.attrs)
    e.setAttribute(CA.has(o) ? o : t4(o), t.attrs[o]);
}
function c4(e, t) {
  const { style: n } = e, r = {};
  for (const o in n)
    (so(n[o]) || t.style && so(t.style[o]) || uA(o, e)) && (r[o] = n[o]);
  return r;
}
function yA(e, t) {
  const n = c4(e, t);
  for (const r in e)
    if (so(e[r]) || so(t[r])) {
      const o = Ld.indexOf(r) !== -1 ? "attr" + r.charAt(0).toUpperCase() + r.substring(1) : r;
      n[o] = e[r];
    }
  return n;
}
function d4(e, t, n, r = {}, o = {}) {
  return typeof t == "function" && (t = t(n !== void 0 ? n : e.custom, r, o)), typeof t == "string" && (t = e.variants && e.variants[t]), typeof t == "function" && (t = t(n !== void 0 ? n : e.custom, r, o)), t;
}
function SA(e) {
  const t = Ve(null);
  return t.current === null && (t.current = e()), t.current;
}
const v2 = (e) => Array.isArray(e), ZW = (e) => !!(e && typeof e == "object" && e.mix && e.toValue), jW = (e) => v2(e) ? e[e.length - 1] || 0 : e;
function Yf(e) {
  const t = so(e) ? e.get() : e;
  return ZW(t) ? t.toValue() : t;
}
function WW({ scrapeMotionValuesFromProps: e, createRenderState: t, onMount: n }, r, o, a) {
  const i = {
    latestValues: zW(r, o, a, e),
    renderState: t()
  };
  return n && (i.mount = (l) => n(r, l, i)), i;
}
const AA = (e) => (t, n) => {
  const r = Yn(Ih), o = Yn(Id), a = () => WW(e, t, r, o);
  return n ? a() : SA(a);
};
function zW(e, t, n, r) {
  const o = {}, a = r(e, {});
  for (const p in a)
    o[p] = Yf(a[p]);
  let { initial: i, animate: l } = e;
  const u = Dh(e), d = sA(e);
  t && d && !u && e.inherit !== !1 && (i === void 0 && (i = t.initial), l === void 0 && (l = t.animate));
  let f = n ? n.initial === !1 : !1;
  f = f || i === !1;
  const h = f ? l : i;
  return h && typeof h != "boolean" && !Rh(h) && (Array.isArray(h) ? h : [h]).forEach((g) => {
    const C = d4(e, g);
    if (!C)
      return;
    const { transitionEnd: v, transition: y, ...M } = C;
    for (const x in M) {
      let _ = M[x];
      if (Array.isArray(_)) {
        const L = f ? _.length - 1 : 0;
        _ = _[L];
      }
      _ !== null && (o[x] = _);
    }
    for (const x in v)
      o[x] = v[x];
  }), o;
}
const Zn = (e) => e;
class Uv {
  constructor() {
    this.order = [], this.scheduled = /* @__PURE__ */ new Set();
  }
  add(t) {
    if (!this.scheduled.has(t))
      return this.scheduled.add(t), this.order.push(t), !0;
  }
  remove(t) {
    const n = this.order.indexOf(t);
    n !== -1 && (this.order.splice(n, 1), this.scheduled.delete(t));
  }
  clear() {
    this.order.length = 0, this.scheduled.clear();
  }
}
function UW(e) {
  let t = new Uv(), n = new Uv(), r = 0, o = !1, a = !1;
  const i = /* @__PURE__ */ new WeakSet(), l = {
    /**
     * Schedule a process to run on the next frame.
     */
    schedule: (u, d = !1, f = !1) => {
      const h = f && o, p = h ? t : n;
      return d && i.add(u), p.add(u) && h && o && (r = t.order.length), u;
    },
    /**
     * Cancel the provided callback from running on the next frame.
     */
    cancel: (u) => {
      n.remove(u), i.delete(u);
    },
    /**
     * Execute all schedule callbacks.
     */
    process: (u) => {
      if (o) {
        a = !0;
        return;
      }
      if (o = !0, [t, n] = [n, t], n.clear(), r = t.order.length, r)
        for (let d = 0; d < r; d++) {
          const f = t.order[d];
          f(u), i.has(f) && (l.schedule(f), e());
        }
      o = !1, a && (a = !1, l.process(u));
    }
  };
  return l;
}
const ff = [
  "prepare",
  "read",
  "update",
  "preRender",
  "render",
  "postRender"
], XW = 40;
function YW(e, t) {
  let n = !1, r = !0;
  const o = {
    delta: 0,
    timestamp: 0,
    isProcessing: !1
  }, a = ff.reduce((h, p) => (h[p] = UW(() => n = !0), h), {}), i = (h) => a[h].process(o), l = () => {
    const h = performance.now();
    n = !1, o.delta = r ? 1e3 / 60 : Math.max(Math.min(h - o.timestamp, XW), 1), o.timestamp = h, o.isProcessing = !0, ff.forEach(i), o.isProcessing = !1, n && t && (r = !1, e(l));
  }, u = () => {
    n = !0, r = !0, o.isProcessing || e(l);
  };
  return { schedule: ff.reduce((h, p) => {
    const g = a[p];
    return h[p] = (C, v = !1, y = !1) => (n || u(), g.schedule(C, v, y)), h;
  }, {}), cancel: (h) => ff.forEach((p) => a[p].cancel(h)), state: o, steps: a };
}
const { schedule: Mn, cancel: Ii, state: Rr, steps: ig } = YW(typeof requestAnimationFrame < "u" ? requestAnimationFrame : Zn, !0), qW = {
  useVisualState: AA({
    scrapeMotionValuesFromProps: yA,
    createRenderState: gA,
    onMount: (e, t, { renderState: n, latestValues: r }) => {
      Mn.read(() => {
        try {
          n.dimensions = typeof t.getBBox == "function" ? t.getBBox() : t.getBoundingClientRect();
        } catch {
          n.dimensions = {
            x: 0,
            y: 0,
            width: 0,
            height: 0
          };
        }
      }), Mn.render(() => {
        l4(n, r, { enableHardwareAcceleration: !1 }, u4(t.tagName), e.transformTemplate), bA(t, n);
      });
    }
  })
}, JW = {
  useVisualState: AA({
    scrapeMotionValuesFromProps: c4,
    createRenderState: s4
  })
};
function KW(e, { forwardMotionProps: t = !1 }, n, r) {
  return {
    ...a4(e) ? qW : JW,
    preloadedFeatures: n,
    useRender: $W(t),
    createVisualElement: r,
    Component: e
  };
}
function gi(e, t, n, r = { passive: !0 }) {
  return e.addEventListener(t, n, r), () => e.removeEventListener(t, n);
}
const MA = (e) => e.pointerType === "mouse" ? typeof e.button != "number" || e.button <= 0 : e.isPrimary !== !1;
function Eh(e, t = "page") {
  return {
    point: {
      x: e[t + "X"],
      y: e[t + "Y"]
    }
  };
}
const QW = (e) => (t) => MA(t) && e(t, Eh(t));
function yi(e, t, n, r) {
  return gi(e, t, QW(n), r);
}
const ez = (e, t) => (n) => t(e(n)), Cs = (...e) => e.reduce(ez);
function xA(e) {
  let t = null;
  return () => {
    const n = () => {
      t = null;
    };
    return t === null ? (t = e, n) : !1;
  };
}
const Xv = xA("dragHorizontal"), Yv = xA("dragVertical");
function wA(e) {
  let t = !1;
  if (e === "y")
    t = Yv();
  else if (e === "x")
    t = Xv();
  else {
    const n = Xv(), r = Yv();
    n && r ? t = () => {
      n(), r();
    } : (n && n(), r && r());
  }
  return t;
}
function _A() {
  const e = wA(!0);
  return e ? (e(), !1) : !0;
}
class Ls {
  constructor(t) {
    this.isMounted = !1, this.node = t;
  }
  update() {
  }
}
function qv(e, t) {
  const n = "pointer" + (t ? "enter" : "leave"), r = "onHover" + (t ? "Start" : "End"), o = (a, i) => {
    if (a.pointerType === "touch" || _A())
      return;
    const l = e.getProps();
    e.animationState && l.whileHover && e.animationState.setActive("whileHover", t), l[r] && Mn.update(() => l[r](a, i));
  };
  return yi(e.current, n, o, {
    passive: !e.getProps()[r]
  });
}
class tz extends Ls {
  mount() {
    this.unmount = Cs(qv(this.node, !0), qv(this.node, !1));
  }
  unmount() {
  }
}
class nz extends Ls {
  constructor() {
    super(...arguments), this.isActive = !1;
  }
  onFocus() {
    let t = !1;
    try {
      t = this.node.current.matches(":focus-visible");
    } catch {
      t = !0;
    }
    !t || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !0), this.isActive = !0);
  }
  onBlur() {
    !this.isActive || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !1), this.isActive = !1);
  }
  mount() {
    this.unmount = Cs(gi(this.node.current, "focus", () => this.onFocus()), gi(this.node.current, "blur", () => this.onBlur()));
  }
  unmount() {
  }
}
const IA = (e, t) => t ? e === t ? !0 : IA(e, t.parentElement) : !1;
function sg(e, t) {
  if (!t)
    return;
  const n = new PointerEvent("pointer" + e);
  t(n, Eh(n));
}
class rz extends Ls {
  constructor() {
    super(...arguments), this.removeStartListeners = Zn, this.removeEndListeners = Zn, this.removeAccessibleListeners = Zn, this.startPointerPress = (t, n) => {
      if (this.isPressing)
        return;
      this.removeEndListeners();
      const r = this.node.getProps(), a = yi(window, "pointerup", (l, u) => {
        if (!this.checkPressEnd())
          return;
        const { onTap: d, onTapCancel: f, globalTapTarget: h } = this.node.getProps();
        Mn.update(() => {
          !h && !IA(this.node.current, l.target) ? f && f(l, u) : d && d(l, u);
        });
      }, { passive: !(r.onTap || r.onPointerUp) }), i = yi(window, "pointercancel", (l, u) => this.cancelPress(l, u), { passive: !(r.onTapCancel || r.onPointerCancel) });
      this.removeEndListeners = Cs(a, i), this.startPress(t, n);
    }, this.startAccessiblePress = () => {
      const t = (a) => {
        if (a.key !== "Enter" || this.isPressing)
          return;
        const i = (l) => {
          l.key !== "Enter" || !this.checkPressEnd() || sg("up", (u, d) => {
            const { onTap: f } = this.node.getProps();
            f && Mn.update(() => f(u, d));
          });
        };
        this.removeEndListeners(), this.removeEndListeners = gi(this.node.current, "keyup", i), sg("down", (l, u) => {
          this.startPress(l, u);
        });
      }, n = gi(this.node.current, "keydown", t), r = () => {
        this.isPressing && sg("cancel", (a, i) => this.cancelPress(a, i));
      }, o = gi(this.node.current, "blur", r);
      this.removeAccessibleListeners = Cs(n, o);
    };
  }
  startPress(t, n) {
    this.isPressing = !0;
    const { onTapStart: r, whileTap: o } = this.node.getProps();
    o && this.node.animationState && this.node.animationState.setActive("whileTap", !0), r && Mn.update(() => r(t, n));
  }
  checkPressEnd() {
    return this.removeEndListeners(), this.isPressing = !1, this.node.getProps().whileTap && this.node.animationState && this.node.animationState.setActive("whileTap", !1), !_A();
  }
  cancelPress(t, n) {
    if (!this.checkPressEnd())
      return;
    const { onTapCancel: r } = this.node.getProps();
    r && Mn.update(() => r(t, n));
  }
  mount() {
    const t = this.node.getProps(), n = yi(t.globalTapTarget ? window : this.node.current, "pointerdown", this.startPointerPress, { passive: !(t.onTapStart || t.onPointerStart) }), r = gi(this.node.current, "focus", this.startAccessiblePress);
    this.removeStartListeners = Cs(n, r);
  }
  unmount() {
    this.removeStartListeners(), this.removeEndListeners(), this.removeAccessibleListeners();
  }
}
const I5 = /* @__PURE__ */ new WeakMap(), lg = /* @__PURE__ */ new WeakMap(), oz = (e) => {
  const t = I5.get(e.target);
  t && t(e);
}, az = (e) => {
  e.forEach(oz);
};
function iz({ root: e, ...t }) {
  const n = e || document;
  lg.has(n) || lg.set(n, {});
  const r = lg.get(n), o = JSON.stringify(t);
  return r[o] || (r[o] = new IntersectionObserver(az, { root: e, ...t })), r[o];
}
function sz(e, t, n) {
  const r = iz(t);
  return I5.set(e, n), r.observe(e), () => {
    I5.delete(e), r.unobserve(e);
  };
}
const lz = {
  some: 0,
  all: 1
};
class uz extends Ls {
  constructor() {
    super(...arguments), this.hasEnteredView = !1, this.isInView = !1;
  }
  startObserver() {
    this.unmount();
    const { viewport: t = {} } = this.node.getProps(), { root: n, margin: r, amount: o = "some", once: a } = t, i = {
      root: n ? n.current : void 0,
      rootMargin: r,
      threshold: typeof o == "number" ? o : lz[o]
    }, l = (u) => {
      const { isIntersecting: d } = u;
      if (this.isInView === d || (this.isInView = d, a && !d && this.hasEnteredView))
        return;
      d && (this.hasEnteredView = !0), this.node.animationState && this.node.animationState.setActive("whileInView", d);
      const { onViewportEnter: f, onViewportLeave: h } = this.node.getProps(), p = d ? f : h;
      p && p(u);
    };
    return sz(this.node.current, i, l);
  }
  mount() {
    this.startObserver();
  }
  update() {
    if (typeof IntersectionObserver > "u")
      return;
    const { props: t, prevProps: n } = this.node;
    ["amount", "margin", "root"].some(cz(t, n)) && this.startObserver();
  }
  unmount() {
  }
}
function cz({ viewport: e = {} }, { viewport: t = {} } = {}) {
  return (n) => e[n] !== t[n];
}
const dz = {
  inView: {
    Feature: uz
  },
  tap: {
    Feature: rz
  },
  focus: {
    Feature: nz
  },
  hover: {
    Feature: tz
  }
};
function LA(e, t) {
  if (!Array.isArray(t))
    return !1;
  const n = t.length;
  if (n !== e.length)
    return !1;
  for (let r = 0; r < n; r++)
    if (t[r] !== e[r])
      return !1;
  return !0;
}
function fz(e) {
  const t = {};
  return e.values.forEach((n, r) => t[r] = n.get()), t;
}
function hz(e) {
  const t = {};
  return e.values.forEach((n, r) => t[r] = n.getVelocity()), t;
}
function Th(e, t, n) {
  const r = e.getProps();
  return d4(r, t, n !== void 0 ? n : r.custom, fz(e), hz(e));
}
let Pd = Zn, qo = Zn;
process.env.NODE_ENV !== "production" && (Pd = (e, t) => {
  !e && typeof console < "u" && console.warn(t);
}, qo = (e, t) => {
  if (!e)
    throw new Error(t);
});
const bs = (e) => e * 1e3, Si = (e) => e / 1e3, mz = {
  current: !1
}, RA = (e) => Array.isArray(e) && typeof e[0] == "number";
function DA(e) {
  return !!(!e || typeof e == "string" && PA[e] || RA(e) || Array.isArray(e) && e.every(DA));
}
const P1 = ([e, t, n, r]) => `cubic-bezier(${e}, ${t}, ${n}, ${r})`, PA = {
  linear: "linear",
  ease: "ease",
  easeIn: "ease-in",
  easeOut: "ease-out",
  easeInOut: "ease-in-out",
  circIn: P1([0, 0.65, 0.55, 1]),
  circOut: P1([0.55, 0, 1, 0.45]),
  backIn: P1([0.31, 0.01, 0.66, -0.59]),
  backOut: P1([0.33, 1.53, 0.69, 0.99])
};
function EA(e) {
  if (e)
    return RA(e) ? P1(e) : Array.isArray(e) ? e.map(EA) : PA[e];
}
function pz(e, t, n, { delay: r = 0, duration: o, repeat: a = 0, repeatType: i = "loop", ease: l, times: u } = {}) {
  const d = { [t]: n };
  u && (d.offset = u);
  const f = EA(l);
  return Array.isArray(f) && (d.easing = f), e.animate(d, {
    delay: r,
    duration: o,
    easing: Array.isArray(f) ? "linear" : f,
    fill: "both",
    iterations: a + 1,
    direction: i === "reverse" ? "alternate" : "normal"
  });
}
function gz(e, { repeat: t, repeatType: n = "loop" }) {
  const r = t && n !== "loop" && t % 2 === 1 ? 0 : e.length - 1;
  return e[r];
}
const TA = (e, t, n) => (((1 - 3 * n + 3 * t) * e + (3 * n - 6 * t)) * e + 3 * t) * e, vz = 1e-7, Cz = 12;
function bz(e, t, n, r, o) {
  let a, i, l = 0;
  do
    i = t + (n - t) / 2, a = TA(i, r, o) - e, a > 0 ? n = i : t = i;
  while (Math.abs(a) > vz && ++l < Cz);
  return i;
}
function Ed(e, t, n, r) {
  if (e === t && n === r)
    return Zn;
  const o = (a) => bz(a, 0, 1, e, n);
  return (a) => a === 0 || a === 1 ? a : TA(o(a), t, r);
}
const yz = Ed(0.42, 0, 1, 1), Sz = Ed(0, 0, 0.58, 1), NA = Ed(0.42, 0, 0.58, 1), Az = (e) => Array.isArray(e) && typeof e[0] != "number", kA = (e) => (t) => t <= 0.5 ? e(2 * t) / 2 : (2 - e(2 * (1 - t))) / 2, VA = (e) => (t) => 1 - e(1 - t), f4 = (e) => 1 - Math.sin(Math.acos(e)), OA = VA(f4), Mz = kA(f4), FA = Ed(0.33, 1.53, 0.69, 0.99), h4 = VA(FA), xz = kA(h4), wz = (e) => (e *= 2) < 1 ? 0.5 * h4(e) : 0.5 * (2 - Math.pow(2, -10 * (e - 1))), Jv = {
  linear: Zn,
  easeIn: yz,
  easeInOut: NA,
  easeOut: Sz,
  circIn: f4,
  circInOut: Mz,
  circOut: OA,
  backIn: h4,
  backInOut: xz,
  backOut: FA,
  anticipate: wz
}, Kv = (e) => {
  if (Array.isArray(e)) {
    qo(e.length === 4, "Cubic bezier arrays must contain four numerical values.");
    const [t, n, r, o] = e;
    return Ed(t, n, r, o);
  } else if (typeof e == "string")
    return qo(Jv[e] !== void 0, `Invalid easing type '${e}'`), Jv[e];
  return e;
}, m4 = (e, t) => (n) => !!(Rd(n) && LW.test(n) && n.startsWith(e) || t && Object.prototype.hasOwnProperty.call(n, t)), BA = (e, t, n) => (r) => {
  if (!Rd(r))
    return r;
  const [o, a, i, l] = r.match(Ph);
  return {
    [e]: parseFloat(o),
    [t]: parseFloat(a),
    [n]: parseFloat(i),
    alpha: l !== void 0 ? parseFloat(l) : 1
  };
}, _z = (e) => As(0, 255, e), ug = {
  ...Bl,
  transform: (e) => Math.round(_z(e))
}, ll = {
  test: m4("rgb", "red"),
  parse: BA("red", "green", "blue"),
  transform: ({ red: e, green: t, blue: n, alpha: r = 1 }) => "rgba(" + ug.transform(e) + ", " + ug.transform(t) + ", " + ug.transform(n) + ", " + U1(z1.transform(r)) + ")"
};
function Iz(e) {
  let t = "", n = "", r = "", o = "";
  return e.length > 5 ? (t = e.substring(1, 3), n = e.substring(3, 5), r = e.substring(5, 7), o = e.substring(7, 9)) : (t = e.substring(1, 2), n = e.substring(2, 3), r = e.substring(3, 4), o = e.substring(4, 5), t += t, n += n, r += r, o += o), {
    red: parseInt(t, 16),
    green: parseInt(n, 16),
    blue: parseInt(r, 16),
    alpha: o ? parseInt(o, 16) / 255 : 1
  };
}
const L5 = {
  test: m4("#"),
  parse: Iz,
  transform: ll.transform
}, Bu = {
  test: m4("hsl", "hue"),
  parse: BA("hue", "saturation", "lightness"),
  transform: ({ hue: e, saturation: t, lightness: n, alpha: r = 1 }) => "hsla(" + Math.round(e) + ", " + Ha.transform(U1(t)) + ", " + Ha.transform(U1(n)) + ", " + U1(z1.transform(r)) + ")"
}, Br = {
  test: (e) => ll.test(e) || L5.test(e) || Bu.test(e),
  parse: (e) => ll.test(e) ? ll.parse(e) : Bu.test(e) ? Bu.parse(e) : L5.parse(e),
  transform: (e) => Rd(e) ? e : e.hasOwnProperty("red") ? ll.transform(e) : Bu.transform(e)
}, Fn = (e, t, n) => -n * e + n * t + e;
function cg(e, t, n) {
  return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? e + (t - e) * 6 * n : n < 1 / 2 ? t : n < 2 / 3 ? e + (t - e) * (2 / 3 - n) * 6 : e;
}
function Lz({ hue: e, saturation: t, lightness: n, alpha: r }) {
  e /= 360, t /= 100, n /= 100;
  let o = 0, a = 0, i = 0;
  if (!t)
    o = a = i = n;
  else {
    const l = n < 0.5 ? n * (1 + t) : n + t - n * t, u = 2 * n - l;
    o = cg(u, l, e + 1 / 3), a = cg(u, l, e), i = cg(u, l, e - 1 / 3);
  }
  return {
    red: Math.round(o * 255),
    green: Math.round(a * 255),
    blue: Math.round(i * 255),
    alpha: r
  };
}
const dg = (e, t, n) => {
  const r = e * e;
  return Math.sqrt(Math.max(0, n * (t * t - r) + r));
}, Rz = [L5, ll, Bu], Dz = (e) => Rz.find((t) => t.test(e));
function Qv(e) {
  const t = Dz(e);
  qo(!!t, `'${e}' is not an animatable color. Use the equivalent color code instead.`);
  let n = t.parse(e);
  return t === Bu && (n = Lz(n)), n;
}
const HA = (e, t) => {
  const n = Qv(e), r = Qv(t), o = { ...n };
  return (a) => (o.red = dg(n.red, r.red, a), o.green = dg(n.green, r.green, a), o.blue = dg(n.blue, r.blue, a), o.alpha = Fn(n.alpha, r.alpha, a), ll.transform(o));
};
function Pz(e) {
  var t, n;
  return isNaN(e) && Rd(e) && (((t = e.match(Ph)) === null || t === void 0 ? void 0 : t.length) || 0) + (((n = e.match(fA)) === null || n === void 0 ? void 0 : n.length) || 0) > 0;
}
const GA = {
  regex: _W,
  countKey: "Vars",
  token: "${v}",
  parse: Zn
}, $A = {
  regex: fA,
  countKey: "Colors",
  token: "${c}",
  parse: Br.parse
}, ZA = {
  regex: Ph,
  countKey: "Numbers",
  token: "${n}",
  parse: Bl.parse
};
function fg(e, { regex: t, countKey: n, token: r, parse: o }) {
  const a = e.tokenised.match(t);
  a && (e["num" + n] = a.length, e.tokenised = e.tokenised.replace(t, r), e.values.push(...a.map(o)));
}
function C2(e) {
  const t = e.toString(), n = {
    value: t,
    tokenised: t,
    values: [],
    numVars: 0,
    numColors: 0,
    numNumbers: 0
  };
  return n.value.includes("var(--") && fg(n, GA), fg(n, $A), fg(n, ZA), n;
}
function jA(e) {
  return C2(e).values;
}
function WA(e) {
  const { values: t, numColors: n, numVars: r, tokenised: o } = C2(e), a = t.length;
  return (i) => {
    let l = o;
    for (let u = 0; u < a; u++)
      u < r ? l = l.replace(GA.token, i[u]) : u < r + n ? l = l.replace($A.token, Br.transform(i[u])) : l = l.replace(ZA.token, U1(i[u]));
    return l;
  };
}
const Ez = (e) => typeof e == "number" ? 0 : e;
function Tz(e) {
  const t = jA(e);
  return WA(e)(t.map(Ez));
}
const Ms = {
  test: Pz,
  parse: jA,
  createTransformer: WA,
  getAnimatableNone: Tz
}, zA = (e, t) => (n) => `${n > 0 ? t : e}`;
function UA(e, t) {
  return typeof e == "number" ? (n) => Fn(e, t, n) : Br.test(e) ? HA(e, t) : e.startsWith("var(") ? zA(e, t) : YA(e, t);
}
const XA = (e, t) => {
  const n = [...e], r = n.length, o = e.map((a, i) => UA(a, t[i]));
  return (a) => {
    for (let i = 0; i < r; i++)
      n[i] = o[i](a);
    return n;
  };
}, Nz = (e, t) => {
  const n = { ...e, ...t }, r = {};
  for (const o in n)
    e[o] !== void 0 && t[o] !== void 0 && (r[o] = UA(e[o], t[o]));
  return (o) => {
    for (const a in r)
      n[a] = r[a](o);
    return n;
  };
}, YA = (e, t) => {
  const n = Ms.createTransformer(t), r = C2(e), o = C2(t);
  return r.numVars === o.numVars && r.numColors === o.numColors && r.numNumbers >= o.numNumbers ? Cs(XA(r.values, o.values), n) : (Pd(!0, `Complex values '${e}' and '${t}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`), zA(e, t));
}, dd = (e, t, n) => {
  const r = t - e;
  return r === 0 ? 1 : (n - e) / r;
}, e8 = (e, t) => (n) => Fn(e, t, n);
function kz(e) {
  return typeof e == "number" ? e8 : typeof e == "string" ? Br.test(e) ? HA : YA : Array.isArray(e) ? XA : typeof e == "object" ? Nz : e8;
}
function Vz(e, t, n) {
  const r = [], o = n || kz(e[0]), a = e.length - 1;
  for (let i = 0; i < a; i++) {
    let l = o(e[i], e[i + 1]);
    if (t) {
      const u = Array.isArray(t) ? t[i] || Zn : t;
      l = Cs(u, l);
    }
    r.push(l);
  }
  return r;
}
function qA(e, t, { clamp: n = !0, ease: r, mixer: o } = {}) {
  const a = e.length;
  if (qo(a === t.length, "Both input and output ranges must be the same length"), a === 1)
    return () => t[0];
  e[0] > e[a - 1] && (e = [...e].reverse(), t = [...t].reverse());
  const i = Vz(t, r, o), l = i.length, u = (d) => {
    let f = 0;
    if (l > 1)
      for (; f < e.length - 2 && !(d < e[f + 1]); f++)
        ;
    const h = dd(e[f], e[f + 1], d);
    return i[f](h);
  };
  return n ? (d) => u(As(e[0], e[a - 1], d)) : u;
}
function Oz(e, t) {
  const n = e[e.length - 1];
  for (let r = 1; r <= t; r++) {
    const o = dd(0, t, r);
    e.push(Fn(n, 1, o));
  }
}
function Fz(e) {
  const t = [0];
  return Oz(t, e.length - 1), t;
}
function Bz(e, t) {
  return e.map((n) => n * t);
}
function Hz(e, t) {
  return e.map(() => t || NA).splice(0, e.length - 1);
}
function b2({ duration: e = 300, keyframes: t, times: n, ease: r = "easeInOut" }) {
  const o = Az(r) ? r.map(Kv) : Kv(r), a = {
    done: !1,
    value: t[0]
  }, i = Bz(
    // Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    n && n.length === t.length ? n : Fz(t),
    e
  ), l = qA(i, t, {
    ease: Array.isArray(o) ? o : Hz(t, o)
  });
  return {
    calculatedDuration: e,
    next: (u) => (a.value = l(u), a.done = u >= e, a)
  };
}
function JA(e, t) {
  return t ? e * (1e3 / t) : 0;
}
const Gz = 5;
function KA(e, t, n) {
  const r = Math.max(t - Gz, 0);
  return JA(n - e(r), t - r);
}
const hg = 1e-3, $z = 0.01, t8 = 10, Zz = 0.05, jz = 1;
function Wz({ duration: e = 800, bounce: t = 0.25, velocity: n = 0, mass: r = 1 }) {
  let o, a;
  Pd(e <= bs(t8), "Spring duration must be 10 seconds or less");
  let i = 1 - t;
  i = As(Zz, jz, i), e = As($z, t8, Si(e)), i < 1 ? (o = (d) => {
    const f = d * i, h = f * e, p = f - n, g = R5(d, i), C = Math.exp(-h);
    return hg - p / g * C;
  }, a = (d) => {
    const h = d * i * e, p = h * n + n, g = Math.pow(i, 2) * Math.pow(d, 2) * e, C = Math.exp(-h), v = R5(Math.pow(d, 2), i);
    return (-o(d) + hg > 0 ? -1 : 1) * ((p - g) * C) / v;
  }) : (o = (d) => {
    const f = Math.exp(-d * e), h = (d - n) * e + 1;
    return -hg + f * h;
  }, a = (d) => {
    const f = Math.exp(-d * e), h = (n - d) * (e * e);
    return f * h;
  });
  const l = 5 / e, u = Uz(o, a, l);
  if (e = bs(e), isNaN(u))
    return {
      stiffness: 100,
      damping: 10,
      duration: e
    };
  {
    const d = Math.pow(u, 2) * r;
    return {
      stiffness: d,
      damping: i * 2 * Math.sqrt(r * d),
      duration: e
    };
  }
}
const zz = 12;
function Uz(e, t, n) {
  let r = n;
  for (let o = 1; o < zz; o++)
    r = r - e(r) / t(r);
  return r;
}
function R5(e, t) {
  return e * Math.sqrt(1 - t * t);
}
const Xz = ["duration", "bounce"], Yz = ["stiffness", "damping", "mass"];
function n8(e, t) {
  return t.some((n) => e[n] !== void 0);
}
function qz(e) {
  let t = {
    velocity: 0,
    stiffness: 100,
    damping: 10,
    mass: 1,
    isResolvedFromDuration: !1,
    ...e
  };
  if (!n8(e, Yz) && n8(e, Xz)) {
    const n = Wz(e);
    t = {
      ...t,
      ...n,
      mass: 1
    }, t.isResolvedFromDuration = !0;
  }
  return t;
}
function QA({ keyframes: e, restDelta: t, restSpeed: n, ...r }) {
  const o = e[0], a = e[e.length - 1], i = { done: !1, value: o }, { stiffness: l, damping: u, mass: d, duration: f, velocity: h, isResolvedFromDuration: p } = qz({
    ...r,
    velocity: -Si(r.velocity || 0)
  }), g = h || 0, C = u / (2 * Math.sqrt(l * d)), v = a - o, y = Si(Math.sqrt(l / d)), M = Math.abs(v) < 5;
  n || (n = M ? 0.01 : 2), t || (t = M ? 5e-3 : 0.5);
  let x;
  if (C < 1) {
    const _ = R5(y, C);
    x = (L) => {
      const R = Math.exp(-C * y * L);
      return a - R * ((g + C * y * v) / _ * Math.sin(_ * L) + v * Math.cos(_ * L));
    };
  } else if (C === 1)
    x = (_) => a - Math.exp(-y * _) * (v + (g + y * v) * _);
  else {
    const _ = y * Math.sqrt(C * C - 1);
    x = (L) => {
      const R = Math.exp(-C * y * L), k = Math.min(_ * L, 300);
      return a - R * ((g + C * y * v) * Math.sinh(k) + _ * v * Math.cosh(k)) / _;
    };
  }
  return {
    calculatedDuration: p && f || null,
    next: (_) => {
      const L = x(_);
      if (p)
        i.done = _ >= f;
      else {
        let R = g;
        _ !== 0 && (C < 1 ? R = KA(x, _, L) : R = 0);
        const k = Math.abs(R) <= n, P = Math.abs(a - L) <= t;
        i.done = k && P;
      }
      return i.value = i.done ? a : L, i;
    }
  };
}
function r8({ keyframes: e, velocity: t = 0, power: n = 0.8, timeConstant: r = 325, bounceDamping: o = 10, bounceStiffness: a = 500, modifyTarget: i, min: l, max: u, restDelta: d = 0.5, restSpeed: f }) {
  const h = e[0], p = {
    done: !1,
    value: h
  }, g = (N) => l !== void 0 && N < l || u !== void 0 && N > u, C = (N) => l === void 0 ? u : u === void 0 || Math.abs(l - N) < Math.abs(u - N) ? l : u;
  let v = n * t;
  const y = h + v, M = i === void 0 ? y : i(y);
  M !== y && (v = M - h);
  const x = (N) => -v * Math.exp(-N / r), _ = (N) => M + x(N), L = (N) => {
    const O = x(N), H = _(N);
    p.done = Math.abs(O) <= d, p.value = p.done ? M : H;
  };
  let R, k;
  const P = (N) => {
    g(p.value) && (R = N, k = QA({
      keyframes: [p.value, C(p.value)],
      velocity: KA(_, N, p.value),
      damping: o,
      stiffness: a,
      restDelta: d,
      restSpeed: f
    }));
  };
  return P(0), {
    calculatedDuration: null,
    next: (N) => {
      let O = !1;
      return !k && R === void 0 && (O = !0, L(N), P(N)), R !== void 0 && N > R ? k.next(N - R) : (!O && L(N), p);
    }
  };
}
const Jz = (e) => {
  const t = ({ timestamp: n }) => e(n);
  return {
    start: () => Mn.update(t, !0),
    stop: () => Ii(t),
    /**
     * If we're processing this frame we can use the
     * framelocked timestamp to keep things in sync.
     */
    now: () => Rr.isProcessing ? Rr.timestamp : performance.now()
  };
}, o8 = 2e4;
function a8(e) {
  let t = 0;
  const n = 50;
  let r = e.next(t);
  for (; !r.done && t < o8; )
    t += n, r = e.next(t);
  return t >= o8 ? 1 / 0 : t;
}
const Kz = {
  decay: r8,
  inertia: r8,
  tween: b2,
  keyframes: b2,
  spring: QA
};
function y2({ autoplay: e = !0, delay: t = 0, driver: n = Jz, keyframes: r, type: o = "keyframes", repeat: a = 0, repeatDelay: i = 0, repeatType: l = "loop", onPlay: u, onStop: d, onComplete: f, onUpdate: h, ...p }) {
  let g = 1, C = !1, v, y;
  const M = () => {
    y = new Promise((q) => {
      v = q;
    });
  };
  M();
  let x;
  const _ = Kz[o] || b2;
  let L;
  _ !== b2 && typeof r[0] != "number" && (process.env.NODE_ENV !== "production" && qo(r.length === 2, `Only two keyframes currently supported with spring and inertia animations. Trying to animate ${r}`), L = qA([0, 100], r, {
    clamp: !1
  }), r = [0, 100]);
  const R = _({ ...p, keyframes: r });
  let k;
  l === "mirror" && (k = _({
    ...p,
    keyframes: [...r].reverse(),
    velocity: -(p.velocity || 0)
  }));
  let P = "idle", N = null, O = null, H = null;
  R.calculatedDuration === null && a && (R.calculatedDuration = a8(R));
  const { calculatedDuration: $ } = R;
  let ne = 1 / 0, ie = 1 / 0;
  $ !== null && (ne = $ + i, ie = ne * (a + 1) - i);
  let re = 0;
  const ve = (q) => {
    if (O === null)
      return;
    g > 0 && (O = Math.min(O, q)), g < 0 && (O = Math.min(q - ie / g, O)), N !== null ? re = N : re = Math.round(q - O) * g;
    const ge = re - t * (g >= 0 ? 1 : -1), X = g >= 0 ? ge < 0 : ge > ie;
    re = Math.max(ge, 0), P === "finished" && N === null && (re = ie);
    let he = re, me = R;
    if (a) {
      const Ne = Math.min(re, ie) / ne;
      let ye = Math.floor(Ne), ke = Ne % 1;
      !ke && Ne >= 1 && (ke = 1), ke === 1 && ye--, ye = Math.min(ye, a + 1), !!(ye % 2) && (l === "reverse" ? (ke = 1 - ke, i && (ke -= i / ne)) : l === "mirror" && (me = k)), he = As(0, 1, ke) * ne;
    }
    const de = X ? { done: !1, value: r[0] } : me.next(he);
    L && (de.value = L(de.value));
    let { done: Le } = de;
    !X && $ !== null && (Le = g >= 0 ? re >= ie : re <= 0);
    const Ie = N === null && (P === "finished" || P === "running" && Le);
    return h && h(de.value), Ie && K(), de;
  }, ue = () => {
    x && x.stop(), x = void 0;
  }, j = () => {
    P = "idle", ue(), v(), M(), O = H = null;
  }, K = () => {
    P = "finished", f && f(), ue(), v();
  }, ce = () => {
    if (C)
      return;
    x || (x = n(ve));
    const q = x.now();
    u && u(), N !== null ? O = q - N : (!O || P === "finished") && (O = q), P === "finished" && M(), H = O, N = null, P = "running", x.start();
  };
  e && ce();
  const U = {
    then(q, ge) {
      return y.then(q, ge);
    },
    get time() {
      return Si(re);
    },
    set time(q) {
      q = bs(q), re = q, N !== null || !x || g === 0 ? N = q : O = x.now() - q / g;
    },
    get duration() {
      const q = R.calculatedDuration === null ? a8(R) : R.calculatedDuration;
      return Si(q);
    },
    get speed() {
      return g;
    },
    set speed(q) {
      q === g || !x || (g = q, U.time = Si(re));
    },
    get state() {
      return P;
    },
    play: ce,
    pause: () => {
      P = "paused", N = re;
    },
    stop: () => {
      C = !0, P !== "idle" && (P = "idle", d && d(), j());
    },
    cancel: () => {
      H !== null && ve(H), j();
    },
    complete: () => {
      P = "finished";
    },
    sample: (q) => (O = 0, ve(q))
  };
  return U;
}
function Qz(e) {
  let t;
  return () => (t === void 0 && (t = e()), t);
}
const eU = Qz(() => Object.hasOwnProperty.call(Element.prototype, "animate")), tU = /* @__PURE__ */ new Set([
  "opacity",
  "clipPath",
  "filter",
  "transform",
  "backgroundColor"
]), hf = 10, nU = 2e4, rU = (e, t) => t.type === "spring" || e === "backgroundColor" || !DA(t.ease);
function oU(e, t, { onUpdate: n, onComplete: r, ...o }) {
  if (!(eU() && tU.has(t) && !o.repeatDelay && o.repeatType !== "mirror" && o.damping !== 0 && o.type !== "inertia"))
    return !1;
  let i = !1, l, u, d = !1;
  const f = () => {
    u = new Promise((_) => {
      l = _;
    });
  };
  f();
  let { keyframes: h, duration: p = 300, ease: g, times: C } = o;
  if (rU(t, o)) {
    const _ = y2({
      ...o,
      repeat: 0,
      delay: 0
    });
    let L = { done: !1, value: h[0] };
    const R = [];
    let k = 0;
    for (; !L.done && k < nU; )
      L = _.sample(k), R.push(L.value), k += hf;
    C = void 0, h = R, p = k - hf, g = "linear";
  }
  const v = pz(e.owner.current, t, h, {
    ...o,
    duration: p,
    /**
     * This function is currently not called if ease is provided
     * as a function so the cast is safe.
     *
     * However it would be possible for a future refinement to port
     * in easing pregeneration from Motion One for browsers that
     * support the upcoming `linear()` easing function.
     */
    ease: g,
    times: C
  }), y = () => {
    d = !1, v.cancel();
  }, M = () => {
    d = !0, Mn.update(y), l(), f();
  };
  return v.onfinish = () => {
    d || (e.set(gz(h, o)), r && r(), M());
  }, {
    then(_, L) {
      return u.then(_, L);
    },
    attachTimeline(_) {
      return v.timeline = _, v.onfinish = null, Zn;
    },
    get time() {
      return Si(v.currentTime || 0);
    },
    set time(_) {
      v.currentTime = bs(_);
    },
    get speed() {
      return v.playbackRate;
    },
    set speed(_) {
      v.playbackRate = _;
    },
    get duration() {
      return Si(p);
    },
    play: () => {
      i || (v.play(), Ii(y));
    },
    pause: () => v.pause(),
    stop: () => {
      if (i = !0, v.playState === "idle")
        return;
      const { currentTime: _ } = v;
      if (_) {
        const L = y2({
          ...o,
          autoplay: !1
        });
        e.setWithVelocity(L.sample(_ - hf).value, L.sample(_).value, hf);
      }
      M();
    },
    complete: () => {
      d || v.finish();
    },
    cancel: M
  };
}
function aU({ keyframes: e, delay: t, onUpdate: n, onComplete: r }) {
  const o = () => (n && n(e[e.length - 1]), r && r(), {
    time: 0,
    speed: 1,
    duration: 0,
    play: Zn,
    pause: Zn,
    stop: Zn,
    then: (a) => (a(), Promise.resolve()),
    cancel: Zn,
    complete: Zn
  });
  return t ? y2({
    keyframes: [0, 1],
    duration: 0,
    delay: t,
    onComplete: o
  }) : o();
}
const iU = {
  type: "spring",
  stiffness: 500,
  damping: 25,
  restSpeed: 10
}, sU = (e) => ({
  type: "spring",
  stiffness: 550,
  damping: e === 0 ? 2 * Math.sqrt(550) : 30,
  restSpeed: 10
}), lU = {
  type: "keyframes",
  duration: 0.8
}, uU = {
  type: "keyframes",
  ease: [0.25, 0.1, 0.35, 1],
  duration: 0.3
}, cU = (e, { keyframes: t }) => t.length > 2 ? lU : Fl.has(e) ? e.startsWith("scale") ? sU(t[1]) : iU : uU, D5 = (e, t) => e === "zIndex" ? !1 : !!(typeof t == "number" || Array.isArray(t) || typeof t == "string" && // It's animatable if we have a string
(Ms.test(t) || t === "0") && // And it contains numbers and/or colors
!t.startsWith("url(")), dU = /* @__PURE__ */ new Set(["brightness", "contrast", "saturate", "opacity"]);
function fU(e) {
  const [t, n] = e.slice(0, -1).split("(");
  if (t === "drop-shadow")
    return e;
  const [r] = n.match(Ph) || [];
  if (!r)
    return e;
  const o = n.replace(r, "");
  let a = dU.has(t) ? 1 : 0;
  return r !== n && (a *= 100), t + "(" + a + o + ")";
}
const hU = /([a-z-]*)\(.*?\)/g, P5 = {
  ...Ms,
  getAnimatableNone: (e) => {
    const t = e.match(hU);
    return t ? t.map(fU).join(" ") : e;
  }
}, mU = {
  ...hA,
  // Color props
  color: Br,
  backgroundColor: Br,
  outlineColor: Br,
  fill: Br,
  stroke: Br,
  // Border props
  borderColor: Br,
  borderTopColor: Br,
  borderRightColor: Br,
  borderBottomColor: Br,
  borderLeftColor: Br,
  filter: P5,
  WebkitFilter: P5
}, p4 = (e) => mU[e];
function eM(e, t) {
  let n = p4(e);
  return n !== P5 && (n = Ms), n.getAnimatableNone ? n.getAnimatableNone(t) : void 0;
}
const tM = (e) => /^0[^.\s]+$/.test(e);
function pU(e) {
  if (typeof e == "number")
    return e === 0;
  if (e !== null)
    return e === "none" || e === "0" || tM(e);
}
function gU(e, t, n, r) {
  const o = D5(t, n);
  let a;
  Array.isArray(n) ? a = [...n] : a = [null, n];
  const i = r.from !== void 0 ? r.from : e.get();
  let l;
  const u = [];
  for (let d = 0; d < a.length; d++)
    a[d] === null && (a[d] = d === 0 ? i : a[d - 1]), pU(a[d]) && u.push(d), typeof a[d] == "string" && a[d] !== "none" && a[d] !== "0" && (l = a[d]);
  if (o && u.length && l)
    for (let d = 0; d < u.length; d++) {
      const f = u[d];
      a[f] = eM(t, l);
    }
  return a;
}
function vU({ when: e, delay: t, delayChildren: n, staggerChildren: r, staggerDirection: o, repeat: a, repeatType: i, repeatDelay: l, from: u, elapsed: d, ...f }) {
  return !!Object.keys(f).length;
}
function g4(e, t) {
  return e[t] || e.default || e;
}
const CU = {
  skipAnimations: !1
}, v4 = (e, t, n, r = {}) => (o) => {
  const a = g4(r, e) || {}, i = a.delay || r.delay || 0;
  let { elapsed: l = 0 } = r;
  l = l - bs(i);
  const u = gU(t, e, n, a), d = u[0], f = u[u.length - 1], h = D5(e, d), p = D5(e, f);
  Pd(h === p, `You are trying to animate ${e} from "${d}" to "${f}". ${d} is not an animatable value - to enable this animation set ${d} to a value animatable to ${f} via the \`style\` property.`);
  let g = {
    keyframes: u,
    velocity: t.getVelocity(),
    ease: "easeOut",
    ...a,
    delay: -l,
    onUpdate: (C) => {
      t.set(C), a.onUpdate && a.onUpdate(C);
    },
    onComplete: () => {
      o(), a.onComplete && a.onComplete();
    }
  };
  if (vU(a) || (g = {
    ...g,
    ...cU(e, g)
  }), g.duration && (g.duration = bs(g.duration)), g.repeatDelay && (g.repeatDelay = bs(g.repeatDelay)), !h || !p || mz.current || a.type === !1 || CU.skipAnimations)
    return aU(g);
  if (
    /**
     * If this is a handoff animation, the optimised animation will be running via
     * WAAPI. Therefore, this animation must be JS to ensure it runs "under" the
     * optimised animation.
     */
    !r.isHandoff && t.owner && t.owner.current instanceof HTMLElement && /**
     * If we're outputting values to onUpdate then we can't use WAAPI as there's
     * no way to read the value from WAAPI every frame.
     */
    !t.owner.getProps().onUpdate
  ) {
    const C = oU(t, e, g);
    if (C)
      return C;
  }
  return y2(g);
};
function S2(e) {
  return !!(so(e) && e.add);
}
const nM = (e) => /^\-?\d*\.?\d+$/.test(e);
function C4(e, t) {
  e.indexOf(t) === -1 && e.push(t);
}
function b4(e, t) {
  const n = e.indexOf(t);
  n > -1 && e.splice(n, 1);
}
class y4 {
  constructor() {
    this.subscriptions = [];
  }
  add(t) {
    return C4(this.subscriptions, t), () => b4(this.subscriptions, t);
  }
  notify(t, n, r) {
    const o = this.subscriptions.length;
    if (o)
      if (o === 1)
        this.subscriptions[0](t, n, r);
      else
        for (let a = 0; a < o; a++) {
          const i = this.subscriptions[a];
          i && i(t, n, r);
        }
  }
  getSize() {
    return this.subscriptions.length;
  }
  clear() {
    this.subscriptions.length = 0;
  }
}
const i8 = /* @__PURE__ */ new Set();
function S4(e, t, n) {
  e || i8.has(t) || (console.warn(t), n && console.warn(n), i8.add(t));
}
const bU = (e) => !isNaN(parseFloat(e));
class yU {
  /**
   * @param init - The initiating value
   * @param config - Optional configuration options
   *
   * -  `transformer`: A function to transform incoming values with.
   *
   * @internal
   */
  constructor(t, n = {}) {
    this.version = "10.18.0", this.timeDelta = 0, this.lastUpdated = 0, this.canTrackVelocity = !1, this.events = {}, this.updateAndNotify = (r, o = !0) => {
      this.prev = this.current, this.current = r;
      const { delta: a, timestamp: i } = Rr;
      this.lastUpdated !== i && (this.timeDelta = a, this.lastUpdated = i, Mn.postRender(this.scheduleVelocityCheck)), this.prev !== this.current && this.events.change && this.events.change.notify(this.current), this.events.velocityChange && this.events.velocityChange.notify(this.getVelocity()), o && this.events.renderRequest && this.events.renderRequest.notify(this.current);
    }, this.scheduleVelocityCheck = () => Mn.postRender(this.velocityCheck), this.velocityCheck = ({ timestamp: r }) => {
      r !== this.lastUpdated && (this.prev = this.current, this.events.velocityChange && this.events.velocityChange.notify(this.getVelocity()));
    }, this.hasAnimated = !1, this.prev = this.current = t, this.canTrackVelocity = bU(this.current), this.owner = n.owner;
  }
  /**
   * Adds a function that will be notified when the `MotionValue` is updated.
   *
   * It returns a function that, when called, will cancel the subscription.
   *
   * When calling `onChange` inside a React component, it should be wrapped with the
   * `useEffect` hook. As it returns an unsubscribe function, this should be returned
   * from the `useEffect` function to ensure you don't add duplicate subscribers..
   *
   * ```jsx
   * export const MyComponent = () => {
   *   const x = useMotionValue(0)
   *   const y = useMotionValue(0)
   *   const opacity = useMotionValue(1)
   *
   *   useEffect(() => {
   *     function updateOpacity() {
   *       const maxXY = Math.max(x.get(), y.get())
   *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
   *       opacity.set(newOpacity)
   *     }
   *
   *     const unsubscribeX = x.on("change", updateOpacity)
   *     const unsubscribeY = y.on("change", updateOpacity)
   *
   *     return () => {
   *       unsubscribeX()
   *       unsubscribeY()
   *     }
   *   }, [])
   *
   *   return <motion.div style={{ x }} />
   * }
   * ```
   *
   * @param subscriber - A function that receives the latest value.
   * @returns A function that, when called, will cancel this subscription.
   *
   * @deprecated
   */
  onChange(t) {
    return process.env.NODE_ENV !== "production" && S4(!1, 'value.onChange(callback) is deprecated. Switch to value.on("change", callback).'), this.on("change", t);
  }
  on(t, n) {
    this.events[t] || (this.events[t] = new y4());
    const r = this.events[t].add(n);
    return t === "change" ? () => {
      r(), Mn.read(() => {
        this.events.change.getSize() || this.stop();
      });
    } : r;
  }
  clearListeners() {
    for (const t in this.events)
      this.events[t].clear();
  }
  /**
   * Attaches a passive effect to the `MotionValue`.
   *
   * @internal
   */
  attach(t, n) {
    this.passiveEffect = t, this.stopPassiveEffect = n;
  }
  /**
   * Sets the state of the `MotionValue`.
   *
   * @remarks
   *
   * ```jsx
   * const x = useMotionValue(0)
   * x.set(10)
   * ```
   *
   * @param latest - Latest value to set.
   * @param render - Whether to notify render subscribers. Defaults to `true`
   *
   * @public
   */
  set(t, n = !0) {
    !n || !this.passiveEffect ? this.updateAndNotify(t, n) : this.passiveEffect(t, this.updateAndNotify);
  }
  setWithVelocity(t, n, r) {
    this.set(n), this.prev = t, this.timeDelta = r;
  }
  /**
   * Set the state of the `MotionValue`, stopping any active animations,
   * effects, and resets velocity to `0`.
   */
  jump(t) {
    this.updateAndNotify(t), this.prev = t, this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
  /**
   * Returns the latest state of `MotionValue`
   *
   * @returns - The latest state of `MotionValue`
   *
   * @public
   */
  get() {
    return this.current;
  }
  /**
   * @public
   */
  getPrevious() {
    return this.prev;
  }
  /**
   * Returns the latest velocity of `MotionValue`
   *
   * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
   *
   * @public
   */
  getVelocity() {
    return this.canTrackVelocity ? (
      // These casts could be avoided if parseFloat would be typed better
      JA(parseFloat(this.current) - parseFloat(this.prev), this.timeDelta)
    ) : 0;
  }
  /**
   * Registers a new animation to control this `MotionValue`. Only one
   * animation can drive a `MotionValue` at one time.
   *
   * ```jsx
   * value.start()
   * ```
   *
   * @param animation - A function that starts the provided animation
   *
   * @internal
   */
  start(t) {
    return this.stop(), new Promise((n) => {
      this.hasAnimated = !0, this.animation = t(n), this.events.animationStart && this.events.animationStart.notify();
    }).then(() => {
      this.events.animationComplete && this.events.animationComplete.notify(), this.clearAnimation();
    });
  }
  /**
   * Stop the currently active animation.
   *
   * @public
   */
  stop() {
    this.animation && (this.animation.stop(), this.events.animationCancel && this.events.animationCancel.notify()), this.clearAnimation();
  }
  /**
   * Returns `true` if this value is currently animating.
   *
   * @public
   */
  isAnimating() {
    return !!this.animation;
  }
  clearAnimation() {
    delete this.animation;
  }
  /**
   * Destroy and clean up subscribers to this `MotionValue`.
   *
   * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
   * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
   * created a `MotionValue` via the `motionValue` function.
   *
   * @public
   */
  destroy() {
    this.clearListeners(), this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
}
function Qu(e, t) {
  return new yU(e, t);
}
const rM = (e) => (t) => t.test(e), SU = {
  test: (e) => e === "auto",
  parse: (e) => e
}, oM = [Bl, ft, Ha, is, DW, RW, SU], c1 = (e) => oM.find(rM(e)), AU = [...oM, Br, Ms], MU = (e) => AU.find(rM(e));
function xU(e, t, n) {
  e.hasValue(t) ? e.getValue(t).set(n) : e.addValue(t, Qu(n));
}
function wU(e, t) {
  const n = Th(e, t);
  let { transitionEnd: r = {}, transition: o = {}, ...a } = n ? e.makeTargetAnimatable(n, !1) : {};
  a = { ...a, ...r };
  for (const i in a) {
    const l = jW(a[i]);
    xU(e, i, l);
  }
}
function _U(e, t, n) {
  var r, o;
  const a = Object.keys(t).filter((l) => !e.hasValue(l)), i = a.length;
  if (i)
    for (let l = 0; l < i; l++) {
      const u = a[l], d = t[u];
      let f = null;
      Array.isArray(d) && (f = d[0]), f === null && (f = (o = (r = n[u]) !== null && r !== void 0 ? r : e.readValue(u)) !== null && o !== void 0 ? o : t[u]), f != null && (typeof f == "string" && (nM(f) || tM(f)) ? f = parseFloat(f) : !MU(f) && Ms.test(d) && (f = eM(u, d)), e.addValue(u, Qu(f, { owner: e })), n[u] === void 0 && (n[u] = f), f !== null && e.setBaseTarget(u, f));
    }
}
function IU(e, t) {
  return t ? (t[e] || t.default || t).from : void 0;
}
function LU(e, t, n) {
  const r = {};
  for (const o in e) {
    const a = IU(o, t);
    if (a !== void 0)
      r[o] = a;
    else {
      const i = n.getValue(o);
      i && (r[o] = i.get());
    }
  }
  return r;
}
function RU({ protectedKeys: e, needsAnimating: t }, n) {
  const r = e.hasOwnProperty(n) && t[n] !== !0;
  return t[n] = !1, r;
}
function DU(e, t) {
  const n = e.get();
  if (Array.isArray(t)) {
    for (let r = 0; r < t.length; r++)
      if (t[r] !== n)
        return !0;
  } else
    return n !== t;
}
function aM(e, t, { delay: n = 0, transitionOverride: r, type: o } = {}) {
  let { transition: a = e.getDefaultTransition(), transitionEnd: i, ...l } = e.makeTargetAnimatable(t);
  const u = e.getValue("willChange");
  r && (a = r);
  const d = [], f = o && e.animationState && e.animationState.getState()[o];
  for (const h in l) {
    const p = e.getValue(h), g = l[h];
    if (!p || g === void 0 || f && RU(f, h))
      continue;
    const C = {
      delay: n,
      elapsed: 0,
      ...g4(a || {}, h)
    };
    if (window.HandoffAppearAnimations) {
      const M = e.getProps()[iA];
      if (M) {
        const x = window.HandoffAppearAnimations(M, h, p, Mn);
        x !== null && (C.elapsed = x, C.isHandoff = !0);
      }
    }
    let v = !C.isHandoff && !DU(p, g);
    if (C.type === "spring" && (p.getVelocity() || C.velocity) && (v = !1), p.animation && (v = !1), v)
      continue;
    p.start(v4(h, p, g, e.shouldReduceMotion && Fl.has(h) ? { type: !1 } : C));
    const y = p.animation;
    S2(u) && (u.add(h), y.then(() => u.remove(h))), d.push(y);
  }
  return i && Promise.all(d).then(() => {
    i && wU(e, i);
  }), d;
}
function E5(e, t, n = {}) {
  const r = Th(e, t, n.custom);
  let { transition: o = e.getDefaultTransition() || {} } = r || {};
  n.transitionOverride && (o = n.transitionOverride);
  const a = r ? () => Promise.all(aM(e, r, n)) : () => Promise.resolve(), i = e.variantChildren && e.variantChildren.size ? (u = 0) => {
    const { delayChildren: d = 0, staggerChildren: f, staggerDirection: h } = o;
    return PU(e, t, d + u, f, h, n);
  } : () => Promise.resolve(), { when: l } = o;
  if (l) {
    const [u, d] = l === "beforeChildren" ? [a, i] : [i, a];
    return u().then(() => d());
  } else
    return Promise.all([a(), i(n.delay)]);
}
function PU(e, t, n = 0, r = 0, o = 1, a) {
  const i = [], l = (e.variantChildren.size - 1) * r, u = o === 1 ? (d = 0) => d * r : (d = 0) => l - d * r;
  return Array.from(e.variantChildren).sort(EU).forEach((d, f) => {
    d.notify("AnimationStart", t), i.push(E5(d, t, {
      ...a,
      delay: n + u(f)
    }).then(() => d.notify("AnimationComplete", t)));
  }), Promise.all(i);
}
function EU(e, t) {
  return e.sortNodePosition(t);
}
function TU(e, t, n = {}) {
  e.notify("AnimationStart", t);
  let r;
  if (Array.isArray(t)) {
    const o = t.map((a) => E5(e, a, n));
    r = Promise.all(o);
  } else if (typeof t == "string")
    r = E5(e, t, n);
  else {
    const o = typeof t == "function" ? Th(e, t, n.custom) : t;
    r = Promise.all(aM(e, o, n));
  }
  return r.then(() => e.notify("AnimationComplete", t));
}
const NU = [...n4].reverse(), kU = n4.length;
function VU(e) {
  return (t) => Promise.all(t.map(({ animation: n, options: r }) => TU(e, n, r)));
}
function OU(e) {
  let t = VU(e);
  const n = BU();
  let r = !0;
  const o = (u, d) => {
    const f = Th(e, d);
    if (f) {
      const { transition: h, transitionEnd: p, ...g } = f;
      u = { ...u, ...g, ...p };
    }
    return u;
  };
  function a(u) {
    t = u(e);
  }
  function i(u, d) {
    const f = e.getProps(), h = e.getVariantContext(!0) || {}, p = [], g = /* @__PURE__ */ new Set();
    let C = {}, v = 1 / 0;
    for (let M = 0; M < kU; M++) {
      const x = NU[M], _ = n[x], L = f[x] !== void 0 ? f[x] : h[x], R = ud(L), k = x === d ? _.isActive : null;
      k === !1 && (v = M);
      let P = L === h[x] && L !== f[x] && R;
      if (P && r && e.manuallyAnimateOnMount && (P = !1), _.protectedKeys = { ...C }, // If it isn't active and hasn't *just* been set as inactive
      !_.isActive && k === null || // If we didn't and don't have any defined prop for this animation type
      !L && !_.prevProp || // Or if the prop doesn't define an animation
      Rh(L) || typeof L == "boolean")
        continue;
      let O = FU(_.prevProp, L) || // If we're making this variant active, we want to always make it active
      x === d && _.isActive && !P && R || // If we removed a higher-priority variant (i is in reverse order)
      M > v && R, H = !1;
      const $ = Array.isArray(L) ? L : [L];
      let ne = $.reduce(o, {});
      k === !1 && (ne = {});
      const { prevResolvedValues: ie = {} } = _, re = {
        ...ie,
        ...ne
      }, ve = (ue) => {
        O = !0, g.has(ue) && (H = !0, g.delete(ue)), _.needsAnimating[ue] = !0;
      };
      for (const ue in re) {
        const j = ne[ue], K = ie[ue];
        if (C.hasOwnProperty(ue))
          continue;
        let ce = !1;
        v2(j) && v2(K) ? ce = !LA(j, K) : ce = j !== K, ce ? j !== void 0 ? ve(ue) : g.add(ue) : j !== void 0 && g.has(ue) ? ve(ue) : _.protectedKeys[ue] = !0;
      }
      _.prevProp = L, _.prevResolvedValues = ne, _.isActive && (C = { ...C, ...ne }), r && e.blockInitialAnimation && (O = !1), O && (!P || H) && p.push(...$.map((ue) => ({
        animation: ue,
        options: { type: x, ...u }
      })));
    }
    if (g.size) {
      const M = {};
      g.forEach((x) => {
        const _ = e.getBaseTarget(x);
        _ !== void 0 && (M[x] = _);
      }), p.push({ animation: M });
    }
    let y = !!p.length;
    return r && (f.initial === !1 || f.initial === f.animate) && !e.manuallyAnimateOnMount && (y = !1), r = !1, y ? t(p) : Promise.resolve();
  }
  function l(u, d, f) {
    var h;
    if (n[u].isActive === d)
      return Promise.resolve();
    (h = e.variantChildren) === null || h === void 0 || h.forEach((g) => {
      var C;
      return (C = g.animationState) === null || C === void 0 ? void 0 : C.setActive(u, d);
    }), n[u].isActive = d;
    const p = i(f, u);
    for (const g in n)
      n[g].protectedKeys = {};
    return p;
  }
  return {
    animateChanges: i,
    setActive: l,
    setAnimateFunction: a,
    getState: () => n
  };
}
function FU(e, t) {
  return typeof t == "string" ? t !== e : Array.isArray(t) ? !LA(t, e) : !1;
}
function Js(e = !1) {
  return {
    isActive: e,
    protectedKeys: {},
    needsAnimating: {},
    prevResolvedValues: {}
  };
}
function BU() {
  return {
    animate: Js(!0),
    whileInView: Js(),
    whileHover: Js(),
    whileTap: Js(),
    whileDrag: Js(),
    whileFocus: Js(),
    exit: Js()
  };
}
class HU extends Ls {
  /**
   * We dynamically generate the AnimationState manager as it contains a reference
   * to the underlying animation library. We only want to load that if we load this,
   * so people can optionally code split it out using the `m` component.
   */
  constructor(t) {
    super(t), t.animationState || (t.animationState = OU(t));
  }
  updateAnimationControlsSubscription() {
    const { animate: t } = this.node.getProps();
    this.unmount(), Rh(t) && (this.unmount = t.subscribe(this.node));
  }
  /**
   * Subscribe any provided AnimationControls to the component's VisualElement
   */
  mount() {
    this.updateAnimationControlsSubscription();
  }
  update() {
    const { animate: t } = this.node.getProps(), { animate: n } = this.node.prevProps || {};
    t !== n && this.updateAnimationControlsSubscription();
  }
  unmount() {
  }
}
let GU = 0;
class $U extends Ls {
  constructor() {
    super(...arguments), this.id = GU++;
  }
  update() {
    if (!this.node.presenceContext)
      return;
    const { isPresent: t, onExitComplete: n, custom: r } = this.node.presenceContext, { isPresent: o } = this.node.prevPresenceContext || {};
    if (!this.node.animationState || t === o)
      return;
    const a = this.node.animationState.setActive("exit", !t, { custom: r ?? this.node.getProps().custom });
    n && !t && a.then(() => n(this.id));
  }
  mount() {
    const { register: t } = this.node.presenceContext || {};
    t && (this.unmount = t(this.id));
  }
  unmount() {
  }
}
const ZU = {
  animation: {
    Feature: HU
  },
  exit: {
    Feature: $U
  }
}, s8 = (e, t) => Math.abs(e - t);
function jU(e, t) {
  const n = s8(e.x, t.x), r = s8(e.y, t.y);
  return Math.sqrt(n ** 2 + r ** 2);
}
class iM {
  constructor(t, n, { transformPagePoint: r, contextWindow: o, dragSnapToOrigin: a = !1 } = {}) {
    if (this.startEvent = null, this.lastMoveEvent = null, this.lastMoveEventInfo = null, this.handlers = {}, this.contextWindow = window, this.updatePoint = () => {
      if (!(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      const h = pg(this.lastMoveEventInfo, this.history), p = this.startEvent !== null, g = jU(h.offset, { x: 0, y: 0 }) >= 3;
      if (!p && !g)
        return;
      const { point: C } = h, { timestamp: v } = Rr;
      this.history.push({ ...C, timestamp: v });
      const { onStart: y, onMove: M } = this.handlers;
      p || (y && y(this.lastMoveEvent, h), this.startEvent = this.lastMoveEvent), M && M(this.lastMoveEvent, h);
    }, this.handlePointerMove = (h, p) => {
      this.lastMoveEvent = h, this.lastMoveEventInfo = mg(p, this.transformPagePoint), Mn.update(this.updatePoint, !0);
    }, this.handlePointerUp = (h, p) => {
      this.end();
      const { onEnd: g, onSessionEnd: C, resumeAnimation: v } = this.handlers;
      if (this.dragSnapToOrigin && v && v(), !(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      const y = pg(h.type === "pointercancel" ? this.lastMoveEventInfo : mg(p, this.transformPagePoint), this.history);
      this.startEvent && g && g(h, y), C && C(h, y);
    }, !MA(t))
      return;
    this.dragSnapToOrigin = a, this.handlers = n, this.transformPagePoint = r, this.contextWindow = o || window;
    const i = Eh(t), l = mg(i, this.transformPagePoint), { point: u } = l, { timestamp: d } = Rr;
    this.history = [{ ...u, timestamp: d }];
    const { onSessionStart: f } = n;
    f && f(t, pg(l, this.history)), this.removeListeners = Cs(yi(this.contextWindow, "pointermove", this.handlePointerMove), yi(this.contextWindow, "pointerup", this.handlePointerUp), yi(this.contextWindow, "pointercancel", this.handlePointerUp));
  }
  updateHandlers(t) {
    this.handlers = t;
  }
  end() {
    this.removeListeners && this.removeListeners(), Ii(this.updatePoint);
  }
}
function mg(e, t) {
  return t ? { point: t(e.point) } : e;
}
function l8(e, t) {
  return { x: e.x - t.x, y: e.y - t.y };
}
function pg({ point: e }, t) {
  return {
    point: e,
    delta: l8(e, sM(t)),
    offset: l8(e, WU(t)),
    velocity: zU(t, 0.1)
  };
}
function WU(e) {
  return e[0];
}
function sM(e) {
  return e[e.length - 1];
}
function zU(e, t) {
  if (e.length < 2)
    return { x: 0, y: 0 };
  let n = e.length - 1, r = null;
  const o = sM(e);
  for (; n >= 0 && (r = e[n], !(o.timestamp - r.timestamp > bs(t))); )
    n--;
  if (!r)
    return { x: 0, y: 0 };
  const a = Si(o.timestamp - r.timestamp);
  if (a === 0)
    return { x: 0, y: 0 };
  const i = {
    x: (o.x - r.x) / a,
    y: (o.y - r.y) / a
  };
  return i.x === 1 / 0 && (i.x = 0), i.y === 1 / 0 && (i.y = 0), i;
}
function wo(e) {
  return e.max - e.min;
}
function T5(e, t = 0, n = 0.01) {
  return Math.abs(e - t) <= n;
}
function u8(e, t, n, r = 0.5) {
  e.origin = r, e.originPoint = Fn(t.min, t.max, e.origin), e.scale = wo(n) / wo(t), (T5(e.scale, 1, 1e-4) || isNaN(e.scale)) && (e.scale = 1), e.translate = Fn(n.min, n.max, e.origin) - e.originPoint, (T5(e.translate) || isNaN(e.translate)) && (e.translate = 0);
}
function X1(e, t, n, r) {
  u8(e.x, t.x, n.x, r ? r.originX : void 0), u8(e.y, t.y, n.y, r ? r.originY : void 0);
}
function c8(e, t, n) {
  e.min = n.min + t.min, e.max = e.min + wo(t);
}
function UU(e, t, n) {
  c8(e.x, t.x, n.x), c8(e.y, t.y, n.y);
}
function d8(e, t, n) {
  e.min = t.min - n.min, e.max = e.min + wo(t);
}
function Y1(e, t, n) {
  d8(e.x, t.x, n.x), d8(e.y, t.y, n.y);
}
function XU(e, { min: t, max: n }, r) {
  return t !== void 0 && e < t ? e = r ? Fn(t, e, r.min) : Math.max(e, t) : n !== void 0 && e > n && (e = r ? Fn(n, e, r.max) : Math.min(e, n)), e;
}
function f8(e, t, n) {
  return {
    min: t !== void 0 ? e.min + t : void 0,
    max: n !== void 0 ? e.max + n - (e.max - e.min) : void 0
  };
}
function YU(e, { top: t, left: n, bottom: r, right: o }) {
  return {
    x: f8(e.x, n, o),
    y: f8(e.y, t, r)
  };
}
function h8(e, t) {
  let n = t.min - e.min, r = t.max - e.max;
  return t.max - t.min < e.max - e.min && ([n, r] = [r, n]), { min: n, max: r };
}
function qU(e, t) {
  return {
    x: h8(e.x, t.x),
    y: h8(e.y, t.y)
  };
}
function JU(e, t) {
  let n = 0.5;
  const r = wo(e), o = wo(t);
  return o > r ? n = dd(t.min, t.max - r, e.min) : r > o && (n = dd(e.min, e.max - o, t.min)), As(0, 1, n);
}
function KU(e, t) {
  const n = {};
  return t.min !== void 0 && (n.min = t.min - e.min), t.max !== void 0 && (n.max = t.max - e.min), n;
}
const N5 = 0.35;
function QU(e = N5) {
  return e === !1 ? e = 0 : e === !0 && (e = N5), {
    x: m8(e, "left", "right"),
    y: m8(e, "top", "bottom")
  };
}
function m8(e, t, n) {
  return {
    min: p8(e, t),
    max: p8(e, n)
  };
}
function p8(e, t) {
  return typeof e == "number" ? e : e[t] || 0;
}
const g8 = () => ({
  translate: 0,
  scale: 1,
  origin: 0,
  originPoint: 0
}), Hu = () => ({
  x: g8(),
  y: g8()
}), v8 = () => ({ min: 0, max: 0 }), er = () => ({
  x: v8(),
  y: v8()
});
function $o(e) {
  return [e("x"), e("y")];
}
function lM({ top: e, left: t, right: n, bottom: r }) {
  return {
    x: { min: t, max: n },
    y: { min: e, max: r }
  };
}
function eX({ x: e, y: t }) {
  return { top: t.min, right: e.max, bottom: t.max, left: e.min };
}
function tX(e, t) {
  if (!t)
    return e;
  const n = t({ x: e.left, y: e.top }), r = t({ x: e.right, y: e.bottom });
  return {
    top: n.y,
    left: n.x,
    bottom: r.y,
    right: r.x
  };
}
function gg(e) {
  return e === void 0 || e === 1;
}
function k5({ scale: e, scaleX: t, scaleY: n }) {
  return !gg(e) || !gg(t) || !gg(n);
}
function el(e) {
  return k5(e) || uM(e) || e.z || e.rotate || e.rotateX || e.rotateY;
}
function uM(e) {
  return C8(e.x) || C8(e.y);
}
function C8(e) {
  return e && e !== "0%";
}
function A2(e, t, n) {
  const r = e - n, o = t * r;
  return n + o;
}
function b8(e, t, n, r, o) {
  return o !== void 0 && (e = A2(e, o, r)), A2(e, n, r) + t;
}
function V5(e, t = 0, n = 1, r, o) {
  e.min = b8(e.min, t, n, r, o), e.max = b8(e.max, t, n, r, o);
}
function cM(e, { x: t, y: n }) {
  V5(e.x, t.translate, t.scale, t.originPoint), V5(e.y, n.translate, n.scale, n.originPoint);
}
function nX(e, t, n, r = !1) {
  const o = n.length;
  if (!o)
    return;
  t.x = t.y = 1;
  let a, i;
  for (let l = 0; l < o; l++) {
    a = n[l], i = a.projectionDelta;
    const u = a.instance;
    u && u.style && u.style.display === "contents" || (r && a.options.layoutScroll && a.scroll && a !== a.root && Gu(e, {
      x: -a.scroll.offset.x,
      y: -a.scroll.offset.y
    }), i && (t.x *= i.x.scale, t.y *= i.y.scale, cM(e, i)), r && el(a.latestValues) && Gu(e, a.latestValues));
  }
  t.x = y8(t.x), t.y = y8(t.y);
}
function y8(e) {
  return Number.isInteger(e) || e > 1.0000000000001 || e < 0.999999999999 ? e : 1;
}
function us(e, t) {
  e.min = e.min + t, e.max = e.max + t;
}
function S8(e, t, [n, r, o]) {
  const a = t[o] !== void 0 ? t[o] : 0.5, i = Fn(e.min, e.max, a);
  V5(e, t[n], t[r], i, t.scale);
}
const rX = ["x", "scaleX", "originX"], oX = ["y", "scaleY", "originY"];
function Gu(e, t) {
  S8(e.x, t, rX), S8(e.y, t, oX);
}
function dM(e, t) {
  return lM(tX(e.getBoundingClientRect(), t));
}
function aX(e, t, n) {
  const r = dM(e, n), { scroll: o } = t;
  return o && (us(r.x, o.offset.x), us(r.y, o.offset.y)), r;
}
const fM = ({ current: e }) => e ? e.ownerDocument.defaultView : null, iX = /* @__PURE__ */ new WeakMap();
class sX {
  constructor(t) {
    this.openGlobalLock = null, this.isDragging = !1, this.currentDirection = null, this.originPoint = { x: 0, y: 0 }, this.constraints = !1, this.hasMutatedConstraints = !1, this.elastic = er(), this.visualElement = t;
  }
  start(t, { snapToCursor: n = !1 } = {}) {
    const { presenceContext: r } = this.visualElement;
    if (r && r.isPresent === !1)
      return;
    const o = (f) => {
      const { dragSnapToOrigin: h } = this.getProps();
      h ? this.pauseAnimation() : this.stopAnimation(), n && this.snapToCursor(Eh(f, "page").point);
    }, a = (f, h) => {
      const { drag: p, dragPropagation: g, onDragStart: C } = this.getProps();
      if (p && !g && (this.openGlobalLock && this.openGlobalLock(), this.openGlobalLock = wA(p), !this.openGlobalLock))
        return;
      this.isDragging = !0, this.currentDirection = null, this.resolveConstraints(), this.visualElement.projection && (this.visualElement.projection.isAnimationBlocked = !0, this.visualElement.projection.target = void 0), $o((y) => {
        let M = this.getAxisMotionValue(y).get() || 0;
        if (Ha.test(M)) {
          const { projection: x } = this.visualElement;
          if (x && x.layout) {
            const _ = x.layout.layoutBox[y];
            _ && (M = wo(_) * (parseFloat(M) / 100));
          }
        }
        this.originPoint[y] = M;
      }), C && Mn.update(() => C(f, h), !1, !0);
      const { animationState: v } = this.visualElement;
      v && v.setActive("whileDrag", !0);
    }, i = (f, h) => {
      const { dragPropagation: p, dragDirectionLock: g, onDirectionLock: C, onDrag: v } = this.getProps();
      if (!p && !this.openGlobalLock)
        return;
      const { offset: y } = h;
      if (g && this.currentDirection === null) {
        this.currentDirection = lX(y), this.currentDirection !== null && C && C(this.currentDirection);
        return;
      }
      this.updateAxis("x", h.point, y), this.updateAxis("y", h.point, y), this.visualElement.render(), v && v(f, h);
    }, l = (f, h) => this.stop(f, h), u = () => $o((f) => {
      var h;
      return this.getAnimationState(f) === "paused" && ((h = this.getAxisMotionValue(f).animation) === null || h === void 0 ? void 0 : h.play());
    }), { dragSnapToOrigin: d } = this.getProps();
    this.panSession = new iM(t, {
      onSessionStart: o,
      onStart: a,
      onMove: i,
      onSessionEnd: l,
      resumeAnimation: u
    }, {
      transformPagePoint: this.visualElement.getTransformPagePoint(),
      dragSnapToOrigin: d,
      contextWindow: fM(this.visualElement)
    });
  }
  stop(t, n) {
    const r = this.isDragging;
    if (this.cancel(), !r)
      return;
    const { velocity: o } = n;
    this.startAnimation(o);
    const { onDragEnd: a } = this.getProps();
    a && Mn.update(() => a(t, n));
  }
  cancel() {
    this.isDragging = !1;
    const { projection: t, animationState: n } = this.visualElement;
    t && (t.isAnimationBlocked = !1), this.panSession && this.panSession.end(), this.panSession = void 0;
    const { dragPropagation: r } = this.getProps();
    !r && this.openGlobalLock && (this.openGlobalLock(), this.openGlobalLock = null), n && n.setActive("whileDrag", !1);
  }
  updateAxis(t, n, r) {
    const { drag: o } = this.getProps();
    if (!r || !mf(t, o, this.currentDirection))
      return;
    const a = this.getAxisMotionValue(t);
    let i = this.originPoint[t] + r[t];
    this.constraints && this.constraints[t] && (i = XU(i, this.constraints[t], this.elastic[t])), a.set(i);
  }
  resolveConstraints() {
    var t;
    const { dragConstraints: n, dragElastic: r } = this.getProps(), o = this.visualElement.projection && !this.visualElement.projection.layout ? this.visualElement.projection.measure(!1) : (t = this.visualElement.projection) === null || t === void 0 ? void 0 : t.layout, a = this.constraints;
    n && Fu(n) ? this.constraints || (this.constraints = this.resolveRefConstraints()) : n && o ? this.constraints = YU(o.layoutBox, n) : this.constraints = !1, this.elastic = QU(r), a !== this.constraints && o && this.constraints && !this.hasMutatedConstraints && $o((i) => {
      this.getAxisMotionValue(i) && (this.constraints[i] = KU(o.layoutBox[i], this.constraints[i]));
    });
  }
  resolveRefConstraints() {
    const { dragConstraints: t, onMeasureDragConstraints: n } = this.getProps();
    if (!t || !Fu(t))
      return !1;
    const r = t.current;
    qo(r !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
    const { projection: o } = this.visualElement;
    if (!o || !o.layout)
      return !1;
    const a = aX(r, o.root, this.visualElement.getTransformPagePoint());
    let i = qU(o.layout.layoutBox, a);
    if (n) {
      const l = n(eX(i));
      this.hasMutatedConstraints = !!l, l && (i = lM(l));
    }
    return i;
  }
  startAnimation(t) {
    const { drag: n, dragMomentum: r, dragElastic: o, dragTransition: a, dragSnapToOrigin: i, onDragTransitionEnd: l } = this.getProps(), u = this.constraints || {}, d = $o((f) => {
      if (!mf(f, n, this.currentDirection))
        return;
      let h = u && u[f] || {};
      i && (h = { min: 0, max: 0 });
      const p = o ? 200 : 1e6, g = o ? 40 : 1e7, C = {
        type: "inertia",
        velocity: r ? t[f] : 0,
        bounceStiffness: p,
        bounceDamping: g,
        timeConstant: 750,
        restDelta: 1,
        restSpeed: 10,
        ...a,
        ...h
      };
      return this.startAxisValueAnimation(f, C);
    });
    return Promise.all(d).then(l);
  }
  startAxisValueAnimation(t, n) {
    const r = this.getAxisMotionValue(t);
    return r.start(v4(t, r, 0, n));
  }
  stopAnimation() {
    $o((t) => this.getAxisMotionValue(t).stop());
  }
  pauseAnimation() {
    $o((t) => {
      var n;
      return (n = this.getAxisMotionValue(t).animation) === null || n === void 0 ? void 0 : n.pause();
    });
  }
  getAnimationState(t) {
    var n;
    return (n = this.getAxisMotionValue(t).animation) === null || n === void 0 ? void 0 : n.state;
  }
  /**
   * Drag works differently depending on which props are provided.
   *
   * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
   * - Otherwise, we apply the delta to the x/y motion values.
   */
  getAxisMotionValue(t) {
    const n = "_drag" + t.toUpperCase(), r = this.visualElement.getProps(), o = r[n];
    return o || this.visualElement.getValue(t, (r.initial ? r.initial[t] : void 0) || 0);
  }
  snapToCursor(t) {
    $o((n) => {
      const { drag: r } = this.getProps();
      if (!mf(n, r, this.currentDirection))
        return;
      const { projection: o } = this.visualElement, a = this.getAxisMotionValue(n);
      if (o && o.layout) {
        const { min: i, max: l } = o.layout.layoutBox[n];
        a.set(t[n] - Fn(i, l, 0.5));
      }
    });
  }
  /**
   * When the viewport resizes we want to check if the measured constraints
   * have changed and, if so, reposition the element within those new constraints
   * relative to where it was before the resize.
   */
  scalePositionWithinConstraints() {
    if (!this.visualElement.current)
      return;
    const { drag: t, dragConstraints: n } = this.getProps(), { projection: r } = this.visualElement;
    if (!Fu(n) || !r || !this.constraints)
      return;
    this.stopAnimation();
    const o = { x: 0, y: 0 };
    $o((i) => {
      const l = this.getAxisMotionValue(i);
      if (l) {
        const u = l.get();
        o[i] = JU({ min: u, max: u }, this.constraints[i]);
      }
    });
    const { transformTemplate: a } = this.visualElement.getProps();
    this.visualElement.current.style.transform = a ? a({}, "") : "none", r.root && r.root.updateScroll(), r.updateLayout(), this.resolveConstraints(), $o((i) => {
      if (!mf(i, t, null))
        return;
      const l = this.getAxisMotionValue(i), { min: u, max: d } = this.constraints[i];
      l.set(Fn(u, d, o[i]));
    });
  }
  addListeners() {
    if (!this.visualElement.current)
      return;
    iX.set(this.visualElement, this);
    const t = this.visualElement.current, n = yi(t, "pointerdown", (u) => {
      const { drag: d, dragListener: f = !0 } = this.getProps();
      d && f && this.start(u);
    }), r = () => {
      const { dragConstraints: u } = this.getProps();
      Fu(u) && (this.constraints = this.resolveRefConstraints());
    }, { projection: o } = this.visualElement, a = o.addEventListener("measure", r);
    o && !o.layout && (o.root && o.root.updateScroll(), o.updateLayout()), r();
    const i = gi(window, "resize", () => this.scalePositionWithinConstraints()), l = o.addEventListener("didUpdate", ({ delta: u, hasLayoutChanged: d }) => {
      this.isDragging && d && ($o((f) => {
        const h = this.getAxisMotionValue(f);
        h && (this.originPoint[f] += u[f].translate, h.set(h.get() + u[f].translate));
      }), this.visualElement.render());
    });
    return () => {
      i(), n(), a(), l && l();
    };
  }
  getProps() {
    const t = this.visualElement.getProps(), { drag: n = !1, dragDirectionLock: r = !1, dragPropagation: o = !1, dragConstraints: a = !1, dragElastic: i = N5, dragMomentum: l = !0 } = t;
    return {
      ...t,
      drag: n,
      dragDirectionLock: r,
      dragPropagation: o,
      dragConstraints: a,
      dragElastic: i,
      dragMomentum: l
    };
  }
}
function mf(e, t, n) {
  return (t === !0 || t === e) && (n === null || n === e);
}
function lX(e, t = 10) {
  let n = null;
  return Math.abs(e.y) > t ? n = "y" : Math.abs(e.x) > t && (n = "x"), n;
}
class uX extends Ls {
  constructor(t) {
    super(t), this.removeGroupControls = Zn, this.removeListeners = Zn, this.controls = new sX(t);
  }
  mount() {
    const { dragControls: t } = this.node.getProps();
    t && (this.removeGroupControls = t.subscribe(this.controls)), this.removeListeners = this.controls.addListeners() || Zn;
  }
  unmount() {
    this.removeGroupControls(), this.removeListeners();
  }
}
const A8 = (e) => (t, n) => {
  e && Mn.update(() => e(t, n));
};
class cX extends Ls {
  constructor() {
    super(...arguments), this.removePointerDownListener = Zn;
  }
  onPointerDown(t) {
    this.session = new iM(t, this.createPanHandlers(), {
      transformPagePoint: this.node.getTransformPagePoint(),
      contextWindow: fM(this.node)
    });
  }
  createPanHandlers() {
    const { onPanSessionStart: t, onPanStart: n, onPan: r, onPanEnd: o } = this.node.getProps();
    return {
      onSessionStart: A8(t),
      onStart: A8(n),
      onMove: r,
      onEnd: (a, i) => {
        delete this.session, o && Mn.update(() => o(a, i));
      }
    };
  }
  mount() {
    this.removePointerDownListener = yi(this.node.current, "pointerdown", (t) => this.onPointerDown(t));
  }
  update() {
    this.session && this.session.updateHandlers(this.createPanHandlers());
  }
  unmount() {
    this.removePointerDownListener(), this.session && this.session.end();
  }
}
function hM() {
  const e = Yn(Id);
  if (e === null)
    return [!0, null];
  const { isPresent: t, onExitComplete: n, register: r } = e, o = Lo();
  return st(() => r(o), []), !t && n ? [!1, () => n && n(o)] : [!0];
}
function dX() {
  return fX(Yn(Id));
}
function fX(e) {
  return e === null ? !0 : e.isPresent;
}
const qf = {
  /**
   * Global flag as to whether the tree has animated since the last time
   * we resized the window
   */
  hasAnimatedSinceResize: !0,
  /**
   * We set this to true once, on the first update. Any nodes added to the tree beyond that
   * update will be given a `data-projection-id` attribute.
   */
  hasEverUpdated: !1
};
function M8(e, t) {
  return t.max === t.min ? 0 : e / (t.max - t.min) * 100;
}
const d1 = {
  correct: (e, t) => {
    if (!t.target)
      return e;
    if (typeof e == "string")
      if (ft.test(e))
        e = parseFloat(e);
      else
        return e;
    const n = M8(e, t.target.x), r = M8(e, t.target.y);
    return `${n}% ${r}%`;
  }
}, hX = {
  correct: (e, { treeScale: t, projectionDelta: n }) => {
    const r = e, o = Ms.parse(e);
    if (o.length > 5)
      return r;
    const a = Ms.createTransformer(e), i = typeof o[0] != "number" ? 1 : 0, l = n.x.scale * t.x, u = n.y.scale * t.y;
    o[0 + i] /= l, o[1 + i] /= u;
    const d = Fn(l, u, 0.5);
    return typeof o[2 + i] == "number" && (o[2 + i] /= d), typeof o[3 + i] == "number" && (o[3 + i] /= d), a(o);
  }
};
class mX extends tt.Component {
  /**
   * This only mounts projection nodes for components that
   * need measuring, we might want to do it for all components
   * in order to incorporate transforms
   */
  componentDidMount() {
    const { visualElement: t, layoutGroup: n, switchLayoutGroup: r, layoutId: o } = this.props, { projection: a } = t;
    AW(pX), a && (n.group && n.group.add(a), r && r.register && o && r.register(a), a.root.didUpdate(), a.addEventListener("animationComplete", () => {
      this.safeToRemove();
    }), a.setOptions({
      ...a.options,
      onExitComplete: () => this.safeToRemove()
    })), qf.hasEverUpdated = !0;
  }
  getSnapshotBeforeUpdate(t) {
    const { layoutDependency: n, visualElement: r, drag: o, isPresent: a } = this.props, i = r.projection;
    return i && (i.isPresent = a, o || t.layoutDependency !== n || n === void 0 ? i.willUpdate() : this.safeToRemove(), t.isPresent !== a && (a ? i.promote() : i.relegate() || Mn.postRender(() => {
      const l = i.getStack();
      (!l || !l.members.length) && this.safeToRemove();
    }))), null;
  }
  componentDidUpdate() {
    const { projection: t } = this.props.visualElement;
    t && (t.root.didUpdate(), queueMicrotask(() => {
      !t.currentAnimation && t.isLead() && this.safeToRemove();
    }));
  }
  componentWillUnmount() {
    const { visualElement: t, layoutGroup: n, switchLayoutGroup: r } = this.props, { projection: o } = t;
    o && (o.scheduleCheckAfterUnmount(), n && n.group && n.group.remove(o), r && r.deregister && r.deregister(o));
  }
  safeToRemove() {
    const { safeToRemove: t } = this.props;
    t && t();
  }
  render() {
    return null;
  }
}
function mM(e) {
  const [t, n] = hM(), r = Yn(o4);
  return tt.createElement(mX, { ...e, layoutGroup: r, switchLayoutGroup: Yn(lA), isPresent: t, safeToRemove: n });
}
const pX = {
  borderRadius: {
    ...d1,
    applyTo: [
      "borderTopLeftRadius",
      "borderTopRightRadius",
      "borderBottomLeftRadius",
      "borderBottomRightRadius"
    ]
  },
  borderTopLeftRadius: d1,
  borderTopRightRadius: d1,
  borderBottomLeftRadius: d1,
  borderBottomRightRadius: d1,
  boxShadow: hX
}, pM = ["TopLeft", "TopRight", "BottomLeft", "BottomRight"], gX = pM.length, x8 = (e) => typeof e == "string" ? parseFloat(e) : e, w8 = (e) => typeof e == "number" || ft.test(e);
function vX(e, t, n, r, o, a) {
  o ? (e.opacity = Fn(
    0,
    // TODO Reinstate this if only child
    n.opacity !== void 0 ? n.opacity : 1,
    CX(r)
  ), e.opacityExit = Fn(t.opacity !== void 0 ? t.opacity : 1, 0, bX(r))) : a && (e.opacity = Fn(t.opacity !== void 0 ? t.opacity : 1, n.opacity !== void 0 ? n.opacity : 1, r));
  for (let i = 0; i < gX; i++) {
    const l = `border${pM[i]}Radius`;
    let u = _8(t, l), d = _8(n, l);
    if (u === void 0 && d === void 0)
      continue;
    u || (u = 0), d || (d = 0), u === 0 || d === 0 || w8(u) === w8(d) ? (e[l] = Math.max(Fn(x8(u), x8(d), r), 0), (Ha.test(d) || Ha.test(u)) && (e[l] += "%")) : e[l] = d;
  }
  (t.rotate || n.rotate) && (e.rotate = Fn(t.rotate || 0, n.rotate || 0, r));
}
function _8(e, t) {
  return e[t] !== void 0 ? e[t] : e.borderRadius;
}
const CX = gM(0, 0.5, OA), bX = gM(0.5, 0.95, Zn);
function gM(e, t, n) {
  return (r) => r < e ? 0 : r > t ? 1 : n(dd(e, t, r));
}
function I8(e, t) {
  e.min = t.min, e.max = t.max;
}
function Ho(e, t) {
  I8(e.x, t.x), I8(e.y, t.y);
}
function L8(e, t, n, r, o) {
  return e -= t, e = A2(e, 1 / n, r), o !== void 0 && (e = A2(e, 1 / o, r)), e;
}
function yX(e, t = 0, n = 1, r = 0.5, o, a = e, i = e) {
  if (Ha.test(t) && (t = parseFloat(t), t = Fn(i.min, i.max, t / 100) - i.min), typeof t != "number")
    return;
  let l = Fn(a.min, a.max, r);
  e === a && (l -= t), e.min = L8(e.min, t, n, l, o), e.max = L8(e.max, t, n, l, o);
}
function R8(e, t, [n, r, o], a, i) {
  yX(e, t[n], t[r], t[o], t.scale, a, i);
}
const SX = ["x", "scaleX", "originX"], AX = ["y", "scaleY", "originY"];
function D8(e, t, n, r) {
  R8(e.x, t, SX, n ? n.x : void 0, r ? r.x : void 0), R8(e.y, t, AX, n ? n.y : void 0, r ? r.y : void 0);
}
function P8(e) {
  return e.translate === 0 && e.scale === 1;
}
function vM(e) {
  return P8(e.x) && P8(e.y);
}
function MX(e, t) {
  return e.x.min === t.x.min && e.x.max === t.x.max && e.y.min === t.y.min && e.y.max === t.y.max;
}
function CM(e, t) {
  return Math.round(e.x.min) === Math.round(t.x.min) && Math.round(e.x.max) === Math.round(t.x.max) && Math.round(e.y.min) === Math.round(t.y.min) && Math.round(e.y.max) === Math.round(t.y.max);
}
function E8(e) {
  return wo(e.x) / wo(e.y);
}
class xX {
  constructor() {
    this.members = [];
  }
  add(t) {
    C4(this.members, t), t.scheduleRender();
  }
  remove(t) {
    if (b4(this.members, t), t === this.prevLead && (this.prevLead = void 0), t === this.lead) {
      const n = this.members[this.members.length - 1];
      n && this.promote(n);
    }
  }
  relegate(t) {
    const n = this.members.findIndex((o) => t === o);
    if (n === 0)
      return !1;
    let r;
    for (let o = n; o >= 0; o--) {
      const a = this.members[o];
      if (a.isPresent !== !1) {
        r = a;
        break;
      }
    }
    return r ? (this.promote(r), !0) : !1;
  }
  promote(t, n) {
    const r = this.lead;
    if (t !== r && (this.prevLead = r, this.lead = t, t.show(), r)) {
      r.instance && r.scheduleRender(), t.scheduleRender(), t.resumeFrom = r, n && (t.resumeFrom.preserveOpacity = !0), r.snapshot && (t.snapshot = r.snapshot, t.snapshot.latestValues = r.animationValues || r.latestValues), t.root && t.root.isUpdating && (t.isLayoutDirty = !0);
      const { crossfade: o } = t.options;
      o === !1 && r.hide();
    }
  }
  exitAnimationComplete() {
    this.members.forEach((t) => {
      const { options: n, resumingFrom: r } = t;
      n.onExitComplete && n.onExitComplete(), r && r.options.onExitComplete && r.options.onExitComplete();
    });
  }
  scheduleRender() {
    this.members.forEach((t) => {
      t.instance && t.scheduleRender(!1);
    });
  }
  /**
   * Clear any leads that have been removed this render to prevent them from being
   * used in future animations and to prevent memory leaks
   */
  removeLeadSnapshot() {
    this.lead && this.lead.snapshot && (this.lead.snapshot = void 0);
  }
}
function T8(e, t, n) {
  let r = "";
  const o = e.x.translate / t.x, a = e.y.translate / t.y;
  if ((o || a) && (r = `translate3d(${o}px, ${a}px, 0) `), (t.x !== 1 || t.y !== 1) && (r += `scale(${1 / t.x}, ${1 / t.y}) `), n) {
    const { rotate: u, rotateX: d, rotateY: f } = n;
    u && (r += `rotate(${u}deg) `), d && (r += `rotateX(${d}deg) `), f && (r += `rotateY(${f}deg) `);
  }
  const i = e.x.scale * t.x, l = e.y.scale * t.y;
  return (i !== 1 || l !== 1) && (r += `scale(${i}, ${l})`), r || "none";
}
const wX = (e, t) => e.depth - t.depth;
class _X {
  constructor() {
    this.children = [], this.isDirty = !1;
  }
  add(t) {
    C4(this.children, t), this.isDirty = !0;
  }
  remove(t) {
    b4(this.children, t), this.isDirty = !0;
  }
  forEach(t) {
    this.isDirty && this.children.sort(wX), this.isDirty = !1, this.children.forEach(t);
  }
}
function IX(e, t) {
  const n = performance.now(), r = ({ timestamp: o }) => {
    const a = o - n;
    a >= t && (Ii(r), e(a - t));
  };
  return Mn.read(r, !0), () => Ii(r);
}
function LX(e) {
  window.MotionDebug && window.MotionDebug.record(e);
}
function RX(e) {
  return e instanceof SVGElement && e.tagName !== "svg";
}
function DX(e, t, n) {
  const r = so(e) ? e : Qu(e);
  return r.start(v4("", r, t, n)), r.animation;
}
const N8 = ["", "X", "Y", "Z"], PX = { visibility: "hidden" }, k8 = 1e3;
let EX = 0;
const tl = {
  type: "projectionFrame",
  totalNodes: 0,
  resolvedTargetDeltas: 0,
  recalculatedProjection: 0
};
function bM({ attachResizeListener: e, defaultParent: t, measureScroll: n, checkIsScrollRoot: r, resetTransform: o }) {
  return class {
    constructor(i = {}, l = t == null ? void 0 : t()) {
      this.id = EX++, this.animationId = 0, this.children = /* @__PURE__ */ new Set(), this.options = {}, this.isTreeAnimating = !1, this.isAnimationBlocked = !1, this.isLayoutDirty = !1, this.isProjectionDirty = !1, this.isSharedProjectionDirty = !1, this.isTransformDirty = !1, this.updateManuallyBlocked = !1, this.updateBlockedByResize = !1, this.isUpdating = !1, this.isSVG = !1, this.needsReset = !1, this.shouldResetTransform = !1, this.treeScale = { x: 1, y: 1 }, this.eventHandlers = /* @__PURE__ */ new Map(), this.hasTreeAnimated = !1, this.updateScheduled = !1, this.projectionUpdateScheduled = !1, this.checkUpdateFailed = () => {
        this.isUpdating && (this.isUpdating = !1, this.clearAllSnapshots());
      }, this.updateProjection = () => {
        this.projectionUpdateScheduled = !1, tl.totalNodes = tl.resolvedTargetDeltas = tl.recalculatedProjection = 0, this.nodes.forEach(kX), this.nodes.forEach(HX), this.nodes.forEach(GX), this.nodes.forEach(VX), LX(tl);
      }, this.hasProjected = !1, this.isVisible = !0, this.animationProgress = 0, this.sharedNodes = /* @__PURE__ */ new Map(), this.latestValues = i, this.root = l ? l.root || l : this, this.path = l ? [...l.path, l] : [], this.parent = l, this.depth = l ? l.depth + 1 : 0;
      for (let u = 0; u < this.path.length; u++)
        this.path[u].shouldResetTransform = !0;
      this.root === this && (this.nodes = new _X());
    }
    addEventListener(i, l) {
      return this.eventHandlers.has(i) || this.eventHandlers.set(i, new y4()), this.eventHandlers.get(i).add(l);
    }
    notifyListeners(i, ...l) {
      const u = this.eventHandlers.get(i);
      u && u.notify(...l);
    }
    hasListeners(i) {
      return this.eventHandlers.has(i);
    }
    /**
     * Lifecycles
     */
    mount(i, l = this.root.hasTreeAnimated) {
      if (this.instance)
        return;
      this.isSVG = RX(i), this.instance = i;
      const { layoutId: u, layout: d, visualElement: f } = this.options;
      if (f && !f.current && f.mount(i), this.root.nodes.add(this), this.parent && this.parent.children.add(this), l && (d || u) && (this.isLayoutDirty = !0), e) {
        let h;
        const p = () => this.root.updateBlockedByResize = !1;
        e(i, () => {
          this.root.updateBlockedByResize = !0, h && h(), h = IX(p, 250), qf.hasAnimatedSinceResize && (qf.hasAnimatedSinceResize = !1, this.nodes.forEach(O8));
        });
      }
      u && this.root.registerSharedNode(u, this), this.options.animate !== !1 && f && (u || d) && this.addEventListener("didUpdate", ({ delta: h, hasLayoutChanged: p, hasRelativeTargetChanged: g, layout: C }) => {
        if (this.isTreeAnimationBlocked()) {
          this.target = void 0, this.relativeTarget = void 0;
          return;
        }
        const v = this.options.transition || f.getDefaultTransition() || zX, { onLayoutAnimationStart: y, onLayoutAnimationComplete: M } = f.getProps(), x = !this.targetLayout || !CM(this.targetLayout, C) || g, _ = !p && g;
        if (this.options.layoutRoot || this.resumeFrom && this.resumeFrom.instance || _ || p && (x || !this.currentAnimation)) {
          this.resumeFrom && (this.resumingFrom = this.resumeFrom, this.resumingFrom.resumingFrom = void 0), this.setAnimationOrigin(h, _);
          const L = {
            ...g4(v, "layout"),
            onPlay: y,
            onComplete: M
          };
          (f.shouldReduceMotion || this.options.layoutRoot) && (L.delay = 0, L.type = !1), this.startAnimation(L);
        } else
          p || O8(this), this.isLead() && this.options.onExitComplete && this.options.onExitComplete();
        this.targetLayout = C;
      });
    }
    unmount() {
      this.options.layoutId && this.willUpdate(), this.root.nodes.remove(this);
      const i = this.getStack();
      i && i.remove(this), this.parent && this.parent.children.delete(this), this.instance = void 0, Ii(this.updateProjection);
    }
    // only on the root
    blockUpdate() {
      this.updateManuallyBlocked = !0;
    }
    unblockUpdate() {
      this.updateManuallyBlocked = !1;
    }
    isUpdateBlocked() {
      return this.updateManuallyBlocked || this.updateBlockedByResize;
    }
    isTreeAnimationBlocked() {
      return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || !1;
    }
    // Note: currently only running on root node
    startUpdate() {
      this.isUpdateBlocked() || (this.isUpdating = !0, this.nodes && this.nodes.forEach($X), this.animationId++);
    }
    getTransformTemplate() {
      const { visualElement: i } = this.options;
      return i && i.getProps().transformTemplate;
    }
    willUpdate(i = !0) {
      if (this.root.hasTreeAnimated = !0, this.root.isUpdateBlocked()) {
        this.options.onExitComplete && this.options.onExitComplete();
        return;
      }
      if (!this.root.isUpdating && this.root.startUpdate(), this.isLayoutDirty)
        return;
      this.isLayoutDirty = !0;
      for (let f = 0; f < this.path.length; f++) {
        const h = this.path[f];
        h.shouldResetTransform = !0, h.updateScroll("snapshot"), h.options.layoutRoot && h.willUpdate(!1);
      }
      const { layoutId: l, layout: u } = this.options;
      if (l === void 0 && !u)
        return;
      const d = this.getTransformTemplate();
      this.prevTransformTemplateValue = d ? d(this.latestValues, "") : void 0, this.updateSnapshot(), i && this.notifyListeners("willUpdate");
    }
    update() {
      if (this.updateScheduled = !1, this.isUpdateBlocked()) {
        this.unblockUpdate(), this.clearAllSnapshots(), this.nodes.forEach(V8);
        return;
      }
      this.isUpdating || this.nodes.forEach(FX), this.isUpdating = !1, this.nodes.forEach(BX), this.nodes.forEach(TX), this.nodes.forEach(NX), this.clearAllSnapshots();
      const l = performance.now();
      Rr.delta = As(0, 1e3 / 60, l - Rr.timestamp), Rr.timestamp = l, Rr.isProcessing = !0, ig.update.process(Rr), ig.preRender.process(Rr), ig.render.process(Rr), Rr.isProcessing = !1;
    }
    didUpdate() {
      this.updateScheduled || (this.updateScheduled = !0, queueMicrotask(() => this.update()));
    }
    clearAllSnapshots() {
      this.nodes.forEach(OX), this.sharedNodes.forEach(ZX);
    }
    scheduleUpdateProjection() {
      this.projectionUpdateScheduled || (this.projectionUpdateScheduled = !0, Mn.preRender(this.updateProjection, !1, !0));
    }
    scheduleCheckAfterUnmount() {
      Mn.postRender(() => {
        this.isLayoutDirty ? this.root.didUpdate() : this.root.checkUpdateFailed();
      });
    }
    /**
     * Update measurements
     */
    updateSnapshot() {
      this.snapshot || !this.instance || (this.snapshot = this.measure());
    }
    updateLayout() {
      if (!this.instance || (this.updateScroll(), !(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty))
        return;
      if (this.resumeFrom && !this.resumeFrom.instance)
        for (let u = 0; u < this.path.length; u++)
          this.path[u].updateScroll();
      const i = this.layout;
      this.layout = this.measure(!1), this.layoutCorrected = er(), this.isLayoutDirty = !1, this.projectionDelta = void 0, this.notifyListeners("measure", this.layout.layoutBox);
      const { visualElement: l } = this.options;
      l && l.notify("LayoutMeasure", this.layout.layoutBox, i ? i.layoutBox : void 0);
    }
    updateScroll(i = "measure") {
      let l = !!(this.options.layoutScroll && this.instance);
      this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === i && (l = !1), l && (this.scroll = {
        animationId: this.root.animationId,
        phase: i,
        isRoot: r(this.instance),
        offset: n(this.instance)
      });
    }
    resetTransform() {
      if (!o)
        return;
      const i = this.isLayoutDirty || this.shouldResetTransform, l = this.projectionDelta && !vM(this.projectionDelta), u = this.getTransformTemplate(), d = u ? u(this.latestValues, "") : void 0, f = d !== this.prevTransformTemplateValue;
      i && (l || el(this.latestValues) || f) && (o(this.instance, d), this.shouldResetTransform = !1, this.scheduleRender());
    }
    measure(i = !0) {
      const l = this.measurePageBox();
      let u = this.removeElementScroll(l);
      return i && (u = this.removeTransform(u)), UX(u), {
        animationId: this.root.animationId,
        measuredBox: l,
        layoutBox: u,
        latestValues: {},
        source: this.id
      };
    }
    measurePageBox() {
      const { visualElement: i } = this.options;
      if (!i)
        return er();
      const l = i.measureViewportBox(), { scroll: u } = this.root;
      return u && (us(l.x, u.offset.x), us(l.y, u.offset.y)), l;
    }
    removeElementScroll(i) {
      const l = er();
      Ho(l, i);
      for (let u = 0; u < this.path.length; u++) {
        const d = this.path[u], { scroll: f, options: h } = d;
        if (d !== this.root && f && h.layoutScroll) {
          if (f.isRoot) {
            Ho(l, i);
            const { scroll: p } = this.root;
            p && (us(l.x, -p.offset.x), us(l.y, -p.offset.y));
          }
          us(l.x, f.offset.x), us(l.y, f.offset.y);
        }
      }
      return l;
    }
    applyTransform(i, l = !1) {
      const u = er();
      Ho(u, i);
      for (let d = 0; d < this.path.length; d++) {
        const f = this.path[d];
        !l && f.options.layoutScroll && f.scroll && f !== f.root && Gu(u, {
          x: -f.scroll.offset.x,
          y: -f.scroll.offset.y
        }), el(f.latestValues) && Gu(u, f.latestValues);
      }
      return el(this.latestValues) && Gu(u, this.latestValues), u;
    }
    removeTransform(i) {
      const l = er();
      Ho(l, i);
      for (let u = 0; u < this.path.length; u++) {
        const d = this.path[u];
        if (!d.instance || !el(d.latestValues))
          continue;
        k5(d.latestValues) && d.updateSnapshot();
        const f = er(), h = d.measurePageBox();
        Ho(f, h), D8(l, d.latestValues, d.snapshot ? d.snapshot.layoutBox : void 0, f);
      }
      return el(this.latestValues) && D8(l, this.latestValues), l;
    }
    setTargetDelta(i) {
      this.targetDelta = i, this.root.scheduleUpdateProjection(), this.isProjectionDirty = !0;
    }
    setOptions(i) {
      this.options = {
        ...this.options,
        ...i,
        crossfade: i.crossfade !== void 0 ? i.crossfade : !0
      };
    }
    clearMeasurements() {
      this.scroll = void 0, this.layout = void 0, this.snapshot = void 0, this.prevTransformTemplateValue = void 0, this.targetDelta = void 0, this.target = void 0, this.isLayoutDirty = !1;
    }
    forceRelativeParentToResolveTarget() {
      this.relativeParent && this.relativeParent.resolvedRelativeTargetAt !== Rr.timestamp && this.relativeParent.resolveTargetDelta(!0);
    }
    resolveTargetDelta(i = !1) {
      var l;
      const u = this.getLead();
      this.isProjectionDirty || (this.isProjectionDirty = u.isProjectionDirty), this.isTransformDirty || (this.isTransformDirty = u.isTransformDirty), this.isSharedProjectionDirty || (this.isSharedProjectionDirty = u.isSharedProjectionDirty);
      const d = !!this.resumingFrom || this !== u;
      if (!(i || d && this.isSharedProjectionDirty || this.isProjectionDirty || !((l = this.parent) === null || l === void 0) && l.isProjectionDirty || this.attemptToResolveRelativeTarget))
        return;
      const { layout: h, layoutId: p } = this.options;
      if (!(!this.layout || !(h || p))) {
        if (this.resolvedRelativeTargetAt = Rr.timestamp, !this.targetDelta && !this.relativeTarget) {
          const g = this.getClosestProjectingParent();
          g && g.layout && this.animationProgress !== 1 ? (this.relativeParent = g, this.forceRelativeParentToResolveTarget(), this.relativeTarget = er(), this.relativeTargetOrigin = er(), Y1(this.relativeTargetOrigin, this.layout.layoutBox, g.layout.layoutBox), Ho(this.relativeTarget, this.relativeTargetOrigin)) : this.relativeParent = this.relativeTarget = void 0;
        }
        if (!(!this.relativeTarget && !this.targetDelta)) {
          if (this.target || (this.target = er(), this.targetWithTransforms = er()), this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target ? (this.forceRelativeParentToResolveTarget(), UU(this.target, this.relativeTarget, this.relativeParent.target)) : this.targetDelta ? (this.resumingFrom ? this.target = this.applyTransform(this.layout.layoutBox) : Ho(this.target, this.layout.layoutBox), cM(this.target, this.targetDelta)) : Ho(this.target, this.layout.layoutBox), this.attemptToResolveRelativeTarget) {
            this.attemptToResolveRelativeTarget = !1;
            const g = this.getClosestProjectingParent();
            g && !!g.resumingFrom == !!this.resumingFrom && !g.options.layoutScroll && g.target && this.animationProgress !== 1 ? (this.relativeParent = g, this.forceRelativeParentToResolveTarget(), this.relativeTarget = er(), this.relativeTargetOrigin = er(), Y1(this.relativeTargetOrigin, this.target, g.target), Ho(this.relativeTarget, this.relativeTargetOrigin)) : this.relativeParent = this.relativeTarget = void 0;
          }
          tl.resolvedTargetDeltas++;
        }
      }
    }
    getClosestProjectingParent() {
      if (!(!this.parent || k5(this.parent.latestValues) || uM(this.parent.latestValues)))
        return this.parent.isProjecting() ? this.parent : this.parent.getClosestProjectingParent();
    }
    isProjecting() {
      return !!((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
    }
    calcProjection() {
      var i;
      const l = this.getLead(), u = !!this.resumingFrom || this !== l;
      let d = !0;
      if ((this.isProjectionDirty || !((i = this.parent) === null || i === void 0) && i.isProjectionDirty) && (d = !1), u && (this.isSharedProjectionDirty || this.isTransformDirty) && (d = !1), this.resolvedRelativeTargetAt === Rr.timestamp && (d = !1), d)
        return;
      const { layout: f, layoutId: h } = this.options;
      if (this.isTreeAnimating = !!(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation), this.isTreeAnimating || (this.targetDelta = this.relativeTarget = void 0), !this.layout || !(f || h))
        return;
      Ho(this.layoutCorrected, this.layout.layoutBox);
      const p = this.treeScale.x, g = this.treeScale.y;
      nX(this.layoutCorrected, this.treeScale, this.path, u), l.layout && !l.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1) && (l.target = l.layout.layoutBox);
      const { target: C } = l;
      if (!C) {
        this.projectionTransform && (this.projectionDelta = Hu(), this.projectionTransform = "none", this.scheduleRender());
        return;
      }
      this.projectionDelta || (this.projectionDelta = Hu(), this.projectionDeltaWithTransform = Hu());
      const v = this.projectionTransform;
      X1(this.projectionDelta, this.layoutCorrected, C, this.latestValues), this.projectionTransform = T8(this.projectionDelta, this.treeScale), (this.projectionTransform !== v || this.treeScale.x !== p || this.treeScale.y !== g) && (this.hasProjected = !0, this.scheduleRender(), this.notifyListeners("projectionUpdate", C)), tl.recalculatedProjection++;
    }
    hide() {
      this.isVisible = !1;
    }
    show() {
      this.isVisible = !0;
    }
    scheduleRender(i = !0) {
      if (this.options.scheduleRender && this.options.scheduleRender(), i) {
        const l = this.getStack();
        l && l.scheduleRender();
      }
      this.resumingFrom && !this.resumingFrom.instance && (this.resumingFrom = void 0);
    }
    setAnimationOrigin(i, l = !1) {
      const u = this.snapshot, d = u ? u.latestValues : {}, f = { ...this.latestValues }, h = Hu();
      (!this.relativeParent || !this.relativeParent.options.layoutRoot) && (this.relativeTarget = this.relativeTargetOrigin = void 0), this.attemptToResolveRelativeTarget = !l;
      const p = er(), g = u ? u.source : void 0, C = this.layout ? this.layout.source : void 0, v = g !== C, y = this.getStack(), M = !y || y.members.length <= 1, x = !!(v && !M && this.options.crossfade === !0 && !this.path.some(WX));
      this.animationProgress = 0;
      let _;
      this.mixTargetDelta = (L) => {
        const R = L / 1e3;
        F8(h.x, i.x, R), F8(h.y, i.y, R), this.setTargetDelta(h), this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout && (Y1(p, this.layout.layoutBox, this.relativeParent.layout.layoutBox), jX(this.relativeTarget, this.relativeTargetOrigin, p, R), _ && MX(this.relativeTarget, _) && (this.isProjectionDirty = !1), _ || (_ = er()), Ho(_, this.relativeTarget)), v && (this.animationValues = f, vX(f, d, this.latestValues, R, x, M)), this.root.scheduleUpdateProjection(), this.scheduleRender(), this.animationProgress = R;
      }, this.mixTargetDelta(this.options.layoutRoot ? 1e3 : 0);
    }
    startAnimation(i) {
      this.notifyListeners("animationStart"), this.currentAnimation && this.currentAnimation.stop(), this.resumingFrom && this.resumingFrom.currentAnimation && this.resumingFrom.currentAnimation.stop(), this.pendingAnimation && (Ii(this.pendingAnimation), this.pendingAnimation = void 0), this.pendingAnimation = Mn.update(() => {
        qf.hasAnimatedSinceResize = !0, this.currentAnimation = DX(0, k8, {
          ...i,
          onUpdate: (l) => {
            this.mixTargetDelta(l), i.onUpdate && i.onUpdate(l);
          },
          onComplete: () => {
            i.onComplete && i.onComplete(), this.completeAnimation();
          }
        }), this.resumingFrom && (this.resumingFrom.currentAnimation = this.currentAnimation), this.pendingAnimation = void 0;
      });
    }
    completeAnimation() {
      this.resumingFrom && (this.resumingFrom.currentAnimation = void 0, this.resumingFrom.preserveOpacity = void 0);
      const i = this.getStack();
      i && i.exitAnimationComplete(), this.resumingFrom = this.currentAnimation = this.animationValues = void 0, this.notifyListeners("animationComplete");
    }
    finishAnimation() {
      this.currentAnimation && (this.mixTargetDelta && this.mixTargetDelta(k8), this.currentAnimation.stop()), this.completeAnimation();
    }
    applyTransformsToTarget() {
      const i = this.getLead();
      let { targetWithTransforms: l, target: u, layout: d, latestValues: f } = i;
      if (!(!l || !u || !d)) {
        if (this !== i && this.layout && d && yM(this.options.animationType, this.layout.layoutBox, d.layoutBox)) {
          u = this.target || er();
          const h = wo(this.layout.layoutBox.x);
          u.x.min = i.target.x.min, u.x.max = u.x.min + h;
          const p = wo(this.layout.layoutBox.y);
          u.y.min = i.target.y.min, u.y.max = u.y.min + p;
        }
        Ho(l, u), Gu(l, f), X1(this.projectionDeltaWithTransform, this.layoutCorrected, l, f);
      }
    }
    registerSharedNode(i, l) {
      this.sharedNodes.has(i) || this.sharedNodes.set(i, new xX()), this.sharedNodes.get(i).add(l);
      const d = l.options.initialPromotionConfig;
      l.promote({
        transition: d ? d.transition : void 0,
        preserveFollowOpacity: d && d.shouldPreserveFollowOpacity ? d.shouldPreserveFollowOpacity(l) : void 0
      });
    }
    isLead() {
      const i = this.getStack();
      return i ? i.lead === this : !0;
    }
    getLead() {
      var i;
      const { layoutId: l } = this.options;
      return l ? ((i = this.getStack()) === null || i === void 0 ? void 0 : i.lead) || this : this;
    }
    getPrevLead() {
      var i;
      const { layoutId: l } = this.options;
      return l ? (i = this.getStack()) === null || i === void 0 ? void 0 : i.prevLead : void 0;
    }
    getStack() {
      const { layoutId: i } = this.options;
      if (i)
        return this.root.sharedNodes.get(i);
    }
    promote({ needsReset: i, transition: l, preserveFollowOpacity: u } = {}) {
      const d = this.getStack();
      d && d.promote(this, u), i && (this.projectionDelta = void 0, this.needsReset = !0), l && this.setOptions({ transition: l });
    }
    relegate() {
      const i = this.getStack();
      return i ? i.relegate(this) : !1;
    }
    resetRotation() {
      const { visualElement: i } = this.options;
      if (!i)
        return;
      let l = !1;
      const { latestValues: u } = i;
      if ((u.rotate || u.rotateX || u.rotateY || u.rotateZ) && (l = !0), !l)
        return;
      const d = {};
      for (let f = 0; f < N8.length; f++) {
        const h = "rotate" + N8[f];
        u[h] && (d[h] = u[h], i.setStaticValue(h, 0));
      }
      i.render();
      for (const f in d)
        i.setStaticValue(f, d[f]);
      i.scheduleRender();
    }
    getProjectionStyles(i) {
      var l, u;
      if (!this.instance || this.isSVG)
        return;
      if (!this.isVisible)
        return PX;
      const d = {
        visibility: ""
      }, f = this.getTransformTemplate();
      if (this.needsReset)
        return this.needsReset = !1, d.opacity = "", d.pointerEvents = Yf(i == null ? void 0 : i.pointerEvents) || "", d.transform = f ? f(this.latestValues, "") : "none", d;
      const h = this.getLead();
      if (!this.projectionDelta || !this.layout || !h.target) {
        const v = {};
        return this.options.layoutId && (v.opacity = this.latestValues.opacity !== void 0 ? this.latestValues.opacity : 1, v.pointerEvents = Yf(i == null ? void 0 : i.pointerEvents) || ""), this.hasProjected && !el(this.latestValues) && (v.transform = f ? f({}, "") : "none", this.hasProjected = !1), v;
      }
      const p = h.animationValues || h.latestValues;
      this.applyTransformsToTarget(), d.transform = T8(this.projectionDeltaWithTransform, this.treeScale, p), f && (d.transform = f(p, d.transform));
      const { x: g, y: C } = this.projectionDelta;
      d.transformOrigin = `${g.origin * 100}% ${C.origin * 100}% 0`, h.animationValues ? d.opacity = h === this ? (u = (l = p.opacity) !== null && l !== void 0 ? l : this.latestValues.opacity) !== null && u !== void 0 ? u : 1 : this.preserveOpacity ? this.latestValues.opacity : p.opacityExit : d.opacity = h === this ? p.opacity !== void 0 ? p.opacity : "" : p.opacityExit !== void 0 ? p.opacityExit : 0;
      for (const v in p2) {
        if (p[v] === void 0)
          continue;
        const { correct: y, applyTo: M } = p2[v], x = d.transform === "none" ? p[v] : y(p[v], h);
        if (M) {
          const _ = M.length;
          for (let L = 0; L < _; L++)
            d[M[L]] = x;
        } else
          d[v] = x;
      }
      return this.options.layoutId && (d.pointerEvents = h === this ? Yf(i == null ? void 0 : i.pointerEvents) || "" : "none"), d;
    }
    clearSnapshot() {
      this.resumeFrom = this.snapshot = void 0;
    }
    // Only run on root
    resetTree() {
      this.root.nodes.forEach((i) => {
        var l;
        return (l = i.currentAnimation) === null || l === void 0 ? void 0 : l.stop();
      }), this.root.nodes.forEach(V8), this.root.sharedNodes.clear();
    }
  };
}
function TX(e) {
  e.updateLayout();
}
function NX(e) {
  var t;
  const n = ((t = e.resumeFrom) === null || t === void 0 ? void 0 : t.snapshot) || e.snapshot;
  if (e.isLead() && e.layout && n && e.hasListeners("didUpdate")) {
    const { layoutBox: r, measuredBox: o } = e.layout, { animationType: a } = e.options, i = n.source !== e.layout.source;
    a === "size" ? $o((h) => {
      const p = i ? n.measuredBox[h] : n.layoutBox[h], g = wo(p);
      p.min = r[h].min, p.max = p.min + g;
    }) : yM(a, n.layoutBox, r) && $o((h) => {
      const p = i ? n.measuredBox[h] : n.layoutBox[h], g = wo(r[h]);
      p.max = p.min + g, e.relativeTarget && !e.currentAnimation && (e.isProjectionDirty = !0, e.relativeTarget[h].max = e.relativeTarget[h].min + g);
    });
    const l = Hu();
    X1(l, r, n.layoutBox);
    const u = Hu();
    i ? X1(u, e.applyTransform(o, !0), n.measuredBox) : X1(u, r, n.layoutBox);
    const d = !vM(l);
    let f = !1;
    if (!e.resumeFrom) {
      const h = e.getClosestProjectingParent();
      if (h && !h.resumeFrom) {
        const { snapshot: p, layout: g } = h;
        if (p && g) {
          const C = er();
          Y1(C, n.layoutBox, p.layoutBox);
          const v = er();
          Y1(v, r, g.layoutBox), CM(C, v) || (f = !0), h.options.layoutRoot && (e.relativeTarget = v, e.relativeTargetOrigin = C, e.relativeParent = h);
        }
      }
    }
    e.notifyListeners("didUpdate", {
      layout: r,
      snapshot: n,
      delta: u,
      layoutDelta: l,
      hasLayoutChanged: d,
      hasRelativeTargetChanged: f
    });
  } else if (e.isLead()) {
    const { onExitComplete: r } = e.options;
    r && r();
  }
  e.options.transition = void 0;
}
function kX(e) {
  tl.totalNodes++, e.parent && (e.isProjecting() || (e.isProjectionDirty = e.parent.isProjectionDirty), e.isSharedProjectionDirty || (e.isSharedProjectionDirty = !!(e.isProjectionDirty || e.parent.isProjectionDirty || e.parent.isSharedProjectionDirty)), e.isTransformDirty || (e.isTransformDirty = e.parent.isTransformDirty));
}
function VX(e) {
  e.isProjectionDirty = e.isSharedProjectionDirty = e.isTransformDirty = !1;
}
function OX(e) {
  e.clearSnapshot();
}
function V8(e) {
  e.clearMeasurements();
}
function FX(e) {
  e.isLayoutDirty = !1;
}
function BX(e) {
  const { visualElement: t } = e.options;
  t && t.getProps().onBeforeLayoutMeasure && t.notify("BeforeLayoutMeasure"), e.resetTransform();
}
function O8(e) {
  e.finishAnimation(), e.targetDelta = e.relativeTarget = e.target = void 0, e.isProjectionDirty = !0;
}
function HX(e) {
  e.resolveTargetDelta();
}
function GX(e) {
  e.calcProjection();
}
function $X(e) {
  e.resetRotation();
}
function ZX(e) {
  e.removeLeadSnapshot();
}
function F8(e, t, n) {
  e.translate = Fn(t.translate, 0, n), e.scale = Fn(t.scale, 1, n), e.origin = t.origin, e.originPoint = t.originPoint;
}
function B8(e, t, n, r) {
  e.min = Fn(t.min, n.min, r), e.max = Fn(t.max, n.max, r);
}
function jX(e, t, n, r) {
  B8(e.x, t.x, n.x, r), B8(e.y, t.y, n.y, r);
}
function WX(e) {
  return e.animationValues && e.animationValues.opacityExit !== void 0;
}
const zX = {
  duration: 0.45,
  ease: [0.4, 0, 0.1, 1]
}, H8 = (e) => typeof navigator < "u" && navigator.userAgent.toLowerCase().includes(e), G8 = H8("applewebkit/") && !H8("chrome/") ? Math.round : Zn;
function $8(e) {
  e.min = G8(e.min), e.max = G8(e.max);
}
function UX(e) {
  $8(e.x), $8(e.y);
}
function yM(e, t, n) {
  return e === "position" || e === "preserve-aspect" && !T5(E8(t), E8(n), 0.2);
}
const XX = bM({
  attachResizeListener: (e, t) => gi(e, "resize", t),
  measureScroll: () => ({
    x: document.documentElement.scrollLeft || document.body.scrollLeft,
    y: document.documentElement.scrollTop || document.body.scrollTop
  }),
  checkIsScrollRoot: () => !0
}), vg = {
  current: void 0
}, SM = bM({
  measureScroll: (e) => ({
    x: e.scrollLeft,
    y: e.scrollTop
  }),
  defaultParent: () => {
    if (!vg.current) {
      const e = new XX({});
      e.mount(window), e.setOptions({ layoutScroll: !0 }), vg.current = e;
    }
    return vg.current;
  },
  resetTransform: (e, t) => {
    e.style.transform = t !== void 0 ? t : "none";
  },
  checkIsScrollRoot: (e) => window.getComputedStyle(e).position === "fixed"
}), YX = {
  pan: {
    Feature: cX
  },
  drag: {
    Feature: uX,
    ProjectionNode: SM,
    MeasureLayout: mM
  }
}, qX = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;
function JX(e) {
  const t = qX.exec(e);
  if (!t)
    return [,];
  const [, n, r] = t;
  return [n, r];
}
const KX = 4;
function O5(e, t, n = 1) {
  qo(n <= KX, `Max CSS variable fallback depth detected in property "${e}". This may indicate a circular fallback dependency.`);
  const [r, o] = JX(e);
  if (!r)
    return;
  const a = window.getComputedStyle(t).getPropertyValue(r);
  if (a) {
    const i = a.trim();
    return nM(i) ? parseFloat(i) : i;
  } else
    return _5(o) ? O5(o, t, n + 1) : o;
}
function QX(e, { ...t }, n) {
  const r = e.current;
  if (!(r instanceof Element))
    return { target: t, transitionEnd: n };
  n && (n = { ...n }), e.values.forEach((o) => {
    const a = o.get();
    if (!_5(a))
      return;
    const i = O5(a, r);
    i && o.set(i);
  });
  for (const o in t) {
    const a = t[o];
    if (!_5(a))
      continue;
    const i = O5(a, r);
    i && (t[o] = i, n || (n = {}), n[o] === void 0 && (n[o] = a));
  }
  return { target: t, transitionEnd: n };
}
const eY = /* @__PURE__ */ new Set([
  "width",
  "height",
  "top",
  "left",
  "right",
  "bottom",
  "x",
  "y",
  "translateX",
  "translateY"
]), AM = (e) => eY.has(e), tY = (e) => Object.keys(e).some(AM), pf = (e) => e === Bl || e === ft, Z8 = (e, t) => parseFloat(e.split(", ")[t]), j8 = (e, t) => (n, { transform: r }) => {
  if (r === "none" || !r)
    return 0;
  const o = r.match(/^matrix3d\((.+)\)$/);
  if (o)
    return Z8(o[1], t);
  {
    const a = r.match(/^matrix\((.+)\)$/);
    return a ? Z8(a[1], e) : 0;
  }
}, nY = /* @__PURE__ */ new Set(["x", "y", "z"]), rY = Ld.filter((e) => !nY.has(e));
function oY(e) {
  const t = [];
  return rY.forEach((n) => {
    const r = e.getValue(n);
    r !== void 0 && (t.push([n, r.get()]), r.set(n.startsWith("scale") ? 1 : 0));
  }), t.length && e.render(), t;
}
const ec = {
  // Dimensions
  width: ({ x: e }, { paddingLeft: t = "0", paddingRight: n = "0" }) => e.max - e.min - parseFloat(t) - parseFloat(n),
  height: ({ y: e }, { paddingTop: t = "0", paddingBottom: n = "0" }) => e.max - e.min - parseFloat(t) - parseFloat(n),
  top: (e, { top: t }) => parseFloat(t),
  left: (e, { left: t }) => parseFloat(t),
  bottom: ({ y: e }, { top: t }) => parseFloat(t) + (e.max - e.min),
  right: ({ x: e }, { left: t }) => parseFloat(t) + (e.max - e.min),
  // Transform
  x: j8(4, 13),
  y: j8(5, 14)
};
ec.translateX = ec.x;
ec.translateY = ec.y;
const aY = (e, t, n) => {
  const r = t.measureViewportBox(), o = t.current, a = getComputedStyle(o), { display: i } = a, l = {};
  i === "none" && t.setStaticValue("display", e.display || "block"), n.forEach((d) => {
    l[d] = ec[d](r, a);
  }), t.render();
  const u = t.measureViewportBox();
  return n.forEach((d) => {
    const f = t.getValue(d);
    f && f.jump(l[d]), e[d] = ec[d](u, a);
  }), e;
}, iY = (e, t, n = {}, r = {}) => {
  t = { ...t }, r = { ...r };
  const o = Object.keys(t).filter(AM);
  let a = [], i = !1;
  const l = [];
  if (o.forEach((u) => {
    const d = e.getValue(u);
    if (!e.hasValue(u))
      return;
    let f = n[u], h = c1(f);
    const p = t[u];
    let g;
    if (v2(p)) {
      const C = p.length, v = p[0] === null ? 1 : 0;
      f = p[v], h = c1(f);
      for (let y = v; y < C && p[y] !== null; y++)
        g ? qo(c1(p[y]) === g, "All keyframes must be of the same type") : (g = c1(p[y]), qo(g === h || pf(h) && pf(g), "Keyframes must be of the same dimension as the current value"));
    } else
      g = c1(p);
    if (h !== g)
      if (pf(h) && pf(g)) {
        const C = d.get();
        typeof C == "string" && d.set(parseFloat(C)), typeof p == "string" ? t[u] = parseFloat(p) : Array.isArray(p) && g === ft && (t[u] = p.map(parseFloat));
      } else
        h != null && h.transform && (g != null && g.transform) && (f === 0 || p === 0) ? f === 0 ? d.set(g.transform(f)) : t[u] = h.transform(p) : (i || (a = oY(e), i = !0), l.push(u), r[u] = r[u] !== void 0 ? r[u] : t[u], d.jump(p));
  }), l.length) {
    const u = l.indexOf("height") >= 0 ? window.pageYOffset : null, d = aY(t, e, l);
    return a.length && a.forEach(([f, h]) => {
      e.getValue(f).set(h);
    }), e.render(), Lh && u !== null && window.scrollTo({ top: u }), { target: d, transitionEnd: r };
  } else
    return { target: t, transitionEnd: r };
};
function sY(e, t, n, r) {
  return tY(t) ? iY(e, t, n, r) : { target: t, transitionEnd: r };
}
const lY = (e, t, n, r) => {
  const o = QX(e, t, r);
  return t = o.target, r = o.transitionEnd, sY(e, t, n, r);
}, F5 = { current: null }, MM = { current: !1 };
function uY() {
  if (MM.current = !0, !!Lh)
    if (window.matchMedia) {
      const e = window.matchMedia("(prefers-reduced-motion)"), t = () => F5.current = e.matches;
      e.addListener(t), t();
    } else
      F5.current = !1;
}
function cY(e, t, n) {
  const { willChange: r } = t;
  for (const o in t) {
    const a = t[o], i = n[o];
    if (so(a))
      e.addValue(o, a), S2(r) && r.add(o), process.env.NODE_ENV === "development" && S4(a.version === "10.18.0", `Attempting to mix Framer Motion versions ${a.version} with 10.18.0 may not work as expected.`);
    else if (so(i))
      e.addValue(o, Qu(a, { owner: e })), S2(r) && r.remove(o);
    else if (i !== a)
      if (e.hasValue(o)) {
        const l = e.getValue(o);
        !l.hasAnimated && l.set(a);
      } else {
        const l = e.getStaticValue(o);
        e.addValue(o, Qu(l !== void 0 ? l : a, { owner: e }));
      }
  }
  for (const o in n)
    t[o] === void 0 && e.removeValue(o);
  return t;
}
const W8 = /* @__PURE__ */ new WeakMap(), xM = Object.keys(cd), dY = xM.length, z8 = [
  "AnimationStart",
  "AnimationComplete",
  "Update",
  "BeforeLayoutMeasure",
  "LayoutMeasure",
  "LayoutAnimationStart",
  "LayoutAnimationComplete"
], fY = r4.length;
class hY {
  constructor({ parent: t, props: n, presenceContext: r, reducedMotionConfig: o, visualState: a }, i = {}) {
    this.current = null, this.children = /* @__PURE__ */ new Set(), this.isVariantNode = !1, this.isControllingVariants = !1, this.shouldReduceMotion = null, this.values = /* @__PURE__ */ new Map(), this.features = {}, this.valueSubscriptions = /* @__PURE__ */ new Map(), this.prevMotionValues = {}, this.events = {}, this.propEventSubscriptions = {}, this.notifyUpdate = () => this.notify("Update", this.latestValues), this.render = () => {
      this.current && (this.triggerBuild(), this.renderInstance(this.current, this.renderState, this.props.style, this.projection));
    }, this.scheduleRender = () => Mn.render(this.render, !1, !0);
    const { latestValues: l, renderState: u } = a;
    this.latestValues = l, this.baseTarget = { ...l }, this.initialValues = n.initial ? { ...l } : {}, this.renderState = u, this.parent = t, this.props = n, this.presenceContext = r, this.depth = t ? t.depth + 1 : 0, this.reducedMotionConfig = o, this.options = i, this.isControllingVariants = Dh(n), this.isVariantNode = sA(n), this.isVariantNode && (this.variantChildren = /* @__PURE__ */ new Set()), this.manuallyAnimateOnMount = !!(t && t.current);
    const { willChange: d, ...f } = this.scrapeMotionValuesFromProps(n, {});
    for (const h in f) {
      const p = f[h];
      l[h] !== void 0 && so(p) && (p.set(l[h], !1), S2(d) && d.add(h));
    }
  }
  /**
   * This method takes React props and returns found MotionValues. For example, HTML
   * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
   *
   * This isn't an abstract method as it needs calling in the constructor, but it is
   * intended to be one.
   */
  scrapeMotionValuesFromProps(t, n) {
    return {};
  }
  mount(t) {
    this.current = t, W8.set(t, this), this.projection && !this.projection.instance && this.projection.mount(t), this.parent && this.isVariantNode && !this.isControllingVariants && (this.removeFromVariantTree = this.parent.addVariantChild(this)), this.values.forEach((n, r) => this.bindToMotionValue(r, n)), MM.current || uY(), this.shouldReduceMotion = this.reducedMotionConfig === "never" ? !1 : this.reducedMotionConfig === "always" ? !0 : F5.current, process.env.NODE_ENV !== "production" && S4(this.shouldReduceMotion !== !0, "You have Reduced Motion enabled on your device. Animations may not appear as expected."), this.parent && this.parent.children.add(this), this.update(this.props, this.presenceContext);
  }
  unmount() {
    W8.delete(this.current), this.projection && this.projection.unmount(), Ii(this.notifyUpdate), Ii(this.render), this.valueSubscriptions.forEach((t) => t()), this.removeFromVariantTree && this.removeFromVariantTree(), this.parent && this.parent.children.delete(this);
    for (const t in this.events)
      this.events[t].clear();
    for (const t in this.features)
      this.features[t].unmount();
    this.current = null;
  }
  bindToMotionValue(t, n) {
    const r = Fl.has(t), o = n.on("change", (i) => {
      this.latestValues[t] = i, this.props.onUpdate && Mn.update(this.notifyUpdate, !1, !0), r && this.projection && (this.projection.isTransformDirty = !0);
    }), a = n.on("renderRequest", this.scheduleRender);
    this.valueSubscriptions.set(t, () => {
      o(), a();
    });
  }
  sortNodePosition(t) {
    return !this.current || !this.sortInstanceNodePosition || this.type !== t.type ? 0 : this.sortInstanceNodePosition(this.current, t.current);
  }
  loadFeatures({ children: t, ...n }, r, o, a) {
    let i, l;
    if (process.env.NODE_ENV !== "production" && o && r) {
      const u = "You have rendered a `motion` component within a `LazyMotion` component. This will break tree shaking. Import and render a `m` component instead.";
      n.ignoreStrict ? Pd(!1, u) : qo(!1, u);
    }
    for (let u = 0; u < dY; u++) {
      const d = xM[u], { isEnabled: f, Feature: h, ProjectionNode: p, MeasureLayout: g } = cd[d];
      p && (i = p), f(n) && (!this.features[d] && h && (this.features[d] = new h(this)), g && (l = g));
    }
    if ((this.type === "html" || this.type === "svg") && !this.projection && i) {
      this.projection = new i(this.latestValues, this.parent && this.parent.projection);
      const { layoutId: u, layout: d, drag: f, dragConstraints: h, layoutScroll: p, layoutRoot: g } = n;
      this.projection.setOptions({
        layoutId: u,
        layout: d,
        alwaysMeasureLayout: !!f || h && Fu(h),
        visualElement: this,
        scheduleRender: () => this.scheduleRender(),
        /**
         * TODO: Update options in an effect. This could be tricky as it'll be too late
         * to update by the time layout animations run.
         * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
         * ensuring it gets called if there's no potential layout animations.
         *
         */
        animationType: typeof d == "string" ? d : "both",
        initialPromotionConfig: a,
        layoutScroll: p,
        layoutRoot: g
      });
    }
    return l;
  }
  updateFeatures() {
    for (const t in this.features) {
      const n = this.features[t];
      n.isMounted ? n.update() : (n.mount(), n.isMounted = !0);
    }
  }
  triggerBuild() {
    this.build(this.renderState, this.latestValues, this.options, this.props);
  }
  /**
   * Measure the current viewport box with or without transforms.
   * Only measures axis-aligned boxes, rotate and skew must be manually
   * removed with a re-render to work.
   */
  measureViewportBox() {
    return this.current ? this.measureInstanceViewportBox(this.current, this.props) : er();
  }
  getStaticValue(t) {
    return this.latestValues[t];
  }
  setStaticValue(t, n) {
    this.latestValues[t] = n;
  }
  /**
   * Make a target animatable by Popmotion. For instance, if we're
   * trying to animate width from 100px to 100vw we need to measure 100vw
   * in pixels to determine what we really need to animate to. This is also
   * pluggable to support Framer's custom value types like Color,
   * and CSS variables.
   */
  makeTargetAnimatable(t, n = !0) {
    return this.makeTargetAnimatableFromInstance(t, this.props, n);
  }
  /**
   * Update the provided props. Ensure any newly-added motion values are
   * added to our map, old ones removed, and listeners updated.
   */
  update(t, n) {
    (t.transformTemplate || this.props.transformTemplate) && this.scheduleRender(), this.prevProps = this.props, this.props = t, this.prevPresenceContext = this.presenceContext, this.presenceContext = n;
    for (let r = 0; r < z8.length; r++) {
      const o = z8[r];
      this.propEventSubscriptions[o] && (this.propEventSubscriptions[o](), delete this.propEventSubscriptions[o]);
      const a = t["on" + o];
      a && (this.propEventSubscriptions[o] = this.on(o, a));
    }
    this.prevMotionValues = cY(this, this.scrapeMotionValuesFromProps(t, this.prevProps), this.prevMotionValues), this.handleChildMotionValue && this.handleChildMotionValue();
  }
  getProps() {
    return this.props;
  }
  /**
   * Returns the variant definition with a given name.
   */
  getVariant(t) {
    return this.props.variants ? this.props.variants[t] : void 0;
  }
  /**
   * Returns the defined default transition on this component.
   */
  getDefaultTransition() {
    return this.props.transition;
  }
  getTransformPagePoint() {
    return this.props.transformPagePoint;
  }
  getClosestVariantNode() {
    return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : void 0;
  }
  getVariantContext(t = !1) {
    if (t)
      return this.parent ? this.parent.getVariantContext() : void 0;
    if (!this.isControllingVariants) {
      const r = this.parent ? this.parent.getVariantContext() || {} : {};
      return this.props.initial !== void 0 && (r.initial = this.props.initial), r;
    }
    const n = {};
    for (let r = 0; r < fY; r++) {
      const o = r4[r], a = this.props[o];
      (ud(a) || a === !1) && (n[o] = a);
    }
    return n;
  }
  /**
   * Add a child visual element to our set of children.
   */
  addVariantChild(t) {
    const n = this.getClosestVariantNode();
    if (n)
      return n.variantChildren && n.variantChildren.add(t), () => n.variantChildren.delete(t);
  }
  /**
   * Add a motion value and bind it to this visual element.
   */
  addValue(t, n) {
    n !== this.values.get(t) && (this.removeValue(t), this.bindToMotionValue(t, n)), this.values.set(t, n), this.latestValues[t] = n.get();
  }
  /**
   * Remove a motion value and unbind any active subscriptions.
   */
  removeValue(t) {
    this.values.delete(t);
    const n = this.valueSubscriptions.get(t);
    n && (n(), this.valueSubscriptions.delete(t)), delete this.latestValues[t], this.removeValueFromRenderState(t, this.renderState);
  }
  /**
   * Check whether we have a motion value for this key
   */
  hasValue(t) {
    return this.values.has(t);
  }
  getValue(t, n) {
    if (this.props.values && this.props.values[t])
      return this.props.values[t];
    let r = this.values.get(t);
    return r === void 0 && n !== void 0 && (r = Qu(n, { owner: this }), this.addValue(t, r)), r;
  }
  /**
   * If we're trying to animate to a previously unencountered value,
   * we need to check for it in our state and as a last resort read it
   * directly from the instance (which might have performance implications).
   */
  readValue(t) {
    var n;
    return this.latestValues[t] !== void 0 || !this.current ? this.latestValues[t] : (n = this.getBaseTargetFromProps(this.props, t)) !== null && n !== void 0 ? n : this.readValueFromInstance(this.current, t, this.options);
  }
  /**
   * Set the base target to later animate back to. This is currently
   * only hydrated on creation and when we first read a value.
   */
  setBaseTarget(t, n) {
    this.baseTarget[t] = n;
  }
  /**
   * Find the base target for a value thats been removed from all animation
   * props.
   */
  getBaseTarget(t) {
    var n;
    const { initial: r } = this.props, o = typeof r == "string" || typeof r == "object" ? (n = d4(this.props, r)) === null || n === void 0 ? void 0 : n[t] : void 0;
    if (r && o !== void 0)
      return o;
    const a = this.getBaseTargetFromProps(this.props, t);
    return a !== void 0 && !so(a) ? a : this.initialValues[t] !== void 0 && o === void 0 ? void 0 : this.baseTarget[t];
  }
  on(t, n) {
    return this.events[t] || (this.events[t] = new y4()), this.events[t].add(n);
  }
  notify(t, ...n) {
    this.events[t] && this.events[t].notify(...n);
  }
}
class wM extends hY {
  sortInstanceNodePosition(t, n) {
    return t.compareDocumentPosition(n) & 2 ? 1 : -1;
  }
  getBaseTargetFromProps(t, n) {
    return t.style ? t.style[n] : void 0;
  }
  removeValueFromRenderState(t, { vars: n, style: r }) {
    delete n[t], delete r[t];
  }
  makeTargetAnimatableFromInstance({ transition: t, transitionEnd: n, ...r }, { transformValues: o }, a) {
    let i = LU(r, t || {}, this);
    if (o && (n && (n = o(n)), r && (r = o(r)), i && (i = o(i))), a) {
      _U(this, r, i);
      const l = lY(this, r, i, n);
      n = l.transitionEnd, r = l.target;
    }
    return {
      transition: t,
      transitionEnd: n,
      ...r
    };
  }
}
function mY(e) {
  return window.getComputedStyle(e);
}
class pY extends wM {
  constructor() {
    super(...arguments), this.type = "html";
  }
  readValueFromInstance(t, n) {
    if (Fl.has(n)) {
      const r = p4(n);
      return r && r.default || 0;
    } else {
      const r = mY(t), o = (dA(n) ? r.getPropertyValue(n) : r[n]) || 0;
      return typeof o == "string" ? o.trim() : o;
    }
  }
  measureInstanceViewportBox(t, { transformPagePoint: n }) {
    return dM(t, n);
  }
  build(t, n, r, o) {
    i4(t, n, r, o.transformTemplate);
  }
  scrapeMotionValuesFromProps(t, n) {
    return c4(t, n);
  }
  handleChildMotionValue() {
    this.childSubscription && (this.childSubscription(), delete this.childSubscription);
    const { children: t } = this.props;
    so(t) && (this.childSubscription = t.on("change", (n) => {
      this.current && (this.current.textContent = `${n}`);
    }));
  }
  renderInstance(t, n, r, o) {
    vA(t, n, r, o);
  }
}
class gY extends wM {
  constructor() {
    super(...arguments), this.type = "svg", this.isSVGTag = !1;
  }
  getBaseTargetFromProps(t, n) {
    return t[n];
  }
  readValueFromInstance(t, n) {
    if (Fl.has(n)) {
      const r = p4(n);
      return r && r.default || 0;
    }
    return n = CA.has(n) ? n : t4(n), t.getAttribute(n);
  }
  measureInstanceViewportBox() {
    return er();
  }
  scrapeMotionValuesFromProps(t, n) {
    return yA(t, n);
  }
  build(t, n, r, o) {
    l4(t, n, r, this.isSVGTag, o.transformTemplate);
  }
  renderInstance(t, n, r, o) {
    bA(t, n, r, o);
  }
  mount(t) {
    this.isSVGTag = u4(t.tagName), super.mount(t);
  }
}
const vY = (e, t) => a4(e) ? new gY(t, { enableHardwareAcceleration: !1 }) : new pY(t, { enableHardwareAcceleration: !0 }), CY = {
  layout: {
    ProjectionNode: SM,
    MeasureLayout: mM
  }
}, bY = {
  ...ZU,
  ...dz,
  ...YX,
  ...CY
}, xa = /* @__PURE__ */ yW((e, t) => KW(e, t, bY, vY));
function _M() {
  const e = Ve(!1);
  return e4(() => (e.current = !0, () => {
    e.current = !1;
  }), []), e;
}
function yY() {
  const e = _M(), [t, n] = He(0), r = Q(() => {
    e.current && n(t + 1);
  }, [t]);
  return [Q(() => Mn.postRender(r), [r]), t];
}
class SY extends Ee.Component {
  getSnapshotBeforeUpdate(t) {
    const n = this.props.childRef.current;
    if (n && t.isPresent && !this.props.isPresent) {
      const r = this.props.sizeRef.current;
      r.height = n.offsetHeight || 0, r.width = n.offsetWidth || 0, r.top = n.offsetTop, r.left = n.offsetLeft;
    }
    return null;
  }
  /**
   * Required with getSnapshotBeforeUpdate to stop React complaining.
   */
  componentDidUpdate() {
  }
  render() {
    return this.props.children;
  }
}
function AY({ children: e, isPresent: t }) {
  const n = Lo(), r = Ve(null), o = Ve({
    width: 0,
    height: 0,
    top: 0,
    left: 0
  });
  return lS(() => {
    const { width: a, height: i, top: l, left: u } = o.current;
    if (t || !r.current || !a || !i)
      return;
    r.current.dataset.motionPopId = n;
    const d = document.createElement("style");
    return document.head.appendChild(d), d.sheet && d.sheet.insertRule(`
          [data-motion-pop-id="${n}"] {
            position: absolute !important;
            width: ${a}px !important;
            height: ${i}px !important;
            top: ${l}px !important;
            left: ${u}px !important;
          }
        `), () => {
      document.head.removeChild(d);
    };
  }, [t]), Ee.createElement(SY, { isPresent: t, childRef: r, sizeRef: o }, Ee.cloneElement(e, { ref: r }));
}
const Cg = ({ children: e, initial: t, isPresent: n, onExitComplete: r, custom: o, presenceAffectsLayout: a, mode: i }) => {
  const l = SA(MY), u = Lo(), d = bt(
    () => ({
      id: u,
      initial: t,
      isPresent: n,
      custom: o,
      onExitComplete: (f) => {
        l.set(f, !0);
        for (const h of l.values())
          if (!h)
            return;
        r && r();
      },
      register: (f) => (l.set(f, !1), () => l.delete(f))
    }),
    /**
     * If the presence of a child affects the layout of the components around it,
     * we want to make a new context value to ensure they get re-rendered
     * so they can detect that layout change.
     */
    a ? void 0 : [n]
  );
  return bt(() => {
    l.forEach((f, h) => l.set(h, !1));
  }, [n]), Ee.useEffect(() => {
    !n && !l.size && r && r();
  }, [n]), i === "popLayout" && (e = Ee.createElement(AY, { isPresent: n }, e)), Ee.createElement(Id.Provider, { value: d }, e);
};
function MY() {
  return /* @__PURE__ */ new Map();
}
function xY(e) {
  return st(() => () => e(), []);
}
const nl = (e) => e.key || "";
function wY(e, t) {
  e.forEach((n) => {
    const r = nl(n);
    t.set(r, n);
  });
}
function _Y(e) {
  const t = [];
  return Ad.forEach(e, (n) => {
    Ol(n) && t.push(n);
  }), t;
}
const Rs = ({ children: e, custom: t, initial: n = !0, onExitComplete: r, exitBeforeEnter: o, presenceAffectsLayout: a = !0, mode: i = "sync" }) => {
  qo(!o, "Replace exitBeforeEnter with mode='wait'");
  const l = Yn(o4).forceRender || yY()[0], u = _M(), d = _Y(e);
  let f = d;
  const h = Ve(/* @__PURE__ */ new Map()).current, p = Ve(f), g = Ve(/* @__PURE__ */ new Map()).current, C = Ve(!0);
  if (e4(() => {
    C.current = !1, wY(d, g), p.current = f;
  }), xY(() => {
    C.current = !0, g.clear(), h.clear();
  }), C.current)
    return Ee.createElement(Ee.Fragment, null, f.map((x) => Ee.createElement(Cg, { key: nl(x), isPresent: !0, initial: n ? void 0 : !1, presenceAffectsLayout: a, mode: i }, x)));
  f = [...f];
  const v = p.current.map(nl), y = d.map(nl), M = v.length;
  for (let x = 0; x < M; x++) {
    const _ = v[x];
    y.indexOf(_) === -1 && !h.has(_) && h.set(_, void 0);
  }
  return i === "wait" && h.size && (f = []), h.forEach((x, _) => {
    if (y.indexOf(_) !== -1)
      return;
    const L = g.get(_);
    if (!L)
      return;
    const R = v.indexOf(_);
    let k = x;
    if (!k) {
      const P = () => {
        h.delete(_);
        const N = Array.from(g.keys()).filter((O) => !y.includes(O));
        if (N.forEach((O) => g.delete(O)), p.current = d.filter((O) => {
          const H = nl(O);
          return (
            // filter out the node exiting
            H === _ || // filter out the leftover children
            N.includes(H)
          );
        }), !h.size) {
          if (u.current === !1)
            return;
          l(), r && r();
        }
      };
      k = Ee.createElement(Cg, { key: nl(L), isPresent: !1, onExitComplete: P, custom: t, presenceAffectsLayout: a, mode: i }, L), h.set(_, k);
    }
    f.splice(R, 0, k);
  }), f = f.map((x) => {
    const _ = x.key;
    return h.has(_) ? x : Ee.createElement(Cg, { key: nl(x), isPresent: !0, presenceAffectsLayout: a, mode: i }, x);
  }), process.env.NODE_ENV !== "production" && i === "wait" && f.length > 1 && console.warn(`You're attempting to animate multiple children within AnimatePresence, but its mode is set to "wait". This will lead to odd visual behaviour.`), Ee.createElement(Ee.Fragment, null, h.size ? f : f.map((x) => Yo(x)));
}, IY = (e, t) => e.find((n) => n.id === t);
function U8(e, t) {
  const n = IM(e, t), r = n ? e[n].findIndex((o) => o.id === t) : -1;
  return {
    position: n,
    index: r
  };
}
function IM(e, t) {
  for (const [n, r] of Object.entries(e))
    if (IY(r, t))
      return n;
}
function LY(e) {
  const t = e.includes("right"), n = e.includes("left");
  let r = "center";
  return t && (r = "flex-end"), n && (r = "flex-start"), {
    display: "flex",
    flexDirection: "column",
    alignItems: r
  };
}
function RY(e) {
  const n = e === "top" || e === "bottom" ? "0 auto" : void 0, r = e.includes("top") ? "env(safe-area-inset-top, 0px)" : void 0, o = e.includes("bottom") ? "env(safe-area-inset-bottom, 0px)" : void 0, a = e.includes("left") ? void 0 : "env(safe-area-inset-right, 0px)", i = e.includes("right") ? void 0 : "env(safe-area-inset-left, 0px)";
  return {
    position: "fixed",
    zIndex: "var(--toast-z-index, 5500)",
    pointerEvents: "none",
    display: "flex",
    flexDirection: "column",
    margin: n,
    top: r,
    bottom: o,
    right: a,
    left: i
  };
}
const DY = /* @__PURE__ */ new Set([
  ...dF,
  "textStyle",
  "layerStyle",
  "apply",
  "noOfLines",
  "focusBorderColor",
  "errorBorderColor",
  "as",
  "__css",
  "css",
  "sx"
]), PY = /* @__PURE__ */ new Set([
  "htmlWidth",
  "htmlHeight",
  "htmlSize",
  "htmlTranslate"
]);
function EY(e) {
  return (PY.has(e) || !DY.has(e)) && e[0] !== "_";
}
const TY = iO(FV), NY = ({ baseStyle: e }) => (t) => {
  const { theme: n, css: r, __css: o, sx: a, ...i } = t, [l] = fO(i, hF), u = Wo(e, t), d = UV(
    {},
    o,
    u,
    Z3(l),
    a
  ), f = kS(d)(t.theme);
  return r ? [f, r] : f;
};
function bg(e, t) {
  const { baseStyle: n, ...r } = t ?? {};
  r.shouldForwardProp || (r.shouldForwardProp = EY);
  const o = NY({ baseStyle: n }), a = TY(
    e,
    r
  )(o);
  return Ke(
    function(u, d) {
      const { children: f, ...h } = u, { colorMode: p, forced: g } = Q3();
      return uS(
        a,
        { ref: d, "data-theme": g ? p : void 0, ...h },
        f
      );
    }
  );
}
function kY() {
  const e = /* @__PURE__ */ new Map();
  return new Proxy(bg, {
    /**
     * @example
     * const Div = chakra("div")
     * const WithChakra = chakra(AnotherComponent)
     */
    apply(t, n, r) {
      return bg(...r);
    },
    /**
     * @example
     * <chakra.div />
     */
    get(t, n) {
      return e.has(n) || e.set(n, bg(n)), e.get(n);
    }
  });
}
const xe = kY(), VY = {
  initial: (e) => {
    const { position: t } = e, n = ["top", "bottom"].includes(t) ? "y" : "x";
    let r = ["top-right", "bottom-right"].includes(t) ? 1 : -1;
    return t === "bottom" && (r = 1), {
      opacity: 0,
      [n]: r * 24
    };
  },
  animate: {
    opacity: 1,
    y: 0,
    x: 0,
    scale: 1,
    transition: {
      duration: 0.4,
      ease: [0.4, 0, 0.2, 1]
    }
  },
  exit: {
    opacity: 0,
    scale: 0.85,
    transition: {
      duration: 0.2,
      ease: [0.4, 0, 1, 1]
    }
  }
}, LM = PV((e) => {
  const {
    id: t,
    message: n,
    onCloseComplete: r,
    onRequestRemove: o,
    requestClose: a = !1,
    position: i = "bottom",
    duration: l = 5e3,
    containerStyle: u,
    motionVariants: d = VY,
    toastSpacing: f = "0.5rem"
  } = e, [h, p] = He(l), g = dX();
  Ss(() => {
    g || r == null || r();
  }, [g]), Ss(() => {
    p(l);
  }, [l]);
  const C = () => p(null), v = () => p(l), y = () => {
    g && o();
  };
  st(() => {
    g && a && o();
  }, [g, a, o]), PO(y, h);
  const M = bt(
    () => ({
      pointerEvents: "auto",
      maxWidth: 560,
      minWidth: 300,
      margin: f,
      ...u
    }),
    [u, f]
  ), x = bt(() => LY(i), [i]);
  return /* @__PURE__ */ A.jsx(
    xa.div,
    {
      layout: !0,
      className: "chakra-toast",
      variants: d,
      initial: "initial",
      animate: "animate",
      exit: "exit",
      onHoverStart: C,
      onHoverEnd: v,
      custom: { position: i },
      style: x,
      children: /* @__PURE__ */ A.jsx(
        xe.div,
        {
          role: "status",
          "aria-atomic": "true",
          className: "chakra-toast__inner",
          __css: M,
          children: Wo(n, { id: t, onClose: y })
        }
      )
    }
  );
});
LM.displayName = "ToastComponent";
function Be(e) {
  return Ke(e);
}
var OY = typeof Element < "u", FY = typeof Map == "function", BY = typeof Set == "function", HY = typeof ArrayBuffer == "function" && !!ArrayBuffer.isView;
function Jf(e, t) {
  if (e === t)
    return !0;
  if (e && t && typeof e == "object" && typeof t == "object") {
    if (e.constructor !== t.constructor)
      return !1;
    var n, r, o;
    if (Array.isArray(e)) {
      if (n = e.length, n != t.length)
        return !1;
      for (r = n; r-- !== 0; )
        if (!Jf(e[r], t[r]))
          return !1;
      return !0;
    }
    var a;
    if (FY && e instanceof Map && t instanceof Map) {
      if (e.size !== t.size)
        return !1;
      for (a = e.entries(); !(r = a.next()).done; )
        if (!t.has(r.value[0]))
          return !1;
      for (a = e.entries(); !(r = a.next()).done; )
        if (!Jf(r.value[1], t.get(r.value[0])))
          return !1;
      return !0;
    }
    if (BY && e instanceof Set && t instanceof Set) {
      if (e.size !== t.size)
        return !1;
      for (a = e.entries(); !(r = a.next()).done; )
        if (!t.has(r.value[0]))
          return !1;
      return !0;
    }
    if (HY && ArrayBuffer.isView(e) && ArrayBuffer.isView(t)) {
      if (n = e.length, n != t.length)
        return !1;
      for (r = n; r-- !== 0; )
        if (e[r] !== t[r])
          return !1;
      return !0;
    }
    if (e.constructor === RegExp)
      return e.source === t.source && e.flags === t.flags;
    if (e.valueOf !== Object.prototype.valueOf && typeof e.valueOf == "function" && typeof t.valueOf == "function")
      return e.valueOf() === t.valueOf();
    if (e.toString !== Object.prototype.toString && typeof e.toString == "function" && typeof t.toString == "function")
      return e.toString() === t.toString();
    if (o = Object.keys(e), n = o.length, n !== Object.keys(t).length)
      return !1;
    for (r = n; r-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(t, o[r]))
        return !1;
    if (OY && e instanceof Element)
      return !1;
    for (r = n; r-- !== 0; )
      if (!((o[r] === "_owner" || o[r] === "__v" || o[r] === "__o") && e.$$typeof) && !Jf(e[o[r]], t[o[r]]))
        return !1;
    return !0;
  }
  return e !== e && t !== t;
}
var GY = function(t, n) {
  try {
    return Jf(t, n);
  } catch (r) {
    if ((r.message || "").match(/stack|recursion/i))
      return console.warn("react-fast-compare cannot handle circular refs"), !1;
    throw r;
  }
};
const $Y = /* @__PURE__ */ yh(GY);
function bc() {
  const e = Yn(
    OV
  );
  if (!e)
    throw Error(
      "useTheme: `theme` is undefined. Seems you forgot to wrap your app in `<ChakraProvider />` or `<ThemeProvider />`"
    );
  return e;
}
function ZY() {
  const e = Q3(), t = bc();
  return { ...e, theme: t };
}
function jY(e, t, n) {
  if (t == null)
    return t;
  const r = (o) => {
    var a, i;
    return (i = (a = e.__breakpoints) == null ? void 0 : a.asArray) == null ? void 0 : i[o];
  };
  return r(t) ?? r(n) ?? n;
}
function WY(e, t, n) {
  if (t == null)
    return t;
  const r = (o) => {
    var a, i;
    return (i = (a = e.__cssMap) == null ? void 0 : a[o]) == null ? void 0 : i.value;
  };
  return r(t) ?? r(n) ?? n;
}
function zY(e, t, n) {
  const r = Array.isArray(t) ? t : [t], o = Array.isArray(n) ? n : [n];
  return (a) => {
    const i = o.filter(Boolean), l = r.map((u, d) => {
      if (e === "breakpoints")
        return jY(a, u, i[d] ?? u);
      const f = `${e}.${u}`;
      return WY(a, f, i[d] ?? u);
    });
    return Array.isArray(t) ? l : l[0];
  };
}
function UY(e) {
  return Object.fromEntries(
    Object.entries(e).filter(([t, n]) => n !== void 0 && t !== "children" && !Ol(n))
  );
}
function RM(e, t = {}) {
  const { styleConfig: n, ...r } = t, { theme: o, colorMode: a } = ZY(), i = e ? vS(o, `components.${e}`) : void 0, l = n || i, u = zo(
    { theme: o, colorMode: a },
    (l == null ? void 0 : l.defaultProps) ?? {},
    UY(r),
    (f, h) => f ? void 0 : h
  ), d = Ve({});
  if (l) {
    const h = xF(l)(u);
    $Y(d.current, h) || (d.current = h);
  }
  return d.current;
}
function Ua(e, t = {}) {
  return RM(e, t);
}
function yr(e, t = {}) {
  return RM(e, t);
}
const X8 = {
  path: /* @__PURE__ */ A.jsxs("g", { stroke: "currentColor", strokeWidth: "1.5", children: [
    /* @__PURE__ */ A.jsx(
      "path",
      {
        strokeLinecap: "round",
        fill: "none",
        d: "M9,9a3,3,0,1,1,4,2.829,1.5,1.5,0,0,0-1,1.415V14.25"
      }
    ),
    /* @__PURE__ */ A.jsx(
      "path",
      {
        fill: "currentColor",
        strokeLinecap: "round",
        d: "M12,17.25a.375.375,0,1,0,.375.375A.375.375,0,0,0,12,17.25h0"
      }
    ),
    /* @__PURE__ */ A.jsx("circle", { fill: "none", strokeMiterlimit: "10", cx: "12", cy: "12", r: "11.25" })
  ] }),
  viewBox: "0 0 24 24"
}, Ni = Be((e, t) => {
  const {
    as: n,
    viewBox: r,
    color: o = "currentColor",
    focusable: a = !1,
    children: i,
    className: l,
    __css: u,
    ...d
  } = e, f = ze("chakra-icon", l), h = Ua("Icon", e), p = {
    w: "1em",
    h: "1em",
    display: "inline-block",
    lineHeight: "1em",
    flexShrink: 0,
    color: o,
    ...u,
    ...h
  }, g = {
    ref: t,
    focusable: a,
    className: f,
    __css: p
  }, C = r ?? X8.viewBox;
  if (n && typeof n != "string")
    return /* @__PURE__ */ A.jsx(xe.svg, { as: n, ...g, ...d });
  const v = i ?? X8.path;
  return /* @__PURE__ */ A.jsx(xe.svg, { verticalAlign: "middle", viewBox: C, ...g, ...d, children: v });
});
Ni.displayName = "Icon";
function XY(e) {
  return /* @__PURE__ */ A.jsx(Ni, { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ A.jsx(
    "path",
    {
      fill: "currentColor",
      d: "M12,0A12,12,0,1,0,24,12,12.014,12.014,0,0,0,12,0Zm6.927,8.2-6.845,9.289a1.011,1.011,0,0,1-1.43.188L5.764,13.769a1,1,0,1,1,1.25-1.562l4.076,3.261,6.227-8.451A1,1,0,1,1,18.927,8.2Z"
    }
  ) });
}
function YY(e) {
  return /* @__PURE__ */ A.jsx(Ni, { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ A.jsx(
    "path",
    {
      fill: "currentColor",
      d: "M12,0A12,12,0,1,0,24,12,12.013,12.013,0,0,0,12,0Zm.25,5a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,12.25,5ZM14.5,18.5h-4a1,1,0,0,1,0-2h.75a.25.25,0,0,0,.25-.25v-4.5a.25.25,0,0,0-.25-.25H10.5a1,1,0,0,1,0-2h1a2,2,0,0,1,2,2v4.75a.25.25,0,0,0,.25.25h.75a1,1,0,1,1,0,2Z"
    }
  ) });
}
function Y8(e) {
  return /* @__PURE__ */ A.jsx(Ni, { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ A.jsx(
    "path",
    {
      fill: "currentColor",
      d: "M11.983,0a12.206,12.206,0,0,0-8.51,3.653A11.8,11.8,0,0,0,0,12.207,11.779,11.779,0,0,0,11.8,24h.214A12.111,12.111,0,0,0,24,11.791h0A11.766,11.766,0,0,0,11.983,0ZM10.5,16.542a1.476,1.476,0,0,1,1.449-1.53h.027a1.527,1.527,0,0,1,1.523,1.47,1.475,1.475,0,0,1-1.449,1.53h-.027A1.529,1.529,0,0,1,10.5,16.542ZM11,12.5v-6a1,1,0,0,1,2,0v6a1,1,0,1,1-2,0Z"
    }
  ) });
}
const qY = Md({
  "0%": {
    transform: "rotate(0deg)"
  },
  "100%": {
    transform: "rotate(360deg)"
  }
}), A4 = Be((e, t) => {
  const n = Ua("Spinner", e), {
    label: r = "Loading...",
    thickness: o = "2px",
    speed: a = "0.45s",
    emptyColor: i = "transparent",
    className: l,
    ...u
  } = Ln(e), d = ze("chakra-spinner", l), f = {
    display: "inline-block",
    borderColor: "currentColor",
    borderStyle: "solid",
    borderRadius: "99999px",
    borderWidth: o,
    borderBottomColor: i,
    borderLeftColor: i,
    animation: `${qY} ${a} linear infinite`,
    ...n
  };
  return /* @__PURE__ */ A.jsx(
    xe.div,
    {
      ref: t,
      __css: f,
      className: d,
      ...u,
      children: r && /* @__PURE__ */ A.jsx(xe.span, { srOnly: !0, children: r })
    }
  );
});
A4.displayName = "Spinner";
const [JY, M4] = mn({
  name: "AlertContext",
  hookName: "useAlertContext",
  providerName: "<Alert />"
}), [KY, x4] = mn({
  name: "AlertStylesContext",
  hookName: "useAlertStyles",
  providerName: "<Alert />"
}), DM = {
  info: { icon: YY, colorScheme: "blue" },
  warning: { icon: Y8, colorScheme: "orange" },
  success: { icon: XY, colorScheme: "green" },
  error: { icon: Y8, colorScheme: "red" },
  loading: { icon: A4, colorScheme: "blue" }
};
function QY(e) {
  return DM[e].colorScheme;
}
function eq(e) {
  return DM[e].icon;
}
const w4 = Be(function(t, n) {
  const { status: r = "info", addRole: o = !0, ...a } = Ln(t), i = t.colorScheme ?? QY(r), l = yr("Alert", { ...t, colorScheme: i }), u = {
    width: "100%",
    display: "flex",
    alignItems: "center",
    position: "relative",
    overflow: "hidden",
    ...l.container
  };
  return /* @__PURE__ */ A.jsx(JY, { value: { status: r }, children: /* @__PURE__ */ A.jsx(KY, { value: l, children: /* @__PURE__ */ A.jsx(
    xe.div,
    {
      "data-status": r,
      role: o ? "alert" : void 0,
      ref: n,
      ...a,
      className: ze("chakra-alert", t.className),
      __css: u
    }
  ) }) });
});
w4.displayName = "Alert";
function _4(e) {
  const { status: t } = M4(), n = eq(t), r = x4(), o = t === "loading" ? r.spinner : r.icon;
  return /* @__PURE__ */ A.jsx(
    xe.span,
    {
      display: "inherit",
      "data-status": t,
      ...e,
      className: ze("chakra-alert__icon", e.className),
      __css: o,
      children: e.children || /* @__PURE__ */ A.jsx(n, { h: "100%", w: "100%" })
    }
  );
}
_4.displayName = "AlertIcon";
const PM = Be(
  function(t, n) {
    const r = x4(), { status: o } = M4();
    return /* @__PURE__ */ A.jsx(
      xe.div,
      {
        ref: n,
        "data-status": o,
        ...t,
        className: ze("chakra-alert__title", t.className),
        __css: r.title
      }
    );
  }
);
PM.displayName = "AlertTitle";
const EM = Be(
  function(t, n) {
    const { status: r } = M4(), o = x4(), a = {
      display: "inline",
      ...o.description
    };
    return /* @__PURE__ */ A.jsx(
      xe.div,
      {
        ref: n,
        "data-status": r,
        ...t,
        className: ze("chakra-alert__desc", t.className),
        __css: a
      }
    );
  }
);
EM.displayName = "AlertDescription";
function tq(e) {
  return /* @__PURE__ */ A.jsx(Ni, { focusable: "false", "aria-hidden": !0, ...e, children: /* @__PURE__ */ A.jsx(
    "path",
    {
      fill: "currentColor",
      d: "M.439,21.44a1.5,1.5,0,0,0,2.122,2.121L11.823,14.3a.25.25,0,0,1,.354,0l9.262,9.263a1.5,1.5,0,1,0,2.122-2.121L14.3,12.177a.25.25,0,0,1,0-.354l9.263-9.262A1.5,1.5,0,0,0,21.439.44L12.177,9.7a.25.25,0,0,1-.354,0L2.561.44A1.5,1.5,0,0,0,.439,2.561L9.7,11.823a.25.25,0,0,1,0,.354Z"
    }
  ) });
}
const Td = Be(
  function(t, n) {
    const r = Ua("CloseButton", t), { children: o, isDisabled: a, __css: i, ...l } = Ln(t), u = {
      outline: 0,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexShrink: 0
    };
    return /* @__PURE__ */ A.jsx(
      xe.button,
      {
        type: "button",
        "aria-label": "Close",
        ref: n,
        disabled: a,
        __css: {
          ...u,
          ...r,
          ...i
        },
        ...l,
        children: o || /* @__PURE__ */ A.jsx(tq, { width: "1em", height: "1em" })
      }
    );
  }
);
Td.displayName = "CloseButton";
const nq = (e) => {
  const {
    status: t,
    variant: n = "solid",
    id: r,
    title: o,
    isClosable: a,
    onClose: i,
    description: l,
    colorScheme: u,
    icon: d
  } = e, f = r ? {
    root: `toast-${r}`,
    title: `toast-${r}-title`,
    description: `toast-${r}-description`
  } : void 0;
  return /* @__PURE__ */ A.jsxs(
    w4,
    {
      addRole: !1,
      status: t,
      variant: n,
      id: f == null ? void 0 : f.root,
      alignItems: "start",
      borderRadius: "md",
      boxShadow: "lg",
      paddingEnd: 8,
      textAlign: "start",
      width: "auto",
      colorScheme: u,
      children: [
        /* @__PURE__ */ A.jsx(_4, { children: d }),
        /* @__PURE__ */ A.jsxs(xe.div, { flex: "1", maxWidth: "100%", children: [
          o && /* @__PURE__ */ A.jsx(PM, { id: f == null ? void 0 : f.title, children: o }),
          l && /* @__PURE__ */ A.jsx(EM, { id: f == null ? void 0 : f.description, display: "block", children: l })
        ] }),
        a && /* @__PURE__ */ A.jsx(
          Td,
          {
            size: "sm",
            onClick: i,
            position: "absolute",
            insetEnd: 1,
            top: 1
          }
        )
      ]
    }
  );
};
function rq(e = {}) {
  const { render: t, toastComponent: n = nq } = e;
  return (o) => typeof t == "function" ? t({ ...o, ...e }) : /* @__PURE__ */ A.jsx(n, { ...o, ...e });
}
const oq = {
  top: [],
  "top-left": [],
  "top-right": [],
  "bottom-left": [],
  bottom: [],
  "bottom-right": []
}, q1 = aq(oq);
function aq(e) {
  let t = e;
  const n = /* @__PURE__ */ new Set(), r = (o) => {
    t = o(t), n.forEach((a) => a());
  };
  return {
    getState: () => t,
    subscribe: (o) => (n.add(o), () => {
      r(() => e), n.delete(o);
    }),
    /**
     * Delete a toast record at its position
     */
    removeToast: (o, a) => {
      r((i) => ({
        ...i,
        // id may be string or number
        // eslint-disable-next-line eqeqeq
        [a]: i[a].filter((l) => l.id != o)
      }));
    },
    notify: (o, a) => {
      const i = iq(o, a), { position: l, id: u } = i;
      return r((d) => {
        const h = l.includes("top") ? [i, ...d[l] ?? []] : [...d[l] ?? [], i];
        return {
          ...d,
          [l]: h
        };
      }), u;
    },
    update: (o, a) => {
      o && r((i) => {
        const l = { ...i }, { position: u, index: d } = U8(l, o);
        return u && d !== -1 && (l[u][d] = {
          ...l[u][d],
          ...a,
          message: rq(a)
        }), l;
      });
    },
    closeAll: ({ positions: o } = {}) => {
      r((a) => (o ?? [
        "bottom",
        "bottom-right",
        "bottom-left",
        "top",
        "top-left",
        "top-right"
      ]).reduce(
        (u, d) => (u[d] = a[d].map((f) => ({
          ...f,
          requestClose: !0
        })), u),
        { ...a }
      ));
    },
    close: (o) => {
      r((a) => {
        const i = IM(a, o);
        return i ? {
          ...a,
          [i]: a[i].map((l) => l.id == o ? {
            ...l,
            requestClose: !0
          } : l)
        } : a;
      });
    },
    isActive: (o) => !!U8(q1.getState(), o).position
  };
}
let q8 = 0;
function iq(e, t = {}) {
  q8 += 1;
  const n = t.id ?? q8, r = t.position ?? "bottom";
  return {
    id: n,
    message: e,
    position: r,
    duration: t.duration,
    onCloseComplete: t.onCloseComplete,
    onRequestRemove: () => q1.removeToast(String(n), r),
    status: t.status,
    requestClose: !1,
    containerStyle: t.containerStyle
  };
}
const [TM, sq] = mn({
  strict: !1,
  name: "PortalContext"
}), I4 = "chakra-portal", lq = ".chakra-portal", uq = (e) => /* @__PURE__ */ A.jsx(
  "div",
  {
    className: "chakra-portal-zIndex",
    style: {
      position: "absolute",
      zIndex: e.zIndex,
      top: 0,
      left: 0,
      right: 0
      // NB: Don't add `bottom: 0`, it makes the entire app unusable
      // @see https://github.com/chakra-ui/chakra-ui/issues/3201
    },
    children: e.children
  }
), cq = (e) => {
  const { appendToParentPortal: t, children: n } = e, [r, o] = He(null), a = Ve(null), [, i] = He({});
  st(() => i({}), []);
  const l = sq(), u = uW();
  Ci(() => {
    if (!r)
      return;
    const f = r.ownerDocument, h = t ? l ?? f.body : f.body;
    if (!h)
      return;
    a.current = f.createElement("div"), a.current.className = I4, h.appendChild(a.current), i({});
    const p = a.current;
    return () => {
      h.contains(p) && h.removeChild(p);
    };
  }, [r]);
  const d = u != null && u.zIndex ? /* @__PURE__ */ A.jsx(uq, { zIndex: u == null ? void 0 : u.zIndex, children: n }) : n;
  return a.current ? G3(
    /* @__PURE__ */ A.jsx(TM, { value: a.current, children: d }),
    a.current
  ) : /* @__PURE__ */ A.jsx(
    "span",
    {
      ref: (f) => {
        f && o(f);
      }
    }
  );
}, dq = (e) => {
  const { children: t, containerRef: n, appendToParentPortal: r } = e, o = n.current, a = o ?? (typeof window < "u" ? document.body : void 0), i = bt(() => {
    const u = o == null ? void 0 : o.ownerDocument.createElement("div");
    return u && (u.className = I4), u;
  }, [o]), [, l] = He({});
  return Ci(() => l({}), []), Ci(() => {
    if (!(!i || !a))
      return a.appendChild(i), () => {
        a.removeChild(i);
      };
  }, [i, a]), a && i ? G3(
    /* @__PURE__ */ A.jsx(TM, { value: r ? i : null, children: t }),
    i
  ) : null;
};
function ki(e) {
  const t = {
    appendToParentPortal: !0,
    ...e
  }, { containerRef: n, ...r } = t;
  return n ? /* @__PURE__ */ A.jsx(dq, { containerRef: n, ...r }) : /* @__PURE__ */ A.jsx(cq, { ...r });
}
ki.className = I4;
ki.selector = lq;
ki.displayName = "Portal";
const [fq, q3e] = mn({
  name: "ToastOptionsContext",
  strict: !1
}), hq = (e) => {
  const t = EV(
    q1.subscribe,
    q1.getState,
    q1.getState
  ), {
    motionVariants: n,
    component: r = LM,
    portalProps: o,
    animatePresenceProps: a
  } = e, l = Object.keys(t).map((u) => {
    const d = t[u];
    return /* @__PURE__ */ A.jsx(
      "div",
      {
        role: "region",
        "aria-live": "polite",
        "aria-label": `Notifications-${u}`,
        id: `chakra-toast-manager-${u}`,
        style: RY(u),
        children: /* @__PURE__ */ A.jsx(Rs, { ...a, initial: !1, children: d.map((f) => /* @__PURE__ */ A.jsx(
          r,
          {
            motionVariants: n,
            ...f
          },
          f.id
        )) })
      },
      u
    );
  });
  return /* @__PURE__ */ A.jsx(ki, { ...o, children: l });
}, mq = (e) => function({
  children: n,
  theme: r = e,
  toastOptions: o,
  ...a
}) {
  return /* @__PURE__ */ A.jsxs(cW, { theme: r, ...a, children: [
    /* @__PURE__ */ A.jsx(fq, { value: o == null ? void 0 : o.defaultOptions, children: n }),
    /* @__PURE__ */ A.jsx(hq, { ...o })
  ] });
}, pq = mq(JS);
function J8(e) {
  return e.sort((t, n) => {
    const r = t.compareDocumentPosition(n);
    if (r & Node.DOCUMENT_POSITION_FOLLOWING || r & Node.DOCUMENT_POSITION_CONTAINED_BY)
      return -1;
    if (r & Node.DOCUMENT_POSITION_PRECEDING || r & Node.DOCUMENT_POSITION_CONTAINS)
      return 1;
    if (r & Node.DOCUMENT_POSITION_DISCONNECTED || r & Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC)
      throw Error("Cannot sort the given nodes.");
    return 0;
  });
}
const gq = (e) => typeof e == "object" && "nodeType" in e && e.nodeType === Node.ELEMENT_NODE;
function K8(e, t, n) {
  let r = e + 1;
  return n && r >= t && (r = 0), r;
}
function Q8(e, t, n) {
  let r = e - 1;
  return n && r < 0 && (r = t), r;
}
const yg = typeof window < "u" ? Cc : st, eC = (e) => e;
var vq = Object.defineProperty, Cq = (e, t, n) => t in e ? vq(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, Gn = (e, t, n) => (Cq(e, typeof t != "symbol" ? t + "" : t, n), n);
class bq {
  constructor() {
    Gn(this, "descendants", /* @__PURE__ */ new Map()), Gn(this, "register", (t) => {
      if (t != null)
        return gq(t) ? this.registerNode(t) : (n) => {
          this.registerNode(n, t);
        };
    }), Gn(this, "unregister", (t) => {
      this.descendants.delete(t);
      const n = J8(Array.from(this.descendants.keys()));
      this.assignIndex(n);
    }), Gn(this, "destroy", () => {
      this.descendants.clear();
    }), Gn(this, "assignIndex", (t) => {
      this.descendants.forEach((n) => {
        const r = t.indexOf(n.node);
        n.index = r, n.node.dataset.index = n.index.toString();
      });
    }), Gn(this, "count", () => this.descendants.size), Gn(this, "enabledCount", () => this.enabledValues().length), Gn(this, "values", () => Array.from(this.descendants.values()).sort((n, r) => n.index - r.index)), Gn(this, "enabledValues", () => this.values().filter((t) => !t.disabled)), Gn(this, "item", (t) => {
      if (this.count() !== 0)
        return this.values()[t];
    }), Gn(this, "enabledItem", (t) => {
      if (this.enabledCount() !== 0)
        return this.enabledValues()[t];
    }), Gn(this, "first", () => this.item(0)), Gn(this, "firstEnabled", () => this.enabledItem(0)), Gn(this, "last", () => this.item(this.descendants.size - 1)), Gn(this, "lastEnabled", () => {
      const t = this.enabledValues().length - 1;
      return this.enabledItem(t);
    }), Gn(this, "indexOf", (t) => {
      var n;
      return t ? ((n = this.descendants.get(t)) == null ? void 0 : n.index) ?? -1 : -1;
    }), Gn(this, "enabledIndexOf", (t) => t == null ? -1 : this.enabledValues().findIndex((n) => n.node.isSameNode(t))), Gn(this, "next", (t, n = !0) => {
      const r = K8(t, this.count(), n);
      return this.item(r);
    }), Gn(this, "nextEnabled", (t, n = !0) => {
      const r = this.item(t);
      if (!r)
        return;
      const o = this.enabledIndexOf(r.node), a = K8(
        o,
        this.enabledCount(),
        n
      );
      return this.enabledItem(a);
    }), Gn(this, "prev", (t, n = !0) => {
      const r = Q8(t, this.count() - 1, n);
      return this.item(r);
    }), Gn(this, "prevEnabled", (t, n = !0) => {
      const r = this.item(t);
      if (!r)
        return;
      const o = this.enabledIndexOf(r.node), a = Q8(
        o,
        this.enabledCount() - 1,
        n
      );
      return this.enabledItem(a);
    }), Gn(this, "registerNode", (t, n) => {
      if (!t || this.descendants.has(t))
        return;
      const r = Array.from(this.descendants.keys()).concat(t), o = J8(r);
      n != null && n.disabled && (n.disabled = !!n.disabled);
      const a = { node: t, index: -1, ...n };
      this.descendants.set(t, a), this.assignIndex(o);
    });
  }
}
function NM() {
  const [e, t] = mn({
    name: "DescendantsProvider",
    errorMessage: "useDescendantsContext must be used within DescendantsProvider"
  });
  return [
    // context provider
    e,
    // call this when you need to read from context
    t,
    () => {
      const o = Ve(new bq());
      return yg(() => () => o.current.destroy()), o.current;
    },
    (o) => {
      const a = t(), [i, l] = He(-1), u = Ve(null);
      yg(() => () => {
        u.current && a.unregister(u.current);
      }, []), yg(() => {
        if (!u.current)
          return;
        const f = Number(u.current.dataset.index);
        i != f && !Number.isNaN(f) && l(f);
      });
      const d = eC(o ? a.register(o) : a.register);
      return {
        descendants: a,
        index: i,
        enabledIndex: a.enabledIndexOf(u.current),
        register: In(d, u)
      };
    }
  ];
}
const [yq, Nh] = mn({
  name: "AccordionStylesContext",
  hookName: "useAccordionStyles",
  providerName: "<Accordion />"
}), [Sq, L4] = mn({
  name: "AccordionItemContext",
  hookName: "useAccordionItemContext",
  providerName: "<AccordionItem />"
}), [
  Aq,
  J3e,
  Mq,
  xq
] = NM();
function wq(e) {
  const {
    onChange: t,
    defaultIndex: n,
    index: r,
    allowMultiple: o,
    allowToggle: a,
    ...i
  } = e;
  Lq(e), Rq(e);
  const l = Mq(), [u, d] = He(-1);
  st(() => () => {
    d(-1);
  }, []);
  const [f, h] = xS({
    value: r,
    defaultValue() {
      return o ? n ?? [] : n ?? -1;
    },
    onChange: t
  });
  return {
    index: f,
    setIndex: h,
    htmlProps: i,
    getAccordionItemProps: (g) => {
      let C = !1;
      return g !== null && (C = Array.isArray(f) ? f.includes(g) : f === g), { isOpen: C, onChange: (y) => {
        if (g !== null)
          if (o && Array.isArray(f)) {
            const M = y ? f.concat(g) : f.filter((x) => x !== g);
            h(M);
          } else
            y ? h(g) : a && h(-1);
      } };
    },
    focusedIndex: u,
    setFocusedIndex: d,
    descendants: l
  };
}
const [_q, R4] = mn({
  name: "AccordionContext",
  hookName: "useAccordionContext",
  providerName: "Accordion"
});
function Iq(e) {
  const { isDisabled: t, isFocusable: n, id: r, ...o } = e, { getAccordionItemProps: a, setFocusedIndex: i } = R4(), l = Ve(null), u = Lo(), d = r ?? u, f = `accordion-button-${d}`, h = `accordion-panel-${d}`;
  Dq(e);
  const { register: p, index: g, descendants: C } = xq({
    disabled: t && !n
  }), { isOpen: v, onChange: y } = a(
    g === -1 ? null : g
  );
  Pq({ isOpen: v, isDisabled: t });
  const M = () => {
    y == null || y(!0);
  }, x = () => {
    y == null || y(!1);
  }, _ = Q(() => {
    y == null || y(!v), i(g);
  }, [g, i, v, y]), L = Q(
    (N) => {
      const H = {
        ArrowDown: () => {
          const $ = C.nextEnabled(g);
          $ == null || $.node.focus();
        },
        ArrowUp: () => {
          const $ = C.prevEnabled(g);
          $ == null || $.node.focus();
        },
        Home: () => {
          const $ = C.firstEnabled();
          $ == null || $.node.focus();
        },
        End: () => {
          const $ = C.lastEnabled();
          $ == null || $.node.focus();
        }
      }[N.key];
      H && (N.preventDefault(), H(N));
    },
    [C, g]
  ), R = Q(() => {
    i(g);
  }, [i, g]), k = Q(
    function(O = {}, H = null) {
      return {
        ...O,
        type: "button",
        ref: In(p, l, H),
        id: f,
        disabled: !!t,
        "aria-expanded": !!v,
        "aria-controls": h,
        onClick: qe(O.onClick, _),
        onFocus: qe(O.onFocus, R),
        onKeyDown: qe(O.onKeyDown, L)
      };
    },
    [
      f,
      t,
      v,
      _,
      R,
      L,
      h,
      p
    ]
  ), P = Q(
    function(O = {}, H = null) {
      return {
        ...O,
        ref: H,
        role: "region",
        id: h,
        "aria-labelledby": f,
        hidden: !v
      };
    },
    [f, v, h]
  );
  return {
    isOpen: v,
    isDisabled: t,
    isFocusable: n,
    onOpen: M,
    onClose: x,
    getButtonProps: k,
    getPanelProps: P,
    htmlProps: o
  };
}
function Lq(e) {
  const t = e.index || e.defaultIndex, n = t != null && !Array.isArray(t) && e.allowMultiple;
  xd({
    condition: !!n,
    message: `If 'allowMultiple' is passed, then 'index' or 'defaultIndex' must be an array. You passed: ${typeof t},`
  });
}
function Rq(e) {
  xd({
    condition: !!(e.allowMultiple && e.allowToggle),
    message: "If 'allowMultiple' is passed, 'allowToggle' will be ignored. Either remove 'allowToggle' or 'allowMultiple' depending on whether you want multiple accordions visible or not"
  });
}
function Dq(e) {
  xd({
    condition: !!(e.isFocusable && !e.isDisabled),
    message: `Using only 'isFocusable', this prop is reserved for situations where you pass 'isDisabled' but you still want the element to receive focus (A11y). Either remove it or pass 'isDisabled' as well.
    `
  });
}
function Pq(e) {
  xd({
    condition: e.isOpen && !!e.isDisabled,
    message: "Cannot open a disabled accordion item"
  });
}
const kM = Be(function({ children: t, reduceMotion: n, ...r }, o) {
  const a = yr("Accordion", r), i = Ln(r), { htmlProps: l, descendants: u, ...d } = wq(i), f = bt(
    () => ({ ...d, reduceMotion: !!n }),
    [d, n]
  );
  return /* @__PURE__ */ A.jsx(Aq, { value: u, children: /* @__PURE__ */ A.jsx(_q, { value: f, children: /* @__PURE__ */ A.jsx(yq, { value: a, children: /* @__PURE__ */ A.jsx(
    xe.div,
    {
      ref: o,
      ...l,
      className: ze("chakra-accordion", r.className),
      __css: a.root,
      children: t
    }
  ) }) }) });
});
kM.displayName = "Accordion";
const VM = Be(
  function(t, n) {
    const { getButtonProps: r } = L4(), o = r(t, n), i = {
      display: "flex",
      alignItems: "center",
      width: "100%",
      outline: 0,
      ...Nh().button
    };
    return /* @__PURE__ */ A.jsx(
      xe.button,
      {
        ...o,
        className: ze("chakra-accordion__button", t.className),
        __css: i
      }
    );
  }
);
VM.displayName = "AccordionButton";
function OM(e) {
  const { isOpen: t, isDisabled: n } = L4(), { reduceMotion: r } = R4(), o = ze("chakra-accordion__icon", e.className), a = Nh(), i = {
    opacity: n ? 0.4 : 1,
    transform: t ? "rotate(-180deg)" : void 0,
    transition: r ? void 0 : "transform 0.2s",
    transformOrigin: "center",
    ...a.icon
  };
  return /* @__PURE__ */ A.jsx(
    Ni,
    {
      viewBox: "0 0 24 24",
      "aria-hidden": !0,
      className: o,
      __css: i,
      ...e,
      children: /* @__PURE__ */ A.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"
        }
      )
    }
  );
}
OM.displayName = "AccordionIcon";
const FM = Be(
  function(t, n) {
    const { children: r, className: o } = t, { htmlProps: a, ...i } = Iq(t), l = Nh(), u = {
      ...l.container,
      overflowAnchor: "none"
    }, d = bt(() => i, [i]);
    return /* @__PURE__ */ A.jsx(Sq, { value: d, children: /* @__PURE__ */ A.jsx(
      xe.div,
      {
        ref: n,
        ...a,
        className: ze("chakra-accordion__item", o),
        __css: u,
        children: typeof r == "function" ? r({
          isExpanded: !!i.isOpen,
          isDisabled: !!i.isDisabled
        }) : r
      }
    ) });
  }
);
FM.displayName = "AccordionItem";
const ul = {
  ease: [0.25, 0.1, 0.25, 1],
  easeIn: [0.4, 0, 1, 1],
  easeOut: [0, 0, 0.2, 1],
  easeInOut: [0.4, 0, 0.2, 1]
}, f1 = {
  scale: {
    enter: { scale: 1 },
    exit: { scale: 0.95 }
  },
  fade: {
    enter: { opacity: 1 },
    exit: { opacity: 0 }
  },
  pushLeft: {
    enter: { x: "100%" },
    exit: { x: "-30%" }
  },
  pushRight: {
    enter: { x: "-100%" },
    exit: { x: "30%" }
  },
  pushUp: {
    enter: { y: "100%" },
    exit: { y: "-30%" }
  },
  pushDown: {
    enter: { y: "-100%" },
    exit: { y: "30%" }
  },
  slideLeft: {
    position: { left: 0, top: 0, bottom: 0, width: "100%" },
    enter: { x: 0, y: 0 },
    exit: { x: "-100%", y: 0 }
  },
  slideRight: {
    position: { right: 0, top: 0, bottom: 0, width: "100%" },
    enter: { x: 0, y: 0 },
    exit: { x: "100%", y: 0 }
  },
  slideUp: {
    position: { top: 0, left: 0, right: 0, maxWidth: "100vw" },
    enter: { x: 0, y: 0 },
    exit: { x: 0, y: "-100%" }
  },
  slideDown: {
    position: { bottom: 0, left: 0, right: 0, maxWidth: "100vw" },
    enter: { x: 0, y: 0 },
    exit: { x: 0, y: "100%" }
  }
};
function B5(e) {
  switch ((e == null ? void 0 : e.direction) ?? "right") {
    case "right":
      return f1.slideRight;
    case "left":
      return f1.slideLeft;
    case "bottom":
      return f1.slideDown;
    case "top":
      return f1.slideUp;
    default:
      return f1.slideRight;
  }
}
const vl = {
  enter: {
    duration: 0.2,
    ease: ul.easeOut
  },
  exit: {
    duration: 0.1,
    ease: ul.easeIn
  }
}, ba = {
  enter: (e, t) => ({
    ...e,
    delay: typeof t == "number" ? t : t == null ? void 0 : t.enter
  }),
  exit: (e, t) => ({
    ...e,
    delay: typeof t == "number" ? t : t == null ? void 0 : t.exit
  })
}, Eq = (e) => e != null && parseInt(e.toString(), 10) > 0, tC = {
  exit: {
    height: { duration: 0.2, ease: ul.ease },
    opacity: { duration: 0.3, ease: ul.ease }
  },
  enter: {
    height: { duration: 0.3, ease: ul.ease },
    opacity: { duration: 0.4, ease: ul.ease }
  }
}, Tq = {
  exit: ({
    animateOpacity: e,
    startingHeight: t,
    transition: n,
    transitionEnd: r,
    delay: o
  }) => ({
    ...e && { opacity: Eq(t) ? 1 : 0 },
    height: t,
    transitionEnd: r == null ? void 0 : r.exit,
    transition: (n == null ? void 0 : n.exit) ?? ba.exit(tC.exit, o)
  }),
  enter: ({
    animateOpacity: e,
    endingHeight: t,
    transition: n,
    transitionEnd: r,
    delay: o
  }) => ({
    ...e && { opacity: 1 },
    height: t,
    transitionEnd: r == null ? void 0 : r.enter,
    transition: (n == null ? void 0 : n.enter) ?? ba.enter(tC.enter, o)
  })
}, BM = Ke(
  (e, t) => {
    const {
      in: n,
      unmountOnExit: r,
      animateOpacity: o = !0,
      startingHeight: a = 0,
      endingHeight: i = "auto",
      style: l,
      className: u,
      transition: d,
      transitionEnd: f,
      animatePresenceProps: h,
      ...p
    } = e, [g, C] = He(!1);
    st(() => {
      const _ = setTimeout(() => {
        C(!0);
      });
      return () => clearTimeout(_);
    }, []), xd({
      condition: Number(a) > 0 && !!r,
      message: "startingHeight and unmountOnExit are mutually exclusive. You can't use them together"
    });
    const v = parseFloat(a.toString()) > 0, y = {
      startingHeight: a,
      endingHeight: i,
      animateOpacity: o,
      transition: g ? d : { enter: { duration: 0 } },
      transitionEnd: {
        enter: f == null ? void 0 : f.enter,
        exit: r ? f == null ? void 0 : f.exit : {
          ...f == null ? void 0 : f.exit,
          display: v ? "block" : "none"
        }
      }
    }, M = r ? n : !0, x = n || r ? "enter" : "exit";
    return /* @__PURE__ */ A.jsx(
      Rs,
      {
        ...h,
        initial: !1,
        custom: y,
        children: M && /* @__PURE__ */ A.jsx(
          xa.div,
          {
            ref: t,
            ...p,
            className: ze("chakra-collapse", u),
            style: {
              overflow: "hidden",
              display: "block",
              ...l
            },
            custom: y,
            variants: Tq,
            initial: r ? "exit" : !1,
            animate: x,
            exit: "exit"
          }
        )
      }
    );
  }
);
BM.displayName = "Collapse";
const HM = Be(
  function(t, n) {
    const { className: r, motionProps: o, ...a } = t, { reduceMotion: i } = R4(), { getPanelProps: l, isOpen: u } = L4(), d = l(a, n), f = ze("chakra-accordion__panel", r), h = Nh();
    i || delete d.hidden;
    const p = /* @__PURE__ */ A.jsx(xe.div, { ...d, __css: h.panel, className: f });
    return i ? p : /* @__PURE__ */ A.jsx(BM, { in: u, ...o, children: p });
  }
);
HM.displayName = "AccordionPanel";
const [Nq, kq] = mn({
  name: "AvatarStylesContext",
  hookName: "useAvatarStyles",
  providerName: "<Avatar/>"
});
function Vq(e) {
  const t = e.trim().split(" "), n = t[0] ?? "", r = t.length > 1 ? t[t.length - 1] : "";
  return n && r ? `${n.charAt(0)}${r.charAt(0)}` : n.charAt(0);
}
function GM(e) {
  const { name: t, getInitials: n, ...r } = e, o = kq();
  return /* @__PURE__ */ A.jsx(xe.div, { role: "img", "aria-label": t, ...r, __css: o.label, children: t ? n == null ? void 0 : n(t) : null });
}
GM.displayName = "AvatarName";
const $M = (e) => /* @__PURE__ */ A.jsxs(
  xe.svg,
  {
    viewBox: "0 0 128 128",
    color: "#fff",
    width: "100%",
    height: "100%",
    className: "chakra-avatar__svg",
    ...e,
    children: [
      /* @__PURE__ */ A.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M103,102.1388 C93.094,111.92 79.3504,118 64.1638,118 C48.8056,118 34.9294,111.768 25,101.7892 L25,95.2 C25,86.8096 31.981,80 40.6,80 L87.4,80 C96.019,80 103,86.8096 103,95.2 L103,102.1388 Z"
        }
      ),
      /* @__PURE__ */ A.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M63.9961647,24 C51.2938136,24 41,34.2938136 41,46.9961647 C41,59.7061864 51.2938136,70 63.9961647,70 C76.6985159,70 87,59.7061864 87,46.9961647 C87,34.2938136 76.6985159,24 63.9961647,24"
        }
      )
    ]
  }
);
function Oq(e) {
  const {
    loading: t,
    src: n,
    srcSet: r,
    onLoad: o,
    onError: a,
    crossOrigin: i,
    sizes: l,
    ignoreFallback: u
  } = e, [d, f] = He("pending");
  st(() => {
    f(n ? "loading" : "pending");
  }, [n]);
  const h = Ve(null), p = Q(() => {
    if (!n)
      return;
    g();
    const C = new Image();
    C.src = n, i && (C.crossOrigin = i), r && (C.srcset = r), l && (C.sizes = l), t && (C.loading = t), C.onload = (v) => {
      g(), f("loaded"), o == null || o(v);
    }, C.onerror = (v) => {
      g(), f("failed"), a == null || a(v);
    }, h.current = C;
  }, [n, i, r, l, o, a, t]), g = () => {
    h.current && (h.current.onload = null, h.current.onerror = null, h.current = null);
  };
  return Ci(() => {
    if (!u)
      return d === "loading" && p(), () => {
        g();
      };
  }, [d, p, u]), u ? "loaded" : d;
}
function ZM(e) {
  const {
    src: t,
    srcSet: n,
    onError: r,
    onLoad: o,
    getInitials: a,
    name: i,
    borderRadius: l,
    loading: u,
    iconLabel: d,
    icon: f = /* @__PURE__ */ A.jsx($M, {}),
    ignoreFallback: h,
    referrerPolicy: p,
    crossOrigin: g
  } = e, v = Oq({ src: t, onError: r, crossOrigin: g, ignoreFallback: h }) === "loaded";
  return !t || !v ? i ? /* @__PURE__ */ A.jsx(
    GM,
    {
      className: "chakra-avatar__initials",
      getInitials: a,
      name: i
    }
  ) : Yo(f, {
    role: "img",
    "aria-label": d
  }) : /* @__PURE__ */ A.jsx(
    xe.img,
    {
      src: t,
      srcSet: n,
      alt: i ?? d,
      onLoad: o,
      referrerPolicy: p,
      crossOrigin: g ?? void 0,
      className: "chakra-avatar__img",
      loading: u,
      __css: {
        width: "100%",
        height: "100%",
        objectFit: "cover",
        borderRadius: l
      }
    }
  );
}
ZM.displayName = "AvatarImage";
const Fq = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",
  textTransform: "uppercase",
  fontWeight: "medium",
  position: "relative",
  flexShrink: 0
}, jM = Be((e, t) => {
  const n = yr("Avatar", e), [r, o] = He(!1), {
    src: a,
    srcSet: i,
    name: l,
    showBorder: u,
    borderRadius: d = "full",
    onError: f,
    onLoad: h,
    getInitials: p = Vq,
    icon: g = /* @__PURE__ */ A.jsx($M, {}),
    iconLabel: C = " avatar",
    loading: v,
    children: y,
    borderColor: M,
    ignoreFallback: x,
    crossOrigin: _,
    referrerPolicy: L,
    ...R
  } = Ln(e), k = {
    borderRadius: d,
    borderWidth: u ? "2px" : void 0,
    ...Fq,
    ...n.container
  };
  return M && (k.borderColor = M), /* @__PURE__ */ A.jsx(
    xe.span,
    {
      ref: t,
      ...R,
      className: ze("chakra-avatar", e.className),
      "data-loaded": Qe(r),
      __css: k,
      children: /* @__PURE__ */ A.jsxs(Nq, { value: n, children: [
        /* @__PURE__ */ A.jsx(
          ZM,
          {
            src: a,
            srcSet: i,
            loading: v,
            onLoad: qe(h, () => {
              o(!0);
            }),
            onError: f,
            getInitials: p,
            name: l,
            borderRadius: d,
            icon: g,
            iconLabel: C,
            ignoreFallback: x,
            crossOrigin: _,
            referrerPolicy: L
          }
        ),
        y
      ] })
    }
  );
});
jM.displayName = "Avatar";
const Ma = xe("div");
Ma.displayName = "Box";
const [K3e, Bq] = mn({
  strict: !1,
  name: "ButtonGroupContext"
});
function E1(e) {
  const { children: t, className: n, ...r } = e, o = Ol(t) ? Yo(t, {
    "aria-hidden": !0,
    focusable: !1
  }) : t, a = ze("chakra-button__icon", n);
  return /* @__PURE__ */ A.jsx(
    xe.span,
    {
      display: "inline-flex",
      alignSelf: "center",
      flexShrink: 0,
      ...r,
      className: a,
      children: o
    }
  );
}
E1.displayName = "ButtonIcon";
function H5(e) {
  const {
    label: t,
    placement: n,
    spacing: r = "0.5rem",
    children: o = /* @__PURE__ */ A.jsx(A4, { color: "currentColor", width: "1em", height: "1em" }),
    className: a,
    __css: i,
    ...l
  } = e, u = ze("chakra-button__spinner", a), d = n === "start" ? "marginEnd" : "marginStart", f = bt(
    () => ({
      display: "flex",
      alignItems: "center",
      position: t ? "relative" : "absolute",
      [d]: t ? r : 0,
      fontSize: "1em",
      lineHeight: "normal",
      ...i
    }),
    [i, t, d, r]
  );
  return /* @__PURE__ */ A.jsx(xe.div, { className: u, ...l, __css: f, children: o });
}
H5.displayName = "ButtonSpinner";
function Hq(e) {
  const [t, n] = He(!e);
  return { ref: Q((a) => {
    a && n(a.tagName === "BUTTON");
  }, []), type: t ? "button" : void 0 };
}
const tc = Be((e, t) => {
  const n = Bq(), r = Ua("Button", { ...n, ...e }), {
    isDisabled: o = n == null ? void 0 : n.isDisabled,
    isLoading: a,
    isActive: i,
    children: l,
    leftIcon: u,
    rightIcon: d,
    loadingText: f,
    iconSpacing: h = "0.5rem",
    type: p,
    spinner: g,
    spinnerPlacement: C = "start",
    className: v,
    as: y,
    shouldWrapChildren: M,
    ...x
  } = Ln(e), _ = bt(() => {
    const P = { ...r == null ? void 0 : r._focus, zIndex: 1 };
    return {
      display: "inline-flex",
      appearance: "none",
      alignItems: "center",
      justifyContent: "center",
      userSelect: "none",
      position: "relative",
      whiteSpace: "nowrap",
      verticalAlign: "middle",
      outline: "none",
      ...r,
      ...!!n && { _focus: P }
    };
  }, [r, n]), { ref: L, type: R } = Hq(y), k = {
    rightIcon: d,
    leftIcon: u,
    iconSpacing: h,
    children: l,
    shouldWrapChildren: M
  };
  return /* @__PURE__ */ A.jsxs(
    xe.button,
    {
      disabled: o || a,
      ref: DO(t, L),
      as: y,
      type: p ?? R,
      "data-active": Qe(i),
      "data-loading": Qe(a),
      __css: _,
      className: ze("chakra-button", v),
      ...x,
      children: [
        a && C === "start" && /* @__PURE__ */ A.jsx(
          H5,
          {
            className: "chakra-button__spinner--start",
            label: f,
            placement: "start",
            spacing: h,
            children: g
          }
        ),
        a ? f || /* @__PURE__ */ A.jsx(xe.span, { opacity: 0, children: /* @__PURE__ */ A.jsx(nC, { ...k }) }) : /* @__PURE__ */ A.jsx(nC, { ...k }),
        a && C === "end" && /* @__PURE__ */ A.jsx(
          H5,
          {
            className: "chakra-button__spinner--end",
            label: f,
            placement: "end",
            spacing: h,
            children: g
          }
        )
      ]
    }
  );
});
tc.displayName = "Button";
function nC(e) {
  const { leftIcon: t, rightIcon: n, children: r, iconSpacing: o, shouldWrapChildren: a } = e;
  return a ? /* @__PURE__ */ A.jsxs("span", { style: { display: "contents" }, children: [
    t && /* @__PURE__ */ A.jsx(E1, { marginEnd: o, children: t }),
    r,
    n && /* @__PURE__ */ A.jsx(E1, { marginStart: o, children: n })
  ] }) : /* @__PURE__ */ A.jsxs(A.Fragment, { children: [
    t && /* @__PURE__ */ A.jsx(E1, { marginEnd: o, children: t }),
    r,
    n && /* @__PURE__ */ A.jsx(E1, { marginStart: o, children: n })
  ] });
}
const [Gq, D4] = iW("Card"), $q = Be(function(t, n) {
  const {
    className: r,
    children: o,
    direction: a = "column",
    justify: i,
    align: l,
    ...u
  } = Ln(t), d = yr("Card", t);
  return /* @__PURE__ */ A.jsx(
    xe.div,
    {
      ref: n,
      className: ze("chakra-card", r),
      __css: {
        display: "flex",
        flexDirection: a,
        justifyContent: i,
        alignItems: l,
        position: "relative",
        minWidth: 0,
        wordWrap: "break-word",
        ...d.container
      },
      ...u,
      children: /* @__PURE__ */ A.jsx(Gq, { value: d, children: o })
    }
  );
}), Zq = Be(
  function(t, n) {
    const { className: r, ...o } = t, a = D4();
    return /* @__PURE__ */ A.jsx(
      xe.div,
      {
        ref: n,
        className: ze("chakra-card__body", r),
        __css: a.body,
        ...o
      }
    );
  }
), jq = Be(
  function(t, n) {
    const { className: r, justify: o, ...a } = t, i = D4();
    return /* @__PURE__ */ A.jsx(
      xe.div,
      {
        ref: n,
        className: ze("chakra-card__footer", r),
        __css: {
          display: "flex",
          justifyContent: o,
          ...i.footer
        },
        ...a
      }
    );
  }
), Wq = Be(
  function(t, n) {
    const { className: r, ...o } = t, a = D4();
    return /* @__PURE__ */ A.jsx(
      xe.div,
      {
        ref: n,
        className: ze("chakra-card__header", r),
        __css: a.header,
        ...o
      }
    );
  }
), [zq, Uq] = mn({
  name: "CheckboxGroupContext",
  strict: !1
});
function Xq(e) {
  return /* @__PURE__ */ A.jsx(
    xe.svg,
    {
      width: "1.2em",
      viewBox: "0 0 12 10",
      style: {
        fill: "none",
        strokeWidth: 2,
        stroke: "currentColor",
        strokeDasharray: 16
      },
      ...e,
      children: /* @__PURE__ */ A.jsx("polyline", { points: "1.5 6 4.5 9 10.5 1" })
    }
  );
}
function Yq(e) {
  return /* @__PURE__ */ A.jsx(
    xe.svg,
    {
      width: "1.2em",
      viewBox: "0 0 24 24",
      style: { stroke: "currentColor", strokeWidth: 4 },
      ...e,
      children: /* @__PURE__ */ A.jsx("line", { x1: "21", x2: "3", y1: "12", y2: "12" })
    }
  );
}
function qq(e) {
  const { isIndeterminate: t, isChecked: n, ...r } = e, o = t ? Yq : Xq;
  return n || t ? /* @__PURE__ */ A.jsx(
    xe.div,
    {
      style: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100%"
      },
      children: /* @__PURE__ */ A.jsx(o, { ...r })
    }
  ) : null;
}
var Jq = () => typeof document < "u", rC = !1, Nd = null, wl = !1, G5 = !1, $5 = /* @__PURE__ */ new Set();
function P4(e, t) {
  $5.forEach((n) => n(e, t));
}
var Kq = typeof window < "u" && window.navigator != null ? /^Mac/.test(window.navigator.platform) : !1;
function Qq(e) {
  return !(e.metaKey || !Kq && e.altKey || e.ctrlKey || e.key === "Control" || e.key === "Shift" || e.key === "Meta");
}
function oC(e) {
  wl = !0, Qq(e) && (Nd = "keyboard", P4("keyboard", e));
}
function bu(e) {
  if (Nd = "pointer", e.type === "mousedown" || e.type === "pointerdown") {
    wl = !0;
    const t = e.composedPath ? e.composedPath()[0] : e.target;
    let n = !1;
    try {
      n = t.matches(":focus-visible");
    } catch {
    }
    if (n)
      return;
    P4("pointer", e);
  }
}
function eJ(e) {
  return e.mozInputSource === 0 && e.isTrusted ? !0 : e.detail === 0 && !e.pointerType;
}
function tJ(e) {
  eJ(e) && (wl = !0, Nd = "virtual");
}
function nJ(e) {
  e.target === window || e.target === document || e.target instanceof Element && e.target.hasAttribute("tabindex") || (!wl && !G5 && (Nd = "virtual", P4("virtual", e)), wl = !1, G5 = !1);
}
function rJ() {
  wl = !1, G5 = !0;
}
function aC() {
  return Nd !== "pointer";
}
function oJ() {
  if (!Jq() || rC)
    return;
  const { focus: e } = HTMLElement.prototype;
  HTMLElement.prototype.focus = function(...n) {
    wl = !0, e.apply(this, n);
  }, document.addEventListener("keydown", oC, !0), document.addEventListener("keyup", oC, !0), document.addEventListener("click", tJ, !0), window.addEventListener("focus", nJ, !0), window.addEventListener("blur", rJ, !1), typeof PointerEvent < "u" ? (document.addEventListener("pointerdown", bu, !0), document.addEventListener("pointermove", bu, !0), document.addEventListener("pointerup", bu, !0)) : (document.addEventListener("mousedown", bu, !0), document.addEventListener("mousemove", bu, !0), document.addEventListener("mouseup", bu, !0)), rC = !0;
}
function WM(e) {
  oJ(), e(aC());
  const t = () => e(aC());
  return $5.add(t), () => {
    $5.delete(t);
  };
}
const [aJ, zM] = mn({
  name: "FormControlStylesContext",
  errorMessage: `useFormControlStyles returned is 'undefined'. Seems you forgot to wrap the components in "<FormControl />" `
}), [iJ, Hl] = mn({
  strict: !1,
  name: "FormControlContext"
});
function sJ(e) {
  const {
    id: t,
    isRequired: n,
    isInvalid: r,
    isDisabled: o,
    isReadOnly: a,
    ...i
  } = e, l = Lo(), u = t || `field-${l}`, d = `${u}-label`, f = `${u}-feedback`, h = `${u}-helptext`, [p, g] = He(!1), [C, v] = He(!1), [y, M] = He(!1), x = Q(
    (P = {}, N = null) => ({
      id: h,
      ...P,
      /**
       * Notify the field context when the help text is rendered on screen,
       * so we can apply the correct `aria-describedby` to the field (e.g. input, textarea).
       */
      ref: In(N, (O) => {
        O && v(!0);
      })
    }),
    [h]
  ), _ = Q(
    (P = {}, N = null) => ({
      ...P,
      ref: N,
      "data-focus": Qe(y),
      "data-disabled": Qe(o),
      "data-invalid": Qe(r),
      "data-readonly": Qe(a),
      id: P.id !== void 0 ? P.id : d,
      htmlFor: P.htmlFor !== void 0 ? P.htmlFor : u
    }),
    [u, o, y, r, a, d]
  ), L = Q(
    (P = {}, N = null) => ({
      id: f,
      ...P,
      /**
       * Notify the field context when the error message is rendered on screen,
       * so we can apply the correct `aria-describedby` to the field (e.g. input, textarea).
       */
      ref: In(N, (O) => {
        O && g(!0);
      }),
      "aria-live": "polite"
    }),
    [f]
  ), R = Q(
    (P = {}, N = null) => ({
      ...P,
      ...i,
      ref: N,
      role: "group",
      "data-focus": Qe(y),
      "data-disabled": Qe(o),
      "data-invalid": Qe(r),
      "data-readonly": Qe(a)
    }),
    [i, o, y, r, a]
  ), k = Q(
    (P = {}, N = null) => ({
      ...P,
      ref: N,
      role: "presentation",
      "aria-hidden": !0,
      children: P.children || "*"
    }),
    []
  );
  return {
    isRequired: !!n,
    isInvalid: !!r,
    isReadOnly: !!a,
    isDisabled: !!o,
    isFocused: !!y,
    onFocus: () => M(!0),
    onBlur: () => M(!1),
    hasFeedbackText: p,
    setHasFeedbackText: g,
    hasHelpText: C,
    setHasHelpText: v,
    id: u,
    labelId: d,
    feedbackId: f,
    helpTextId: h,
    htmlProps: i,
    getHelpTextProps: x,
    getErrorMessageProps: L,
    getRootProps: R,
    getLabelProps: _,
    getRequiredIndicatorProps: k
  };
}
const UM = Be(
  function(t, n) {
    const r = yr("Form", t), o = Ln(t), {
      getRootProps: a,
      htmlProps: i,
      ...l
    } = sJ(o), u = ze("chakra-form-control", t.className);
    return /* @__PURE__ */ A.jsx(iJ, { value: l, children: /* @__PURE__ */ A.jsx(aJ, { value: r, children: /* @__PURE__ */ A.jsx(
      xe.div,
      {
        ...a({}, n),
        className: u,
        __css: r.container
      }
    ) }) });
  }
);
UM.displayName = "FormControl";
const XM = Be(
  function(t, n) {
    const r = Hl(), o = zM(), a = ze("chakra-form__helper-text", t.className);
    return /* @__PURE__ */ A.jsx(
      xe.div,
      {
        ...r == null ? void 0 : r.getHelpTextProps(t, n),
        __css: o.helperText,
        className: a
      }
    );
  }
);
XM.displayName = "FormHelperText";
function E4(e) {
  const { isDisabled: t, isInvalid: n, isReadOnly: r, isRequired: o, ...a } = T4(e);
  return {
    ...a,
    disabled: t,
    readOnly: r,
    required: o,
    "aria-invalid": vi(n),
    "aria-required": vi(o),
    "aria-readonly": vi(r)
  };
}
function T4(e) {
  const t = Hl(), {
    id: n,
    disabled: r,
    readOnly: o,
    required: a,
    isRequired: i,
    isInvalid: l,
    isReadOnly: u,
    isDisabled: d,
    onFocus: f,
    onBlur: h,
    ...p
  } = e, g = e["aria-describedby"] ? [e["aria-describedby"]] : [];
  return t != null && t.hasFeedbackText && (t != null && t.isInvalid) && g.push(t.feedbackId), t != null && t.hasHelpText && g.push(t.helpTextId), {
    ...p,
    "aria-describedby": g.join(" ") || void 0,
    id: n ?? (t == null ? void 0 : t.id),
    isDisabled: r ?? d ?? (t == null ? void 0 : t.isDisabled),
    isReadOnly: o ?? u ?? (t == null ? void 0 : t.isReadOnly),
    isRequired: a ?? i ?? (t == null ? void 0 : t.isRequired),
    isInvalid: l ?? (t == null ? void 0 : t.isInvalid),
    onFocus: qe(t == null ? void 0 : t.onFocus, f),
    onBlur: qe(t == null ? void 0 : t.onBlur, h)
  };
}
const YM = {
  border: "0",
  clip: "rect(0, 0, 0, 0)",
  height: "1px",
  width: "1px",
  margin: "-1px",
  padding: "0",
  overflow: "hidden",
  whiteSpace: "nowrap",
  position: "absolute"
};
function qM(e = {}) {
  const t = T4(e), {
    isDisabled: n,
    isReadOnly: r,
    isRequired: o,
    isInvalid: a,
    id: i,
    onBlur: l,
    onFocus: u,
    "aria-describedby": d
  } = t, {
    defaultChecked: f,
    isChecked: h,
    isFocusable: p,
    onChange: g,
    isIndeterminate: C,
    name: v,
    value: y,
    tabIndex: M = void 0,
    "aria-label": x,
    "aria-labelledby": _,
    "aria-invalid": L,
    ...R
  } = e, k = Mh(R, [
    "isDisabled",
    "isReadOnly",
    "isRequired",
    "isInvalid",
    "id",
    "onBlur",
    "onFocus",
    "aria-describedby"
  ]), P = ur(g), N = ur(l), O = ur(u), [H, $] = He(!1), [ne, ie] = He(!1), [re, ve] = He(!1), ue = Ve(!1);
  st(() => WM((Re) => {
    ue.current = Re;
  }), []);
  const j = Ve(null), [K, ce] = He(!0), [U, q] = He(!!f), ge = h !== void 0, X = ge ? h : U, he = Q(
    (Re) => {
      if (r || n) {
        Re.preventDefault();
        return;
      }
      ge || q(X ? Re.currentTarget.checked : C ? !0 : Re.currentTarget.checked), P == null || P(Re);
    },
    [
      r,
      n,
      X,
      ge,
      C,
      P
    ]
  );
  Ci(() => {
    j.current && (j.current.indeterminate = !!C);
  }, [C]), Ss(() => {
    n && $(!1);
  }, [n, $]), Ci(() => {
    const Re = j.current;
    if (!(Re != null && Re.form))
      return;
    const _t = () => {
      q(!!f);
    };
    return Re.form.addEventListener("reset", _t), () => {
      var on;
      return (on = Re.form) == null ? void 0 : on.removeEventListener("reset", _t);
    };
  }, []);
  const me = n && !p, de = Q(
    (Re) => {
      Re.key === " " && ve(!0);
    },
    [ve]
  ), Le = Q(
    (Re) => {
      Re.key === " " && ve(!1);
    },
    [ve]
  );
  Ci(() => {
    if (!j.current)
      return;
    j.current.checked !== X && q(j.current.checked);
  }, [j.current]);
  const Ie = Q(
    (Re = {}, _t = null) => {
      const on = ($e) => {
        H && $e.preventDefault(), ve(!0);
      };
      return {
        ...Re,
        ref: _t,
        "data-active": Qe(re),
        "data-hover": Qe(ne),
        "data-checked": Qe(X),
        "data-focus": Qe(H),
        "data-focus-visible": Qe(H && ue.current),
        "data-indeterminate": Qe(C),
        "data-disabled": Qe(n),
        "data-invalid": Qe(a),
        "data-readonly": Qe(r),
        "aria-hidden": !0,
        onMouseDown: qe(Re.onMouseDown, on),
        onMouseUp: qe(Re.onMouseUp, () => ve(!1)),
        onMouseEnter: qe(
          Re.onMouseEnter,
          () => ie(!0)
        ),
        onMouseLeave: qe(
          Re.onMouseLeave,
          () => ie(!1)
        )
      };
    },
    [
      re,
      X,
      n,
      H,
      ne,
      C,
      a,
      r
    ]
  ), Ne = Q(
    (Re = {}, _t = null) => ({
      ...Re,
      ref: _t,
      "data-active": Qe(re),
      "data-hover": Qe(ne),
      "data-checked": Qe(X),
      "data-focus": Qe(H),
      "data-focus-visible": Qe(H && ue.current),
      "data-indeterminate": Qe(C),
      "data-disabled": Qe(n),
      "data-invalid": Qe(a),
      "data-readonly": Qe(r)
    }),
    [
      re,
      X,
      n,
      H,
      ne,
      C,
      a,
      r
    ]
  ), ye = Q(
    (Re = {}, _t = null) => ({
      ...k,
      ...Re,
      ref: In(_t, (on) => {
        on && ce(on.tagName === "LABEL");
      }),
      onClick: qe(Re.onClick, () => {
        var on;
        K || ((on = j.current) == null || on.click(), requestAnimationFrame(() => {
          var $e;
          ($e = j.current) == null || $e.focus({ preventScroll: !0 });
        }));
      }),
      "data-disabled": Qe(n),
      "data-checked": Qe(X),
      "data-invalid": Qe(a)
    }),
    [k, n, X, a, K]
  ), ke = Q(
    (Re = {}, _t = null) => ({
      ...Re,
      ref: In(j, _t),
      type: "checkbox",
      name: v,
      value: y,
      id: i,
      tabIndex: M,
      onChange: qe(Re.onChange, he),
      onBlur: qe(
        Re.onBlur,
        N,
        () => $(!1)
      ),
      onFocus: qe(
        Re.onFocus,
        O,
        () => $(!0)
      ),
      onKeyDown: qe(Re.onKeyDown, de),
      onKeyUp: qe(Re.onKeyUp, Le),
      required: o,
      checked: X,
      disabled: me,
      readOnly: r,
      "aria-label": x,
      "aria-labelledby": _,
      "aria-invalid": L ? !!L : a,
      "aria-describedby": d,
      "aria-disabled": n,
      "aria-checked": C ? "mixed" : X,
      style: YM
    }),
    [
      v,
      y,
      i,
      M,
      he,
      N,
      O,
      de,
      Le,
      o,
      X,
      me,
      r,
      x,
      _,
      L,
      a,
      d,
      n,
      C
    ]
  ), oe = Q(
    (Re = {}, _t = null) => ({
      ...Re,
      ref: _t,
      onMouseDown: qe(Re.onMouseDown, lJ),
      "data-disabled": Qe(n),
      "data-checked": Qe(X),
      "data-invalid": Qe(a)
    }),
    [X, n, a]
  );
  return {
    state: {
      isInvalid: a,
      isFocused: H,
      isChecked: X,
      isActive: re,
      isHovered: ne,
      isIndeterminate: C,
      isDisabled: n,
      isReadOnly: r,
      isRequired: o
    },
    getRootProps: ye,
    getCheckboxProps: Ie,
    getIndicatorProps: Ne,
    getInputProps: ke,
    getLabelProps: oe,
    htmlProps: k
  };
}
function lJ(e) {
  e.preventDefault(), e.stopPropagation();
}
function uJ(e) {
  const [t, n] = He(e), [r, o] = He(!1);
  return e !== t && (o(!0), n(e)), r;
}
const cJ = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  verticalAlign: "top",
  userSelect: "none",
  flexShrink: 0
}, dJ = {
  cursor: "pointer",
  display: "inline-flex",
  alignItems: "center",
  verticalAlign: "top",
  position: "relative"
}, fJ = Md({
  from: {
    opacity: 0,
    strokeDashoffset: 16,
    transform: "scale(0.95)"
  },
  to: {
    opacity: 1,
    strokeDashoffset: 0,
    transform: "scale(1)"
  }
}), hJ = Md({
  from: {
    opacity: 0
  },
  to: {
    opacity: 1
  }
}), mJ = Md({
  from: {
    transform: "scaleX(0.65)"
  },
  to: {
    transform: "scaleX(1)"
  }
}), N4 = Be(
  function(t, n) {
    const r = Uq(), o = { ...r, ...t }, a = yr("Checkbox", o), i = Ln(t), {
      spacing: l = "0.5rem",
      className: u,
      children: d,
      iconColor: f,
      iconSize: h,
      icon: p = /* @__PURE__ */ A.jsx(qq, {}),
      isChecked: g,
      isDisabled: C = r == null ? void 0 : r.isDisabled,
      onChange: v,
      inputProps: y,
      ...M
    } = i;
    let x = g;
    r != null && r.value && i.value && (x = r.value.includes(i.value));
    let _ = v;
    r != null && r.onChange && i.value && (_ = Ah(r.onChange, v));
    const {
      state: L,
      getInputProps: R,
      getCheckboxProps: k,
      getLabelProps: P,
      getRootProps: N
    } = qM({
      ...M,
      isDisabled: C,
      isChecked: x,
      onChange: _
    }), O = uJ(L.isChecked), H = bt(
      () => ({
        animation: O ? L.isIndeterminate ? `${hJ} 20ms linear, ${mJ} 200ms linear` : `${fJ} 200ms linear` : void 0,
        ...a.icon,
        ...Z3({
          fontSize: h,
          color: f
        })
      }),
      [f, h, O, L.isIndeterminate, a.icon]
    ), $ = Yo(p, {
      __css: H,
      isIndeterminate: L.isIndeterminate,
      isChecked: L.isChecked
    });
    return /* @__PURE__ */ A.jsxs(
      xe.label,
      {
        __css: { ...dJ, ...a.container },
        className: ze("chakra-checkbox", u),
        ...N(),
        children: [
          /* @__PURE__ */ A.jsx(
            "input",
            {
              className: "chakra-checkbox__input",
              ...R(y, n)
            }
          ),
          /* @__PURE__ */ A.jsx(
            xe.span,
            {
              __css: { ...cJ, ...a.control },
              className: "chakra-checkbox__control",
              ...k(),
              children: $
            }
          ),
          d && /* @__PURE__ */ A.jsx(
            xe.span,
            {
              className: "chakra-checkbox__label",
              ...P(),
              __css: {
                marginStart: l,
                ...a.label
              },
              children: d
            }
          )
        ]
      }
    );
  }
);
N4.displayName = "Checkbox";
function iC(e) {
  return e && cr(e) && cr(e.target);
}
function pJ(e = {}) {
  const {
    defaultValue: t,
    value: n,
    onChange: r,
    isDisabled: o,
    isNative: a
  } = e, i = ur(r), [l, u] = xS({
    value: n,
    defaultValue: t || [],
    onChange: i
  }), d = Q(
    (h) => {
      if (!l)
        return;
      const p = iC(h) ? h.target.checked : !l.includes(h), g = iC(h) ? h.target.value : h, C = p ? [...l, g] : l.filter((v) => String(v) !== String(g));
      u(C);
    },
    [u, l]
  ), f = Q(
    (h = {}) => ({
      ...h,
      [a ? "checked" : "isChecked"]: l.some((g) => String(h.value) === String(g)),
      onChange: d
    }),
    [d, a, l]
  );
  return {
    value: l,
    isDisabled: o,
    onChange: d,
    setValue: u,
    getCheckboxProps: f
  };
}
function JM(e) {
  const { colorScheme: t, size: n, variant: r, children: o, isDisabled: a } = e, { value: i, onChange: l } = pJ(e), u = bt(
    () => ({
      size: n,
      onChange: l,
      colorScheme: t,
      value: i,
      variant: r,
      isDisabled: a
    }),
    [n, l, t, i, r, a]
  );
  return /* @__PURE__ */ A.jsx(zq, { value: u, children: o });
}
JM.displayName = "CheckboxGroup";
const KM = Be(
  function(t, n) {
    const {
      borderLeftWidth: r,
      borderBottomWidth: o,
      borderTopWidth: a,
      borderRightWidth: i,
      borderWidth: l,
      borderStyle: u,
      borderColor: d,
      ...f
    } = Ua("Divider", t), {
      className: h,
      orientation: p = "horizontal",
      __css: g,
      ...C
    } = Ln(t), v = {
      vertical: {
        borderLeftWidth: r || i || l || "1px",
        height: "100%"
      },
      horizontal: {
        borderBottomWidth: o || a || l || "1px",
        width: "100%"
      }
    };
    return /* @__PURE__ */ A.jsx(
      xe.hr,
      {
        ref: n,
        "aria-orientation": p,
        ...C,
        __css: {
          ...f,
          border: "0",
          borderColor: d,
          borderStyle: u,
          ...v[p],
          ...g
        },
        className: ze("chakra-divider", h)
      }
    );
  }
);
KM.displayName = "Divider";
function T1(e) {
  return typeof e == "function";
}
function gJ(...e) {
  return (t) => e.reduce((n, r) => r(n), t);
}
const vJ = (e) => function(...n) {
  let r = [...n], o = n[n.length - 1];
  return Xj(o) && // this ensures backward compatibility
  // previously only `extendTheme(override, activeTheme?)` was allowed
  r.length > 1 ? r = r.slice(0, r.length - 1) : o = e, gJ(
    ...r.map(
      (a) => (i) => T1(a) ? a(i) : bJ(i, a)
    )
  )(o);
}, CJ = vJ(JS);
function bJ(...e) {
  return zo({}, ...e, QM);
}
function QM(e, t, n, r) {
  if ((T1(e) || T1(t)) && Object.prototype.hasOwnProperty.call(r, n))
    return (...o) => {
      const a = T1(e) ? e(...o) : e, i = T1(t) ? t(...o) : t;
      return zo({}, a, i, QM);
    };
  if (cr(e) && p5(t) || p5(e) && cr(t))
    return t;
}
const fd = Be(function(t, n) {
  const { direction: r, align: o, justify: a, wrap: i, basis: l, grow: u, shrink: d, ...f } = t, h = {
    display: "flex",
    flexDirection: r,
    alignItems: o,
    justifyContent: a,
    flexWrap: i,
    flexBasis: l,
    flexGrow: u,
    flexShrink: d
  };
  return /* @__PURE__ */ A.jsx(xe.div, { ref: n, __css: h, ...f });
});
fd.displayName = "Flex";
function ex(e, t) {
  if (e == null)
    return {};
  var n = {};
  for (var r in e)
    if ({}.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) !== -1)
        continue;
      n[r] = e[r];
    }
  return n;
}
function et() {
  return et = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, et.apply(null, arguments);
}
var Z5 = { exports: {} }, gf = { exports: {} }, sn = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var sC;
function yJ() {
  if (sC)
    return sn;
  sC = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, a = e ? Symbol.for("react.profiler") : 60114, i = e ? Symbol.for("react.provider") : 60109, l = e ? Symbol.for("react.context") : 60110, u = e ? Symbol.for("react.async_mode") : 60111, d = e ? Symbol.for("react.concurrent_mode") : 60111, f = e ? Symbol.for("react.forward_ref") : 60112, h = e ? Symbol.for("react.suspense") : 60113, p = e ? Symbol.for("react.suspense_list") : 60120, g = e ? Symbol.for("react.memo") : 60115, C = e ? Symbol.for("react.lazy") : 60116, v = e ? Symbol.for("react.block") : 60121, y = e ? Symbol.for("react.fundamental") : 60117, M = e ? Symbol.for("react.responder") : 60118, x = e ? Symbol.for("react.scope") : 60119;
  function _(R) {
    if (typeof R == "object" && R !== null) {
      var k = R.$$typeof;
      switch (k) {
        case t:
          switch (R = R.type, R) {
            case u:
            case d:
            case r:
            case a:
            case o:
            case h:
              return R;
            default:
              switch (R = R && R.$$typeof, R) {
                case l:
                case f:
                case C:
                case g:
                case i:
                  return R;
                default:
                  return k;
              }
          }
        case n:
          return k;
      }
    }
  }
  function L(R) {
    return _(R) === d;
  }
  return sn.AsyncMode = u, sn.ConcurrentMode = d, sn.ContextConsumer = l, sn.ContextProvider = i, sn.Element = t, sn.ForwardRef = f, sn.Fragment = r, sn.Lazy = C, sn.Memo = g, sn.Portal = n, sn.Profiler = a, sn.StrictMode = o, sn.Suspense = h, sn.isAsyncMode = function(R) {
    return L(R) || _(R) === u;
  }, sn.isConcurrentMode = L, sn.isContextConsumer = function(R) {
    return _(R) === l;
  }, sn.isContextProvider = function(R) {
    return _(R) === i;
  }, sn.isElement = function(R) {
    return typeof R == "object" && R !== null && R.$$typeof === t;
  }, sn.isForwardRef = function(R) {
    return _(R) === f;
  }, sn.isFragment = function(R) {
    return _(R) === r;
  }, sn.isLazy = function(R) {
    return _(R) === C;
  }, sn.isMemo = function(R) {
    return _(R) === g;
  }, sn.isPortal = function(R) {
    return _(R) === n;
  }, sn.isProfiler = function(R) {
    return _(R) === a;
  }, sn.isStrictMode = function(R) {
    return _(R) === o;
  }, sn.isSuspense = function(R) {
    return _(R) === h;
  }, sn.isValidElementType = function(R) {
    return typeof R == "string" || typeof R == "function" || R === r || R === d || R === a || R === o || R === h || R === p || typeof R == "object" && R !== null && (R.$$typeof === C || R.$$typeof === g || R.$$typeof === i || R.$$typeof === l || R.$$typeof === f || R.$$typeof === y || R.$$typeof === M || R.$$typeof === x || R.$$typeof === v);
  }, sn.typeOf = _, sn;
}
var ln = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var lC;
function SJ() {
  return lC || (lC = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, a = e ? Symbol.for("react.profiler") : 60114, i = e ? Symbol.for("react.provider") : 60109, l = e ? Symbol.for("react.context") : 60110, u = e ? Symbol.for("react.async_mode") : 60111, d = e ? Symbol.for("react.concurrent_mode") : 60111, f = e ? Symbol.for("react.forward_ref") : 60112, h = e ? Symbol.for("react.suspense") : 60113, p = e ? Symbol.for("react.suspense_list") : 60120, g = e ? Symbol.for("react.memo") : 60115, C = e ? Symbol.for("react.lazy") : 60116, v = e ? Symbol.for("react.block") : 60121, y = e ? Symbol.for("react.fundamental") : 60117, M = e ? Symbol.for("react.responder") : 60118, x = e ? Symbol.for("react.scope") : 60119;
    function _(oe) {
      return typeof oe == "string" || typeof oe == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      oe === r || oe === d || oe === a || oe === o || oe === h || oe === p || typeof oe == "object" && oe !== null && (oe.$$typeof === C || oe.$$typeof === g || oe.$$typeof === i || oe.$$typeof === l || oe.$$typeof === f || oe.$$typeof === y || oe.$$typeof === M || oe.$$typeof === x || oe.$$typeof === v);
    }
    function L(oe) {
      if (typeof oe == "object" && oe !== null) {
        var lt = oe.$$typeof;
        switch (lt) {
          case t:
            var Re = oe.type;
            switch (Re) {
              case u:
              case d:
              case r:
              case a:
              case o:
              case h:
                return Re;
              default:
                var _t = Re && Re.$$typeof;
                switch (_t) {
                  case l:
                  case f:
                  case C:
                  case g:
                  case i:
                    return _t;
                  default:
                    return lt;
                }
            }
          case n:
            return lt;
        }
      }
    }
    var R = u, k = d, P = l, N = i, O = t, H = f, $ = r, ne = C, ie = g, re = n, ve = a, ue = o, j = h, K = !1;
    function ce(oe) {
      return K || (K = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), U(oe) || L(oe) === u;
    }
    function U(oe) {
      return L(oe) === d;
    }
    function q(oe) {
      return L(oe) === l;
    }
    function ge(oe) {
      return L(oe) === i;
    }
    function X(oe) {
      return typeof oe == "object" && oe !== null && oe.$$typeof === t;
    }
    function he(oe) {
      return L(oe) === f;
    }
    function me(oe) {
      return L(oe) === r;
    }
    function de(oe) {
      return L(oe) === C;
    }
    function Le(oe) {
      return L(oe) === g;
    }
    function Ie(oe) {
      return L(oe) === n;
    }
    function Ne(oe) {
      return L(oe) === a;
    }
    function ye(oe) {
      return L(oe) === o;
    }
    function ke(oe) {
      return L(oe) === h;
    }
    ln.AsyncMode = R, ln.ConcurrentMode = k, ln.ContextConsumer = P, ln.ContextProvider = N, ln.Element = O, ln.ForwardRef = H, ln.Fragment = $, ln.Lazy = ne, ln.Memo = ie, ln.Portal = re, ln.Profiler = ve, ln.StrictMode = ue, ln.Suspense = j, ln.isAsyncMode = ce, ln.isConcurrentMode = U, ln.isContextConsumer = q, ln.isContextProvider = ge, ln.isElement = X, ln.isForwardRef = he, ln.isFragment = me, ln.isLazy = de, ln.isMemo = Le, ln.isPortal = Ie, ln.isProfiler = Ne, ln.isStrictMode = ye, ln.isSuspense = ke, ln.isValidElementType = _, ln.typeOf = L;
  }()), ln;
}
var uC;
function tx() {
  return uC || (uC = 1, process.env.NODE_ENV === "production" ? gf.exports = yJ() : gf.exports = SJ()), gf.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var Sg, cC;
function AJ() {
  if (cC)
    return Sg;
  cC = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function r(a) {
    if (a == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(a);
  }
  function o() {
    try {
      if (!Object.assign)
        return !1;
      var a = new String("abc");
      if (a[5] = "de", Object.getOwnPropertyNames(a)[0] === "5")
        return !1;
      for (var i = {}, l = 0; l < 10; l++)
        i["_" + String.fromCharCode(l)] = l;
      var u = Object.getOwnPropertyNames(i).map(function(f) {
        return i[f];
      });
      if (u.join("") !== "0123456789")
        return !1;
      var d = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(f) {
        d[f] = f;
      }), Object.keys(Object.assign({}, d)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return Sg = o() ? Object.assign : function(a, i) {
    for (var l, u = r(a), d, f = 1; f < arguments.length; f++) {
      l = Object(arguments[f]);
      for (var h in l)
        t.call(l, h) && (u[h] = l[h]);
      if (e) {
        d = e(l);
        for (var p = 0; p < d.length; p++)
          n.call(l, d[p]) && (u[d[p]] = l[d[p]]);
      }
    }
    return u;
  }, Sg;
}
var Ag, dC;
function k4() {
  if (dC)
    return Ag;
  dC = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return Ag = e, Ag;
}
var Mg, fC;
function nx() {
  return fC || (fC = 1, Mg = Function.call.bind(Object.prototype.hasOwnProperty)), Mg;
}
var xg, hC;
function MJ() {
  if (hC)
    return xg;
  hC = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = k4(), n = {}, r = nx();
    e = function(a) {
      var i = "Warning: " + a;
      typeof console < "u" && console.error(i);
      try {
        throw new Error(i);
      } catch {
      }
    };
  }
  function o(a, i, l, u, d) {
    if (process.env.NODE_ENV !== "production") {
      for (var f in a)
        if (r(a, f)) {
          var h;
          try {
            if (typeof a[f] != "function") {
              var p = Error(
                (u || "React class") + ": " + l + " type `" + f + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof a[f] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw p.name = "Invariant Violation", p;
            }
            h = a[f](i, f, u, l, null, t);
          } catch (C) {
            h = C;
          }
          if (h && !(h instanceof Error) && e(
            (u || "React class") + ": type specification of " + l + " `" + f + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof h + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), h instanceof Error && !(h.message in n)) {
            n[h.message] = !0;
            var g = d ? d() : "";
            e(
              "Failed " + l + " type: " + h.message + (g ?? "")
            );
          }
        }
    }
  }
  return o.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, xg = o, xg;
}
var wg, mC;
function xJ() {
  if (mC)
    return wg;
  mC = 1;
  var e = tx(), t = AJ(), n = k4(), r = nx(), o = MJ(), a = function() {
  };
  process.env.NODE_ENV !== "production" && (a = function(l) {
    var u = "Warning: " + l;
    typeof console < "u" && console.error(u);
    try {
      throw new Error(u);
    } catch {
    }
  });
  function i() {
    return null;
  }
  return wg = function(l, u) {
    var d = typeof Symbol == "function" && Symbol.iterator, f = "@@iterator";
    function h(U) {
      var q = U && (d && U[d] || U[f]);
      if (typeof q == "function")
        return q;
    }
    var p = "<<anonymous>>", g = {
      array: M("array"),
      bigint: M("bigint"),
      bool: M("boolean"),
      func: M("function"),
      number: M("number"),
      object: M("object"),
      string: M("string"),
      symbol: M("symbol"),
      any: x(),
      arrayOf: _,
      element: L(),
      elementType: R(),
      instanceOf: k,
      node: H(),
      objectOf: N,
      oneOf: P,
      oneOfType: O,
      shape: ne,
      exact: ie
    };
    function C(U, q) {
      return U === q ? U !== 0 || 1 / U === 1 / q : U !== U && q !== q;
    }
    function v(U, q) {
      this.message = U, this.data = q && typeof q == "object" ? q : {}, this.stack = "";
    }
    v.prototype = Error.prototype;
    function y(U) {
      if (process.env.NODE_ENV !== "production")
        var q = {}, ge = 0;
      function X(me, de, Le, Ie, Ne, ye, ke) {
        if (Ie = Ie || p, ye = ye || Le, ke !== n) {
          if (u) {
            var oe = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw oe.name = "Invariant Violation", oe;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var lt = Ie + ":" + Le;
            !q[lt] && // Avoid spamming the console because they are often not actionable except for lib authors
            ge < 3 && (a(
              "You are manually calling a React.PropTypes validation function for the `" + ye + "` prop on `" + Ie + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), q[lt] = !0, ge++);
          }
        }
        return de[Le] == null ? me ? de[Le] === null ? new v("The " + Ne + " `" + ye + "` is marked as required " + ("in `" + Ie + "`, but its value is `null`.")) : new v("The " + Ne + " `" + ye + "` is marked as required in " + ("`" + Ie + "`, but its value is `undefined`.")) : null : U(de, Le, Ie, Ne, ye);
      }
      var he = X.bind(null, !1);
      return he.isRequired = X.bind(null, !0), he;
    }
    function M(U) {
      function q(ge, X, he, me, de, Le) {
        var Ie = ge[X], Ne = ue(Ie);
        if (Ne !== U) {
          var ye = j(Ie);
          return new v(
            "Invalid " + me + " `" + de + "` of type " + ("`" + ye + "` supplied to `" + he + "`, expected ") + ("`" + U + "`."),
            { expectedType: U }
          );
        }
        return null;
      }
      return y(q);
    }
    function x() {
      return y(i);
    }
    function _(U) {
      function q(ge, X, he, me, de) {
        if (typeof U != "function")
          return new v("Property `" + de + "` of component `" + he + "` has invalid PropType notation inside arrayOf.");
        var Le = ge[X];
        if (!Array.isArray(Le)) {
          var Ie = ue(Le);
          return new v("Invalid " + me + " `" + de + "` of type " + ("`" + Ie + "` supplied to `" + he + "`, expected an array."));
        }
        for (var Ne = 0; Ne < Le.length; Ne++) {
          var ye = U(Le, Ne, he, me, de + "[" + Ne + "]", n);
          if (ye instanceof Error)
            return ye;
        }
        return null;
      }
      return y(q);
    }
    function L() {
      function U(q, ge, X, he, me) {
        var de = q[ge];
        if (!l(de)) {
          var Le = ue(de);
          return new v("Invalid " + he + " `" + me + "` of type " + ("`" + Le + "` supplied to `" + X + "`, expected a single ReactElement."));
        }
        return null;
      }
      return y(U);
    }
    function R() {
      function U(q, ge, X, he, me) {
        var de = q[ge];
        if (!e.isValidElementType(de)) {
          var Le = ue(de);
          return new v("Invalid " + he + " `" + me + "` of type " + ("`" + Le + "` supplied to `" + X + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return y(U);
    }
    function k(U) {
      function q(ge, X, he, me, de) {
        if (!(ge[X] instanceof U)) {
          var Le = U.name || p, Ie = ce(ge[X]);
          return new v("Invalid " + me + " `" + de + "` of type " + ("`" + Ie + "` supplied to `" + he + "`, expected ") + ("instance of `" + Le + "`."));
        }
        return null;
      }
      return y(q);
    }
    function P(U) {
      if (!Array.isArray(U))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? a(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : a("Invalid argument supplied to oneOf, expected an array.")), i;
      function q(ge, X, he, me, de) {
        for (var Le = ge[X], Ie = 0; Ie < U.length; Ie++)
          if (C(Le, U[Ie]))
            return null;
        var Ne = JSON.stringify(U, function(ke, oe) {
          var lt = j(oe);
          return lt === "symbol" ? String(oe) : oe;
        });
        return new v("Invalid " + me + " `" + de + "` of value `" + String(Le) + "` " + ("supplied to `" + he + "`, expected one of " + Ne + "."));
      }
      return y(q);
    }
    function N(U) {
      function q(ge, X, he, me, de) {
        if (typeof U != "function")
          return new v("Property `" + de + "` of component `" + he + "` has invalid PropType notation inside objectOf.");
        var Le = ge[X], Ie = ue(Le);
        if (Ie !== "object")
          return new v("Invalid " + me + " `" + de + "` of type " + ("`" + Ie + "` supplied to `" + he + "`, expected an object."));
        for (var Ne in Le)
          if (r(Le, Ne)) {
            var ye = U(Le, Ne, he, me, de + "." + Ne, n);
            if (ye instanceof Error)
              return ye;
          }
        return null;
      }
      return y(q);
    }
    function O(U) {
      if (!Array.isArray(U))
        return process.env.NODE_ENV !== "production" && a("Invalid argument supplied to oneOfType, expected an instance of array."), i;
      for (var q = 0; q < U.length; q++) {
        var ge = U[q];
        if (typeof ge != "function")
          return a(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + K(ge) + " at index " + q + "."
          ), i;
      }
      function X(he, me, de, Le, Ie) {
        for (var Ne = [], ye = 0; ye < U.length; ye++) {
          var ke = U[ye], oe = ke(he, me, de, Le, Ie, n);
          if (oe == null)
            return null;
          oe.data && r(oe.data, "expectedType") && Ne.push(oe.data.expectedType);
        }
        var lt = Ne.length > 0 ? ", expected one of type [" + Ne.join(", ") + "]" : "";
        return new v("Invalid " + Le + " `" + Ie + "` supplied to " + ("`" + de + "`" + lt + "."));
      }
      return y(X);
    }
    function H() {
      function U(q, ge, X, he, me) {
        return re(q[ge]) ? null : new v("Invalid " + he + " `" + me + "` supplied to " + ("`" + X + "`, expected a ReactNode."));
      }
      return y(U);
    }
    function $(U, q, ge, X, he) {
      return new v(
        (U || "React class") + ": " + q + " type `" + ge + "." + X + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + he + "`."
      );
    }
    function ne(U) {
      function q(ge, X, he, me, de) {
        var Le = ge[X], Ie = ue(Le);
        if (Ie !== "object")
          return new v("Invalid " + me + " `" + de + "` of type `" + Ie + "` " + ("supplied to `" + he + "`, expected `object`."));
        for (var Ne in U) {
          var ye = U[Ne];
          if (typeof ye != "function")
            return $(he, me, de, Ne, j(ye));
          var ke = ye(Le, Ne, he, me, de + "." + Ne, n);
          if (ke)
            return ke;
        }
        return null;
      }
      return y(q);
    }
    function ie(U) {
      function q(ge, X, he, me, de) {
        var Le = ge[X], Ie = ue(Le);
        if (Ie !== "object")
          return new v("Invalid " + me + " `" + de + "` of type `" + Ie + "` " + ("supplied to `" + he + "`, expected `object`."));
        var Ne = t({}, ge[X], U);
        for (var ye in Ne) {
          var ke = U[ye];
          if (r(U, ye) && typeof ke != "function")
            return $(he, me, de, ye, j(ke));
          if (!ke)
            return new v(
              "Invalid " + me + " `" + de + "` key `" + ye + "` supplied to `" + he + "`.\nBad object: " + JSON.stringify(ge[X], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(U), null, "  ")
            );
          var oe = ke(Le, ye, he, me, de + "." + ye, n);
          if (oe)
            return oe;
        }
        return null;
      }
      return y(q);
    }
    function re(U) {
      switch (typeof U) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !U;
        case "object":
          if (Array.isArray(U))
            return U.every(re);
          if (U === null || l(U))
            return !0;
          var q = h(U);
          if (q) {
            var ge = q.call(U), X;
            if (q !== U.entries) {
              for (; !(X = ge.next()).done; )
                if (!re(X.value))
                  return !1;
            } else
              for (; !(X = ge.next()).done; ) {
                var he = X.value;
                if (he && !re(he[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function ve(U, q) {
      return U === "symbol" ? !0 : q ? q["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && q instanceof Symbol : !1;
    }
    function ue(U) {
      var q = typeof U;
      return Array.isArray(U) ? "array" : U instanceof RegExp ? "object" : ve(q, U) ? "symbol" : q;
    }
    function j(U) {
      if (typeof U > "u" || U === null)
        return "" + U;
      var q = ue(U);
      if (q === "object") {
        if (U instanceof Date)
          return "date";
        if (U instanceof RegExp)
          return "regexp";
      }
      return q;
    }
    function K(U) {
      var q = j(U);
      switch (q) {
        case "array":
        case "object":
          return "an " + q;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + q;
        default:
          return q;
      }
    }
    function ce(U) {
      return !U.constructor || !U.constructor.name ? p : U.constructor.name;
    }
    return g.checkPropTypes = o, g.resetWarningCache = o.resetWarningCache, g.PropTypes = g, g;
  }, wg;
}
var _g, pC;
function wJ() {
  if (pC)
    return _g;
  pC = 1;
  var e = k4();
  function t() {
  }
  function n() {
  }
  return n.resetWarningCache = t, _g = function() {
    function r(i, l, u, d, f, h) {
      if (h !== e) {
        var p = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw p.name = "Invariant Violation", p;
      }
    }
    r.isRequired = r;
    function o() {
      return r;
    }
    var a = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: o,
      element: r,
      elementType: r,
      instanceOf: o,
      node: r,
      objectOf: o,
      oneOf: o,
      oneOfType: o,
      shape: o,
      exact: o,
      checkPropTypes: n,
      resetWarningCache: t
    };
    return a.PropTypes = a, a;
  }, _g;
}
if (process.env.NODE_ENV !== "production") {
  var _J = tx(), IJ = !0;
  Z5.exports = xJ()(_J.isElement, IJ);
} else
  Z5.exports = wJ()();
var yn = Z5.exports;
const Lr = /* @__PURE__ */ yh(yn);
var j5 = "data-focus-lock", rx = "data-focus-lock-disabled", LJ = "data-no-focus-lock", RJ = "data-autofocus-inside", DJ = "data-no-autofocus";
function Ig(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function PJ(e, t) {
  var n = He(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(r) {
          var o = n.value;
          o !== r && (n.value = r, n.callback(r, o));
        }
      }
    };
  })[0];
  return n.callback = t, n.facade;
}
var EJ = typeof window < "u" ? Ee.useLayoutEffect : Ee.useEffect, gC = /* @__PURE__ */ new WeakMap();
function ox(e, t) {
  var n = PJ(t || null, function(r) {
    return e.forEach(function(o) {
      return Ig(o, r);
    });
  });
  return EJ(function() {
    var r = gC.get(n);
    if (r) {
      var o = new Set(r), a = new Set(e), i = n.current;
      o.forEach(function(l) {
        a.has(l) || Ig(l, null);
      }), a.forEach(function(l) {
        o.has(l) || Ig(l, i);
      });
    }
    gC.set(n, e);
  }, [e]), n;
}
var Lg = {
  width: "1px",
  height: "0px",
  padding: 0,
  overflow: "hidden",
  position: "fixed",
  top: "1px",
  left: "1px"
};
process.env.NODE_ENV !== "production" && Lr.node;
var Va = function() {
  return Va = Object.assign || function(t) {
    for (var n, r = 1, o = arguments.length; r < o; r++) {
      n = arguments[r];
      for (var a in n)
        Object.prototype.hasOwnProperty.call(n, a) && (t[a] = n[a]);
    }
    return t;
  }, Va.apply(this, arguments);
};
function ax(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
}
function TJ(e, t, n) {
  if (n || arguments.length === 2)
    for (var r = 0, o = t.length, a; r < o; r++)
      (a || !(r in t)) && (a || (a = Array.prototype.slice.call(t, 0, r)), a[r] = t[r]);
  return e.concat(a || Array.prototype.slice.call(t));
}
function ix(e) {
  return e;
}
function sx(e, t) {
  t === void 0 && (t = ix);
  var n = [], r = !1, o = {
    read: function() {
      if (r)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : e;
    },
    useMedium: function(a) {
      var i = t(a, r);
      return n.push(i), function() {
        n = n.filter(function(l) {
          return l !== i;
        });
      };
    },
    assignSyncMedium: function(a) {
      for (r = !0; n.length; ) {
        var i = n;
        n = [], i.forEach(a);
      }
      n = {
        push: function(l) {
          return a(l);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(a) {
      r = !0;
      var i = [];
      if (n.length) {
        var l = n;
        n = [], l.forEach(a), i = n;
      }
      var u = function() {
        var f = i;
        i = [], f.forEach(a);
      }, d = function() {
        return Promise.resolve().then(u);
      };
      d(), n = {
        push: function(f) {
          i.push(f), d();
        },
        filter: function(f) {
          return i = i.filter(f), n;
        }
      };
    }
  };
  return o;
}
function V4(e, t) {
  return t === void 0 && (t = ix), sx(e, t);
}
function lx(e) {
  e === void 0 && (e = {});
  var t = sx(null);
  return t.options = Va({ async: !0, ssr: !1 }, e), t;
}
var ux = function(e) {
  var t = e.sideCar, n = ax(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var r = t.read();
  if (!r)
    throw new Error("Sidecar medium not found");
  return Ee.createElement(r, Va({}, n));
};
ux.isSideCarExport = !0;
function NJ(e, t) {
  return e.useMedium(t), ux;
}
var cx = V4({}, function(e) {
  var t = e.target, n = e.currentTarget;
  return {
    target: t,
    currentTarget: n
  };
}), dx = V4(), kJ = V4(), VJ = lx({
  async: !0,
  ssr: typeof document < "u"
}), OJ = /* @__PURE__ */ ea(void 0), FJ = [], fx = /* @__PURE__ */ Ke(function(t, n) {
  var r, o = He(), a = o[0], i = o[1], l = Ve(), u = Ve(!1), d = Ve(null), f = He({}), h = f[1], p = t.children, g = t.disabled, C = g === void 0 ? !1 : g, v = t.noFocusGuards, y = v === void 0 ? !1 : v, M = t.persistentFocus, x = M === void 0 ? !1 : M, _ = t.crossFrame, L = _ === void 0 ? !0 : _, R = t.autoFocus, k = R === void 0 ? !0 : R, P = t.allowTextSelection, N = t.group, O = t.className, H = t.whiteList, $ = t.hasPositiveIndices, ne = t.shards, ie = ne === void 0 ? FJ : ne, re = t.as, ve = re === void 0 ? "div" : re, ue = t.lockProps, j = ue === void 0 ? {} : ue, K = t.sideCar, ce = t.returnFocus, U = ce === void 0 ? !1 : ce, q = t.focusOptions, ge = t.onActivation, X = t.onDeactivation, he = He({}), me = he[0], de = Q(function($e) {
    var Zt = $e.captureFocusRestore;
    if (!d.current) {
      var Pt, yt = (Pt = document) == null ? void 0 : Pt.activeElement;
      d.current = yt, yt !== document.body && (d.current = Zt(yt));
    }
    l.current && ge && ge(l.current), u.current = !0, h();
  }, [ge]), Le = Q(function() {
    u.current = !1, X && X(l.current), h();
  }, [X]), Ie = Q(function($e) {
    var Zt = d.current;
    if (Zt) {
      var Pt = (typeof Zt == "function" ? Zt() : Zt) || document.body, yt = typeof U == "function" ? U(Pt) : U;
      if (yt) {
        var jt = typeof yt == "object" ? yt : void 0;
        d.current = null, $e ? Promise.resolve().then(function() {
          return Pt.focus(jt);
        }) : Pt.focus(jt);
      }
    }
  }, [U]), Ne = Q(function($e) {
    u.current && cx.useMedium($e);
  }, []), ye = dx.useMedium, ke = Q(function($e) {
    l.current !== $e && (l.current = $e, i($e));
  }, []);
  process.env.NODE_ENV !== "production" && (typeof P < "u" && console.warn("React-Focus-Lock: allowTextSelection is deprecated and enabled by default"), st(function() {
    !l.current && typeof ve != "string" && console.error("FocusLock: could not obtain ref to internal node");
  }, []));
  var oe = et((r = {}, r[rx] = C && "disabled", r[j5] = N, r), j), lt = y !== !0, Re = lt && y !== "tail", _t = ox([n, ke]), on = bt(function() {
    return {
      observed: l,
      shards: ie,
      enabled: !C,
      active: u.current
    };
  }, [C, u.current, ie, a]);
  return /* @__PURE__ */ tt.createElement(Ml, null, lt && [
    /* @__PURE__ */ tt.createElement("div", {
      key: "guard-first",
      "data-focus-guard": !0,
      tabIndex: C ? -1 : 0,
      style: Lg
    }),
    $ ? /* @__PURE__ */ tt.createElement("div", {
      key: "guard-nearest",
      "data-focus-guard": !0,
      tabIndex: C ? -1 : 1,
      style: Lg
    }) : null
  ], !C && /* @__PURE__ */ tt.createElement(K, {
    id: me,
    sideCar: VJ,
    observed: a,
    disabled: C,
    persistentFocus: x,
    crossFrame: L,
    autoFocus: k,
    whiteList: H,
    shards: ie,
    onActivation: de,
    onDeactivation: Le,
    returnFocus: Ie,
    focusOptions: q,
    noFocusGuards: y
  }), /* @__PURE__ */ tt.createElement(ve, et({
    ref: _t
  }, oe, {
    className: O,
    onBlur: ye,
    onFocus: Ne
  }), /* @__PURE__ */ tt.createElement(OJ.Provider, {
    value: on
  }, p)), Re && /* @__PURE__ */ tt.createElement("div", {
    "data-focus-guard": !0,
    tabIndex: C ? -1 : 0,
    style: Lg
  }));
});
fx.propTypes = process.env.NODE_ENV !== "production" ? {
  children: yn.node,
  disabled: yn.bool,
  returnFocus: yn.oneOfType([yn.bool, yn.object, yn.func]),
  focusOptions: yn.object,
  noFocusGuards: yn.bool,
  hasPositiveIndices: yn.bool,
  allowTextSelection: yn.bool,
  autoFocus: yn.bool,
  persistentFocus: yn.bool,
  crossFrame: yn.bool,
  group: yn.string,
  className: yn.string,
  whiteList: yn.func,
  shards: yn.arrayOf(yn.any),
  as: yn.oneOfType([yn.string, yn.func, yn.object]),
  lockProps: yn.object,
  onActivation: yn.func,
  onDeactivation: yn.func,
  sideCar: yn.any.isRequired
} : {};
const hx = fx;
function M2(e, t) {
  return M2 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, r) {
    return n.__proto__ = r, n;
  }, M2(e, t);
}
function BJ(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, M2(e, t);
}
function Li(e) {
  "@babel/helpers - typeof";
  return Li = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Li(e);
}
function HJ(e, t) {
  if (Li(e) != "object" || !e)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (Li(r) != "object")
      return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function mx(e) {
  var t = HJ(e, "string");
  return Li(t) == "symbol" ? t : t + "";
}
function $u(e, t, n) {
  return (t = mx(t)) in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function GJ(e, t) {
  if (process.env.NODE_ENV !== "production") {
    if (typeof e != "function")
      throw new Error("Expected reducePropsToState to be a function.");
    if (typeof t != "function")
      throw new Error("Expected handleStateChangeOnClient to be a function.");
  }
  function n(r) {
    return r.displayName || r.name || "Component";
  }
  return function(o) {
    if (process.env.NODE_ENV !== "production" && typeof o != "function")
      throw new Error("Expected WrappedComponent to be a React component.");
    var a = [], i;
    function l() {
      i = e(a.map(function(d) {
        return d.props;
      })), t(i);
    }
    var u = /* @__PURE__ */ function(d) {
      BJ(f, d);
      function f() {
        return d.apply(this, arguments) || this;
      }
      f.peek = function() {
        return i;
      };
      var h = f.prototype;
      return h.componentDidMount = function() {
        a.push(this), l();
      }, h.componentDidUpdate = function() {
        l();
      }, h.componentWillUnmount = function() {
        var g = a.indexOf(this);
        a.splice(g, 1), l();
      }, h.render = function() {
        return /* @__PURE__ */ tt.createElement(o, this.props);
      }, f;
    }(TV);
    return $u(u, "displayName", "SideEffect(" + n(o) + ")"), u;
  };
}
var Xa = function(e) {
  for (var t = Array(e.length), n = 0; n < e.length; ++n)
    t[n] = e[n];
  return t;
}, _l = function(e) {
  return Array.isArray(e) ? e : [e];
}, px = function(e) {
  return Array.isArray(e) ? e[0] : e;
}, $J = function(e) {
  if (e.nodeType !== Node.ELEMENT_NODE)
    return !1;
  var t = window.getComputedStyle(e, null);
  return !t || !t.getPropertyValue ? !1 : t.getPropertyValue("display") === "none" || t.getPropertyValue("visibility") === "hidden";
}, gx = function(e) {
  return e.parentNode && e.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    e.parentNode.host
  ) : e.parentNode;
}, vx = function(e) {
  return e === document || e && e.nodeType === Node.DOCUMENT_NODE;
}, ZJ = function(e) {
  return e.hasAttribute("inert");
}, jJ = function(e, t) {
  return !e || vx(e) || !$J(e) && !ZJ(e) && t(gx(e));
}, Cx = function(e, t) {
  var n = e.get(t);
  if (n !== void 0)
    return n;
  var r = jJ(t, Cx.bind(void 0, e));
  return e.set(t, r), r;
}, WJ = function(e, t) {
  return e && !vx(e) ? XJ(e) ? t(gx(e)) : !1 : !0;
}, bx = function(e, t) {
  var n = e.get(t);
  if (n !== void 0)
    return n;
  var r = WJ(t, bx.bind(void 0, e));
  return e.set(t, r), r;
}, yx = function(e) {
  return e.dataset;
}, zJ = function(e) {
  return e.tagName === "BUTTON";
}, Sx = function(e) {
  return e.tagName === "INPUT";
}, Ax = function(e) {
  return Sx(e) && e.type === "radio";
}, UJ = function(e) {
  return !((Sx(e) || zJ(e)) && (e.type === "hidden" || e.disabled));
}, XJ = function(e) {
  var t = e.getAttribute(DJ);
  return ![!0, "true", ""].includes(t);
}, O4 = function(e) {
  var t;
  return !!(e && (!((t = yx(e)) === null || t === void 0) && t.focusGuard));
}, W5 = function(e) {
  return !O4(e);
}, YJ = function(e) {
  return !!e;
}, qJ = function(e, t) {
  var n = Math.max(0, e.tabIndex), r = Math.max(0, t.tabIndex), o = n - r, a = e.index - t.index;
  if (o) {
    if (!n)
      return 1;
    if (!r)
      return -1;
  }
  return o || a;
}, JJ = function(e) {
  return e.tabIndex < 0 && !e.hasAttribute("tabindex") ? 0 : e.tabIndex;
}, F4 = function(e, t, n) {
  return Xa(e).map(function(r, o) {
    var a = JJ(r);
    return {
      node: r,
      index: o,
      tabIndex: n && a === -1 ? (r.dataset || {}).focusGuard ? 0 : -1 : a
    };
  }).filter(function(r) {
    return !t || r.tabIndex >= 0;
  }).sort(qJ);
}, KJ = [
  "button:enabled",
  "select:enabled",
  "textarea:enabled",
  "input:enabled",
  // elements with explicit roles will also use explicit tabindex
  // '[role="button"]',
  "a[href]",
  "area[href]",
  "summary",
  "iframe",
  "object",
  "embed",
  "audio[controls]",
  "video[controls]",
  "[tabindex]",
  "[contenteditable]",
  "[autofocus]"
], B4 = KJ.join(","), QJ = "".concat(B4, ", [data-focus-guard]"), Mx = function(e, t) {
  return Xa((e.shadowRoot || e).children).reduce(function(n, r) {
    return n.concat(r.matches(t ? QJ : B4) ? [r] : [], Mx(r));
  }, []);
}, eK = function(e, t) {
  var n;
  return e instanceof HTMLIFrameElement && (!((n = e.contentDocument) === null || n === void 0) && n.body) ? nc([e.contentDocument.body], t) : [e];
}, nc = function(e, t) {
  return e.reduce(function(n, r) {
    var o, a = Mx(r, t), i = (o = []).concat.apply(o, a.map(function(l) {
      return eK(l, t);
    }));
    return n.concat(
      // add all tabbables inside and within shadow DOMs in DOM order
      i,
      // add if node is tabbable itself
      r.parentNode ? Xa(r.parentNode.querySelectorAll(B4)).filter(function(l) {
        return l === r;
      }) : []
    );
  }, []);
}, tK = function(e) {
  var t = e.querySelectorAll("[".concat(RJ, "]"));
  return Xa(t).map(function(n) {
    return nc([n]);
  }).reduce(function(n, r) {
    return n.concat(r);
  }, []);
}, H4 = function(e, t) {
  return Xa(e).filter(function(n) {
    return Cx(t, n);
  }).filter(function(n) {
    return UJ(n);
  });
}, vC = function(e, t) {
  return t === void 0 && (t = /* @__PURE__ */ new Map()), Xa(e).filter(function(n) {
    return bx(t, n);
  });
}, G4 = function(e, t, n) {
  return F4(H4(nc(e, n), t), !0, n);
}, hd = function(e, t) {
  return F4(H4(nc(e), t), !1);
}, nK = function(e, t) {
  return H4(tK(e), t);
}, Cl = function(e, t) {
  return e.shadowRoot ? Cl(e.shadowRoot, t) : Object.getPrototypeOf(e).contains !== void 0 && Object.getPrototypeOf(e).contains.call(e, t) ? !0 : Xa(e.children).some(function(n) {
    var r;
    if (n instanceof HTMLIFrameElement) {
      var o = (r = n.contentDocument) === null || r === void 0 ? void 0 : r.body;
      return o ? Cl(o, t) : !1;
    }
    return Cl(n, t);
  });
}, rK = function(e) {
  for (var t = /* @__PURE__ */ new Set(), n = e.length, r = 0; r < n; r += 1)
    for (var o = r + 1; o < n; o += 1) {
      var a = e[r].compareDocumentPosition(e[o]);
      (a & Node.DOCUMENT_POSITION_CONTAINED_BY) > 0 && t.add(o), (a & Node.DOCUMENT_POSITION_CONTAINS) > 0 && t.add(r);
    }
  return e.filter(function(i, l) {
    return !t.has(l);
  });
}, xx = function(e) {
  return e.parentNode ? xx(e.parentNode) : e;
}, $4 = function(e) {
  var t = _l(e);
  return t.filter(Boolean).reduce(function(n, r) {
    var o = r.getAttribute(j5);
    return n.push.apply(n, o ? rK(Xa(xx(r).querySelectorAll("[".concat(j5, '="').concat(o, '"]:not([').concat(rx, '="disabled"])')))) : [r]), n;
  }, []);
}, oK = function(e) {
  try {
    return e();
  } catch {
    return;
  }
}, md = function(e) {
  if (e === void 0 && (e = document), !(!e || !e.activeElement)) {
    var t = e.activeElement;
    return t.shadowRoot ? md(t.shadowRoot) : t instanceof HTMLIFrameElement && oK(function() {
      return t.contentWindow.document;
    }) ? md(t.contentWindow.document) : t;
  }
}, aK = function(e, t) {
  return e === t;
}, iK = function(e, t) {
  return !!Xa(e.querySelectorAll("iframe")).some(function(n) {
    return aK(n, t);
  });
}, wx = function(e, t) {
  return t === void 0 && (t = md(px(e).ownerDocument)), !t || t.dataset && t.dataset.focusGuard ? !1 : $4(e).some(function(n) {
    return Cl(n, t) || iK(n, t);
  });
}, sK = function(e) {
  e === void 0 && (e = document);
  var t = md(e);
  return t ? Xa(e.querySelectorAll("[".concat(LJ, "]"))).some(function(n) {
    return Cl(n, t);
  }) : !1;
}, lK = function(e, t) {
  return t.filter(Ax).filter(function(n) {
    return n.name === e.name;
  }).filter(function(n) {
    return n.checked;
  })[0] || e;
}, Z4 = function(e, t) {
  return Ax(e) && e.name ? lK(e, t) : e;
}, uK = function(e) {
  var t = /* @__PURE__ */ new Set();
  return e.forEach(function(n) {
    return t.add(Z4(n, e));
  }), e.filter(function(n) {
    return t.has(n);
  });
}, CC = function(e) {
  return e[0] && e.length > 1 ? Z4(e[0], e) : e[0];
}, bC = function(e, t) {
  return e.indexOf(Z4(t, e));
}, z5 = "NEW_FOCUS", cK = function(e, t, n, r, o) {
  var a = e.length, i = e[0], l = e[a - 1], u = O4(r);
  if (!(r && e.indexOf(r) >= 0)) {
    var d = r !== void 0 ? n.indexOf(r) : -1, f = o ? n.indexOf(o) : d, h = o ? e.indexOf(o) : -1;
    if (d === -1)
      return h !== -1 ? h : z5;
    if (h === -1)
      return z5;
    var p = d - f, g = n.indexOf(i), C = n.indexOf(l), v = uK(n), y = r !== void 0 ? v.indexOf(r) : -1, M = o ? v.indexOf(o) : y, x = v.filter(function(N) {
      return N.tabIndex >= 0;
    }), _ = r !== void 0 ? x.indexOf(r) : -1, L = o ? x.indexOf(o) : _, R = _ >= 0 && L >= 0 ? (
      // old/new are tabbables, measure distance in tabbable space
      L - _
    ) : (
      // or else measure in focusable space
      M - y
    );
    if (!p && h >= 0 || t.length === 0)
      return h;
    var k = bC(e, t[0]), P = bC(e, t[t.length - 1]);
    if (d <= g && u && Math.abs(p) > 1)
      return P;
    if (d >= C && u && Math.abs(p) > 1)
      return k;
    if (p && Math.abs(R) > 1)
      return h;
    if (d <= g)
      return P;
    if (d > C)
      return k;
    if (p)
      return Math.abs(p) > 1 ? h : (a + h + p) % a;
  }
}, dK = function(e) {
  return function(t) {
    var n, r = (n = yx(t)) === null || n === void 0 ? void 0 : n.autofocus;
    return (
      // @ts-expect-error
      t.autofocus || //
      r !== void 0 && r !== "false" || //
      e.indexOf(t) >= 0
    );
  };
}, yC = function(e, t, n) {
  var r = e.map(function(a) {
    var i = a.node;
    return i;
  }), o = vC(r.filter(dK(n)));
  return o && o.length ? CC(o) : CC(vC(t));
}, U5 = function(e, t) {
  return t === void 0 && (t = []), t.push(e), e.parentNode && U5(e.parentNode.host || e.parentNode, t), t;
}, Rg = function(e, t) {
  for (var n = U5(e), r = U5(t), o = 0; o < n.length; o += 1) {
    var a = n[o];
    if (r.indexOf(a) >= 0)
      return a;
  }
  return !1;
}, _x = function(e, t, n) {
  var r = _l(e), o = _l(t), a = r[0], i = !1;
  return o.filter(Boolean).forEach(function(l) {
    i = Rg(i || l, l) || i, n.filter(Boolean).forEach(function(u) {
      var d = Rg(a, u);
      d && (!i || Cl(d, i) ? i = d : i = Rg(d, i));
    });
  }), i;
}, SC = function(e, t) {
  return e.reduce(function(n, r) {
    return n.concat(nK(r, t));
  }, []);
}, fK = function(e, t) {
  var n = /* @__PURE__ */ new Map();
  return t.forEach(function(r) {
    return n.set(r.node, r);
  }), e.map(function(r) {
    return n.get(r);
  }).filter(YJ);
}, hK = function(e, t) {
  var n = md(_l(e).length > 0 ? document : px(e).ownerDocument), r = $4(e).filter(W5), o = _x(n || e, e, r), a = /* @__PURE__ */ new Map(), i = hd(r, a), l = i.filter(function(C) {
    var v = C.node;
    return W5(v);
  });
  if (l[0]) {
    var u = hd([o], a).map(function(C) {
      var v = C.node;
      return v;
    }), d = fK(u, l), f = d.map(function(C) {
      var v = C.node;
      return v;
    }), h = d.filter(function(C) {
      var v = C.tabIndex;
      return v >= 0;
    }).map(function(C) {
      var v = C.node;
      return v;
    }), p = cK(f, h, u, n, t);
    if (p === z5) {
      var g = (
        // first try only tabbable, and the fallback to all focusable, as long as at least one element should be picked for focus
        yC(i, h, SC(r, a)) || yC(i, f, SC(r, a))
      );
      if (g)
        return { node: g };
      console.warn("focus-lock: cannot find any node to move focus into");
      return;
    }
    return p === void 0 ? p : d[p];
  }
}, mK = function(e) {
  var t = $4(e).filter(W5), n = _x(e, e, t), r = F4(nc([n], !0), !0, !0), o = nc(t, !1);
  return r.map(function(a) {
    var i = a.node, l = a.index;
    return {
      node: i,
      index: l,
      lockItem: o.indexOf(i) >= 0,
      guard: O4(i)
    };
  });
}, j4 = function(e, t) {
  e && ("focus" in e && e.focus(t), "contentWindow" in e && e.contentWindow && e.contentWindow.focus());
}, Dg = 0, Pg = !1, Ix = function(e, t, n) {
  n === void 0 && (n = {});
  var r = hK(e, t);
  if (!Pg && r) {
    if (Dg > 2) {
      console.error("FocusLock: focus-fighting detected. Only one focus management system could be active. See https://github.com/theKashey/focus-lock/#focus-fighting"), Pg = !0, setTimeout(function() {
        Pg = !1;
      }, 1);
      return;
    }
    Dg++, j4(r.node, n.focusOptions), Dg--;
  }
};
function h1(e) {
  if (!e)
    return null;
  if (typeof WeakRef > "u")
    return function() {
      return e || null;
    };
  var t = e ? new WeakRef(e) : null;
  return function() {
    return (t == null ? void 0 : t.deref()) || null;
  };
}
var pK = function(e) {
  if (!e)
    return null;
  for (var t = [], n = e; n && n !== document.body; )
    t.push({
      current: h1(n),
      parent: h1(n.parentElement),
      left: h1(n.previousElementSibling),
      right: h1(n.nextElementSibling)
    }), n = n.parentElement;
  return {
    element: h1(e),
    stack: t,
    ownerDocument: e.ownerDocument
  };
}, gK = function(e) {
  var t, n, r, o, a;
  if (e)
    for (var i = e.stack, l = e.ownerDocument, u = /* @__PURE__ */ new Map(), d = 0, f = i; d < f.length; d++) {
      var h = f[d], p = (t = h.parent) === null || t === void 0 ? void 0 : t.call(h);
      if (p && l.contains(p)) {
        for (var g = (n = h.left) === null || n === void 0 ? void 0 : n.call(h), C = h.current(), v = p.contains(C) ? C : void 0, y = (r = h.right) === null || r === void 0 ? void 0 : r.call(h), M = G4([p], u), x = (
          // that is element itself
          (a = (o = v ?? // or something in it's place
          (g == null ? void 0 : g.nextElementSibling)) !== null && o !== void 0 ? o : (
            // or somebody to the right, still close enough
            y
          )) !== null && a !== void 0 ? a : (
            // or somebody to the left, something?
            g
          )
        ); x; ) {
          for (var _ = 0, L = M; _ < L.length; _++) {
            var R = L[_];
            if (x != null && x.contains(R.node))
              return R.node;
          }
          x = x.nextElementSibling;
        }
        if (M.length)
          return M[0].node;
      }
    }
}, Lx = function(e) {
  var t = pK(e);
  return function() {
    return gK(t);
  };
}, vK = function(e, t, n) {
  if (!e || !t)
    return console.error("no element or scope given"), {};
  var r = _l(t);
  if (r.every(function(i) {
    return !Cl(i, e);
  }))
    return console.error("Active element is not contained in the scope"), {};
  var o = n ? G4(r, /* @__PURE__ */ new Map()) : hd(r, /* @__PURE__ */ new Map()), a = o.findIndex(function(i) {
    var l = i.node;
    return l === e;
  });
  if (a !== -1)
    return {
      prev: o[a - 1],
      next: o[a + 1],
      first: o[0],
      last: o[o.length - 1]
    };
}, CK = function(e, t) {
  var n = t ? G4(_l(e), /* @__PURE__ */ new Map()) : hd(_l(e), /* @__PURE__ */ new Map());
  return {
    first: n[0],
    last: n[n.length - 1]
  };
}, bK = function(e) {
  return Object.assign({
    scope: document.body,
    cycle: !0,
    onlyTabbable: !0
  }, e);
}, Rx = function(e, t, n) {
  t === void 0 && (t = {});
  var r = bK(t), o = vK(e, r.scope, r.onlyTabbable);
  if (o) {
    var a = n(o, r.cycle);
    a && j4(a.node, r.focusOptions);
  }
}, yK = function(e, t) {
  t === void 0 && (t = {}), Rx(e, t, function(n, r) {
    var o = n.next, a = n.first;
    return o || r && a;
  });
}, SK = function(e, t) {
  t === void 0 && (t = {}), Rx(e, t, function(n, r) {
    var o = n.prev, a = n.last;
    return o || r && a;
  });
}, Dx = function(e, t, n) {
  var r, o = CK(e, (r = t.onlyTabbable) !== null && r !== void 0 ? r : !0), a = o[n];
  a && j4(a.node, t.focusOptions);
}, AK = function(e, t) {
  t === void 0 && (t = {}), Dx(e, t, "first");
}, MK = function(e, t) {
  t === void 0 && (t = {}), Dx(e, t, "last");
};
function W4(e) {
  setTimeout(e, 1);
}
var xK = function(t) {
  return t && "current" in t ? t.current : t;
}, Px = function() {
  return document && document.activeElement === document.body;
}, wK = function() {
  return Px() || sK();
}, Xu = null, ro = null, AC = function() {
  return null;
}, Yu = null, pd = !1, z4 = !1, _K = function() {
  return !0;
}, IK = function(t) {
  return (Xu.whiteList || _K)(t);
}, LK = function(t, n) {
  Yu = {
    observerNode: t,
    portaledElement: n
  };
}, RK = function(t) {
  return Yu && Yu.portaledElement === t;
};
function MC(e, t, n, r) {
  var o = null, a = e;
  do {
    var i = r[a];
    if (i.guard)
      i.node.dataset.focusAutoGuard && (o = i);
    else if (i.lockItem) {
      if (a !== e)
        return;
      o = null;
    } else
      break;
  } while ((a += n) !== t);
  o && (o.node.tabIndex = 0);
}
var DK = function(t) {
  return t ? !!pd : pd === "meanwhile";
}, PK = function e(t, n, r) {
  return n && (n.host === t && (!n.activeElement || r.contains(n.activeElement)) || n.parentNode && e(t, n.parentNode, r));
}, EK = function(t, n) {
  return n.some(function(r) {
    return PK(t, r, r);
  });
}, Ex = function(t) {
  return hd(t, /* @__PURE__ */ new Map());
}, TK = function(t) {
  return !Ex([t.parentNode]).some(function(n) {
    return n.node === t;
  });
}, x2 = function() {
  var t = !1;
  if (Xu) {
    var n = Xu, r = n.observed, o = n.persistentFocus, a = n.autoFocus, i = n.shards, l = n.crossFrame, u = n.focusOptions, d = n.noFocusGuards, f = r || Yu && Yu.portaledElement;
    if (Px() && ro && ro !== document.body && (!document.body.contains(ro) || TK(ro))) {
      var h = AC();
      h && h.focus();
    }
    var p = document && document.activeElement;
    if (f) {
      var g = [f].concat(i.map(xK).filter(Boolean)), C = function() {
        if (!DK(l) || !d || !ro || z4)
          return !1;
        var _ = Ex(g), L = _.findIndex(function(R) {
          var k = R.node;
          return k === ro;
        });
        return L === 0 || L === _.length - 1;
      };
      if ((!p || IK(p)) && (o || C() || !wK() || !ro && a) && (f && !(wx(g) || p && EK(p, g) || RK(p)) && (document && !ro && p && !a ? (p.blur && p.blur(), document.body.focus()) : (t = Ix(g, ro, {
        focusOptions: u
      }), Yu = {})), ro = document && document.activeElement, ro !== document.body && (AC = Lx(ro)), pd = !1), document && p !== document.activeElement && document.querySelector("[data-focus-auto-guard]")) {
        var v = document && document.activeElement, y = mK(g), M = y.map(function(x) {
          var _ = x.node;
          return _;
        }).indexOf(v);
        M > -1 && (y.filter(function(x) {
          var _ = x.guard, L = x.node;
          return _ && L.dataset.focusAutoGuard;
        }).forEach(function(x) {
          var _ = x.node;
          return _.removeAttribute("tabIndex");
        }), MC(M, y.length, 1, y), MC(M, -1, -1, y));
      }
    }
  }
  return t;
}, Tx = function(t) {
  x2() && t && (t.stopPropagation(), t.preventDefault());
}, U4 = function() {
  return W4(x2);
}, NK = function(t) {
  var n = t.target, r = t.currentTarget;
  r.contains(n) || LK(r, n);
}, kK = function() {
  return null;
};
process.env.NODE_ENV !== "production" && Lr.node.isRequired;
var Nx = function() {
  z4 = !0;
}, kx = function() {
  z4 = !1, pd = "just", W4(function() {
    pd = "meanwhile";
  });
}, VK = function() {
  document.addEventListener("focusin", Tx), document.addEventListener("focusout", U4), window.addEventListener("focus", Nx), window.addEventListener("blur", kx);
}, OK = function() {
  document.removeEventListener("focusin", Tx), document.removeEventListener("focusout", U4), window.removeEventListener("focus", Nx), window.removeEventListener("blur", kx);
};
function FK(e) {
  return e.filter(function(t) {
    var n = t.disabled;
    return !n;
  });
}
var Vx = {
  moveFocusInside: Ix,
  focusInside: wx,
  focusNextElement: yK,
  focusPrevElement: SK,
  focusFirstElement: AK,
  focusLastElement: MK,
  captureFocusRestore: Lx
};
function BK(e) {
  var t = e.slice(-1)[0];
  t && !Xu && VK();
  var n = Xu, r = n && t && t.id === n.id;
  Xu = t, n && !r && (n.onDeactivation(), e.filter(function(o) {
    var a = o.id;
    return a === n.id;
  }).length || n.returnFocus(!t)), t ? (ro = null, (!r || n.observed !== t.observed) && t.onActivation(Vx), x2(), W4(x2)) : (OK(), ro = null);
}
cx.assignSyncMedium(NK);
dx.assignMedium(U4);
kJ.assignMedium(function(e) {
  return e(Vx);
});
const HK = GJ(FK, BK)(kK);
var Ox = /* @__PURE__ */ Ke(function(t, n) {
  return /* @__PURE__ */ tt.createElement(hx, et({
    sideCar: HK,
    ref: n
  }, t));
}), Fx = hx.propTypes || {};
Fx.sideCar;
var GK = ex(Fx, ["sideCar"]);
Ox.propTypes = process.env.NODE_ENV !== "production" ? GK : {};
const w2 = Ox, $K = w2.default ?? w2, Bx = (e) => {
  const {
    initialFocusRef: t,
    finalFocusRef: n,
    contentRef: r,
    restoreFocus: o,
    children: a,
    isDisabled: i,
    autoFocus: l,
    persistentFocus: u,
    lockFocusAcrossFrames: d
  } = e, f = Q(() => {
    t != null && t.current ? t.current.focus() : r != null && r.current && gS(r.current).length === 0 && requestAnimationFrame(() => {
      var C;
      (C = r.current) == null || C.focus();
    });
  }, [t, r]), h = Q(() => {
    var g;
    (g = n == null ? void 0 : n.current) == null || g.focus();
  }, [n]), p = o && !n;
  return /* @__PURE__ */ A.jsx(
    $K,
    {
      crossFrame: d,
      persistentFocus: u,
      autoFocus: l,
      disabled: i,
      onActivation: f,
      onDeactivation: h,
      returnFocus: p,
      children: a
    }
  );
};
Bx.displayName = "FocusLock";
const [ZK, jK] = mn({
  name: "FormErrorStylesContext",
  errorMessage: `useFormErrorStyles returned is 'undefined'. Seems you forgot to wrap the components in "<FormError />" `
}), Hx = Be(
  (e, t) => {
    const n = yr("FormError", e), r = Ln(e), o = Hl();
    return o != null && o.isInvalid ? /* @__PURE__ */ A.jsx(ZK, { value: n, children: /* @__PURE__ */ A.jsx(
      xe.div,
      {
        ...o == null ? void 0 : o.getErrorMessageProps(r, t),
        className: ze("chakra-form__error-message", e.className),
        __css: {
          display: "flex",
          alignItems: "center",
          ...n.text
        }
      }
    ) }) : null;
  }
);
Hx.displayName = "FormErrorMessage";
const WK = Be((e, t) => {
  const n = jK(), r = Hl();
  if (!(r != null && r.isInvalid))
    return null;
  const o = ze("chakra-form__error-icon", e.className);
  return /* @__PURE__ */ A.jsx(
    Ni,
    {
      ref: t,
      "aria-hidden": !0,
      ...e,
      __css: n.icon,
      className: o,
      children: /* @__PURE__ */ A.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M11.983,0a12.206,12.206,0,0,0-8.51,3.653A11.8,11.8,0,0,0,0,12.207,11.779,11.779,0,0,0,11.8,24h.214A12.111,12.111,0,0,0,24,11.791h0A11.766,11.766,0,0,0,11.983,0ZM10.5,16.542a1.476,1.476,0,0,1,1.449-1.53h.027a1.527,1.527,0,0,1,1.523,1.47,1.475,1.475,0,0,1-1.449,1.53h-.027A1.529,1.529,0,0,1,10.5,16.542ZM11,12.5v-6a1,1,0,0,1,2,0v6a1,1,0,1,1-2,0Z"
        }
      )
    }
  );
});
WK.displayName = "FormErrorIcon";
const Gx = Be(
  function(t, n) {
    const r = Ua("FormLabel", t), o = Ln(t), {
      className: a,
      children: i,
      requiredIndicator: l = /* @__PURE__ */ A.jsx($x, {}),
      optionalIndicator: u = null,
      ...d
    } = o, f = Hl(), h = (f == null ? void 0 : f.getLabelProps(d, n)) ?? { ref: n, ...d };
    return /* @__PURE__ */ A.jsxs(
      xe.label,
      {
        ...h,
        className: ze("chakra-form__label", o.className),
        __css: {
          display: "block",
          textAlign: "start",
          ...r
        },
        children: [
          i,
          f != null && f.isRequired ? l : u
        ]
      }
    );
  }
);
Gx.displayName = "FormLabel";
const $x = Be(
  function(t, n) {
    const r = Hl(), o = zM();
    if (!(r != null && r.isRequired))
      return null;
    const a = ze("chakra-form__required-indicator", t.className);
    return /* @__PURE__ */ A.jsx(
      xe.span,
      {
        ...r == null ? void 0 : r.getRequiredIndicatorProps(t, n),
        __css: o.requiredIndicator,
        className: a
      }
    );
  }
);
$x.displayName = "RequiredIndicator";
const Zx = Be(function(t, n) {
  const {
    templateAreas: r,
    gap: o,
    rowGap: a,
    columnGap: i,
    column: l,
    row: u,
    autoFlow: d,
    autoRows: f,
    templateRows: h,
    autoColumns: p,
    templateColumns: g,
    ...C
  } = t, v = {
    display: "grid",
    gridTemplateAreas: r,
    gridGap: o,
    gridRowGap: a,
    gridColumnGap: i,
    gridAutoColumns: p,
    gridColumn: l,
    gridRow: u,
    gridAutoFlow: d,
    gridAutoRows: f,
    gridTemplateRows: h,
    gridTemplateColumns: g
  };
  return /* @__PURE__ */ A.jsx(xe.div, { ref: n, __css: v, ...C });
});
Zx.displayName = "Grid";
const jx = Be(
  function(t, n) {
    const { columns: r, spacingX: o, spacingY: a, spacing: i, minChildWidth: l, ...u } = t, d = bc(), f = l ? UK(l, d) : XK(r);
    return /* @__PURE__ */ A.jsx(
      Zx,
      {
        ref: n,
        gap: i,
        columnGap: o,
        rowGap: a,
        templateColumns: f,
        ...u
      }
    );
  }
);
jx.displayName = "SimpleGrid";
function zK(e) {
  return typeof e == "number" ? `${e}px` : e;
}
function UK(e, t) {
  return j3(e, (n) => {
    const r = zY("sizes", n, zK(n))(t);
    return n === null ? null : `repeat(auto-fit, minmax(${r}, 1fr))`;
  });
}
function XK(e) {
  return j3(
    e,
    (t) => t === null ? null : `repeat(${t}, minmax(0, 1fr))`
  );
}
const Pr = Be(
  function(t, n) {
    const { htmlSize: r, ...o } = t, a = yr("Input", o), i = Ln(o), l = E4(i), u = ze("chakra-input", t.className);
    return /* @__PURE__ */ A.jsx(
      xe.input,
      {
        size: r,
        ...l,
        __css: a.field,
        ref: n,
        className: u
      }
    );
  }
);
Pr.displayName = "Input";
Pr.id = "Input";
const [YK, Wx] = mn({
  name: "InputGroupStylesContext",
  errorMessage: `useInputGroupStyles returned is 'undefined'. Seems you forgot to wrap the components in "<InputGroup />" `
}), X4 = Be(
  function(t, n) {
    const r = yr("Input", t), { children: o, className: a, ...i } = Ln(t), l = ze("chakra-input__group", a), u = {}, d = mS(o), f = r.field;
    d.forEach((p) => {
      r && (f && p.type.id === "InputLeftElement" && (u.paddingStart = f.height ?? f.h), f && p.type.id === "InputRightElement" && (u.paddingEnd = f.height ?? f.h), p.type.id === "InputRightAddon" && (u.borderEndRadius = 0), p.type.id === "InputLeftAddon" && (u.borderStartRadius = 0));
    });
    const h = d.map((p) => {
      var C, v;
      const g = Z3({
        size: ((C = p.props) == null ? void 0 : C.size) || t.size,
        variant: ((v = p.props) == null ? void 0 : v.variant) || t.variant
      });
      return p.type.id !== "Input" ? Yo(p, g) : Yo(p, Object.assign(g, u, p.props));
    });
    return /* @__PURE__ */ A.jsx(
      xe.div,
      {
        className: l,
        ref: n,
        __css: {
          width: "100%",
          display: "flex",
          position: "relative",
          // Parts of inputs override z-index to ensure that they stack correctly on each other
          // Create a new stacking context so that these overrides don't leak out and conflict with other z-indexes
          isolation: "isolate",
          ...r.group
        },
        "data-group": !0,
        ...i,
        children: /* @__PURE__ */ A.jsx(YK, { value: r, children: h })
      }
    );
  }
);
X4.displayName = "InputGroup";
const qK = {
  left: {
    marginEnd: "-1px",
    borderEndRadius: 0,
    borderEndColor: "transparent"
  },
  right: {
    marginStart: "-1px",
    borderStartRadius: 0,
    borderStartColor: "transparent"
  }
}, JK = xe("div", {
  baseStyle: {
    flex: "0 0 auto",
    width: "auto",
    display: "flex",
    alignItems: "center",
    whiteSpace: "nowrap"
  }
}), Y4 = Be(
  function(t, n) {
    const { placement: r = "left", ...o } = t, a = qK[r] ?? {}, i = Wx();
    return /* @__PURE__ */ A.jsx(
      JK,
      {
        ref: n,
        ...o,
        __css: {
          ...i.addon,
          ...a
        }
      }
    );
  }
);
Y4.displayName = "InputAddon";
const q4 = Be(
  function(t, n) {
    return /* @__PURE__ */ A.jsx(
      Y4,
      {
        ref: n,
        placement: "left",
        ...t,
        className: ze("chakra-input__left-addon", t.className)
      }
    );
  }
);
q4.displayName = "InputLeftAddon";
q4.id = "InputLeftAddon";
const J4 = Be(
  function(t, n) {
    return /* @__PURE__ */ A.jsx(
      Y4,
      {
        ref: n,
        placement: "right",
        ...t,
        className: ze("chakra-input__right-addon", t.className)
      }
    );
  }
);
J4.displayName = "InputRightAddon";
J4.id = "InputRightAddon";
const KK = xe("div", {
  baseStyle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "absolute",
    top: "0",
    zIndex: 2
  }
}), kh = Be(
  function(t, n) {
    const { placement: r = "left", ...o } = t, a = Wx(), i = a.field, u = {
      [r === "left" ? "insetStart" : "insetEnd"]: "0",
      width: (i == null ? void 0 : i.height) ?? (i == null ? void 0 : i.h),
      height: (i == null ? void 0 : i.height) ?? (i == null ? void 0 : i.h),
      fontSize: i == null ? void 0 : i.fontSize,
      ...a.element
    };
    return /* @__PURE__ */ A.jsx(KK, { ref: n, __css: u, ...o });
  }
);
kh.id = "InputElement";
kh.displayName = "InputElement";
const K4 = Be(
  function(t, n) {
    const { className: r, ...o } = t, a = ze("chakra-input__left-element", r);
    return /* @__PURE__ */ A.jsx(
      kh,
      {
        ref: n,
        placement: "left",
        className: a,
        ...o
      }
    );
  }
);
K4.id = "InputLeftElement";
K4.displayName = "InputLeftElement";
const Q4 = Be(
  function(t, n) {
    const { className: r, ...o } = t, a = ze("chakra-input__right-element", r);
    return /* @__PURE__ */ A.jsx(
      kh,
      {
        ref: n,
        placement: "right",
        className: a,
        ...o
      }
    );
  }
);
Q4.id = "InputRightElement";
Q4.displayName = "InputRightElement";
const X5 = Be(function(t, n) {
  const r = Ua("Link", t), { className: o, isExternal: a, ...i } = Ln(t);
  return /* @__PURE__ */ A.jsx(
    xe.a,
    {
      target: a ? "_blank" : void 0,
      rel: a ? "noopener" : void 0,
      ref: n,
      className: ze("chakra-link", o),
      ...i,
      __css: r
    }
  );
});
X5.displayName = "Link";
function QK(e, t, n, r) {
  if (t == null)
    return r;
  if (!r)
    return e.find(
      (i) => n(i).toLowerCase().startsWith(t.toLowerCase())
    );
  const o = e.filter(
    (a) => n(a).toLowerCase().startsWith(t.toLowerCase())
  );
  if (o.length > 0) {
    let a;
    return o.includes(r) ? (a = o.indexOf(r) + 1, a === o.length && (a = 0), o[a]) : (a = e.indexOf(o[0]), e[a]);
  }
  return r;
}
function eQ(e) {
  const { key: t } = e;
  return t.length === 1 || t.length > 1 && /[^a-zA-Z0-9]/.test(t);
}
function tQ(e = {}) {
  const { timeout: t = 300, preventDefault: n = () => !0 } = e, [r, o] = He([]), a = Ve(void 0), i = () => {
    a.current && (clearTimeout(a.current), a.current = null);
  }, l = () => {
    i(), a.current = setTimeout(() => {
      o([]), a.current = null;
    }, t);
  };
  st(() => i, []);
  function u(d) {
    return (f) => {
      if (f.key === "Backspace") {
        const h = [...r];
        h.pop(), o(h);
        return;
      }
      if (eQ(f)) {
        const h = r.concat(f.key);
        n(f) && (f.preventDefault(), f.stopPropagation()), o(h), d(h.join("")), l();
      }
    };
  }
  return u;
}
var ao = "top", Jo = "bottom", Ko = "right", io = "left", e9 = "auto", kd = [ao, Jo, Ko, io], rc = "start", gd = "end", nQ = "clippingParents", zx = "viewport", m1 = "popper", rQ = "reference", xC = /* @__PURE__ */ kd.reduce(function(e, t) {
  return e.concat([t + "-" + rc, t + "-" + gd]);
}, []), Ux = /* @__PURE__ */ [].concat(kd, [e9]).reduce(function(e, t) {
  return e.concat([t, t + "-" + rc, t + "-" + gd]);
}, []), oQ = "beforeRead", aQ = "read", iQ = "afterRead", sQ = "beforeMain", lQ = "main", uQ = "afterMain", cQ = "beforeWrite", dQ = "write", fQ = "afterWrite", hQ = [oQ, aQ, iQ, sQ, lQ, uQ, cQ, dQ, fQ];
function ja(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function _o(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var t = e.ownerDocument;
    return t && t.defaultView || window;
  }
  return e;
}
function Il(e) {
  var t = _o(e).Element;
  return e instanceof t || e instanceof Element;
}
function Uo(e) {
  var t = _o(e).HTMLElement;
  return e instanceof t || e instanceof HTMLElement;
}
function t9(e) {
  if (typeof ShadowRoot > "u")
    return !1;
  var t = _o(e).ShadowRoot;
  return e instanceof t || e instanceof ShadowRoot;
}
function mQ(e) {
  var t = e.state;
  Object.keys(t.elements).forEach(function(n) {
    var r = t.styles[n] || {}, o = t.attributes[n] || {}, a = t.elements[n];
    !Uo(a) || !ja(a) || (Object.assign(a.style, r), Object.keys(o).forEach(function(i) {
      var l = o[i];
      l === !1 ? a.removeAttribute(i) : a.setAttribute(i, l === !0 ? "" : l);
    }));
  });
}
function pQ(e) {
  var t = e.state, n = {
    popper: {
      position: t.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(t.elements.popper.style, n.popper), t.styles = n, t.elements.arrow && Object.assign(t.elements.arrow.style, n.arrow), function() {
    Object.keys(t.elements).forEach(function(r) {
      var o = t.elements[r], a = t.attributes[r] || {}, i = Object.keys(t.styles.hasOwnProperty(r) ? t.styles[r] : n[r]), l = i.reduce(function(u, d) {
        return u[d] = "", u;
      }, {});
      !Uo(o) || !ja(o) || (Object.assign(o.style, l), Object.keys(a).forEach(function(u) {
        o.removeAttribute(u);
      }));
    });
  };
}
const gQ = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: mQ,
  effect: pQ,
  requires: ["computeStyles"]
};
function Ga(e) {
  return e.split("-")[0];
}
var bl = Math.max, _2 = Math.min, oc = Math.round;
function Y5() {
  var e = navigator.userAgentData;
  return e != null && e.brands && Array.isArray(e.brands) ? e.brands.map(function(t) {
    return t.brand + "/" + t.version;
  }).join(" ") : navigator.userAgent;
}
function Xx() {
  return !/^((?!chrome|android).)*safari/i.test(Y5());
}
function ac(e, t, n) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  var r = e.getBoundingClientRect(), o = 1, a = 1;
  t && Uo(e) && (o = e.offsetWidth > 0 && oc(r.width) / e.offsetWidth || 1, a = e.offsetHeight > 0 && oc(r.height) / e.offsetHeight || 1);
  var i = Il(e) ? _o(e) : window, l = i.visualViewport, u = !Xx() && n, d = (r.left + (u && l ? l.offsetLeft : 0)) / o, f = (r.top + (u && l ? l.offsetTop : 0)) / a, h = r.width / o, p = r.height / a;
  return {
    width: h,
    height: p,
    top: f,
    right: d + h,
    bottom: f + p,
    left: d,
    x: d,
    y: f
  };
}
function n9(e) {
  var t = ac(e), n = e.offsetWidth, r = e.offsetHeight;
  return Math.abs(t.width - n) <= 1 && (n = t.width), Math.abs(t.height - r) <= 1 && (r = t.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: n,
    height: r
  };
}
function Yx(e, t) {
  var n = t.getRootNode && t.getRootNode();
  if (e.contains(t))
    return !0;
  if (n && t9(n)) {
    var r = t;
    do {
      if (r && e.isSameNode(r))
        return !0;
      r = r.parentNode || r.host;
    } while (r);
  }
  return !1;
}
function Ri(e) {
  return _o(e).getComputedStyle(e);
}
function vQ(e) {
  return ["table", "td", "th"].indexOf(ja(e)) >= 0;
}
function Ds(e) {
  return ((Il(e) ? e.ownerDocument : (
    // $FlowFixMe[prop-missing]
    e.document
  )) || window.document).documentElement;
}
function Vh(e) {
  return ja(e) === "html" ? e : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    e.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    e.parentNode || // DOM Element detected
    (t9(e) ? e.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    Ds(e)
  );
}
function wC(e) {
  return !Uo(e) || // https://github.com/popperjs/popper-core/issues/837
  Ri(e).position === "fixed" ? null : e.offsetParent;
}
function CQ(e) {
  var t = /firefox/i.test(Y5()), n = /Trident/i.test(Y5());
  if (n && Uo(e)) {
    var r = Ri(e);
    if (r.position === "fixed")
      return null;
  }
  var o = Vh(e);
  for (t9(o) && (o = o.host); Uo(o) && ["html", "body"].indexOf(ja(o)) < 0; ) {
    var a = Ri(o);
    if (a.transform !== "none" || a.perspective !== "none" || a.contain === "paint" || ["transform", "perspective"].indexOf(a.willChange) !== -1 || t && a.willChange === "filter" || t && a.filter && a.filter !== "none")
      return o;
    o = o.parentNode;
  }
  return null;
}
function Vd(e) {
  for (var t = _o(e), n = wC(e); n && vQ(n) && Ri(n).position === "static"; )
    n = wC(n);
  return n && (ja(n) === "html" || ja(n) === "body" && Ri(n).position === "static") ? t : n || CQ(e) || t;
}
function r9(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function J1(e, t, n) {
  return bl(e, _2(t, n));
}
function bQ(e, t, n) {
  var r = J1(e, t, n);
  return r > n ? n : r;
}
function qx() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function Jx(e) {
  return Object.assign({}, qx(), e);
}
function Kx(e, t) {
  return t.reduce(function(n, r) {
    return n[r] = e, n;
  }, {});
}
var yQ = function(t, n) {
  return t = typeof t == "function" ? t(Object.assign({}, n.rects, {
    placement: n.placement
  })) : t, Jx(typeof t != "number" ? t : Kx(t, kd));
};
function SQ(e) {
  var t, n = e.state, r = e.name, o = e.options, a = n.elements.arrow, i = n.modifiersData.popperOffsets, l = Ga(n.placement), u = r9(l), d = [io, Ko].indexOf(l) >= 0, f = d ? "height" : "width";
  if (!(!a || !i)) {
    var h = yQ(o.padding, n), p = n9(a), g = u === "y" ? ao : io, C = u === "y" ? Jo : Ko, v = n.rects.reference[f] + n.rects.reference[u] - i[u] - n.rects.popper[f], y = i[u] - n.rects.reference[u], M = Vd(a), x = M ? u === "y" ? M.clientHeight || 0 : M.clientWidth || 0 : 0, _ = v / 2 - y / 2, L = h[g], R = x - p[f] - h[C], k = x / 2 - p[f] / 2 + _, P = J1(L, k, R), N = u;
    n.modifiersData[r] = (t = {}, t[N] = P, t.centerOffset = P - k, t);
  }
}
function AQ(e) {
  var t = e.state, n = e.options, r = n.element, o = r === void 0 ? "[data-popper-arrow]" : r;
  o != null && (typeof o == "string" && (o = t.elements.popper.querySelector(o), !o) || Yx(t.elements.popper, o) && (t.elements.arrow = o));
}
const MQ = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: SQ,
  effect: AQ,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function ic(e) {
  return e.split("-")[1];
}
var xQ = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function wQ(e, t) {
  var n = e.x, r = e.y, o = t.devicePixelRatio || 1;
  return {
    x: oc(n * o) / o || 0,
    y: oc(r * o) / o || 0
  };
}
function _C(e) {
  var t, n = e.popper, r = e.popperRect, o = e.placement, a = e.variation, i = e.offsets, l = e.position, u = e.gpuAcceleration, d = e.adaptive, f = e.roundOffsets, h = e.isFixed, p = i.x, g = p === void 0 ? 0 : p, C = i.y, v = C === void 0 ? 0 : C, y = typeof f == "function" ? f({
    x: g,
    y: v
  }) : {
    x: g,
    y: v
  };
  g = y.x, v = y.y;
  var M = i.hasOwnProperty("x"), x = i.hasOwnProperty("y"), _ = io, L = ao, R = window;
  if (d) {
    var k = Vd(n), P = "clientHeight", N = "clientWidth";
    if (k === _o(n) && (k = Ds(n), Ri(k).position !== "static" && l === "absolute" && (P = "scrollHeight", N = "scrollWidth")), k = k, o === ao || (o === io || o === Ko) && a === gd) {
      L = Jo;
      var O = h && k === R && R.visualViewport ? R.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        k[P]
      );
      v -= O - r.height, v *= u ? 1 : -1;
    }
    if (o === io || (o === ao || o === Jo) && a === gd) {
      _ = Ko;
      var H = h && k === R && R.visualViewport ? R.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        k[N]
      );
      g -= H - r.width, g *= u ? 1 : -1;
    }
  }
  var $ = Object.assign({
    position: l
  }, d && xQ), ne = f === !0 ? wQ({
    x: g,
    y: v
  }, _o(n)) : {
    x: g,
    y: v
  };
  if (g = ne.x, v = ne.y, u) {
    var ie;
    return Object.assign({}, $, (ie = {}, ie[L] = x ? "0" : "", ie[_] = M ? "0" : "", ie.transform = (R.devicePixelRatio || 1) <= 1 ? "translate(" + g + "px, " + v + "px)" : "translate3d(" + g + "px, " + v + "px, 0)", ie));
  }
  return Object.assign({}, $, (t = {}, t[L] = x ? v + "px" : "", t[_] = M ? g + "px" : "", t.transform = "", t));
}
function _Q(e) {
  var t = e.state, n = e.options, r = n.gpuAcceleration, o = r === void 0 ? !0 : r, a = n.adaptive, i = a === void 0 ? !0 : a, l = n.roundOffsets, u = l === void 0 ? !0 : l, d = {
    placement: Ga(t.placement),
    variation: ic(t.placement),
    popper: t.elements.popper,
    popperRect: t.rects.popper,
    gpuAcceleration: o,
    isFixed: t.options.strategy === "fixed"
  };
  t.modifiersData.popperOffsets != null && (t.styles.popper = Object.assign({}, t.styles.popper, _C(Object.assign({}, d, {
    offsets: t.modifiersData.popperOffsets,
    position: t.options.strategy,
    adaptive: i,
    roundOffsets: u
  })))), t.modifiersData.arrow != null && (t.styles.arrow = Object.assign({}, t.styles.arrow, _C(Object.assign({}, d, {
    offsets: t.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: u
  })))), t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-placement": t.placement
  });
}
const IQ = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: _Q,
  data: {}
};
var vf = {
  passive: !0
};
function LQ(e) {
  var t = e.state, n = e.instance, r = e.options, o = r.scroll, a = o === void 0 ? !0 : o, i = r.resize, l = i === void 0 ? !0 : i, u = _o(t.elements.popper), d = [].concat(t.scrollParents.reference, t.scrollParents.popper);
  return a && d.forEach(function(f) {
    f.addEventListener("scroll", n.update, vf);
  }), l && u.addEventListener("resize", n.update, vf), function() {
    a && d.forEach(function(f) {
      f.removeEventListener("scroll", n.update, vf);
    }), l && u.removeEventListener("resize", n.update, vf);
  };
}
const RQ = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: LQ,
  data: {}
};
var DQ = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function Kf(e) {
  return e.replace(/left|right|bottom|top/g, function(t) {
    return DQ[t];
  });
}
var PQ = {
  start: "end",
  end: "start"
};
function IC(e) {
  return e.replace(/start|end/g, function(t) {
    return PQ[t];
  });
}
function o9(e) {
  var t = _o(e), n = t.pageXOffset, r = t.pageYOffset;
  return {
    scrollLeft: n,
    scrollTop: r
  };
}
function a9(e) {
  return ac(Ds(e)).left + o9(e).scrollLeft;
}
function EQ(e, t) {
  var n = _o(e), r = Ds(e), o = n.visualViewport, a = r.clientWidth, i = r.clientHeight, l = 0, u = 0;
  if (o) {
    a = o.width, i = o.height;
    var d = Xx();
    (d || !d && t === "fixed") && (l = o.offsetLeft, u = o.offsetTop);
  }
  return {
    width: a,
    height: i,
    x: l + a9(e),
    y: u
  };
}
function TQ(e) {
  var t, n = Ds(e), r = o9(e), o = (t = e.ownerDocument) == null ? void 0 : t.body, a = bl(n.scrollWidth, n.clientWidth, o ? o.scrollWidth : 0, o ? o.clientWidth : 0), i = bl(n.scrollHeight, n.clientHeight, o ? o.scrollHeight : 0, o ? o.clientHeight : 0), l = -r.scrollLeft + a9(e), u = -r.scrollTop;
  return Ri(o || n).direction === "rtl" && (l += bl(n.clientWidth, o ? o.clientWidth : 0) - a), {
    width: a,
    height: i,
    x: l,
    y: u
  };
}
function i9(e) {
  var t = Ri(e), n = t.overflow, r = t.overflowX, o = t.overflowY;
  return /auto|scroll|overlay|hidden/.test(n + o + r);
}
function Qx(e) {
  return ["html", "body", "#document"].indexOf(ja(e)) >= 0 ? e.ownerDocument.body : Uo(e) && i9(e) ? e : Qx(Vh(e));
}
function K1(e, t) {
  var n;
  t === void 0 && (t = []);
  var r = Qx(e), o = r === ((n = e.ownerDocument) == null ? void 0 : n.body), a = _o(r), i = o ? [a].concat(a.visualViewport || [], i9(r) ? r : []) : r, l = t.concat(i);
  return o ? l : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    l.concat(K1(Vh(i)))
  );
}
function q5(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function NQ(e, t) {
  var n = ac(e, !1, t === "fixed");
  return n.top = n.top + e.clientTop, n.left = n.left + e.clientLeft, n.bottom = n.top + e.clientHeight, n.right = n.left + e.clientWidth, n.width = e.clientWidth, n.height = e.clientHeight, n.x = n.left, n.y = n.top, n;
}
function LC(e, t, n) {
  return t === zx ? q5(EQ(e, n)) : Il(t) ? NQ(t, n) : q5(TQ(Ds(e)));
}
function kQ(e) {
  var t = K1(Vh(e)), n = ["absolute", "fixed"].indexOf(Ri(e).position) >= 0, r = n && Uo(e) ? Vd(e) : e;
  return Il(r) ? t.filter(function(o) {
    return Il(o) && Yx(o, r) && ja(o) !== "body";
  }) : [];
}
function VQ(e, t, n, r) {
  var o = t === "clippingParents" ? kQ(e) : [].concat(t), a = [].concat(o, [n]), i = a[0], l = a.reduce(function(u, d) {
    var f = LC(e, d, r);
    return u.top = bl(f.top, u.top), u.right = _2(f.right, u.right), u.bottom = _2(f.bottom, u.bottom), u.left = bl(f.left, u.left), u;
  }, LC(e, i, r));
  return l.width = l.right - l.left, l.height = l.bottom - l.top, l.x = l.left, l.y = l.top, l;
}
function ew(e) {
  var t = e.reference, n = e.element, r = e.placement, o = r ? Ga(r) : null, a = r ? ic(r) : null, i = t.x + t.width / 2 - n.width / 2, l = t.y + t.height / 2 - n.height / 2, u;
  switch (o) {
    case ao:
      u = {
        x: i,
        y: t.y - n.height
      };
      break;
    case Jo:
      u = {
        x: i,
        y: t.y + t.height
      };
      break;
    case Ko:
      u = {
        x: t.x + t.width,
        y: l
      };
      break;
    case io:
      u = {
        x: t.x - n.width,
        y: l
      };
      break;
    default:
      u = {
        x: t.x,
        y: t.y
      };
  }
  var d = o ? r9(o) : null;
  if (d != null) {
    var f = d === "y" ? "height" : "width";
    switch (a) {
      case rc:
        u[d] = u[d] - (t[f] / 2 - n[f] / 2);
        break;
      case gd:
        u[d] = u[d] + (t[f] / 2 - n[f] / 2);
        break;
    }
  }
  return u;
}
function vd(e, t) {
  t === void 0 && (t = {});
  var n = t, r = n.placement, o = r === void 0 ? e.placement : r, a = n.strategy, i = a === void 0 ? e.strategy : a, l = n.boundary, u = l === void 0 ? nQ : l, d = n.rootBoundary, f = d === void 0 ? zx : d, h = n.elementContext, p = h === void 0 ? m1 : h, g = n.altBoundary, C = g === void 0 ? !1 : g, v = n.padding, y = v === void 0 ? 0 : v, M = Jx(typeof y != "number" ? y : Kx(y, kd)), x = p === m1 ? rQ : m1, _ = e.rects.popper, L = e.elements[C ? x : p], R = VQ(Il(L) ? L : L.contextElement || Ds(e.elements.popper), u, f, i), k = ac(e.elements.reference), P = ew({
    reference: k,
    element: _,
    strategy: "absolute",
    placement: o
  }), N = q5(Object.assign({}, _, P)), O = p === m1 ? N : k, H = {
    top: R.top - O.top + M.top,
    bottom: O.bottom - R.bottom + M.bottom,
    left: R.left - O.left + M.left,
    right: O.right - R.right + M.right
  }, $ = e.modifiersData.offset;
  if (p === m1 && $) {
    var ne = $[o];
    Object.keys(H).forEach(function(ie) {
      var re = [Ko, Jo].indexOf(ie) >= 0 ? 1 : -1, ve = [ao, Jo].indexOf(ie) >= 0 ? "y" : "x";
      H[ie] += ne[ve] * re;
    });
  }
  return H;
}
function OQ(e, t) {
  t === void 0 && (t = {});
  var n = t, r = n.placement, o = n.boundary, a = n.rootBoundary, i = n.padding, l = n.flipVariations, u = n.allowedAutoPlacements, d = u === void 0 ? Ux : u, f = ic(r), h = f ? l ? xC : xC.filter(function(C) {
    return ic(C) === f;
  }) : kd, p = h.filter(function(C) {
    return d.indexOf(C) >= 0;
  });
  p.length === 0 && (p = h);
  var g = p.reduce(function(C, v) {
    return C[v] = vd(e, {
      placement: v,
      boundary: o,
      rootBoundary: a,
      padding: i
    })[Ga(v)], C;
  }, {});
  return Object.keys(g).sort(function(C, v) {
    return g[C] - g[v];
  });
}
function FQ(e) {
  if (Ga(e) === e9)
    return [];
  var t = Kf(e);
  return [IC(e), t, IC(t)];
}
function BQ(e) {
  var t = e.state, n = e.options, r = e.name;
  if (!t.modifiersData[r]._skip) {
    for (var o = n.mainAxis, a = o === void 0 ? !0 : o, i = n.altAxis, l = i === void 0 ? !0 : i, u = n.fallbackPlacements, d = n.padding, f = n.boundary, h = n.rootBoundary, p = n.altBoundary, g = n.flipVariations, C = g === void 0 ? !0 : g, v = n.allowedAutoPlacements, y = t.options.placement, M = Ga(y), x = M === y, _ = u || (x || !C ? [Kf(y)] : FQ(y)), L = [y].concat(_).reduce(function(he, me) {
      return he.concat(Ga(me) === e9 ? OQ(t, {
        placement: me,
        boundary: f,
        rootBoundary: h,
        padding: d,
        flipVariations: C,
        allowedAutoPlacements: v
      }) : me);
    }, []), R = t.rects.reference, k = t.rects.popper, P = /* @__PURE__ */ new Map(), N = !0, O = L[0], H = 0; H < L.length; H++) {
      var $ = L[H], ne = Ga($), ie = ic($) === rc, re = [ao, Jo].indexOf(ne) >= 0, ve = re ? "width" : "height", ue = vd(t, {
        placement: $,
        boundary: f,
        rootBoundary: h,
        altBoundary: p,
        padding: d
      }), j = re ? ie ? Ko : io : ie ? Jo : ao;
      R[ve] > k[ve] && (j = Kf(j));
      var K = Kf(j), ce = [];
      if (a && ce.push(ue[ne] <= 0), l && ce.push(ue[j] <= 0, ue[K] <= 0), ce.every(function(he) {
        return he;
      })) {
        O = $, N = !1;
        break;
      }
      P.set($, ce);
    }
    if (N)
      for (var U = C ? 3 : 1, q = function(me) {
        var de = L.find(function(Le) {
          var Ie = P.get(Le);
          if (Ie)
            return Ie.slice(0, me).every(function(Ne) {
              return Ne;
            });
        });
        if (de)
          return O = de, "break";
      }, ge = U; ge > 0; ge--) {
        var X = q(ge);
        if (X === "break")
          break;
      }
    t.placement !== O && (t.modifiersData[r]._skip = !0, t.placement = O, t.reset = !0);
  }
}
const HQ = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: BQ,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function RC(e, t, n) {
  return n === void 0 && (n = {
    x: 0,
    y: 0
  }), {
    top: e.top - t.height - n.y,
    right: e.right - t.width + n.x,
    bottom: e.bottom - t.height + n.y,
    left: e.left - t.width - n.x
  };
}
function DC(e) {
  return [ao, Ko, Jo, io].some(function(t) {
    return e[t] >= 0;
  });
}
function GQ(e) {
  var t = e.state, n = e.name, r = t.rects.reference, o = t.rects.popper, a = t.modifiersData.preventOverflow, i = vd(t, {
    elementContext: "reference"
  }), l = vd(t, {
    altBoundary: !0
  }), u = RC(i, r), d = RC(l, o, a), f = DC(u), h = DC(d);
  t.modifiersData[n] = {
    referenceClippingOffsets: u,
    popperEscapeOffsets: d,
    isReferenceHidden: f,
    hasPopperEscaped: h
  }, t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-reference-hidden": f,
    "data-popper-escaped": h
  });
}
const $Q = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: GQ
};
function ZQ(e, t, n) {
  var r = Ga(e), o = [io, ao].indexOf(r) >= 0 ? -1 : 1, a = typeof n == "function" ? n(Object.assign({}, t, {
    placement: e
  })) : n, i = a[0], l = a[1];
  return i = i || 0, l = (l || 0) * o, [io, Ko].indexOf(r) >= 0 ? {
    x: l,
    y: i
  } : {
    x: i,
    y: l
  };
}
function jQ(e) {
  var t = e.state, n = e.options, r = e.name, o = n.offset, a = o === void 0 ? [0, 0] : o, i = Ux.reduce(function(f, h) {
    return f[h] = ZQ(h, t.rects, a), f;
  }, {}), l = i[t.placement], u = l.x, d = l.y;
  t.modifiersData.popperOffsets != null && (t.modifiersData.popperOffsets.x += u, t.modifiersData.popperOffsets.y += d), t.modifiersData[r] = i;
}
const WQ = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: jQ
};
function zQ(e) {
  var t = e.state, n = e.name;
  t.modifiersData[n] = ew({
    reference: t.rects.reference,
    element: t.rects.popper,
    strategy: "absolute",
    placement: t.placement
  });
}
const UQ = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: zQ,
  data: {}
};
function XQ(e) {
  return e === "x" ? "y" : "x";
}
function YQ(e) {
  var t = e.state, n = e.options, r = e.name, o = n.mainAxis, a = o === void 0 ? !0 : o, i = n.altAxis, l = i === void 0 ? !1 : i, u = n.boundary, d = n.rootBoundary, f = n.altBoundary, h = n.padding, p = n.tether, g = p === void 0 ? !0 : p, C = n.tetherOffset, v = C === void 0 ? 0 : C, y = vd(t, {
    boundary: u,
    rootBoundary: d,
    padding: h,
    altBoundary: f
  }), M = Ga(t.placement), x = ic(t.placement), _ = !x, L = r9(M), R = XQ(L), k = t.modifiersData.popperOffsets, P = t.rects.reference, N = t.rects.popper, O = typeof v == "function" ? v(Object.assign({}, t.rects, {
    placement: t.placement
  })) : v, H = typeof O == "number" ? {
    mainAxis: O,
    altAxis: O
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, O), $ = t.modifiersData.offset ? t.modifiersData.offset[t.placement] : null, ne = {
    x: 0,
    y: 0
  };
  if (k) {
    if (a) {
      var ie, re = L === "y" ? ao : io, ve = L === "y" ? Jo : Ko, ue = L === "y" ? "height" : "width", j = k[L], K = j + y[re], ce = j - y[ve], U = g ? -N[ue] / 2 : 0, q = x === rc ? P[ue] : N[ue], ge = x === rc ? -N[ue] : -P[ue], X = t.elements.arrow, he = g && X ? n9(X) : {
        width: 0,
        height: 0
      }, me = t.modifiersData["arrow#persistent"] ? t.modifiersData["arrow#persistent"].padding : qx(), de = me[re], Le = me[ve], Ie = J1(0, P[ue], he[ue]), Ne = _ ? P[ue] / 2 - U - Ie - de - H.mainAxis : q - Ie - de - H.mainAxis, ye = _ ? -P[ue] / 2 + U + Ie + Le + H.mainAxis : ge + Ie + Le + H.mainAxis, ke = t.elements.arrow && Vd(t.elements.arrow), oe = ke ? L === "y" ? ke.clientTop || 0 : ke.clientLeft || 0 : 0, lt = (ie = $ == null ? void 0 : $[L]) != null ? ie : 0, Re = j + Ne - lt - oe, _t = j + ye - lt, on = J1(g ? _2(K, Re) : K, j, g ? bl(ce, _t) : ce);
      k[L] = on, ne[L] = on - j;
    }
    if (l) {
      var $e, Zt = L === "x" ? ao : io, Pt = L === "x" ? Jo : Ko, yt = k[R], jt = R === "y" ? "height" : "width", An = yt + y[Zt], Rn = yt - y[Pt], Er = [ao, io].indexOf(M) !== -1, Ar = ($e = $ == null ? void 0 : $[R]) != null ? $e : 0, oa = Er ? An : yt - P[jt] - N[jt] - Ar + H.altAxis, fr = Er ? yt + P[jt] + N[jt] - Ar - H.altAxis : Rn, De = g && Er ? bQ(oa, yt, fr) : J1(g ? oa : An, yt, g ? fr : Rn);
      k[R] = De, ne[R] = De - yt;
    }
    t.modifiersData[r] = ne;
  }
}
const qQ = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: YQ,
  requiresIfExists: ["offset"]
};
function JQ(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function KQ(e) {
  return e === _o(e) || !Uo(e) ? o9(e) : JQ(e);
}
function QQ(e) {
  var t = e.getBoundingClientRect(), n = oc(t.width) / e.offsetWidth || 1, r = oc(t.height) / e.offsetHeight || 1;
  return n !== 1 || r !== 1;
}
function eee(e, t, n) {
  n === void 0 && (n = !1);
  var r = Uo(t), o = Uo(t) && QQ(t), a = Ds(t), i = ac(e, o, n), l = {
    scrollLeft: 0,
    scrollTop: 0
  }, u = {
    x: 0,
    y: 0
  };
  return (r || !r && !n) && ((ja(t) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  i9(a)) && (l = KQ(t)), Uo(t) ? (u = ac(t, !0), u.x += t.clientLeft, u.y += t.clientTop) : a && (u.x = a9(a))), {
    x: i.left + l.scrollLeft - u.x,
    y: i.top + l.scrollTop - u.y,
    width: i.width,
    height: i.height
  };
}
function tee(e) {
  var t = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Set(), r = [];
  e.forEach(function(a) {
    t.set(a.name, a);
  });
  function o(a) {
    n.add(a.name);
    var i = [].concat(a.requires || [], a.requiresIfExists || []);
    i.forEach(function(l) {
      if (!n.has(l)) {
        var u = t.get(l);
        u && o(u);
      }
    }), r.push(a);
  }
  return e.forEach(function(a) {
    n.has(a.name) || o(a);
  }), r;
}
function nee(e) {
  var t = tee(e);
  return hQ.reduce(function(n, r) {
    return n.concat(t.filter(function(o) {
      return o.phase === r;
    }));
  }, []);
}
function ree(e) {
  var t;
  return function() {
    return t || (t = new Promise(function(n) {
      Promise.resolve().then(function() {
        t = void 0, n(e());
      });
    })), t;
  };
}
function oee(e) {
  var t = e.reduce(function(n, r) {
    var o = n[r.name];
    return n[r.name] = o ? Object.assign({}, o, r, {
      options: Object.assign({}, o.options, r.options),
      data: Object.assign({}, o.data, r.data)
    }) : r, n;
  }, {});
  return Object.keys(t).map(function(n) {
    return t[n];
  });
}
var PC = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function EC() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return !t.some(function(r) {
    return !(r && typeof r.getBoundingClientRect == "function");
  });
}
function aee(e) {
  e === void 0 && (e = {});
  var t = e, n = t.defaultModifiers, r = n === void 0 ? [] : n, o = t.defaultOptions, a = o === void 0 ? PC : o;
  return function(l, u, d) {
    d === void 0 && (d = a);
    var f = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, PC, a),
      modifiersData: {},
      elements: {
        reference: l,
        popper: u
      },
      attributes: {},
      styles: {}
    }, h = [], p = !1, g = {
      state: f,
      setOptions: function(M) {
        var x = typeof M == "function" ? M(f.options) : M;
        v(), f.options = Object.assign({}, a, f.options, x), f.scrollParents = {
          reference: Il(l) ? K1(l) : l.contextElement ? K1(l.contextElement) : [],
          popper: K1(u)
        };
        var _ = nee(oee([].concat(r, f.options.modifiers)));
        return f.orderedModifiers = _.filter(function(L) {
          return L.enabled;
        }), C(), g.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!p) {
          var M = f.elements, x = M.reference, _ = M.popper;
          if (EC(x, _)) {
            f.rects = {
              reference: eee(x, Vd(_), f.options.strategy === "fixed"),
              popper: n9(_)
            }, f.reset = !1, f.placement = f.options.placement, f.orderedModifiers.forEach(function(H) {
              return f.modifiersData[H.name] = Object.assign({}, H.data);
            });
            for (var L = 0; L < f.orderedModifiers.length; L++) {
              if (f.reset === !0) {
                f.reset = !1, L = -1;
                continue;
              }
              var R = f.orderedModifiers[L], k = R.fn, P = R.options, N = P === void 0 ? {} : P, O = R.name;
              typeof k == "function" && (f = k({
                state: f,
                options: N,
                name: O,
                instance: g
              }) || f);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: ree(function() {
        return new Promise(function(y) {
          g.forceUpdate(), y(f);
        });
      }),
      destroy: function() {
        v(), p = !0;
      }
    };
    if (!EC(l, u))
      return g;
    g.setOptions(d).then(function(y) {
      !p && d.onFirstUpdate && d.onFirstUpdate(y);
    });
    function C() {
      f.orderedModifiers.forEach(function(y) {
        var M = y.name, x = y.options, _ = x === void 0 ? {} : x, L = y.effect;
        if (typeof L == "function") {
          var R = L({
            state: f,
            name: M,
            instance: g,
            options: _
          }), k = function() {
          };
          h.push(R || k);
        }
      });
    }
    function v() {
      h.forEach(function(y) {
        return y();
      }), h = [];
    }
    return g;
  };
}
var iee = [RQ, UQ, IQ, gQ, WQ, HQ, qQ, MQ, $Q], see = /* @__PURE__ */ aee({
  defaultModifiers: iee
});
const yu = (e, t) => ({
  var: e,
  varRef: t ? `var(${e}, ${t})` : `var(${e})`
}), tr = {
  arrowShadowColor: yu("--popper-arrow-shadow-color"),
  arrowSize: yu("--popper-arrow-size", "8px"),
  arrowSizeHalf: yu("--popper-arrow-size-half"),
  arrowBg: yu("--popper-arrow-bg"),
  transformOrigin: yu("--popper-transform-origin"),
  arrowOffset: yu("--popper-arrow-offset")
};
function lee(e) {
  if (e.includes("top"))
    return "1px 1px 0px 0 var(--popper-arrow-shadow-color)";
  if (e.includes("bottom"))
    return "-1px -1px 0px 0 var(--popper-arrow-shadow-color)";
  if (e.includes("right"))
    return "-1px 1px 0px 0 var(--popper-arrow-shadow-color)";
  if (e.includes("left"))
    return "1px -1px 0px 0 var(--popper-arrow-shadow-color)";
}
const uee = {
  top: "bottom center",
  "top-start": "bottom left",
  "top-end": "bottom right",
  bottom: "top center",
  "bottom-start": "top left",
  "bottom-end": "top right",
  left: "right center",
  "left-start": "right top",
  "left-end": "right bottom",
  right: "left center",
  "right-start": "left top",
  "right-end": "left bottom"
}, cee = (e) => uee[e], TC = {
  scroll: !0,
  resize: !0
};
function dee(e) {
  let t;
  return typeof e == "object" ? t = {
    enabled: !0,
    options: { ...TC, ...e }
  } : t = {
    enabled: e,
    options: TC
  }, t;
}
const fee = {
  name: "matchWidth",
  enabled: !0,
  phase: "beforeWrite",
  requires: ["computeStyles"],
  fn: ({ state: e }) => {
    e.styles.popper.width = `${e.rects.reference.width}px`;
  },
  effect: ({ state: e }) => () => {
    const t = e.elements.reference;
    e.elements.popper.style.width = `${t.offsetWidth}px`;
  }
}, hee = {
  name: "transformOrigin",
  enabled: !0,
  phase: "write",
  fn: ({ state: e }) => {
    NC(e);
  },
  effect: ({ state: e }) => () => {
    NC(e);
  }
}, NC = (e) => {
  e.elements.popper.style.setProperty(
    tr.transformOrigin.var,
    cee(e.placement)
  );
}, mee = {
  name: "positionArrow",
  enabled: !0,
  phase: "afterWrite",
  fn: ({ state: e }) => {
    pee(e);
  }
}, pee = (e) => {
  var n;
  if (!e.placement)
    return;
  const t = gee(e.placement);
  if ((n = e.elements) != null && n.arrow && t) {
    Object.assign(e.elements.arrow.style, {
      [t.property]: t.value,
      width: tr.arrowSize.varRef,
      height: tr.arrowSize.varRef,
      zIndex: -1
    });
    const r = {
      [tr.arrowSizeHalf.var]: `calc(${tr.arrowSize.varRef} / 2 - 1px)`,
      [tr.arrowOffset.var]: `calc(${tr.arrowSizeHalf.varRef} * -1)`
    };
    for (const o in r)
      e.elements.arrow.style.setProperty(o, r[o]);
  }
}, gee = (e) => {
  if (e.startsWith("top"))
    return { property: "bottom", value: tr.arrowOffset.varRef };
  if (e.startsWith("bottom"))
    return { property: "top", value: tr.arrowOffset.varRef };
  if (e.startsWith("left"))
    return { property: "right", value: tr.arrowOffset.varRef };
  if (e.startsWith("right"))
    return { property: "left", value: tr.arrowOffset.varRef };
}, vee = {
  name: "innerArrow",
  enabled: !0,
  phase: "main",
  requires: ["arrow"],
  fn: ({ state: e }) => {
    kC(e);
  },
  effect: ({ state: e }) => () => {
    kC(e);
  }
}, kC = (e) => {
  if (!e.elements.arrow)
    return;
  const t = e.elements.arrow.querySelector(
    "[data-popper-arrow-inner]"
  );
  if (!t)
    return;
  const n = lee(e.placement);
  n && t.style.setProperty("--popper-arrow-default-shadow", n), Object.assign(t.style, {
    transform: "rotate(45deg)",
    background: tr.arrowBg.varRef,
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    position: "absolute",
    zIndex: "inherit",
    boxShadow: "var(--popper-arrow-shadow, var(--popper-arrow-default-shadow))"
  });
}, Cee = {
  "start-start": { ltr: "left-start", rtl: "right-start" },
  "start-end": { ltr: "left-end", rtl: "right-end" },
  "end-start": { ltr: "right-start", rtl: "left-start" },
  "end-end": { ltr: "right-end", rtl: "left-end" },
  start: { ltr: "left", rtl: "right" },
  end: { ltr: "right", rtl: "left" }
}, bee = {
  "auto-start": "auto-end",
  "auto-end": "auto-start",
  "top-start": "top-end",
  "top-end": "top-start",
  "bottom-start": "bottom-end",
  "bottom-end": "bottom-start"
};
function yee(e, t = "ltr") {
  var r;
  const n = ((r = Cee[e]) == null ? void 0 : r[t]) || e;
  return t === "ltr" ? n : bee[e] ?? n;
}
function s9(e = {}) {
  const {
    enabled: t = !0,
    modifiers: n,
    placement: r = "bottom",
    strategy: o = "absolute",
    arrowPadding: a = 8,
    eventListeners: i = !0,
    offset: l,
    gutter: u = 8,
    flip: d = !0,
    boundary: f = "clippingParents",
    preventOverflow: h = !0,
    matchWidth: p,
    direction: g = "ltr"
  } = e, C = Ve(null), v = Ve(null), y = Ve(null), M = yee(r, g), x = Ve(() => {
  }), _ = Q(() => {
    var H;
    !t || !C.current || !v.current || ((H = x.current) == null || H.call(x), y.current = see(C.current, v.current, {
      placement: M,
      modifiers: [
        vee,
        mee,
        hee,
        {
          ...fee,
          enabled: !!p
        },
        {
          name: "eventListeners",
          ...dee(i)
        },
        {
          name: "arrow",
          options: { padding: a }
        },
        {
          name: "offset",
          options: {
            offset: l ?? [0, u]
          }
        },
        {
          name: "flip",
          enabled: !!d,
          options: { padding: 8 }
        },
        {
          name: "preventOverflow",
          enabled: !!h,
          options: { boundary: f }
        },
        // allow users override internal modifiers
        ...n ?? []
      ],
      strategy: o
    }), y.current.forceUpdate(), x.current = y.current.destroy);
  }, [
    M,
    t,
    n,
    p,
    i,
    a,
    l,
    u,
    d,
    h,
    f,
    o
  ]);
  st(() => () => {
    var H;
    !C.current && !v.current && ((H = y.current) == null || H.destroy(), y.current = null);
  }, []);
  const L = Q(
    (H) => {
      C.current = H, _();
    },
    [_]
  ), R = Q(
    (H = {}, $ = null) => ({
      ...H,
      ref: In(L, $)
    }),
    [L]
  ), k = Q(
    (H) => {
      v.current = H, _();
    },
    [_]
  ), P = Q(
    (H = {}, $ = null) => ({
      ...H,
      ref: In(k, $),
      style: {
        ...H.style,
        position: o,
        minWidth: p ? void 0 : "max-content",
        inset: "0 auto auto 0"
      }
    }),
    [o, k, p]
  ), N = Q((H = {}, $ = null) => {
    const { size: ne, shadowColor: ie, bg: re, style: ve, ...ue } = H;
    return {
      ...ue,
      ref: $,
      "data-popper-arrow": "",
      style: See(H)
    };
  }, []), O = Q(
    (H = {}, $ = null) => ({
      ...H,
      ref: $,
      "data-popper-arrow-inner": ""
    }),
    []
  );
  return {
    update() {
      var H;
      (H = y.current) == null || H.update();
    },
    forceUpdate() {
      var H;
      (H = y.current) == null || H.forceUpdate();
    },
    transformOrigin: tr.transformOrigin.varRef,
    referenceRef: L,
    popperRef: k,
    getPopperProps: P,
    getArrowProps: N,
    getArrowInnerProps: O,
    getReferenceProps: R
  };
}
function See(e) {
  const { size: t, shadowColor: n, bg: r, style: o } = e, a = { ...o, position: "absolute" };
  return t && (a["--popper-arrow-size"] = t), n && (a["--popper-arrow-shadow-color"] = n), r && (a["--popper-arrow-bg"] = r), a;
}
function Aee() {
  const e = Ve(/* @__PURE__ */ new Map()), t = e.current, n = Q((o, a, i, l) => {
    e.current.set(i, { type: a, el: o, options: l }), o.addEventListener(a, i, l);
  }, []), r = Q(
    (o, a, i, l) => {
      o.removeEventListener(a, i, l), e.current.delete(i);
    },
    []
  );
  return st(
    () => () => {
      t.forEach((o, a) => {
        r(o.el, o.type, a, o.options);
      });
    },
    [r, t]
  ), { add: n, remove: r };
}
function Eg(e) {
  var o, a;
  const t = ((a = (o = e.composedPath) == null ? void 0 : o.call(e)) == null ? void 0 : a[0]) ?? e.target, { tagName: n, isContentEditable: r } = t;
  return n !== "INPUT" && n !== "TEXTAREA" && r !== !0;
}
function Mee(e = {}) {
  const {
    ref: t,
    isDisabled: n,
    isFocusable: r,
    clickOnEnter: o = !0,
    clickOnSpace: a = !0,
    onMouseDown: i,
    onMouseUp: l,
    onClick: u,
    onKeyDown: d,
    onKeyUp: f,
    tabIndex: h,
    onMouseOver: p,
    onMouseLeave: g,
    ...C
  } = e, [v, y] = He(!0), [M, x] = He(!1), _ = Aee(), L = (j) => {
    j && j.tagName !== "BUTTON" && y(!1);
  }, R = v ? h : h || 0, k = n && !r, P = Q(
    (j) => {
      if (n) {
        j.stopPropagation(), j.preventDefault();
        return;
      }
      j.currentTarget.focus(), u == null || u(j);
    },
    [n, u]
  ), N = Q(
    (j) => {
      M && Eg(j) && (j.preventDefault(), j.stopPropagation(), x(!1), _.remove(document, "keyup", N, !1));
    },
    [M, _]
  ), O = Q(
    (j) => {
      if (d == null || d(j), n || j.defaultPrevented || j.metaKey || !Eg(j.nativeEvent) || v)
        return;
      const K = o && j.key === "Enter";
      a && j.key === " " && (j.preventDefault(), x(!0)), K && (j.preventDefault(), j.currentTarget.click()), _.add(document, "keyup", N, !1);
    },
    [
      n,
      v,
      d,
      o,
      a,
      _,
      N
    ]
  ), H = Q(
    (j) => {
      if (f == null || f(j), n || j.defaultPrevented || j.metaKey || !Eg(j.nativeEvent) || v)
        return;
      a && j.key === " " && (j.preventDefault(), x(!1), j.currentTarget.click());
    },
    [a, v, n, f]
  ), $ = Q(
    (j) => {
      j.button === 0 && (x(!1), _.remove(document, "mouseup", $, !1));
    },
    [_]
  ), ne = Q(
    (j) => {
      if (j.button !== 0)
        return;
      if (n) {
        j.stopPropagation(), j.preventDefault();
        return;
      }
      v || x(!0), j.currentTarget.focus({ preventScroll: !0 }), _.add(document, "mouseup", $, !1), i == null || i(j);
    },
    [n, v, i, _, $]
  ), ie = Q(
    (j) => {
      j.button === 0 && (v || x(!1), l == null || l(j));
    },
    [l, v]
  ), re = Q(
    (j) => {
      if (n) {
        j.preventDefault();
        return;
      }
      p == null || p(j);
    },
    [n, p]
  ), ve = Q(
    (j) => {
      M && (j.preventDefault(), x(!1)), g == null || g(j);
    },
    [M, g]
  ), ue = In(t, L);
  return v ? {
    ...C,
    ref: ue,
    type: "button",
    "aria-disabled": k ? void 0 : n,
    disabled: k,
    onClick: P,
    onMouseDown: i,
    onMouseUp: l,
    onKeyUp: f,
    onKeyDown: d,
    onMouseOver: p,
    onMouseLeave: g
  } : {
    ...C,
    ref: ue,
    role: "button",
    "data-active": Qe(M),
    "aria-disabled": n ? "true" : void 0,
    tabIndex: k ? void 0 : R,
    onClick: P,
    onMouseDown: ne,
    onMouseUp: ie,
    onKeyUp: H,
    onKeyDown: O,
    onMouseOver: re,
    onMouseLeave: ve
  };
}
const [
  xee,
  wee,
  _ee,
  Iee
] = NM(), [Lee, Od] = mn({
  strict: !1,
  name: "MenuContext"
});
function tw(e) {
  return (e == null ? void 0 : e.ownerDocument) ?? document;
}
function Ree(e) {
  return tw(e).activeElement === e;
}
function Dee(e = {}) {
  const {
    id: t,
    closeOnSelect: n = !0,
    closeOnBlur: r = !0,
    initialFocusRef: o,
    autoSelect: a = !0,
    isLazy: i,
    isOpen: l,
    defaultIsOpen: u,
    onClose: d,
    onOpen: f,
    placement: h = "bottom-start",
    lazyBehavior: p = "unmount",
    direction: g,
    computePositionOnMount: C = !1,
    ...v
  } = e, y = Ve(null), M = Ve(null), x = Ve(!0), _ = _ee(), L = Q(() => {
    requestAnimationFrame(() => {
      var X;
      (X = y.current) == null || X.focus({ preventScroll: !1 });
    });
  }, []), R = Q(() => {
    const X = setTimeout(() => {
      var he, me;
      if (o)
        (he = o.current) == null || he.focus();
      else if (!_.count())
        (me = y.current) == null || me.focus({ preventScroll: !1 });
      else {
        const de = _.firstEnabled();
        de && re(de.index);
      }
    });
    ce.current.add(X);
  }, [_, o]), k = Q(() => {
    const X = setTimeout(() => {
      var he;
      if (!_.count())
        (he = y.current) == null || he.focus({ preventScroll: !1 });
      else {
        const me = _.lastEnabled();
        me && re(me.index);
      }
    });
    ce.current.add(X);
  }, [_]), P = Q(() => {
    f == null || f(), a ? R() : L();
  }, [a, R, L, f]), { isOpen: N, onOpen: O, onClose: H, onToggle: $ } = wd({
    isOpen: l,
    defaultIsOpen: u,
    onClose: d,
    onOpen: P
  });
  LS({
    enabled: N && r,
    ref: y,
    handler: (X) => {
      var me, de, Le;
      const he = ((de = (me = X.composedPath) == null ? void 0 : me.call(X)) == null ? void 0 : de[0]) ?? X.target;
      (Le = M.current) != null && Le.contains(he) || H();
    }
  });
  const ne = s9({
    ...v,
    enabled: N || C,
    placement: h,
    direction: g
  }), [ie, re] = He(-1);
  _S(y, {
    focusRef: M,
    visible: N,
    shouldFocus: !0
  });
  const ve = MS({ isOpen: N, ref: y }), [ue, j] = IO(t, "menu-button", "menu-list"), K = Q(() => {
    O(), L();
  }, [O, L]), ce = Ve(/* @__PURE__ */ new Set([]));
  st(() => {
    const X = ce.current;
    return () => {
      X.forEach((he) => clearTimeout(he)), X.clear();
    };
  }, []), Ss(() => {
    var X;
    N || (re(-1), (X = y.current) == null || X.scrollTo(0, 0));
  }, [N]), Ss(() => {
    N && ie === -1 && L();
  }, [ie, N]), st(() => {
    var he;
    if (!N)
      return;
    const X = _.item(ie);
    (he = X == null ? void 0 : X.node) == null || he.focus({ preventScroll: !x.current });
  }, [_, ie, N]);
  const U = Q(() => {
    O(), R();
  }, [R, O]), q = Q(() => {
    x.current = !0, O(), k();
  }, [O, k]), ge = Q(() => {
    var Le, Ie;
    const X = tw(y.current), he = (Le = y.current) == null ? void 0 : Le.contains(X.activeElement);
    if (!(N && !he))
      return;
    const de = (Ie = _.item(ie)) == null ? void 0 : Ie.node;
    de == null || de.focus({ preventScroll: !x.current });
  }, [N, ie, _]);
  return {
    openAndFocusMenu: K,
    openAndFocusFirstItem: U,
    openAndFocusLastItem: q,
    onTransitionEnd: ge,
    unstable__animationState: ve,
    descendants: _,
    popper: ne,
    buttonId: ue,
    menuId: j,
    forceUpdate: ne.forceUpdate,
    orientation: "vertical",
    isOpen: N,
    onToggle: $,
    onOpen: O,
    onClose: H,
    menuRef: y,
    buttonRef: M,
    focusedIndex: ie,
    closeOnSelect: n,
    closeOnBlur: r,
    autoSelect: a,
    setFocusedIndex: re,
    isLazy: i,
    lazyBehavior: p,
    initialFocusRef: o,
    scrollIntoViewRef: x
  };
}
function Pee(e = {}, t = null) {
  const n = Od(), {
    onToggle: r,
    popper: o,
    openAndFocusFirstItem: a,
    openAndFocusLastItem: i,
    scrollIntoViewRef: l
  } = n, u = Q(
    (d) => {
      const f = d.key, p = {
        Enter: a,
        ArrowDown: a,
        ArrowUp: i
      }[f];
      p && (l.current = !0, d.preventDefault(), d.stopPropagation(), p(d));
    },
    [a, i, l]
  );
  return {
    ...e,
    ref: In(n.buttonRef, t, o.referenceRef),
    id: n.buttonId,
    "data-active": Qe(n.isOpen),
    "aria-expanded": n.isOpen,
    "aria-haspopup": "menu",
    "aria-controls": n.menuId,
    onClick: qe(e.onClick, r),
    onKeyDown: qe(e.onKeyDown, u)
  };
}
function J5(e) {
  var t;
  return kee(e) && !!((t = e == null ? void 0 : e.getAttribute("role")) != null && t.startsWith("menuitem"));
}
function Eee(e = {}, t = null) {
  const n = Od();
  if (!n)
    throw new Error(
      "useMenuContext: context is undefined. Seems you forgot to wrap component within <Menu>"
    );
  const {
    focusedIndex: r,
    setFocusedIndex: o,
    menuRef: a,
    isOpen: i,
    onClose: l,
    menuId: u,
    isLazy: d,
    lazyBehavior: f,
    scrollIntoViewRef: h,
    unstable__animationState: p
  } = n, g = wee(), C = tQ({
    preventDefault: (x) => x.key !== " " && J5(x.target)
  }), v = Q(
    (x) => {
      if (!x.currentTarget.contains(x.target))
        return;
      const _ = x.key, R = {
        Tab: (P) => P.preventDefault(),
        Escape: (P) => {
          P.stopPropagation(), l();
        },
        ArrowDown: () => {
          h.current = !0;
          const P = g.nextEnabled(r) ?? g.firstEnabled();
          P && o(P.index);
        },
        ArrowUp: () => {
          h.current = !0;
          const P = g.prevEnabled(r) ?? g.firstEnabled();
          P && o(P.index);
        }
      }[_];
      if (R) {
        x.preventDefault(), R(x);
        return;
      }
      const k = C((P) => {
        const N = QK(
          g.values(),
          P,
          (O) => {
            var H;
            return ((H = O == null ? void 0 : O.node) == null ? void 0 : H.textContent) ?? "";
          },
          g.item(r)
        );
        if (N) {
          const O = g.indexOf(N.node);
          o(O);
        }
      });
      J5(x.target) && k(x);
    },
    [
      g,
      r,
      C,
      l,
      o,
      h
    ]
  ), y = Ve(!1);
  i && (y.current = !0);
  const M = CS({
    wasSelected: y.current,
    enabled: d,
    mode: f,
    isSelected: p.present
  });
  return {
    ...e,
    ref: In(a, t),
    children: M ? e.children : null,
    tabIndex: -1,
    role: "menu",
    id: u,
    style: {
      ...e.style,
      transformOrigin: "var(--popper-transform-origin)"
    },
    "aria-orientation": "vertical",
    onKeyDown: qe(e.onKeyDown, v)
  };
}
function Tee(e = {}) {
  const { popper: t, isOpen: n } = Od();
  return t.getPopperProps({
    ...e,
    style: {
      visibility: n ? "visible" : "hidden",
      ...e.style
    }
  });
}
function Nee(e = {}, t = null) {
  const {
    onMouseEnter: n,
    onMouseMove: r,
    onMouseLeave: o,
    onClick: a,
    onFocus: i,
    isDisabled: l,
    isFocusable: u,
    closeOnSelect: d,
    type: f,
    ...h
  } = e, p = Od(), {
    setFocusedIndex: g,
    focusedIndex: C,
    closeOnSelect: v,
    onClose: y,
    menuId: M,
    scrollIntoViewRef: x
  } = p, _ = Ve(null), L = `${M}-menuitem-${Lo()}`, { index: R, register: k } = Iee({
    disabled: l && !u
  }), P = Q(
    (re) => {
      n == null || n(re), !l && (x.current = !1, g(R));
    },
    [g, R, l, n, x]
  ), N = Q(
    (re) => {
      r == null || r(re), _.current && !Ree(_.current) && P(re);
    },
    [P, r]
  ), O = Q(
    (re) => {
      o == null || o(re), !l && g(-1);
    },
    [g, l, o]
  ), H = Q(
    (re) => {
      a == null || a(re), J5(re.currentTarget) && (d ?? v) && y();
    },
    [y, a, v, d]
  ), $ = Q(
    (re) => {
      i == null || i(re), g(R);
    },
    [g, i, R]
  ), ne = R === C, ie = Mee({
    onClick: H,
    onFocus: $,
    onMouseEnter: P,
    onMouseMove: N,
    onMouseLeave: O,
    ref: In(k, _, t),
    isDisabled: l,
    isFocusable: u
  });
  return {
    ...h,
    ...ie,
    type: f ?? ie.type,
    id: L,
    role: "menuitem",
    tabIndex: ne ? 0 : -1
  };
}
function kee(e) {
  if (!Vee(e))
    return !1;
  const t = e.ownerDocument.defaultView ?? window;
  return e instanceof t.HTMLElement;
}
function Vee(e) {
  return e != null && typeof e == "object" && "nodeType" in e && e.nodeType === Node.ELEMENT_NODE;
}
const [Oee, Fd] = mn({
  name: "MenuStylesContext",
  errorMessage: `useMenuStyles returned is 'undefined'. Seems you forgot to wrap the components in "<Menu />" `
}), nw = (e) => {
  const { children: t } = e, n = yr("Menu", e), r = Ln(e), { direction: o } = bc(), { descendants: a, ...i } = Dee({ ...r, direction: o }), l = bt(() => i, [i]), { isOpen: u, onClose: d, forceUpdate: f } = l;
  return /* @__PURE__ */ A.jsx(xee, { value: a, children: /* @__PURE__ */ A.jsx(Lee, { value: l, children: /* @__PURE__ */ A.jsx(Oee, { value: n, children: Wo(t, { isOpen: u, onClose: d, forceUpdate: f }) }) }) });
};
nw.displayName = "Menu";
const Fee = Be((e, t) => {
  const n = Fd();
  return /* @__PURE__ */ A.jsx(
    xe.button,
    {
      ref: t,
      ...e,
      __css: {
        display: "inline-flex",
        appearance: "none",
        alignItems: "center",
        outline: 0,
        ...n.button
      }
    }
  );
}), rw = Be(
  (e, t) => {
    const { children: n, as: r, ...o } = e, a = Pee(o, t), i = r || Fee;
    return /* @__PURE__ */ A.jsx(
      i,
      {
        ...a,
        className: ze("chakra-menu__menu-button", e.className),
        children: /* @__PURE__ */ A.jsx(
          xe.span,
          {
            __css: { pointerEvents: "none", flex: "1 1 auto", minW: 0 },
            children: e.children
          }
        )
      }
    );
  }
);
rw.displayName = "MenuButton";
const ow = Be(
  (e, t) => {
    const n = Fd();
    return /* @__PURE__ */ A.jsx(
      xe.span,
      {
        ref: t,
        ...e,
        __css: n.command,
        className: "chakra-menu__command"
      }
    );
  }
);
ow.displayName = "MenuCommand";
const aw = (e) => {
  const { className: t, children: n, ...r } = e, o = Fd(), a = Ad.only(n), i = Ol(a) ? Yo(a, {
    focusable: "false",
    "aria-hidden": !0,
    className: ze("chakra-menu__icon", a.props.className)
  }) : null, l = ze("chakra-menu__icon-wrapper", t);
  return /* @__PURE__ */ A.jsx(xe.span, { className: l, ...r, __css: o.icon, children: i });
};
aw.displayName = "MenuIcon";
const Bee = Be(
  (e, t) => {
    const { type: n, ...r } = e, o = Fd(), a = r.as || n ? n ?? void 0 : "button", i = bt(
      () => ({
        textDecoration: "none",
        color: "inherit",
        userSelect: "none",
        display: "flex",
        width: "100%",
        alignItems: "center",
        textAlign: "start",
        flex: "0 0 auto",
        outline: 0,
        ...o.item
      }),
      [o.item]
    );
    return /* @__PURE__ */ A.jsx(xe.button, { ref: t, type: a, ...r, __css: i });
  }
), iw = Be((e, t) => {
  const {
    icon: n,
    iconSpacing: r = "0.75rem",
    command: o,
    commandSpacing: a = "0.75rem",
    children: i,
    ...l
  } = e, u = Nee(l, t), f = n || o ? /* @__PURE__ */ A.jsx("span", { style: { pointerEvents: "none", flex: 1 }, children: i }) : i;
  return /* @__PURE__ */ A.jsxs(
    Bee,
    {
      ...u,
      className: ze("chakra-menu__menuitem", u.className),
      children: [
        n && /* @__PURE__ */ A.jsx(aw, { fontSize: "0.8em", marginEnd: r, children: n }),
        f,
        o && /* @__PURE__ */ A.jsx(ow, { marginStart: a, children: o })
      ]
    }
  );
});
iw.displayName = "MenuItem";
const Hee = {
  enter: {
    visibility: "visible",
    opacity: 1,
    scale: 1,
    transition: {
      duration: 0.2,
      ease: [0.4, 0, 0.2, 1]
    }
  },
  exit: {
    transitionEnd: {
      visibility: "hidden"
    },
    opacity: 0,
    scale: 0.8,
    transition: {
      duration: 0.1,
      easings: "easeOut"
    }
  }
}, Gee = xe(xa.div), sw = Be(
  function(t, n) {
    var p;
    const { rootProps: r, motionProps: o, ...a } = t, {
      isOpen: i,
      onTransitionEnd: l,
      unstable__animationState: u
    } = Od(), d = Eee(a, n), f = Tee(r), h = Fd();
    return /* @__PURE__ */ A.jsx(
      xe.div,
      {
        ...f,
        __css: { zIndex: t.zIndex ?? ((p = h.list) == null ? void 0 : p.zIndex) },
        children: /* @__PURE__ */ A.jsx(
          Gee,
          {
            variants: Hee,
            initial: !1,
            animate: i ? "enter" : "exit",
            __css: { outline: 0, ...h.list },
            ...o,
            ...d,
            className: ze("chakra-menu__menu-list", d.className),
            onUpdate: l,
            onAnimationComplete: Ah(
              u.onComplete,
              d.onAnimationComplete
            )
          }
        )
      }
    );
  }
);
sw.displayName = "MenuList";
var $ee = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, Su = /* @__PURE__ */ new WeakMap(), Cf = /* @__PURE__ */ new WeakMap(), bf = {}, Tg = 0, lw = function(e) {
  return e && (e.host || lw(e.parentNode));
}, Zee = function(e, t) {
  return t.map(function(n) {
    if (e.contains(n))
      return n;
    var r = lw(n);
    return r && e.contains(r) ? r : (console.error("aria-hidden", n, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(n) {
    return !!n;
  });
}, jee = function(e, t, n, r) {
  var o = Zee(t, Array.isArray(e) ? e : [e]);
  bf[n] || (bf[n] = /* @__PURE__ */ new WeakMap());
  var a = bf[n], i = [], l = /* @__PURE__ */ new Set(), u = new Set(o), d = function(h) {
    !h || l.has(h) || (l.add(h), d(h.parentNode));
  };
  o.forEach(d);
  var f = function(h) {
    !h || u.has(h) || Array.prototype.forEach.call(h.children, function(p) {
      if (l.has(p))
        f(p);
      else
        try {
          var g = p.getAttribute(r), C = g !== null && g !== "false", v = (Su.get(p) || 0) + 1, y = (a.get(p) || 0) + 1;
          Su.set(p, v), a.set(p, y), i.push(p), v === 1 && C && Cf.set(p, !0), y === 1 && p.setAttribute(n, "true"), C || p.setAttribute(r, "true");
        } catch (M) {
          console.error("aria-hidden: cannot operate on ", p, M);
        }
    });
  };
  return f(t), l.clear(), Tg++, function() {
    i.forEach(function(h) {
      var p = Su.get(h) - 1, g = a.get(h) - 1;
      Su.set(h, p), a.set(h, g), p || (Cf.has(h) || h.removeAttribute(r), Cf.delete(h)), g || h.removeAttribute(n);
    }), Tg--, Tg || (Su = /* @__PURE__ */ new WeakMap(), Su = /* @__PURE__ */ new WeakMap(), Cf = /* @__PURE__ */ new WeakMap(), bf = {});
  };
}, Wee = function(e, t, n) {
  n === void 0 && (n = "data-aria-hidden");
  var r = Array.from(Array.isArray(e) ? e : [e]), o = t || $ee(e);
  return o ? (r.push.apply(r, Array.from(o.querySelectorAll("[aria-live], script"))), jee(r, o, n, "aria-hidden")) : function() {
    return null;
  };
}, zee = Object.defineProperty, Uee = (e, t, n) => t in e ? zee(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, Xee = (e, t, n) => (Uee(e, typeof t != "symbol" ? t + "" : t, n), n);
class Yee {
  constructor() {
    Xee(this, "modals"), this.modals = /* @__PURE__ */ new Set();
  }
  add(t) {
    return this.modals.add(t), this.modals.size;
  }
  remove(t) {
    this.modals.delete(t);
  }
  isTopModal(t) {
    if (!t)
      return !1;
    const n = Array.from(this.modals)[this.modals.size - 1];
    return t === n;
  }
}
const K5 = new Yee();
function uw(e, t) {
  const [n, r] = He(0);
  return st(() => {
    const o = e.current;
    if (o) {
      if (t) {
        const a = K5.add(o);
        r(a);
      }
      return () => {
        K5.remove(o), r(0);
      };
    }
  }, [t, e]), n;
}
function qee(e) {
  const {
    isOpen: t,
    onClose: n,
    id: r,
    closeOnOverlayClick: o = !0,
    closeOnEsc: a = !0,
    useInert: i = !0,
    onOverlayClick: l,
    onEsc: u
  } = e, d = Ve(null), f = Ve(null), [h, p, g] = Kee(
    r,
    "chakra-modal",
    "chakra-modal--header",
    "chakra-modal--body"
  );
  Jee(d, t && i);
  const C = uw(d, t), v = Ve(null), y = Q((O) => {
    v.current = O.target;
  }, []), M = Q(
    (O) => {
      O.key === "Escape" && (O.stopPropagation(), a && (n == null || n()), u == null || u());
    },
    [a, n, u]
  ), [x, _] = He(!1), [L, R] = He(!1), k = Q(
    (O = {}, H = null) => ({
      role: "dialog",
      ...O,
      ref: In(H, d),
      id: h,
      tabIndex: -1,
      "aria-modal": !0,
      "aria-labelledby": x ? p : void 0,
      "aria-describedby": L ? g : void 0,
      onClick: qe(
        O.onClick,
        ($) => $.stopPropagation()
      )
    }),
    [g, L, h, p, x]
  ), P = Q(
    (O) => {
      O.stopPropagation(), v.current === O.target && K5.isTopModal(d.current) && (o && (n == null || n()), l == null || l());
    },
    [n, o, l]
  ), N = Q(
    (O = {}, H = null) => ({
      ...O,
      ref: In(H, f),
      onClick: qe(O.onClick, P),
      onKeyDown: qe(O.onKeyDown, M),
      onMouseDown: qe(O.onMouseDown, y)
    }),
    [M, y, P]
  );
  return {
    isOpen: t,
    onClose: n,
    headerId: p,
    bodyId: g,
    setBodyMounted: R,
    setHeaderMounted: _,
    dialogRef: d,
    overlayRef: f,
    getDialogProps: k,
    getDialogContainerProps: N,
    index: C
  };
}
function Jee(e, t) {
  const n = e.current;
  st(() => {
    if (!(!e.current || !t))
      return Wee(e.current);
  }, [t, e, n]);
}
function Kee(e, ...t) {
  const n = Lo(), r = e || n;
  return bt(() => t.map((o) => `${o}-${r}`), [r, t]);
}
const [Qee, Gl] = mn({
  name: "ModalStylesContext",
  errorMessage: `useModalStyles returned is 'undefined'. Seems you forgot to wrap the components in "<Modal />" `
}), [ete, xs] = mn({
  strict: !0,
  name: "ModalContext",
  errorMessage: "useModalContext: `context` is undefined. Seems you forgot to wrap modal components in `<Modal />`"
}), l9 = (e) => {
  const t = {
    scrollBehavior: "outside",
    autoFocus: !0,
    trapFocus: !0,
    returnFocusOnClose: !0,
    blockScrollOnMount: !0,
    allowPinchZoom: !1,
    preserveScrollBarGap: !0,
    motionPreset: "scale",
    ...e,
    lockFocusAcrossFrames: e.lockFocusAcrossFrames ?? !0
  }, {
    portalProps: n,
    children: r,
    autoFocus: o,
    trapFocus: a,
    initialFocusRef: i,
    finalFocusRef: l,
    returnFocusOnClose: u,
    blockScrollOnMount: d,
    allowPinchZoom: f,
    preserveScrollBarGap: h,
    motionPreset: p,
    lockFocusAcrossFrames: g,
    animatePresenceProps: C,
    onCloseComplete: v
  } = t, y = yr("Modal", t), x = {
    ...qee(t),
    autoFocus: o,
    trapFocus: a,
    initialFocusRef: i,
    finalFocusRef: l,
    returnFocusOnClose: u,
    blockScrollOnMount: d,
    allowPinchZoom: f,
    preserveScrollBarGap: h,
    motionPreset: p,
    lockFocusAcrossFrames: g
  };
  return /* @__PURE__ */ A.jsx(ete, { value: x, children: /* @__PURE__ */ A.jsx(Qee, { value: y, children: /* @__PURE__ */ A.jsx(
    Rs,
    {
      ...C,
      onExitComplete: v,
      children: x.isOpen && /* @__PURE__ */ A.jsx(ki, { ...n, children: r })
    }
  ) }) });
};
l9.displayName = "Modal";
var Qf = "right-scroll-bar-position", e2 = "width-before-scroll-bar", tte = "with-scroll-bars-hidden", nte = "--removed-body-scroll-bar-size", cw = lx(), Ng = function() {
}, Oh = Ee.forwardRef(function(e, t) {
  var n = Ee.useRef(null), r = Ee.useState({
    onScrollCapture: Ng,
    onWheelCapture: Ng,
    onTouchMoveCapture: Ng
  }), o = r[0], a = r[1], i = e.forwardProps, l = e.children, u = e.className, d = e.removeScrollBar, f = e.enabled, h = e.shards, p = e.sideCar, g = e.noRelative, C = e.noIsolation, v = e.inert, y = e.allowPinchZoom, M = e.as, x = M === void 0 ? "div" : M, _ = e.gapMode, L = ax(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noRelative", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), R = p, k = ox([n, t]), P = Va(Va({}, L), o);
  return Ee.createElement(
    Ee.Fragment,
    null,
    f && Ee.createElement(R, { sideCar: cw, removeScrollBar: d, shards: h, noRelative: g, noIsolation: C, inert: v, setCallbacks: a, allowPinchZoom: !!y, lockRef: n, gapMode: _ }),
    i ? Ee.cloneElement(Ee.Children.only(l), Va(Va({}, P), { ref: k })) : Ee.createElement(x, Va({}, P, { className: u, ref: k }), l)
  );
});
Oh.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
Oh.classNames = {
  fullWidth: e2,
  zeroRight: Qf
};
var VC, rte = function() {
  if (VC)
    return VC;
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function ote() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = rte();
  return t && e.setAttribute("nonce", t), e;
}
function ate(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function ite(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var ste = function() {
  var e = 0, t = null;
  return {
    add: function(n) {
      e == 0 && (t = ote()) && (ate(t, n), ite(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, lte = function() {
  var e = ste();
  return function(t, n) {
    Ee.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && n]);
  };
}, dw = function() {
  var e = lte(), t = function(n) {
    var r = n.styles, o = n.dynamic;
    return e(r, o), null;
  };
  return t;
}, ute = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, kg = function(e) {
  return parseInt(e || "", 10) || 0;
}, cte = function(e) {
  var t = window.getComputedStyle(document.body), n = t[e === "padding" ? "paddingLeft" : "marginLeft"], r = t[e === "padding" ? "paddingTop" : "marginTop"], o = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [kg(n), kg(r), kg(o)];
}, dte = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return ute;
  var t = cte(e), n = document.documentElement.clientWidth, r = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, r - n + t[2] - t[0])
  };
}, fte = dw(), qu = "data-scroll-locked", hte = function(e, t, n, r) {
  var o = e.left, a = e.top, i = e.right, l = e.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(tte, ` {
   overflow: hidden `).concat(r, `;
   padding-right: `).concat(l, "px ").concat(r, `;
  }
  body[`).concat(qu, `] {
    overflow: hidden `).concat(r, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(r, ";"),
    n === "margin" && `
    padding-left: `.concat(o, `px;
    padding-top: `).concat(a, `px;
    padding-right: `).concat(i, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(l, "px ").concat(r, `;
    `),
    n === "padding" && "padding-right: ".concat(l, "px ").concat(r, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(Qf, ` {
    right: `).concat(l, "px ").concat(r, `;
  }
  
  .`).concat(e2, ` {
    margin-right: `).concat(l, "px ").concat(r, `;
  }
  
  .`).concat(Qf, " .").concat(Qf, ` {
    right: 0 `).concat(r, `;
  }
  
  .`).concat(e2, " .").concat(e2, ` {
    margin-right: 0 `).concat(r, `;
  }
  
  body[`).concat(qu, `] {
    `).concat(nte, ": ").concat(l, `px;
  }
`);
}, OC = function() {
  var e = parseInt(document.body.getAttribute(qu) || "0", 10);
  return isFinite(e) ? e : 0;
}, mte = function() {
  Ee.useEffect(function() {
    return document.body.setAttribute(qu, (OC() + 1).toString()), function() {
      var e = OC() - 1;
      e <= 0 ? document.body.removeAttribute(qu) : document.body.setAttribute(qu, e.toString());
    };
  }, []);
}, pte = function(e) {
  var t = e.noRelative, n = e.noImportant, r = e.gapMode, o = r === void 0 ? "margin" : r;
  mte();
  var a = Ee.useMemo(function() {
    return dte(o);
  }, [o]);
  return Ee.createElement(fte, { styles: hte(a, !t, o, n ? "" : "!important") });
}, Q5 = !1;
if (typeof window < "u")
  try {
    var yf = Object.defineProperty({}, "passive", {
      get: function() {
        return Q5 = !0, !0;
      }
    });
    window.addEventListener("test", yf, yf), window.removeEventListener("test", yf, yf);
  } catch {
    Q5 = !1;
  }
var Au = Q5 ? { passive: !1 } : !1, gte = function(e) {
  return e.tagName === "TEXTAREA";
}, fw = function(e, t) {
  if (!(e instanceof Element))
    return !1;
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !gte(e) && n[t] === "visible")
  );
}, vte = function(e) {
  return fw(e, "overflowY");
}, Cte = function(e) {
  return fw(e, "overflowX");
}, FC = function(e, t) {
  var n = t.ownerDocument, r = t;
  do {
    typeof ShadowRoot < "u" && r instanceof ShadowRoot && (r = r.host);
    var o = hw(e, r);
    if (o) {
      var a = mw(e, r), i = a[1], l = a[2];
      if (i > l)
        return !0;
    }
    r = r.parentNode;
  } while (r && r !== n.body);
  return !1;
}, bte = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, r = e.clientHeight;
  return [
    t,
    n,
    r
  ];
}, yte = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, r = e.clientWidth;
  return [
    t,
    n,
    r
  ];
}, hw = function(e, t) {
  return e === "v" ? vte(t) : Cte(t);
}, mw = function(e, t) {
  return e === "v" ? bte(t) : yte(t);
}, Ste = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, Ate = function(e, t, n, r, o) {
  var a = Ste(e, window.getComputedStyle(t).direction), i = a * r, l = n.target, u = t.contains(l), d = !1, f = i > 0, h = 0, p = 0;
  do {
    if (!l)
      break;
    var g = mw(e, l), C = g[0], v = g[1], y = g[2], M = v - y - a * C;
    (C || M) && hw(e, l) && (h += M, p += C);
    var x = l.parentNode;
    l = x && x.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? x.host : x;
  } while (
    // portaled content
    !u && l !== document.body || // self content
    u && (t.contains(l) || t === l)
  );
  return (f && (o && Math.abs(h) < 1 || !o && i > h) || !f && (o && Math.abs(p) < 1 || !o && -i > p)) && (d = !0), d;
}, Sf = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, BC = function(e) {
  return [e.deltaX, e.deltaY];
}, HC = function(e) {
  return e && "current" in e ? e.current : e;
}, Mte = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, xte = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, wte = 0, Mu = [];
function _te(e) {
  var t = Ee.useRef([]), n = Ee.useRef([0, 0]), r = Ee.useRef(), o = Ee.useState(wte++)[0], a = Ee.useState(dw)[0], i = Ee.useRef(e);
  Ee.useEffect(function() {
    i.current = e;
  }, [e]), Ee.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(o));
      var v = TJ([e.lockRef.current], (e.shards || []).map(HC), !0).filter(Boolean);
      return v.forEach(function(y) {
        return y.classList.add("allow-interactivity-".concat(o));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(o)), v.forEach(function(y) {
          return y.classList.remove("allow-interactivity-".concat(o));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var l = Ee.useCallback(function(v, y) {
    if ("touches" in v && v.touches.length === 2 || v.type === "wheel" && v.ctrlKey)
      return !i.current.allowPinchZoom;
    var M = Sf(v), x = n.current, _ = "deltaX" in v ? v.deltaX : x[0] - M[0], L = "deltaY" in v ? v.deltaY : x[1] - M[1], R, k = v.target, P = Math.abs(_) > Math.abs(L) ? "h" : "v";
    if ("touches" in v && P === "h" && k.type === "range")
      return !1;
    var N = FC(P, k);
    if (!N)
      return !0;
    if (N ? R = P : (R = P === "v" ? "h" : "v", N = FC(P, k)), !N)
      return !1;
    if (!r.current && "changedTouches" in v && (_ || L) && (r.current = R), !R)
      return !0;
    var O = r.current || R;
    return Ate(O, y, v, O === "h" ? _ : L, !0);
  }, []), u = Ee.useCallback(function(v) {
    var y = v;
    if (!(!Mu.length || Mu[Mu.length - 1] !== a)) {
      var M = "deltaY" in y ? BC(y) : Sf(y), x = t.current.filter(function(R) {
        return R.name === y.type && (R.target === y.target || y.target === R.shadowParent) && Mte(R.delta, M);
      })[0];
      if (x && x.should) {
        y.cancelable && y.preventDefault();
        return;
      }
      if (!x) {
        var _ = (i.current.shards || []).map(HC).filter(Boolean).filter(function(R) {
          return R.contains(y.target);
        }), L = _.length > 0 ? l(y, _[0]) : !i.current.noIsolation;
        L && y.cancelable && y.preventDefault();
      }
    }
  }, []), d = Ee.useCallback(function(v, y, M, x) {
    var _ = { name: v, delta: y, target: M, should: x, shadowParent: Ite(M) };
    t.current.push(_), setTimeout(function() {
      t.current = t.current.filter(function(L) {
        return L !== _;
      });
    }, 1);
  }, []), f = Ee.useCallback(function(v) {
    n.current = Sf(v), r.current = void 0;
  }, []), h = Ee.useCallback(function(v) {
    d(v.type, BC(v), v.target, l(v, e.lockRef.current));
  }, []), p = Ee.useCallback(function(v) {
    d(v.type, Sf(v), v.target, l(v, e.lockRef.current));
  }, []);
  Ee.useEffect(function() {
    return Mu.push(a), e.setCallbacks({
      onScrollCapture: h,
      onWheelCapture: h,
      onTouchMoveCapture: p
    }), document.addEventListener("wheel", u, Au), document.addEventListener("touchmove", u, Au), document.addEventListener("touchstart", f, Au), function() {
      Mu = Mu.filter(function(v) {
        return v !== a;
      }), document.removeEventListener("wheel", u, Au), document.removeEventListener("touchmove", u, Au), document.removeEventListener("touchstart", f, Au);
    };
  }, []);
  var g = e.removeScrollBar, C = e.inert;
  return Ee.createElement(
    Ee.Fragment,
    null,
    C ? Ee.createElement(a, { styles: xte(o) }) : null,
    g ? Ee.createElement(pte, { noRelative: e.noRelative, gapMode: e.gapMode }) : null
  );
}
function Ite(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const Lte = NJ(cw, _te);
var pw = Ee.forwardRef(function(e, t) {
  return Ee.createElement(Oh, Va({}, e, { ref: t, sideCar: Lte }));
});
pw.classNames = Oh.classNames;
const Rte = pw;
function gw(e) {
  const {
    autoFocus: t,
    trapFocus: n,
    dialogRef: r,
    initialFocusRef: o,
    blockScrollOnMount: a,
    allowPinchZoom: i,
    finalFocusRef: l,
    returnFocusOnClose: u,
    preserveScrollBarGap: d,
    lockFocusAcrossFrames: f,
    isOpen: h
  } = xs(), [p, g] = hM();
  st(() => {
    !p && g && setTimeout(g);
  }, [p, g]);
  const C = uw(r, h);
  return /* @__PURE__ */ A.jsx(
    Bx,
    {
      autoFocus: t,
      isDisabled: !n,
      initialFocusRef: o,
      finalFocusRef: l,
      restoreFocus: u,
      contentRef: r,
      lockFocusAcrossFrames: f,
      children: /* @__PURE__ */ A.jsx(
        Rte,
        {
          removeScrollBar: !d,
          allowPinchZoom: i,
          enabled: C === 1 && a,
          forwardProps: !0,
          children: e.children
        }
      )
    }
  );
}
const Dte = {
  initial: ({ offsetX: e, offsetY: t, transition: n, transitionEnd: r, delay: o }) => ({
    opacity: 0,
    x: e,
    y: t,
    transition: (n == null ? void 0 : n.exit) ?? ba.exit(vl.exit, o),
    transitionEnd: r == null ? void 0 : r.exit
  }),
  enter: ({ transition: e, transitionEnd: t, delay: n }) => ({
    opacity: 1,
    x: 0,
    y: 0,
    transition: (e == null ? void 0 : e.enter) ?? ba.enter(vl.enter, n),
    transitionEnd: t == null ? void 0 : t.enter
  }),
  exit: ({ offsetY: e, offsetX: t, transition: n, transitionEnd: r, reverse: o, delay: a }) => {
    const i = { x: t, y: e };
    return {
      opacity: 0,
      transition: (n == null ? void 0 : n.exit) ?? ba.exit(vl.exit, a),
      ...o ? { ...i, transitionEnd: r == null ? void 0 : r.exit } : { transitionEnd: { ...i, ...r == null ? void 0 : r.exit } }
    };
  }
}, N1 = {
  initial: "initial",
  animate: "enter",
  exit: "exit",
  variants: Dte
}, Pte = Ke(
  function(t, n) {
    const {
      unmountOnExit: r,
      in: o,
      reverse: a = !0,
      className: i,
      offsetX: l = 0,
      offsetY: u = 8,
      transition: d,
      transitionEnd: f,
      delay: h,
      animatePresenceProps: p,
      ...g
    } = t, C = r ? o && r : !0, v = o || r ? "enter" : "exit", y = {
      offsetX: l,
      offsetY: u,
      reverse: a,
      transition: d,
      transitionEnd: f,
      delay: h
    };
    return /* @__PURE__ */ A.jsx(Rs, { ...p, custom: y, children: C && /* @__PURE__ */ A.jsx(
      xa.div,
      {
        ref: n,
        className: ze("chakra-offset-slide", i),
        custom: y,
        ...N1,
        animate: v,
        ...g
      }
    ) });
  }
);
Pte.displayName = "SlideFade";
const Ete = {
  exit: ({ reverse: e, initialScale: t, transition: n, transitionEnd: r, delay: o }) => ({
    opacity: 0,
    ...e ? { scale: t, transitionEnd: r == null ? void 0 : r.exit } : { transitionEnd: { scale: t, ...r == null ? void 0 : r.exit } },
    transition: (n == null ? void 0 : n.exit) ?? ba.exit(vl.exit, o)
  }),
  enter: ({ transitionEnd: e, transition: t, delay: n }) => ({
    opacity: 1,
    scale: 1,
    transition: (t == null ? void 0 : t.enter) ?? ba.enter(vl.enter, n),
    transitionEnd: e == null ? void 0 : e.enter
  })
}, vw = {
  initial: "exit",
  animate: "enter",
  exit: "exit",
  variants: Ete
}, Tte = Ke(
  function(t, n) {
    const {
      unmountOnExit: r,
      in: o,
      reverse: a = !0,
      initialScale: i = 0.95,
      className: l,
      transition: u,
      transitionEnd: d,
      delay: f,
      animatePresenceProps: h,
      ...p
    } = t, g = r ? o && r : !0, C = o || r ? "enter" : "exit", v = { initialScale: i, reverse: a, transition: u, transitionEnd: d, delay: f };
    return /* @__PURE__ */ A.jsx(Rs, { ...h, custom: v, children: g && /* @__PURE__ */ A.jsx(
      xa.div,
      {
        ref: n,
        className: ze("chakra-offset-slide", l),
        ...vw,
        animate: C,
        custom: v,
        ...p
      }
    ) });
  }
);
Tte.displayName = "ScaleFade";
const Nte = {
  slideInBottom: {
    ...N1,
    custom: { offsetY: 16, reverse: !0 }
  },
  slideInRight: {
    ...N1,
    custom: { offsetX: 16, reverse: !0 }
  },
  slideInTop: {
    ...N1,
    custom: { offsetY: -16, reverse: !0 }
  },
  slideInLeft: {
    ...N1,
    custom: { offsetX: -16, reverse: !0 }
  },
  scale: {
    ...vw,
    custom: { initialScale: 0.95, reverse: !0 }
  },
  none: {}
}, kte = xe(xa.section), Vte = (e) => Nte[e || "none"], Cw = Ke(
  (e, t) => {
    const { preset: n, motionProps: r = Vte(n), ...o } = e;
    return /* @__PURE__ */ A.jsx(kte, { ref: t, ...r, ...o });
  }
);
Cw.displayName = "ModalTransition";
const bw = Be(
  (e, t) => {
    const {
      className: n,
      children: r,
      containerProps: o,
      motionProps: a,
      ...i
    } = e, { getDialogProps: l, getDialogContainerProps: u } = xs(), d = l(i, t), f = u(o), h = ze("chakra-modal__content", n), p = Gl(), g = {
      display: "flex",
      flexDirection: "column",
      position: "relative",
      width: "100%",
      outline: 0,
      ...p.dialog
    }, C = {
      display: "flex",
      width: "100vw",
      height: "$100vh",
      position: "fixed",
      left: 0,
      top: 0,
      ...p.dialogContainer
    }, { motionPreset: v } = xs();
    return /* @__PURE__ */ A.jsx(gw, { children: /* @__PURE__ */ A.jsx(
      xe.div,
      {
        ...f,
        className: "chakra-modal__content-container",
        tabIndex: -1,
        __css: C,
        children: /* @__PURE__ */ A.jsx(
          Cw,
          {
            preset: v,
            motionProps: a,
            className: h,
            ...d,
            __css: g,
            children: r
          }
        )
      }
    ) });
  }
);
bw.displayName = "ModalContent";
const u9 = Be((e, t) => {
  const { className: n, ...r } = e, { bodyId: o, setBodyMounted: a } = xs();
  st(() => (a(!0), () => a(!1)), [a]);
  const i = ze("chakra-modal__body", n), l = Gl();
  return /* @__PURE__ */ A.jsx(
    xe.div,
    {
      ref: t,
      className: i,
      id: o,
      ...r,
      __css: l.body
    }
  );
});
u9.displayName = "ModalBody";
const yw = Be(
  (e, t) => {
    const { onClick: n, className: r, ...o } = e, { onClose: a } = xs(), i = ze("chakra-modal__close-btn", r), l = Gl();
    return /* @__PURE__ */ A.jsx(
      Td,
      {
        ref: t,
        __css: l.closeButton,
        className: i,
        onClick: qe(n, (u) => {
          u.stopPropagation(), a();
        }),
        ...o
      }
    );
  }
);
yw.displayName = "ModalCloseButton";
const c9 = Be(
  (e, t) => {
    const { className: n, ...r } = e, o = ze("chakra-modal__footer", n), a = Gl(), i = {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      ...a.footer
    };
    return /* @__PURE__ */ A.jsx(
      xe.footer,
      {
        ref: t,
        ...r,
        __css: i,
        className: o
      }
    );
  }
);
c9.displayName = "ModalFooter";
const d9 = Be(
  (e, t) => {
    const { className: n, ...r } = e, { headerId: o, setHeaderMounted: a } = xs();
    st(() => (a(!0), () => a(!1)), [a]);
    const i = ze("chakra-modal__header", n), l = Gl(), u = {
      flex: 0,
      ...l.header
    };
    return /* @__PURE__ */ A.jsx(
      xe.header,
      {
        ref: t,
        className: i,
        id: o,
        ...r,
        __css: u
      }
    );
  }
);
d9.displayName = "ModalHeader";
const Ote = {
  enter: ({ transition: e, transitionEnd: t, delay: n } = {}) => ({
    opacity: 1,
    transition: (e == null ? void 0 : e.enter) ?? ba.enter(vl.enter, n),
    transitionEnd: t == null ? void 0 : t.enter
  }),
  exit: ({ transition: e, transitionEnd: t, delay: n } = {}) => ({
    opacity: 0,
    transition: (e == null ? void 0 : e.exit) ?? ba.exit(vl.exit, n),
    transitionEnd: t == null ? void 0 : t.exit
  })
}, Sw = {
  initial: "exit",
  animate: "enter",
  exit: "exit",
  variants: Ote
}, Fte = Ke(
  function(t, n) {
    const {
      unmountOnExit: r,
      in: o,
      className: a,
      transition: i,
      transitionEnd: l,
      delay: u,
      animatePresenceProps: d,
      ...f
    } = t, h = o || r ? "enter" : "exit", p = r ? o && r : !0, g = { transition: i, transitionEnd: l, delay: u };
    return /* @__PURE__ */ A.jsx(Rs, { ...d, custom: g, children: p && /* @__PURE__ */ A.jsx(
      xa.div,
      {
        ref: n,
        className: ze("chakra-fade", a),
        custom: g,
        ...Sw,
        animate: h,
        ...f
      }
    ) });
  }
);
Fte.displayName = "Fade";
const Bte = xe(xa.div), f9 = Be(
  (e, t) => {
    const { className: n, transition: r, motionProps: o, ...a } = e, i = ze("chakra-modal__overlay", n), u = {
      pos: "fixed",
      left: "0",
      top: "0",
      w: "100vw",
      h: "100vh",
      ...Gl().overlay
    }, { motionPreset: d } = xs(), h = o || (d === "none" ? {} : Sw);
    return /* @__PURE__ */ A.jsx(
      Bte,
      {
        ...h,
        __css: u,
        ref: t,
        className: i,
        ...a
      }
    );
  }
);
f9.displayName = "ModalOverlay";
const [Hte, Gte] = mn(), $te = {
  start: { ltr: "left", rtl: "right" },
  end: { ltr: "right", rtl: "left" }
};
function Zte(e, t) {
  var n;
  if (e)
    return ((n = $te[e]) == null ? void 0 : n[t]) ?? e;
}
function jte(e) {
  var d;
  const {
    isOpen: t,
    onClose: n,
    placement: r = "right",
    children: o,
    ...a
  } = e, i = bc(), l = (d = i.components) == null ? void 0 : d.Drawer, u = Zte(r, i.direction);
  return /* @__PURE__ */ A.jsx(Hte, { value: { placement: u }, children: /* @__PURE__ */ A.jsx(
    l9,
    {
      isOpen: t,
      onClose: n,
      styleConfig: l,
      ...a,
      children: o
    }
  ) });
}
const GC = {
  exit: {
    duration: 0.15,
    ease: ul.easeInOut
  },
  enter: {
    type: "spring",
    damping: 25,
    stiffness: 180
  }
}, Wte = {
  exit: ({ direction: e, transition: t, transitionEnd: n, delay: r }) => {
    const { exit: o } = B5({ direction: e });
    return {
      ...o,
      transition: (t == null ? void 0 : t.exit) ?? ba.exit(GC.exit, r),
      transitionEnd: n == null ? void 0 : n.exit
    };
  },
  enter: ({ direction: e, transitionEnd: t, transition: n, delay: r }) => {
    const { enter: o } = B5({ direction: e });
    return {
      ...o,
      transition: (n == null ? void 0 : n.enter) ?? ba.enter(GC.enter, r),
      transitionEnd: t == null ? void 0 : t.enter
    };
  }
}, Aw = Ke(
  function(t, n) {
    const {
      direction: r = "right",
      style: o,
      unmountOnExit: a,
      in: i,
      className: l,
      transition: u,
      transitionEnd: d,
      delay: f,
      motionProps: h,
      animatePresenceProps: p,
      ...g
    } = t, C = B5({ direction: r }), v = Object.assign(
      { position: "fixed" },
      C.position,
      o
    ), y = a ? i && a : !0, M = i || a ? "enter" : "exit", x = { transitionEnd: d, transition: u, direction: r, delay: f };
    return /* @__PURE__ */ A.jsx(Rs, { ...p, custom: x, children: y && /* @__PURE__ */ A.jsx(
      xa.div,
      {
        ...g,
        ref: n,
        initial: "exit",
        className: ze("chakra-slide", l),
        animate: M,
        exit: "exit",
        custom: x,
        variants: Wte,
        style: v,
        ...h
      }
    ) });
  }
);
Aw.displayName = "Slide";
const zte = xe(Aw), Mw = Be(
  (e, t) => {
    const {
      className: n,
      children: r,
      motionProps: o,
      containerProps: a,
      ...i
    } = e, { getDialogProps: l, getDialogContainerProps: u, isOpen: d } = xs(), f = l(i, t), h = u(a), p = ze("chakra-modal__content", n), g = Gl(), C = {
      display: "flex",
      flexDirection: "column",
      position: "relative",
      width: "100%",
      outline: 0,
      ...g.dialog
    }, v = {
      display: "flex",
      width: "100vw",
      height: "$100vh",
      position: "fixed",
      left: 0,
      top: 0,
      ...g.dialogContainer
    }, { placement: y } = Gte();
    return /* @__PURE__ */ A.jsx(gw, { children: /* @__PURE__ */ A.jsx(
      xe.div,
      {
        ...h,
        className: "chakra-modal__content-container",
        __css: v,
        children: /* @__PURE__ */ A.jsx(
          zte,
          {
            motionProps: o,
            direction: y,
            in: d,
            className: p,
            ...f,
            __css: C,
            children: r
          }
        )
      }
    ) });
  }
);
Mw.displayName = "DrawerContent";
const Ute = (e) => /* @__PURE__ */ A.jsx(Ni, { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ A.jsx(
  "path",
  {
    fill: "currentColor",
    d: "M21,5H3C2.621,5,2.275,5.214,2.105,5.553C1.937,5.892,1.973,6.297,2.2,6.6l9,12 c0.188,0.252,0.485,0.4,0.8,0.4s0.611-0.148,0.8-0.4l9-12c0.228-0.303,0.264-0.708,0.095-1.047C21.725,5.214,21.379,5,21,5z"
  }
) }), Xte = (e) => /* @__PURE__ */ A.jsx(Ni, { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ A.jsx(
  "path",
  {
    fill: "currentColor",
    d: "M12.8,5.4c-0.377-0.504-1.223-0.504-1.6,0l-9,12c-0.228,0.303-0.264,0.708-0.095,1.047 C2.275,18.786,2.621,19,3,19h18c0.379,0,0.725-0.214,0.895-0.553c0.169-0.339,0.133-0.744-0.095-1.047L12.8,5.4z"
  }
) });
function $C(e, t, n, r) {
  st(() => {
    if (!e.current || !r)
      return;
    const o = e.current.ownerDocument.defaultView ?? window, a = Array.isArray(t) ? t : [t], i = new o.MutationObserver((l) => {
      for (const u of l)
        u.type === "attributes" && u.attributeName && a.includes(u.attributeName) && n(u);
    });
    return i.observe(e.current, { attributes: !0, attributeFilter: a }), () => i.disconnect();
  });
}
const Yte = 50, ZC = 300;
function qte(e, t) {
  const [n, r] = He(!1), [o, a] = He(null), [i, l] = He(!0), u = Ve(null), d = () => clearTimeout(u.current);
  LO(
    () => {
      o === "increment" && e(), o === "decrement" && t();
    },
    n ? Yte : null
  );
  const f = Q(() => {
    i && e(), u.current = setTimeout(() => {
      l(!1), r(!0), a("increment");
    }, ZC);
  }, [e, i]), h = Q(() => {
    i && t(), u.current = setTimeout(() => {
      l(!1), r(!0), a("decrement");
    }, ZC);
  }, [t, i]), p = Q(() => {
    l(!0), r(!1), d();
  }, []);
  return st(() => () => d(), []), { up: f, down: h, stop: p, isSpinning: n };
}
const Jte = /^[Ee0-9+\-.]$/;
function Kte(e) {
  return Jte.test(e);
}
function Qte(e, t) {
  if (e.key == null)
    return !0;
  const n = e.ctrlKey || e.altKey || e.metaKey;
  return !(e.key.length === 1) || n ? !0 : t(e.key);
}
function ene(e = {}) {
  const {
    focusInputOnChange: t = !0,
    clampValueOnBlur: n = !0,
    keepWithinRange: r = !0,
    min: o = Number.MIN_SAFE_INTEGER,
    max: a = Number.MAX_SAFE_INTEGER,
    step: i = 1,
    isReadOnly: l,
    isDisabled: u,
    isRequired: d,
    isInvalid: f,
    pattern: h = "[0-9]*(.[0-9]+)?",
    inputMode: p = "decimal",
    allowMouseWheel: g,
    id: C,
    onChange: v,
    precision: y,
    name: M,
    "aria-describedby": x,
    "aria-label": _,
    "aria-labelledby": L,
    onFocus: R,
    onBlur: k,
    onInvalid: P,
    getAriaValueText: N,
    isValidCharacter: O,
    format: H,
    parse: $,
    ...ne
  } = e, ie = ur(R), re = ur(k), ve = ur(P), ue = ur(
    O ?? Kte
  ), j = ur(N), K = mO(e), {
    update: ce,
    increment: U,
    decrement: q
  } = K, [ge, X] = He(!1), he = !(l || u), me = Ve(null), de = Ve(null), Le = Ve(null), Ie = Ve(null), Ne = Q(
    (De) => De.split("").filter(ue).join(""),
    [ue]
  ), ye = Q(
    (De) => ($ == null ? void 0 : $(De)) ?? De,
    [$]
  ), ke = Q(
    (De) => ((H == null ? void 0 : H(De)) ?? De).toString(),
    [H]
  );
  Ss(() => {
    (K.valueAsNumber > a || K.valueAsNumber < o) && (ve == null || ve("rangeOverflow", ke(K.value), K.valueAsNumber));
  }, [K.valueAsNumber, K.value, ke, ve]), Ci(() => {
    if (!me.current)
      return;
    if (me.current.value != K.value) {
      const Xt = ye(me.current.value);
      K.setValue(Ne(Xt));
    }
  }, [ye, Ne]);
  const oe = Q(
    (De = i) => {
      he && U(De);
    },
    [U, he, i]
  ), lt = Q(
    (De = i) => {
      he && q(De);
    },
    [q, he, i]
  ), Re = qte(oe, lt);
  $C(
    Le,
    "disabled",
    Re.stop,
    Re.isSpinning
  ), $C(
    Ie,
    "disabled",
    Re.stop,
    Re.isSpinning
  );
  const _t = Q(
    (De) => {
      if (De.nativeEvent.isComposing)
        return;
      const Nn = ye(De.currentTarget.value);
      ce(Ne(Nn)), de.current = {
        start: De.currentTarget.selectionStart,
        end: De.currentTarget.selectionEnd
      };
    },
    [ce, Ne, ye]
  ), on = Q(
    (De) => {
      var Xt;
      ie == null || ie(De), de.current && (De.currentTarget.selectionStart = de.current.start ?? ((Xt = De.currentTarget.value) == null ? void 0 : Xt.length), De.currentTarget.selectionEnd = de.current.end ?? De.currentTarget.selectionStart);
    },
    [ie]
  ), $e = Q(
    (De) => {
      if (De.nativeEvent.isComposing)
        return;
      Qte(De, ue) || De.preventDefault();
      const Xt = Zt(De) * i, Nn = De.key, Jr = {
        ArrowUp: () => oe(Xt),
        ArrowDown: () => lt(Xt),
        Home: () => ce(o),
        End: () => ce(a)
      }[Nn];
      Jr && (De.preventDefault(), Jr(De));
    },
    [ue, i, oe, lt, ce, o, a]
  ), Zt = (De) => {
    let Xt = 1;
    return (De.metaKey || De.ctrlKey) && (Xt = 0.1), De.shiftKey && (Xt = 10), Xt;
  }, Pt = bt(() => {
    const De = j == null ? void 0 : j(K.value);
    if (De != null)
      return De;
    const Xt = K.value.toString();
    return Xt || void 0;
  }, [K.value, j]), yt = Q(() => {
    let De = K.value;
    if (K.value === "")
      return;
    /^[eE]/.test(K.value.toString()) ? K.setValue("") : (K.valueAsNumber < o && (De = o), K.valueAsNumber > a && (De = a), K.cast(De));
  }, [K, a, o]), jt = Q(() => {
    X(!1), n && yt();
  }, [n, X, yt]), An = Q(() => {
    t && requestAnimationFrame(() => {
      var De;
      (De = me.current) == null || De.focus();
    });
  }, [t]), Rn = Q(
    (De) => {
      De.preventDefault(), Re.up(), An();
    },
    [An, Re]
  ), Er = Q(
    (De) => {
      De.preventDefault(), Re.down(), An();
    },
    [An, Re]
  );
  hl(
    () => me.current,
    "wheel",
    (De) => {
      var aa;
      const Nn = (((aa = me.current) == null ? void 0 : aa.ownerDocument) ?? document).activeElement === me.current;
      if (!g || !Nn)
        return;
      De.preventDefault();
      const Kn = Zt(De) * i, Jr = Math.sign(De.deltaY);
      Jr === -1 ? oe(Kn) : Jr === 1 && lt(Kn);
    },
    { passive: !1 }
  );
  const Ar = Q(
    (De = {}, Xt = null) => {
      const Nn = u || r && K.isAtMax;
      return {
        ...De,
        ref: In(Xt, Le),
        role: "button",
        tabIndex: -1,
        onPointerDown: qe(De.onPointerDown, (Kn) => {
          Kn.button !== 0 || Nn || Rn(Kn);
        }),
        onPointerLeave: qe(De.onPointerLeave, Re.stop),
        onPointerUp: qe(De.onPointerUp, Re.stop),
        disabled: Nn,
        "aria-disabled": vi(Nn)
      };
    },
    [K.isAtMax, r, Rn, Re.stop, u]
  ), oa = Q(
    (De = {}, Xt = null) => {
      const Nn = u || r && K.isAtMin;
      return {
        ...De,
        ref: In(Xt, Ie),
        role: "button",
        tabIndex: -1,
        onPointerDown: qe(De.onPointerDown, (Kn) => {
          Kn.button !== 0 || Nn || Er(Kn);
        }),
        onPointerLeave: qe(De.onPointerLeave, Re.stop),
        onPointerUp: qe(De.onPointerUp, Re.stop),
        disabled: Nn,
        "aria-disabled": vi(Nn)
      };
    },
    [K.isAtMin, r, Er, Re.stop, u]
  ), fr = Q(
    (De = {}, Xt = null) => ({
      name: M,
      inputMode: p,
      type: "text",
      pattern: h,
      "aria-labelledby": L,
      "aria-label": _,
      "aria-describedby": x,
      id: C,
      disabled: u,
      role: "spinbutton",
      ...De,
      readOnly: De.readOnly ?? l,
      "aria-readonly": De.readOnly ?? l,
      "aria-required": De.required ?? d,
      required: De.required ?? d,
      ref: In(me, Xt),
      value: ke(K.value),
      "aria-valuemin": o,
      "aria-valuemax": a,
      "aria-valuenow": Number.isNaN(K.valueAsNumber) ? void 0 : K.valueAsNumber,
      "aria-invalid": vi(f ?? K.isOutOfRange),
      "aria-valuetext": Pt,
      autoComplete: "off",
      autoCorrect: "off",
      onChange: qe(De.onChange, _t),
      onKeyDown: qe(De.onKeyDown, $e),
      onFocus: qe(
        De.onFocus,
        on,
        () => X(!0)
      ),
      onBlur: qe(De.onBlur, re, jt)
    }),
    [
      M,
      p,
      h,
      L,
      _,
      ke,
      x,
      C,
      u,
      d,
      l,
      f,
      K.value,
      K.valueAsNumber,
      K.isOutOfRange,
      o,
      a,
      Pt,
      _t,
      $e,
      on,
      re,
      jt
    ]
  );
  return {
    value: ke(K.value),
    valueAsNumber: K.valueAsNumber,
    isFocused: ge,
    isDisabled: u,
    isReadOnly: l,
    getIncrementButtonProps: Ar,
    getDecrementButtonProps: oa,
    getInputProps: fr,
    htmlProps: ne
  };
}
const [tne, Fh] = mn({
  name: "NumberInputStylesContext",
  errorMessage: `useNumberInputStyles returned is 'undefined'. Seems you forgot to wrap the components in "<NumberInput />" `
}), [nne, h9] = mn({
  name: "NumberInputContext",
  errorMessage: "useNumberInputContext: `context` is undefined. Seems you forgot to wrap number-input's components within <NumberInput />"
}), xw = Be(
  function(t, n) {
    const r = yr("NumberInput", t), o = Ln(t), a = T4(o), { htmlProps: i, ...l } = ene(a), u = bt(() => l, [l]);
    return /* @__PURE__ */ A.jsx(nne, { value: u, children: /* @__PURE__ */ A.jsx(tne, { value: r, children: /* @__PURE__ */ A.jsx(
      xe.div,
      {
        ...i,
        ref: n,
        className: ze("chakra-numberinput", t.className),
        __css: {
          position: "relative",
          zIndex: 0,
          ...r.root
        }
      }
    ) }) });
  }
);
xw.displayName = "NumberInput";
const ww = Be(
  function(t, n) {
    const r = Fh();
    return /* @__PURE__ */ A.jsx(
      xe.div,
      {
        "aria-hidden": !0,
        ref: n,
        ...t,
        __css: {
          display: "flex",
          flexDirection: "column",
          position: "absolute",
          top: "0",
          insetEnd: "0px",
          margin: "1px",
          height: "calc(100% - 2px)",
          zIndex: 1,
          ...r.stepperGroup
        }
      }
    );
  }
);
ww.displayName = "NumberInputStepper";
const _w = Be(
  function(t, n) {
    const { getInputProps: r } = h9(), o = r(t, n), a = Fh();
    return /* @__PURE__ */ A.jsx(
      xe.input,
      {
        ...o,
        className: ze("chakra-numberinput__field", t.className),
        __css: {
          width: "100%",
          ...a.field
        }
      }
    );
  }
);
_w.displayName = "NumberInputField";
const Iw = xe("div", {
  baseStyle: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flex: 1,
    transitionProperty: "common",
    transitionDuration: "normal",
    userSelect: "none",
    cursor: "pointer",
    lineHeight: "normal"
  }
}), Lw = Be(function(t, n) {
  const r = Fh(), { getDecrementButtonProps: o } = h9(), a = o(t, n);
  return /* @__PURE__ */ A.jsx(Iw, { ...a, __css: r.stepper, children: t.children ?? /* @__PURE__ */ A.jsx(Ute, {}) });
});
Lw.displayName = "NumberDecrementStepper";
const Rw = Be(function(t, n) {
  const { getIncrementButtonProps: r } = h9(), o = r(t, n), a = Fh();
  return /* @__PURE__ */ A.jsx(Iw, { ...o, __css: a.stepper, children: t.children ?? /* @__PURE__ */ A.jsx(Xte, {}) });
});
Rw.displayName = "NumberIncrementStepper";
const [rne, yc] = mn({
  name: "PopoverContext",
  errorMessage: "usePopoverContext: `context` is undefined. Seems you forgot to wrap all popover components within `<Popover />`"
}), [one, Bh] = mn({
  name: "PopoverStylesContext",
  errorMessage: `usePopoverStyles returned is 'undefined'. Seems you forgot to wrap the components in "<Popover />" `
}), xu = {
  click: "click",
  hover: "hover"
};
function ane(e = {}) {
  const {
    closeOnBlur: t = !0,
    closeOnEsc: n = !0,
    initialFocusRef: r,
    id: o,
    returnFocusOnClose: a = !0,
    autoFocus: i = !0,
    arrowSize: l,
    arrowShadowColor: u,
    trigger: d = xu.click,
    openDelay: f = 200,
    closeDelay: h = 200,
    isLazy: p,
    lazyBehavior: g = "unmount",
    computePositionOnMount: C,
    ...v
  } = e, { isOpen: y, onClose: M, onOpen: x, onToggle: _ } = wd(e), [L, R] = He(a);
  st(() => R(a), [a]);
  const k = Ve(null), P = Ve(null), N = Ve(null), O = Ve(!1), H = Ve(!1);
  y && (H.current = !0);
  const [$, ne] = He(!1), [ie, re] = He(!1), ve = Lo(), ue = o ?? ve, [j, K, ce, U] = [
    "popover-trigger",
    "popover-content",
    "popover-header",
    "popover-body"
  ].map(($e) => `${$e}-${ue}`), {
    referenceRef: q,
    getArrowProps: ge,
    getPopperProps: X,
    getArrowInnerProps: he,
    forceUpdate: me
  } = s9({
    ...v,
    enabled: y || !!C
  }), de = MS({ isOpen: y, ref: N });
  wO({
    enabled: y,
    ref: P
  }), _S(N, {
    focusRef: P,
    visible: y,
    shouldFocus: L && d === xu.click
  }), vO(N, {
    focusRef: r,
    visible: y,
    shouldFocus: i && d === xu.click
  }), LS({
    enabled: y && t,
    ref: N,
    handler($e) {
      var Pt;
      const Zt = ((Pt = $e.composedPath) == null ? void 0 : Pt.call($e)[0]) ?? [
        $e.target
      ];
      Af(P.current, Zt) || (Zt && R(!c2(Zt)), M());
    }
  });
  const Le = CS({
    wasSelected: H.current,
    enabled: p,
    mode: g,
    isSelected: de.present
  }), Ie = Q(
    ($e = {}, Zt = null) => {
      const Pt = {
        ...$e,
        style: {
          ...$e.style,
          transformOrigin: tr.transformOrigin.varRef,
          [tr.arrowSize.var]: l ? `${l}px` : void 0,
          [tr.arrowShadowColor.var]: u
        },
        ref: In(N, Zt),
        children: Le ? $e.children : null,
        id: K,
        tabIndex: -1,
        role: "dialog",
        onKeyDown: qe($e.onKeyDown, (yt) => {
          yt.nativeEvent.isComposing || n && yt.key === "Escape" && (yt.preventDefault(), yt.stopPropagation(), M());
        }),
        onBlur: qe($e.onBlur, (yt) => {
          const jt = jC(yt), An = Af(N.current, jt), Rn = Af(P.current, jt), Er = !An && !Rn;
          jt && R(!c2(jt)), y && t && Er && M();
        }),
        "aria-labelledby": $ ? ce : void 0,
        "aria-describedby": ie ? U : void 0
      };
      return d === xu.hover && (Pt.role = "tooltip", Pt.onMouseEnter = qe($e.onMouseEnter, () => {
        O.current = !0;
      }), Pt.onMouseLeave = qe(
        $e.onMouseLeave,
        (yt) => {
          yt.nativeEvent.relatedTarget !== null && (O.current = !1, setTimeout(() => M(), h));
        }
      )), Pt;
    },
    [
      Le,
      K,
      $,
      ce,
      ie,
      U,
      d,
      n,
      M,
      y,
      t,
      h,
      u,
      l
    ]
  ), Ne = Q(
    ($e = {}, Zt = null) => X(
      {
        ...$e,
        style: {
          visibility: y ? "visible" : "hidden",
          ...$e.style
        }
      },
      Zt
    ),
    [y, X]
  ), ye = Q(
    ($e, Zt = null) => ({
      ...$e,
      // If anchor is rendered, it is used as reference.
      ref: In(Zt, k, q)
    }),
    [k, q]
  ), ke = Ve(void 0), oe = Ve(void 0), lt = Q(
    ($e) => {
      k.current == null && q($e);
    },
    [q]
  ), Re = Q(
    ($e = {}, Zt = null) => {
      const Pt = {
        ...$e,
        ref: In(P, Zt, lt),
        id: j,
        "aria-haspopup": "dialog",
        "aria-expanded": y,
        "aria-controls": K
      };
      return d === xu.click && (Pt.onClick = qe($e.onClick, _)), d === xu.hover && (Pt.onFocus = qe($e.onFocus, () => {
        ke.current === void 0 && x();
      }), Pt.onBlur = qe($e.onBlur, (yt) => {
        const jt = jC(yt), An = !Af(N.current, jt);
        y && t && An && M();
      }), Pt.onKeyDown = qe($e.onKeyDown, (yt) => {
        yt.key === "Escape" && M();
      }), Pt.onMouseEnter = qe($e.onMouseEnter, () => {
        O.current = !0, ke.current = window.setTimeout(() => x(), f);
      }), Pt.onMouseLeave = qe($e.onMouseLeave, () => {
        O.current = !1, ke.current && (clearTimeout(ke.current), ke.current = void 0), oe.current = window.setTimeout(() => {
          O.current === !1 && M();
        }, h);
      })), Pt;
    },
    [
      j,
      y,
      K,
      d,
      lt,
      _,
      x,
      t,
      M,
      f,
      h
    ]
  );
  st(() => () => {
    ke.current && clearTimeout(ke.current), oe.current && clearTimeout(oe.current);
  }, []);
  const _t = Q(
    ($e = {}, Zt = null) => ({
      ...$e,
      id: ce,
      ref: In(Zt, (Pt) => {
        ne(!!Pt);
      })
    }),
    [ce]
  ), on = Q(
    ($e = {}, Zt = null) => ({
      ...$e,
      id: U,
      ref: In(Zt, (Pt) => {
        re(!!Pt);
      })
    }),
    [U]
  );
  return {
    forceUpdate: me,
    isOpen: y,
    onAnimationComplete: de.onComplete,
    onClose: M,
    getAnchorProps: ye,
    getArrowProps: ge,
    getArrowInnerProps: he,
    getPopoverPositionerProps: Ne,
    getPopoverProps: Ie,
    getTriggerProps: Re,
    getHeaderProps: _t,
    getBodyProps: on
  };
}
function Af(e, t) {
  return e === t || (e == null ? void 0 : e.contains(t));
}
function jC(e) {
  const t = e.currentTarget.ownerDocument.activeElement;
  return e.relatedTarget ?? t;
}
function Hh(e) {
  const t = yr("Popover", e), { children: n, ...r } = Ln(e), o = bc(), a = ane({ ...r, direction: o.direction });
  return /* @__PURE__ */ A.jsx(rne, { value: a, children: /* @__PURE__ */ A.jsx(one, { value: t, children: Wo(n, {
    isOpen: a.isOpen,
    onClose: a.onClose,
    forceUpdate: a.forceUpdate
  }) }) });
}
Hh.displayName = "Popover";
function Dw(e) {
  var n;
  const t = Ee.version;
  return typeof t != "string" || t.startsWith("18.") ? e == null ? void 0 : e.ref : (n = e == null ? void 0 : e.props) == null ? void 0 : n.ref;
}
const Vg = (e, t) => t ? `${e}.${t}, ${t}` : void 0;
function Pw(e) {
  const {
    bg: t,
    bgColor: n,
    backgroundColor: r,
    shadow: o,
    boxShadow: a,
    shadowColor: i,
    ...l
  } = e, { getArrowProps: u, getArrowInnerProps: d } = yc(), f = Bh(), h = t ?? n ?? r, p = o ?? a;
  return /* @__PURE__ */ A.jsx(
    xe.div,
    {
      ...u(),
      className: "chakra-popover__arrow-positioner",
      children: /* @__PURE__ */ A.jsx(
        xe.div,
        {
          className: ze("chakra-popover__arrow", e.className),
          ...d(l),
          __css: {
            "--popper-arrow-shadow-color": Vg("colors", i),
            "--popper-arrow-bg": Vg("colors", h),
            "--popper-arrow-shadow": Vg("shadows", p),
            ...f.arrow
          }
        }
      )
    }
  );
}
Pw.displayName = "PopoverArrow";
const Gh = Be(
  function(t, n) {
    const { getBodyProps: r } = yc(), o = Bh();
    return /* @__PURE__ */ A.jsx(
      xe.div,
      {
        ...r(t, n),
        className: ze("chakra-popover__body", t.className),
        __css: o.body
      }
    );
  }
);
Gh.displayName = "PopoverBody";
const Ew = Be(
  function(t, n) {
    const { onClose: r } = yc(), o = Bh();
    return /* @__PURE__ */ A.jsx(
      Td,
      {
        size: "sm",
        onClick: r,
        className: ze("chakra-popover__close-btn", t.className),
        __css: o.closeButton,
        ref: n,
        ...t
      }
    );
  }
);
Ew.displayName = "PopoverCloseButton";
function ine(e) {
  if (e)
    return {
      enter: {
        ...e.enter,
        visibility: "visible"
      },
      exit: {
        ...e.exit,
        transitionEnd: {
          visibility: "hidden"
        }
      }
    };
}
const sne = {
  exit: {
    opacity: 0,
    scale: 0.95,
    transition: {
      duration: 0.1,
      ease: [0.4, 0, 1, 1]
    }
  },
  enter: {
    scale: 1,
    opacity: 1,
    transition: {
      duration: 0.15,
      ease: [0, 0, 0.2, 1]
    }
  }
}, lne = xe(xa.section), Tw = Be(function(t, n) {
  const { variants: r = sne, ...o } = t, { isOpen: a } = yc();
  return /* @__PURE__ */ A.jsx(
    lne,
    {
      ref: n,
      variants: ine(r),
      initial: !1,
      animate: a ? "enter" : "exit",
      ...o
    }
  );
});
Tw.displayName = "PopoverTransition";
const $h = Be(
  function(t, n) {
    const { rootProps: r, motionProps: o, ...a } = t, { getPopoverProps: i, getPopoverPositionerProps: l, onAnimationComplete: u } = yc(), d = Bh(), f = {
      position: "relative",
      display: "flex",
      flexDirection: "column",
      ...d.content
    };
    return /* @__PURE__ */ A.jsx(
      xe.div,
      {
        ...l(r),
        __css: d.popper,
        className: "chakra-popover__popper",
        children: /* @__PURE__ */ A.jsx(
          Tw,
          {
            ...o,
            ...i(a, n),
            onAnimationComplete: Ah(
              u,
              a.onAnimationComplete
            ),
            className: ze("chakra-popover__content", t.className),
            __css: f
          }
        )
      }
    );
  }
);
$h.displayName = "PopoverContent";
function Zh(e) {
  const t = Ad.only(e.children), { getTriggerProps: n } = yc();
  return /* @__PURE__ */ A.jsx(A.Fragment, { children: Yo(t, n(t.props, Dw(t))) });
}
Zh.displayName = "PopoverTrigger";
function une(e) {
  return e && cr(e) && cr(e.target);
}
function Nw(e = {}) {
  const {
    onChange: t,
    value: n,
    defaultValue: r,
    name: o,
    isDisabled: a,
    isFocusable: i,
    isNative: l,
    ...u
  } = e, [d, f] = He(r || ""), h = typeof n < "u", p = h ? n : d, g = Ve(null), C = Q(() => {
    const R = g.current;
    if (!R)
      return;
    let k = "input:not(:disabled):checked";
    const P = R.querySelector(
      k
    );
    if (P) {
      P.focus();
      return;
    }
    k = "input:not(:disabled)";
    const N = R.querySelector(k);
    N == null || N.focus();
  }, []), y = `radio-${Lo()}`, M = o || y, x = Q(
    (R) => {
      const k = une(R) ? R.target.value : R;
      h || f(k), t == null || t(String(k));
    },
    [t, h]
  ), _ = Q(
    (R = {}, k = null) => ({
      ...R,
      ref: In(k, g),
      role: "radiogroup"
    }),
    []
  ), L = Q(
    (R = {}, k = null) => ({
      ...R,
      ref: k,
      name: M,
      [l ? "checked" : "isChecked"]: p != null ? R.value === p : void 0,
      onChange(N) {
        x(N);
      },
      "data-radiogroup": !0
    }),
    [l, M, x, p]
  );
  return {
    getRootProps: _,
    getRadioProps: L,
    name: M,
    ref: g,
    focus: C,
    setValue: f,
    value: p,
    onChange: x,
    isDisabled: a,
    isFocusable: i,
    htmlProps: u
  };
}
const [cne, kw] = mn({
  name: "RadioGroupContext",
  strict: !1
}), Vw = Be((e, t) => {
  const {
    colorScheme: n,
    size: r,
    variant: o,
    children: a,
    className: i,
    isDisabled: l,
    isFocusable: u,
    ...d
  } = e, { value: f, onChange: h, getRootProps: p, name: g, htmlProps: C } = Nw(d), v = bt(
    () => ({
      name: g,
      size: r,
      onChange: h,
      colorScheme: n,
      value: f,
      variant: o,
      isDisabled: l,
      isFocusable: u
    }),
    [
      g,
      r,
      h,
      n,
      f,
      o,
      l,
      u
    ]
  );
  return /* @__PURE__ */ A.jsx(cne, { value: v, children: /* @__PURE__ */ A.jsx(
    xe.div,
    {
      ...p(C, t),
      className: ze("chakra-radio-group", i),
      children: a
    }
  ) });
});
Vw.displayName = "RadioGroup";
function Ow(e = {}) {
  const {
    defaultChecked: t,
    isChecked: n,
    isFocusable: r,
    isDisabled: o,
    isReadOnly: a,
    isRequired: i,
    onChange: l,
    isInvalid: u,
    name: d,
    value: f,
    id: h,
    "data-radiogroup": p,
    "aria-describedby": g,
    ...C
  } = e, v = `radio-${Lo()}`, y = Hl(), x = !!kw() || !!p;
  let L = !!y && !x ? y.id : v;
  L = h ?? L;
  const R = o ?? (y == null ? void 0 : y.isDisabled), k = a ?? (y == null ? void 0 : y.isReadOnly), P = i ?? (y == null ? void 0 : y.isRequired), N = u ?? (y == null ? void 0 : y.isInvalid), [O, H] = He(!1), [$, ne] = He(!1), [ie, re] = He(!1), [ve, ue] = He(!!t), j = typeof n < "u", K = j ? n : ve, ce = Ve(!1);
  st(() => WM((ye) => {
    ce.current = ye;
  }), []);
  const U = Q(
    (ye) => {
      if (k || R) {
        ye.preventDefault();
        return;
      }
      j || ue(ye.currentTarget.checked), l == null || l(ye);
    },
    [j, R, k, l]
  ), q = Q(
    (ye) => {
      ye.key === " " && re(!0);
    },
    [re]
  ), ge = Q(
    (ye) => {
      ye.key === " " && re(!1);
    },
    [re]
  ), X = Q(
    (ye = {}, ke = null) => ({
      ...ye,
      ref: ke,
      "data-active": Qe(ie),
      "data-hover": Qe($),
      "data-disabled": Qe(R),
      "data-invalid": Qe(N),
      "data-checked": Qe(K),
      "data-focus": Qe(O),
      "data-focus-visible": Qe(O && ce.current),
      "data-readonly": Qe(k),
      "aria-hidden": !0,
      onMouseDown: qe(ye.onMouseDown, () => re(!0)),
      onMouseUp: qe(ye.onMouseUp, () => re(!1)),
      onMouseEnter: qe(
        ye.onMouseEnter,
        () => ne(!0)
      ),
      onMouseLeave: qe(
        ye.onMouseLeave,
        () => ne(!1)
      )
    }),
    [
      ie,
      $,
      R,
      N,
      K,
      O,
      k
    ]
  ), { onFocus: he, onBlur: me } = y ?? {}, de = Q(
    (ye = {}, ke = null) => {
      const oe = R && !r;
      return {
        ...ye,
        id: L,
        ref: ke,
        type: "radio",
        name: d,
        value: f,
        onChange: qe(ye.onChange, U),
        onBlur: qe(
          me,
          ye.onBlur,
          () => H(!1)
        ),
        onFocus: qe(
          he,
          ye.onFocus,
          () => H(!0)
        ),
        onKeyDown: qe(ye.onKeyDown, q),
        onKeyUp: qe(ye.onKeyUp, ge),
        checked: K,
        disabled: oe,
        readOnly: k,
        required: P,
        "aria-invalid": vi(N),
        "aria-disabled": vi(oe),
        "aria-required": vi(P),
        "data-readonly": Qe(k),
        "aria-describedby": g,
        style: YM
      };
    },
    [
      R,
      r,
      L,
      d,
      f,
      U,
      me,
      he,
      q,
      ge,
      K,
      k,
      P,
      N,
      g
    ]
  );
  return {
    state: {
      isInvalid: N,
      isFocused: O,
      isChecked: K,
      isActive: ie,
      isHovered: $,
      isDisabled: R,
      isReadOnly: k,
      isRequired: P
    },
    getRadioProps: X,
    getInputProps: de,
    getLabelProps: (ye = {}, ke = null) => ({
      ...ye,
      ref: ke,
      onMouseDown: qe(ye.onMouseDown, dne),
      "data-disabled": Qe(R),
      "data-checked": Qe(K),
      "data-invalid": Qe(N)
    }),
    getRootProps: (ye, ke = null) => ({
      htmlFor: L,
      ...ye,
      ref: ke,
      "data-disabled": Qe(R),
      "data-checked": Qe(K),
      "data-invalid": Qe(N)
    }),
    htmlProps: C
  };
}
function dne(e) {
  e.preventDefault(), e.stopPropagation();
}
const Fw = Be((e, t) => {
  const n = kw(), { onChange: r, value: o } = e, a = yr("Radio", { ...n, ...e }), i = Ln(e), {
    spacing: l = "0.5rem",
    children: u,
    isDisabled: d = n == null ? void 0 : n.isDisabled,
    isFocusable: f = n == null ? void 0 : n.isFocusable,
    inputProps: h,
    ...p
  } = i;
  let g = e.isChecked;
  (n == null ? void 0 : n.value) != null && o != null && (g = n.value === o);
  let C = r;
  n != null && n.onChange && o != null && (C = Ah(n.onChange, r));
  const v = (e == null ? void 0 : e.name) ?? (n == null ? void 0 : n.name), {
    getInputProps: y,
    getRadioProps: M,
    getLabelProps: x,
    getRootProps: _,
    htmlProps: L
  } = Ow({
    ...p,
    isChecked: g,
    isFocusable: f,
    isDisabled: d,
    onChange: C,
    name: v
  }), [R, k] = AS(L, NS), P = M(k), N = y(h, t), O = x(), H = Object.assign({}, R, _()), $ = {
    display: "inline-flex",
    alignItems: "center",
    verticalAlign: "top",
    cursor: "pointer",
    position: "relative",
    ...a.container
  }, ne = {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    ...a.control
  }, ie = {
    userSelect: "none",
    marginStart: l,
    ...a.label
  };
  return /* @__PURE__ */ A.jsxs(xe.label, { className: "chakra-radio", ...H, __css: $, children: [
    /* @__PURE__ */ A.jsx("input", { className: "chakra-radio__input", ...N }),
    /* @__PURE__ */ A.jsx(
      xe.span,
      {
        className: "chakra-radio__control",
        ...P,
        __css: ne
      }
    ),
    u && /* @__PURE__ */ A.jsx(
      xe.span,
      {
        className: "chakra-radio__label",
        ...O,
        __css: ie,
        children: u
      }
    )
  ] });
});
Fw.displayName = "Radio";
const Bw = Be(
  function(t, n) {
    const { children: r, placeholder: o, className: a, ...i } = t;
    return /* @__PURE__ */ A.jsxs(
      xe.select,
      {
        ...i,
        ref: n,
        className: ze("chakra-select", a),
        children: [
          o && /* @__PURE__ */ A.jsx("option", { value: "", children: o }),
          r
        ]
      }
    );
  }
);
Bw.displayName = "SelectField";
const Hw = Be((e, t) => {
  var _;
  const n = yr("Select", e), {
    rootProps: r,
    placeholder: o,
    icon: a,
    color: i,
    height: l,
    h: u,
    minH: d,
    minHeight: f,
    iconColor: h,
    iconSize: p,
    ...g
  } = Ln(e), [C, v] = AS(g, NS), y = E4(v), M = {
    width: "100%",
    height: "fit-content",
    position: "relative",
    color: i
  }, x = {
    paddingEnd: "2rem",
    ...n.field,
    _focus: {
      zIndex: "unset",
      ...(_ = n.field) == null ? void 0 : _._focus
    }
  };
  return /* @__PURE__ */ A.jsxs(
    xe.div,
    {
      className: "chakra-select__wrapper",
      __css: M,
      ...C,
      ...r,
      children: [
        /* @__PURE__ */ A.jsx(
          Bw,
          {
            ref: t,
            height: u ?? l,
            minH: d ?? f,
            placeholder: o,
            ...y,
            __css: x,
            children: e.children
          }
        ),
        /* @__PURE__ */ A.jsx(
          Gw,
          {
            "data-disabled": Qe(y.disabled),
            ...(h || i) && { color: h || i },
            __css: n.icon,
            ...p && { fontSize: p },
            children: a
          }
        )
      ]
    }
  );
});
Hw.displayName = "Select";
const fne = (e) => /* @__PURE__ */ A.jsx("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ A.jsx(
  "path",
  {
    fill: "currentColor",
    d: "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"
  }
) }), hne = xe("div", {
  baseStyle: {
    position: "absolute",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    pointerEvents: "none",
    top: "50%",
    transform: "translateY(-50%)"
  }
}), Gw = (e) => {
  const { children: t = /* @__PURE__ */ A.jsx(fne, {}), ...n } = e, r = Yo(t, {
    role: "presentation",
    className: "chakra-select__icon",
    focusable: !1,
    "aria-hidden": !0,
    // force icon to adhere to `IconWrapper` styles
    style: {
      width: "1em",
      height: "1em",
      color: "currentColor"
    }
  });
  return /* @__PURE__ */ A.jsx(hne, { ...n, className: "chakra-select__icon-wrapper", children: Ol(t) ? r : null });
};
Gw.displayName = "SelectIcon";
const $w = (e) => /* @__PURE__ */ A.jsx(
  xe.div,
  {
    className: "chakra-stack__item",
    ...e,
    __css: {
      display: "inline-block",
      flex: "0 0 auto",
      minWidth: 0,
      ...e.__css
    }
  }
);
$w.displayName = "StackItem";
function mne(e) {
  const { spacing: t, direction: n } = e, r = {
    column: {
      my: t,
      mx: 0,
      borderLeftWidth: 0,
      borderBottomWidth: "1px"
    },
    "column-reverse": {
      my: t,
      mx: 0,
      borderLeftWidth: 0,
      borderBottomWidth: "1px"
    },
    row: {
      mx: t,
      my: 0,
      borderLeftWidth: "1px",
      borderBottomWidth: 0
    },
    "row-reverse": {
      mx: t,
      my: 0,
      borderLeftWidth: "1px",
      borderBottomWidth: 0
    }
  };
  return {
    "&": j3(
      n,
      (o) => r[o]
    )
  };
}
const jh = Be((e, t) => {
  const {
    isInline: n,
    direction: r,
    align: o,
    justify: a,
    spacing: i = "0.5rem",
    wrap: l,
    children: u,
    divider: d,
    className: f,
    shouldWrapChildren: h,
    ...p
  } = e, g = n ? "row" : r ?? "column", C = bt(
    () => mne({ spacing: i, direction: g }),
    [i, g]
  ), v = !!d, y = !h && !v, M = bt(() => {
    const _ = mS(u);
    return y ? _ : _.map((L, R) => {
      const k = typeof L.key < "u" ? L.key : R, P = R + 1 === _.length, O = h ? /* @__PURE__ */ A.jsx($w, { children: L }, k) : L;
      if (!v)
        return O;
      const H = Yo(
        d,
        {
          __css: C
        }
      ), $ = P ? null : H;
      return /* @__PURE__ */ A.jsxs(Ml, { children: [
        O,
        $
      ] }, k);
    });
  }, [
    d,
    C,
    v,
    y,
    h,
    u
  ]), x = ze("chakra-stack", f);
  return /* @__PURE__ */ A.jsx(
    xe.div,
    {
      ref: t,
      display: "flex",
      alignItems: o,
      justifyContent: a,
      flexDirection: g,
      flexWrap: l,
      gap: v ? void 0 : i,
      className: x,
      ...p,
      children: M
    }
  );
});
jh.displayName = "Stack";
const I2 = Be((e, t) => /* @__PURE__ */ A.jsx(jh, { align: "center", ...e, direction: "row", ref: t }));
I2.displayName = "HStack";
const Zw = Be((e, t) => /* @__PURE__ */ A.jsx(jh, { align: "center", ...e, direction: "column", ref: t }));
Zw.displayName = "VStack";
const jw = Be(
  function(t, n) {
    const r = yr("Switch", t), {
      spacing: o = "0.5rem",
      children: a,
      ...i
    } = Ln(t), {
      getIndicatorProps: l,
      getInputProps: u,
      getCheckboxProps: d,
      getRootProps: f,
      getLabelProps: h
    } = qM(i), p = bt(
      () => ({
        display: "inline-block",
        position: "relative",
        verticalAlign: "middle",
        lineHeight: 0,
        ...r.container
      }),
      [r.container]
    ), g = bt(
      () => ({
        display: "inline-flex",
        flexShrink: 0,
        justifyContent: "flex-start",
        boxSizing: "content-box",
        cursor: "pointer",
        ...r.track
      }),
      [r.track]
    ), C = bt(
      () => ({
        userSelect: "none",
        marginStart: o,
        ...r.label
      }),
      [o, r.label]
    );
    return /* @__PURE__ */ A.jsxs(
      xe.label,
      {
        ...f(),
        className: ze("chakra-switch", t.className),
        __css: p,
        children: [
          /* @__PURE__ */ A.jsx("input", { className: "chakra-switch__input", ...u({}, n) }),
          /* @__PURE__ */ A.jsx(
            xe.span,
            {
              ...d(),
              className: "chakra-switch__track",
              __css: g,
              children: /* @__PURE__ */ A.jsx(
                xe.span,
                {
                  __css: r.thumb,
                  className: "chakra-switch__thumb",
                  ...l()
                }
              )
            }
          ),
          a && /* @__PURE__ */ A.jsx(
            xe.span,
            {
              className: "chakra-switch__label",
              ...h(),
              __css: C,
              children: a
            }
          )
        ]
      }
    );
  }
);
jw.displayName = "Switch";
const [pne, Bd] = mn({
  name: "TableStylesContext",
  errorMessage: `useTableStyles returned is 'undefined'. Seems you forgot to wrap the components in "<Table />" `
}), Ww = Be((e, t) => {
  const n = yr("Table", e), { className: r, layout: o, ...a } = Ln(e);
  return /* @__PURE__ */ A.jsx(pne, { value: n, children: /* @__PURE__ */ A.jsx(
    xe.table,
    {
      ref: t,
      __css: { tableLayout: o, ...n.table },
      className: ze("chakra-table", r),
      ...a
    }
  ) });
});
Ww.displayName = "Table";
const gne = Be((e, t) => {
  const n = Bd();
  return /* @__PURE__ */ A.jsx(xe.tbody, { ...e, ref: t, __css: n.tbody });
}), vne = Be(
  ({ isNumeric: e, ...t }, n) => {
    const r = Bd();
    return /* @__PURE__ */ A.jsx(
      xe.td,
      {
        ...t,
        ref: n,
        __css: r.td,
        "data-is-numeric": e
      }
    );
  }
), Cne = Be(
  ({ isNumeric: e, ...t }, n) => {
    const r = Bd();
    return /* @__PURE__ */ A.jsx(
      xe.th,
      {
        ...t,
        ref: n,
        __css: r.th,
        "data-is-numeric": e
      }
    );
  }
), bne = Be((e, t) => {
  const n = Bd();
  return /* @__PURE__ */ A.jsx(xe.thead, { ...e, ref: t, __css: n.thead });
}), WC = Be((e, t) => {
  const n = Bd();
  return /* @__PURE__ */ A.jsx(xe.tr, { ...e, ref: t, __css: n.tr });
}), yne = ["h", "minH", "height", "minHeight"], zw = Be((e, t) => {
  const n = Ua("Textarea", e), { className: r, rows: o, ...a } = Ln(e), i = E4(a), l = o ? Mh(n, yne) : n;
  return /* @__PURE__ */ A.jsx(
    xe.textarea,
    {
      ref: t,
      rows: o,
      ...i,
      className: ze("chakra-textarea", r),
      __css: l
    }
  );
});
zw.displayName = "Textarea";
const Sne = {
  exit: {
    scale: 0.85,
    opacity: 0,
    transition: {
      opacity: { duration: 0.15, easings: "easeInOut" },
      scale: { duration: 0.2, easings: "easeInOut" }
    }
  },
  enter: {
    scale: 1,
    opacity: 1,
    transition: {
      opacity: { easings: "easeOut", duration: 0.2 },
      scale: { duration: 0.2, ease: [0.175, 0.885, 0.4, 1.1] }
    }
  }
}, e3 = (e) => {
  var t;
  return ((t = e.current) == null ? void 0 : t.ownerDocument) || document;
}, t2 = (e) => {
  var t, n;
  return ((n = (t = e.current) == null ? void 0 : t.ownerDocument) == null ? void 0 : n.defaultView) || window;
};
function Ane(e = {}) {
  const {
    openDelay: t = 0,
    closeDelay: n = 0,
    closeOnClick: r = !0,
    closeOnMouseDown: o,
    closeOnScroll: a,
    closeOnPointerDown: i = o,
    closeOnEsc: l = !0,
    onOpen: u,
    onClose: d,
    placement: f,
    id: h,
    isOpen: p,
    defaultIsOpen: g,
    arrowSize: C = 10,
    arrowShadowColor: v,
    arrowPadding: y,
    modifiers: M,
    isDisabled: x,
    gutter: _,
    offset: L,
    direction: R,
    ...k
  } = e, { isOpen: P, onOpen: N, onClose: O } = wd({
    isOpen: p,
    defaultIsOpen: g,
    onOpen: u,
    onClose: d
  }), { referenceRef: H, getPopperProps: $, getArrowInnerProps: ne, getArrowProps: ie } = s9({
    enabled: P,
    placement: f,
    arrowPadding: y,
    modifiers: M,
    gutter: _,
    offset: L,
    direction: R
  }), re = Lo(), ue = `tooltip-${h ?? re}`, j = Ve(null), K = Ve(void 0), ce = Q(() => {
    K.current && (clearTimeout(K.current), K.current = void 0);
  }, []), U = Ve(void 0), q = Q(() => {
    U.current && (clearTimeout(U.current), U.current = void 0);
  }, []), ge = Q(() => {
    q(), O();
  }, [O, q]), X = Mne(j, ge), he = Q(() => {
    if (!x && !K.current) {
      P && X();
      const oe = t2(j);
      K.current = oe.setTimeout(N, t);
    }
  }, [X, x, P, N, t]), me = Q(() => {
    ce();
    const oe = t2(j);
    U.current = oe.setTimeout(ge, n);
  }, [n, ge, ce]), de = Q(() => {
    P && r && me();
  }, [r, me, P]), Le = Q(() => {
    P && i && me();
  }, [i, me, P]), Ie = Q(
    (oe) => {
      P && oe.key === "Escape" && me();
    },
    [P, me]
  );
  hl(
    () => e3(j),
    "keydown",
    l ? Ie : void 0
  ), hl(
    () => {
      if (!a)
        return null;
      const oe = j.current;
      if (!oe)
        return null;
      const lt = SS(oe);
      return lt.localName === "body" ? t2(j) : lt;
    },
    "scroll",
    () => {
      P && a && ge();
    },
    { passive: !0, capture: !0 }
  ), st(() => {
    x && (ce(), P && O());
  }, [x, P, O, ce]), st(() => () => {
    ce(), q();
  }, [ce, q]), hl(() => j.current, "pointerleave", me);
  const Ne = Q(
    (oe = {}, lt = null) => ({
      ...oe,
      ref: In(j, lt, H),
      onPointerEnter: qe(oe.onPointerEnter, (_t) => {
        _t.pointerType !== "touch" && he();
      }),
      onClick: qe(oe.onClick, de),
      onPointerDown: qe(oe.onPointerDown, Le),
      onFocus: qe(oe.onFocus, he),
      onBlur: qe(oe.onBlur, me),
      "aria-describedby": P ? ue : void 0
    }),
    [
      he,
      me,
      Le,
      P,
      ue,
      de,
      H
    ]
  ), ye = Q(
    (oe = {}, lt = null) => $(
      {
        ...oe,
        style: {
          ...oe.style,
          [tr.arrowSize.var]: C ? `${C}px` : void 0,
          [tr.arrowShadowColor.var]: v
        }
      },
      lt
    ),
    [$, C, v]
  ), ke = Q(
    (oe = {}, lt = null) => {
      const Re = {
        ...oe.style,
        position: "relative",
        transformOrigin: tr.transformOrigin.varRef
      };
      return {
        ref: lt,
        ...k,
        ...oe,
        id: ue,
        role: "tooltip",
        style: Re
      };
    },
    [k, ue]
  );
  return {
    isOpen: P,
    show: he,
    hide: me,
    getTriggerProps: Ne,
    getTooltipProps: ke,
    getTooltipPositionerProps: ye,
    getArrowProps: ie,
    getArrowInnerProps: ne
  };
}
const Og = "chakra-ui:close-tooltip";
function Mne(e, t) {
  return st(() => {
    const n = e3(e);
    return n.addEventListener(Og, t), () => n.removeEventListener(Og, t);
  }, [t, e]), () => {
    const n = e3(e), r = t2(e);
    n.dispatchEvent(new r.CustomEvent(Og));
  };
}
const xne = xe(xa.div), m9 = Be((e, t) => {
  const n = Ua("Tooltip", e), r = Ln(e), o = bc(), {
    children: a,
    label: i,
    shouldWrapChildren: l,
    "aria-label": u,
    hasArrow: d,
    bg: f,
    portalProps: h,
    background: p,
    backgroundColor: g,
    bgColor: C,
    motionProps: v,
    animatePresenceProps: y,
    ...M
  } = r, x = p ?? g ?? f ?? C;
  if (x) {
    n.bg = x;
    const H = yF(o, "colors", x);
    n[tr.arrowBg.var] = H;
  }
  const _ = Ane({ ...M, direction: o.direction }), L = !Ol(a) || l;
  let R;
  if (L)
    R = /* @__PURE__ */ A.jsx(
      xe.span,
      {
        display: "inline-block",
        tabIndex: 0,
        ..._.getTriggerProps(),
        children: a
      }
    );
  else {
    const H = Ad.only(a);
    R = Yo(
      H,
      _.getTriggerProps(H.props, Dw(H))
    );
  }
  const k = !!u, P = _.getTooltipProps({}, t), N = k ? Mh(P, ["role", "id"]) : P, O = yS(P, ["role", "id"]);
  return i ? /* @__PURE__ */ A.jsxs(A.Fragment, { children: [
    R,
    /* @__PURE__ */ A.jsx(Rs, { ...y, children: _.isOpen && /* @__PURE__ */ A.jsx(ki, { ...h, children: /* @__PURE__ */ A.jsx(
      xe.div,
      {
        ..._.getTooltipPositionerProps(),
        __css: {
          zIndex: n.zIndex,
          pointerEvents: "none"
        },
        children: /* @__PURE__ */ A.jsxs(
          xne,
          {
            variants: Sne,
            initial: "exit",
            animate: "enter",
            exit: "exit",
            ...v,
            ...N,
            __css: n,
            children: [
              i,
              k && /* @__PURE__ */ A.jsx(xe.span, { srOnly: !0, ...O, children: u }),
              d && /* @__PURE__ */ A.jsx(
                xe.div,
                {
                  "data-popper-arrow": !0,
                  className: "chakra-tooltip__arrow-wrapper",
                  children: /* @__PURE__ */ A.jsx(
                    xe.div,
                    {
                      "data-popper-arrow-inner": !0,
                      className: "chakra-tooltip__arrow",
                      __css: { bg: n.bg }
                    }
                  )
                }
              )
            ]
          }
        )
      }
    ) }) })
  ] }) : /* @__PURE__ */ A.jsx(A.Fragment, { children: a });
});
m9.displayName = "Tooltip";
const Uw = Be(
  function(t, n) {
    const r = Ua("Heading", t), { className: o, ...a } = Ln(t);
    return /* @__PURE__ */ A.jsx(
      xe.h2,
      {
        ref: n,
        className: ze("chakra-heading", t.className),
        ...a,
        __css: r
      }
    );
  }
);
Uw.displayName = "Heading";
const wne = "#E8F4FE", _ne = "#F8FBFE", Ine = "#40A7FF", zC = "#E4E8EC", Lne = "#728291", Rne = "#394D60", Dne = Rne, Pne = "#F23636", Ene = wne, Tne = _ne, Nne = {
  primary: Ine,
  primaryBackground: Ene,
  secondaryBackground: Tne,
  disabled: zC,
  textSecondary: Dne,
  inputLabelText: Lne,
  border: zC,
  danger: Pne
}, Te = {
  white: "#FFFFFF",
  black: "#000000",
  gray: "#9CA6AF",
  "gray.50": "#FAFAFA",
  "gray.100": "#F7F7F7",
  "gray.200": "#E7E7E7",
  "gray.300": "#CDD3D7",
  "gray.350": "#394D6015",
  "gray.400": "#E1E4E7",
  "gray.600": "#728291",
  "gray.650": "#657888",
  "gray.700": "#394D60",
  "gray.800": "#45525F",
  "gray.900": "#072138",
  "red.200": "#F4CCCD",
  "red.400": "#FA3C48",
  "red.700": "#CE161B",
  "orange.100": "#FBE7C3",
  "orange.500": "#EE9611",
  "orange.600": "#D55E00",
  "yellow.200": "#FFF6C7",
  "yellow.400": "#FFD600",
  lightYellow: "#FFFFE0",
  // maps to `lightyellow` named color
  "green.200": "#E0F4F0",
  "green.300": "#C7EBE3",
  "green.500": "#00A67F",
  "green.600": "#019E73",
  "green.700": "#087742",
  navy: "#3455DB",
  "navy.50": "#F4F7FF",
  "navy.100": "#EDF0FF",
  "navy.200": "#DAE1FE",
  "navy.250": "#D2E4F4",
  "navy.300": "#3455DB20",
  "navy.400": "#9CAFFF",
  "navy.450": "#5C76E2",
  "navy.600": "#2240B9",
  "navy.700": "#0072B2",
  "navy.800": "#00008B",
  "navy.900": "#1F364E",
  "pink.500": "#CC79A7",
  "purple.500": "#9552ee",
  "lavender.100": "#E6D7FC",
  "lavender.500": "#9552EE",
  "tiers.1": "#008B8B",
  "tiers.2": "#2A9570",
  "tiers.3": "#619B4E",
  "tiers.4": "#999933",
  "tiers.5": "#a17f2b",
  "tiers.6": "#b36d20",
  "tiers.7": "#d45a1d",
  "tiers.8": "#f04619",
  "tiers.9": "#f02c00",
  "tiers.10": "#FF0000"
}, kne = {
  // empty:
  none: "#00000000",
  // buttons:
  buttonDefault: Te.navy,
  buttonHover: Te["navy.600"],
  buttonActive: Te["navy.800"],
  // non-button-interactive-items:
  selected1: Te["navy.100"],
  selected2: Te.navy,
  selected3: Te["navy.900"],
  selected4: Te["navy.200"],
  selected5: Te["lavender.100"],
  hover1: Te["navy.50"],
  hover2: Te["navy.400"],
  hoverTransparent: Te["navy.300"],
  hoverTransparentLight: Te["gray.350"],
  disabledFill: Te["gray.100"],
  // strokes:
  strokeDefault: Te["gray.300"],
  strokeLight: Te["gray.200"],
  strokeHover: Te.gray,
  strokeActive: Te["gray.600"],
  strokeInteractive: Te["gray.800"],
  // surfaces:
  surface1: Te.white,
  surface2: Te["gray.100"],
  surface3: Te["navy.50"],
  surface4: Te["gray.200"],
  surface5: Te["gray.700"],
  surface6: Te["gray.50"],
  surface7: Te["gray.400"],
  surface8: Te["green.200"],
  // surface-accents:
  surfaceAccent1: Te["navy.600"],
  surfaceAccent2: Te["navy.900"],
  surfaceAccent3: Te["navy.800"],
  surfaceAccent4: Te.navy,
  surfaceAccent5: Te["navy.400"],
  surfaceAccent6: Te["navy.450"],
  surfaceAccent7: Te["gray.700"],
  surfaceAccent8: Te["green.200"],
  surfaceAccent9: Te.black,
  surfaceAccent10: Te["lavender.500"],
  surfaceRequiredField: Te["yellow.200"],
  surfaceReadonly: Te["gray.400"],
  alertSuccess: Te["green.600"],
  alertError: Te["red.700"],
  alertWarning: Te["yellow.400"],
  alertSuccessLight: Te["green.300"],
  alertErrorLight: Te["red.200"],
  alertWarningLight: Te["orange.100"],
  alertInfoLight: Te["navy.250"],
  // text:
  textPrimary: Te["gray.900"],
  textSecondary: Te["gray.700"],
  textTertiary: Te["gray.650"],
  textOffset: Te.white,
  textDisabled: Te.gray,
  textError: Te["red.700"],
  textSuccess: Te["green.700"],
  textWarning: Te["orange.600"],
  // status:
  statusOverdue: Te["red.400"],
  statusInProgress: Te["yellow.400"],
  statusComplete: Te["green.600"],
  statusWarning: Te["orange.500"],
  // pins:
  pinSold: Te["navy.700"],
  pinPending: Te["pink.500"],
  pinActive: Te["green.600"],
  pinRented: Te["orange.600"],
  pinOffMarket: Te["gray.650"],
  pinOther: Te["gray.900"],
  pinSubject: Te["orange.500"],
  // DEPRECATED
  error: Te["red.700"],
  // TODO: Replace with textError
  success: Te["green.700"],
  // TODO: Replace with textSuccess
  // OTHER:
  aiv: Te["yellow.400"],
  aivLight: Te["yellow.200"],
  aivText: Te["gray.900"],
  arv: Te["green.500"],
  arvLight: Te["green.200"],
  arvText: Te.white,
  transparent: "#00000000",
  // @ts-expect-error hacking our way to not overriding colors
  // eslint-disable-next-line object-shorthand
  undefined: void 0,
  // Quality tiers
  qualityTier1: Te["tiers.1"],
  qualityTier2: Te["tiers.2"],
  qualityTier3: Te["tiers.3"],
  qualityTier4: Te["tiers.4"],
  qualityTier5: Te["tiers.5"],
  qualityTier6: Te["tiers.6"],
  qualityTier7: Te["tiers.7"],
  qualityTier8: Te["tiers.8"],
  qualityTier9: Te["tiers.9"],
  qualityTier10: Te["tiers.10"]
}, Hr = {
  ...Nne,
  ...kne,
  // all these are sorta hacky ways to use existing chakra components but hijacked with aloft colors
  // too tricky to figure out all the component style configs without TS help
  aloft: {
    100: Te["navy.50"]
  },
  green: {
    500: Te["green.600"]
  },
  red: {
    500: Te["red.400"]
  },
  orange: {
    500: Te["yellow.400"]
  },
  blue: {
    500: Te.navy
  }
}, Vne = {
  background: "#FFFFFF",
  backgroundAccent: "#1F364E",
  backgroundAccentDark: "#394D60",
  backgroundAccentLight: "#3C70A7",
  strokeLight: "#EBEDEF",
  surface: "#F0F0F0",
  text: "#072138",
  textLight: "#465C72",
  border: "#E0E0E0",
  borderDark: "#E1E1E1",
  positive: "#008646",
  negative: "#CE161B",
  aivBackground: "#FFD600",
  arvBackground: "#00A67F"
}, UC = {
  Accordion: {
    parts: ["container"],
    baseStyle: {
      container: {
        borderStyle: "solid",
        borderColor: "gray.200"
      }
    }
  }
}, One = {
  ...UC,
  Accordion: {
    ...UC.Accordion,
    variants: {
      default: {
        button: {
          backgroundColor: "surface2"
        }
      }
    }
  }
};
function br(e, t) {
  Fne(e) && (e = "100%");
  var n = Bne(e);
  return e = t === 360 ? e : Math.min(t, Math.max(0, parseFloat(e))), n && (e = parseInt(String(e * t), 10) / 100), Math.abs(e - t) < 1e-6 ? 1 : (t === 360 ? e = (e < 0 ? e % t + t : e % t) / parseFloat(String(t)) : e = e % t / parseFloat(String(t)), e);
}
function Mf(e) {
  return Math.min(1, Math.max(0, e));
}
function Fne(e) {
  return typeof e == "string" && e.indexOf(".") !== -1 && parseFloat(e) === 1;
}
function Bne(e) {
  return typeof e == "string" && e.indexOf("%") !== -1;
}
function Xw(e) {
  return e = parseFloat(e), (isNaN(e) || e < 0 || e > 1) && (e = 1), e;
}
function xf(e) {
  return e <= 1 ? "".concat(Number(e) * 100, "%") : e;
}
function cl(e) {
  return e.length === 1 ? "0" + e : String(e);
}
function Hne(e, t, n) {
  return {
    r: br(e, 255) * 255,
    g: br(t, 255) * 255,
    b: br(n, 255) * 255
  };
}
function XC(e, t, n) {
  e = br(e, 255), t = br(t, 255), n = br(n, 255);
  var r = Math.max(e, t, n), o = Math.min(e, t, n), a = 0, i = 0, l = (r + o) / 2;
  if (r === o)
    i = 0, a = 0;
  else {
    var u = r - o;
    switch (i = l > 0.5 ? u / (2 - r - o) : u / (r + o), r) {
      case e:
        a = (t - n) / u + (t < n ? 6 : 0);
        break;
      case t:
        a = (n - e) / u + 2;
        break;
      case n:
        a = (e - t) / u + 4;
        break;
    }
    a /= 6;
  }
  return { h: a, s: i, l };
}
function Fg(e, t, n) {
  return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? e + (t - e) * (6 * n) : n < 1 / 2 ? t : n < 2 / 3 ? e + (t - e) * (2 / 3 - n) * 6 : e;
}
function Gne(e, t, n) {
  var r, o, a;
  if (e = br(e, 360), t = br(t, 100), n = br(n, 100), t === 0)
    o = n, a = n, r = n;
  else {
    var i = n < 0.5 ? n * (1 + t) : n + t - n * t, l = 2 * n - i;
    r = Fg(l, i, e + 1 / 3), o = Fg(l, i, e), a = Fg(l, i, e - 1 / 3);
  }
  return { r: r * 255, g: o * 255, b: a * 255 };
}
function YC(e, t, n) {
  e = br(e, 255), t = br(t, 255), n = br(n, 255);
  var r = Math.max(e, t, n), o = Math.min(e, t, n), a = 0, i = r, l = r - o, u = r === 0 ? 0 : l / r;
  if (r === o)
    a = 0;
  else {
    switch (r) {
      case e:
        a = (t - n) / l + (t < n ? 6 : 0);
        break;
      case t:
        a = (n - e) / l + 2;
        break;
      case n:
        a = (e - t) / l + 4;
        break;
    }
    a /= 6;
  }
  return { h: a, s: u, v: i };
}
function $ne(e, t, n) {
  e = br(e, 360) * 6, t = br(t, 100), n = br(n, 100);
  var r = Math.floor(e), o = e - r, a = n * (1 - t), i = n * (1 - o * t), l = n * (1 - (1 - o) * t), u = r % 6, d = [n, i, a, a, l, n][u], f = [l, n, n, i, a, a][u], h = [a, a, l, n, n, i][u];
  return { r: d * 255, g: f * 255, b: h * 255 };
}
function qC(e, t, n, r) {
  var o = [
    cl(Math.round(e).toString(16)),
    cl(Math.round(t).toString(16)),
    cl(Math.round(n).toString(16))
  ];
  return r && o[0].startsWith(o[0].charAt(1)) && o[1].startsWith(o[1].charAt(1)) && o[2].startsWith(o[2].charAt(1)) ? o[0].charAt(0) + o[1].charAt(0) + o[2].charAt(0) : o.join("");
}
function Zne(e, t, n, r, o) {
  var a = [
    cl(Math.round(e).toString(16)),
    cl(Math.round(t).toString(16)),
    cl(Math.round(n).toString(16)),
    cl(jne(r))
  ];
  return o && a[0].startsWith(a[0].charAt(1)) && a[1].startsWith(a[1].charAt(1)) && a[2].startsWith(a[2].charAt(1)) && a[3].startsWith(a[3].charAt(1)) ? a[0].charAt(0) + a[1].charAt(0) + a[2].charAt(0) + a[3].charAt(0) : a.join("");
}
function jne(e) {
  return Math.round(parseFloat(e) * 255).toString(16);
}
function JC(e) {
  return yo(e) / 255;
}
function yo(e) {
  return parseInt(e, 16);
}
function Wne(e) {
  return {
    r: e >> 16,
    g: (e & 65280) >> 8,
    b: e & 255
  };
}
var t3 = {
  aliceblue: "#f0f8ff",
  antiquewhite: "#faebd7",
  aqua: "#00ffff",
  aquamarine: "#7fffd4",
  azure: "#f0ffff",
  beige: "#f5f5dc",
  bisque: "#ffe4c4",
  black: "#000000",
  blanchedalmond: "#ffebcd",
  blue: "#0000ff",
  blueviolet: "#8a2be2",
  brown: "#a52a2a",
  burlywood: "#deb887",
  cadetblue: "#5f9ea0",
  chartreuse: "#7fff00",
  chocolate: "#d2691e",
  coral: "#ff7f50",
  cornflowerblue: "#6495ed",
  cornsilk: "#fff8dc",
  crimson: "#dc143c",
  cyan: "#00ffff",
  darkblue: "#00008b",
  darkcyan: "#008b8b",
  darkgoldenrod: "#b8860b",
  darkgray: "#a9a9a9",
  darkgreen: "#006400",
  darkgrey: "#a9a9a9",
  darkkhaki: "#bdb76b",
  darkmagenta: "#8b008b",
  darkolivegreen: "#556b2f",
  darkorange: "#ff8c00",
  darkorchid: "#9932cc",
  darkred: "#8b0000",
  darksalmon: "#e9967a",
  darkseagreen: "#8fbc8f",
  darkslateblue: "#483d8b",
  darkslategray: "#2f4f4f",
  darkslategrey: "#2f4f4f",
  darkturquoise: "#00ced1",
  darkviolet: "#9400d3",
  deeppink: "#ff1493",
  deepskyblue: "#00bfff",
  dimgray: "#696969",
  dimgrey: "#696969",
  dodgerblue: "#1e90ff",
  firebrick: "#b22222",
  floralwhite: "#fffaf0",
  forestgreen: "#228b22",
  fuchsia: "#ff00ff",
  gainsboro: "#dcdcdc",
  ghostwhite: "#f8f8ff",
  goldenrod: "#daa520",
  gold: "#ffd700",
  gray: "#808080",
  green: "#008000",
  greenyellow: "#adff2f",
  grey: "#808080",
  honeydew: "#f0fff0",
  hotpink: "#ff69b4",
  indianred: "#cd5c5c",
  indigo: "#4b0082",
  ivory: "#fffff0",
  khaki: "#f0e68c",
  lavenderblush: "#fff0f5",
  lavender: "#e6e6fa",
  lawngreen: "#7cfc00",
  lemonchiffon: "#fffacd",
  lightblue: "#add8e6",
  lightcoral: "#f08080",
  lightcyan: "#e0ffff",
  lightgoldenrodyellow: "#fafad2",
  lightgray: "#d3d3d3",
  lightgreen: "#90ee90",
  lightgrey: "#d3d3d3",
  lightpink: "#ffb6c1",
  lightsalmon: "#ffa07a",
  lightseagreen: "#20b2aa",
  lightskyblue: "#87cefa",
  lightslategray: "#778899",
  lightslategrey: "#778899",
  lightsteelblue: "#b0c4de",
  lightyellow: "#ffffe0",
  lime: "#00ff00",
  limegreen: "#32cd32",
  linen: "#faf0e6",
  magenta: "#ff00ff",
  maroon: "#800000",
  mediumaquamarine: "#66cdaa",
  mediumblue: "#0000cd",
  mediumorchid: "#ba55d3",
  mediumpurple: "#9370db",
  mediumseagreen: "#3cb371",
  mediumslateblue: "#7b68ee",
  mediumspringgreen: "#00fa9a",
  mediumturquoise: "#48d1cc",
  mediumvioletred: "#c71585",
  midnightblue: "#191970",
  mintcream: "#f5fffa",
  mistyrose: "#ffe4e1",
  moccasin: "#ffe4b5",
  navajowhite: "#ffdead",
  navy: "#000080",
  oldlace: "#fdf5e6",
  olive: "#808000",
  olivedrab: "#6b8e23",
  orange: "#ffa500",
  orangered: "#ff4500",
  orchid: "#da70d6",
  palegoldenrod: "#eee8aa",
  palegreen: "#98fb98",
  paleturquoise: "#afeeee",
  palevioletred: "#db7093",
  papayawhip: "#ffefd5",
  peachpuff: "#ffdab9",
  peru: "#cd853f",
  pink: "#ffc0cb",
  plum: "#dda0dd",
  powderblue: "#b0e0e6",
  purple: "#800080",
  rebeccapurple: "#663399",
  red: "#ff0000",
  rosybrown: "#bc8f8f",
  royalblue: "#4169e1",
  saddlebrown: "#8b4513",
  salmon: "#fa8072",
  sandybrown: "#f4a460",
  seagreen: "#2e8b57",
  seashell: "#fff5ee",
  sienna: "#a0522d",
  silver: "#c0c0c0",
  skyblue: "#87ceeb",
  slateblue: "#6a5acd",
  slategray: "#708090",
  slategrey: "#708090",
  snow: "#fffafa",
  springgreen: "#00ff7f",
  steelblue: "#4682b4",
  tan: "#d2b48c",
  teal: "#008080",
  thistle: "#d8bfd8",
  tomato: "#ff6347",
  turquoise: "#40e0d0",
  violet: "#ee82ee",
  wheat: "#f5deb3",
  white: "#ffffff",
  whitesmoke: "#f5f5f5",
  yellow: "#ffff00",
  yellowgreen: "#9acd32"
};
function zne(e) {
  var t = { r: 0, g: 0, b: 0 }, n = 1, r = null, o = null, a = null, i = !1, l = !1;
  return typeof e == "string" && (e = Yne(e)), typeof e == "object" && (si(e.r) && si(e.g) && si(e.b) ? (t = Hne(e.r, e.g, e.b), i = !0, l = String(e.r).substr(-1) === "%" ? "prgb" : "rgb") : si(e.h) && si(e.s) && si(e.v) ? (r = xf(e.s), o = xf(e.v), t = $ne(e.h, r, o), i = !0, l = "hsv") : si(e.h) && si(e.s) && si(e.l) && (r = xf(e.s), a = xf(e.l), t = Gne(e.h, r, a), i = !0, l = "hsl"), Object.prototype.hasOwnProperty.call(e, "a") && (n = e.a)), n = Xw(n), {
    ok: i,
    format: e.format || l,
    r: Math.min(255, Math.max(t.r, 0)),
    g: Math.min(255, Math.max(t.g, 0)),
    b: Math.min(255, Math.max(t.b, 0)),
    a: n
  };
}
var Une = "[-\\+]?\\d+%?", Xne = "[-\\+]?\\d*\\.\\d+%?", hs = "(?:".concat(Xne, ")|(?:").concat(Une, ")"), Bg = "[\\s|\\(]+(".concat(hs, ")[,|\\s]+(").concat(hs, ")[,|\\s]+(").concat(hs, ")\\s*\\)?"), Hg = "[\\s|\\(]+(".concat(hs, ")[,|\\s]+(").concat(hs, ")[,|\\s]+(").concat(hs, ")[,|\\s]+(").concat(hs, ")\\s*\\)?"), ma = {
  CSS_UNIT: new RegExp(hs),
  rgb: new RegExp("rgb" + Bg),
  rgba: new RegExp("rgba" + Hg),
  hsl: new RegExp("hsl" + Bg),
  hsla: new RegExp("hsla" + Hg),
  hsv: new RegExp("hsv" + Bg),
  hsva: new RegExp("hsva" + Hg),
  hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
  hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
  hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
  hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
};
function Yne(e) {
  if (e = e.trim().toLowerCase(), e.length === 0)
    return !1;
  var t = !1;
  if (t3[e])
    e = t3[e], t = !0;
  else if (e === "transparent")
    return { r: 0, g: 0, b: 0, a: 0, format: "name" };
  var n = ma.rgb.exec(e);
  return n ? { r: n[1], g: n[2], b: n[3] } : (n = ma.rgba.exec(e), n ? { r: n[1], g: n[2], b: n[3], a: n[4] } : (n = ma.hsl.exec(e), n ? { h: n[1], s: n[2], l: n[3] } : (n = ma.hsla.exec(e), n ? { h: n[1], s: n[2], l: n[3], a: n[4] } : (n = ma.hsv.exec(e), n ? { h: n[1], s: n[2], v: n[3] } : (n = ma.hsva.exec(e), n ? { h: n[1], s: n[2], v: n[3], a: n[4] } : (n = ma.hex8.exec(e), n ? {
    r: yo(n[1]),
    g: yo(n[2]),
    b: yo(n[3]),
    a: JC(n[4]),
    format: t ? "name" : "hex8"
  } : (n = ma.hex6.exec(e), n ? {
    r: yo(n[1]),
    g: yo(n[2]),
    b: yo(n[3]),
    format: t ? "name" : "hex"
  } : (n = ma.hex4.exec(e), n ? {
    r: yo(n[1] + n[1]),
    g: yo(n[2] + n[2]),
    b: yo(n[3] + n[3]),
    a: JC(n[4] + n[4]),
    format: t ? "name" : "hex8"
  } : (n = ma.hex3.exec(e), n ? {
    r: yo(n[1] + n[1]),
    g: yo(n[2] + n[2]),
    b: yo(n[3] + n[3]),
    format: t ? "name" : "hex"
  } : !1)))))))));
}
function si(e) {
  return !!ma.CSS_UNIT.exec(String(e));
}
var Wh = (
  /** @class */
  function() {
    function e(t, n) {
      t === void 0 && (t = ""), n === void 0 && (n = {});
      var r;
      if (t instanceof e)
        return t;
      typeof t == "number" && (t = Wne(t)), this.originalInput = t;
      var o = zne(t);
      this.originalInput = t, this.r = o.r, this.g = o.g, this.b = o.b, this.a = o.a, this.roundA = Math.round(100 * this.a) / 100, this.format = (r = n.format) !== null && r !== void 0 ? r : o.format, this.gradientType = n.gradientType, this.r < 1 && (this.r = Math.round(this.r)), this.g < 1 && (this.g = Math.round(this.g)), this.b < 1 && (this.b = Math.round(this.b)), this.isValid = o.ok;
    }
    return e.prototype.isDark = function() {
      return this.getBrightness() < 128;
    }, e.prototype.isLight = function() {
      return !this.isDark();
    }, e.prototype.getBrightness = function() {
      var t = this.toRgb();
      return (t.r * 299 + t.g * 587 + t.b * 114) / 1e3;
    }, e.prototype.getLuminance = function() {
      var t = this.toRgb(), n, r, o, a = t.r / 255, i = t.g / 255, l = t.b / 255;
      return a <= 0.03928 ? n = a / 12.92 : n = Math.pow((a + 0.055) / 1.055, 2.4), i <= 0.03928 ? r = i / 12.92 : r = Math.pow((i + 0.055) / 1.055, 2.4), l <= 0.03928 ? o = l / 12.92 : o = Math.pow((l + 0.055) / 1.055, 2.4), 0.2126 * n + 0.7152 * r + 0.0722 * o;
    }, e.prototype.getAlpha = function() {
      return this.a;
    }, e.prototype.setAlpha = function(t) {
      return this.a = Xw(t), this.roundA = Math.round(100 * this.a) / 100, this;
    }, e.prototype.isMonochrome = function() {
      var t = this.toHsl().s;
      return t === 0;
    }, e.prototype.toHsv = function() {
      var t = YC(this.r, this.g, this.b);
      return { h: t.h * 360, s: t.s, v: t.v, a: this.a };
    }, e.prototype.toHsvString = function() {
      var t = YC(this.r, this.g, this.b), n = Math.round(t.h * 360), r = Math.round(t.s * 100), o = Math.round(t.v * 100);
      return this.a === 1 ? "hsv(".concat(n, ", ").concat(r, "%, ").concat(o, "%)") : "hsva(".concat(n, ", ").concat(r, "%, ").concat(o, "%, ").concat(this.roundA, ")");
    }, e.prototype.toHsl = function() {
      var t = XC(this.r, this.g, this.b);
      return { h: t.h * 360, s: t.s, l: t.l, a: this.a };
    }, e.prototype.toHslString = function() {
      var t = XC(this.r, this.g, this.b), n = Math.round(t.h * 360), r = Math.round(t.s * 100), o = Math.round(t.l * 100);
      return this.a === 1 ? "hsl(".concat(n, ", ").concat(r, "%, ").concat(o, "%)") : "hsla(".concat(n, ", ").concat(r, "%, ").concat(o, "%, ").concat(this.roundA, ")");
    }, e.prototype.toHex = function(t) {
      return t === void 0 && (t = !1), qC(this.r, this.g, this.b, t);
    }, e.prototype.toHexString = function(t) {
      return t === void 0 && (t = !1), "#" + this.toHex(t);
    }, e.prototype.toHex8 = function(t) {
      return t === void 0 && (t = !1), Zne(this.r, this.g, this.b, this.a, t);
    }, e.prototype.toHex8String = function(t) {
      return t === void 0 && (t = !1), "#" + this.toHex8(t);
    }, e.prototype.toHexShortString = function(t) {
      return t === void 0 && (t = !1), this.a === 1 ? this.toHexString(t) : this.toHex8String(t);
    }, e.prototype.toRgb = function() {
      return {
        r: Math.round(this.r),
        g: Math.round(this.g),
        b: Math.round(this.b),
        a: this.a
      };
    }, e.prototype.toRgbString = function() {
      var t = Math.round(this.r), n = Math.round(this.g), r = Math.round(this.b);
      return this.a === 1 ? "rgb(".concat(t, ", ").concat(n, ", ").concat(r, ")") : "rgba(".concat(t, ", ").concat(n, ", ").concat(r, ", ").concat(this.roundA, ")");
    }, e.prototype.toPercentageRgb = function() {
      var t = function(n) {
        return "".concat(Math.round(br(n, 255) * 100), "%");
      };
      return {
        r: t(this.r),
        g: t(this.g),
        b: t(this.b),
        a: this.a
      };
    }, e.prototype.toPercentageRgbString = function() {
      var t = function(n) {
        return Math.round(br(n, 255) * 100);
      };
      return this.a === 1 ? "rgb(".concat(t(this.r), "%, ").concat(t(this.g), "%, ").concat(t(this.b), "%)") : "rgba(".concat(t(this.r), "%, ").concat(t(this.g), "%, ").concat(t(this.b), "%, ").concat(this.roundA, ")");
    }, e.prototype.toName = function() {
      if (this.a === 0)
        return "transparent";
      if (this.a < 1)
        return !1;
      for (var t = "#" + qC(this.r, this.g, this.b, !1), n = 0, r = Object.entries(t3); n < r.length; n++) {
        var o = r[n], a = o[0], i = o[1];
        if (t === i)
          return a;
      }
      return !1;
    }, e.prototype.toString = function(t) {
      var n = !!t;
      t = t ?? this.format;
      var r = !1, o = this.a < 1 && this.a >= 0, a = !n && o && (t.startsWith("hex") || t === "name");
      return a ? t === "name" && this.a === 0 ? this.toName() : this.toRgbString() : (t === "rgb" && (r = this.toRgbString()), t === "prgb" && (r = this.toPercentageRgbString()), (t === "hex" || t === "hex6") && (r = this.toHexString()), t === "hex3" && (r = this.toHexString(!0)), t === "hex4" && (r = this.toHex8String(!0)), t === "hex8" && (r = this.toHex8String()), t === "name" && (r = this.toName()), t === "hsl" && (r = this.toHslString()), t === "hsv" && (r = this.toHsvString()), r || this.toHexString());
    }, e.prototype.toNumber = function() {
      return (Math.round(this.r) << 16) + (Math.round(this.g) << 8) + Math.round(this.b);
    }, e.prototype.clone = function() {
      return new e(this.toString());
    }, e.prototype.lighten = function(t) {
      t === void 0 && (t = 10);
      var n = this.toHsl();
      return n.l += t / 100, n.l = Mf(n.l), new e(n);
    }, e.prototype.brighten = function(t) {
      t === void 0 && (t = 10);
      var n = this.toRgb();
      return n.r = Math.max(0, Math.min(255, n.r - Math.round(255 * -(t / 100)))), n.g = Math.max(0, Math.min(255, n.g - Math.round(255 * -(t / 100)))), n.b = Math.max(0, Math.min(255, n.b - Math.round(255 * -(t / 100)))), new e(n);
    }, e.prototype.darken = function(t) {
      t === void 0 && (t = 10);
      var n = this.toHsl();
      return n.l -= t / 100, n.l = Mf(n.l), new e(n);
    }, e.prototype.tint = function(t) {
      return t === void 0 && (t = 10), this.mix("white", t);
    }, e.prototype.shade = function(t) {
      return t === void 0 && (t = 10), this.mix("black", t);
    }, e.prototype.desaturate = function(t) {
      t === void 0 && (t = 10);
      var n = this.toHsl();
      return n.s -= t / 100, n.s = Mf(n.s), new e(n);
    }, e.prototype.saturate = function(t) {
      t === void 0 && (t = 10);
      var n = this.toHsl();
      return n.s += t / 100, n.s = Mf(n.s), new e(n);
    }, e.prototype.greyscale = function() {
      return this.desaturate(100);
    }, e.prototype.spin = function(t) {
      var n = this.toHsl(), r = (n.h + t) % 360;
      return n.h = r < 0 ? 360 + r : r, new e(n);
    }, e.prototype.mix = function(t, n) {
      n === void 0 && (n = 50);
      var r = this.toRgb(), o = new e(t).toRgb(), a = n / 100, i = {
        r: (o.r - r.r) * a + r.r,
        g: (o.g - r.g) * a + r.g,
        b: (o.b - r.b) * a + r.b,
        a: (o.a - r.a) * a + r.a
      };
      return new e(i);
    }, e.prototype.analogous = function(t, n) {
      t === void 0 && (t = 6), n === void 0 && (n = 30);
      var r = this.toHsl(), o = 360 / n, a = [this];
      for (r.h = (r.h - (o * t >> 1) + 720) % 360; --t; )
        r.h = (r.h + o) % 360, a.push(new e(r));
      return a;
    }, e.prototype.complement = function() {
      var t = this.toHsl();
      return t.h = (t.h + 180) % 360, new e(t);
    }, e.prototype.monochromatic = function(t) {
      t === void 0 && (t = 6);
      for (var n = this.toHsv(), r = n.h, o = n.s, a = n.v, i = [], l = 1 / t; t--; )
        i.push(new e({ h: r, s: o, v: a })), a = (a + l) % 1;
      return i;
    }, e.prototype.splitcomplement = function() {
      var t = this.toHsl(), n = t.h;
      return [
        this,
        new e({ h: (n + 72) % 360, s: t.s, l: t.l }),
        new e({ h: (n + 216) % 360, s: t.s, l: t.l })
      ];
    }, e.prototype.onBackground = function(t) {
      var n = this.toRgb(), r = new e(t).toRgb(), o = n.a + r.a * (1 - n.a);
      return new e({
        r: (n.r * n.a + r.r * r.a * (1 - n.a)) / o,
        g: (n.g * n.a + r.g * r.a * (1 - n.a)) / o,
        b: (n.b * n.a + r.b * r.a * (1 - n.a)) / o,
        a: o
      });
    }, e.prototype.triad = function() {
      return this.polyad(3);
    }, e.prototype.tetrad = function() {
      return this.polyad(4);
    }, e.prototype.polyad = function(t) {
      for (var n = this.toHsl(), r = n.h, o = [this], a = 360 / t, i = 1; i < t; i++)
        o.push(new e({ h: (r + i * a) % 360, s: n.s, l: n.l }));
      return o;
    }, e.prototype.equals = function(t) {
      return this.toRgbString() === new e(t).toRgbString();
    }, e;
  }()
);
function qne(e) {
  return Array.isArray(e);
}
function Jne(e) {
  var t = typeof e;
  return e != null && (t === "object" || t === "function") && !qne(e);
}
process.env.NODE_ENV;
process.env.NODE_ENV;
function Kne(e, t, n, r) {
  var o = typeof t == "string" ? t.split(".") : [t];
  for (r = 0; r < o.length && e; r += 1)
    e = e[o[r]];
  return e === void 0 ? n : e;
}
var Qne = function(t) {
  var n = /* @__PURE__ */ new WeakMap(), r = function(a, i, l, u) {
    if (typeof a > "u")
      return t(a, i, l);
    n.has(a) || n.set(a, /* @__PURE__ */ new Map());
    var d = n.get(a);
    if (d.has(i))
      return d.get(i);
    var f = t(a, i, l, u);
    return d.set(i, f), f;
  };
  return r;
}, ere = Qne(Kne), p9 = function(t, n, r) {
  var o = ere(t, "colors." + n, n), a = new Wh(o), i = a.isValid;
  return i ? o : r;
}, _n = function(t, n) {
  return function(r) {
    var o = p9(r, t);
    return new Wh(o).setAlpha(n).toRgbString();
  };
}, pa = function(t, n) {
  return function(r) {
    var o = p9(r, t);
    return new Wh(o).darken(n).toHexString();
  };
}, Gg = function(t, n) {
  return function(r) {
    return new Wh(p9(r, t)).lighten(n).toHexString();
  };
};
function Yw(e) {
  return Jne(e) && e.reference ? e.reference : String(e);
}
var zh = function(t) {
  for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), o = 1; o < n; o++)
    r[o - 1] = arguments[o];
  return r.map(Yw).join(" " + t + " ").replace(/calc/g, "");
}, KC = function() {
  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
    n[r] = arguments[r];
  return "calc(" + zh.apply(void 0, ["+"].concat(n)) + ")";
}, QC = function() {
  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
    n[r] = arguments[r];
  return "calc(" + zh.apply(void 0, ["-"].concat(n)) + ")";
}, n3 = function() {
  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
    n[r] = arguments[r];
  return "calc(" + zh.apply(void 0, ["*"].concat(n)) + ")";
}, eb = function() {
  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
    n[r] = arguments[r];
  return "calc(" + zh.apply(void 0, ["/"].concat(n)) + ")";
}, tb = function(t) {
  var n = Yw(t);
  return n != null && !Number.isNaN(parseFloat(n)) ? String(n).startsWith("-") ? String(n).slice(1) : "-" + n : n3(n, -1);
}, p1 = Object.assign(function(e) {
  return {
    add: function() {
      for (var n = arguments.length, r = new Array(n), o = 0; o < n; o++)
        r[o] = arguments[o];
      return p1(KC.apply(void 0, [e].concat(r)));
    },
    subtract: function() {
      for (var n = arguments.length, r = new Array(n), o = 0; o < n; o++)
        r[o] = arguments[o];
      return p1(QC.apply(void 0, [e].concat(r)));
    },
    multiply: function() {
      for (var n = arguments.length, r = new Array(n), o = 0; o < n; o++)
        r[o] = arguments[o];
      return p1(n3.apply(void 0, [e].concat(r)));
    },
    divide: function() {
      for (var n = arguments.length, r = new Array(n), o = 0; o < n; o++)
        r[o] = arguments[o];
      return p1(eb.apply(void 0, [e].concat(r)));
    },
    negate: function() {
      return p1(tb(e));
    },
    toString: function() {
      return e.toString();
    }
  };
}, {
  add: KC,
  subtract: QC,
  multiply: n3,
  divide: eb,
  negate: tb
});
const L2 = {
  Button: {
    // nope -- use SoundUI
    // baseStyle: {
    //     borderRadius: 'sm',
    //     _focus: {
    //         boxShadow: 'none',
    //     },
    // },
    variants: {
      filled: {
        color: "white",
        backgroundColor: "primary",
        _hover: {
          backgroundColor: pa("primary", 10),
          _disabled: {
            backgroundColor: "disabled"
          }
        },
        _focus: {
          backgroundColor: pa("primary", 10)
        },
        _active: {
          backgroundColor: pa("primary", 20)
        },
        _disabled: {
          backgroundColor: "disabled",
          color: pa("disabled", 50)
        }
      },
      outline: {
        color: "primary",
        backgroundColor: "transparent",
        borderColor: "border",
        borderWidth: "1px",
        borderStyle: "solid",
        _hover: {
          backgroundColor: Gg("primary", 35)
        },
        _focus: {
          backgroundColor: Gg("primary", 35)
        },
        _active: {
          backgroundColor: Gg("primary", 30)
        },
        _disabled: {
          color: pa("disabled", 50)
        }
      },
      danger: {
        backgroundColor: "danger",
        color: "white",
        _hover: {
          backgroundColor: pa("danger", 10),
          _disabled: {
            backgroundColor: "danger"
          }
        },
        _focus: {
          backgroundColor: pa("danger", 10)
        },
        _active: {
          backgroundColor: pa("danger", 20)
        }
      }
    },
    defaultProps: {
      variant: "filled"
    }
  }
}, nb = {
  color: "buttonDefault",
  _hover: {
    color: "buttonHover",
    textDecoration: "underline"
  },
  _focus: {
    color: "buttonHover",
    textDecoration: "underline"
  },
  _active: {
    color: "buttonActive",
    textDecoration: "underline"
  }
}, En = {
  Text: {
    variants: {
      link: nb,
      // headings
      h1: {
        fontSize: "1.5rem",
        fontWeight: "800",
        color: "textPrimary"
      },
      h2: {
        fontSize: "1.25rem",
        fontWeight: "700",
        color: "textPrimary"
      },
      h3: {
        fontSize: "1rem",
        fontWeight: "700",
        color: "textPrimary"
      },
      h4: {
        fontSize: "0.875rem",
        fontWeight: "700",
        color: "textPrimary"
      },
      h5: {
        fontSize: "0.75rem",
        fontWeight: "700",
        color: "textPrimary"
      },
      // bodies 🪦
      body1: {
        fontSize: "0.875rem",
        fontWeight: "400",
        color: "textPrimary",
        maxWidth: "40rem"
        // roughly 100 characters; no super wide lines please
      },
      body2: {
        fontSize: "0.75rem",
        fontWeight: "400",
        color: "textPrimary",
        maxWidth: "40rem"
        // roughly 110 characters; no super wide lines please
      },
      // placeholder
      placeholder: {
        fontSize: "0.875rem",
        fontWeight: "400",
        color: "textTertiary",
        fontStyle: "italic"
      },
      // subtitles
      subtitle1: {
        fontSize: "0.75rem",
        fontWeight: "600",
        color: "textSecondary",
        textTransform: "uppercase"
      },
      subtitle2: {
        fontSize: "0.625rem",
        fontWeight: "600",
        color: "textPrimary",
        textTransform: "uppercase"
      },
      subtitle3: {
        fontSize: "0.625rem",
        fontWeight: "600",
        color: "textSecondary"
      },
      // buttons and chips
      chip: {
        fontSize: "0.75rem",
        fontWeight: "600",
        color: "textPrimary"
      },
      buttonSmall: {
        fontSize: "0.75rem",
        fontWeight: "800",
        color: "typography.white"
      },
      buttonRegular: {
        fontSize: "0.875rem",
        fontWeight: "700",
        color: "typography.white"
      },
      // tables
      tableColumnTitle: {
        fontSize: "0.875rem",
        fontWeight: "700",
        color: "textPrimary"
      },
      tableH1: {
        fontSize: "0.75rem",
        fontWeight: "700",
        color: "textSecondary"
      },
      tableH2: {
        fontSize: "0.75rem",
        fontWeight: "500",
        color: "typography.black"
      },
      tableH3: {
        fontSize: "0.625rem",
        fontWeight: "600",
        color: "textPrimary",
        textTransform: "uppercase"
      },
      tableTag: {
        fontSize: "0.375rem",
        fontWeight: "800",
        color: "textPrimary"
      },
      // displays
      displayLarge: {
        fontSize: "3.75rem",
        fontWeight: "700",
        color: "textPrimary"
      },
      displayMedium: {
        fontSize: "2.75rem",
        fontWeight: "700",
        color: "textPrimary"
      },
      displaySmall: {
        fontSize: "1.75rem",
        fontWeight: "700",
        color: "textPrimary"
      },
      label: {
        fontSize: "1rem",
        fontWeight: "700",
        color: "textPrimary"
      }
    }
  },
  Link: {
    variants: {
      default: nb,
      unstyled: {}
    }
  }
}, tre = {
  color: "textOffset",
  backgroundColor: "buttonDefault",
  _hover: {
    color: "textOffset",
    backgroundColor: "buttonHover",
    _disabled: {
      backgroundColor: _n("buttonHover", 0.5)
    }
  },
  _focus: {
    color: "textOffset",
    backgroundColor: "buttonHover"
  },
  _active: {
    color: "textOffset",
    backgroundColor: "buttonActive"
  },
  _disabled: {
    color: "textOffset",
    backgroundColor: _n("buttonDefault", 0.5)
  }
}, nre = {
  backgroundColor: "surface1",
  border: "1px solid",
  color: "buttonDefault",
  borderColor: "buttonDefault",
  _hover: {
    color: "buttonHover",
    borderColor: "buttonHover",
    backgroundColor: "surface1",
    _disabled: {
      backgroundColor: _n("surface1", 0.5)
    }
  },
  _focus: {
    color: "buttonHover",
    borderColor: "buttonHover",
    backgroundColor: "surface1"
  },
  _active: {
    color: "buttonActive",
    borderColor: "buttonActive",
    backgroundColor: "surface1"
  },
  _disabled: {
    backgroundColor: _n("surface1", 0.5),
    color: _n("buttonDefault", 0.5),
    borderColor: _n("buttonDefault", 0.5)
  }
}, rb = {
  backgroundColor: "textTertiary",
  border: "1px solid",
  borderColor: "strokeDefault",
  color: "textOffset",
  _hover: {
    backgroundColor: "textSecondary",
    borderColor: "strokeHover",
    _disabled: {
      backgroundColor: _n("strokeHover", 0.5),
      color: _n("textPrimary", 0.5)
    }
  },
  _focus: {
    backgroundColor: "strokeHover",
    borderColor: "strokeHover"
  },
  _active: {
    backgroundColor: "strokeActive",
    borderColor: "strokeActive"
  },
  _disabled: {
    backgroundColor: _n("textTertiary", 0.5),
    borderColor: _n("strokeDefault", 0.5),
    color: _n("textOffset", 0.5)
  }
}, rre = {
  backgroundColor: "strokeDefault",
  border: "1px solid",
  borderColor: "strokeDefault",
  color: "textPrimary",
  _hover: {
    backgroundColor: "strokeHover",
    borderColor: "strokeHover",
    _disabled: {
      backgroundColor: _n("strokeHover", 0.5),
      color: _n("textPrimary", 0.5)
    }
  },
  _focus: {
    backgroundColor: "strokeHover",
    borderColor: "strokeHover"
  },
  _active: {
    backgroundColor: "strokeActive",
    borderColor: "strokeActive"
  },
  _disabled: {
    backgroundColor: _n("strokeDefault", 0.5),
    borderColor: _n("strokeDefault", 0.5),
    color: _n("textPrimary", 0.5)
  }
};
var Xy, Yy, qy, Jy, Ky, Qy;
const ore = {
  Button: {
    baseStyle: {
      borderRadius: "4px"
    },
    variants: {
      ...L2.Button.variants,
      primary: tre,
      danger: {
        color: "textOffset",
        backgroundColor: "error",
        _hover: {
          backgroundColor: pa("error", 5),
          _disabled: {
            backgroundColor: _n("error", 0.6)
          }
        },
        _focus: {
          backgroundColor: pa("error", 10)
        },
        _active: {
          backgroundColor: pa("error", 15)
        },
        _disabled: {
          backgroundColor: _n("error", 0.5)
        }
      },
      secondary: nre,
      quarternary: rb,
      inline: {
        padding: "inlineButtonPadding",
        color: "buttonDefault",
        _hover: {
          color: "buttonHover",
          textDecoration: "underline",
          textUnderlineOffset: "2px",
          _disabled: {
            color: _n("buttonHover", 0.5)
          }
        },
        _focus: {
          color: "buttonHover"
        },
        _active: {
          color: "buttonActive"
        },
        _disabled: {
          color: _n("buttonDefault", 0.5)
        }
      },
      nav: {
        backgroundColor: "transparent",
        padding: "navButtonPadding",
        color: "buttonDefault",
        _hover: {
          color: "buttonHover",
          backgroundColor: "transparent",
          _disabled: {
            backgroundColor: _n("navBackgroundHover", 0.5)
          }
        },
        _focus: {
          color: "buttonHover",
          backgroundColor: "transparent"
        },
        _active: {
          color: "buttonActive",
          backgroundColor: "transparent"
        },
        _disabled: {
          color: _n("buttonDefault", 0.5)
        }
      },
      tertiary: {
        color: "strokeDefault",
        _hover: {
          color: "strokeHover",
          backgroundColor: _n("strokeHover", 0.1),
          _disabled: {
            backgroundColor: _n("strokeHover", 0.5)
          }
        },
        _focus: {
          color: "strokeHover"
        },
        _active: {
          color: "strokeActive"
        },
        _disabled: {
          color: _n("strokeHover", 0.5)
        }
      },
      lowContrast: rre
    },
    sizes: {
      sm: {
        ...(Yy = (Xy = En == null ? void 0 : En.Text) == null ? void 0 : Xy.variants) == null ? void 0 : Yy.buttonSmall,
        px: "12px",
        py: "4px",
        height: "22px"
      },
      md: {
        ...(Jy = (qy = En == null ? void 0 : En.Text) == null ? void 0 : qy.variants) == null ? void 0 : Jy.buttonRegular,
        px: "40px",
        py: "10px"
      },
      lg: {
        ...(Qy = (Ky = En == null ? void 0 : En.Text) == null ? void 0 : Ky.variants) == null ? void 0 : Qy.buttonRegular,
        px: "40px",
        py: "10px"
      }
    },
    defaultProps: {
      ...L2.Button.defaultProps
    }
  },
  IconButton: {
    sizes: {
      xs: {
        padding: "0rem"
      },
      sm: {
        padding: ".25rem"
      },
      md: {
        padding: ".5rem"
      },
      lg: {
        padding: ".75rem"
      }
    },
    variants: {
      quarternary: rb
    }
  }
};
var eS, tS, nS, rS;
const are = {
  Checkbox: {
    baseStyle: {
      control: {
        borderColor: "strokeInteractive",
        _checked: {
          borderColor: "selected2",
          backgroundColor: "selected2",
          _before: {
            content: '""',
            display: "inline-block",
            pos: "relative",
            borderWidth: 0,
            bg: "selected2"
          },
          _hover: {
            background: "hover2"
          }
        },
        _hover: {
          background: "hover2"
        }
      }
    },
    variants: {
      boxed: {
        container: {
          marginBottom: ".5rem",
          borderWidth: "1px",
          borderColor: "strokeDefault",
          padding: ".5rem",
          width: "100%"
        }
      }
    },
    sizes: {
      sm: {
        control: {
          width: "12px",
          height: "12px",
          borderWidth: 1.5
        },
        label: {
          ...(tS = (eS = En == null ? void 0 : En.Text) == null ? void 0 : eS.variants) == null ? void 0 : tS.h4,
          marginInlineStart: "10px"
        },
        container: {
          marginBottom: "8px"
        }
      },
      lg: {
        control: {
          width: "18px",
          height: "18px",
          borderWidth: 2
        },
        label: {
          ...(rS = (nS = En == null ? void 0 : En.Text) == null ? void 0 : nS.variants) == null ? void 0 : rS.h4,
          marginInlineStart: "10px"
        },
        container: {
          marginBottom: "10px"
        }
      }
    }
  }
}, ire = {
  FormLabel: {
    baseStyle: {
      fontSize: "sm",
      color: "inputLabelText"
    }
  }
}, sre = {
  ...ire,
  FormLabel: {
    baseStyle: {
      color: "typography.tertiary",
      fontWeight: "bold",
      fontSize: "md"
    }
  },
  FormError: {
    parts: ["text"],
    baseStyle: {
      text: {
        ...En.Text.variants.body2,
        color: "typography.danger"
      }
    }
  },
  Form: {
    parts: ["helperText"],
    baseStyle: {
      helperText: {
        ...En.Text.variants.body1,
        color: "typography.tertiary"
      }
    }
  }
}, r3 = {
  outline: {
    borderRadius: "4px",
    borderColor: "strokeDefault",
    backgroundColor: "surface1",
    _hover: {
      borderColor: "strokeHover"
    },
    _invalid: {
      borderColor: "error"
    },
    _selected: {
      borderColor: "selected2"
    },
    _focusVisible: {
      borderColor: "selected2",
      boxShadow: "0 0 0 1px var(--chakra-colors-selected2)",
      // transparent outline doesn't show in any case except Windows with high-contrast theme enabled
      // in this case, boxShadow is _disabled_, and windows overrides 'transparent' with a new value
      outlineColor: "transparent",
      outlineWidth: "1px",
      outlineStyle: "dotted"
    }
  }
}, lre = {
  Input: {
    variants: {
      outline: {
        field: {
          borderRadius: "sm",
          borderColor: "border",
          _focus: {
            borderColor: "primary",
            _invalid: {
              borderColor: "danger"
            }
          },
          _invalid: {
            borderColor: "danger"
          }
        }
      }
    }
  }
}, ure = {
  Input: {
    variants: {
      ...lre.Input.variants,
      outline: {
        field: r3.outline
      },
      ghost: {
        border: "none",
        backgroundColor: "surface3",
        _focus: {
          border: "none"
        },
        _disabled: {
          backgroundColor: "none"
        }
      }
    },
    defaultProps: {
      variant: "outline"
    },
    sizes: {
      xs: {
        field: {
          height: "1.5rem"
        }
      },
      sm: {
        field: {
          height: "2rem"
        }
      },
      md: {
        field: {
          height: "2.75rem"
        }
      },
      lg: {
        field: {
          height: "3rem"
        }
      }
    }
  },
  Textarea: {
    variants: {
      outline: r3.outline
    },
    defaultProps: {
      variant: "outline"
    }
  }
}, qw = {
  hide: -1,
  auto: "auto",
  base: 0,
  docked: 10,
  dropdown: 500,
  sticky: 600,
  banner: 700,
  overlay: 800,
  modal: 900,
  popover: 950,
  skipLink: 1600,
  toast: 1700,
  tooltip: 1800
}, { definePartsStyle: cre } = vn(OS.keys), dre = {
  Popover: {
    baseStyle: {
      popper: {
        zIndex: "popover"
      }
    },
    variants: {
      inline: cre({
        popper: { zIndex: qw.base + 1 }
      })
    }
  }
};
var oS, aS, iS, sS;
const fre = {
  RadioGroup: {
    baseStyle: {
      backgroundColor: "red"
    }
  },
  Radio: {
    parts: ["control"],
    baseStyle: {
      control: {
        borderColor: "strokeInteractive",
        _checked: {
          borderColor: "selected2",
          background: "none",
          _before: {
            content: '""',
            display: "inline-block",
            pos: "relative",
            borderWidth: 0,
            bg: "selected2"
          },
          _hover: {
            background: "hover2"
          }
        },
        _hover: {
          background: "hover2"
        },
        _disabled: {
          _checked: {
            _before: {
              bg: "selected1"
            }
          }
        }
      }
    },
    variants: {
      __dangerDoNotUseCheckmarks: {
        control: {
          position: "relative",
          borderColor: "none",
          background: "white",
          _before: {
            position: "absolute",
            top: "-2px",
            content: '""',
            transform: "rotate(45deg)",
            height: "1rem",
            width: ".5rem",
            borderRadius: "0px",
            borderBottomWidth: "3px",
            borderBottomStyle: "solid",
            borderBottomColor: "selected1",
            borderRightWidth: "3px",
            borderRightStyle: "solid",
            borderRightColor: "selected1"
          },
          _checked: {
            borderColor: "none",
            background: "white",
            _before: {
              content: '""',
              height: "1rem",
              width: ".5rem",
              borderRadius: "0px",
              borderBottomWidth: "3px",
              borderBottomStyle: "solid",
              borderBottomColor: "selected2",
              borderRightWidth: "3px",
              borderRightStyle: "solid",
              borderRightColor: "selected2",
              display: "inline-block",
              pos: "absolute",
              bg: "none"
            },
            _hover: {
              borderColor: "none",
              background: "white",
              _before: {
                content: '""',
                height: "1rem",
                width: ".5rem",
                borderRadius: "0px",
                borderBottomWidth: "3px",
                borderBottomStyle: "solid",
                borderBottomColor: "selected3",
                borderRightWidth: "3px",
                borderRightStyle: "solid",
                borderRightColor: "selected3",
                display: "inline-block",
                pos: "absolute",
                bg: "none"
              }
            }
          },
          _hover: {
            borderColor: "none",
            background: "white",
            _before: {
              content: '""',
              height: "1rem",
              width: ".5rem",
              borderRadius: "0px",
              borderBottomWidth: "3px",
              borderBottomStyle: "solid",
              borderBottomColor: "surfaceAccent5",
              borderRightWidth: "3px",
              borderRightStyle: "solid",
              borderRightColor: "surfaceAccent5",
              display: "inline-block",
              pos: "absolute",
              bg: "none"
            }
          }
        }
      }
    },
    sizes: {
      sm: {
        control: {
          width: "14px",
          height: "14px",
          borderWidth: 1.5,
          _checked: {
            _before: {
              w: "7px",
              h: "7px"
            }
          }
        },
        label: {
          ...(aS = (oS = En == null ? void 0 : En.Text) == null ? void 0 : oS.variants) == null ? void 0 : aS.h4,
          marginInlineStart: "10px"
        },
        container: {
          marginBottom: "8px",
          _last: {
            marginBottom: 0
          }
        }
      },
      lg: {
        control: {
          width: "20px",
          height: "20px",
          borderWidth: 2,
          _checked: {
            _before: {
              w: "10px",
              h: "10px"
            }
          }
        },
        label: {
          ...(sS = (iS = En == null ? void 0 : En.Text) == null ? void 0 : iS.variants) == null ? void 0 : sS.h4,
          marginInlineStart: "10px"
        },
        container: {
          marginBottom: "10px",
          _last: {
            marginBottom: 0
          }
        }
      }
    }
  }
}, hre = {
  ReactTableUI: {
    parts: ["tbody"],
    baseStyle: {
      tbody: {
        tr: {
          "th, td": {
            borderBottomWidth: 0
          }
        }
      }
    }
  }
}, { defineMultiStyleConfig: mre } = vn(["field"]), pre = {
  Select: mre({
    defaultProps: {
      variant: "outline"
    },
    variants: {
      outline: {
        field: r3.outline
      }
    },
    sizes: {
      xs: {
        field: {
          height: "1.5rem"
        }
      },
      sm: {
        field: {
          height: "2rem"
        }
      },
      md: {
        field: {
          height: "2.75rem"
        }
      },
      lg: {
        field: {
          height: "3rem"
        }
      }
    }
  })
}, gre = {
  Switch: {
    baseStyle: {
      track: {
        borderRadius: "4px",
        bg: "strokeDefault",
        _checked: {
          bg: "surfaceAccent4"
        }
      },
      thumb: {
        borderRadius: "2px"
      }
    }
  }
}, vre = {
  ...One,
  ...ore,
  ...are,
  ...sre,
  ...ure,
  ...fre,
  ...dre,
  ...gre,
  ...En,
  ...hre,
  ...pre
}, Cre = {
  xxs: "8px",
  xs: "12px",
  sm: "14px",
  md: "16px",
  lg: "18px",
  xl: "24px",
  "2xl": "28px"
}, bre = {
  xs: "7px",
  sm: "8px",
  md: "10px",
  lg: "12px",
  xl: "16px",
  xxxl: "56px"
}, Jw = {
  heading: "'Lato', sans-serif",
  body: "'Lato', sans-serif",
  mono: "'Lato', sans-serif"
}, yre = {
  styles: {
    global: () => {
      var e;
      return {
        a: {
          textDecoration: "underline"
        },
        svg: {
          display: "inline"
        },
        ".fc": {
          button: {
            ...L2.Button.baseStyle,
            ...(e = L2.Button.variants) == null ? void 0 : e.filled,
            border: "0px"
          },
          ".fc-daygrid-day.fc-day-sat, .fc-daygrid-day.fc-day-sun": {
            backgroundColor: "secondaryBackground"
          },
          ".fc-col-header-cell": {
            color: "black",
            backgroundColor: "initial"
          }
        }
      };
    }
  }
}, Sre = {}, Are = {
  primaryButtonPadding: "10px 40px",
  secondaryButtonPadding: "10px 40px",
  secondarySmallButtonPadding: "4px 12px",
  inlineButtonPadding: "0px 3px",
  navButtonPadding: "8px 20px"
}, Mre = {
  config: {
    initialColorMode: "light",
    useSystemColorMode: !1
  },
  ...yre,
  colors: Hr,
  components: vre,
  fonts: Jw,
  fontSizes: Cre,
  space: Are,
  sizes: Sre,
  zIndices: qw
}, Q3e = {
  config: {
    initialColorMode: "light",
    useSystemColorMode: !1
  },
  colors: Vne,
  fonts: Jw,
  fontSizes: bre
};
const e4e = ({ children: e, themes: t }) => {
  const n = CJ(Mre, ...t || []);
  return /* @__PURE__ */ A.jsx(pq, { theme: n, children: e });
}, t4e = (e) => /* @__PURE__ */ A.jsx(jM, { ...e });
function Kw(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number")
    r += e;
  else if (typeof e == "object")
    if (Array.isArray(e)) {
      var o = e.length;
      for (t = 0; t < o; t++)
        e[t] && (n = Kw(e[t])) && (r && (r += " "), r += n);
    } else
      for (n in e)
        e[n] && (r && (r += " "), r += n);
  return r;
}
function Ur() {
  for (var e, t, n = 0, r = "", o = arguments.length; n < o; n++)
    (e = arguments[n]) && (t = Kw(e)) && (r && (r += " "), r += t);
  return r;
}
const xre = ({ size: e, variant: t, children: n }) => /* @__PURE__ */ A.jsx("div", { className: Ur("dot", e, t), children: n }), wre = ["home-heart-filled", "baths", "location"], _re = (e) => wre.includes(e) ? "evenodd" : "nonzero", Ire = {
  add: {
    paths: [
      "M11 11V6C11 5.44772 11.4477 5 12 5C12.5523 5 13 5.44772 13 6V11H18C18.5523 11 19 11.4477 19 12C19 12.5523 18.5523 13 18 13H13V18C13 18.5523 12.5523 19 12 19C11.4477 19 11 18.5523 11 18V13H6C5.44772 13 5 12.5523 5 12C5 11.4477 5.44772 11 6 11H11Z"
    ],
    category: "System"
  },
  "arrow-left": {
    paths: [
      "M7.828 11H19C19.5523 11 20 11.4477 20 12C20 12.5523 19.5523 13 19 13H7.828L12.485 17.657C12.8755 18.0475 12.8755 18.6805 12.485 19.071C12.0945 19.4615 11.4615 19.4615 11.071 19.071L4 12L11.071 4.929C11.4615 4.53853 12.0945 4.53853 12.485 4.929C12.8755 5.31947 12.8755 5.95254 12.485 6.343L7.828 11Z"
    ],
    category: "System"
  },
  "assignment-add": {
    paths: [
      "M180-120q-24.75 0-42.375-17.625T120-180v-600q0-24.75 17.625-42.375T180-840h205q5-35 32-57.5t63-22.5q36 0 63 22.5t32 57.5h205q24.75 0 42.375 17.625T840-780v329q-14-8-29.5-13t-30.5-8v-308H180v600h309q4 16 9.023 31.172Q503.045-133.655 510-120H180Zm0-107v47-600 308-4 249Zm100-53h211q4-16 9-31t13-29H280v60Zm0-170h344q14-7 27-11.5t29-8.5v-40H280v60Zm0-170h400v-60H280v60Zm200-177q14 0 24.5-10.5T515-832q0-14-10.5-24.5T480-867q-14 0-24.5 10.5T445-832q0 14 10.5 24.5T480-797ZM732.5-41Q655-41 600-96.5T545-228q0-78.435 54.99-133.717Q654.98-417 733-417q77 0 132.5 55.283Q921-306.435 921-228q0 76-55.5 131.5T732.5-41ZM718-101h33v-110h110v-33H751v-110h-33v110H608v33h110v110Z"
    ],
    viewBox: "0 -960 960 960",
    category: "Business"
  },
  bank: {
    paths: [
      "M11 1.57752L2.70577 6.3662C2.26904 6.61834 2 7.08433 2 7.58863C2 8.3682 2.63197 9.00017 3.41154 9.00017H20.5885C21.368 9.00017 22 8.3682 22 7.58863C22 7.08434 21.731 6.61835 21.2942 6.3662L13 1.57752C12.3812 1.22025 11.6188 1.22025 11 1.57752ZM12 3.88692L7.47372 6.50017H16.5263L12 3.88692Z",
      "M12 11.0002C12.6904 11.0002 13.25 11.5598 13.25 12.2502V16.5002C13.25 17.1905 12.6904 17.7502 12 17.7502C11.3096 17.7502 10.75 17.1905 10.75 16.5002V12.2502C10.75 11.5598 11.3096 11.0002 12 11.0002Z",
      "M20.75 22.0002C21.4404 22.0002 22 21.4405 22 20.7502C22 20.0598 21.4404 19.5002 20.75 19.5002H3.25C2.55964 19.5002 2 20.0598 2 20.7502C2 21.4405 2.55964 22.0002 3.25 22.0002H20.75Z",
      "M17.5 11.0002C18.1904 11.0002 18.75 11.5598 18.75 12.2502V16.5002C18.75 17.1905 18.1904 17.7502 17.5 17.7502C16.8096 17.7502 16.25 17.1905 16.25 16.5002V12.2502C16.25 11.5598 16.8096 11.0002 17.5 11.0002Z",
      "M6.5 11.0002C7.19036 11.0002 7.75 11.5598 7.75 12.2502V16.5002C7.75 17.1905 7.19036 17.7502 6.5 17.7502C5.80964 17.7502 5.25 17.1905 5.25 16.5002V12.2502C5.25 11.5598 5.80964 11.0002 6.5 11.0002Z"
    ],
    category: "Buildings"
    // called account-balance in Figma, may not be exactly this icon
  },
  cursor: {
    paths: [
      "M17.94 20.512L15.388 13.498H15.389L19.947 12.865L8.41004 1.633L6.79004 17.653L10.689 15.208L13.242 22.222L17.94 20.512Z"
    ],
    category: "Communication"
  },
  "heart-3": {
    paths: [
      "M16.5 3C19.538 3 22 5.5 22 9C22 16 14.5 20 12 21.5C9.5 20 2 16 2 9C2 5.5 4.5 3 7.5 3C9.36 3 11 4 12 5C13 4 14.64 3 16.5 3ZM12.934 18.604C13.815 18.048 14.61 17.495 15.354 16.903C18.335 14.533 20 11.943 20 9C20 6.64 18.463 5 16.5 5C15.424 5 14.26 5.57 13.414 6.414L12 7.828L10.586 6.414C9.74 5.57 8.576 5 7.5 5C5.56 5 4 6.656 4 9C4 11.944 5.666 14.533 8.645 16.903C9.39 17.495 10.185 18.048 11.066 18.603C11.365 18.792 11.661 18.973 12 19.175C12.339 18.973 12.635 18.792 12.934 18.604V18.604Z"
    ],
    category: "System"
  },
  lock: {
    paths: [
      "M19 10H20C20.2652 10 20.5196 10.1054 20.7071 10.2929C20.8946 10.4804 21 10.7348 21 11V21C21 21.2652 20.8946 21.5196 20.7071 21.7071C20.5196 21.8946 20.2652 22 20 22H4C3.73478 22 3.48043 21.8946 3.29289 21.7071C3.10536 21.5196 3 21.2652 3 21V11C3 10.7348 3.10536 10.4804 3.29289 10.2929C3.48043 10.1054 3.73478 10 4 10H5V9C5 8.08075 5.18106 7.1705 5.53284 6.32122C5.88463 5.47194 6.40024 4.70026 7.05025 4.05025C7.70026 3.40024 8.47194 2.88463 9.32122 2.53284C10.1705 2.18106 11.0807 2 12 2C12.9193 2 13.8295 2.18106 14.6788 2.53284C15.5281 2.88463 16.2997 3.40024 16.9497 4.05025C17.5998 4.70026 18.1154 5.47194 18.4672 6.32122C18.8189 7.1705 19 8.08075 19 9V10ZM5 12V20H19V12H5ZM11 14H13V18H11V14ZM17 10V9C17 7.67392 16.4732 6.40215 15.5355 5.46447C14.5979 4.52678 13.3261 4 12 4C10.6739 4 9.40215 4.52678 8.46447 5.46447C7.52678 6.40215 7 7.67392 7 9V10H17Z"
    ],
    category: "System"
  },
  "indeterminate-circle": {
    paths: [
      "M12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22ZM12 20C14.1217 20 16.1566 19.1571 17.6569 17.6569C19.1571 16.1566 20 14.1217 20 12C20 9.87827 19.1571 7.84344 17.6569 6.34315C16.1566 4.84285 14.1217 4 12 4C9.87827 4 7.84344 4.84285 6.34315 6.34315C4.84285 7.84344 4 9.87827 4 12C4 14.1217 4.84285 16.1566 6.34315 17.6569C7.84344 19.1571 9.87827 20 12 20V20ZM7 11H17V13H7V11Z"
    ],
    category: "System"
  },
  "arrow-drop-down": {
    paths: [
      "M11.9998 15L8.46419 11.4643C8.07357 11.0737 8.07376 10.4403 8.46452 10.0498V10.0498C8.85514 9.65946 9.48829 9.65955 9.87869 10.0501L11.9998 12.172L14.121 10.0501C14.5114 9.65955 15.1445 9.65946 15.5351 10.0498V10.0498C15.9259 10.4403 15.9261 11.0737 15.5355 11.4643L11.9998 15Z"
    ],
    category: "System"
  },
  subtract: {
    paths: [
      "M5 12C5 11.4477 5.44772 11 6 11H18C18.5523 11 19 11.4477 19 12V12C19 12.5523 18.5523 13 18 13H6C5.44772 13 5 12.5523 5 12V12Z"
    ],
    category: "System"
  },
  "settings-3": {
    paths: [
      "M3.33933 17C2.9166 16.269 2.58799 15.4875 2.36133 14.674C2.85464 14.4231 3.26892 14.0406 3.55836 13.5689C3.84779 13.0972 4.00109 12.5546 4.0013 12.0011C4.00151 11.4477 3.84861 10.905 3.55953 10.433C3.27045 9.96106 2.85645 9.57828 2.36333 9.32701C2.81536 7.69249 3.67606 6.19996 4.86433 4.99001C5.32842 5.29173 5.86695 5.45917 6.42031 5.47379C6.97367 5.48841 7.52028 5.34964 7.99966 5.07284C8.47904 4.79604 8.87248 4.392 9.13646 3.90545C9.40043 3.41889 9.52463 2.86878 9.49533 2.31601C11.1374 1.89163 12.8606 1.89232 14.5023 2.31801C14.4733 2.87077 14.5977 3.4208 14.8619 3.90721C15.1261 4.39363 15.5197 4.79748 15.9992 5.07407C16.4786 5.35065 17.0253 5.48919 17.5786 5.47436C18.1319 5.45952 18.6704 5.29189 19.1343 4.99001C19.7133 5.58001 20.2273 6.25101 20.6593 7.00001C21.0923 7.74901 21.4163 8.53001 21.6373 9.32601C21.144 9.57691 20.7297 9.95938 20.4403 10.4311C20.1509 10.9028 19.9976 11.4454 19.9974 11.9989C19.9971 12.5523 20.15 13.0951 20.4391 13.567C20.7282 14.039 21.1422 14.4217 21.6353 14.673C21.1833 16.3075 20.3226 17.8001 19.1343 19.01C18.6702 18.7083 18.1317 18.5408 17.5784 18.5262C17.025 18.5116 16.4784 18.6504 15.999 18.9272C15.5196 19.204 15.1262 19.608 14.8622 20.0946C14.5982 20.5811 14.474 21.1312 14.5033 21.684C12.8612 22.1084 11.1381 22.1077 9.49633 21.682C9.52537 21.1292 9.40093 20.5792 9.13675 20.0928C8.87257 19.6064 8.47897 19.2025 7.9995 18.9259C7.52003 18.6494 6.97338 18.5108 6.42005 18.5257C5.86673 18.5405 5.32829 18.7081 4.86433 19.01C4.27332 18.407 3.76092 17.7316 3.33933 17V17ZM8.99933 17.196C10.065 17.8106 10.8662 18.797 11.2493 19.966C11.7483 20.013 12.2493 20.014 12.7483 19.967C13.1317 18.7979 13.9333 17.8114 14.9993 17.197C16.0645 16.5807 17.3199 16.3795 18.5243 16.632C18.8143 16.224 19.0643 15.789 19.2723 15.334C18.4518 14.4174 17.9984 13.2302 17.9993 12C17.9993 10.74 18.4693 9.56301 19.2723 8.66601C19.0629 8.21115 18.8118 7.77664 18.5223 7.36801C17.3186 7.62032 16.0641 7.41948 14.9993 6.80401C13.9337 6.18938 13.1325 5.20299 12.7493 4.03401C12.2503 3.98701 11.7493 3.98601 11.2503 4.03301C10.8669 5.20215 10.0653 6.18857 8.99933 6.80301C7.93411 7.41932 6.67881 7.62053 5.47433 7.36801C5.18489 7.77629 4.93446 8.21087 4.72633 8.66601C5.5469 9.58257 6.00021 10.7698 5.99933 12C5.99933 13.26 5.52933 14.437 4.72633 15.334C4.9358 15.7889 5.18687 16.2234 5.47633 16.632C6.68005 16.3797 7.93454 16.5805 8.99933 17.196ZM11.9993 15C11.2037 15 10.4406 14.6839 9.87801 14.1213C9.3154 13.5587 8.99933 12.7957 8.99933 12C8.99933 11.2044 9.3154 10.4413 9.87801 9.87869C10.4406 9.31608 11.2037 9.00001 11.9993 9.00001C12.795 9.00001 13.558 9.31608 14.1206 9.87869C14.6833 10.4413 14.9993 11.2044 14.9993 12C14.9993 12.7957 14.6833 13.5587 14.1206 14.1213C13.558 14.6839 12.795 15 11.9993 15ZM11.9993 13C12.2645 13 12.5189 12.8946 12.7064 12.7071C12.894 12.5196 12.9993 12.2652 12.9993 12C12.9993 11.7348 12.894 11.4804 12.7064 11.2929C12.5189 11.1054 12.2645 11 11.9993 11C11.7341 11 11.4798 11.1054 11.2922 11.2929C11.1047 11.4804 10.9993 11.7348 10.9993 12C10.9993 12.2652 11.1047 12.5196 11.2922 12.7071C11.4798 12.8946 11.7341 13 11.9993 13V13Z"
    ],
    category: "System"
  },
  "apps-2": {
    paths: [
      "M6.5 11.5C5.90905 11.5 5.32389 11.3836 4.77792 11.1575C4.23196 10.9313 3.73588 10.5998 3.31802 10.182C2.90016 9.76412 2.56869 9.26804 2.34254 8.72208C2.1164 8.17611 2 7.59095 2 7C2 6.40905 2.1164 5.82389 2.34254 5.27792C2.56869 4.73196 2.90016 4.23588 3.31802 3.81802C3.73588 3.40016 4.23196 3.06869 4.77792 2.84254C5.32389 2.6164 5.90905 2.5 6.5 2.5C7.69347 2.5 8.83807 2.97411 9.68198 3.81802C10.5259 4.66193 11 5.80653 11 7C11 8.19347 10.5259 9.33807 9.68198 10.182C8.83807 11.0259 7.69347 11.5 6.5 11.5V11.5ZM7 21.5C5.80653 21.5 4.66193 21.0259 3.81802 20.182C2.97411 19.3381 2.5 18.1935 2.5 17C2.5 15.8065 2.97411 14.6619 3.81802 13.818C4.66193 12.9741 5.80653 12.5 7 12.5C8.19347 12.5 9.33807 12.9741 10.182 13.818C11.0259 14.6619 11.5 15.8065 11.5 17C11.5 18.1935 11.0259 19.3381 10.182 20.182C9.33807 21.0259 8.19347 21.5 7 21.5V21.5ZM17 11.5C16.4091 11.5 15.8239 11.3836 15.2779 11.1575C14.732 10.9313 14.2359 10.5998 13.818 10.182C13.4002 9.76412 13.0687 9.26804 12.8425 8.72208C12.6164 8.17611 12.5 7.59095 12.5 7C12.5 6.40905 12.6164 5.82389 12.8425 5.27792C13.0687 4.73196 13.4002 4.23588 13.818 3.81802C14.2359 3.40016 14.732 3.06869 15.2779 2.84254C15.8239 2.6164 16.4091 2.5 17 2.5C18.1935 2.5 19.3381 2.97411 20.182 3.81802C21.0259 4.66193 21.5 5.80653 21.5 7C21.5 8.19347 21.0259 9.33807 20.182 10.182C19.3381 11.0259 18.1935 11.5 17 11.5V11.5ZM17 21.5C15.8065 21.5 14.6619 21.0259 13.818 20.182C12.9741 19.3381 12.5 18.1935 12.5 17C12.5 15.8065 12.9741 14.6619 13.818 13.818C14.6619 12.9741 15.8065 12.5 17 12.5C18.1935 12.5 19.3381 12.9741 20.182 13.818C21.0259 14.6619 21.5 15.8065 21.5 17C21.5 18.1935 21.0259 19.3381 20.182 20.182C19.3381 21.0259 18.1935 21.5 17 21.5ZM6.5 9.5C7.16304 9.5 7.79893 9.23661 8.26777 8.76777C8.73661 8.29893 9 7.66304 9 7C9 6.33696 8.73661 5.70107 8.26777 5.23223C7.79893 4.76339 7.16304 4.5 6.5 4.5C5.83696 4.5 5.20107 4.76339 4.73223 5.23223C4.26339 5.70107 4 6.33696 4 7C4 7.66304 4.26339 8.29893 4.73223 8.76777C5.20107 9.23661 5.83696 9.5 6.5 9.5V9.5ZM7 19.5C7.66304 19.5 8.29893 19.2366 8.76777 18.7678C9.23661 18.2989 9.5 17.663 9.5 17C9.5 16.337 9.23661 15.7011 8.76777 15.2322C8.29893 14.7634 7.66304 14.5 7 14.5C6.33696 14.5 5.70107 14.7634 5.23223 15.2322C4.76339 15.7011 4.5 16.337 4.5 17C4.5 17.663 4.76339 18.2989 5.23223 18.7678C5.70107 19.2366 6.33696 19.5 7 19.5ZM17 9.5C17.663 9.5 18.2989 9.23661 18.7678 8.76777C19.2366 8.29893 19.5 7.66304 19.5 7C19.5 6.33696 19.2366 5.70107 18.7678 5.23223C18.2989 4.76339 17.663 4.5 17 4.5C16.337 4.5 15.7011 4.76339 15.2322 5.23223C14.7634 5.70107 14.5 6.33696 14.5 7C14.5 7.66304 14.7634 8.29893 15.2322 8.76777C15.7011 9.23661 16.337 9.5 17 9.5ZM17 19.5C17.663 19.5 18.2989 19.2366 18.7678 18.7678C19.2366 18.2989 19.5 17.663 19.5 17C19.5 16.337 19.2366 15.7011 18.7678 15.2322C18.2989 14.7634 17.663 14.5 17 14.5C16.337 14.5 15.7011 14.7634 15.2322 15.2322C14.7634 15.7011 14.5 16.337 14.5 17C14.5 17.663 14.7634 18.2989 15.2322 18.7678C15.7011 19.2366 16.337 19.5 17 19.5Z"
    ],
    category: "System"
  },
  "arrow-drop-up": {
    paths: [
      "M11.9998 11.828L9.87869 13.9499C9.48829 14.3404 8.85514 14.3405 8.46452 13.9502V13.9502C8.07376 13.5597 8.07357 12.9263 8.46419 12.5356L11.9998 9L15.5355 12.5356C15.9261 12.9263 15.9259 13.5597 15.5351 13.9502V13.9502C15.1445 14.3405 14.5114 14.3404 14.121 13.9499L11.9998 11.828Z"
    ],
    category: "System"
  },
  "thumb-down": {
    paths: [
      "M9.4 16H3C2.46957 16 1.96086 15.7893 1.58579 15.4142C1.21071 15.0391 1 14.5304 1 14V11.896C0.999731 11.6346 1.05069 11.3758 1.15 11.134L4.246 3.62C4.32128 3.43675 4.4493 3.28 4.6138 3.16961C4.77831 3.05923 4.97189 3.0002 5.17 3H22C22.2652 3 22.5196 3.10536 22.7071 3.29289C22.8946 3.48043 23 3.73478 23 4V14C23 14.2652 22.8946 14.5196 22.7071 14.7071C22.5196 14.8946 22.2652 15 22 15H18.518C18.3579 15 18.2001 15.0384 18.058 15.112C17.9158 15.1856 17.7934 15.2922 17.701 15.423L12.248 23.149C12.1791 23.2467 12.0774 23.3164 11.9615 23.3456C11.8455 23.3748 11.723 23.3614 11.616 23.308L9.802 22.4C9.2915 22.1448 8.88367 21.7227 8.64627 21.2037C8.40887 20.6847 8.3562 20.1001 8.497 19.547L9.4 16ZM17 13.412V5H5.84L3 11.896V14H9.4C9.7046 14 10.0052 14.0697 10.2788 14.2035C10.5524 14.3374 10.7918 14.532 10.9787 14.7725C11.1657 15.013 11.2952 15.293 11.3575 15.5912C11.4197 15.8893 11.4131 16.1978 11.338 16.493L10.435 20.041C10.4067 20.1517 10.4172 20.2687 10.4647 20.3726C10.5122 20.4765 10.5938 20.561 10.696 20.612L11.357 20.942L16.067 14.27C16.317 13.916 16.637 13.626 17 13.412V13.412ZM19 13H21V5H19V13Z"
    ],
    category: "System"
  },
  "external-link": {
    paths: [
      "M10 6V8H5V19H16V14H18V20C18 20.2652 17.8946 20.5196 17.7071 20.7071C17.5196 20.8946 17.2652 21 17 21H4C3.73478 21 3.48043 20.8946 3.29289 20.7071C3.10536 20.5196 3 20.2652 3 20V7C3 6.73478 3.10536 6.48043 3.29289 6.29289C3.48043 6.10536 3.73478 6 4 6H10ZM21 3V11H19V6.413L11.207 14.207L9.793 12.793L17.585 5H13V3H21Z"
    ],
    category: "System"
  },
  "delete-bin": {
    paths: [
      "M17 6H22V8H20V21C20 21.2652 19.8946 21.5196 19.7071 21.7071C19.5196 21.8946 19.2652 22 19 22H5C4.73478 22 4.48043 21.8946 4.29289 21.7071C4.10536 21.5196 4 21.2652 4 21V8H2V6H7V3C7 2.73478 7.10536 2.48043 7.29289 2.29289C7.48043 2.10536 7.73478 2 8 2H16C16.2652 2 16.5196 2.10536 16.7071 2.29289C16.8946 2.48043 17 2.73478 17 3V6ZM18 8H6V20H18V8ZM9 11H11V17H9V11ZM13 11H15V17H13V11ZM9 4V6H15V4H9Z"
    ],
    category: "System"
  },
  remove: {
    viewBox: "0 0 16 16",
    paths: [
      "M7.99967 14.6666C4.31767 14.6666 1.33301 11.6819 1.33301 7.99992C1.33301 4.31792 4.31767 1.33325 7.99967 1.33325C11.6817 1.33325 14.6663 4.31792 14.6663 7.99992C14.6663 11.6819 11.6817 14.6666 7.99967 14.6666ZM7.99967 13.3333C9.41416 13.3333 10.7707 12.7713 11.7709 11.7712C12.7711 10.771 13.333 9.41441 13.333 7.99992C13.333 6.58543 12.7711 5.22888 11.7709 4.22868C10.7707 3.22849 9.41416 2.66659 7.99967 2.66659C6.58519 2.66659 5.22863 3.22849 4.22844 4.22868C3.22824 5.22888 2.66634 6.58543 2.66634 7.99992C2.66634 9.41441 3.22824 10.771 4.22844 11.7712C5.22863 12.7713 6.58519 13.3333 7.99967 13.3333ZM4.66634 7.33325H11.333V8.66659H4.66634V7.33325Z"
    ],
    category: "System"
  },
  "arrow-left-down": {
    paths: [
      "M9 13.59L16.9 5.69C17.2905 5.29954 17.9235 5.29954 18.314 5.69V5.69C18.7045 6.08047 18.7045 6.71354 18.314 7.104L10.414 15.004H17C17.5523 15.004 18 15.4517 18 16.004V16.004C18 16.5563 17.5523 17.004 17 17.004H7V7.004C7 6.45172 7.44772 6.004 8 6.004V6.004C8.55228 6.004 9 6.45172 9 7.004V13.589V13.59Z"
    ],
    category: "System"
  },
  "arrow-left-up": {
    paths: [
      "M10.41 9L18.31 16.9C18.7005 17.2905 18.7005 17.9235 18.31 18.314V18.314C17.9195 18.7045 17.2865 18.7045 16.896 18.314L8.996 10.414L8.996 17C8.996 17.5523 8.54828 18 7.996 18V18C7.44371 18 6.996 17.5523 6.996 17L6.996 7L16.996 7C17.5483 7 17.996 7.44772 17.996 8V8C17.996 8.55228 17.5483 9 16.996 9L10.411 9L10.41 9Z"
    ],
    category: "System"
  },
  question: {
    paths: [
      "M10 20C4.477 20 0 15.523 0 10C0 4.477 4.477 0 10 0C15.523 0 20 4.477 20 10C20 15.523 15.523 20 10 20ZM10 18C12.1217 18 14.1566 17.1571 15.6569 15.6569C17.1571 14.1566 18 12.1217 18 10C18 7.87827 17.1571 5.84344 15.6569 4.34315C14.1566 2.84285 12.1217 2 10 2C7.87827 2 5.84344 2.84285 4.34315 4.34315C2.84285 5.84344 2 7.87827 2 10C2 12.1217 2.84285 14.1566 4.34315 15.6569C5.84344 17.1571 7.87827 18 10 18ZM9 13H11V15H9V13ZM11 11.355V12H9V10.5C9 10.2348 9.10536 9.98043 9.29289 9.79289C9.48043 9.60536 9.73478 9.5 10 9.5C10.2841 9.49998 10.5623 9.4193 10.8023 9.26733C11.0423 9.11536 11.2343 8.89837 11.3558 8.64158C11.4773 8.3848 11.5234 8.0988 11.4887 7.81684C11.454 7.53489 11.34 7.26858 11.1598 7.04891C10.9797 6.82924 10.7409 6.66523 10.4712 6.57597C10.2015 6.48671 9.91204 6.47587 9.63643 6.54471C9.36081 6.61354 9.11042 6.75923 8.91437 6.96482C8.71832 7.1704 8.58468 7.42743 8.529 7.706L6.567 7.313C6.68863 6.70508 6.96951 6.14037 7.38092 5.67659C7.79233 5.2128 8.31952 4.86658 8.90859 4.67332C9.49766 4.48006 10.1275 4.44669 10.7337 4.57661C11.3399 4.70654 11.9007 4.99511 12.3588 5.41282C12.8169 5.83054 13.1559 6.36241 13.3411 6.95406C13.5263 7.54572 13.5511 8.17594 13.4129 8.78031C13.2747 9.38467 12.9785 9.9415 12.5545 10.3939C12.1306 10.8462 11.5941 11.1779 11 11.355Z"
    ],
    viewBox: "0 0 20 20",
    category: "System"
  },
  close: {
    paths: [
      "M12.0007 10.586L16.2437 6.34299C16.6342 5.95252 17.2673 5.95252 17.6577 6.34299V6.34299C18.0482 6.73345 18.0482 7.36652 17.6577 7.75699L13.4147 12L17.6577 16.243C18.0482 16.6335 18.0482 17.2665 17.6577 17.657V17.657C17.2673 18.0475 16.6342 18.0475 16.2437 17.657L12.0007 13.414L7.75772 17.657C7.36725 18.0475 6.73418 18.0475 6.34372 17.657V17.657C5.95325 17.2665 5.95325 16.6335 6.34372 16.243L10.5867 12L6.34372 7.75699C5.95325 7.36652 5.95325 6.73345 6.34372 6.34299V6.34299C6.73418 5.95252 7.36725 5.95252 7.75772 6.34299L12.0007 10.586Z"
    ],
    category: "System"
  },
  "close-circle": {
    paths: [
      "M10 20C4.477 20 0 15.523 0 10C0 4.477 4.477 0 10 0C15.523 0 20 4.477 20 10C20 15.523 15.523 20 10 20ZM10 18C12.1217 18 14.1566 17.1571 15.6569 15.6569C17.1571 14.1566 18 12.1217 18 10C18 7.87827 17.1571 5.84344 15.6569 4.34315C14.1566 2.84285 12.1217 2 10 2C7.87827 2 5.84344 2.84285 4.34315 4.34315C2.84285 5.84344 2 7.87827 2 10C2 12.1217 2.84285 14.1566 4.34315 15.6569C5.84344 17.1571 7.87827 18 10 18Z",
      "M10 8.88906L13.3336 5.55547C13.6404 5.24869 14.1378 5.24869 14.4445 5.55547C14.7513 5.86224 14.7513 6.35963 14.4445 6.6664L11.1109 10L14.4445 13.3336C14.7513 13.6404 14.7513 14.1378 14.4445 14.4445C14.1378 14.7513 13.6404 14.7513 13.3336 14.4445L10 11.1109L6.6664 14.4445C6.35963 14.7513 5.86224 14.7513 5.55547 14.4445C5.24869 14.1378 5.24869 13.6404 5.55547 13.3336L8.88906 10L5.55547 6.6664C5.24869 6.35963 5.24869 5.86224 5.55547 5.55547C5.86224 5.24869 6.35963 5.24869 6.6664 5.55547L10 8.88906Z"
    ],
    category: "System"
    // information-close in figma
  },
  "arrow-left-s": {
    paths: [
      "M10.828 12L15.071 16.243C15.4615 16.6335 15.4615 17.2665 15.071 17.657V17.657C14.6805 18.0475 14.0475 18.0475 13.657 17.657L8 12L13.657 6.343C14.0475 5.95253 14.6805 5.95253 15.071 6.343V6.343C15.4615 6.73347 15.4615 7.36653 15.071 7.757L10.828 12Z"
    ],
    category: "System"
  },
  "lock-unlock": {
    paths: [
      "M10.828 12L15.071 16.243C15.4615 16.6335 15.4615 17.2665 15.071 17.657V17.657C14.6805 18.0475 14.0475 18.0475 13.657 17.657L8 12L13.657 6.343C14.0475 5.95253 14.6805 5.95253 15.071 6.343V6.343C15.4615 6.73347 15.4615 7.36653 15.071 7.757L10.828 12Z"
    ],
    category: "System"
  },
  time: {
    paths: [
      "M12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22ZM12 20C14.1217 20 16.1566 19.1571 17.6569 17.6569C19.1571 16.1566 20 14.1217 20 12C20 9.87827 19.1571 7.84344 17.6569 6.34315C16.1566 4.84285 14.1217 4 12 4C9.87827 4 7.84344 4.84285 6.34315 6.34315C4.84285 7.84344 4 9.87827 4 12C4 14.1217 4.84285 16.1566 6.34315 17.6569C7.84344 19.1571 9.87827 20 12 20V20ZM13 12H17V14H11V7H13V12Z"
    ],
    category: "System"
  },
  "zoom-out": {
    paths: [
      "M18.031 16.617L22.314 20.899L20.899 22.314L16.617 18.031C15.0237 19.3082 13.042 20.0029 11 20C6.032 20 2 15.968 2 11C2 6.032 6.032 2 11 2C15.968 2 20 6.032 20 11C20.0029 13.042 19.3082 15.0237 18.031 16.617ZM16.025 15.875C17.2941 14.5699 18.0029 12.8204 18 11C18 7.132 14.867 4 11 4C7.132 4 4 7.132 4 11C4 14.867 7.132 18 11 18C12.8204 18.0029 14.5699 17.2941 15.875 16.025L16.025 15.875V15.875ZM7 10H15V12H7V10Z"
    ],
    category: "System"
  },
  "more-2": {
    paths: [
      "M12 3C11.175 3 10.5 3.675 10.5 4.5C10.5 5.325 11.175 6 12 6C12.825 6 13.5 5.325 13.5 4.5C13.5 3.675 12.825 3 12 3ZM12 18C11.175 18 10.5 18.675 10.5 19.5C10.5 20.325 11.175 21 12 21C12.825 21 13.5 20.325 13.5 19.5C13.5 18.675 12.825 18 12 18ZM12 10.5C11.175 10.5 10.5 11.175 10.5 12C10.5 12.825 11.175 13.5 12 13.5C12.825 13.5 13.5 12.825 13.5 12C13.5 11.175 12.825 10.5 12 10.5Z"
    ],
    category: "System"
  },
  information: {
    viewBox: "0 0 20 20",
    paths: [
      "M10 18.3333C5.39751 18.3333 1.66667 14.6025 1.66667 9.99999C1.66667 5.39749 5.39751 1.66666 10 1.66666C14.6025 1.66666 18.3333 5.39749 18.3333 9.99999C18.3333 14.6025 14.6025 18.3333 10 18.3333ZM10 16.6667C11.7681 16.6667 13.4638 15.9643 14.7141 14.714C15.9643 13.4638 16.6667 11.7681 16.6667 9.99999C16.6667 8.23188 15.9643 6.53619 14.7141 5.28594C13.4638 4.0357 11.7681 3.33332 10 3.33332C8.2319 3.33332 6.5362 4.0357 5.28596 5.28594C4.03572 6.53619 3.33334 8.23188 3.33334 9.99999C3.33334 11.7681 4.03572 13.4638 5.28596 14.714C6.5362 15.9643 8.2319 16.6667 10 16.6667ZM9.16667 5.83332H10.8333V7.49999H9.16667V5.83332ZM9.16667 9.16666H10.8333V14.1667H9.16667V9.16666Z"
    ],
    category: "System"
  },
  "information-inverse": {
    viewBox: "0 0 16 16",
    paths: [
      "M8.00049 1.33334C11.6822 1.33352 14.6665 4.31855 14.6665 8.00034C14.6663 11.682 11.6821 14.6662 8.00049 14.6664C4.3187 14.6664 1.33367 11.6821 1.3335 8.00034C1.3335 4.31844 4.31859 1.33334 8.00049 1.33334ZM7.44189 10.7601V11.8714H8.55322V10.7601H7.44189ZM7.44189 4.09409V9.09409H8.55322V4.09409H7.44189Z"
    ],
    category: "System"
  },
  "arrow-right-up": {
    paths: [
      "M16.0044 9.414L8.10442 17.314C7.71394 17.7045 7.08085 17.7045 6.69038 17.314V17.314C6.29992 16.9235 6.2999 16.2905 6.69034 15.9L14.5894 8H8.0044C7.45211 8 7.0044 7.55228 7.0044 7V7C7.0044 6.44772 7.45211 6 8.0044 6H18.0044V16C18.0044 16.5523 17.5567 17 17.0044 17V17C16.4521 17 16.0044 16.5523 16.0044 16V9.414Z"
    ],
    category: "System"
  },
  "arrow-right-down": {
    paths: [
      "M14.586 16.0044L6.68602 8.10442C6.29554 7.71394 6.29554 7.08085 6.68602 6.69038V6.69038C7.07648 6.29992 7.70954 6.2999 8.10002 6.69034L16 14.5894L16 8.0044C16 7.45211 16.4477 7.0044 17 7.0044V7.0044C17.5523 7.0044 18 7.45211 18 8.0044L18 18.0044L8 18.0044C7.44771 18.0044 7 17.5567 7 17.0044V17.0044C7 16.4521 7.44771 16.0044 8 16.0044L14.586 16.0044Z"
    ],
    category: "System"
  },
  "alarm-warning": {
    paths: [
      "M4.00059 20V14C4.00059 11.8783 4.84345 9.84344 6.34374 8.34315C7.84403 6.84285 9.87886 6 12.0006 6C14.1223 6 16.1572 6.84285 17.6574 8.34315C19.1577 9.84344 20.0006 11.8783 20.0006 14V20H21.0006V22H3.00059V20H4.00059ZM6.00059 20H18.0006V14C18.0006 12.4087 17.3685 10.8826 16.2432 9.75736C15.118 8.63214 13.5919 8 12.0006 8C10.4093 8 8.88317 8.63214 7.75795 9.75736C6.63273 10.8826 6.00059 12.4087 6.00059 14V20ZM11.0006 2H13.0006V5H11.0006V2ZM19.7786 4.808L21.1926 6.222L19.0726 8.343L17.6576 6.929L19.7786 4.808ZM2.80859 6.222L4.22259 4.808L6.34359 6.928L4.93059 8.344L2.80859 6.222ZM7.00059 14C7.00059 12.6739 7.52738 11.4021 8.46506 10.4645C9.40274 9.52678 10.6745 9 12.0006 9V11C11.2049 11 10.4419 11.3161 9.87927 11.8787C9.31666 12.4413 9.00059 13.2044 9.00059 14H7.00059Z"
    ],
    category: "System"
  },
  "arrow-up-down": {
    paths: [
      "M11.9498 7.95L10.5358 9.364L7.9998 6.828V20H5.9998V6.828L3.4648 9.364L2.0498 7.95L6.9998 3L11.9498 7.95ZM21.9498 16.05L16.9998 21L12.0498 16.05L13.4638 14.636L16.0008 17.172L15.9998 4H17.9998V17.172L20.5358 14.636L21.9498 16.05V16.05Z"
    ],
    category: "System"
  },
  filter: {
    paths: [
      "M21 4V6H20L15 13.5V22H9V13.5L4 6H3V4H21ZM6.404 6L11 12.894V20H13V12.894L17.596 6H6.404Z"
    ],
    category: "System"
  },
  "delete-bin-6": {
    paths: [
      "M7 4V2H17V4H22V6H20V21C20 21.2652 19.8946 21.5196 19.7071 21.7071C19.5196 21.8946 19.2652 22 19 22H5C4.73478 22 4.48043 21.8946 4.29289 21.7071C4.10536 21.5196 4 21.2652 4 21V6H2V4H7ZM6 6V20H18V6H6ZM9 9H11V17H9V9ZM13 9H15V17H13V9Z"
    ],
    category: "System"
  },
  "delete-bin-7": {
    paths: [
      "M17 6H22V8H20V21C20 21.2652 19.8946 21.5196 19.7071 21.7071C19.5196 21.8946 19.2652 22 19 22H5C4.73478 22 4.48043 21.8946 4.29289 21.7071C4.10536 21.5196 4 21.2652 4 21V8H2V6H7V3C7 2.73478 7.10536 2.48043 7.29289 2.29289C7.48043 2.10536 7.73478 2 8 2H16C16.2652 2 16.5196 2.10536 16.7071 2.29289C16.8946 2.48043 17 2.73478 17 3V6ZM18 8H6V20H18V8ZM9 4V6H15V4H9Z"
    ],
    category: "System"
  },
  "add-circle": {
    paths: [
      "M11 11V8C11 7.44772 11.4477 7 12 7V7C12.5523 7 13 7.44772 13 8V11H16C16.5523 11 17 11.4477 17 12V12C17 12.5523 16.5523 13 16 13H13V16C13 16.5523 12.5523 17 12 17V17C11.4477 17 11 16.5523 11 16V13H8C7.44772 13 7 12.5523 7 12V12C7 11.4477 7.44772 11 8 11H11ZM12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22ZM12 20C14.1217 20 16.1566 19.1571 17.6569 17.6569C19.1571 16.1566 20 14.1217 20 12C20 9.87827 19.1571 7.84344 17.6569 6.34315C16.1566 4.84285 14.1217 4 12 4C9.87827 4 7.84344 4.84285 6.34315 6.34315C4.84285 7.84344 4 9.87827 4 12C4 14.1217 4.84285 16.1566 6.34315 17.6569C7.84344 19.1571 9.87827 20 12 20Z"
    ],
    category: "System"
  },
  "settings-5": {
    paths: [
      "M2.21276 14.06C1.92517 12.7017 1.92517 11.2983 2.21276 9.94001C3.32276 10.07 4.29276 9.70301 4.60876 8.93901C4.92576 8.17401 4.50076 7.22901 3.62276 6.53601C4.3798 5.37233 5.37209 4.38005 6.53576 3.62301C7.22776 4.50001 8.17376 4.92601 8.93876 4.60901C9.70376 4.29201 10.0708 3.32301 9.93976 2.21301C11.298 1.92542 12.7015 1.92542 14.0598 2.21301C13.9298 3.32301 14.2968 4.29301 15.0608 4.60901C15.8258 4.92601 16.7708 4.50101 17.4638 3.62301C18.6274 4.38005 19.6197 5.37233 20.3768 6.53601C19.4998 7.22801 19.0738 8.17401 19.3908 8.93901C19.7078 9.70401 20.6768 10.071 21.7868 9.94001C22.0744 11.2983 22.0744 12.7017 21.7868 14.06C20.6768 13.93 19.7068 14.297 19.3908 15.061C19.0738 15.826 19.4988 16.771 20.3768 17.464C19.6197 18.6277 18.6274 19.62 17.4638 20.377C16.7718 19.5 15.8258 19.074 15.0608 19.391C14.2958 19.708 13.9288 20.677 14.0598 21.787C12.7015 22.0746 11.298 22.0746 9.93976 21.787C10.0698 20.677 9.70276 19.707 8.93876 19.391C8.17376 19.074 7.22876 19.499 6.53576 20.377C5.37209 19.62 4.3798 18.6277 3.62276 17.464C4.49976 16.772 4.92576 15.826 4.60876 15.061C4.29176 14.296 3.32276 13.929 2.21276 14.06V14.06ZM3.99976 12.21C5.09976 12.515 6.00676 13.212 6.45676 14.296C6.90576 15.381 6.75676 16.516 6.19476 17.508C6.29076 17.61 6.38976 17.709 6.49176 17.805C7.48476 17.243 8.61876 17.095 9.70376 17.543C10.7878 17.993 11.4848 18.9 11.7898 20C11.9298 20.004 12.0698 20.004 12.2098 20C12.5148 18.9 13.2118 17.993 14.2958 17.543C15.3808 17.094 16.5158 17.243 17.5078 17.805C17.6098 17.709 17.7088 17.61 17.8048 17.508C17.2428 16.515 17.0948 15.381 17.5428 14.296C17.9928 13.212 18.8998 12.515 19.9998 12.21C20.0038 12.07 20.0038 11.93 19.9998 11.79C18.8998 11.485 17.9928 10.788 17.5428 9.70401C17.0938 8.61901 17.2428 7.48401 17.8048 6.49201C17.7084 6.3904 17.6094 6.29137 17.5078 6.19501C16.5148 6.75701 15.3808 6.90501 14.2958 6.45701C13.2118 6.00701 12.5148 5.10001 12.2098 4.00001C12.0698 3.9963 11.9297 3.9963 11.7898 4.00001C11.4848 5.10001 10.7878 6.00701 9.70376 6.45701C8.61876 6.90601 7.48376 6.75701 6.49176 6.19501C6.38976 6.29101 6.29076 6.39001 6.19476 6.49201C6.75676 7.48501 6.90476 8.61901 6.45676 9.70401C6.00676 10.788 5.09976 11.485 3.99976 11.79C3.99576 11.93 3.99576 12.07 3.99976 12.21V12.21ZM11.9998 15C11.2041 15 10.4411 14.6839 9.87844 14.1213C9.31583 13.5587 8.99976 12.7957 8.99976 12C8.99976 11.2044 9.31583 10.4413 9.87844 9.87869C10.4411 9.31608 11.2041 9.00001 11.9998 9.00001C12.7954 9.00001 13.5585 9.31608 14.1211 9.87869C14.6837 10.4413 14.9998 11.2044 14.9998 12C14.9998 12.7957 14.6837 13.5587 14.1211 14.1213C13.5585 14.6839 12.7954 15 11.9998 15ZM11.9998 13C12.265 13 12.5193 12.8946 12.7069 12.7071C12.8944 12.5196 12.9998 12.2652 12.9998 12C12.9998 11.7348 12.8944 11.4804 12.7069 11.2929C12.5193 11.1054 12.265 11 11.9998 11C11.7345 11 11.4802 11.1054 11.2927 11.2929C11.1051 11.4804 10.9998 11.7348 10.9998 12C10.9998 12.2652 11.1051 12.5196 11.2927 12.7071C11.4802 12.8946 11.7345 13 11.9998 13V13Z"
    ],
    category: "System"
  },
  "arrow-up-s": {
    paths: [
      "M12.0007 10.828L7.75772 15.071C7.36725 15.4615 6.73418 15.4615 6.34372 15.071V15.071C5.95325 14.6805 5.95325 14.0475 6.34372 13.657L12.0007 8L17.6577 13.657C18.0482 14.0475 18.0482 14.6805 17.6577 15.071V15.071C17.2673 15.4615 16.6342 15.4615 16.2437 15.071L12.0007 10.828Z"
    ],
    category: "System"
  },
  "zoom-in": {
    paths: [
      "M18.031 16.617L22.314 20.899L20.899 22.314L16.617 18.031C15.0237 19.3082 13.042 20.0029 11 20C6.032 20 2 15.968 2 11C2 6.032 6.032 2 11 2C15.968 2 20 6.032 20 11C20.0029 13.042 19.3082 15.0237 18.031 16.617ZM16.025 15.875C17.2941 14.5699 18.0029 12.8204 18 11C18 7.132 14.867 4 11 4C7.132 4 4 7.132 4 11C4 14.867 7.132 18 11 18C12.8204 18.0029 14.5699 17.2941 15.875 16.025L16.025 15.875V15.875ZM10 10V7H12V10H15V12H12V15H10V12H7V10H10Z"
    ],
    category: "System"
  },
  "share-forward-fill": {
    paths: [
      "M13 14H11C9.3596 13.9994 7.75023 14.4471 6.34588 15.2949C4.94152 16.1427 3.7956 17.3582 3.032 18.81C3.01054 18.5405 2.99986 18.2703 3 18C3 12.477 7.477 8 13 8V3L23 11L13 19V14Z"
    ],
    category: "System"
  },
  "upload-line": {
    paths: [
      "M3 19H21V21H3V19ZM13 5.828V17H11V5.828L4.929 11.9L3.515 10.486L12 2L20.485 10.485L19.071 11.899L13 5.83V5.828Z"
    ],
    category: "System"
  },
  "error-warning": {
    paths: [
      "M12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22ZM12 20C14.1217 20 16.1566 19.1571 17.6569 17.6569C19.1571 16.1566 20 14.1217 20 12C20 9.87827 19.1571 7.84344 17.6569 6.34315C16.1566 4.84285 14.1217 4 12 4C9.87827 4 7.84344 4.84285 6.34315 6.34315C4.84285 7.84344 4 9.87827 4 12C4 14.1217 4.84285 16.1566 6.34315 17.6569C7.84344 19.1571 9.87827 20 12 20V20ZM11 15H13V17H11V15ZM11 7H13V13H11V7Z"
    ],
    category: "System"
  },
  "arrow-up": {
    paths: [
      "M13.0007 7.828V19C13.0007 19.5523 12.5529 20 12.0007 20V20C11.4484 20 11.0007 19.5523 11.0007 19V7.828L6.34366 12.485C5.95319 12.8755 5.32012 12.8755 4.92966 12.485V12.485C4.53919 12.0945 4.53919 11.4615 4.92966 11.071L12.0007 4L19.0717 11.071C19.4621 11.4615 19.4621 12.0945 19.0717 12.485V12.485C18.6812 12.8755 18.0481 12.8755 17.6577 12.485L13.0007 7.828Z"
    ],
    category: "System"
  },
  share: {
    paths: [
      "M13.1202 17.023L8.92121 14.733C8.373 15.3191 7.66119 15.7267 6.87828 15.9029C6.09537 16.0791 5.27756 16.0157 4.53113 15.7211C3.7847 15.4264 3.14417 14.914 2.69277 14.2505C2.24138 13.587 2 12.803 2 12.0005C2 11.198 2.24138 10.4141 2.69277 9.75058C3.14417 9.08707 3.7847 8.57467 4.53113 8.27998C5.27756 7.98529 6.09537 7.92193 6.87828 8.09813C7.66119 8.27434 8.373 8.68196 8.92121 9.26802L13.1212 6.97802C12.8828 6.03409 12.9968 5.03561 13.4418 4.16972C13.8869 3.30384 14.6325 2.63 15.5389 2.27452C16.4452 1.91904 17.4501 1.90633 18.3652 2.23875C19.2803 2.57118 20.0427 3.22594 20.5095 4.08028C20.9764 4.93463 21.1156 5.92991 20.9011 6.87957C20.6866 7.82922 20.1332 8.66806 19.3444 9.23883C18.5557 9.8096 17.5859 10.0731 16.6168 9.98001C15.6477 9.8869 14.7458 9.44353 14.0802 8.73302L9.88021 11.023C10.0414 11.6644 10.0414 12.3357 9.88021 12.977L14.0792 15.267C14.7448 14.5565 15.6467 14.1131 16.6158 14.02C17.5849 13.9269 18.5547 14.1904 19.3434 14.7612C20.1322 15.332 20.6856 16.1708 20.9001 17.1205C21.1146 18.0701 20.9754 19.0654 20.5085 19.9198C20.0417 20.7741 19.2793 21.4289 18.3642 21.7613C17.4491 22.0937 16.4442 22.081 15.5379 21.7255C14.6315 21.37 13.8859 20.6962 13.4408 19.8303C12.9958 18.9644 12.8818 17.9659 13.1202 17.022V17.023ZM6.00021 14C6.53064 14 7.03935 13.7893 7.41442 13.4142C7.78949 13.0392 8.00021 12.5305 8.00021 12C8.00021 11.4696 7.78949 10.9609 7.41442 10.5858C7.03935 10.2107 6.53064 10 6.00021 10C5.46977 10 4.96107 10.2107 4.58599 10.5858C4.21092 10.9609 4.00021 11.4696 4.00021 12C4.00021 12.5305 4.21092 13.0392 4.58599 13.4142C4.96107 13.7893 5.46977 14 6.00021 14V14ZM17.0002 8.00002C17.5306 8.00002 18.0393 7.78931 18.4144 7.41423C18.7895 7.03916 19.0002 6.53045 19.0002 6.00002C19.0002 5.46959 18.7895 4.96088 18.4144 4.58581C18.0393 4.21073 17.5306 4.00002 17.0002 4.00002C16.4698 4.00002 15.9611 4.21073 15.586 4.58581C15.2109 4.96088 15.0002 5.46959 15.0002 6.00002C15.0002 6.53045 15.2109 7.03916 15.586 7.41423C15.9611 7.78931 16.4698 8.00002 17.0002 8.00002V8.00002ZM17.0002 20C17.5306 20 18.0393 19.7893 18.4144 19.4142C18.7895 19.0392 19.0002 18.5305 19.0002 18C19.0002 17.4696 18.7895 16.9609 18.4144 16.5858C18.0393 16.2107 17.5306 16 17.0002 16C16.4698 16 15.9611 16.2107 15.586 16.5858C15.2109 16.9609 15.0002 17.4696 15.0002 18C15.0002 18.5305 15.2109 19.0392 15.586 19.4142C15.9611 19.7893 16.4698 20 17.0002 20V20Z"
    ],
    category: "System"
  },
  "side-nav-expand": {
    paths: [
      "M14.2861 16.1429L4.00042 16.1429L4.00042 15L14.2861 15L14.2861 16.1429ZM14.2861 12.1429L4.00042 12.1429L4.00042 11L14.2861 11L14.2861 12.1429ZM14.2861 8.14288L4.00042 8.14288L4.00042 7.00002L14.2861 7.00003L14.2861 8.14288Z",
      "M18.384 11.5715L16.7674 9.95546L17.5754 9.14689L20 11.5715L17.5754 13.996L16.7674 13.1875L18.384 11.5715Z"
    ],
    category: "System"
  },
  "side-nav-collapse": {
    paths: [
      "M9.71387 7H19.9996V8.14286H9.71387V7ZM9.71387 11H19.9996V12.1429H9.71387V11ZM9.71387 15H19.9996V16.1429H9.71387V15Z",
      "M5.616 11.5714L7.23257 13.1874L6.42457 13.996L4 11.5714L6.42457 9.14685L7.23257 9.95542L5.616 11.5714Z"
    ],
    category: "System"
  },
  "arrow-drop-left": {
    paths: [
      "M11.828 12L13.9499 14.1211C14.3404 14.5115 14.3405 15.1447 13.9502 15.5353V15.5353C13.5597 15.9261 12.9263 15.9263 12.5356 15.5356L9 12L12.5356 8.46436C12.9263 8.07374 13.5597 8.07393 13.9502 8.46469V8.46469C14.3405 8.8553 14.3404 9.48845 13.9499 9.87886L11.828 12Z"
    ],
    category: "System"
  },
  "arrow-down": {
    paths: [
      "M13.0007 16.172L17.6577 11.515C18.0481 11.1245 18.6812 11.1245 19.0717 11.515V11.515C19.4621 11.9055 19.4621 12.5385 19.0717 12.929L12.0007 20L4.92966 12.929C4.53919 12.5385 4.53919 11.9055 4.92966 11.515V11.515C5.32012 11.1245 5.95319 11.1245 6.34366 11.515L11.0007 16.172V5C11.0007 4.44772 11.4484 4 12.0007 4V4C12.5529 4 13.0007 4.44772 13.0007 5V16.172Z"
    ],
    category: "System"
  },
  dashboard: {
    paths: [
      "M13 21V11H21V21H13ZM3 13V3H11V13H3ZM9 11V5H5V11H9ZM3 21V15H11V21H3ZM5 19H9V17H5V19ZM15 19H19V13H15V19ZM13 3H21V9H13V3ZM15 5V7H19V5H15Z"
    ],
    category: "System"
  },
  "arrow-down-s": {
    paths: [
      "M12.0007 13.172L16.2437 8.92899C16.6342 8.53852 17.2673 8.53852 17.6577 8.92898V8.92898C18.0482 9.31945 18.0482 9.95252 17.6577 10.343L12.0007 16L6.34372 10.343C5.95325 9.95252 5.95325 9.31945 6.34372 8.92898V8.92898C6.73418 8.53852 7.36725 8.53852 7.75772 8.92898L12.0007 13.172Z"
    ],
    category: "System"
  },
  "star-s": {
    paths: [
      "M12.0002 17L6.12223 20.59L7.72023 13.89L2.49023 9.41L9.35523 8.86L12.0002 2.5L14.6452 8.86L21.5112 9.41L16.2802 13.89L17.8782 20.59L12.0002 17ZM12.0002 14.656L14.8172 16.376L14.0512 13.166L16.5582 11.019L13.2682 10.755L12.0002 7.708L10.7322 10.755L7.44223 11.019L9.94923 13.166L9.18323 16.376L12.0002 14.657V14.656Z"
    ],
    category: "System"
  },
  "lock-2": {
    paths: [
      "M6 8V7C6 5.4087 6.63214 3.88258 7.75736 2.75736C8.88258 1.63214 10.4087 1 12 1C13.5913 1 15.1174 1.63214 16.2426 2.75736C17.3679 3.88258 18 5.4087 18 7V8H20C20.2652 8 20.5196 8.10536 20.7071 8.29289C20.8946 8.48043 21 8.73478 21 9V21C21 21.2652 20.8946 21.5196 20.7071 21.7071C20.5196 21.8946 20.2652 22 20 22H4C3.73478 22 3.48043 21.8946 3.29289 21.7071C3.10536 21.5196 3 21.2652 3 21V9C3 8.73478 3.10536 8.48043 3.29289 8.29289C3.48043 8.10536 3.73478 8 4 8H6ZM19 10H5V20H19V10ZM11 15.732C10.6187 15.5119 10.3207 15.1721 10.1522 14.7653C9.98376 14.3586 9.9542 13.9076 10.0681 13.4823C10.1821 13.057 10.4332 12.6813 10.7825 12.4132C11.1318 12.1452 11.5597 11.9999 12 11.9999C12.4403 11.9999 12.8682 12.1452 13.2175 12.4132C13.5668 12.6813 13.8179 13.057 13.9319 13.4823C14.0458 13.9076 14.0162 14.3586 13.8478 14.7653C13.6793 15.1721 13.3813 15.5119 13 15.732V18H11V15.732ZM8 8H16V7C16 5.93913 15.5786 4.92172 14.8284 4.17157C14.0783 3.42143 13.0609 3 12 3C10.9391 3 9.92172 3.42143 9.17157 4.17157C8.42143 4.92172 8 5.93913 8 7V8Z"
    ],
    category: "System"
  },
  "arrow-right": {
    paths: [
      "M16.172 11L11.515 6.343C11.1245 5.95253 11.1245 5.31947 11.515 4.929V4.929C11.9055 4.53853 12.5385 4.53853 12.929 4.929L20 12L12.929 19.071C12.5385 19.4615 11.9055 19.4615 11.515 19.071V19.071C11.1245 18.6805 11.1245 18.0475 11.515 17.657L16.172 13H5C4.44772 13 4 12.5523 4 12V12C4 11.4477 4.44772 11 5 11H16.172Z"
    ],
    category: "System"
  },
  search: {
    paths: [
      "M18.031 16.617L21.6067 20.1919C21.9973 20.5824 21.9971 21.2159 21.6065 21.6065V21.6065C21.2159 21.9971 20.5824 21.9973 20.1919 21.6067L16.617 18.031C15.0237 19.3082 13.042 20.0029 11 20C6.032 20 2 15.968 2 11C2 6.032 6.032 2 11 2C15.968 2 20 6.032 20 11C20.0029 13.042 19.3082 15.0237 18.031 16.617ZM16.025 15.875C17.2941 14.5699 18.0029 12.8204 18 11C18 7.132 14.867 4 11 4C7.132 4 4 7.132 4 11C4 14.867 7.132 18 11 18C12.8204 18.0029 14.5699 17.2941 15.875 16.025L16.025 15.875Z"
    ],
    category: "System"
  },
  more: {
    paths: [
      "M4.5 10.5C3.675 10.5 3 11.175 3 12C3 12.825 3.675 13.5 4.5 13.5C5.325 13.5 6 12.825 6 12C6 11.175 5.325 10.5 4.5 10.5ZM19.5 10.5C18.675 10.5 18 11.175 18 12C18 12.825 18.675 13.5 19.5 13.5C20.325 13.5 21 12.825 21 12C21 11.175 20.325 10.5 19.5 10.5ZM12 10.5C11.175 10.5 10.5 11.175 10.5 12C10.5 12.825 11.175 13.5 12 13.5C12.825 13.5 13.5 12.825 13.5 12C13.5 11.175 12.825 10.5 12 10.5Z"
    ],
    category: "System"
  },
  "lock-password": {
    paths: [
      "M18 8H20C20.2652 8 20.5196 8.10536 20.7071 8.29289C20.8946 8.48043 21 8.73478 21 9V21C21 21.2652 20.8946 21.5196 20.7071 21.7071C20.5196 21.8946 20.2652 22 20 22H4C3.73478 22 3.48043 21.8946 3.29289 21.7071C3.10536 21.5196 3 21.2652 3 21V9C3 8.73478 3.10536 8.48043 3.29289 8.29289C3.48043 8.10536 3.73478 8 4 8H6V7C6 5.4087 6.63214 3.88258 7.75736 2.75736C8.88258 1.63214 10.4087 1 12 1C13.5913 1 15.1174 1.63214 16.2426 2.75736C17.3679 3.88258 18 5.4087 18 7V8ZM5 10V20H19V10H5ZM11 14H13V16H11V14ZM7 14H9V16H7V14ZM15 14H17V16H15V14ZM16 8V7C16 5.93913 15.5786 4.92172 14.8284 4.17157C14.0783 3.42143 13.0609 3 12 3C10.9391 3 9.92172 3.42143 9.17157 4.17157C8.42143 4.92172 8 5.93913 8 7V8H16Z"
    ],
    category: "System"
  },
  download: {
    paths: [
      "M3 19H21V21H3V19ZM13 13.172L19.071 7.1L20.485 8.514L12 17L3.515 8.515L4.929 7.1L11 13.17V2H13V13.172Z"
    ],
    category: "System"
  },
  star: {
    paths: [
      "M11.9999 18.26L4.94691 22.208L6.52191 14.28L0.586914 8.792L8.61391 7.84L11.9999 0.5L15.3859 7.84L23.4129 8.792L17.4779 14.28L19.0529 22.208L11.9999 18.26ZM11.9999 15.968L16.2469 18.345L15.2979 13.572L18.8709 10.267L14.0379 9.694L11.9999 5.275L9.96191 9.695L5.12891 10.267L8.70191 13.572L7.75291 18.345L11.9999 15.968V15.968Z"
    ],
    category: "System"
  },
  "arrow-go-forward": {
    paths: [
      "M18.172 7H11C9.4087 7 7.88258 7.63214 6.75736 8.75736C5.63214 9.88258 5 11.4087 5 13C5 14.5913 5.63214 16.1174 6.75736 17.2426C7.88258 18.3679 9.4087 19 11 19H19C19.5523 19 20 19.4477 20 20V20C20 20.5523 19.5523 21 19 21H11C8.87827 21 6.84344 20.1571 5.34315 18.6569C3.84285 17.1566 3 15.1217 3 13C3 10.8783 3.84285 8.84344 5.34315 7.34315C6.84344 5.84285 8.87827 5 11 5H18.172L16.343 3.171C15.9525 2.78053 15.9525 2.14746 16.343 1.757V1.757C16.7335 1.36653 17.3665 1.36653 17.757 1.757L22 6L17.757 10.243C17.3665 10.6335 16.7335 10.6335 16.343 10.243V10.243C15.9525 9.85253 15.9525 9.21946 16.343 8.829L18.172 7Z"
    ],
    category: "System"
  },
  eye: {
    paths: [
      "M12.0006 3C17.3926 3 21.8786 6.88 22.8196 12C21.8796 17.12 17.3926 21 12.0006 21C6.60864 21 2.12264 17.12 1.18164 12C2.12164 6.88 6.60864 3 12.0006 3ZM12.0006 19C14.0401 18.9996 16.019 18.3068 17.6135 17.0352C19.208 15.7635 20.3235 13.9883 20.7776 12C20.3219 10.0133 19.2056 8.24 17.6113 6.97003C16.017 5.70005 14.0389 5.00853 12.0006 5.00853C9.96234 5.00853 7.98433 5.70005 6.39002 6.97003C4.7957 8.24 3.67941 10.0133 3.22364 12C3.67774 13.9883 4.79331 15.7635 6.38778 17.0352C7.98226 18.3068 9.96117 18.9996 12.0006 19V19ZM12.0006 16.5C10.8072 16.5 9.66257 16.0259 8.81866 15.182C7.97475 14.3381 7.50064 13.1935 7.50064 12C7.50064 10.8065 7.97475 9.66193 8.81866 8.81802C9.66257 7.97411 10.8072 7.5 12.0006 7.5C13.1941 7.5 14.3387 7.97411 15.1826 8.81802C16.0265 9.66193 16.5006 10.8065 16.5006 12C16.5006 13.1935 16.0265 14.3381 15.1826 15.182C14.3387 16.0259 13.1941 16.5 12.0006 16.5ZM12.0006 14.5C12.6637 14.5 13.2996 14.2366 13.7684 13.7678C14.2372 13.2989 14.5006 12.663 14.5006 12C14.5006 11.337 14.2372 10.7011 13.7684 10.2322C13.2996 9.76339 12.6637 9.5 12.0006 9.5C11.3376 9.5 10.7017 9.76339 10.2329 10.2322C9.76403 10.7011 9.50064 11.337 9.50064 12C9.50064 12.663 9.76403 13.2989 10.2329 13.7678C10.7017 14.2366 11.3376 14.5 12.0006 14.5Z"
    ],
    category: "System"
  },
  "thumb-up": {
    paths: [
      "M14.6 8H21C21.5304 8 22.0391 8.21071 22.4142 8.58578C22.7893 8.96085 23 9.46956 23 10V12.104C23.0003 12.3654 22.9493 12.6242 22.85 12.866L19.755 20.381C19.6795 20.5642 19.5513 20.7209 19.3866 20.8311C19.2219 20.9413 19.0282 21.0001 18.83 21H2C1.73478 21 1.48043 20.8946 1.29289 20.7071C1.10536 20.5196 1 20.2652 1 20V10C1 9.73478 1.10536 9.48043 1.29289 9.29289C1.48043 9.10535 1.73478 9 2 9H5.482C5.6421 9.00004 5.79986 8.96164 5.94203 8.88803C6.0842 8.81442 6.20662 8.70775 6.299 8.57699L11.752 0.849995C11.8209 0.752308 11.9226 0.682556 12.0385 0.653386C12.1545 0.624215 12.277 0.637558 12.384 0.690995L14.198 1.598C14.7085 1.85316 15.1163 2.27531 15.3537 2.79431C15.5911 3.31331 15.6438 3.89792 15.503 4.451L14.6 8ZM7 10.588V19H18.16L21 12.104V10H14.6C14.2954 9.99995 13.9948 9.93033 13.7212 9.79645C13.4476 9.66257 13.2082 9.46797 13.0213 9.22748C12.8343 8.987 12.7048 8.70699 12.6425 8.40882C12.5803 8.11065 12.5869 7.8022 12.662 7.507L13.565 3.959C13.5933 3.84832 13.5828 3.73131 13.5353 3.62742C13.4878 3.52354 13.4062 3.43904 13.304 3.388L12.643 3.058L7.933 9.72999C7.683 10.084 7.363 10.374 7 10.588V10.588ZM5 11H3V19H5V11Z"
    ],
    category: "System"
  },
  function: {
    paths: [
      "M3 3H11V11H3V3ZM3 13H11V21H3V13ZM13 3H21V11H13V3ZM13 13H21V21H13V13ZM15 5V9H19V5H15ZM15 15V19H19V15H15ZM5 5V9H9V5H5ZM5 15V19H9V15H5Z"
    ],
    category: "System"
  },
  "arrow-drop-right": {
    paths: [
      "M12.1718 12L10.0499 9.87885C9.65934 9.48844 9.65925 8.85529 10.0496 8.46468V8.46468C10.4401 8.07392 11.0735 8.07372 11.4641 8.46435L14.9998 12L11.4641 15.5356C11.0735 15.9263 10.4401 15.9261 10.0496 15.5353V15.5353C9.65925 15.1447 9.65934 14.5115 10.0499 14.1211L12.1718 12Z"
    ],
    category: "System"
  },
  "eye-off": {
    paths: [
      "M17.8826 19.297C16.1239 20.4126 14.0834 21.0033 12.0006 21C6.60864 21 2.12264 17.12 1.18164 12C1.61167 9.67072 2.78327 7.5429 4.52164 5.93401L1.39264 2.80801L2.80764 1.39301L22.6066 21.193L21.1916 22.607L17.8816 19.297H17.8826ZM5.93564 7.35001C4.57665 8.5856 3.62996 10.2088 3.22364 12C3.53593 13.3665 4.1629 14.6411 5.05464 15.7226C5.94638 16.804 7.07827 17.6624 8.36019 18.2293C9.64212 18.7962 11.0387 19.0561 12.4387 18.9881C13.8388 18.9202 15.2036 18.5264 16.4246 17.838L14.3966 15.81C13.5333 16.3538 12.5108 16.5881 11.4969 16.4744C10.4829 16.3608 9.53768 15.9059 8.81621 15.1844C8.09474 14.463 7.63987 13.5177 7.5262 12.5038C7.41254 11.4898 7.64682 10.4673 8.19064 9.60401L5.93564 7.35001ZM12.9146 14.328L9.67264 11.086C9.49471 11.5389 9.45283 12.034 9.55215 12.5104C9.65146 12.9867 9.88766 13.4238 10.2318 13.7679C10.5759 14.112 11.0129 14.3482 11.4893 14.4475C11.9657 14.5468 12.4607 14.5049 12.9136 14.327L12.9146 14.328ZM20.8076 16.592L19.3766 15.162C20.0451 14.2093 20.521 13.1352 20.7776 12C20.5059 10.8097 19.9949 9.68715 19.2758 8.7005C18.5567 7.71385 17.6444 6.88373 16.5945 6.26061C15.5446 5.63749 14.3789 5.23437 13.1684 5.07577C11.9578 4.91717 10.7276 5.00638 9.55264 5.33801L7.97464 3.76001C9.22164 3.27001 10.5806 3.00001 12.0006 3.00001C17.3926 3.00001 21.8786 6.88001 22.8196 12C22.5132 13.6657 21.8245 15.2376 20.8076 16.592V16.592ZM11.7236 7.50801C12.3602 7.46867 12.9978 7.56507 13.5942 7.79082C14.1906 8.01657 14.7323 8.36652 15.1832 8.81746C15.6341 9.2684 15.9841 9.81003 16.2098 10.4065C16.4356 11.0029 16.532 11.6405 16.4926 12.277L11.7226 7.50801H11.7236Z"
    ],
    category: "System"
  },
  "arrow-right-s": {
    paths: [
      "M13.1727 12L8.92966 7.75699C8.53919 7.36652 8.53919 6.73345 8.92966 6.34299V6.34299C9.32012 5.95252 9.95319 5.95252 10.3437 6.34299L16.0007 12L10.3437 17.657C9.95319 18.0475 9.32012 18.0475 8.92966 17.657V17.657C8.53919 17.2665 8.53919 16.6335 8.92966 16.243L13.1727 12Z"
    ],
    category: "System"
  },
  "arrow-go-back": {
    paths: [
      "M5.828 7L7.657 8.829C8.04747 9.21946 8.04747 9.85253 7.657 10.243V10.243C7.26653 10.6335 6.63347 10.6335 6.243 10.243L2 6L6.243 1.757C6.63346 1.36653 7.26653 1.36653 7.657 1.757V1.757C8.04747 2.14746 8.04747 2.78053 7.657 3.171L5.828 5H13C15.1217 5 17.1566 5.84285 18.6569 7.34315C20.1571 8.84344 21 10.8783 21 13C21 15.1217 20.1571 17.1566 18.6569 18.6569C17.1566 20.1571 15.1217 21 13 21H5C4.44772 21 4 20.5523 4 20V20C4 19.4477 4.44772 19 5 19H13C14.5913 19 16.1174 18.3679 17.2426 17.2426C18.3679 16.1174 19 14.5913 19 13C19 11.4087 18.3679 9.88258 17.2426 8.75736C16.1174 7.63214 14.5913 7 13 7H5.828Z"
    ],
    category: "System"
  },
  check: {
    paths: [
      "M10.0007 15.172L18.4859 6.68594C18.8763 6.29547 19.5094 6.29547 19.9 6.68577V6.68577C20.2907 7.07626 20.291 7.70974 19.9004 8.10036L10.7078 17.2929C10.3173 17.6834 9.68414 17.6834 9.29361 17.2929L4.34372 12.343C3.95325 11.9525 3.95325 11.3195 4.34372 10.929V10.929C4.73418 10.5385 5.36725 10.5385 5.75772 10.929L10.0007 15.172Z"
    ],
    category: "System"
  },
  "check-circle": {
    paths: [
      "M10 20C4.477 20 0 15.523 0 10C0 4.477 4.477 0 10 0C15.523 0 20 4.477 20 10C20 15.523 15.523 20 10 20ZM10 18C12.1217 18 14.1566 17.1571 15.6569 15.6569C17.1571 14.1566 18 12.1217 18 10C18 7.87827 17.1571 5.84344 15.6569 4.34315C14.1566 2.84285 12.1217 2 10 2C7.87827 2 5.84344 2.84285 4.34315 4.34315C2.84285 5.84344 2 7.87827 2 10C2 12.1217 2.84285 14.1566 4.34315 15.6569C5.84344 17.1571 7.87827 18 10 18Z",
      "M7.66667 14.6167L4 10.95L5.28333 9.66667L7.66667 12.05L13.7167 6L15 7.28333L7.66667 14.6167Z"
    ],
    category: "System"
    // information-check in figma
  },
  "share-box": {
    paths: [
      "M10 3V5H5V19H19V14H21V20C21 20.2652 20.8946 20.5196 20.7071 20.7071C20.5196 20.8946 20.2652 21 20 21H4C3.73478 21 3.48043 20.8946 3.29289 20.7071C3.10536 20.5196 3 20.2652 3 20V4C3 3.73478 3.10536 3.48043 3.29289 3.29289C3.48043 3.10536 3.73478 3 4 3H10ZM17.586 5H13V3H21V11H19V6.414L12 13.414L10.586 12L17.586 5Z"
    ],
    category: "System"
  },
  menu: {
    paths: ["M3 4H21V6H3V4ZM3 11H21V13H3V11ZM3 18H21V20H3V18Z"],
    category: "System"
  },
  "notification-4": {
    paths: [
      "M18 10C18 8.4087 17.3679 6.88258 16.2426 5.75736C15.1174 4.63214 13.5913 4 12 4C10.4087 4 8.88258 4.63214 7.75736 5.75736C6.63214 6.88258 6 8.4087 6 10V18H18V10ZM20 18.667L20.4 19.2C20.4557 19.2743 20.4896 19.3626 20.498 19.4551C20.5063 19.5476 20.4887 19.6406 20.4472 19.7236C20.4057 19.8067 20.3419 19.8765 20.2629 19.9253C20.1839 19.9741 20.0929 20 20 20H4C3.90714 20 3.81612 19.9741 3.73713 19.9253C3.65815 19.8765 3.59431 19.8067 3.55279 19.7236C3.51126 19.6406 3.49368 19.5476 3.50202 19.4551C3.51036 19.3626 3.54429 19.2743 3.6 19.2L4 18.667V10C4 7.87827 4.84286 5.84344 6.34315 4.34315C7.84344 2.84285 9.87827 2 12 2C14.1217 2 16.1566 2.84285 17.6569 4.34315C19.1571 5.84344 20 7.87827 20 10V18.667ZM9.5 21H14.5C14.5 21.663 14.2366 22.2989 13.7678 22.7678C13.2989 23.2366 12.663 23.5 12 23.5C11.337 23.5 10.7011 23.2366 10.2322 22.7678C9.76339 22.2989 9.5 21.663 9.5 21V21Z"
    ],
    category: "System"
  },
  "logo-google-drive": {
    paths: [
      "M29.5004 21L26.3296 26.5489C26.0476 27.0036 25.6517 27.3768 25.181 27.6313C24.7103 27.8859 24.1813 28.0129 23.6463 28H8.35454C7.81961 28.0129 7.29058 27.8859 6.8199 27.6313C6.34923 27.3768 5.95325 27.0036 5.67124 26.5489L4.36914 24.27L9.75824 21H29.5004Z",
      "M12.3828 4.13C11.6626 4.38843 11.0577 4.89441 10.6761 5.5576L2.95974 18.76C2.67862 19.2153 2.52139 19.7362 2.50364 20.271C2.48589 20.8058 2.60823 21.336 2.85854 21.8089L4.38854 24.2747L9.75854 21L16.0006 10.32L12.3828 4.13Z",
      "M9.75816 21H2.56836C2.62045 21.2836 2.7184 21.5568 2.85836 21.8089L4.38036 24.2632L4.36886 24.2702L5.67126 26.549C5.98317 27.0645 6.45165 27.4669 7.00836 27.6974L9.75816 21L9.75006 21.0049L9.75816 21Z",
      "M19.6062 4.13C20.3264 4.3884 20.9312 4.89439 21.3128 5.5576L29.0294 18.76C29.3105 19.2153 29.4678 19.7362 29.4855 20.271C29.5033 20.8058 29.381 21.336 29.1307 21.8089L27.6012 24.2747L22.2305 21L15.9883 10.32L19.6062 4.13Z",
      "M22.2305 21H29.4205C29.3684 21.2836 29.2704 21.5568 29.1305 21.8089L27.6081 24.2633L27.6197 24.2703L26.3175 26.549C26.0055 27.0645 25.5371 27.4669 24.9804 27.6974L22.2306 21L22.2387 21.0049L22.2305 21Z",
      "M19.6159 4.1342L19.6182 4.1302C19.5003 4.08935 19.3797 4.05651 19.2573 4.0319L16.0004 4L12.7435 4.0319C12.6211 4.05651 12.5006 4.08935 12.3826 4.1302C12.2567 4.17751 12.1341 4.23316 12.0156 4.2968L15.9893 10.32L19.9774 4.2993C19.8607 4.23642 19.7399 4.18126 19.6159 4.1342Z"
    ],
    category: "Logos"
  },
  "emotion-happy": {
    paths: [
      "M12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22ZM12 20C14.1217 20 16.1566 19.1571 17.6569 17.6569C19.1571 16.1566 20 14.1217 20 12C20 9.87827 19.1571 7.84344 17.6569 6.34315C16.1566 4.84285 14.1217 4 12 4C9.87827 4 7.84344 4.84285 6.34315 6.34315C4.84285 7.84344 4 9.87827 4 12C4 14.1217 4.84285 16.1566 6.34315 17.6569C7.84344 19.1571 9.87827 20 12 20V20ZM7 13H9C9 13.7956 9.31607 14.5587 9.87868 15.1213C10.4413 15.6839 11.2044 16 12 16C12.7956 16 13.5587 15.6839 14.1213 15.1213C14.6839 14.5587 15 13.7956 15 13H17C17 14.3261 16.4732 15.5979 15.5355 16.5355C14.5979 17.4732 13.3261 18 12 18C10.6739 18 9.40215 17.4732 8.46447 16.5355C7.52678 15.5979 7 14.3261 7 13V13ZM8 11C7.60218 11 7.22064 10.842 6.93934 10.5607C6.65804 10.2794 6.5 9.89782 6.5 9.5C6.5 9.10218 6.65804 8.72064 6.93934 8.43934C7.22064 8.15804 7.60218 8 8 8C8.39782 8 8.77936 8.15804 9.06066 8.43934C9.34196 8.72064 9.5 9.10218 9.5 9.5C9.5 9.89782 9.34196 10.2794 9.06066 10.5607C8.77936 10.842 8.39782 11 8 11ZM16 11C15.6022 11 15.2206 10.842 14.9393 10.5607C14.658 10.2794 14.5 9.89782 14.5 9.5C14.5 9.10218 14.658 8.72064 14.9393 8.43934C15.2206 8.15804 15.6022 8 16 8C16.3978 8 16.7794 8.15804 17.0607 8.43934C17.342 8.72064 17.5 9.10218 17.5 9.5C17.5 9.89782 17.342 10.2794 17.0607 10.5607C16.7794 10.842 16.3978 11 16 11Z"
    ],
    category: "User"
  },
  "user-add": {
    paths: [
      "M14 14.252V16.342C13.0949 16.022 12.1263 15.9239 11.1754 16.0558C10.2245 16.1877 9.3192 16.5459 8.53543 17.1002C7.75166 17.6545 7.11234 18.3888 6.67116 19.2414C6.22998 20.094 5.99982 21.04 6 22L4 21.999C3.99969 20.7779 4.27892 19.5729 4.8163 18.4764C5.35368 17.3799 6.13494 16.4209 7.10022 15.673C8.0655 14.9251 9.18918 14.4081 10.3852 14.1616C11.5811 13.9152 12.8177 13.9457 14 14.251V14.252ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13ZM12 11C14.21 11 16 9.21 16 7C16 4.79 14.21 3 12 3C9.79 3 8 4.79 8 7C8 9.21 9.79 11 12 11ZM18 17V14H20V17H23V19H20V22H18V19H15V17H18Z"
    ],
    category: "User"
  },
  "emotion-normal": {
    paths: [
      "M12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22ZM12 20C14.1217 20 16.1566 19.1571 17.6569 17.6569C19.1571 16.1566 20 14.1217 20 12C20 9.87827 19.1571 7.84344 17.6569 6.34315C16.1566 4.84285 14.1217 4 12 4C9.87827 4 7.84344 4.84285 6.34315 6.34315C4.84285 7.84344 4 9.87827 4 12C4 14.1217 4.84285 16.1566 6.34315 17.6569C7.84344 19.1571 9.87827 20 12 20V20ZM8 14H16V16H8V14ZM8 11C7.60218 11 7.22064 10.842 6.93934 10.5607C6.65804 10.2794 6.5 9.89782 6.5 9.5C6.5 9.10218 6.65804 8.72064 6.93934 8.43934C7.22064 8.15804 7.60218 8 8 8C8.39782 8 8.77936 8.15804 9.06066 8.43934C9.34196 8.72064 9.5 9.10218 9.5 9.5C9.5 9.89782 9.34196 10.2794 9.06066 10.5607C8.77936 10.842 8.39782 11 8 11ZM16 11C15.6022 11 15.2206 10.842 14.9393 10.5607C14.658 10.2794 14.5 9.89782 14.5 9.5C14.5 9.10218 14.658 8.72064 14.9393 8.43934C15.2206 8.15804 15.6022 8 16 8C16.3978 8 16.7794 8.15804 17.0607 8.43934C17.342 8.72064 17.5 9.10218 17.5 9.5C17.5 9.89782 17.342 10.2794 17.0607 10.5607C16.7794 10.842 16.3978 11 16 11Z"
    ],
    category: "User"
  },
  "user-search": {
    paths: [
      "M12 14V16C10.4087 16 8.88258 16.6321 7.75736 17.7574C6.63214 18.8826 6 20.4087 6 22H4C4 19.8783 4.84285 17.8434 6.34315 16.3431C7.84344 14.8429 9.87827 14 12 14V14ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13ZM12 11C14.21 11 16 9.21 16 7C16 4.79 14.21 3 12 3C9.79 3 8 4.79 8 7C8 9.21 9.79 11 12 11ZM21.446 20.032L22.95 21.536L21.536 22.95L20.032 21.446C19.1933 21.9405 18.2031 22.1121 17.247 21.9288C16.2908 21.7454 15.4343 21.2196 14.8381 20.4499C14.2419 19.6802 13.9469 18.7195 14.0083 17.7479C14.0698 16.7762 14.4835 15.8604 15.1719 15.1719C15.8604 14.4835 16.7762 14.0698 17.7479 14.0083C18.7195 13.9469 19.6802 14.2419 20.4499 14.8381C21.2196 15.4343 21.7454 16.2908 21.9288 17.247C22.1121 18.2031 21.9405 19.1933 21.446 20.032V20.032ZM18 20C18.5304 20 19.0391 19.7893 19.4142 19.4142C19.7893 19.0391 20 18.5304 20 18C20 17.4696 19.7893 16.9609 19.4142 16.5858C19.0391 16.2107 18.5304 16 18 16C17.4696 16 16.9609 16.2107 16.5858 16.5858C16.2107 16.9609 16 17.4696 16 18C16 18.5304 16.2107 19.0391 16.5858 19.4142C16.9609 19.7893 17.4696 20 18 20V20Z"
    ],
    category: "User"
  },
  "user-shared": {
    paths: [
      "M14 14.252V16.342C13.0949 16.022 12.1263 15.9239 11.1754 16.0558C10.2245 16.1877 9.3192 16.5459 8.53543 17.1002C7.75166 17.6545 7.11234 18.3888 6.67116 19.2414C6.22998 20.094 5.99982 21.04 6 22L4 21.999C3.99969 20.7779 4.27892 19.5729 4.8163 18.4764C5.35368 17.3799 6.13494 16.4209 7.10022 15.673C8.0655 14.9251 9.18918 14.4081 10.3852 14.1616C11.5811 13.9152 12.8177 13.9457 14 14.251V14.252ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13ZM12 11C14.21 11 16 9.21 16 7C16 4.79 14.21 3 12 3C9.79 3 8 4.79 8 7C8 9.21 9.79 11 12 11ZM18.586 17L16.757 15.172L18.172 13.757L22.414 18L18.172 22.243L16.757 20.828L18.586 19H15V17H18.586Z"
    ],
    category: "User"
  },
  user: {
    paths: [
      "M4 22C4 19.8783 4.84285 17.8434 6.34315 16.3431C7.84344 14.8429 9.87827 14 12 14C14.1217 14 16.1566 14.8429 17.6569 16.3431C19.1571 17.8434 20 19.8783 20 22H18C18 20.4087 17.3679 18.8826 16.2426 17.7574C15.1174 16.6321 13.5913 16 12 16C10.4087 16 8.88258 16.6321 7.75736 17.7574C6.63214 18.8826 6 20.4087 6 22H4ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13ZM12 11C14.21 11 16 9.21 16 7C16 4.79 14.21 3 12 3C9.79 3 8 4.79 8 7C8 9.21 9.79 11 12 11Z"
    ],
    category: "User"
  },
  parent: {
    paths: [
      "M7 9C7.66304 9 8.29893 8.73661 8.76777 8.26777C9.23661 7.79893 9.5 7.16304 9.5 6.5C9.5 5.83696 9.23661 5.20107 8.76777 4.73223C8.29893 4.26339 7.66304 4 7 4C6.33696 4 5.70107 4.26339 5.23223 4.73223C4.76339 5.20107 4.5 5.83696 4.5 6.5C4.5 7.16304 4.76339 7.79893 5.23223 8.26777C5.70107 8.73661 6.33696 9 7 9ZM7 11C6.40905 11 5.82389 10.8836 5.27792 10.6575C4.73196 10.4313 4.23588 10.0998 3.81802 9.68198C3.40016 9.26412 3.06869 8.76804 2.84254 8.22208C2.6164 7.67611 2.5 7.09095 2.5 6.5C2.5 5.90905 2.6164 5.32389 2.84254 4.77792C3.06869 4.23196 3.40016 3.73588 3.81802 3.31802C4.23588 2.90016 4.73196 2.56869 5.27792 2.34254C5.82389 2.1164 6.40905 2 7 2C8.19347 2 9.33807 2.47411 10.182 3.31802C11.0259 4.16193 11.5 5.30653 11.5 6.5C11.5 7.69347 11.0259 8.83807 10.182 9.68198C9.33807 10.5259 8.19347 11 7 11V11ZM17.5 13C18.0304 13 18.5391 12.7893 18.9142 12.4142C19.2893 12.0391 19.5 11.5304 19.5 11C19.5 10.4696 19.2893 9.96086 18.9142 9.58579C18.5391 9.21071 18.0304 9 17.5 9C16.9696 9 16.4609 9.21071 16.0858 9.58579C15.7107 9.96086 15.5 10.4696 15.5 11C15.5 11.5304 15.7107 12.0391 16.0858 12.4142C16.4609 12.7893 16.9696 13 17.5 13V13ZM17.5 15C16.4391 15 15.4217 14.5786 14.6716 13.8284C13.9214 13.0783 13.5 12.0609 13.5 11C13.5 9.93913 13.9214 8.92172 14.6716 8.17157C15.4217 7.42143 16.4391 7 17.5 7C18.5609 7 19.5783 7.42143 20.3284 8.17157C21.0786 8.92172 21.5 9.93913 21.5 11C21.5 12.0609 21.0786 13.0783 20.3284 13.8284C19.5783 14.5786 18.5609 15 17.5 15ZM20 21V20.5C20 19.837 19.7366 19.2011 19.2678 18.7322C18.7989 18.2634 18.163 18 17.5 18C16.837 18 16.2011 18.2634 15.7322 18.7322C15.2634 19.2011 15 19.837 15 20.5V21H13V20.5C13 19.9091 13.1164 19.3239 13.3425 18.7779C13.5687 18.232 13.9002 17.7359 14.318 17.318C14.7359 16.9002 15.232 16.5687 15.7779 16.3425C16.3239 16.1164 16.9091 16 17.5 16C18.0909 16 18.6761 16.1164 19.2221 16.3425C19.768 16.5687 20.2641 16.9002 20.682 17.318C21.0998 17.7359 21.4313 18.232 21.6575 18.7779C21.8836 19.3239 22 19.9091 22 20.5V21H20ZM10 21V17C10 16.2044 9.68393 15.4413 9.12132 14.8787C8.55871 14.3161 7.79565 14 7 14C6.20435 14 5.44129 14.3161 4.87868 14.8787C4.31607 15.4413 4 16.2044 4 17V21H2V17C2 15.6739 2.52678 14.4021 3.46447 13.4645C4.40215 12.5268 5.67392 12 7 12C8.32608 12 9.59785 12.5268 10.5355 13.4645C11.4732 14.4021 12 15.6739 12 17V21H10Z"
    ],
    category: "User"
  },
  team: {
    paths: [
      "M12 11C13.3261 11 14.5979 11.5268 15.5355 12.4645C16.4732 13.4021 17 14.6739 17 16V22H15V16C15 15.2348 14.7077 14.4985 14.1827 13.9417C13.6578 13.385 12.9399 13.0499 12.176 13.005L12 13C11.2348 13 10.4985 13.2923 9.94174 13.8173C9.38499 14.3422 9.04989 15.0601 9.005 15.824L9 16V22H7V16C7 14.6739 7.52678 13.4021 8.46447 12.4645C9.40215 11.5268 10.6739 11 12 11ZM5.5 14C5.779 14 6.05 14.033 6.31 14.094C6.13902 14.603 6.03777 15.1328 6.009 15.669L6 16V16.086C5.88505 16.0449 5.76549 16.018 5.644 16.006L5.5 16C5.12712 16 4.76761 16.1389 4.49158 16.3896C4.21555 16.6403 4.0428 16.9848 4.007 17.356L4 17.5V22H2V17.5C2 16.5717 2.36875 15.6815 3.02513 15.0251C3.6815 14.3687 4.57174 14 5.5 14V14ZM18.5 14C19.4283 14 20.3185 14.3687 20.9749 15.0251C21.6313 15.6815 22 16.5717 22 17.5V22H20V17.5C20 17.1271 19.8611 16.7676 19.6104 16.4916C19.3597 16.2156 19.0152 16.0428 18.644 16.007L18.5 16C18.325 16 18.157 16.03 18 16.085V16C18 15.334 17.892 14.694 17.691 14.096C17.95 14.033 18.221 14 18.5 14ZM5.5 8C6.16304 8 6.79893 8.26339 7.26777 8.73223C7.73661 9.20107 8 9.83696 8 10.5C8 11.163 7.73661 11.7989 7.26777 12.2678C6.79893 12.7366 6.16304 13 5.5 13C4.83696 13 4.20107 12.7366 3.73223 12.2678C3.26339 11.7989 3 11.163 3 10.5C3 9.83696 3.26339 9.20107 3.73223 8.73223C4.20107 8.26339 4.83696 8 5.5 8V8ZM18.5 8C19.163 8 19.7989 8.26339 20.2678 8.73223C20.7366 9.20107 21 9.83696 21 10.5C21 11.163 20.7366 11.7989 20.2678 12.2678C19.7989 12.7366 19.163 13 18.5 13C17.837 13 17.2011 12.7366 16.7322 12.2678C16.2634 11.7989 16 11.163 16 10.5C16 9.83696 16.2634 9.20107 16.7322 8.73223C17.2011 8.26339 17.837 8 18.5 8V8ZM5.5 10C5.36739 10 5.24021 10.0527 5.14645 10.1464C5.05268 10.2402 5 10.3674 5 10.5C5 10.6326 5.05268 10.7598 5.14645 10.8536C5.24021 10.9473 5.36739 11 5.5 11C5.63261 11 5.75979 10.9473 5.85355 10.8536C5.94732 10.7598 6 10.6326 6 10.5C6 10.3674 5.94732 10.2402 5.85355 10.1464C5.75979 10.0527 5.63261 10 5.5 10ZM18.5 10C18.3674 10 18.2402 10.0527 18.1464 10.1464C18.0527 10.2402 18 10.3674 18 10.5C18 10.6326 18.0527 10.7598 18.1464 10.8536C18.2402 10.9473 18.3674 11 18.5 11C18.6326 11 18.7598 10.9473 18.8536 10.8536C18.9473 10.7598 19 10.6326 19 10.5C19 10.3674 18.9473 10.2402 18.8536 10.1464C18.7598 10.0527 18.6326 10 18.5 10ZM12 2C13.0609 2 14.0783 2.42143 14.8284 3.17157C15.5786 3.92172 16 4.93913 16 6C16 7.06087 15.5786 8.07828 14.8284 8.82843C14.0783 9.57857 13.0609 10 12 10C10.9391 10 9.92172 9.57857 9.17157 8.82843C8.42143 8.07828 8 7.06087 8 6C8 4.93913 8.42143 3.92172 9.17157 3.17157C9.92172 2.42143 10.9391 2 12 2V2ZM12 4C11.4696 4 10.9609 4.21071 10.5858 4.58579C10.2107 4.96086 10 5.46957 10 6C10 6.53043 10.2107 7.03914 10.5858 7.41421C10.9609 7.78929 11.4696 8 12 8C12.5304 8 13.0391 7.78929 13.4142 7.41421C13.7893 7.03914 14 6.53043 14 6C14 5.46957 13.7893 4.96086 13.4142 4.58579C13.0391 4.21071 12.5304 4 12 4V4Z"
    ],
    category: "User"
  },
  "user-follow": {
    paths: [
      "M14 14.252V16.342C13.0949 16.022 12.1263 15.9239 11.1754 16.0558C10.2245 16.1877 9.3192 16.5459 8.53543 17.1002C7.75166 17.6545 7.11234 18.3888 6.67116 19.2414C6.22998 20.094 5.99982 21.04 6 22L4 21.999C3.99969 20.7779 4.27892 19.5729 4.8163 18.4764C5.35368 17.3799 6.13494 16.4209 7.10022 15.673C8.0655 14.9251 9.18918 14.4081 10.3852 14.1616C11.5811 13.9152 12.8177 13.9457 14 14.251V14.252ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13ZM12 11C14.21 11 16 9.21 16 7C16 4.79 14.21 3 12 3C9.79 3 8 4.79 8 7C8 9.21 9.79 11 12 11ZM17.793 19.914L21.328 16.379L22.743 17.793L17.793 22.743L14.257 19.207L15.672 17.793L17.792 19.914H17.793Z"
    ],
    category: "User"
  },
  "user-received": {
    paths: [
      "M14 14.252V16.342C13.0949 16.022 12.1263 15.9239 11.1754 16.0558C10.2245 16.1877 9.3192 16.5459 8.53543 17.1002C7.75166 17.6545 7.11234 18.3888 6.67116 19.2414C6.22998 20.094 5.99982 21.04 6 22L4 21.999C3.99969 20.7779 4.27892 19.5729 4.8163 18.4764C5.35368 17.3799 6.13494 16.4209 7.10022 15.673C8.0655 14.9251 9.18918 14.4081 10.3852 14.1616C11.5811 13.9152 12.8177 13.9457 14 14.251V14.252ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13ZM12 11C14.21 11 16 9.21 16 7C16 4.79 14.21 3 12 3C9.79 3 8 4.79 8 7C8 9.21 9.79 11 12 11ZM19.418 17H23.004V19H19.418L21.247 20.828L19.833 22.243L15.59 18L19.833 13.757L21.247 15.172L19.418 17Z"
    ],
    category: "User"
  },
  admin: {
    paths: [
      "M12 14V16C10.4087 16 8.88258 16.6321 7.75736 17.7574C6.63214 18.8826 6 20.4087 6 22H4C4 19.8783 4.84285 17.8434 6.34315 16.3431C7.84344 14.8429 9.87827 14 12 14V14ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13ZM12 11C14.21 11 16 9.21 16 7C16 4.79 14.21 3 12 3C9.79 3 8 4.79 8 7C8 9.21 9.79 11 12 11ZM21 17H22V22H14V17H15V16C15 15.2044 15.3161 14.4413 15.8787 13.8787C16.4413 13.3161 17.2044 13 18 13C18.7956 13 19.5587 13.3161 20.1213 13.8787C20.6839 14.4413 21 15.2044 21 16V17ZM19 17V16C19 15.7348 18.8946 15.4804 18.7071 15.2929C18.5196 15.1054 18.2652 15 18 15C17.7348 15 17.4804 15.1054 17.2929 15.2929C17.1054 15.4804 17 15.7348 17 16V17H19Z"
    ],
    category: "User"
  },
  "user-heart": {
    paths: [
      "M17.841 15.659L18.017 15.836L18.195 15.659C18.4039 15.4501 18.652 15.2843 18.925 15.1713C19.1979 15.0582 19.4905 15 19.786 15C20.0815 15 20.3741 15.0582 20.647 15.1713C20.92 15.2843 21.1681 15.4501 21.377 15.659C21.5859 15.8679 21.7517 16.116 21.8647 16.389C21.9778 16.6619 22.036 16.9545 22.036 17.25C22.036 17.5455 21.9778 17.8381 21.8647 18.111C21.7517 18.384 21.5859 18.6321 21.377 18.841L18.017 22.2L14.659 18.841C14.237 18.419 14 17.8467 14 17.25C14 16.6533 14.237 16.081 14.659 15.659C15.081 15.237 15.6533 15 16.25 15C16.8467 15 17.419 15.237 17.841 15.659V15.659ZM12 14V16C10.4087 16 8.88258 16.6321 7.75736 17.7574C6.63214 18.8826 6 20.4087 6 22H4C4.00002 19.9216 4.80894 17.9247 6.25547 16.4323C7.702 14.9398 9.67259 14.069 11.75 14.004L12 14ZM12 1C15.315 1 18 3.685 18 7C18.0006 8.55253 17.3991 10.0448 16.3221 11.163C15.2451 12.2812 13.7765 12.9383 12.225 12.996L12 13C8.685 13 6 10.315 6 7C5.99944 5.44747 6.6009 3.95521 7.67791 2.83699C8.75491 1.71877 10.2235 1.06172 11.775 1.004L12 1ZM12 3C9.79 3 8 4.79 8 7C8 9.21 9.79 11 12 11C14.21 11 16 9.21 16 7C16 4.79 14.21 3 12 3Z"
    ],
    category: "User"
  },
  "user-unfollow": {
    paths: [
      "M14 14.252V16.342C13.0949 16.022 12.1263 15.9239 11.1754 16.0558C10.2245 16.1877 9.3192 16.5459 8.53543 17.1002C7.75166 17.6545 7.11234 18.3888 6.67116 19.2414C6.22998 20.094 5.99982 21.04 6 22L4 21.999C3.99969 20.7779 4.27892 19.5729 4.8163 18.4764C5.35368 17.3799 6.13494 16.4209 7.10022 15.673C8.0655 14.9251 9.18918 14.4081 10.3852 14.1616C11.5811 13.9152 12.8177 13.9457 14 14.251V14.252ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13ZM12 11C14.21 11 16 9.21 16 7C16 4.79 14.21 3 12 3C9.79 3 8 4.79 8 7C8 9.21 9.79 11 12 11ZM19 17.586L21.121 15.464L22.536 16.879L20.414 19L22.536 21.121L21.121 22.536L19 20.414L16.879 22.536L15.464 21.121L17.586 19L15.464 16.879L16.879 15.464L19 17.586Z"
    ],
    category: "User"
  },
  "emotion-unhappy": {
    paths: [
      "M12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22ZM12 20C14.1217 20 16.1566 19.1571 17.6569 17.6569C19.1571 16.1566 20 14.1217 20 12C20 9.87827 19.1571 7.84344 17.6569 6.34315C16.1566 4.84285 14.1217 4 12 4C9.87827 4 7.84344 4.84285 6.34315 6.34315C4.84285 7.84344 4 9.87827 4 12C4 14.1217 4.84285 16.1566 6.34315 17.6569C7.84344 19.1571 9.87827 20 12 20V20ZM7 17C7 15.6739 7.52678 14.4021 8.46447 13.4645C9.40215 12.5268 10.6739 12 12 12C13.3261 12 14.5979 12.5268 15.5355 13.4645C16.4732 14.4021 17 15.6739 17 17H15C15 16.2044 14.6839 15.4413 14.1213 14.8787C13.5587 14.3161 12.7956 14 12 14C11.2044 14 10.4413 14.3161 9.87868 14.8787C9.31607 15.4413 9 16.2044 9 17H7ZM8 11C7.60218 11 7.22064 10.842 6.93934 10.5607C6.65804 10.2794 6.5 9.89782 6.5 9.5C6.5 9.10218 6.65804 8.72064 6.93934 8.43934C7.22064 8.15804 7.60218 8 8 8C8.39782 8 8.77936 8.15804 9.06066 8.43934C9.34196 8.72064 9.5 9.10218 9.5 9.5C9.5 9.89782 9.34196 10.2794 9.06066 10.5607C8.77936 10.842 8.39782 11 8 11ZM16 11C15.6022 11 15.2206 10.842 14.9393 10.5607C14.658 10.2794 14.5 9.89782 14.5 9.5C14.5 9.10218 14.658 8.72064 14.9393 8.43934C15.2206 8.15804 15.6022 8 16 8C16.3978 8 16.7794 8.15804 17.0607 8.43934C17.342 8.72064 17.5 9.10218 17.5 9.5C17.5 9.89782 17.342 10.2794 17.0607 10.5607C16.7794 10.842 16.3978 11 16 11Z"
    ],
    category: "User"
  },
  "user-voice": {
    paths: [
      "M1 22C1 19.8783 1.84285 17.8434 3.34315 16.3431C4.84344 14.8429 6.87827 14 9 14C11.1217 14 13.1566 14.8429 14.6569 16.3431C16.1571 17.8434 17 19.8783 17 22H15C15 20.4087 14.3679 18.8826 13.2426 17.7574C12.1174 16.6321 10.5913 16 9 16C7.4087 16 5.88258 16.6321 4.75736 17.7574C3.63214 18.8826 3 20.4087 3 22H1ZM9 13C5.685 13 3 10.315 3 7C3 3.685 5.685 1 9 1C12.315 1 15 3.685 15 7C15 10.315 12.315 13 9 13ZM9 11C11.21 11 13 9.21 13 7C13 4.79 11.21 3 9 3C6.79 3 5 4.79 5 7C5 9.21 6.79 11 9 11ZM21.548 0.784C22.5062 2.71583 23.0032 4.84359 23 7C23 9.233 22.477 11.344 21.548 13.216L19.903 12.02C20.6282 10.446 21.0025 8.73307 21 7C21 5.208 20.607 3.507 19.903 1.98L21.548 0.784ZM18.246 3.184C18.7454 4.39416 19.0016 5.69083 19 7C19.0016 8.30917 18.7454 9.60584 18.246 10.816L16.569 9.596C16.8552 8.76044 17.0008 7.88321 17 7C17.0011 6.11685 16.8558 5.23962 16.57 4.404L18.246 3.184Z"
    ],
    category: "User"
  },
  "camera-off": {
    paths: [
      "M19.5856 21H2.99958C2.73436 21 2.48001 20.8946 2.29247 20.7071C2.10493 20.5196 1.99958 20.2652 1.99958 20V6.00001C1.99958 5.73479 2.10493 5.48044 2.29247 5.2929C2.48001 5.10536 2.73436 5.00001 2.99958 5.00001H3.58558L1.39258 2.80801L2.80758 1.39301L22.6066 21.193L21.1916 22.607L19.5856 21ZM5.58558 7.00001H3.99958V19H17.5856L15.4056 16.82C14.3481 17.6569 13.0201 18.0762 11.6738 17.9981C10.3275 17.92 9.05677 17.35 8.10319 16.3964C7.14961 15.4428 6.57961 14.1721 6.50151 12.8258C6.42341 11.4795 6.84266 10.1515 7.67958 9.09401L5.58558 7.00001V7.00001ZM9.10958 10.525C8.64856 11.1988 8.43757 12.0125 8.5131 12.8253C8.58863 13.6382 8.94595 14.3991 9.52321 14.9764C10.1005 15.5536 10.8614 15.9109 11.6743 15.9865C12.4871 16.062 13.3008 15.851 13.9746 15.39L9.10958 10.525ZM21.9996 17.785L19.9996 15.785V7.00001H16.1716L14.1716 5.00001H9.82758L9.52058 5.30701L8.10658 3.89301L8.99958 3.00001H14.9996L16.9996 5.00001H20.9996C21.2648 5.00001 21.5191 5.10536 21.7067 5.2929C21.8942 5.48044 21.9996 5.73479 21.9996 6.00001V17.786V17.785ZM11.2626 7.05001C12.1019 6.9364 12.9562 7.01819 13.7587 7.28899C14.5613 7.55979 15.2904 8.0123 15.8894 8.61122C16.4883 9.21014 16.9408 9.9393 17.2116 10.7419C17.4824 11.5444 17.5642 12.3987 17.4506 13.238L15.1126 10.9C14.7778 10.2512 14.2494 9.72276 13.6006 9.388L11.2626 7.05001V7.05001Z"
    ],
    category: "Media"
  },
  "image-add": {
    paths: [
      "M21 15V18H24V20H21V23H19V20H16V18H19V15H21ZM21.008 3C21.556 3 22 3.445 22 3.993V13H20V5H4V18.999L14 9L17 12V14.829L14 11.829L6.827 19H14V21H2.992C2.72881 20.9997 2.4765 20.895 2.29049 20.7088C2.10448 20.5226 2 20.2702 2 20.007V3.993C2.00183 3.73038 2.1069 3.47902 2.29251 3.29322C2.47813 3.10742 2.72938 3.00209 2.992 3H21.008ZM8 7C8.53043 7 9.03914 7.21071 9.41421 7.58579C9.78929 7.96086 10 8.46957 10 9C10 9.53043 9.78929 10.0391 9.41421 10.4142C9.03914 10.7893 8.53043 11 8 11C7.46957 11 6.96086 10.7893 6.58579 10.4142C6.21071 10.0391 6 9.53043 6 9C6 8.46957 6.21071 7.96086 6.58579 7.58579C6.96086 7.21071 7.46957 7 8 7V7Z"
    ],
    category: "Media"
  },
  camera: {
    paths: [
      "M9.828 5L7.828 7H4V19H20V7H16.172L14.172 5H9.828ZM9 3H15L17 5H21C21.2652 5 21.5196 5.10536 21.7071 5.29289C21.8946 5.48043 22 5.73478 22 6V20C22 20.2652 21.8946 20.5196 21.7071 20.7071C21.5196 20.8946 21.2652 21 21 21H3C2.73478 21 2.48043 20.8946 2.29289 20.7071C2.10536 20.5196 2 20.2652 2 20V6C2 5.73478 2.10536 5.48043 2.29289 5.29289C2.48043 5.10536 2.73478 5 3 5H7L9 3ZM12 18C10.5413 18 9.14236 17.4205 8.11091 16.3891C7.07946 15.3576 6.5 13.9587 6.5 12.5C6.5 11.0413 7.07946 9.64236 8.11091 8.61091C9.14236 7.57946 10.5413 7 12 7C13.4587 7 14.8576 7.57946 15.8891 8.61091C16.9205 9.64236 17.5 11.0413 17.5 12.5C17.5 13.9587 16.9205 15.3576 15.8891 16.3891C14.8576 17.4205 13.4587 18 12 18ZM12 16C12.9283 16 13.8185 15.6313 14.4749 14.9749C15.1313 14.3185 15.5 13.4283 15.5 12.5C15.5 11.5717 15.1313 10.6815 14.4749 10.0251C13.8185 9.36875 12.9283 9 12 9C11.0717 9 10.1815 9.36875 9.52513 10.0251C8.86875 10.6815 8.5 11.5717 8.5 12.5C8.5 13.4283 8.86875 14.3185 9.52513 14.9749C10.1815 15.6313 11.0717 16 12 16V16Z"
    ],
    category: "Media"
  },
  image: {
    paths: [
      "M4.828 21L4.808 21.02L4.787 21H2.992C2.72881 20.9997 2.4765 20.895 2.29049 20.7088C2.10448 20.5226 2 20.2702 2 20.007V3.993C2.00183 3.73038 2.1069 3.47902 2.29251 3.29322C2.47813 3.10742 2.72938 3.00209 2.992 3H21.008C21.556 3 22 3.445 22 3.993V20.007C21.9982 20.2696 21.8931 20.521 21.7075 20.7068C21.5219 20.8926 21.2706 20.9979 21.008 21H4.828V21ZM20 15V5H4V19L14 9L20 15ZM20 17.828L14 11.828L6.828 19H20V17.828ZM8 11C7.46957 11 6.96086 10.7893 6.58579 10.4142C6.21071 10.0391 6 9.53043 6 9C6 8.46957 6.21071 7.96086 6.58579 7.58579C6.96086 7.21071 7.46957 7 8 7C8.53043 7 9.03914 7.21071 9.41421 7.58579C9.78929 7.96086 10 8.46957 10 9C10 9.53043 9.78929 10.0391 9.41421 10.4142C9.03914 10.7893 8.53043 11 8 11Z"
    ],
    category: "Media"
  },
  equalizer: {
    paths: [
      "M6.17 18C6.3766 17.4145 6.75974 16.9074 7.2666 16.5488C7.77346 16.1901 8.37909 15.9976 9 15.9976C9.62091 15.9976 10.2265 16.1901 10.7334 16.5488C11.2403 16.9074 11.6234 17.4145 11.83 18H22V20H11.83C11.6234 20.5855 11.2403 21.0926 10.7334 21.4512C10.2265 21.8099 9.62091 22.0025 9 22.0025C8.37909 22.0025 7.77346 21.8099 7.2666 21.4512C6.75974 21.0926 6.3766 20.5855 6.17 20H2V18H6.17ZM12.17 11C12.3766 10.4145 12.7597 9.90743 13.2666 9.54879C13.7735 9.19015 14.3791 8.99755 15 8.99755C15.6209 8.99755 16.2265 9.19015 16.7334 9.54879C17.2403 9.90743 17.6234 10.4145 17.83 11H22V13H17.83C17.6234 13.5855 17.2403 14.0926 16.7334 14.4512C16.2265 14.8099 15.6209 15.0025 15 15.0025C14.3791 15.0025 13.7735 14.8099 13.2666 14.4512C12.7597 14.0926 12.3766 13.5855 12.17 13H2V11H12.17ZM6.17 4C6.3766 3.41447 6.75974 2.90744 7.2666 2.54879C7.77346 2.19015 8.37909 1.99755 9 1.99755C9.62091 1.99755 10.2265 2.19015 10.7334 2.54879C11.2403 2.90744 11.6234 3.41447 11.83 4H22V6H11.83C11.6234 6.58553 11.2403 7.09257 10.7334 7.45121C10.2265 7.80986 9.62091 8.00245 9 8.00245C8.37909 8.00245 7.77346 7.80986 7.2666 7.45121C6.75974 7.09257 6.3766 6.58553 6.17 6H2V4H6.17ZM9 6C9.26522 6 9.51957 5.89464 9.70711 5.70711C9.89464 5.51957 10 5.26522 10 5C10 4.73478 9.89464 4.48043 9.70711 4.29289C9.51957 4.10536 9.26522 4 9 4C8.73478 4 8.48043 4.10536 8.29289 4.29289C8.10536 4.48043 8 4.73478 8 5C8 5.26522 8.10536 5.51957 8.29289 5.70711C8.48043 5.89464 8.73478 6 9 6V6ZM15 13C15.2652 13 15.5196 12.8946 15.7071 12.7071C15.8946 12.5196 16 12.2652 16 12C16 11.7348 15.8946 11.4804 15.7071 11.2929C15.5196 11.1054 15.2652 11 15 11C14.7348 11 14.4804 11.1054 14.2929 11.2929C14.1054 11.4804 14 11.7348 14 12C14 12.2652 14.1054 12.5196 14.2929 12.7071C14.4804 12.8946 14.7348 13 15 13V13ZM9 20C9.26522 20 9.51957 19.8946 9.70711 19.7071C9.89464 19.5196 10 19.2652 10 19C10 18.7348 9.89464 18.4804 9.70711 18.2929C9.51957 18.1054 9.26522 18 9 18C8.73478 18 8.48043 18.1054 8.29289 18.2929C8.10536 18.4804 8 18.7348 8 19C8 19.2652 8.10536 19.5196 8.29289 19.7071C8.48043 19.8946 8.73478 20 9 20V20Z"
    ],
    category: "Media"
  },
  "map-pin": {
    paths: [
      "M12 20.9L16.95 15.95C17.9289 14.971 18.5955 13.7237 18.8656 12.3659C19.1356 11.008 18.9969 9.6006 18.4671 8.32155C17.9373 7.04251 17.04 5.9493 15.8889 5.18017C14.7378 4.41103 13.3844 4.0005 12 4.0005C10.6156 4.0005 9.26222 4.41103 8.11109 5.18017C6.95996 5.9493 6.06275 7.04251 5.53292 8.32155C5.00308 9.6006 4.86442 11.008 5.13445 12.3659C5.40449 13.7237 6.07111 14.971 7.05 15.95L12 20.9ZM12 23.728L5.636 17.364C4.37734 16.1053 3.52019 14.5017 3.17293 12.7558C2.82567 11.01 3.00391 9.20043 3.6851 7.5559C4.36629 5.91137 5.51984 4.50577 6.99988 3.51684C8.47992 2.52791 10.22 2.00008 12 2.00008C13.78 2.00008 15.5201 2.52791 17.0001 3.51684C18.4802 4.50577 19.6337 5.91137 20.3149 7.5559C20.9961 9.20043 21.1743 11.01 20.8271 12.7558C20.4798 14.5017 19.6227 16.1053 18.364 17.364L12 23.728V23.728ZM12 13C12.5304 13 13.0391 12.7893 13.4142 12.4142C13.7893 12.0391 14 11.5304 14 11C14 10.4696 13.7893 9.96086 13.4142 9.58578C13.0391 9.21071 12.5304 9 12 9C11.4696 9 10.9609 9.21071 10.5858 9.58578C10.2107 9.96086 10 10.4696 10 11C10 11.5304 10.2107 12.0391 10.5858 12.4142C10.9609 12.7893 11.4696 13 12 13ZM12 15C10.9391 15 9.92172 14.5786 9.17158 13.8284C8.42143 13.0783 8 12.0609 8 11C8 9.93913 8.42143 8.92172 9.17158 8.17157C9.92172 7.42143 10.9391 7 12 7C13.0609 7 14.0783 7.42143 14.8284 8.17157C15.5786 8.92172 16 9.93913 16 11C16 12.0609 15.5786 13.0783 14.8284 13.8284C14.0783 14.5786 13.0609 15 12 15Z"
    ],
    category: "Map"
  },
  "map-pin-filled": {
    paths: [
      "M12 20.9L16.95 15.95C17.9289 14.971 18.5955 13.7237 18.8656 12.3659C19.1356 11.008 18.9969 9.6006 18.4671 8.32155C17.9373 7.04251 17.04 5.9493 15.8889 5.18017C14.7378 4.41103 13.3844 4.0005 12 4.0005C10.6156 4.0005 9.26222 4.41103 8.11109 5.18017C6.95996 5.9493 6.06275 7.04251 5.53292 8.32155C5.00308 9.6006 4.86442 11.008 5.13445 12.3659C5.40449 13.7237 6.07111 14.971 7.05 15.95L12 20.9Z"
    ],
    viewBox: "2 2 20 20",
    category: "Map"
  },
  "map-pin-add": {
    paths: [
      "M12 20.9L16.95 15.95C17.9289 14.971 18.5955 13.7237 18.8656 12.3659C19.1356 11.008 18.9969 9.6006 18.4671 8.32155C17.9373 7.04251 17.04 5.9493 15.8889 5.18017C14.7378 4.41103 13.3844 4.0005 12 4.0005C10.6156 4.0005 9.26222 4.41103 8.11109 5.18017C6.95996 5.9493 6.06275 7.04251 5.53292 8.32155C5.00308 9.6006 4.86442 11.008 5.13445 12.3659C5.40449 13.7237 6.07111 14.971 7.05 15.95L12 20.9ZM12 23.728L5.636 17.364C4.37734 16.1053 3.52019 14.5017 3.17293 12.7558C2.82567 11.01 3.00391 9.20043 3.6851 7.5559C4.36629 5.91137 5.51984 4.50577 6.99988 3.51684C8.47992 2.52791 10.22 2.00008 12 2.00008C13.78 2.00008 15.5201 2.52791 17.0001 3.51684C18.4802 4.50577 19.6337 5.91137 20.3149 7.5559C20.9961 9.20043 21.1743 11.01 20.8271 12.7558C20.4798 14.5017 19.6227 16.1053 18.364 17.364L12 23.728V23.728ZM11 10V7H13V10H16V12H13V15H11V12H8V10H11Z"
    ],
    category: "Map"
  },
  pushpin: {
    paths: [
      "M13.8277 1.686L22.3137 10.172L20.8987 11.586L20.1917 10.879L15.9497 15.121L15.2427 18.657L13.8277 20.071L9.58568 15.828L4.63568 20.778L3.22168 19.364L8.17168 14.414L3.92868 10.172L5.34268 8.757L8.87968 8.05L13.1217 3.808L12.4147 3.101L13.8287 1.686H13.8277ZM14.5357 5.222L9.86468 9.892L7.04268 10.457L13.5427 16.957L14.1067 14.135L18.7777 9.465L14.5357 5.222V5.222Z"
    ],
    category: "Map"
  },
  earth: {
    paths: [
      "M6.235 6.453C4.96004 7.77629 4.1795 9.49815 4.02457 11.3292C3.86964 13.1602 4.34977 14.9887 5.38426 16.5074C6.41874 18.0261 7.94451 19.1424 9.70511 19.6686C11.4657 20.1948 13.3538 20.0989 15.052 19.397C15.167 18.647 14.915 17.927 14.812 17.675C14.582 17.115 13.824 16.158 12.559 14.831C12.221 14.476 12.243 14.203 12.364 13.394L12.377 13.303C12.459 12.749 12.597 12.421 14.462 12.125C15.41 11.975 15.659 12.353 16.004 12.878L16.12 13.05C16.448 13.53 16.691 13.64 17.058 13.806C17.223 13.881 17.428 13.976 17.703 14.131C18.355 14.504 18.355 14.925 18.355 15.847V15.952C18.355 16.343 18.317 16.687 18.257 16.986C19.0244 16.0229 19.5591 14.8957 19.8196 13.6922C20.0801 12.4886 20.0593 11.2412 19.7588 10.047C19.4584 8.85284 18.8863 7.7441 18.0873 6.80714C17.2883 5.87017 16.2838 5.13026 15.152 4.645C14.599 5.018 13.84 5.547 13.575 5.91C13.44 6.095 13.248 7.042 12.625 7.12C12.463 7.14 12.244 7.126 12.012 7.111C11.39 7.071 10.54 7.016 10.268 7.755C10.095 8.223 10.065 9.495 10.624 10.155C10.714 10.26 10.731 10.455 10.67 10.674C10.59 10.961 10.429 11.136 10.378 11.172C10.282 11.116 10.09 10.893 9.959 10.742C9.646 10.377 9.254 9.922 8.748 9.782C8.564 9.731 8.362 9.689 8.165 9.647C7.616 9.532 6.995 9.401 6.85 9.093C6.744 8.867 6.745 8.556 6.745 8.228C6.745 7.811 6.745 7.34 6.541 6.883C6.47008 6.71991 6.36585 6.57344 6.235 6.453V6.453ZM12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22Z"
    ],
    category: "Map"
  },
  "map-2": {
    paths: [
      "M2 5L9 2L15 5L21.303 2.299C21.3791 2.26638 21.4621 2.25317 21.5445 2.26054C21.627 2.26792 21.7063 2.29565 21.7754 2.34124C21.8445 2.38684 21.9012 2.44888 21.9404 2.5218C21.9796 2.59471 22.0001 2.67622 22 2.759V19L15 22L9 19L2.697 21.701C2.62091 21.7336 2.53792 21.7468 2.45547 21.7395C2.37301 21.7321 2.29368 21.7044 2.22459 21.6588C2.1555 21.6132 2.09881 21.5511 2.05961 21.4782C2.02041 21.4053 1.99993 21.3238 2 21.241V5ZM16 19.395L20 17.681V5.033L16 6.747V19.395ZM14 19.264V6.736L10 4.736V17.264L14 19.264ZM8 17.253V4.605L4 6.319V18.967L8 17.253Z"
    ],
    category: "Map"
  },
  "pushpin-2": {
    paths: [
      "M18 3V5H17V11L19 14V16H13V23H11V16H5V14L7 11V5H6V3H18ZM9 5V11.606L7.404 14H16.596L15 11.606V5H9Z"
    ],
    category: "Map"
  },
  "map-pin-2": {
    paths: [
      "M12 23.728L5.636 17.364C4.37734 16.1053 3.52019 14.5017 3.17293 12.7558C2.82567 11.01 3.00391 9.20043 3.6851 7.5559C4.36629 5.91137 5.51984 4.50577 6.99988 3.51684C8.47992 2.52791 10.22 2.00008 12 2.00008C13.78 2.00008 15.5201 2.52791 17.0001 3.51684C18.4802 4.50577 19.6337 5.91137 20.3149 7.5559C20.9961 9.20043 21.1743 11.01 20.8271 12.7558C20.4798 14.5017 19.6227 16.1053 18.364 17.364L12 23.728ZM16.95 15.95C17.9289 14.971 18.5955 13.7237 18.8656 12.3659C19.1356 11.008 18.9969 9.6006 18.4671 8.32155C17.9373 7.04251 17.04 5.9493 15.8889 5.18017C14.7378 4.41103 13.3844 4.0005 12 4.0005C10.6156 4.0005 9.26222 4.41103 8.11109 5.18017C6.95996 5.9493 6.06275 7.04251 5.53292 8.32155C5.00308 9.6006 4.86442 11.008 5.13445 12.3659C5.40449 13.7237 6.07111 14.971 7.05 15.95L12 20.9L16.95 15.95V15.95ZM12 13C11.4696 13 10.9609 12.7893 10.5858 12.4142C10.2107 12.0391 10 11.5304 10 11C10 10.4696 10.2107 9.96086 10.5858 9.58578C10.9609 9.21071 11.4696 9 12 9C12.5304 9 13.0391 9.21071 13.4142 9.58578C13.7893 9.96086 14 10.4696 14 11C14 11.5304 13.7893 12.0391 13.4142 12.4142C13.0391 12.7893 12.5304 13 12 13Z"
    ],
    category: "Map"
  },
  pencil: {
    paths: [
      "M15.728 9.686L14.314 8.272L5 17.586V19H6.414L15.728 9.686ZM17.142 8.272L18.556 6.858L17.142 5.444L15.728 6.858L17.142 8.272ZM7.242 21H3V16.757L16.435 3.322C16.6225 3.13453 16.8768 3.02921 17.142 3.02921C17.4072 3.02921 17.6615 3.13453 17.849 3.322L20.678 6.151C20.8655 6.33853 20.9708 6.59284 20.9708 6.858C20.9708 7.12316 20.8655 7.37747 20.678 7.565L7.243 21H7.242Z"
    ],
    category: "Design"
  },
  "layout-left-2": {
    paths: [
      "M21 3C21.2652 3 21.5196 3.10536 21.7071 3.29289C21.8946 3.48043 22 3.73478 22 4V20C22 20.2652 21.8946 20.5196 21.7071 20.7071C21.5196 20.8946 21.2652 21 21 21H3C2.73478 21 2.48043 20.8946 2.29289 20.7071C2.10536 20.5196 2 20.2652 2 20V4C2 3.73478 2.10536 3.48043 2.29289 3.29289C2.48043 3.10536 2.73478 3 3 3H21ZM20 5H4V19H20V5ZM8 7V17H6V7H8Z"
    ],
    category: "Design"
  },
  "edit-2": {
    paths: [
      "M5 19H6.414L15.728 9.686L14.314 8.272L5 17.586V19ZM21 21H3V16.757L16.435 3.322C16.6225 3.13453 16.8768 3.02921 17.142 3.02921C17.4072 3.02921 17.6615 3.13453 17.849 3.322L20.678 6.151C20.8655 6.33853 20.9708 6.59284 20.9708 6.858C20.9708 7.12316 20.8655 7.37747 20.678 7.565L9.243 19H21V21ZM15.728 6.858L17.142 8.272L18.556 6.858L17.142 5.444L15.728 6.858V6.858Z"
    ],
    category: "Design"
  },
  "edit-box": {
    paths: [
      "M16.757 3L14.757 5H5V19H19V9.243L21 7.243V20C21 20.2652 20.8946 20.5196 20.7071 20.7071C20.5196 20.8946 20.2652 21 20 21H4C3.73478 21 3.48043 20.8946 3.29289 20.7071C3.10536 20.5196 3 20.2652 3 20V4C3 3.73478 3.10536 3.48043 3.29289 3.29289C3.48043 3.10536 3.73478 3 4 3H16.757V3ZM20.485 2.1L21.9 3.516L12.708 12.708L11.296 12.711L11.294 11.294L20.485 2.1V2.1Z"
    ],
    category: "Design"
  },
  edit: {
    paths: [
      "M6.414 16L16.556 5.858L15.142 4.444L5 14.586V16H6.414ZM7.243 18H3V13.757L14.435 2.322C14.6225 2.13453 14.8768 2.02921 15.142 2.02921C15.4072 2.02921 15.6615 2.13453 15.849 2.322L18.678 5.151C18.8655 5.33853 18.9708 5.59284 18.9708 5.858C18.9708 6.12316 18.8655 6.37747 18.678 6.565L7.243 18V18ZM3 20H21V22H3V20Z"
    ],
    category: "Design"
  },
  "layout-top-2": {
    paths: [
      "M21 3C21.2652 3 21.5196 3.10536 21.7071 3.29289C21.8946 3.48043 22 3.73478 22 4V20C22 20.2652 21.8946 20.5196 21.7071 20.7071C21.5196 20.8946 21.2652 21 21 21H3C2.73478 21 2.48043 20.8946 2.29289 20.7071C2.10536 20.5196 2 20.2652 2 20V4C2 3.73478 2.10536 3.48043 2.29289 3.29289C2.48043 3.10536 2.73478 3 3 3H21ZM20 5H4V19H20V5ZM18 7V9H6V7H18Z"
    ],
    category: "Design"
  },
  "file-list-2": {
    paths: [
      "M20 22H4C3.73478 22 3.48043 21.8946 3.29289 21.7071C3.10536 21.5196 3 21.2652 3 21V3C3 2.73478 3.10536 2.48043 3.29289 2.29289C3.48043 2.10536 3.73478 2 4 2H20C20.2652 2 20.5196 2.10536 20.7071 2.29289C20.8946 2.48043 21 2.73478 21 3V21C21 21.2652 20.8946 21.5196 20.7071 21.7071C20.5196 21.8946 20.2652 22 20 22ZM19 20V4H5V20H19ZM8 7H16V9H8V7ZM8 11H16V13H8V11ZM8 15H13V17H8V15Z"
    ],
    category: "Document"
  },
  clipboard: {
    paths: [
      "M7 4V2H17V4H20.007C20.555 4 21 4.445 21 4.993V21.007C20.9997 21.2703 20.895 21.5227 20.7089 21.7089C20.5227 21.895 20.2703 21.9997 20.007 22H3.993C3.72972 21.9997 3.4773 21.895 3.29114 21.7089C3.10497 21.5227 3.00026 21.2703 3 21.007V4.993C3 4.445 3.445 4 3.993 4H7ZM7 6H5V20H19V6H17V8H7V6ZM9 4V6H15V4H9Z"
    ],
    category: "Document"
  },
  "contacts-book-2": {
    paths: [
      "M20 22H6C5.20435 22 4.44129 21.6839 3.87868 21.1213C3.31607 20.5587 3 19.7956 3 19V5C3 4.20435 3.31607 3.44129 3.87868 2.87868C4.44129 2.31607 5.20435 2 6 2H20C20.2652 2 20.5196 2.10536 20.7071 2.29289C20.8946 2.48043 21 2.73478 21 3V21C21 21.2652 20.8946 21.5196 20.7071 21.7071C20.5196 21.8946 20.2652 22 20 22ZM19 20V18H6C5.73478 18 5.48043 18.1054 5.29289 18.2929C5.10536 18.4804 5 18.7348 5 19C5 19.2652 5.10536 19.5196 5.29289 19.7071C5.48043 19.8946 5.73478 20 6 20H19ZM5 16.17C5.313 16.06 5.65 16 6 16H19V4H6C5.73478 4 5.48043 4.10536 5.29289 4.29289C5.10536 4.48043 5 4.73478 5 5V16.17ZM12 10C11.4696 10 10.9609 9.78929 10.5858 9.41421C10.2107 9.03914 10 8.53043 10 8C10 7.46957 10.2107 6.96086 10.5858 6.58579C10.9609 6.21071 11.4696 6 12 6C12.5304 6 13.0391 6.21071 13.4142 6.58579C13.7893 6.96086 14 7.46957 14 8C14 8.53043 13.7893 9.03914 13.4142 9.41421C13.0391 9.78929 12.5304 10 12 10ZM9 14C9 13.2044 9.31607 12.4413 9.87868 11.8787C10.4413 11.3161 11.2044 11 12 11C12.7956 11 13.5587 11.3161 14.1213 11.8787C14.6839 12.4413 15 13.2044 15 14H9Z"
    ],
    category: "Document"
  },
  "file-3": {
    paths: [
      "M21 8V20.993C21.0009 21.1243 20.976 21.2545 20.9266 21.3762C20.8772 21.4979 20.8043 21.6087 20.7121 21.7022C20.6199 21.7957 20.5101 21.8701 20.3892 21.9212C20.2682 21.9723 20.1383 21.9991 20.007 22H3.993C3.72981 22 3.47739 21.8955 3.2912 21.7095C3.105 21.5235 3.00027 21.2712 3 21.008V2.992C3 2.455 3.449 2 4.002 2H14.997L21 8ZM19 9H14V4H5V20H19V9Z"
    ],
    category: "Document"
  },
  "file-lock": {
    paths: [
      "M15 4H5V20H19V8H15V4ZM3 2.992C3 2.444 3.447 2 3.999 2H16L21 7V20.993C21.0009 21.1243 20.976 21.2545 20.9266 21.3762C20.8772 21.4979 20.8043 21.6087 20.7121 21.7022C20.6199 21.7957 20.5101 21.8701 20.3892 21.9212C20.2682 21.9723 20.1383 21.9991 20.007 22H3.993C3.73038 21.9982 3.47902 21.8931 3.29322 21.7075C3.10742 21.5219 3.00209 21.2706 3 21.008V2.992ZM15 11H16V16H8V11H9V10C9 9.20435 9.31607 8.44129 9.87868 7.87868C10.4413 7.31607 11.2044 7 12 7C12.7956 7 13.5587 7.31607 14.1213 7.87868C14.6839 8.44129 15 9.20435 15 10V11ZM13 11V10C13 9.73478 12.8946 9.48043 12.7071 9.29289C12.5196 9.10536 12.2652 9 12 9C11.7348 9 11.4804 9.10536 11.2929 9.29289C11.1054 9.48043 11 9.73478 11 10V11H13Z"
    ],
    category: "Document"
  },
  "file-copy": {
    paths: [
      "M17 6V3C17 2.73478 16.8946 2.48043 16.7071 2.29289C16.5196 2.10536 16.2652 2 16 2H4C3.73478 2 3.48043 2.10536 3.29289 2.29289C3.10536 2.48043 3 2.73478 3 3V17C3 17.2652 3.10536 17.5196 3.29289 17.7071C3.48043 17.8946 3.73478 18 4 18H7V21C7 21.552 7.45 22 8.007 22H19.993C20.1249 22.0008 20.2556 21.9755 20.3777 21.9256C20.4998 21.8757 20.6108 21.8022 20.7043 21.7093C20.7979 21.6164 20.8722 21.5059 20.9229 21.3841C20.9737 21.2624 20.9999 21.1319 21 21L20.997 7C20.997 6.448 20.547 6 19.99 6H17ZM18.997 8L19 20H9V8H18.997ZM15 6H7V16H5V4H15V6Z"
    ],
    category: "Document"
  },
  draft: {
    paths: [
      "M20 2C20.552 2 21 2.448 21 3V6.757L19 8.757V4H5V20H19V17.242L21 15.242V21C21 21.552 20.552 22 20 22H4C3.448 22 3 21.552 3 21V3C3 2.448 3.448 2 4 2H20ZM21.778 8.808L23.192 10.222L15.414 18L13.998 17.998L14 16.586L21.778 8.808V8.808ZM13 12V14H8V12H13ZM16 8V10H8V8H16Z"
    ],
    category: "Document"
  },
  "folder-3": {
    paths: [
      "M12.414 5H21C21.2652 5 21.5196 5.10536 21.7071 5.29289C21.8946 5.48043 22 5.73478 22 6V20C22 20.2652 21.8946 20.5196 21.7071 20.7071C21.5196 20.8946 21.2652 21 21 21H3C2.73478 21 2.48043 20.8946 2.29289 20.7071C2.10536 20.5196 2 20.2652 2 20V4C2 3.73478 2.10536 3.48043 2.29289 3.29289C2.48043 3.10536 2.73478 3 3 3H10.414L12.414 5ZM4 7V19H20V7H4Z"
    ],
    category: "Document"
  },
  folder: {
    paths: [
      "M4 5V19H20V7H11.586L9.586 5H4ZM12.414 5H21C21.2652 5 21.5196 5.10536 21.7071 5.29289C21.8946 5.48043 22 5.73478 22 6V20C22 20.2652 21.8946 20.5196 21.7071 20.7071C21.5196 20.8946 21.2652 21 21 21H3C2.73478 21 2.48043 20.8946 2.29289 20.7071C2.10536 20.5196 2 20.2652 2 20V4C2 3.73478 2.10536 3.48043 2.29289 3.29289C2.48043 3.10536 2.73478 3 3 3H10.414L12.414 5Z"
    ],
    category: "Document"
  },
  "folder-4": {
    paths: [
      "M12.414 5H21C21.2652 5 21.5196 5.10536 21.7071 5.29289C21.8946 5.48043 22 5.73478 22 6V20C22 20.2652 21.8946 20.5196 21.7071 20.7071C21.5196 20.8946 21.2652 21 21 21H3C2.73478 21 2.48043 20.8946 2.29289 20.7071C2.10536 20.5196 2 20.2652 2 20V4C2 3.73478 2.10536 3.48043 2.29289 3.29289C2.48043 3.10536 2.73478 3 3 3H10.414L12.414 5ZM8 19H20V11H8V19ZM6 19V10C6 9.73478 6.10536 9.48043 6.29289 9.29289C6.48043 9.10536 6.73478 9 7 9H20V7H11.586L9.586 5H4V19H6Z"
    ],
    category: "Document"
  },
  "folder-copy-2": {
    paths: [
      "M17 6V3C17 2.73478 16.8946 2.48043 16.7071 2.29289C16.5196 2.10536 16.2652 2 16 2H4C3.73478 2 3.48043 2.10536 3.29289 2.29289C3.10536 2.48043 3 2.73478 3 3V17C3 17.2652 3.10536 17.5196 3.29289 17.7071C3.48043 17.8946 3.73478 18 4 18H7V21C7 21.552 7.45 22 8.007 22H19.993C20.1249 22.0008 20.2556 21.9755 20.3777 21.9256C20.4998 21.8757 20.6108 21.8022 20.7043 21.7093C20.7979 21.6164 20.8722 21.5059 20.9229 21.3841C20.9737 21.2624 20.9999 21.1319 21 21L20.997 7C20.997 6.448 20.547 6 19.991 6H17ZM18.998 8L19 20H9V8H18.998ZM15 6H7V16H5V4H15V6ZM17 11H11V13H17V11ZM17 15H11V17H17V15Z"
    ],
    category: "Document"
  },
  folders: {
    paths: [
      "M6 7V4C6 3.73478 6.10536 3.48043 6.29289 3.29289C6.48043 3.10536 6.73478 3 7 3H13.414L15.414 5H21C21.2652 5 21.5196 5.10536 21.7071 5.29289C21.8946 5.48043 22 5.73478 22 6V16C22 16.2652 21.8946 16.5196 21.7071 16.7071C21.5196 16.8946 21.2652 17 21 17H18V20C18 20.2652 17.8946 20.5196 17.7071 20.7071C17.5196 20.8946 17.2652 21 17 21H3C2.73478 21 2.48043 20.8946 2.29289 20.7071C2.10536 20.5196 2 20.2652 2 20V8C2 7.73478 2.10536 7.48043 2.29289 7.29289C2.48043 7.10536 2.73478 7 3 7H6ZM6 9H4V19H16V17H6V9ZM8 5V15H20V7H14.586L12.586 5H8Z"
    ],
    category: "Document"
  },
  task: {
    paths: [
      "M21 2.992V21.008C20.9979 21.2706 20.8926 21.5219 20.7068 21.7075C20.521 21.8931 20.2696 21.9982 20.007 22H3.993C3.72981 22 3.47739 21.8955 3.2912 21.7095C3.105 21.5235 3.00027 21.2712 3 21.008V2.992C3.00209 2.72938 3.10742 2.47813 3.29322 2.29251C3.47902 2.1069 3.73038 2.00183 3.993 2H20.007C20.555 2 21 2.444 21 2.992V2.992ZM19 4H5V20H19V4ZM11.293 13.121L15.536 8.879L16.95 10.293L11.293 15.95L7.403 12.06L8.818 10.646L11.293 13.121V13.121Z"
    ],
    category: "Document"
  },
  "vip-crown": {
    paths: [
      "M2 19H22V21H2V19ZM2 5L7 8.5L12 2L17 8.5L22 5V17H2V5ZM4 8.841V15H20V8.841L16.58 11.235L12 5.28L7.42 11.235L4 8.84V8.841Z"
    ],
    category: "Finance"
  },
  vip: {
    paths: [
      "M2 19H22V21H2V19ZM11 8H13V16H11V8ZM7.965 8H10.09L7.104 15.964H5.104L2.118 8H4.243L6.104 13.113L7.965 8ZM17 14V16H15V8H19C19.7956 8 20.5587 8.31607 21.1213 8.87868C21.6839 9.44129 22 10.2044 22 11C22 11.7956 21.6839 12.5587 21.1213 13.1213C20.5587 13.6839 19.7956 14 19 14H17ZM17 10V12H19C19.2652 12 19.5196 11.8946 19.7071 11.7071C19.8946 11.5196 20 11.2652 20 11C20 10.7348 19.8946 10.4804 19.7071 10.2929C19.5196 10.1054 19.2652 10 19 10H17ZM2 3H22V5H2V3Z"
    ],
    category: "Finance"
  },
  "vip-diamond": {
    paths: [
      "M4.87303 3H19.127C19.2848 2.99998 19.4404 3.0373 19.581 3.1089C19.7216 3.18051 19.8433 3.28437 19.936 3.412L23.759 8.668C23.827 8.76152 23.8605 8.8757 23.8537 8.99112C23.847 9.10653 23.8004 9.21603 23.722 9.301L12.367 21.602C12.2771 21.6992 12.1522 21.7568 12.0198 21.7621C11.8875 21.7673 11.7584 21.7198 11.661 21.63C11.654 21.624 7.86103 17.515 0.278033 9.301C0.199637 9.21603 0.153106 9.10653 0.14636 8.99112C0.139614 8.8757 0.17307 8.76152 0.241033 8.668L4.06403 3.412C4.15681 3.28437 4.27848 3.18051 4.41908 3.1089C4.55969 3.0373 4.71524 2.99998 4.87303 3ZM5.38303 5L2.58303 8.85L12 19.05L21.417 8.85L18.617 5H5.38303Z"
    ],
    category: "Finance"
  },
  "money-dollar": {
    paths: [
      "M8.5 14H14C14.1326 14 14.2598 13.9473 14.3536 13.8536C14.4473 13.7598 14.5 13.6326 14.5 13.5C14.5 13.3674 14.4473 13.2402 14.3536 13.1464C14.2598 13.0527 14.1326 13 14 13H10C9.33696 13 8.70107 12.7366 8.23223 12.2678C7.76339 11.7989 7.5 11.163 7.5 10.5C7.5 9.83696 7.76339 9.20107 8.23223 8.73223C8.70107 8.26339 9.33696 8 10 8H11V6H13V8H15.5V10H10C9.86739 10 9.74021 10.0527 9.64645 10.1464C9.55268 10.2402 9.5 10.3674 9.5 10.5C9.5 10.6326 9.55268 10.7598 9.64645 10.8536C9.74021 10.9473 9.86739 11 10 11H14C14.663 11 15.2989 11.2634 15.7678 11.7322C16.2366 12.2011 16.5 12.837 16.5 13.5C16.5 14.163 16.2366 14.7989 15.7678 15.2678C15.2989 15.7366 14.663 16 14 16H13V18H11V16H8.5V14Z"
    ],
    category: "Finance"
  },
  "money-dollar-circle": {
    paths: [
      "M12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22ZM12 20C14.1217 20 16.1566 19.1571 17.6569 17.6569C19.1571 16.1566 20 14.1217 20 12C20 9.87827 19.1571 7.84344 17.6569 6.34315C16.1566 4.84285 14.1217 4 12 4C9.87827 4 7.84344 4.84285 6.34315 6.34315C4.84285 7.84344 4 9.87827 4 12C4 14.1217 4.84285 16.1566 6.34315 17.6569C7.84344 19.1571 9.87827 20 12 20V20ZM8.5 14H14C14.1326 14 14.2598 13.9473 14.3536 13.8536C14.4473 13.7598 14.5 13.6326 14.5 13.5C14.5 13.3674 14.4473 13.2402 14.3536 13.1464C14.2598 13.0527 14.1326 13 14 13H10C9.33696 13 8.70107 12.7366 8.23223 12.2678C7.76339 11.7989 7.5 11.163 7.5 10.5C7.5 9.83696 7.76339 9.20107 8.23223 8.73223C8.70107 8.26339 9.33696 8 10 8H11V6H13V8H15.5V10H10C9.86739 10 9.74021 10.0527 9.64645 10.1464C9.55268 10.2402 9.5 10.3674 9.5 10.5C9.5 10.6326 9.55268 10.7598 9.64645 10.8536C9.74021 10.9473 9.86739 11 10 11H14C14.663 11 15.2989 11.2634 15.7678 11.7322C16.2366 12.2011 16.5 12.837 16.5 13.5C16.5 14.163 16.2366 14.7989 15.7678 15.2678C15.2989 15.7366 14.663 16 14 16H13V18H11V16H8.5V14Z"
    ],
    category: "Finance"
  },
  "bank-card": {
    paths: [
      "M3 3H21C21.2652 3 21.5196 3.10536 21.7071 3.29289C21.8946 3.48043 22 3.73478 22 4V20C22 20.2652 21.8946 20.5196 21.7071 20.7071C21.5196 20.8946 21.2652 21 21 21H3C2.73478 21 2.48043 20.8946 2.29289 20.7071C2.10536 20.5196 2 20.2652 2 20V4C2 3.73478 2.10536 3.48043 2.29289 3.29289C2.48043 3.10536 2.73478 3 3 3V3ZM20 11H4V19H20V11ZM20 9V5H4V9H20ZM14 15H18V17H14V15Z"
    ],
    category: "Finance"
  },
  "gift-2": {
    paths: [
      "M14.5 2C15.0906 1.9998 15.6717 2.14908 16.1892 2.43393C16.7066 2.71879 17.1435 3.12995 17.4592 3.62914C17.7749 4.12832 17.9592 4.69929 17.9948 5.28886C18.0305 5.87843 17.9163 6.46743 17.663 7.001L21 7C21.2652 7 21.5196 7.10536 21.7071 7.2929C21.8946 7.48043 22 7.73479 22 8V12C22 12.2652 21.8946 12.5196 21.7071 12.7071C21.5196 12.8946 21.2652 13 21 13H20V21C20 21.2652 19.8946 21.5196 19.7071 21.7071C19.5196 21.8946 19.2652 22 19 22H5C4.73478 22 4.48043 21.8946 4.29289 21.7071C4.10536 21.5196 4 21.2652 4 21V13H3C2.73478 13 2.48043 12.8946 2.29289 12.7071C2.10536 12.5196 2 12.2652 2 12V8C2 7.73479 2.10536 7.48043 2.29289 7.2929C2.48043 7.10536 2.73478 7 3 7L6.337 7.001C5.98076 6.25268 5.90163 5.40221 6.1137 4.601C6.32577 3.7998 6.81529 3.09985 7.4951 2.62576C8.17491 2.15167 9.0009 1.9342 9.82603 2.01207C10.6512 2.08994 11.4219 2.4581 12.001 3.051C12.326 2.71753 12.7147 2.45268 13.1439 2.27215C13.5732 2.09162 14.0343 1.99908 14.5 2V2ZM18 13H6V20H18V13ZM20 9H4V11H20V9ZM9.5 4C9.11478 4.00019 8.74441 4.14858 8.46561 4.41441C8.18682 4.68025 8.02099 5.04315 8.00248 5.42792C7.98396 5.81269 8.11419 6.18984 8.36618 6.48121C8.61816 6.77258 8.97258 6.95583 9.356 6.993L9.5 7H11V5.5C11 5.12712 10.8611 4.76761 10.6104 4.49158C10.3597 4.21556 10.0152 4.0428 9.644 4.007L9.5 4ZM14.5 4L14.356 4.007C14.0094 4.04021 13.6851 4.19298 13.4388 4.43911C13.1925 4.68525 13.0395 5.0094 13.006 5.356L13 5.5V7H14.5L14.644 6.993C15.015 6.95703 15.3594 6.7842 15.6099 6.50819C15.8605 6.23218 15.9993 5.87277 15.9993 5.5C15.9993 5.12724 15.8605 4.76783 15.6099 4.49182C15.3594 4.21581 15.015 4.04297 14.644 4.007L14.5 4Z"
    ],
    category: "Finance"
  },
  "vip-crown-2": {
    paths: [
      "M3.49189 8.06499L4.77789 19H19.2219L20.5079 8.06499L16.4979 10.738L11.9999 4.44099L7.50189 10.738L3.49189 8.06499ZM2.80089 5.19999L6.99989 7.99999L11.1859 2.13999C11.2784 2.01036 11.4005 1.9047 11.5421 1.83179C11.6837 1.75889 11.8406 1.72086 11.9999 1.72086C12.1591 1.72086 12.3161 1.75889 12.4577 1.83179C12.5993 1.9047 12.7214 2.01036 12.8139 2.13999L16.9999 7.99999L21.1999 5.19999C21.3588 5.09424 21.5447 5.0362 21.7356 5.03273C21.9265 5.02926 22.1144 5.0805 22.2771 5.18041C22.4398 5.28032 22.5705 5.42471 22.6537 5.59653C22.737 5.76834 22.7693 5.96039 22.7469 6.14999L21.1039 20.117C21.0752 20.3602 20.9583 20.5845 20.7753 20.7473C20.5922 20.91 20.3558 21 20.1109 21H3.88889C3.64395 21 3.40755 20.91 3.22451 20.7473C3.04148 20.5845 2.92454 20.3602 2.89589 20.117L1.25289 6.14899C1.23069 5.95947 1.26317 5.76756 1.34651 5.59591C1.42984 5.42425 1.56055 5.28003 1.7232 5.18025C1.88584 5.08048 2.07364 5.02932 2.26442 5.03281C2.45521 5.03631 2.641 5.09432 2.79989 5.19999H2.80089ZM11.9999 15C11.4695 15 10.9607 14.7893 10.5857 14.4142C10.2106 14.0391 9.99989 13.5304 9.99989 13C9.99989 12.4696 10.2106 11.9609 10.5857 11.5858C10.9607 11.2107 11.4695 11 11.9999 11C12.5303 11 13.039 11.2107 13.4141 11.5858C13.7892 11.9609 13.9999 12.4696 13.9999 13C13.9999 13.5304 13.7892 14.0391 13.4141 14.4142C13.039 14.7893 12.5303 15 11.9999 15Z"
    ],
    category: "Finance"
  },
  "bank-card-2": {
    paths: [
      "M3 3H21C21.2652 3 21.5196 3.10536 21.7071 3.29289C21.8946 3.48043 22 3.73478 22 4V20C22 20.2652 21.8946 20.5196 21.7071 20.7071C21.5196 20.8946 21.2652 21 21 21H3C2.73478 21 2.48043 20.8946 2.29289 20.7071C2.10536 20.5196 2 20.2652 2 20V4C2 3.73478 2.10536 3.48043 2.29289 3.29289C2.48043 3.10536 2.73478 3 3 3V3ZM20 12H4V19H20V12ZM20 8V5H4V8H20Z"
    ],
    category: "Finance"
  },
  "money-dollar-box": {
    paths: [
      "M3 3H21C21.2652 3 21.5196 3.10536 21.7071 3.29289C21.8946 3.48043 22 3.73478 22 4V20C22 20.2652 21.8946 20.5196 21.7071 20.7071C21.5196 20.8946 21.2652 21 21 21H3C2.73478 21 2.48043 20.8946 2.29289 20.7071C2.10536 20.5196 2 20.2652 2 20V4C2 3.73478 2.10536 3.48043 2.29289 3.29289C2.48043 3.10536 2.73478 3 3 3V3ZM4 5V19H20V5H4ZM8.5 14H14C14.1326 14 14.2598 13.9473 14.3536 13.8536C14.4473 13.7598 14.5 13.6326 14.5 13.5C14.5 13.3674 14.4473 13.2402 14.3536 13.1464C14.2598 13.0527 14.1326 13 14 13H10C9.33696 13 8.70107 12.7366 8.23223 12.2678C7.76339 11.7989 7.5 11.163 7.5 10.5C7.5 9.83696 7.76339 9.20107 8.23223 8.73223C8.70107 8.26339 9.33696 8 10 8H11V6H13V8H15.5V10H10C9.86739 10 9.74021 10.0527 9.64645 10.1464C9.55268 10.2402 9.5 10.3674 9.5 10.5C9.5 10.6326 9.55268 10.7598 9.64645 10.8536C9.74021 10.9473 9.86739 11 10 11H14C14.663 11 15.2989 11.2634 15.7678 11.7322C16.2366 12.2011 16.5 12.837 16.5 13.5C16.5 14.163 16.2366 14.7989 15.7678 15.2678C15.2989 15.7366 14.663 16 14 16H13V18H11V16H8.5V14Z"
    ],
    category: "Finance"
  },
  gift: {
    paths: [
      "M15 2.00001C15.7023 1.99992 16.3922 2.18474 17.0004 2.53587C17.6086 2.887 18.1137 3.39207 18.4647 4.0003C18.8158 4.60853 19.0006 5.29847 19.0005 6.00075C19.0003 6.70304 18.8153 7.39291 18.464 8.00101L23 8.00001V10H21V20C21 20.2652 20.8946 20.5196 20.7071 20.7071C20.5196 20.8946 20.2652 21 20 21H4C3.73478 21 3.48043 20.8946 3.29289 20.7071C3.10536 20.5196 3 20.2652 3 20V10H1V8.00001L5.536 8.00101C5.03986 7.14189 4.88069 6.12906 5.08938 5.15918C5.29808 4.1893 5.85975 3.33157 6.66533 2.75256C7.47092 2.17354 8.46293 1.91456 9.44875 2.02588C10.4346 2.13721 11.3438 2.61091 12 3.35501C12.3746 2.92839 12.8361 2.58678 13.3535 2.35308C13.8709 2.11939 14.4323 1.99901 15 2.00001V2.00001ZM11 10H5V19H11V10ZM19 10H13V19H19V10ZM9 4.00001C8.48102 3.99768 7.98145 4.19719 7.60685 4.55639C7.23224 4.91558 7.01193 5.40632 6.99246 5.92495C6.97299 6.44357 7.15588 6.94945 7.50249 7.33572C7.84911 7.722 8.3323 7.9584 8.85 7.99501L9 8.00001H11V6.00001C11 5.52207 10.8289 5.05992 10.5176 4.69726C10.2063 4.33461 9.77542 4.09541 9.303 4.02301L9.149 4.00501L9 4.00001ZM15 4.00001C14.4954 3.99985 14.0094 4.19041 13.6395 4.5335C13.2695 4.87659 13.0428 5.34685 13.005 5.85001L13 6.00001V8.00001H15C15.5046 8.00017 15.9906 7.8096 16.3605 7.46651C16.7305 7.12342 16.9572 6.65316 16.995 6.15001L17 6.00001C17 5.46957 16.7893 4.96087 16.4142 4.58579C16.0391 4.21072 15.5304 4.00001 15 4.00001V4.00001Z"
    ],
    category: "Finance"
  },
  "attachment-2": {
    paths: [
      "M14.8283 7.75701L9.17229 13.414C9.07678 13.5063 9.00059 13.6166 8.94819 13.7386C8.89578 13.8606 8.86819 13.9918 8.86704 14.1246C8.86588 14.2574 8.89118 14.3891 8.94147 14.512C8.99175 14.6349 9.066 14.7465 9.15989 14.8404C9.25378 14.9343 9.36544 15.0086 9.48833 15.0588C9.61123 15.1091 9.74291 15.1344 9.87569 15.1333C10.0085 15.1321 10.1397 15.1045 10.2617 15.0521C10.3837 14.9997 10.494 14.9235 10.5863 14.828L16.2433 9.17201C16.8059 8.60935 17.122 7.84623 17.122 7.05051C17.122 6.25479 16.8059 5.49167 16.2433 4.92901C15.6806 4.36635 14.9175 4.05026 14.1218 4.05026C13.3261 4.05026 12.5629 4.36635 12.0003 4.92901L6.34329 10.586C5.86936 11.0481 5.49192 11.5998 5.23284 12.2089C4.97377 12.818 4.83823 13.4726 4.83408 14.1345C4.82994 14.7964 4.95727 15.4526 5.20868 16.0649C5.4601 16.6773 5.83061 17.2336 6.2987 17.7016C6.7668 18.1696 7.32317 18.5401 7.93554 18.7914C8.54791 19.0427 9.20409 19.17 9.86602 19.1657C10.5279 19.1615 11.1824 19.0258 11.7915 18.7667C12.4006 18.5075 12.9522 18.13 13.4143 17.656L19.0713 12L20.4853 13.414L14.8283 19.071C14.1782 19.7211 13.4065 20.2367 12.5572 20.5885C11.7079 20.9403 10.7976 21.1214 9.87829 21.1214C8.95899 21.1214 8.04869 20.9403 7.19937 20.5885C6.35004 20.2367 5.57833 19.7211 4.92829 19.071C4.27824 18.421 3.7626 17.6493 3.4108 16.7999C3.059 15.9506 2.87793 15.0403 2.87793 14.121C2.87793 13.2017 3.059 12.2914 3.4108 11.4421C3.7626 10.5928 4.27824 9.82105 4.92829 9.17101L10.5863 3.51501C11.5293 2.60422 12.7923 2.10025 14.1033 2.11164C15.4143 2.12303 16.6683 2.64888 17.5954 3.57592C18.5224 4.50296 19.0483 5.75702 19.0597 7.068C19.071 8.37899 18.5671 9.642 17.6563 10.585L12.0003 16.244C11.7216 16.5226 11.3908 16.7436 11.0267 16.8943C10.6627 17.0451 10.2725 17.1227 9.87843 17.1226C9.48439 17.1226 9.09421 17.0449 8.73018 16.8941C8.36615 16.7432 8.03539 16.5222 7.75679 16.2435C7.47819 15.9648 7.2572 15.634 7.10645 15.27C6.9557 14.9059 6.87813 14.5157 6.87818 14.1217C6.87823 13.7276 6.95588 13.3374 7.10672 12.9734C7.25756 12.6094 7.47862 12.2786 7.75729 12L13.4143 6.34301L14.8283 7.75701Z"
    ],
    category: "Editor"
  },
  asterisk: {
    paths: [
      "M13.0001 3V10.267L19.2941 6.634L20.2941 8.366L14.0011 11.999L20.2941 15.634L19.2941 17.366L13.0001 13.732V21H11.0001V13.732L4.70605 17.366L3.70605 15.634L9.99905 12L3.70605 8.366L4.70605 6.634L11.0001 10.267V3H13.0001Z"
    ],
    category: "Editor"
  },
  autofill: {
    paths: [
      "M17 2V4H20.0068C20.5548 4 21 4.44516 21 4.99316V8H19V6H17V8H7V6H5V20H19V18H21V21.0068C20.9997 21.2701 20.8952 21.5228 20.709 21.709C20.5228 21.8952 20.2701 21.9997 20.0068 22H3.99316C3.72989 21.9997 3.47718 21.8952 3.29102 21.709C3.10485 21.5228 3.00026 21.2701 3 21.0068V4.99316C3 4.44516 3.44516 4 3.99316 4H7V2H17ZM9 4V6H15V4H9Z",
      "M17.4043 9.11073C17.7948 8.72042 18.4279 8.72033 18.8184 9.11073L22.707 12.9994L18.8184 16.889C18.428 17.2794 17.7948 17.2792 17.4043 16.889C17.0138 16.4985 17.0138 15.8655 17.4043 15.475L18.8789 13.9994H14.5C13.9477 13.9994 13.5 13.5517 13.5 12.9994C13.5002 12.4473 13.9478 11.9994 14.5 11.9994H18.8789L17.4043 10.5248C17.0138 10.1343 17.0138 9.50121 17.4043 9.11073Z"
    ],
    viewBox: "0 0 24 24",
    category: "Editor"
  },
  phone: {
    paths: [
      "M9.366 10.682C10.3043 12.3305 11.6695 13.6957 13.318 14.634L14.202 13.396C14.3442 13.1969 14.5544 13.0569 14.7928 13.0023C15.0313 12.9478 15.2814 12.9825 15.496 13.1C16.9103 13.8729 18.4722 14.3378 20.079 14.464C20.3298 14.4839 20.5638 14.5975 20.7345 14.7823C20.9052 14.9671 21 15.2094 21 15.461V19.923C21.0001 20.1706 20.9083 20.4094 20.7424 20.5932C20.5765 20.777 20.3483 20.8927 20.102 20.918C19.572 20.973 19.038 21 18.5 21C9.94 21 3 14.06 3 5.5C3 4.962 3.027 4.428 3.082 3.898C3.10725 3.6517 3.22298 3.42352 3.40679 3.25763C3.5906 3.09175 3.82941 2.99995 4.077 3H8.539C8.79056 2.99997 9.0329 3.09475 9.21768 3.26545C9.40247 3.43615 9.51613 3.67022 9.536 3.921C9.66222 5.52779 10.1271 7.08968 10.9 8.504C11.0175 8.71856 11.0522 8.96874 10.9977 9.2072C10.9431 9.44565 10.8031 9.65584 10.604 9.798L9.366 10.682V10.682ZM6.844 10.025L8.744 8.668C8.20478 7.50409 7.83535 6.26884 7.647 5H5.01C5.004 5.166 5.001 5.333 5.001 5.5C5 12.956 11.044 19 18.5 19C18.667 19 18.834 18.997 19 18.99V16.353C17.7312 16.1646 16.4959 15.7952 15.332 15.256L13.975 17.156C13.4287 16.9437 12.898 16.6931 12.387 16.406L12.329 16.373C10.3676 15.2567 8.74328 13.6324 7.627 11.671L7.594 11.613C7.30691 11.102 7.05628 10.5713 6.844 10.025V10.025Z"
    ],
    category: "Device"
  },
  computer: {
    paths: [
      "M4.00004 16H20V5H4.00004V16ZM13 18V20H17V22H7.00004V20H11V18H2.99204C2.86073 17.9992 2.73086 17.9725 2.60988 17.9215C2.4889 17.8704 2.37919 17.7959 2.28703 17.7024C2.19488 17.6088 2.12209 17.498 2.07284 17.3763C2.02359 17.2546 1.99885 17.1243 2.00004 16.993V4.007C2.00004 3.451 2.45504 3 2.99204 3H21.008C21.556 3 22 3.449 22 4.007V16.993C22 17.549 21.545 18 21.008 18H13V18Z"
    ],
    category: "Device"
  },
  smartphone: {
    paths: [
      "M7 4V20H17V4H7ZM6 2H18C18.2652 2 18.5196 2.10536 18.7071 2.29289C18.8946 2.48043 19 2.73478 19 3V21C19 21.2652 18.8946 21.5196 18.7071 21.7071C18.5196 21.8946 18.2652 22 18 22H6C5.73478 22 5.48043 21.8946 5.29289 21.7071C5.10536 21.5196 5 21.2652 5 21V3C5 2.73478 5.10536 2.48043 5.29289 2.29289C5.48043 2.10536 5.73478 2 6 2ZM12 17C12.2652 17 12.5196 17.1054 12.7071 17.2929C12.8946 17.4804 13 17.7348 13 18C13 18.2652 12.8946 18.5196 12.7071 18.7071C12.5196 18.8946 12.2652 19 12 19C11.7348 19 11.4804 18.8946 11.2929 18.7071C11.1054 18.5196 11 18.2652 11 18C11 17.7348 11.1054 17.4804 11.2929 17.2929C11.4804 17.1054 11.7348 17 12 17V17Z"
    ],
    category: "Device"
  },
  macbook: {
    paths: [
      "M4 5V16H20V5H4ZM2 4.007C2 3.451 2.455 3 2.992 3H21.008C21.556 3 22 3.449 22 4.007V18H2V4.007ZM1 19H23V21H1V19Z"
    ],
    category: "Device"
  },
  "chat-new": {
    paths: [
      "M14 3V5H4V18.385L5.763 17H20V10H22V18C22 18.2652 21.8946 18.5196 21.7071 18.7071C21.5196 18.8946 21.2652 19 21 19H6.455L2 22.5V4C2 3.73478 2.10536 3.48043 2.29289 3.29289C2.48043 3.10536 2.73478 3 3 3H14ZM19 3V0H21V3H24V5H21V8H19V5H16V3H19Z"
    ],
    category: "Communication"
  },
  "chat-4": {
    paths: [
      "M5.763 17H20V5H4V18.385L5.763 17ZM6.455 19L2 22.5V4C2 3.73478 2.10536 3.48043 2.29289 3.29289C2.48043 3.10536 2.73478 3 3 3H21C21.2652 3 21.5196 3.10536 21.7071 3.29289C21.8946 3.48043 22 3.73478 22 4V18C22 18.2652 21.8946 18.5196 21.7071 18.7071C21.5196 18.8946 21.2652 19 21 19H6.455Z"
    ],
    category: "Communication"
  },
  "question-answer": {
    paths: [
      "M5.455 15L1 18.5V3C1 2.73478 1.10536 2.48043 1.29289 2.29289C1.48043 2.10536 1.73478 2 2 2H17C17.2652 2 17.5196 2.10536 17.7071 2.29289C17.8946 2.48043 18 2.73478 18 3V15H5.455ZM4.763 13H16V4H3V14.385L4.763 13ZM8 17H18.237L20 18.385V8H21C21.2652 8 21.5196 8.10536 21.7071 8.29289C21.8946 8.48043 22 8.73478 22 9V22.5L17.545 19H9C8.73478 19 8.48043 18.8946 8.29289 18.7071C8.10536 18.5196 8 18.2652 8 18V17Z"
    ],
    category: "Communication"
  },
  "chat-3": {
    paths: [
      "M7.29101 20.824L2.00001 22L3.17601 16.709C2.40154 15.2604 1.99754 13.6426 2.00001 12C2.00001 6.477 6.47701 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22C10.3574 22.0025 8.73963 21.5985 7.29101 20.824V20.824ZM7.58101 18.711L8.23401 19.061C9.39256 19.6801 10.6864 20.0027 12 20C13.5823 20 15.129 19.5308 16.4446 18.6518C17.7602 17.7727 18.7855 16.5233 19.391 15.0615C19.9965 13.5997 20.155 11.9911 19.8463 10.4393C19.5376 8.88743 18.7757 7.46197 17.6569 6.34315C16.538 5.22433 15.1126 4.4624 13.5607 4.15372C12.0089 3.84504 10.4004 4.00346 8.93854 4.60896C7.47674 5.21447 6.22731 6.23984 5.34825 7.55544C4.4692 8.87103 4.00001 10.4177 4.00001 12C4.00001 13.334 4.32501 14.618 4.94001 15.766L5.28901 16.419L4.63401 19.366L7.58101 18.711V18.711Z"
    ],
    category: "Communication"
  },
  "chat-2": {
    paths: [
      "M14.45 19L12 22.5L9.55 19H3C2.73478 19 2.48043 18.8946 2.29289 18.7071C2.10536 18.5196 2 18.2652 2 18V4C2 3.73478 2.10536 3.48043 2.29289 3.29289C2.48043 3.10536 2.73478 3 3 3H21C21.2652 3 21.5196 3.10536 21.7071 3.29289C21.8946 3.48043 22 3.73478 22 4V18C22 18.2652 21.8946 18.5196 21.7071 18.7071C21.5196 18.8946 21.2652 19 21 19H14.45ZM13.409 17H20V5H4V17H10.591L12 19.012L13.409 17V17Z"
    ],
    category: "Communication"
  },
  "chat-check": {
    paths: [
      "M6.455 19L2 22.5V4C2 3.73478 2.10536 3.48043 2.29289 3.29289C2.48043 3.10536 2.73478 3 3 3H21C21.2652 3 21.5196 3.10536 21.7071 3.29289C21.8946 3.48043 22 3.73478 22 4V18C22 18.2652 21.8946 18.5196 21.7071 18.7071C21.5196 18.8946 21.2652 19 21 19H6.455ZM5.763 17H20V5H4V18.385L5.763 17ZM11.293 12.121L15.536 7.879L16.95 9.293L11.293 14.95L7.403 11.06L8.818 9.646L11.293 12.121V12.121Z"
    ],
    category: "Communication"
  },
  "message-2": {
    paths: [
      "M6.455 19L2 22.5V4C2 3.73478 2.10536 3.48043 2.29289 3.29289C2.48043 3.10536 2.73478 3 3 3H21C21.2652 3 21.5196 3.10536 21.7071 3.29289C21.8946 3.48043 22 3.73478 22 4V18C22 18.2652 21.8946 18.5196 21.7071 18.7071C21.5196 18.8946 21.2652 19 21 19H6.455ZM5.763 17H20V5H4V18.385L5.763 17ZM11 10H13V12H11V10ZM7 10H9V12H7V10ZM15 10H17V12H15V10Z"
    ],
    category: "Communication"
  },
  feedback: {
    paths: [
      "M6.455 19L2 22.5V4C2 3.73478 2.10536 3.48043 2.29289 3.29289C2.48043 3.10536 2.73478 3 3 3H21C21.2652 3 21.5196 3.10536 21.7071 3.29289C21.8946 3.48043 22 3.73478 22 4V18C22 18.2652 21.8946 18.5196 21.7071 18.7071C21.5196 18.8946 21.2652 19 21 19H6.455ZM4 18.385L5.763 17H20V5H4V18.385V18.385ZM11 13H13V15H11V13ZM11 7H13V12H11V7Z"
    ],
    category: "Communication"
  },
  "chat-heart": {
    paths: [
      "M6.455 19L2 22.5V4C2 3.73478 2.10536 3.48043 2.29289 3.29289C2.48043 3.10536 2.73478 3 3 3H21C21.2652 3 21.5196 3.10536 21.7071 3.29289C21.8946 3.48043 22 3.73478 22 4V18C22 18.2652 21.8946 18.5196 21.7071 18.7071C21.5196 18.8946 21.2652 19 21 19H6.455ZM4 18.385L5.763 17H20V5H4V18.385V18.385ZM12.018 14.7L8.659 11.34C8.23704 10.918 7.99999 10.3457 7.99999 9.749C7.99999 9.45352 8.05818 9.16094 8.17126 8.88796C8.28433 8.61497 8.45007 8.36693 8.659 8.158C8.86793 7.94907 9.11597 7.78333 9.38896 7.67026C9.66194 7.55718 9.95452 7.49899 10.25 7.49899C10.8467 7.49899 11.419 7.73604 11.841 8.158L12.018 8.335L12.195 8.158C12.4039 7.94907 12.652 7.78333 12.925 7.67026C13.1979 7.55718 13.4905 7.49899 13.786 7.49899C14.0815 7.49899 14.3741 7.55718 14.647 7.67026C14.92 7.78333 15.1681 7.94907 15.377 8.158C15.5859 8.36693 15.7517 8.61497 15.8647 8.88796C15.9778 9.16094 16.036 9.45352 16.036 9.749C16.036 10.0445 15.9778 10.3371 15.8647 10.61C15.7517 10.883 15.5859 11.1311 15.377 11.34L12.017 14.699L12.018 14.7Z"
    ],
    category: "Communication"
  },
  "chat-delete": {
    paths: [
      "M6.455 19L2 22.5V4C2 3.73478 2.10536 3.48043 2.29289 3.29289C2.48043 3.10536 2.73478 3 3 3H21C21.2652 3 21.5196 3.10536 21.7071 3.29289C21.8946 3.48043 22 3.73478 22 4V18C22 18.2652 21.8946 18.5196 21.7071 18.7071C21.5196 18.8946 21.2652 19 21 19H6.455ZM4 18.385L5.763 17H20V5H4V18.385V18.385ZM13.414 11L15.889 13.475L14.475 14.889L12 12.414L9.525 14.89L8.111 13.476L10.586 11L8.11 8.525L9.524 7.111L12 9.586L14.475 7.111L15.889 8.525L13.414 11Z"
    ],
    category: "Communication"
  },
  "chat-quote": {
    paths: [
      "M21 3C21.552 3 22 3.448 22 4V18C22 18.552 21.552 19 21 19H6.455L2 22.5V4C2 3.448 2.448 3 3 3H21ZM20 5H4V18.385L5.763 17H20V5ZM10.515 7.412L10.962 8.1C9.294 9.003 9.323 10.452 9.323 10.764C9.478 10.744 9.641 10.74 9.803 10.755C10.705 10.839 11.416 11.58 11.416 12.5C11.416 13.466 10.632 14.25 9.666 14.25C9.129 14.25 8.616 14.005 8.292 13.66C7.777 13.114 7.5 12.5 7.5 11.505C7.5 9.755 8.728 8.187 10.515 7.412V7.412ZM15.515 7.412L15.962 8.1C14.294 9.003 14.323 10.452 14.323 10.764C14.478 10.744 14.641 10.74 14.803 10.755C15.705 10.839 16.416 11.58 16.416 12.5C16.416 13.466 15.632 14.25 14.666 14.25C14.129 14.25 13.616 14.005 13.292 13.66C12.777 13.114 12.5 12.5 12.5 11.505C12.5 9.755 13.728 8.187 15.515 7.412V7.412Z"
    ],
    category: "Communication"
  },
  numbers: {
    paths: [
      "M9 18H4V10H9V18ZM7 16V12H6V16H7ZM13 16V8H12V16H13ZM15 18H10V6H15V18ZM19 16V4H18V16H19ZM21 18H16V2H21V18ZM22 22H3V20H22V22Z"
    ],
    category: "Business"
  },
  "line-chart": {
    paths: [
      "M5 3V19H21V21H3V3H5ZM20.293 6.293L21.707 7.707L16 13.414L13 10.415L8.707 14.707L7.293 13.293L13 7.586L16 10.585L20.293 6.293V6.293Z"
    ],
    category: "Business"
  },
  cloud: {
    paths: [
      "M16.9999 21H6.99987C5.5831 21.0009 4.21172 20.5004 3.12856 19.5872C2.0454 18.6739 1.32035 17.4069 1.08178 16.0103C0.843215 14.6138 1.10653 13.1779 1.82511 11.9568C2.54368 10.7358 3.67115 9.80847 5.00787 9.33899C4.96259 8.39265 5.10989 7.44697 5.44083 6.55923C5.77178 5.67149 6.2795 4.86017 6.93322 4.17441C7.58694 3.48866 8.37307 2.94275 9.24398 2.56975C10.1149 2.19675 11.0525 2.00443 11.9999 2.00443C12.9473 2.00443 13.8849 2.19675 14.7558 2.56975C15.6267 2.94275 16.4128 3.48866 17.0665 4.17441C17.7203 4.86017 18.228 5.67149 18.5589 6.55923C18.8899 7.44697 19.0372 8.39265 18.9919 9.33899C20.3286 9.80847 21.4561 10.7358 22.1746 11.9568C22.8932 13.1779 23.1565 14.6138 22.918 16.0103C22.6794 17.4069 21.9543 18.6739 20.8712 19.5872C19.788 20.5004 18.4166 21.0009 16.9999 21ZM16.9999 8.99999C17.0001 8.333 16.8669 7.67269 16.6081 7.05796C16.3493 6.44323 15.9701 5.88649 15.4928 5.42053C15.0156 4.95457 14.4499 4.58881 13.8292 4.34478C13.2084 4.10075 12.5451 3.98339 11.8783 3.9996C11.2115 4.01582 10.5547 4.16528 9.94657 4.43919C9.33841 4.7131 8.7912 5.10592 8.33716 5.59452C7.88312 6.08312 7.53143 6.65763 7.3028 7.28421C7.07417 7.9108 6.97321 8.5768 7.00587 9.24299L7.07587 10.731L5.67187 11.225C4.78238 11.5396 4.03263 12.1583 3.55497 12.9719C3.07732 13.7856 2.90249 14.7418 3.06133 15.6718C3.22018 16.6018 3.7025 17.4458 4.42314 18.0548C5.14378 18.6637 6.0564 18.9985 6.99987 19H16.9999C17.7362 18.9998 18.4582 18.7963 19.0863 18.4119C19.7144 18.0276 20.2242 17.4774 20.5596 16.8219C20.895 16.1663 21.0429 15.431 20.9871 14.6967C20.9312 13.9625 20.6738 13.258 20.2432 12.6607C19.8126 12.0634 19.2254 11.5966 18.5464 11.3116C17.8675 11.0267 17.123 10.9347 16.3951 11.0458C15.6672 11.1569 14.9841 11.4667 14.421 11.9412C13.8579 12.4157 13.4367 13.0364 13.2039 13.735L11.3059 13.102C11.7047 11.9074 12.4692 10.8685 13.491 10.1323C14.5129 9.39613 15.7404 9 16.9999 8.99999Z"
    ],
    category: "Business"
  },
  "bar-chart-2": {
    paths: [
      "M2 13H8V21H2V13ZM16 8H22V21H16V8ZM9 3H15V21H9V3ZM4 15V19H6V15H4ZM11 5V19H13V5H11ZM18 10V19H20V10H18Z"
    ],
    category: "Business"
  },
  "chart-mixed": {
    paths: [
      "M564 153C577.8 142 580 121.8 569 108C558 94.2 537.8 92 524 103L383.4 215.5L275.2 134.4C263.5 125.6 247.4 125.9 236 135L76 263C62.2 274 60 294.2 71 308C82 321.8 102.2 324 116 313L256.6 200.5L364.8 281.6C376.5 290.4 392.6 290.1 404 281L564 153zM224 320L224 512C224 529.7 238.3 544 256 544C273.7 544 288 529.7 288 512L288 320C288 302.3 273.7 288 256 288C238.3 288 224 302.3 224 320zM96 416L96 512C96 529.7 110.3 544 128 544C145.7 544 160 529.7 160 512L160 416C160 398.3 145.7 384 128 384C110.3 384 96 398.3 96 416zM384 352C366.3 352 352 366.3 352 384L352 512C352 529.7 366.3 544 384 544C401.7 544 416 529.7 416 512L416 384C416 366.3 401.7 352 384 352zM480 320L480 512C480 529.7 494.3 544 512 544C529.7 544 544 529.7 544 512L544 320C544 302.3 529.7 288 512 288C494.3 288 480 302.3 480 320z"
    ],
    viewBox: "0 0 640 640",
    category: "Business"
  },
  "mail-close": {
    paths: [
      "M22 14H20V7.238L12.072 14.338L4 7.216V19H15V21H3C2.73478 21 2.48043 20.8946 2.29289 20.7071C2.10536 20.5196 2 20.2652 2 20V4C2 3.73478 2.10536 3.48043 2.29289 3.29289C2.48043 3.10536 2.73478 3 3 3H21C21.2652 3 21.5196 3.10536 21.7071 3.29289C21.8946 3.48043 22 3.73478 22 4V14ZM4.511 5L12.061 11.662L19.502 5H4.511ZM21.414 19L23.536 21.121L22.121 22.536L20 20.414L17.879 22.536L16.464 21.121L18.586 19L16.464 16.879L17.879 15.464L20 17.586L22.121 15.464L23.536 16.879L21.414 19V19Z"
    ],
    category: "Business"
  },
  "record-mail": {
    paths: [
      "M14.2566 15C13.4613 14.0359 13.018 12.8296 12.9999 11.5798C12.9817 10.3301 13.3898 9.11142 14.1569 8.12461C14.9239 7.13779 16.0042 6.44166 17.2198 6.1509C18.4354 5.86014 19.7138 5.99208 20.8443 6.52499C21.9749 7.0579 22.8903 7.96 23.4396 9.08269C23.9889 10.2054 24.1395 11.4817 23.8665 12.7014C23.5935 13.9211 22.9132 15.0114 21.9376 15.7928C20.9621 16.5741 19.7495 16.9999 18.4996 17H5.49965C4.24977 16.9999 3.0372 16.5741 2.06166 15.7928C1.08613 15.0114 0.40583 13.9211 0.132818 12.7014C-0.140194 11.4817 0.0103691 10.2054 0.559706 9.08269C1.10904 7.96 2.02439 7.0579 3.15496 6.52499C4.28553 5.99208 5.5639 5.86014 6.77949 6.1509C7.99507 6.44166 9.07537 7.13779 9.84243 8.12461C10.6095 9.11142 11.0176 10.3301 10.9994 11.5798C10.9813 12.8296 10.538 14.0359 9.74265 15H14.2566V15ZM5.49965 15C6.4279 15 7.31814 14.6313 7.97452 13.9749C8.6309 13.3185 8.99965 12.4283 8.99965 11.5C8.99965 10.5717 8.6309 9.68151 7.97452 9.02513C7.31814 8.36875 6.4279 8 5.49965 8C4.57139 8 3.68115 8.36875 3.02477 9.02513C2.3684 9.68151 1.99965 10.5717 1.99965 11.5C1.99965 12.4283 2.3684 13.3185 3.02477 13.9749C3.68115 14.6313 4.57139 15 5.49965 15V15ZM18.4996 15C19.4279 15 20.3181 14.6313 20.9745 13.9749C21.6309 13.3185 21.9996 12.4283 21.9996 11.5C21.9996 10.5717 21.6309 9.68151 20.9745 9.02513C20.3181 8.36875 19.4279 8 18.4996 8C17.5714 8 16.6811 8.36875 16.0248 9.02513C15.3684 9.68151 14.9996 10.5717 14.9996 11.5C14.9996 12.4283 15.3684 13.3185 16.0248 13.9749C16.6811 14.6313 17.5714 15 18.4996 15V15Z"
    ],
    category: "Business"
  },
  refresh: {
    paths: [
      "M12 20C9.76667 20 7.875 19.225 6.325 17.675C4.775 16.125 4 14.2333 4 12C4 9.76667 4.775 7.875 6.325 6.325C7.875 4.775 9.76667 4 12 4C13.15 4 14.25 4.2375 15.3 4.7125C16.35 5.1875 17.25 5.86667 18 6.75V4H20V11H13V9H17.2C16.6667 8.06667 15.9375 7.33333 15.0125 6.8C14.0875 6.26667 13.0833 6 12 6C10.3333 6 8.91667 6.58333 7.75 7.75C6.58333 8.91667 6 10.3333 6 12C6 13.6667 6.58333 15.0833 7.75 16.25C8.91667 17.4167 10.3333 18 12 18C13.2833 18 14.4417 17.6333 15.475 16.9C16.5083 16.1667 17.2333 15.2 17.65 14H19.75C19.2833 15.7667 18.3333 17.2083 16.9 18.325C15.4667 19.4417 13.8333 20 12 20Z"
    ],
    category: "System"
  },
  mail: {
    paths: [
      "M3 3H21C21.2652 3 21.5196 3.10536 21.7071 3.29289C21.8946 3.48043 22 3.73478 22 4V20C22 20.2652 21.8946 20.5196 21.7071 20.7071C21.5196 20.8946 21.2652 21 21 21H3C2.73478 21 2.48043 20.8946 2.29289 20.7071C2.10536 20.5196 2 20.2652 2 20V4C2 3.73478 2.10536 3.48043 2.29289 3.29289C2.48043 3.10536 2.73478 3 3 3V3ZM20 7.238L12.072 14.338L4 7.216V19H20V7.238ZM4.511 5L12.061 11.662L19.502 5H4.511Z"
    ],
    category: "Business"
  },
  "calendar-2": {
    paths: [
      "M17 3H21C21.2652 3 21.5196 3.10536 21.7071 3.29289C21.8946 3.48043 22 3.73478 22 4V20C22 20.2652 21.8946 20.5196 21.7071 20.7071C21.5196 20.8946 21.2652 21 21 21H3C2.73478 21 2.48043 20.8946 2.29289 20.7071C2.10536 20.5196 2 20.2652 2 20V4C2 3.73478 2.10536 3.48043 2.29289 3.29289C2.48043 3.10536 2.73478 3 3 3H7V1H9V3H15V1H17V3ZM20 11H4V19H20V11ZM15 5H9V7H7V5H4V9H20V5H17V7H15V5ZM6 13H8V15H6V13ZM11 13H13V15H11V13ZM16 13H18V15H16V13Z"
    ],
    category: "Business"
  },
  "flag-2": {
    paths: [
      "M4 17V22H2V3H21.138C21.2256 2.99985 21.3118 3.02275 21.3878 3.06639C21.4638 3.11002 21.527 3.17288 21.5711 3.24864C21.6151 3.3244 21.6385 3.41042 21.6388 3.49806C21.6392 3.5857 21.6165 3.6719 21.573 3.748L18 10L21.573 16.252C21.6165 16.3281 21.6392 16.4143 21.6388 16.5019C21.6385 16.5896 21.6151 16.6756 21.5711 16.7514C21.527 16.8271 21.4638 16.89 21.3878 16.9336C21.3118 16.9773 21.2256 17.0001 21.138 17H4ZM4 5V15H18.554L15.696 10L18.554 5H4Z"
    ],
    category: "Business"
  },
  "send-plane": {
    paths: [
      "M1.92302 9.37001C1.41302 9.16501 1.41902 8.86001 1.95702 8.68101L21.043 2.31901C21.572 2.14301 21.875 2.43901 21.727 2.95701L16.273 22.043C16.123 22.572 15.798 22.596 15.556 22.113L11 13L1.92302 9.37001ZM6.81302 9.17001L12.449 11.425L15.489 17.507L19.035 5.09701L6.81202 9.17001H6.81302Z"
    ],
    category: "Business"
  },
  "send-plane-2": {
    paths: [
      "M3.741 1.40801L22.203 11.562C22.2814 11.6052 22.3468 11.6686 22.3923 11.7456C22.4378 11.8227 22.4618 11.9105 22.4618 12C22.4618 12.0895 22.4378 12.1774 22.3923 12.2544C22.3468 12.3314 22.2814 12.3949 22.203 12.438L3.741 22.592C3.66487 22.6339 3.57915 22.6552 3.49227 22.6539C3.4054 22.6525 3.32037 22.6286 3.24558 22.5844C3.17078 22.5401 3.1088 22.4772 3.06573 22.4017C3.02267 22.3263 3.00001 22.2409 3 22.154V1.84601C3.00001 1.75913 3.02267 1.67375 3.06573 1.59828C3.1088 1.52282 3.17078 1.45988 3.24558 1.41567C3.32037 1.37146 3.4054 1.3475 3.49227 1.34616C3.57915 1.34482 3.66487 1.36614 3.741 1.40801V1.40801ZM5 13V19.617L18.85 12L5 4.38301V11H10V13H5Z"
    ],
    category: "Business"
  },
  "mail-add": {
    paths: [
      "M22 13H20V7.238L12.072 14.338L4 7.216V19H14V21H3C2.73478 21 2.48043 20.8946 2.29289 20.7071C2.10536 20.5196 2 20.2652 2 20V4C2 3.73478 2.10536 3.48043 2.29289 3.29289C2.48043 3.10536 2.73478 3 3 3H21C21.2652 3 21.5196 3.10536 21.7071 3.29289C21.8946 3.48043 22 3.73478 22 4V13ZM4.511 5L12.061 11.662L19.502 5H4.511ZM21 18H24V20H21V23H19V20H16V18H19V15H21V18Z"
    ],
    category: "Business"
  },
  bookmark: {
    paths: [
      "M5 2H19C19.2652 2 19.5196 2.10536 19.7071 2.29289C19.8946 2.48043 20 2.73478 20 3V22.143C20.0001 22.2324 19.9763 22.3202 19.9309 22.3973C19.8855 22.4743 19.8204 22.5378 19.7421 22.5811C19.6639 22.6244 19.5755 22.6459 19.4861 22.6434C19.3968 22.641 19.3097 22.6146 19.234 22.567L12 18.03L4.766 22.566C4.69037 22.6135 4.60339 22.6399 4.5141 22.6424C4.42482 22.6449 4.33649 22.6235 4.2583 22.5803C4.1801 22.5371 4.11491 22.4738 4.06948 22.3969C4.02406 22.32 4.00007 22.2323 4 22.143V3C4 2.73478 4.10536 2.48043 4.29289 2.29289C4.48043 2.10536 4.73478 2 5 2ZM18 4H6V19.432L12 15.671L18 19.432V4Z"
    ],
    category: "Business"
  },
  "calendar-check": {
    paths: [
      "M9 1V3H15V1H17V3H21C21.2652 3 21.5196 3.10536 21.7071 3.29289C21.8946 3.48043 22 3.73478 22 4V20C22 20.2652 21.8946 20.5196 21.7071 20.7071C21.5196 20.8946 21.2652 21 21 21H3C2.73478 21 2.48043 20.8946 2.29289 20.7071C2.10536 20.5196 2 20.2652 2 20V4C2 3.73478 2.10536 3.48043 2.29289 3.29289C2.48043 3.10536 2.73478 3 3 3H7V1H9ZM20 10H4V19H20V10ZM15.036 11.136L16.45 12.55L11.5 17.5L7.964 13.964L9.38 12.55L11.501 14.672L15.037 11.136H15.036ZM7 5H4V8H20V5H17V6H15V5H9V6H7V5Z"
    ],
    category: "Business"
  },
  "mail-check": {
    paths: [
      "M22 14H20V7.238L12.072 14.338L4 7.216V19H14V21H3C2.73478 21 2.48043 20.8946 2.29289 20.7071C2.10536 20.5196 2 20.2652 2 20V4C2 3.73478 2.10536 3.48043 2.29289 3.29289C2.48043 3.10536 2.73478 3 3 3H21C21.2652 3 21.5196 3.10536 21.7071 3.29289C21.8946 3.48043 22 3.73478 22 4V14ZM4.511 5L12.061 11.662L19.502 5H4.511ZM19 22L15.464 18.464L16.879 17.05L19 19.172L22.536 15.636L23.95 17.05L19 22Z"
    ],
    category: "Business"
  },
  "mail-send": {
    paths: [
      "M22 20.007C21.9982 20.2696 21.8931 20.521 21.7075 20.7068C21.5219 20.8926 21.2706 20.9979 21.008 21H2.992C2.72881 20.9997 2.4765 20.895 2.29049 20.7088C2.10448 20.5226 2 20.2702 2 20.007V19H20V7.3L12 14.5L2 5.5V4C2 3.73478 2.10536 3.48043 2.29289 3.29289C2.48043 3.10536 2.73478 3 3 3H21C21.2652 3 21.5196 3.10536 21.7071 3.29289C21.8946 3.48043 22 3.73478 22 4V20.007ZM4.434 5L12 11.81L19.566 5H4.434ZM0 15H8V17H0V15ZM0 10H5V12H0V10Z"
    ],
    category: "Business"
  },
  "building-4": {
    paths: [
      "M21 20H23V22H1V20H3V3C3 2.73478 3.10536 2.48043 3.29289 2.29289C3.48043 2.10536 3.73478 2 4 2H20C20.2652 2 20.5196 2.10536 20.7071 2.29289C20.8946 2.48043 21 2.73478 21 3V20ZM19 20V4H5V20H19ZM8 11H11V13H8V11ZM8 7H11V9H8V7ZM8 15H11V17H8V15ZM13 15H16V17H13V15ZM13 11H16V13H13V11ZM13 7H16V9H13V7Z"
    ],
    category: "Buildings"
  },
  "home-2": {
    paths: [
      "M19 21H5C4.73478 21 4.48043 20.8947 4.29289 20.7071C4.10536 20.5196 4 20.2652 4 20V11H1L11.327 1.61201C11.5111 1.44449 11.7511 1.35165 12 1.35165C12.2489 1.35165 12.4889 1.44449 12.673 1.61201L23 11H20V20C20 20.2652 19.8946 20.5196 19.7071 20.7071C19.5196 20.8947 19.2652 21 19 21ZM6 19H18V9.15701L12 3.70301L6 9.15701V19Z"
    ],
    category: "Buildings"
  },
  "home-2-filled": {
    paths: [
      "M19 21H5C4.73478 21 4.48043 20.8947 4.29289 20.7071C4.10536 20.5196 4 20.2652 4 20V11H1L11.327 1.61201C11.5111 1.44449 11.7511 1.35165 12 1.35165C12.2489 1.35165 12.4889 1.44449 12.673 1.61201L23 11H20V20C20 20.2652 19.8946 20.5196 19.7071 20.7071C19.5196 20.8947 19.2652 21 19 21Z"
    ],
    category: "Buildings"
  },
  "home+building": {
    paths: [
      "M21 21H3C2.73478 21 2.48043 20.8946 2.29289 20.7071C2.10536 20.5196 2 20.2652 2 20V12.487C1.99998 12.3441 2.03059 12.2029 2.08976 12.0728C2.14892 11.9428 2.23528 11.8269 2.343 11.733L6 8.544V4C6 3.73478 6.10536 3.48043 6.29289 3.29289C6.48043 3.10536 6.73478 3 7 3H21C21.2652 3 21.5196 3.10536 21.7071 3.29289C21.8946 3.48043 22 3.73478 22 4V20C22 20.2652 21.8946 20.5196 21.7071 20.7071C21.5196 20.8946 21.2652 21 21 21ZM9 19H12V12.942L8 9.454L4 12.942V19H7V15H9V19ZM14 19H20V5H8V7.127C8.234 7.127 8.469 7.209 8.657 7.374L13.657 11.733C13.7647 11.8269 13.8511 11.9428 13.9102 12.0728C13.9694 12.2029 14 12.3441 14 12.487V19ZM16 11H18V13H16V11ZM16 15H18V17H16V15ZM16 7H18V9H16V7ZM12 7H14V9H12V7Z"
    ],
    category: "Buildings"
  },
  "home-heart": {
    paths: [
      "M20 20C20 20.2652 19.8946 20.5196 19.7071 20.7071C19.5196 20.8947 19.2652 21 19 21H5C4.73478 21 4.48043 20.8947 4.29289 20.7071C4.10536 20.5196 4 20.2652 4 20V11H1L11.327 1.61201C11.5111 1.44449 11.7511 1.35165 12 1.35165C12.2489 1.35165 12.4889 1.44449 12.673 1.61201L23 11H20V20ZM18 19V9.15701L12 3.70301L6 9.15701V19H18ZM12 17L8.641 13.641C8.43207 13.4321 8.26633 13.184 8.15326 12.9111C8.04018 12.6381 7.98199 12.3455 7.98199 12.05C7.98199 11.7545 8.04018 11.462 8.15326 11.189C8.26633 10.916 8.43207 10.6679 8.641 10.459C8.84993 10.2501 9.09797 10.0843 9.37096 9.97127C9.64394 9.8582 9.93652 9.8 10.232 9.8C10.5275 9.8 10.8201 9.8582 11.093 9.97127C11.366 10.0843 11.6141 10.2501 11.823 10.459L12 10.636L12.177 10.459C12.3859 10.2501 12.634 10.0843 12.907 9.97127C13.1799 9.8582 13.4725 9.8 13.768 9.8C14.0635 9.8 14.3561 9.8582 14.629 9.97127C14.902 10.0843 15.1501 10.2501 15.359 10.459C15.5679 10.6679 15.7337 10.916 15.8467 11.189C15.9598 11.462 16.018 11.7545 16.018 12.05C16.018 12.3455 15.9598 12.6381 15.8467 12.9111C15.7337 13.184 15.5679 13.4321 15.359 13.641L12 17Z"
    ],
    category: "Buildings"
  },
  "home-heart-filled": {
    paths: [
      "M20 20C20 20.2652 19.8946 20.5196 19.7071 20.7071C19.5196 20.8947 19.2652 21 19 21H5C4.73478 21 4.48043 20.8947 4.29289 20.7071C4.10536 20.5196 4 20.2652 4 20V11H1L11.327 1.61201C11.5111 1.44449 11.7511 1.35165 12 1.35165C12.2489 1.35165 12.4889 1.44449 12.673 1.61201L23 11H20V20ZM12 17L8.641 13.641C8.43207 13.4321 8.26633 13.184 8.15326 12.9111C8.04018 12.6381 7.98199 12.3455 7.98199 12.05C7.98199 11.7545 8.04018 11.462 8.15326 11.189C8.26633 10.916 8.43207 10.6679 8.641 10.459C8.84993 10.2501 9.09797 10.0843 9.37096 9.97127C9.64394 9.8582 9.93652 9.8 10.232 9.8C10.5275 9.8 10.8201 9.8582 11.093 9.97127C11.366 10.0843 11.6141 10.2501 11.823 10.459L12 10.636L12.177 10.459C12.3859 10.2501 12.634 10.0843 12.907 9.97127C13.1799 9.8582 13.4725 9.8 13.768 9.8C14.0635 9.8 14.3561 9.8582 14.629 9.97127C14.902 10.0843 15.1501 10.2501 15.359 10.459C15.5679 10.6679 15.7337 10.916 15.8467 11.189C15.9598 11.462 16.018 11.7545 16.018 12.05C16.018 12.3455 15.9598 12.6381 15.8467 12.9111C15.7337 13.184 15.5679 13.4321 15.359 13.641L12 17Z"
    ],
    category: "Buildings"
  },
  "arrow-out": {
    paths: [
      "M14.6667 4L16.7111 6.04444L14.1422 8.59556L15.4044 9.85778L17.9556 7.28889L20 9.33333V4L14.6667 4ZM4 9.33333L6.04444 7.28889L8.59556 9.85778L9.85778 8.59556L7.28889 6.04444L9.33333 4L4 4L4 9.33333ZM9.33333 20L7.28889 17.9556L9.85778 15.4044L8.59556 14.1422L6.04444 16.7111L4 14.6667L4 20H9.33333ZM20 14.6667L17.9556 16.7111L15.4044 14.1422L14.1422 15.4044L16.7111 17.9556L14.6667 20L20 20L20 14.6667Z"
    ],
    category: "Not In Figma"
  },
  "touch-point": {
    paths: [
      "M15.8464 13.1714L13.5982 12.0143C14.4933 11.3 15.0693 10.1857 15.0693 8.92857C15.0693 6.76429 13.3553 5 11.2528 5C9.15031 5 7.43637 6.76429 7.43637 8.92857C7.43637 10.45 8.28293 11.7714 9.51808 12.4214V14.75C8.02619 14.4214 8.1164 14.4357 7.94986 14.4357C7.58209 14.4357 7.23514 14.5857 6.97146 14.8571L6 15.8714L9.53195 19.5071C9.83033 19.8214 10.2467 20 10.6769 20H15.0485C15.7285 20 16.3044 19.5 16.4154 18.8071L16.9706 15.4429C17.1232 14.5143 16.6722 13.6 15.8464 13.1714ZM15.6036 15.2071L15.0485 18.5714H10.6769C10.6144 18.5714 10.5589 18.5429 10.5104 18.5L7.9568 15.8714L10.9059 16.5071V8.92857C10.9059 8.72857 11.0585 8.57143 11.2528 8.57143C11.4471 8.57143 11.5998 8.72857 11.5998 8.92857V13.2143H12.821L15.2219 14.45C15.4995 14.5929 15.6522 14.9 15.6036 15.2071ZM8.82417 8.92857C8.82417 7.55 9.9136 6.42857 11.2528 6.42857C12.5921 6.42857 13.6815 7.55 13.6815 8.92857C13.6815 9.60714 13.4178 10.2214 12.9876 10.6714V8.92857C12.9876 7.94286 12.2104 7.14286 11.2528 7.14286C10.2952 7.14286 9.51808 7.94286 9.51808 8.92857V10.6714C9.08786 10.2214 8.82417 9.60714 8.82417 8.92857Z"
    ],
    category: "Not In Figma"
  },
  tag: {
    paths: [
      "M8.6 8.8C9.26274 8.8 9.8 8.26274 9.8 7.6C9.8 6.93726 9.26274 6.4 8.6 6.4C7.93726 6.4 7.4 6.93726 7.4 7.6C7.4 8.26274 7.93726 8.8 8.6 8.8Z",
      "M20.528 11.664L13.328 4.464C13.04 4.176 12.64 4 12.2 4H6.6C5.72 4 5 4.72 5 5.6V11.2C5 11.64 5.176 12.04 5.472 12.336L12.672 19.536C12.96 19.824 13.36 20 13.8 20C14.24 20 14.64 19.824 14.928 19.528L20.528 13.928C20.824 13.64 21 13.24 21 12.8C21 12.36 20.816 11.952 20.528 11.664ZM13.8 18.408L6.6 11.2V5.6H12.2V5.592L19.4 12.792L13.8 18.408V18.408Z"
    ],
    category: "System"
    // called label in Figma
  },
  angle: {
    paths: [
      "M14.6,17.8c0.4,0.4,0.4,1,0,1.4l0,0c-0.4,0.4-1,0.4-1.4,0l-7.1-7.1L13.2,5c0.4-0.4,1-0.4,1.4,0l0,0c0.4,0.4,0.4,1,0,1.4L9,12",
      "M12.8,18l-1.4-1.4c2.6-2.6,2.6-6.7,0-9.3L12.8,6C16.1,9.3,16.1,14.7,12.8,18z"
    ],
    category: "Not In Figma"
  },
  percent: {
    paths: [
      "M19 3.58587L3.58594 18.9999L5.00014 20.4141L20.4142 5.00006L19 3.58587Z",
      "M7 11C9.209 11 11 9.209 11 7C11 4.791 9.209 3 7 3C4.791 3 3 4.791 3 7C3 9.209 4.791 11 7 11ZM7 5C8.103 5 9 5.897 9 7C9 8.103 8.103 9 7 9C5.897 9 5 8.103 5 7C5 5.897 5.897 5 7 5Z",
      "M17 21C19.209 21 21 19.209 21 17C21 14.791 19.209 13 17 13C14.791 13 13 14.791 13 17C13 19.209 14.791 21 17 21ZM17 15C18.103 15 19 15.897 19 17C19 18.103 18.103 19 17 19C15.897 19 15 18.103 15 17C15 15.897 15.897 15 17 15Z"
    ],
    category: "System"
  },
  bolt: {
    paths: [
      "M10.0568 1.36475L3.20312 9.83535H7.204L6.21909 15.25C6.21722 15.2606 6.2177 15.2715 6.2205 15.2819C6.22329 15.2923 6.22834 15.302 6.23529 15.3103C6.24223 15.3185 6.2509 15.3251 6.26069 15.3297C6.27047 15.3342 6.28113 15.3366 6.29192 15.3365V15.3365C6.3034 15.3365 6.31472 15.3338 6.32497 15.3287C6.33523 15.3235 6.34414 15.3161 6.351 15.3068L13.2053 6.83469H9.20443L10.194 1.41945C10.1954 1.40866 10.1944 1.39772 10.1911 1.38734C10.1879 1.37696 10.1825 1.36738 10.1753 1.35925C10.1681 1.35112 10.1592 1.34462 10.1493 1.34018C10.1394 1.33574 10.1286 1.33346 10.1178 1.3335V1.3335C10.1059 1.33354 10.0941 1.3364 10.0835 1.34183C10.0729 1.34726 10.0638 1.35512 10.0568 1.36475V1.36475Z"
    ],
    viewBox: "0 0 16 16",
    category: "System"
  },
  "resize-vertical": {
    paths: [
      "M11.891 9.992a1 1 0 1 1 1.416 1.415l-4.3 4.3a1 1 0 0 1-1.414 0l-4.3-4.3A1 1 0 0 1 4.71 9.992l3.59 3.591 3.591-3.591zm0-3.984L8.3 2.417 4.709 6.008a1 1 0 0 1-1.416-1.415l4.3-4.3a1 1 0 0 1 1.414 0l4.3 4.3a1 1 0 1 1-1.416 1.415z"
    ],
    viewBox: "0 0 16 16",
    category: "Not In Figma"
  },
  "share-forward-fill-down": {
    paths: [
      "M5 10L5 8C5.00063 6.3596 4.55286 4.75023 3.7051 3.34588C2.85734 1.94152 1.64184 0.795601 0.190001 0.0320007C0.459466 0.0105373 0.729681 -0.00013795 1 6.76941e-07C6.523 9.18359e-07 11 4.477 11 10L16 10L8 20L-4.37114e-07 10L5 10Z"
    ],
    viewBox: "0 0 16 20",
    category: "System"
  },
  "directions-car": {
    paths: [
      "M15.7667 5.00841C15.6 4.51675 15.1333 4.16675 14.5833 4.16675H5.41667C4.86667 4.16675 4.40833 4.51675 4.23333 5.00841L2.5 10.0001V16.6667C2.5 17.1251 2.875 17.5001 3.33333 17.5001H4.16667C4.625 17.5001 5 17.1251 5 16.6667V15.8334H15V16.6667C15 17.1251 15.375 17.5001 15.8333 17.5001H16.6667C17.125 17.5001 17.5 17.1251 17.5 16.6667V10.0001L15.7667 5.00841ZM5.70833 5.83341H14.2833L15.1833 8.42508H4.80833L5.70833 5.83341ZM15.8333 14.1667H4.16667V10.0001H15.8333V14.1667Z",
      "M6.25 13.3333C6.94036 13.3333 7.5 12.7736 7.5 12.0833C7.5 11.3929 6.94036 10.8333 6.25 10.8333C5.55964 10.8333 5 11.3929 5 12.0833C5 12.7736 5.55964 13.3333 6.25 13.3333Z",
      "M13.75 13.3333C14.4404 13.3333 15 12.7736 15 12.0833C15 11.3929 14.4404 10.8333 13.75 10.8333C13.0596 10.8333 12.5 11.3929 12.5 12.0833C12.5 12.7736 13.0596 13.3333 13.75 13.3333Z"
    ],
    category: "Not In Figma"
  },
  roofing: {
    paths: [
      "M10.8337 15H9.16699V13.3333H10.8337V15ZM12.5003 11.6667H7.50033V16.6667H12.5003V11.6667ZM15.8337 7.75V3.33333H13.3337V5.5L10.0003 2.5L1.66699 10H4.16699L10.0003 4.74167L15.8337 10H18.3337L15.8337 7.75Z"
    ],
    category: "Not In Figma"
  },
  hotel: {
    paths: [
      "M5.83301 11.6667C7.21634 11.6667 8.33301 10.5501 8.33301 9.16675C8.33301 7.78341 7.21634 6.66675 5.83301 6.66675C4.44967 6.66675 3.33301 7.78341 3.33301 9.16675C3.33301 10.5501 4.44967 11.6667 5.83301 11.6667ZM5.83301 8.33341C6.29134 8.33341 6.66634 8.70841 6.66634 9.16675C6.66634 9.62508 6.29134 10.0001 5.83301 10.0001C5.37467 10.0001 4.99967 9.62508 4.99967 9.16675C4.99967 8.70841 5.37467 8.33341 5.83301 8.33341ZM15.833 5.83341H9.16634V12.5001H2.49967V4.16675H0.833008V16.6667H2.49967V14.1667H17.4997V16.6667H19.1663V9.16675C19.1663 7.32508 17.6747 5.83341 15.833 5.83341ZM17.4997 12.5001H10.833V7.50008H15.833C16.7497 7.50008 17.4997 8.25008 17.4997 9.16675V12.5001Z"
    ],
    category: "Not In Figma"
  },
  hvac: {
    paths: [
      "M15.8333 2.5H4.16667C3.25 2.5 2.5 3.25 2.5 4.16667V15.8333C2.5 16.75 3.25 17.5 4.16667 17.5H15.8333C16.75 17.5 17.5 16.75 17.5 15.8333V4.16667C17.5 3.25 16.75 2.5 15.8333 2.5ZM15.8333 15.8333H4.16667V4.16667H15.8333V15.8333Z",
      "M10 15C12.7583 15 15 12.7583 15 10C15 7.24167 12.7583 5 10 5C7.24167 5 5 7.24167 5 10C5 12.7583 7.24167 15 10 15ZM12.8667 8.33333C13.0833 8.70833 13.2333 9.13333 13.2917 9.58333H6.70833C6.76667 9.13333 6.90833 8.70833 7.13333 8.33333H12.8667ZM13.2917 10.4167C13.2333 10.8667 13.0917 11.2917 12.8667 11.6667H7.13333C6.91667 11.2917 6.76667 10.8667 6.70833 10.4167H13.2917ZM7.81667 12.5H12.1833C11.6 13.0083 10.8417 13.3333 10 13.3333C9.15833 13.3333 8.40833 13.0083 7.81667 12.5ZM12.1833 7.5H7.81667C8.4 6.99167 9.15833 6.66667 10 6.66667C10.8417 6.66667 11.5917 6.99167 12.1833 7.5Z"
    ],
    category: "Not In Figma"
  },
  "rotate-right": {
    paths: [
      "M15.55 5.55L11 1V4.07C7.06 4.56 4 7.92 4 12C4 16.08 7.05 19.44 11 19.93V17.91C8.16 17.43 6 14.97 6 12C6 9.03 8.16 6.57 11 6.09V10L15.55 5.55ZM19.93 11C19.76 9.61 19.21 8.27 18.31 7.11L16.89 8.53C17.43 9.28 17.77 10.13 17.91 11H19.93ZM13 17.9V19.92C14.39 19.75 15.74 19.21 16.9 18.31L15.46 16.87C14.71 17.41 13.87 17.76 13 17.9ZM16.89 15.48L18.31 16.89C19.21 15.73 19.76 14.39 19.93 13H17.91C17.77 13.87 17.43 14.72 16.89 15.48V15.48Z"
    ],
    category: "System"
  },
  "side-nav-collapse-2": {
    paths: [
      "M4.05579 18H17.479V16H4.05579V18ZM4.05579 13H14.3814V11H4.05579V13ZM4.05579 6V8H17.479V6H4.05579ZM22.6418 15.59L18.9453 12L22.6418 8.41L21.1859 7L16.0231 12L21.1859 17L22.6418 15.59Z"
    ],
    viewBox: "0 0 26 24",
    category: "Not In Figma"
    // side-nav-collapse is under system, but there is no -2
  },
  "side-nav-expand-2": {
    paths: [
      "M21 6L8 6V8L21 8V6ZM21 11H11V13H21V11ZM21 18V16L8 16V18H21ZM3 8.41L6.58 12L3 15.59L4.41 17L9.41 12L4.41 7L3 8.41Z"
    ],
    viewBox: "0 0 24 24",
    category: "Not In Figma"
    // side-nav-expand is under system, but there is no -2
  },
  "cloud-upload": {
    paths: [
      "M22.4788 69.1667C17.2337 69.1667 12.7523 67.3511 9.03457 63.7198C5.31686 60.0886 3.45801 55.6504 3.45801 50.4052C3.45801 45.9094 4.81252 41.9035 7.52155 38.3875C10.2306 34.8716 13.7754 32.6237 18.1559 31.6438C19.5969 26.341 22.4788 22.0469 26.8018 18.7615C31.1247 15.4761 36.024 13.8334 41.4997 13.8334C48.2434 13.8334 53.9641 16.1822 58.6617 20.8797C63.3592 25.5773 65.708 31.298 65.708 38.0417C69.6851 38.5028 72.9849 40.2176 75.6075 43.186C78.2301 46.1544 79.5413 49.6271 79.5413 53.6042C79.5413 57.9271 78.0283 61.6016 75.0023 64.6276C71.9762 67.6537 68.3018 69.1667 63.9788 69.1667H44.958C43.0559 69.1667 41.4276 68.4895 40.0731 67.1349C38.7186 65.7804 38.0413 64.1521 38.0413 62.25V44.4396L32.508 49.8L27.6663 44.9584L41.4997 31.125L55.333 44.9584L50.4913 49.8L44.958 44.4396V62.25H63.9788C66.3997 62.25 68.4459 61.4143 70.1174 59.7427C71.7889 58.0712 72.6247 56.025 72.6247 53.6042C72.6247 51.1834 71.7889 49.1372 70.1174 47.4657C68.4459 45.7941 66.3997 44.9584 63.9788 44.9584H58.7913V38.0417C58.7913 33.2577 57.1054 29.1797 53.7335 25.8079C50.3617 22.436 46.2837 20.75 41.4997 20.75C36.7156 20.75 32.6377 22.436 29.2658 25.8079C25.8939 29.1797 24.208 33.2577 24.208 38.0417H22.4788C19.1358 38.0417 16.2827 39.2233 13.9195 41.5865C11.5563 43.9497 10.3747 46.8028 10.3747 50.1459C10.3747 53.4889 11.5563 56.3421 13.9195 58.7052C16.2827 61.0684 19.1358 62.25 22.4788 62.25H31.1247V69.1667H22.4788Z"
    ],
    viewBox: "0 0 83 83",
    category: "System"
  },
  "mls-listing": {
    paths: [
      "M19 14V7.5L14 4L9 7.5V9H7V6.5L14 1.5L21 6.5V14H19ZM14.5 8H15.5V7H14.5V8ZM12.5 8H13.5V7H12.5V8ZM14.5 10H15.5V9H14.5V10ZM12.5 10H13.5V9H12.5V10ZM14 22.5L7 20.55V22H1V11H8.95L15.15 13.3C15.7 13.5 16.1458 13.85 16.4875 14.35C16.8292 14.85 17 15.4 17 16H19C19.8333 16 20.5417 16.275 21.125 16.825C21.7083 17.375 22 18.1 22 19V20L14 22.5ZM3 20H5V13H3V20ZM13.95 20.4L19.9 18.55C19.85 18.3667 19.7375 18.2292 19.5625 18.1375C19.3875 18.0458 19.2 18 19 18H14.2C13.6833 18 13.2167 17.9667 12.8 17.9C12.3833 17.8333 11.9333 17.7167 11.45 17.55L9.725 16.95L10.3 15.05L12.3 15.7C12.6 15.8 12.95 15.875 13.35 15.925C13.75 15.975 14.3 16 15 16C15 15.8167 14.9458 15.6417 14.8375 15.475C14.7292 15.3083 14.6 15.2 14.45 15.15L8.6 13H7V18.5L13.95 20.4Z"
    ],
    category: "Business"
  },
  "street-view": {
    paths: [
      "M7.875 18C6.59167 18 5.61667 17.525 4.95 16.575C4.28333 15.625 3.96667 14.5583 4 13.375L3.55 12.7C3.36667 12.4167 3.0625 11.775 2.6375 10.775C2.2125 9.775 2 8.51667 2 7C2 5.28333 2.425 3.85417 3.275 2.7125C4.125 1.57083 5.2 1 6.5 1C7.91667 1 9.02083 1.62917 9.8125 2.8875C10.6042 4.14583 11 5.51667 11 7C11 7.96667 10.8667 8.85833 10.6 9.675C10.3333 10.4917 10.1 11.15 9.9 11.65L10.1 11.975C10.2333 12.2083 10.4167 12.5792 10.65 13.0875C10.8833 13.5958 11 14.125 11 14.675C11 15.625 10.7042 16.4167 10.1125 17.05C9.52083 17.6833 8.775 18 7.875 18ZM5.25 11.6L8 11.05C8.21667 10.5167 8.4375 9.90833 8.6625 9.225C8.8875 8.54167 9 7.8 9 7C9 6 8.77083 5.08333 8.3125 4.25C7.85417 3.41667 7.25 3 6.5 3C5.75 3 5.14583 3.41667 4.6875 4.25C4.22917 5.08333 4 6 4 7C4 8.05 4.14583 8.97917 4.4375 9.7875C4.72917 10.5958 5 11.2 5.25 11.6ZM7.875 16C8.19167 16 8.45833 15.8833 8.675 15.65C8.89167 15.4167 9 15.0917 9 14.675C9 14.3917 8.93333 14.1 8.8 13.8C8.66667 13.5 8.53333 13.2333 8.4 13L6 13.5C6 14.1667 6.14583 14.75 6.4375 15.25C6.72917 15.75 7.20833 16 7.875 16ZM16.125 23C15.225 23 14.4792 22.6833 13.8875 22.05C13.2958 21.4167 13 20.625 13 19.675C13 19.125 13.1167 18.5958 13.35 18.0875C13.5833 17.5792 13.7667 17.2083 13.9 16.975L14.1 16.65C13.9 16.15 13.6667 15.4917 13.4 14.675C13.1333 13.8583 13 12.9667 13 12C13 10.5167 13.3958 9.14583 14.1875 7.8875C14.9792 6.62917 16.0833 6 17.5 6C18.8 6 19.875 6.57083 20.725 7.7125C21.575 8.85417 22 10.2833 22 12C22 13.5167 21.7875 14.7708 21.3625 15.7625C20.9375 16.7542 20.6333 17.3917 20.45 17.675L20 18.375C20.0167 19.5583 19.6958 20.625 19.0375 21.575C18.3792 22.525 17.4083 23 16.125 23ZM18.75 16.6C19 16.2 19.2708 15.6 19.5625 14.8C19.8542 14 20 13.0667 20 12C20 11 19.7708 10.0833 19.3125 9.25C18.8542 8.41667 18.25 8 17.5 8C16.75 8 16.1458 8.41667 15.6875 9.25C15.2292 10.0833 15 11 15 12C15 12.8 15.1125 13.5375 15.3375 14.2125C15.5625 14.8875 15.7833 15.5 16 16.05L18.75 16.6ZM16.125 21C16.7917 21 17.2708 20.75 17.5625 20.25C17.8542 19.75 18 19.1667 18 18.5L15.6 18C15.4667 18.2333 15.3333 18.5 15.2 18.8C15.0667 19.1 15 19.3917 15 19.675C15 20.0083 15.1042 20.3125 15.3125 20.5875C15.5208 20.8625 15.7917 21 16.125 21Z"
    ],
    category: "Map"
  },
  "play-button": {
    paths: [
      "M9.5 16.5L16.5 12L9.5 7.5V16.5ZM12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C9.76667 4 7.875 4.775 6.325 6.325C4.775 7.875 4 9.76667 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20Z"
    ],
    category: "Not In Figma"
  },
  "arrow-left-right": {
    paths: ["M6.99 11 3 15l3.99 4v-3H14v-2H6.99v-3zM21 9l-3.99-4v3H10v2h7.01v3L21 9z"],
    category: "Not In Figma"
  },
  warning: {
    paths: ["M10.5 17H13.5V20H10.5V17ZM10.5 4H13.5V14H10.5V4Z"],
    category: "System"
  },
  attachment: {
    paths: [
      "M19 20.9999H5C4.73478 20.9999 4.48043 20.8946 4.29289 20.707C4.10536 20.5195 4 20.2651 4 19.9999V10.9999H1L11.327 1.61192C11.5111 1.4444 11.7511 1.35156 12 1.35156C12.2489 1.35156 12.4889 1.4444 12.673 1.61192L23 10.9999H20V19.9999C20 20.2651 19.8946 20.5195 19.7071 20.707C19.5196 20.8946 19.2652 20.9999 19 20.9999ZM6 18.9999H18V9.15692L12 3.70292L6 9.15692V18.9999Z"
    ],
    category: "Paired Sales"
  },
  bedrooms: {
    paths: [
      "M21.9875 13V18.9875H20.0125V17V16.9875H20H4H3.9875V17V18.9875H2.0125V13C2.0125 12.5517 2.1038 12.1454 2.28618 11.7806C2.46885 11.4152 2.70964 11.0914 3.00858 10.8091L3.0125 10.8132V10.8V8C3.0125 7.16994 3.30288 6.4648 3.88384 5.88384C4.4648 5.30288 5.16994 5.0125 6 5.0125H10C10.3818 5.0125 10.7384 5.08303 11.0701 5.224C11.4022 5.36512 11.7094 5.56022 11.9917 5.80937L12 5.81667L12.0083 5.80937C12.2906 5.56022 12.5978 5.36512 12.9299 5.224C13.2616 5.08303 13.6182 5.0125 14 5.0125H18C18.8301 5.0125 19.5352 5.30288 20.1162 5.88384C20.6971 6.4648 20.9875 7.16994 20.9875 8V10.8H20.9818L20.9914 10.8091C21.2904 11.0914 21.5311 11.4152 21.7138 11.7806C21.8962 12.1454 21.9875 12.5517 21.9875 13ZM12.9875 10V10.0125H13H19H19.0125V10V8C19.0125 7.71352 18.9155 7.47279 18.7213 7.27866C18.5272 7.08453 18.2865 6.9875 18 6.9875H14C13.7135 6.9875 13.4728 7.08453 13.2787 7.27866C13.0845 7.47279 12.9875 7.71352 12.9875 8V10ZM4.9875 10V10.0125H5H11H11.0125V10V8C11.0125 7.71352 10.9155 7.47279 10.7213 7.27866C10.5272 7.08453 10.2865 6.9875 10 6.9875H6C5.71352 6.9875 5.47279 7.08453 5.27866 7.27866C5.08453 7.47279 4.9875 7.71352 4.9875 8V10ZM3.9875 15V15.0125H4H20H20.0125V15V13C20.0125 12.7135 19.9155 12.4728 19.7213 12.2787C19.5272 12.0845 19.2865 11.9875 19 11.9875H5C4.71352 11.9875 4.47279 12.0845 4.27866 12.2787C4.08453 12.4728 3.9875 12.7135 3.9875 13V15Z"
    ],
    category: "Paired Sales"
  },
  "basement-sf": {
    paths: [
      "M10.425 14.6625H10.4125V14.675V17.9875H6.0125V16.0125H8.425H8.4375V16V12.6625H11H11.0125V12.65V9.3375H13.575H13.5875V9.325V6.0125H17.9875V7.9875H15.575H15.5625V8V11.3375H13H12.9875V11.35V14.6625H10.425ZM4.9875 19V19.0125H5H19H19.0125V19V5V4.9875H19H5H4.9875V5V19ZM5 20.9875C4.45334 20.9875 3.98568 20.793 3.59634 20.4037C3.207 20.0143 3.0125 19.5467 3.0125 19V5C3.0125 4.45334 3.207 3.98568 3.59634 3.59634C3.98568 3.207 4.45334 3.0125 5 3.0125H19C19.5467 3.0125 20.0143 3.207 20.4037 3.59634C20.793 3.98568 20.9875 4.45334 20.9875 5V19C20.9875 19.5467 20.793 20.0143 20.4037 20.4037C20.0143 20.793 19.5467 20.9875 19 20.9875H5Z"
    ],
    category: "Paired Sales"
  },
  baths: {
    paths: [
      "M12.1719 4.23869C12.1719 4.38228 12.2883 4.49869 12.4319 4.49869H17.5959C17.7395 4.49869 17.8559 4.38228 17.8559 4.23869V2.81469C17.8559 2.67109 17.7395 2.55469 17.5959 2.55469H12.4319C12.2883 2.55469 12.1719 2.67109 12.1719 2.81469V4.23869ZM19.7263 1.94402C19.8165 1.94492 19.9034 1.97627 19.9731 2.03236C19.9842 2.04133 19.9949 2.05094 20.0052 2.06116C20.0726 2.12865 20.1135 2.21778 20.121 2.31225C20.1216 2.31881 20.1219 2.32539 20.1221 2.332C20.1223 2.33599 20.1223 2.33999 20.1223 2.344V10.44H21.9983V2.332C22.0047 1.72796 21.774 1.14576 21.3562 0.710149C21.352 0.705792 21.3478 0.701451 21.3436 0.697124C20.9178 0.260125 20.3363 0.00948271 19.7263 0H16.3343C16.329 8.20692e-05 16.3236 0.00018281 16.3182 0.000302187C16.048 0.0063234 15.7833 0.0597554 15.5355 0.156C15.3848 0.214518 15.2404 0.288864 15.1047 0.378003C15.023 0.43162 14.9446 0.49059 14.8698 0.554688C14.8395 0.580701 14.8098 0.607559 14.7807 0.635246C14.5696 0.836301 14.4004 1.07367 14.2798 1.33356C14.1607 1.59017 14.0888 1.86874 14.0703 2.156H16.0063C16.03 2.10622 16.0644 2.0625 16.1069 2.02785C16.118 2.01874 16.1297 2.01025 16.1419 2.00245C16.1995 1.96569 16.2661 1.9455 16.3343 1.94406C16.3356 1.94403 16.337 1.94401 16.3383 1.944H19.7223C19.7236 1.944 19.725 1.94401 19.7263 1.94402ZM0 11V15C0 17.2091 1.79086 19 4 19H20C22.2091 19 24 17.2091 24 15V11H0ZM22 13H2V15C2 16.1046 2.89543 17 4 17H20C21.1046 17 22 16.1046 22 15V13Z"
    ],
    category: "Paired Sales"
  },
  cooling: {
    paths: [
      "M11.25 21.75V17.2538L7.74998 20.7038L6.69615 19.65L11.25 15.0961V12.75H8.90383L4.34998 17.3038L3.29615 16.25L6.74617 12.75H2.25V11.25H6.74617L3.29615 7.74998L4.34998 6.69615L8.90383 11.25H11.25V8.90383L6.69615 4.34998L7.74998 3.29615L11.25 6.74618V2.25H12.75V6.74618L16.25 3.29615L17.3038 4.34998L12.75 8.90383V11.25H15.0961L19.65 6.69615L20.7038 7.74998L17.2538 11.25H21.75V12.75H17.2538L20.7038 16.25L19.65 17.3038L15.0961 12.75H12.75V15.0961L17.3038 19.65L16.25 20.7038L12.75 17.2538V21.75L11.25 21.75Z"
    ],
    category: "Paired Sales"
  },
  "energy-efficiency": {
    paths: [
      "M11.077 23.0355V19.5088H12.923V23.0354L11.077 23.0355ZM0 11.9585V10.1124H3.52662V11.9585H0ZM20.4734 11.9585V10.1124H24V11.9585H20.4734ZM19.4083 20.3561L16.942 17.8899L18.2391 16.5929L20.7053 19.0591L19.4083 20.3561ZM4.5917 20.3561L3.29469 19.0591L5.76094 16.5929L7.05796 17.8899L4.5917 20.3561ZM12 16.5739C10.4631 16.5739 9.15584 16.035 8.07811 14.9573C7.00041 13.8796 6.46156 12.5723 6.46156 11.0354C6.46156 10.0982 6.68207 9.22953 7.1231 8.42953C7.56412 7.62952 8.16412 6.9676 8.9231 6.44374V1H15.0769V6.44374C15.8359 6.9676 16.4359 7.62952 16.8769 8.42953C17.3179 9.22953 17.5384 10.0982 17.5384 11.0354C17.5384 12.5723 16.9996 13.8796 15.9219 14.9573C14.8442 16.035 13.5369 16.5739 12 16.5739ZM10.7692 5.64377C10.9744 5.59484 11.1775 5.55815 11.3787 5.5337C11.5799 5.50923 11.787 5.497 12 5.497C12.213 5.497 12.4201 5.50923 12.6213 5.5337C12.8225 5.55815 13.0256 5.59484 13.2308 5.64377V2.8461H10.7692V5.64377ZM12 14.7278C13.0256 14.7278 13.8974 14.3688 14.6154 13.6508C15.3333 12.9329 15.6923 12.0611 15.6923 11.0354C15.6923 10.0098 15.3333 9.138 14.6154 8.42005C13.8974 7.7021 13.0256 7.34312 12 7.34312C10.9744 7.34312 10.1026 7.7021 9.38461 8.42005C8.66666 9.138 8.30768 10.0098 8.30768 11.0354C8.30768 12.0611 8.66666 12.9329 9.38461 13.6508C10.1026 14.3688 10.9744 14.7278 12 14.7278Z"
    ],
    category: "Paired Sales"
  },
  gla: {
    paths: [
      "M5.81519 20.2306C5.24341 20.2306 4.75944 20.0325 4.36329 19.6363C3.96713 19.2402 3.76904 18.7562 3.76904 18.1844V6.31147C3.76904 5.88584 3.96039 5.59001 4.34309 5.42397C4.72578 5.25796 5.06134 5.31918 5.34979 5.60765L7.21517 7.473L6.15364 8.5345L6.73824 9.11912L7.79977 8.0576L10.169 10.4268L9.10747 11.4883L9.69207 12.0729L10.7536 11.0114L13.1613 13.4191L12.0997 14.4806L12.6844 15.0652L13.7459 14.0037L16.1151 16.3729L15.0536 17.4344L15.6382 18.019L16.6997 16.9575L18.4112 18.669C18.6933 18.9511 18.7513 19.2819 18.5852 19.6613C18.4192 20.0408 18.1266 20.2306 17.7074 20.2306H5.81519ZM6.30749 17.9998H14.2998L5.99977 9.69985V17.6921C5.99977 17.7819 6.02862 17.8556 6.08632 17.9133C6.14402 17.971 6.21774 17.9998 6.30749 17.9998Z"
    ],
    category: "Paired Sales"
  },
  heating: {
    paths: [
      "M8.01665 18.5093L8.04463 18.5344L8.03726 18.4975C8.02071 18.4148 8.0125 18.3407 8.0125 18.275V18.05C8.0125 17.5183 8.11219 17.02 8.31149 16.5549C8.51081 16.0898 8.80151 15.6662 9.18376 15.2839C9.18379 15.2839 9.18381 15.2839 9.18384 15.2838L12 12.5175L14.8162 15.2838C14.8162 15.2839 14.8162 15.2839 14.8162 15.2839C15.1985 15.6662 15.4892 16.0898 15.6885 16.5549C15.8878 17.02 15.9875 17.5183 15.9875 18.05V18.275C15.9875 18.3407 15.9793 18.4148 15.9627 18.4975L15.9554 18.5344L15.9833 18.5093C16.6346 17.9248 17.1357 17.2443 17.4864 16.4676C17.8371 15.691 18.0125 14.8684 18.0125 14C18.0125 13.1651 17.858 12.3759 17.549 11.6327C17.2401 10.8895 16.7933 10.2256 16.2088 9.64116L16.2017 9.634L16.1932 9.63952C15.8608 9.85556 15.5119 10.0175 15.1465 10.1255C14.7809 10.2335 14.4071 10.2875 14.025 10.2875C12.9947 10.2875 12.1019 9.94695 11.3459 9.26571C10.5898 8.58438 10.1537 7.74549 10.0374 6.74855L10.0347 6.7254L10.0169 6.74046C9.36645 7.29086 8.79094 7.86218 8.29045 8.45443C7.79 9.04664 7.3687 9.64728 7.0266 10.2564C6.68447 10.8655 6.42574 11.4873 6.25045 12.1217C6.07517 12.756 5.9875 13.3821 5.9875 14C5.9875 14.8684 6.16286 15.691 6.51361 16.4676C6.86434 17.2443 7.36539 17.9248 8.01665 18.5093ZM12.0088 15.2911L12 15.2825L11.9912 15.2911L10.5662 16.6911L10.5662 16.6912C10.3817 16.8756 10.2392 17.0852 10.1385 17.3201C10.0379 17.5549 9.9875 17.7983 9.9875 18.05C9.9875 18.5868 10.1848 19.0483 10.5788 19.4339C10.9728 19.8196 11.4467 20.0125 12 20.0125C12.5533 20.0125 13.0272 19.8196 13.4212 19.4339C13.8152 19.0483 14.0125 18.5868 14.0125 18.05C14.0125 17.7817 13.9622 17.5342 13.8614 17.3074C13.7608 17.0809 13.6182 16.8755 13.4338 16.6912L13.4338 16.6911L12.0088 15.2911ZM14.8679 8.12375C15.1281 7.99786 15.3587 7.80911 15.5597 7.55784C15.5597 7.55783 15.5598 7.55782 15.5598 7.55781L16.003 7.01608C17.23 7.71458 18.2004 8.68622 18.9142 9.93122C19.6297 11.1793 19.9875 12.5355 19.9875 14C19.9875 16.2301 19.2138 18.1186 17.6662 19.6662C16.1186 21.2138 14.2301 21.9875 12 21.9875C9.76991 21.9875 7.88145 21.2138 6.33384 19.6662C4.78623 18.1186 4.0125 16.2301 4.0125 14C4.0125 11.853 4.73226 9.81392 6.17252 7.88247C7.60933 5.95566 9.54753 4.33509 11.9875 3.02092V6.3C11.9875 6.8699 12.1846 7.34816 12.5788 7.73393C12.9728 8.11964 13.4552 8.3125 14.025 8.3125C14.3268 8.3125 14.6078 8.24961 14.8679 8.12375Z"
    ],
    category: "Paired Sales"
  },
  "lot-size": {
    paths: [
      "M5 22V20H11V16H9C7.61667 16 6.4375 15.5125 5.4625 14.5375C4.4875 13.5625 4 12.3833 4 11C4 10 4.275 9.07917 4.825 8.2375C5.375 7.39583 6.11667 6.78333 7.05 6.4C7.2 5.15 7.74583 4.10417 8.6875 3.2625C9.62917 2.42083 10.7333 2 12 2C13.2667 2 14.3708 2.42083 15.3125 3.2625C16.2542 4.10417 16.8 5.15 16.95 6.4C17.8833 6.78333 18.625 7.39583 19.175 8.2375C19.725 9.07917 20 10 20 11C20 12.3833 19.5125 13.5625 18.5375 14.5375C17.5625 15.5125 16.3833 16 15 16H13V20H19V22H5ZM9 14H15C15.8333 14 16.5417 13.7083 17.125 13.125C17.7083 12.5417 18 11.8333 18 11C18 10.4 17.8292 9.85 17.4875 9.35C17.1458 8.85 16.7 8.48333 16.15 8.25L15.1 7.8L14.95 6.65C14.85 5.9 14.5208 5.27083 13.9625 4.7625C13.4042 4.25417 12.75 4 12 4C11.25 4 10.5958 4.25417 10.0375 4.7625C9.47917 5.27083 9.15 5.9 9.05 6.65L8.9 7.8L7.85 8.25C7.3 8.48333 6.85417 8.85 6.5125 9.35C6.17083 9.85 6 10.4 6 11C6 11.8333 6.29167 12.5417 6.875 13.125C7.45833 13.7083 8.16667 14 9 14Z"
    ],
    category: "Paired Sales"
  },
  "patio-porch": {
    paths: [
      "M12 2.01526L21.9603 8.9875H13H12.9875V9V21.9875H11.0125V9V8.9875H11H2.03965L12 2.01526ZM4.9 16.0125H8.9875V21.9875H7.0125V18V17.9875H7H5H4.9875V18V21.9875H3.0125V16.75H3.0127L3.0123 16.7478L2.21454 12.3601L4.14 12.0145L4.88771 16.0023L4.88963 16.0125H4.9ZM19.86 12.0145L21.7855 12.3601L20.9877 16.7478L20.9875 16.7477V16.75V21.9875H19.0125V18V17.9875H19H17H16.9875V18V21.9875H15.0125V16.0125H19.1H19.1104L19.1123 16.0023L19.86 12.0145ZM8.34284 6.98975L8.31028 7.0125H8.35H15.65H15.6897L15.6572 6.98975L12.0072 4.43975L12 4.43475L11.9928 4.43975L8.34284 6.98975Z"
    ],
    category: "Paired Sales"
  },
  pool: {
    paths: [
      "M2 20.3484V18.3984C2.48333 18.3984 2.89583 18.3234 3.2375 18.1734C3.57917 18.0234 3.925 17.8609 4.275 17.6859C4.625 17.5109 5.0125 17.3526 5.4375 17.2109C5.8625 17.0693 6.38333 16.9984 7 16.9984C7.63333 16.9984 8.15417 17.0693 8.5625 17.2109C8.97083 17.3526 9.35 17.5109 9.7 17.6859C10.05 17.8609 10.4 18.0234 10.75 18.1734C11.1 18.3234 11.5167 18.3984 12 18.3984C12.4833 18.3984 12.9 18.3234 13.25 18.1734C13.6 18.0234 13.95 17.8609 14.3 17.6859C14.65 17.5109 15.0333 17.3526 15.45 17.2109C15.8667 17.0693 16.3833 16.9984 17 16.9984C17.6333 16.9984 18.1583 17.0693 18.575 17.2109C18.9917 17.3526 19.375 17.5109 19.725 17.6859C20.075 17.8609 20.425 18.0234 20.775 18.1734C21.125 18.3234 21.5333 18.3984 22 18.3984V20.3484C21.3667 20.3484 20.8375 20.2734 20.4125 20.1234C19.9875 19.9734 19.6 19.8109 19.25 19.6359C18.9 19.4609 18.5583 19.3026 18.225 19.1609C17.8917 19.0193 17.4833 18.9484 17 18.9484C16.5333 18.9484 16.1292 19.0193 15.7875 19.1609C15.4458 19.3026 15.1042 19.4609 14.7625 19.6359C14.4208 19.8109 14.0375 19.9734 13.6125 20.1234C13.1875 20.2734 12.65 20.3484 12 20.3484C11.35 20.3484 10.8125 20.2734 10.3875 20.1234C9.9625 19.9734 9.57917 19.8109 9.2375 19.6359C8.89583 19.4609 8.55833 19.3026 8.225 19.1609C7.89167 19.0193 7.48333 18.9484 7 18.9484C6.53333 18.9484 6.12917 19.0193 5.7875 19.1609C5.44583 19.3026 5.1 19.4609 4.75 19.6359C4.4 19.8109 4.0125 19.9734 3.5875 20.1234C3.1625 20.2734 2.63333 20.3484 2 20.3484ZM2 15.8984V13.9484C2.48333 13.9484 2.89583 13.8734 3.2375 13.7234C3.57917 13.5734 3.925 13.4109 4.275 13.2359C4.625 13.0609 5.0125 12.9026 5.4375 12.7609C5.8625 12.6193 6.38333 12.5484 7 12.5484C7.63333 12.5484 8.15417 12.6193 8.5625 12.7609C8.97083 12.9026 9.35 13.0609 9.7 13.2359C10.05 13.4109 10.4 13.5734 10.75 13.7234C11.1 13.8734 11.5167 13.9484 12 13.9484C12.4833 13.9484 12.9 13.8734 13.25 13.7234C13.6 13.5734 13.95 13.4109 14.3 13.2359C14.65 13.0609 15.0333 12.9026 15.45 12.7609C15.8667 12.6193 16.3833 12.5484 17 12.5484C17.6333 12.5484 18.1583 12.6193 18.575 12.7609C18.9917 12.9026 19.375 13.0609 19.725 13.2359C20.075 13.4109 20.425 13.5734 20.775 13.7234C21.125 13.8734 21.5333 13.9484 22 13.9484V15.8984C21.3667 15.8984 20.8375 15.8234 20.4125 15.6734C19.9875 15.5234 19.6 15.3609 19.25 15.1859C18.9 15.0109 18.5583 14.8526 18.225 14.7109C17.8917 14.5693 17.4833 14.4984 17 14.4984C16.5167 14.4984 16.1042 14.5693 15.7625 14.7109C15.4208 14.8526 15.0792 15.0109 14.7375 15.1859C14.3958 15.3609 14.0167 15.5234 13.6 15.6734C13.1833 15.8234 12.65 15.8984 12 15.8984C11.35 15.8984 10.8125 15.8234 10.3875 15.6734C9.9625 15.5234 9.57917 15.3609 9.2375 15.1859C8.89583 15.0109 8.55833 14.8526 8.225 14.7109C7.89167 14.5693 7.48333 14.4984 7 14.4984C6.53333 14.4984 6.12917 14.5693 5.7875 14.7109C5.44583 14.8526 5.1 15.0109 4.75 15.1859C4.4 15.3609 4.0125 15.5234 3.5875 15.6734C3.1625 15.8234 2.63333 15.8984 2 15.8984ZM2 11.4484V9.49844C2.48333 9.49844 2.89583 9.42344 3.2375 9.27344C3.57917 9.12344 3.925 8.96094 4.275 8.78594C4.625 8.61094 5.0125 8.4526 5.4375 8.31094C5.8625 8.16927 6.38333 8.09844 7 8.09844C7.63333 8.09844 8.15417 8.16927 8.5625 8.31094C8.97083 8.4526 9.35 8.61094 9.7 8.78594C10.05 8.96094 10.4 9.12344 10.75 9.27344C11.1 9.42344 11.5167 9.49844 12 9.49844C12.4833 9.49844 12.9 9.42344 13.25 9.27344C13.6 9.12344 13.95 8.96094 14.3 8.78594C14.65 8.61094 15.0333 8.4526 15.45 8.31094C15.8667 8.16927 16.3833 8.09844 17 8.09844C17.6333 8.09844 18.1583 8.16927 18.575 8.31094C18.9917 8.4526 19.375 8.61094 19.725 8.78594C20.075 8.96094 20.425 9.12344 20.775 9.27344C21.125 9.42344 21.5333 9.49844 22 9.49844V11.4484C21.3667 11.4484 20.8375 11.3734 20.4125 11.2234C19.9875 11.0734 19.6 10.9109 19.25 10.7359C18.9 10.5609 18.5583 10.4026 18.225 10.2609C17.8917 10.1193 17.4833 10.0484 17 10.0484C16.5333 10.0484 16.1292 10.1193 15.7875 10.2609C15.4458 10.4026 15.1042 10.5609 14.7625 10.7359C14.4208 10.9109 14.0375 11.0734 13.6125 11.2234C13.1875 11.3734 12.65 11.4484 12 11.4484C11.35 11.4484 10.8125 11.3734 10.3875 11.2234C9.9625 11.0734 9.57917 10.9109 9.2375 10.7359C8.89583 10.5609 8.55833 10.4026 8.225 10.2609C7.89167 10.1193 7.48333 10.0484 7 10.0484C6.53333 10.0484 6.12917 10.1193 5.7875 10.2609C5.44583 10.4026 5.1 10.5609 4.75 10.7359C4.4 10.9109 4.0125 11.0734 3.5875 11.2234C3.1625 11.3734 2.63333 11.4484 2 11.4484ZM2 6.99844V5.04844C2.48333 5.04844 2.89583 4.97344 3.2375 4.82344C3.57917 4.67344 3.925 4.51094 4.275 4.33594C4.625 4.16094 5.0125 4.0026 5.4375 3.86094C5.8625 3.71927 6.38333 3.64844 7 3.64844C7.63333 3.64844 8.15417 3.71927 8.5625 3.86094C8.97083 4.0026 9.35 4.16094 9.7 4.33594C10.05 4.51094 10.4 4.67344 10.75 4.82344C11.1 4.97344 11.5167 5.04844 12 5.04844C12.4833 5.04844 12.9 4.97344 13.25 4.82344C13.6 4.67344 13.95 4.51094 14.3 4.33594C14.65 4.16094 15.0333 4.0026 15.45 3.86094C15.8667 3.71927 16.3833 3.64844 17 3.64844C17.6333 3.64844 18.1583 3.71927 18.575 3.86094C18.9917 4.0026 19.375 4.16094 19.725 4.33594C20.075 4.51094 20.425 4.67344 20.775 4.82344C21.125 4.97344 21.5333 5.04844 22 5.04844V6.99844C21.3667 6.99844 20.8375 6.92344 20.4125 6.77344C19.9875 6.62344 19.6 6.46094 19.25 6.28594C18.9 6.11094 18.5583 5.9526 18.225 5.81094C17.8917 5.66927 17.4833 5.59844 17 5.59844C16.5333 5.59844 16.1292 5.66927 15.7875 5.81094C15.4458 5.9526 15.1042 6.11094 14.7625 6.28594C14.4208 6.46094 14.0375 6.62344 13.6125 6.77344C13.1875 6.92344 12.65 6.99844 12 6.99844C11.35 6.99844 10.8125 6.92344 10.3875 6.77344C9.9625 6.62344 9.57917 6.46094 9.2375 6.28594C8.89583 6.11094 8.55833 5.9526 8.225 5.81094C7.89167 5.66927 7.48333 5.59844 7 5.59844C6.53333 5.59844 6.12917 5.66927 5.7875 5.81094C5.44583 5.9526 5.1 6.11094 4.75 6.28594C4.4 6.46094 4.0125 6.62344 3.5875 6.77344C3.1625 6.92344 2.63333 6.99844 2 6.99844Z"
    ],
    category: "Paired Sales"
  },
  parking: {
    paths: [
      "M4.3077 21.5C3.80257 21.5 3.375 21.325 3.025 20.975C2.675 20.625 2.5 20.1974 2.5 19.6923V4.3077C2.5 3.80257 2.675 3.375 3.025 3.025C3.375 2.675 3.80257 2.5 4.3077 2.5H19.6923C20.1974 2.5 20.625 2.675 20.975 3.025C21.325 3.375 21.5 3.80257 21.5 4.3077V19.6923C21.5 20.1974 21.325 20.625 20.975 20.975C20.625 21.325 20.1974 21.5 19.6923 21.5H4.3077ZM4.3077 20H19.6923C19.7692 20 19.8397 19.9679 19.9038 19.9038C19.9679 19.8397 20 19.7692 20 19.6923V4.3077C20 4.23077 19.9679 4.16024 19.9038 4.09613C19.8397 4.03203 19.7692 3.99998 19.6923 3.99998H4.3077C4.23077 3.99998 4.16024 4.03203 4.09613 4.09613C4.03202 4.16024 3.99998 4.23077 3.99998 4.3077V19.6923C3.99998 19.7692 4.03202 19.8397 4.09613 19.9038C4.16024 19.9679 4.23077 20 4.3077 20ZM8.80765 13.8846C8.56278 13.8846 8.35413 13.7984 8.1817 13.6259C8.00927 13.4535 7.92305 13.2448 7.92305 13C7.92305 12.7551 8.00927 12.5465 8.1817 12.374C8.35413 12.2016 8.56278 12.1154 8.80765 12.1154C9.05252 12.1154 9.26117 12.2016 9.4336 12.374C9.60603 12.5465 9.69225 12.7551 9.69225 13C9.69225 13.2448 9.60603 13.4535 9.4336 13.6259C9.26117 13.7984 9.05252 13.8846 8.80765 13.8846ZM15.1923 13.8846C14.9474 13.8846 14.7388 13.7984 14.5664 13.6259C14.3939 13.4535 14.3077 13.2448 14.3077 13C14.3077 12.7551 14.3939 12.5465 14.5664 12.374C14.7388 12.2016 14.9474 12.1154 15.1923 12.1154C15.4372 12.1154 15.6458 12.2016 15.8183 12.374C15.9907 12.5465 16.0769 12.7551 16.0769 13C16.0769 13.2448 15.9907 13.4535 15.8183 13.6259C15.6458 13.7984 15.4372 13.8846 15.1923 13.8846ZM5.5 11.1769V17.373C5.5 17.5551 5.55898 17.7051 5.67693 17.823C5.79488 17.941 5.94488 18 6.12693 18H6.37308C6.55511 18 6.7051 17.941 6.82305 17.823C6.941 17.7051 6.99998 17.5551 6.99998 17.373V16H17V17.373C17 17.5551 17.059 17.7051 17.1769 17.823C17.2949 17.941 17.4448 18 17.6269 18H17.873C18.0551 18 18.2051 17.941 18.323 17.823C18.441 17.7051 18.5 17.5551 18.5 17.373V11.1769L16.9269 6.62693C16.8628 6.43846 16.7541 6.28686 16.6009 6.17213C16.4477 6.05738 16.2769 6 16.0884 6H7.91153C7.72308 6 7.55225 6.05738 7.39905 6.17213C7.24583 6.28686 7.13718 6.43846 7.07308 6.62693L5.5 11.1769ZM7.47687 10L8.34998 7.49998H15.65L16.5231 10H7.47687ZM6.99998 14.5V11.5H17V14.5H6.99998Z"
    ],
    category: "Paired Sales"
  },
  view: {
    paths: [
      "M4.828 21L4.808 21.02L4.787 21H2.992C2.72881 20.9997 2.4765 20.895 2.29049 20.7088C2.10448 20.5226 2 20.2702 2 20.007V3.993C2.00183 3.73038 2.1069 3.47902 2.29251 3.29322C2.47813 3.10742 2.72938 3.00209 2.992 3H21.008C21.556 3 22 3.445 22 3.993V20.007C21.9982 20.2696 21.8931 20.521 21.7075 20.7068C21.5219 20.8926 21.2706 20.9979 21.008 21H4.828ZM20 15V5H4V19L14 9L20 15ZM20 17.828L14 11.828L6.828 19H20V17.828ZM8 11C7.46957 11 6.96086 10.7893 6.58579 10.4142C6.21071 10.0391 6 9.53043 6 9C6 8.46957 6.21071 7.96086 6.58579 7.58579C6.96086 7.21071 7.46957 7 8 7C8.53043 7 9.03914 7.21071 9.41421 7.58579C9.78929 7.96086 10 8.46957 10 9C10 9.53043 9.78929 10.0391 9.41421 10.4142C9.03914 10.7893 8.53043 11 8 11Z"
    ],
    category: "Paired Sales"
  },
  other: {
    paths: [
      "M19 20.9999H5C4.73478 20.9999 4.48043 20.8946 4.29289 20.707C4.10536 20.5195 4 20.2651 4 19.9999V10.9999H1L11.327 1.61192C11.5111 1.4444 11.7511 1.35156 12 1.35156C12.2489 1.35156 12.4889 1.4444 12.673 1.61192L23 10.9999H20V19.9999C20 20.2651 19.8946 20.5195 19.7071 20.707C19.5196 20.8946 19.2652 20.9999 19 20.9999ZM6 18.9999H18V9.15692L12 3.70292L6 9.15692V18.9999Z",
      "M9.3125 8.79462C9.47117 8.65462 9.64383 8.52162 9.8305 8.39562C10.0218 8.26962 10.2272 8.15996 10.4465 8.06662C10.6658 7.97329 10.9038 7.90096 11.1605 7.84962C11.4172 7.79362 11.6948 7.76562 11.9935 7.76562C12.3995 7.76562 12.7682 7.82162 13.0995 7.93362C13.4355 8.04562 13.7225 8.20662 13.9605 8.41662C14.1985 8.62196 14.3828 8.87162 14.5135 9.16562C14.6442 9.45962 14.7095 9.78862 14.7095 10.1526C14.7095 10.5073 14.6582 10.8153 14.5555 11.0766C14.4528 11.3333 14.3222 11.5573 14.1635 11.7486C14.0095 11.94 13.8415 12.1056 13.6595 12.2456C13.4775 12.3856 13.3048 12.5186 13.1415 12.6446C12.9782 12.766 12.8358 12.8873 12.7145 13.0086C12.5978 13.1253 12.5278 13.2583 12.5045 13.4076L12.3435 14.4296H11.1605L11.0415 13.2886C11.0368 13.2653 11.0345 13.2466 11.0345 13.2326C11.0345 13.214 11.0345 13.193 11.0345 13.1696C11.0345 12.9643 11.0858 12.787 11.1885 12.6376C11.2912 12.4836 11.4195 12.3413 11.5735 12.2106C11.7275 12.0753 11.8932 11.9446 12.0705 11.8186C12.2478 11.6926 12.4135 11.5573 12.5675 11.4126C12.7215 11.2633 12.8498 11.0953 12.9525 10.9086C13.0552 10.722 13.1065 10.5026 13.1065 10.2506C13.1065 10.0826 13.0738 9.93329 13.0085 9.80263C12.9478 9.66729 12.8615 9.55296 12.7495 9.45962C12.6375 9.36162 12.5022 9.28696 12.3435 9.23562C12.1895 9.18429 12.0215 9.15863 11.8395 9.15863C11.5735 9.15863 11.3472 9.18896 11.1605 9.24963C10.9785 9.30562 10.8222 9.37096 10.6915 9.44563C10.5655 9.51562 10.4582 9.58096 10.3695 9.64163C10.2808 9.69762 10.2015 9.72562 10.1315 9.72562C9.9635 9.72562 9.84217 9.65562 9.7675 9.51562L9.3125 8.79462ZM10.6355 17.0476C10.6355 16.903 10.6612 16.7653 10.7125 16.6346C10.7685 16.504 10.8432 16.392 10.9365 16.2986C11.0345 16.2053 11.1488 16.1306 11.2795 16.0746C11.4102 16.0186 11.5502 15.9906 11.6995 15.9906C11.8442 15.9906 11.9818 16.0186 12.1125 16.0746C12.2432 16.1306 12.3552 16.2053 12.4485 16.2986C12.5418 16.392 12.6165 16.504 12.6725 16.6346C12.7285 16.7653 12.7565 16.903 12.7565 17.0476C12.7565 17.197 12.7285 17.337 12.6725 17.4676C12.6165 17.5936 12.5418 17.7033 12.4485 17.7966C12.3552 17.89 12.2432 17.9623 12.1125 18.0136C11.9818 18.0696 11.8442 18.0976 11.6995 18.0976C11.5502 18.0976 11.4102 18.0696 11.2795 18.0136C11.1488 17.9623 11.0345 17.89 10.9365 17.7966C10.8432 17.7033 10.7685 17.5936 10.7125 17.4676C10.6612 17.337 10.6355 17.197 10.6355 17.0476Z"
    ],
    category: "Paired Sales"
  },
  location: {
    paths: [
      "M0.10612 9.37871C0.326299 10.6258 0.8891 11.9482 1.79452 13.3461C1.85721 13.4429 1.92153 13.54 1.9875 13.6375C3.08066 15.2532 4.63611 16.9795 6.65384 18.8164C7.08177 19.2059 7.53049 19.6005 8 20C8.46951 19.6005 8.91823 19.2059 9.34616 18.8164C11.3639 16.9795 12.9193 15.2532 14.0125 13.6375C14.0785 13.54 14.1428 13.4429 14.2055 13.3461C14.2514 13.2752 14.2964 13.2045 14.3406 13.134C15.4469 11.3676 16 9.72291 16 8.2C16 5.7 15.1958 3.70833 13.5875 2.225C13.5067 2.1505 13.4253 2.07788 13.3433 2.00713C11.7915 0.669042 10.0104 0 8 0C5.98962 0 4.20853 0.669051 2.65671 2.00715C2.57467 2.0779 2.49326 2.15051 2.4125 2.225C0.804167 3.70833 0 5.7 0 8.2C0 8.58512 0.0353734 8.97802 0.10612 9.37871ZM8.007 17.3436C9.92431 15.5827 11.3743 13.974 12.3569 12.5173C12.4145 12.4319 12.4706 12.3469 12.525 12.2625C12.5632 12.2033 12.6006 12.1444 12.6373 12.0857C13.263 11.085 13.6732 10.1591 13.8679 9.30809C13.956 8.92343 14 8.55407 14 8.2C14 8.16382 13.9998 8.12778 13.9993 8.09186C13.9989 8.06115 13.9984 8.03053 13.9976 8C13.9838 7.42121 13.9096 6.87674 13.775 6.3666C13.5081 5.35535 13.004 4.47898 12.2625 3.7375C12.1833 3.65828 12.1028 3.58177 12.0212 3.50797C10.9086 2.50266 9.56821 2 8 2C6.43178 2 5.09139 2.50266 3.97883 3.50798C3.89716 3.58178 3.81671 3.65829 3.7375 3.7375C2.99602 4.47898 2.49186 5.35535 2.22502 6.36659C2.09041 6.87674 2.01619 7.42121 2.00237 8C2.00164 8.03053 2.00108 8.06115 2.00069 8.09186C2.00023 8.12778 2 8.16382 2 8.2C2 8.55407 2.04402 8.92344 2.13206 9.30809C2.32694 10.1596 2.73752 11.086 3.3638 12.0874C3.40014 12.1455 3.43721 12.2039 3.475 12.2625C3.52943 12.3469 3.58547 12.4319 3.64312 12.5173C4.62573 13.974 6.07569 15.5827 7.993 17.3436C7.99533 17.3457 7.99767 17.3479 8 17.35C8.00233 17.3479 8.00467 17.3457 8.007 17.3436ZM11.999 8.08821C11.9521 10.2566 10.1797 12 8 12C5.82034 12 4.04787 10.2566 4.00095 8.08821C4.00032 8.05889 4 8.02948 4 8C4 7.62717 4.05101 7.26626 4.14642 6.92386C4.61638 5.2374 6.16369 4 8 4C9.83631 4 11.3836 5.2374 11.8536 6.92386C11.949 7.26626 12 7.62717 12 8C12 8.02948 11.9997 8.05889 11.999 8.08821ZM8 10C9.10457 10 10 9.10457 10 8C10 6.89543 9.10457 6 8 6C6.89543 6 6 6.89543 6 8C6 9.10457 6.89543 10 8 10Z"
    ],
    category: "Paired Sales"
  },
  sparkle: {
    paths: [
      "M10.9789 6.43883C11.4321 6.28268 11.4321 6.0051 10.9789 5.83162L8.52121 4.89479C8.08545 4.73865 7.57997 4.23553 7.40567 3.78447L6.46443 1.33831C6.30755 0.88723 6.02867 0.88723 5.85436 1.33831L4.91312 3.78447C4.75625 4.21818 4.25077 4.7213 3.79758 4.89479L1.33989 5.83162C0.886702 5.98777 0.886702 6.26533 1.33989 6.43883L3.79758 7.37566C4.23334 7.5318 4.73882 8.0349 4.91312 8.48598L5.85436 10.9321C6.01124 11.3832 6.29012 11.3832 6.46443 10.9321L7.40567 8.48598C7.56254 8.05225 8.06802 7.54914 8.52121 7.37566L10.9789 6.43883ZM22.9541 15.0093C24.3486 14.6623 24.3486 14.0897 22.9541 13.7427L19.8691 12.9794C18.4746 12.6324 17.0453 11.2098 16.6967 9.82194L15.9298 6.75122C15.5811 5.36333 15.006 5.36333 14.6573 6.75122L13.8904 9.82194C13.5418 11.2098 12.1125 12.6324 10.7181 12.9794L7.63288 13.7427C6.23846 14.0897 6.23846 14.6623 7.63288 15.0093L10.7181 15.7725C12.1125 16.1195 13.5418 17.5421 13.8904 18.93L14.6573 22.0007C15.006 23.3886 15.5811 23.3886 15.9298 22.0007L16.6967 18.93C17.0453 17.5421 18.4746 16.1195 19.8691 15.7725L22.9541 15.0093Z"
    ],
    category: "System"
  },
  school: {
    paths: [
      "M12 21L5 17.2V11.2L1 9L12 3L23 9V17H21V10.1L19 11.2V17.2L12 21ZM12 12.7L18.85 9L12 5.3L5.15 9L12 12.7ZM12 18.725L17 16.025V12.25L12 15L7 12.25V16.025L12 18.725Z"
    ],
    category: "System"
  },
  database: {
    paths: [
      "M13.5655 3.46623V6.3536C13.1449 6.58797 12.5662 6.81584 11.8326 7.00138C10.7606 7.27482 9.43882 7.43758 8.00002 7.43758C6.56122 7.43758 5.23942 7.27482 4.16743 7.00138C3.4338 6.81584 2.85512 6.59123 2.43454 6.3536V3.46623L2.45352 3.44995C2.62111 3.30347 2.95631 3.10164 3.50337 2.89982C4.58168 2.50594 6.17227 2.22925 8.00002 2.22925C9.82777 2.22925 11.4184 2.50594 12.4967 2.89982C13.0437 3.10164 13.3758 3.30347 13.5465 3.44995L13.5655 3.46623ZM13.5655 8.07235V10.5203C13.1449 10.7546 12.5662 10.9825 11.8326 11.1681C10.7606 11.4415 9.43882 11.6042 8.00002 11.6042C6.56122 11.6042 5.23942 11.4415 4.16743 11.1681C3.4338 10.9825 2.85512 10.7579 2.43454 10.5203V8.07235C2.85512 8.24487 3.3168 8.39461 3.80378 8.51831C5.01174 8.8243 6.45687 9.00008 8.00002 9.00008C9.54318 9.00008 10.9883 8.8243 12.1963 8.51831C12.6832 8.39461 13.1449 8.24813 13.5655 8.07235ZM2.43454 14.5339V12.2423C2.85512 12.4148 3.3168 12.5645 3.80378 12.6882C5.01174 12.991 6.45687 13.1667 8.00002 13.1667C9.54318 13.1667 10.9883 12.991 12.1963 12.685C12.6832 12.5613 13.1449 12.4148 13.5655 12.239V14.5307L13.5465 14.547C13.3789 14.6934 13.0437 14.8953 12.4967 15.0971C11.4184 15.4942 9.82777 15.7709 8.00002 15.7709C6.17227 15.7709 4.58168 15.4942 3.50337 15.1003C2.95631 14.8985 2.62428 14.6967 2.45352 14.5502L2.43454 14.5339ZM13.6319 14.4656C13.6319 14.4656 13.6319 14.4688 13.6256 14.4721L13.6287 14.4656C13.6287 14.4656 13.6287 14.4656 13.6287 14.4623L13.6319 14.4656ZM2.3713 14.4656C2.3713 14.4656 2.3713 14.4688 2.37762 14.4721C2.37446 14.4688 2.37446 14.4656 2.3713 14.4656ZM13.6287 3.52808C13.6319 3.53133 13.6351 3.53459 13.6351 3.53459C13.6351 3.53459 13.6351 3.53133 13.6287 3.52808ZM15.0834 14.7292V3.27092C15.0834 1.83211 11.9117 0.666748 8.00002 0.666748C4.08838 0.666748 0.916687 1.83211 0.916687 3.27092V14.7292C0.916687 16.1681 4.08838 17.3334 8.00002 17.3334C11.9117 17.3334 15.0834 16.1681 15.0834 14.7292Z"
    ],
    category: "System",
    viewBox: "0 0 16 18"
  },
  "database-filled": {
    paths: [
      "M15.5416 3.27092V4.83342C15.5416 6.27222 12.2767 7.43758 8.24998 7.43758C4.22329 7.43758 0.958313 6.27222 0.958313 4.83342V3.27092C0.958313 1.83211 4.22329 0.666748 8.24998 0.666748C12.2767 0.666748 15.5416 1.83211 15.5416 3.27092ZM13.7578 7.65568C14.4349 7.4148 15.0566 7.10555 15.5416 6.72469V10.0417C15.5416 11.4806 12.2767 12.6459 8.24998 12.6459C4.22329 12.6459 0.958313 11.4806 0.958313 10.0417V6.72469C1.44334 7.10881 2.06508 7.4148 2.74217 7.65568C4.20376 8.17651 6.15037 8.47925 8.24998 8.47925C10.3496 8.47925 12.2962 8.17651 13.7578 7.65568ZM0.958313 11.933C1.44334 12.3171 2.06508 12.6231 2.74217 12.864C4.20376 13.3848 6.15037 13.6876 8.24998 13.6876C10.3496 13.6876 12.2962 13.3848 13.7578 12.864C14.4349 12.6231 15.0566 12.3139 15.5416 11.933V14.7292C15.5416 16.1681 12.2767 17.3334 8.24998 17.3334C4.22329 17.3334 0.958313 16.1681 0.958313 14.7292V11.933Z"
    ],
    category: "System",
    viewBox: "0 0 16 18"
  },
  "file-xml": {
    paths: [
      "M4.5 20.125H6.375V22H4.5C3.12109 22 2 20.8789 2 19.5V4.5C2 3.12109 3.12109 2 4.5 2H10.9648C11.6289 2 12.2656 2.26172 12.7344 2.73047L16.2695 6.26562C16.7383 6.73437 17 7.37109 17 8.03516V13.875H15.125V8.25H12C11.3086 8.25 10.75 7.69141 10.75 7V3.875H4.5C4.15625 3.875 3.875 4.15625 3.875 4.5V19.5C3.875 19.8438 4.15625 20.125 4.5 20.125ZM9.5 16.375C9.5 16.6602 9.58594 16.9375 9.74219 17.1719L10.125 17.7461L10.5078 17.1719C10.6641 16.9336 10.75 16.6562 10.75 16.375C10.75 16.0312 11.0312 15.75 11.375 15.75C11.7188 15.75 12 16.0312 12 16.375C12 16.9063 11.8437 17.4258 11.5469 17.8672L10.875 18.875L11.5469 19.8828C11.8437 20.3242 12 20.8437 12 21.375C12 21.7188 11.7188 22 11.375 22C11.0312 22 10.75 21.7188 10.75 21.375C10.75 21.0898 10.6641 20.8125 10.5078 20.5781L10.125 20L9.74219 20.5742C9.58594 20.8125 9.5 21.0898 9.5 21.3711C9.5 21.7148 9.21875 21.9961 8.875 21.9961C8.53125 21.9961 8.25 21.7148 8.25 21.3711C8.25 20.8398 8.40625 20.3203 8.70313 19.8789L9.375 18.875L8.70313 17.8672C8.40625 17.4258 8.25 16.9063 8.25 16.375C8.25 16.0312 8.53125 15.75 8.875 15.75C9.21875 15.75 9.5 16.0312 9.5 16.375ZM19.5 21.375V16.375C19.5 16.0312 19.7812 15.75 20.125 15.75C20.4688 15.75 20.75 16.0312 20.75 16.375V20.75H21.375C21.7188 20.75 22 21.0312 22 21.375C22 21.7188 21.7188 22 21.375 22H20.125C19.7812 22 19.5 21.7188 19.5 21.375ZM13.707 15.7734C13.9766 15.6992 14.2656 15.8125 14.4102 16.0547L15.75 18.2852L17.0898 16.0547C17.2344 15.8125 17.5234 15.6992 17.793 15.7734C18.0625 15.8477 18.25 16.0938 18.25 16.375V21.375C18.25 21.7188 17.9688 22 17.625 22C17.2812 22 17 21.7188 17 21.375V18.6328L16.2852 19.8242C16.1719 20.0117 15.9687 20.1289 15.75 20.1289C15.5313 20.1289 15.3281 20.0156 15.2148 19.8242L14.5 18.6328V21.375C14.5 21.7188 14.2188 22 13.875 22C13.5312 22 13.25 21.7188 13.25 21.375V16.375C13.25 16.0938 13.4375 15.8477 13.707 15.7734Z"
    ],
    category: "Data Source"
  },
  "property-inspection": {
    paths: [
      "M20 2C20.552 2 21 2.448 21 3V6.757L19 8.757V4H5V20H19V17.242L21 15.242V21C21 21.552 20.552 22 20 22H4C3.448 22 3 21.552 3 21V3C3 2.448 3.448 2 4 2H20ZM21.778 8.808L23.192 10.222L15.414 18L13.998 17.998L14 16.586L21.778 8.808V8.808ZM13 12V14H8V12H13ZM16 8V10H8V8H16Z"
    ],
    category: "Data Source"
  },
  "public-record": {
    paths: [
      "M6.5 10H4.5V17H6.5V10ZM12.5 10H10.5V17H12.5V10ZM21 19H2V21H21V19ZM18.5 10H16.5V17H18.5V10ZM11.5 3.26L16.71 6H6.29L11.5 3.26ZM11.5 1L2 6V8H21V6L11.5 1Z"
    ],
    category: "Data Source"
  },
  "user-input": {
    paths: [
      "M15 23L15.5 20.5L19.5734 16.4266L21.5734 18.4266L17.5 22.5L15 23ZM21.9266 18.0734L19.9266 16.0734L21 15L23 17L21.9266 18.0734Z",
      "M14 14.252V16.342C13.0949 16.022 12.1263 15.9239 11.1754 16.0558C10.2245 16.1877 9.3192 16.5459 8.53543 17.1002C7.75166 17.6545 7.11234 18.3888 6.67116 19.2414C6.22998 20.094 5.99982 21.04 6 22L4 21.999C3.99969 20.7779 4.27892 19.5729 4.8163 18.4764C5.35368 17.3799 6.13494 16.4209 7.10022 15.673C8.0655 14.9251 9.18918 14.4081 10.3852 14.1616C11.5811 13.9152 12.8177 13.9467 14 14.252ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13ZM12 11C14.21 11 16 9.21 16 7C16 4.79 14.21 3 12 3C9.79 3 8 4.79 8 7C8 9.21 9.79 11 12 11Z"
    ],
    category: "Data Source"
  },
  people: {
    paths: [
      "M12 11C13.3261 11 14.5979 11.5268 15.5355 12.4645C16.4732 13.4021 17 14.6739 17 16V22H15V16C15 15.2348 14.7077 14.4985 14.1827 13.9417C13.6578 13.385 12.9399 13.0499 12.176 13.005L12 13C11.2348 13 10.4985 13.2923 9.94174 13.8173C9.38499 14.3422 9.04989 15.0601 9.005 15.824L9 16V22H7V16C7 14.6739 7.52678 13.4021 8.46447 12.4645C9.40215 11.5268 10.6739 11 12 11ZM5.5 14C5.779 14 6.05 14.033 6.31 14.094C6.13902 14.603 6.03777 15.1328 6.009 15.669L6 16V16.086C5.88505 16.0449 5.76549 16.018 5.644 16.006L5.5 16C5.12712 16 4.76761 16.1389 4.49158 16.3896C4.21555 16.6403 4.0428 16.9848 4.007 17.356L4 17.5V22H2V17.5C2 16.5717 2.36875 15.6815 3.02513 15.0251C3.6815 14.3687 4.57174 14 5.5 14ZM18.5 14C19.4283 14 20.3185 14.3687 20.9749 15.0251C21.6313 15.6815 22 16.5717 22 17.5V22H20V17.5C20 17.1271 19.8611 16.7676 19.6104 16.4916C19.3597 16.2156 19.0152 16.0428 18.644 16.007L18.5 16C18.325 16 18.157 16.03 18 16.085V16C18 15.334 17.892 14.694 17.691 14.096C17.95 14.033 18.221 14 18.5 14ZM5.5 8C6.16304 8 6.79893 8.26339 7.26777 8.73223C7.73661 9.20107 8 9.83696 8 10.5C8 11.163 7.73661 11.7989 7.26777 12.2678C6.79893 12.7366 6.16304 13 5.5 13C4.83696 13 4.20107 12.7366 3.73223 12.2678C3.26339 11.7989 3 11.163 3 10.5C3 9.83696 3.26339 9.20107 3.73223 8.73223C4.20107 8.26339 4.83696 8 5.5 8ZM18.5 8C19.163 8 19.7989 8.26339 20.2678 8.73223C20.7366 9.20107 21 9.83696 21 10.5C21 11.163 20.7366 11.7989 20.2678 12.2678C19.7989 12.7366 19.163 13 18.5 13C17.837 13 17.2011 12.7366 16.7322 12.2678C16.2634 11.7989 16 11.163 16 10.5C16 9.83696 16.2634 9.20107 16.7322 8.73223C17.2011 8.26339 17.837 8 18.5 8ZM5.5 10C5.36739 10 5.24021 10.0527 5.14645 10.1464C5.05268 10.2402 5 10.3674 5 10.5C5 10.6326 5.05268 10.7598 5.14645 10.8536C5.24021 10.9473 5.36739 11 5.5 11C5.63261 11 5.75979 10.9473 5.85355 10.8536C5.94732 10.7598 6 10.6326 6 10.5C6 10.3674 5.94732 10.2402 5.85355 10.1464C5.75979 10.0527 5.63261 10 5.5 10ZM18.5 10C18.3674 10 18.2402 10.0527 18.1464 10.1464C18.0527 10.2402 18 10.3674 18 10.5C18 10.6326 18.0527 10.7598 18.1464 10.8536C18.2402 10.9473 18.3674 11 18.5 11C18.6326 11 18.7598 10.9473 18.8536 10.8536C18.9473 10.7598 19 10.6326 19 10.5C19 10.3674 18.9473 10.2402 18.8536 10.1464C18.7598 10.0527 18.6326 10 18.5 10ZM12 2C13.0609 2 14.0783 2.42143 14.8284 3.17157C15.5786 3.92172 16 4.93913 16 6C16 7.06087 15.5786 8.07828 14.8284 8.82843C14.0783 9.57857 13.0609 10 12 10C10.9391 10 9.92172 9.57857 9.17157 8.82843C8.42143 8.07828 8 7.06087 8 6C8 4.93913 8.42143 3.92172 9.17157 3.17157C9.92172 2.42143 10.9391 2 12 2ZM12 4C11.4696 4 10.9609 4.21071 10.5858 4.58579C10.2107 4.96086 10 5.46957 10 6C10 6.53043 10.2107 7.03914 10.5858 7.41421C10.9609 7.78929 11.4696 8 12 8C12.5304 8 13.0391 7.78929 13.4142 7.41421C13.7893 7.03914 14 6.53043 14 6C14 5.46957 13.7893 4.96086 13.4142 4.58579C13.0391 4.21071 12.5304 4 12 4Z"
    ],
    category: "System"
  },
  signature: {
    viewBox: "0 0 16 16",
    paths: [
      "M3.33333 12.6667H4.276L10.4853 6.45739L9.54267 5.51472L3.33333 11.7241V12.6667ZM14 14.0001H2V11.1714L10.9567 2.21472C11.0817 2.08974 11.2512 2.01953 11.428 2.01953C11.6048 2.01953 11.7743 2.08974 11.8993 2.21472L13.7853 4.10072C13.9103 4.22574 13.9805 4.39528 13.9805 4.57206C13.9805 4.74883 13.9103 4.91837 13.7853 5.04339L6.162 12.6667H14V14.0001ZM10.4853 4.57206L11.428 5.51472L12.3707 4.57206L11.428 3.62939L10.4853 4.57206Z"
    ],
    category: "Document"
  },
  "signature-draw": {
    viewBox: "0 0 640 640",
    paths: [
      "M192 192C192 174.3 206.3 160 224 160C241.7 160 256 174.3 256 192L256 199.8C256 227.5 253.6 255.1 248.9 282.3L164.5 307.6C123.9 319.8 96.1 357.2 96.1 399.6L96.1 432L24.1 432C10.8 432 .1 442.7 .1 456C.1 469.3 10.8 480 24.1 480L96.6 480C100.8 516 131.4 544 168.6 544C194.6 544 218.6 530.1 231.5 507.5L245.4 483.2C272.2 436.2 291.9 385.5 303.8 332.7L398.2 304.4L385.7 341.9C382.4 351.7 384.1 362.4 390.1 370.7C396.1 379 405.7 384 416 384L544 384C561.7 384 576 369.7 576 352C576 334.3 561.7 320 544 320L460.4 320L478.4 266.1C482.2 254.8 479.3 242.3 471 233.7C462.7 225.1 450.3 221.9 438.8 225.3L316.4 262.1C318.8 241.4 320 220.7 320 199.8L320 192C320 139 277 96 224 96C171 96 128 139 128 192L128 224C128 241.7 142.3 256 160 256C177.7 256 192 241.7 192 224L192 192zM182.8 369L231.8 354.3C221.4 388.1 207.3 420.7 189.7 451.5L175.8 475.8C174.3 478.4 171.5 480.1 168.4 480.1C163.7 480.1 159.9 476.3 159.9 471.6L159.9 399.7C159.9 385.6 169.2 373.1 182.7 369zM616 480C629.3 480 640 469.3 640 456C640 442.7 629.3 432 616 432L323.1 432C316.6 448.3 309.4 464.3 301.5 480L616 480"
    ],
    category: "Document"
  },
  comment: {
    viewBox: "0 0 24 24",
    paths: [
      "M21 3C21.552 3 22 3.448 22 4V18C22 18.552 21.552 19 21 19H6.455L2 22.5V4C2 3.448 2.448 3 3 3H21ZM20 5H4V18.385L5.763 17H20V5ZM10.515 7.412L10.962 8.1C9.294 9.003 9.323 10.452 9.323 10.764C9.478 10.744 9.641 10.74 9.803 10.755C10.705 10.839 11.416 11.58 11.416 12.5C11.416 13.466 10.632 14.25 9.666 14.25C9.129 14.25 8.616 14.005 8.292 13.66C7.777 13.114 7.5 12.5 7.5 11.505C7.5 9.755 8.728 8.187 10.515 7.412ZM15.515 7.412L15.962 8.1C14.294 9.003 14.323 10.452 14.323 10.764C14.478 10.744 14.641 10.74 14.803 10.755C15.705 10.839 16.416 11.58 16.416 12.5C16.416 13.466 15.632 14.25 14.666 14.25C14.129 14.25 13.616 14.005 13.292 13.66C12.777 13.114 12.5 12.5 12.5 11.505C12.5 9.755 13.728 8.187 15.515 7.412Z"
    ],
    category: "System"
  },
  pdf: {
    viewBox: "0 0 24 24",
    paths: [
      "M5.45801 19.375V19.5C5.45801 20.1148 5.99198 20.625 6.66699 20.625H17.333C18.0092 20.625 18.542 20.1149 18.542 19.5V19.375H20.125V19.5C20.125 20.9554 18.8652 22.125 17.333 22.125H6.66699C5.1327 22.125 3.875 20.9554 3.875 19.5V19.375H5.45801ZM7.66699 11.875C9.01566 11.8752 10.125 12.9041 10.125 14.1875C10.125 15.4709 9.01566 16.4998 7.66699 16.5H7.45801V17.625C7.45801 18.045 7.09671 18.3748 6.66699 18.375C6.23714 18.375 5.875 18.0451 5.875 17.625V12.625C5.875 12.2049 6.23714 11.875 6.66699 11.875H7.66699ZM12.333 11.875C13.4985 11.875 14.458 12.7633 14.458 13.875V16.375C14.458 17.4867 13.4985 18.375 12.333 18.375H11.333C10.9052 18.3748 10.542 18.0452 10.542 17.625V12.625C10.542 12.2048 10.9052 11.8752 11.333 11.875H12.333ZM18 11.875C18.428 11.875 18.792 12.2047 18.792 12.625C18.792 13.0453 18.428 13.375 18 13.375H16.792V14.375H18C18.428 14.375 18.792 14.7047 18.792 15.125C18.792 15.5453 18.428 15.875 18 15.875H16.792V17.625C16.792 18.0453 16.428 18.375 16 18.375C15.572 18.375 15.208 18.0453 15.208 17.625V12.625C15.208 12.2047 15.572 11.875 16 11.875H18ZM12.125 16.875H12.333C12.6384 16.875 12.875 16.6422 12.875 16.375V13.875C12.875 13.6078 12.6384 13.375 12.333 13.375H12.125V16.875ZM7.45801 15H7.66699C8.15969 14.9998 8.54199 14.6304 8.54199 14.1875C8.54199 13.7446 8.15969 13.3752 7.66699 13.375H7.45801V15ZM13.1709 1.875C13.7304 1.87502 14.2738 2.08378 14.6729 2.45801L19.498 6.9834C19.8971 7.35762 20.125 7.87042 20.125 8.40234V10.875H18.542V9.625H14C12.8345 9.625 11.875 8.73667 11.875 7.625V3.375H6.66699C5.99206 3.375 5.45801 3.88628 5.45801 4.5V10.875H3.875V4.5C3.875 3.04263 5.13276 1.875 6.66699 1.875H13.1709ZM13.458 7.625C13.458 7.89224 13.6946 8.125 14 8.125H18.4502C18.4318 8.09951 18.4115 8.07493 18.3877 8.05371L18.3857 8.05176L13.5566 3.52441L13.5547 3.52246C13.5264 3.49504 13.4935 3.47163 13.458 3.45117V7.625Z"
    ],
    category: "Document"
  },
  inspectifyReport: {
    viewBox: "0 0 24 24",
    paths: [
      "M20 2C20.552 2 21 2.448 21 3V6.757L19 8.757V4H5V20H19V17.242L21 15.242V21C21 21.552 20.552 22 20 22H4C3.448 22 3 21.552 3 21V3C3 2.448 3.448 2 4 2H20ZM21.778 8.808L23.192 10.222L15.414 18L13.998 17.998L14 16.586L21.778 8.808ZM13 12V14H8V12H13ZM16 8V10H8V8H16Z"
    ],
    category: "Document"
  },
  "quality-tiers": {
    viewBox: "0 0 16 16",
    paths: [
      "M9.57655 8.00783C10.2025 8.07293 10.6914 8.60414 10.6914 9.25253V10.5024H12.7609L12.8876 10.5076C13.5136 10.5727 14.0025 11.104 14.0025 11.7523V13.4189L13.9973 13.5465C13.9378 14.135 13.4722 14.6037 12.8902 14.661L12.7634 14.6662H3.24415C2.55866 14.6662 2.0025 14.1063 2.0025 13.4163V10.9165C2.0025 10.2264 2.55866 9.66656 3.24415 9.66656H5.72744V9.24992C5.72744 8.60153 6.21634 8.07032 6.84234 8.00522L6.96909 8.00002H9.45238L9.57914 8.00522L9.57655 8.00783ZM3.24156 13.4163H5.72486V10.9165H3.24156V13.4163ZM6.9665 13.4163H9.4498V9.24992H6.9665V13.4163ZM10.6914 13.4163H12.7609V11.7497H10.6914V13.4163ZM7.9443 1.4979C8.05553 1.27395 8.37112 1.28177 8.472 1.4979L9.08248 2.73999L10.4354 2.93789C10.6759 2.97435 10.7768 3.2738 10.6009 3.45348L9.62052 4.40914L9.85075 5.76581C9.88696 6.00798 9.63604 6.19546 9.41617 6.08349L8.21332 5.44812L7.00013 6.09391C6.77767 6.20588 6.52675 6.01839 6.56555 5.77622L6.79578 4.41955L5.81539 3.45608C5.63949 3.27901 5.74038 2.97956 5.98095 2.9405L7.33382 2.74259L7.9443 1.5005V1.4979Z"
    ],
    category: "System"
  }
}, Lre = {
  sm: 10,
  md: 16,
  lg: 24,
  xl: 48,
  xxl: 64
};
const Xo = Ke(
  ({ color: e, icon: t, size: n = "md", variant: r = "default", __styleDoNotUse: o, __testId: a }, i) => {
    const { paths: l, viewBox: u = "0 0 24 24" } = Ire[t], d = Lre[n], h = {
      fill: e ? Hr[e] : "currentColor",
      ...o || {}
    }, p = l.map((g, C) => /* @__PURE__ */ A.jsx("path", { d: g }, C));
    return /* @__PURE__ */ A.jsx(
      "svg",
      {
        ref: i,
        className: Ur("icon", r === "outlined" && r),
        "data-testid": a || t,
        width: d,
        height: d,
        viewBox: u,
        xmlns: "http://www.w3.org/2000/svg",
        style: h,
        fillRule: _re(t),
        children: p
      }
    );
  }
);
Xo.displayName = "Icon";
const Rre = (e) => {
  switch (e) {
    case "complete":
      return "check";
    case "inProgress":
      return "subtract";
    case "overdue":
      return "information";
    case "primary":
    default:
      return "flag-2";
  }
}, n4e = ({ __testId: e, status: t }) => /* @__PURE__ */ A.jsx(xre, { size: "sm", variant: t, __testId: e, children: /* @__PURE__ */ A.jsx(Xo, { icon: Rre(t), size: "sm", color: "textOffset" }) }), Qw = ({ text: e, variant: t = "primary", size: n = "sm" }) => /* @__PURE__ */ A.jsx("span", { className: `badge ${t} ${n}`, children: e });
const e_ = ({ size: e = 20 }) => /* @__PURE__ */ A.jsxs(
  "div",
  {
    className: "small-roller",
    style: { height: e, width: e, transform: `scale(${e / 80})` },
    children: [
      /* @__PURE__ */ A.jsx("div", {}),
      /* @__PURE__ */ A.jsx("div", {}),
      /* @__PURE__ */ A.jsx("div", {}),
      /* @__PURE__ */ A.jsx("div", {}),
      /* @__PURE__ */ A.jsx("div", {}),
      /* @__PURE__ */ A.jsx("div", {})
    ]
  }
), Dre = (e, t) => e === "nav" ? "arrow-left" : t, o3 = Ke(
  ({
    variant: e = "primary",
    icon: t,
    disabled: n,
    onClick: r,
    onMouseDown: o,
    size: a,
    __dangerDoNotUseSx: i,
    __testId: l,
    title: u,
    text: d,
    isLoading: f,
    "data-trace-name": h,
    fullWidth: p,
    rightIcon: g,
    type: C = "button",
    tabIndex: v,
    marginLeft: y,
    marginRight: M,
    id: x,
    badge: _
  }, L) => {
    const R = Dre(e, t);
    return (
      // eslint-disable-next-line aloft/prefer-sound-ui-button
      /* @__PURE__ */ A.jsxs(
        "button",
        {
          ref: L,
          id: x,
          "data-testid": l ?? x,
          "data-trace-name": h,
          className: Ur("button", e, a, (n || f) && "disabled"),
          style: {
            ...i,
            width: p ? "100%" : void 0,
            marginLeft: y,
            marginRight: M,
            position: f ? "relative" : i == null ? void 0 : i.position
          },
          title: u,
          onClick: r,
          onMouseDown: (k) => {
            k.preventDefault(), o == null || o(k);
          },
          disabled: n || f,
          type: C,
          tabIndex: v,
          children: [
            /* @__PURE__ */ A.jsxs("div", { className: Ur("contents", f && "loading"), children: [
              R && /* @__PURE__ */ A.jsx(Xo, { icon: R, size: a }),
              d,
              g && /* @__PURE__ */ A.jsx(Xo, { icon: g, size: a }),
              _ && /* @__PURE__ */ A.jsx(Qw, { ..._ })
            ] }),
            f && /* @__PURE__ */ A.jsx("div", { className: "loader", children: /* @__PURE__ */ A.jsx(e_, { size: a === "sm" || e === "inline" ? 20 : 30 }) })
          ]
        }
      )
    );
  }
), g9 = Ke(
  ({ children: e, ...t }, n) => /* @__PURE__ */ A.jsx(m9, { ref: n, ...t, children: /* @__PURE__ */ A.jsx(Ma, { children: e }) })
), R2 = Ke(
  ({
    id: e,
    variant: t = "primary",
    ariaLabel: n,
    icon: r,
    disabled: o,
    onClick: a,
    onMouseDown: i,
    size: l = "md",
    __dangerDoNotUseSx: u,
    __testId: d,
    title: f,
    iconSize: h = "md",
    isLoading: p,
    iconColor: g,
    tabIndex: C,
    isRound: v
  }, y) => {
    let M = 30;
    return l === "xs" ? M = 16 : l === "sm" && (M = 20), // eslint-disable-next-line aloft/prefer-sound-ui-button
    /* @__PURE__ */ A.jsx(
      "button",
      {
        ref: y,
        className: Ur(
          "button",
          "icon-button",
          t,
          l,
          (o || p) && "disabled",
          v && "round"
        ),
        id: e,
        tabIndex: C,
        "aria-label": n,
        "data-testid": d ?? e,
        title: f ?? n,
        onClick: a,
        onMouseDown: i,
        disabled: o,
        type: "button",
        style: u,
        children: p ? /* @__PURE__ */ A.jsx("div", { className: "loader", children: /* @__PURE__ */ A.jsx(e_, { size: M }) }) : /* @__PURE__ */ A.jsx(Xo, { icon: r, size: h, color: g })
      }
    );
  }
);
R2.displayName = "IconButton";
const Pre = Ke(
  ({ size: e = "xs", value: t }, n) => {
    if (!t)
      return null;
    const [r, o] = He("Copy to clipboard"), a = (i) => {
      i.stopPropagation(), i.preventDefault(), navigator.clipboard.writeText(t), o("Copied!"), setTimeout(() => {
        o("Copy to clipboard");
      }, 2e3);
    };
    return /* @__PURE__ */ A.jsx(g9, { openDelay: 500, label: r, children: /* @__PURE__ */ A.jsx(
      R2,
      {
        ref: n,
        ariaLabel: "Copy to clipboard",
        icon: "file-copy",
        size: e,
        variant: "tertiary",
        onClick: a
      }
    ) });
  }
);
Pre.displayName = "CopyButton";
const t_ = (e) => {
  throw new Error(`unexpected: ${e}`);
}, r4e = (e) => {
  switch (e) {
    case "xs":
    case "sm":
      return "sm";
    case "md":
      return "md";
    case "lg":
      return "lg";
    default:
      t_(e);
  }
}, Ere = Ke(
  ({ isChecked: e, onChange: t, isDisabled: n, isIndeterminate: r, children: o }, a) => /* @__PURE__ */ A.jsx(
    N4,
    {
      ref: a,
      isChecked: e,
      onChange: t,
      isDisabled: n,
      isIndeterminate: r,
      children: o
    }
  )
);
Ere.displayName = "Checkbox";
function Tre(e = {}) {
  const {
    strict: t = !0,
    errorMessage: n = "useContext: `context` is undefined. Seems you forgot to wrap component within the Provider",
    name: r
  } = e, o = ea(void 0);
  o.displayName = r;
  function a() {
    var i;
    const l = Yn(o);
    if (!l && t) {
      const u = new Error(n);
      throw u.name = "ContextError", (i = Error.captureStackTrace) == null || i.call(Error, u, a), u;
    }
    return l;
  }
  return [
    o.Provider,
    a,
    o
  ];
}
var qt;
(function(e) {
  e.assertEqual = (o) => {
  };
  function t(o) {
  }
  e.assertIs = t;
  function n(o) {
    throw new Error();
  }
  e.assertNever = n, e.arrayToEnum = (o) => {
    const a = {};
    for (const i of o)
      a[i] = i;
    return a;
  }, e.getValidEnumValues = (o) => {
    const a = e.objectKeys(o).filter((l) => typeof o[o[l]] != "number"), i = {};
    for (const l of a)
      i[l] = o[l];
    return e.objectValues(i);
  }, e.objectValues = (o) => e.objectKeys(o).map(function(a) {
    return o[a];
  }), e.objectKeys = typeof Object.keys == "function" ? (o) => Object.keys(o) : (o) => {
    const a = [];
    for (const i in o)
      Object.prototype.hasOwnProperty.call(o, i) && a.push(i);
    return a;
  }, e.find = (o, a) => {
    for (const i of o)
      if (a(i))
        return i;
  }, e.isInteger = typeof Number.isInteger == "function" ? (o) => Number.isInteger(o) : (o) => typeof o == "number" && Number.isFinite(o) && Math.floor(o) === o;
  function r(o, a = " | ") {
    return o.map((i) => typeof i == "string" ? `'${i}'` : i).join(a);
  }
  e.joinValues = r, e.jsonStringifyReplacer = (o, a) => typeof a == "bigint" ? a.toString() : a;
})(qt || (qt = {}));
var ob;
(function(e) {
  e.mergeShapes = (t, n) => ({
    ...t,
    ...n
    // second overwrites first
  });
})(ob || (ob = {}));
const We = qt.arrayToEnum([
  "string",
  "nan",
  "number",
  "integer",
  "float",
  "boolean",
  "date",
  "bigint",
  "symbol",
  "function",
  "undefined",
  "null",
  "array",
  "object",
  "unknown",
  "promise",
  "void",
  "never",
  "map",
  "set"
]), cs = (e) => {
  switch (typeof e) {
    case "undefined":
      return We.undefined;
    case "string":
      return We.string;
    case "number":
      return Number.isNaN(e) ? We.nan : We.number;
    case "boolean":
      return We.boolean;
    case "function":
      return We.function;
    case "bigint":
      return We.bigint;
    case "symbol":
      return We.symbol;
    case "object":
      return Array.isArray(e) ? We.array : e === null ? We.null : e.then && typeof e.then == "function" && e.catch && typeof e.catch == "function" ? We.promise : typeof Map < "u" && e instanceof Map ? We.map : typeof Set < "u" && e instanceof Set ? We.set : typeof Date < "u" && e instanceof Date ? We.date : We.object;
    default:
      return We.unknown;
  }
}, we = qt.arrayToEnum([
  "invalid_type",
  "invalid_literal",
  "custom",
  "invalid_union",
  "invalid_union_discriminator",
  "invalid_enum_value",
  "unrecognized_keys",
  "invalid_arguments",
  "invalid_return_type",
  "invalid_date",
  "invalid_string",
  "too_small",
  "too_big",
  "invalid_intersection_types",
  "not_multiple_of",
  "not_finite"
]);
class Di extends Error {
  get errors() {
    return this.issues;
  }
  constructor(t) {
    super(), this.issues = [], this.addIssue = (r) => {
      this.issues = [...this.issues, r];
    }, this.addIssues = (r = []) => {
      this.issues = [...this.issues, ...r];
    };
    const n = new.target.prototype;
    Object.setPrototypeOf ? Object.setPrototypeOf(this, n) : this.__proto__ = n, this.name = "ZodError", this.issues = t;
  }
  format(t) {
    const n = t || function(a) {
      return a.message;
    }, r = { _errors: [] }, o = (a) => {
      for (const i of a.issues)
        if (i.code === "invalid_union")
          i.unionErrors.map(o);
        else if (i.code === "invalid_return_type")
          o(i.returnTypeError);
        else if (i.code === "invalid_arguments")
          o(i.argumentsError);
        else if (i.path.length === 0)
          r._errors.push(n(i));
        else {
          let l = r, u = 0;
          for (; u < i.path.length; ) {
            const d = i.path[u];
            u === i.path.length - 1 ? (l[d] = l[d] || { _errors: [] }, l[d]._errors.push(n(i))) : l[d] = l[d] || { _errors: [] }, l = l[d], u++;
          }
        }
    };
    return o(this), r;
  }
  static assert(t) {
    if (!(t instanceof Di))
      throw new Error(`Not a ZodError: ${t}`);
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, qt.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(t = (n) => n.message) {
    const n = {}, r = [];
    for (const o of this.issues)
      o.path.length > 0 ? (n[o.path[0]] = n[o.path[0]] || [], n[o.path[0]].push(t(o))) : r.push(t(o));
    return { formErrors: r, fieldErrors: n };
  }
  get formErrors() {
    return this.flatten();
  }
}
Di.create = (e) => new Di(e);
const a3 = (e, t) => {
  let n;
  switch (e.code) {
    case we.invalid_type:
      e.received === We.undefined ? n = "Required" : n = `Expected ${e.expected}, received ${e.received}`;
      break;
    case we.invalid_literal:
      n = `Invalid literal value, expected ${JSON.stringify(e.expected, qt.jsonStringifyReplacer)}`;
      break;
    case we.unrecognized_keys:
      n = `Unrecognized key(s) in object: ${qt.joinValues(e.keys, ", ")}`;
      break;
    case we.invalid_union:
      n = "Invalid input";
      break;
    case we.invalid_union_discriminator:
      n = `Invalid discriminator value. Expected ${qt.joinValues(e.options)}`;
      break;
    case we.invalid_enum_value:
      n = `Invalid enum value. Expected ${qt.joinValues(e.options)}, received '${e.received}'`;
      break;
    case we.invalid_arguments:
      n = "Invalid function arguments";
      break;
    case we.invalid_return_type:
      n = "Invalid function return type";
      break;
    case we.invalid_date:
      n = "Invalid date";
      break;
    case we.invalid_string:
      typeof e.validation == "object" ? "includes" in e.validation ? (n = `Invalid input: must include "${e.validation.includes}"`, typeof e.validation.position == "number" && (n = `${n} at one or more positions greater than or equal to ${e.validation.position}`)) : "startsWith" in e.validation ? n = `Invalid input: must start with "${e.validation.startsWith}"` : "endsWith" in e.validation ? n = `Invalid input: must end with "${e.validation.endsWith}"` : qt.assertNever(e.validation) : e.validation !== "regex" ? n = `Invalid ${e.validation}` : n = "Invalid";
      break;
    case we.too_small:
      e.type === "array" ? n = `Array must contain ${e.exact ? "exactly" : e.inclusive ? "at least" : "more than"} ${e.minimum} element(s)` : e.type === "string" ? n = `String must contain ${e.exact ? "exactly" : e.inclusive ? "at least" : "over"} ${e.minimum} character(s)` : e.type === "number" ? n = `Number must be ${e.exact ? "exactly equal to " : e.inclusive ? "greater than or equal to " : "greater than "}${e.minimum}` : e.type === "date" ? n = `Date must be ${e.exact ? "exactly equal to " : e.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(e.minimum))}` : n = "Invalid input";
      break;
    case we.too_big:
      e.type === "array" ? n = `Array must contain ${e.exact ? "exactly" : e.inclusive ? "at most" : "less than"} ${e.maximum} element(s)` : e.type === "string" ? n = `String must contain ${e.exact ? "exactly" : e.inclusive ? "at most" : "under"} ${e.maximum} character(s)` : e.type === "number" ? n = `Number must be ${e.exact ? "exactly" : e.inclusive ? "less than or equal to" : "less than"} ${e.maximum}` : e.type === "bigint" ? n = `BigInt must be ${e.exact ? "exactly" : e.inclusive ? "less than or equal to" : "less than"} ${e.maximum}` : e.type === "date" ? n = `Date must be ${e.exact ? "exactly" : e.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(e.maximum))}` : n = "Invalid input";
      break;
    case we.custom:
      n = "Invalid input";
      break;
    case we.invalid_intersection_types:
      n = "Intersection results could not be merged";
      break;
    case we.not_multiple_of:
      n = `Number must be a multiple of ${e.multipleOf}`;
      break;
    case we.not_finite:
      n = "Number must be finite";
      break;
    default:
      n = t.defaultError, qt.assertNever(e);
  }
  return { message: n };
};
let Nre = a3;
function kre() {
  return Nre;
}
const Vre = (e) => {
  const { data: t, path: n, errorMaps: r, issueData: o } = e, a = [...n, ...o.path || []], i = {
    ...o,
    path: a
  };
  if (o.message !== void 0)
    return {
      ...o,
      path: a,
      message: o.message
    };
  let l = "";
  const u = r.filter((d) => !!d).slice().reverse();
  for (const d of u)
    l = d(i, { data: t, defaultError: l }).message;
  return {
    ...o,
    path: a,
    message: l
  };
};
function Ge(e, t) {
  const n = kre(), r = Vre({
    issueData: t,
    data: e.data,
    path: e.path,
    errorMaps: [
      e.common.contextualErrorMap,
      // contextual error map is first priority
      e.schemaErrorMap,
      // then schema-bound map if available
      n,
      // then global override map
      n === a3 ? void 0 : a3
      // then global default map
    ].filter((o) => !!o)
  });
  e.common.issues.push(r);
}
class Xr {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    this.value === "valid" && (this.value = "dirty");
  }
  abort() {
    this.value !== "aborted" && (this.value = "aborted");
  }
  static mergeArray(t, n) {
    const r = [];
    for (const o of n) {
      if (o.status === "aborted")
        return vt;
      o.status === "dirty" && t.dirty(), r.push(o.value);
    }
    return { status: t.value, value: r };
  }
  static async mergeObjectAsync(t, n) {
    const r = [];
    for (const o of n) {
      const a = await o.key, i = await o.value;
      r.push({
        key: a,
        value: i
      });
    }
    return Xr.mergeObjectSync(t, r);
  }
  static mergeObjectSync(t, n) {
    const r = {};
    for (const o of n) {
      const { key: a, value: i } = o;
      if (a.status === "aborted" || i.status === "aborted")
        return vt;
      a.status === "dirty" && t.dirty(), i.status === "dirty" && t.dirty(), a.value !== "__proto__" && (typeof i.value < "u" || o.alwaysSet) && (r[a.value] = i.value);
    }
    return { status: t.value, value: r };
  }
}
const vt = Object.freeze({
  status: "aborted"
}), k1 = (e) => ({ status: "dirty", value: e }), ta = (e) => ({ status: "valid", value: e }), ab = (e) => e.status === "aborted", ib = (e) => e.status === "dirty", sc = (e) => e.status === "valid", D2 = (e) => typeof Promise < "u" && e instanceof Promise;
var Ye;
(function(e) {
  e.errToObj = (t) => typeof t == "string" ? { message: t } : t || {}, e.toString = (t) => typeof t == "string" ? t : t == null ? void 0 : t.message;
})(Ye || (Ye = {}));
class Wa {
  constructor(t, n, r, o) {
    this._cachedPath = [], this.parent = t, this.data = n, this._path = r, this._key = o;
  }
  get path() {
    return this._cachedPath.length || (Array.isArray(this._key) ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
  }
}
const sb = (e, t) => {
  if (sc(t))
    return { success: !0, data: t.value };
  if (!e.common.issues.length)
    throw new Error("Validation failed but no issues detected.");
  return {
    success: !1,
    get error() {
      if (this._error)
        return this._error;
      const n = new Di(e.common.issues);
      return this._error = n, this._error;
    }
  };
};
function Rt(e) {
  if (!e)
    return {};
  const { errorMap: t, invalid_type_error: n, required_error: r, description: o } = e;
  if (t && (n || r))
    throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  return t ? { errorMap: t, description: o } : { errorMap: (i, l) => {
    const { message: u } = e;
    return i.code === "invalid_enum_value" ? { message: u ?? l.defaultError } : typeof l.data > "u" ? { message: u ?? r ?? l.defaultError } : i.code !== "invalid_type" ? { message: l.defaultError } : { message: u ?? n ?? l.defaultError };
  }, description: o };
}
class Gt {
  get description() {
    return this._def.description;
  }
  _getType(t) {
    return cs(t.data);
  }
  _getOrReturnCtx(t, n) {
    return n || {
      common: t.parent.common,
      data: t.data,
      parsedType: cs(t.data),
      schemaErrorMap: this._def.errorMap,
      path: t.path,
      parent: t.parent
    };
  }
  _processInputParams(t) {
    return {
      status: new Xr(),
      ctx: {
        common: t.parent.common,
        data: t.data,
        parsedType: cs(t.data),
        schemaErrorMap: this._def.errorMap,
        path: t.path,
        parent: t.parent
      }
    };
  }
  _parseSync(t) {
    const n = this._parse(t);
    if (D2(n))
      throw new Error("Synchronous parse encountered promise.");
    return n;
  }
  _parseAsync(t) {
    const n = this._parse(t);
    return Promise.resolve(n);
  }
  parse(t, n) {
    const r = this.safeParse(t, n);
    if (r.success)
      return r.data;
    throw r.error;
  }
  safeParse(t, n) {
    const r = {
      common: {
        issues: [],
        async: (n == null ? void 0 : n.async) ?? !1,
        contextualErrorMap: n == null ? void 0 : n.errorMap
      },
      path: (n == null ? void 0 : n.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: t,
      parsedType: cs(t)
    }, o = this._parseSync({ data: t, path: r.path, parent: r });
    return sb(r, o);
  }
  "~validate"(t) {
    var r, o;
    const n = {
      common: {
        issues: [],
        async: !!this["~standard"].async
      },
      path: [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: t,
      parsedType: cs(t)
    };
    if (!this["~standard"].async)
      try {
        const a = this._parseSync({ data: t, path: [], parent: n });
        return sc(a) ? {
          value: a.value
        } : {
          issues: n.common.issues
        };
      } catch (a) {
        (o = (r = a == null ? void 0 : a.message) == null ? void 0 : r.toLowerCase()) != null && o.includes("encountered") && (this["~standard"].async = !0), n.common = {
          issues: [],
          async: !0
        };
      }
    return this._parseAsync({ data: t, path: [], parent: n }).then((a) => sc(a) ? {
      value: a.value
    } : {
      issues: n.common.issues
    });
  }
  async parseAsync(t, n) {
    const r = await this.safeParseAsync(t, n);
    if (r.success)
      return r.data;
    throw r.error;
  }
  async safeParseAsync(t, n) {
    const r = {
      common: {
        issues: [],
        contextualErrorMap: n == null ? void 0 : n.errorMap,
        async: !0
      },
      path: (n == null ? void 0 : n.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: t,
      parsedType: cs(t)
    }, o = this._parse({ data: t, path: r.path, parent: r }), a = await (D2(o) ? o : Promise.resolve(o));
    return sb(r, a);
  }
  refine(t, n) {
    const r = (o) => typeof n == "string" || typeof n > "u" ? { message: n } : typeof n == "function" ? n(o) : n;
    return this._refinement((o, a) => {
      const i = t(o), l = () => a.addIssue({
        code: we.custom,
        ...r(o)
      });
      return typeof Promise < "u" && i instanceof Promise ? i.then((u) => u ? !0 : (l(), !1)) : i ? !0 : (l(), !1);
    });
  }
  refinement(t, n) {
    return this._refinement((r, o) => t(r) ? !0 : (o.addIssue(typeof n == "function" ? n(r, o) : n), !1));
  }
  _refinement(t) {
    return new Pi({
      schema: this,
      typeName: Ct.ZodEffects,
      effect: { type: "refinement", refinement: t }
    });
  }
  superRefine(t) {
    return this._refinement(t);
  }
  constructor(t) {
    this.spa = this.safeParseAsync, this._def = t, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.readonly = this.readonly.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this), this["~standard"] = {
      version: 1,
      vendor: "zod",
      validate: (n) => this["~validate"](n)
    };
  }
  optional() {
    return Ai.create(this, this._def);
  }
  nullable() {
    return El.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return $a.create(this);
  }
  promise() {
    return H2.create(this, this._def);
  }
  or(t) {
    return N2.create([this, t], this._def);
  }
  and(t) {
    return k2.create(this, t, this._def);
  }
  transform(t) {
    return new Pi({
      ...Rt(this._def),
      schema: this,
      typeName: Ct.ZodEffects,
      effect: { type: "transform", transform: t }
    });
  }
  default(t) {
    const n = typeof t == "function" ? t : () => t;
    return new G2({
      ...Rt(this._def),
      innerType: this,
      defaultValue: n,
      typeName: Ct.ZodDefault
    });
  }
  brand() {
    return new a_({
      typeName: Ct.ZodBranded,
      type: this,
      ...Rt(this._def)
    });
  }
  catch(t) {
    const n = typeof t == "function" ? t : () => t;
    return new $2({
      ...Rt(this._def),
      innerType: this,
      catchValue: n,
      typeName: Ct.ZodCatch
    });
  }
  describe(t) {
    const n = this.constructor;
    return new n({
      ...this._def,
      description: t
    });
  }
  pipe(t) {
    return C9.create(this, t);
  }
  readonly() {
    return Z2.create(this);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
}
const Ore = /^c[^\s-]{8,}$/i, Fre = /^[0-9a-z]+$/, Bre = /^[0-9A-HJKMNP-TV-Z]{26}$/i, Hre = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i, Gre = /^[a-z0-9_-]{21}$/i, $re = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/, Zre = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/, jre = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i, Wre = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
let $g;
const zre = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, Ure = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/, Xre = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/, Yre = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, qre = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/, Jre = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/, n_ = "((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))", Kre = new RegExp(`^${n_}$`);
function r_(e) {
  let t = "[0-5]\\d";
  e.precision ? t = `${t}\\.\\d{${e.precision}}` : e.precision == null && (t = `${t}(\\.\\d+)?`);
  const n = e.precision ? "+" : "?";
  return `([01]\\d|2[0-3]):[0-5]\\d(:${t})${n}`;
}
function Qre(e) {
  return new RegExp(`^${r_(e)}$`);
}
function eoe(e) {
  let t = `${n_}T${r_(e)}`;
  const n = [];
  return n.push(e.local ? "Z?" : "Z"), e.offset && n.push("([+-]\\d{2}:?\\d{2})"), t = `${t}(${n.join("|")})`, new RegExp(`^${t}$`);
}
function toe(e, t) {
  return !!((t === "v4" || !t) && zre.test(e) || (t === "v6" || !t) && Xre.test(e));
}
function noe(e, t) {
  if (!$re.test(e))
    return !1;
  try {
    const [n] = e.split("."), r = n.replace(/-/g, "+").replace(/_/g, "/").padEnd(n.length + (4 - n.length % 4) % 4, "="), o = JSON.parse(atob(r));
    return !(typeof o != "object" || o === null || "typ" in o && (o == null ? void 0 : o.typ) !== "JWT" || !o.alg || t && o.alg !== t);
  } catch {
    return !1;
  }
}
function roe(e, t) {
  return !!((t === "v4" || !t) && Ure.test(e) || (t === "v6" || !t) && Yre.test(e));
}
class Fa extends Gt {
  _parse(t) {
    if (this._def.coerce && (t.data = String(t.data)), this._getType(t) !== We.string) {
      const a = this._getOrReturnCtx(t);
      return Ge(a, {
        code: we.invalid_type,
        expected: We.string,
        received: a.parsedType
      }), vt;
    }
    const r = new Xr();
    let o;
    for (const a of this._def.checks)
      if (a.kind === "min")
        t.data.length < a.value && (o = this._getOrReturnCtx(t, o), Ge(o, {
          code: we.too_small,
          minimum: a.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: a.message
        }), r.dirty());
      else if (a.kind === "max")
        t.data.length > a.value && (o = this._getOrReturnCtx(t, o), Ge(o, {
          code: we.too_big,
          maximum: a.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: a.message
        }), r.dirty());
      else if (a.kind === "length") {
        const i = t.data.length > a.value, l = t.data.length < a.value;
        (i || l) && (o = this._getOrReturnCtx(t, o), i ? Ge(o, {
          code: we.too_big,
          maximum: a.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: a.message
        }) : l && Ge(o, {
          code: we.too_small,
          minimum: a.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: a.message
        }), r.dirty());
      } else if (a.kind === "email")
        jre.test(t.data) || (o = this._getOrReturnCtx(t, o), Ge(o, {
          validation: "email",
          code: we.invalid_string,
          message: a.message
        }), r.dirty());
      else if (a.kind === "emoji")
        $g || ($g = new RegExp(Wre, "u")), $g.test(t.data) || (o = this._getOrReturnCtx(t, o), Ge(o, {
          validation: "emoji",
          code: we.invalid_string,
          message: a.message
        }), r.dirty());
      else if (a.kind === "uuid")
        Hre.test(t.data) || (o = this._getOrReturnCtx(t, o), Ge(o, {
          validation: "uuid",
          code: we.invalid_string,
          message: a.message
        }), r.dirty());
      else if (a.kind === "nanoid")
        Gre.test(t.data) || (o = this._getOrReturnCtx(t, o), Ge(o, {
          validation: "nanoid",
          code: we.invalid_string,
          message: a.message
        }), r.dirty());
      else if (a.kind === "cuid")
        Ore.test(t.data) || (o = this._getOrReturnCtx(t, o), Ge(o, {
          validation: "cuid",
          code: we.invalid_string,
          message: a.message
        }), r.dirty());
      else if (a.kind === "cuid2")
        Fre.test(t.data) || (o = this._getOrReturnCtx(t, o), Ge(o, {
          validation: "cuid2",
          code: we.invalid_string,
          message: a.message
        }), r.dirty());
      else if (a.kind === "ulid")
        Bre.test(t.data) || (o = this._getOrReturnCtx(t, o), Ge(o, {
          validation: "ulid",
          code: we.invalid_string,
          message: a.message
        }), r.dirty());
      else if (a.kind === "url")
        try {
          new URL(t.data);
        } catch {
          o = this._getOrReturnCtx(t, o), Ge(o, {
            validation: "url",
            code: we.invalid_string,
            message: a.message
          }), r.dirty();
        }
      else
        a.kind === "regex" ? (a.regex.lastIndex = 0, a.regex.test(t.data) || (o = this._getOrReturnCtx(t, o), Ge(o, {
          validation: "regex",
          code: we.invalid_string,
          message: a.message
        }), r.dirty())) : a.kind === "trim" ? t.data = t.data.trim() : a.kind === "includes" ? t.data.includes(a.value, a.position) || (o = this._getOrReturnCtx(t, o), Ge(o, {
          code: we.invalid_string,
          validation: { includes: a.value, position: a.position },
          message: a.message
        }), r.dirty()) : a.kind === "toLowerCase" ? t.data = t.data.toLowerCase() : a.kind === "toUpperCase" ? t.data = t.data.toUpperCase() : a.kind === "startsWith" ? t.data.startsWith(a.value) || (o = this._getOrReturnCtx(t, o), Ge(o, {
          code: we.invalid_string,
          validation: { startsWith: a.value },
          message: a.message
        }), r.dirty()) : a.kind === "endsWith" ? t.data.endsWith(a.value) || (o = this._getOrReturnCtx(t, o), Ge(o, {
          code: we.invalid_string,
          validation: { endsWith: a.value },
          message: a.message
        }), r.dirty()) : a.kind === "datetime" ? eoe(a).test(t.data) || (o = this._getOrReturnCtx(t, o), Ge(o, {
          code: we.invalid_string,
          validation: "datetime",
          message: a.message
        }), r.dirty()) : a.kind === "date" ? Kre.test(t.data) || (o = this._getOrReturnCtx(t, o), Ge(o, {
          code: we.invalid_string,
          validation: "date",
          message: a.message
        }), r.dirty()) : a.kind === "time" ? Qre(a).test(t.data) || (o = this._getOrReturnCtx(t, o), Ge(o, {
          code: we.invalid_string,
          validation: "time",
          message: a.message
        }), r.dirty()) : a.kind === "duration" ? Zre.test(t.data) || (o = this._getOrReturnCtx(t, o), Ge(o, {
          validation: "duration",
          code: we.invalid_string,
          message: a.message
        }), r.dirty()) : a.kind === "ip" ? toe(t.data, a.version) || (o = this._getOrReturnCtx(t, o), Ge(o, {
          validation: "ip",
          code: we.invalid_string,
          message: a.message
        }), r.dirty()) : a.kind === "jwt" ? noe(t.data, a.alg) || (o = this._getOrReturnCtx(t, o), Ge(o, {
          validation: "jwt",
          code: we.invalid_string,
          message: a.message
        }), r.dirty()) : a.kind === "cidr" ? roe(t.data, a.version) || (o = this._getOrReturnCtx(t, o), Ge(o, {
          validation: "cidr",
          code: we.invalid_string,
          message: a.message
        }), r.dirty()) : a.kind === "base64" ? qre.test(t.data) || (o = this._getOrReturnCtx(t, o), Ge(o, {
          validation: "base64",
          code: we.invalid_string,
          message: a.message
        }), r.dirty()) : a.kind === "base64url" ? Jre.test(t.data) || (o = this._getOrReturnCtx(t, o), Ge(o, {
          validation: "base64url",
          code: we.invalid_string,
          message: a.message
        }), r.dirty()) : qt.assertNever(a);
    return { status: r.value, value: t.data };
  }
  _regex(t, n, r) {
    return this.refinement((o) => t.test(o), {
      validation: n,
      code: we.invalid_string,
      ...Ye.errToObj(r)
    });
  }
  _addCheck(t) {
    return new Fa({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  email(t) {
    return this._addCheck({ kind: "email", ...Ye.errToObj(t) });
  }
  url(t) {
    return this._addCheck({ kind: "url", ...Ye.errToObj(t) });
  }
  emoji(t) {
    return this._addCheck({ kind: "emoji", ...Ye.errToObj(t) });
  }
  uuid(t) {
    return this._addCheck({ kind: "uuid", ...Ye.errToObj(t) });
  }
  nanoid(t) {
    return this._addCheck({ kind: "nanoid", ...Ye.errToObj(t) });
  }
  cuid(t) {
    return this._addCheck({ kind: "cuid", ...Ye.errToObj(t) });
  }
  cuid2(t) {
    return this._addCheck({ kind: "cuid2", ...Ye.errToObj(t) });
  }
  ulid(t) {
    return this._addCheck({ kind: "ulid", ...Ye.errToObj(t) });
  }
  base64(t) {
    return this._addCheck({ kind: "base64", ...Ye.errToObj(t) });
  }
  base64url(t) {
    return this._addCheck({
      kind: "base64url",
      ...Ye.errToObj(t)
    });
  }
  jwt(t) {
    return this._addCheck({ kind: "jwt", ...Ye.errToObj(t) });
  }
  ip(t) {
    return this._addCheck({ kind: "ip", ...Ye.errToObj(t) });
  }
  cidr(t) {
    return this._addCheck({ kind: "cidr", ...Ye.errToObj(t) });
  }
  datetime(t) {
    return typeof t == "string" ? this._addCheck({
      kind: "datetime",
      precision: null,
      offset: !1,
      local: !1,
      message: t
    }) : this._addCheck({
      kind: "datetime",
      precision: typeof (t == null ? void 0 : t.precision) > "u" ? null : t == null ? void 0 : t.precision,
      offset: (t == null ? void 0 : t.offset) ?? !1,
      local: (t == null ? void 0 : t.local) ?? !1,
      ...Ye.errToObj(t == null ? void 0 : t.message)
    });
  }
  date(t) {
    return this._addCheck({ kind: "date", message: t });
  }
  time(t) {
    return typeof t == "string" ? this._addCheck({
      kind: "time",
      precision: null,
      message: t
    }) : this._addCheck({
      kind: "time",
      precision: typeof (t == null ? void 0 : t.precision) > "u" ? null : t == null ? void 0 : t.precision,
      ...Ye.errToObj(t == null ? void 0 : t.message)
    });
  }
  duration(t) {
    return this._addCheck({ kind: "duration", ...Ye.errToObj(t) });
  }
  regex(t, n) {
    return this._addCheck({
      kind: "regex",
      regex: t,
      ...Ye.errToObj(n)
    });
  }
  includes(t, n) {
    return this._addCheck({
      kind: "includes",
      value: t,
      position: n == null ? void 0 : n.position,
      ...Ye.errToObj(n == null ? void 0 : n.message)
    });
  }
  startsWith(t, n) {
    return this._addCheck({
      kind: "startsWith",
      value: t,
      ...Ye.errToObj(n)
    });
  }
  endsWith(t, n) {
    return this._addCheck({
      kind: "endsWith",
      value: t,
      ...Ye.errToObj(n)
    });
  }
  min(t, n) {
    return this._addCheck({
      kind: "min",
      value: t,
      ...Ye.errToObj(n)
    });
  }
  max(t, n) {
    return this._addCheck({
      kind: "max",
      value: t,
      ...Ye.errToObj(n)
    });
  }
  length(t, n) {
    return this._addCheck({
      kind: "length",
      value: t,
      ...Ye.errToObj(n)
    });
  }
  /**
   * Equivalent to `.min(1)`
   */
  nonempty(t) {
    return this.min(1, Ye.errToObj(t));
  }
  trim() {
    return new Fa({
      ...this._def,
      checks: [...this._def.checks, { kind: "trim" }]
    });
  }
  toLowerCase() {
    return new Fa({
      ...this._def,
      checks: [...this._def.checks, { kind: "toLowerCase" }]
    });
  }
  toUpperCase() {
    return new Fa({
      ...this._def,
      checks: [...this._def.checks, { kind: "toUpperCase" }]
    });
  }
  get isDatetime() {
    return !!this._def.checks.find((t) => t.kind === "datetime");
  }
  get isDate() {
    return !!this._def.checks.find((t) => t.kind === "date");
  }
  get isTime() {
    return !!this._def.checks.find((t) => t.kind === "time");
  }
  get isDuration() {
    return !!this._def.checks.find((t) => t.kind === "duration");
  }
  get isEmail() {
    return !!this._def.checks.find((t) => t.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((t) => t.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((t) => t.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((t) => t.kind === "uuid");
  }
  get isNANOID() {
    return !!this._def.checks.find((t) => t.kind === "nanoid");
  }
  get isCUID() {
    return !!this._def.checks.find((t) => t.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((t) => t.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((t) => t.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((t) => t.kind === "ip");
  }
  get isCIDR() {
    return !!this._def.checks.find((t) => t.kind === "cidr");
  }
  get isBase64() {
    return !!this._def.checks.find((t) => t.kind === "base64");
  }
  get isBase64url() {
    return !!this._def.checks.find((t) => t.kind === "base64url");
  }
  get minLength() {
    let t = null;
    for (const n of this._def.checks)
      n.kind === "min" && (t === null || n.value > t) && (t = n.value);
    return t;
  }
  get maxLength() {
    let t = null;
    for (const n of this._def.checks)
      n.kind === "max" && (t === null || n.value < t) && (t = n.value);
    return t;
  }
}
Fa.create = (e) => new Fa({
  checks: [],
  typeName: Ct.ZodString,
  coerce: (e == null ? void 0 : e.coerce) ?? !1,
  ...Rt(e)
});
function ooe(e, t) {
  const n = (e.toString().split(".")[1] || "").length, r = (t.toString().split(".")[1] || "").length, o = n > r ? n : r, a = Number.parseInt(e.toFixed(o).replace(".", "")), i = Number.parseInt(t.toFixed(o).replace(".", ""));
  return a % i / 10 ** o;
}
class Ll extends Gt {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
  }
  _parse(t) {
    if (this._def.coerce && (t.data = Number(t.data)), this._getType(t) !== We.number) {
      const a = this._getOrReturnCtx(t);
      return Ge(a, {
        code: we.invalid_type,
        expected: We.number,
        received: a.parsedType
      }), vt;
    }
    let r;
    const o = new Xr();
    for (const a of this._def.checks)
      a.kind === "int" ? qt.isInteger(t.data) || (r = this._getOrReturnCtx(t, r), Ge(r, {
        code: we.invalid_type,
        expected: "integer",
        received: "float",
        message: a.message
      }), o.dirty()) : a.kind === "min" ? (a.inclusive ? t.data < a.value : t.data <= a.value) && (r = this._getOrReturnCtx(t, r), Ge(r, {
        code: we.too_small,
        minimum: a.value,
        type: "number",
        inclusive: a.inclusive,
        exact: !1,
        message: a.message
      }), o.dirty()) : a.kind === "max" ? (a.inclusive ? t.data > a.value : t.data >= a.value) && (r = this._getOrReturnCtx(t, r), Ge(r, {
        code: we.too_big,
        maximum: a.value,
        type: "number",
        inclusive: a.inclusive,
        exact: !1,
        message: a.message
      }), o.dirty()) : a.kind === "multipleOf" ? ooe(t.data, a.value) !== 0 && (r = this._getOrReturnCtx(t, r), Ge(r, {
        code: we.not_multiple_of,
        multipleOf: a.value,
        message: a.message
      }), o.dirty()) : a.kind === "finite" ? Number.isFinite(t.data) || (r = this._getOrReturnCtx(t, r), Ge(r, {
        code: we.not_finite,
        message: a.message
      }), o.dirty()) : qt.assertNever(a);
    return { status: o.value, value: t.data };
  }
  gte(t, n) {
    return this.setLimit("min", t, !0, Ye.toString(n));
  }
  gt(t, n) {
    return this.setLimit("min", t, !1, Ye.toString(n));
  }
  lte(t, n) {
    return this.setLimit("max", t, !0, Ye.toString(n));
  }
  lt(t, n) {
    return this.setLimit("max", t, !1, Ye.toString(n));
  }
  setLimit(t, n, r, o) {
    return new Ll({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: t,
          value: n,
          inclusive: r,
          message: Ye.toString(o)
        }
      ]
    });
  }
  _addCheck(t) {
    return new Ll({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  int(t) {
    return this._addCheck({
      kind: "int",
      message: Ye.toString(t)
    });
  }
  positive(t) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !1,
      message: Ye.toString(t)
    });
  }
  negative(t) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !1,
      message: Ye.toString(t)
    });
  }
  nonpositive(t) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !0,
      message: Ye.toString(t)
    });
  }
  nonnegative(t) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !0,
      message: Ye.toString(t)
    });
  }
  multipleOf(t, n) {
    return this._addCheck({
      kind: "multipleOf",
      value: t,
      message: Ye.toString(n)
    });
  }
  finite(t) {
    return this._addCheck({
      kind: "finite",
      message: Ye.toString(t)
    });
  }
  safe(t) {
    return this._addCheck({
      kind: "min",
      inclusive: !0,
      value: Number.MIN_SAFE_INTEGER,
      message: Ye.toString(t)
    })._addCheck({
      kind: "max",
      inclusive: !0,
      value: Number.MAX_SAFE_INTEGER,
      message: Ye.toString(t)
    });
  }
  get minValue() {
    let t = null;
    for (const n of this._def.checks)
      n.kind === "min" && (t === null || n.value > t) && (t = n.value);
    return t;
  }
  get maxValue() {
    let t = null;
    for (const n of this._def.checks)
      n.kind === "max" && (t === null || n.value < t) && (t = n.value);
    return t;
  }
  get isInt() {
    return !!this._def.checks.find((t) => t.kind === "int" || t.kind === "multipleOf" && qt.isInteger(t.value));
  }
  get isFinite() {
    let t = null, n = null;
    for (const r of this._def.checks) {
      if (r.kind === "finite" || r.kind === "int" || r.kind === "multipleOf")
        return !0;
      r.kind === "min" ? (n === null || r.value > n) && (n = r.value) : r.kind === "max" && (t === null || r.value < t) && (t = r.value);
    }
    return Number.isFinite(n) && Number.isFinite(t);
  }
}
Ll.create = (e) => new Ll({
  checks: [],
  typeName: Ct.ZodNumber,
  coerce: (e == null ? void 0 : e.coerce) || !1,
  ...Rt(e)
});
class Rl extends Gt {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte;
  }
  _parse(t) {
    if (this._def.coerce)
      try {
        t.data = BigInt(t.data);
      } catch {
        return this._getInvalidInput(t);
      }
    if (this._getType(t) !== We.bigint)
      return this._getInvalidInput(t);
    let r;
    const o = new Xr();
    for (const a of this._def.checks)
      a.kind === "min" ? (a.inclusive ? t.data < a.value : t.data <= a.value) && (r = this._getOrReturnCtx(t, r), Ge(r, {
        code: we.too_small,
        type: "bigint",
        minimum: a.value,
        inclusive: a.inclusive,
        message: a.message
      }), o.dirty()) : a.kind === "max" ? (a.inclusive ? t.data > a.value : t.data >= a.value) && (r = this._getOrReturnCtx(t, r), Ge(r, {
        code: we.too_big,
        type: "bigint",
        maximum: a.value,
        inclusive: a.inclusive,
        message: a.message
      }), o.dirty()) : a.kind === "multipleOf" ? t.data % a.value !== BigInt(0) && (r = this._getOrReturnCtx(t, r), Ge(r, {
        code: we.not_multiple_of,
        multipleOf: a.value,
        message: a.message
      }), o.dirty()) : qt.assertNever(a);
    return { status: o.value, value: t.data };
  }
  _getInvalidInput(t) {
    const n = this._getOrReturnCtx(t);
    return Ge(n, {
      code: we.invalid_type,
      expected: We.bigint,
      received: n.parsedType
    }), vt;
  }
  gte(t, n) {
    return this.setLimit("min", t, !0, Ye.toString(n));
  }
  gt(t, n) {
    return this.setLimit("min", t, !1, Ye.toString(n));
  }
  lte(t, n) {
    return this.setLimit("max", t, !0, Ye.toString(n));
  }
  lt(t, n) {
    return this.setLimit("max", t, !1, Ye.toString(n));
  }
  setLimit(t, n, r, o) {
    return new Rl({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: t,
          value: n,
          inclusive: r,
          message: Ye.toString(o)
        }
      ]
    });
  }
  _addCheck(t) {
    return new Rl({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  positive(t) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !1,
      message: Ye.toString(t)
    });
  }
  negative(t) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !1,
      message: Ye.toString(t)
    });
  }
  nonpositive(t) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !0,
      message: Ye.toString(t)
    });
  }
  nonnegative(t) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !0,
      message: Ye.toString(t)
    });
  }
  multipleOf(t, n) {
    return this._addCheck({
      kind: "multipleOf",
      value: t,
      message: Ye.toString(n)
    });
  }
  get minValue() {
    let t = null;
    for (const n of this._def.checks)
      n.kind === "min" && (t === null || n.value > t) && (t = n.value);
    return t;
  }
  get maxValue() {
    let t = null;
    for (const n of this._def.checks)
      n.kind === "max" && (t === null || n.value < t) && (t = n.value);
    return t;
  }
}
Rl.create = (e) => new Rl({
  checks: [],
  typeName: Ct.ZodBigInt,
  coerce: (e == null ? void 0 : e.coerce) ?? !1,
  ...Rt(e)
});
class P2 extends Gt {
  _parse(t) {
    if (this._def.coerce && (t.data = !!t.data), this._getType(t) !== We.boolean) {
      const r = this._getOrReturnCtx(t);
      return Ge(r, {
        code: we.invalid_type,
        expected: We.boolean,
        received: r.parsedType
      }), vt;
    }
    return ta(t.data);
  }
}
P2.create = (e) => new P2({
  typeName: Ct.ZodBoolean,
  coerce: (e == null ? void 0 : e.coerce) || !1,
  ...Rt(e)
});
class lc extends Gt {
  _parse(t) {
    if (this._def.coerce && (t.data = new Date(t.data)), this._getType(t) !== We.date) {
      const a = this._getOrReturnCtx(t);
      return Ge(a, {
        code: we.invalid_type,
        expected: We.date,
        received: a.parsedType
      }), vt;
    }
    if (Number.isNaN(t.data.getTime())) {
      const a = this._getOrReturnCtx(t);
      return Ge(a, {
        code: we.invalid_date
      }), vt;
    }
    const r = new Xr();
    let o;
    for (const a of this._def.checks)
      a.kind === "min" ? t.data.getTime() < a.value && (o = this._getOrReturnCtx(t, o), Ge(o, {
        code: we.too_small,
        message: a.message,
        inclusive: !0,
        exact: !1,
        minimum: a.value,
        type: "date"
      }), r.dirty()) : a.kind === "max" ? t.data.getTime() > a.value && (o = this._getOrReturnCtx(t, o), Ge(o, {
        code: we.too_big,
        message: a.message,
        inclusive: !0,
        exact: !1,
        maximum: a.value,
        type: "date"
      }), r.dirty()) : qt.assertNever(a);
    return {
      status: r.value,
      value: new Date(t.data.getTime())
    };
  }
  _addCheck(t) {
    return new lc({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  min(t, n) {
    return this._addCheck({
      kind: "min",
      value: t.getTime(),
      message: Ye.toString(n)
    });
  }
  max(t, n) {
    return this._addCheck({
      kind: "max",
      value: t.getTime(),
      message: Ye.toString(n)
    });
  }
  get minDate() {
    let t = null;
    for (const n of this._def.checks)
      n.kind === "min" && (t === null || n.value > t) && (t = n.value);
    return t != null ? new Date(t) : null;
  }
  get maxDate() {
    let t = null;
    for (const n of this._def.checks)
      n.kind === "max" && (t === null || n.value < t) && (t = n.value);
    return t != null ? new Date(t) : null;
  }
}
lc.create = (e) => new lc({
  checks: [],
  coerce: (e == null ? void 0 : e.coerce) || !1,
  typeName: Ct.ZodDate,
  ...Rt(e)
});
class i3 extends Gt {
  _parse(t) {
    if (this._getType(t) !== We.symbol) {
      const r = this._getOrReturnCtx(t);
      return Ge(r, {
        code: we.invalid_type,
        expected: We.symbol,
        received: r.parsedType
      }), vt;
    }
    return ta(t.data);
  }
}
i3.create = (e) => new i3({
  typeName: Ct.ZodSymbol,
  ...Rt(e)
});
class E2 extends Gt {
  _parse(t) {
    if (this._getType(t) !== We.undefined) {
      const r = this._getOrReturnCtx(t);
      return Ge(r, {
        code: we.invalid_type,
        expected: We.undefined,
        received: r.parsedType
      }), vt;
    }
    return ta(t.data);
  }
}
E2.create = (e) => new E2({
  typeName: Ct.ZodUndefined,
  ...Rt(e)
});
class T2 extends Gt {
  _parse(t) {
    if (this._getType(t) !== We.null) {
      const r = this._getOrReturnCtx(t);
      return Ge(r, {
        code: we.invalid_type,
        expected: We.null,
        received: r.parsedType
      }), vt;
    }
    return ta(t.data);
  }
}
T2.create = (e) => new T2({
  typeName: Ct.ZodNull,
  ...Rt(e)
});
class Cd extends Gt {
  constructor() {
    super(...arguments), this._any = !0;
  }
  _parse(t) {
    return ta(t.data);
  }
}
Cd.create = (e) => new Cd({
  typeName: Ct.ZodAny,
  ...Rt(e)
});
class s3 extends Gt {
  constructor() {
    super(...arguments), this._unknown = !0;
  }
  _parse(t) {
    return ta(t.data);
  }
}
s3.create = (e) => new s3({
  typeName: Ct.ZodUnknown,
  ...Rt(e)
});
class ws extends Gt {
  _parse(t) {
    const n = this._getOrReturnCtx(t);
    return Ge(n, {
      code: we.invalid_type,
      expected: We.never,
      received: n.parsedType
    }), vt;
  }
}
ws.create = (e) => new ws({
  typeName: Ct.ZodNever,
  ...Rt(e)
});
class l3 extends Gt {
  _parse(t) {
    if (this._getType(t) !== We.undefined) {
      const r = this._getOrReturnCtx(t);
      return Ge(r, {
        code: we.invalid_type,
        expected: We.void,
        received: r.parsedType
      }), vt;
    }
    return ta(t.data);
  }
}
l3.create = (e) => new l3({
  typeName: Ct.ZodVoid,
  ...Rt(e)
});
class $a extends Gt {
  _parse(t) {
    const { ctx: n, status: r } = this._processInputParams(t), o = this._def;
    if (n.parsedType !== We.array)
      return Ge(n, {
        code: we.invalid_type,
        expected: We.array,
        received: n.parsedType
      }), vt;
    if (o.exactLength !== null) {
      const i = n.data.length > o.exactLength.value, l = n.data.length < o.exactLength.value;
      (i || l) && (Ge(n, {
        code: i ? we.too_big : we.too_small,
        minimum: l ? o.exactLength.value : void 0,
        maximum: i ? o.exactLength.value : void 0,
        type: "array",
        inclusive: !0,
        exact: !0,
        message: o.exactLength.message
      }), r.dirty());
    }
    if (o.minLength !== null && n.data.length < o.minLength.value && (Ge(n, {
      code: we.too_small,
      minimum: o.minLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: o.minLength.message
    }), r.dirty()), o.maxLength !== null && n.data.length > o.maxLength.value && (Ge(n, {
      code: we.too_big,
      maximum: o.maxLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: o.maxLength.message
    }), r.dirty()), n.common.async)
      return Promise.all([...n.data].map((i, l) => o.type._parseAsync(new Wa(n, i, n.path, l)))).then((i) => Xr.mergeArray(r, i));
    const a = [...n.data].map((i, l) => o.type._parseSync(new Wa(n, i, n.path, l)));
    return Xr.mergeArray(r, a);
  }
  get element() {
    return this._def.type;
  }
  min(t, n) {
    return new $a({
      ...this._def,
      minLength: { value: t, message: Ye.toString(n) }
    });
  }
  max(t, n) {
    return new $a({
      ...this._def,
      maxLength: { value: t, message: Ye.toString(n) }
    });
  }
  length(t, n) {
    return new $a({
      ...this._def,
      exactLength: { value: t, message: Ye.toString(n) }
    });
  }
  nonempty(t) {
    return this.min(1, t);
  }
}
$a.create = (e, t) => new $a({
  type: e,
  minLength: null,
  maxLength: null,
  exactLength: null,
  typeName: Ct.ZodArray,
  ...Rt(t)
});
function Ru(e) {
  if (e instanceof $n) {
    const t = {};
    for (const n in e.shape) {
      const r = e.shape[n];
      t[n] = Ai.create(Ru(r));
    }
    return new $n({
      ...e._def,
      shape: () => t
    });
  } else
    return e instanceof $a ? new $a({
      ...e._def,
      type: Ru(e.element)
    }) : e instanceof Ai ? Ai.create(Ru(e.unwrap())) : e instanceof El ? El.create(Ru(e.unwrap())) : e instanceof Dl ? Dl.create(e.items.map((t) => Ru(t))) : e;
}
class $n extends Gt {
  constructor() {
    super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null)
      return this._cached;
    const t = this._def.shape(), n = qt.objectKeys(t);
    return this._cached = { shape: t, keys: n }, this._cached;
  }
  _parse(t) {
    if (this._getType(t) !== We.object) {
      const d = this._getOrReturnCtx(t);
      return Ge(d, {
        code: we.invalid_type,
        expected: We.object,
        received: d.parsedType
      }), vt;
    }
    const { status: r, ctx: o } = this._processInputParams(t), { shape: a, keys: i } = this._getCached(), l = [];
    if (!(this._def.catchall instanceof ws && this._def.unknownKeys === "strip"))
      for (const d in o.data)
        i.includes(d) || l.push(d);
    const u = [];
    for (const d of i) {
      const f = a[d], h = o.data[d];
      u.push({
        key: { status: "valid", value: d },
        value: f._parse(new Wa(o, h, o.path, d)),
        alwaysSet: d in o.data
      });
    }
    if (this._def.catchall instanceof ws) {
      const d = this._def.unknownKeys;
      if (d === "passthrough")
        for (const f of l)
          u.push({
            key: { status: "valid", value: f },
            value: { status: "valid", value: o.data[f] }
          });
      else if (d === "strict")
        l.length > 0 && (Ge(o, {
          code: we.unrecognized_keys,
          keys: l
        }), r.dirty());
      else if (d !== "strip")
        throw new Error("Internal ZodObject error: invalid unknownKeys value.");
    } else {
      const d = this._def.catchall;
      for (const f of l) {
        const h = o.data[f];
        u.push({
          key: { status: "valid", value: f },
          value: d._parse(
            new Wa(o, h, o.path, f)
            //, ctx.child(key), value, getParsedType(value)
          ),
          alwaysSet: f in o.data
        });
      }
    }
    return o.common.async ? Promise.resolve().then(async () => {
      const d = [];
      for (const f of u) {
        const h = await f.key, p = await f.value;
        d.push({
          key: h,
          value: p,
          alwaysSet: f.alwaysSet
        });
      }
      return d;
    }).then((d) => Xr.mergeObjectSync(r, d)) : Xr.mergeObjectSync(r, u);
  }
  get shape() {
    return this._def.shape();
  }
  strict(t) {
    return Ye.errToObj, new $n({
      ...this._def,
      unknownKeys: "strict",
      ...t !== void 0 ? {
        errorMap: (n, r) => {
          var a, i;
          const o = ((i = (a = this._def).errorMap) == null ? void 0 : i.call(a, n, r).message) ?? r.defaultError;
          return n.code === "unrecognized_keys" ? {
            message: Ye.errToObj(t).message ?? o
          } : {
            message: o
          };
        }
      } : {}
    });
  }
  strip() {
    return new $n({
      ...this._def,
      unknownKeys: "strip"
    });
  }
  passthrough() {
    return new $n({
      ...this._def,
      unknownKeys: "passthrough"
    });
  }
  // const AugmentFactory =
  //   <Def extends ZodObjectDef>(def: Def) =>
  //   <Augmentation extends ZodRawShape>(
  //     augmentation: Augmentation
  //   ): ZodObject<
  //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
  //     Def["unknownKeys"],
  //     Def["catchall"]
  //   > => {
  //     return new ZodObject({
  //       ...def,
  //       shape: () => ({
  //         ...def.shape(),
  //         ...augmentation,
  //       }),
  //     }) as any;
  //   };
  extend(t) {
    return new $n({
      ...this._def,
      shape: () => ({
        ...this._def.shape(),
        ...t
      })
    });
  }
  /**
   * Prior to zod@1.0.12 there was a bug in the
   * inferred type of merged objects. Please
   * upgrade if you are experiencing issues.
   */
  merge(t) {
    return new $n({
      unknownKeys: t._def.unknownKeys,
      catchall: t._def.catchall,
      shape: () => ({
        ...this._def.shape(),
        ...t._def.shape()
      }),
      typeName: Ct.ZodObject
    });
  }
  // merge<
  //   Incoming extends AnyZodObject,
  //   Augmentation extends Incoming["shape"],
  //   NewOutput extends {
  //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
  //       ? Augmentation[k]["_output"]
  //       : k extends keyof Output
  //       ? Output[k]
  //       : never;
  //   },
  //   NewInput extends {
  //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
  //       ? Augmentation[k]["_input"]
  //       : k extends keyof Input
  //       ? Input[k]
  //       : never;
  //   }
  // >(
  //   merging: Incoming
  // ): ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"],
  //   NewOutput,
  //   NewInput
  // > {
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  setKey(t, n) {
    return this.augment({ [t]: n });
  }
  // merge<Incoming extends AnyZodObject>(
  //   merging: Incoming
  // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
  // ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"]
  // > {
  //   // const mergedShape = objectUtil.mergeShapes(
  //   //   this._def.shape(),
  //   //   merging._def.shape()
  //   // );
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  catchall(t) {
    return new $n({
      ...this._def,
      catchall: t
    });
  }
  pick(t) {
    const n = {};
    for (const r of qt.objectKeys(t))
      t[r] && this.shape[r] && (n[r] = this.shape[r]);
    return new $n({
      ...this._def,
      shape: () => n
    });
  }
  omit(t) {
    const n = {};
    for (const r of qt.objectKeys(this.shape))
      t[r] || (n[r] = this.shape[r]);
    return new $n({
      ...this._def,
      shape: () => n
    });
  }
  /**
   * @deprecated
   */
  deepPartial() {
    return Ru(this);
  }
  partial(t) {
    const n = {};
    for (const r of qt.objectKeys(this.shape)) {
      const o = this.shape[r];
      t && !t[r] ? n[r] = o : n[r] = o.optional();
    }
    return new $n({
      ...this._def,
      shape: () => n
    });
  }
  required(t) {
    const n = {};
    for (const r of qt.objectKeys(this.shape))
      if (t && !t[r])
        n[r] = this.shape[r];
      else {
        let a = this.shape[r];
        for (; a instanceof Ai; )
          a = a._def.innerType;
        n[r] = a;
      }
    return new $n({
      ...this._def,
      shape: () => n
    });
  }
  keyof() {
    return o_(qt.objectKeys(this.shape));
  }
}
$n.create = (e, t) => new $n({
  shape: () => e,
  unknownKeys: "strip",
  catchall: ws.create(),
  typeName: Ct.ZodObject,
  ...Rt(t)
});
$n.strictCreate = (e, t) => new $n({
  shape: () => e,
  unknownKeys: "strict",
  catchall: ws.create(),
  typeName: Ct.ZodObject,
  ...Rt(t)
});
$n.lazycreate = (e, t) => new $n({
  shape: e,
  unknownKeys: "strip",
  catchall: ws.create(),
  typeName: Ct.ZodObject,
  ...Rt(t)
});
class N2 extends Gt {
  _parse(t) {
    const { ctx: n } = this._processInputParams(t), r = this._def.options;
    function o(a) {
      for (const l of a)
        if (l.result.status === "valid")
          return l.result;
      for (const l of a)
        if (l.result.status === "dirty")
          return n.common.issues.push(...l.ctx.common.issues), l.result;
      const i = a.map((l) => new Di(l.ctx.common.issues));
      return Ge(n, {
        code: we.invalid_union,
        unionErrors: i
      }), vt;
    }
    if (n.common.async)
      return Promise.all(r.map(async (a) => {
        const i = {
          ...n,
          common: {
            ...n.common,
            issues: []
          },
          parent: null
        };
        return {
          result: await a._parseAsync({
            data: n.data,
            path: n.path,
            parent: i
          }),
          ctx: i
        };
      })).then(o);
    {
      let a;
      const i = [];
      for (const u of r) {
        const d = {
          ...n,
          common: {
            ...n.common,
            issues: []
          },
          parent: null
        }, f = u._parseSync({
          data: n.data,
          path: n.path,
          parent: d
        });
        if (f.status === "valid")
          return f;
        f.status === "dirty" && !a && (a = { result: f, ctx: d }), d.common.issues.length && i.push(d.common.issues);
      }
      if (a)
        return n.common.issues.push(...a.ctx.common.issues), a.result;
      const l = i.map((u) => new Di(u));
      return Ge(n, {
        code: we.invalid_union,
        unionErrors: l
      }), vt;
    }
  }
  get options() {
    return this._def.options;
  }
}
N2.create = (e, t) => new N2({
  options: e,
  typeName: Ct.ZodUnion,
  ...Rt(t)
});
const li = (e) => e instanceof O2 ? li(e.schema) : e instanceof Pi ? li(e.innerType()) : e instanceof F2 ? [e.value] : e instanceof Pl ? e.options : e instanceof B2 ? qt.objectValues(e.enum) : e instanceof G2 ? li(e._def.innerType) : e instanceof E2 ? [void 0] : e instanceof T2 ? [null] : e instanceof Ai ? [void 0, ...li(e.unwrap())] : e instanceof El ? [null, ...li(e.unwrap())] : e instanceof a_ || e instanceof Z2 ? li(e.unwrap()) : e instanceof $2 ? li(e._def.innerType) : [];
class v9 extends Gt {
  _parse(t) {
    const { ctx: n } = this._processInputParams(t);
    if (n.parsedType !== We.object)
      return Ge(n, {
        code: we.invalid_type,
        expected: We.object,
        received: n.parsedType
      }), vt;
    const r = this.discriminator, o = n.data[r], a = this.optionsMap.get(o);
    return a ? n.common.async ? a._parseAsync({
      data: n.data,
      path: n.path,
      parent: n
    }) : a._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }) : (Ge(n, {
      code: we.invalid_union_discriminator,
      options: Array.from(this.optionsMap.keys()),
      path: [r]
    }), vt);
  }
  get discriminator() {
    return this._def.discriminator;
  }
  get options() {
    return this._def.options;
  }
  get optionsMap() {
    return this._def.optionsMap;
  }
  /**
   * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
   * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
   * have a different value for each object in the union.
   * @param discriminator the name of the discriminator property
   * @param types an array of object schemas
   * @param params
   */
  static create(t, n, r) {
    const o = /* @__PURE__ */ new Map();
    for (const a of n) {
      const i = li(a.shape[t]);
      if (!i.length)
        throw new Error(`A discriminator value for key \`${t}\` could not be extracted from all schema options`);
      for (const l of i) {
        if (o.has(l))
          throw new Error(`Discriminator property ${String(t)} has duplicate value ${String(l)}`);
        o.set(l, a);
      }
    }
    return new v9({
      typeName: Ct.ZodDiscriminatedUnion,
      discriminator: t,
      options: n,
      optionsMap: o,
      ...Rt(r)
    });
  }
}
function u3(e, t) {
  const n = cs(e), r = cs(t);
  if (e === t)
    return { valid: !0, data: e };
  if (n === We.object && r === We.object) {
    const o = qt.objectKeys(t), a = qt.objectKeys(e).filter((l) => o.indexOf(l) !== -1), i = { ...e, ...t };
    for (const l of a) {
      const u = u3(e[l], t[l]);
      if (!u.valid)
        return { valid: !1 };
      i[l] = u.data;
    }
    return { valid: !0, data: i };
  } else if (n === We.array && r === We.array) {
    if (e.length !== t.length)
      return { valid: !1 };
    const o = [];
    for (let a = 0; a < e.length; a++) {
      const i = e[a], l = t[a], u = u3(i, l);
      if (!u.valid)
        return { valid: !1 };
      o.push(u.data);
    }
    return { valid: !0, data: o };
  } else
    return n === We.date && r === We.date && +e == +t ? { valid: !0, data: e } : { valid: !1 };
}
class k2 extends Gt {
  _parse(t) {
    const { status: n, ctx: r } = this._processInputParams(t), o = (a, i) => {
      if (ab(a) || ab(i))
        return vt;
      const l = u3(a.value, i.value);
      return l.valid ? ((ib(a) || ib(i)) && n.dirty(), { status: n.value, value: l.data }) : (Ge(r, {
        code: we.invalid_intersection_types
      }), vt);
    };
    return r.common.async ? Promise.all([
      this._def.left._parseAsync({
        data: r.data,
        path: r.path,
        parent: r
      }),
      this._def.right._parseAsync({
        data: r.data,
        path: r.path,
        parent: r
      })
    ]).then(([a, i]) => o(a, i)) : o(this._def.left._parseSync({
      data: r.data,
      path: r.path,
      parent: r
    }), this._def.right._parseSync({
      data: r.data,
      path: r.path,
      parent: r
    }));
  }
}
k2.create = (e, t, n) => new k2({
  left: e,
  right: t,
  typeName: Ct.ZodIntersection,
  ...Rt(n)
});
class Dl extends Gt {
  _parse(t) {
    const { status: n, ctx: r } = this._processInputParams(t);
    if (r.parsedType !== We.array)
      return Ge(r, {
        code: we.invalid_type,
        expected: We.array,
        received: r.parsedType
      }), vt;
    if (r.data.length < this._def.items.length)
      return Ge(r, {
        code: we.too_small,
        minimum: this._def.items.length,
        inclusive: !0,
        exact: !1,
        type: "array"
      }), vt;
    !this._def.rest && r.data.length > this._def.items.length && (Ge(r, {
      code: we.too_big,
      maximum: this._def.items.length,
      inclusive: !0,
      exact: !1,
      type: "array"
    }), n.dirty());
    const a = [...r.data].map((i, l) => {
      const u = this._def.items[l] || this._def.rest;
      return u ? u._parse(new Wa(r, i, r.path, l)) : null;
    }).filter((i) => !!i);
    return r.common.async ? Promise.all(a).then((i) => Xr.mergeArray(n, i)) : Xr.mergeArray(n, a);
  }
  get items() {
    return this._def.items;
  }
  rest(t) {
    return new Dl({
      ...this._def,
      rest: t
    });
  }
}
Dl.create = (e, t) => {
  if (!Array.isArray(e))
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  return new Dl({
    items: e,
    typeName: Ct.ZodTuple,
    rest: null,
    ...Rt(t)
  });
};
class V2 extends Gt {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(t) {
    const { status: n, ctx: r } = this._processInputParams(t);
    if (r.parsedType !== We.object)
      return Ge(r, {
        code: we.invalid_type,
        expected: We.object,
        received: r.parsedType
      }), vt;
    const o = [], a = this._def.keyType, i = this._def.valueType;
    for (const l in r.data)
      o.push({
        key: a._parse(new Wa(r, l, r.path, l)),
        value: i._parse(new Wa(r, r.data[l], r.path, l)),
        alwaysSet: l in r.data
      });
    return r.common.async ? Xr.mergeObjectAsync(n, o) : Xr.mergeObjectSync(n, o);
  }
  get element() {
    return this._def.valueType;
  }
  static create(t, n, r) {
    return n instanceof Gt ? new V2({
      keyType: t,
      valueType: n,
      typeName: Ct.ZodRecord,
      ...Rt(r)
    }) : new V2({
      keyType: Fa.create(),
      valueType: t,
      typeName: Ct.ZodRecord,
      ...Rt(n)
    });
  }
}
class c3 extends Gt {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(t) {
    const { status: n, ctx: r } = this._processInputParams(t);
    if (r.parsedType !== We.map)
      return Ge(r, {
        code: we.invalid_type,
        expected: We.map,
        received: r.parsedType
      }), vt;
    const o = this._def.keyType, a = this._def.valueType, i = [...r.data.entries()].map(([l, u], d) => ({
      key: o._parse(new Wa(r, l, r.path, [d, "key"])),
      value: a._parse(new Wa(r, u, r.path, [d, "value"]))
    }));
    if (r.common.async) {
      const l = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const u of i) {
          const d = await u.key, f = await u.value;
          if (d.status === "aborted" || f.status === "aborted")
            return vt;
          (d.status === "dirty" || f.status === "dirty") && n.dirty(), l.set(d.value, f.value);
        }
        return { status: n.value, value: l };
      });
    } else {
      const l = /* @__PURE__ */ new Map();
      for (const u of i) {
        const d = u.key, f = u.value;
        if (d.status === "aborted" || f.status === "aborted")
          return vt;
        (d.status === "dirty" || f.status === "dirty") && n.dirty(), l.set(d.value, f.value);
      }
      return { status: n.value, value: l };
    }
  }
}
c3.create = (e, t, n) => new c3({
  valueType: t,
  keyType: e,
  typeName: Ct.ZodMap,
  ...Rt(n)
});
class uc extends Gt {
  _parse(t) {
    const { status: n, ctx: r } = this._processInputParams(t);
    if (r.parsedType !== We.set)
      return Ge(r, {
        code: we.invalid_type,
        expected: We.set,
        received: r.parsedType
      }), vt;
    const o = this._def;
    o.minSize !== null && r.data.size < o.minSize.value && (Ge(r, {
      code: we.too_small,
      minimum: o.minSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: o.minSize.message
    }), n.dirty()), o.maxSize !== null && r.data.size > o.maxSize.value && (Ge(r, {
      code: we.too_big,
      maximum: o.maxSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: o.maxSize.message
    }), n.dirty());
    const a = this._def.valueType;
    function i(u) {
      const d = /* @__PURE__ */ new Set();
      for (const f of u) {
        if (f.status === "aborted")
          return vt;
        f.status === "dirty" && n.dirty(), d.add(f.value);
      }
      return { status: n.value, value: d };
    }
    const l = [...r.data.values()].map((u, d) => a._parse(new Wa(r, u, r.path, d)));
    return r.common.async ? Promise.all(l).then((u) => i(u)) : i(l);
  }
  min(t, n) {
    return new uc({
      ...this._def,
      minSize: { value: t, message: Ye.toString(n) }
    });
  }
  max(t, n) {
    return new uc({
      ...this._def,
      maxSize: { value: t, message: Ye.toString(n) }
    });
  }
  size(t, n) {
    return this.min(t, n).max(t, n);
  }
  nonempty(t) {
    return this.min(1, t);
  }
}
uc.create = (e, t) => new uc({
  valueType: e,
  minSize: null,
  maxSize: null,
  typeName: Ct.ZodSet,
  ...Rt(t)
});
class O2 extends Gt {
  get schema() {
    return this._def.getter();
  }
  _parse(t) {
    const { ctx: n } = this._processInputParams(t);
    return this._def.getter()._parse({ data: n.data, path: n.path, parent: n });
  }
}
O2.create = (e, t) => new O2({
  getter: e,
  typeName: Ct.ZodLazy,
  ...Rt(t)
});
class F2 extends Gt {
  _parse(t) {
    if (t.data !== this._def.value) {
      const n = this._getOrReturnCtx(t);
      return Ge(n, {
        received: n.data,
        code: we.invalid_literal,
        expected: this._def.value
      }), vt;
    }
    return { status: "valid", value: t.data };
  }
  get value() {
    return this._def.value;
  }
}
F2.create = (e, t) => new F2({
  value: e,
  typeName: Ct.ZodLiteral,
  ...Rt(t)
});
function o_(e, t) {
  return new Pl({
    values: e,
    typeName: Ct.ZodEnum,
    ...Rt(t)
  });
}
class Pl extends Gt {
  _parse(t) {
    if (typeof t.data != "string") {
      const n = this._getOrReturnCtx(t), r = this._def.values;
      return Ge(n, {
        expected: qt.joinValues(r),
        received: n.parsedType,
        code: we.invalid_type
      }), vt;
    }
    if (this._cache || (this._cache = new Set(this._def.values)), !this._cache.has(t.data)) {
      const n = this._getOrReturnCtx(t), r = this._def.values;
      return Ge(n, {
        received: n.data,
        code: we.invalid_enum_value,
        options: r
      }), vt;
    }
    return ta(t.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const t = {};
    for (const n of this._def.values)
      t[n] = n;
    return t;
  }
  get Values() {
    const t = {};
    for (const n of this._def.values)
      t[n] = n;
    return t;
  }
  get Enum() {
    const t = {};
    for (const n of this._def.values)
      t[n] = n;
    return t;
  }
  extract(t, n = this._def) {
    return Pl.create(t, {
      ...this._def,
      ...n
    });
  }
  exclude(t, n = this._def) {
    return Pl.create(this.options.filter((r) => !t.includes(r)), {
      ...this._def,
      ...n
    });
  }
}
Pl.create = o_;
class B2 extends Gt {
  _parse(t) {
    const n = qt.getValidEnumValues(this._def.values), r = this._getOrReturnCtx(t);
    if (r.parsedType !== We.string && r.parsedType !== We.number) {
      const o = qt.objectValues(n);
      return Ge(r, {
        expected: qt.joinValues(o),
        received: r.parsedType,
        code: we.invalid_type
      }), vt;
    }
    if (this._cache || (this._cache = new Set(qt.getValidEnumValues(this._def.values))), !this._cache.has(t.data)) {
      const o = qt.objectValues(n);
      return Ge(r, {
        received: r.data,
        code: we.invalid_enum_value,
        options: o
      }), vt;
    }
    return ta(t.data);
  }
  get enum() {
    return this._def.values;
  }
}
B2.create = (e, t) => new B2({
  values: e,
  typeName: Ct.ZodNativeEnum,
  ...Rt(t)
});
class H2 extends Gt {
  unwrap() {
    return this._def.type;
  }
  _parse(t) {
    const { ctx: n } = this._processInputParams(t);
    if (n.parsedType !== We.promise && n.common.async === !1)
      return Ge(n, {
        code: we.invalid_type,
        expected: We.promise,
        received: n.parsedType
      }), vt;
    const r = n.parsedType === We.promise ? n.data : Promise.resolve(n.data);
    return ta(r.then((o) => this._def.type.parseAsync(o, {
      path: n.path,
      errorMap: n.common.contextualErrorMap
    })));
  }
}
H2.create = (e, t) => new H2({
  type: e,
  typeName: Ct.ZodPromise,
  ...Rt(t)
});
class Pi extends Gt {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === Ct.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(t) {
    const { status: n, ctx: r } = this._processInputParams(t), o = this._def.effect || null, a = {
      addIssue: (i) => {
        Ge(r, i), i.fatal ? n.abort() : n.dirty();
      },
      get path() {
        return r.path;
      }
    };
    if (a.addIssue = a.addIssue.bind(a), o.type === "preprocess") {
      const i = o.transform(r.data, a);
      if (r.common.async)
        return Promise.resolve(i).then(async (l) => {
          if (n.value === "aborted")
            return vt;
          const u = await this._def.schema._parseAsync({
            data: l,
            path: r.path,
            parent: r
          });
          return u.status === "aborted" ? vt : u.status === "dirty" || n.value === "dirty" ? k1(u.value) : u;
        });
      {
        if (n.value === "aborted")
          return vt;
        const l = this._def.schema._parseSync({
          data: i,
          path: r.path,
          parent: r
        });
        return l.status === "aborted" ? vt : l.status === "dirty" || n.value === "dirty" ? k1(l.value) : l;
      }
    }
    if (o.type === "refinement") {
      const i = (l) => {
        const u = o.refinement(l, a);
        if (r.common.async)
          return Promise.resolve(u);
        if (u instanceof Promise)
          throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        return l;
      };
      if (r.common.async === !1) {
        const l = this._def.schema._parseSync({
          data: r.data,
          path: r.path,
          parent: r
        });
        return l.status === "aborted" ? vt : (l.status === "dirty" && n.dirty(), i(l.value), { status: n.value, value: l.value });
      } else
        return this._def.schema._parseAsync({ data: r.data, path: r.path, parent: r }).then((l) => l.status === "aborted" ? vt : (l.status === "dirty" && n.dirty(), i(l.value).then(() => ({ status: n.value, value: l.value }))));
    }
    if (o.type === "transform")
      if (r.common.async === !1) {
        const i = this._def.schema._parseSync({
          data: r.data,
          path: r.path,
          parent: r
        });
        if (!sc(i))
          return vt;
        const l = o.transform(i.value, a);
        if (l instanceof Promise)
          throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
        return { status: n.value, value: l };
      } else
        return this._def.schema._parseAsync({ data: r.data, path: r.path, parent: r }).then((i) => sc(i) ? Promise.resolve(o.transform(i.value, a)).then((l) => ({
          status: n.value,
          value: l
        })) : vt);
    qt.assertNever(o);
  }
}
Pi.create = (e, t, n) => new Pi({
  schema: e,
  typeName: Ct.ZodEffects,
  effect: t,
  ...Rt(n)
});
Pi.createWithPreprocess = (e, t, n) => new Pi({
  schema: t,
  effect: { type: "preprocess", transform: e },
  typeName: Ct.ZodEffects,
  ...Rt(n)
});
class Ai extends Gt {
  _parse(t) {
    return this._getType(t) === We.undefined ? ta(void 0) : this._def.innerType._parse(t);
  }
  unwrap() {
    return this._def.innerType;
  }
}
Ai.create = (e, t) => new Ai({
  innerType: e,
  typeName: Ct.ZodOptional,
  ...Rt(t)
});
class El extends Gt {
  _parse(t) {
    return this._getType(t) === We.null ? ta(null) : this._def.innerType._parse(t);
  }
  unwrap() {
    return this._def.innerType;
  }
}
El.create = (e, t) => new El({
  innerType: e,
  typeName: Ct.ZodNullable,
  ...Rt(t)
});
class G2 extends Gt {
  _parse(t) {
    const { ctx: n } = this._processInputParams(t);
    let r = n.data;
    return n.parsedType === We.undefined && (r = this._def.defaultValue()), this._def.innerType._parse({
      data: r,
      path: n.path,
      parent: n
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
}
G2.create = (e, t) => new G2({
  innerType: e,
  typeName: Ct.ZodDefault,
  defaultValue: typeof t.default == "function" ? t.default : () => t.default,
  ...Rt(t)
});
class $2 extends Gt {
  _parse(t) {
    const { ctx: n } = this._processInputParams(t), r = {
      ...n,
      common: {
        ...n.common,
        issues: []
      }
    }, o = this._def.innerType._parse({
      data: r.data,
      path: r.path,
      parent: {
        ...r
      }
    });
    return D2(o) ? o.then((a) => ({
      status: "valid",
      value: a.status === "valid" ? a.value : this._def.catchValue({
        get error() {
          return new Di(r.common.issues);
        },
        input: r.data
      })
    })) : {
      status: "valid",
      value: o.status === "valid" ? o.value : this._def.catchValue({
        get error() {
          return new Di(r.common.issues);
        },
        input: r.data
      })
    };
  }
  removeCatch() {
    return this._def.innerType;
  }
}
$2.create = (e, t) => new $2({
  innerType: e,
  typeName: Ct.ZodCatch,
  catchValue: typeof t.catch == "function" ? t.catch : () => t.catch,
  ...Rt(t)
});
class d3 extends Gt {
  _parse(t) {
    if (this._getType(t) !== We.nan) {
      const r = this._getOrReturnCtx(t);
      return Ge(r, {
        code: we.invalid_type,
        expected: We.nan,
        received: r.parsedType
      }), vt;
    }
    return { status: "valid", value: t.data };
  }
}
d3.create = (e) => new d3({
  typeName: Ct.ZodNaN,
  ...Rt(e)
});
class a_ extends Gt {
  _parse(t) {
    const { ctx: n } = this._processInputParams(t), r = n.data;
    return this._def.type._parse({
      data: r,
      path: n.path,
      parent: n
    });
  }
  unwrap() {
    return this._def.type;
  }
}
class C9 extends Gt {
  _parse(t) {
    const { status: n, ctx: r } = this._processInputParams(t);
    if (r.common.async)
      return (async () => {
        const a = await this._def.in._parseAsync({
          data: r.data,
          path: r.path,
          parent: r
        });
        return a.status === "aborted" ? vt : a.status === "dirty" ? (n.dirty(), k1(a.value)) : this._def.out._parseAsync({
          data: a.value,
          path: r.path,
          parent: r
        });
      })();
    {
      const o = this._def.in._parseSync({
        data: r.data,
        path: r.path,
        parent: r
      });
      return o.status === "aborted" ? vt : o.status === "dirty" ? (n.dirty(), {
        status: "dirty",
        value: o.value
      }) : this._def.out._parseSync({
        data: o.value,
        path: r.path,
        parent: r
      });
    }
  }
  static create(t, n) {
    return new C9({
      in: t,
      out: n,
      typeName: Ct.ZodPipeline
    });
  }
}
class Z2 extends Gt {
  _parse(t) {
    const n = this._def.innerType._parse(t), r = (o) => (sc(o) && (o.value = Object.freeze(o.value)), o);
    return D2(n) ? n.then((o) => r(o)) : r(n);
  }
  unwrap() {
    return this._def.innerType;
  }
}
Z2.create = (e, t) => new Z2({
  innerType: e,
  typeName: Ct.ZodReadonly,
  ...Rt(t)
});
function lb(e, t) {
  const n = typeof e == "function" ? e(t) : typeof e == "string" ? { message: e } : e;
  return typeof n == "string" ? { message: n } : n;
}
function Uh(e, t = {}, n) {
  return e ? Cd.create().superRefine((r, o) => {
    const a = e(r);
    if (a instanceof Promise)
      return a.then((i) => {
        if (!i) {
          const l = lb(t, r), u = l.fatal ?? n ?? !0;
          o.addIssue({ code: "custom", ...l, fatal: u });
        }
      });
    if (!a) {
      const i = lb(t, r), l = i.fatal ?? n ?? !0;
      o.addIssue({ code: "custom", ...i, fatal: l });
    }
  }) : Cd.create();
}
$n.lazycreate;
var Ct;
(function(e) {
  e.ZodString = "ZodString", e.ZodNumber = "ZodNumber", e.ZodNaN = "ZodNaN", e.ZodBigInt = "ZodBigInt", e.ZodBoolean = "ZodBoolean", e.ZodDate = "ZodDate", e.ZodSymbol = "ZodSymbol", e.ZodUndefined = "ZodUndefined", e.ZodNull = "ZodNull", e.ZodAny = "ZodAny", e.ZodUnknown = "ZodUnknown", e.ZodNever = "ZodNever", e.ZodVoid = "ZodVoid", e.ZodArray = "ZodArray", e.ZodObject = "ZodObject", e.ZodUnion = "ZodUnion", e.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", e.ZodIntersection = "ZodIntersection", e.ZodTuple = "ZodTuple", e.ZodRecord = "ZodRecord", e.ZodMap = "ZodMap", e.ZodSet = "ZodSet", e.ZodFunction = "ZodFunction", e.ZodLazy = "ZodLazy", e.ZodLiteral = "ZodLiteral", e.ZodEnum = "ZodEnum", e.ZodEffects = "ZodEffects", e.ZodNativeEnum = "ZodNativeEnum", e.ZodOptional = "ZodOptional", e.ZodNullable = "ZodNullable", e.ZodDefault = "ZodDefault", e.ZodCatch = "ZodCatch", e.ZodPromise = "ZodPromise", e.ZodBranded = "ZodBranded", e.ZodPipeline = "ZodPipeline", e.ZodReadonly = "ZodReadonly";
})(Ct || (Ct = {}));
const b = Fa.create, D = Ll.create;
d3.create;
Rl.create;
const J = P2.create;
lc.create;
i3.create;
const Vi = E2.create, n2 = T2.create, yl = Cd.create, fn = s3.create, ub = ws.create;
l3.create;
const se = $a.create, w = $n.create, $t = $n.strictCreate, nn = N2.create, na = v9.create, i_ = k2.create, aoe = Dl.create, gn = V2.create;
c3.create;
uc.create;
O2.create;
const fe = F2.create, Me = Pl.create;
B2.create;
H2.create;
Pi.create;
Ai.create;
const Xe = El.create;
Pi.createWithPreprocess;
const ioe = {
  string: (e) => Fa.create({ ...e, coerce: !0 }),
  number: (e) => Ll.create({ ...e, coerce: !0 }),
  boolean: (e) => P2.create({
    ...e,
    coerce: !0
  }),
  bigint: (e) => Rl.create({ ...e, coerce: !0 }),
  date: (e) => lc.create({ ...e, coerce: !0 })
}, j2 = vt;
var W2 = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
W2.exports;
(function(e, t) {
  (function() {
    var n, r = "4.17.21", o = 200, a = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", i = "Expected a function", l = "Invalid `variable` option passed into `_.template`", u = "__lodash_hash_undefined__", d = 500, f = "__lodash_placeholder__", h = 1, p = 2, g = 4, C = 1, v = 2, y = 1, M = 2, x = 4, _ = 8, L = 16, R = 32, k = 64, P = 128, N = 256, O = 512, H = 30, $ = "...", ne = 800, ie = 16, re = 1, ve = 2, ue = 3, j = 1 / 0, K = 9007199254740991, ce = 17976931348623157e292, U = 0 / 0, q = 4294967295, ge = q - 1, X = q >>> 1, he = [
      ["ary", P],
      ["bind", y],
      ["bindKey", M],
      ["curry", _],
      ["curryRight", L],
      ["flip", O],
      ["partial", R],
      ["partialRight", k],
      ["rearg", N]
    ], me = "[object Arguments]", de = "[object Array]", Le = "[object AsyncFunction]", Ie = "[object Boolean]", Ne = "[object Date]", ye = "[object DOMException]", ke = "[object Error]", oe = "[object Function]", lt = "[object GeneratorFunction]", Re = "[object Map]", _t = "[object Number]", on = "[object Null]", $e = "[object Object]", Zt = "[object Promise]", Pt = "[object Proxy]", yt = "[object RegExp]", jt = "[object Set]", An = "[object String]", Rn = "[object Symbol]", Er = "[object Undefined]", Ar = "[object WeakMap]", oa = "[object WeakSet]", fr = "[object ArrayBuffer]", De = "[object DataView]", Xt = "[object Float32Array]", Nn = "[object Float64Array]", Kn = "[object Int8Array]", Jr = "[object Int16Array]", aa = "[object Int32Array]", ks = "[object Uint8Array]", Vs = "[object Uint8ClampedArray]", uo = "[object Uint16Array]", _a = "[object Uint32Array]", Pc = /\b__p \+= '';/g, Gi = /\b(__p \+=) '' \+/g, Wl = /(__e\(.*?\)|\b__t\)) \+\n'';/g, Ro = /&(?:amp|lt|gt|quot|#39);/g, Do = /[&<>"']/g, Os = RegExp(Ro.source), Po = RegExp(Do.source), Ec = /<%-([\s\S]+?)%>/g, zl = /<%([\s\S]+?)%>/g, Ul = /<%=([\s\S]+?)%>/g, Xl = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, Yl = /^\w*$/, co = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Fs = /[\\^$.*+?()[\]{}|]/g, ql = RegExp(Fs.source), $i = /^\s+/, Tc = /\s/, Nc = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, Ia = /\{\n\/\* \[wrapped with (.+)\] \*/, kc = /,? & /, B = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, Ae = /[()=,{}\[\]\/\s]/, Oe = /\\(\\)?/g, ut = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, It = /\w*$/, Kt = /^[-+]0x[0-9a-f]+$/i, Vt = /^0b[01]+$/i, Et = /^\[object .+?Constructor\]$/, or = /^0o[0-7]+$/i, xn = /^(?:0|[1-9]\d*)$/, Dn = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, zn = /($^)/, La = /['\n\r\u2028\u2029\\]/g, pr = "\\ud800-\\udfff", Qn = "\\u0300-\\u036f", Bs = "\\ufe20-\\ufe2f", Zi = "\\u20d0-\\u20ff", Hs = Qn + Bs + Zi, qd = "\\u2700-\\u27bf", Jd = "a-z\\xdf-\\xf6\\xf8-\\xff", Rm = "\\xac\\xb1\\xd7\\xf7", Kd = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", Dm = "\\u2000-\\u206f", Pm = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", Qd = "A-Z\\xc0-\\xd6\\xd8-\\xde", e0 = "\\ufe0e\\ufe0f", t0 = Rm + Kd + Dm + Pm, Vc = "['’]", Em = "[" + pr + "]", n0 = "[" + t0 + "]", Jl = "[" + Hs + "]", r0 = "\\d+", Kl = "[" + qd + "]", Ql = "[" + Jd + "]", o0 = "[^" + pr + t0 + r0 + qd + Jd + Qd + "]", Oc = "\\ud83c[\\udffb-\\udfff]", a0 = "(?:" + Jl + "|" + Oc + ")", i0 = "[^" + pr + "]", Fc = "(?:\\ud83c[\\udde6-\\uddff]){2}", Bc = "[\\ud800-\\udbff][\\udc00-\\udfff]", qa = "[" + Qd + "]", s0 = "\\u200d", l0 = "(?:" + Ql + "|" + o0 + ")", Tm = "(?:" + qa + "|" + o0 + ")", eu = "(?:" + Vc + "(?:d|ll|m|re|s|t|ve))?", u0 = "(?:" + Vc + "(?:D|LL|M|RE|S|T|VE))?", c0 = a0 + "?", d0 = "[" + e0 + "]?", tu = "(?:" + s0 + "(?:" + [i0, Fc, Bc].join("|") + ")" + d0 + c0 + ")*", Hc = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", Gc = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", nu = d0 + c0 + tu, Nm = "(?:" + [Kl, Fc, Bc].join("|") + ")" + nu, f0 = "(?:" + [i0 + Jl + "?", Jl, Fc, Bc, Em].join("|") + ")", $c = RegExp(Vc, "g"), h0 = RegExp(Jl, "g"), ia = RegExp(Oc + "(?=" + Oc + ")|" + f0 + nu, "g"), Gs = RegExp([
      qa + "?" + Ql + "+" + eu + "(?=" + [n0, qa, "$"].join("|") + ")",
      Tm + "+" + u0 + "(?=" + [n0, qa + l0, "$"].join("|") + ")",
      qa + "?" + l0 + "+" + eu,
      qa + "+" + u0,
      Gc,
      Hc,
      r0,
      Nm
    ].join("|"), "g"), km = RegExp("[" + s0 + pr + Hs + e0 + "]"), m0 = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, Vm = [
      "Array",
      "Buffer",
      "DataView",
      "Date",
      "Error",
      "Float32Array",
      "Float64Array",
      "Function",
      "Int8Array",
      "Int16Array",
      "Int32Array",
      "Map",
      "Math",
      "Object",
      "Promise",
      "RegExp",
      "Set",
      "String",
      "Symbol",
      "TypeError",
      "Uint8Array",
      "Uint8ClampedArray",
      "Uint16Array",
      "Uint32Array",
      "WeakMap",
      "_",
      "clearTimeout",
      "isFinite",
      "parseInt",
      "setTimeout"
    ], p0 = -1, Cn = {};
    Cn[Xt] = Cn[Nn] = Cn[Kn] = Cn[Jr] = Cn[aa] = Cn[ks] = Cn[Vs] = Cn[uo] = Cn[_a] = !0, Cn[me] = Cn[de] = Cn[fr] = Cn[Ie] = Cn[De] = Cn[Ne] = Cn[ke] = Cn[oe] = Cn[Re] = Cn[_t] = Cn[$e] = Cn[yt] = Cn[jt] = Cn[An] = Cn[Ar] = !1;
    var pn = {};
    pn[me] = pn[de] = pn[fr] = pn[De] = pn[Ie] = pn[Ne] = pn[Xt] = pn[Nn] = pn[Kn] = pn[Jr] = pn[aa] = pn[Re] = pn[_t] = pn[$e] = pn[yt] = pn[jt] = pn[An] = pn[Rn] = pn[ks] = pn[Vs] = pn[uo] = pn[_a] = !0, pn[ke] = pn[oe] = pn[Ar] = !1;
    var g0 = {
      // Latin-1 Supplement block.
      À: "A",
      Á: "A",
      Â: "A",
      Ã: "A",
      Ä: "A",
      Å: "A",
      à: "a",
      á: "a",
      â: "a",
      ã: "a",
      ä: "a",
      å: "a",
      Ç: "C",
      ç: "c",
      Ð: "D",
      ð: "d",
      È: "E",
      É: "E",
      Ê: "E",
      Ë: "E",
      è: "e",
      é: "e",
      ê: "e",
      ë: "e",
      Ì: "I",
      Í: "I",
      Î: "I",
      Ï: "I",
      ì: "i",
      í: "i",
      î: "i",
      ï: "i",
      Ñ: "N",
      ñ: "n",
      Ò: "O",
      Ó: "O",
      Ô: "O",
      Õ: "O",
      Ö: "O",
      Ø: "O",
      ò: "o",
      ó: "o",
      ô: "o",
      õ: "o",
      ö: "o",
      ø: "o",
      Ù: "U",
      Ú: "U",
      Û: "U",
      Ü: "U",
      ù: "u",
      ú: "u",
      û: "u",
      ü: "u",
      Ý: "Y",
      ý: "y",
      ÿ: "y",
      Æ: "Ae",
      æ: "ae",
      Þ: "Th",
      þ: "th",
      ß: "ss",
      // Latin Extended-A block.
      Ā: "A",
      Ă: "A",
      Ą: "A",
      ā: "a",
      ă: "a",
      ą: "a",
      Ć: "C",
      Ĉ: "C",
      Ċ: "C",
      Č: "C",
      ć: "c",
      ĉ: "c",
      ċ: "c",
      č: "c",
      Ď: "D",
      Đ: "D",
      ď: "d",
      đ: "d",
      Ē: "E",
      Ĕ: "E",
      Ė: "E",
      Ę: "E",
      Ě: "E",
      ē: "e",
      ĕ: "e",
      ė: "e",
      ę: "e",
      ě: "e",
      Ĝ: "G",
      Ğ: "G",
      Ġ: "G",
      Ģ: "G",
      ĝ: "g",
      ğ: "g",
      ġ: "g",
      ģ: "g",
      Ĥ: "H",
      Ħ: "H",
      ĥ: "h",
      ħ: "h",
      Ĩ: "I",
      Ī: "I",
      Ĭ: "I",
      Į: "I",
      İ: "I",
      ĩ: "i",
      ī: "i",
      ĭ: "i",
      į: "i",
      ı: "i",
      Ĵ: "J",
      ĵ: "j",
      Ķ: "K",
      ķ: "k",
      ĸ: "k",
      Ĺ: "L",
      Ļ: "L",
      Ľ: "L",
      Ŀ: "L",
      Ł: "L",
      ĺ: "l",
      ļ: "l",
      ľ: "l",
      ŀ: "l",
      ł: "l",
      Ń: "N",
      Ņ: "N",
      Ň: "N",
      Ŋ: "N",
      ń: "n",
      ņ: "n",
      ň: "n",
      ŋ: "n",
      Ō: "O",
      Ŏ: "O",
      Ő: "O",
      ō: "o",
      ŏ: "o",
      ő: "o",
      Ŕ: "R",
      Ŗ: "R",
      Ř: "R",
      ŕ: "r",
      ŗ: "r",
      ř: "r",
      Ś: "S",
      Ŝ: "S",
      Ş: "S",
      Š: "S",
      ś: "s",
      ŝ: "s",
      ş: "s",
      š: "s",
      Ţ: "T",
      Ť: "T",
      Ŧ: "T",
      ţ: "t",
      ť: "t",
      ŧ: "t",
      Ũ: "U",
      Ū: "U",
      Ŭ: "U",
      Ů: "U",
      Ű: "U",
      Ų: "U",
      ũ: "u",
      ū: "u",
      ŭ: "u",
      ů: "u",
      ű: "u",
      ų: "u",
      Ŵ: "W",
      ŵ: "w",
      Ŷ: "Y",
      ŷ: "y",
      Ÿ: "Y",
      Ź: "Z",
      Ż: "Z",
      Ž: "Z",
      ź: "z",
      ż: "z",
      ž: "z",
      Ĳ: "IJ",
      ĳ: "ij",
      Œ: "Oe",
      œ: "oe",
      ŉ: "'n",
      ſ: "s"
    }, Om = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    }, V = {
      "&amp;": "&",
      "&lt;": "<",
      "&gt;": ">",
      "&quot;": '"',
      "&#39;": "'"
    }, Z = {
      "\\": "\\",
      "'": "'",
      "\n": "n",
      "\r": "r",
      "\u2028": "u2028",
      "\u2029": "u2029"
    }, ee = parseFloat, Ze = parseInt, Ot = typeof di == "object" && di && di.Object === Object && di, un = typeof self == "object" && self && self.Object === Object && self, xt = Ot || un || Function("return this")(), Nt = t && !t.nodeType && t, Jt = Nt && !0 && e && !e.nodeType && e, Tr = Jt && Jt.exports === Nt, gr = Tr && Ot.process, hr = function() {
      try {
        var z = Jt && Jt.require && Jt.require("util").types;
        return z || gr && gr.binding && gr.binding("util");
      } catch {
      }
    }(), ru = hr && hr.isArrayBuffer, ou = hr && hr.isDate, Zc = hr && hr.isMap, g7 = hr && hr.isRegExp, v7 = hr && hr.isSet, C7 = hr && hr.isTypedArray;
    function fo(z, le, te) {
      switch (te.length) {
        case 0:
          return z.call(le);
        case 1:
          return z.call(le, te[0]);
        case 2:
          return z.call(le, te[0], te[1]);
        case 3:
          return z.call(le, te[0], te[1], te[2]);
      }
      return z.apply(le, te);
    }
    function KR(z, le, te, je) {
      for (var St = -1, Qt = z == null ? 0 : z.length; ++St < Qt; ) {
        var ar = z[St];
        le(je, ar, te(ar), z);
      }
      return je;
    }
    function Eo(z, le) {
      for (var te = -1, je = z == null ? 0 : z.length; ++te < je && le(z[te], te, z) !== !1; )
        ;
      return z;
    }
    function QR(z, le) {
      for (var te = z == null ? 0 : z.length; te-- && le(z[te], te, z) !== !1; )
        ;
      return z;
    }
    function b7(z, le) {
      for (var te = -1, je = z == null ? 0 : z.length; ++te < je; )
        if (!le(z[te], te, z))
          return !1;
      return !0;
    }
    function ji(z, le) {
      for (var te = -1, je = z == null ? 0 : z.length, St = 0, Qt = []; ++te < je; ) {
        var ar = z[te];
        le(ar, te, z) && (Qt[St++] = ar);
      }
      return Qt;
    }
    function v0(z, le) {
      var te = z == null ? 0 : z.length;
      return !!te && au(z, le, 0) > -1;
    }
    function Fm(z, le, te) {
      for (var je = -1, St = z == null ? 0 : z.length; ++je < St; )
        if (te(le, z[je]))
          return !0;
      return !1;
    }
    function Pn(z, le) {
      for (var te = -1, je = z == null ? 0 : z.length, St = Array(je); ++te < je; )
        St[te] = le(z[te], te, z);
      return St;
    }
    function Wi(z, le) {
      for (var te = -1, je = le.length, St = z.length; ++te < je; )
        z[St + te] = le[te];
      return z;
    }
    function Bm(z, le, te, je) {
      var St = -1, Qt = z == null ? 0 : z.length;
      for (je && Qt && (te = z[++St]); ++St < Qt; )
        te = le(te, z[St], St, z);
      return te;
    }
    function eD(z, le, te, je) {
      var St = z == null ? 0 : z.length;
      for (je && St && (te = z[--St]); St--; )
        te = le(te, z[St], St, z);
      return te;
    }
    function Hm(z, le) {
      for (var te = -1, je = z == null ? 0 : z.length; ++te < je; )
        if (le(z[te], te, z))
          return !0;
      return !1;
    }
    var tD = Gm("length");
    function nD(z) {
      return z.split("");
    }
    function rD(z) {
      return z.match(B) || [];
    }
    function y7(z, le, te) {
      var je;
      return te(z, function(St, Qt, ar) {
        if (le(St, Qt, ar))
          return je = Qt, !1;
      }), je;
    }
    function C0(z, le, te, je) {
      for (var St = z.length, Qt = te + (je ? 1 : -1); je ? Qt-- : ++Qt < St; )
        if (le(z[Qt], Qt, z))
          return Qt;
      return -1;
    }
    function au(z, le, te) {
      return le === le ? pD(z, le, te) : C0(z, S7, te);
    }
    function oD(z, le, te, je) {
      for (var St = te - 1, Qt = z.length; ++St < Qt; )
        if (je(z[St], le))
          return St;
      return -1;
    }
    function S7(z) {
      return z !== z;
    }
    function A7(z, le) {
      var te = z == null ? 0 : z.length;
      return te ? Zm(z, le) / te : U;
    }
    function Gm(z) {
      return function(le) {
        return le == null ? n : le[z];
      };
    }
    function $m(z) {
      return function(le) {
        return z == null ? n : z[le];
      };
    }
    function M7(z, le, te, je, St) {
      return St(z, function(Qt, ar, bn) {
        te = je ? (je = !1, Qt) : le(te, Qt, ar, bn);
      }), te;
    }
    function aD(z, le) {
      var te = z.length;
      for (z.sort(le); te--; )
        z[te] = z[te].value;
      return z;
    }
    function Zm(z, le) {
      for (var te, je = -1, St = z.length; ++je < St; ) {
        var Qt = le(z[je]);
        Qt !== n && (te = te === n ? Qt : te + Qt);
      }
      return te;
    }
    function jm(z, le) {
      for (var te = -1, je = Array(z); ++te < z; )
        je[te] = le(te);
      return je;
    }
    function iD(z, le) {
      return Pn(le, function(te) {
        return [te, z[te]];
      });
    }
    function x7(z) {
      return z && z.slice(0, L7(z) + 1).replace($i, "");
    }
    function ho(z) {
      return function(le) {
        return z(le);
      };
    }
    function Wm(z, le) {
      return Pn(le, function(te) {
        return z[te];
      });
    }
    function jc(z, le) {
      return z.has(le);
    }
    function w7(z, le) {
      for (var te = -1, je = z.length; ++te < je && au(le, z[te], 0) > -1; )
        ;
      return te;
    }
    function _7(z, le) {
      for (var te = z.length; te-- && au(le, z[te], 0) > -1; )
        ;
      return te;
    }
    function sD(z, le) {
      for (var te = z.length, je = 0; te--; )
        z[te] === le && ++je;
      return je;
    }
    var lD = $m(g0), uD = $m(Om);
    function cD(z) {
      return "\\" + Z[z];
    }
    function dD(z, le) {
      return z == null ? n : z[le];
    }
    function iu(z) {
      return km.test(z);
    }
    function fD(z) {
      return m0.test(z);
    }
    function hD(z) {
      for (var le, te = []; !(le = z.next()).done; )
        te.push(le.value);
      return te;
    }
    function zm(z) {
      var le = -1, te = Array(z.size);
      return z.forEach(function(je, St) {
        te[++le] = [St, je];
      }), te;
    }
    function I7(z, le) {
      return function(te) {
        return z(le(te));
      };
    }
    function zi(z, le) {
      for (var te = -1, je = z.length, St = 0, Qt = []; ++te < je; ) {
        var ar = z[te];
        (ar === le || ar === f) && (z[te] = f, Qt[St++] = te);
      }
      return Qt;
    }
    function b0(z) {
      var le = -1, te = Array(z.size);
      return z.forEach(function(je) {
        te[++le] = je;
      }), te;
    }
    function mD(z) {
      var le = -1, te = Array(z.size);
      return z.forEach(function(je) {
        te[++le] = [je, je];
      }), te;
    }
    function pD(z, le, te) {
      for (var je = te - 1, St = z.length; ++je < St; )
        if (z[je] === le)
          return je;
      return -1;
    }
    function gD(z, le, te) {
      for (var je = te + 1; je--; )
        if (z[je] === le)
          return je;
      return je;
    }
    function su(z) {
      return iu(z) ? CD(z) : tD(z);
    }
    function sa(z) {
      return iu(z) ? bD(z) : nD(z);
    }
    function L7(z) {
      for (var le = z.length; le-- && Tc.test(z.charAt(le)); )
        ;
      return le;
    }
    var vD = $m(V);
    function CD(z) {
      for (var le = ia.lastIndex = 0; ia.test(z); )
        ++le;
      return le;
    }
    function bD(z) {
      return z.match(ia) || [];
    }
    function yD(z) {
      return z.match(Gs) || [];
    }
    var SD = function z(le) {
      le = le == null ? xt : lu.defaults(xt.Object(), le, lu.pick(xt, Vm));
      var te = le.Array, je = le.Date, St = le.Error, Qt = le.Function, ar = le.Math, bn = le.Object, Um = le.RegExp, AD = le.String, To = le.TypeError, y0 = te.prototype, MD = Qt.prototype, uu = bn.prototype, S0 = le["__core-js_shared__"], A0 = MD.toString, cn = uu.hasOwnProperty, xD = 0, R7 = function() {
        var s = /[^.]+$/.exec(S0 && S0.keys && S0.keys.IE_PROTO || "");
        return s ? "Symbol(src)_1." + s : "";
      }(), M0 = uu.toString, wD = A0.call(bn), _D = xt._, ID = Um(
        "^" + A0.call(cn).replace(Fs, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
      ), x0 = Tr ? le.Buffer : n, Ui = le.Symbol, w0 = le.Uint8Array, D7 = x0 ? x0.allocUnsafe : n, _0 = I7(bn.getPrototypeOf, bn), P7 = bn.create, E7 = uu.propertyIsEnumerable, I0 = y0.splice, T7 = Ui ? Ui.isConcatSpreadable : n, Wc = Ui ? Ui.iterator : n, $s = Ui ? Ui.toStringTag : n, L0 = function() {
        try {
          var s = Us(bn, "defineProperty");
          return s({}, "", {}), s;
        } catch {
        }
      }(), LD = le.clearTimeout !== xt.clearTimeout && le.clearTimeout, RD = je && je.now !== xt.Date.now && je.now, DD = le.setTimeout !== xt.setTimeout && le.setTimeout, R0 = ar.ceil, D0 = ar.floor, Xm = bn.getOwnPropertySymbols, PD = x0 ? x0.isBuffer : n, N7 = le.isFinite, ED = y0.join, TD = I7(bn.keys, bn), ir = ar.max, Mr = ar.min, ND = je.now, kD = le.parseInt, k7 = ar.random, VD = y0.reverse, Ym = Us(le, "DataView"), zc = Us(le, "Map"), qm = Us(le, "Promise"), cu = Us(le, "Set"), Uc = Us(le, "WeakMap"), Xc = Us(bn, "create"), P0 = Uc && new Uc(), du = {}, OD = Xs(Ym), FD = Xs(zc), BD = Xs(qm), HD = Xs(cu), GD = Xs(Uc), E0 = Ui ? Ui.prototype : n, Yc = E0 ? E0.valueOf : n, V7 = E0 ? E0.toString : n;
      function E(s) {
        if (Hn(s) && !At(s) && !(s instanceof Ht)) {
          if (s instanceof No)
            return s;
          if (cn.call(s, "__wrapped__"))
            return O6(s);
        }
        return new No(s);
      }
      var fu = function() {
        function s() {
        }
        return function(c) {
          if (!kn(c))
            return {};
          if (P7)
            return P7(c);
          s.prototype = c;
          var m = new s();
          return s.prototype = n, m;
        };
      }();
      function T0() {
      }
      function No(s, c) {
        this.__wrapped__ = s, this.__actions__ = [], this.__chain__ = !!c, this.__index__ = 0, this.__values__ = n;
      }
      E.templateSettings = {
        /**
         * Used to detect `data` property values to be HTML-escaped.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        escape: Ec,
        /**
         * Used to detect code to be evaluated.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        evaluate: zl,
        /**
         * Used to detect `data` property values to inject.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        interpolate: Ul,
        /**
         * Used to reference the data object in the template text.
         *
         * @memberOf _.templateSettings
         * @type {string}
         */
        variable: "",
        /**
         * Used to import variables into the compiled template.
         *
         * @memberOf _.templateSettings
         * @type {Object}
         */
        imports: {
          /**
           * A reference to the `lodash` function.
           *
           * @memberOf _.templateSettings.imports
           * @type {Function}
           */
          _: E
        }
      }, E.prototype = T0.prototype, E.prototype.constructor = E, No.prototype = fu(T0.prototype), No.prototype.constructor = No;
      function Ht(s) {
        this.__wrapped__ = s, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = q, this.__views__ = [];
      }
      function $D() {
        var s = new Ht(this.__wrapped__);
        return s.__actions__ = Kr(this.__actions__), s.__dir__ = this.__dir__, s.__filtered__ = this.__filtered__, s.__iteratees__ = Kr(this.__iteratees__), s.__takeCount__ = this.__takeCount__, s.__views__ = Kr(this.__views__), s;
      }
      function ZD() {
        if (this.__filtered__) {
          var s = new Ht(this);
          s.__dir__ = -1, s.__filtered__ = !0;
        } else
          s = this.clone(), s.__dir__ *= -1;
        return s;
      }
      function jD() {
        var s = this.__wrapped__.value(), c = this.__dir__, m = At(s), S = c < 0, I = m ? s.length : 0, T = nE(0, I, this.__views__), F = T.start, G = T.end, Y = G - F, Ce = S ? G : F - 1, be = this.__iteratees__, Se = be.length, Fe = 0, Ue = Mr(Y, this.__takeCount__);
        if (!m || !S && I == Y && Ue == Y)
          return i6(s, this.__actions__);
        var ct = [];
        e:
          for (; Y-- && Fe < Ue; ) {
            Ce += c;
            for (var Tt = -1, dt = s[Ce]; ++Tt < Se; ) {
              var Ft = be[Tt], Wt = Ft.iteratee, go = Ft.type, Vr = Wt(dt);
              if (go == ve)
                dt = Vr;
              else if (!Vr) {
                if (go == re)
                  continue e;
                break e;
              }
            }
            ct[Fe++] = dt;
          }
        return ct;
      }
      Ht.prototype = fu(T0.prototype), Ht.prototype.constructor = Ht;
      function Zs(s) {
        var c = -1, m = s == null ? 0 : s.length;
        for (this.clear(); ++c < m; ) {
          var S = s[c];
          this.set(S[0], S[1]);
        }
      }
      function WD() {
        this.__data__ = Xc ? Xc(null) : {}, this.size = 0;
      }
      function zD(s) {
        var c = this.has(s) && delete this.__data__[s];
        return this.size -= c ? 1 : 0, c;
      }
      function UD(s) {
        var c = this.__data__;
        if (Xc) {
          var m = c[s];
          return m === u ? n : m;
        }
        return cn.call(c, s) ? c[s] : n;
      }
      function XD(s) {
        var c = this.__data__;
        return Xc ? c[s] !== n : cn.call(c, s);
      }
      function YD(s, c) {
        var m = this.__data__;
        return this.size += this.has(s) ? 0 : 1, m[s] = Xc && c === n ? u : c, this;
      }
      Zs.prototype.clear = WD, Zs.prototype.delete = zD, Zs.prototype.get = UD, Zs.prototype.has = XD, Zs.prototype.set = YD;
      function Ja(s) {
        var c = -1, m = s == null ? 0 : s.length;
        for (this.clear(); ++c < m; ) {
          var S = s[c];
          this.set(S[0], S[1]);
        }
      }
      function qD() {
        this.__data__ = [], this.size = 0;
      }
      function JD(s) {
        var c = this.__data__, m = N0(c, s);
        if (m < 0)
          return !1;
        var S = c.length - 1;
        return m == S ? c.pop() : I0.call(c, m, 1), --this.size, !0;
      }
      function KD(s) {
        var c = this.__data__, m = N0(c, s);
        return m < 0 ? n : c[m][1];
      }
      function QD(s) {
        return N0(this.__data__, s) > -1;
      }
      function eP(s, c) {
        var m = this.__data__, S = N0(m, s);
        return S < 0 ? (++this.size, m.push([s, c])) : m[S][1] = c, this;
      }
      Ja.prototype.clear = qD, Ja.prototype.delete = JD, Ja.prototype.get = KD, Ja.prototype.has = QD, Ja.prototype.set = eP;
      function Ka(s) {
        var c = -1, m = s == null ? 0 : s.length;
        for (this.clear(); ++c < m; ) {
          var S = s[c];
          this.set(S[0], S[1]);
        }
      }
      function tP() {
        this.size = 0, this.__data__ = {
          hash: new Zs(),
          map: new (zc || Ja)(),
          string: new Zs()
        };
      }
      function nP(s) {
        var c = z0(this, s).delete(s);
        return this.size -= c ? 1 : 0, c;
      }
      function rP(s) {
        return z0(this, s).get(s);
      }
      function oP(s) {
        return z0(this, s).has(s);
      }
      function aP(s, c) {
        var m = z0(this, s), S = m.size;
        return m.set(s, c), this.size += m.size == S ? 0 : 1, this;
      }
      Ka.prototype.clear = tP, Ka.prototype.delete = nP, Ka.prototype.get = rP, Ka.prototype.has = oP, Ka.prototype.set = aP;
      function js(s) {
        var c = -1, m = s == null ? 0 : s.length;
        for (this.__data__ = new Ka(); ++c < m; )
          this.add(s[c]);
      }
      function iP(s) {
        return this.__data__.set(s, u), this;
      }
      function sP(s) {
        return this.__data__.has(s);
      }
      js.prototype.add = js.prototype.push = iP, js.prototype.has = sP;
      function la(s) {
        var c = this.__data__ = new Ja(s);
        this.size = c.size;
      }
      function lP() {
        this.__data__ = new Ja(), this.size = 0;
      }
      function uP(s) {
        var c = this.__data__, m = c.delete(s);
        return this.size = c.size, m;
      }
      function cP(s) {
        return this.__data__.get(s);
      }
      function dP(s) {
        return this.__data__.has(s);
      }
      function fP(s, c) {
        var m = this.__data__;
        if (m instanceof Ja) {
          var S = m.__data__;
          if (!zc || S.length < o - 1)
            return S.push([s, c]), this.size = ++m.size, this;
          m = this.__data__ = new Ka(S);
        }
        return m.set(s, c), this.size = m.size, this;
      }
      la.prototype.clear = lP, la.prototype.delete = uP, la.prototype.get = cP, la.prototype.has = dP, la.prototype.set = fP;
      function O7(s, c) {
        var m = At(s), S = !m && Ys(s), I = !m && !S && Ki(s), T = !m && !S && !I && gu(s), F = m || S || I || T, G = F ? jm(s.length, AD) : [], Y = G.length;
        for (var Ce in s)
          (c || cn.call(s, Ce)) && !(F && // Safari 9 has enumerable `arguments.length` in strict mode.
          (Ce == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
          I && (Ce == "offset" || Ce == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
          T && (Ce == "buffer" || Ce == "byteLength" || Ce == "byteOffset") || // Skip index properties.
          ni(Ce, Y))) && G.push(Ce);
        return G;
      }
      function F7(s) {
        var c = s.length;
        return c ? s[sp(0, c - 1)] : n;
      }
      function hP(s, c) {
        return U0(Kr(s), Ws(c, 0, s.length));
      }
      function mP(s) {
        return U0(Kr(s));
      }
      function Jm(s, c, m) {
        (m !== n && !ua(s[c], m) || m === n && !(c in s)) && Qa(s, c, m);
      }
      function qc(s, c, m) {
        var S = s[c];
        (!(cn.call(s, c) && ua(S, m)) || m === n && !(c in s)) && Qa(s, c, m);
      }
      function N0(s, c) {
        for (var m = s.length; m--; )
          if (ua(s[m][0], c))
            return m;
        return -1;
      }
      function pP(s, c, m, S) {
        return Xi(s, function(I, T, F) {
          c(S, I, m(I), F);
        }), S;
      }
      function B7(s, c) {
        return s && Da(c, mr(c), s);
      }
      function gP(s, c) {
        return s && Da(c, eo(c), s);
      }
      function Qa(s, c, m) {
        c == "__proto__" && L0 ? L0(s, c, {
          configurable: !0,
          enumerable: !0,
          value: m,
          writable: !0
        }) : s[c] = m;
      }
      function Km(s, c) {
        for (var m = -1, S = c.length, I = te(S), T = s == null; ++m < S; )
          I[m] = T ? n : Ep(s, c[m]);
        return I;
      }
      function Ws(s, c, m) {
        return s === s && (m !== n && (s = s <= m ? s : m), c !== n && (s = s >= c ? s : c)), s;
      }
      function ko(s, c, m, S, I, T) {
        var F, G = c & h, Y = c & p, Ce = c & g;
        if (m && (F = I ? m(s, S, I, T) : m(s)), F !== n)
          return F;
        if (!kn(s))
          return s;
        var be = At(s);
        if (be) {
          if (F = oE(s), !G)
            return Kr(s, F);
        } else {
          var Se = xr(s), Fe = Se == oe || Se == lt;
          if (Ki(s))
            return u6(s, G);
          if (Se == $e || Se == me || Fe && !I) {
            if (F = Y || Fe ? {} : L6(s), !G)
              return Y ? UP(s, gP(F, s)) : zP(s, B7(F, s));
          } else {
            if (!pn[Se])
              return I ? s : {};
            F = aE(s, Se, G);
          }
        }
        T || (T = new la());
        var Ue = T.get(s);
        if (Ue)
          return Ue;
        T.set(s, F), rv(s) ? s.forEach(function(dt) {
          F.add(ko(dt, c, m, dt, s, T));
        }) : tv(s) && s.forEach(function(dt, Ft) {
          F.set(Ft, ko(dt, c, m, Ft, s, T));
        });
        var ct = Ce ? Y ? Cp : vp : Y ? eo : mr, Tt = be ? n : ct(s);
        return Eo(Tt || s, function(dt, Ft) {
          Tt && (Ft = dt, dt = s[Ft]), qc(F, Ft, ko(dt, c, m, Ft, s, T));
        }), F;
      }
      function vP(s) {
        var c = mr(s);
        return function(m) {
          return H7(m, s, c);
        };
      }
      function H7(s, c, m) {
        var S = m.length;
        if (s == null)
          return !S;
        for (s = bn(s); S--; ) {
          var I = m[S], T = c[I], F = s[I];
          if (F === n && !(I in s) || !T(F))
            return !1;
        }
        return !0;
      }
      function G7(s, c, m) {
        if (typeof s != "function")
          throw new To(i);
        return r1(function() {
          s.apply(n, m);
        }, c);
      }
      function Jc(s, c, m, S) {
        var I = -1, T = v0, F = !0, G = s.length, Y = [], Ce = c.length;
        if (!G)
          return Y;
        m && (c = Pn(c, ho(m))), S ? (T = Fm, F = !1) : c.length >= o && (T = jc, F = !1, c = new js(c));
        e:
          for (; ++I < G; ) {
            var be = s[I], Se = m == null ? be : m(be);
            if (be = S || be !== 0 ? be : 0, F && Se === Se) {
              for (var Fe = Ce; Fe--; )
                if (c[Fe] === Se)
                  continue e;
              Y.push(be);
            } else
              T(c, Se, S) || Y.push(be);
          }
        return Y;
      }
      var Xi = m6(Ra), $7 = m6(ep, !0);
      function CP(s, c) {
        var m = !0;
        return Xi(s, function(S, I, T) {
          return m = !!c(S, I, T), m;
        }), m;
      }
      function k0(s, c, m) {
        for (var S = -1, I = s.length; ++S < I; ) {
          var T = s[S], F = c(T);
          if (F != null && (G === n ? F === F && !po(F) : m(F, G)))
            var G = F, Y = T;
        }
        return Y;
      }
      function bP(s, c, m, S) {
        var I = s.length;
        for (m = Lt(m), m < 0 && (m = -m > I ? 0 : I + m), S = S === n || S > I ? I : Lt(S), S < 0 && (S += I), S = m > S ? 0 : av(S); m < S; )
          s[m++] = c;
        return s;
      }
      function Z7(s, c) {
        var m = [];
        return Xi(s, function(S, I, T) {
          c(S, I, T) && m.push(S);
        }), m;
      }
      function vr(s, c, m, S, I) {
        var T = -1, F = s.length;
        for (m || (m = sE), I || (I = []); ++T < F; ) {
          var G = s[T];
          c > 0 && m(G) ? c > 1 ? vr(G, c - 1, m, S, I) : Wi(I, G) : S || (I[I.length] = G);
        }
        return I;
      }
      var Qm = p6(), j7 = p6(!0);
      function Ra(s, c) {
        return s && Qm(s, c, mr);
      }
      function ep(s, c) {
        return s && j7(s, c, mr);
      }
      function V0(s, c) {
        return ji(c, function(m) {
          return ri(s[m]);
        });
      }
      function zs(s, c) {
        c = qi(c, s);
        for (var m = 0, S = c.length; s != null && m < S; )
          s = s[Pa(c[m++])];
        return m && m == S ? s : n;
      }
      function W7(s, c, m) {
        var S = c(s);
        return At(s) ? S : Wi(S, m(s));
      }
      function Nr(s) {
        return s == null ? s === n ? Er : on : $s && $s in bn(s) ? tE(s) : mE(s);
      }
      function tp(s, c) {
        return s > c;
      }
      function yP(s, c) {
        return s != null && cn.call(s, c);
      }
      function SP(s, c) {
        return s != null && c in bn(s);
      }
      function AP(s, c, m) {
        return s >= Mr(c, m) && s < ir(c, m);
      }
      function np(s, c, m) {
        for (var S = m ? Fm : v0, I = s[0].length, T = s.length, F = T, G = te(T), Y = 1 / 0, Ce = []; F--; ) {
          var be = s[F];
          F && c && (be = Pn(be, ho(c))), Y = Mr(be.length, Y), G[F] = !m && (c || I >= 120 && be.length >= 120) ? new js(F && be) : n;
        }
        be = s[0];
        var Se = -1, Fe = G[0];
        e:
          for (; ++Se < I && Ce.length < Y; ) {
            var Ue = be[Se], ct = c ? c(Ue) : Ue;
            if (Ue = m || Ue !== 0 ? Ue : 0, !(Fe ? jc(Fe, ct) : S(Ce, ct, m))) {
              for (F = T; --F; ) {
                var Tt = G[F];
                if (!(Tt ? jc(Tt, ct) : S(s[F], ct, m)))
                  continue e;
              }
              Fe && Fe.push(ct), Ce.push(Ue);
            }
          }
        return Ce;
      }
      function MP(s, c, m, S) {
        return Ra(s, function(I, T, F) {
          c(S, m(I), T, F);
        }), S;
      }
      function Kc(s, c, m) {
        c = qi(c, s), s = E6(s, c);
        var S = s == null ? s : s[Pa(Oo(c))];
        return S == null ? n : fo(S, s, m);
      }
      function z7(s) {
        return Hn(s) && Nr(s) == me;
      }
      function xP(s) {
        return Hn(s) && Nr(s) == fr;
      }
      function wP(s) {
        return Hn(s) && Nr(s) == Ne;
      }
      function Qc(s, c, m, S, I) {
        return s === c ? !0 : s == null || c == null || !Hn(s) && !Hn(c) ? s !== s && c !== c : _P(s, c, m, S, Qc, I);
      }
      function _P(s, c, m, S, I, T) {
        var F = At(s), G = At(c), Y = F ? de : xr(s), Ce = G ? de : xr(c);
        Y = Y == me ? $e : Y, Ce = Ce == me ? $e : Ce;
        var be = Y == $e, Se = Ce == $e, Fe = Y == Ce;
        if (Fe && Ki(s)) {
          if (!Ki(c))
            return !1;
          F = !0, be = !1;
        }
        if (Fe && !be)
          return T || (T = new la()), F || gu(s) ? w6(s, c, m, S, I, T) : QP(s, c, Y, m, S, I, T);
        if (!(m & C)) {
          var Ue = be && cn.call(s, "__wrapped__"), ct = Se && cn.call(c, "__wrapped__");
          if (Ue || ct) {
            var Tt = Ue ? s.value() : s, dt = ct ? c.value() : c;
            return T || (T = new la()), I(Tt, dt, m, S, T);
          }
        }
        return Fe ? (T || (T = new la()), eE(s, c, m, S, I, T)) : !1;
      }
      function IP(s) {
        return Hn(s) && xr(s) == Re;
      }
      function rp(s, c, m, S) {
        var I = m.length, T = I, F = !S;
        if (s == null)
          return !T;
        for (s = bn(s); I--; ) {
          var G = m[I];
          if (F && G[2] ? G[1] !== s[G[0]] : !(G[0] in s))
            return !1;
        }
        for (; ++I < T; ) {
          G = m[I];
          var Y = G[0], Ce = s[Y], be = G[1];
          if (F && G[2]) {
            if (Ce === n && !(Y in s))
              return !1;
          } else {
            var Se = new la();
            if (S)
              var Fe = S(Ce, be, Y, s, c, Se);
            if (!(Fe === n ? Qc(be, Ce, C | v, S, Se) : Fe))
              return !1;
          }
        }
        return !0;
      }
      function U7(s) {
        if (!kn(s) || uE(s))
          return !1;
        var c = ri(s) ? ID : Et;
        return c.test(Xs(s));
      }
      function LP(s) {
        return Hn(s) && Nr(s) == yt;
      }
      function RP(s) {
        return Hn(s) && xr(s) == jt;
      }
      function DP(s) {
        return Hn(s) && Q0(s.length) && !!Cn[Nr(s)];
      }
      function X7(s) {
        return typeof s == "function" ? s : s == null ? to : typeof s == "object" ? At(s) ? J7(s[0], s[1]) : q7(s) : gv(s);
      }
      function op(s) {
        if (!n1(s))
          return TD(s);
        var c = [];
        for (var m in bn(s))
          cn.call(s, m) && m != "constructor" && c.push(m);
        return c;
      }
      function PP(s) {
        if (!kn(s))
          return hE(s);
        var c = n1(s), m = [];
        for (var S in s)
          S == "constructor" && (c || !cn.call(s, S)) || m.push(S);
        return m;
      }
      function ap(s, c) {
        return s < c;
      }
      function Y7(s, c) {
        var m = -1, S = Qr(s) ? te(s.length) : [];
        return Xi(s, function(I, T, F) {
          S[++m] = c(I, T, F);
        }), S;
      }
      function q7(s) {
        var c = yp(s);
        return c.length == 1 && c[0][2] ? D6(c[0][0], c[0][1]) : function(m) {
          return m === s || rp(m, s, c);
        };
      }
      function J7(s, c) {
        return Ap(s) && R6(c) ? D6(Pa(s), c) : function(m) {
          var S = Ep(m, s);
          return S === n && S === c ? Tp(m, s) : Qc(c, S, C | v);
        };
      }
      function O0(s, c, m, S, I) {
        s !== c && Qm(c, function(T, F) {
          if (I || (I = new la()), kn(T))
            EP(s, c, F, m, O0, S, I);
          else {
            var G = S ? S(xp(s, F), T, F + "", s, c, I) : n;
            G === n && (G = T), Jm(s, F, G);
          }
        }, eo);
      }
      function EP(s, c, m, S, I, T, F) {
        var G = xp(s, m), Y = xp(c, m), Ce = F.get(Y);
        if (Ce) {
          Jm(s, m, Ce);
          return;
        }
        var be = T ? T(G, Y, m + "", s, c, F) : n, Se = be === n;
        if (Se) {
          var Fe = At(Y), Ue = !Fe && Ki(Y), ct = !Fe && !Ue && gu(Y);
          be = Y, Fe || Ue || ct ? At(G) ? be = G : Un(G) ? be = Kr(G) : Ue ? (Se = !1, be = u6(Y, !0)) : ct ? (Se = !1, be = c6(Y, !0)) : be = [] : o1(Y) || Ys(Y) ? (be = G, Ys(G) ? be = iv(G) : (!kn(G) || ri(G)) && (be = L6(Y))) : Se = !1;
        }
        Se && (F.set(Y, be), I(be, Y, S, T, F), F.delete(Y)), Jm(s, m, be);
      }
      function K7(s, c) {
        var m = s.length;
        if (m)
          return c += c < 0 ? m : 0, ni(c, m) ? s[c] : n;
      }
      function Q7(s, c, m) {
        c.length ? c = Pn(c, function(T) {
          return At(T) ? function(F) {
            return zs(F, T.length === 1 ? T[0] : T);
          } : T;
        }) : c = [to];
        var S = -1;
        c = Pn(c, ho(it()));
        var I = Y7(s, function(T, F, G) {
          var Y = Pn(c, function(Ce) {
            return Ce(T);
          });
          return { criteria: Y, index: ++S, value: T };
        });
        return aD(I, function(T, F) {
          return WP(T, F, m);
        });
      }
      function TP(s, c) {
        return e6(s, c, function(m, S) {
          return Tp(s, S);
        });
      }
      function e6(s, c, m) {
        for (var S = -1, I = c.length, T = {}; ++S < I; ) {
          var F = c[S], G = zs(s, F);
          m(G, F) && e1(T, qi(F, s), G);
        }
        return T;
      }
      function NP(s) {
        return function(c) {
          return zs(c, s);
        };
      }
      function ip(s, c, m, S) {
        var I = S ? oD : au, T = -1, F = c.length, G = s;
        for (s === c && (c = Kr(c)), m && (G = Pn(s, ho(m))); ++T < F; )
          for (var Y = 0, Ce = c[T], be = m ? m(Ce) : Ce; (Y = I(G, be, Y, S)) > -1; )
            G !== s && I0.call(G, Y, 1), I0.call(s, Y, 1);
        return s;
      }
      function t6(s, c) {
        for (var m = s ? c.length : 0, S = m - 1; m--; ) {
          var I = c[m];
          if (m == S || I !== T) {
            var T = I;
            ni(I) ? I0.call(s, I, 1) : cp(s, I);
          }
        }
        return s;
      }
      function sp(s, c) {
        return s + D0(k7() * (c - s + 1));
      }
      function kP(s, c, m, S) {
        for (var I = -1, T = ir(R0((c - s) / (m || 1)), 0), F = te(T); T--; )
          F[S ? T : ++I] = s, s += m;
        return F;
      }
      function lp(s, c) {
        var m = "";
        if (!s || c < 1 || c > K)
          return m;
        do
          c % 2 && (m += s), c = D0(c / 2), c && (s += s);
        while (c);
        return m;
      }
      function kt(s, c) {
        return wp(P6(s, c, to), s + "");
      }
      function VP(s) {
        return F7(vu(s));
      }
      function OP(s, c) {
        var m = vu(s);
        return U0(m, Ws(c, 0, m.length));
      }
      function e1(s, c, m, S) {
        if (!kn(s))
          return s;
        c = qi(c, s);
        for (var I = -1, T = c.length, F = T - 1, G = s; G != null && ++I < T; ) {
          var Y = Pa(c[I]), Ce = m;
          if (Y === "__proto__" || Y === "constructor" || Y === "prototype")
            return s;
          if (I != F) {
            var be = G[Y];
            Ce = S ? S(be, Y, G) : n, Ce === n && (Ce = kn(be) ? be : ni(c[I + 1]) ? [] : {});
          }
          qc(G, Y, Ce), G = G[Y];
        }
        return s;
      }
      var n6 = P0 ? function(s, c) {
        return P0.set(s, c), s;
      } : to, FP = L0 ? function(s, c) {
        return L0(s, "toString", {
          configurable: !0,
          enumerable: !1,
          value: kp(c),
          writable: !0
        });
      } : to;
      function BP(s) {
        return U0(vu(s));
      }
      function Vo(s, c, m) {
        var S = -1, I = s.length;
        c < 0 && (c = -c > I ? 0 : I + c), m = m > I ? I : m, m < 0 && (m += I), I = c > m ? 0 : m - c >>> 0, c >>>= 0;
        for (var T = te(I); ++S < I; )
          T[S] = s[S + c];
        return T;
      }
      function HP(s, c) {
        var m;
        return Xi(s, function(S, I, T) {
          return m = c(S, I, T), !m;
        }), !!m;
      }
      function F0(s, c, m) {
        var S = 0, I = s == null ? S : s.length;
        if (typeof c == "number" && c === c && I <= X) {
          for (; S < I; ) {
            var T = S + I >>> 1, F = s[T];
            F !== null && !po(F) && (m ? F <= c : F < c) ? S = T + 1 : I = T;
          }
          return I;
        }
        return up(s, c, to, m);
      }
      function up(s, c, m, S) {
        var I = 0, T = s == null ? 0 : s.length;
        if (T === 0)
          return 0;
        c = m(c);
        for (var F = c !== c, G = c === null, Y = po(c), Ce = c === n; I < T; ) {
          var be = D0((I + T) / 2), Se = m(s[be]), Fe = Se !== n, Ue = Se === null, ct = Se === Se, Tt = po(Se);
          if (F)
            var dt = S || ct;
          else
            Ce ? dt = ct && (S || Fe) : G ? dt = ct && Fe && (S || !Ue) : Y ? dt = ct && Fe && !Ue && (S || !Tt) : Ue || Tt ? dt = !1 : dt = S ? Se <= c : Se < c;
          dt ? I = be + 1 : T = be;
        }
        return Mr(T, ge);
      }
      function r6(s, c) {
        for (var m = -1, S = s.length, I = 0, T = []; ++m < S; ) {
          var F = s[m], G = c ? c(F) : F;
          if (!m || !ua(G, Y)) {
            var Y = G;
            T[I++] = F === 0 ? 0 : F;
          }
        }
        return T;
      }
      function o6(s) {
        return typeof s == "number" ? s : po(s) ? U : +s;
      }
      function mo(s) {
        if (typeof s == "string")
          return s;
        if (At(s))
          return Pn(s, mo) + "";
        if (po(s))
          return V7 ? V7.call(s) : "";
        var c = s + "";
        return c == "0" && 1 / s == -j ? "-0" : c;
      }
      function Yi(s, c, m) {
        var S = -1, I = v0, T = s.length, F = !0, G = [], Y = G;
        if (m)
          F = !1, I = Fm;
        else if (T >= o) {
          var Ce = c ? null : JP(s);
          if (Ce)
            return b0(Ce);
          F = !1, I = jc, Y = new js();
        } else
          Y = c ? [] : G;
        e:
          for (; ++S < T; ) {
            var be = s[S], Se = c ? c(be) : be;
            if (be = m || be !== 0 ? be : 0, F && Se === Se) {
              for (var Fe = Y.length; Fe--; )
                if (Y[Fe] === Se)
                  continue e;
              c && Y.push(Se), G.push(be);
            } else
              I(Y, Se, m) || (Y !== G && Y.push(Se), G.push(be));
          }
        return G;
      }
      function cp(s, c) {
        return c = qi(c, s), s = E6(s, c), s == null || delete s[Pa(Oo(c))];
      }
      function a6(s, c, m, S) {
        return e1(s, c, m(zs(s, c)), S);
      }
      function B0(s, c, m, S) {
        for (var I = s.length, T = S ? I : -1; (S ? T-- : ++T < I) && c(s[T], T, s); )
          ;
        return m ? Vo(s, S ? 0 : T, S ? T + 1 : I) : Vo(s, S ? T + 1 : 0, S ? I : T);
      }
      function i6(s, c) {
        var m = s;
        return m instanceof Ht && (m = m.value()), Bm(c, function(S, I) {
          return I.func.apply(I.thisArg, Wi([S], I.args));
        }, m);
      }
      function dp(s, c, m) {
        var S = s.length;
        if (S < 2)
          return S ? Yi(s[0]) : [];
        for (var I = -1, T = te(S); ++I < S; )
          for (var F = s[I], G = -1; ++G < S; )
            G != I && (T[I] = Jc(T[I] || F, s[G], c, m));
        return Yi(vr(T, 1), c, m);
      }
      function s6(s, c, m) {
        for (var S = -1, I = s.length, T = c.length, F = {}; ++S < I; ) {
          var G = S < T ? c[S] : n;
          m(F, s[S], G);
        }
        return F;
      }
      function fp(s) {
        return Un(s) ? s : [];
      }
      function hp(s) {
        return typeof s == "function" ? s : to;
      }
      function qi(s, c) {
        return At(s) ? s : Ap(s, c) ? [s] : V6(an(s));
      }
      var GP = kt;
      function Ji(s, c, m) {
        var S = s.length;
        return m = m === n ? S : m, !c && m >= S ? s : Vo(s, c, m);
      }
      var l6 = LD || function(s) {
        return xt.clearTimeout(s);
      };
      function u6(s, c) {
        if (c)
          return s.slice();
        var m = s.length, S = D7 ? D7(m) : new s.constructor(m);
        return s.copy(S), S;
      }
      function mp(s) {
        var c = new s.constructor(s.byteLength);
        return new w0(c).set(new w0(s)), c;
      }
      function $P(s, c) {
        var m = c ? mp(s.buffer) : s.buffer;
        return new s.constructor(m, s.byteOffset, s.byteLength);
      }
      function ZP(s) {
        var c = new s.constructor(s.source, It.exec(s));
        return c.lastIndex = s.lastIndex, c;
      }
      function jP(s) {
        return Yc ? bn(Yc.call(s)) : {};
      }
      function c6(s, c) {
        var m = c ? mp(s.buffer) : s.buffer;
        return new s.constructor(m, s.byteOffset, s.length);
      }
      function d6(s, c) {
        if (s !== c) {
          var m = s !== n, S = s === null, I = s === s, T = po(s), F = c !== n, G = c === null, Y = c === c, Ce = po(c);
          if (!G && !Ce && !T && s > c || T && F && Y && !G && !Ce || S && F && Y || !m && Y || !I)
            return 1;
          if (!S && !T && !Ce && s < c || Ce && m && I && !S && !T || G && m && I || !F && I || !Y)
            return -1;
        }
        return 0;
      }
      function WP(s, c, m) {
        for (var S = -1, I = s.criteria, T = c.criteria, F = I.length, G = m.length; ++S < F; ) {
          var Y = d6(I[S], T[S]);
          if (Y) {
            if (S >= G)
              return Y;
            var Ce = m[S];
            return Y * (Ce == "desc" ? -1 : 1);
          }
        }
        return s.index - c.index;
      }
      function f6(s, c, m, S) {
        for (var I = -1, T = s.length, F = m.length, G = -1, Y = c.length, Ce = ir(T - F, 0), be = te(Y + Ce), Se = !S; ++G < Y; )
          be[G] = c[G];
        for (; ++I < F; )
          (Se || I < T) && (be[m[I]] = s[I]);
        for (; Ce--; )
          be[G++] = s[I++];
        return be;
      }
      function h6(s, c, m, S) {
        for (var I = -1, T = s.length, F = -1, G = m.length, Y = -1, Ce = c.length, be = ir(T - G, 0), Se = te(be + Ce), Fe = !S; ++I < be; )
          Se[I] = s[I];
        for (var Ue = I; ++Y < Ce; )
          Se[Ue + Y] = c[Y];
        for (; ++F < G; )
          (Fe || I < T) && (Se[Ue + m[F]] = s[I++]);
        return Se;
      }
      function Kr(s, c) {
        var m = -1, S = s.length;
        for (c || (c = te(S)); ++m < S; )
          c[m] = s[m];
        return c;
      }
      function Da(s, c, m, S) {
        var I = !m;
        m || (m = {});
        for (var T = -1, F = c.length; ++T < F; ) {
          var G = c[T], Y = S ? S(m[G], s[G], G, m, s) : n;
          Y === n && (Y = s[G]), I ? Qa(m, G, Y) : qc(m, G, Y);
        }
        return m;
      }
      function zP(s, c) {
        return Da(s, Sp(s), c);
      }
      function UP(s, c) {
        return Da(s, _6(s), c);
      }
      function H0(s, c) {
        return function(m, S) {
          var I = At(m) ? KR : pP, T = c ? c() : {};
          return I(m, s, it(S, 2), T);
        };
      }
      function hu(s) {
        return kt(function(c, m) {
          var S = -1, I = m.length, T = I > 1 ? m[I - 1] : n, F = I > 2 ? m[2] : n;
          for (T = s.length > 3 && typeof T == "function" ? (I--, T) : n, F && kr(m[0], m[1], F) && (T = I < 3 ? n : T, I = 1), c = bn(c); ++S < I; ) {
            var G = m[S];
            G && s(c, G, S, T);
          }
          return c;
        });
      }
      function m6(s, c) {
        return function(m, S) {
          if (m == null)
            return m;
          if (!Qr(m))
            return s(m, S);
          for (var I = m.length, T = c ? I : -1, F = bn(m); (c ? T-- : ++T < I) && S(F[T], T, F) !== !1; )
            ;
          return m;
        };
      }
      function p6(s) {
        return function(c, m, S) {
          for (var I = -1, T = bn(c), F = S(c), G = F.length; G--; ) {
            var Y = F[s ? G : ++I];
            if (m(T[Y], Y, T) === !1)
              break;
          }
          return c;
        };
      }
      function XP(s, c, m) {
        var S = c & y, I = t1(s);
        function T() {
          var F = this && this !== xt && this instanceof T ? I : s;
          return F.apply(S ? m : this, arguments);
        }
        return T;
      }
      function g6(s) {
        return function(c) {
          c = an(c);
          var m = iu(c) ? sa(c) : n, S = m ? m[0] : c.charAt(0), I = m ? Ji(m, 1).join("") : c.slice(1);
          return S[s]() + I;
        };
      }
      function mu(s) {
        return function(c) {
          return Bm(mv(hv(c).replace($c, "")), s, "");
        };
      }
      function t1(s) {
        return function() {
          var c = arguments;
          switch (c.length) {
            case 0:
              return new s();
            case 1:
              return new s(c[0]);
            case 2:
              return new s(c[0], c[1]);
            case 3:
              return new s(c[0], c[1], c[2]);
            case 4:
              return new s(c[0], c[1], c[2], c[3]);
            case 5:
              return new s(c[0], c[1], c[2], c[3], c[4]);
            case 6:
              return new s(c[0], c[1], c[2], c[3], c[4], c[5]);
            case 7:
              return new s(c[0], c[1], c[2], c[3], c[4], c[5], c[6]);
          }
          var m = fu(s.prototype), S = s.apply(m, c);
          return kn(S) ? S : m;
        };
      }
      function YP(s, c, m) {
        var S = t1(s);
        function I() {
          for (var T = arguments.length, F = te(T), G = T, Y = pu(I); G--; )
            F[G] = arguments[G];
          var Ce = T < 3 && F[0] !== Y && F[T - 1] !== Y ? [] : zi(F, Y);
          if (T -= Ce.length, T < m)
            return S6(
              s,
              c,
              G0,
              I.placeholder,
              n,
              F,
              Ce,
              n,
              n,
              m - T
            );
          var be = this && this !== xt && this instanceof I ? S : s;
          return fo(be, this, F);
        }
        return I;
      }
      function v6(s) {
        return function(c, m, S) {
          var I = bn(c);
          if (!Qr(c)) {
            var T = it(m, 3);
            c = mr(c), m = function(G) {
              return T(I[G], G, I);
            };
          }
          var F = s(c, m, S);
          return F > -1 ? I[T ? c[F] : F] : n;
        };
      }
      function C6(s) {
        return ti(function(c) {
          var m = c.length, S = m, I = No.prototype.thru;
          for (s && c.reverse(); S--; ) {
            var T = c[S];
            if (typeof T != "function")
              throw new To(i);
            if (I && !F && W0(T) == "wrapper")
              var F = new No([], !0);
          }
          for (S = F ? S : m; ++S < m; ) {
            T = c[S];
            var G = W0(T), Y = G == "wrapper" ? bp(T) : n;
            Y && Mp(Y[0]) && Y[1] == (P | _ | R | N) && !Y[4].length && Y[9] == 1 ? F = F[W0(Y[0])].apply(F, Y[3]) : F = T.length == 1 && Mp(T) ? F[G]() : F.thru(T);
          }
          return function() {
            var Ce = arguments, be = Ce[0];
            if (F && Ce.length == 1 && At(be))
              return F.plant(be).value();
            for (var Se = 0, Fe = m ? c[Se].apply(this, Ce) : be; ++Se < m; )
              Fe = c[Se].call(this, Fe);
            return Fe;
          };
        });
      }
      function G0(s, c, m, S, I, T, F, G, Y, Ce) {
        var be = c & P, Se = c & y, Fe = c & M, Ue = c & (_ | L), ct = c & O, Tt = Fe ? n : t1(s);
        function dt() {
          for (var Ft = arguments.length, Wt = te(Ft), go = Ft; go--; )
            Wt[go] = arguments[go];
          if (Ue)
            var Vr = pu(dt), vo = sD(Wt, Vr);
          if (S && (Wt = f6(Wt, S, I, Ue)), T && (Wt = h6(Wt, T, F, Ue)), Ft -= vo, Ue && Ft < Ce) {
            var Xn = zi(Wt, Vr);
            return S6(
              s,
              c,
              G0,
              dt.placeholder,
              m,
              Wt,
              Xn,
              G,
              Y,
              Ce - Ft
            );
          }
          var ca = Se ? m : this, ai = Fe ? ca[s] : s;
          return Ft = Wt.length, G ? Wt = pE(Wt, G) : ct && Ft > 1 && Wt.reverse(), be && Y < Ft && (Wt.length = Y), this && this !== xt && this instanceof dt && (ai = Tt || t1(ai)), ai.apply(ca, Wt);
        }
        return dt;
      }
      function b6(s, c) {
        return function(m, S) {
          return MP(m, s, c(S), {});
        };
      }
      function $0(s, c) {
        return function(m, S) {
          var I;
          if (m === n && S === n)
            return c;
          if (m !== n && (I = m), S !== n) {
            if (I === n)
              return S;
            typeof m == "string" || typeof S == "string" ? (m = mo(m), S = mo(S)) : (m = o6(m), S = o6(S)), I = s(m, S);
          }
          return I;
        };
      }
      function pp(s) {
        return ti(function(c) {
          return c = Pn(c, ho(it())), kt(function(m) {
            var S = this;
            return s(c, function(I) {
              return fo(I, S, m);
            });
          });
        });
      }
      function Z0(s, c) {
        c = c === n ? " " : mo(c);
        var m = c.length;
        if (m < 2)
          return m ? lp(c, s) : c;
        var S = lp(c, R0(s / su(c)));
        return iu(c) ? Ji(sa(S), 0, s).join("") : S.slice(0, s);
      }
      function qP(s, c, m, S) {
        var I = c & y, T = t1(s);
        function F() {
          for (var G = -1, Y = arguments.length, Ce = -1, be = S.length, Se = te(be + Y), Fe = this && this !== xt && this instanceof F ? T : s; ++Ce < be; )
            Se[Ce] = S[Ce];
          for (; Y--; )
            Se[Ce++] = arguments[++G];
          return fo(Fe, I ? m : this, Se);
        }
        return F;
      }
      function y6(s) {
        return function(c, m, S) {
          return S && typeof S != "number" && kr(c, m, S) && (m = S = n), c = oi(c), m === n ? (m = c, c = 0) : m = oi(m), S = S === n ? c < m ? 1 : -1 : oi(S), kP(c, m, S, s);
        };
      }
      function j0(s) {
        return function(c, m) {
          return typeof c == "string" && typeof m == "string" || (c = Fo(c), m = Fo(m)), s(c, m);
        };
      }
      function S6(s, c, m, S, I, T, F, G, Y, Ce) {
        var be = c & _, Se = be ? F : n, Fe = be ? n : F, Ue = be ? T : n, ct = be ? n : T;
        c |= be ? R : k, c &= ~(be ? k : R), c & x || (c &= ~(y | M));
        var Tt = [
          s,
          c,
          I,
          Ue,
          Se,
          ct,
          Fe,
          G,
          Y,
          Ce
        ], dt = m.apply(n, Tt);
        return Mp(s) && T6(dt, Tt), dt.placeholder = S, N6(dt, s, c);
      }
      function gp(s) {
        var c = ar[s];
        return function(m, S) {
          if (m = Fo(m), S = S == null ? 0 : Mr(Lt(S), 292), S && N7(m)) {
            var I = (an(m) + "e").split("e"), T = c(I[0] + "e" + (+I[1] + S));
            return I = (an(T) + "e").split("e"), +(I[0] + "e" + (+I[1] - S));
          }
          return c(m);
        };
      }
      var JP = cu && 1 / b0(new cu([, -0]))[1] == j ? function(s) {
        return new cu(s);
      } : Fp;
      function A6(s) {
        return function(c) {
          var m = xr(c);
          return m == Re ? zm(c) : m == jt ? mD(c) : iD(c, s(c));
        };
      }
      function ei(s, c, m, S, I, T, F, G) {
        var Y = c & M;
        if (!Y && typeof s != "function")
          throw new To(i);
        var Ce = S ? S.length : 0;
        if (Ce || (c &= ~(R | k), S = I = n), F = F === n ? F : ir(Lt(F), 0), G = G === n ? G : Lt(G), Ce -= I ? I.length : 0, c & k) {
          var be = S, Se = I;
          S = I = n;
        }
        var Fe = Y ? n : bp(s), Ue = [
          s,
          c,
          m,
          S,
          I,
          be,
          Se,
          T,
          F,
          G
        ];
        if (Fe && fE(Ue, Fe), s = Ue[0], c = Ue[1], m = Ue[2], S = Ue[3], I = Ue[4], G = Ue[9] = Ue[9] === n ? Y ? 0 : s.length : ir(Ue[9] - Ce, 0), !G && c & (_ | L) && (c &= ~(_ | L)), !c || c == y)
          var ct = XP(s, c, m);
        else
          c == _ || c == L ? ct = YP(s, c, G) : (c == R || c == (y | R)) && !I.length ? ct = qP(s, c, m, S) : ct = G0.apply(n, Ue);
        var Tt = Fe ? n6 : T6;
        return N6(Tt(ct, Ue), s, c);
      }
      function M6(s, c, m, S) {
        return s === n || ua(s, uu[m]) && !cn.call(S, m) ? c : s;
      }
      function x6(s, c, m, S, I, T) {
        return kn(s) && kn(c) && (T.set(c, s), O0(s, c, n, x6, T), T.delete(c)), s;
      }
      function KP(s) {
        return o1(s) ? n : s;
      }
      function w6(s, c, m, S, I, T) {
        var F = m & C, G = s.length, Y = c.length;
        if (G != Y && !(F && Y > G))
          return !1;
        var Ce = T.get(s), be = T.get(c);
        if (Ce && be)
          return Ce == c && be == s;
        var Se = -1, Fe = !0, Ue = m & v ? new js() : n;
        for (T.set(s, c), T.set(c, s); ++Se < G; ) {
          var ct = s[Se], Tt = c[Se];
          if (S)
            var dt = F ? S(Tt, ct, Se, c, s, T) : S(ct, Tt, Se, s, c, T);
          if (dt !== n) {
            if (dt)
              continue;
            Fe = !1;
            break;
          }
          if (Ue) {
            if (!Hm(c, function(Ft, Wt) {
              if (!jc(Ue, Wt) && (ct === Ft || I(ct, Ft, m, S, T)))
                return Ue.push(Wt);
            })) {
              Fe = !1;
              break;
            }
          } else if (!(ct === Tt || I(ct, Tt, m, S, T))) {
            Fe = !1;
            break;
          }
        }
        return T.delete(s), T.delete(c), Fe;
      }
      function QP(s, c, m, S, I, T, F) {
        switch (m) {
          case De:
            if (s.byteLength != c.byteLength || s.byteOffset != c.byteOffset)
              return !1;
            s = s.buffer, c = c.buffer;
          case fr:
            return !(s.byteLength != c.byteLength || !T(new w0(s), new w0(c)));
          case Ie:
          case Ne:
          case _t:
            return ua(+s, +c);
          case ke:
            return s.name == c.name && s.message == c.message;
          case yt:
          case An:
            return s == c + "";
          case Re:
            var G = zm;
          case jt:
            var Y = S & C;
            if (G || (G = b0), s.size != c.size && !Y)
              return !1;
            var Ce = F.get(s);
            if (Ce)
              return Ce == c;
            S |= v, F.set(s, c);
            var be = w6(G(s), G(c), S, I, T, F);
            return F.delete(s), be;
          case Rn:
            if (Yc)
              return Yc.call(s) == Yc.call(c);
        }
        return !1;
      }
      function eE(s, c, m, S, I, T) {
        var F = m & C, G = vp(s), Y = G.length, Ce = vp(c), be = Ce.length;
        if (Y != be && !F)
          return !1;
        for (var Se = Y; Se--; ) {
          var Fe = G[Se];
          if (!(F ? Fe in c : cn.call(c, Fe)))
            return !1;
        }
        var Ue = T.get(s), ct = T.get(c);
        if (Ue && ct)
          return Ue == c && ct == s;
        var Tt = !0;
        T.set(s, c), T.set(c, s);
        for (var dt = F; ++Se < Y; ) {
          Fe = G[Se];
          var Ft = s[Fe], Wt = c[Fe];
          if (S)
            var go = F ? S(Wt, Ft, Fe, c, s, T) : S(Ft, Wt, Fe, s, c, T);
          if (!(go === n ? Ft === Wt || I(Ft, Wt, m, S, T) : go)) {
            Tt = !1;
            break;
          }
          dt || (dt = Fe == "constructor");
        }
        if (Tt && !dt) {
          var Vr = s.constructor, vo = c.constructor;
          Vr != vo && "constructor" in s && "constructor" in c && !(typeof Vr == "function" && Vr instanceof Vr && typeof vo == "function" && vo instanceof vo) && (Tt = !1);
        }
        return T.delete(s), T.delete(c), Tt;
      }
      function ti(s) {
        return wp(P6(s, n, H6), s + "");
      }
      function vp(s) {
        return W7(s, mr, Sp);
      }
      function Cp(s) {
        return W7(s, eo, _6);
      }
      var bp = P0 ? function(s) {
        return P0.get(s);
      } : Fp;
      function W0(s) {
        for (var c = s.name + "", m = du[c], S = cn.call(du, c) ? m.length : 0; S--; ) {
          var I = m[S], T = I.func;
          if (T == null || T == s)
            return I.name;
        }
        return c;
      }
      function pu(s) {
        var c = cn.call(E, "placeholder") ? E : s;
        return c.placeholder;
      }
      function it() {
        var s = E.iteratee || Vp;
        return s = s === Vp ? X7 : s, arguments.length ? s(arguments[0], arguments[1]) : s;
      }
      function z0(s, c) {
        var m = s.__data__;
        return lE(c) ? m[typeof c == "string" ? "string" : "hash"] : m.map;
      }
      function yp(s) {
        for (var c = mr(s), m = c.length; m--; ) {
          var S = c[m], I = s[S];
          c[m] = [S, I, R6(I)];
        }
        return c;
      }
      function Us(s, c) {
        var m = dD(s, c);
        return U7(m) ? m : n;
      }
      function tE(s) {
        var c = cn.call(s, $s), m = s[$s];
        try {
          s[$s] = n;
          var S = !0;
        } catch {
        }
        var I = M0.call(s);
        return S && (c ? s[$s] = m : delete s[$s]), I;
      }
      var Sp = Xm ? function(s) {
        return s == null ? [] : (s = bn(s), ji(Xm(s), function(c) {
          return E7.call(s, c);
        }));
      } : Bp, _6 = Xm ? function(s) {
        for (var c = []; s; )
          Wi(c, Sp(s)), s = _0(s);
        return c;
      } : Bp, xr = Nr;
      (Ym && xr(new Ym(new ArrayBuffer(1))) != De || zc && xr(new zc()) != Re || qm && xr(qm.resolve()) != Zt || cu && xr(new cu()) != jt || Uc && xr(new Uc()) != Ar) && (xr = function(s) {
        var c = Nr(s), m = c == $e ? s.constructor : n, S = m ? Xs(m) : "";
        if (S)
          switch (S) {
            case OD:
              return De;
            case FD:
              return Re;
            case BD:
              return Zt;
            case HD:
              return jt;
            case GD:
              return Ar;
          }
        return c;
      });
      function nE(s, c, m) {
        for (var S = -1, I = m.length; ++S < I; ) {
          var T = m[S], F = T.size;
          switch (T.type) {
            case "drop":
              s += F;
              break;
            case "dropRight":
              c -= F;
              break;
            case "take":
              c = Mr(c, s + F);
              break;
            case "takeRight":
              s = ir(s, c - F);
              break;
          }
        }
        return { start: s, end: c };
      }
      function rE(s) {
        var c = s.match(Ia);
        return c ? c[1].split(kc) : [];
      }
      function I6(s, c, m) {
        c = qi(c, s);
        for (var S = -1, I = c.length, T = !1; ++S < I; ) {
          var F = Pa(c[S]);
          if (!(T = s != null && m(s, F)))
            break;
          s = s[F];
        }
        return T || ++S != I ? T : (I = s == null ? 0 : s.length, !!I && Q0(I) && ni(F, I) && (At(s) || Ys(s)));
      }
      function oE(s) {
        var c = s.length, m = new s.constructor(c);
        return c && typeof s[0] == "string" && cn.call(s, "index") && (m.index = s.index, m.input = s.input), m;
      }
      function L6(s) {
        return typeof s.constructor == "function" && !n1(s) ? fu(_0(s)) : {};
      }
      function aE(s, c, m) {
        var S = s.constructor;
        switch (c) {
          case fr:
            return mp(s);
          case Ie:
          case Ne:
            return new S(+s);
          case De:
            return $P(s, m);
          case Xt:
          case Nn:
          case Kn:
          case Jr:
          case aa:
          case ks:
          case Vs:
          case uo:
          case _a:
            return c6(s, m);
          case Re:
            return new S();
          case _t:
          case An:
            return new S(s);
          case yt:
            return ZP(s);
          case jt:
            return new S();
          case Rn:
            return jP(s);
        }
      }
      function iE(s, c) {
        var m = c.length;
        if (!m)
          return s;
        var S = m - 1;
        return c[S] = (m > 1 ? "& " : "") + c[S], c = c.join(m > 2 ? ", " : " "), s.replace(Nc, `{
/* [wrapped with ` + c + `] */
`);
      }
      function sE(s) {
        return At(s) || Ys(s) || !!(T7 && s && s[T7]);
      }
      function ni(s, c) {
        var m = typeof s;
        return c = c ?? K, !!c && (m == "number" || m != "symbol" && xn.test(s)) && s > -1 && s % 1 == 0 && s < c;
      }
      function kr(s, c, m) {
        if (!kn(m))
          return !1;
        var S = typeof c;
        return (S == "number" ? Qr(m) && ni(c, m.length) : S == "string" && c in m) ? ua(m[c], s) : !1;
      }
      function Ap(s, c) {
        if (At(s))
          return !1;
        var m = typeof s;
        return m == "number" || m == "symbol" || m == "boolean" || s == null || po(s) ? !0 : Yl.test(s) || !Xl.test(s) || c != null && s in bn(c);
      }
      function lE(s) {
        var c = typeof s;
        return c == "string" || c == "number" || c == "symbol" || c == "boolean" ? s !== "__proto__" : s === null;
      }
      function Mp(s) {
        var c = W0(s), m = E[c];
        if (typeof m != "function" || !(c in Ht.prototype))
          return !1;
        if (s === m)
          return !0;
        var S = bp(m);
        return !!S && s === S[0];
      }
      function uE(s) {
        return !!R7 && R7 in s;
      }
      var cE = S0 ? ri : Hp;
      function n1(s) {
        var c = s && s.constructor, m = typeof c == "function" && c.prototype || uu;
        return s === m;
      }
      function R6(s) {
        return s === s && !kn(s);
      }
      function D6(s, c) {
        return function(m) {
          return m == null ? !1 : m[s] === c && (c !== n || s in bn(m));
        };
      }
      function dE(s) {
        var c = J0(s, function(S) {
          return m.size === d && m.clear(), S;
        }), m = c.cache;
        return c;
      }
      function fE(s, c) {
        var m = s[1], S = c[1], I = m | S, T = I < (y | M | P), F = S == P && m == _ || S == P && m == N && s[7].length <= c[8] || S == (P | N) && c[7].length <= c[8] && m == _;
        if (!(T || F))
          return s;
        S & y && (s[2] = c[2], I |= m & y ? 0 : x);
        var G = c[3];
        if (G) {
          var Y = s[3];
          s[3] = Y ? f6(Y, G, c[4]) : G, s[4] = Y ? zi(s[3], f) : c[4];
        }
        return G = c[5], G && (Y = s[5], s[5] = Y ? h6(Y, G, c[6]) : G, s[6] = Y ? zi(s[5], f) : c[6]), G = c[7], G && (s[7] = G), S & P && (s[8] = s[8] == null ? c[8] : Mr(s[8], c[8])), s[9] == null && (s[9] = c[9]), s[0] = c[0], s[1] = I, s;
      }
      function hE(s) {
        var c = [];
        if (s != null)
          for (var m in bn(s))
            c.push(m);
        return c;
      }
      function mE(s) {
        return M0.call(s);
      }
      function P6(s, c, m) {
        return c = ir(c === n ? s.length - 1 : c, 0), function() {
          for (var S = arguments, I = -1, T = ir(S.length - c, 0), F = te(T); ++I < T; )
            F[I] = S[c + I];
          I = -1;
          for (var G = te(c + 1); ++I < c; )
            G[I] = S[I];
          return G[c] = m(F), fo(s, this, G);
        };
      }
      function E6(s, c) {
        return c.length < 2 ? s : zs(s, Vo(c, 0, -1));
      }
      function pE(s, c) {
        for (var m = s.length, S = Mr(c.length, m), I = Kr(s); S--; ) {
          var T = c[S];
          s[S] = ni(T, m) ? I[T] : n;
        }
        return s;
      }
      function xp(s, c) {
        if (!(c === "constructor" && typeof s[c] == "function") && c != "__proto__")
          return s[c];
      }
      var T6 = k6(n6), r1 = DD || function(s, c) {
        return xt.setTimeout(s, c);
      }, wp = k6(FP);
      function N6(s, c, m) {
        var S = c + "";
        return wp(s, iE(S, gE(rE(S), m)));
      }
      function k6(s) {
        var c = 0, m = 0;
        return function() {
          var S = ND(), I = ie - (S - m);
          if (m = S, I > 0) {
            if (++c >= ne)
              return arguments[0];
          } else
            c = 0;
          return s.apply(n, arguments);
        };
      }
      function U0(s, c) {
        var m = -1, S = s.length, I = S - 1;
        for (c = c === n ? S : c; ++m < c; ) {
          var T = sp(m, I), F = s[T];
          s[T] = s[m], s[m] = F;
        }
        return s.length = c, s;
      }
      var V6 = dE(function(s) {
        var c = [];
        return s.charCodeAt(0) === 46 && c.push(""), s.replace(co, function(m, S, I, T) {
          c.push(I ? T.replace(Oe, "$1") : S || m);
        }), c;
      });
      function Pa(s) {
        if (typeof s == "string" || po(s))
          return s;
        var c = s + "";
        return c == "0" && 1 / s == -j ? "-0" : c;
      }
      function Xs(s) {
        if (s != null) {
          try {
            return A0.call(s);
          } catch {
          }
          try {
            return s + "";
          } catch {
          }
        }
        return "";
      }
      function gE(s, c) {
        return Eo(he, function(m) {
          var S = "_." + m[0];
          c & m[1] && !v0(s, S) && s.push(S);
        }), s.sort();
      }
      function O6(s) {
        if (s instanceof Ht)
          return s.clone();
        var c = new No(s.__wrapped__, s.__chain__);
        return c.__actions__ = Kr(s.__actions__), c.__index__ = s.__index__, c.__values__ = s.__values__, c;
      }
      function vE(s, c, m) {
        (m ? kr(s, c, m) : c === n) ? c = 1 : c = ir(Lt(c), 0);
        var S = s == null ? 0 : s.length;
        if (!S || c < 1)
          return [];
        for (var I = 0, T = 0, F = te(R0(S / c)); I < S; )
          F[T++] = Vo(s, I, I += c);
        return F;
      }
      function CE(s) {
        for (var c = -1, m = s == null ? 0 : s.length, S = 0, I = []; ++c < m; ) {
          var T = s[c];
          T && (I[S++] = T);
        }
        return I;
      }
      function bE() {
        var s = arguments.length;
        if (!s)
          return [];
        for (var c = te(s - 1), m = arguments[0], S = s; S--; )
          c[S - 1] = arguments[S];
        return Wi(At(m) ? Kr(m) : [m], vr(c, 1));
      }
      var yE = kt(function(s, c) {
        return Un(s) ? Jc(s, vr(c, 1, Un, !0)) : [];
      }), SE = kt(function(s, c) {
        var m = Oo(c);
        return Un(m) && (m = n), Un(s) ? Jc(s, vr(c, 1, Un, !0), it(m, 2)) : [];
      }), AE = kt(function(s, c) {
        var m = Oo(c);
        return Un(m) && (m = n), Un(s) ? Jc(s, vr(c, 1, Un, !0), n, m) : [];
      });
      function ME(s, c, m) {
        var S = s == null ? 0 : s.length;
        return S ? (c = m || c === n ? 1 : Lt(c), Vo(s, c < 0 ? 0 : c, S)) : [];
      }
      function xE(s, c, m) {
        var S = s == null ? 0 : s.length;
        return S ? (c = m || c === n ? 1 : Lt(c), c = S - c, Vo(s, 0, c < 0 ? 0 : c)) : [];
      }
      function wE(s, c) {
        return s && s.length ? B0(s, it(c, 3), !0, !0) : [];
      }
      function _E(s, c) {
        return s && s.length ? B0(s, it(c, 3), !0) : [];
      }
      function IE(s, c, m, S) {
        var I = s == null ? 0 : s.length;
        return I ? (m && typeof m != "number" && kr(s, c, m) && (m = 0, S = I), bP(s, c, m, S)) : [];
      }
      function F6(s, c, m) {
        var S = s == null ? 0 : s.length;
        if (!S)
          return -1;
        var I = m == null ? 0 : Lt(m);
        return I < 0 && (I = ir(S + I, 0)), C0(s, it(c, 3), I);
      }
      function B6(s, c, m) {
        var S = s == null ? 0 : s.length;
        if (!S)
          return -1;
        var I = S - 1;
        return m !== n && (I = Lt(m), I = m < 0 ? ir(S + I, 0) : Mr(I, S - 1)), C0(s, it(c, 3), I, !0);
      }
      function H6(s) {
        var c = s == null ? 0 : s.length;
        return c ? vr(s, 1) : [];
      }
      function LE(s) {
        var c = s == null ? 0 : s.length;
        return c ? vr(s, j) : [];
      }
      function RE(s, c) {
        var m = s == null ? 0 : s.length;
        return m ? (c = c === n ? 1 : Lt(c), vr(s, c)) : [];
      }
      function DE(s) {
        for (var c = -1, m = s == null ? 0 : s.length, S = {}; ++c < m; ) {
          var I = s[c];
          S[I[0]] = I[1];
        }
        return S;
      }
      function G6(s) {
        return s && s.length ? s[0] : n;
      }
      function PE(s, c, m) {
        var S = s == null ? 0 : s.length;
        if (!S)
          return -1;
        var I = m == null ? 0 : Lt(m);
        return I < 0 && (I = ir(S + I, 0)), au(s, c, I);
      }
      function EE(s) {
        var c = s == null ? 0 : s.length;
        return c ? Vo(s, 0, -1) : [];
      }
      var TE = kt(function(s) {
        var c = Pn(s, fp);
        return c.length && c[0] === s[0] ? np(c) : [];
      }), NE = kt(function(s) {
        var c = Oo(s), m = Pn(s, fp);
        return c === Oo(m) ? c = n : m.pop(), m.length && m[0] === s[0] ? np(m, it(c, 2)) : [];
      }), kE = kt(function(s) {
        var c = Oo(s), m = Pn(s, fp);
        return c = typeof c == "function" ? c : n, c && m.pop(), m.length && m[0] === s[0] ? np(m, n, c) : [];
      });
      function VE(s, c) {
        return s == null ? "" : ED.call(s, c);
      }
      function Oo(s) {
        var c = s == null ? 0 : s.length;
        return c ? s[c - 1] : n;
      }
      function OE(s, c, m) {
        var S = s == null ? 0 : s.length;
        if (!S)
          return -1;
        var I = S;
        return m !== n && (I = Lt(m), I = I < 0 ? ir(S + I, 0) : Mr(I, S - 1)), c === c ? gD(s, c, I) : C0(s, S7, I, !0);
      }
      function FE(s, c) {
        return s && s.length ? K7(s, Lt(c)) : n;
      }
      var BE = kt($6);
      function $6(s, c) {
        return s && s.length && c && c.length ? ip(s, c) : s;
      }
      function HE(s, c, m) {
        return s && s.length && c && c.length ? ip(s, c, it(m, 2)) : s;
      }
      function GE(s, c, m) {
        return s && s.length && c && c.length ? ip(s, c, n, m) : s;
      }
      var $E = ti(function(s, c) {
        var m = s == null ? 0 : s.length, S = Km(s, c);
        return t6(s, Pn(c, function(I) {
          return ni(I, m) ? +I : I;
        }).sort(d6)), S;
      });
      function ZE(s, c) {
        var m = [];
        if (!(s && s.length))
          return m;
        var S = -1, I = [], T = s.length;
        for (c = it(c, 3); ++S < T; ) {
          var F = s[S];
          c(F, S, s) && (m.push(F), I.push(S));
        }
        return t6(s, I), m;
      }
      function _p(s) {
        return s == null ? s : VD.call(s);
      }
      function jE(s, c, m) {
        var S = s == null ? 0 : s.length;
        return S ? (m && typeof m != "number" && kr(s, c, m) ? (c = 0, m = S) : (c = c == null ? 0 : Lt(c), m = m === n ? S : Lt(m)), Vo(s, c, m)) : [];
      }
      function WE(s, c) {
        return F0(s, c);
      }
      function zE(s, c, m) {
        return up(s, c, it(m, 2));
      }
      function UE(s, c) {
        var m = s == null ? 0 : s.length;
        if (m) {
          var S = F0(s, c);
          if (S < m && ua(s[S], c))
            return S;
        }
        return -1;
      }
      function XE(s, c) {
        return F0(s, c, !0);
      }
      function YE(s, c, m) {
        return up(s, c, it(m, 2), !0);
      }
      function qE(s, c) {
        var m = s == null ? 0 : s.length;
        if (m) {
          var S = F0(s, c, !0) - 1;
          if (ua(s[S], c))
            return S;
        }
        return -1;
      }
      function JE(s) {
        return s && s.length ? r6(s) : [];
      }
      function KE(s, c) {
        return s && s.length ? r6(s, it(c, 2)) : [];
      }
      function QE(s) {
        var c = s == null ? 0 : s.length;
        return c ? Vo(s, 1, c) : [];
      }
      function eT(s, c, m) {
        return s && s.length ? (c = m || c === n ? 1 : Lt(c), Vo(s, 0, c < 0 ? 0 : c)) : [];
      }
      function tT(s, c, m) {
        var S = s == null ? 0 : s.length;
        return S ? (c = m || c === n ? 1 : Lt(c), c = S - c, Vo(s, c < 0 ? 0 : c, S)) : [];
      }
      function nT(s, c) {
        return s && s.length ? B0(s, it(c, 3), !1, !0) : [];
      }
      function rT(s, c) {
        return s && s.length ? B0(s, it(c, 3)) : [];
      }
      var oT = kt(function(s) {
        return Yi(vr(s, 1, Un, !0));
      }), aT = kt(function(s) {
        var c = Oo(s);
        return Un(c) && (c = n), Yi(vr(s, 1, Un, !0), it(c, 2));
      }), iT = kt(function(s) {
        var c = Oo(s);
        return c = typeof c == "function" ? c : n, Yi(vr(s, 1, Un, !0), n, c);
      });
      function sT(s) {
        return s && s.length ? Yi(s) : [];
      }
      function lT(s, c) {
        return s && s.length ? Yi(s, it(c, 2)) : [];
      }
      function uT(s, c) {
        return c = typeof c == "function" ? c : n, s && s.length ? Yi(s, n, c) : [];
      }
      function Ip(s) {
        if (!(s && s.length))
          return [];
        var c = 0;
        return s = ji(s, function(m) {
          if (Un(m))
            return c = ir(m.length, c), !0;
        }), jm(c, function(m) {
          return Pn(s, Gm(m));
        });
      }
      function Z6(s, c) {
        if (!(s && s.length))
          return [];
        var m = Ip(s);
        return c == null ? m : Pn(m, function(S) {
          return fo(c, n, S);
        });
      }
      var cT = kt(function(s, c) {
        return Un(s) ? Jc(s, c) : [];
      }), dT = kt(function(s) {
        return dp(ji(s, Un));
      }), fT = kt(function(s) {
        var c = Oo(s);
        return Un(c) && (c = n), dp(ji(s, Un), it(c, 2));
      }), hT = kt(function(s) {
        var c = Oo(s);
        return c = typeof c == "function" ? c : n, dp(ji(s, Un), n, c);
      }), mT = kt(Ip);
      function pT(s, c) {
        return s6(s || [], c || [], qc);
      }
      function gT(s, c) {
        return s6(s || [], c || [], e1);
      }
      var vT = kt(function(s) {
        var c = s.length, m = c > 1 ? s[c - 1] : n;
        return m = typeof m == "function" ? (s.pop(), m) : n, Z6(s, m);
      });
      function j6(s) {
        var c = E(s);
        return c.__chain__ = !0, c;
      }
      function CT(s, c) {
        return c(s), s;
      }
      function X0(s, c) {
        return c(s);
      }
      var bT = ti(function(s) {
        var c = s.length, m = c ? s[0] : 0, S = this.__wrapped__, I = function(T) {
          return Km(T, s);
        };
        return c > 1 || this.__actions__.length || !(S instanceof Ht) || !ni(m) ? this.thru(I) : (S = S.slice(m, +m + (c ? 1 : 0)), S.__actions__.push({
          func: X0,
          args: [I],
          thisArg: n
        }), new No(S, this.__chain__).thru(function(T) {
          return c && !T.length && T.push(n), T;
        }));
      });
      function yT() {
        return j6(this);
      }
      function ST() {
        return new No(this.value(), this.__chain__);
      }
      function AT() {
        this.__values__ === n && (this.__values__ = ov(this.value()));
        var s = this.__index__ >= this.__values__.length, c = s ? n : this.__values__[this.__index__++];
        return { done: s, value: c };
      }
      function MT() {
        return this;
      }
      function xT(s) {
        for (var c, m = this; m instanceof T0; ) {
          var S = O6(m);
          S.__index__ = 0, S.__values__ = n, c ? I.__wrapped__ = S : c = S;
          var I = S;
          m = m.__wrapped__;
        }
        return I.__wrapped__ = s, c;
      }
      function wT() {
        var s = this.__wrapped__;
        if (s instanceof Ht) {
          var c = s;
          return this.__actions__.length && (c = new Ht(this)), c = c.reverse(), c.__actions__.push({
            func: X0,
            args: [_p],
            thisArg: n
          }), new No(c, this.__chain__);
        }
        return this.thru(_p);
      }
      function _T() {
        return i6(this.__wrapped__, this.__actions__);
      }
      var IT = H0(function(s, c, m) {
        cn.call(s, m) ? ++s[m] : Qa(s, m, 1);
      });
      function LT(s, c, m) {
        var S = At(s) ? b7 : CP;
        return m && kr(s, c, m) && (c = n), S(s, it(c, 3));
      }
      function RT(s, c) {
        var m = At(s) ? ji : Z7;
        return m(s, it(c, 3));
      }
      var DT = v6(F6), PT = v6(B6);
      function ET(s, c) {
        return vr(Y0(s, c), 1);
      }
      function TT(s, c) {
        return vr(Y0(s, c), j);
      }
      function NT(s, c, m) {
        return m = m === n ? 1 : Lt(m), vr(Y0(s, c), m);
      }
      function W6(s, c) {
        var m = At(s) ? Eo : Xi;
        return m(s, it(c, 3));
      }
      function z6(s, c) {
        var m = At(s) ? QR : $7;
        return m(s, it(c, 3));
      }
      var kT = H0(function(s, c, m) {
        cn.call(s, m) ? s[m].push(c) : Qa(s, m, [c]);
      });
      function VT(s, c, m, S) {
        s = Qr(s) ? s : vu(s), m = m && !S ? Lt(m) : 0;
        var I = s.length;
        return m < 0 && (m = ir(I + m, 0)), ef(s) ? m <= I && s.indexOf(c, m) > -1 : !!I && au(s, c, m) > -1;
      }
      var OT = kt(function(s, c, m) {
        var S = -1, I = typeof c == "function", T = Qr(s) ? te(s.length) : [];
        return Xi(s, function(F) {
          T[++S] = I ? fo(c, F, m) : Kc(F, c, m);
        }), T;
      }), FT = H0(function(s, c, m) {
        Qa(s, m, c);
      });
      function Y0(s, c) {
        var m = At(s) ? Pn : Y7;
        return m(s, it(c, 3));
      }
      function BT(s, c, m, S) {
        return s == null ? [] : (At(c) || (c = c == null ? [] : [c]), m = S ? n : m, At(m) || (m = m == null ? [] : [m]), Q7(s, c, m));
      }
      var HT = H0(function(s, c, m) {
        s[m ? 0 : 1].push(c);
      }, function() {
        return [[], []];
      });
      function GT(s, c, m) {
        var S = At(s) ? Bm : M7, I = arguments.length < 3;
        return S(s, it(c, 4), m, I, Xi);
      }
      function $T(s, c, m) {
        var S = At(s) ? eD : M7, I = arguments.length < 3;
        return S(s, it(c, 4), m, I, $7);
      }
      function ZT(s, c) {
        var m = At(s) ? ji : Z7;
        return m(s, K0(it(c, 3)));
      }
      function jT(s) {
        var c = At(s) ? F7 : VP;
        return c(s);
      }
      function WT(s, c, m) {
        (m ? kr(s, c, m) : c === n) ? c = 1 : c = Lt(c);
        var S = At(s) ? hP : OP;
        return S(s, c);
      }
      function zT(s) {
        var c = At(s) ? mP : BP;
        return c(s);
      }
      function UT(s) {
        if (s == null)
          return 0;
        if (Qr(s))
          return ef(s) ? su(s) : s.length;
        var c = xr(s);
        return c == Re || c == jt ? s.size : op(s).length;
      }
      function XT(s, c, m) {
        var S = At(s) ? Hm : HP;
        return m && kr(s, c, m) && (c = n), S(s, it(c, 3));
      }
      var YT = kt(function(s, c) {
        if (s == null)
          return [];
        var m = c.length;
        return m > 1 && kr(s, c[0], c[1]) ? c = [] : m > 2 && kr(c[0], c[1], c[2]) && (c = [c[0]]), Q7(s, vr(c, 1), []);
      }), q0 = RD || function() {
        return xt.Date.now();
      };
      function qT(s, c) {
        if (typeof c != "function")
          throw new To(i);
        return s = Lt(s), function() {
          if (--s < 1)
            return c.apply(this, arguments);
        };
      }
      function U6(s, c, m) {
        return c = m ? n : c, c = s && c == null ? s.length : c, ei(s, P, n, n, n, n, c);
      }
      function X6(s, c) {
        var m;
        if (typeof c != "function")
          throw new To(i);
        return s = Lt(s), function() {
          return --s > 0 && (m = c.apply(this, arguments)), s <= 1 && (c = n), m;
        };
      }
      var Lp = kt(function(s, c, m) {
        var S = y;
        if (m.length) {
          var I = zi(m, pu(Lp));
          S |= R;
        }
        return ei(s, S, c, m, I);
      }), Y6 = kt(function(s, c, m) {
        var S = y | M;
        if (m.length) {
          var I = zi(m, pu(Y6));
          S |= R;
        }
        return ei(c, S, s, m, I);
      });
      function q6(s, c, m) {
        c = m ? n : c;
        var S = ei(s, _, n, n, n, n, n, c);
        return S.placeholder = q6.placeholder, S;
      }
      function J6(s, c, m) {
        c = m ? n : c;
        var S = ei(s, L, n, n, n, n, n, c);
        return S.placeholder = J6.placeholder, S;
      }
      function K6(s, c, m) {
        var S, I, T, F, G, Y, Ce = 0, be = !1, Se = !1, Fe = !0;
        if (typeof s != "function")
          throw new To(i);
        c = Fo(c) || 0, kn(m) && (be = !!m.leading, Se = "maxWait" in m, T = Se ? ir(Fo(m.maxWait) || 0, c) : T, Fe = "trailing" in m ? !!m.trailing : Fe);
        function Ue(Xn) {
          var ca = S, ai = I;
          return S = I = n, Ce = Xn, F = s.apply(ai, ca), F;
        }
        function ct(Xn) {
          return Ce = Xn, G = r1(Ft, c), be ? Ue(Xn) : F;
        }
        function Tt(Xn) {
          var ca = Xn - Y, ai = Xn - Ce, vv = c - ca;
          return Se ? Mr(vv, T - ai) : vv;
        }
        function dt(Xn) {
          var ca = Xn - Y, ai = Xn - Ce;
          return Y === n || ca >= c || ca < 0 || Se && ai >= T;
        }
        function Ft() {
          var Xn = q0();
          if (dt(Xn))
            return Wt(Xn);
          G = r1(Ft, Tt(Xn));
        }
        function Wt(Xn) {
          return G = n, Fe && S ? Ue(Xn) : (S = I = n, F);
        }
        function go() {
          G !== n && l6(G), Ce = 0, S = Y = I = G = n;
        }
        function Vr() {
          return G === n ? F : Wt(q0());
        }
        function vo() {
          var Xn = q0(), ca = dt(Xn);
          if (S = arguments, I = this, Y = Xn, ca) {
            if (G === n)
              return ct(Y);
            if (Se)
              return l6(G), G = r1(Ft, c), Ue(Y);
          }
          return G === n && (G = r1(Ft, c)), F;
        }
        return vo.cancel = go, vo.flush = Vr, vo;
      }
      var JT = kt(function(s, c) {
        return G7(s, 1, c);
      }), KT = kt(function(s, c, m) {
        return G7(s, Fo(c) || 0, m);
      });
      function QT(s) {
        return ei(s, O);
      }
      function J0(s, c) {
        if (typeof s != "function" || c != null && typeof c != "function")
          throw new To(i);
        var m = function() {
          var S = arguments, I = c ? c.apply(this, S) : S[0], T = m.cache;
          if (T.has(I))
            return T.get(I);
          var F = s.apply(this, S);
          return m.cache = T.set(I, F) || T, F;
        };
        return m.cache = new (J0.Cache || Ka)(), m;
      }
      J0.Cache = Ka;
      function K0(s) {
        if (typeof s != "function")
          throw new To(i);
        return function() {
          var c = arguments;
          switch (c.length) {
            case 0:
              return !s.call(this);
            case 1:
              return !s.call(this, c[0]);
            case 2:
              return !s.call(this, c[0], c[1]);
            case 3:
              return !s.call(this, c[0], c[1], c[2]);
          }
          return !s.apply(this, c);
        };
      }
      function eN(s) {
        return X6(2, s);
      }
      var tN = GP(function(s, c) {
        c = c.length == 1 && At(c[0]) ? Pn(c[0], ho(it())) : Pn(vr(c, 1), ho(it()));
        var m = c.length;
        return kt(function(S) {
          for (var I = -1, T = Mr(S.length, m); ++I < T; )
            S[I] = c[I].call(this, S[I]);
          return fo(s, this, S);
        });
      }), Rp = kt(function(s, c) {
        var m = zi(c, pu(Rp));
        return ei(s, R, n, c, m);
      }), Q6 = kt(function(s, c) {
        var m = zi(c, pu(Q6));
        return ei(s, k, n, c, m);
      }), nN = ti(function(s, c) {
        return ei(s, N, n, n, n, c);
      });
      function rN(s, c) {
        if (typeof s != "function")
          throw new To(i);
        return c = c === n ? c : Lt(c), kt(s, c);
      }
      function oN(s, c) {
        if (typeof s != "function")
          throw new To(i);
        return c = c == null ? 0 : ir(Lt(c), 0), kt(function(m) {
          var S = m[c], I = Ji(m, 0, c);
          return S && Wi(I, S), fo(s, this, I);
        });
      }
      function aN(s, c, m) {
        var S = !0, I = !0;
        if (typeof s != "function")
          throw new To(i);
        return kn(m) && (S = "leading" in m ? !!m.leading : S, I = "trailing" in m ? !!m.trailing : I), K6(s, c, {
          leading: S,
          maxWait: c,
          trailing: I
        });
      }
      function iN(s) {
        return U6(s, 1);
      }
      function sN(s, c) {
        return Rp(hp(c), s);
      }
      function lN() {
        if (!arguments.length)
          return [];
        var s = arguments[0];
        return At(s) ? s : [s];
      }
      function uN(s) {
        return ko(s, g);
      }
      function cN(s, c) {
        return c = typeof c == "function" ? c : n, ko(s, g, c);
      }
      function dN(s) {
        return ko(s, h | g);
      }
      function fN(s, c) {
        return c = typeof c == "function" ? c : n, ko(s, h | g, c);
      }
      function hN(s, c) {
        return c == null || H7(s, c, mr(c));
      }
      function ua(s, c) {
        return s === c || s !== s && c !== c;
      }
      var mN = j0(tp), pN = j0(function(s, c) {
        return s >= c;
      }), Ys = z7(function() {
        return arguments;
      }()) ? z7 : function(s) {
        return Hn(s) && cn.call(s, "callee") && !E7.call(s, "callee");
      }, At = te.isArray, gN = ru ? ho(ru) : xP;
      function Qr(s) {
        return s != null && Q0(s.length) && !ri(s);
      }
      function Un(s) {
        return Hn(s) && Qr(s);
      }
      function vN(s) {
        return s === !0 || s === !1 || Hn(s) && Nr(s) == Ie;
      }
      var Ki = PD || Hp, CN = ou ? ho(ou) : wP;
      function bN(s) {
        return Hn(s) && s.nodeType === 1 && !o1(s);
      }
      function yN(s) {
        if (s == null)
          return !0;
        if (Qr(s) && (At(s) || typeof s == "string" || typeof s.splice == "function" || Ki(s) || gu(s) || Ys(s)))
          return !s.length;
        var c = xr(s);
        if (c == Re || c == jt)
          return !s.size;
        if (n1(s))
          return !op(s).length;
        for (var m in s)
          if (cn.call(s, m))
            return !1;
        return !0;
      }
      function SN(s, c) {
        return Qc(s, c);
      }
      function AN(s, c, m) {
        m = typeof m == "function" ? m : n;
        var S = m ? m(s, c) : n;
        return S === n ? Qc(s, c, n, m) : !!S;
      }
      function Dp(s) {
        if (!Hn(s))
          return !1;
        var c = Nr(s);
        return c == ke || c == ye || typeof s.message == "string" && typeof s.name == "string" && !o1(s);
      }
      function MN(s) {
        return typeof s == "number" && N7(s);
      }
      function ri(s) {
        if (!kn(s))
          return !1;
        var c = Nr(s);
        return c == oe || c == lt || c == Le || c == Pt;
      }
      function ev(s) {
        return typeof s == "number" && s == Lt(s);
      }
      function Q0(s) {
        return typeof s == "number" && s > -1 && s % 1 == 0 && s <= K;
      }
      function kn(s) {
        var c = typeof s;
        return s != null && (c == "object" || c == "function");
      }
      function Hn(s) {
        return s != null && typeof s == "object";
      }
      var tv = Zc ? ho(Zc) : IP;
      function xN(s, c) {
        return s === c || rp(s, c, yp(c));
      }
      function wN(s, c, m) {
        return m = typeof m == "function" ? m : n, rp(s, c, yp(c), m);
      }
      function _N(s) {
        return nv(s) && s != +s;
      }
      function IN(s) {
        if (cE(s))
          throw new St(a);
        return U7(s);
      }
      function LN(s) {
        return s === null;
      }
      function RN(s) {
        return s == null;
      }
      function nv(s) {
        return typeof s == "number" || Hn(s) && Nr(s) == _t;
      }
      function o1(s) {
        if (!Hn(s) || Nr(s) != $e)
          return !1;
        var c = _0(s);
        if (c === null)
          return !0;
        var m = cn.call(c, "constructor") && c.constructor;
        return typeof m == "function" && m instanceof m && A0.call(m) == wD;
      }
      var Pp = g7 ? ho(g7) : LP;
      function DN(s) {
        return ev(s) && s >= -K && s <= K;
      }
      var rv = v7 ? ho(v7) : RP;
      function ef(s) {
        return typeof s == "string" || !At(s) && Hn(s) && Nr(s) == An;
      }
      function po(s) {
        return typeof s == "symbol" || Hn(s) && Nr(s) == Rn;
      }
      var gu = C7 ? ho(C7) : DP;
      function PN(s) {
        return s === n;
      }
      function EN(s) {
        return Hn(s) && xr(s) == Ar;
      }
      function TN(s) {
        return Hn(s) && Nr(s) == oa;
      }
      var NN = j0(ap), kN = j0(function(s, c) {
        return s <= c;
      });
      function ov(s) {
        if (!s)
          return [];
        if (Qr(s))
          return ef(s) ? sa(s) : Kr(s);
        if (Wc && s[Wc])
          return hD(s[Wc]());
        var c = xr(s), m = c == Re ? zm : c == jt ? b0 : vu;
        return m(s);
      }
      function oi(s) {
        if (!s)
          return s === 0 ? s : 0;
        if (s = Fo(s), s === j || s === -j) {
          var c = s < 0 ? -1 : 1;
          return c * ce;
        }
        return s === s ? s : 0;
      }
      function Lt(s) {
        var c = oi(s), m = c % 1;
        return c === c ? m ? c - m : c : 0;
      }
      function av(s) {
        return s ? Ws(Lt(s), 0, q) : 0;
      }
      function Fo(s) {
        if (typeof s == "number")
          return s;
        if (po(s))
          return U;
        if (kn(s)) {
          var c = typeof s.valueOf == "function" ? s.valueOf() : s;
          s = kn(c) ? c + "" : c;
        }
        if (typeof s != "string")
          return s === 0 ? s : +s;
        s = x7(s);
        var m = Vt.test(s);
        return m || or.test(s) ? Ze(s.slice(2), m ? 2 : 8) : Kt.test(s) ? U : +s;
      }
      function iv(s) {
        return Da(s, eo(s));
      }
      function VN(s) {
        return s ? Ws(Lt(s), -K, K) : s === 0 ? s : 0;
      }
      function an(s) {
        return s == null ? "" : mo(s);
      }
      var ON = hu(function(s, c) {
        if (n1(c) || Qr(c)) {
          Da(c, mr(c), s);
          return;
        }
        for (var m in c)
          cn.call(c, m) && qc(s, m, c[m]);
      }), sv = hu(function(s, c) {
        Da(c, eo(c), s);
      }), tf = hu(function(s, c, m, S) {
        Da(c, eo(c), s, S);
      }), FN = hu(function(s, c, m, S) {
        Da(c, mr(c), s, S);
      }), BN = ti(Km);
      function HN(s, c) {
        var m = fu(s);
        return c == null ? m : B7(m, c);
      }
      var GN = kt(function(s, c) {
        s = bn(s);
        var m = -1, S = c.length, I = S > 2 ? c[2] : n;
        for (I && kr(c[0], c[1], I) && (S = 1); ++m < S; )
          for (var T = c[m], F = eo(T), G = -1, Y = F.length; ++G < Y; ) {
            var Ce = F[G], be = s[Ce];
            (be === n || ua(be, uu[Ce]) && !cn.call(s, Ce)) && (s[Ce] = T[Ce]);
          }
        return s;
      }), $N = kt(function(s) {
        return s.push(n, x6), fo(lv, n, s);
      });
      function ZN(s, c) {
        return y7(s, it(c, 3), Ra);
      }
      function jN(s, c) {
        return y7(s, it(c, 3), ep);
      }
      function WN(s, c) {
        return s == null ? s : Qm(s, it(c, 3), eo);
      }
      function zN(s, c) {
        return s == null ? s : j7(s, it(c, 3), eo);
      }
      function UN(s, c) {
        return s && Ra(s, it(c, 3));
      }
      function XN(s, c) {
        return s && ep(s, it(c, 3));
      }
      function YN(s) {
        return s == null ? [] : V0(s, mr(s));
      }
      function qN(s) {
        return s == null ? [] : V0(s, eo(s));
      }
      function Ep(s, c, m) {
        var S = s == null ? n : zs(s, c);
        return S === n ? m : S;
      }
      function JN(s, c) {
        return s != null && I6(s, c, yP);
      }
      function Tp(s, c) {
        return s != null && I6(s, c, SP);
      }
      var KN = b6(function(s, c, m) {
        c != null && typeof c.toString != "function" && (c = M0.call(c)), s[c] = m;
      }, kp(to)), QN = b6(function(s, c, m) {
        c != null && typeof c.toString != "function" && (c = M0.call(c)), cn.call(s, c) ? s[c].push(m) : s[c] = [m];
      }, it), ek = kt(Kc);
      function mr(s) {
        return Qr(s) ? O7(s) : op(s);
      }
      function eo(s) {
        return Qr(s) ? O7(s, !0) : PP(s);
      }
      function tk(s, c) {
        var m = {};
        return c = it(c, 3), Ra(s, function(S, I, T) {
          Qa(m, c(S, I, T), S);
        }), m;
      }
      function nk(s, c) {
        var m = {};
        return c = it(c, 3), Ra(s, function(S, I, T) {
          Qa(m, I, c(S, I, T));
        }), m;
      }
      var rk = hu(function(s, c, m) {
        O0(s, c, m);
      }), lv = hu(function(s, c, m, S) {
        O0(s, c, m, S);
      }), ok = ti(function(s, c) {
        var m = {};
        if (s == null)
          return m;
        var S = !1;
        c = Pn(c, function(T) {
          return T = qi(T, s), S || (S = T.length > 1), T;
        }), Da(s, Cp(s), m), S && (m = ko(m, h | p | g, KP));
        for (var I = c.length; I--; )
          cp(m, c[I]);
        return m;
      });
      function ak(s, c) {
        return uv(s, K0(it(c)));
      }
      var ik = ti(function(s, c) {
        return s == null ? {} : TP(s, c);
      });
      function uv(s, c) {
        if (s == null)
          return {};
        var m = Pn(Cp(s), function(S) {
          return [S];
        });
        return c = it(c), e6(s, m, function(S, I) {
          return c(S, I[0]);
        });
      }
      function sk(s, c, m) {
        c = qi(c, s);
        var S = -1, I = c.length;
        for (I || (I = 1, s = n); ++S < I; ) {
          var T = s == null ? n : s[Pa(c[S])];
          T === n && (S = I, T = m), s = ri(T) ? T.call(s) : T;
        }
        return s;
      }
      function lk(s, c, m) {
        return s == null ? s : e1(s, c, m);
      }
      function uk(s, c, m, S) {
        return S = typeof S == "function" ? S : n, s == null ? s : e1(s, c, m, S);
      }
      var cv = A6(mr), dv = A6(eo);
      function ck(s, c, m) {
        var S = At(s), I = S || Ki(s) || gu(s);
        if (c = it(c, 4), m == null) {
          var T = s && s.constructor;
          I ? m = S ? new T() : [] : kn(s) ? m = ri(T) ? fu(_0(s)) : {} : m = {};
        }
        return (I ? Eo : Ra)(s, function(F, G, Y) {
          return c(m, F, G, Y);
        }), m;
      }
      function dk(s, c) {
        return s == null ? !0 : cp(s, c);
      }
      function fk(s, c, m) {
        return s == null ? s : a6(s, c, hp(m));
      }
      function hk(s, c, m, S) {
        return S = typeof S == "function" ? S : n, s == null ? s : a6(s, c, hp(m), S);
      }
      function vu(s) {
        return s == null ? [] : Wm(s, mr(s));
      }
      function mk(s) {
        return s == null ? [] : Wm(s, eo(s));
      }
      function pk(s, c, m) {
        return m === n && (m = c, c = n), m !== n && (m = Fo(m), m = m === m ? m : 0), c !== n && (c = Fo(c), c = c === c ? c : 0), Ws(Fo(s), c, m);
      }
      function gk(s, c, m) {
        return c = oi(c), m === n ? (m = c, c = 0) : m = oi(m), s = Fo(s), AP(s, c, m);
      }
      function vk(s, c, m) {
        if (m && typeof m != "boolean" && kr(s, c, m) && (c = m = n), m === n && (typeof c == "boolean" ? (m = c, c = n) : typeof s == "boolean" && (m = s, s = n)), s === n && c === n ? (s = 0, c = 1) : (s = oi(s), c === n ? (c = s, s = 0) : c = oi(c)), s > c) {
          var S = s;
          s = c, c = S;
        }
        if (m || s % 1 || c % 1) {
          var I = k7();
          return Mr(s + I * (c - s + ee("1e-" + ((I + "").length - 1))), c);
        }
        return sp(s, c);
      }
      var Ck = mu(function(s, c, m) {
        return c = c.toLowerCase(), s + (m ? fv(c) : c);
      });
      function fv(s) {
        return Np(an(s).toLowerCase());
      }
      function hv(s) {
        return s = an(s), s && s.replace(Dn, lD).replace(h0, "");
      }
      function bk(s, c, m) {
        s = an(s), c = mo(c);
        var S = s.length;
        m = m === n ? S : Ws(Lt(m), 0, S);
        var I = m;
        return m -= c.length, m >= 0 && s.slice(m, I) == c;
      }
      function yk(s) {
        return s = an(s), s && Po.test(s) ? s.replace(Do, uD) : s;
      }
      function Sk(s) {
        return s = an(s), s && ql.test(s) ? s.replace(Fs, "\\$&") : s;
      }
      var Ak = mu(function(s, c, m) {
        return s + (m ? "-" : "") + c.toLowerCase();
      }), Mk = mu(function(s, c, m) {
        return s + (m ? " " : "") + c.toLowerCase();
      }), xk = g6("toLowerCase");
      function wk(s, c, m) {
        s = an(s), c = Lt(c);
        var S = c ? su(s) : 0;
        if (!c || S >= c)
          return s;
        var I = (c - S) / 2;
        return Z0(D0(I), m) + s + Z0(R0(I), m);
      }
      function _k(s, c, m) {
        s = an(s), c = Lt(c);
        var S = c ? su(s) : 0;
        return c && S < c ? s + Z0(c - S, m) : s;
      }
      function Ik(s, c, m) {
        s = an(s), c = Lt(c);
        var S = c ? su(s) : 0;
        return c && S < c ? Z0(c - S, m) + s : s;
      }
      function Lk(s, c, m) {
        return m || c == null ? c = 0 : c && (c = +c), kD(an(s).replace($i, ""), c || 0);
      }
      function Rk(s, c, m) {
        return (m ? kr(s, c, m) : c === n) ? c = 1 : c = Lt(c), lp(an(s), c);
      }
      function Dk() {
        var s = arguments, c = an(s[0]);
        return s.length < 3 ? c : c.replace(s[1], s[2]);
      }
      var Pk = mu(function(s, c, m) {
        return s + (m ? "_" : "") + c.toLowerCase();
      });
      function Ek(s, c, m) {
        return m && typeof m != "number" && kr(s, c, m) && (c = m = n), m = m === n ? q : m >>> 0, m ? (s = an(s), s && (typeof c == "string" || c != null && !Pp(c)) && (c = mo(c), !c && iu(s)) ? Ji(sa(s), 0, m) : s.split(c, m)) : [];
      }
      var Tk = mu(function(s, c, m) {
        return s + (m ? " " : "") + Np(c);
      });
      function Nk(s, c, m) {
        return s = an(s), m = m == null ? 0 : Ws(Lt(m), 0, s.length), c = mo(c), s.slice(m, m + c.length) == c;
      }
      function kk(s, c, m) {
        var S = E.templateSettings;
        m && kr(s, c, m) && (c = n), s = an(s), c = tf({}, c, S, M6);
        var I = tf({}, c.imports, S.imports, M6), T = mr(I), F = Wm(I, T), G, Y, Ce = 0, be = c.interpolate || zn, Se = "__p += '", Fe = Um(
          (c.escape || zn).source + "|" + be.source + "|" + (be === Ul ? ut : zn).source + "|" + (c.evaluate || zn).source + "|$",
          "g"
        ), Ue = "//# sourceURL=" + (cn.call(c, "sourceURL") ? (c.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++p0 + "]") + `
`;
        s.replace(Fe, function(dt, Ft, Wt, go, Vr, vo) {
          return Wt || (Wt = go), Se += s.slice(Ce, vo).replace(La, cD), Ft && (G = !0, Se += `' +
__e(` + Ft + `) +
'`), Vr && (Y = !0, Se += `';
` + Vr + `;
__p += '`), Wt && (Se += `' +
((__t = (` + Wt + `)) == null ? '' : __t) +
'`), Ce = vo + dt.length, dt;
        }), Se += `';
`;
        var ct = cn.call(c, "variable") && c.variable;
        if (!ct)
          Se = `with (obj) {
` + Se + `
}
`;
        else if (Ae.test(ct))
          throw new St(l);
        Se = (Y ? Se.replace(Pc, "") : Se).replace(Gi, "$1").replace(Wl, "$1;"), Se = "function(" + (ct || "obj") + `) {
` + (ct ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (G ? ", __e = _.escape" : "") + (Y ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + Se + `return __p
}`;
        var Tt = pv(function() {
          return Qt(T, Ue + "return " + Se).apply(n, F);
        });
        if (Tt.source = Se, Dp(Tt))
          throw Tt;
        return Tt;
      }
      function Vk(s) {
        return an(s).toLowerCase();
      }
      function Ok(s) {
        return an(s).toUpperCase();
      }
      function Fk(s, c, m) {
        if (s = an(s), s && (m || c === n))
          return x7(s);
        if (!s || !(c = mo(c)))
          return s;
        var S = sa(s), I = sa(c), T = w7(S, I), F = _7(S, I) + 1;
        return Ji(S, T, F).join("");
      }
      function Bk(s, c, m) {
        if (s = an(s), s && (m || c === n))
          return s.slice(0, L7(s) + 1);
        if (!s || !(c = mo(c)))
          return s;
        var S = sa(s), I = _7(S, sa(c)) + 1;
        return Ji(S, 0, I).join("");
      }
      function Hk(s, c, m) {
        if (s = an(s), s && (m || c === n))
          return s.replace($i, "");
        if (!s || !(c = mo(c)))
          return s;
        var S = sa(s), I = w7(S, sa(c));
        return Ji(S, I).join("");
      }
      function Gk(s, c) {
        var m = H, S = $;
        if (kn(c)) {
          var I = "separator" in c ? c.separator : I;
          m = "length" in c ? Lt(c.length) : m, S = "omission" in c ? mo(c.omission) : S;
        }
        s = an(s);
        var T = s.length;
        if (iu(s)) {
          var F = sa(s);
          T = F.length;
        }
        if (m >= T)
          return s;
        var G = m - su(S);
        if (G < 1)
          return S;
        var Y = F ? Ji(F, 0, G).join("") : s.slice(0, G);
        if (I === n)
          return Y + S;
        if (F && (G += Y.length - G), Pp(I)) {
          if (s.slice(G).search(I)) {
            var Ce, be = Y;
            for (I.global || (I = Um(I.source, an(It.exec(I)) + "g")), I.lastIndex = 0; Ce = I.exec(be); )
              var Se = Ce.index;
            Y = Y.slice(0, Se === n ? G : Se);
          }
        } else if (s.indexOf(mo(I), G) != G) {
          var Fe = Y.lastIndexOf(I);
          Fe > -1 && (Y = Y.slice(0, Fe));
        }
        return Y + S;
      }
      function $k(s) {
        return s = an(s), s && Os.test(s) ? s.replace(Ro, vD) : s;
      }
      var Zk = mu(function(s, c, m) {
        return s + (m ? " " : "") + c.toUpperCase();
      }), Np = g6("toUpperCase");
      function mv(s, c, m) {
        return s = an(s), c = m ? n : c, c === n ? fD(s) ? yD(s) : rD(s) : s.match(c) || [];
      }
      var pv = kt(function(s, c) {
        try {
          return fo(s, n, c);
        } catch (m) {
          return Dp(m) ? m : new St(m);
        }
      }), jk = ti(function(s, c) {
        return Eo(c, function(m) {
          m = Pa(m), Qa(s, m, Lp(s[m], s));
        }), s;
      });
      function Wk(s) {
        var c = s == null ? 0 : s.length, m = it();
        return s = c ? Pn(s, function(S) {
          if (typeof S[1] != "function")
            throw new To(i);
          return [m(S[0]), S[1]];
        }) : [], kt(function(S) {
          for (var I = -1; ++I < c; ) {
            var T = s[I];
            if (fo(T[0], this, S))
              return fo(T[1], this, S);
          }
        });
      }
      function zk(s) {
        return vP(ko(s, h));
      }
      function kp(s) {
        return function() {
          return s;
        };
      }
      function Uk(s, c) {
        return s == null || s !== s ? c : s;
      }
      var Xk = C6(), Yk = C6(!0);
      function to(s) {
        return s;
      }
      function Vp(s) {
        return X7(typeof s == "function" ? s : ko(s, h));
      }
      function qk(s) {
        return q7(ko(s, h));
      }
      function Jk(s, c) {
        return J7(s, ko(c, h));
      }
      var Kk = kt(function(s, c) {
        return function(m) {
          return Kc(m, s, c);
        };
      }), Qk = kt(function(s, c) {
        return function(m) {
          return Kc(s, m, c);
        };
      });
      function Op(s, c, m) {
        var S = mr(c), I = V0(c, S);
        m == null && !(kn(c) && (I.length || !S.length)) && (m = c, c = s, s = this, I = V0(c, mr(c)));
        var T = !(kn(m) && "chain" in m) || !!m.chain, F = ri(s);
        return Eo(I, function(G) {
          var Y = c[G];
          s[G] = Y, F && (s.prototype[G] = function() {
            var Ce = this.__chain__;
            if (T || Ce) {
              var be = s(this.__wrapped__), Se = be.__actions__ = Kr(this.__actions__);
              return Se.push({ func: Y, args: arguments, thisArg: s }), be.__chain__ = Ce, be;
            }
            return Y.apply(s, Wi([this.value()], arguments));
          });
        }), s;
      }
      function eV() {
        return xt._ === this && (xt._ = _D), this;
      }
      function Fp() {
      }
      function tV(s) {
        return s = Lt(s), kt(function(c) {
          return K7(c, s);
        });
      }
      var nV = pp(Pn), rV = pp(b7), oV = pp(Hm);
      function gv(s) {
        return Ap(s) ? Gm(Pa(s)) : NP(s);
      }
      function aV(s) {
        return function(c) {
          return s == null ? n : zs(s, c);
        };
      }
      var iV = y6(), sV = y6(!0);
      function Bp() {
        return [];
      }
      function Hp() {
        return !1;
      }
      function lV() {
        return {};
      }
      function uV() {
        return "";
      }
      function cV() {
        return !0;
      }
      function dV(s, c) {
        if (s = Lt(s), s < 1 || s > K)
          return [];
        var m = q, S = Mr(s, q);
        c = it(c), s -= q;
        for (var I = jm(S, c); ++m < s; )
          c(m);
        return I;
      }
      function fV(s) {
        return At(s) ? Pn(s, Pa) : po(s) ? [s] : Kr(V6(an(s)));
      }
      function hV(s) {
        var c = ++xD;
        return an(s) + c;
      }
      var mV = $0(function(s, c) {
        return s + c;
      }, 0), pV = gp("ceil"), gV = $0(function(s, c) {
        return s / c;
      }, 1), vV = gp("floor");
      function CV(s) {
        return s && s.length ? k0(s, to, tp) : n;
      }
      function bV(s, c) {
        return s && s.length ? k0(s, it(c, 2), tp) : n;
      }
      function yV(s) {
        return A7(s, to);
      }
      function SV(s, c) {
        return A7(s, it(c, 2));
      }
      function AV(s) {
        return s && s.length ? k0(s, to, ap) : n;
      }
      function MV(s, c) {
        return s && s.length ? k0(s, it(c, 2), ap) : n;
      }
      var xV = $0(function(s, c) {
        return s * c;
      }, 1), wV = gp("round"), _V = $0(function(s, c) {
        return s - c;
      }, 0);
      function IV(s) {
        return s && s.length ? Zm(s, to) : 0;
      }
      function LV(s, c) {
        return s && s.length ? Zm(s, it(c, 2)) : 0;
      }
      return E.after = qT, E.ary = U6, E.assign = ON, E.assignIn = sv, E.assignInWith = tf, E.assignWith = FN, E.at = BN, E.before = X6, E.bind = Lp, E.bindAll = jk, E.bindKey = Y6, E.castArray = lN, E.chain = j6, E.chunk = vE, E.compact = CE, E.concat = bE, E.cond = Wk, E.conforms = zk, E.constant = kp, E.countBy = IT, E.create = HN, E.curry = q6, E.curryRight = J6, E.debounce = K6, E.defaults = GN, E.defaultsDeep = $N, E.defer = JT, E.delay = KT, E.difference = yE, E.differenceBy = SE, E.differenceWith = AE, E.drop = ME, E.dropRight = xE, E.dropRightWhile = wE, E.dropWhile = _E, E.fill = IE, E.filter = RT, E.flatMap = ET, E.flatMapDeep = TT, E.flatMapDepth = NT, E.flatten = H6, E.flattenDeep = LE, E.flattenDepth = RE, E.flip = QT, E.flow = Xk, E.flowRight = Yk, E.fromPairs = DE, E.functions = YN, E.functionsIn = qN, E.groupBy = kT, E.initial = EE, E.intersection = TE, E.intersectionBy = NE, E.intersectionWith = kE, E.invert = KN, E.invertBy = QN, E.invokeMap = OT, E.iteratee = Vp, E.keyBy = FT, E.keys = mr, E.keysIn = eo, E.map = Y0, E.mapKeys = tk, E.mapValues = nk, E.matches = qk, E.matchesProperty = Jk, E.memoize = J0, E.merge = rk, E.mergeWith = lv, E.method = Kk, E.methodOf = Qk, E.mixin = Op, E.negate = K0, E.nthArg = tV, E.omit = ok, E.omitBy = ak, E.once = eN, E.orderBy = BT, E.over = nV, E.overArgs = tN, E.overEvery = rV, E.overSome = oV, E.partial = Rp, E.partialRight = Q6, E.partition = HT, E.pick = ik, E.pickBy = uv, E.property = gv, E.propertyOf = aV, E.pull = BE, E.pullAll = $6, E.pullAllBy = HE, E.pullAllWith = GE, E.pullAt = $E, E.range = iV, E.rangeRight = sV, E.rearg = nN, E.reject = ZT, E.remove = ZE, E.rest = rN, E.reverse = _p, E.sampleSize = WT, E.set = lk, E.setWith = uk, E.shuffle = zT, E.slice = jE, E.sortBy = YT, E.sortedUniq = JE, E.sortedUniqBy = KE, E.split = Ek, E.spread = oN, E.tail = QE, E.take = eT, E.takeRight = tT, E.takeRightWhile = nT, E.takeWhile = rT, E.tap = CT, E.throttle = aN, E.thru = X0, E.toArray = ov, E.toPairs = cv, E.toPairsIn = dv, E.toPath = fV, E.toPlainObject = iv, E.transform = ck, E.unary = iN, E.union = oT, E.unionBy = aT, E.unionWith = iT, E.uniq = sT, E.uniqBy = lT, E.uniqWith = uT, E.unset = dk, E.unzip = Ip, E.unzipWith = Z6, E.update = fk, E.updateWith = hk, E.values = vu, E.valuesIn = mk, E.without = cT, E.words = mv, E.wrap = sN, E.xor = dT, E.xorBy = fT, E.xorWith = hT, E.zip = mT, E.zipObject = pT, E.zipObjectDeep = gT, E.zipWith = vT, E.entries = cv, E.entriesIn = dv, E.extend = sv, E.extendWith = tf, Op(E, E), E.add = mV, E.attempt = pv, E.camelCase = Ck, E.capitalize = fv, E.ceil = pV, E.clamp = pk, E.clone = uN, E.cloneDeep = dN, E.cloneDeepWith = fN, E.cloneWith = cN, E.conformsTo = hN, E.deburr = hv, E.defaultTo = Uk, E.divide = gV, E.endsWith = bk, E.eq = ua, E.escape = yk, E.escapeRegExp = Sk, E.every = LT, E.find = DT, E.findIndex = F6, E.findKey = ZN, E.findLast = PT, E.findLastIndex = B6, E.findLastKey = jN, E.floor = vV, E.forEach = W6, E.forEachRight = z6, E.forIn = WN, E.forInRight = zN, E.forOwn = UN, E.forOwnRight = XN, E.get = Ep, E.gt = mN, E.gte = pN, E.has = JN, E.hasIn = Tp, E.head = G6, E.identity = to, E.includes = VT, E.indexOf = PE, E.inRange = gk, E.invoke = ek, E.isArguments = Ys, E.isArray = At, E.isArrayBuffer = gN, E.isArrayLike = Qr, E.isArrayLikeObject = Un, E.isBoolean = vN, E.isBuffer = Ki, E.isDate = CN, E.isElement = bN, E.isEmpty = yN, E.isEqual = SN, E.isEqualWith = AN, E.isError = Dp, E.isFinite = MN, E.isFunction = ri, E.isInteger = ev, E.isLength = Q0, E.isMap = tv, E.isMatch = xN, E.isMatchWith = wN, E.isNaN = _N, E.isNative = IN, E.isNil = RN, E.isNull = LN, E.isNumber = nv, E.isObject = kn, E.isObjectLike = Hn, E.isPlainObject = o1, E.isRegExp = Pp, E.isSafeInteger = DN, E.isSet = rv, E.isString = ef, E.isSymbol = po, E.isTypedArray = gu, E.isUndefined = PN, E.isWeakMap = EN, E.isWeakSet = TN, E.join = VE, E.kebabCase = Ak, E.last = Oo, E.lastIndexOf = OE, E.lowerCase = Mk, E.lowerFirst = xk, E.lt = NN, E.lte = kN, E.max = CV, E.maxBy = bV, E.mean = yV, E.meanBy = SV, E.min = AV, E.minBy = MV, E.stubArray = Bp, E.stubFalse = Hp, E.stubObject = lV, E.stubString = uV, E.stubTrue = cV, E.multiply = xV, E.nth = FE, E.noConflict = eV, E.noop = Fp, E.now = q0, E.pad = wk, E.padEnd = _k, E.padStart = Ik, E.parseInt = Lk, E.random = vk, E.reduce = GT, E.reduceRight = $T, E.repeat = Rk, E.replace = Dk, E.result = sk, E.round = wV, E.runInContext = z, E.sample = jT, E.size = UT, E.snakeCase = Pk, E.some = XT, E.sortedIndex = WE, E.sortedIndexBy = zE, E.sortedIndexOf = UE, E.sortedLastIndex = XE, E.sortedLastIndexBy = YE, E.sortedLastIndexOf = qE, E.startCase = Tk, E.startsWith = Nk, E.subtract = _V, E.sum = IV, E.sumBy = LV, E.template = kk, E.times = dV, E.toFinite = oi, E.toInteger = Lt, E.toLength = av, E.toLower = Vk, E.toNumber = Fo, E.toSafeInteger = VN, E.toString = an, E.toUpper = Ok, E.trim = Fk, E.trimEnd = Bk, E.trimStart = Hk, E.truncate = Gk, E.unescape = $k, E.uniqueId = hV, E.upperCase = Zk, E.upperFirst = Np, E.each = W6, E.eachRight = z6, E.first = G6, Op(E, function() {
        var s = {};
        return Ra(E, function(c, m) {
          cn.call(E.prototype, m) || (s[m] = c);
        }), s;
      }(), { chain: !1 }), E.VERSION = r, Eo(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(s) {
        E[s].placeholder = E;
      }), Eo(["drop", "take"], function(s, c) {
        Ht.prototype[s] = function(m) {
          m = m === n ? 1 : ir(Lt(m), 0);
          var S = this.__filtered__ && !c ? new Ht(this) : this.clone();
          return S.__filtered__ ? S.__takeCount__ = Mr(m, S.__takeCount__) : S.__views__.push({
            size: Mr(m, q),
            type: s + (S.__dir__ < 0 ? "Right" : "")
          }), S;
        }, Ht.prototype[s + "Right"] = function(m) {
          return this.reverse()[s](m).reverse();
        };
      }), Eo(["filter", "map", "takeWhile"], function(s, c) {
        var m = c + 1, S = m == re || m == ue;
        Ht.prototype[s] = function(I) {
          var T = this.clone();
          return T.__iteratees__.push({
            iteratee: it(I, 3),
            type: m
          }), T.__filtered__ = T.__filtered__ || S, T;
        };
      }), Eo(["head", "last"], function(s, c) {
        var m = "take" + (c ? "Right" : "");
        Ht.prototype[s] = function() {
          return this[m](1).value()[0];
        };
      }), Eo(["initial", "tail"], function(s, c) {
        var m = "drop" + (c ? "" : "Right");
        Ht.prototype[s] = function() {
          return this.__filtered__ ? new Ht(this) : this[m](1);
        };
      }), Ht.prototype.compact = function() {
        return this.filter(to);
      }, Ht.prototype.find = function(s) {
        return this.filter(s).head();
      }, Ht.prototype.findLast = function(s) {
        return this.reverse().find(s);
      }, Ht.prototype.invokeMap = kt(function(s, c) {
        return typeof s == "function" ? new Ht(this) : this.map(function(m) {
          return Kc(m, s, c);
        });
      }), Ht.prototype.reject = function(s) {
        return this.filter(K0(it(s)));
      }, Ht.prototype.slice = function(s, c) {
        s = Lt(s);
        var m = this;
        return m.__filtered__ && (s > 0 || c < 0) ? new Ht(m) : (s < 0 ? m = m.takeRight(-s) : s && (m = m.drop(s)), c !== n && (c = Lt(c), m = c < 0 ? m.dropRight(-c) : m.take(c - s)), m);
      }, Ht.prototype.takeRightWhile = function(s) {
        return this.reverse().takeWhile(s).reverse();
      }, Ht.prototype.toArray = function() {
        return this.take(q);
      }, Ra(Ht.prototype, function(s, c) {
        var m = /^(?:filter|find|map|reject)|While$/.test(c), S = /^(?:head|last)$/.test(c), I = E[S ? "take" + (c == "last" ? "Right" : "") : c], T = S || /^find/.test(c);
        I && (E.prototype[c] = function() {
          var F = this.__wrapped__, G = S ? [1] : arguments, Y = F instanceof Ht, Ce = G[0], be = Y || At(F), Se = function(Ft) {
            var Wt = I.apply(E, Wi([Ft], G));
            return S && Fe ? Wt[0] : Wt;
          };
          be && m && typeof Ce == "function" && Ce.length != 1 && (Y = be = !1);
          var Fe = this.__chain__, Ue = !!this.__actions__.length, ct = T && !Fe, Tt = Y && !Ue;
          if (!T && be) {
            F = Tt ? F : new Ht(this);
            var dt = s.apply(F, G);
            return dt.__actions__.push({ func: X0, args: [Se], thisArg: n }), new No(dt, Fe);
          }
          return ct && Tt ? s.apply(this, G) : (dt = this.thru(Se), ct ? S ? dt.value()[0] : dt.value() : dt);
        });
      }), Eo(["pop", "push", "shift", "sort", "splice", "unshift"], function(s) {
        var c = y0[s], m = /^(?:push|sort|unshift)$/.test(s) ? "tap" : "thru", S = /^(?:pop|shift)$/.test(s);
        E.prototype[s] = function() {
          var I = arguments;
          if (S && !this.__chain__) {
            var T = this.value();
            return c.apply(At(T) ? T : [], I);
          }
          return this[m](function(F) {
            return c.apply(At(F) ? F : [], I);
          });
        };
      }), Ra(Ht.prototype, function(s, c) {
        var m = E[c];
        if (m) {
          var S = m.name + "";
          cn.call(du, S) || (du[S] = []), du[S].push({ name: c, func: m });
        }
      }), du[G0(n, M).name] = [{
        name: "wrapper",
        func: n
      }], Ht.prototype.clone = $D, Ht.prototype.reverse = ZD, Ht.prototype.value = jD, E.prototype.at = bT, E.prototype.chain = yT, E.prototype.commit = ST, E.prototype.next = AT, E.prototype.plant = xT, E.prototype.reverse = wT, E.prototype.toJSON = E.prototype.valueOf = E.prototype.value = _T, E.prototype.first = E.prototype.head, Wc && (E.prototype[Wc] = MT), E;
    }, lu = SD();
    Jt ? ((Jt.exports = lu)._ = lu, Nt._ = lu) : xt._ = lu;
  }).call(di);
})(W2, W2.exports);
var Xh = W2.exports;
const V1 = /* @__PURE__ */ yh(Xh);
function soe(e, t) {
  var n = doe(t);
  return n.formatToParts ? uoe(n, e) : coe(n, e);
}
var loe = {
  year: 0,
  month: 1,
  day: 2,
  hour: 3,
  minute: 4,
  second: 5
};
function uoe(e, t) {
  try {
    for (var n = e.formatToParts(t), r = [], o = 0; o < n.length; o++) {
      var a = loe[n[o].type];
      a >= 0 && (r[a] = parseInt(n[o].value, 10));
    }
    return r;
  } catch (i) {
    if (i instanceof RangeError)
      return [NaN];
    throw i;
  }
}
function coe(e, t) {
  var n = e.format(t), r = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(n);
  return [r[3], r[1], r[2], r[4], r[5], r[6]];
}
var Zg = {};
function doe(e) {
  if (!Zg[e]) {
    var t = new Intl.DateTimeFormat("en-US", {
      hourCycle: "h23",
      timeZone: "America/New_York",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    }).format(/* @__PURE__ */ new Date("2014-06-25T04:00:00.123Z")), n = t === "06/25/2014, 00:00:00" || t === "‎06‎/‎25‎/‎2014‎ ‎00‎:‎00‎:‎00";
    Zg[e] = n ? new Intl.DateTimeFormat("en-US", {
      hourCycle: "h23",
      timeZone: e,
      year: "numeric",
      month: "numeric",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    }) : new Intl.DateTimeFormat("en-US", {
      hour12: !1,
      timeZone: e,
      year: "numeric",
      month: "numeric",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    });
  }
  return Zg[e];
}
function s_(e, t, n, r, o, a, i) {
  var l = /* @__PURE__ */ new Date(0);
  return l.setUTCFullYear(e, t, n), l.setUTCHours(r, o, a, i), l;
}
var cb = 36e5, foe = 6e4, jg = {
  timezone: /([Z+-].*)$/,
  timezoneZ: /^(Z)$/,
  timezoneHH: /^([+-]\d{2})$/,
  timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/
};
function hoe(e, t, n) {
  var r, o;
  if (!e || (r = jg.timezoneZ.exec(e), r))
    return 0;
  var a;
  if (r = jg.timezoneHH.exec(e), r)
    return a = parseInt(r[1], 10), db(a) ? -(a * cb) : NaN;
  if (r = jg.timezoneHHMM.exec(e), r) {
    a = parseInt(r[2], 10);
    var i = parseInt(r[3], 10);
    return db(a, i) ? (o = Math.abs(a) * cb + i * foe, r[1] === "+" ? -o : o) : NaN;
  }
  if (goe(e)) {
    t = new Date(t || Date.now());
    var l = n ? t : moe(t), u = f3(l, e), d = n ? u : poe(t, u, e);
    return -d;
  }
  return NaN;
}
function moe(e) {
  return s_(
    e.getFullYear(),
    e.getMonth(),
    e.getDate(),
    e.getHours(),
    e.getMinutes(),
    e.getSeconds(),
    e.getMilliseconds()
  );
}
function f3(e, t) {
  var n = soe(e, t), r = s_(
    n[0],
    n[1] - 1,
    n[2],
    n[3] % 24,
    n[4],
    n[5],
    0
  ).getTime(), o = e.getTime(), a = o % 1e3;
  return o -= a >= 0 ? a : 1e3 + a, r - o;
}
function poe(e, t, n) {
  var r = e.getTime(), o = r - t, a = f3(new Date(o), n);
  if (t === a)
    return t;
  o -= a - t;
  var i = f3(new Date(o), n);
  return a === i ? a : Math.max(a, i);
}
function db(e, t) {
  return -23 <= e && e <= 23 && (t == null || 0 <= t && t <= 59);
}
var fb = {};
function goe(e) {
  if (fb[e])
    return !0;
  try {
    return new Intl.DateTimeFormat(void 0, { timeZone: e }), fb[e] = !0, !0;
  } catch {
    return !1;
  }
}
function hb(e, t) {
  return -hoe(e, t);
}
var voe = Object.create, b9 = Object.defineProperty, Coe = Object.getOwnPropertyDescriptor, l_ = Object.getOwnPropertyNames, boe = Object.getPrototypeOf, yoe = Object.prototype.hasOwnProperty, Soe = /* @__PURE__ */ ((e) => typeof require < "u" ? require : typeof Proxy < "u" ? new Proxy(e, {
  get: (t, n) => (typeof require < "u" ? require : t)[n]
}) : e)(function(e) {
  if (typeof require < "u")
    return require.apply(this, arguments);
  throw Error('Dynamic require of "' + e + '" is not supported');
}), ra = (e, t) => function() {
  return t || (0, e[l_(e)[0]])((t = { exports: {} }).exports, t), t.exports;
}, Hd = (e, t) => {
  for (var n in t)
    b9(e, n, { get: t[n], enumerable: !0 });
}, Aoe = (e, t, n, r) => {
  if (t && typeof t == "object" || typeof t == "function")
    for (let o of l_(t))
      !yoe.call(e, o) && o !== n && b9(e, o, { get: () => t[o], enumerable: !(r = Coe(t, o)) || r.enumerable });
  return e;
}, ae = (e, t, n) => (n = e != null ? voe(boe(e)) : {}, Aoe(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  t || !e || !e.__esModule ? b9(n, "default", { value: e, enumerable: !0 }) : n,
  e
)), Moe = ra({
  "../shared-utils/lib/distinct.js"(e) {
    Object.defineProperty(e, "__esModule", { value: !0 });
  }
}), Tl = ra({
  "../shared-utils/lib/is.js"(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.isNull = e.isUndefined = e.isSymbol = e.isFunction = e.isObject = e.isString = e.isNumber = e.isBoolean = e.isArray = e.getPrimitiveType = void 0;
    var t = "Array", n = "Object", r = (p) => Object.prototype.toString.call(p).slice(8, -1);
    e.getPrimitiveType = r;
    var o = (p) => (g) => (0, e.getPrimitiveType)(g) === p;
    e.isArray = o(t);
    var a = (p) => typeof p == "boolean";
    e.isBoolean = a;
    var i = (p) => typeof p == "number";
    e.isNumber = i;
    var l = (p) => typeof p == "string";
    e.isString = l, e.isObject = o(n);
    var u = (p) => typeof p == "function";
    e.isFunction = u;
    var d = (p) => typeof p == "symbol";
    e.isSymbol = d;
    var f = (p) => p === void 0;
    e.isUndefined = f;
    var h = (p) => p === null;
    e.isNull = h;
  }
}), xoe = ra({
  "../shared-utils/lib/checkLength.js"(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.checkLength = t;
    function t(n, r, o = "Incorrect array size") {
      if (r.length !== n)
        throw new Error(`${o} (expected ${n}, got ${r.length})`);
      return r;
    }
  }
}), woe = ra({
  "../shared-utils/lib/checkMinLength.js"(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.checkMinLength = t;
    function t(n, r, o = "Array size too small") {
      if (r.length < n)
        throw new Error(`${o} (expected ${n}, got ${r.length})`);
      return r;
    }
  }
}), _oe = ra({
  "../shared-utils/lib/enumerate.js"(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.enumerate = t;
    function* t(n) {
      let r = 0;
      for (const o of n)
        yield [r, o], r += 1;
    }
  }
}), Ioe = ra({
  "../shared-utils/lib/hasDefinedValues.js"(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.hasDefinedValues = n;
    var t = Tl();
    function n(r) {
      return Object.values(r).some((o) => !(0, t.isUndefined)(o));
    }
  }
}), Loe = ra({
  "../shared-utils/lib/toTitleCase.js"(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.toTitleCase = t;
    function t(n) {
      return n.replace(/\w\S*/g, (r) => r.charAt(0).toUpperCase() + r.substr(1).toLowerCase());
    }
  }
}), pe = ra({
  "../shared-utils/lib/index.js"(e) {
    var t = e && e.__createBinding || (Object.create ? function(P, N, O, H) {
      H === void 0 && (H = O);
      var $ = Object.getOwnPropertyDescriptor(N, O);
      (!$ || ("get" in $ ? !N.__esModule : $.writable || $.configurable)) && ($ = { enumerable: !0, get: function() {
        return N[O];
      } }), Object.defineProperty(P, H, $);
    } : function(P, N, O, H) {
      H === void 0 && (H = O), P[H] = N[O];
    }), n = e && e.__exportStar || function(P, N) {
      for (var O in P)
        O !== "default" && !Object.prototype.hasOwnProperty.call(N, O) && t(N, P, O);
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), e.noop = e.memoize = e.toPunctuatedPhoneFormat = e.GDRIVE_REGEX = e.URL_REGEX = e.PHONE_REGEX = e.EMAIL_REGEX = e.toTitleCase = e.isUndefined = void 0, e.linJitter = i, e.clamp = l, e.unreachable = u, e.populated = d, e.isObject = f, e.difference = h, e.isDefined = p, e.expected = g, e.orNull = v, e.orUndefined = y, e.applyIfNonEmptyString = M, e.isNonEmptyString = x, e.makeLookup = R, Moe();
    var r = Tl();
    n(xoe(), e), n(woe(), e), n(_oe(), e), n(Ioe(), e);
    var o = Tl();
    Object.defineProperty(e, "isUndefined", { enumerable: !0, get: function() {
      return o.isUndefined;
    } });
    var a = Loe();
    Object.defineProperty(e, "toTitleCase", { enumerable: !0, get: function() {
      return a.toTitleCase;
    } });
    function i(P, N) {
      return P + Math.random() * (N - P);
    }
    function l(P, N, O) {
      return Math.min(O ?? 1 / 0, Math.max(P, N ?? -1 / 0));
    }
    function u(P) {
      throw console.log(P), new Error(`unexpected: ${P}`);
    }
    function d(P) {
      if (P !== null && typeof P == "object") {
        for (const N in P)
          if (P[N] !== void 0)
            return !0;
      }
      return !1;
    }
    function f(P) {
      return typeof P == "object" && P !== null && !Array.isArray(P);
    }
    function h(P, N) {
      const O = new Set(P);
      for (const H of N)
        O.delete(H);
      return O;
    }
    function p(P) {
      return P !== void 0;
    }
    function g(P, N = "expected a defined value") {
      if (P == null)
        throw new Error(`${N} (got ${P})`);
      return P;
    }
    e.EMAIL_REGEX = /^[^@]*@.*\..*$/, e.PHONE_REGEX = /^\+1[1-9]\d{1,14}$/, e.URL_REGEX = /^https:\/\/.*$/, e.GDRIVE_REGEX = /https:\/\/drive.google.com\/drive\/.+/;
    var C = (P) => {
      const N = P == null ? void 0 : P.match(/([0-9]{3})([0-9]{3})([0-9]{4})$/);
      return N ? `(${N[1]}) ${N[2]}-${N[3]}` : P;
    };
    e.toPunctuatedPhoneFormat = C;
    function v(P) {
      return (N) => N !== null ? P(N) : null;
    }
    function y(P) {
      return (N) => N !== void 0 ? P(N) : void 0;
    }
    function M(P) {
      return y((N) => N.trim() === "" ? void 0 : P(N));
    }
    function x(P) {
      return P != null && P.trim() !== "";
    }
    var _ = {}, L = (P, N, O) => {
      if (N.every((ne, ie) => {
        var re;
        return ne === ((re = _[O]) === null || re === void 0 ? void 0 : re.deps[ie]);
      }, !0))
        return _[O].value;
      const $ = P();
      return _[O] = {
        deps: N,
        value: $
      }, $;
    };
    e.memoize = L;
    function R({ cases: P, default: N, errorMsg: O }) {
      const H = P.flatMap((ne) => {
        const [ie, re] = ne;
        return (0, r.isArray)(ie) ? ie.map((ve) => [ve, re]) : [ne];
      }), $ = Object.fromEntries(H);
      return (ne) => {
        const ie = $[ne];
        if (p(ie))
          return ie;
        if (p(N))
          return N;
        if ((0, r.isString)(O))
          throw new Error(O);
        const re = Object.keys($), ve = String(ne);
        if ((0, r.isFunction)(O))
          throw new Error(O(ve, re));
        const ue = new Intl.ListFormat("en", { type: "disjunction" }).format(re);
        throw new Error(`Invalid case: ${ve}.
Expected one of: ${ue}`);
      };
    }
    var k = () => {
    };
    e.noop = k;
  }
}), y9 = ra({
  "../shared-utils/lib/lens.js"(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.Iso = e.Lens = void 0, e.identityLens = r, e.propertyLens = o, e.arrayLens = a, e.arrayFindLens = i, e.arrayFindDeleteLens = l;
    var t = class h3 {
      /**
       * Constructs a new FullLens from the given getter and setter pair.
       */
      constructor(f, h) {
        this.get = f, this.set = h;
      }
      /**
       * Lenses can be concatenated/pipelined/composed/etc, whatever your
       * preferred terminology is. We "zoom in" with the first lens, and then
       * "zoom in" with the second lens. For example, suppose we have a
       * Map<string, Request>. We can concatenate a lens that zooms in on a
       * specific key of this map to a lens that zooms in on a property of Request
       * to get a lens that zooms in on that property within the whole map.
       *
       * This is probably the trickiest code in this whole file. If you understand
       * it, you understand lenses. If you really want to make sure you understand
       * it, delete the code below and see if you can implement it yourself. If
       * working with FullLens is too hard, try using the simpler Lens type first.
       *
       * This is defined as a class method to make it easier to concatenate
       * multiple lenses in a row.
       */
      concat(f) {
        return new h3((h) => f.get(this.get(h)), (h, p) => this.set(h, f.set(this.get(h), p)));
      }
      /**
       * Converts a lens from a container S to an item A into a lens from arrays
       * of containers S to arrays of items A. When setting, the new array MUST be
       * the same length as the old one.
       */
      overArray() {
        return new h3((f) => f.map(this.get), (f, h) => {
          if (f.length !== h.length) {
            const p = `got ${h.length}, need ${f.length}`;
            throw new Error(`FullLens.mapped() input wrong length (${p})`);
          }
          return f.map((p, g) => this.set(p, h[g]));
        });
      }
      /**
       * Applies a function to transform the value the lens points at.
       */
      map(f, h) {
        return this.set(f, h(this.get(f)));
      }
      /**
       * Adapt this lens to a simplified version of the React useState-style API.
       * Returns a new value and setter callback.
       *
       *     const [house, setHouse] = useState(initHouse);
       *     const [addr, setAddr] = houseAddressLens.adaptReact(house, setHouse);
       */
      adaptReact(f, h) {
        return [this.get(f), (p) => h(this.set(f, p))];
      }
    }, n = class extends t {
    };
    e.Lens = n;
    function r() {
      return new n((d) => d, (d, f) => f);
    }
    function o(d) {
      return new n((f) => f[d], (f, h) => Object.assign(Object.assign({}, f), { [d]: h }));
    }
    function a(...d) {
      return new t((f) => d.map((h) => h.get(f)), (f, h) => {
        if (h.length != d.length) {
          const p = `got ${h.length}, need ${d.length}`;
          throw new Error(`arrayLens().set() input wrong length (${p})`);
        }
        return h.reduce((p, g, C) => d[C].set(p, g), f);
      });
    }
    function i(d) {
      return new t((f) => f.find(d), (f, h) => {
        const p = f.findIndex(d);
        return p === -1 ? [...f, h] : [...f.slice(0, p), h, ...f.slice(p + 1)];
      });
    }
    function l(d) {
      return new n((f) => f.find(d), (f, h) => {
        if (h === void 0)
          return f.filter((g) => !d(g));
        const p = f.findIndex(d);
        return p === -1 ? [...f, h] : [...f.slice(0, p), h, ...f.slice(p + 1)];
      });
    }
    var u = class {
      constructor(d, f) {
        this.fwd = d, this.inv = f;
      }
      /**
       * Converts this isomorphism into a lens, which is useful for inserting an
       * isomorphism into Lens.concat()
       */
      toLens() {
        return new n(this.fwd, (d, f) => this.inv(f));
      }
    };
    e.Iso = u;
  }
}), Yh = ra({
  "../shared-utils/lib/enum.js"(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.AloftEnum = t;
    function t() {
      return (n) => {
        const r = Object.keys(n);
        if (r.length === 0)
          throw new Error("AloftEnum requires at least one enum variant");
        return Object.assign(Object.assign({}, n), { _keys: r, _values: Object.values(n), _isKey: (o) => o in n, _index: (o) => Object.keys(n).findIndex((a) => o === a) });
      };
    }
  }
}), Roe = ra({
  "../../node_modules/fast-json-stable-stringify/index.js"(e, t) {
    t.exports = function(n, r) {
      r || (r = {}), typeof r == "function" && (r = { cmp: r });
      var o = typeof r.cycles == "boolean" ? r.cycles : !1, a = r.cmp && function(l) {
        return function(u) {
          return function(d, f) {
            var h = { key: d, value: u[d] }, p = { key: f, value: u[f] };
            return l(h, p);
          };
        };
      }(r.cmp), i = [];
      return function l(u) {
        if (u && u.toJSON && typeof u.toJSON == "function" && (u = u.toJSON()), u !== void 0) {
          if (typeof u == "number")
            return isFinite(u) ? "" + u : "null";
          if (typeof u != "object")
            return JSON.stringify(u);
          var d, f;
          if (Array.isArray(u)) {
            for (f = "[", d = 0; d < u.length; d++)
              d && (f += ","), f += l(u[d]) || "null";
            return f + "]";
          }
          if (u === null)
            return "null";
          if (i.indexOf(u) !== -1) {
            if (o)
              return JSON.stringify("__cycle__");
            throw new TypeError("Converting circular structure to JSON");
          }
          var h = i.push(u) - 1, p = Object.keys(u).sort(a && a(u));
          for (f = "", d = 0; d < p.length; d++) {
            var g = p[d], C = l(u[g]);
            C && (f && (f += ","), f += JSON.stringify(g) + ":" + C);
          }
          return i.splice(h, 1), "{" + f + "}";
        }
      }(n);
    };
  }
}), Doe = ra({
  "../../node_modules/pluralize/pluralize.js"(e, t) {
    (function(n, r) {
      typeof Soe == "function" && typeof e == "object" && typeof t == "object" ? t.exports = r() : typeof define == "function" && define.amd ? define(function() {
        return r();
      }) : n.pluralize = r();
    })(e, function() {
      var n = [], r = [], o = {}, a = {}, i = {};
      function l(v) {
        return typeof v == "string" ? new RegExp("^" + v + "$", "i") : v;
      }
      function u(v, y) {
        return v === y ? y : v === v.toLowerCase() ? y.toLowerCase() : v === v.toUpperCase() ? y.toUpperCase() : v[0] === v[0].toUpperCase() ? y.charAt(0).toUpperCase() + y.substr(1).toLowerCase() : y.toLowerCase();
      }
      function d(v, y) {
        return v.replace(/\$(\d{1,2})/g, function(M, x) {
          return y[x] || "";
        });
      }
      function f(v, y) {
        return v.replace(y[0], function(M, x) {
          var _ = d(y[1], arguments);
          return u(M === "" ? v[x - 1] : M, _);
        });
      }
      function h(v, y, M) {
        if (!v.length || o.hasOwnProperty(v))
          return y;
        for (var x = M.length; x--; ) {
          var _ = M[x];
          if (_[0].test(y))
            return f(y, _);
        }
        return y;
      }
      function p(v, y, M) {
        return function(x) {
          var _ = x.toLowerCase();
          return y.hasOwnProperty(_) ? u(x, _) : v.hasOwnProperty(_) ? u(x, v[_]) : h(_, x, M);
        };
      }
      function g(v, y, M, x) {
        return function(_) {
          var L = _.toLowerCase();
          return y.hasOwnProperty(L) ? !0 : v.hasOwnProperty(L) ? !1 : h(L, L, M) === L;
        };
      }
      function C(v, y, M) {
        var x = y === 1 ? C.singular(v) : C.plural(v);
        return (M ? y + " " : "") + x;
      }
      return C.plural = p(
        i,
        a,
        n
      ), C.isPlural = g(
        i,
        a,
        n
      ), C.singular = p(
        a,
        i,
        r
      ), C.isSingular = g(
        a,
        i,
        r
      ), C.addPluralRule = function(v, y) {
        n.push([l(v), y]);
      }, C.addSingularRule = function(v, y) {
        r.push([l(v), y]);
      }, C.addUncountableRule = function(v) {
        if (typeof v == "string") {
          o[v.toLowerCase()] = !0;
          return;
        }
        C.addPluralRule(v, "$0"), C.addSingularRule(v, "$0");
      }, C.addIrregularRule = function(v, y) {
        y = y.toLowerCase(), v = v.toLowerCase(), i[v] = y, a[y] = v;
      }, [
        // Pronouns.
        ["I", "we"],
        ["me", "us"],
        ["he", "they"],
        ["she", "they"],
        ["them", "them"],
        ["myself", "ourselves"],
        ["yourself", "yourselves"],
        ["itself", "themselves"],
        ["herself", "themselves"],
        ["himself", "themselves"],
        ["themself", "themselves"],
        ["is", "are"],
        ["was", "were"],
        ["has", "have"],
        ["this", "these"],
        ["that", "those"],
        // Words ending in with a consonant and `o`.
        ["echo", "echoes"],
        ["dingo", "dingoes"],
        ["volcano", "volcanoes"],
        ["tornado", "tornadoes"],
        ["torpedo", "torpedoes"],
        // Ends with `us`.
        ["genus", "genera"],
        ["viscus", "viscera"],
        // Ends with `ma`.
        ["stigma", "stigmata"],
        ["stoma", "stomata"],
        ["dogma", "dogmata"],
        ["lemma", "lemmata"],
        ["schema", "schemata"],
        ["anathema", "anathemata"],
        // Other irregular rules.
        ["ox", "oxen"],
        ["axe", "axes"],
        ["die", "dice"],
        ["yes", "yeses"],
        ["foot", "feet"],
        ["eave", "eaves"],
        ["goose", "geese"],
        ["tooth", "teeth"],
        ["quiz", "quizzes"],
        ["human", "humans"],
        ["proof", "proofs"],
        ["carve", "carves"],
        ["valve", "valves"],
        ["looey", "looies"],
        ["thief", "thieves"],
        ["groove", "grooves"],
        ["pickaxe", "pickaxes"],
        ["passerby", "passersby"]
      ].forEach(function(v) {
        return C.addIrregularRule(v[0], v[1]);
      }), [
        [/s?$/i, "s"],
        [/[^\u0000-\u007F]$/i, "$0"],
        [/([^aeiou]ese)$/i, "$1"],
        [/(ax|test)is$/i, "$1es"],
        [/(alias|[^aou]us|t[lm]as|gas|ris)$/i, "$1es"],
        [/(e[mn]u)s?$/i, "$1s"],
        [/([^l]ias|[aeiou]las|[ejzr]as|[iu]am)$/i, "$1"],
        [/(alumn|syllab|vir|radi|nucle|fung|cact|stimul|termin|bacill|foc|uter|loc|strat)(?:us|i)$/i, "$1i"],
        [/(alumn|alg|vertebr)(?:a|ae)$/i, "$1ae"],
        [/(seraph|cherub)(?:im)?$/i, "$1im"],
        [/(her|at|gr)o$/i, "$1oes"],
        [/(agend|addend|millenni|dat|extrem|bacteri|desiderat|strat|candelabr|errat|ov|symposi|curricul|automat|quor)(?:a|um)$/i, "$1a"],
        [/(apheli|hyperbat|periheli|asyndet|noumen|phenomen|criteri|organ|prolegomen|hedr|automat)(?:a|on)$/i, "$1a"],
        [/sis$/i, "ses"],
        [/(?:(kni|wi|li)fe|(ar|l|ea|eo|oa|hoo)f)$/i, "$1$2ves"],
        [/([^aeiouy]|qu)y$/i, "$1ies"],
        [/([^ch][ieo][ln])ey$/i, "$1ies"],
        [/(x|ch|ss|sh|zz)$/i, "$1es"],
        [/(matr|cod|mur|sil|vert|ind|append)(?:ix|ex)$/i, "$1ices"],
        [/\b((?:tit)?m|l)(?:ice|ouse)$/i, "$1ice"],
        [/(pe)(?:rson|ople)$/i, "$1ople"],
        [/(child)(?:ren)?$/i, "$1ren"],
        [/eaux$/i, "$0"],
        [/m[ae]n$/i, "men"],
        ["thou", "you"]
      ].forEach(function(v) {
        return C.addPluralRule(v[0], v[1]);
      }), [
        [/s$/i, ""],
        [/(ss)$/i, "$1"],
        [/(wi|kni|(?:after|half|high|low|mid|non|night|[^\w]|^)li)ves$/i, "$1fe"],
        [/(ar|(?:wo|[ae])l|[eo][ao])ves$/i, "$1f"],
        [/ies$/i, "y"],
        [/\b([pl]|zomb|(?:neck|cross)?t|coll|faer|food|gen|goon|group|lass|talk|goal|cut)ies$/i, "$1ie"],
        [/\b(mon|smil)ies$/i, "$1ey"],
        [/\b((?:tit)?m|l)ice$/i, "$1ouse"],
        [/(seraph|cherub)im$/i, "$1"],
        [/(x|ch|ss|sh|zz|tto|go|cho|alias|[^aou]us|t[lm]as|gas|(?:her|at|gr)o|[aeiou]ris)(?:es)?$/i, "$1"],
        [/(analy|diagno|parenthe|progno|synop|the|empha|cri|ne)(?:sis|ses)$/i, "$1sis"],
        [/(movie|twelve|abuse|e[mn]u)s$/i, "$1"],
        [/(test)(?:is|es)$/i, "$1is"],
        [/(alumn|syllab|vir|radi|nucle|fung|cact|stimul|termin|bacill|foc|uter|loc|strat)(?:us|i)$/i, "$1us"],
        [/(agend|addend|millenni|dat|extrem|bacteri|desiderat|strat|candelabr|errat|ov|symposi|curricul|quor)a$/i, "$1um"],
        [/(apheli|hyperbat|periheli|asyndet|noumen|phenomen|criteri|organ|prolegomen|hedr|automat)a$/i, "$1on"],
        [/(alumn|alg|vertebr)ae$/i, "$1a"],
        [/(cod|mur|sil|vert|ind)ices$/i, "$1ex"],
        [/(matr|append)ices$/i, "$1ix"],
        [/(pe)(rson|ople)$/i, "$1rson"],
        [/(child)ren$/i, "$1"],
        [/(eau)x?$/i, "$1"],
        [/men$/i, "man"]
      ].forEach(function(v) {
        return C.addSingularRule(v[0], v[1]);
      }), [
        // Singular words with no plurals.
        "adulthood",
        "advice",
        "agenda",
        "aid",
        "aircraft",
        "alcohol",
        "ammo",
        "analytics",
        "anime",
        "athletics",
        "audio",
        "bison",
        "blood",
        "bream",
        "buffalo",
        "butter",
        "carp",
        "cash",
        "chassis",
        "chess",
        "clothing",
        "cod",
        "commerce",
        "cooperation",
        "corps",
        "debris",
        "diabetes",
        "digestion",
        "elk",
        "energy",
        "equipment",
        "excretion",
        "expertise",
        "firmware",
        "flounder",
        "fun",
        "gallows",
        "garbage",
        "graffiti",
        "hardware",
        "headquarters",
        "health",
        "herpes",
        "highjinks",
        "homework",
        "housework",
        "information",
        "jeans",
        "justice",
        "kudos",
        "labour",
        "literature",
        "machinery",
        "mackerel",
        "mail",
        "media",
        "mews",
        "moose",
        "music",
        "mud",
        "manga",
        "news",
        "only",
        "personnel",
        "pike",
        "plankton",
        "pliers",
        "police",
        "pollution",
        "premises",
        "rain",
        "research",
        "rice",
        "salmon",
        "scissors",
        "series",
        "sewage",
        "shambles",
        "shrimp",
        "software",
        "species",
        "staff",
        "swine",
        "tennis",
        "traffic",
        "transportation",
        "trout",
        "tuna",
        "wealth",
        "welfare",
        "whiting",
        "wildebeest",
        "wildlife",
        "you",
        /pok[eé]mon$/i,
        // Regexes.
        /[^aeiou]ese$/i,
        // "chinese", "japanese"
        /deer$/i,
        // "deer", "reindeer"
        /fish$/i,
        // "fish", "blowfish", "angelfish"
        /measles$/i,
        /o[iu]s$/i,
        // "carnivorous"
        /pox$/i,
        // "chickpox", "smallpox"
        /sheep$/i
      ].forEach(C.addUncountableRule), C;
    });
  }
}), Sr = ae(pe(), 1), Oi = ae(Tl(), 1);
ae(y9(), 1);
var Poe = {};
Hd(Poe, {
  BLOB_ID_REGEX: () => u_,
  equals: () => Noe,
  fromMetadata: () => Toe,
  getExtension: () => koe
});
var Eoe = ae(pe(), 1), u_ = /b-[0-9a-f]{40}/;
function Toe(e, t) {
  return {
    $type: "AloftToolkitBlob",
    id: e,
    type: t.type,
    name: t.name,
    size: t.size,
    createdAt: t.createdAt,
    createdBy: t.createdBy,
    annotation: t.annotation
  };
}
function Noe(e, t) {
  return e.id === t.id;
}
function koe(e) {
  var n;
  const t = ((n = e.name) == null ? void 0 : n.split(".")) ?? [];
  return t.length >= 2 ? (0, Eoe.expected)(t[t.length - 1]).toLowerCase() : void 0;
}
var S9 = b().regex(u_).brand("BlobID"), ms = w({
  blobID: S9,
  filename: b()
}), Voe = {};
Hd(Voe, {
  equals: () => Boe,
  fromToolkitAccountID: () => Hoe,
  schAloftToolkitAccount: () => Foe,
  toToolkitAccountID: () => Goe
});
var Sc = b(), Tn = b(), za = b();
b();
var c_ = w({
  self: b().optional(),
  next: b().optional(),
  limit: D().optional(),
  totalCount: D().optional(),
  numResults: D().optional()
}), Ooe = w({
  id: Sc
}), Foe = $t({
  $type: fe("AloftToolkitAccount")
}).and(Ooe), Boe = V1.isEqual, Hoe = (e) => ({
  $type: "AloftToolkitAccount",
  id: e
}), Goe = (e) => e.id, A9 = ae(Yh(), 1), $l = $t({
  AddressLineText: b(),
  CityName: b(),
  PostalCode: b(),
  StateCode: b(),
  unitNumber: b().optional(),
  CountyName: b().optional()
}), d_ = w({
  latitude: D(),
  longitude: D()
}), $oe = Me([
  "Weekly",
  "Bi-Monthly",
  "Monthly",
  "Quarterly",
  "Semi-Annually",
  "Annually"
]), Zoe = Me(["Legal", "Illegal", "Legal Nonconforming", "No Zoning"]), joe = Me(["Fee Simple", "Leased Fee", "Leasehold", "Other"]), Woe = w({
  address: $l,
  coordinates: d_.optional(),
  zoning: b().optional(),
  zoningCompliance: Zoe.optional(),
  legalDescription: b().optional(),
  hoa: b().optional(),
  hoaFeeAmount: qn.optional(),
  hoaFeeFrequency: $oe.optional(),
  parcelNumber: b().optional(),
  pud: J().optional(),
  propertyInterest: joe.optional(),
  propertyInterestOther: b().optional()
}), Gd = $l.partial(), wf = (e) => b().default("").transform((t) => t.trim()).pipe(b().min(1, { message: `${e} is required.` })), M9 = w({
  AddressLineText: wf("Address"),
  CityName: wf("City"),
  PostalCode: wf("Zip"),
  StateCode: wf("State"),
  unitNumber: b().optional()
});
function zoe(e) {
  const t = e != null && e.unitNumber ? ` ${e.unitNumber}` : "", n = (e == null ? void 0 : e.AddressLineText) ?? "Unknown Street Number and Name", r = `${(e == null ? void 0 : e.CityName) ?? "Unknown City Name"}, ${(e == null ? void 0 : e.StateCode) ?? "Unknown State"} ${(e == null ? void 0 : e.PostalCode) ?? "Unknown Zip Code"}`;
  return [n + t, r];
}
var Uoe = (e) => zoe(e).join(" "), z2 = ae(pe(), 1);
function Xoe(e) {
  var t;
  try {
    const n = e.split(",").map((r) => r.trim()).filter((r) => r);
    switch (n.length) {
      case 3:
        return Yoe(n);
      case 4:
        return ((t = n[n.length - 1]) == null ? void 0 : t.split(" ").length) !== 1 ? mb(n, !0) : mb(n);
      case 5:
        return qoe(n);
      default:
        throw new Error("Unexpected address format");
    }
  } catch (n) {
    throw new Error(`could not translate string address to Address: ${e}, ${n}`);
  }
}
var Yoe = (e) => {
  const [t, n, r] = (0, z2.checkMinLength)(3, e), [o, a] = r.split(" ");
  if (o.length > 2)
    throw new Error("Unexpected address format");
  return {
    AddressLineText: t,
    CityName: n,
    StateCode: o,
    PostalCode: a
  };
}, mb = (e, t = !1) => {
  const [n, r, o, a] = (0, z2.checkMinLength)(4, e);
  if (t) {
    const [i, l] = (0, z2.checkLength)(2, a.split(" "));
    return {
      AddressLineText: `${n} ${r}`,
      CityName: o,
      StateCode: i,
      PostalCode: l
    };
  }
  if (o.length > 2)
    throw new Error("Unexpected address format");
  return {
    AddressLineText: n,
    CityName: r,
    StateCode: o,
    PostalCode: a
  };
}, qoe = (e) => {
  const [t, n, r, o, a] = (0, z2.checkMinLength)(
    5,
    e
  );
  if (o.length > 2)
    throw new Error("Unexpected address format");
  return {
    AddressLineText: `${t} ${n}`.trim(),
    CityName: r,
    StateCode: o,
    PostalCode: a
  };
}, nr = rr.schema, Bn = wi.schema, wt = Dt.schema, Pe = Yt.schema, zt = gt.schema, Joe = b().transform((e, t) => {
  const n = +e.replace(/,/g, "").replace(/—|−/g, "-");
  return Number.isNaN(n) ? (t.addIssue({
    code: we.custom,
    message: "Not a number"
  }), j2) : n;
}), Koe = nn([D(), Joe]);
fe("");
var Qoe = /^\(\d{3}\) \d{3}-\d{4}$/;
b().regex(Qoe, "Invalid US phone number");
b().refine(
  (e) => (
    // US zip codes are 5 digits or 9 digits with a hyphen in the middle
    /(^\d{5}$)|(^\d{5}-\d{4}$)/.test(e)
  ),
  {
    message: "Invalid US zip code"
  }
);
var _e = Koe.refine((e) => e % 1 === 0, "Not a whole number").refine((e) => e >= 0, "Not a positive number").brand("PositiveInt"), Sn = b();
function Ac(e) {
  return yl().transform((t, n) => {
    const r = e.safeParse(t);
    if (r.success)
      return r.data;
    for (const o of r.error.issues)
      n.addIssue(o);
    return j2;
  });
}
var eae = na("t", [
  w({ t: fe("string"), v: b() }),
  w({ t: fe("boolean"), v: J() }),
  w({ t: fe("number"), v: D() }),
  w({ t: fe("enum"), v: Sn }),
  w({ t: fe("price"), v: Pe }),
  w({ t: fe("date"), v: nr }),
  w({ t: fe("count"), v: zt }),
  w({ t: fe("area"), v: wt })
]), tae = b().brand("ToolkitListingID"), nae = ae(Yh(), 1), Je;
((e) => {
  ((t) => {
    t.US_PACIFIC = "America/Los_Angeles", t.US_EASTERN = "America/New_York", t.US_CENTRAL = "America/Chicago", t.US_MOUNTAIN = "America/Denver", t.US_PHOENIX = "America/Phoenix", t.UTC = "Etc/UTC";
  })(e.TimeZones || (e.TimeZones = {})), e.differenceInMinutes = (t, n, r = /* @__PURE__ */ new Date()) => (hb(t, r) - hb(n, r)) / 6e4;
})(Je || (Je = {}));
var Qo = (0, nae.AloftEnum)()({
  northwestmls: {
    resoID: "M00000650",
    constellation1ID: "NorthwestMLS",
    shortName: "NWMLS",
    longName: "Northwest Multiple Listing Service",
    isActive: !0,
    timeZone: Je.TimeZones.US_PACIFIC,
    abodeMLSName: "Northwest MLS"
  },
  mlspin: {
    resoID: "M00000306",
    constellation1ID: "MLSPIN",
    shortName: "MLS PIN",
    longName: "Massachusetts MLS Property Information Network",
    isActive: !0,
    timeZone: Je.TimeZones.US_EASTERN,
    abodeMLSName: "MLS Property Information Network"
  },
  armls: {
    resoID: "M00000048",
    constellation1ID: "ArizonaRegional",
    shortName: "ARMLS",
    longName: "Arizona Regional Multiple Listing Service (ARMLS)",
    isActive: !0,
    timeZone: Je.TimeZones.US_MOUNTAIN,
    abodeMLSName: "Arizona Regional MLS"
  },
  houston: {
    resoID: "M00000599",
    constellation1ID: "Houston",
    shortName: "HAR",
    longName: "Houston Association of Realtors",
    isActive: !0,
    timeZone: Je.TimeZones.US_CENTRAL,
    abodeMLSName: "Houston Association of Realtors MLS"
  },
  lasvegas: {
    resoID: "M00000466",
    constellation1ID: "LasVegas",
    shortName: "LVR",
    longName: "Las Vegas Realtors",
    isActive: !0,
    timeZone: Je.TimeZones.US_PACIFIC,
    abodeMLSName: "Greater Las Vegas Association of Realtors"
  },
  sef: {
    resoID: "M00000151",
    constellation1ID: "SEF",
    shortName: "Miami Realtors MLS",
    longName: "Miami Realtors MLS",
    isActive: !0,
    timeZone: Je.TimeZones.US_EASTERN,
    abodeMLSName: "Miami Association of Realtors"
  },
  mlsnow: {
    resoID: "M00000830",
    constellation1ID: "MLSNow",
    shortName: "MLS Now",
    longName: "MLS Now",
    isActive: !0,
    timeZone: Je.TimeZones.US_EASTERN,
    abodeMLSName: "MLS Now (YES MLS)"
  },
  onekey: {
    resoID: "M00000489",
    constellation1ID: "OneKey",
    shortName: "OneKey",
    longName: "OneKey MLS",
    isActive: !0,
    timeZone: Je.TimeZones.US_EASTERN,
    abodeMLSName: "One Key MLS"
  },
  stellarmls: {
    resoID: "M00000146",
    constellation1ID: "StellarMLS",
    shortName: "Stellar MLS",
    longName: "Stellar MLS",
    isActive: !0,
    timeZone: Je.TimeZones.US_EASTERN,
    abodeMLSName: "Stellar MLS"
  },
  crmls: {
    resoID: "M00000093",
    constellation1ID: "CRMLS",
    shortName: "CRMLS",
    longName: "California Regional Multiple Listing Service (CRMLS)",
    isActive: !0,
    timeZone: Je.TimeZones.US_PACIFIC,
    abodeMLSName: "California Regional Multiple Listing Service"
  },
  trianglemls: {
    resoID: "M00000389",
    constellation1ID: "TriangleMLS",
    shortName: "Triangle MLS",
    longName: "Triangle MLS",
    isActive: !0,
    timeZone: Je.TimeZones.US_EASTERN,
    abodeMLSName: "Triangle MLS"
  },
  canopymls: {
    resoID: "M00000391",
    constellation1ID: "CanopyMLS",
    shortName: "Canopy MLS",
    longName: "Canopy MLS (Canopy Realtor Association)",
    isActive: !0,
    timeZone: Je.TimeZones.US_EASTERN,
    abodeMLSName: "Canopy MLS"
  },
  recolorado: {
    resoID: "M00000116",
    constellation1ID: "REColorado",
    shortName: "REcolorado",
    longName: "REcolorado",
    isActive: !0,
    timeZone: Je.TimeZones.US_MOUNTAIN,
    abodeMLSName: "REcolorado"
  },
  sanantonio: {
    resoID: "M00000616",
    constellation1ID: "SanAntonio",
    shortName: "SanAntonio",
    longName: "San Antonio Board of REALTORS",
    isActive: !0,
    timeZone: Je.TimeZones.US_CENTRAL,
    abodeMLSName: "San Antonio Board of Realtors"
  },
  mlsok: {
    resoID: "M00000519",
    constellation1ID: "MLSOK",
    shortName: "MLSOK",
    longName: "MLSOK",
    isActive: !0,
    timeZone: Je.TimeZones.US_CENTRAL,
    abodeMLSName: "MLS of Oklahoma"
  },
  centraltexas: {
    resoID: "M00000610",
    constellation1ID: "CentralTexas",
    shortName: "CTXMLS",
    longName: "Central Texas MLS (CTXMLS)",
    isActive: !0,
    timeZone: Je.TimeZones.US_CENTRAL,
    abodeMLSName: "Central Texas MLS (Four River AOR)"
  },
  georgiamls: {
    resoID: "M00000188",
    constellation1ID: "GeorgiaMLS",
    shortName: "Georgia MLS",
    longName: "Georgia MLS",
    isActive: !0,
    timeZone: Je.TimeZones.US_EASTERN,
    abodeMLSName: "Georgia MLS"
  },
  nabor: {
    resoID: void 0,
    constellation1ID: void 0,
    shortName: "NABOR",
    longName: "Naples Area Board of REALTORS",
    isActive: !1
  },
  swmric: {
    resoID: void 0,
    constellation1ID: void 0,
    shortName: "SWMRIC",
    longName: "Southwestern Michigan Association of REALTORS",
    isActive: !1
  },
  rebny: {
    resoID: "T00000046",
    constellation1ID: "REBNY",
    shortName: "REBNY",
    longName: "Real Estate Board of New York (REBNY)",
    isActive: !1,
    timeZone: Je.TimeZones.US_EASTERN,
    abodeMLSName: "Real Estate Board of NEW York 620A"
  },
  realtracs: {
    resoID: "M00000574",
    constellation1ID: "Realtracs",
    shortName: "Realtracs",
    longName: "Realtracs",
    isActive: !0,
    timeZone: Je.TimeZones.US_CENTRAL,
    abodeMLSName: "Middle Tennessee MLS - REALTRACS"
  },
  gsrein: {
    resoID: "M00000065",
    constellation1ID: "GSREIN",
    shortName: "GSREIN",
    longName: "Gulf South Real Estate Information Network",
    isActive: !0,
    timeZone: Je.TimeZones.US_CENTRAL,
    abodeMLSName: "Gulf South Real Estate Information Network (NEW Orleans)"
  },
  realmls: {
    resoID: "M00000141",
    constellation1ID: "RealMLS",
    shortName: "RealMLS",
    longName: "realMLS (Northeast Florida Multiple Listing Service)",
    isActive: !0,
    timeZone: Je.TimeZones.US_EASTERN,
    abodeMLSName: "Northeast Florida/Jacksonville"
  },
  irmls: {
    resoID: "M00000256",
    constellation1ID: "IRMLS",
    shortName: "IRMLS",
    longName: "Indiana Regional MLS",
    isActive: !0,
    timeZone: Je.TimeZones.US_EASTERN,
    abodeMLSName: "Indiana Regional MLS"
  },
  mlstechnology: {
    resoID: "M00000521",
    constellation1ID: "MLSTechnology",
    shortName: "MLS Technology",
    longName: "MLS Technology",
    isActive: !0,
    timeZone: Je.TimeZones.US_CENTRAL,
    abodeMLSName: "MLS Technology (Tulsa MLS)"
  },
  knoxville: {
    resoID: "M00000582",
    constellation1ID: "Knoxville",
    shortName: "Knoxville",
    longName: "Knoxville Area Association of REALTORS",
    isActive: !0,
    timeZone: Je.TimeZones.US_EASTERN,
    abodeMLSName: "Knoxville Area Association of Realtors"
  },
  mred: {
    resoID: "M00000243",
    constellation1ID: "MRED",
    shortName: "MRED",
    longName: "Midwest Real Estate Data (MRED)",
    isActive: !0,
    timeZone: Je.TimeZones.US_CENTRAL,
    abodeMLSName: "Midwest Real Estate Data"
  },
  brightmls: {
    resoID: "M00000309",
    constellation1ID: "BrightMLS",
    shortName: "Bright MLS",
    longName: "Bright MLS",
    isActive: !0,
    timeZone: Je.TimeZones.US_EASTERN,
    abodeMLSName: "Bright MLS"
  },
  northcarolinaregional: {
    resoID: "M00000722",
    constellation1ID: "NorthCarolinaRegional",
    shortName: "NorthCarolinaRegional",
    longName: "North Carolina Regional MLS",
    isActive: !0,
    timeZone: Je.TimeZones.US_EASTERN,
    abodeMLSName: "North Carolina Regional MLS"
  },
  austin: {
    resoID: "M00000589",
    constellation1ID: "Austin",
    shortName: "ACTRIS",
    longName: "Austin Central Texas Realty Information Service (ACTRIS)",
    isActive: !0,
    timeZone: Je.TimeZones.US_CENTRAL,
    abodeMLSName: "Austin Board of Realtors"
  },
  metrolist: {
    resoID: "M00000091",
    constellation1ID: "Metrolist",
    shortName: "MetroList",
    longName: "MetroList",
    isActive: !0,
    timeZone: Je.TimeZones.US_PACIFIC,
    abodeMLSName: "MetroList - Sacramento"
  },
  mlsunited: {
    resoID: "M00000070",
    constellation1ID: "MLSUnited",
    shortName: "MLS United",
    longName: "MLS United",
    isActive: !0,
    timeZone: Je.TimeZones.US_CENTRAL,
    abodeMLSName: "MLS United"
  },
  fmls: {
    resoID: void 0,
    constellation1ID: void 0,
    shortName: "FMLS",
    longName: "First Multiple Listing Service",
    isActive: !1
  },
  heartlandmls: {
    resoID: "M00000270",
    constellation1ID: "HeartlandMLS",
    shortName: "Heartland MLS",
    longName: "Heartland MLS",
    isActive: !0,
    timeZone: Je.TimeZones.US_CENTRAL,
    abodeMLSName: "Heartland MLS"
  },
  gardenstatemls: {
    resoID: "M00000449",
    constellation1ID: "GardenStateMLS",
    shortName: "Garden State MLS",
    longName: "Garden State MLS",
    isActive: !0,
    timeZone: Je.TimeZones.US_EASTERN,
    abodeMLSName: "Garden State MLS"
  },
  ntreis: {
    resoID: "M00000594",
    constellation1ID: "NTREIS",
    shortName: "NTREIS",
    longName: "North Texas Real Estate Information Systems (NTREIS)",
    isActive: !0,
    timeZone: Je.TimeZones.US_CENTRAL,
    abodeMLSName: "North Texas Real Estate Information System"
  },
  mibor: {
    resoID: "M00000255",
    constellation1ID: "MIBOR",
    shortName: "MIBOR",
    longName: "MIBOR Broker Listing Cooperative",
    isActive: !0,
    timeZone: Je.TimeZones.US_EASTERN,
    abodeMLSName: "Metropolitan Indiana Board of Realtors"
  },
  palmbeachfl: {
    resoID: void 0,
    constellation1ID: void 0,
    shortName: "PalmBeachFL",
    longName: "Palm Beach Board of REALTORS",
    isActive: !1
  },
  portlandor: {
    resoID: "M00000531",
    constellation1ID: "PortlandOR",
    shortName: "RMLS",
    longName: "Regional Multiple Listing Service (RMLS)",
    isActive: !0,
    timeZone: Je.TimeZones.US_PACIFIC,
    abodeMLSName: "Regional MLS of Oregon"
  },
  maris: {
    resoID: "M00000360",
    constellation1ID: "MARIS",
    shortName: "MARIS MLS",
    longName: "MARIS MLS",
    isActive: !0,
    timeZone: Je.TimeZones.US_CENTRAL,
    abodeMLSName: "Mid America Regional Information System"
  },
  northstarmls: {
    resoID: "M00000345",
    constellation1ID: "NorthStarMLS",
    shortName: "NorthstarMLS",
    longName: "NorthstarMLS",
    isActive: !0,
    timeZone: Je.TimeZones.US_CENTRAL,
    abodeMLSName: "Northstar MLS"
  },
  westpenn: {
    resoID: "M00000549",
    constellation1ID: "WestPenn",
    shortName: "West Penn MultiList",
    longName: "West Penn MultiList",
    isActive: !0,
    timeZone: Je.TimeZones.US_EASTERN,
    abodeMLSName: "West Penn Multi List"
  },
  smartmls: {
    resoID: "M00000127",
    constellation1ID: "SmartMLS",
    shortName: "SmartMLS",
    longName: "SmartMLS",
    isActive: !0,
    timeZone: Je.TimeZones.US_EASTERN,
    abodeMLSName: "SMART MLS"
  },
  claw: {
    resoID: "M00000071",
    constellation1ID: "CLAW",
    shortName: "The MLS",
    longName: "The MLS",
    isActive: !0,
    timeZone: Je.TimeZones.US_PACIFIC,
    abodeMLSName: "Combined L.A./Westside MLS, Inc."
  },
  beachesmls: {
    resoID: "M00000170",
    constellation1ID: "Beaches",
    shortName: "BeachesMLS",
    longName: "BeachesMLS",
    isActive: !0,
    timeZone: Je.TimeZones.US_EASTERN,
    abodeMLSName: "Beaches MLS- FLEX MLS"
  },
  wasatch_front_regional_mls_utahrealestatecom: {
    resoID: "M00000628",
    constellation1ID: "UtahRealEstate",
    shortName: "UtahRealEstatecom",
    longName: "UtahRealEstatecom",
    isActive: !0,
    timeZone: Je.TimeZones.US_MOUNTAIN,
    abodeMLSName: "Wasatch Front Regional MLS (UtahRealEstate.com)"
  },
  utahrealestate: {
    resoID: "M00000628",
    constellation1ID: "UtahRealEstate",
    shortName: "UtahRealEstatecom",
    longName: "UtahRealEstatecom",
    isActive: !0,
    timeZone: Je.TimeZones.US_MOUNTAIN,
    abodeMLSName: "Wasatch Front Regional MLS (UtahRealEstate.com)"
  },
  realcomp: {
    resoID: "M00000316",
    constellation1ID: "Realcomp",
    shortName: "Realcom",
    longName: "Realcomp",
    isActive: !0,
    timeZone: Je.TimeZones.US_EASTERN,
    abodeMLSName: "Realcomp MLS"
  },
  bridgemls: {
    resoID: void 0,
    constellation1ID: void 0,
    shortName: "bridgeMLS",
    longName: "bridgeMLS",
    isActive: !1
  },
  neren: {
    resoID: "M00000445",
    constellation1ID: "NEREN",
    shortName: "PrimeMLS",
    longName: "PrimeMLS",
    isActive: !0,
    timeZone: Je.TimeZones.US_EASTERN,
    abodeMLSName: "New England Real Estate Network"
  },
  brevard_county_mls: {
    resoID: "M00000150",
    constellation1ID: "BrevardMLS",
    longName: "Brevard County MLS (Melborne/Space Coast)",
    shortName: "Brevard County MLS (Melborne/Space Coast)",
    isActive: !0,
    timeZone: Je.TimeZones.US_EASTERN,
    abodeMLSName: "Space Coast Association of Realtors MLS"
  },
  rmlsa: {
    resoID: "M00000852",
    constellation1ID: "RMLSA",
    longName: "RMLS Alliance (IL)",
    shortName: "RMLSA",
    isActive: !0,
    timeZone: Je.TimeZones.US_CENTRAL,
    abodeMLSName: "RMLS Alliance (Peoria Area Association of Reatlors)"
  },
  wyoming_mls: {
    isActive: !0,
    resoID: "M00000679",
    constellation1ID: "WyomingMLS",
    longName: "Wyoming MLS",
    shortName: "Wyoming MLS",
    timeZone: Je.TimeZones.US_MOUNTAIN,
    abodeMLSName: "Wyoming MLS"
  },
  florida_gulf_coast_mls: {
    isActive: !0,
    resoID: "M00000130",
    constellation1ID: "FGCMLS",
    longName: "Florida Gulf Coast MLS",
    shortName: "Florida Gulf Coast MLS",
    timeZone: Je.TimeZones.US_EASTERN,
    abodeMLSName: "SWFL MLS/Florida Gulf Coast MLS (Royal Palm Coast AOR)"
  },
  des_moines: {
    isActive: !0,
    resoID: "M00000204",
    constellation1ID: "DesMoines",
    longName: "Des Moines Area Association of REALTORS",
    shortName: "Des Moines",
    timeZone: Je.TimeZones.US_CENTRAL,
    abodeMLSName: "Des Moines Area Association of Reatlors MLS"
  },
  centralpanhandle: {
    isActive: !0,
    resoID: "M00000159",
    constellation1ID: "CentralPanhandle",
    longName: "Central Panhandle Association of REALTORS",
    shortName: "Central Panhandle",
    timeZone: Je.TimeZones.US_EASTERN,
    abodeMLSName: "Central Panhandle AOR"
  },
  oklahoma_city_metropolitan_board_of_realtors_mlsok: {
    isActive: !0,
    resoID: "M00000519",
    constellation1ID: "MLSOK",
    longName: "Oklahoma City Metropolitan Board of Realtors / MLSOK",
    shortName: "Oklahoma City Metropolitan Board of Realtors / MLSOK",
    timeZone: Je.TimeZones.US_CENTRAL,
    abodeMLSName: "MLS of Oklahoma"
  },
  emerald_coast_association_of_realtors: {
    isActive: !0,
    resoID: "M00000138",
    constellation1ID: "EmeraldCoast",
    longName: "Emerald Coast Association of Realtors",
    shortName: "Emerald Coast Association of Realtors",
    timeZone: Je.TimeZones.US_EASTERN,
    abodeMLSName: "Emerald Coast"
  },
  lexington_bluegrass_association_of_realtors: {
    isActive: !0,
    resoID: "M00000288",
    constellation1ID: "LexingtonKY",
    longName: "Lexington Bluegrass Association of Realtors",
    shortName: "Lexington Bluegrass Association of Realtors",
    timeZone: Je.TimeZones.US_EASTERN,
    abodeMLSName: "Lexington-Bluegrass Association of Realtors"
  },
  triad_multiple_listing_service: {
    isActive: !0,
    resoID: "M00000400",
    constellation1ID: "TriadMLS",
    longName: "Triad Multiple Listing Service",
    shortName: "Triad Multiple Listing Service",
    timeZone: Je.TimeZones.US_EASTERN,
    abodeMLSName: "Triad MLS"
  },
  tucson_association_of_realtors: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Tucson Association of Realtors",
    shortName: "Tucson Association of Realtors"
  },
  tulare_county_association_of_realtors: {
    isActive: !0,
    resoID: "M00000104",
    constellation1ID: void 0,
    longName: "Tulare County Association of Realtors",
    shortName: "Tulare County Association of Realtors",
    abodeMLSName: "Tulare County Association of Realtors MLS"
  },
  tuolumne_county_association_of_realtors: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Tuolumne County Association of Realtors",
    shortName: "Tuolumne County Association of Realtors"
  },
  tuscaloosa: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Tuscaloosa",
    shortName: "Tuscaloosa"
  },
  ulster_county_board_of_realtors: {
    isActive: !0,
    resoID: "M00000479",
    constellation1ID: void 0,
    longName: "Ulster County Board of Realtors",
    shortName: "Ulster County Board of Realtors",
    abodeMLSName: "Hudson Valley Catskill Region MLS (Ulster County Board of Realtors)"
  },
  upper_peninsula_association_of_realtors: {
    isActive: !0,
    resoID: "M00000324",
    constellation1ID: void 0,
    longName: "Upper Peninsula Association of REALTORS",
    shortName: "Upper Peninsula Association of REALTORS",
    abodeMLSName: "Upper Peninsula Association of Realtors"
  },
  upstate_new_york_real_estate_information_services: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Upstate New York Real Estate Information Services (UNYREIS)",
    shortName: "Upstate New York Real Estate Information Services (UNYREIS)"
  },
  vail_board_of_realtors: {
    isActive: !0,
    resoID: "M00000114",
    constellation1ID: void 0,
    longName: "Vail Board of Realtors",
    shortName: "Vail Board of Realtors",
    abodeMLSName: "Vail Multi-List Services"
  },
  ventura_county_regional_data_share: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Ventura County Regional Data Share",
    shortName: "Ventura County Regional Data Share"
  },
  waco_association_of_realtors: {
    isActive: !0,
    resoID: "M00000594",
    constellation1ID: void 0,
    longName: "Waco Association of Realtors",
    shortName: "Waco Association of Realtors",
    abodeMLSName: "Waco Association of Realtors"
  },
  walker_co: {
    isActive: !0,
    resoID: "M00000711",
    constellation1ID: void 0,
    longName: "Walker Co",
    shortName: "Walker Co",
    abodeMLSName: "Walker County Board of Realtors"
  },
  warren_county_board_of_realtors: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Warren County Board of REALTORS",
    shortName: "Warren County Board of REALTORS"
  },
  washington_county_board_of_realtors: {
    isActive: !0,
    resoID: "M00000629",
    constellation1ID: void 0,
    longName: "Washington County Board of Realtors",
    shortName: "Washington County Board of Realtors",
    abodeMLSName: "Washington County Board of Realtors"
  },
  water_wonderland_mls: {
    isActive: !0,
    resoID: "M00000317",
    constellation1ID: void 0,
    longName: "Water Wonderland MLS",
    shortName: "Water Wonderland MLS",
    abodeMLSName: "Water Wonderland Board of Realtors"
  },
  waterloo_cedar_falls_board_of_realtors: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Waterloo Cedar Falls Board of Realtors",
    shortName: "Waterloo Cedar Falls Board of Realtors"
  },
  west_branch_valley_association_of_realtors: {
    isActive: !0,
    resoID: "M00000799",
    constellation1ID: void 0,
    longName: "West Branch Valley Association of Realtors",
    shortName: "West Branch Valley Association of Realtors",
    abodeMLSName: "West Branch Valley AOR"
  },
  west_central_association_of_realtors_sedaliawarsaw_mls: {
    isActive: !0,
    resoID: "M00000735",
    constellation1ID: void 0,
    longName: "West Central Association of REALTORS (MO) - Sedalia/Warsaw MLS",
    shortName: "West Central Association of REALTORS (MO) - Sedalia/Warsaw MLS",
    abodeMLSName: "West Central Association of Realtors"
  },
  west_metro_board_of_realtors_ga: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "West Metro Board of Realtors, GA",
    shortName: "West Metro Board of Realtors, GA"
  },
  western_regional_information_systems_technology: {
    isActive: !0,
    resoID: "M00000506",
    constellation1ID: void 0,
    longName: "Western Regional Information Systems & Technology",
    shortName: "Western Regional Information Systems & Technology",
    abodeMLSName: "Western Regional Information System & Technology"
  },
  western_upstate_multiple_listing_service: {
    isActive: !0,
    resoID: "M00000556",
    constellation1ID: void 0,
    longName: "Western Upstate Multiple Listing Service",
    shortName: "Western Upstate Multiple Listing Service",
    abodeMLSName: "Western Upstate MLS"
  },
  white_mountain_assoc_of_realtors: {
    isActive: !0,
    resoID: "M00000042",
    constellation1ID: void 0,
    longName: "White Mountain Assoc. of Realtors",
    shortName: "White Mountain Assoc. of Realtors",
    abodeMLSName: "White Mountain Association of Realtors MLS"
  },
  wichita_falls_association_of_realtors: {
    isActive: !0,
    resoID: "M00000625",
    constellation1ID: void 0,
    longName: "Wichita Falls Association of REALTORS",
    shortName: "Wichita Falls Association of REALTORS",
    abodeMLSName: "Wichita Falls AOR"
  },
  willamette_valley_mls: {
    isActive: !0,
    resoID: "M00000532",
    constellation1ID: void 0,
    longName: "Willamette Valley MLS",
    shortName: "Willamette Valley MLS",
    abodeMLSName: "Willamette Valley MLS"
  },
  williamsburg_area_association_of_realtors: {
    isActive: !0,
    resoID: "M00000858",
    constellation1ID: void 0,
    longName: "Williamsburg Area Association of Realtors",
    shortName: "Williamsburg Area Association of Realtors",
    abodeMLSName: "Williamsburg Board of Realtors"
  },
  yakima_association_of_realtors: {
    isActive: !0,
    resoID: "M00000656",
    constellation1ID: void 0,
    longName: "Yakima Association of Realtors",
    shortName: "Yakima Association of Realtors",
    abodeMLSName: "Yakima Association of Realtors MLS"
  },
  yuma_mls: {
    isActive: !0,
    resoID: "M00000050",
    constellation1ID: void 0,
    longName: "Yuma MLS",
    shortName: "Yuma MLS",
    abodeMLSName: "Yuma Association of Realtors MLS"
  },
  ack_association_of_realtors_northern_mi_mls: {
    isActive: !0,
    resoID: "M00000315",
    constellation1ID: void 0,
    longName: "ACK Association of Realtors/Northern MI MLS",
    shortName: "ACK Association of Realtors/Northern MI MLS",
    abodeMLSName: "ACK Association of Realtors/Northern MI MLS"
  },
  adirondack_champlain_valley_mls: {
    isActive: !0,
    resoID: "M00000483",
    constellation1ID: void 0,
    longName: "Adirondack-Champlain Valley MLS",
    shortName: "Adirondack-Champlain Valley MLS",
    abodeMLSName: "Adirondack-Champlain Valley MLS"
  },
  aiken_board_of_realtors: {
    isActive: !0,
    resoID: "M00000555",
    constellation1ID: void 0,
    longName: "Aiken Board of Realtors",
    shortName: "Aiken Board of Realtors",
    abodeMLSName: "Aiken Board of Realtors"
  },
  alaska_mls: {
    isActive: !0,
    resoID: "M00000001",
    constellation1ID: void 0,
    longName: "Alaska MLS",
    shortName: "Alaska MLS",
    abodeMLSName: "Alaska MLS"
  },
  albany_bor_southwest_ga_mls: {
    isActive: !0,
    resoID: "M00000172",
    constellation1ID: void 0,
    longName: "Albany BOR/Southwest GA MLS",
    shortName: "Albany BOR/Southwest GA MLS",
    abodeMLSName: "Albany BOR/Southwest GA MLS"
  },
  allegheny_valley_board_of_realtors: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Allegheny Valley Board of REALTORS",
    shortName: "Allegheny Valley Board of REALTORS",
    abodeMLSName: void 0
  },
  amarillo_association_of_realtors: {
    isActive: !0,
    resoID: "M00000588",
    constellation1ID: void 0,
    longName: "Amarillo Association of Realtors",
    shortName: "Amarillo Association of Realtors",
    abodeMLSName: "Amarillo Association of Realtors"
  },
  amelia_island_nassau_county_assoc_of_realtors: {
    isActive: !0,
    resoID: "M00000136",
    constellation1ID: void 0,
    longName: "Amelia Island",
    shortName: "Amelia Island",
    abodeMLSName: "Amelia Island"
  },
  ann_arbor_area_board_of_realtors: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Ann Arbor Area Board of Realtors",
    shortName: "Ann Arbor Area Board of Realtors",
    abodeMLSName: void 0
  },
  ashland_board_of_realtors_oh: {
    isActive: !0,
    resoID: "M00000278",
    constellation1ID: void 0,
    longName: "Ashland Area AOR",
    shortName: "Ashland Area AOR",
    abodeMLSName: "Ashland Area AOR"
  },
  aspen_glenwood_springs_mls_co: {
    isActive: !0,
    resoID: "M00000109",
    constellation1ID: void 0,
    longName: "Aspen/Glenwood Springs MLS",
    shortName: "Aspen/Glenwood Springs MLS",
    abodeMLSName: "Aspen/Glenwood Springs MLS"
  },
  athens_area_association_or_realtors_: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Athens Area Association or Realtors *",
    shortName: "Athens Area Association or Realtors *",
    abodeMLSName: void 0
  },
  athens_board_of_realtors_oh: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Athens Board of REALTORS, OH",
    shortName: "Athens Board of REALTORS, OH",
    abodeMLSName: void 0
  },
  badlands_board_of_realtors: {
    isActive: !0,
    resoID: "M00000427",
    constellation1ID: void 0,
    longName: "Badlands Board of Realtors",
    shortName: "Badlands Board of Realtors",
    abodeMLSName: "Badlands Board of Realtors"
  },
  bagnell_dam_association_of_realtors: {
    isActive: !0,
    resoID: "M00000355",
    constellation1ID: void 0,
    longName: "Bagnell Dam Association of Realtors",
    shortName: "Bagnell Dam Association of Realtors",
    abodeMLSName: "Bagnell Dam Association of Realtors"
  },
  bakersfield_association_of_realtors: {
    isActive: !0,
    resoID: "M00000053",
    constellation1ID: void 0,
    longName: "Bakersfield Association of Realtors/Golden Empire MLS",
    shortName: "Bakersfield Association of Realtors/Golden Empire MLS",
    abodeMLSName: "Bakersfield Association of Realtors/Golden Empire MLS"
  },
  baldwin_county_association: {
    isActive: !0,
    resoID: "M00000022",
    constellation1ID: void 0,
    longName: "Baldwin Realtors MLS",
    shortName: "Baldwin Realtors MLS",
    abodeMLSName: "Baldwin Realtors MLS"
  },
  bay_area_real_estate_information: {
    isActive: !0,
    resoID: "M00000097",
    constellation1ID: void 0,
    longName: "Bay Area Real Estate Information Services",
    shortName: "Bay Area Real Estate Information Services",
    abodeMLSName: "Bay Area Real Estate Information Services"
  },
  bay_county: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Bay County (Panama City MLS)",
    shortName: "Bay County (Panama City MLS)",
    abodeMLSName: void 0
  },
  bay_east_aor_contra_costa_aor: {
    isActive: !0,
    resoID: "M00000105",
    constellation1ID: void 0,
    longName: "Bay East AOR/Contra Costa AOR",
    shortName: "Bay East AOR/Contra Costa AOR",
    abodeMLSName: "Bay East AOR/Contra Costa AOR"
  },
  beaches_mls_matrix_mls: {
    isActive: !0,
    resoID: "M00000170",
    constellation1ID: void 0,
    longName: "Beaches MLS- MATRIX MLS",
    shortName: "Beaches MLS- MATRIX MLS",
    abodeMLSName: "Beaches MLS- MATRIX MLS"
  },
  beaumont_board_of_realtors: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Beaumont Board of REALTORS",
    shortName: "Beaumont Board of REALTORS",
    abodeMLSName: void 0
  },
  berkshire_county_ma: {
    isActive: !0,
    resoID: "M00000305",
    constellation1ID: void 0,
    longName: "Berkshire Realtors",
    shortName: "Berkshire Realtors",
    abodeMLSName: "Berkshire Realtors"
  },
  big_bear_mls_ca: {
    isActive: !0,
    resoID: "M00000055",
    constellation1ID: void 0,
    longName: "Big Bear AOR",
    shortName: "Big Bear AOR",
    abodeMLSName: "Big Bear AOR"
  },
  billings_multiple_listing_service: {
    isActive: !0,
    resoID: "M00000378",
    constellation1ID: void 0,
    longName: "Billings Association of Realtors",
    shortName: "Billings Association of Realtors",
    abodeMLSName: "Billings Association of Realtors"
  },
  birmingham: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Birmingham",
    shortName: "Birmingham",
    abodeMLSName: void 0
  },
  black_hills_association_of_realtors: {
    isActive: !0,
    resoID: "M00000571",
    constellation1ID: void 0,
    longName: "Black Hills Association of Realtors",
    shortName: "Black Hills Association of Realtors",
    abodeMLSName: "Black Hills Association of Realtors"
  },
  bonita_springs_estero_association_of_realtors: {
    isActive: !0,
    resoID: "M00000821",
    constellation1ID: void 0,
    longName: "Bonita Springs Association of Realtors MLS",
    shortName: "Bonita Springs Association of Realtors MLS",
    abodeMLSName: "Bonita Springs Association of Realtors MLS"
  },
  brooklyn_bor: {
    isActive: !0,
    resoID: "M00000471",
    constellation1ID: void 0,
    longName: "Brooklyn BOR",
    shortName: "Brooklyn BOR",
    abodeMLSName: "Brooklyn BOR"
  },
  bryan_college_station_regional_aor_bryancollege_station_regional_mls: {
    isActive: !0,
    resoID: "M00000592",
    constellation1ID: void 0,
    longName: "Bryan College Station Association of Realtors",
    shortName: "Bryan College Station Association of Realtors",
    abodeMLSName: "Bryan College Station Association of Realtors"
  },
  buffalo_niagara_association_of_realtors: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Buffalo Niagara Association of Realtors",
    shortName: "Buffalo Niagara Association of Realtors",
    abodeMLSName: void 0
  },
  burlingtonalamance_mls: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Burlington/Alamance MLS",
    shortName: "Burlington/Alamance MLS",
    abodeMLSName: void 0
  },
  calaveras_county_association_of_realtors: {
    isActive: !0,
    resoID: "M00000052",
    constellation1ID: void 0,
    longName: "Calaveras County Association of Realtors MLS",
    shortName: "Calaveras County Association of Realtors MLS",
    abodeMLSName: "Calaveras County Association of Realtors MLS"
  },
  california_desert_association_of_realtors: {
    isActive: !0,
    resoID: "M00000093",
    constellation1ID: void 0,
    longName: "California Data Share",
    shortName: "California Data Share",
    abodeMLSName: "California Data Share"
  },
  campbell_county_board_of_realtors_northeast_wyoming_realtor_alliance: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Campbell County Board of Realtors / Northeast Wyoming REALTOR Alliance",
    shortName: "Campbell County Board of Realtors / Northeast Wyoming REALTOR Alliance",
    abodeMLSName: void 0
  },
  cape_cod_islands_association_of_realtors: {
    isActive: !0,
    resoID: "M00000307",
    constellation1ID: void 0,
    longName: "Cape Cod and the Islands Association of Realtors",
    shortName: "Cape Cod and the Islands Association of Realtors",
    abodeMLSName: "Cape Cod and the Islands Association of Realtors"
  },
  cape_fear_realtors_multiple_listing_service: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Cape Fear REALTORS Multiple Listing Service (North Carolina Regional MLS)",
    shortName: "Cape Fear REALTORS Multiple Listing Service (North Carolina Regional MLS)",
    abodeMLSName: void 0
  },
  cape_may_county_association_of_realtors: {
    isActive: !0,
    resoID: "M00000447",
    constellation1ID: void 0,
    longName: "Cape May County MLS",
    shortName: "Cape May County MLS",
    abodeMLSName: "Cape May County MLS"
  },
  carolina_smokies_aor: {
    isActive: !0,
    resoID: "M00000395",
    constellation1ID: void 0,
    longName: "Carolina Smokies AOR",
    shortName: "Carolina Smokies AOR",
    abodeMLSName: "Carolina Smokies AOR"
  },
  carpet_capital_aor: {
    isActive: !0,
    resoID: "M00000752",
    constellation1ID: void 0,
    longName: "Carpet Capital AOR",
    shortName: "Carpet Capital AOR",
    abodeMLSName: "Carpet Capital AOR"
  },
  cedar_rapids: {
    isActive: !0,
    resoID: "M00000200",
    constellation1ID: void 0,
    longName: "Cedar Rapids AOR",
    shortName: "Cedar Rapids AOR",
    abodeMLSName: "Cedar Rapids AOR"
  },
  central_arizona_board_of_realtors: {
    isActive: !0,
    resoID: "M00000043",
    constellation1ID: void 0,
    longName: "Central Arizona Association of Realtors MLS",
    shortName: "Central Arizona Association of Realtors MLS",
    abodeMLSName: "Central Arizona Association of Realtors MLS"
  },
  central_iowa_board_of_realtors: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Central Iowa Board of Realtors",
    shortName: "Central Iowa Board of Realtors",
    abodeMLSName: void 0
  },
  central_ga_bor_mls: {
    isActive: !0,
    resoID: "M00000190",
    constellation1ID: void 0,
    longName: "Central GA BOR MLS",
    shortName: "Central GA BOR MLS",
    abodeMLSName: "Central GA BOR MLS"
  },
  central_hill_country_association_of_realtors: {
    isActive: !0,
    resoID: "M00000596",
    constellation1ID: void 0,
    longName: "Central Hill Country Association of Realtors",
    shortName: "Central Hill Country Association of Realtors",
    abodeMLSName: "Central Hill Country Association of Realtors"
  },
  central_jersey_mls: {
    isActive: !0,
    resoID: "M00000450",
    constellation1ID: void 0,
    longName: "Central Jersey MLS",
    shortName: "Central Jersey MLS",
    abodeMLSName: "Central Jersey MLS"
  },
  central_new_york_information_services: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Central New York Information Services (Jefferson Lewis Board of Realtors MLS)",
    shortName: "Central New York Information Services (Jefferson Lewis Board of Realtors MLS)",
    abodeMLSName: void 0
  },
  central_oregon_association_of_realtors: {
    isActive: !0,
    resoID: "M00000525",
    constellation1ID: void 0,
    longName: "Central Oregon Association of Realtors",
    shortName: "Central Oregon Association of Realtors",
    abodeMLSName: "Central Oregon Association of Realtors"
  },
  central_susquehanna_valley_board_of_realtors: {
    isActive: !0,
    resoID: "M00000538",
    constellation1ID: void 0,
    longName: "Central Susquehanna Valley BOR",
    shortName: "Central Susquehanna Valley BOR",
    abodeMLSName: "Central Susquehanna Valley BOR"
  },
  central_tennessee_west_aor: {
    isActive: !0,
    resoID: "M00000581",
    constellation1ID: void 0,
    longName: "Central Tennessee West AOR",
    shortName: "Central Tennessee West AOR",
    abodeMLSName: "Central Tennessee West AOR"
  },
  central_virginia_regional_mls: {
    isActive: !0,
    resoID: "M00000643",
    constellation1ID: void 0,
    longName: "Central Virginia Regional MLS",
    shortName: "Central Virginia Regional MLS",
    abodeMLSName: "Central Virginia Regional MLS"
  },
  central_wisconsin_multiple_listing_service: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Central Wisconsin Multiple Listing Service",
    shortName: "Central Wisconsin Multiple Listing Service",
    abodeMLSName: void 0
  },
  centre_county_association_of_realtors_pa: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Centre County Association of Realtors, PA",
    shortName: "Centre County Association of Realtors, PA",
    abodeMLSName: void 0
  },
  centris: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Centris",
    shortName: "Centris",
    abodeMLSName: void 0
  },
  charleston_trident_mls_chs_regional: {
    isActive: !0,
    resoID: "M00000558",
    constellation1ID: void 0,
    longName: "Charleston-Trident Association of Realtors",
    shortName: "Charleston-Trident Association of Realtors",
    abodeMLSName: "Charleston-Trident Association of Realtors"
  },
  charlottesville_area_association_of_realtors: {
    isActive: !0,
    resoID: "M00000633",
    constellation1ID: void 0,
    longName: "Charlottesville Association of Realtors",
    shortName: "Charlottesville Association of Realtors",
    abodeMLSName: "Charlottesville Association of Realtors"
  },
  chattanooga_association_of_realtors_tn: {
    isActive: !0,
    resoID: "M00000575",
    constellation1ID: void 0,
    longName: "Chattanooga Association of Realtors, TN",
    shortName: "Chattanooga Association of Realtors, TN",
    abodeMLSName: "Greater Chattanooga AOR"
  },
  cheyenne_board_of_realtors: {
    isActive: !0,
    resoID: "M00000675",
    constellation1ID: void 0,
    longName: "Cheyenne Board of Realtors",
    shortName: "Cheyenne Board of Realtors",
    abodeMLSName: "Cheyenne Board of Realtors"
  },
  classic_athens: {
    isActive: !0,
    resoID: "M00000177",
    constellation1ID: void 0,
    longName: "Classic / Athens",
    shortName: "Classic / Athens",
    abodeMLSName: "Classic / Athens"
  },
  clatsop_mls_or_clatsop_association_of_realtors: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Clatsop MLS, OR / Clatsop Association of REALTORS",
    shortName: "Clatsop MLS, OR / Clatsop Association of REALTORS",
    abodeMLSName: void 0
  },
  coastal_carolinas_association_of_realtors_sc: {
    isActive: !0,
    resoID: "M00000565",
    constellation1ID: void 0,
    longName: "Coastal Carolina AOR",
    shortName: "Coastal Carolina AOR",
    abodeMLSName: "Coastal Carolina AOR"
  },
  coeur_d_alene_association_of_realtors: {
    isActive: !0,
    resoID: "M00000227",
    constellation1ID: void 0,
    longName: "Coeur d'Alene Association of Realtors",
    shortName: "Coeur d'Alene Association of Realtors",
    abodeMLSName: "Coeur d'Alene Association of Realtors"
  },
  colorado_real_estate_network: {
    isActive: !0,
    resoID: "M00000684",
    constellation1ID: void 0,
    longName: "Colorado Real Estate Network",
    shortName: "Colorado Real Estate Network",
    abodeMLSName: "Colorado Real Estate Network"
  },
  columbia_board_of_realtors: {
    isActive: !0,
    resoID: "M00000349",
    constellation1ID: void 0,
    longName: "Columbia Board of REALTORS",
    shortName: "Columbia Board of REALTORS",
    abodeMLSName: "Columbia Board of REALTORS"
  },
  columbia_county_northern_dutchess_mls: {
    isActive: !0,
    resoID: "M00000476",
    constellation1ID: void 0,
    longName: "Columbia Greene North Dutchess MLS",
    shortName: "Columbia Greene North Dutchess MLS",
    abodeMLSName: "Columbia Greene North Dutchess MLS"
  },
  columbus_and_central_ohio_regional_mls: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Columbus and Central Ohio Regional MLS",
    shortName: "Columbus and Central Ohio Regional MLS",
    abodeMLSName: void 0
  },
  columbus_board_of_realtors_ga: {
    isActive: !0,
    resoID: "M00000753",
    constellation1ID: void 0,
    longName: "Columbus BOR",
    shortName: "Columbus BOR",
    abodeMLSName: "Columbus BOR"
  },
  columbus_ne_board_of_realtors: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Columbus NE Board of Realtors",
    shortName: "Columbus NE Board of Realtors",
    abodeMLSName: void 0
  },
  commercial_and_industrial_real_estate_brokers: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Commercial and Industrial Real Estate Brokers",
    shortName: "Commercial and Industrial Real Estate Brokers",
    abodeMLSName: void 0
  },
  consolidated_mls: {
    isActive: !0,
    resoID: "M00000559",
    constellation1ID: void 0,
    longName: "Consolidated MLS",
    shortName: "Consolidated MLS",
    abodeMLSName: "Consolidated MLS"
  },
  cooperative_arkansas_realtors_mls: {
    isActive: !0,
    resoID: "M00000031",
    constellation1ID: void 0,
    longName: "Cooperative Arkansas Realtors MLS",
    shortName: "Cooperative Arkansas Realtors MLS",
    abodeMLSName: "Cooperative Arkansas Realtors MLS"
  },
  corpus_christi_association_of_realtors_south_texas_mls: {
    isActive: !0,
    resoID: "M00000593",
    constellation1ID: void 0,
    longName: "Corpus Christi Board of Realtors (South Texas MLS)",
    shortName: "Corpus Christi Board of Realtors (South Texas MLS)",
    abodeMLSName: "Corpus Christi Board of Realtors (South Texas MLS)"
  },
  darien_mls: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Darien MLS",
    shortName: "Darien MLS",
    abodeMLSName: void 0
  },
  dayton_realtors: {
    isActive: !0,
    resoID: "M00000496",
    constellation1ID: void 0,
    longName: "Dayton Area Board of Realtors",
    shortName: "Dayton Area Board of Realtors",
    abodeMLSName: "Dayton Area Board of Realtors"
  },
  daytona_beach_area_association: {
    isActive: !0,
    resoID: "M00000140",
    constellation1ID: void 0,
    longName: "Daytona Beach Area Association of REALTORS",
    shortName: "Daytona Beach Area Association of REALTORS",
    abodeMLSName: "Daytona Beach Area Association of REALTORS"
  },
  desert_area_mls: {
    isActive: !0,
    resoID: "M00000082",
    constellation1ID: void 0,
    longName: "Desert Area MLS",
    shortName: "Desert Area MLS",
    abodeMLSName: "Desert Area MLS"
  },
  door_county_board_of_realtors: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Door County Board of REALTORS",
    shortName: "Door County Board of REALTORS",
    abodeMLSName: void 0
  },
  dothan_mls: {
    isActive: !0,
    resoID: "M00000013",
    constellation1ID: void 0,
    longName: "Dothan MLS",
    shortName: "Dothan MLS",
    abodeMLSName: "Southeast Alabama AOR/MLS (Dothan)"
  },
  east_alabama_board_of_realtors_al: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "East Alabama Board of REALTORS, AL",
    shortName: "East Alabama Board of REALTORS, AL",
    abodeMLSName: void 0
  },
  east_central_association_of_realtors: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "East Central Association of Realtors",
    shortName: "East Central Association of Realtors",
    abodeMLSName: void 0
  },
  east_central_iowa: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "East Central Iowa",
    shortName: "East Central Iowa",
    abodeMLSName: void 0
  },
  eastern_shore_aor: {
    isActive: !0,
    resoID: "M00000631",
    constellation1ID: void 0,
    longName: "Eastern Shore AOR",
    shortName: "Eastern Shore AOR",
    abodeMLSName: "Eastern Shore AOR"
  },
  fargo_moorhead_area_association_of_realtors: {
    isActive: !0,
    resoID: "M00000428",
    constellation1ID: void 0,
    longName: "Fargo Morehead Area Association of Realtors",
    shortName: "Fargo Morehead Area Association of Realtors",
    abodeMLSName: "Fargo Morehead Area Association of Realtors"
  },
  fayetteville_association_of_realtors: {
    isActive: !0,
    resoID: "M00000394",
    constellation1ID: void 0,
    longName: "Longleaf Pine REALTORS (Fayetteville)",
    shortName: "Longleaf Pine REALTORS (Fayetteville)",
    abodeMLSName: "Fayetteville Association of Realtors (Longleaf Pine REALTORS)"
  },
  firelands_association_of_realtors: {
    isActive: !0,
    resoID: "M00000504",
    constellation1ID: void 0,
    longName: "Firelands Association of Realtors",
    shortName: "Firelands Association of Realtors",
    abodeMLSName: "Firelands Association of Realtors"
  },
  flint_hills_mls: {
    isActive: !0,
    resoID: "M00000271",
    constellation1ID: void 0,
    longName: "Flint Hills AOR (aka Manhattan Area AOR)",
    shortName: "Flint Hills AOR (aka Manhattan Area AOR)",
    abodeMLSName: "Flint Hills AOR (aka Manhattan Area AOR)"
  },
  florida_keys_multiple_listing_service: {
    isActive: !0,
    resoID: "M00000168",
    constellation1ID: void 0,
    longName: "Florida Keys MLS",
    shortName: "Florida Keys MLS",
    abodeMLSName: "Florida Keys MLS"
  },
  fort_smith_bor_dba_western_river_valley_bor: {
    isActive: !0,
    resoID: "M00000853",
    constellation1ID: void 0,
    longName: "Fort Smith BOR dba Western River Valley BOR",
    shortName: "Fort Smith BOR dba Western River Valley BOR",
    abodeMLSName: "Fort Smith BOR dba Western River Valley BOR"
  },
  franklin_and_gulf_counties: {
    isActive: !0,
    resoID: "M00000129",
    constellation1ID: void 0,
    longName: "Franklin and Gulf Counties",
    shortName: "Franklin and Gulf Counties",
    abodeMLSName: "Franklin and Gulf Counties"
  },
  freeport_galena: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Freeport Galena (Realtor Association of Northwestern Illinois)",
    shortName: "Freeport Galena (Realtor Association of Northwestern Illinois)",
    abodeMLSName: void 0
  },
  fresno_association_of_realtors: {
    isActive: !0,
    resoID: "M00000060",
    constellation1ID: void 0,
    longName: "Fresno Association of REALTORS",
    shortName: "Fresno Association of REALTORS",
    abodeMLSName: "Fresno Association of REALTORS"
  },
  gallatin_association_of_realtors_big_sky_country_mls: {
    isActive: !0,
    resoID: "M00000379",
    constellation1ID: void 0,
    longName: "Gallatin Association of Realtors (Big Sky Country MLS)",
    shortName: "Gallatin Association of Realtors (Big Sky Country MLS)",
    abodeMLSName: "Gallatin Association of Realtors (Big Sky Country MLS)"
  },
  galveston_association_of_realtors: {
    isActive: !0,
    resoID: "M00000597",
    constellation1ID: void 0,
    longName: "Galveston Board of Realtors",
    shortName: "Galveston Board of Realtors",
    abodeMLSName: "Galveston Board of Realtors"
  },
  golden_isles_association_of_realtors: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Golden Isles Association of Realtors",
    shortName: "Golden Isles Association of Realtors",
    abodeMLSName: void 0
  },
  global_mls: {
    isActive: !0,
    resoID: "M00000468",
    constellation1ID: void 0,
    longName: "Global MLS",
    shortName: "Global MLS",
    abodeMLSName: "Global MLS"
  },
  grand_forks_area_association_of_realtors: {
    isActive: !0,
    resoID: "M00000429",
    constellation1ID: void 0,
    longName: "Grand Forks Area Association of Realtors",
    shortName: "Grand Forks Area Association of Realtors",
    abodeMLSName: "Grand Forks Area Association of Realtors"
  },
  grand_island_board_of_realtors: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Grand Island Board of Realtors",
    shortName: "Grand Island Board of Realtors",
    abodeMLSName: void 0
  },
  grand_junction_area_realtor_association: {
    isActive: !0,
    resoID: "M00000729",
    constellation1ID: void 0,
    longName: "Grand Junction Area Realtor Association",
    shortName: "Grand Junction Area Realtor Association",
    abodeMLSName: "Grand Junction Association of Realtors MLS"
  },
  great_north_mls: {
    isActive: !0,
    resoID: "M00000107",
    constellation1ID: void 0,
    longName: "Great North MLS",
    shortName: "Great North MLS",
    abodeMLSName: "Great North MLS"
  },
  great_plains_mls_omaha: {
    isActive: !0,
    resoID: "M00000441",
    constellation1ID: void 0,
    longName: "Great Plains Regional MLS",
    shortName: "Great Plains Regional MLS",
    abodeMLSName: "Great Plains Regional MLS"
  },
  greater_alabama_mls: {
    isActive: !0,
    resoID: "M00000010",
    constellation1ID: void 0,
    longName: "Greater Alabama MLS",
    shortName: "Greater Alabama MLS",
    abodeMLSName: "Greater Alabama MLS"
  },
  greater_antelope_valley_association_of_realtors: {
    isActive: !0,
    resoID: "M00000084",
    constellation1ID: void 0,
    longName: "Greater Antelope Valley Association of Realtors",
    shortName: "Greater Antelope Valley Association of Realtors",
    abodeMLSName: "Greater Antelope Valley Association of Realtors"
  },
  greater_augusta_association_of_realtors: {
    isActive: !0,
    resoID: "M00000176",
    constellation1ID: void 0,
    longName: "Greater Augusta Board of Realtors MLS",
    shortName: "Greater Augusta Board of Realtors MLS",
    abodeMLSName: "Greater Augusta Board of Realtors MLS"
  },
  greater_baton_rouge_aor: {
    isActive: !0,
    resoID: "M00000298",
    constellation1ID: void 0,
    longName: "Greater Baton Rouge Association of Realtors",
    shortName: "Greater Baton Rouge Association of Realtors",
    abodeMLSName: "Greater Baton Rouge Association of Realtors"
  },
  greater_binghamton_aor: {
    isActive: !0,
    resoID: "M00000470",
    constellation1ID: void 0,
    longName: "Greater Binghamton AOR",
    shortName: "Greater Binghamton AOR",
    abodeMLSName: "Greater Binghamton AOR"
  },
  greater_capital_region_multiple_listing_service: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Greater Capital Region Multiple Listing Service",
    shortName: "Greater Capital Region Multiple Listing Service"
  },
  greater_el_paso_association_of_realtors: {
    isActive: !0,
    resoID: "M00000595",
    constellation1ID: void 0,
    longName: "Greater El Paso Association of Realtors",
    shortName: "Greater El Paso Association of Realtors",
    abodeMLSName: "Greater El Paso Association of Realtors"
  },
  greater_erie_board_of_realtors_oh: {
    isActive: !0,
    resoID: "M00000540",
    constellation1ID: void 0,
    longName: "Greater Erie BOR",
    shortName: "Greater Erie BOR",
    abodeMLSName: "Greater Erie BOR"
  },
  greater_fairbanks_board_of_realtors_mls: {
    isActive: !0,
    resoID: "M00000002",
    constellation1ID: void 0,
    longName: "Greater Fairbanks Board of Realtors MLS",
    shortName: "Greater Fairbanks Board of Realtors MLS",
    abodeMLSName: "Greater Fairbanks Board of Realtors MLS"
  },
  greater_greenville_association_mls: {
    isActive: !0,
    resoID: "M00000365",
    constellation1ID: void 0,
    longName: "Greater Greenville Association of Realtors",
    shortName: "Greater Greenville Association of Realtors",
    abodeMLSName: "Greater Greenville Association of Realtors"
  },
  greater_lansing_association_of_realtors: {
    isActive: !0,
    resoID: "M00000322",
    constellation1ID: void 0,
    longName: "Greater Lansing Association of Realtors",
    shortName: "Greater Lansing Association of Realtors",
    abodeMLSName: "Greater Lansing Association of Realtors"
  },
  greater_las_vegas_association_of_realtors: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Greater Las Vegas Association of Realtors",
    shortName: "Greater Las Vegas Association of Realtors",
    abodeMLSName: void 0
  },
  greater_lehigh_association_of_realtors: {
    isActive: !0,
    resoID: "M00000534",
    constellation1ID: void 0,
    longName: "Greater Lehigh Valley MLS",
    shortName: "Greater Lehigh Valley MLS",
    abodeMLSName: "Greater Lehigh Valley MLS"
  },
  greater_louisville_association_of_realtors: {
    isActive: !0,
    resoID: "M00000290",
    constellation1ID: void 0,
    longName: "Greater Louisville Association of Realtors",
    shortName: "Greater Louisville Association of Realtors",
    abodeMLSName: "Greater Louisville Association of Realtors"
  },
  greater_mcallen_association_of_realtors: {
    isActive: !0,
    resoID: "M00000608",
    constellation1ID: void 0,
    longName: "Greater McAllen Association of Realtors",
    shortName: "Greater McAllen Association of Realtors",
    abodeMLSName: "Greater McAllen Association of Realtors"
  },
  greater_northwest_indiana_association_of_realtors: {
    isActive: !0,
    resoID: "M00000259",
    constellation1ID: void 0,
    longName: "Greater Northwest Indiana Association of Realtors",
    shortName: "Greater Northwest Indiana Association of Realtors",
    abodeMLSName: "Greater Northwest Indiana Association of Realtors"
  },
  greater_pocatello_association_on_realtors: {
    isActive: !0,
    resoID: "M00000233",
    constellation1ID: void 0,
    longName: "Greater Pocatello Association on Realtors",
    shortName: "Greater Pocatello Association on Realtors",
    abodeMLSName: "Pocatello Board of Realtors"
  },
  greater_scranton_board_of_realtors: {
    isActive: !0,
    resoID: "M00000536",
    constellation1ID: void 0,
    longName: "Greater Scranton Board of Realtors",
    shortName: "Greater Scranton Board of Realtors",
    abodeMLSName: "Greater Scranton Board of Realtors"
  },
  greater_southern_mls: {
    isActive: !0,
    resoID: "M00000083",
    constellation1ID: void 0,
    longName: "Greater Southern MLS (Lake Charles)/Southwest Louisiana Association of Realtors",
    shortName: "Greater Southern MLS (Lake Charles)/Southwest Louisiana Association of Realtors",
    abodeMLSName: "Greater Southern MLS (Lake Charles)/Southwest Louisiana Association of Realtors"
  },
  greater_tyler_association_of_realtors: {
    isActive: !0,
    resoID: "M00000621",
    constellation1ID: void 0,
    longName: "Greater Tyler Association of Realtors",
    shortName: "Greater Tyler Association of Realtors",
    abodeMLSName: "Greater Tyler Association of Realtors"
  },
  greenbrier_valley_board_of_realtors: {
    isActive: !0,
    resoID: "M00000669",
    constellation1ID: void 0,
    longName: "Greenbrier Valley Board of Realtors",
    shortName: "Greenbrier Valley Board of Realtors",
    abodeMLSName: "Greenbrier Valley Board of Realtors"
  },
  greenwich_association_of_realtors: {
    isActive: !0,
    resoID: "M00000125",
    constellation1ID: void 0,
    longName: "Greenwich Board of Realtors MLS",
    shortName: "Greenwich Board of Realtors MLS",
    abodeMLSName: "Greenwich Board of Realtors MLS"
  },
  greenwood_association: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Greenwood Association",
    shortName: "Greenwood Association",
    abodeMLSName: void 0
  },
  harlingen_board_of_realtors_mls_rio_grande_valley_multiple_listing_service: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Harlingen Board of Realtors MLS / Rio Grande Valley Multiple Listing Service",
    shortName: "Harlingen Board of Realtors MLS / Rio Grande Valley Multiple Listing Service",
    abodeMLSName: void 0
  },
  hastings_board_of_realtors: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Hastings Board of Realtors",
    shortName: "Hastings Board of Realtors",
    abodeMLSName: void 0
  },
  gulf_coast_mls: {
    isActive: !0,
    resoID: "M00000018",
    constellation1ID: void 0,
    longName: "Gulf Coast MLS",
    shortName: "Gulf Coast MLS",
    abodeMLSName: "Gulf Coast MLS"
  },
  hattiesburg_area_association_of_realtors: {
    isActive: !0,
    resoID: "M00000367",
    constellation1ID: void 0,
    longName: "Hattiesburg Area Association of Realtors",
    shortName: "Hattiesburg Area Association of Realtors",
    abodeMLSName: "Hattiesburg Area Association of Realtors"
  },
  hawaii_information_service_mls: {
    isActive: !0,
    resoID: "M00000193",
    constellation1ID: void 0,
    longName: "Hawaii Information System",
    shortName: "Hawaii Information System",
    abodeMLSName: "Hawaii Information System"
  },
  heart_of_missouri_board_of_realtors: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Heart of Missouri Board of REALTORS",
    shortName: "Heart of Missouri Board of REALTORS",
    abodeMLSName: void 0
  },
  heart_of_iowa_association_of_realtors: {
    isActive: !0,
    resoID: "M00000205",
    constellation1ID: void 0,
    longName: "Heart of Iowa Association of Realtors",
    shortName: "Heart of Iowa Association of Realtors",
    abodeMLSName: "Heart of Iowa Association of Realtors"
  },
  henderson_county_board_of_realtors: {
    isActive: !0,
    resoID: "M00000740",
    constellation1ID: void 0,
    longName: "Henderson County BOR",
    shortName: "Henderson County BOR",
    abodeMLSName: "Henderson County BOR"
  },
  hernando_county_association_of_realtors: {
    isActive: !0,
    resoID: "M00000131",
    constellation1ID: void 0,
    longName: "Hernando County Association of REALTORS/MLS",
    shortName: "Hernando County Association of REALTORS/MLS",
    abodeMLSName: "Hernando County Association of REALTORS/MLS"
  },
  hi_central_mls: {
    isActive: !0,
    resoID: "M00000194",
    constellation1ID: void 0,
    longName: "Hi-Central MLS",
    shortName: "Hi-Central MLS",
    abodeMLSName: "Hi-Central MLS"
  },
  high_country_association_of_realtors: {
    isActive: !0,
    resoID: "M00000387",
    constellation1ID: void 0,
    longName: "High Country AOR",
    shortName: "High Country AOR",
    abodeMLSName: "High Country AOR"
  },
  highland_lakes_association_of_realtors: {
    isActive: !0,
    resoID: "M00000606",
    constellation1ID: void 0,
    longName: "Highland Lakes BOR",
    shortName: "Highland Lakes BOR",
    abodeMLSName: "Highland Lakes BOR"
  },
  highlands_cashiers_board_of_realtors: {
    isActive: !0,
    resoID: "M00000390",
    constellation1ID: void 0,
    longName: "Highlands Cashiers Board of Realtors MLS",
    shortName: "Highlands Cashiers Board of Realtors MLS",
    abodeMLSName: "Highlands Cashiers Board of Realtors MLS"
  },
  hilton_head_mls_resides: {
    isActive: !0,
    resoID: "M00000564",
    constellation1ID: void 0,
    longName: "Hilton Head Area Association of Realtors",
    shortName: "Hilton Head Area Association of Realtors",
    abodeMLSName: "Hilton Head Area Association of Realtors"
  },
  honolulu_board_of_realtors: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Honolulu Board of Realtors",
    shortName: "Honolulu Board of Realtors",
    abodeMLSName: void 0
  },
  hot_springs_mls: {
    isActive: !0,
    resoID: "M00000029",
    constellation1ID: void 0,
    longName: "Hot Springs MLS",
    shortName: "Hot Springs MLS",
    abodeMLSName: "Hot Springs MLS"
  },
  hudson_county_mls: {
    isActive: !0,
    resoID: "M00000784",
    constellation1ID: void 0,
    longName: "Hudson MLS",
    shortName: "Hudson MLS",
    abodeMLSName: "Hudson MLS"
  },
  humboldt_association_of_realtors: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Humboldt Association of Realtors",
    shortName: "Humboldt Association of Realtors",
    abodeMLSName: void 0
  },
  huntington_board_of_realtors: {
    isActive: !0,
    resoID: "M00000668",
    constellation1ID: void 0,
    longName: "Huntington Board of Realtors",
    shortName: "Huntington Board of Realtors",
    abodeMLSName: "Huntington Board of Realtors"
  },
  idyllwild: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Idyllwild",
    shortName: "Idyllwild",
    abodeMLSName: void 0
  },
  imperial_county_aor: {
    isActive: !0,
    resoID: "M00000058",
    constellation1ID: void 0,
    longName: "Imperial County AOR",
    shortName: "Imperial County AOR",
    abodeMLSName: "Imperial County AOR"
  },
  incline_village_board_of_realtors: {
    isActive: !0,
    resoID: "M00000465",
    constellation1ID: void 0,
    longName: "Incline Village Board of Realtors",
    shortName: "Incline Village Board of Realtors",
    abodeMLSName: "Incline Village Board of Realtors"
  },
  indian_river_association_of_realtors_mls: {
    isActive: !0,
    resoID: "M00000169",
    constellation1ID: void 0,
    longName: "Indian River Association of Realtors MLS",
    shortName: "Indian River Association of Realtors MLS",
    abodeMLSName: "Indian River Association of Realtors MLS"
  },
  intermountain_multiple_listing_service: {
    isActive: !0,
    resoID: "M00000225",
    constellation1ID: void 0,
    longName: "Intermountain MLS",
    shortName: "Intermountain MLS",
    abodeMLSName: "Intermountain MLS"
  },
  iowa_city_area: {
    isActive: !0,
    resoID: "M00000206",
    constellation1ID: void 0,
    longName: "Iowa City Area Association of Realtors",
    shortName: "Iowa City Area Association of Realtors",
    abodeMLSName: "Iowa City Area Association of Realtors"
  },
  iowa_great_lakes: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Iowa Great Lakes",
    shortName: "Iowa Great Lakes",
    abodeMLSName: void 0
  },
  ires_regional_mls_of_northern_colorado: {
    isActive: !0,
    resoID: "M00000118",
    constellation1ID: void 0,
    longName: "IRES",
    shortName: "IRES",
    abodeMLSName: "IRES"
  },
  ithaca_board_of_realtors: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Ithaca Board of Realtors",
    shortName: "Ithaca Board of Realtors",
    abodeMLSName: void 0
  },
  jasper_association_of_realtors: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Jasper Association of REALTORS",
    shortName: "Jasper Association of REALTORS",
    abodeMLSName: void 0
  },
  jefferson_city_area_board_of_realtors: {
    isActive: !0,
    resoID: "M00000353",
    constellation1ID: void 0,
    longName: "Jefferson City Area Board of Realtors",
    shortName: "Jefferson City Area Board of Realtors",
    abodeMLSName: "Jefferson City Area Board of Realtors"
  },
  jonesboro_board_of_realtors: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Jonesboro Board of Realtors",
    shortName: "Jonesboro Board of Realtors",
    abodeMLSName: void 0
  },
  kanab_listing_service: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Kanab Listing Service",
    shortName: "Kanab Listing Service",
    abodeMLSName: void 0
  },
  kanawha_valley_board_of_realtors: {
    isActive: !0,
    resoID: "M00000667",
    constellation1ID: void 0,
    longName: "Kanawha Valley Board of Realtors",
    shortName: "Kanawha Valley Board of Realtors",
    abodeMLSName: "Kanawha Valley Board of Realtors"
  },
  kerrville_bor: {
    isActive: !0,
    resoID: "M00000600",
    constellation1ID: void 0,
    longName: "Kerrville BOR",
    shortName: "Kerrville BOR",
    abodeMLSName: "Kerrville BOR"
  },
  key_west_association_of_realtors: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Key West Association of Realtors",
    shortName: "Key West Association of Realtors",
    abodeMLSName: void 0
  },
  kings_county_board_of_realtors: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Kings County Board of Realtors",
    shortName: "Kings County Board of Realtors",
    abodeMLSName: void 0
  },
  lake_country_board_of_realtors: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Lake Country Board of Realtors",
    shortName: "Lake Country Board of Realtors",
    abodeMLSName: void 0
  },
  lake_havasu_mls: {
    isActive: !0,
    resoID: "M00000832",
    constellation1ID: void 0,
    longName: "Lake Havasu AOR",
    shortName: "Lake Havasu AOR",
    abodeMLSName: "Lake Havasu AOR"
  },
  lake_martin: {
    isActive: !0,
    resoID: "M00000004",
    constellation1ID: void 0,
    longName: "Lake Martin Area AOR",
    shortName: "Lake Martin Area AOR",
    abodeMLSName: "Lake Martin Area AOR"
  },
  lakeway_area_association_of_realtors: {
    isActive: !0,
    resoID: "M00000584",
    constellation1ID: void 0,
    longName: "Lakeway Area Association of Realtors",
    shortName: "Lakeway Area Association of Realtors",
    abodeMLSName: "Lakeway Area Association of Realtors"
  },
  laredo_bor: {
    isActive: !0,
    resoID: "M00000603",
    constellation1ID: void 0,
    longName: "Laredo BOR",
    shortName: "Laredo BOR",
    abodeMLSName: "Laredo BOR"
  },
  lawrence_mls: {
    isActive: !0,
    resoID: "M00000269",
    constellation1ID: void 0,
    longName: "Lawrence BOR",
    shortName: "Lawrence BOR",
    abodeMLSName: "Lawrence BOR"
  },
  lee_county_association: {
    isActive: !0,
    resoID: "M00000008",
    constellation1ID: void 0,
    longName: "Lee County AOR MLS",
    shortName: "Lee County AOR MLS",
    abodeMLSName: "Lee County AOR MLS"
  },
  link_nantucket: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Link Nantucket",
    shortName: "Link Nantucket",
    abodeMLSName: void 0
  },
  lmperial_county: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "lmperial County",
    shortName: "lmperial County",
    abodeMLSName: void 0
  },
  longleaf_pine_realtors: {
    isActive: !0,
    resoID: "M00000394",
    constellation1ID: void 0,
    longName: "Longleaf Pine REALTORS (Fayetteville)",
    shortName: "Longleaf Pine REALTORS (Fayetteville)",
    abodeMLSName: "Longleaf Pine REALTORS (Fayetteville)"
  },
  longview_association: {
    isActive: !0,
    resoID: "M00000604",
    constellation1ID: void 0,
    longName: "Longview Association of Realtors",
    shortName: "Longview Association of Realtors",
    abodeMLSName: "Longview Association of Realtors"
  },
  low_country_mls: {
    isActive: !0,
    resoID: "M00000557",
    constellation1ID: void 0,
    longName: "Low Country Regional MLS (Beaufort County Association of Realtors)",
    shortName: "Low Country Regional MLS (Beaufort County Association of Realtors)",
    abodeMLSName: "Low Country Regional MLS (Beaufort County Association of Realtors)"
  },
  lubbock_association_of_realtors: {
    isActive: !0,
    resoID: "M00000811",
    constellation1ID: void 0,
    longName: "Lubbock Association of Realtors",
    shortName: "Lubbock Association of Realtors",
    abodeMLSName: "Lubbock Association of Realtors"
  },
  luzerne_county_association_of_realtors_greater_wilkes_barre_association_of_realtors: {
    isActive: !0,
    resoID: "M00000545",
    constellation1ID: void 0,
    longName: "Luzerne County Association of REALTORS (was Greater Wilkes-Barre Association of Realtors)",
    shortName: "Luzerne County Association of REALTORS (was Greater Wilkes-Barre Association of Realtors)",
    abodeMLSName: "Luzerne County Association of REALTORS (was Greater Wilkes-Barre Association of Realtors)"
  },
  lynchburg_association_of_realtors: {
    isActive: !0,
    resoID: "M00000641",
    constellation1ID: void 0,
    longName: "Lynchburg Board of Realtors",
    shortName: "Lynchburg Board of Realtors",
    abodeMLSName: "Lynchburg Board of Realtors"
  },
  maine_real_estate_information_system: {
    isActive: !0,
    resoID: "M00000311",
    constellation1ID: void 0,
    longName: "Maine Listings",
    shortName: "Maine Listings",
    abodeMLSName: "Maine Listings"
  },
  mansfield_board_of_realtors_oh: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Mansfield Board of Realtors , OH",
    shortName: "Mansfield Board of Realtors , OH",
    abodeMLSName: void 0
  },
  mammoth_lakes_board_of_realtors: {
    isActive: !0,
    resoID: "M00000073",
    constellation1ID: void 0,
    longName: "Mammoth Lakes Board of Realtors",
    shortName: "Mammoth Lakes Board of Realtors",
    abodeMLSName: "Mammoth Lakes Board of Realtors"
  },
  marco_multi_list_mls: {
    isActive: !0,
    resoID: "M00000148",
    constellation1ID: void 0,
    longName: "Marco Multi List",
    shortName: "Marco Multi List",
    abodeMLSName: "Marco Multi List, Inc."
  },
  mason_city_greater: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Mason City, Greater",
    shortName: "Mason City, Greater",
    abodeMLSName: void 0
  },
  max_mls: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Max MLS (bridge MLS)",
    shortName: "Max MLS (bridge MLS)",
    abodeMLSName: void 0
  },
  maui_board_of_reatlors: {
    isActive: !0,
    resoID: "M00000195",
    constellation1ID: void 0,
    longName: "Maui Board of Reatlors",
    shortName: "Maui Board of Reatlors",
    abodeMLSName: "Maui Board of Reatlors"
  },
  memphis_area_association_of_realtors: {
    isActive: !0,
    resoID: "M00000583",
    constellation1ID: void 0,
    longName: "Memphis Area Association of Realtors",
    shortName: "Memphis Area Association of Realtors",
    abodeMLSName: "Memphis Area Association of Realtors"
  },
  mercer_tazewell_county_board_of_realtors: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Mercer - Tazewell County Board of REALTORS",
    shortName: "Mercer - Tazewell County Board of REALTORS",
    abodeMLSName: void 0
  },
  metro_mls: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Metro MLS",
    shortName: "Metro MLS",
    abodeMLSName: void 0
  },
  metropolitan_indianapolis_board_of_realtors: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Metropolitan Indianapolis Board of Realtors",
    shortName: "Metropolitan Indianapolis Board of Realtors",
    abodeMLSName: void 0
  },
  mi_realsource: {
    isActive: !0,
    resoID: "M00000331",
    constellation1ID: void 0,
    longName: "MI RealSource",
    shortName: "MI RealSource",
    abodeMLSName: "MI RealSource"
  },
  michigan_regional_information_center: {
    isActive: !0,
    resoID: "T00000006",
    constellation1ID: void 0,
    longName: "Michigan Regional Information Center",
    shortName: "Michigan Regional Information Center",
    abodeMLSName: "Michigan Regional Information Center"
  },
  mid_georgia_multiple_listing_service_ga: {
    isActive: !0,
    resoID: "M00000184",
    constellation1ID: void 0,
    longName: "Middle Georgia MLS",
    shortName: "Middle Georgia MLS",
    abodeMLSName: "Middle Georgia MLS"
  },
  mid_ks_mls: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Mid KS MLS",
    shortName: "Mid KS MLS",
    abodeMLSName: void 0
  },
  midamerica_regional_information_systems: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "MidAmerica Regional Information Systems",
    shortName: "MidAmerica Regional Information Systems",
    abodeMLSName: void 0
  },
  middle_tennessee_regional_mls_realtracs: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Middle Tennessee Regional MLS / Realtracs",
    shortName: "Middle Tennessee Regional MLS / Realtracs",
    abodeMLSName: void 0
  },
  middlesex_county_mls: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Middlesex County MLS (Central Jersey MLS)",
    shortName: "Middlesex County MLS (Central Jersey MLS)",
    abodeMLSName: void 0
  },
  midhudson_multiple_listing_service: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "MidHudson Multiple Listing Service",
    shortName: "MidHudson Multiple Listing Service",
    abodeMLSName: void 0
  },
  midwest_minnesota_regional_mls: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Midwest Minnesota Regional MLS",
    shortName: "Midwest Minnesota Regional MLS",
    abodeMLSName: void 0
  },
  minot_board_of_realtors: {
    isActive: !0,
    resoID: "M00000431",
    constellation1ID: void 0,
    longName: "Minot Board of Realtors",
    shortName: "Minot Board of Realtors",
    abodeMLSName: "Minot Board of Realtors"
  },
  mls_listings: {
    isActive: !0,
    resoID: "M00000101",
    constellation1ID: void 0,
    longName: "MLS Listings",
    shortName: "MLS Listings",
    abodeMLSName: "MLS Listings"
  },
  mls_of_columbus_realtors: {
    isActive: !0,
    resoID: "M00000495",
    constellation1ID: void 0,
    longName: "MLS of Columbus Realtors",
    shortName: "MLS of Columbus Realtors",
    abodeMLSName: "MLS of Columbus Realtors"
  },
  mls_of_greater_cincinnati: {
    isActive: !0,
    resoID: "M00000494",
    constellation1ID: void 0,
    longName: "MLS of Greater Cincinnati",
    shortName: "MLS of Greater Cincinnati",
    abodeMLSName: "MLS of Greater Cincinnati"
  },
  mls_of_southern_arizona: {
    isActive: !0,
    resoID: "M00000049",
    constellation1ID: void 0,
    longName: "MLS of Southern Arizona (MLSSAZ-aka Tucson AOR)",
    shortName: "MLS of Southern Arizona (MLSSAZ-aka Tucson AOR)",
    abodeMLSName: "MLS of Southern Arizona (MLSSAZ-aka Tucson AOR)"
  },
  mobile_area_asociation_of_realtors: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Mobile Area Asociation of Realtors",
    shortName: "Mobile Area Asociation of Realtors",
    abodeMLSName: void 0
  },
  monmouthocean_multiple_listing_service: {
    isActive: !0,
    resoID: "M00000452",
    constellation1ID: void 0,
    longName: "Monmouth County Board of Realtors",
    shortName: "Monmouth County Board of Realtors",
    abodeMLSName: "Monmouth County Board of Realtors"
  },
  montana_regional_mls: {
    isActive: !0,
    resoID: "M00000383",
    constellation1ID: void 0,
    longName: "Montana Regional MLS",
    shortName: "Montana Regional MLS",
    abodeMLSName: "Montana Regional MLS"
  },
  montgomery_area_association_of_realtors: {
    isActive: !0,
    resoID: "M00000020",
    constellation1ID: void 0,
    longName: "Montgomery AreaAOR/MLS",
    shortName: "Montgomery AreaAOR/MLS",
    abodeMLSName: "Montgomery AreaAOR/MLS"
  },
  mount_rushmore_mls: {
    isActive: !0,
    resoID: "M00000573",
    constellation1ID: void 0,
    longName: "Mount Rushmore AOR MLS",
    shortName: "Mount Rushmore AOR MLS",
    abodeMLSName: "Mount Rushmore AOR MLS"
  },
  mountain_central_association_of_realtors: {
    isActive: !0,
    resoID: "M00000231",
    constellation1ID: void 0,
    longName: "Mountain Central AOR",
    shortName: "Mountain Central AOR",
    abodeMLSName: "Mountain Central AOR"
  },
  mountain_home_mls_north_central_bor: {
    isActive: !0,
    resoID: "M00000033",
    constellation1ID: void 0,
    longName: "Mountain Home MLS/North Central BOR",
    shortName: "Mountain Home MLS/North Central BOR",
    abodeMLSName: "Mountain Home MLS/North Central BOR"
  },
  navarre_area_bor: {
    isActive: !0,
    resoID: "M00000153",
    constellation1ID: void 0,
    longName: "Navarre Area BOR",
    shortName: "Navarre Area BOR",
    abodeMLSName: "Navarre Area BOR"
  },
  muscatine_county: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Muscatine County",
    shortName: "Muscatine County",
    abodeMLSName: void 0
  },
  new_canaan_board_of_realtors: {
    isActive: !0,
    resoID: "M00000127",
    constellation1ID: void 0,
    longName: "NEW Canaan Association of Realtors MLS",
    shortName: "NEW Canaan Association of Realtors MLS",
    abodeMLSName: "NEW Canaan Association of Realtors MLS"
  },
  new_england_real_estate_network: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "New England Real Estate Network (NEREN)",
    shortName: "New England Real Estate Network (NEREN)",
    abodeMLSName: void 0
  },
  new_jersey_mls: {
    isActive: !0,
    resoID: "M00000448",
    constellation1ID: void 0,
    longName: "New Jersey MLS",
    shortName: "New Jersey MLS",
    abodeMLSName: "New Jersey MLS"
  },
  new_mexico_mls: {
    isActive: !0,
    resoID: "M00000462",
    constellation1ID: void 0,
    longName: "New Mexico MLS",
    shortName: "New Mexico MLS",
    abodeMLSName: "New Mexico MLS"
  },
  new_river_valley_association_of_realtors_va: {
    isActive: !0,
    resoID: "M00000634",
    constellation1ID: void 0,
    longName: "New River Valley Association of Realtors",
    shortName: "New River Valley Association of Realtors",
    abodeMLSName: "New River Valley Association of Realtors"
  },
  new_york_state_alliance_of_mls: {
    isActive: !0,
    resoID: "T00000077",
    constellation1ID: void 0,
    longName: "New York State Alliance of MLSs (NYSAMLS/GENRIS/CNYIS/WNYREIS)",
    shortName: "New York State Alliance of MLSs (NYSAMLS/GENRIS/CNYIS/WNYREIS)",
    abodeMLSName: "New York State Alliance of MLSs (NYSAMLS/GENRIS/CNYIS/WNYREIS)"
  },
  norfolk_ne_board_of_realtors: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Norfolk NE Board of Realtors",
    shortName: "Norfolk NE Board of Realtors",
    abodeMLSName: void 0
  },
  north_alabama_real_estate_information_services_al: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "North Alabama Real Estate Information Services, AL",
    shortName: "North Alabama Real Estate Information Services, AL",
    abodeMLSName: void 0
  },
  north_central_iowa_regional: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "North Central Iowa Regional",
    shortName: "North Central Iowa Regional",
    abodeMLSName: void 0
  },
  north_central_washington_association_of_realtors: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "North Central Washington Association of Realtors",
    shortName: "North Central Washington Association of Realtors",
    abodeMLSName: void 0
  },
  north_central_west_virginia: {
    isActive: !0,
    resoID: "M00000666",
    constellation1ID: void 0,
    longName: "North Central West Virginia Real Estate",
    shortName: "North Central West Virginia Real Estate",
    abodeMLSName: "North Central West Virginia Real Estate"
  },
  northeast_ar_aor: {
    isActive: !0,
    resoID: "M00000030",
    constellation1ID: void 0,
    longName: "Northeast AR AOR",
    shortName: "Northeast AR AOR",
    abodeMLSName: "Northeast AR AOR"
  },
  northeast_central_aor_mls: {
    isActive: !0,
    resoID: "M00000771",
    constellation1ID: void 0,
    longName: "NorthEast Central AOR MLS",
    shortName: "NorthEast Central AOR MLS",
    abodeMLSName: "NorthEast Central AOR MLS"
  },
  northeast_florida_mls: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Northeast Florida MLS",
    shortName: "Northeast Florida MLS",
    abodeMLSName: void 0
  },
  northeast_georgia_board_of_realtors: {
    isActive: !0,
    resoID: "M00000848",
    constellation1ID: void 0,
    longName: "Northeast Georgia BOR (NEGBOR)",
    shortName: "Northeast Georgia BOR (NEGBOR)",
    abodeMLSName: "Northeast Georgia BOR (NEGBOR)"
  },
  northeast_ia_regional_mls: {
    isActive: !0,
    resoID: "M00000221",
    constellation1ID: void 0,
    longName: "Northeast IA Regional MLS",
    shortName: "Northeast IA Regional MLS",
    abodeMLSName: "Northeast IA Regional MLS"
  },
  northeast_louisiana_board_of_realtors: {
    isActive: !0,
    resoID: "M00000303",
    constellation1ID: void 0,
    longName: "Northeast Louisiana Association of Realtors",
    shortName: "Northeast Louisiana Association of Realtors",
    abodeMLSName: "Northeast Louisiana Association of Realtors"
  },
  northeast_mississippi_board_of_realtors: {
    isActive: !0,
    resoID: "M00000376",
    constellation1ID: void 0,
    longName: "Northeast Mississippi Board of Realtors",
    shortName: "Northeast Mississippi Board of Realtors",
    abodeMLSName: "Northeast Mississippi Board of Realtors"
  },
  northeast_oklahoma_aor: {
    isActive: !0,
    resoID: "M00000515",
    constellation1ID: void 0,
    longName: "Northeast Oklahoma AOR",
    shortName: "Northeast Oklahoma AOR",
    abodeMLSName: "Northeast Oklahoma AOR"
  },
  northeast_wisconsin_association_of_realtors: {
    isActive: !0,
    resoID: "M00000657",
    constellation1ID: void 0,
    longName: "Northeast Wisconsin Association of Realtors",
    shortName: "Northeast Wisconsin Association of Realtors",
    abodeMLSName: "Northeast Wisconsin Association of Realtors"
  },
  northern_arizona_assoc_of_realtors: {
    isActive: !0,
    resoID: "M00000040",
    constellation1ID: void 0,
    longName: "Northern Arizona Assocation of Realtors MLS",
    shortName: "Northern Arizona Assocation of Realtors MLS",
    abodeMLSName: "Northern Arizona Assocation of Realtors MLS"
  },
  northern_great_lakes_mls: {
    isActive: !0,
    resoID: "M00000330",
    constellation1ID: void 0,
    longName: "Northern Great Lakes Realtors MLS",
    shortName: "Northern Great Lakes Realtors MLS",
    abodeMLSName: "Northern Great Lakes Realtors MLS"
  },
  northern_jackson_county_mls: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Northern Jackson County MLS",
    shortName: "Northern Jackson County MLS",
    abodeMLSName: void 0
  },
  northern_kentucky_association_of_realtors: {
    isActive: !0,
    resoID: "M00000284",
    constellation1ID: void 0,
    longName: "Northern Kentucky Association of Realtors",
    shortName: "Northern Kentucky Association of Realtors",
    abodeMLSName: "Northern Kentucky Association of Realtors"
  },
  northern_michigan_mls: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Northern Michigan MLS",
    shortName: "Northern Michigan MLS",
    abodeMLSName: void 0
  },
  northern_nevada_regional_mls: {
    isActive: !0,
    resoID: "M00000467",
    constellation1ID: void 0,
    longName: "Northern Nevada Regional MLS",
    shortName: "Northern Nevada Regional MLS",
    abodeMLSName: "Northern Nevada Regional MLS"
  },
  northern_santa_barbara_county_mls: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Northern Santa Barbara County MLS",
    shortName: "Northern Santa Barbara County MLS",
    abodeMLSName: void 0
  },
  northwest_arkansas_board_of_realtors_mls: {
    isActive: !0,
    resoID: "M00000035",
    constellation1ID: void 0,
    longName: "Northwest Arkansas Associaton of Realtors MLS",
    shortName: "Northwest Arkansas Associaton of Realtors MLS",
    abodeMLSName: "Northwest Arkansas Associaton of Realtors MLS"
  },
  northwest_association_ms: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Northwest Association, MS (MLS United)",
    shortName: "Northwest Association, MS (MLS United)",
    abodeMLSName: void 0
  },
  northwest_illinois_alliance_of_realtors: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "NorthWest Illinois Alliance of REALTORS (formerly Rockford Area REALTORS )",
    shortName: "NorthWest Illinois Alliance of REALTORS (formerly Rockford Area REALTORS )",
    abodeMLSName: void 0
  },
  northwest_iowa_regional: {
    isActive: !0,
    resoID: "M00000224",
    constellation1ID: void 0,
    longName: "Northwest IA Regionial BOR",
    shortName: "Northwest IA Regionial BOR",
    abodeMLSName: "Northwest IA Regionial BOR"
  },
  northwest_ohio_real_estate_information_systems: {
    isActive: !0,
    resoID: "M00000505",
    constellation1ID: void 0,
    longName: "Northwest Ohio Real Estate Information System",
    shortName: "Northwest Ohio Real Estate Information System",
    abodeMLSName: "Northwest Ohio Real Estate Information System"
  },
  northwest_oklahoma_associaton_of_realtors: {
    isActive: !0,
    resoID: "M00000514",
    constellation1ID: void 0,
    longName: "Northwest Oklahoma Associaton of Realtors",
    shortName: "Northwest Oklahoma Associaton of Realtors",
    abodeMLSName: "Northwest Oklahoma Associaton of Realtors"
  },
  northwest_wyoming_board_of_realtors: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Northwest Wyoming Board of Realtors",
    shortName: "Northwest Wyoming Board of Realtors",
    abodeMLSName: void 0
  },
  northwoods_association_of_realtors: {
    isActive: !0,
    resoID: "M00000663",
    constellation1ID: void 0,
    longName: "Northwoods Association of Realtors",
    shortName: "Northwoods Association of Realtors",
    abodeMLSName: "Northwoods Association of Realtors"
  },
  odessa_bor: {
    isActive: !0,
    resoID: "M00000736",
    constellation1ID: void 0,
    longName: "Odessa BOR",
    shortName: "Odessa BOR",
    abodeMLSName: "Odessa BOR"
  },
  oregon_data_share: {
    isActive: !0,
    resoID: "T00000038",
    constellation1ID: void 0,
    longName: "Oregon Data Share",
    shortName: "Oregon Data Share",
    abodeMLSName: "Oregon Data Share"
  },
  outer_banks_association_of_realtors: {
    isActive: !0,
    resoID: "M00000409",
    constellation1ID: void 0,
    longName: "Outer Banks Association of Realtors",
    shortName: "Outer Banks Association of Realtors",
    abodeMLSName: "Outer Banks Association of Realtors"
  },
  ozark_gateway_association_of_realtors: {
    isActive: !0,
    resoID: "M00000354",
    constellation1ID: void 0,
    longName: "Ozark Gateway AOR",
    shortName: "Ozark Gateway AOR",
    abodeMLSName: "Ozark Gateway AOR"
  },
  pacific_regional_mls: {
    isActive: !0,
    resoID: "M00000648",
    constellation1ID: void 0,
    longName: "Pacific Regional MLS",
    shortName: "Pacific Regional MLS",
    abodeMLSName: "Pacific Regional MLS"
  },
  park_city_board_of_realtors: {
    isActive: !0,
    resoID: "M00000627",
    constellation1ID: void 0,
    longName: "Park City Board Services",
    shortName: "Park City Board Services",
    abodeMLSName: "Park City Board Services"
  },
  pensacola_association_of_realtors: {
    isActive: !0,
    resoID: "M00000161",
    constellation1ID: void 0,
    longName: "Pensacola Association of Realtors",
    shortName: "Pensacola Association of Realtors",
    abodeMLSName: "Pensacola Association of Realtors"
  },
  perchwell: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Perchwell (NYC)",
    shortName: "Perchwell (NYC)",
    abodeMLSName: void 0
  },
  permian_basin_board_of_realtors: {
    isActive: !0,
    resoID: "M00000737",
    constellation1ID: void 0,
    longName: "Permian Basin Association of Realtors",
    shortName: "Permian Basin Association of Realtors",
    abodeMLSName: "Permian Basin Association of Realtors"
  },
  pike_wayne_association_of_realtors: {
    isActive: !0,
    resoID: "M00000721",
    constellation1ID: void 0,
    longName: "Pike Wayne Association of Realtors",
    shortName: "Pike Wayne Association of Realtors",
    abodeMLSName: "Pike Wayne Association of Realtors"
  },
  pikes_peak_association_of_realtors: {
    isActive: !0,
    resoID: "M00000111",
    constellation1ID: void 0,
    longName: "Pikes Peak REALTOR Services Corporation",
    shortName: "Pikes Peak REALTOR Services Corporation",
    abodeMLSName: "Pikes Peak REALTOR Services Corporation"
  },
  pinehurst_southern_pines_area_association_of_realtors: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Pinehurst Southern Pines Area Association of Realtors",
    shortName: "Pinehurst Southern Pines Area Association of Realtors",
    abodeMLSName: void 0
  },
  plumas_association_of_realtors: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Plumas Association of Realtors",
    shortName: "Plumas Association of Realtors",
    abodeMLSName: void 0
  },
  pocono_mountain_mls: {
    isActive: !0,
    resoID: "M00000552",
    constellation1ID: void 0,
    longName: "Pocono Mountains Association of Realtors",
    shortName: "Pocono Mountains Association of Realtors",
    abodeMLSName: "Pocono Mountains Association of Realtors"
  },
  port_neches_port_arthur_and_nederland_board_of_realtors: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Port Neches Port Arthur and Nederland Board of REALTORS",
    shortName: "Port Neches Port Arthur and Nederland Board of REALTORS",
    abodeMLSName: void 0
  },
  prescott_area_association_of_realtors: {
    isActive: !0,
    resoID: "M00000044",
    constellation1ID: void 0,
    longName: "Presott Area Association of Realtors MLS",
    shortName: "Presott Area Association of Realtors MLS",
    abodeMLSName: "Presott Area Association of Realtors MLS"
  },
  pueblo_association: {
    isActive: !0,
    resoID: "M00000120",
    constellation1ID: void 0,
    longName: "Pueblo Board of Realtors MLS",
    shortName: "Pueblo Board of Realtors MLS",
    abodeMLSName: "Pueblo Board of Realtors MLS"
  },
  quad_city_area: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Quad City Area",
    shortName: "Quad City Area",
    abodeMLSName: void 0
  },
  range_area_mls: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Range Area MLS",
    shortName: "Range Area MLS",
    abodeMLSName: void 0
  },
  real_comp: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Real Comp",
    shortName: "Real Comp",
    abodeMLSName: void 0
  },
  real_estate_board_of_new_york_620a: {
    isActive: !0,
    resoID: "T00000046",
    constellation1ID: void 0,
    longName: "Real Estate Board of NEW York 620A",
    shortName: "Real Estate Board of NEW York 620A",
    abodeMLSName: "Real Estate Board of NEW York 620A"
  },
  real_estate_information_network: {
    isActive: !0,
    resoID: "M00000646",
    constellation1ID: void 0,
    longName: "Real Estate Information Network",
    shortName: "Real Estate Information Network",
    abodeMLSName: "Real Estate Information Network"
  },
  real_estate_information_services: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Real Estate Information Services (REALTOR Association of Southern Kentucky)",
    shortName: "Real Estate Information Services (REALTOR Association of Southern Kentucky)",
    abodeMLSName: void 0
  },
  realtor_association_of_citrus_county: {
    isActive: !0,
    resoID: "M00000145",
    constellation1ID: void 0,
    longName: "Realtor Association of Citrus County",
    shortName: "Realtor Association of Citrus County",
    abodeMLSName: "Realtor Association of Citrus County"
  },
  realtor_association_of_franklin_and_southern_gulf_counties: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Realtor Association of Franklin and Southern Gulf Counties",
    shortName: "Realtor Association of Franklin and Southern Gulf Counties",
    abodeMLSName: void 0
  },
  realtor_association_of_the_greater_pee_dee_sc: {
    isActive: !0,
    resoID: "M00000703",
    constellation1ID: void 0,
    longName: "Realtor Association of Greater Pee Dee",
    shortName: "Realtor Association of Greater Pee Dee",
    abodeMLSName: "Realtor Association of Greater Pee Dee"
  },
  realtor_association_of_martin_county_fl: {
    isActive: !0,
    resoID: "M00000165",
    constellation1ID: void 0,
    longName: "Realtor Association of Martin County FL",
    shortName: "Realtor Association of Martin County FL",
    abodeMLSName: "Martin County Realtors of the Treasure coast Inc"
  },
  realtor_association_of_southern_kentucky: {
    isActive: !0,
    resoID: "M00000281",
    constellation1ID: void 0,
    longName: "REALTOR Association of Southern Kentucky",
    shortName: "REALTOR Association of Southern Kentucky",
    abodeMLSName: "REALTOR Association of Southern Kentucky"
  },
  realtor_association_of_new_mexico: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Realtor Association of New Mexico",
    shortName: "Realtor Association of New Mexico",
    abodeMLSName: void 0
  },
  realtor_association_of_sioux_empire: {
    isActive: !0,
    resoID: "M00000572",
    constellation1ID: void 0,
    longName: "Realtor Association of the Sioux Empire",
    shortName: "Realtor Association of the Sioux Empire",
    abodeMLSName: "Realtor Association of the Sioux Empire"
  },
  realtor_association_of_southern_minnesota: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "REALTOR Association of Southern Minnesota",
    shortName: "REALTOR Association of Southern Minnesota",
    abodeMLSName: void 0
  },
  realtors_association_greater_fort_myers_the_beach: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Realtors Association Greater Fort Myers & The Beach",
    shortName: "Realtors Association Greater Fort Myers & The Beach",
    abodeMLSName: void 0
  },
  realtors_association_of_acadiana: {
    isActive: !0,
    resoID: "M00000300",
    constellation1ID: void 0,
    longName: "Realtors Association of Acadiana",
    shortName: "Realtors Association of Acadiana",
    abodeMLSName: "Realtors Association of Acadiana"
  },
  realtors_association_of_indian_river_county: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Realtors Association of Indian River County",
    shortName: "Realtors Association of Indian River County",
    abodeMLSName: void 0
  },
  realtors_association_of_maui: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Realtors Association of Maui",
    shortName: "Realtors Association of Maui",
    abodeMLSName: void 0
  },
  realtors_association_of_northeast_wisconsin: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "REALTORS Association of Northeast Wisconsin",
    shortName: "REALTORS Association of Northeast Wisconsin",
    abodeMLSName: void 0
  },
  realtors_association_of_northwestern_wisconsin: {
    isActive: !0,
    resoID: "M00000658",
    constellation1ID: void 0,
    longName: "Realtors Association of Northwest Wisconsin",
    shortName: "Realtors Association of Northwest Wisconsin",
    abodeMLSName: "Realtors Association of Northwest Wisconsin"
  },
  regional_multiple_listing_service_of_minnesota: {
    isActive: !0,
    resoID: "M00000343",
    constellation1ID: void 0,
    longName: "Realtors Association of Southern MN",
    shortName: "Realtors Association of Southern MN",
    abodeMLSName: "Realtors Association of Southern MN"
  },
  rhode_island_association_of_realtors: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Rhode Island Association of Realtors (State-Wide MLS)",
    shortName: "Rhode Island Association of Realtors (State-Wide MLS)",
    abodeMLSName: void 0
  },
  rio_grande_valley_mls: {
    isActive: !0,
    resoID: "M00000598",
    constellation1ID: void 0,
    longName: "Rio Grande Valley MLS",
    shortName: "Rio Grande Valley MLS",
    abodeMLSName: "Rio Grande Valley MLS"
  },
  river_counties_association_of_realtors: {
    isActive: !0,
    resoID: "M00000577",
    constellation1ID: void 0,
    longName: "River Counties AOR",
    shortName: "River Counties AOR",
    abodeMLSName: "River Counties AOR"
  },
  roanoke_valley_association_of_realtors: {
    isActive: !0,
    resoID: "M00000644",
    constellation1ID: void 0,
    longName: "Roanoke Valley Association of REALTORS",
    shortName: "Roanoke Valley Association of REALTORS",
    abodeMLSName: "Roanoke Valley Association of REALTORS"
  },
  rockford_area_association_of_realtors: {
    isActive: !0,
    resoID: "M00000818",
    constellation1ID: void 0,
    longName: "Rockford Area Association of Realtors",
    shortName: "Rockford Area Association of Realtors",
    abodeMLSName: "Rockford Area Association of Realtors"
  },
  roswell_board_of_realtors: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Roswell Board of Realtors",
    shortName: "Roswell Board of Realtors",
    abodeMLSName: void 0
  },
  royal_gorge_association_of_realtors: {
    isActive: !0,
    resoID: "M00000110",
    constellation1ID: void 0,
    longName: "Royal Gorge AOR",
    shortName: "Royal Gorge AOR",
    abodeMLSName: "Royal Gorge AOR"
  },
  ruidosolincoln_county_association_or_realtors: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Ruidoso/Lincoln County Association or Realtors",
    shortName: "Ruidoso/Lincoln County Association or Realtors",
    abodeMLSName: void 0
  },
  saginaw_board_of_realtors: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Saginaw Board of Realtors",
    shortName: "Saginaw Board of Realtors",
    abodeMLSName: void 0
  },
  san_angelo_association_of_realtors: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "San Angelo Association of Realtors",
    shortName: "San Angelo Association of Realtors",
    abodeMLSName: void 0
  },
  san_diego_regional_mls: {
    isActive: !0,
    resoID: "M00000846",
    constellation1ID: void 0,
    longName: "San Diego Regional MLS",
    shortName: "San Diego Regional MLS",
    abodeMLSName: "San Diego Regional MLS"
  },
  san_francisco_association_of_realtors: {
    isActive: !0,
    resoID: "M00000094",
    constellation1ID: void 0,
    longName: "San Francisco Multiple Listing Service",
    shortName: "San Francisco Multiple Listing Service",
    abodeMLSName: "San Francisco Multiple Listing Service"
  },
  san_juan_county_board_of_realtors_inc: {
    isActive: !0,
    resoID: "M00000785",
    constellation1ID: void 0,
    longName: "San Juan County Board of Realtors Inc.",
    shortName: "San Juan County Board of Realtors Inc.",
    abodeMLSName: "San Juan County Board of Realtors Inc."
  },
  sandicor: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Sandicor",
    shortName: "Sandicor",
    abodeMLSName: void 0
  },
  sanibel_captiva_islands_aor: {
    isActive: !0,
    resoID: "M00000163",
    constellation1ID: void 0,
    longName: "Sanibel & Captiva Islands AOR",
    shortName: "Sanibel & Captiva Islands AOR",
    abodeMLSName: "Sanibel & Captiva Islands AOR"
  },
  santa_barbara_association_of_realtors: {
    isActive: !0,
    resoID: "M00000096",
    constellation1ID: void 0,
    longName: "Santa Barbara Multiple Listing Service",
    shortName: "Santa Barbara Multiple Listing Service",
    abodeMLSName: "Santa Barbara Multiple Listing Service"
  },
  santa_fe_association_of_realtors: {
    isActive: !0,
    resoID: "M00000461",
    constellation1ID: void 0,
    longName: "Santa Fe MLS",
    shortName: "Santa Fe MLS",
    abodeMLSName: "Santa Fe MLS"
  },
  santa_ynez_aor: {
    isActive: !0,
    resoID: "M00000820",
    constellation1ID: void 0,
    longName: "Santa Ynez AOR (North Santa Barbara County MLS)",
    shortName: "Santa Ynez AOR (North Santa Barbara County MLS)",
    abodeMLSName: "Santa Ynez AOR (North Santa Barbara County MLS)"
  },
  savannah_board_of_realtors_ga: {
    isActive: !0,
    resoID: "M00000751",
    constellation1ID: void 0,
    longName: "Savannah Multi-List",
    shortName: "Savannah Multi-List",
    abodeMLSName: "Savannah Multi-List"
  },
  sedona_verde_valley_association_of_realtors: {
    isActive: !0,
    resoID: "M00000048",
    constellation1ID: void 0,
    longName: "Sedona-Verde Association of Realtors MLS",
    shortName: "Sedona-Verde Association of Realtors MLS",
    abodeMLSName: "Sedona-Verde Association of Realtors MLS"
  },
  selkirk_aor: {
    isActive: !0,
    resoID: "M00000235",
    constellation1ID: void 0,
    longName: "Selkirk AOR",
    shortName: "Selkirk AOR",
    abodeMLSName: "Selkirk AOR"
  },
  shasta_association_of_realtors: {
    isActive: !0,
    resoID: "M00000090",
    constellation1ID: void 0,
    longName: "Shasta Association of Realtors",
    shortName: "Shasta Association of Realtors",
    abodeMLSName: "Shasta Association of Realtors"
  },
  shoals: {
    isActive: !0,
    resoID: "M00000012",
    constellation1ID: void 0,
    longName: "Shoals",
    shortName: "Shoals",
    abodeMLSName: "Strategic MLS:Cullman"
  },
  snake_river_mls: {
    isActive: !0,
    resoID: "M00000228",
    constellation1ID: void 0,
    longName: "Snake River Association of Realtors",
    shortName: "Snake River Association of Realtors",
    abodeMLSName: "Snake River Association of Realtors"
  },
  south_carolina_statewide_commercial_mls: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "South Carolina Statewide Commercial MLS",
    shortName: "South Carolina Statewide Commercial MLS",
    abodeMLSName: void 0
  },
  south_central_association_of_realtors: {
    isActive: !0,
    resoID: "M00000637",
    constellation1ID: void 0,
    longName: "South Central AOR MLS",
    shortName: "South Central AOR MLS",
    abodeMLSName: "South Central AOR MLS"
  },
  south_central_kansas_mls: {
    isActive: !0,
    resoID: "M00000277",
    constellation1ID: void 0,
    longName: "South Central Kansas MLS",
    shortName: "South Central Kansas MLS",
    abodeMLSName: "South Central Kansas MLS"
  },
  south_central_kentucky_association_of_realtors: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "South Central Kentucky Association of Realtors",
    shortName: "South Central Kentucky Association of Realtors",
    abodeMLSName: void 0
  },
  south_central_wisconsin_multiple_listing_service: {
    isActive: !0,
    resoID: "M00000662",
    constellation1ID: void 0,
    longName: "South Central Wisconsin MLS",
    shortName: "South Central Wisconsin MLS",
    abodeMLSName: "South Central Wisconsin MLS"
  },
  south_east_ks_mls: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "South East KS MLS",
    shortName: "South East KS MLS",
    abodeMLSName: void 0
  },
  south_ga_mls: {
    isActive: !0,
    resoID: "M00000756",
    constellation1ID: void 0,
    longName: "South GA MLS",
    shortName: "South GA MLS",
    abodeMLSName: "South GA MLS"
  },
  south_jersey_shore_regional_mls: {
    isActive: !0,
    resoID: "M00000446",
    constellation1ID: void 0,
    longName: "South Jersey Shore Regional MLS",
    shortName: "South Jersey Shore Regional MLS",
    abodeMLSName: "South Jersey Shore Regional MLS"
  },
  south_lake_tahoe_association_of_realtors: {
    isActive: !0,
    resoID: "M00000100",
    constellation1ID: void 0,
    longName: "South Tahoe Association of REALTORS",
    shortName: "South Tahoe Association of REALTORS",
    abodeMLSName: "South Tahoe Association of REALTORS"
  },
  southeast_alabama_aor_mls: {
    isActive: !0,
    resoID: "M00000013",
    constellation1ID: void 0,
    longName: "Southeast Alabama AOR/MLS (Dothan)",
    shortName: "Southeast Alabama AOR/MLS (Dothan)",
    abodeMLSName: "Southeast Alabama AOR/MLS (Dothan)"
  },
  southeast_texas_bor: {
    isActive: !0,
    resoID: "M00000591",
    constellation1ID: void 0,
    longName: "Southeast Texas BOR",
    shortName: "Southeast Texas BOR",
    abodeMLSName: "Southeast Texas BOR"
  },
  southeastern_indiana_board_of_realtors_in: {
    isActive: !0,
    resoID: "M00000251",
    constellation1ID: void 0,
    longName: "Southeastern Indiana BOR",
    shortName: "Southeastern Indiana BOR",
    abodeMLSName: "Southeastern Indiana BOR"
  },
  southern_indiana_realtors_association: {
    isActive: !0,
    resoID: "M00000252",
    constellation1ID: void 0,
    longName: "Southern Indiana Realtor Associaion",
    shortName: "Southern Indiana Realtor Associaion",
    abodeMLSName: "Southern Indiana Realtor Associaion"
  },
  southern_missouri_regional_mls: {
    isActive: !0,
    resoID: "M00000748",
    constellation1ID: void 0,
    longName: "Southern Missouri Regional MLS",
    shortName: "Southern Missouri Regional MLS",
    abodeMLSName: "Southern Missouri Regional MLS"
  },
  southern_new_mexico_mls: {
    isActive: !0,
    resoID: "M00000457",
    constellation1ID: void 0,
    longName: "Southern New Mexico MLS",
    shortName: "Southern New Mexico MLS",
    abodeMLSName: "Southern New Mexico MLS"
  },
  southern_oregon_mls: {
    isActive: !0,
    resoID: "M00000530",
    constellation1ID: void 0,
    longName: "Southern Oregon MLS",
    shortName: "Southern Oregon MLS",
    abodeMLSName: "Southern Oregon MLS"
  },
  southwest_georgia_board_of_realtors: {
    isActive: !0,
    resoID: "M00000179",
    constellation1ID: void 0,
    longName: "Southwest Georgia Board of Realtors",
    shortName: "Southwest Georgia Board of Realtors",
    abodeMLSName: "Southwest Georgia Board of Realtors"
  },
  southwest_mls: {
    isActive: !0,
    resoID: "M00000456",
    constellation1ID: void 0,
    longName: "Southwest MLS",
    shortName: "Southwest MLS",
    abodeMLSName: "Southwest MLS"
  },
  southwest_virginia_association_of_realtors_va: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Southwest Virginia Association of Realtors, VA",
    shortName: "Southwest Virginia Association of Realtors, VA",
    abodeMLSName: void 0
  },
  southwestern_michigan_regional_information_center: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Southwestern Michigan Regional Information Center",
    shortName: "Southwestern Michigan Regional Information Center",
    abodeMLSName: void 0
  },
  spartanburg_board_of_realtors_multiple_listing_service_of_spartanburg: {
    isActive: !0,
    resoID: "M00000568",
    constellation1ID: void 0,
    longName: "Spartanburg Board of Realtors / Multiple Listing Service of Spartanburg",
    shortName: "Spartanburg Board of Realtors / Multiple Listing Service of Spartanburg",
    abodeMLSName: "MLS of Spartanburg"
  },
  spokane_association_of_realtors: {
    isActive: !0,
    resoID: "M00000653",
    constellation1ID: void 0,
    longName: "Spokane Association of Realtors",
    shortName: "Spokane Association of Realtors",
    abodeMLSName: "Spokane Association of Realtors"
  },
  st_augustine_st_johns_county_board_of_realtors: {
    isActive: !0,
    resoID: "M00000164",
    constellation1ID: void 0,
    longName: "St. Augustine & St. Johns County BOR",
    shortName: "St. Augustine & St. Johns County BOR",
    abodeMLSName: "St. Augustine & St. Johns County BOR"
  },
  staten_island_bor: {
    isActive: !0,
    resoID: "M00000487",
    constellation1ID: void 0,
    longName: "Staten Island BOR",
    shortName: "Staten Island BOR",
    abodeMLSName: "Staten Island BOR"
  },
  statewide_mls: {
    isActive: !0,
    resoID: "M00000554",
    constellation1ID: void 0,
    longName: "Statewide MLS",
    shortName: "Statewide MLS",
    abodeMLSName: "Statewide MLS"
  },
  summit_mls: {
    isActive: !0,
    resoID: "M00000113",
    constellation1ID: void 0,
    longName: "Summit County AOR",
    shortName: "Summit County AOR",
    abodeMLSName: "Summit County AOR"
  },
  sumter_association_of_realtors: {
    isActive: !0,
    resoID: "M00000569",
    constellation1ID: void 0,
    longName: "Sumter Board of Realtors",
    shortName: "Sumter Board of Realtors",
    abodeMLSName: "Sumter Board of Realtors"
  },
  sun_valley_board_of_realtors: {
    isActive: !0,
    resoID: "M00000229",
    constellation1ID: void 0,
    longName: "Sun Valley Board of Realtors",
    shortName: "Sun Valley Board of Realtors",
    abodeMLSName: "Sun Valley Board of Realtors"
  },
  sunflower_association_of_realtors: {
    isActive: !0,
    resoID: "M00000276",
    constellation1ID: void 0,
    longName: "Sunflower Association of Realtors",
    shortName: "Sunflower Association of Realtors",
    abodeMLSName: "Sunflower Association of Realtors"
  },
  sunshine_mls: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Sunshine MLS",
    shortName: "Sunshine MLS",
    abodeMLSName: void 0
  },
  tahoe_sierra_board_of_realtors: {
    isActive: !0,
    resoID: "M00000079",
    constellation1ID: void 0,
    longName: "Tahoe - Sierra MLS",
    shortName: "Tahoe - Sierra MLS",
    abodeMLSName: "Tahoe - Sierra MLS"
  },
  tallahassee_board_of_realtors: {
    isActive: !0,
    resoID: "M00000166",
    constellation1ID: void 0,
    longName: "Tallahassee Board of Realtors MLS",
    shortName: "Tallahassee Board of Realtors MLS",
    abodeMLSName: "Tallahassee Board of Realtors MLS"
  },
  taos_county_association_of_realtors_nm: {
    isActive: !0,
    resoID: "M00000464",
    constellation1ID: void 0,
    longName: "Taos County Association of Realtors",
    shortName: "Taos County Association of Realtors",
    abodeMLSName: "Taos County Association of Realtors"
  },
  tehachapi_area_association_of_realtors: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Tehachapi Area Association of Realtors",
    shortName: "Tehachapi Area Association of Realtors",
    abodeMLSName: void 0
  },
  telluride_association_of_realtors: {
    isActive: !0,
    resoID: "M00000122",
    constellation1ID: void 0,
    longName: "Telluride AOR",
    shortName: "Telluride AOR",
    abodeMLSName: "Telluride AOR"
  },
  tennessee_virginia_regional_mls: {
    isActive: !0,
    resoID: "M00000580",
    constellation1ID: void 0,
    longName: "Tennessee Virginia Regional MLS",
    shortName: "Tennessee Virginia Regional MLS",
    abodeMLSName: "Tennessee Virginia Regional MLS"
  },
  terra_haute_association_of_realtors: {
    isActive: !0,
    resoID: "M00000261",
    constellation1ID: void 0,
    longName: "Terre Haute Area Association of Realtors",
    shortName: "Terre Haute Area Association of Realtors",
    abodeMLSName: "Terre Haute Area Association of Realtors"
  },
  teton_board_of_realtors: {
    isActive: !0,
    resoID: "M00000678",
    constellation1ID: void 0,
    longName: "Teton County Board of Realtors",
    shortName: "Teton County Board of Realtors",
    abodeMLSName: "Teton County Board of Realtors"
  },
  the_heart_of_kentucky_association_of_realtors: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "The Heart Of Kentucky Association of Realtors",
    shortName: "The Heart Of Kentucky Association of Realtors",
    abodeMLSName: void 0
  },
  the_lake_superior_area_mls: {
    isActive: !0,
    resoID: "M00000337",
    constellation1ID: void 0,
    longName: "The Lake Superior Area MLS",
    shortName: "The Lake Superior Area MLS",
    abodeMLSName: "Lake Superior Area of Realtors"
  },
  tri_city_association_of_realtors_pacific_regional_mls: {
    isActive: !1,
    resoID: void 0,
    constellation1ID: void 0,
    longName: "Tri City Association of Realtors / Pacific Regional MLS",
    shortName: "Tri City Association of Realtors / Pacific Regional MLS",
    abodeMLSName: void 0
  },
  valley_mls: {
    isActive: !0,
    resoID: "M00000017",
    constellation1ID: void 0,
    longName: "Valley MLS",
    shortName: "Valley MLS",
    abodeMLSName: "Valley MLS"
  },
  west_alabama_mls: {
    isActive: !0,
    resoID: "M00000024",
    constellation1ID: void 0,
    longName: "West Alabama MLS",
    shortName: "West Alabama MLS",
    abodeMLSName: "West Alabama MLS"
  },
  west_central_aor: {
    isActive: !0,
    resoID: "M00000357",
    constellation1ID: void 0,
    longName: "West Central AOR",
    shortName: "West Central AOR",
    abodeMLSName: "West Central AOR"
  },
  western_arizona_real_estate_data_exchange: {
    isActive: !0,
    resoID: "M00000039",
    constellation1ID: void 0,
    longName: "Western Arizona Real Estate Data Exchange",
    shortName: "Western Arizona Real Estate Data Exchange",
    abodeMLSName: "Western Arizona Real Estate Data Exchange"
  },
  western_kentucky_regional_mls: {
    isActive: !0,
    resoID: "M00000280",
    constellation1ID: void 0,
    longName: "Western Kentucky Regional MLS (Pennyrile AOR)",
    shortName: "Western Kentucky Regional MLS (Pennyrile AOR)",
    abodeMLSName: "Western Kentucky Regional MLS (Pennyrile AOR)"
  }
}), Mc = Me([...Qo._keys]), rae = Me([
  "M00000315",
  "M00000483",
  "M00000555",
  "M00000001",
  "M00000172",
  "M00000588",
  "M00000136",
  "M00000048",
  "M00000278",
  "M00000109",
  "M00000589",
  "M00000427",
  "M00000355",
  "M00000053",
  "M00000022",
  "M00000097",
  "M00000105",
  "M00000170",
  "M00000170",
  "M00000305",
  "M00000055",
  "M00000378",
  "M00000571",
  "M00000821",
  "M00000309",
  "M00000471",
  "M00000592",
  "M00000052",
  "M00000093",
  "M00000093",
  "M00000391",
  "M00000307",
  "M00000447",
  "M00000395",
  "M00000752",
  "M00000200",
  "M00000043",
  "M00000190",
  "M00000596",
  "M00000450",
  "M00000525",
  "M00000159",
  "M00000538",
  "M00000581",
  "M00000610",
  "M00000643",
  "M00000558",
  "M00000633",
  "M00000675",
  "M00000177",
  "M00000565",
  "M00000227",
  "M00000684",
  "M00000349",
  "M00000476",
  "M00000753",
  "M00000071",
  "M00000559",
  "M00000031",
  "M00000593",
  "M00000496",
  "M00000140",
  "M00000204",
  "M00000082",
  "M00000631",
  "M00000138",
  "M00000428",
  "M00000504",
  "M00000271",
  "M00000168",
  "M00000853",
  "M00000129",
  "M00000060",
  "M00000379",
  "M00000597",
  "M00000449",
  "M00000188",
  "M00000468",
  "M00000429",
  "M00000729",
  "M00000107",
  "M00000441",
  "M00000010",
  "M00000084",
  "M00000176",
  "M00000298",
  "M00000470",
  "M00000575",
  "M00000595",
  "M00000540",
  "M00000002",
  "M00000365",
  "M00000322",
  "M00000466",
  "M00000534",
  "M00000290",
  "M00000608",
  "M00000259",
  "M00000536",
  "M00000083",
  "M00000621",
  "M00000669",
  "M00000125",
  "M00000018",
  "M00000065",
  "M00000367",
  "M00000193",
  "M00000205",
  "M00000270",
  "M00000740",
  "M00000131",
  "M00000194",
  "M00000387",
  "M00000606",
  "M00000390",
  "M00000564",
  "M00000029",
  "M00000599",
  "M00000784",
  "M00000479",
  "M00000668",
  "M00000058",
  "M00000465",
  "M00000169",
  "M00000256",
  "M00000225",
  "M00000206",
  "M00000118",
  "M00000353",
  "M00000667",
  "M00000600",
  "M00000582",
  "M00000832",
  "M00000004",
  "M00000337",
  "M00000584",
  "M00000603",
  "M00000269",
  "M00000008",
  "M00000288",
  "M00000394",
  "M00000604",
  "M00000557",
  "M00000811",
  "M00000545",
  "M00000641",
  "M00000311",
  "M00000073",
  "M00000148",
  "M00000165",
  "M00000195",
  "M00000583",
  "M00000091",
  "M00000255",
  "M00000331",
  "M00000151",
  "T00000006",
  "M00000360",
  "M00000184",
  "M00000574",
  "M00000243",
  "M00000431",
  "M00000101",
  "M00000830",
  "M00000495",
  "M00000494",
  "M00000519",
  "M00000049",
  "M00000568",
  "M00000306",
  "M00000521",
  "M00000070",
  "M00000452",
  "M00000383",
  "M00000020",
  "M00000573",
  "M00000231",
  "M00000033",
  "M00000153",
  "M00000127",
  "M00000445",
  "M00000448",
  "M00000462",
  "M00000634",
  "T00000077",
  "M00000722",
  "M00000666",
  "M00000594",
  "M00000030",
  "M00000771",
  "M00000141",
  "M00000848",
  "M00000221",
  "M00000303",
  "M00000376",
  "M00000515",
  "M00000657",
  "M00000040",
  "M00000330",
  "M00000284",
  "M00000467",
  "M00000345",
  "M00000035",
  "M00000224",
  "M00000650",
  "M00000505",
  "M00000514",
  "M00000663",
  "M00000736",
  "M00000489",
  "T00000038",
  "M00000409",
  "M00000354",
  "M00000648",
  "M00000627",
  "M00000161",
  "M00000737",
  "M00000721",
  "M00000111",
  "M00000233",
  "M00000552",
  "M00000044",
  "M00000120",
  "T00000046",
  "M00000646",
  "M00000316",
  "M00000145",
  "M00000703",
  "M00000281",
  "M00000572",
  "M00000300",
  "M00000658",
  "M00000343",
  "M00000116",
  "M00000531",
  "M00000598",
  "M00000577",
  "M00000852",
  "M00000644",
  "M00000818",
  "M00000110",
  "M00000616",
  "M00000846",
  "M00000094",
  "M00000785",
  "M00000163",
  "M00000096",
  "M00000461",
  "M00000820",
  "M00000751",
  "M00000048",
  "M00000235",
  "M00000090",
  "M00000127",
  "M00000228",
  "M00000637",
  "M00000277",
  "M00000662",
  "M00000756",
  "M00000446",
  "M00000100",
  "M00000013",
  "M00000591",
  "M00000251",
  "M00000252",
  "M00000748",
  "M00000457",
  "M00000530",
  "M00000179",
  "M00000456",
  "M00000150",
  "M00000653",
  "M00000164",
  "M00000487",
  "M00000554",
  "M00000146",
  "M00000012",
  "M00000113",
  "M00000569",
  "M00000229",
  "M00000276",
  "M00000130",
  "M00000079",
  "M00000166",
  "M00000464",
  "M00000122",
  "M00000580",
  "M00000261",
  "M00000678",
  "M00000400",
  "M00000389",
  "M00000104",
  "M00000324",
  "M00000114",
  "M00000017",
  "M00000594",
  "M00000711",
  "M00000628",
  "M00000629",
  "M00000317",
  "M00000024",
  "M00000799",
  "M00000357",
  "M00000735",
  "M00000549",
  "M00000039",
  "M00000280",
  "M00000506",
  "M00000556",
  "M00000042",
  "M00000625",
  "M00000532",
  "M00000858",
  "M00000679",
  "M00000656",
  "M00000050"
]);
function f_(e) {
  return typeof e == "string" && Qo._isKey(e);
}
function h_(e) {
  return rae.safeParse(e).success;
}
var oae = ae(pe(), 1), aae = ae(pe(), 1);
function iae(e) {
  return { mlsid: e, ...(0, aae.expected)(Qo[e], `Invalid MLSID: ${e}`) };
}
var m_ = /* @__PURE__ */ new Map();
for (const e of Qo._keys) {
  const { constellation1ID: t } = Qo[e];
  t !== void 0 && m_.set(t, e);
}
function sae(e) {
  if ((0, oae.isUndefined)(e))
    return;
  const t = m_.get(e);
  if (t !== void 0)
    return iae(t);
}
ae(pe(), 1);
ae(pe(), 1);
var lae = /* @__PURE__ */ new Map();
for (const e of Qo._keys) {
  const { shortName: t } = Qo[e];
  t !== void 0 && lae.set(t.toLowerCase(), e);
}
ae(pe(), 1);
var uae = /* @__PURE__ */ new Map();
for (const e of Qo._keys) {
  const { abodeMLSName: t } = Qo[e];
  t !== void 0 && uae.set(t.toLowerCase(), e);
}
ae(pe(), 1);
ae(pe(), 1);
function cae() {
  const e = /* @__PURE__ */ new Map();
  return Qo._keys.forEach((t) => {
    const { resoID: n } = Qo[t];
    n && e.set(n.toLowerCase(), t);
  }), e;
}
cae();
var m3 = "tkl:";
function dae(e) {
  const t = Qo[e];
  return t && typeof t == "object" && "resoID" in t ? t.resoID : null;
}
function p_(e) {
  if (!(e != null && e.startsWith(m3)))
    return null;
  const t = e.slice(m3.length), n = t.indexOf(":");
  if (n < 0)
    return null;
  let r = t.slice(0, n);
  const o = t.slice(n + 1);
  if (!f_(r) && !h_(r))
    return null;
  const a = dae(r);
  return a && (r = a), { mls: r, listingID: o };
}
function g_(e) {
  return typeof e == "string" && p_(e) !== null;
}
function fae(e) {
  if (!g_(e))
    throw new Error(`Invalid ToolkitListingID: ${e}`);
  return e;
}
var pb = ae(pe(), 1);
function hae(e) {
  if ((0, pb.isUndefined)(e.mls))
    throw new Error("Listing is missing a valid MLS");
  if ((0, pb.isUndefined)(e.listingID))
    throw new Error("Listing is missing a ListingID");
  if (e.mls.includes(":"))
    throw new Error(`Invalid MLS ID: ${e.mls}`);
  return `${m3}${e.mls}:${e.listingID}`;
}
var v_ = Uh(
  g_,
  "invalid ToolkitListingID"
);
b().brand("ToolkitRecordID");
var _f = ae(pe(), 1), gb = "tkp:";
function mae(e) {
  return e.replaceAll("~1", "/").replaceAll("~0", "~");
}
function pae(e) {
  if (!e.startsWith(gb))
    return null;
  const t = e.slice(gb.length).split("/").map(mae);
  if (t[0] !== "order")
    return null;
  const n = t[1];
  if (!(0, _f.isDefined)(n))
    return null;
  switch (t[2]) {
    case "subject":
      return { orderID: n, location: { t: "subject" } };
    case "comp": {
      const r = t[3];
      return (0, _f.isDefined)(r) ? { orderID: n, location: { t: "comp", attachmentID: r } } : null;
    }
    case "dataset": {
      const r = t[3], o = t[4];
      if (!(0, _f.isDefined)(r) || !(0, _f.isDefined)(o))
        return null;
      const a = fae(o);
      return { orderID: n, location: { t: "dataset", datasetID: r, listingID: a } };
    }
    default:
      return null;
  }
}
function gae(e) {
  return typeof e == "string" && pae(e) !== null;
}
var p3 = Uh(
  gae,
  "Invalid ToolkitRecordID"
), vae = w({
  toolkitRecordID: p3,
  toolkitListingID: v_,
  mls: b(),
  address: Gd,
  projectPhase: b(),
  projectName: b(),
  salePrice: Pe,
  listPrice: Pe,
  grossMonthlyRent: Pe,
  rentControl: J(),
  dataSources: b(),
  verificationSources: b(),
  saleType: Sn,
  financingType: b(),
  financialConcessionAmount: Pe,
  listingStatus: Sn,
  listDate: nr,
  contractDate: nr,
  closeDate: nr,
  withdrawalDate: nr,
  expirationDate: nr,
  leaseholdOrFeeSimple: Sn,
  locationImpact: Sn,
  locationFactorOne: Sn,
  locationFactorTwo: Sn,
  site: wt,
  viewImpact: Sn,
  viewFactorOne: Sn,
  viewFactorTwo: Sn,
  designAttachmentType: Sn,
  designNumberOfStories: D(),
  designStyle: Sn,
  quality: Sn,
  age: D(),
  yearBuilt: D(),
  condition: Sn,
  aboveGradeBedroomCount: zt,
  aboveGradeFullBathCount: zt,
  aboveGradeHalfBathCount: zt,
  aboveGradeThreeQuarterBathCount: zt,
  aboveGradeTotalRoomCount: zt,
  grossLivingArea: wt,
  grossBuildingArea: wt,
  totalBasementArea: wt,
  finishedBasementArea: wt,
  basementFinishedRoomCount: zt,
  basementDescription: b(),
  belowGradeExteriorAccessType: Sn,
  belowGradeRecRoomCount: zt,
  belowGradeBedroomCount: zt,
  belowGradeFullBathCount: D(),
  belowGradeHalfBathCount: zt,
  belowGradeThreeQuarterBathCount: zt,
  belowGradeOtherRoomCount: zt,
  finishedRoomsBelowGrade: zt,
  heatingCooling: b(),
  functionalUtility: Sn,
  energyEfficientItems: b(),
  attachedGarageParkingSpacesCount: zt,
  detachedGarageParkingSpacesCount: zt,
  builtInGarageParkingSpacesCount: zt,
  carportParkingSpacesCount: zt,
  drivewayParkingSpacesCount: zt,
  porchPatioDeck: b(),
  hoaMonthlyAssessment: Pe,
  commonElementsAndRecFacilities: b(),
  floorLocation: Sn,
  dynamicFields: gn(
    b(),
    nn([eae, n2(), Vi()])
  ),
  propertyType: b(),
  stucturalDesignDescription: Sn,
  structureType: Sn,
  storiesDescription: b(),
  elementarySchool: b(),
  mlsArea: b(),
  listingID: b(),
  marketingCommentary: b(),
  images: se(w({ url: b() })),
  daysOnMarket: zt,
  cumulativeDaysOnMarket: zt,
  longitude: D(),
  latitude: D(),
  architectureStyle: b(),
  assesorsMapReferenceID: b(),
  parcelID: b(),
  censusTractID: b(),
  zoningDescription: b(),
  legalDescription: b(),
  sewerType: b(),
  annualTaxAmount: Pe,
  taxYear: D(),
  ownerOccupied: J(),
  cooling: b(),
  greenEnergyEfficient: b(),
  heating: b(),
  poolFeatures: b(),
  custom: b(),
  additionalFeature1Title: b(),
  additionalFeature1Description: b(),
  additionalFeature2Title: b(),
  additionalFeature2Description: b(),
  additionalFeature3Title: b(),
  additionalFeature3Description: b()
}).partial(), U2 = Ac(
  vae.transform((e) => e)
), g1 = ae(pe(), 1), qh = /^([0-9]{4})-(1[0-2]|0[1-9])$/, Zr = b().regex(qh).brand("IsoMonth"), C_ = ["Active", "Contract", "Expired", "Withdrawn", "SettledSale"], Cae = C_.map((e) => ({
  key: e,
  label: e,
  value: e
})), x9 = Me([
  "Active",
  "Contract",
  "Expired",
  "Withdrawn",
  "SettledSale"
]), b_ = w({
  listingStatus: x9.optional(),
  contractMonth: Zr.optional(),
  closeMonth: Zr.optional(),
  withdrawalMonth: Zr.optional(),
  expirationMonth: Zr.optional()
}), Gr = D().gte(0).brand("ParkingSpaceNumber"), y_ = $t({
  attachedGarageSpaces: Gr,
  detachedGarageSpaces: Gr,
  builtInGarageSpaces: Gr,
  carportSpaces: Gr,
  drivewaySpaces: Gr
}).partial(), S_ = D().gte(1).multipleOf(0.01), w9 = Me(["AT", "DT", "SD"]), A_ = $t({
  attachmentType: w9,
  stories: S_,
  style: b()
}).partial(), M_ = $t({
  mls: b(),
  listingID: b(),
  daysOnMarket: _e
}).partial(), x_ = $t({
  age: _e,
  isEstimation: J()
}).partial(), w_ = $t({
  fullBaths: _e,
  halfBaths: _e
}).partial(), __ = Me(["wu", "wo", "in"]), I_ = $t({
  total: wt,
  finished: wt,
  accessType: __
}).partial(), L_ = $t({
  recRoomCount: _e,
  bedroomCount: _e,
  fullBathCount: _e,
  halfBathCount: _e,
  otherRoomCount: _e
}).partial(), bae = ae(pe(), 1), _9 = Me([
  "REO",
  "Short",
  "CrtOrd",
  "Estate",
  "Relo",
  "NonArm",
  "ArmLth",
  "Listing"
]), yae = (0, bae.makeLookup)({
  cases: [
    ["REO", "REO Sale"],
    ["Short", "Short Sale"],
    ["CrtOrd", "Court-Ordered Sale"],
    ["Estate", "Estate Sale"],
    ["Relo", "Relocation Sale"],
    ["NonArm", "Non-Arm's Length Sale"],
    ["ArmLth", "Arm's Length Sale"],
    ["Listing", "Listing"]
  ]
});
_9.options.map((e) => ({
  key: e,
  value: e,
  label: yae(e)
}));
var Q1 = Me(["Cash", "Conventional", "FHA", "Private", "USDA", "VA"]), R_ = w({
  id: b(),
  price: qn,
  status: x9,
  contractDate: Zr,
  saleDate: Zr,
  expirationDate: Zr,
  withdrawalDate: Zr,
  mls: Mc,
  mlsListingID: b(),
  originalListPrice: qn,
  daysOnMarket: D(),
  concessions: b(),
  // TODO: Type as schConcessions
  termsOfSale: _9
}).partial(), D_ = class extends Error {
}, ka = class extends D_ {
}, Bt = class extends D_ {
};
function $d(e, t, n = {}) {
  function r(i) {
    return n.caseSensitive ? i.trim() : i.trim().toLowerCase();
  }
  const o = t, a = Object.fromEntries(
    Object.entries(t).map(([i, l]) => [r(l), i])
  );
  return {
    encode(i) {
      const l = o[i];
      if (l === void 0) {
        if (!n.allowOther)
          throw new ka(`Unknown enum variant: ${i}`);
        return i;
      }
      return l;
    },
    decode(i) {
      const l = a[r(i)];
      if (l === void 0) {
        if (!n.allowOther)
          throw new Bt(`Unknown value for ${e}: ${i}`);
        return i;
      }
      return l;
    }
  };
}
var I9 = [
  "REOSale",
  "ShortSale",
  "CourtOrderedSale",
  "EstateSale",
  "RelocationSale",
  "NonArmsLengthSale",
  "ArmsLengthSale",
  "Listing"
], Sae = Me(I9), P_ = $d("sale type", {
  REOSale: "REO",
  ShortSale: "Short",
  CourtOrderedSale: "CrtOrd",
  EstateSale: "Estate",
  RelocationSale: "Relo",
  NonArmsLengthSale: "NonArm",
  ArmsLengthSale: "ArmLth",
  Listing: "Listing"
}), Aae = (e) => e.saleType === void 0 ? "" : P_.encode(e.saleType), Mae = (e, t) => {
  const n = e.trim();
  return { saleType: n === "" ? void 0 : Sae.parse(P_.decode(n)) };
}, xae = { encode: Aae, decode: Mae }, ui = {};
Hd(ui, {
  ISO_MONTH_REGEX: () => qh,
  actualAgeSyntax: () => sm,
  addressSyntax: () => X2,
  aloftDateToIsoMonth: () => Lie,
  areaSyntax: () => L9,
  basementLine1Syntax: () => Jh,
  basementLine2Syntax: () => Qh,
  bathroomSyntax: () => em,
  conditionSyntax: () => Uae,
  dataSourceSyntax: () => Y2,
  dateOfSaleSyntax: () => am,
  designSyntax: () => tm,
  financialConcessionsSyntax: () => lie,
  garageCarportSyntax: () => nm,
  grossLivingAreaSyntax: () => im,
  isoMonthToAloftDate: () => Iie,
  legacyBasementLine2Syntax: () => Wae,
  legacyDateOfSaleSyntax: () => nie,
  locationSyntax: () => mie,
  numberSyntax: () => ys,
  priceSyntax: () => lm,
  qualitySyntax: () => gie,
  saleTypeSyntax: () => xae,
  schActualAge: () => x_,
  schAttachmentType: () => w9,
  schBasementAccessType: () => __,
  schBasementLine1: () => I_,
  schBasementLine2: () => L_,
  schBathroomCount: () => w_,
  schCarStorage: () => y_,
  schComparableStatus: () => b_,
  schDataSource: () => M_,
  schDesignStyle: () => A_,
  schIsoMonth: () => Zr,
  schParkingSpaceNumber: () => Gr,
  schStoriesNum: () => S_,
  schUadListingStatus: () => x9,
  siteSyntax: () => om,
  splitUndelimited: () => Kh,
  statusOptions: () => Cae,
  valuesSaleType: () => I9,
  valuesUadListingStatus: () => C_,
  viewSyntax: () => Aie
});
var E_ = ae(pe(), 1), wae = ae(pe(), 1);
function _ae(e, t) {
  const n = {};
  for (const [r, o] of Object.entries(e))
    n[r] = t(o, r);
  return n;
}
var T_ = Me([
  "AL",
  "AK",
  "AZ",
  "AR",
  "CA",
  "CO",
  "CT",
  "DE",
  "DC",
  "FL",
  "GA",
  "HI",
  "ID",
  "IL",
  "IN",
  "IA",
  "KS",
  "KY",
  "LA",
  "ME",
  "MD",
  "MA",
  "MI",
  "MN",
  "MS",
  "MO",
  "MT",
  "NE",
  "NV",
  "NH",
  "NJ",
  "NM",
  "NY",
  "NC",
  "ND",
  "OH",
  "OK",
  "OR",
  "PA",
  "PR",
  "RI",
  "SC",
  "SD",
  "TN",
  "TX",
  "UT",
  "VT",
  "VA",
  "VI",
  "WA",
  "WV",
  "WI",
  "WY"
]), Iae = {
  AL: "Alabama",
  AK: "Alaska",
  AZ: "Arizona",
  AR: "Arkansas",
  CA: "California",
  CO: "Colorado",
  CT: "Connecticut",
  DE: "Delaware",
  DC: "District of Columbia",
  FL: "Florida",
  GA: "Georgia",
  HI: "Hawaii",
  ID: "Idaho",
  IL: "Illinois",
  IN: "Indiana",
  IA: "Iowa",
  KS: "Kansas",
  KY: "Kentucky",
  LA: "Louisiana",
  ME: "Maine",
  MD: "Maryland",
  MA: "Massachusetts",
  MI: "Michigan",
  MN: "Minnesota",
  MS: "Mississippi",
  MO: "Missouri",
  MT: "Montana",
  NE: "Nebraska",
  NV: "Nevada",
  NH: "New Hampshire",
  NJ: "New Jersey",
  NM: "New Mexico",
  NY: "New York",
  NC: "North Carolina",
  ND: "North Dakota",
  OH: "Ohio",
  OK: "Oklahoma",
  OR: "Oregon",
  PA: "Pennsylvania",
  PR: "Puerto Rico",
  RI: "Rhode Island",
  SC: "South Carolina",
  SD: "South Dakota",
  TN: "Tennessee",
  TX: "Texas",
  UT: "Utah",
  VT: "Vermont",
  VA: "Virginia",
  VI: "Virgin Islands",
  WA: "Washington",
  WV: "West Virginia",
  WI: "Wisconsin",
  WY: "Wyoming"
}, N_ = _ae(Iae, (e) => e.toUpperCase()), vb = Object.fromEntries(
  Object.entries(N_).map(([e, t]) => [t, e])
);
function Lae(e, t = !1) {
  if (e = e.trim().toUpperCase(), vb.hasOwnProperty(e))
    return (0, wae.expected)(vb[e]);
  if (N_.hasOwnProperty(e))
    return e;
  if (t)
    return "";
  throw new Error(`unknown state: ${e}`);
}
function Rae({
  AddressLineText: e,
  unitNumber: t,
  CityName: n,
  StateCode: r,
  PostalCode: o
}) {
  return {
    PropertyStreetAddress: `${e}${(0, E_.isDefined)(t) ? " " + t : ""}`,
    PropertyCity: n,
    PropertyState: r,
    PropertyPostalCode: o
  };
}
function Dae({
  PropertyStreetAddress: e,
  PropertyCity: t,
  PropertyState: n,
  PropertyPostalCode: r
}) {
  let o;
  try {
    o = (0, E_.orUndefined)(T_.parse)(n);
  } catch {
    console.warn(`Ignoring invalid state code: ${n}`);
  }
  return {
    AddressLineText: e,
    CityName: t,
    StateCode: o,
    PostalCode: r
  };
}
var X2 = {
  encode: Rae,
  decode: Dae,
  emptyAnnotations: {
    PropertyStreetAddress: void 0,
    PropertyCity: void 0,
    PropertyState: void 0,
    PropertyPostalCode: void 0
  }
}, Pae = ae(pe(), 1);
function Eae(e) {
  const t = e.toSqFt().unitAmount, n = e.toAcre().unitAmount;
  return n < 1 ? `${t.toFixed(0)} sf` : `${n.toFixed(2)} ac`;
}
function Tae(e) {
  const t = /^([0-9.,]+)\s*(\S+)$/i.exec(e.trim());
  if (t === null)
    throw new Bt(`Unknown area format: ${e}`);
  let [, n, r] = (0, Pae.checkLength)(3, t);
  switch (n = n.replaceAll(",", ""), r.toLowerCase()) {
    case "sf":
    case "sqft":
    case "ft2":
      return Dt.fromNumber(parseFloat(n), "sqft");
    case "ac":
    case "acre":
    case "acres":
      return Dt.fromNumber(parseFloat(n), "acre");
    default:
      throw new Bt(`Unknown unit of area: ${r}`);
  }
}
var L9 = { encode: Eae, decode: Tae }, g3 = ae(pe(), 1), Nae = new RegExp(/^((\d+)sf((\d+)sf)?)?(wo|wu|in)?$/);
function kae({ total: e, finished: t, accessType: n }) {
  return [e, t, n].every(g3.isUndefined) ? "" : `${e ? Math.round(e.getUnitAmount("sqft")) : 0}sf${t ? Math.round(t.getUnitAmount("sqft")) + "sf" : ""}${n || ""}`;
}
function Vae(e) {
  const t = e.trim();
  if (t === "")
    return {};
  const n = t.match(Nae);
  if (!n)
    throw new Bt(`Invalid Basement Line 1: ${e}`);
  const r = n[2], o = n[4], a = n[5];
  return {
    total: (0, g3.orUndefined)((i) => Dt.fromString(i, "sqft"))(r),
    finished: (0, g3.orUndefined)((i) => Dt.fromString(i, "sqft"))(o),
    accessType: a
  };
}
var Jh = {
  encode: kae,
  decode: Vae
}, Oae = ae(pe(), 1), Fae = ae(pe(), 1);
function* Kh(e) {
  const t = /\s*([0-9.]+)\s*([a-zA-Z]+)\s*/g;
  for (; ; ) {
    if (t.lastIndex === e.length)
      return;
    const n = t.exec(e);
    if (n === null)
      throw new Bt(`Invalid format: ${e}`);
    const [, r, o] = (0, Fae.checkLength)(3, n);
    yield [r, o];
  }
}
var Bae = new RegExp(/^(\d+(rr|br|o)|\d+\.\d+ba)*$/);
function Hae(e) {
  const t = [];
  if (e.recRoomCount !== void 0 && t.push(`${e.recRoomCount}rr`), e.bedroomCount !== void 0 && t.push(`${e.bedroomCount}br`), e.fullBathCount !== void 0 || e.halfBathCount !== void 0) {
    const n = e.fullBathCount ?? 0, r = e.halfBathCount ?? 0;
    t.push(`${n}.${r}ba`);
  }
  return e.otherRoomCount !== void 0 && t.push(`${e.otherRoomCount}o`), t.join("");
}
function Gae(e) {
  const t = e.trim().toLowerCase(), n = {};
  if (t === "")
    return n;
  if (!t.match(Bae))
    throw new Bt(`Invalid Basement Line 2: ${e}`);
  for (const [r, o] of Kh(t))
    switch (o) {
      case "rr":
        if (n.recRoomCount !== void 0)
          throw new Bt('"rr" appears multiple times in input');
        n.recRoomCount = _e.parse(r);
        break;
      case "br":
        if (n.bedroomCount !== void 0)
          throw new Bt('"br" appears multiple times in input');
        n.bedroomCount = _e.parse(r);
        break;
      case "ba":
        if (n.fullBathCount !== void 0 || n.halfBathCount !== void 0)
          throw new Bt('"ba" appears multiple times in input');
        const [a, i] = (0, Oae.checkMinLength)(2, r.split("."));
        n.fullBathCount = _e.parse(a), n.halfBathCount = i === void 0 ? _e.parse(0) : _e.parse(i);
        break;
      case "o":
        if (n.otherRoomCount !== void 0)
          throw new Bt('"o" appears multiple times in input');
        n.otherRoomCount = _e.parse(r);
        break;
      default:
        throw new Bt(`Unknown below grade room type: ${o}`);
    }
  return n;
}
var Qh = {
  encode: Hae,
  decode: Gae
}, $ae = ae(pe(), 1);
function Zae(e) {
  var n;
  const t = [];
  if (e.belowGradeRecRoomCount !== void 0 && t.push(`${e.belowGradeRecRoomCount.value}rr`), e.belowGradeBedroomCount !== void 0 && t.push(`${e.belowGradeBedroomCount.value}br`), e.belowGradeFullBathCount !== void 0 || e.belowGradeHalfBathCount !== void 0) {
    const r = Math.round(e.belowGradeFullBathCount ?? 0), o = ((n = e.belowGradeHalfBathCount) == null ? void 0 : n.value) ?? 0;
    t.push(`${r}.${o}ba`);
  }
  return e.belowGradeOtherRoomCount !== void 0 && t.push(`${e.belowGradeOtherRoomCount.value}o`), t.join("");
}
function jae(e) {
  const t = e.trim(), n = {
    belowGradeRecRoomCount: void 0,
    belowGradeBedroomCount: void 0,
    belowGradeFullBathCount: void 0,
    belowGradeHalfBathCount: void 0,
    belowGradeOtherRoomCount: void 0
  };
  if (t === "")
    return n;
  for (const [r, o] of Kh(t))
    switch (o.toLowerCase()) {
      case "rr":
        if (n.belowGradeRecRoomCount !== void 0)
          throw new Bt('"rr" appears multiple times in input');
        n.belowGradeRecRoomCount = gt.fromNumber(parseInt(r));
        break;
      case "br":
        if (n.belowGradeBedroomCount !== void 0)
          throw new Bt('"br" appears multiple times in input');
        n.belowGradeBedroomCount = gt.fromNumber(parseInt(r));
        break;
      case "ba":
        if (n.belowGradeFullBathCount !== void 0 || n.belowGradeHalfBathCount !== void 0)
          throw new Bt('"ba" appears multiple times in input');
        const [a, i] = (0, $ae.checkMinLength)(2, r.split("."));
        n.belowGradeFullBathCount = parseInt(a), n.belowGradeHalfBathCount = i === void 0 ? gt.zero : gt.fromNumber(parseInt(i));
        break;
      case "o":
        if (n.belowGradeOtherRoomCount !== void 0)
          throw new Bt('"o" appears multiple times in input');
        n.belowGradeOtherRoomCount = gt.fromNumber(parseInt(r));
        break;
      default:
        throw new Bt(`Unknown parking space type: ${o}`);
    }
  return n;
}
var Wae = {
  encode: Zae,
  decode: jae
}, Cb = ae(pe(), 1), em = {
  encode: (e) => {
    const t = e.fullBaths ?? 0, n = e.halfBaths ?? 0;
    return `${t}.${n}`;
  },
  decode: (e) => {
    const [t, n] = e.trim().split(".").map((r) => r.trim());
    try {
      return {
        fullBaths: (0, Cb.orUndefined)(_e.parse)(t),
        halfBaths: (0, Cb.orUndefined)(_e.parse)(n)
      };
    } catch {
      throw new Bt(`Invalid bathroom count provided: ${e}`);
    }
  }
}, zae = /* @__PURE__ */ new Set(["C1", "C2", "C3", "C4", "C5", "C6"]), Uae = {
  encode(e) {
    return e.condition ?? "";
  },
  decode(e) {
    const t = e.trim().toUpperCase();
    if (t === "")
      return { condition: void 0 };
    if (!zae.has(t))
      throw new Bt(`Invalid quality code: ${t}`);
    return { condition: t };
  }
}, Xae = ae(pe(), 1), Yae = new RegExp(/^[^;]*;\s*dom\s*(\d+|unk)$/), qae = new RegExp(/^dom (\d+|unk)$/);
function Jae({ mls: e, listingID: t, daysOnMarket: n }) {
  return [e, t, n].every(Xae.isUndefined) ? "" : `${e ?? ""}${t ? `#${t}` : ""}; DOM ${n ?? "Unk"}`;
}
function Kae(e) {
  var l;
  if (e === "")
    return {};
  if (!e.trim().toLowerCase().match(Yae))
    throw new Bt(`Invalid data source: ${e}`);
  const [t, n] = e.split(";"), [r, o] = (t == null ? void 0 : t.split("#")) ?? [];
  let a;
  const i = (l = n == null ? void 0 : n.trim().toLowerCase()) == null ? void 0 : l.match(qae);
  if (i && i[1] !== "unk")
    try {
      a = _e.parse(+i[1]);
    } catch (u) {
      console.warn("Could not parse DOM", u);
    }
  return {
    mls: (r == null ? void 0 : r.trim()) === "" || r == null ? void 0 : r.trim(),
    listingID: Qae(o),
    daysOnMarket: a
  };
}
function Qae(e) {
  const t = e != null && e.startsWith(":") ? e.slice(1) : e, n = t == null ? void 0 : t.trim();
  return n === "" ? void 0 : n;
}
var Y2 = {
  encode: Jae,
  decode: Kae
}, v3 = ae(pe(), 1);
function eie(e) {
  const { listingStatus: t, contractDate: n, closeDate: r, withdrawalDate: o, expirationDate: a } = e;
  if (t === void 0)
    throw new ka("Listing status is required");
  switch (t) {
    case "Active":
      return "Active";
    case "Expired": {
      if (a === void 0)
        throw new ka("Missing expiration date for expired listing");
      return "e" + Oa.encode(a);
    }
    case "Withdrawn": {
      if (o === void 0)
        throw new ka("Missing withdrawal date for withdrawn listing");
      return "w" + Oa.encode(o);
    }
    case "Contract": {
      if (n === void 0)
        throw new ka("Missing contract date for contract listing");
      return "c" + Oa.encode(n);
    }
    case "SettledSale": {
      if (r === void 0)
        throw new ka("Missing close date for settled listing");
      const i = "s" + Oa.encode(r), l = n === void 0 ? "Unk" : "c" + Oa.encode(n);
      return `${i};${l}`;
    }
    default:
      throw new ka(`Unknown listing status: ${t}`);
  }
}
function tie(e, t) {
  const n = e.trim().toLowerCase(), r = {
    listingStatus: void 0,
    closeDate: void 0,
    contractDate: void 0,
    expirationDate: void 0,
    withdrawalDate: void 0
  };
  if (n === "")
    return r;
  if (n === "active")
    return r.listingStatus = "Active", r;
  const o = (t == null ? void 0 : t.closeDate) ?? (t == null ? void 0 : t.contractDate) ?? (t == null ? void 0 : t.expirationDate) ?? (t == null ? void 0 : t.withdrawalDate);
  switch (n.charAt(0)) {
    case "e": {
      r.listingStatus = "Expired", r.expirationDate = Oa.decode(
        n.slice(1),
        (t == null ? void 0 : t.expirationDate) ?? o
      );
      break;
    }
    case "w": {
      r.listingStatus = "Withdrawn", r.withdrawalDate = Oa.decode(
        n.slice(1),
        (t == null ? void 0 : t.withdrawalDate) ?? o
      );
      break;
    }
    case "c": {
      r.listingStatus = "Contract", r.contractDate = Oa.decode(n.slice(1), (t == null ? void 0 : t.contractDate) ?? o);
      break;
    }
    case "s": {
      const a = n.split(";").map((u) => u.trim()), [i, l] = (0, v3.checkMinLength)(1, a);
      r.listingStatus = "SettledSale", r.closeDate = Oa.decode(
        i.slice(1),
        (t == null ? void 0 : t.closeDate) ?? o
      ), r.contractDate = l === void 0 || l === "unk" ? void 0 : Oa.decode(l.slice(1), (t == null ? void 0 : t.contractDate) ?? o);
      break;
    }
    default:
      throw new Bt(`Invalid FNMA UAD date of sale string: ${n}`);
  }
  return r;
}
var Oa = {
  encode: (e) => e.format("MM/yy"),
  decode: (e, t) => {
    let n;
    if (n = /^([0-9]{2})\/([0-9]{2})$/.exec(e), n === null)
      throw new Bt(`${e}: Invalid date format, expected MM/YY`);
    const [, r, o] = (0, v3.checkLength)(3, n), a = parseInt(r), i = parseInt(o);
    let l = 1990, u = 1;
    if (t !== void 0 && (n = /^([0-9]{4})-([0-9]{2})-([0-9]{2})$/.exec(t.toIsoString()), n !== null)) {
      const [, x, , _] = (0, v3.checkLength)(4, n);
      l = parseInt(x), u = parseInt(_);
    }
    const d = 1900 + i, f = 2e3 + i, h = Math.abs(d - l) < Math.abs(f - l) ? d : f, p = a, g = u, C = h.toFixed(0).padStart(4, "0"), v = p.toFixed(0).padStart(2, "0"), y = g.toFixed(0).padStart(2, "0"), M = `${C}-${v}-${y}`;
    return rr.fromIsoString(M);
  }
}, nie = {
  encode: eie,
  decode: tie
}, bb = ae(pe(), 1), rie = new RegExp(/^(AT|DT|SD)?(\d|\d\.\d{1,2})?;(.+)?$/);
function oie(e) {
  var r;
  const t = ["", ""];
  let n = ((r = e.stories) == null ? void 0 : r.toFixed(2)) ?? "";
  for (; n.endsWith("0"); )
    n = n.slice(0, -1);
  return n.endsWith(".") && (n = n.slice(0, -1)), t[0] = `${e.attachmentType ?? ""}${n}`, e.style !== void 0 && (t[1] = e.style), t.join(";");
}
function aie(e) {
  if (e === "")
    return {
      attachmentType: void 0,
      stories: void 0,
      style: void 0
    };
  const t = e.match(rie);
  if (!t)
    throw new Bt(`Cannot decode design style: ${e}`);
  return {
    attachmentType: (0, bb.orUndefined)(w9.parse)(t[1]),
    stories: (0, bb.orUndefined)((n) => +n)(t[2]),
    style: t[3]
  };
}
var tm = { encode: oie, decode: aie }, k_ = $d(
  "financing type",
  {
    Conventional: "Conv",
    FHA: "FHA",
    VA: "VA",
    Cash: "Cash",
    USDA: "USDA",
    Private: "Private"
  },
  { allowOther: !0 }
), iie = (e) => {
  var o;
  const t = e.financingType === void 0 ? "" : k_.encode(e.financingType), n = ((o = e.financialConcessionAmount) == null ? void 0 : o.toString(!0)) ?? "", r = `${t};${n}`;
  return r === ";" ? "" : r;
}, sie = (e) => {
  let [t, n] = e.split(";").map((a) => a.trim());
  if (t === "Conv" && (t = "Conventional"), !e.includes(";"))
    return Q1.safeParse(t).success ? { financingType: Q1.parse(t) } : Number.isNaN(Number(t.replaceAll("$", "").replaceAll(",", ""))) ? {} : { financialConcessionAmount: Yt.fromDollarLike(t) };
  const r = t === "" ? void 0 : t, o = n === "" ? void 0 : n;
  return {
    financingType: r ? Q1.parse(k_.decode(r)) : void 0,
    financialConcessionAmount: o ? Yt.fromDollarLike(o, "usd") : void 0
  };
}, lie = { encode: iie, decode: sie };
function uie(e) {
  const t = [];
  return e.attachedGarageSpaces !== void 0 && t.push(`${e.attachedGarageSpaces}ga`), e.detachedGarageSpaces !== void 0 && t.push(`${e.detachedGarageSpaces}gd`), e.builtInGarageSpaces !== void 0 && t.push(`${e.builtInGarageSpaces}gbi`), e.carportSpaces !== void 0 && t.push(`${e.carportSpaces}cp`), e.drivewaySpaces !== void 0 && t.push(`${e.drivewaySpaces}dw`), t.length < 1 ? "None" : t.join("");
}
function cie(e) {
  const t = e.trim().toLowerCase(), n = {
    attachedGarageSpaces: void 0,
    detachedGarageSpaces: void 0,
    builtInGarageSpaces: void 0,
    carportSpaces: void 0,
    drivewaySpaces: void 0
  };
  if (t === "" || t === "none")
    return n;
  for (const [r, o] of Kh(t))
    switch (o) {
      case "ga":
        if (n.attachedGarageSpaces !== void 0)
          throw new Bt('"ga" appears multiple times in input');
        n.attachedGarageSpaces = v1(r);
        break;
      case "gd":
        if (n.detachedGarageSpaces !== void 0)
          throw new Bt('"gd" appears multiple times in input');
        n.detachedGarageSpaces = v1(r);
        break;
      case "gbi":
        if (n.builtInGarageSpaces !== void 0)
          throw new Bt('"gbi" appears multiple times in input');
        n.builtInGarageSpaces = v1(r);
        break;
      case "cp":
        if (n.carportSpaces !== void 0)
          throw new Bt('"cp" appears multiple times in input');
        n.carportSpaces = v1(r);
        break;
      case "dw":
        if (n.drivewaySpaces !== void 0)
          throw new Bt('"dw" appears multiple times in input');
        n.drivewaySpaces = v1(r);
        break;
      default:
        throw new Bt(`Unknown parking space type: ${o}`);
    }
  return n;
}
var nm = {
  encode: uie,
  decode: cie
};
function v1(e) {
  if (isNaN(+e)) {
    console.warn(`${e} is not a n`);
    return;
  }
  try {
    return Gr.parse(+e);
  } catch {
    console.warn(`${e} does not match parking space schema`);
    return;
  }
}
var die = ae(pe(), 1), rm = $d("impact rating", {
  Neutral: "N",
  Beneficial: "B",
  Adverse: "A"
}), q2 = $d(
  "location type",
  {
    Residential: "Res",
    Industrial: "Ind",
    Commercial: "Comm",
    BusyRoad: "BsyRd",
    WaterFront: "WtrFr",
    GolfCourse: "GlfCse",
    AdjacentToPark: "AdjPrk",
    AdjacentToPowerLines: "AdjPwr",
    Landfill: "Lndfl",
    PublicTransportation: "PubTrn"
  },
  { allowOther: !0 }
);
function fie(e) {
  const t = [];
  for (t.push(
    e.locationImpact === void 0 ? "" : rm.encode(e.locationImpact)
  ), e.locationFactorOne !== void 0 && t.push(q2.encode(e.locationFactorOne)), e.locationFactorTwo !== void 0 && t.push(q2.encode(e.locationFactorTwo)); t.length > 0 && t[0] !== "" && t.length < 3; )
    t.push("");
  return t.join(";");
}
function hie(e) {
  const [t, n, r] = (0, die.checkMinLength)(1, e.trim().split(";"));
  return {
    locationImpact: t === "" ? void 0 : rm.decode(t),
    locationFactorOne: n === void 0 || n === "" ? void 0 : q2.decode(n),
    locationFactorTwo: r === void 0 || r === "" ? void 0 : q2.decode(r)
  };
}
var mie = { encode: fie, decode: hie }, pie = /* @__PURE__ */ new Set(["Q1", "Q2", "Q3", "Q4", "Q5", "Q6"]), gie = {
  encode(e) {
    return e.quality ?? "";
  },
  decode(e) {
    const t = e.trim().toUpperCase();
    if (t === "")
      return { quality: void 0 };
    if (!pie.has(t))
      throw new Bt(`Invalid quality code: ${t}`);
    return { quality: t };
  }
};
function vie(e) {
  return e.site === void 0 ? "" : L9.encode(e.site);
}
function Cie(e) {
  return { site: e.trim() === "" ? void 0 : L9.decode(e) };
}
var om = { encode: vie, decode: Cie }, bie = ae(pe(), 1), J2 = $d(
  "view type",
  {
    WaterView: "Wtr",
    PastoralView: "Pstrl",
    WoodsView: "Woods",
    ParkView: "Prk",
    GolfCourseView: "Glfvw",
    CitySkylineView: "CtySky",
    MountainView: "Mtn",
    ResidentialView: "Res",
    CityStreetView: "CtyStr",
    IndustrialView: "Ind",
    PowerLines: "PwrLn",
    LimitedSight: "LtdSght"
  },
  { allowOther: !0 }
);
function yie(e) {
  const t = [];
  for (t.push(
    e.viewImpact === void 0 ? "" : rm.encode(e.viewImpact)
  ), e.viewFactorOne !== void 0 && t.push(J2.encode(e.viewFactorOne)), e.viewFactorTwo !== void 0 && t.push(J2.encode(e.viewFactorTwo)); t.length > 0 && t[0] !== "" && t.length < 3; )
    t.push("");
  return t.join(";");
}
function Sie(e) {
  const [t, n, r] = (0, bie.checkMinLength)(1, e.trim().split(";"));
  let o;
  try {
    o = t === "" ? void 0 : rm.decode(t);
  } catch {
    console.error("Failed to parse view impact");
  }
  return {
    viewImpact: o,
    viewFactorOne: n === void 0 || n === "" ? void 0 : J2.decode(n),
    viewFactorTwo: r === void 0 || r === "" ? void 0 : J2.decode(r)
  };
}
var Aie = { encode: yie, decode: Sie }, Du = ae(pe(), 1), Mie = new RegExp(
  /^(c|s|w|e)(([0-9]{2}\/[0-9]{2})?)(;(c([0-9]{2}\/[0-9]{2})|unk))?$/
), xie = new RegExp(/^(1[0-2]|0[1-9])\/([0-9]{2})$/);
function wie(e) {
  const { listingStatus: t, contractMonth: n, closeMonth: r, withdrawalMonth: o, expirationMonth: a } = e;
  if ([t, n, r, o, a].every(
    (i) => i === void 0
  ))
    return "";
  if (t === void 0)
    throw new ka("Listing status is required");
  switch (t) {
    case "Active":
      return "Active";
    case "Expired":
      return "e" + If(a);
    case "Withdrawn":
      return "w" + If(o);
    case "Contract":
      return "c" + If(n);
    case "SettledSale": {
      const i = "s" + If(r), l = n === void 0 ? "Unk" : "c" + V_(n);
      return `${i};${l}`;
    }
    default:
      throw new ka(`Unknown listing status: ${t}`);
  }
}
function If(e) {
  return (0, Du.isUndefined)(e) ? "" : V_(e);
}
function _ie(e) {
  const t = e.trim().toLowerCase(), n = {
    listingStatus: void 0,
    closeMonth: void 0,
    contractMonth: void 0,
    expirationMonth: void 0,
    withdrawalMonth: void 0
  };
  if (t === "")
    return n;
  if (t === "active")
    return n.listingStatus = "Active", n;
  const r = t.match(Mie);
  if (!r)
    throw new Bt(`Invalid FNMA UAD date of sale string: ${t}`);
  switch (r[1]) {
    case "e": {
      n.listingStatus = "Expired", n.expirationMonth = (0, Du.orUndefined)(C1)(r[3]);
      break;
    }
    case "w": {
      n.listingStatus = "Withdrawn", n.withdrawalMonth = (0, Du.orUndefined)(C1)(r[3]);
      break;
    }
    case "c": {
      n.listingStatus = "Contract", n.contractMonth = (0, Du.orUndefined)(C1)(r[3]);
      break;
    }
    case "s": {
      n.listingStatus = "SettledSale", n.closeMonth = (0, Du.orUndefined)(C1)(r[3]), r[5] && (n.contractMonth = (0, Du.orUndefined)(C1)(r[6]));
      break;
    }
    default:
      throw new Bt(`Invalid FNMA UAD date of sale string: ${t}`);
  }
  return n;
}
function V_(e) {
  const t = e.match(qh);
  if (!t)
    throw Error(`Invalid ISO month provided: ${e}`);
  return `${t[2]}/${t[1].slice(2)}`;
}
function C1(e) {
  if (e === "unk")
    return;
  const t = e.match(xie);
  if (!t) {
    console.error(`Invalid UAD month provided: ${e}`);
    return;
  }
  const n = t[1], r = t[2], o = +r >= 30 ? `19${r}` : `20${r}`;
  return Zr.parse(`${o}-${n}`);
}
function Iie(e) {
  const t = e.match(qh);
  if (!t)
    throw Error(`Invalid ISO month provided: ${e}`);
  return rr.fromIsoString(`${t[1]}-${t[2]}-01`);
}
function Lie(e) {
  return e.format("yyyy-MM");
}
var am = {
  encode: wie,
  decode: _ie
};
function Rie(e) {
  return e.toSqFt().toSqFtValueStringRounded();
}
function Die(e) {
  if (e === "")
    return Dt.zero;
  try {
    return Dt.fromNumber(_e.parse(e), "sqft");
  } catch {
    throw new Bt(`Invalid GLA: ${e}`);
  }
}
var im = { encode: Rie, decode: Die }, Pie = ae(pe(), 1), Eie = new RegExp(/^(~?)(\d*)$/);
function Tie({ age: e, isEstimation: t }) {
  return `${t ? "~" : ""}${(0, Pie.isDefined)(e) ? e : ""}`;
}
function Nie(e) {
  if (e === "")
    return {};
  const t = e.match(Eie);
  if (!t)
    throw new Bt(`Invalid actual age: ${e}`);
  const n = t[1], r = t[2], o = n === "~";
  return {
    age: r === "" ? void 0 : _e.parse(+r),
    isEstimation: o
  };
}
var sm = { encode: Tie, decode: Nie };
function kie(e) {
  return (e == null ? void 0 : e.toNumericPrice().toFixed(0)) ?? "";
}
function Vie(e) {
  if (e !== "")
    try {
      return Yt.fromDollarLike(e);
    } catch {
      throw new Bt(`Invalid price: ${e}`);
    }
}
var lm = { encode: kie, decode: Vie }, Oie = ae(pe(), 1);
function Fie(e) {
  const t = e == null ? void 0 : e.toString();
  return (0, Oie.isUndefined)(t) ? "" : t;
}
function Bie(e) {
  const t = e.trim();
  if (t === "")
    return;
  const n = +t;
  if (isNaN(n))
    throw new Bt(`Invalid number: ${e}`);
  return n;
}
var ys = { encode: Fie, decode: Bie }, Co = {
  StructuralDesignDescription: {
    values: [
      "Craftsman",
      "Mid Century",
      "Tudor",
      "Victorian",
      "Contemporary",
      "Traditional",
      "Bungalow",
      "Cape Code",
      "Modern"
    ],
    allowOther: !0
  },
  ValueMarketabilityImpactType: {
    // only UAD
    values: ["Neutral", "Beneficial", "Adverse"],
    allowOther: !1
  },
  BelowGradeExteriorAccessType: {
    values: ["WalkOut", "WalkUp", "InteriorOnly"],
    allowOther: !1
  },
  StructuralDesignType: {
    // This one is a shot in the dark
    // /VALUATION_RESPONSE/PROPERTY/PROJECT[@_DesignType='Other' and @_DesignTypeOtherDescription='AttachedAndDetached']
    values: ["Attached", "Detached"],
    allowOther: !0
  },
  ListingStatusType: {
    values: [
      "Active",
      "Expired",
      "Withdrawn",
      "Contract",
      "SettledSale",
      "Rented",
      "Backup",
      "ComingSoon",
      "Off-Market",
      "Deleted",
      "Cancelled",
      "Other",
      "Unknown",
      "Pending"
    ],
    allowOther: !1
  },
  OverallConditionRatingCode: {
    values: ["C1", "C2", "C3", "C4", "C5", "C6"],
    allowOther: !1
  },
  OverallQualityRatingCode: {
    values: ["Q1", "Q2", "Q3", "Q4", "Q5", "Q6"],
    allowOther: !1
  },
  ViewType: {
    // TODO this also has a PDF view
    values: [
      "WaterView",
      "PastoralView",
      "WoodsView",
      "ParkView",
      "GolfCourseView",
      "CitySkylineView",
      "MountainView",
      "ResidentialView",
      "CityStreetView",
      "IndustrialView",
      "PowerLines",
      "LimitedSight"
    ],
    allowOther: !0
  },
  LocationType: {
    // This also requires PDF Display values
    values: [
      "Residential",
      "Industrial",
      "Commercial",
      "BusyRoad",
      "WaterFront",
      "GolfCourse",
      "AdjacentToPark",
      "AdjacentToPowerLines",
      "Landfill",
      "PublicTransportation"
    ],
    allowOther: !0
  },
  LeaseholdOrFeeSimple: { values: ["Leasehold", "FeeSimple"], allowOther: !1 },
  DesignAttachmentType: { values: ["Detached", "Attached", "SemiDetached"], allowOther: !1 }
}, Hie = ae(Yh(), 1), Gie = (0, Hie.AloftEnum)()({
  Active: "Active",
  Expired: "Expired",
  Withdrawn: "Withdrawn",
  Contract: "Contract",
  SettledSale: "SettledSale"
}), $ie = {
  values: Gie._keys,
  allowOther: !1
}, O_ = {
  address: {
    label: "Address",
    type: "address",
    valueProps: {
      formatValue: (e) => {
        var t;
        return ((t = e.address) == null ? void 0 : t.AddressLineText) ?? "";
      }
    }
  },
  projectPhase: {
    label: "Project Phase",
    type: "string",
    valueProps: {
      annotator: {
        t: "string",
        optional: !0,
        valueKey: "projectPhase"
      }
    }
  },
  projectName: {
    label: "Project Name",
    type: "string",
    valueProps: {
      annotator: {
        t: "string",
        optional: !0,
        valueKey: "projectName"
      }
    }
  },
  salePrice: {
    label: "Sale Price",
    type: "price",
    valueProps: {
      annotator: { t: "AloftPrice", optional: !0, valueKey: "salePrice" },
      formatValue: (e) => {
        var t;
        return ((t = e.salePrice) == null ? void 0 : t.toString(!0)) ?? "";
      }
    }
  },
  listPrice: {
    label: "List Price",
    type: "price",
    valueProps: {
      annotator: {
        t: "AloftPrice",
        optional: !0,
        valueKey: "listPrice"
      }
    }
  },
  grossMonthlyRent: {
    label: "Gross Monthly Rent",
    type: "price",
    valueProps: {
      annotator: {
        t: "AloftPrice",
        optional: !0,
        valueKey: "grossMonthlyRent"
      }
    }
  },
  rentControl: {
    label: "Rent Control",
    type: "boolean",
    valueProps: {
      annotator: {
        t: "boolean",
        optional: !0,
        valueKey: "rentControl"
      }
    }
  },
  dataSources: {
    label: "Data Source(s)",
    isHiddenForSubject: !0,
    type: "string",
    valueProps: {
      annotator: {
        t: "string",
        optional: !0,
        valueKey: "dataSources"
      }
    }
  },
  verificationSources: {
    label: "Verification Source(s)",
    isHiddenForSubject: !0,
    type: "string",
    valueProps: {
      annotator: {
        t: "string",
        optional: !0,
        valueKey: "verificationSources"
      }
    }
  },
  saleType: {
    label: "Terms of Sale",
    isHiddenForSubject: !0,
    type: "enum",
    valueProps: {
      annotator: {
        t: "ToolkitPropertyEnum",
        optional: !0,
        valueKey: "saleType",
        enum: { values: I9, allowOther: !1 }
      }
    },
    adjustProps: {
      manualTerm: "saleTypeManual"
    }
  },
  financingType: {
    label: "Financing Type",
    isHiddenForSubject: !0,
    type: "enum",
    valueProps: {
      annotator: {
        t: "ToolkitPropertyEnum",
        optional: !0,
        valueKey: "financingType",
        enum: { values: Q1.options, allowOther: !0 }
      }
    }
  },
  financialConcessionAmount: {
    label: "Concession Amount",
    isHiddenForSubject: !0,
    type: "price",
    valueProps: {
      annotator: {
        t: "AloftPrice",
        optional: !0,
        valueKey: "financialConcessionAmount"
      }
    }
  },
  listingStatus: {
    label: "Listing Status",
    isHiddenForSubject: !0,
    type: "enum",
    valueProps: {
      annotator: {
        t: "ToolkitPropertyEnum",
        optional: !0,
        valueKey: "listingStatus",
        enum: $ie
      }
    }
  },
  listDate: {
    label: "List Date",
    isHiddenForSubject: !0,
    type: "date",
    valueProps: {
      annotator: {
        t: "AloftDate",
        optional: !0,
        valueKey: "listDate"
      }
    }
  },
  contractDate: {
    label: "Contract Date",
    isHiddenForSubject: !0,
    type: "date",
    valueProps: {
      annotator: {
        t: "AloftDate",
        optional: !0,
        valueKey: "contractDate"
      }
    }
  },
  closeDate: {
    label: "Close Date",
    isHiddenForSubject: !0,
    type: "date",
    valueProps: {
      annotator: {
        t: "AloftDate",
        optional: !0,
        valueKey: "closeDate"
      }
    }
  },
  withdrawalDate: {
    label: "Withdrawal Date",
    isHiddenForSubject: !0,
    type: "date",
    valueProps: {
      annotator: {
        t: "AloftDate",
        optional: !0,
        valueKey: "withdrawalDate"
      }
    }
  },
  expirationDate: {
    label: "Expiration Date",
    isHiddenForSubject: !0,
    type: "date",
    valueProps: {
      annotator: {
        t: "AloftDate",
        optional: !0,
        valueKey: "expirationDate"
      }
    }
  },
  leaseholdOrFeeSimple: {
    label: "Leasehold/Fee Simple",
    type: "enum",
    valueProps: {
      annotator: {
        t: "ToolkitPropertyEnum",
        optional: !0,
        valueKey: "leaseholdOrFeeSimple",
        enum: Co.LeaseholdOrFeeSimple
      }
    },
    adjustProps: {
      manualTerm: "leaseholdFeeSimpleManual"
    }
  },
  locationImpact: {
    label: "Location Impact",
    type: "enum",
    valueProps: {
      annotator: {
        t: "ToolkitPropertyEnum",
        optional: !0,
        valueKey: "locationImpact",
        enum: Co.ValueMarketabilityImpactType
      }
    }
  },
  locationFactorOne: {
    label: "Location Factor 1",
    type: "enum",
    valueProps: {
      annotator: {
        t: "ToolkitPropertyEnum",
        optional: !0,
        valueKey: "locationFactorOne",
        enum: Co.LocationType
      }
    }
  },
  locationFactorTwo: {
    label: "Location Factor 2 (Opt.)",
    type: "enum",
    valueProps: {
      annotator: {
        t: "ToolkitPropertyEnum",
        optional: !0,
        valueKey: "locationFactorTwo",
        enum: Co.LocationType
      }
    }
  },
  site: {
    label: "Lot Size",
    type: "area",
    valueProps: {
      annotator: {
        t: "AloftArea",
        optional: !0,
        valueKey: "site"
      }
    },
    adjustProps: {
      manualTerm: "siteManual",
      managedTerms: ["site"]
    }
  },
  viewImpact: {
    label: "View Impact",
    type: "enum",
    valueProps: {
      annotator: {
        t: "ToolkitPropertyEnum",
        optional: !0,
        valueKey: "viewImpact",
        enum: Co.ValueMarketabilityImpactType
      }
    }
  },
  viewFactorOne: {
    label: "View Factor 1",
    type: "string",
    valueProps: {
      annotator: {
        t: "ToolkitPropertyEnum",
        optional: !0,
        valueKey: "viewFactorOne",
        enum: Co.ViewType
      }
    }
  },
  viewFactorTwo: {
    label: "View Factor 2 (Opt.)",
    type: "string",
    valueProps: {
      annotator: {
        t: "ToolkitPropertyEnum",
        optional: !0,
        valueKey: "viewFactorTwo",
        enum: Co.ViewType
      }
    }
  },
  designAttachmentType: {
    label: "Attachment Type",
    type: "enum",
    valueProps: {
      annotator: {
        t: "ToolkitPropertyEnum",
        optional: !0,
        valueKey: "designAttachmentType",
        enum: Co.DesignAttachmentType
      }
    }
  },
  designNumberOfStories: {
    label: "# of Stories",
    type: "number",
    valueProps: {
      annotator: {
        t: "number",
        optional: !0,
        valueKey: "designNumberOfStories"
      }
    }
  },
  designStyle: {
    label: "Design (Style)",
    type: "string",
    valueProps: {
      annotator: {
        t: "string",
        optional: !0,
        valueKey: "designStyle"
      }
    }
  },
  quality: {
    label: "Quality",
    type: "enum",
    valueProps: {
      annotator: {
        t: "ToolkitPropertyEnum",
        optional: !0,
        valueKey: "quality",
        enum: Co.OverallQualityRatingCode
      }
    },
    adjustProps: {
      manualTerm: "qualityManual",
      managedTerms: ["quality"]
    }
  },
  age: {
    label: "Actual Age",
    type: "number",
    valueProps: {
      annotator: {
        t: "number",
        optional: !0,
        valueKey: "age"
      }
    },
    adjustProps: {
      manualTerm: "ageManual"
    }
  },
  yearBuilt: {
    label: "Year Built",
    type: "number",
    valueProps: {
      annotator: {
        t: "number",
        optional: !0,
        valueKey: "yearBuilt"
      }
    }
  },
  condition: {
    label: "Condition",
    type: "enum",
    valueProps: {
      annotator: {
        t: "ToolkitPropertyEnum",
        optional: !0,
        valueKey: "condition",
        enum: Co.OverallConditionRatingCode
      }
    },
    adjustProps: {
      manualTerm: "conditionManual",
      managedTerms: ["condition"]
    }
  },
  aboveGradeBedroomCount: {
    label: "Above Grade Bedroom Count",
    type: "count",
    valueProps: {
      annotator: {
        t: "AloftCount",
        optional: !0,
        valueKey: "aboveGradeBedroomCount"
      }
    }
  },
  totalBathCount: {
    label: "Total Bathroom Count",
    type: "count",
    valueProps: {
      annotator: {
        t: "AloftCount",
        optional: !0,
        valueKey: "totalBathCount"
      }
    }
  },
  aboveGradeFullBathCount: {
    label: "Above Grade Bathrooms",
    type: "count",
    valueProps: {
      annotator: {
        t: "AloftCount",
        optional: !0,
        valueKey: "aboveGradeFullBathCount"
      }
    }
  },
  aboveGradeHalfBathCount: {
    label: "Above Grade 1/2 Baths",
    type: "count",
    valueProps: {
      annotator: {
        t: "AloftCount",
        optional: !0,
        valueKey: "aboveGradeHalfBathCount"
      }
    }
  },
  aboveGradeThreeQuarterBathCount: {
    label: "Above Grade 3/4 Baths",
    type: "count",
    valueProps: {
      annotator: {
        t: "AloftCount",
        optional: !0,
        valueKey: "aboveGradeThreeQuarterBathCount"
      }
    }
  },
  aboveGradeTotalRoomCount: {
    label: "Above Grade Room Count",
    type: "count",
    valueProps: {
      annotator: {
        t: "AloftCount",
        optional: !0,
        valueKey: "aboveGradeTotalRoomCount"
      }
    }
  },
  grossLivingArea: {
    label: "Gross Living Area",
    type: "area",
    valueProps: {
      annotator: {
        t: "AloftArea",
        optional: !0,
        valueKey: "grossLivingArea"
      }
    },
    adjustProps: {
      manualTerm: "grossLivingAreaManual",
      managedTerms: ["grossLivingArea"]
    }
  },
  grossBuildingArea: {
    label: "Gross Building Area",
    type: "area",
    valueProps: {
      annotator: {
        t: "AloftArea",
        optional: !0,
        valueKey: "grossBuildingArea"
      }
    }
  },
  hasBasement: {
    label: "Has Basement",
    type: "boolean",
    valueProps: {
      annotator: {
        t: "boolean",
        optional: !0,
        valueKey: "hasBasement"
      }
    }
  },
  totalBasementArea: {
    label: "Total Basement Sqft",
    type: "area",
    valueProps: {
      annotator: {
        t: "AloftArea",
        optional: !0,
        valueKey: "totalBasementArea"
      }
    },
    adjustProps: {
      manualTerm: "totalBasementAreaManual",
      managedTerms: ["totalBasementArea"]
    }
  },
  finishedBasementArea: {
    label: "Finished Basement Sqft",
    type: "area",
    valueProps: {
      annotator: {
        t: "AloftArea",
        optional: !0,
        valueKey: "finishedBasementArea"
      }
    }
  },
  basementFinishedRoomCount: {
    label: "Basement Finished Room Count",
    type: "count",
    valueProps: {
      annotator: {
        t: "AloftCount",
        optional: !0,
        valueKey: "basementFinishedRoomCount"
      }
    }
  },
  basementDescription: {
    label: "Basement Description",
    type: "string",
    valueProps: {
      annotator: {
        t: "string",
        optional: !0,
        valueKey: "basementDescription"
      }
    }
  },
  belowGradeExteriorAccessType: {
    label: "Basement Access",
    type: "enum",
    valueProps: {
      annotator: {
        t: "ToolkitPropertyEnum",
        optional: !0,
        valueKey: "belowGradeExteriorAccessType",
        enum: Co.BelowGradeExteriorAccessType
      }
    }
  },
  belowGradeRecRoomCount: {
    label: "Below Grade Rec Rooms",
    type: "count",
    valueProps: {
      annotator: {
        t: "AloftCount",
        optional: !0,
        valueKey: "belowGradeRecRoomCount"
      }
    }
  },
  belowGradeBedroomCount: {
    label: "Below Grade Bedrooms",
    type: "count",
    valueProps: {
      annotator: {
        t: "AloftCount",
        optional: !0,
        valueKey: "belowGradeBedroomCount"
      }
    }
  },
  belowGradeFullBathCount: {
    label: "Below Grade Bathrooms",
    type: "number",
    valueProps: {
      annotator: {
        t: "number",
        optional: !0,
        valueKey: "belowGradeFullBathCount"
      }
    }
  },
  belowGradeHalfBathCount: {
    label: "Below Grade 1/2 Baths",
    type: "count",
    valueProps: {
      annotator: {
        t: "AloftCount",
        optional: !0,
        valueKey: "belowGradeHalfBathCount"
      }
    }
  },
  belowGradeThreeQuarterBathCount: {
    label: "Below Grade 3/4 Baths",
    type: "count",
    valueProps: {
      annotator: {
        t: "AloftCount",
        optional: !0,
        valueKey: "belowGradeThreeQuarterBathCount"
      }
    }
  },
  belowGradeOtherRoomCount: {
    label: "Below Grade Other Rooms",
    type: "count",
    valueProps: {
      annotator: {
        t: "AloftCount",
        optional: !0,
        valueKey: "belowGradeOtherRoomCount"
      }
    }
  },
  finishedRoomsBelowGrade: {
    label: "Below Grade Finished Rooms",
    type: "count",
    valueProps: {
      annotator: {
        t: "AloftCount",
        optional: !0,
        valueKey: "finishedRoomsBelowGrade"
      }
    }
  },
  heatingCooling: {
    label: "Heating/Cooling",
    type: "string",
    valueProps: {
      annotator: {
        t: "string",
        optional: !0,
        valueKey: "heatingCooling"
      }
    },
    adjustProps: {
      manualTerm: "heatingCoolingManual"
    }
  },
  functionalUtility: {
    label: "Functionality Utility",
    type: "enum",
    valueProps: {
      annotator: {
        t: "string",
        optional: !0,
        valueKey: "functionalUtility"
      }
    },
    adjustProps: {
      manualTerm: "functionalUtilityManual",
      managedTerms: ["functionalUtility"]
    }
  },
  energyEfficientItems: {
    label: "Energy Efficient Items",
    type: "string",
    valueProps: {
      annotator: {
        t: "string",
        optional: !0,
        valueKey: "energyEfficientItems"
      }
    },
    adjustProps: {
      manualTerm: "energyEfficientItemsManual",
      managedTerms: ["energyEfficientItems"]
    }
  },
  attachedGarageParkingSpacesCount: {
    label: "Attached Garage Spaces",
    type: "count",
    valueProps: {
      annotator: {
        t: "AloftCount",
        optional: !0,
        valueKey: "attachedGarageParkingSpacesCount"
      }
    }
  },
  detachedGarageParkingSpacesCount: {
    label: "Detached Garage Spaces",
    type: "count",
    valueProps: {
      annotator: {
        t: "AloftCount",
        optional: !0,
        valueKey: "detachedGarageParkingSpacesCount"
      }
    }
  },
  builtInGarageParkingSpacesCount: {
    label: "Built-in Garage Spaces",
    type: "count",
    valueProps: {
      annotator: {
        t: "AloftCount",
        optional: !0,
        valueKey: "builtInGarageParkingSpacesCount"
      }
    }
  },
  carportParkingSpacesCount: {
    label: "Carport Spaces",
    type: "count",
    valueProps: {
      annotator: {
        t: "AloftCount",
        optional: !0,
        valueKey: "carportParkingSpacesCount"
      }
    }
  },
  drivewayParkingSpacesCount: {
    label: "Driveway Spaces",
    type: "count",
    valueProps: {
      annotator: {
        t: "AloftCount",
        optional: !0,
        valueKey: "drivewayParkingSpacesCount"
      }
    }
  },
  porchPatioDeck: {
    label: "Porch/Patio/Deck",
    type: "string",
    valueProps: {
      annotator: {
        t: "string",
        optional: !0,
        valueKey: "porchPatioDeck"
      }
    },
    adjustProps: {
      manualTerm: "porchPatioDeckManual"
    }
  },
  hoaMonthlyAssessment: {
    label: "HOA Monthly Assessment",
    type: "price",
    valueProps: {
      annotator: {
        t: "AloftPrice",
        optional: !0,
        valueKey: "hoaMonthlyAssessment"
      }
    }
  },
  commonElementsAndRecFacilities: {
    label: "Common Elements and Rec Facilities",
    type: "string",
    valueProps: {
      annotator: {
        t: "string",
        optional: !0,
        valueKey: "commonElementsAndRecFacilities"
      }
    }
  },
  floorLocation: {
    label: "Floor Location",
    type: "enum",
    valueProps: {
      annotator: {
        t: "ToolkitPropertyEnum",
        optional: !0,
        valueKey: "floorLocation",
        enum: { values: [], allowOther: !1 }
      }
    }
  },
  propertyType: {
    label: "Property Type",
    type: "string",
    valueProps: {
      annotator: {
        t: "string",
        optional: !0,
        valueKey: "propertyType"
      }
    }
  },
  propertySubtype: {
    label: "Property Subtype",
    type: "string",
    valueProps: {
      annotator: {
        t: "string",
        optional: !0,
        valueKey: "propertySubtype"
      }
    }
  },
  stucturalDesignDescription: {
    label: "Structural Design",
    type: "enum",
    valueProps: {
      annotator: {
        t: "ToolkitPropertyEnum",
        optional: !0,
        valueKey: "stucturalDesignDescription",
        enum: Co.StructuralDesignDescription
      }
    }
  },
  structureType: {
    label: "Structure Type",
    type: "enum",
    valueProps: {
      annotator: {
        t: "ToolkitPropertyEnum",
        optional: !0,
        valueKey: "structureType",
        enum: Co.StructuralDesignType
      }
    }
  },
  storiesDescription: {
    label: "Stories Description",
    type: "string",
    valueProps: {
      annotator: {
        t: "string",
        optional: !0,
        valueKey: "storiesDescription"
      }
    }
  },
  elementarySchool: {
    label: "Elementary School",
    type: "string",
    valueProps: {
      annotator: {
        t: "string",
        optional: !0,
        valueKey: "elementarySchool"
      }
    }
  },
  mlsArea: {
    label: "MLS Area",
    type: "string",
    valueProps: {
      annotator: {
        t: "string",
        optional: !0,
        valueKey: "mlsArea"
      }
    }
  },
  listingID: {
    label: "Listing ID",
    type: "string",
    valueProps: {
      annotator: {
        t: "string",
        optional: !0,
        valueKey: "listingID"
      }
    }
  },
  marketingCommentary: {
    label: "Marketing Commentary",
    type: "string",
    valueProps: {
      annotator: {
        t: "string",
        optional: !0,
        valueKey: "marketingCommentary"
      }
    }
  },
  daysOnMarket: {
    label: "Days on Market",
    type: "count",
    valueProps: {
      annotator: {
        t: "AloftCount",
        optional: !0,
        valueKey: "daysOnMarket"
      }
    }
  },
  cumulativeDaysOnMarket: {
    label: "Cumulative Days on Market",
    type: "count",
    valueProps: {
      annotator: {
        t: "AloftCount",
        optional: !0,
        valueKey: "cumulativeDaysOnMarket"
      }
    }
  },
  longitude: {
    label: "Longitude",
    type: "number",
    valueProps: {
      annotator: {
        t: "number",
        optional: !0,
        valueKey: "longitude"
      }
    }
  },
  latitude: {
    label: "Latitude",
    type: "number",
    valueProps: {
      annotator: {
        t: "number",
        optional: !0,
        valueKey: "latitude"
      }
    }
  },
  architectureStyle: {
    label: "Architectural Style",
    type: "string",
    valueProps: {
      annotator: {
        t: "string",
        optional: !0,
        valueKey: "architectureStyle"
      }
    }
  },
  assesorsMapReferenceID: {
    label: "Assessors Map Reference ID",
    type: "string",
    valueProps: {
      annotator: {
        t: "string",
        optional: !0,
        valueKey: "assesorsMapReferenceID"
      }
    }
  },
  parcelID: {
    label: "Parcel ID",
    type: "string",
    valueProps: {
      annotator: {
        t: "string",
        optional: !0,
        valueKey: "parcelID"
      }
    }
  },
  censusTractID: {
    label: "Census Tract ID",
    type: "string",
    valueProps: {
      annotator: {
        t: "string",
        optional: !0,
        valueKey: "censusTractID"
      }
    }
  },
  zoningDescription: {
    label: "Zoning Description",
    type: "string",
    valueProps: {
      annotator: {
        t: "string",
        optional: !0,
        valueKey: "zoningDescription"
      }
    }
  },
  legalDescription: {
    label: "Legal Description",
    type: "string",
    valueProps: {
      annotator: {
        t: "string",
        optional: !0,
        valueKey: "legalDescription"
      }
    }
  },
  sewerType: {
    label: "Sewer Type",
    type: "string",
    valueProps: {
      annotator: {
        t: "string",
        optional: !0,
        valueKey: "sewerType"
      }
    }
  },
  annualTaxAmount: {
    label: "Annual Tax Amount",
    type: "price",
    valueProps: {
      annotator: {
        t: "AloftPrice",
        optional: !0,
        valueKey: "annualTaxAmount"
      }
    }
  },
  taxYear: {
    label: "Tax Year",
    type: "number",
    valueProps: {
      annotator: {
        t: "number",
        optional: !0,
        valueKey: "taxYear"
      }
    }
  },
  ownerOccupied: {
    label: "Owner Occupied",
    type: "boolean",
    valueProps: {
      annotator: {
        t: "boolean",
        optional: !0,
        valueKey: "ownerOccupied"
      }
    }
  },
  hasAttachment: {
    label: "Has Attachment",
    type: "boolean",
    valueProps: {
      annotator: {
        t: "boolean",
        optional: !0,
        valueKey: "hasAttachment"
      }
    }
  },
  mls: {
    label: "MLS",
    type: "string",
    valueProps: {
      annotator: {
        t: "string",
        optional: !0,
        valueKey: "mls"
      }
    }
  },
  additionalFeature1Title: {
    label: "Additional Feature 1 Title",
    type: "string",
    valueProps: {
      annotator: {
        t: "string",
        optional: !0,
        valueKey: "additionalFeature1Title"
      }
    }
  },
  additionalFeature1Description: {
    label: (e) => e.additionalFeature1Title ?? "Additional Feature 1",
    type: "string",
    valueProps: {
      annotator: {
        t: "string",
        optional: !0,
        valueKey: "additionalFeature1Description"
      }
    },
    adjustProps: {
      manualTerm: "additionalFeature1Manual",
      managedTerms: ["additionalFeature1"]
    }
  },
  additionalFeature2Title: {
    label: "Additional Feature 2 Title",
    type: "string",
    valueProps: {
      annotator: {
        t: "string",
        optional: !0,
        valueKey: "additionalFeature2Title"
      }
    }
  },
  additionalFeature2Description: {
    label: (e) => e.additionalFeature2Title ?? "Additional Feature 2",
    type: "string",
    valueProps: {
      annotator: {
        t: "string",
        optional: !0,
        valueKey: "additionalFeature2Description"
      }
    },
    adjustProps: {
      manualTerm: "additionalFeature2Manual",
      managedTerms: ["additionalFeature2"]
    }
  },
  additionalFeature3Title: {
    label: "Additional Feature 3 Title",
    type: "string",
    valueProps: {
      annotator: {
        t: "string",
        optional: !0,
        valueKey: "additionalFeature3Title"
      }
    }
  },
  additionalFeature3Description: {
    label: (e) => e.additionalFeature3Title ?? "Additional Feature 3",
    type: "string",
    valueProps: {
      annotator: {
        t: "string",
        optional: !0,
        valueKey: "additionalFeature3Description"
      }
    },
    adjustProps: {
      manualTerm: "additionalFeature3Manual",
      managedTerms: ["additionalFeature3"]
    }
  },
  salesPricePerGrossLivingArea: {
    label: "Sale Price/GLA",
    type: "string",
    valueProps: {
      formatValue: (e) => {
        const { salePrice: t } = e, n = e.grossLivingArea;
        return t === void 0 || n === void 0 ? "" : t.div(n.toSqFt().unitAmount).toString();
      }
    }
  },
  dateOfSale: {
    label: "Date of Sale",
    type: "string",
    isHiddenForSubject: !0,
    valueProps: {
      formatValue: ui.legacyDateOfSaleSyntax.encode
    },
    adjustProps: {
      manualTerm: "dateOfSaleManual",
      managedTerms: ["dateOfSale", "listToSale"],
      isRequired: !0
    }
  },
  location: {
    label: "Location",
    type: "string",
    valueProps: {
      formatValue: ui.locationSyntax.encode
    },
    adjustProps: {
      manualTerm: "locationManual",
      managedTerms: ["location"]
    }
  },
  view: {
    label: "View",
    type: "string",
    valueProps: {
      formatValue: ui.viewSyntax.encode
    },
    adjustProps: {
      manualTerm: "viewManual",
      managedTerms: ["view"]
    }
  },
  design: {
    label: "Design (Style)",
    type: "string",
    valueProps: {
      formatValue: (e) => {
        const t = e.designAttachmentType === "Attached" ? "AT" : e.designAttachmentType === "Detached" ? "DT" : e.designAttachmentType === "SemiDetached" ? "SD" : void 0;
        return ui.designSyntax.encode({
          attachmentType: t,
          stories: e.designNumberOfStories,
          style: e.designStyle
        });
      }
    },
    adjustProps: {
      manualTerm: "designManual",
      managedTerms: ["design", "designAttachmentType", "designNumberOfStories"]
    }
  },
  aboveGradeRoomCount: {
    label: "Above Grade Rooms",
    type: "string",
    valueProps: {
      formatValue: ({
        aboveGradeTotalRoomCount: e,
        aboveGradeBedroomCount: t,
        aboveGradeFullBathCount: n,
        aboveGradeHalfBathCount: r
      }) => {
        const o = (e == null ? void 0 : e.value) ?? 0, a = (t == null ? void 0 : t.value) ?? 0, i = (n == null ? void 0 : n.value) ?? 0, l = (r == null ? void 0 : r.value) ?? 0;
        return `${o}r${a}bd${i}.${l}ba`;
      }
    },
    adjustProps: {
      manualTerm: "aboveGradeRoomCountManual",
      managedTerms: [
        "aboveGradeBedroomCount",
        "aboveGradeFullBathCount",
        "aboveGradeHalfBathCount"
      ]
    }
  },
  belowGradeRoomCount: {
    label: "Below Grade Rooms",
    type: "string",
    valueProps: {
      formatValue: ui.legacyBasementLine2Syntax.encode
    },
    adjustProps: {
      manualTerm: "belowGradeRoomCountManual"
    }
  },
  garage: {
    label: "Garage/Carport",
    type: "string",
    valueProps: {
      formatValue: (e) => {
        var t, n, r, o, a;
        return ui.garageCarportSyntax.encode({
          attachedGarageSpaces: (0, g1.orUndefined)(Gr.parse)(
            (t = e.attachedGarageParkingSpacesCount) == null ? void 0 : t.toNumber()
          ),
          detachedGarageSpaces: (0, g1.orUndefined)(Gr.parse)(
            (n = e.detachedGarageParkingSpacesCount) == null ? void 0 : n.toNumber()
          ),
          builtInGarageSpaces: (0, g1.orUndefined)(Gr.parse)(
            (r = e.builtInGarageParkingSpacesCount) == null ? void 0 : r.toNumber()
          ),
          carportSpaces: (0, g1.orUndefined)(Gr.parse)(
            (o = e.carportParkingSpacesCount) == null ? void 0 : o.toNumber()
          ),
          drivewaySpaces: (0, g1.orUndefined)(Gr.parse)(
            (a = e.drivewayParkingSpacesCount) == null ? void 0 : a.toNumber()
          )
        });
      }
    },
    adjustProps: {
      manualTerm: "garageManual",
      managedTerms: [
        "garageParkingSpacesCount",
        "carportParkingSpacesCount",
        "drivewayParkingSpacesCount"
      ]
    }
  },
  financialConcessions: {
    label: "Financial Concessions",
    type: "string",
    valueProps: {
      formatValue: ({ financingType: e, financialConcessionAmount: t }) => ui.financialConcessionsSyntax.encode({
        financingType: Q1.parse(e),
        financialConcessionAmount: t
      })
    },
    adjustProps: {
      manualTerm: "financialConcessionsManual"
    }
  },
  cooling: {
    label: "Cooling",
    type: "string",
    valueProps: {
      annotator: {
        t: "string",
        optional: !0,
        valueKey: "cooling"
      }
    }
  },
  greenEnergyEfficient: {
    label: "Energy Efficiency",
    type: "string",
    valueProps: {
      annotator: {
        t: "string",
        optional: !0,
        valueKey: "greenEnergyEfficient"
      }
    }
  },
  heating: {
    label: "Heating",
    type: "string",
    valueProps: {
      annotator: {
        t: "string",
        optional: !0,
        valueKey: "heating"
      }
    }
  },
  poolFeatures: {
    label: "Pool",
    type: "string",
    valueProps: {
      annotator: {
        t: "string",
        optional: !0,
        valueKey: "poolFeatures"
      }
    }
  },
  custom: {
    label: "Custom",
    type: "string",
    valueProps: {
      annotator: {
        t: "string",
        optional: !0,
        valueKey: "custom"
      }
    }
  }
}, F_ = ae(pe(), 1);
function ts(e) {
  const { valueProps: t } = O_[e], n = t.formatValue ? t.formatValue : (r) => Zie((0, F_.expected)(t.annotator), r) ?? "";
  return (r) => {
    try {
      return n(r);
    } catch (o) {
      if (o instanceof ka)
        return "";
      throw o;
    }
  };
}
var Zie = (e, t) => {
  const n = t[e.valueKey];
  switch (e.t) {
    case "string":
      return n;
    case "number":
      return n == null ? void 0 : n.toString();
    case "boolean":
      return (0, F_.orUndefined)(String)(n);
    case "ToolkitPropertyEnum":
      return n;
    case "AloftArea":
      return n == null ? void 0 : n.toString();
    case "AloftCount":
      return n == null ? void 0 : n.toString();
    case "AloftDate":
      return n == null ? void 0 : n.format();
    case "AloftPrice":
      return n == null ? void 0 : n.toString();
    case "AloftTime":
      return n == null ? void 0 : n.toIsoString();
    default:
      throw new Error(
        `Unsupported annotator type: ${e.t}`
      );
  }
}, jie = ae(pe(), 1), Wie = ae(Yh(), 1), zie = class extends Error {
};
function Uie(e, t) {
  if (!e)
    throw new zie(t ?? `Assertion failed (got ${e})`);
}
var O1 = nn([
  D(),
  wt,
  zt,
  nr,
  Pe,
  Bn
]);
ae(pe(), 1);
function Xie(e) {
  return !!(e === null || e === void 0 || typeof e == "number" || Dt.isAloftArea(e) || gt.isAloftCount(e) || rr.isAloftDate(e) || Yt.isAloftPrice(e) || wi.isAloftTime(e));
}
var Yie = ae(pe(), 1);
function qie(e, t) {
  return e === null ? null : typeof t == "number" ? e : t instanceof Dt ? Dt.fromNumber(e, "sqft").toUnit(t.unit) : t instanceof gt ? gt.fromNumber(e) : t instanceof rr ? rr.fromNumericDate(e) : t instanceof Yt ? Yt.fromNumericPrice(e, t.currency) : t instanceof wi ? wi.fromUnix(e) : (0, Yie.unreachable)(t);
}
var Jie = ae(y9(), 1), Kie = ae(pe(), 1);
function Qie(e) {
  return e === null ? null : typeof e == "number" ? e : e instanceof Dt ? e.toSqFt().unitAmount : e instanceof gt ? e.value : e instanceof rr ? e.toNumericDate() : e instanceof Yt ? e.toNumericPrice() : e instanceof wi ? e.toUnix() : (0, Kie.unreachable)(e);
}
var ese = new Jie.Lens(
  (e) => Qie(e),
  (e, t) => qie(t, e)
), tse = ae(pe(), 1);
function K2(e, t = "unit") {
  switch (e.t) {
    case "linear":
      return `${e.slope.toString()} per ${t}`;
    case "monthly":
      return `${(e.percent * 100).toFixed(1)}% per month`;
    default:
      (0, tse.unreachable)(e);
  }
}
function nse(e) {
  return typeof e == "string" || Xie(e);
}
function lr(e) {
  const { customRate: t, key: n, unit: r, rateToString: o, example: a, defaultGridValue: i } = e, l = O_[n];
  return {
    customRate: t,
    propertyKeys: [n],
    getAnalysisValue(u) {
      var f;
      const d = u === void 0 ? void 0 : u[(f = l.valueProps.annotator) == null ? void 0 : f.valueKey];
      return nse(d) ? d : void 0;
    },
    rateToString: o ?? ((u) => K2(u, r)),
    unit: r,
    example: a,
    defaultGridValue: i
  };
}
var rse = {
  customRate: "percentPerMonth",
  propertyKeys: ["closeDate", "listingStatus"],
  getAnalysisValue(e, t, n) {
    if (e === void 0)
      return;
    const { listingStatus: r } = e, o = n !== "comparable" ? "closeDate" : (t == null ? void 0 : t.dateOfSaleVariant) ?? "closeDate", a = e[o];
    if ((0, jie.isDefined)(r) && r === "SettledSale")
      return a;
  },
  rateToString: ise,
  example: rr.today()
}, ose = {
  propertyKeys: [
    "detachedGarageParkingSpacesCount",
    "attachedGarageParkingSpacesCount",
    "builtInGarageParkingSpacesCount"
  ],
  customRate: "dollarPerUnit",
  getAnalysisValue: (e) => gt.addWithNulls(
    (e == null ? void 0 : e.detachedGarageParkingSpacesCount) ?? null,
    (e == null ? void 0 : e.attachedGarageParkingSpacesCount) ?? null,
    (e == null ? void 0 : e.builtInGarageParkingSpacesCount) ?? null
  ) ?? void 0,
  rateToString: (e) => K2(e, "space"),
  unit: "space",
  example: gt.zero,
  defaultGridValue: gt.zero
}, ase = {
  getAnalysisValue: () => {
  },
  rateToString: () => "n/a"
};
function ise(e) {
  if (e.t === "linear") {
    const t = ese.map(e.slope, (n) => n * 365 / 12);
    return Uie(t instanceof Yt), K2({ t: "linear", slope: t }, "month");
  }
  return K2(e, "day");
}
var sse = (0, Wie.AloftEnum)()({
  salePrice: lr({ key: "salePrice", example: Yt.zero }),
  dateOfSale: rse,
  listToSale: lr({
    customRate: "listToSale",
    key: "listingStatus"
  }),
  site: lr({
    customRate: "dollarPerSqft",
    key: "site",
    unit: "sf",
    example: Dt.zero
  }),
  designStyle: lr({ key: "designStyle" }),
  designAttachmentType: lr({ key: "designAttachmentType" }),
  designNumberOfStories: lr({
    customRate: "dollarPerUnit",
    key: "designNumberOfStories",
    unit: "story",
    example: 0
  }),
  grossLivingArea: lr({
    customRate: "dollarPerSqft",
    key: "grossLivingArea",
    unit: "sf",
    example: Dt.zero
  }),
  aboveGradeBedroomCount: lr({
    customRate: "dollarPerUnit",
    key: "aboveGradeBedroomCount",
    unit: "bedroom",
    example: gt.zero,
    defaultGridValue: gt.zero
  }),
  aboveGradeFullBathCount: lr({
    customRate: "dollarPerUnit",
    key: "aboveGradeFullBathCount",
    unit: "bath",
    example: gt.zero,
    defaultGridValue: gt.zero
  }),
  aboveGradeHalfBathCount: lr({
    customRate: "dollarPerUnit",
    key: "aboveGradeHalfBathCount",
    unit: "half bath",
    example: gt.zero,
    defaultGridValue: gt.zero
  }),
  totalBasementArea: lr({
    customRate: "dollarPerSqft",
    key: "totalBasementArea",
    unit: "sf",
    example: Dt.zero
  }),
  garageParkingSpacesCount: ose,
  carportParkingSpacesCount: lr({
    customRate: "dollarPerUnit",
    key: "carportParkingSpacesCount",
    unit: "space",
    example: gt.zero,
    defaultGridValue: gt.zero
  }),
  drivewayParkingSpacesCount: lr({
    customRate: "dollarPerUnit",
    key: "drivewayParkingSpacesCount",
    unit: "space",
    example: gt.zero,
    defaultGridValue: gt.zero
  }),
  cooling: lr({ key: "cooling", unit: "cooling" }),
  greenEnergyEfficient: lr({
    key: "greenEnergyEfficient",
    unit: "energy efficiency"
  }),
  heating: lr({ key: "heating", unit: "heating" }),
  poolFeatures: lr({ key: "poolFeatures", unit: "pool" }),
  porchPatioDeck: lr({ key: "porchPatioDeck", unit: "patio/porch" }),
  additionalFeature: ase,
  location: lr({ key: "locationFactorOne" })
}), lse = Me(sse._keys), use = nn([b(), O1]), cse = w({
  t: fe("absolute"),
  value: Pe
}), dse = w({
  t: fe("percent"),
  value: D()
});
na("t", [
  cse,
  dse
]);
var R9 = na("t", [
  w({ t: fe("monthly"), percent: D() }),
  w({ t: fe("linear"), slope: Pe })
]), C3 = w({
  // Date of sale variant only applies to comp values, not market values
  dateOfSaleVariant: Me(["closeDate", "contractDate"])
}).partial(), Q2 = b(), xc = Me([
  "dateOfSaleManual",
  "dateOfSale",
  "listToSale",
  "siteManual",
  "site",
  "locationManual",
  "location",
  "viewManual",
  "view",
  "designManual",
  "design",
  "designAttachmentType",
  "designNumberOfStories",
  "qualityManual",
  "quality",
  "conditionManual",
  "condition",
  "grossLivingAreaManual",
  "grossLivingArea",
  "aboveGradeRoomCountManual",
  "aboveGradeBedroomCount",
  "aboveGradeFullBathCount",
  "aboveGradeHalfBathCount",
  "energyEfficientItemsManual",
  "energyEfficientItems",
  "totalBasementAreaManual",
  "totalBasementArea",
  "functionalUtilityManual",
  "functionalUtility",
  "garageManual",
  "garageParkingSpacesCount",
  "carportParkingSpacesCount",
  "drivewayParkingSpacesCount",
  "additionalFeature1Manual",
  "additionalFeature1",
  "additionalFeature2Manual",
  "additionalFeature2",
  "additionalFeature3Manual",
  "additionalFeature3",
  "saleTypeManual",
  "financialConcessionsManual",
  "leaseholdFeeSimpleManual",
  "ageManual",
  "belowGradeRoomCountManual",
  "heatingCoolingManual",
  "porchPatioDeckManual",
  "finishedBasementAreaManual",
  "basementAccessManual",
  "nonStandardGrossLivingAreaManual",
  "cooling",
  "greenEnergyEfficient",
  "heating",
  "pool",
  "porchPatioDeck"
]), fse = w({
  group: w({
    none: w({}).optional(),
    monthly: w({}).optional(),
    quarterly: w({}).optional(),
    nmonth: w({ months: se(D()) }).optional(),
    days: w({ days: se(D()) }).optional(),
    increments: w({ increments: se(D()) }).optional(),
    values: w({ count: D().optional() }).optional()
  }),
  dateOfSaleGroupedWindowed: J().optional()
}), hse = w({
  irregular: J().optional()
}), mse = w({
  degrees: se(D()),
  dateOfSaleLinearWindowed: J().optional()
});
w({
  grouped: fse.optional(),
  paired: hse.optional(),
  polynomial: mse.optional()
});
var pse = na("t", [
  w({
    t: fe("custom"),
    rate: R9,
    featureOptions: C3.optional()
  }),
  w({
    t: fe("customListToSale"),
    ratio: D(),
    featureOptions: C3.optional()
  }),
  w({
    t: fe("analysis"),
    analysis: Q2
  })
]), gse = na("t", [
  w({
    t: fe("acrossTheBoard")
  }),
  w({
    t: fe("analysis"),
    analysis: Q2
  }),
  w({
    t: fe("irregularPaired"),
    analysis: Q2,
    direction: Me(["superior", "inferior"])
  })
]), vse = na("t", [
  w({ t: fe("none") }),
  w({ t: fe("monthly") }),
  w({ t: fe("quarterly") }),
  w({ t: fe("nmonth"), months: D() }),
  w({ t: fe("days"), days: D() }),
  w({ t: fe("increments"), increment: D() }),
  w({ t: fe("values"), values: se(use) })
]), Cse = w({
  t: fe("grouped"),
  dataset: b(),
  agg: Me(["median", "mean"]),
  group: vse,
  adjustAs: Me(["absolute", "percent"]).optional(),
  dateOfSaleGroupedWindowed: J().optional(),
  windowSizeDays: D().optional()
}), bse = w({
  t: fe("paired"),
  dataset: b(),
  p1: U2,
  p2: U2,
  adjustments: gn(xc, Pe),
  adjustAs: Me(["absolute", "percent"]).optional()
}), yse = w({
  t: fe("polynomial"),
  dataset: b(),
  degree: D(),
  dateOfSaleLinearWindowed: J().optional(),
  windowSizeDays: D().optional()
}), Sse = na("t", [
  Cse,
  bse,
  yse
]), Ase = w({
  lastChangedAt: Bn,
  formula: pse,
  cachedRate: R9.optional()
}), Mse = w({
  lastChangedAt: Bn,
  adjustment: Pe.optional(),
  calculated: Pe.optional(),
  formula: gse.optional()
}), xse = w({
  terms: gn(xc, Mse.optional())
}), wse = w({
  createdAt: Bn,
  lastChangedAt: Bn,
  lastRanAt: Bn.optional(),
  term: xc.optional(),
  feature: lse.optional(),
  featureOptions: C3.optional(),
  formula: Sse,
  cachedRate: R9.optional(),
  title: b().optional(),
  addToCommentary: J().optional()
});
w({
  version: fe("1"),
  createdAt: Bn,
  lastChangedAt: Bn,
  effectiveDate: nr,
  roundToNearest: Pe.optional(),
  acrossTheBoard: gn(xc, Ase),
  comps: gn(p3, xse),
  compsOrder: se(p3),
  analysis: gn(Q2, wse)
});
ts("designStyle"), ts("designAttachmentType"), ts("designNumberOfStories"), ts("cooling"), ts("greenEnergyEfficient"), ts("heating"), ts("poolFeatures"), ts("porchPatioDeck");
Me([
  "market-condition",
  "prior-sales",
  "site-extraction",
  "depreciated-cost"
]);
var _se = Me(["addComps"]), Ise = Me(["paired-cost", "studies"]), D9 = Me([
  "details",
  "features",
  "market",
  "analysis",
  "adjustments",
  "adjustments-grid",
  "commentary",
  "appraisify-commentary",
  "craftsman-cost-approach",
  "reconciliation"
]), Lse = b().refine(
  (e) => D9.options.some((t) => {
    if (e === t || e.startsWith(`${t}#`))
      return !0;
    if (e.startsWith(`${t}?`)) {
      const n = e.split("?")[1] ?? "", [r, o] = n.split("=");
      return r && o && _se.safeParse(r).success;
    }
    return !1;
  })
).brand("PairedCostRouteItemWithQuery");
nn([Ise, D9]);
Me(["adjustments", "comparable", "depreciatedCost"]);
var P9 = Me([
  // Adjustments
  "allCompsAdjustedDown",
  "allCompsAdjustedUp",
  "bracketedMarketValue",
  "limitedAdjustedSalePriceRange",
  // Comparable
  "bracketedGLA",
  "bracketedSiteSize",
  "lessThanThreeSettledSales",
  "similarComparableToSubjectPriorSale",
  // Depreciated Cost
  "bracketedSiteToValueRatio",
  "effectiveAgeLowerThanActualAge",
  "inconsistentCompGlaAdjustment",
  "inconsistentCompSiteAdjustment",
  "largestSiteHasHighestValue",
  "limitedSiteToValueRatioRange",
  "negativeSiteValue",
  "smallestSiteHasLowestValue"
]), Rse = Me(["active", "dismissed"]);
w({
  type: P9,
  status: Rse,
  message: b(),
  propertyID: b().optional(),
  fixingInfo: w({
    tips: b(),
    pairedCostRouteItem: D9.or(Lse)
  })
});
w({
  status: Me(["skipped", "passed", "failed"]),
  message: b(),
  propertyID: b().optional()
});
var wr = w({}).refine((e) => Object.keys(e).length === 0, {
  message: "Object must be empty"
}), Dse = w({
  // aboveGradeFinishedArea: z.nullable(z.unknown()),
  // accessibilityFeatures: z.nullable(z.unknown()),
  // additionalFeeInfo: z.nullable(z.unknown()),
  // additionalParcelsDescription: z.nullable(z.unknown()),
  appliances: Xe(se(b()).or(wr)),
  architecturalStyle: Xe(b()),
  // associationAmenities: z.nullable(z.unknown()),
  associationFee: Xe(b()),
  // associationFee2: z.nullable(z.unknown()),
  // associationFeeIncludes: z.nullable(z.unknown()),
  associationName: Xe(b()),
  // associationName2: z.nullable(z.unknown()),
  // associationPhone: z.nullable(z.unknown()),
  // associationPhone2: z.nullable(z.unknown()),
  // associations: z.nullable(z.record(z.unknown())),
  // atAGlanceFacts: z.nullable(
  //     z.array(
  //         z
  //             .object({
  //                 factLabel: z.nullable(z.string()),
  //                 factValue: z.nullable(z.string()),
  //             })
  //             .partial()
  //     )
  // ),
  // attic: z.nullable(z.unknown()),
  // availabilityDate: z.nullable(z.unknown()),
  basement: Xe(b()),
  basementYN: Xe(J()),
  // bathrooms: z.nullable(z.number()),
  // bathroomsFloat: z.nullable(z.number()),
  bathroomsFull: Xe(D()),
  bathroomsHalf: Xe(D()),
  // bathroomsOneQuarter: z.nullable(z.unknown()),
  // bathroomsPartial: z.nullable(z.unknown()),
  bathroomsThreeQuarter: Xe(D()),
  // bedrooms: z.nullable(z.number()),
  // belowGradeFinishedArea: z.nullable(z.unknown()),
  // bodyType: z.nullable(z.unknown()),
  // builderModel: z.nullable(z.unknown()),
  // builderName: z.nullable(z.unknown()),
  // buildingArea: z.nullable(z.string()),
  // buildingAreaSource: z.nullable(z.unknown()),
  // buildingFeatures: z.nullable(z.unknown()),
  // buildingName: z.nullable(z.unknown()),
  // buyerAgencyCompensation: z.nullable(z.string()),
  // buyerAgencyCompensationType: z.nullable(z.string()),
  // canRaiseHorses: z.nullable(z.boolean()),
  carportParkingCapacity: Xe(D()),
  // cityRegion: z.nullable(z.string()),
  // commonWalls: z.nullable(z.unknown()),
  // communityFeatures: z.nullable(z.unknown()),
  // compensationBasedOn: z.nullable(z.unknown()),
  // constructionMaterials: z.nullable(z.array(z.string())),
  // contingency: z.nullable(z.unknown()),
  cooling: Xe(se(b()).or(wr)),
  // coveredParkingCapacity: z.nullable(z.unknown()),
  // cropsIncludedYN: z.nullable(z.unknown()),
  cumulativeDaysOnMarket: Xe(b()),
  // daysOnZillow: z.nullable(z.number()),
  // developmentStatus: z.nullable(z.unknown()),
  // doorFeatures: z.nullable(z.unknown()),
  // electric: z.nullable(z.array(z.string())),
  elementarySchool: Xe(b()),
  elementarySchoolDistrict: Xe(b()),
  // elevation: z.nullable(z.unknown()),
  // elevationUnits: z.nullable(z.string()),
  // entryLevel: z.nullable(z.unknown()),
  // entryLocation: z.nullable(z.unknown()),
  // exclusions: z.nullable(z.unknown()),
  exteriorFeatures: Xe(se(b()).or(wr)),
  // feesAndDues: z.nullable(z.unknown()),
  // fencing: z.nullable(z.unknown()),
  fireplaceFeatures: Xe(se(b()).or(wr)),
  fireplaces: Xe(D()),
  flooring: Xe(se(b()).or(wr)),
  // foundationArea: z.nullable(z.unknown()),
  // foundationDetails: z.nullable(z.array(z.string())),
  frontageLength: Xe(b()),
  // frontageType: z.nullable(z.unknown()),
  // furnished: z.nullable(z.boolean()),
  garageParkingCapacity: Xe(D()),
  // gas: z.nullable(z.unknown()),
  // greenBuildingVerificationType: z.nullable(z.unknown()),
  // greenEnergyEfficient: z.nullable(z.unknown()),
  // greenEnergyGeneration: z.nullable(z.unknown()),
  // greenIndoorAirQuality: z.nullable(z.unknown()),
  // greenSustainability: z.nullable(z.unknown()),
  // greenWaterConservation: z.nullable(z.unknown()),
  // hasAdditionalParcels: z.nullable(z.boolean()),
  hasAssociation: Xe(J()),
  hasAttachedGarage: Xe(J()),
  // hasAttachedProperty: z.nullable(z.boolean()),
  hasCarport: Xe(J()),
  // hasCooling: z.nullable(z.boolean()),
  // hasElectricOnProperty: z.nullable(z.unknown()),
  hasFireplace: Xe(J()),
  hasGarage: Xe(J()),
  // hasHeating: z.nullable(z.boolean()),
  // hasHomeWarranty: z.nullable(z.boolean()),
  // hasLandLease: z.nullable(z.boolean()),
  hasOpenParking: Xe(J()),
  // hasPetsAllowed: z.nullable(z.unknown()),
  hasPrivatePool: Xe(J()),
  // hasRentControl: z.nullable(z.unknown()),
  hasSpa: Xe(J()),
  // hasView: z.nullable(z.boolean()),
  // hasWaterfrontView: z.nullable(z.unknown()),
  heating: Xe(se(b()).or(wr)),
  highSchool: Xe(b()),
  highSchoolDistrict: Xe(b()),
  // hoaFee: z.nullable(z.unknown()),
  // hoaFeeTotal: z.nullable(z.unknown()),
  homeType: Xe(b()),
  // horseAmenities: z.nullable(z.unknown()),
  // horseYN: z.nullable(z.unknown()),
  // inclusions: z.nullable(z.array(z.string())),
  // incomeIncludes: z.nullable(z.unknown()),
  interiorFeatures: Xe(se(b()).or(wr)),
  // irrigationWaterRightsAcres: z.nullable(z.unknown()),
  // irrigationWaterRightsYN: z.nullable(z.boolean()),
  isNewConstruction: Xe(J()),
  // isSeniorCommunity: z.nullable(z.unknown()),
  // landLeaseAmount: z.nullable(z.unknown()),
  // landLeaseExpirationDate: z.nullable(z.unknown()),
  // laundryFeatures: z.nullable(z.unknown()),
  // levels: z.nullable(z.string()),
  // listAOR: z.nullable(z.unknown()),
  // listingId: z.nullable(z.unknown()),
  // listingTerms: z.nullable(z.string()),
  livingArea: Xe(b()),
  // livingAreaRange: z.nullable(z.unknown()),
  // livingAreaRangeUnits: z.nullable(z.unknown()),
  // livingQuarters: z.nullable(z.record(z.unknown())),
  lotFeatures: Xe(se(b()).or(wr)),
  lotSize: Xe(b()),
  lotSizeDimensions: Xe(fn()),
  // mainLevelBathrooms: z.nullable(z.number()),
  // mainLevelBedrooms: z.nullable(z.number()),
  // marketingType: z.nullable(z.unknown()),
  middleOrJuniorSchool: Xe(b()),
  middleOrJuniorSchoolDistrict: Xe(b()),
  // municipality: z.nullable(z.unknown()),
  // numberOfUnitsInCommunity: z.nullable(z.unknown()),
  // numberOfUnitsVacant: z.nullable(z.unknown()),
  // offerReviewDate: z.nullable(z.string()),
  onMarketDate: Xe(D()),
  // openParkingCapacity: z.nullable(z.unknown()),
  // otherEquipment: z.nullable(z.unknown()),
  // otherFacts: z.nullable(z.record(z.unknown())),
  // otherParking: z.nullable(z.unknown()),
  // otherStructures: z.nullable(z.unknown()),
  // ownership: z.nullable(z.unknown()),
  // ownershipType: z.nullable(z.unknown()),
  parcelNumber: Xe(b()),
  parkingCapacity: Xe(D()),
  parkingFeatures: Xe(se(b()).or(wr)),
  patioAndPorchFeatures: Xe(se(b()).or(wr)),
  poolFeatures: Xe(se(b()).or(wr)),
  // pricePerSquareFoot: z.nullable(z.number()),
  // propertyCondition: z.nullable(z.unknown()),
  propertySubType: Xe(se(b()).or(wr)),
  // roadSurfaceType: z.nullable(z.unknown()),
  roofType: Xe(b()),
  // rooms: z.nullable(
  //     z.array(
  //         z
  //             .object({
  //                 area: z.nullable(z.unknown()),
  //                 description: z.nullable(z.unknown()),
  //                 dimensions: z.nullable(z.unknown()),
  //                 features: z.nullable(z.unknown()),
  //                 level: z.nullable(z.unknown()),
  //                 roomArea: z.nullable(z.unknown()),
  //                 roomAreaSource: z.nullable(z.unknown()),
  //                 roomAreaUnits: z.nullable(z.unknown()),
  //                 roomDescription: z.nullable(z.unknown()),
  //                 roomDimensions: z.nullable(z.unknown()),
  //                 roomFeatures: z.nullable(z.unknown()),
  //                 roomLength: z.nullable(z.unknown()),
  //                 roomLengthWidthSource: z.nullable(z.unknown()),
  //                 roomLengthWidthUnits: z.nullable(z.unknown()),
  //                 roomLevel: z.nullable(z.string()),
  //                 roomType: z.nullable(z.string()),
  //                 roomWidth: z.nullable(z.unknown()),
  //             })
  //             .partial()
  //     )
  // ),
  // securityFeatures: z.nullable(z.unknown()),
  sewer: Xe(se(b()).or(wr)),
  specialListingConditions: Xe(b()),
  stories: Xe(D()),
  structureType: Xe(b()),
  subdivisionName: Xe(b()),
  taxAnnualAmount: Xe(D()),
  taxLegalDescription: Xe(fn()),
  topography: Xe(b()),
  // totalActualRent: z.nullable(z.number()),
  // totalBedrooms: z.nullable(z.unknown()),
  // totalRentableArea: z.nullable(z.unknown()),
  // totalUnits: z.nullable(z.unknown()),
  // unitsInCommunity: z.nullable(z.unknown()),
  // utilities: z.nullable(z.array(z.string())),
  // vegetation: z.nullable(z.array(z.string())),
  view: Xe(se(b()).or(wr)),
  // virtualTour: z.nullable(z.string()),
  waterSource: Xe(se(b()).or(wr)),
  // waterViewYN: z.nullable(z.boolean()),
  waterfrontFeatures: Xe(se(b()).or(wr)),
  // windowFeatures: z.nullable(z.array(z.string())),
  yearBuilt: Xe(D())
  // zoning: z.nullable(z.unknown()),
  // zoningDescription: z.nullable(z.string()),
}).partial(), Pse = w({
  city: b().nullable(),
  community: b().nullable(),
  neighborhood: b().nullable(),
  state: b().nullable(),
  streetAddress: b().nullable(),
  subdivision: b().nullable(),
  zipcode: b().nullable()
}).partial(), Ese = w({
  // agentEmail: z.string().nullable(),
  // agentLicenseNumber: z.string().nullable(),
  agentName: b().nullable(),
  agentPhoneNumber: b().nullable(),
  // attributionTitle: z.string().nullable(),
  // brokerName: z.string().nullable(),
  // brokerPhoneNumber: z.string().nullable(),
  // buyerAgentMemberStateLicense: z.string().nullable(),
  // buyerAgentName: z.string().nullable(),
  // buyerBrokerageName: z.string().nullable(),
  // coAgentLicenseNumber: z.string().nullable(),
  // coAgentName: z.string().nullable(),
  // coAgentNumber: z.string().nullable(),
  infoString10: b().nullable(),
  infoString16: b().nullable(),
  infoString3: b().nullable(),
  infoString5: b().nullable(),
  lastChecked: b().nullable(),
  lastUpdated: b().nullable(),
  // listingAgents: z
  //     .array(
  //         z
  //             .object({
  //                 associatedAgentType: z.string().nullable(),
  //                 memberFullName: z.string().nullable(),
  //                 memberStateLicense: z.string().nullable(),
  //             })
  //             .partial()
  //     )
  //     .nullable(),
  // listingAgreement: z.string().nullable(),
  // listingOffices: z
  //     .array(
  //         z
  //             .object({
  //                 associatedOfficeType: z.string().nullable(),
  //                 officeName: z.string().nullable(),
  //             })
  //             .partial()
  //     )
  //     .nullable(),
  // mlsDisclaimer: z.string().nullable(),
  mlsId: b().nullable(),
  mlsName: b().nullable()
  // providerLogo: z.string().nullable(),
  // trueStatus: z.string().nullable(),
}).partial(), Tse = w({
  infoString1: b().nullable(),
  infoString2: b().nullable(),
  infoString3: b().nullable()
}).partial(), Nse = w({
  attributeSource: Tse.nullable(),
  buyerAgent: fn().nullable(),
  date: b().nullable(),
  event: b().nullable(),
  postingIsRental: J().nullable(),
  price: D().nullable(),
  priceChangeRate: D().nullable(),
  pricePerSquareFoot: D().nullable(),
  sellerAgent: fn().nullable(),
  showCountyLink: J().nullable(),
  source: b().nullable(),
  time: D().nullable()
}).partial();
w({
  address: Pse.nullable(),
  annualHomeownersInsurance: D().nullable(),
  attributionInfo: Ese.nullable(),
  bathrooms: D().nullable(),
  bedrooms: D().nullable(),
  brokerId: b().nullable(),
  brokerageName: b().nullable(),
  building: b().nullable(),
  buildingPermits: b().nullable(),
  city: b().nullable(),
  cityId: D().nullable(),
  comingSoonOnMarketDate: b().nullable(),
  // contact_recipients: z.array(schContactRecipient).nullable(),
  contingentListingType: b().nullable(),
  country: b().nullable(),
  county: b().nullable(),
  countyFIPS: b().nullable(),
  countyId: D().nullable(),
  currency: b().nullable(),
  datePosted: b().nullable(),
  dateSold: b().nullable(),
  description: b().nullable(),
  favoriteCount: D().nullable(),
  // homeFacts: z.unknown(),
  homeStatus: b().nullable(),
  homeType: b().nullable(),
  imgSrc: b().nullable(),
  isListedByOwner: b().nullable(),
  latitude: D().nullable(),
  // listed_by: z
  //     .object({
  //         agent_reason: z.number().nullable(),
  //         badge_type: z.string().nullable(),
  //         business_name: z.string().nullable(),
  //         display_name: z.string().nullable(),
  //         image_url: z.string().nullable(),
  //         phone: schPhone.nullable(),
  //         profile_url: z.string().nullable(),
  //         rating_average: z.number().nullable(),
  //         recent_sales: z.number().nullable(),
  //         review_count: z.number().nullable(),
  //         zpro: z.boolean().nullable(),
  //         zuid: z.string().nullable(),
  //     })
  //     .nullable(),
  // listingProvider: z.string().nullable(),
  listingSubType: w({
    is_FSBA: J().nullable(),
    is_FSBO: J().nullable(),
    is_bankOwned: J().nullable(),
    is_comingSoon: J().nullable(),
    is_forAuction: J().nullable(),
    is_foreclosure: J().nullable(),
    is_newHome: J().nullable(),
    is_openHouse: J().nullable().optional(),
    is_pending: J().nullable()
  }).nullable(),
  livingArea: D().nullable(),
  livingAreaUnits: b().nullable(),
  livingAreaValue: D().nullable(),
  longitude: D().nullable(),
  mlsid: b().nullable(),
  monthlyHoaFee: D().nullable(),
  // mortgageRates: z
  //     .object({
  //         thirtyYearFixedRate: z.number().nullable(),
  //     })
  //     .nullable(),
  price: D().nullable(),
  priceHistory: se(Nse).or(w({})).nullable(),
  propertyTaxRate: D().nullable(),
  propertyTypeDimension: b().nullable(),
  providerListingID: b().nullable(),
  rentZestimate: D().nullable(),
  resoFacts: Dse.nullable(),
  solarPotential: b().nullable(),
  state: b().nullable(),
  stateId: D().nullable(),
  streetAddress: b().nullable(),
  timeOnZillow: b().nullable(),
  timeZone: b().nullable(),
  url: b().nullable(),
  yearBuilt: D().nullable(),
  // zestimate: z.number().nullable(),
  // zestimateHighPercent: z.string().nullable(),
  // zestimateLowPercent: z.string().nullable(),
  zipcode: b().nullable(),
  zpid: D().nullable()
}).partial();
var B_ = w({
  address: b().nullable(),
  bathrooms: D().nullable(),
  bedrooms: D().nullable(),
  contingentListingType: yl().nullable(),
  country: b().nullable(),
  currency: b().nullable(),
  dateSold: D().nullable(),
  hasImage: J().nullable(),
  imgSrc: b().nullable(),
  latitude: D().nullable(),
  longitude: D().nullable(),
  listingStatus: b().nullable(),
  listingSubType: yl().nullable(),
  livingArea: D().nullable(),
  lotAreaUnit: b().nullable(),
  lotAreaValue: D().nullable(),
  price: D().nullable(),
  propertyType: b().nullable(),
  zestimate: D().nullable(),
  zpid: b().nullable()
});
w({
  currentPage: D(),
  props: se(B_).optional(),
  resultsPerPage: D(),
  totalPages: D(),
  totalResultCount: D()
});
var H_ = Me(["trial", "bundle"]), E9 = w({
  id: b(),
  type: b(),
  endedAt: Bn.optional()
}), kse = w({
  hasActiveSubscription: fe(!0),
  customerID: b(),
  type: fe("active"),
  nextPaymentDue: nr,
  previousSubscriptions: se(E9)
}), Vse = w({
  hasActiveSubscription: fe(!0),
  customerID: b(),
  type: fe("trialing"),
  trialEnd: nr,
  previousSubscriptions: se(E9),
  hasPaymentMethod: J(),
  id: b(),
  pendingSetupIntent: b(),
  priceID: b(),
  subscriptionItemID: b()
}), Ose = w({
  hasActiveSubscription: fe(!1),
  customerID: b(),
  previousSubscriptions: se(E9)
});
nn([
  kse,
  Vse,
  Ose
]);
w({
  clientSecret: b()
});
w({
  priceID: b(),
  promotionCode: b().optional(),
  addTrial: J().optional(),
  mcKissockOffer: H_.optional()
});
w({
  clientSecret: b(),
  paymentIntentType: Me(["setup", "payment"])
});
var G_ = w({
  city: b(),
  country: b(),
  line1: b(),
  line2: b().optional(),
  postal_code: b(),
  state: b()
});
w({
  automaticTaxStatus: Me(["supported", "unrecognized_location", "not_collecting", "failed"])
});
w({
  address: G_,
  price: Pe
});
w({
  totalAmount: Pe,
  taxAmount: Pe
});
w({
  priceID: b(),
  isTrial: J(),
  address: G_.optional(),
  promotionCode: b().optional()
});
w({
  discount: w({
    amount: Pe,
    percent: D(),
    promotionCode: b(),
    couponName: b()
  }).or(n2()),
  // null if no promo code provided
  subtotalExcludingTax: Pe,
  tax: Pe.or(n2()),
  // null if no billing address provided (i.e., pricing breakdown calculated with promo code before billing address added)
  total: Pe,
  totalDueToday: Pe.or(n2())
  // null if not trial
});
w({
  promotionCode: b()
});
w({
  isValid: J()
});
w({
  priceID: b(),
  promotionCode: b().optional()
});
var Fse = w({
  "autoHelpDrawer-properties": D().default(0),
  "autoHelpDrawer-market-conditions": D().default(0),
  "autoHelpDrawer-replacement-cost": D().default(0),
  "autoHelpDrawer-depreciation-and-site": D().default(0),
  "autoHelpDrawer-summary": D().default(0),
  "autoHelpDrawer-adjustments-summary": D().default(0),
  "autoHelpDrawer-commentary-summary": D().default(0),
  "autoHelpDrawer-cost-appr-summary": D().default(0),
  "autoHelpDrawer-paired-sales-library": D().default(0),
  "autoHelpDrawer-paired-sales-search-and-adjust": D().default(0),
  "autoHelpDrawer-analysis": D().default(0),
  "autoHelpDrawer-adjustments": D().default(0),
  "autoHelpDrawer-commentary": D().default(0),
  "autoHelpDrawer-craftsman-cost-approach": D().default(0),
  replacementCostInputFocus: D().default(0),
  analysisIntroTour: D().default(0)
}), Bse = Me([
  "appraiser",
  "trainee",
  "amc-professional",
  "loan-officer",
  "agent-broker",
  "trainer-educator",
  "gse-rep",
  "other"
]), Hse = Me([
  "total",
  "aci",
  "appraise-it-pro",
  "nexus",
  "clickforms",
  "anow",
  "homeputer",
  "other"
]), Gse = w({
  id: b().optional(),
  state: T_.optional()
}).optional(), $_ = b().email(), $se = w({
  type: H_,
  email: $_
}), Zse = w({
  version: fe(1),
  address: Gd.optional(),
  firstName: b().optional(),
  lastName: b().optional(),
  phone: b().optional(),
  userDefinedRole: Bse.optional(),
  company: b().optional(),
  mlsIDs: se(b()).optional(),
  license: Gse,
  ftux: Fse.optional(),
  signatureBlobId: b().optional(),
  // ID of the signature blob in S3
  // Info used by onboarding
  bubbleUserID: b().optional(),
  isOnboardingComplete: J().optional(),
  referredBy: b().optional(),
  preferredReportSoftware: Hse.optional(),
  mcKissockData: $se.optional()
}), Z_ = Zse, jse = Me(["saas", "appraisify"]), j_ = w({
  id: b(),
  isArchived: J().optional(),
  createdAt: Bn,
  modifiedAt: Bn,
  body: Z_,
  isAdmin: J(),
  email: $_
}), W_ = j_.extend({
  userType: jse
});
W_.pick({
  body: !0
});
Z_.extend({
  version: fe(1).optional()
});
W_.pick({
  body: !0,
  isArchived: !0
});
w({
  blobID: S9
}), fn();
w({
  blobID: S9
}), Uh();
Me(["custom", "constellation1", "abode"]);
var z_ = w({
  zip: b(),
  updated_date: b(),
  monthly_trends: w({
    historical_data: se(
      w({
        year: D(),
        month: D(),
        typicalHomeValue: Pe,
        numCloses: D().optional(),
        sourceMLSes: Mc.array().optional(),
        medianListPrice: Pe.optional(),
        medianClosePriceOverListPrice: D().optional(),
        medianDaysOnMarket: D().optional()
      })
    ),
    one_month_projection: Pe.optional()
  })
}), U_ = ae(pe(), 1), um = ae(Tl(), 1), Wse = Me([
  "ARMLS",
  "ArizonaRegional",
  "Austin",
  "Beaches",
  "BrevardMLS",
  "BridgeMLS",
  "BrightMLS",
  "CanopyMLS",
  "CentralPanhandle",
  "CentralTexas",
  "CincyMLS",
  "CLAW",
  "CRMLS",
  "DesMoines",
  "EmeraldCoast",
  "FGCMLS",
  "FMLS",
  "GardenStateMLS",
  "GeorgiaMLS",
  "GSREIN",
  "HeartlandMLS",
  "Houston",
  "IRMLS",
  "Knoxville",
  "LasVegas",
  "LexingtonKY",
  "MARIS",
  "MIBOR",
  "Metrolist",
  "MLSNow",
  "MLSOK",
  "MLSUnited",
  "MLSPIN",
  "MLSTechnology",
  "MonmouthOceanMLS",
  "MRED",
  "NABOR",
  "NEREN",
  "NorthCarolinaRegional",
  "NorthStarMLS",
  "NorthwestMLS",
  "NTREIS",
  "OneKey",
  "PalmBeachFL",
  "PortlandOR",
  "Realcomp",
  "RealMLS",
  "Realtracs",
  "REBNY",
  "REColorado",
  "RMLSA",
  "SanAntonio",
  "SEF",
  "SmartMLS",
  "StellarMLS",
  "SWMRIC",
  "TriadMLS",
  "TriangleMLS",
  "UtahRealEstate",
  "WestPenn",
  "WyomingMLS"
]), X_ = fe("constellation1").or(fe("abode")), zse = w({
  MediaURL: b(),
  blobID: b().optional()
}), T9 = w({
  Air: b(),
  Appliances: se(b()),
  ArchitecturalStyle: se(b()),
  AssociationFee: D(),
  AssociationFeeFrequency: b(),
  AssociationName: b(),
  AssociationYN: J(),
  Basement: se(b()),
  BasementYN: J(),
  BathroomsFull: D(),
  BathroomsHalf: D(),
  BathroomsThreeQuarter: D(),
  BathroomsTotalInteger: D(),
  BedroomsTotal: D(),
  BuyerFinancing: se(b()),
  City: b(),
  CityRegion: b(),
  CloseDate: b(),
  ClosePrice: D(),
  ConcessionsAmount: D(),
  Cooling: se(b()),
  CountyOrParishFIPS: b(),
  CountyOrParish: b(),
  CumulativeDaysOnMarket: D(),
  DaysOnMarket: D(),
  Directions: b(),
  DoorFeatures: se(b()),
  DoorsWindows: b(),
  ElementarySchool: b(),
  ExpirationDate: b(),
  ExteriorFeatures: se(b()),
  FireplaceFeatures: se(b()),
  FireplacesTotal: D(),
  FloorDescription: b(),
  Flooring: se(b()),
  GarageSpaces: D(),
  GarageYN: J(),
  GreenEnergyEfficient: se(b()),
  HasAttachedGarage: J().nullable(),
  HasView: J(),
  Heating: se(b()),
  HighSchool: b(),
  InteriorFeatures: se(b()),
  Latitude: D(),
  Levels: se(b()),
  ListAgentFullName: b(),
  ListAgentKey: b(),
  ListAgentMlsID: b(),
  ListAgentPhone: b(),
  ListAgentPreferredPhone: b(),
  ListingContractDate: b(),
  ListingId: b(),
  ListingTerms: se(b()),
  ListOfficeKey: b(),
  ListOfficeMlsId: b(),
  ListOfficeName: b(),
  ListOfficePhone: b(),
  ListPrice: D(),
  LivingArea: D(),
  Longitude: D(),
  LotDescription: b(),
  LotFeatures: se(b()),
  LotSizeAcres: D(),
  LotSizeSquareFeet: D(),
  Media: se(zse),
  MiddleOrJuniorSchool: b(),
  MLSAreaMajor: b(),
  MLSOUID: b(),
  MLSName: b(),
  // Technically not RESO field but OriginatingSystemName already taken by C1Listing
  MlsStatus: b(),
  ModificationTimestamp: b(),
  NeighborhoodName: b(),
  NewConstructionYN: J(),
  OnMarketDate: b(),
  OnMarketTimestamp: b(),
  OriginalListPrice: D(),
  ParcelNumber: b(),
  ParkingFeatures: se(b()),
  ParkingTotal: D(),
  PatioAndPorchFeatures: se(b()),
  PendingTimestamp: b(),
  PoolFeatures: se(b()),
  PostalCode: b(),
  PoolPrivateYN: J(),
  PropertyAttachedYN: J(),
  PropertySubType: b(),
  PropertyType: b(),
  PublicRemarks: b(),
  PurchaseContractDate: b(),
  RentControlYN: J(),
  Roof: se(b()),
  RoomsTotal: D(),
  SchoolDistrict: b(),
  Sewer: se(b()),
  SpaYN: J(),
  SpecialListingConditions: se(b()),
  StandardStatus: b(),
  StateOrProvince: b(),
  Stories: D(),
  StoriesTotal: D(),
  StreetDirSuffix: b(),
  StreetName: b(),
  StreetNumber: b(),
  StreetSuffix: b(),
  StructureType: se(b()),
  SubdivisionName: b(),
  TaxAnnualAmount: D(),
  TaxLegalDescription: b(),
  ToolkitListingID: tae,
  TaxYear: D(),
  Topography: b(),
  UnitNumber: b(),
  UnparsedAddress: b(),
  View: se(b()),
  WaterFrontYN: J(),
  WaterFrontFeatures: b(),
  WaterSource: se(b()),
  WithdrawnDate: b(),
  YearBuilt: D()
}).partial(), N9 = T9.extend({
  DerivedAssociationFeeMonthly: D(),
  DerivedPendingTimestamp: b(),
  DerivedOnMarketTimestamp: b(),
  RawMlsStoriesTotal: D(),
  RawMlsBathroomsTotal: D(),
  OriginatingSystemName: Wse,
  // Added by us
  LastSyncDate: b()
}).partial(), yb = (e) => (0, um.isUndefined)(e) || e === "", cm = (e) => {
  if (!(0, um.isUndefined)(e))
    return {
      min: e.min === "" ? void 0 : e.min,
      max: e.max === "" ? void 0 : e.max,
      variance: e.variance === "" ? void 0 : e.variance,
      percentage: e.percentage === "" ? void 0 : e.percentage,
      exact: e.exact === "" ? void 0 : e.exact
    };
}, dm = (e) => {
  if (!(0, um.isUndefined)(e) && !(yb(e.min) && yb(e.max)))
    return {
      min: e.min === "" ? void 0 : e.min,
      max: e.max === "" ? void 0 : e.max
    };
}, Zd = nn([
  D().min(0, { message: "must be greater than or equal to zero" }).max(100, { message: "Must be lesser than or equal to 100" }),
  fe(""),
  Vi()
]), jr = nn([
  D().min(0, { message: "must be greater than or equal to zero" }),
  fe(""),
  Vi()
]), ns = $t({
  min: jr.optional(),
  max: jr.optional()
}).optional().transform(dm), b1 = $t({
  min: jr.optional(),
  max: jr.optional(),
  variance: jr.optional(),
  exact: jr.optional(),
  percentage: Zd.optional()
}).optional().transform(cm), eh = nn([nr, fe(""), Vi()]), Use = $t({
  min: eh.optional(),
  max: eh.optional()
}).optional().transform(dm), Xse = $t({
  min: eh.optional(),
  max: eh.optional(),
  variance: jr.optional(),
  exact: jr.optional(),
  percentage: Zd.optional()
}).optional().transform(cm), th = nn([
  Pe.transform((e, t) => ((0, U_.isDefined)(e) && Yt.isAloftPrice(e) && e.unitAmount < 0 && t.addIssue({
    code: we.custom,
    message: "must be greater than or equal to zero",
    path: []
  }), e)),
  fe(""),
  Vi()
]), Yse = $t({
  min: th.optional(),
  max: th.optional()
}).optional().transform(dm), qse = $t({
  min: th.optional(),
  max: th.optional(),
  variance: jr.optional(),
  exact: jr.optional(),
  percentage: Zd.optional()
}).optional().transform(cm), nh = nn([
  wt.transform((e, t) => ((0, U_.isDefined)(e) && Dt.isAloftArea(e) && e.unitAmount < 0 && t.addIssue({
    code: we.custom,
    message: "must be greater than or equal to zero",
    path: []
  }), e)),
  fe(""),
  Vi()
]), Sb = $t({
  min: nh.optional(),
  max: nh.optional(),
  variance: jr.optional(),
  exact: jr.optional(),
  percentage: Zd.optional()
}).optional().transform(dm), Ab = $t({
  min: nh.optional(),
  max: nh.optional(),
  variance: jr.optional(),
  exact: jr.optional(),
  percentage: Zd.optional()
}).optional().transform(cm), ed = b().optional().transform((e) => e === "" ? void 0 : e), Jse = nn([J(), fe("")]), td = Jse.optional().transform((e) => e === "" ? void 0 : e), Kse = jr.optional().transform((e, t) => {
  if (e !== "")
    return (0, um.isNumber)(e) && e.toString().length !== 5 && t.addIssue({
      code: we.custom,
      message: "must be 5 digits",
      path: []
    }), e;
}), Qse = Me([
  "Acreage",
  "Boat Dock",
  "Business Opportunity",
  "Commercial",
  "Commercial Land",
  "Commercial Lease",
  "Commercial Sale",
  "Condo",
  "Farm",
  "Lots and Land",
  "Manufactured Home",
  "Mixed Use",
  "Mobile Home",
  "Multifamily Property",
  "Rentals",
  "Residential",
  "Residential Income",
  "Residential Lease",
  "Timeshare"
]), ele = Me(["Active", "Pending", "Sold"]), fm = w({
  propertyType: Qse.optional(),
  propertySubType: ed,
  saleDate: Use,
  salePrice: Yse,
  gla: Sb,
  lotSize: Sb,
  zipCode: Kse,
  yearBuilt: ns,
  bedrooms: ns,
  fullBaths: ns,
  threeQuarterBaths: ns,
  halfBaths: ns,
  totalBaths: ns,
  stories: ns,
  garageSpaces: ns,
  hasBasement: td,
  hasPool: td.optional(),
  style: ed,
  view: ed,
  attached: td,
  statuses: se(ele).optional()
}), tle = w({
  propertySubType: ed,
  saleDate: Xse,
  salePrice: qse,
  gla: Ab,
  lotSize: Ab,
  yearBuilt: b1,
  bedrooms: b1,
  fullBaths: b1,
  stories: b1,
  garageSpaces: b1,
  hasBasement: td,
  hasPool: td.optional(),
  status: ed
}), Vn = Me([
  "lasting_range",
  "min_max_range",
  "percentage_range",
  "value_range",
  "exact"
]), nle = w({
  saleDate: Me([Vn.enum.lasting_range, Vn.enum.min_max_range]).optional(),
  salePrice: Me([Vn.enum.min_max_range, Vn.enum.percentage_range]).optional(),
  gla: Me([Vn.enum.min_max_range, Vn.enum.percentage_range]).optional(),
  lotSize: Me([Vn.enum.min_max_range, Vn.enum.percentage_range]).optional(),
  yearBuilt: Me([
    Vn.enum.exact,
    Vn.enum.min_max_range,
    Vn.enum.value_range
  ]).optional(),
  bedrooms: Me([
    Vn.enum.exact,
    Vn.enum.min_max_range,
    Vn.enum.value_range
  ]).optional(),
  fullBaths: Me([
    Vn.enum.exact,
    Vn.enum.min_max_range,
    Vn.enum.value_range
  ]).optional(),
  stories: Me([
    Vn.enum.exact,
    Vn.enum.min_max_range,
    Vn.enum.value_range
  ]).optional(),
  garageSpaces: Me([
    Vn.enum.exact,
    Vn.enum.min_max_range,
    Vn.enum.value_range
  ]).optional()
}), Sl = w({
  filters: tle,
  coordinates: se(
    w({
      longitude: D(),
      latitude: D()
    })
  ),
  radius: D().optional(),
  matchCriteria: nle.optional()
}), rle = w({
  listingsSoldCount: D().optional(),
  listingsActiveCount: D().optional(),
  listingsPendingCount: D().optional(),
  last3MonthsListingsCount: D().optional(),
  last6MonthsListingsCount: D().optional(),
  last12MonthsListingsCount: D().optional()
});
w({
  filters: fm,
  coordinates: se(
    w({
      longitude: D(),
      latitude: D()
    })
  ),
  radius: D().optional()
});
var hm = w({
  resultsCount: D(),
  results: se(N9),
  statistics: rle.optional(),
  source: X_,
  searchCriteria: Sl.optional()
}), ole = hm.extend({
  missingListingIDs: se(b())
}), Y_ = hm.extend({
  totalResultsCount: D(),
  nextToken: b().optional()
});
w({
  mlsOUID: b(),
  listingIDs: se(b())
});
w({
  longitude: D(),
  latitude: D(),
  radiusInMeters: D(),
  filters: fm.optional(),
  nextToken: b().optional(),
  top: D().optional()
});
w({
  coordinates: se(
    w({
      longitude: D(),
      latitude: D()
    })
  ),
  filters: fm.optional(),
  nextToken: b().optional(),
  top: D().optional()
});
var bo = (e) => e.array().optional(), ale = Me(["zillow", "mls"]), ile = Me(["zip", "city", "county"]), sle = Me(["default", "closemonth", "rolling3month"]), lle = w({
  meta: w({
    source: ale,
    geoname: ile,
    geo: b(),
    periodname: sle,
    updated: wi.schema.optional()
  }),
  data: w({
    start: rr.schema.array(),
    // inclusive
    end: rr.schema.array(),
    // exclusive
    latestmodificationtimestamp: bo(wi.schema),
    originatingsystemnames: bo(Mc.array()),
    numcloses: bo(D()),
    avgcloseprice: bo(Yt.schema.nullable()),
    p50closeprice: bo(Yt.schema.nullable()),
    avgclosepriceoverlistprice: bo(D().nullable()),
    p50closepriceoverlistprice: bo(D().nullable()),
    avgclosepricepersqft: bo(Yt.schema.nullable()),
    p50closepricepersqft: bo(Yt.schema.nullable()),
    avgdaysonmarketclosed: bo(D().nullable()),
    p50daysonmarketclosed: bo(D().nullable()),
    avglistprice: bo(Yt.schema.nullable()),
    p50listprice: bo(Yt.schema.nullable())
  })
}), ule = w({
  imageURLs: b().array()
}), cle = w({
  listings: ule.array()
}), q_ = w({
  floor_structure_class: D(),
  floor_structure_commentary: b(),
  wall_framing_and_exterior_finish_class: D(),
  wall_framing_and_exterior_finish_commentary: b(),
  roof_class: D(),
  roof_commentary: b(),
  floor_finish_class: D(),
  floor_finish_commentary: b(),
  interior_wall_and_ceiling_finish_class: D(),
  interior_wall_and_ceiling_finish_commentary: b(),
  interior_detail_class: D(),
  interior_detail_commentary: b(),
  bath_detail_class: D(),
  bath_detail_commentary: b(),
  kitchen_detail_class: D(),
  kitchen_detail_commentary: b(),
  plumbing_detail_class: D(),
  plumbing_detail_commentary: b(),
  special_features_class: D(),
  special_features_commentary: b(),
  electrical_system_class: D(),
  electrical_system_commentary: b(),
  overall_class: D(),
  overall_commentary: b(),
  uad_condition_rating: b(),
  uad_condition_commentary: b(),
  has_barn: J(),
  has_carport: J(),
  has_basement: J(),
  has_deck: J(),
  has_covered_porch: J(),
  has_enclosed_patio: J(),
  has_accessory_dwelling_unit: J(),
  has_pool: J(),
  has_shed: J(),
  has_workshop: J(),
  has_fireplace: J()
}).partial(), r2 = w({
  depreciateSeparately: J().optional(),
  enableFunctionalDepreciation: J().optional(),
  enableExternalDepreciation: J().optional(),
  defaultEcoLife: D().int().optional(),
  defaultEcoLifeManufactured: D().int().optional(),
  defaultEcoLifeGarage: D().int().optional(),
  defaultEcoLifeDetachedGarage: D().int().optional(),
  defaultEcoLifeCarport: D().int().optional(),
  defaultEcoLifePorch: D().int().optional(),
  defaultEcoLifePatio: D().int().optional(),
  defaultEcoLifeDeck: D().int().optional(),
  defaultEcoLifeWorkshop: D().int().optional(),
  defaultEcoLifeShed: D().int().optional(),
  defaultEcoLifeBarn: D().int().optional(),
  defaultEcoLifePool: D().int().optional(),
  defaultEcoLifeSpa: D().int().optional(),
  defaultEcoLifeADU: D().int().optional(),
  defaultEcoLifeManualCost: D().int().optional(),
  defaultEcoLifeFireplace: D().int().optional()
}), dle = w({
  depreciateSeparately: J().optional(),
  enableFunctionalDepreciation: J().optional(),
  enableExternalDepreciation: J().optional(),
  defaultEcoLife: D().int().optional(),
  defaultEcoLifeManufactured: D().int().optional(),
  defaultEcoLifeGarage: D().int().optional(),
  defaultEcoLifeDetachedGarage: D().int().optional(),
  defaultEcoLifeCarport: D().int().optional(),
  defaultEcoLifePorch: D().int().optional(),
  defaultEcoLifePatio: D().int().optional(),
  defaultEcoLifeDeck: D().int().optional(),
  defaultEcoLifeWorkshop: D().int().optional(),
  defaultEcoLifeShed: D().int().optional(),
  defaultEcoLifeBarn: D().int().optional(),
  defaultEcoLifePool: D().int().optional(),
  defaultEcoLifeSpa: D().int().optional(),
  defaultEcoLifeADU: D().int().optional(),
  defaultEcoLifeManualCost: D().int().optional(),
  defaultEcoLifeFireplace: D().int().optional()
});
Object.keys(dle.shape).filter(
  (e) => e.startsWith("defaultEcoLife")
);
var J_ = nn([fe(6), fe(12), fe(24)]), fle = w({
  zip: b(),
  updated_date: b(),
  monthly_trends: w({
    historical_data: se(
      w({
        year: D(),
        month: D(),
        typicalHomeValue: qn,
        numCloses: D().optional(),
        sourceMLSes: Mc.array().optional(),
        medianListPrice: qn.optional(),
        medianClosePriceOverListPrice: D().optional(),
        medianDaysOnMarket: D().optional()
      })
    ),
    one_month_projection: qn.optional()
  })
}), hle = w({
  zip: b(),
  analysisPeriod: J_,
  trends: se(
    w({
      data: fle,
      timestamp: BV
    })
  )
}), mle = w({
  rate: D()
}), ple = w({
  month: Zr,
  value: qn
}), gle = w({
  type: Me(["typicalHomeValue"]),
  analysisPeriod: J_,
  trendsAsPercentages: J().optional().default(!1),
  trends: se(ple)
}), vle = Me([
  "none",
  "zillow",
  "customMonthlyRate",
  "customMonthlyPrice"
]), Cle = w({
  selectedMethod: vle,
  methodState: w({
    zillow: hle.optional(),
    customMonthlyRate: mle,
    customMonthlyPrice: gle
  })
}), ble = w({
  ratio: D()
}), yle = Me(["none", "customRatio"]), Sle = w({
  selectedMethod: yle,
  methodState: w({
    customRatio: ble
  }).partial()
}), Ale = w({
  version: fe(1),
  /** The cached Date of Sale and List to Sale form data */
  cachedForms: w({
    dateOfSale: Cle,
    listToSale: Sle
  }),
  commentary: b().optional()
}), K_ = ["abode_mls"], Q_ = Me(K_), eI = ["abode_public_record"], k9 = Me(eI), tI = ["zillow", "xml", "custom", "none", "radar"];
Me(tI);
var Mle = [...K_, ...eI, ...tI], nI = Me(Mle), xle = 6, wle = Dt.fromNumber(500, "sqft"), _le = Dt.fromNumber(500, "sqft"), Ile = Dt.fromNumber(1e3, "sqft");
Dt.fromNumber(0, "sqft");
Dt.fromNumber(0, "sqft");
var rI = Dt.fromNumber(220, "sqft"), Lle = 2;
rI.mul(Lle);
Dt.fromNumber(200, "sqft");
var Rle = 2;
rI.mul(Rle);
Dt.fromNumber(200, "sqft");
var Dle = Dt.fromNumber(500, "sqft");
Dt.fromNumber(200, "sqft");
var Ple = Dt.fromNumber(200, "sqft"), Ele = Dt.fromNumber(64, "sqft"), Tle = Dt.fromNumber(200, "sqft");
Q_.enum.abode_mls;
k9.enum.abode_public_record;
var Cr = Me([
  "singleFamilyResidence",
  "condominium",
  "duplex",
  "triplex",
  "quadruplex",
  "manufacturedHome",
  "mobileHome",
  "multiFamily",
  "townhouse",
  "apartments",
  "lotsLand"
]), Nle = w({
  PropertyStreetAddress: b(),
  PropertyCity: b(),
  PropertyState: b(),
  PropertyPostalCode: b(),
  LatitudeNumber: b(),
  LongitudeNumber: b(),
  DataSourceDescription: b(),
  DataSourceVerificationDescription: b(),
  PropertySalesAmount: b(),
  /** @deprecated - use SalesConcessions instead */
  SaleType: b(),
  SalesConcessions: b(),
  FinancingConcessions: b(),
  DateOfSale: b(),
  Location: b(),
  PropertyRights: b(),
  SiteArea: b(),
  View: b(),
  DesignStyle: b(),
  Quality: b(),
  Age: b(),
  Condition: b(),
  TotalRoomCount: b(),
  TotalBedroomCount: b(),
  TotalBathroomCount: b(),
  BelowGradeRoomCount: b(),
  GrossLivingArea: b(),
  NumberOfUnits: b(),
  BasementArea: b(),
  BasementFinish: b(),
  FunctionalUtility: b(),
  HeatingCooling: b(),
  EnergyEfficient: b(),
  CarStorage: b(),
  PorchDeck: b(),
  OtherFeature1: b(),
  OtherFeature2: b(),
  OtherFeature3: b()
}).partial(), kle = w({
  SalesConcessions: Pe,
  FinancingConcessions: Pe,
  DateOfSale: Pe,
  Location: Pe,
  PropertyRights: Pe,
  SiteArea: Pe,
  View: Pe,
  DesignStyle: Pe,
  Quality: Pe,
  Age: Pe,
  Condition: Pe,
  RoomAboveGradeLine1: Pe,
  RoomAboveGradeLine2: Pe,
  GrossLivingArea: Pe,
  NumberOfUnits: Pe,
  BasementArea: Pe,
  BasementFinish: Pe,
  FunctionalUtility: Pe,
  HeatingCooling: Pe,
  EnergyEfficient: Pe,
  CarStorage: Pe,
  PorchDeck: Pe,
  OtherFeature1: Pe,
  OtherFeature2: Pe,
  OtherFeature3: Pe
}).partial(), oI = w({
  encoding: fe("UAD_2022"),
  annotations: Nle,
  adjustments: kle.optional()
});
fe("UAD_2022");
fe(1);
var Vle = $t({
  toolkitListingID: v_,
  address: Gd,
  latitude: D(),
  longitude: D(),
  dataSource: M_,
  designStyle: A_,
  carStorage: y_,
  status: b_,
  siteArea: wt,
  actualAge: x_,
  gla: wt,
  numberOfUnits: _e,
  bedroomCount: _e,
  bathroomCount: w_,
  basementLine1: I_,
  basementLine2: L_,
  salePrice: Pe
}).partial();
Object.keys(Vle.shape);
var Ole = w({
  fullBathCost: Pe.optional(),
  halfBathCost: Pe.optional()
}), aI = [
  Cr.Values.singleFamilyResidence,
  Cr.Values.manufacturedHome,
  Cr.Values.multiFamily
], jd = Me(aI), Fle = [
  Cr.Values.singleFamilyResidence,
  Cr.Values.manufacturedHome,
  Cr.Values.multiFamily,
  Cr.Values.condominium,
  Cr.Values.townhouse,
  Cr.Values.lotsLand
];
Me(Fle);
var Ble = [
  "basement",
  "garage",
  "attic",
  "shed",
  "workshop",
  "barn",
  "pool",
  "spa",
  "fireplaces",
  "adu"
];
Me([
  ...aI,
  ...Ble
]);
var Hle = nn([fe(4), fe(6), fe(8), fe(10)]), Gle = Me(["none", "heating", "both"]).default("none"), iI = D().min(1).max(3), $le = iI.int(), sI = D().min(1).max(5);
sI.int();
var Wd = D().min(1).max(6), bd = Wd.int();
Wd.multipleOf(0.1);
var V9 = Wd.multipleOf(0.1), lI = Wd.multipleOf(0.1), uI = Wd.multipleOf(0.1);
nn([
  V9,
  lI,
  uI
]);
var O9 = w({
  hasFeature: J().default(!0),
  finishedArea: Aa.optional(),
  totalArea: Aa.optional(),
  fullBaths: _e.optional(),
  halfBaths: _e.optional()
}), F9 = w({
  hasFeature: J().default(!0),
  area: Aa.optional(),
  spaces: _e.optional(),
  quality: bd.optional()
}), Zle = Me(["attached", "detached"]), b3 = F9.extend({
  type: Zle.optional()
}), Pu = w({
  hasFeature: J().default(!0),
  area: Aa.optional(),
  quality: $le.optional()
}), y3 = w({
  hasFeature: J().default(!0),
  area: Aa.optional()
}), cI = y3.extend({
  quality: bd.optional()
}), jle = Me(["uncovered", "covered", "screen"]), o2 = w({
  hasFeature: J().default(!0),
  type: jle.default("uncovered").optional(),
  area: Aa.optional(),
  quality: bd.optional()
}), Wle = Me(["freestanding", "zeroClearance", "masonry"]), dI = w({
  hasFeature: J().default(!0),
  count: _e.optional(),
  type: Wle.optional()
}), fI = w({
  hasFeature: J().default(!0),
  area: Aa.optional(),
  halfBaths: _e.optional(),
  fullBaths: _e.optional(),
  quality: V9.optional()
}), mm = w({
  corners: Hle.default(xle),
  gla: Aa,
  bedrooms: _e,
  fullBaths: _e,
  halfBaths: _e,
  heatingAndCooling: Gle,
  effectiveAge: _e,
  age: _e,
  uadQuality: bd,
  uadCondition: bd,
  basement: O9,
  attic: cI,
  fireplace: dI,
  // Garage's "type" field is left unchanged for backwards compatibility, but "garage" is now always attached
  garage: b3,
  detachedGarage: b3.extend({
    type: fe("detached").optional().default("detached")
  }),
  carport: F9,
  shed: Pu,
  workshop: Pu,
  barn: Pu,
  pool: Pu,
  spa: Pu,
  adu: fI,
  porch: o2,
  patio: o2,
  deck: o2,
  coveredPorch: y3,
  enclosedPatio: y3,
  hasManualCost: J().default(!1),
  manualCost: qn,
  manualCostDisplayName: b(),
  featureGridDataSources: b(),
  totalEconomicLife: _e,
  externalDepreciation: qn,
  functionalDepreciation: qn,
  garageEffAge: _e,
  garageEcoLife: _e,
  detachedGarageEffAge: _e,
  detachedGarageEcoLife: _e,
  carportEffAge: _e,
  carportEcoLife: _e,
  porchEffAge: _e,
  porchEcoLife: _e,
  patioEffAge: _e,
  patioEcoLife: _e,
  deckEffAge: _e,
  deckEcoLife: _e,
  workshopEffAge: _e,
  workshopEcoLife: _e,
  shedEffAge: _e,
  shedEcoLife: _e,
  barnEffAge: _e,
  barnEcoLife: _e,
  poolEffAge: _e,
  poolEcoLife: _e,
  spaEffAge: _e,
  spaEcoLife: _e,
  aduEffAge: _e,
  aduEcoLife: _e,
  manualCostEffAge: _e,
  manualCostEcoLife: _e,
  fireplaceEffAge: _e,
  fireplaceEcoLife: _e
}).partial(), zle = mm.extend({
  propertyType: fe(jd.Values.singleFamilyResidence),
  craftsmanQuality: V9.optional()
}), hI = Me(["pierAndBeam", "slab"]);
Me(["Pier and Beam", "Slab"]);
var Ule = mm.extend({
  propertyType: fe(jd.Values.manufacturedHome),
  foundation: hI.optional(),
  craftsmanQuality: lI.optional()
}), Xle = mm.extend({
  propertyType: fe(jd.Values.multiFamily),
  numberOfUnits: _e.optional(),
  craftsmanQuality: uI.optional()
}), mI = nn([
  zle,
  Ule,
  Xle
]), Yle = w({
  improvements: mI
}), B9 = [
  "adu",
  "attic",
  "barn",
  "basement",
  "bathAboveGrade",
  "bathBelowGrade",
  "bedrooms",
  "concessions",
  "condition",
  "dateOfSale",
  "externalObsolescence",
  // TODO: Remove?
  "fireplace",
  "functionalUtility",
  // TODO: Remove?
  "gla",
  // TODO: Rename to mainDwelling so there's no 2 "GLA" options in the UI?
  "garageCarport",
  "manual",
  // TODO: Rename to manualCost
  "poolSpa",
  "porchPatioDeck",
  "quality",
  "shed",
  "site",
  "termsOfSale",
  "units",
  // TODO: Rename to numberOfUnits
  "workshop"
];
Me(B9);
var pI = w(
  Object.fromEntries(B9.map((e) => [e, qn]))
).partial();
Me([
  "agricultural",
  "airport",
  "bodyOfWater",
  "busyRoadway",
  "commercialArea",
  "golfCourse",
  "greenSpace",
  "highDensityResidential",
  "highPressureGasLine",
  "historicDistrict",
  "industrialArea",
  "localDistributionLine",
  "oilOrGasWell",
  "overheadPowerLine",
  "park",
  "publicTransportationHub",
  "railLine",
  "residential",
  "school",
  "stormwaterRetention"
]);
Me([
  "bay",
  "canal",
  "cityStreet",
  "commercial",
  "cove",
  "creek",
  "golfCourse",
  "gulf",
  "highDensityResidential",
  "highway",
  "industrial",
  "lake",
  "marsh",
  "mountain",
  "ocean",
  "park",
  "parkingLot",
  "pastoral",
  "pond",
  "reservoir",
  "residential",
  "river",
  "school",
  "skyline",
  "sound",
  "trafficWallBarriers",
  "valley",
  "woods"
]);
var Mb = Me(["Beneficial", "Neutral", "Adverse"]), gI = w({
  area: Aa,
  influence: b(),
  influenceRating: Mb,
  location: b(),
  notes: b(),
  view: b(),
  viewRating: Mb,
  zoning: b()
}).partial(), vI = w({
  transaction: R_,
  propertyIdentification: Woe,
  improvements: mI,
  site: gI
}), qle = vI.extend({
  manualAdjustments: pI
}), CI = vI.extend({
  opinionOfSiteValue: qn.optional(),
  siteValueCommentary: b().optional(),
  arv: Yle.optional()
}), Jle = w({
  version: fe(1),
  listing: T9
}), bI = w({
  backupListingData: Jle
}).partial(), So = w({
  source: nI,
  justification: b().optional(),
  conflictIsResolved: J().optional()
}), Yr = (e) => {
  const t = {};
  return Object.keys(e.shape).forEach((n) => {
    t[n] = So.optional();
  }), w(t);
}, Kle = Yr(R_).partial(), Qle = Yr($l).partial(), eue = Yr(d_).partial(), tue = w({
  address: Qle,
  coordinates: eue,
  zoning: So,
  zoningCompliance: So,
  legalDescription: So,
  hoa: So,
  hoaFeeAmount: So,
  hoaFeeFrequency: So,
  parcelNumber: So,
  pud: So
}).partial(), y1 = Yr(
  Pu
).partial(), nue = Yr(fI).partial(), rue = Yr(cI).partial(), oue = Yr(O9).partial(), aue = Yr(dI).partial(), iue = Yr(F9).partial(), xb = Yr(b3).partial(), Wg = Yr(o2).partial(), sue = Yr(mm).partial(), yI = w({
  ...sue.shape,
  adu: nue,
  attic: rue,
  barn: y1,
  basement: oue,
  carport: iue,
  deck: Wg,
  fireplace: aue,
  garage: xb,
  detachedGarage: xb,
  patio: Wg,
  pool: y1,
  porch: Wg,
  shed: y1,
  spa: y1,
  workshop: y1,
  craftsmanQuality: So,
  foundation: So,
  numberOfUnits: So,
  propertyType: So
}).partial(), lue = Yr(gI).partial(), uue = Yr(pI).partial(), cue = w({
  improvements: yI
}).partial(), due = w({
  transaction: Kle,
  propertyIdentification: tue,
  improvements: yI,
  site: lue,
  manualAdjustments: uue,
  arv: cue
}).partial(), fue = Ac(
  due
), hue = Yr(T9).partial(), mue = w({
  listing: hue
}).partial(), pue = w({
  backupListingData: mue
}).partial(), gue = w({
  editableData: fue,
  readonlyData: pue
}).partial(), vue = Ac(gue), SI = w({
  $type: fe("PropertyData"),
  version: fe(1),
  readonlyData: bI,
  selectedSources: vue.optional()
}), Cue = Me(["arv", "aiv"]), AI = SI.extend({
  editableData: qle,
  compType: Cue.optional()
}), bue = AI.extend({
  readonlyData: bI.optional()
}), cc = Ac(AI), yue = SI.extend({
  editableData: CI
}), dc = Ac(yue), MI = w({
  bedrooms: zt.optional(),
  bathroomsFull: zt,
  bathroomsHalf: zt,
  stories: D(),
  gla: wt,
  quality: Sn,
  nonStandardGLA: wt.optional(),
  multiUnitCount: _e.optional()
}), xI = MI.partial(), wI = xI.pick({
  quality: !0,
  nonStandardGLA: !0,
  multiUnitCount: !0
}), _I = $t({
  totalSqft: wt,
  finishedSqft: wt,
  access: b(),
  quality: Sn
}).partial(), II = _I.pick({ quality: !0 }), H9 = $t({
  label: b(),
  feature: b(),
  cost: Pe
}).partial(), Sue = w({
  totalSqft: wt,
  quality: Sn
}).partial(), wc = w({
  totalSqft: wt,
  quality: Sn
}), pm = w({
  totalSqft: wt,
  percentInteriorFinished: D(),
  electrical: J(),
  subpanel: J(),
  plumbingFixturesCount: zt,
  quality: Sn
}), Aue = wc.extend({ attachedSpaceCount: zt, builtinSpaceCount: zt }).partial(), Mue = wc.extend({ spaceCount: zt }).partial(), xue = wc.extend({ spaceCount: zt }).partial(), wue = wc.partial(), _ue = wc.partial(), Iue = wc.extend({ linearFootage: zt }).partial(), Lue = $t({
  totalSqft: wt,
  quality: Sn
}).partial(), Rue = MI.pick({
  bathroomsFull: !0,
  bathroomsHalf: !0,
  stories: !0,
  gla: !0,
  quality: !0
}).partial(), Due = pm.partial(), Pue = pm.partial(), Eue = pm.partial(), Tue = pm.extend({
  isPoleBarn: J(),
  hasExteriorWall: J()
}).partial(), Nue = $t({
  sections: zt,
  gla: wt,
  bathroomsFull: zt,
  bathroomsHalf: zt,
  quality: Sn,
  hasAC: J(),
  hasClimatePkg: J(),
  foundationType: b(),
  fireplaces: zt,
  fireplaceType: Sn,
  deliveryMileage: zt
}).partial(), LI = w({
  // FIXME: Rename this field to "siteBuiltDwelling"
  /**
   * Primary dwelling is a misnomer. This field actually corresponds to DC's
   * concept of "site-built dwelling". For manufactured properties, the
   * "primary" dwelling would be a manufactured dwelling
   */
  primaryDwelling: xI,
  basement: _I,
  attic: Sue,
  attachedOrBuiltinGarage: Aue,
  detachedGarage: Mue,
  carport: xue,
  deck: wue,
  coveredPatioOrGazebo: _ue,
  enclosedPatio: Iue,
  pool: Lue,
  adu: Rue,
  shed: Due,
  workshop: Pue,
  bonusRoom: Eue,
  barn: Tue,
  manufactured: Nue
}), _c = LI.keyof(), zg = w({
  lumpSum: Pe.optional(),
  percent: D().int().gte(0).lte(100).optional(),
  effectiveAge: D().optional(),
  ecoLifeYears: D().optional()
}), kue = w({
  physicalDepreciation: gn(_c, zg),
  functionalObsolescence: zg,
  externalDepreciation: zg
}), Ic = LI.extend({
  address: b(),
  effectiveDate: nr,
  zip: b(),
  // Not included in DwellingCost request
  depreciation: kue,
  manualCost: H9.optional()
}), Vue = w({
  effectiveAge: D().optional(),
  ecoLifeYears: D().optional(),
  functionalObsolescencePercent: D().int().gte(0).lte(100).optional(),
  externalDepreciationPercent: D().int().gte(0).lte(100).optional()
}), Oue = Ic.extend({
  depreciation: Vue,
  primaryDwelling: wI,
  basement: II,
  manualCost: H9.optional()
});
Ic.omit({ address: !0, effectiveDate: !0, zip: !0 }).extend({
  primaryDwelling: wI,
  basement: II,
  manualCost: H9.optional()
});
Ic.omit({ depreciation: !0 });
gn(
  _c,
  w({ cost: Pe }).or(Vi())
);
var gm = gn(
  _c,
  w({ costPerSqft: Pe }).or(Vi())
), G9 = w({
  // used for making a cost data request (to DwellingCost)
  editableInput: Oue,
  // Not included in DwellingCost response. Manually entered by appraiser.
  additionalFeaturesCost: Pe.optional(),
  // Only set for the subject. Site cost is derived for comps.
  siteCost: Pe.optional()
}), Fue = w({
  backrefs: Ic.optional()
}), RI = G9.merge(w({ structureCosts: gm.or(Vi()) })).merge(Fue);
gn(b(), G9);
var Bue = gn(b(), RI), Hue = _c, a2 = w({
  physicalDepreciationMode: Me(["ageLifeMethod", "percent", "lumpSum"]),
  depreciateImprovementsSeparately: J(),
  defaultEconomicLifePerImprovement: gn(Hue, D()),
  functionalObsolescenceMode: Me(["percent", "lumpSum"]),
  externalObsolescenceMode: Me(["percent", "lumpSum"])
});
ae(pe(), 1);
var Gue = [
  "adu",
  "attic",
  "barn",
  "basement",
  "carport",
  "deck",
  "fireplace",
  "garage",
  "detachedGarage",
  "manualCost",
  "patio",
  "pool",
  "porch",
  "shed",
  "spa",
  "workshop"
], $ue = Me(Gue), Zue = w({
  version: fe(1),
  features: se($ue)
}), jue = [
  "termsOfSale",
  "concessions",
  "dateOfSale",
  "site",
  "locationView",
  "quality",
  "condition",
  "mainDwelling",
  // Either GLA or GBA for multi-family
  "bathAboveGrade",
  "bathBelowGrade",
  "basement",
  "functionalUtility",
  "externalObsolescence",
  "garageCarport",
  "porchPatioDeck",
  "attic",
  "fireplace",
  "belowGradeANSI",
  "barn",
  "bonusRoom",
  "adu",
  "manufactured",
  "pool",
  "shed",
  "workshop",
  "foundation",
  "units",
  "manual"
], Wue = Me([...jue]), zue = Array.from(
  /* @__PURE__ */ new Set([...Wue.options, ...B9])
), rh = Me(
  zue
), i2 = w({
  enableRounding: J().optional(),
  enableThreshold: J().optional(),
  rounding: gn(rh, Yt.schema.optional()),
  roundingDefault: Yt.schema,
  threshold: gn(rh, Yt.schema.optional()),
  thresholdDefault: Yt.schema,
  saveAsDefault: J().optional()
});
w({
  enableRounding: J().optional(),
  enableThreshold: J().optional(),
  rounding: gn(rh, qn),
  roundingDefault: qn,
  threshold: gn(rh, qn),
  thresholdDefault: qn,
  saveAsDefault: J().optional()
});
var dl = ae(pe(), 1), wb = ae(Roe(), 1);
function Uue({
  LotSizeSquareFeet: e,
  LotSizeAcres: t
}) {
  if (e)
    return Dt.fromNumber(e, "sqft");
  if (t)
    return Dt.fromNumber(t, "acre");
}
function Xue(e) {
  if (e !== void 0)
    switch (e.toLowerCase().trim()) {
      case "active":
      case "activeundercontract":
      case "active under contract":
      case "comingsoon":
      case "coming soon":
        return "Active";
      case "pending":
        return "Contract";
      case "withdrawn":
      case "hold":
        return "Withdrawn";
      case "sold":
      case "closed":
        return "SettledSale";
      case "canceled":
      case "delete":
      case "expired":
        return "Expired";
      default:
        return;
    }
}
w({
  subject_address: w({
    address_full: b().nullable(),
    address_id: D().nullable(),
    slug: b().nullable(),
    block_id: b().nullable(),
    city: b().nullable(),
    fips: b().nullable(),
    geo_precision: b().nullable(),
    latitude: D().nullable(),
    longitude: D().nullable(),
    state: b().nullable(),
    unit: b().nullable(),
    address: b().nullable(),
    zipcode: b().nullable(),
    zipcode_plus4: b().nullable(),
    msa: b().nullable()
  }),
  public_records: fn(),
  hc: w({
    architectural_style: b().nullable(),
    attic: fn(),
    // TODO: figure out
    basement: w({
      finished_pct: D().nullable(),
      has: J().nullable(),
      total_area: D().nullable()
    }).nullable(),
    bathrooms: w({
      full: D().nullable(),
      partial: D().nullable(),
      total: D().nullable(),
      total_provided: D().nullable(),
      total_projected: D().nullable()
    }).nullable(),
    bedrooms: D().nullable(),
    buildings: b().nullable(),
    building_quality: b().nullable(),
    construction_types: se(b()).nullable(),
    cooling: se(b()).nullable(),
    fireplace: fn().nullable(),
    // TODO: figure out
    fireplaces_total: D().nullable(),
    heating: se(b()).nullable(),
    legal_description: b().nullable(),
    living_area: D().nullable(),
    living_area_above_grade: D().nullable(),
    living_area_below_grade: D().nullable(),
    lot_size: D().nullable(),
    neighborhood: fn().nullable(),
    // TODO: figure out
    parcel_id: b().nullable(),
    parking: w({
      description: b().nullable(),
      garage: D().nullable(),
      total: D().nullable()
    }).nullable(),
    pool: J().nullable(),
    pool_community: fn().nullable(),
    // TODO: figure out
    property_type: b().nullable(),
    property_type_description: b().nullable(),
    roof_type: fn().nullable(),
    // TODO: figure out
    roof_material: fn().nullable(),
    // TODO: figure out
    rooms_total: D().nullable(),
    sewer: fn().nullable(),
    // TODO: figure out
    sewer_public: J().nullable(),
    solar_panels: fn().nullable(),
    // TODO: figure out
    stories: D().nullable(),
    subdivision: fn().nullable(),
    // TODO: figure out
    units_total: fn().nullable(),
    // TODO: figure out
    walls_exterior_material: b().nullable(),
    water: fn().nullable(),
    // TODO: figure out
    year_built: D().nullable(),
    zoning: w({
      code: b().nullable(),
      description: b().nullable()
    }).nullable(),
    condition_class: D().nullable()
  }).nullable(),
  assessment: w({
    apn: b().nullable(),
    amount_annual: D().nullable(),
    value_assessed: D().nullable(),
    value_assessed_improvement: D().nullable(),
    value_assessed_land: D().nullable(),
    tax_year: D().nullable(),
    year_assessed: D().nullable()
  })
});
se(
  w({
    "property/listing_status": w({
      api_code_description: b().nullable(),
      api_code: D(),
      result: w({
        listing_status: b().nullable(),
        listing_date: b().nullable(),
        listing_price: D().nullable(),
        listing_status_date: b().nullable(),
        has_price_considerations: J().nullable()
      }).nullable()
    }),
    address_info: w({
      city: b().nullable(),
      county_fips: b().nullable(),
      geo_precision: b().nullable(),
      zipcode: b().nullable(),
      address_full: b().nullable(),
      slug: b().nullable(),
      block_id: b().nullable(),
      blockgroup_id: b().nullable(),
      state: b().nullable(),
      zipcode_plus4: b().nullable(),
      address: b().nullable(),
      lat: D().nullable(),
      lng: D().nullable(),
      unit: b().nullable(),
      status: fn().nullable(),
      // TODO: figure out
      msa: b().nullable(),
      metrodiv: fn().nullable()
      // TODO: figure out
    })
  })
);
var Yue = ae(pe(), 1), que = ae(pe(), 1), Jue = (0, que.applyIfNonEmptyString)((e) => rr.fromIsoString(e)), Kue = ae(Tl(), 1), _b = (e, t) => (0, Kue.isUndefined)(e) || e === "" ? void 0 : wi.fromIsoString(e).toAloftDate(t);
function Que(e, t = !1) {
  if (t && (0, Yue.isUndefined)(e.OriginatingSystemName))
    return;
  const n = sae(e.OriginatingSystemName);
  let r;
  return n === void 0 || n.isActive === !1 || !n.timeZone ? r = Je.TimeZones.US_PACIFIC : r = n.timeZone, // PurchaseContractDate is the most accurate, but has very low fill rate
  Jue(e.PurchaseContractDate) ?? // Pending timestamp is the next best option as it's set by the MLS
  _b(e.PendingTimestamp, r) ?? // If neither of those options is available, fallback to C1's derived pending date
  _b(e.DerivedPendingTimestamp, r);
}
ae(pe(), 1);
var Ib = ae(pe(), 1);
function ece(e) {
  if ((0, Ib.isDefined)(e.BathroomsFull) || (0, Ib.isDefined)(e.BathroomsThreeQuarter))
    return (e.BathroomsFull ?? 0) + (e.BathroomsThreeQuarter ?? 0);
  const t = e.BathroomsTotalInteger;
  if (t !== void 0 && !Number.isNaN(t))
    return Math.floor(t);
}
var tce = ae(pe(), 1);
function nce(e) {
  var n;
  if (e.BathroomsHalf !== void 0)
    return e.BathroomsHalf;
  const t = (n = e.BathroomsTotalInteger) == null ? void 0 : n.toString();
  if (t != null && t.includes("."))
    return Number((0, tce.expected)(t).split(".")[1]);
}
ae(pe(), 1);
var rce = ae(pe(), 1);
ae(Tl(), 1);
ae(pe(), 1);
var oce = ae(pe(), 1);
(0, oce.applyIfNonEmptyString)((e) => Lae(e));
var ace = ae(pe(), 1);
(0, ace.makeLookup)({
  cases: [
    [["Active", "Active Under Contract", "Coming Soon"], "Active"],
    [["Canceled", "Delete", "Expired", "Incomplete"], "Expired"],
    [["Closed", "Sold"], "SettledSale"],
    [["Hold", "Withdrawn"], "Withdrawn"],
    ["Pending", "Contract"]
  ],
  default: "Expired"
  // TODO: Should we leave this or get rid of it?
});
Yt.fromNumericPrice;
(0, rce.orUndefined)((e) => e.join(", "));
Yt.fromNumericPrice;
function Ug(e) {
  if (e === void 0)
    return;
  const t = new Date(e), n = t.getMonth() + 1, r = t.getFullYear();
  return Zr.parse(`${r}-${n < 10 ? "0" : ""}${n}`);
}
var ice = ae(pe(), 1), Fi = ae(y9(), 1);
function Lb(e) {
  return Number.isNaN(e) ? void 0 : e;
}
var Za = new Fi.Iso(
  (e) => e === void 0 ? void 0 : Lb(e),
  (e) => e === void 0 ? void 0 : Lb(e)
), Fr = new Fi.Iso(
  Za.fwd,
  (e) => e === void 0 || Number.isNaN(e) ? void 0 : _e.parse(e)
), ga = new Fi.Lens(
  Dt.sqftLensOpt.get,
  Dt.sqftLensOpt.set
).concat(Za.toLens()), ps = Za, gs = new Fi.Iso(
  (e) => e === !0 ? "Yes" : e === !1 ? "No" : void 0,
  (e) => e === "Yes" ? !0 : e === "No" ? !1 : void 0
), Rb = new Fi.Iso(
  // not technically an iso but what can you do
  (e) => e === void 0 ? void 0 : e,
  (e) => e === "" ? void 0 : e
), sce = new Fi.Lens(
  Yt.dollarLensOpt.get,
  Yt.dollarLensOpt.set
).concat(Za.toLens());
function DI(e) {
  return new Fi.Iso(
    (t) => t && e.includes(t) ? t : void 0,
    (t) => t && e.includes(t) ? t : void 0
  );
}
var lce = DI([
  "Permanent or Concrete",
  "Non-Permanent"
]), uce = DI(["Built-In", "Freestanding"]), rs = new Fi.Lens(
  (e) => oh({
    totalSqft: ga.get(e == null ? void 0 : e.totalSqft),
    quality: ps.fwd(e == null ? void 0 : e.quality)
  }),
  (e, t) => oh({
    totalSqft: ga.set(e == null ? void 0 : e.totalSqft, t == null ? void 0 : t.totalSqft),
    quality: ps.fwd(t == null ? void 0 : t.quality)
  })
), Lf = new Fi.Lens(
  (e) => oh({
    totalSqft: ga.get(e == null ? void 0 : e.totalSqft),
    quality: ps.fwd(e == null ? void 0 : e.dwellingCostQuality),
    percentInteriorFinished: Za.fwd(e == null ? void 0 : e.percentInteriorFinished),
    electrical: gs.fwd(e == null ? void 0 : e.electrical),
    subpanel: gs.fwd(e == null ? void 0 : e.subpanel),
    plumbingFixturesCount: Za.fwd(e == null ? void 0 : e.plumbingFixturesCount)
  }),
  (e, t) => oh({
    totalSqft: ga.set(e == null ? void 0 : e.totalSqft, t == null ? void 0 : t.totalSqft),
    percentInteriorFinished: Za.inv(t == null ? void 0 : t.percentInteriorFinished),
    electrical: gs.inv(t == null ? void 0 : t.electrical),
    subpanel: gs.inv(t == null ? void 0 : t.subpanel),
    plumbingFixturesCount: Fr.inv(t == null ? void 0 : t.plumbingFixturesCount),
    dwellingCostQuality: ps.inv(t == null ? void 0 : t.quality)
  })
);
function oh(e) {
  return (0, ice.populated)(e) ? e : void 0;
}
function cce(e) {
  var f, h, p, g, C, v, y, M, x, _, L, R;
  const t = e._getCostDataExtension(), n = e.getStructuredData("gla"), r = e.getStructuredData("bathroomCount"), o = e.getStructuredData("basementLine1"), a = e.getStructuredData("basementLine2"), i = e.getStructuredData("designStyle"), l = e.getPropertyType(), u = () => {
    var P, N, O;
    const k = {
      gla: ga.get(n),
      quality: ps.fwd((P = t == null ? void 0 : t.primaryDwelling) == null ? void 0 : P.quality),
      stories: Za.fwd(i == null ? void 0 : i.stories),
      aboveGradeBathsFull: Fr.fwd(r == null ? void 0 : r.fullBaths),
      aboveGradeBathsHalf: Fr.fwd(r == null ? void 0 : r.halfBaths),
      belowGradeBathsFull: Fr.fwd(a == null ? void 0 : a.fullBathCount),
      belowGradeBathsHalf: Fr.fwd(a == null ? void 0 : a.halfBathCount),
      nonStandardGLA: ga.get((N = t == null ? void 0 : t.primaryDwelling) == null ? void 0 : N.nonStandardGla),
      multiUnitCount: Fr.fwd((O = t == null ? void 0 : t.primaryDwelling) == null ? void 0 : O.multiUnitCount)
    };
    switch (l) {
      case "manufacturedHome":
        return;
      case "multiFamily":
      case "singleFamilyResidence":
      default:
        return k;
    }
  }, d = () => {
    var P, N, O, H, $, ne, ie, re, ve, ue, j, K, ce;
    const k = {
      gla: ga.get((P = t == null ? void 0 : t.manufactured) == null ? void 0 : P.gla),
      quality: ps.fwd((N = t == null ? void 0 : t.manufactured) == null ? void 0 : N.dwellingCostQuality),
      sections: Za.fwd((O = t == null ? void 0 : t.manufactured) == null ? void 0 : O.sections),
      bathroomsFull: Fr.fwd((H = t == null ? void 0 : t.manufactured) == null ? void 0 : H.bathroomsFull),
      bathroomsHalf: Fr.fwd(($ = t == null ? void 0 : t.manufactured) == null ? void 0 : $.bathroomsHalf),
      hasAC: gs.fwd((ne = t == null ? void 0 : t.manufactured) == null ? void 0 : ne.hasAC),
      hasClimatePkg: gs.fwd((ie = t == null ? void 0 : t.manufactured) == null ? void 0 : ie.hasClimatePkg),
      foundationType: lce.fwd((re = t == null ? void 0 : t.manufactured) == null ? void 0 : re.foundationType),
      fireplaces: Fr.fwd((ue = (ve = t == null ? void 0 : t.manufactured) == null ? void 0 : ve.fireplaces) == null ? void 0 : ue.totalCount),
      fireplaceType: uce.fwd((K = (j = t == null ? void 0 : t.manufactured) == null ? void 0 : j.fireplaces) == null ? void 0 : K.type),
      deliveryMileage: Fr.fwd((ce = t == null ? void 0 : t.manufactured) == null ? void 0 : ce.deliveryMileage)
    };
    switch (l) {
      case "manufacturedHome":
        return {
          ...k,
          gla: ga.get(n),
          bathroomsFull: Fr.fwd(r == null ? void 0 : r.fullBaths),
          bathroomsHalf: Fr.fwd(r == null ? void 0 : r.halfBaths)
        };
      case "multiFamily":
      case "singleFamilyResidence":
      default:
        return k;
    }
  };
  return {
    // Primary Dwelling actually refers to site built dwelling here
    primaryDwelling: u(),
    basement: {
      totalSqft: ga.get(o == null ? void 0 : o.total),
      quality: ps.fwd((f = t == null ? void 0 : t.basement) == null ? void 0 : f.quality),
      finishedSqft: ga.get(o == null ? void 0 : o.finished)
    },
    attachedOrBuiltinGarage: rs.get(t == null ? void 0 : t.attachedOrBuiltinGarage),
    detachedGarage: rs.get(t == null ? void 0 : t.detachedGarage),
    carport: rs.get(t == null ? void 0 : t.carport),
    deck: rs.get(t == null ? void 0 : t.deck),
    coveredPatioOrGazebo: rs.get(t == null ? void 0 : t.coveredPatioOrGazebo),
    enclosedPatio: {
      ...rs.get(t == null ? void 0 : t.enclosedPatio),
      linearFootage: Fr.fwd((h = t == null ? void 0 : t.enclosedPatio) == null ? void 0 : h.linearFootage)
    },
    pool: rs.get(t == null ? void 0 : t.pool),
    adu: {
      gla: ga.get((p = t == null ? void 0 : t.adu) == null ? void 0 : p.gla),
      quality: ps.fwd((g = t == null ? void 0 : t.adu) == null ? void 0 : g.dwellingCostQuality),
      bathroomsFull: Fr.fwd((C = t == null ? void 0 : t.adu) == null ? void 0 : C.bathroomsFull),
      bathroomsHalf: Fr.fwd((v = t == null ? void 0 : t.adu) == null ? void 0 : v.bathroomsHalf),
      stories: Za.fwd((y = t == null ? void 0 : t.adu) == null ? void 0 : y.stories)
    },
    attic: rs.get(t == null ? void 0 : t.attic),
    shed: Lf.get(t == null ? void 0 : t.shed),
    workshop: Lf.get(t == null ? void 0 : t.workshop),
    bonusRoom: Lf.get(t == null ? void 0 : t.bonusRoom),
    barn: {
      ...Lf.get(t == null ? void 0 : t.barn),
      isPoleBarn: gs.fwd((M = t == null ? void 0 : t.barn) == null ? void 0 : M.isPoleBarn),
      hasExteriorWall: gs.fwd((x = t == null ? void 0 : t.barn) == null ? void 0 : x.hasExteriorWall)
    },
    manufactured: d(),
    manualCost: {
      label: Rb.fwd((_ = t == null ? void 0 : t.manualCost) == null ? void 0 : _.label),
      feature: Rb.fwd((L = t == null ? void 0 : t.manualCost) == null ? void 0 : L.feature),
      cost: sce.get((R = t == null ? void 0 : t.manualCost) == null ? void 0 : R.cost)
    }
  };
}
var _r = ae(pe(), 1);
function dce(e, t) {
  var o;
  const { encoding: n, annotations: r } = t;
  if (n !== "UAD_2022")
    throw Error(`Cannot retrieve data for encoding: ${n}`);
  try {
    switch (e) {
      case "toolkitListingID":
        if ((0, _r.isUndefined)(r.DataSourceDescription))
          return;
        const { mls: a, listingID: i } = Y2.decode(r.DataSourceDescription);
        return [a, i].some(_r.isUndefined) || !f_(a) || !h_(a) ? void 0 : hae({
          mls: a,
          listingID: i
        });
      case "address":
        return X2.decode(r);
      case "latitude":
        return (0, _r.orUndefined)(ys.decode)(
          r.LatitudeNumber
        );
      case "longitude":
        return (0, _r.orUndefined)(ys.decode)(
          r.LongitudeNumber
        );
      case "dataSource":
        return (0, _r.orUndefined)(Y2.decode)(
          r.DataSourceDescription
        );
      case "designStyle":
        return (0, _r.orUndefined)(tm.decode)(r.DesignStyle);
      case "carStorage":
        return (0, _r.orUndefined)(nm.decode)(
          r.CarStorage
        );
      case "status":
        return (0, _r.orUndefined)(am.decode)(
          r.DateOfSale
        );
      case "siteArea":
        return (o = (0, _r.orUndefined)(om.decode)(r.SiteArea)) == null ? void 0 : o.site;
      case "actualAge":
        return (0, _r.orUndefined)(sm.decode)(r.Age);
      case "gla":
        return (0, _r.orUndefined)(im.decode)(
          r.GrossLivingArea
        );
      case "bedroomCount":
        return (0, _r.orUndefined)(ys.decode)(
          r.TotalBedroomCount
        );
      case "bathroomCount":
        return (0, _r.orUndefined)(em.decode)(
          r.TotalBathroomCount
        );
      case "basementLine1":
        return (0, _r.orUndefined)(Jh.decode)(
          r.BasementArea
        );
      case "basementLine2":
        return (0, _r.orUndefined)(Qh.decode)(
          r.BasementFinish
        );
      case "salePrice":
        return (0, _r.orUndefined)(lm.decode)(
          r.PropertySalesAmount
        );
      default:
        throw Error(`Getter not implemented for field: ${e}`);
    }
  } catch (a) {
    if (a instanceof Bt)
      return;
    throw a;
  }
}
var fa = ae(pe(), 1);
function ha(e, t, n) {
  switch (e) {
    case "actualAge":
      const r = t.getStructuredData(e), o = n.getStructuredData(e);
      return r === void 0 && o === void 0 ? void 0 : (0, fa.orUndefined)(sm.encode)({
        age: (o == null ? void 0 : o.age) ?? (r == null ? void 0 : r.age),
        isEstimation: (o == null ? void 0 : o.isEstimation) ?? (r == null ? void 0 : r.isEstimation)
      });
    case "gla":
      const a = t.getStructuredData(e), i = n.getStructuredData(e);
      return (0, fa.orUndefined)(im.encode)(i ?? a);
    case "bedroomCount":
      const l = t.getStructuredData(e), u = n.getStructuredData(e);
      return (0, fa.orUndefined)(ys.encode)(u ?? l);
    case "bathroomCount":
      const d = t.getStructuredData(e), f = n.getStructuredData(e);
      return d === void 0 && f === void 0 ? void 0 : (0, fa.orUndefined)(em.encode)({
        fullBaths: (f == null ? void 0 : f.fullBaths) ?? (d == null ? void 0 : d.fullBaths),
        halfBaths: (f == null ? void 0 : f.halfBaths) ?? (d == null ? void 0 : d.halfBaths)
      });
    case "basementLine1":
      const h = t.getStructuredData(e), p = n.getStructuredData(e);
      return h === void 0 && p === void 0 ? void 0 : (0, fa.orUndefined)(Jh.encode)({
        total: (p == null ? void 0 : p.total) ?? (h == null ? void 0 : h.total),
        finished: (p == null ? void 0 : p.finished) ?? (h == null ? void 0 : h.finished)
      });
    case "basementLine2":
      const g = t.getStructuredData(e), C = n.getStructuredData(e);
      return g === void 0 && C === void 0 ? void 0 : (0, fa.orUndefined)(Qh.encode)({
        bedroomCount: (C == null ? void 0 : C.bedroomCount) ?? (g == null ? void 0 : g.bedroomCount),
        fullBathCount: (C == null ? void 0 : C.fullBathCount) ?? (g == null ? void 0 : g.fullBathCount),
        halfBathCount: (C == null ? void 0 : C.halfBathCount) ?? (g == null ? void 0 : g.halfBathCount),
        otherRoomCount: (C == null ? void 0 : C.otherRoomCount) ?? (g == null ? void 0 : g.otherRoomCount),
        recRoomCount: (C == null ? void 0 : C.recRoomCount) ?? (g == null ? void 0 : g.recRoomCount)
      });
    case "carStorage":
      const v = t.getStructuredData(e), y = n.getStructuredData(e);
      return v === void 0 && y === void 0 ? void 0 : (0, fa.orUndefined)(nm.encode)({
        attachedGarageSpaces: (y == null ? void 0 : y.attachedGarageSpaces) ?? (v == null ? void 0 : v.attachedGarageSpaces),
        builtInGarageSpaces: (y == null ? void 0 : y.builtInGarageSpaces) ?? (v == null ? void 0 : v.builtInGarageSpaces),
        detachedGarageSpaces: (y == null ? void 0 : y.detachedGarageSpaces) ?? (v == null ? void 0 : v.detachedGarageSpaces),
        drivewaySpaces: (y == null ? void 0 : y.drivewaySpaces) ?? (v == null ? void 0 : v.drivewaySpaces),
        carportSpaces: (y == null ? void 0 : y.carportSpaces) ?? (v == null ? void 0 : v.carportSpaces)
      });
    case "designStyle":
      const M = t.getStructuredData(e), x = n.getStructuredData(e);
      return M === void 0 && x === void 0 ? void 0 : (0, fa.orUndefined)(tm.encode)({
        attachmentType: (x == null ? void 0 : x.attachmentType) ?? (M == null ? void 0 : M.attachmentType),
        style: (x == null ? void 0 : x.style) ?? (M == null ? void 0 : M.style),
        stories: (x == null ? void 0 : x.stories) ?? (M == null ? void 0 : M.stories)
      });
    case "salePrice":
      const _ = t.getStructuredData(e), L = n.getStructuredData(e);
      return _ === void 0 && L === void 0 ? void 0 : (0, fa.orUndefined)(lm.encode)(L ?? _);
    case "siteArea":
      const R = t.getStructuredData(e), k = n.getStructuredData(e);
      return R === void 0 && k === void 0 ? void 0 : (0, fa.orUndefined)(om.encode)({
        site: k ?? R
      });
    case "status":
      const P = t.getStructuredData(e), N = n.getStructuredData(e);
      return P === void 0 && N === void 0 ? void 0 : (0, fa.orUndefined)(am.encode)({
        contractMonth: (N == null ? void 0 : N.contractMonth) ?? (P == null ? void 0 : P.contractMonth),
        closeMonth: (N == null ? void 0 : N.closeMonth) ?? (P == null ? void 0 : P.closeMonth),
        expirationMonth: (N == null ? void 0 : N.expirationMonth) ?? (P == null ? void 0 : P.expirationMonth),
        withdrawalMonth: (N == null ? void 0 : N.withdrawalMonth) ?? (P == null ? void 0 : P.withdrawalMonth),
        listingStatus: (N == null ? void 0 : N.listingStatus) ?? (P == null ? void 0 : P.listingStatus)
      });
    default:
      throw new Error(`Unhandled field: ${e}`);
  }
}
var Or = ae(pe(), 1);
function fce(e, t, n) {
  const { encoding: r } = n;
  if (r !== "UAD_2022")
    throw Error(`Cannot retrieve data for encoding: ${r}`);
  let o, a;
  switch (e) {
    case "address":
      const i = t, l = (0, Or.isUndefined)(i) ? X2.emptyAnnotations : X2.encode(i);
      return {
        ...n,
        annotations: {
          ...n.annotations,
          ...l
        }
      };
    case "latitude":
      o = "LatitudeNumber";
      const u = t;
      a = (0, Or.orUndefined)(ys.encode)(u);
      break;
    case "longitude":
      o = "LongitudeNumber";
      const d = t;
      a = (0, Or.orUndefined)(ys.encode)(d);
      break;
    case "dataSource":
      o = "DataSourceDescription";
      const f = t;
      a = (0, Or.orUndefined)(Y2.encode)(f);
      break;
    case "designStyle":
      o = "DesignStyle";
      const h = t;
      a = (0, Or.orUndefined)(tm.encode)(h);
      break;
    case "carStorage":
      o = "CarStorage";
      const p = t;
      a = (0, Or.orUndefined)(nm.encode)(p);
      break;
    case "status":
      o = "DateOfSale";
      const g = t;
      a = (0, Or.orUndefined)(am.encode)(g);
      break;
    case "siteArea":
      o = "SiteArea";
      const C = t;
      a = (0, Or.orUndefined)((k) => om.encode({ site: k }))(C);
      break;
    case "actualAge":
      o = "Age";
      const v = t;
      a = (0, Or.orUndefined)(sm.encode)(v);
      break;
    case "gla":
      o = "GrossLivingArea";
      const y = t;
      a = (0, Or.orUndefined)(im.encode)(y);
      break;
    case "bedroomCount":
      o = "TotalBedroomCount";
      const M = t;
      a = (0, Or.orUndefined)(ys.encode)(M);
      break;
    case "bathroomCount":
      o = "TotalBathroomCount";
      const x = t;
      a = (0, Or.orUndefined)(em.encode)(x);
      break;
    case "basementLine1":
      o = "BasementArea";
      const _ = t;
      a = (0, Or.orUndefined)(Jh.encode)(_);
      break;
    case "basementLine2":
      o = "BasementFinish";
      const L = t;
      a = (0, Or.orUndefined)(Qh.encode)(L);
      break;
    case "salePrice":
      o = "PropertySalesAmount";
      const R = t;
      a = (0, Or.orUndefined)(lm.encode)(R);
      break;
    default:
      throw Error(`Setter not implemented for field: ${e}`);
  }
  return {
    ...n,
    annotations: {
      ...n.annotations,
      [o]: a
    }
  };
}
var hce = ae(pe(), 1);
function mce(e) {
  var i, l, u, d, f, h;
  const { salesCompGridData: t, costDataExtension: n, runCostExtension: r, propertyType: o } = e, a = {
    ...n,
    depreciation: {
      physicalDepreciation: {
        primaryDwelling: {
          effectiveAge: (l = (i = n.depreciation) == null ? void 0 : i.physicalDepreciation) == null ? void 0 : l.effectiveAge,
          ecoLifeYears: (d = (u = n.depreciation) == null ? void 0 : u.physicalDepreciation) == null ? void 0 : d.economicLifeYears
        }
      },
      functionalObsolescence: {
        percent: (f = n.depreciation) == null ? void 0 : f.functionalObsolescencePercent
      },
      externalDepreciation: {
        percent: (h = n.depreciation) == null ? void 0 : h.externalDepreciationPercent
      }
    }
  };
  return {
    version: 2,
    salesCompGridData: t,
    costDataExtension: a,
    runCostExtension: r,
    propertyType: o
  };
}
function pce(e) {
  let t = e;
  switch (t.version) {
    case 1:
      t = mce(t);
    case 2:
      return t;
    default:
      (0, hce.unreachable)(t);
  }
}
var Ps = D().gte(1).lte(8).multipleOf(0.1), Zl = $t({
  totalSqft: wt,
  quality: Ps
}).partial(), vm = $t({
  totalSqft: wt,
  percentInteriorFinished: D(),
  electrical: J(),
  subpanel: J(),
  plumbingFixturesCount: _e,
  dwellingCostQuality: Ps
}).partial(), PI = Me(["Permanent or Concrete", "Non-Permanent"]), gce = Me(["Built-In", "Freestanding"]), EI = $t({
  quality: Ps,
  nonStandardGla: wt,
  multiUnitCount: _e
}).partial(), TI = $t({
  quality: Ps
}).partial(), NI = w({
  totalSqft: wt,
  quality: Ps
}).partial(), kI = Zl.partial(), VI = Zl.partial(), OI = Zl.partial(), FI = Zl.partial(), BI = Zl.partial(), HI = Zl.extend({ linearFootage: _e }).partial(), GI = Zl.partial(), $I = $t({
  bathroomsFull: _e,
  bathroomsHalf: _e,
  stories: D().gte(0).lte(4).multipleOf(0.5),
  gla: wt,
  dwellingCostQuality: Ps
}).partial(), ZI = vm.partial(), jI = vm.partial(), WI = vm.partial(), zI = vm.extend({
  isPoleBarn: J(),
  hasExteriorWall: J()
}).partial(), $9 = $t({
  sections: D().gte(1).lte(4).int(),
  gla: wt,
  bathroomsFull: _e,
  bathroomsHalf: _e,
  dwellingCostQuality: Ps,
  hasAC: J(),
  hasClimatePkg: J(),
  foundationType: PI,
  fireplaces: $t({
    totalCount: _e,
    type: gce
  }).partial(),
  deliveryMileage: _e
}).partial(), vce = $t({
  physicalDepreciation: $t({
    effectiveAge: D(),
    economicLifeYears: _e
  }).partial(),
  functionalObsolescencePercent: D().int().gte(0).lte(100),
  externalDepreciationPercent: D().int().gte(0).lte(100)
}).partial(), UI = $t({
  label: b(),
  feature: b(),
  cost: Yt.schema
}).partial(), Cce = $t({
  primaryDwelling: EI,
  basement: TI,
  attic: NI,
  attachedOrBuiltinGarage: kI,
  detachedGarage: VI,
  carport: OI,
  deck: FI,
  coveredPatioOrGazebo: BI,
  enclosedPatio: HI,
  pool: GI,
  adu: $I,
  shed: ZI,
  workshop: jI,
  bonusRoom: WI,
  barn: zI,
  manufactured: $9,
  // Not included in DwellingCost request
  /**
   * @deprecated Use manualCost instead
   */
  additionalFeaturesCost: Pe.optional(),
  manualCost: UI,
  depreciation: vce,
  siteNotes: b().optional(),
  // Only set for the subject. Site cost is derived for comps.
  siteCost: Pe.optional()
}).partial(), bce = w({
  output: gm,
  bathroomCosts: Ole.optional()
}), XI = bce.extend({
  input: fn()
}), yce = w({
  version: fe(1),
  salesCompGridData: oI,
  costDataExtension: Cce,
  runCostExtension: XI.optional(),
  propertyType: Cr.optional()
}), S3 = w({
  lumpSum: Pe.optional(),
  percent: D().gte(0).lte(100).optional(),
  effectiveAge: D().optional(),
  ecoLifeYears: D().optional()
}), Sce = gn(
  _c,
  S3
), Ace = $t({
  physicalDepreciation: Sce,
  functionalObsolescence: S3,
  externalDepreciation: S3
}).partial(), Mce = $t({
  primaryDwelling: EI,
  basement: TI,
  attic: NI,
  attachedOrBuiltinGarage: kI,
  detachedGarage: VI,
  carport: OI,
  deck: FI,
  coveredPatioOrGazebo: BI,
  enclosedPatio: HI,
  pool: GI,
  adu: $I,
  shed: ZI,
  workshop: jI,
  bonusRoom: WI,
  barn: zI,
  manufactured: $9,
  // Not included in DwellingCost request
  /**
   * @deprecated Use manualCost instead
   */
  additionalFeaturesCost: Pe.optional(),
  manualCost: UI,
  depreciation: Ace,
  notes: b().optional(),
  // Only set for the subject. Site cost is derived for comps.
  siteCost: Pe.optional()
}).partial(), xce = w({
  version: fe(2),
  salesCompGridData: oI,
  costDataExtension: Mce,
  runCostExtension: XI.optional(),
  propertyType: Cr.optional()
}), wce = na("version", [
  yce,
  xce
]), On, _ce = (On = class {
  constructor(t) {
    qs(this, "salesCompGridData");
    qs(this, "costDataExtension");
    qs(this, "runCostExtension");
    qs(this, "propertyType");
    this.salesCompGridData = t.salesCompGridData, this.costDataExtension = t.costDataExtension, this.runCostExtension = t.runCostExtension, this.propertyType = t.propertyType;
  }
  equals(t) {
    return t instanceof On ? V1.isEqual(this.salesCompGridData, t.salesCompGridData) && V1.isEqual(this.costDataExtension, t.costDataExtension) && V1.isEqual(this.runCostExtension, t.runCostExtension) && V1.isEqual(this.propertyType, t.propertyType) : !1;
  }
  // NOTE: toJSON() and schema.parse() should be inverses of each other! (modulo upgrades)
  toJSON() {
    return {
      version: On.LATEST_VERSION,
      salesCompGridData: this.salesCompGridData,
      costDataExtension: this.costDataExtension,
      runCostExtension: this.runCostExtension,
      propertyType: this.propertyType
    };
  }
  static empty() {
    return new On({
      salesCompGridData: { encoding: "UAD_2022", annotations: {} },
      costDataExtension: {},
      runCostExtension: void 0,
      propertyType: void 0
    });
  }
  static fromSalesCompGridData(t, n) {
    return new On({
      salesCompGridData: t,
      costDataExtension: {},
      runCostExtension: void 0,
      propertyType: n
    });
  }
  static fromPublicRecord(t, n) {
    let r = new On({
      propertyType: n,
      salesCompGridData: {
        encoding: "UAD_2022",
        annotations: {
          PropertyCity: t.PropertyAddressCity ?? void 0,
          PropertyState: t.PropertyAddressState ?? void 0,
          PropertyPostalCode: t.PropertyAddressZIP ?? void 0,
          PropertyStreetAddress: t.PropertyAddressFull ?? void 0,
          View: t.ViewDescription ?? void 0,
          DesignStyle: t.StructureStyle ?? void 0
        }
      },
      costDataExtension: {
        attachedOrBuiltinGarage: {
          totalSqft: t.ParkingGarageArea ?? void 0
        },
        carport: {
          totalSqft: t.ParkingCarportArea ?? void 0
        },
        deck: {
          totalSqft: t.DeckArea ?? void 0
        },
        coveredPatioOrGazebo: {
          totalSqft: t.PatioArea ?? void 0
        },
        attic: {
          totalSqft: t.RoomsAtticArea ?? void 0
        },
        adu: {
          gla: t.GuestHouseArea ?? void 0
        },
        shed: {
          totalSqft: t.ShedArea ?? void 0
        },
        pool: {
          totalSqft: t.PoolArea ?? void 0
        }
      },
      runCostExtension: void 0
    });
    const o = t.RoomsBasementArea ?? t.RoomsBasementAreaFinished ?? void 0, a = t.StoriesCount, i = t.YearBuilt, l = t.ParkingSpaceCount;
    return r = r.updateStructuredData("siteArea", t.AreaLotSF ?? void 0).updateStructuredData("gla", t.AreaBuilding ?? void 0).updateStructuredData("bedroomCount", wu(t.BedroomsCount)).updateStructuredData("bathroomCount", {
      fullBaths: wu(t.BathCount),
      halfBaths: wu(t.BathPartialCount)
    }).updateStructuredData("basementLine1", {
      total: o,
      finished: t.RoomsBasementAreaFinished ?? void 0
    }), l !== null && (r = r.updateStructuredData("carStorage", {
      attachedGarageSpaces: t.ParkingGarage ? Xg(t.ParkingSpaceCount) : void 0,
      carportSpaces: t.ParkingCarport ? Xg(t.ParkingSpaceCount) : void 0
    })), a !== null && (r = r.updateStructuredData("designStyle", {
      stories: a
    })), i !== null && (r = r.updateStructuredData("actualAge", {
      age: _e.parse((/* @__PURE__ */ new Date()).getFullYear() - i)
    })), r;
  }
  static fromMLSData(t, n) {
    var v, y, M, x, _;
    const { listingID: r, mls: o } = p_((0, dl.expected)(t.ToolkitListingID)), a = new On({
      propertyType: n,
      salesCompGridData: {
        encoding: "UAD_2022",
        annotations: {
          PropertyCity: t.City ?? void 0,
          PropertyState: t.StateOrProvince ?? void 0,
          PropertyPostalCode: t.PostalCode ?? void 0,
          PropertyStreetAddress: t.UnparsedAddress ?? void 0,
          View: ((v = t.View) == null ? void 0 : v.join(" ")) ?? void 0,
          PorchDeck: ((y = t.PatioAndPorchFeatures) == null ? void 0 : y.join(" ")) ?? void 0,
          LatitudeNumber: (M = t.Latitude) == null ? void 0 : M.toString(),
          LongitudeNumber: (x = t.Longitude) == null ? void 0 : x.toString()
        }
      },
      costDataExtension: {},
      runCostExtension: void 0
    }), i = wu(nce(t)), l = wu(ece(t)), u = (0, dl.isDefined)(l) || (0, dl.isDefined)(i), d = Que(t), f = d == null ? void 0 : d.getMonth(), h = d == null ? void 0 : d.getYear(), p = f !== void 0 && h !== void 0 ? Zr.parse(`${h}-${f < 10 ? "0" : ""}${f}`) : void 0, g = Xue(t.StandardStatus);
    let C = a.updateStructuredData("dataSource", { mls: o, listingID: r }).updateStructuredData("designStyle", {
      stories: t.StoriesTotal,
      style: (_ = t.ArchitecturalStyle) == null ? void 0 : _.join(" ")
    }).updateStructuredData(
      "salePrice",
      t.ClosePrice ? Yt.fromNumericPrice(t.ClosePrice) : Yt.fromNumericPrice(t.ListPrice)
    ).updateStructuredData("siteArea", Uue(t)).updateStructuredData(
      "gla",
      t.LivingArea ? Dt.fromNumber(t.LivingArea, "sqft") : void 0
    ).updateStructuredData("bedroomCount", wu(t.BedroomsTotal)).updateStructuredData("actualAge", {
      age: t.YearBuilt ? _e.parse((/* @__PURE__ */ new Date()).getFullYear() - t.YearBuilt) : void 0
    });
    return u && (C = C.updateStructuredData("bathroomCount", {
      fullBaths: l,
      halfBaths: i
    })), t.GarageSpaces && (C = C.updateStructuredData("carStorage", {
      attachedGarageSpaces: Xg(t.GarageSpaces)
    })), g && (C = C.updateStructuredData("status", {
      listingStatus: g,
      contractMonth: p,
      closeMonth: Ug(t.CloseDate),
      expirationMonth: Ug(t.ExpirationDate),
      withdrawalMonth: Ug(t.WithdrawnDate)
    })), C;
  }
  /**
   * Pulls the property data from that and overlays it on top of the current
   * tkv2 property. Does not support merging runCostExtension today.
   * Remember: That overrides this where both values are available!
   */
  mergeWith(t) {
    return new On({
      salesCompGridData: {
        encoding: t.salesCompGridData.encoding ?? this.salesCompGridData.encoding,
        annotations: {
          // These are simply strings so spreading is valid here
          ...this.salesCompGridData.annotations,
          ...t.salesCompGridData.annotations,
          Age: ha("actualAge", this, t),
          GrossLivingArea: ha("gla", this, t),
          TotalBedroomCount: ha("bedroomCount", this, t),
          TotalBathroomCount: ha("bathroomCount", this, t),
          BasementArea: ha("basementLine1", this, t),
          BasementFinish: ha("basementLine2", this, t),
          CarStorage: ha("carStorage", this, t),
          DesignStyle: ha("designStyle", this, t),
          PropertySalesAmount: ha("salePrice", this, t),
          SiteArea: ha("siteArea", this, t),
          DateOfSale: ha("status", this, t)
        }
      },
      costDataExtension: {
        primaryDwelling: {
          ...this.costDataExtension.primaryDwelling,
          ...t.costDataExtension.primaryDwelling
        },
        adu: {
          ...this.costDataExtension.adu,
          ...t.costDataExtension.adu
        },
        basement: {
          ...this.costDataExtension.basement,
          ...t.costDataExtension.basement
        },
        attic: {
          ...this.costDataExtension.attic,
          ...t.costDataExtension.attic
        },
        attachedOrBuiltinGarage: {
          ...this.costDataExtension.attachedOrBuiltinGarage,
          ...t.costDataExtension.attachedOrBuiltinGarage
        },
        detachedGarage: {
          ...this.costDataExtension.detachedGarage,
          ...t.costDataExtension.detachedGarage
        },
        carport: {
          ...this.costDataExtension.carport,
          ...t.costDataExtension.carport
        },
        deck: {
          ...this.costDataExtension.deck,
          ...t.costDataExtension.deck
        },
        coveredPatioOrGazebo: {
          ...this.costDataExtension.coveredPatioOrGazebo,
          ...t.costDataExtension.coveredPatioOrGazebo
        },
        enclosedPatio: {
          ...this.costDataExtension.enclosedPatio,
          ...t.costDataExtension.enclosedPatio
        },
        pool: {
          ...this.costDataExtension.pool,
          ...t.costDataExtension.pool
        },
        shed: {
          ...this.costDataExtension.shed,
          ...t.costDataExtension.shed
        },
        workshop: {
          ...this.costDataExtension.workshop,
          ...t.costDataExtension.workshop
        },
        bonusRoom: {
          ...this.costDataExtension.bonusRoom,
          ...t.costDataExtension.bonusRoom
        },
        barn: {
          ...this.costDataExtension.barn,
          ...t.costDataExtension.barn
        },
        manufactured: {
          ...this.costDataExtension.manufactured,
          ...t.costDataExtension.manufactured
        },
        depreciation: {
          ...this.costDataExtension.depreciation,
          ...t.costDataExtension.depreciation
        },
        manualCost: {
          ...this.costDataExtension.manualCost,
          ...t.costDataExtension.manualCost
        },
        siteCost: t.costDataExtension.siteCost ?? this.costDataExtension.siteCost,
        notes: t.costDataExtension.notes ?? this.costDataExtension.notes
      },
      runCostExtension: t.runCostExtension ?? this.runCostExtension,
      propertyType: t.propertyType ?? this.propertyType
    });
  }
  /**
   * Returns an updated version of the current Tkv2Property by copying
   * everything from the given property that is allowed to be updated directly
   * via the API.
   */
  updateAPIWritable(t) {
    return new On({
      salesCompGridData: t.salesCompGridData,
      costDataExtension: t.costDataExtension,
      runCostExtension: this.runCostExtension,
      propertyType: t.propertyType
    });
  }
  getGridField(t) {
    const { encoding: n } = this.salesCompGridData;
    if (n !== "UAD_2022")
      throw Error(`Cannot get UAD field for property with encoding: ${n}`);
    return this.salesCompGridData.annotations[t];
  }
  /**
   * Returns a new Tkv2Property with one field updated. Original property is
   * unchanged.
   */
  updateGridField(t, n) {
    const { encoding: r } = this.salesCompGridData;
    if (r !== "UAD_2022")
      throw Error(`Cannot set UAD field for property with encoding: ${r}`);
    return new On({
      salesCompGridData: {
        ...this.salesCompGridData,
        annotations: {
          ...this.salesCompGridData.annotations,
          [t]: n
        }
      },
      costDataExtension: this.costDataExtension,
      runCostExtension: this.runCostExtension,
      propertyType: this.propertyType
    });
  }
  getAdjustment(t) {
    var r;
    const { encoding: n } = this.salesCompGridData;
    if (n !== "UAD_2022")
      throw Error(`Cannot get UAD adjustment for property with encoding: ${n}`);
    return (r = this.salesCompGridData.adjustments) == null ? void 0 : r[t];
  }
  /**
   * Returns a new Tkv2Property with one adjustment updated. Original property is
   * unchanged.
   */
  updateAdjustment(t, n) {
    const { encoding: r } = this.salesCompGridData;
    if (r !== "UAD_2022")
      throw Error(`Cannot set UAD adjustment for property with encoding: ${r}`);
    return new On({
      salesCompGridData: {
        ...this.salesCompGridData,
        adjustments: {
          ...this.salesCompGridData.adjustments,
          [t]: n
        }
      },
      costDataExtension: this.costDataExtension,
      runCostExtension: this.runCostExtension,
      propertyType: this.propertyType
    });
  }
  getStructuredData(t) {
    return dce(t, this.salesCompGridData);
  }
  /**
   * Returns a new Tkv2Property with updated structured data. Original
   * property is unchanged
   */
  updateStructuredData(t, n) {
    const r = fce(t, n, this.salesCompGridData);
    return new On({
      salesCompGridData: r,
      costDataExtension: this.costDataExtension,
      runCostExtension: this.runCostExtension,
      propertyType: this.propertyType
    });
  }
  /** get SalesCompGridData */
  getSalesCompGridData() {
    return this.salesCompGridData;
  }
  /** Update SalesCompGridData */
  updateSalesCompGridData(t) {
    return new On({
      salesCompGridData: t,
      costDataExtension: this.costDataExtension,
      runCostExtension: this.runCostExtension,
      propertyType: this.propertyType
    });
  }
  getEditableCostData() {
    var n, r, o, a, i, l, u, d, f, h, p, g, C, v, y, M, x, _, L, R, k, P, N, O, H, $, ne, ie, re, ve, ue, j, K;
    const t = this.costDataExtension;
    return {
      primaryDwelling: {
        quality: al((n = t.primaryDwelling) == null ? void 0 : n.quality),
        nonStandardGLA: (r = t.primaryDwelling) == null ? void 0 : r.nonStandardGla,
        multiUnitCount: (o = t.primaryDwelling) == null ? void 0 : o.multiUnitCount
      },
      basement: {
        quality: al((a = t.basement) == null ? void 0 : a.quality)
      },
      attic: {
        quality: al((i = t.attic) == null ? void 0 : i.quality),
        totalSqft: (l = t.attic) == null ? void 0 : l.totalSqft
      },
      attachedOrBuiltinGarage: Ks(t.attachedOrBuiltinGarage),
      detachedGarage: Ks(t.detachedGarage),
      carport: Ks(t.carport),
      deck: Ks(t.deck),
      coveredPatioOrGazebo: Ks(t.coveredPatioOrGazebo),
      enclosedPatio: {
        ...Ks(t.enclosedPatio),
        linearFootage: gt.fromNumber((u = t.enclosedPatio) == null ? void 0 : u.linearFootage)
      },
      pool: Ks(t.pool),
      adu: {
        bathroomsFull: gt.fromNumber((d = t.adu) == null ? void 0 : d.bathroomsFull),
        bathroomsHalf: gt.fromNumber((f = t.adu) == null ? void 0 : f.bathroomsHalf),
        stories: (h = t.adu) == null ? void 0 : h.stories,
        gla: (p = t.adu) == null ? void 0 : p.gla,
        quality: al((g = t.adu) == null ? void 0 : g.dwellingCostQuality)
      },
      shed: Rf(t.shed),
      workshop: Rf(t.workshop),
      bonusRoom: Rf(t.bonusRoom),
      barn: {
        ...Rf(t.barn),
        isPoleBarn: (C = t.barn) == null ? void 0 : C.isPoleBarn,
        hasExteriorWall: (v = t.barn) == null ? void 0 : v.hasExteriorWall
      },
      manufactured: {
        sections: gt.fromNumber((y = t.manufactured) == null ? void 0 : y.sections),
        gla: (M = t.manufactured) == null ? void 0 : M.gla,
        bathroomsFull: gt.fromNumber((x = t.manufactured) == null ? void 0 : x.bathroomsFull),
        bathroomsHalf: gt.fromNumber((_ = t.manufactured) == null ? void 0 : _.bathroomsHalf),
        quality: al((L = t.manufactured) == null ? void 0 : L.dwellingCostQuality),
        hasAC: (R = t.manufactured) == null ? void 0 : R.hasAC,
        hasClimatePkg: (k = t.manufactured) == null ? void 0 : k.hasClimatePkg,
        foundationType: (P = t.manufactured) == null ? void 0 : P.foundationType,
        fireplaces: gt.fromNumber((O = (N = t.manufactured) == null ? void 0 : N.fireplaces) == null ? void 0 : O.totalCount),
        fireplaceType: ($ = (H = t.manufactured) == null ? void 0 : H.fireplaces) == null ? void 0 : $.type,
        deliveryMileage: gt.fromNumber((ne = t.manufactured) == null ? void 0 : ne.deliveryMileage)
      },
      depreciation: {
        physicalDepreciation: ((ie = t.depreciation) == null ? void 0 : ie.physicalDepreciation) ?? {},
        functionalObsolescence: ((re = t.depreciation) == null ? void 0 : re.functionalObsolescence) ?? {},
        externalDepreciation: ((ve = t.depreciation) == null ? void 0 : ve.externalDepreciation) ?? {}
      },
      manualCost: {
        label: (ue = t.manualCost) == null ? void 0 : ue.label,
        feature: (j = t.manualCost) == null ? void 0 : j.feature,
        cost: (K = t.manualCost) == null ? void 0 : K.cost
      }
    };
  }
  updateEditableCostData(t) {
    var r, o, a, i, l, u, d, f, h, p, g, C, v, y, M, x, _, L, R, k, P, N, O, H, $, ne, ie, re, ve;
    const n = {
      ...this.costDataExtension,
      primaryDwelling: {
        quality: il(t.primaryDwelling.quality),
        nonStandardGla: t.primaryDwelling.nonStandardGLA,
        multiUnitCount: t.primaryDwelling.multiUnitCount
      },
      basement: {
        quality: il(t.basement.quality)
      },
      attic: {
        quality: il(t.attic.quality),
        totalSqft: t.attic.totalSqft
      },
      attachedOrBuiltinGarage: Qs(t.attachedOrBuiltinGarage),
      detachedGarage: Qs(t.detachedGarage),
      carport: Qs(t.carport),
      deck: Qs(t.deck),
      coveredPatioOrGazebo: Qs(t.coveredPatioOrGazebo),
      enclosedPatio: {
        ...Qs(t.enclosedPatio),
        linearFootage: _e.optional().parse((r = t.enclosedPatio.linearFootage) == null ? void 0 : r.toNumber())
      },
      pool: Qs(t.pool),
      adu: {
        bathroomsFull: _e.optional().parse((a = (o = t.adu) == null ? void 0 : o.bathroomsFull) == null ? void 0 : a.toNumber()),
        bathroomsHalf: _e.optional().parse((l = (i = t.adu) == null ? void 0 : i.bathroomsHalf) == null ? void 0 : l.toNumber()),
        stories: (u = t.adu) == null ? void 0 : u.stories,
        gla: (d = t.adu) == null ? void 0 : d.gla,
        dwellingCostQuality: il((f = t.adu) == null ? void 0 : f.quality)
      },
      shed: Df(t.shed),
      workshop: Df(t.workshop),
      bonusRoom: Df(t.bonusRoom),
      barn: {
        ...Df(t.barn),
        isPoleBarn: (h = t.barn) == null ? void 0 : h.isPoleBarn,
        hasExteriorWall: (p = t.barn) == null ? void 0 : p.hasExteriorWall
      },
      manufactured: {
        sections: (C = (g = t.manufactured) == null ? void 0 : g.sections) == null ? void 0 : C.toNumber(),
        gla: (v = t.manufactured) == null ? void 0 : v.gla,
        bathroomsFull: _e.optional().parse((M = (y = t.manufactured) == null ? void 0 : y.bathroomsFull) == null ? void 0 : M.toNumber()),
        bathroomsHalf: _e.optional().parse((_ = (x = t.manufactured) == null ? void 0 : x.bathroomsHalf) == null ? void 0 : _.toNumber()),
        dwellingCostQuality: il((L = t.manufactured) == null ? void 0 : L.quality),
        hasAC: (R = t.manufactured) == null ? void 0 : R.hasAC,
        hasClimatePkg: (k = t.manufactured) == null ? void 0 : k.hasClimatePkg,
        foundationType: PI.optional().parse((P = t.manufactured) == null ? void 0 : P.foundationType),
        fireplaces: $9.shape.fireplaces.parse({
          totalCount: _e.optional().parse((O = (N = t.manufactured) == null ? void 0 : N.fireplaces) == null ? void 0 : O.toNumber()),
          type: (H = t.manufactured) == null ? void 0 : H.fireplaceType
        }),
        deliveryMileage: _e.optional().parse((ne = ($ = t.manufactured) == null ? void 0 : $.deliveryMileage) == null ? void 0 : ne.toNumber())
      },
      depreciation: {
        physicalDepreciation: (ie = t.depreciation) == null ? void 0 : ie.physicalDepreciation,
        functionalObsolescence: (re = t.depreciation) == null ? void 0 : re.functionalObsolescence,
        externalDepreciation: (ve = t.depreciation) == null ? void 0 : ve.externalDepreciation
      }
    };
    return new On({
      salesCompGridData: this.salesCompGridData,
      costDataExtension: n,
      runCostExtension: this.runCostExtension,
      propertyType: this.propertyType
    });
  }
  getCostPerSqft(t) {
    var n, r;
    return (r = (n = this._getRunCostExtension()) == null ? void 0 : n.output[t]) == null ? void 0 : r.costPerSqft;
  }
  getDwellingCostQuality(t) {
    var n;
    return (n = this.getEditableCostData()[t]) == null ? void 0 : n.quality;
  }
  /** INTERNAL */
  _getRunCostExtension() {
    return this.runCostExtension;
  }
  /** INTERNAL */
  _updateRunCostExtension(t) {
    return new On({
      salesCompGridData: this.salesCompGridData,
      costDataExtension: this.costDataExtension,
      runCostExtension: t,
      propertyType: this.propertyType
    });
  }
  /** INTERNAL */
  _getCostDataExtension() {
    return this.costDataExtension;
  }
  getPropertyType() {
    return this.propertyType;
  }
  getReplacementCostFields() {
    return cce(this);
  }
  getCostDataInput(t) {
    var u, d, f;
    const n = this.getEditableCostData(), r = this.getStructuredData("bedroomCount"), o = this.getStructuredData("bathroomCount"), a = this.getStructuredData("basementLine2"), i = this.getStructuredData("carStorage"), l = this.getPropertyType();
    return {
      ...n,
      address: this.getGridField("PropertyStreetAddress") ?? "",
      effectiveDate: t,
      zip: this.getGridField("PropertyPostalCode") ?? "",
      primaryDwelling: l === "manufacturedHome" ? {} : {
        ...n.primaryDwelling,
        bedrooms: gt.fromNumber(r),
        bathroomsFull: gt.addWithNulls(
          gt.fromNumber(o == null ? void 0 : o.fullBaths),
          gt.fromNumber(a == null ? void 0 : a.fullBathCount)
        ) ?? void 0,
        bathroomsHalf: gt.addWithNulls(
          gt.fromNumber(o == null ? void 0 : o.halfBaths),
          gt.fromNumber(a == null ? void 0 : a.halfBathCount)
        ) ?? void 0,
        stories: (u = this.getStructuredData("designStyle")) == null ? void 0 : u.stories,
        gla: this.getStructuredData("gla")
      },
      manufactured: l === "manufacturedHome" ? {
        ...n.manufactured,
        bathroomsFull: gt.addWithNulls(
          gt.fromNumber(o == null ? void 0 : o.fullBaths),
          gt.fromNumber(a == null ? void 0 : a.fullBathCount)
        ) ?? void 0,
        bathroomsHalf: gt.addWithNulls(
          gt.fromNumber(o == null ? void 0 : o.halfBaths),
          gt.fromNumber(a == null ? void 0 : a.halfBathCount)
        ) ?? void 0
      } : n.manufactured,
      basement: {
        ...n.basement,
        totalSqft: (d = this.getStructuredData("basementLine1")) == null ? void 0 : d.total,
        finishedSqft: (f = this.getStructuredData("basementLine1")) == null ? void 0 : f.finished
      },
      attachedOrBuiltinGarage: {
        ...n.attachedOrBuiltinGarage,
        attachedSpaceCount: Pf(i == null ? void 0 : i.attachedGarageSpaces),
        builtinSpaceCount: Pf(i == null ? void 0 : i.builtInGarageSpaces)
      },
      detachedGarage: {
        ...n.detachedGarage,
        spaceCount: Pf(i == null ? void 0 : i.detachedGarageSpaces)
      },
      carport: {
        ...n.carport,
        spaceCount: Pf(i == null ? void 0 : i.carportSpaces)
      }
    };
  }
  isCostDataStale(t) {
    var o;
    const n = Db(this.getCostDataInput(t)), r = Db((o = this._getRunCostExtension()) == null ? void 0 : o.input);
    return r === void 0 || (0, wb.default)(n) !== (0, wb.default)(r);
  }
  getBathroomCosts() {
    var t;
    return (t = this.runCostExtension) == null ? void 0 : t.bathroomCosts;
  }
  getBathroomCounts() {
    const t = this.getStructuredData("bathroomCount"), n = this.getStructuredData("basementLine2");
    return {
      aboveGrade: {
        fullBaths: (t == null ? void 0 : t.fullBaths) ?? _e.parse(0),
        halfBaths: (t == null ? void 0 : t.halfBaths) ?? _e.parse(0)
      },
      belowGrade: {
        fullBaths: (n == null ? void 0 : n.fullBathCount) ?? _e.parse(0),
        halfBaths: (n == null ? void 0 : n.halfBathCount) ?? _e.parse(0)
      }
    };
  }
  getGarageStallCount() {
    const t = this.getStructuredData("carStorage");
    return (0, dl.isUndefined)(t) ? 0 : (t.attachedGarageSpaces ?? 0) + (t.builtInGarageSpaces ?? 0) + (t.detachedGarageSpaces ?? 0) + (t.carportSpaces ?? 0);
  }
}, qs(On, "LATEST_VERSION", 2), qs(On, "schema", Ac(
  nn([wce, Uh((t) => t instanceof On)]).transform(
    (t) => t instanceof On ? t : new On(pce(t))
  )
)), On);
function Db(e) {
  if ((0, dl.isUndefined)(e))
    return;
  const { depreciation: t, manualCost: n, ...r } = e;
  return r;
}
var _s = _ce.schema;
function Ks(e) {
  return e === void 0 ? {} : {
    quality: al(e.quality),
    totalSqft: e.totalSqft
  };
}
function Qs(e) {
  return {
    quality: il(e.quality),
    totalSqft: e.totalSqft
  };
}
function Rf(e) {
  return {
    totalSqft: e == null ? void 0 : e.totalSqft,
    percentInteriorFinished: e == null ? void 0 : e.percentInteriorFinished,
    electrical: e == null ? void 0 : e.electrical,
    subpanel: e == null ? void 0 : e.subpanel,
    plumbingFixturesCount: gt.fromNumber(e == null ? void 0 : e.plumbingFixturesCount),
    quality: al(e == null ? void 0 : e.dwellingCostQuality)
  };
}
function Df(e) {
  var t;
  return {
    totalSqft: e.totalSqft,
    percentInteriorFinished: e.percentInteriorFinished,
    electrical: e.electrical,
    subpanel: e.subpanel,
    plumbingFixturesCount: _e.optional().parse((t = e.plumbingFixturesCount) == null ? void 0 : t.toNumber()),
    dwellingCostQuality: il(e.quality)
  };
}
function al(e) {
  if (e !== void 0)
    return `${e}`;
}
function il(e) {
  if (e === void 0)
    return;
  const t = e.match(/^([.0-9]+)$/);
  if (t === null)
    throw new Bt(`cannot parse quality: ${e}`);
  return Ps.parse(parseFloat((0, dl.expected)(t[1])));
}
function Pf(e) {
  if (!(0, dl.isUndefined)(e))
    return gt.fromNumber(Math.floor(e));
}
function wu(e) {
  if (e == null)
    return;
  const t = _e.safeParse(e);
  if (t.success)
    return t.data;
  console.warn(`Expected integer but received: ${e}`);
}
function Xg(e) {
  try {
    return Gr.parse(e);
  } catch {
    return;
  }
}
var Pb = nn([
  w({
    status: fe("found"),
    output: hm
  }),
  w({
    status: fe("not_found"),
    output: w({
      searchCriteria: Sl.optional()
    }).optional()
  }),
  w({
    status: fe("error"),
    message: b(),
    output: w({
      searchCriteria: Sl.optional()
    }).optional()
  })
]), Ice = nn([
  w({
    status: fe("found"),
    output: w({
      results: se(B_),
      resultsCount: D(),
      searchCriteria: Sl.optional()
    })
  }),
  w({
    status: fe("not_found"),
    output: w({
      searchCriteria: Sl.optional()
    }).optional()
  }),
  w({
    status: fe("error"),
    message: b(),
    output: w({
      searchCriteria: Sl
    }).optional()
  })
]), Lce = nn([
  w({
    version: fe(2),
    source: fe("constellation1"),
    input: yl(),
    body: Pb
  }),
  w({
    version: fe(2),
    source: fe("z"),
    input: yl(),
    body: Ice
  }),
  w({
    version: fe(2),
    source: fe("abode"),
    input: yl(),
    body: Pb
  })
]), Rce = Lce, Dce = nn([
  w({
    status: fe("found"),
    output: hm
  }),
  w({
    status: fe("not_found")
  }),
  w({
    status: fe("error"),
    message: b()
  })
]), Pce = w({
  version: fe(1),
  source: X_,
  input: yl(),
  body: Dce
}), s2 = w({
  copyPrimaryDwellingQualityToOthers: J(),
  uadQualityMapping: w({
    q1: D(),
    q2: D(),
    q3: D(),
    q4: D(),
    q5: D(),
    q6: D()
  }),
  garageCarportAreaPerStall: Dt.schema
}), Ece = w({
  featureOneName: b().optional(),
  featureTwoName: b().optional(),
  featureThreeName: b().optional()
}), Tce = w({
  dismissedAlerts: se(P9)
}), Nce = w(
  Object.fromEntries(P9.options.map((e) => [e, b()]))
).partial(), kce = ["Zip Code", "City", "County"], Vce = Me(
  kce
), Oce = ["Shortage", "In Balance", "Over Supply"], Fce = Me(Oce), Bce = [
  "Less than 30 days",
  "30 - 60 days",
  "60 - 90 days",
  "90 - 120 days",
  "120 - 150 days",
  "150 - 180 days",
  "More than 180 days"
], Hce = Me(Bce), Gce = w({
  commentary: b().optional(),
  filter: w({
    type: Vce.default("Zip Code"),
    value: b().optional()
  }),
  estimatedDemandSupply: Fce.default("Shortage"),
  estimatedExposureTime: Hce.default("Less than 30 days")
  // data: z.object({}), // TODO: shape?
}), $ce = w({
  commentary: b()
}).partial(), Zce = w({
  commentary: b()
}).partial(), jce = w({
  glaCommentary: b(),
  bathCommentary: b(),
  basementCommentary: b(),
  qualityCommentary: b(),
  conditionCommentary: b(),
  garageCarportCommentary: b(),
  porchPatioDeckCommentary: b(),
  aduCommentary: b(),
  poolCommentary: b(),
  shedCommentary: b()
}).partial(), Wce = w({
  reconciliationCommentary: b(),
  highestAndBestUseCommentary: b(),
  certificationCommentary: b(),
  revisionCommentary: b(),
  alternativeComparablesCommentary: se(b()),
  roiCommentary: b(),
  feasibilityCommentary: b()
}).partial(), YI = w({
  alerts: Nce.optional(),
  depreciatedCost: jce,
  marketConditionsV2: Gce,
  priorSales: $ce,
  reconciliation: Wce,
  siteExtraction: Zce,
  /** @deprecated */
  isMarketConditionsCommentaryOmit: J(),
  /** @deprecated */
  marketConditions: b(),
  /** @deprecated */
  isSiteCommentaryOmit: J(),
  /** @deprecated */
  siteAdjustments: b(),
  /** @deprecated */
  isImprovementsCommentaryOmit: J(),
  /** @deprecated */
  improvementsAdjustments: b(),
  /** @deprecated */
  isGlaCommentaryOmit: J(),
  /** @deprecated */
  glaAdjustment: b(),
  /** @deprecated */
  isQualityCommentaryOmit: J(),
  /** @deprecated */
  qualityAdjustment: b(),
  /** @deprecated */
  isConditionCommentaryOmit: J(),
  /** @deprecated */
  conditionAdjustment: b(),
  /** @deprecated */
  isAtticCommentaryOmit: J(),
  /** @deprecated */
  atticAdjustment: b(),
  /** @deprecated */
  isBasementCommentaryOmit: J(),
  /** @deprecated */
  basementAdjustment: b(),
  /** @deprecated */
  isBelowGradeCommentaryOmit: J(),
  /** @deprecated */
  belowGradeAdjustment: b(),
  /** @deprecated */
  isParkingCommentaryOmit: J(),
  /** @deprecated */
  parkingAdjustment: b(),
  /** @deprecated */
  isPatioDeckCommentaryOmit: J(),
  /** @deprecated */
  patioDeckAdjustment: b(),
  /** @deprecated */
  isPoolCommentaryOmit: J(),
  /** @deprecated */
  poolAdjustment: b(),
  /** @deprecated */
  isGuestHouseCommentaryOmit: J(),
  /** @deprecated */
  guestHouseAdjustment: b(),
  /** @deprecated */
  isShedCommentaryOmit: J(),
  /** @deprecated */
  shedAdjustment: b(),
  /** @deprecated */
  isWorkshopCommentaryOmit: J(),
  /** @deprecated */
  workshopAdjustment: b(),
  /** @deprecated */
  isBonusRoomCommentaryOmit: J(),
  /** @deprecated */
  bonusRoomAdjustment: b(),
  /** @deprecated */
  isBarnCommentaryOmit: J(),
  /** @deprecated */
  barnAdjustment: b(),
  /** @deprecated */
  isManufacturedDwellingCommentaryOmit: J(),
  /** @deprecated */
  manufacturedDwellingAdjustment: b(),
  /** @deprecated */
  isManualCostCommentaryOmit: J(),
  /** @deprecated */
  manualCostAdjustment: b(),
  /** @deprecated */
  isCostApproachCommentaryOmit: J(),
  /** @deprecated */
  costApproach: b()
}).partial();
YI.pick({
  marketConditionsV2: !0,
  priorSales: !0,
  siteExtraction: !0,
  depreciatedCost: !0,
  reconciliation: !0,
  alerts: !0
});
var zce = w({
  sequence: se(b())
}), Uce = w({
  propertyID: b(),
  imageURLs: b().array(),
  result: q_
}), Z9 = Me([
  "zip",
  "state",
  "county",
  "city",
  "mls_source"
]), Xce = w({
  month: b(),
  geo_type: Z9,
  geo_id: b(),
  total_comparable_sales: D().nullable(),
  total_active_properties: D().nullable().optional(),
  absorption_rate: D().nullable(),
  months_supply: D().nullable(),
  median_days_on_market: D().nullable(),
  median_sale_price: Pe.nullable(),
  median_list_price: Pe.nullable().optional()
}), qI = w({
  geoType: Z9,
  geoId: b(),
  monthlyData: se(Xce)
}), JI = w({
  t: fe("percent"),
  value: D()
}), A3 = w({
  source: fe("customPrice"),
  adjustmentAmount: Pe
}), Yce = w({
  source: fe("customRate"),
  adjustmentAmount: Pe,
  adjustmentSource: JI
}), qce = w({
  source: fe("customListToSale"),
  adjustmentAmount: Pe,
  adjustmentPercent: JI
}), Jce = na("source", [
  A3,
  qce,
  Yce
]), Kce = $t({
  termsOfSale: A3,
  concessions: A3,
  dateOfSale: Jce
}).partial(), Qce = w({
  zip: b(),
  analysisPeriodMonths: nn([fe(6), fe(12), fe(24)]),
  trends: se(
    w({
      data: z_,
      timestamp: Bn
    })
  )
}), e1e = w({
  zip: b(),
  analysisPeriodMonths: nn([fe(6), fe(12), fe(24)]),
  trends: se(
    w({
      data: z_,
      timestamp: Bn
    })
  )
}), t1e = w({
  year: D(),
  month: D(),
  typicalHomeValue: Pe
}), n1e = w({
  analysisPeriodMonths: nn([fe(6), fe(12), fe(24)]),
  trends: se(t1e)
}), r1e = w({
  series: lle,
  using: Me(["p50closeprice", "p50closepricepersqft"])
  // subset of series.data keys
}), o1e = w({
  zillow: Qce,
  mlsData: e1e,
  marketTrends: r1e,
  customRate: w({
    rate: D()
  }),
  customAvgPricePerMonth: n1e
}).partial(), a1e = w({
  customRatio: w({
    ratio: D()
  })
}).partial(), i1e = w({
  dateOfSaleAdjustment: w({
    selectedMethod: Me([
      "zillow",
      "mlsData",
      "marketTrends",
      "customRate",
      "customAvgPricePerMonth"
    ]),
    methods: o1e
  }).partial(),
  listToSaleAdjustment: w({
    selectedMethod: Me(["customRatio"]),
    methods: a1e
  }).partial().optional(),
  marketAggregateData: se(qI).optional()
}), s1e = w({
  version: fe(1),
  // compID mapping to adjustment info
  comps: gn(Kce).optional(),
  cachedState: i1e
}), l1e = se(N9), u1e = gn(b(), l1e), c1e = w({
  version: fe(1),
  priorSales: u1e
}), d1e = Me(["as-is", "subject-to"]), f1e = w({
  includeTotalCostToCure: J().default(!0),
  totalCostToCure: qn.optional(),
  opinionOfMarketValue: qn.optional(),
  includeOpinionOfAfterRepairValue: J().default(!1),
  opinionOfAfterRepairValue: qn.optional(),
  totalRenovationBudget: qn.optional(),
  includeTotalRenovationBudget: J().default(!1),
  allowSubjectToValue: J().default(!0),
  valueTypes: se(d1e).default([])
}), h1e = w({
  id: b()
  // The S3 blob ID of the report PDF
}), m1e = w({
  signatureId: b(),
  // The S3 blob ID of the signature image
  stateSealId: b().optional()
  // The S3 blob ID of the state seal image, if applicable
}), p1e = w({
  id: b()
}), Dr = {
  // Keep this alphabetized
  additionalFeatures: Ece,
  alerts: Tce,
  commentary: YI,
  comp: _s,
  compData: cc,
  compRecommendation: Rce,
  compSequence: zce,
  depreciationSettings: a2,
  depreciationSettingsV2: r2,
  imageAnalysis: Uce,
  marketAdjustments: Ale,
  marketConditions: s1e,
  orderFeatures: Zue,
  pairedCostSettings: i2,
  priorSales: c1e,
  reconciliation: f1e,
  replacementCostSettings: s2,
  report: h1e,
  signature: m1e,
  subject: _s,
  subjectData: dc,
  vacantLandSales: Pce,
  xml: p1e
};
function g1e(e) {
  return e in Dr;
}
var v1e = w({
  id: b(),
  orderID: b(),
  type: b(),
  body: fn()
}).transform((e, t) => {
  if (!g1e(e.type))
    return t.addIssue({
      code: we.invalid_enum_value,
      message: "Invalid attachment type",
      fatal: !0,
      received: e.type,
      options: Object.keys(Dr)
    }), j2;
  const n = Dr[e.type].safeParse(e.body);
  return n.success ? {
    id: e.id,
    orderID: e.orderID,
    type: e.type,
    body: n.data
  } : (t.addIssue({
    code: we.invalid_union,
    message: `Invalid attachment body for ${e.type}`,
    fatal: !0,
    unionErrors: [n.error]
  }), j2);
}), Eb = {};
function Wn(e) {
  const t = Eb[e] ?? v1e.refine((n) => n.type === e, {
    message: `Attachment is not of type ${e}`
  });
  return Eb[e] = t, t;
}
w({
  content: q_
});
w({ orderID: Tn, propertyID: b() }), w({
  content: Wn("imageAnalysis")
});
var C1e = {};
Hd(C1e, {
  ADDITIONAL_FEATURES: () => V1e,
  ALERTS_API: () => F1e,
  COMMENTARY: () => H1e,
  COMPS: () => D1e,
  COMP_DATA: () => P1e,
  COMP_IMAGES: () => j1e,
  COMP_PROPERTY_DATA: () => E1e,
  COMP_RECOMMENDATION: () => Z1e,
  COMP_SEQUENCE: () => _1e,
  MARKET_ADJUSTMENTS: () => T1e,
  MARKET_CONDITIONS: () => N1e,
  ORDER_FEATURES_API: () => O1e,
  PRIOR_SALES: () => B1e,
  RECONCILIATION: () => G1e,
  REPORT: () => U1e,
  REPORT_SIGNATURE: () => z1e,
  SUBJECT: () => I1e,
  SUBJECT_DATA: () => L1e,
  SUBJECT_PROPERTY_DATA: () => R1e,
  VACANT_LAND_SALES: () => W1e,
  XML: () => k1e
});
ae(pe(), 1);
ae(pe(), 1);
ae(pe(), 1);
var Yg = w({
  label: b(),
  value: b()
}), KI = w({
  address: Gd,
  age: _e,
  gla: Aa,
  numberOfUnits: _e,
  fullBaths: _e,
  halfBaths: _e,
  basement: O9,
  garageSpaces: Gr,
  carportSpaces: Gr,
  status: ui.schUadListingStatus,
  foundation: hI,
  price: qn,
  saleDate: Zr,
  contractDate: Zr,
  daysOnMarket: D(),
  latitude: D(),
  longitude: D(),
  mls: Mc,
  mlsListingID: b(),
  siteArea: Aa,
  location: b(),
  view: b(),
  termsOfSale: _9,
  concessions: b(),
  quality: D(),
  condition: D(),
  propertyType: jd,
  porchPatioDeck: b(),
  additionalFeature1: Yg,
  additionalFeature2: Yg,
  additionalFeature3: Yg
}).partial(), pt = { orderID: Tn };
ae(pe(), 1);
var b1e = w({
  sequence: se(b()),
  comps: gn(_s)
}), y1e = w({
  comps: se(_s)
}), S1e = w({
  sequence: se(b()),
  comps: gn(_s)
}), A1e = w({
  id: b()
}), M1e = w({
  id: b()
}), Tb = w({
  sequence: se(b()),
  comps: gn(cc)
}), x1e = w({
  comps: se(cc)
}), w1e = Me([
  "additionalFeatures",
  "alerts",
  "commentary",
  "compRecommendation",
  "compSequence",
  "depreciationSettings",
  "depreciationSettingsV2",
  "marketAdjustments",
  "marketConditions",
  "orderFeatures",
  "pairedCostSettings",
  "priorSales",
  "reconciliation",
  "replacementCostSettings",
  "report",
  "signature",
  "subject",
  "subjectData",
  "vacantLandSales"
]);
w1e.options;
var _1e = {
  GET: {
    REQUEST: {
      PATH_PARAMS: w(pt)
    },
    RESPONSE: Wn("compSequence")
  },
  PUT: {
    REQUEST: {
      PATH_PARAMS: w(pt),
      BODY: Dr.compSequence
    },
    RESPONSE: Wn("compSequence")
  }
}, I1e = {
  GET: {
    REQUEST: {
      PATH_PARAMS: w(pt)
    },
    RESPONSE: Wn("subject")
  },
  PUT: {
    REQUEST: {
      PATH_PARAMS: w(pt),
      BODY: _s
    },
    RESPONSE: Wn("subject")
  }
}, L1e = {
  GET: {
    REQUEST: {
      PATH_PARAMS: w(pt)
    },
    RESPONSE: dc
  },
  PUT: {
    REQUEST: {
      PATH_PARAMS: w(pt),
      BODY: CI
    },
    RESPONSE: dc
  }
}, R1e = {
  PUT: {
    REQUEST: {
      PATH_PARAMS: w(pt),
      BODY: dc
    },
    RESPONSE: dc
  }
}, D1e = {
  GET: {
    REQUEST: {
      PATH_PARAMS: w(pt)
    },
    RESPONSE: b1e
  },
  POST: {
    REQUEST: {
      PATH_PARAMS: w(pt),
      BODY: y1e
    },
    RESPONSE: S1e
  },
  PUT: {
    REQUEST: {
      PATH_PARAMS: w({
        ...pt,
        compID: b()
      }),
      BODY: _s
    },
    RESPONSE: _s
  }
}, P1e = {
  GET: {
    REQUEST: {
      PATH_PARAMS: w(pt)
    },
    RESPONSE: Tb
  },
  POST: {
    REQUEST: {
      PATH_PARAMS: w(pt),
      BODY: x1e
    },
    RESPONSE: Tb
  }
}, E1e = {
  PUT: {
    REQUEST: {
      PATH_PARAMS: w({
        ...pt,
        compID: b()
      }),
      BODY: cc
    },
    RESPONSE: cc
  }
}, T1e = {
  GET: {
    REQUEST: {
      PATH_PARAMS: w(pt)
    },
    RESPONSE: Wn("marketAdjustments")
  },
  PUT: {
    REQUEST: {
      PATH_PARAMS: w(pt),
      BODY: Dr.marketAdjustments
    },
    RESPONSE: Wn("marketAdjustments")
  }
}, N1e = {
  GET: {
    REQUEST: {
      PATH_PARAMS: w(pt)
    },
    RESPONSE: Wn("marketConditions")
  },
  PUT: {
    REQUEST: {
      PATH_PARAMS: w(pt),
      BODY: Dr.marketConditions
    },
    RESPONSE: Wn("marketConditions")
  }
}, k1e = {
  POST: {
    REQUEST: {
      PATH_PARAMS: w(pt),
      BODY: A1e
    },
    RESPONSE: M1e
  }
}, V1e = {
  GET: {
    REQUEST: {
      PATH_PARAMS: w(pt)
    },
    RESPONSE: Wn("additionalFeatures")
  },
  PUT: {
    REQUEST: {
      PATH_PARAMS: w(pt),
      BODY: Dr.additionalFeatures
    },
    RESPONSE: Wn("additionalFeatures")
  }
}, O1e = {
  GET: {
    REQUEST: {
      PATH_PARAMS: w(pt)
    },
    RESPONSE: Wn("orderFeatures")
  },
  PUT: {
    REQUEST: {
      PATH_PARAMS: w(pt),
      BODY: Dr.orderFeatures
    },
    RESPONSE: Wn("orderFeatures")
  }
}, F1e = {
  GET: {
    REQUEST: {
      PATH_PARAMS: w(pt)
    },
    RESPONSE: Wn("alerts")
  },
  PUT: {
    REQUEST: {
      PATH_PARAMS: w(pt),
      BODY: Dr.alerts
    },
    RESPONSE: Wn("alerts")
  }
}, B1e = {
  GET: {
    REQUEST: {
      PATH_PARAMS: w(pt)
    },
    RESPONSE: Wn("priorSales")
  },
  PUT: {
    REQUEST: {
      PATH_PARAMS: w(pt),
      BODY: Dr.priorSales
    },
    RESPONSE: Wn("priorSales")
  }
}, H1e = {
  GET: {
    REQUEST: {
      PATH_PARAMS: w(pt)
    },
    RESPONSE: Wn("commentary")
  },
  PUT: {
    REQUEST: {
      PATH_PARAMS: w(pt),
      BODY: Dr.commentary
    },
    RESPONSE: Wn("commentary")
  }
}, G1e = {
  GET: {
    REQUEST: {
      PATH_PARAMS: w(pt)
    },
    RESPONSE: Wn("reconciliation")
  },
  PUT: {
    REQUEST: {
      PATH_PARAMS: w(pt),
      BODY: Dr.reconciliation
    },
    RESPONSE: Wn("reconciliation")
  }
}, $1e = w({
  body: Dr.compRecommendation
}), Z1e = {
  GET: {
    REQUEST: {
      PATH_PARAMS: w(pt)
    },
    RESPONSE: w({
      body: Dr.compRecommendation
    })
  },
  POST: {
    REQUEST: {
      PATH_PARAMS: w(pt),
      QUERY_PARAMS: w({ source: Me(["constellation1", "z"]) }),
      BODY: Sl
    },
    RESPONSE: $1e
  }
}, j1e = {
  GET: {
    REQUEST: {
      PATH_PARAMS: w({ id: b() })
    },
    RESPONSE: w({ id: b(), images: se(b()) })
  }
}, W1e = {
  GET: {
    REQUEST: {
      PATH_PARAMS: w(pt)
    },
    RESPONSE: w({ body: Dr.vacantLandSales })
  },
  POST: {
    REQUEST: {
      PATH_PARAMS: w(pt)
    },
    RESPONSE: w({ body: Dr.vacantLandSales })
  }
}, z1e = {
  POST: {
    REQUEST: {
      PATH_PARAMS: w(pt),
      BODY: w({
        signatureBlobId: b(),
        stateSealBlobId: b().optional(),
        storeSignatureBlobId: J().optional().default(!1)
      })
    }
  }
}, U1e = {
  GET: {
    REQUEST: {
      PATH_PARAMS: w(pt)
    },
    RESPONSE: w({
      body: Wn("report")
    })
  },
  POST: {
    REQUEST: {
      PATH_PARAMS: w(pt),
      BODY: w({
        reportBlobId: b()
      })
    }
  }
}, X1e = {};
Hd(X1e, {
  COORDINATES_FOR_ADDRESSES: () => Y1e
});
var Y1e = {
  GET: {
    REQUEST: {
      QUERY_PARAMS: w({
        addresses: se(b())
      })
    },
    RESPONSE: se(
      w({ address: b(), lat: D().optional(), lng: D().optional() })
    )
  }
}, q1e = b(), J1e = w({
  listings: se(N9),
  source: Q_
});
$l.extend({
  lookbackCutoff: q1e.optional()
});
var K1e = b(), Q1e = gn(K1e, D()), ede = gn(b(), D()), j9 = w({
  variable: se(D())
}), tde = w({
  fixed: se(D())
}), Ei = i_(j9, tde), nde = w({
  sixCorners: Ei
}), rde = w({
  twoOrThreeUnits: Ei,
  fourToNineUnits: Ei
}), ode = Ei, ade = w({
  fullBaths: se(D()),
  halfBaths: se(D())
}), ide = w({
  totalArea: w({
    variable: se(D())
  }),
  finishedArea: w({
    variable: se(D())
  })
}), sde = w({
  detached: Ei,
  attached: Ei
}), lde = j9, ude = w({
  fixed: se(D()),
  variable240To480: se(D()),
  variableOver480: se(D())
}), cde = w({
  fixed: se(D()),
  variableOver70: se(D())
}), dde = Ei, fde = Ei, hde = Ei, mde = j9, pde = w({
  uncovered: w({
    variable: se(D())
  }),
  covered: w({
    variable: se(D())
  }),
  screen: w({
    variable: se(D())
  })
}), gde = w({
  uncovered: w({
    variable: se(D())
  }),
  covered: w({
    variable: se(D())
  }),
  screen: w({
    variable: se(D())
  })
}), vde = w({
  uncovered: w({
    variable: se(D())
  }),
  covered: w({
    variable: se(D())
  }),
  screen: w({
    variable: se(D())
  })
}), Cde = w({
  freestanding: D(),
  zeroClearance: D(),
  masonry: D()
}), bde = w({
  fullBaths: se(D()),
  halfBaths: se(D())
}), yde = w({
  slab: w({
    variable: D()
  })
}), Sde = w({
  singleFamily: nde,
  multiFamily: rde,
  manufactured: ode,
  bathrooms: ade,
  basement: ide,
  attic: mde,
  garage: sde,
  carport: lde,
  heating: D(),
  heatingAndCooling: D(),
  pool: ude,
  spa: cde,
  shed: dde,
  workshop: fde,
  barn: hde,
  porch: pde,
  patio: gde,
  deck: vde,
  fireplace: Cde,
  manufacturedBaths: bde,
  foundation: yde
}), QI = Me(["2024.1", "2025.1", "2026.1"]);
w({
  version: QI,
  zipMultiplier: Q1e,
  costData: Sde,
  historicalIndex: ede
});
ae(pe(), 1);
ae(pe(), 1);
ae(pe(), 1);
ae(pe(), 1);
var Ade = fe("1.0");
ae(pe(), 1);
ae(pe(), 1);
ae(pe(), 1);
ae(pe(), 1);
Dt.fromNumber(400, "sqft");
Dt.fromNumber(400, "sqft");
Dt.fromNumber(100, "sqft");
Dt.fromNumber(64, "sqft");
var Mde = fe("1.0");
sI.multipleOf(0.1);
iI.multipleOf(0.1);
var xde = nn([fe(1), fe(2)]), eL = w({
  hasInspection: J().optional(),
  reportId: b().nullable().optional()
}), tL = Me(["rov", "revision"]), Nb = w({
  originalOrderId: b(),
  comparables: se(
    w({
      address: b(),
      dataSource: b(),
      dateOfSale: b(),
      justification: b()
    })
  ).optional().nullable(),
  requesterName: b(),
  requesterEmail: b(),
  requesterPhone: b(),
  requestDescription: b(),
  revisionType: tL,
  requestedAt: Bn,
  revisionRequestId: b(),
  inspectionId: b()
}), nL = w({
  costToCure: J().optional(),
  arv: J().optional(),
  allowSubjectToValue: J().optional()
}), W9 = w({
  address: M9.optional(),
  // deprecated
  effectiveDate: nr,
  orderNumber: b().optional(),
  propertyType: Cr,
  // deprecated
  isCraftsman: J().optional(),
  // deprecated
  version: xde.default(1),
  craftsmanAdjustmentVersion: Ade.default("1.0"),
  craftsmanCalculatorVersion: Mde.default("1.0"),
  craftsmanDatasetVersion: QI.default("2024.1"),
  costMultiplier: D().optional(),
  licenseState: b().optional(),
  licenseNumber: b().optional(),
  licenseExpiration: nr.optional(),
  licenseType: b().optional(),
  inspectionData: eL.optional(),
  revisionData: Nb.optional(),
  previousRevisionsData: se(Nb).optional(),
  revisionRequestId: b().optional(),
  inspectionId: b().optional(),
  options: nL.optional(),
  appraisifyName: b().optional(),
  appraisifyAddress: b().optional(),
  isMock: J().optional()
}), wde = Me(["listingID", "publicRecord", "none"]), _de = W9.extend({
  // Autofill fields: publicRecord/none requires nothing besides this autofillType
  autofillType: wde.optional(),
  // MLS autofill fields
  mls: Mc.optional(),
  listingID: b().optional(),
  supplementWithPublicRecord: J().optional(),
  address: M9,
  appraisalType: b().optional(),
  clientName: b().optional(),
  dueDate: nr.optional(),
  inspectionDate: nr.optional(),
  appraiserInstructions: b().optional(),
  intendedUsers: b().optional(),
  intendedUse: b().optional(),
  inspectorType: b().optional(),
  borrowerName: b().optional(),
  inspectifyOrder: J().optional(),
  mock: J().optional()
}), Nl = w({
  id: Tn,
  subjectAddress: Gd.optional(),
  // deprecated
  ownerID: Sc.optional(),
  createdAt: Bn.optional(),
  modifiedAt: Bn.optional(),
  isArchived: J().optional(),
  isDeleted: J().optional(),
  isMock: J().optional(),
  isTraining: J().optional(),
  isCompleted: J().optional(),
  requiresPrefill: J().optional(),
  isInspectifyOrder: J().optional(),
  input: W9,
  appraisalType: b().optional(),
  clientName: b().optional(),
  appraiserFee: Pe.optional(),
  dueDate: nr.optional(),
  inspectionDate: nr.optional(),
  appraiserInstructions: b().optional(),
  intendedUsers: b().optional(),
  intendedUse: b().optional(),
  inspectorType: b().optional(),
  borrowerName: b().optional(),
  signedAt: Bn.optional(),
  appraisifyFee: Pe.optional(),
  isRevision: J().optional(),
  originalOrderId: b().nullable().optional()
}), Ide = Nl.extend({
  warnings: se(b()).optional()
});
se(b());
var Lde = w({
  results: se(Nl),
  pagination: c_
}), Rde = w({
  input: _de,
  subject: KI.optional()
}), Dde = w({
  originalOrderId: b(),
  comparables: se(
    w({
      address: b(),
      dataSource: b(),
      dateOfSale: b(),
      justification: b()
    })
  ).optional().nullable(),
  requesterName: b(),
  requesterEmail: b(),
  requesterPhone: b(),
  requestDescription: b(),
  revisionType: tL,
  requestedAt: b(),
  revisionRequestId: b()
});
w({
  revisionData: Dde,
  appraiserFee: b().nullable(),
  appraisifyFee: b().nullable(),
  dueDate: b(),
  inspectionId: b()
});
w({
  address: M9,
  effectiveDate: b(),
  orderNumber: b(),
  propertyType: Me([
    Cr.Values.singleFamilyResidence,
    Cr.Values.multiFamily,
    Cr.Values.manufacturedHome
  ]),
  appraisalType: b(),
  clientName: b().nullable(),
  appraiserFee: b().nullable(),
  appraisifyFee: b().nullable(),
  dueDate: b(),
  inspectionDate: b().nullable(),
  appraiserInstructions: b().nullable(),
  intendedUsers: b().nullable(),
  intendedUse: b().nullable(),
  inspectorType: b(),
  borrowerName: b().nullable(),
  licenseState: b(),
  licenseNumber: b(),
  licenseExpiration: b(),
  licenseType: b(),
  inspectionData: eL,
  inspectionId: b().optional(),
  options: nL.optional(),
  appraisifyAddress: b().optional(),
  appraisifyName: b().optional(),
  mock: J().optional()
});
var Pde = w({
  dueDate: b()
}), Ede = w({
  input: W9,
  isArchived: J().optional(),
  isDeleted: J().optional(),
  isTraining: J().optional(),
  requiresPrefill: J().optional(),
  intendedUsers: b().optional(),
  intendedUse: b().optional()
}), Tde = Me(["1571BradfordTrace", "2665Dearborn", "6106Lakeshore"]);
w({
  trainingAddress: Tde
});
w({
  archived: J().default(!1)
});
w({
  orderID: Tn
});
w({
  limit: D().optional(),
  next: b().optional()
});
w({
  orderID: Tn
}), w({ orderID: Tn });
w({
  orderID: Tn
});
w({
  orderID: Tn
}), b();
w({ orderID: Tn });
w({ orderID: Tn });
var Cm = { saveAsDefault: b().optional() };
w(pt), w({ changed: D() });
w(pt), w(pt), w(Cm);
w(pt), w(pt), w(Cm);
w(pt), w(pt), w(Cm);
w(pt), w(pt), w(Cm);
var rL = w({
  ParcelNumberRaw: b().nullable(),
  PropertyAddressFull: b().nullable(),
  PropertyAddressCity: b().nullable(),
  PropertyAddressState: b().nullable(),
  PropertyAddressZIP: b().nullable(),
  SitusCounty: b().nullable(),
  NeighborhoodCode: b().nullable(),
  MinorCivilDivisionName: b().nullable(),
  LegalDescription: b().nullable(),
  PropertyUseGroup: b().nullable(),
  YearBuilt: D().nullable(),
  EffectiveYearBuilt: D().nullable(),
  PartyOwner1NameFull: b().nullable(),
  AssessorLastSaleAmount: Pe.nullable(),
  AssessorPriorSaleDate: nr.nullable(),
  AreaBuilding: wt.nullable(),
  AreaGross: wt.nullable(),
  AreaLotSF: wt.nullable(),
  RoomsAtticFlag: J().nullable(),
  RoomsAtticArea: wt.nullable(),
  RoomsBasementArea: wt.nullable(),
  RoomsBasementAreaFinished: wt.nullable(),
  ParkingSpaceCount: D().nullable(),
  DrivewayArea: wt.nullable(),
  PorchArea: wt.nullable(),
  PatioArea: wt.nullable(),
  DeckArea: wt.nullable(),
  PoolArea: wt.nullable(),
  BuildingsCount: D().nullable(),
  PartyOwner2NameFull: b().nullable(),
  PartyOwner3NameFull: b().nullable(),
  PartyOwner4NameFull: b().nullable(),
  ContactOwnerMailAddressFull: b().nullable(),
  ContactOwnerMailAddressCity: b().nullable(),
  ContactOwnerMailAddressState: b().nullable(),
  ContactOwnerMailAddressZIP: b().nullable(),
  CompanyFlag: J().nullable(),
  TaxYearAssessed: D().nullable(),
  TaxAssessedValueImprovements: Pe.nullable(),
  TaxAssessedValueLand: Pe.nullable(),
  TaxAssessedValueTotal: Pe.nullable(),
  TaxMarketValueYear: D().nullable(),
  TaxMarketValueImprovements: Pe.nullable(),
  TaxMarketValueLand: Pe.nullable(),
  TaxMarketValueTotal: Pe.nullable(),
  TaxFiscalYear: D().nullable(),
  TaxRateArea: b().nullable(),
  TaxBilledAmount: Pe.nullable(),
  AssessorLastSaleDate: nr.nullable(),
  LastOwnershipTransferDocumentNumber: b().nullable(),
  AssessorPriorSaleAmount: Pe.nullable(),
  RoomsCount: D().nullable(),
  BathCount: D().nullable(),
  BathPartialCount: D().nullable(),
  BedroomsCount: D().nullable(),
  StoriesCount: D().nullable(),
  UnitsCount: D().nullable(),
  StructureStyle: b().nullable(),
  Exterior1Code: b().nullable(),
  RoofMaterial: b().nullable(),
  ViewDescription: b().nullable(),
  ParkingGarage: b().nullable(),
  ParkingGarageArea: wt.nullable(),
  ParkingCarport: J().nullable(),
  ParkingCarportArea: wt.nullable(),
  HVACCoolingDetail: b().nullable(),
  HVACHeatingDetail: b().nullable(),
  HVACHeatingFuel: b().nullable(),
  UtilitiesSewageUsage: b().nullable(),
  UtilitiesWaterSource: b().nullable(),
  Construction: b().nullable(),
  Foundation: b().nullable(),
  PlumbingFixturesCount: D().nullable(),
  FlooringMaterialPrimary: b().nullable(),
  GuestHouseArea: wt.nullable(),
  ShedArea: wt.nullable(),
  Zoning: b().nullable()
});
w(pt), w({
  listing: rL,
  source: k9
});
w(pt), w({
  addresses: b()
}), se(
  w({
    listing: rL,
    source: k9,
    address: $l
  })
);
var Nde = w({
  // Not included in DwellingCost response. Manually entered by appraiser.
  additionalFeaturesCost: Pe.optional(),
  // Only set for the subject. Site cost is derived for comps.
  siteCost: Pe.optional(),
  runCost: w({
    input: Ic,
    output: gm
  }).optional()
}), oL = gn(b(), Nde);
w({
  results: oL.optional(),
  // indicates that the run cost data is stale
  isRunCostStale: J().optional()
});
var kde = w({
  dateOfSaleAndListToSale: Pe,
  financialConcessions: Pe,
  saleType: Pe
});
w({
  results: gn(b(), kde)
});
var Vde = w({
  results: oL
}), Ode = w({
  type: fe("pairedCost"),
  input: w({}),
  scratch: Vde.nullable(),
  output: w({}).nullable()
}), Fde = w({
  t: fe("custom"),
  name: b()
}), aL = xc.or(
  Fde
), Bde = nn([xc, fe("custom")]), bm = aoe([D(), D()]);
se(bm);
var iL = w({
  coords: bm,
  propertyType: b(),
  propertySubType: b(),
  marketingCommentary: b(),
  address: b(),
  zipCode: b(),
  view: b(),
  designStyle: b(),
  heatingCooling: b(),
  hasBasement: J(),
  hasAttachment: J(),
  bedrooms: D(),
  bathrooms: D(),
  halfBathrooms: D(),
  threeQuarterBathrooms: D(),
  totalBathrooms: D(),
  stories: D(),
  attachedGarageParkingSpacesCount: D(),
  glaSqFt: D(),
  basementSqFt: D(),
  siteSizeSqFt: D(),
  yearBuilt: D(),
  contractDate: D(),
  saleDate: D(),
  salePrice: D(),
  partitionKey: b()
}).partial(), Hde = na("t", [
  w({ t: fe("any"), value: ub().optional() }),
  w({ t: fe("equal"), value: ub().optional() }),
  w({ t: fe("less"), value: O1 }),
  w({ t: fe("greater"), value: O1 }),
  w({ t: fe("withinUnit"), value: O1 }),
  w({ t: fe("withinPercent"), value: O1 })
]), Gde = gn(iL.keyof(), Hde), kb = w({
  t: Me(["any", "includeKeyword", "omitKeyword", "address", "equal"]),
  key: iL.keyof().optional(),
  value: nn([b(), D()]).optional()
}), $de = w({
  p1: kb,
  p2: kb
}), Zde = w({
  version: fe(1),
  matchCriteria: Gde,
  differenceCriteria: $de
}), jde = w({
  t: fe("radius"),
  coord: bm,
  radiusInMeters: D()
}), Wde = w({
  t: fe("polygon"),
  coords: se(bm)
}), zde = na("t", [jde, Wde]), sL = w({
  filters: fm,
  pairCriteria: Zde,
  geoSearch: zde
}), lL = nn([Pe, D()]), Ude = w({
  p1: U2,
  p2: U2,
  adjustments: gn(Bde, Pe),
  additionalFeature1Title: b().optional(),
  additionalFeature2Title: b().optional(),
  additionalFeature3Title: b().optional()
}), uL = se(Ude), Xde = w({
  search: sL,
  notes: b(),
  reconciledValue: lL,
  selectedPairs: uL
}), Yde = w({
  version: fe(1),
  id: za,
  createdBy: Sc,
  createdAt: Bn,
  modifiedAt: Bn,
  analysisFeature: aL,
  // TODO: Check if this is the correct set
  propertyType: Cr,
  mlsID: b(),
  body: Xde
  // Add isArchived?
});
Yde.omit({
  id: !0,
  createdAt: !0,
  modifiedAt: !0
});
var qde = w({
  analysisFeature: aL,
  propertyType: Cr,
  mlsID: b()
}), cL = w({
  search: sL,
  notes: b(),
  reconciledValue: lL,
  selectedPairs: uL
});
w({});
var Jde = w({
  body: cL.optional(),
  addToExport: J().optional(),
  isDeleted: J().optional()
}), ah = w({
  id: za,
  ownerID: Sc,
  createdAt: Bn,
  modifiedAt: Bn,
  input: qde,
  body: cL,
  // TODO: Make this optional when we support in-progress paired Sales
  isExported: J()
});
ah.pick({
  input: !0,
  body: !0
});
w({
  results: se(ah).optional(),
  _pagination: c_.optional()
});
w({
  limit: D().optional(),
  next: b().optional(),
  orderID: Tn.optional()
});
w({
  orderID: Tn.optional()
});
w({
  studyID: za
}), w({
  orderID: Tn.optional()
}), w({
  studyID: za
}), w({
  orderID: Tn.optional()
});
var z9 = fn(), dL = fn(), fL = fn(), hL = Me(["pairedCost", "pairedSales"]), Kde = fn(), mL = w({
  orderID: Tn,
  studyID: za,
  isActive: J(),
  body: Kde
});
mL.pick({
  orderID: !0,
  studyID: !0
});
mL.pick({
  orderID: !0
});
var l2 = w({
  id: za,
  ownerID: Sc,
  createdAt: Bn,
  modifiedAt: Bn,
  type: hL,
  input: z9,
  scratch: dL.optional(),
  output: fL.optional()
}), Qde = w({
  type: fe("pairedSales"),
  input: fn(),
  scratch: fn(),
  output: fn()
});
na("type", [
  Ode,
  Qde
]);
var e0e = w({
  results: se(l2)
});
w({
  orderID: Tn,
  studyID: za
});
var t0e = w({
  input: z9.optional(),
  type: hL
}), n0e = w({
  id: za,
  ownerID: Sc,
  input: z9.optional(),
  scratch: dL.optional(),
  output: fL.optional()
});
w({
  orderID: Tn
});
w({
  orderID: Tn,
  studyID: za
}), nn([l2, w({ message: b() })]), w({
  orderID: Tn
}), nn([l2, w({ message: b() })]), w({
  orderID: Tn,
  studyID: za
}), nn([l2, w({ message: b() })]);
var r0e = Me(["subject"]), o0e = w({
  id: b(),
  studyID: b(),
  type: r0e
}), a0e = w({
  type: fe("subject"),
  body: fn()
});
i_(
  o0e,
  a0e
);
w({
  address: $l,
  effectiveYear: D(),
  xmlProperty: KI.optional(),
  propertyType: jd.optional(),
  orderID: b()
});
w({
  status: fe("success"),
  result: cc
});
w({
  ...pt,
  propertyId: b()
}), w({
  sources: se(nI).optional(),
  includeBackupListingData: J().optional().default(!0)
}), dc.or(bue).optional();
var pL = w({
  reportPDF: ms,
  loePDF: ms.optional(),
  purchaseContractPDF: ms.optional(),
  orderDetailsPDF: ms.optional()
});
pL.keyof();
var gL = w({
  id: b(),
  orderID: Tn,
  status: Me(["in-progress", "error", "success"]),
  results: se(b()).nullable(),
  files: pL,
  createdAt: ioe.date()
}), i0e = w({ status: fe("idle") }), s0e = gL.or(i0e);
w({ orderID: Tn }), w({ orderID: Tn }), w({
  files: w({
    reportPDF: ms,
    loePDF: ms.optional(),
    purchaseContractPDF: ms.optional(),
    orderDetailsPDF: ms.optional()
  })
});
w({
  limit: D().optional(),
  offset: D().optional(),
  email: b().optional(),
  name: b().optional()
}), w({
  results: se(j_),
  resultsCount: D(),
  totalResultsCount: D()
});
w({
  orderID: Tn
}), w({
  geoType: Z9,
  geoId: b()
});
ae(pe(), 1);
wle.toJSON();
ae(pe(), 1);
_le.toJSON();
Ile.toJSON();
ae(pe(), 1);
ae(pe(), 1);
ae(pe(), 1);
_e.parse(20);
ae(pe(), 1);
ae(pe(), 1);
ae(pe(), 1);
ae(pe(), 1);
_e.optional();
Dle.toJSON();
ae(pe(), 1);
Ple.toJSON();
ae(pe(), 1);
Ele.toJSON();
ae(pe(), 1);
ae(pe(), 1);
Tle.toJSON();
ae(pe(), 1);
ae(pe(), 1);
ae(pe(), 1);
ae(pe(), 1);
ae(pe(), 1);
rr.today();
ae(pe(), 1);
ae(pe(), 1);
w({ orderID: b() });
w({ orderID: b(), propertyAttachmentID: b() }), w({ orderID: b(), propertyAttachmentID: b() }), w({}), w({ orderID: b(), propertyAttachmentID: b() });
Me([
  ..._c.exclude(["primaryDwelling"]).options,
  ...Me(["mainDwelling", "belowGradeANSI", "manual"]).options
]);
ae(pe(), 1);
ae(pe(), 1);
ae(pe(), 1);
ae(pe(), 1);
Yt.fromDollarLike(1e3), Yt.fromDollarLike(1e3);
ae(pe(), 1);
ae(Doe(), 1);
ae(pe(), 1);
ae(pe(), 1);
ae(pe(), 1);
ae(pe(), 1);
ae(pe(), 1);
ae(pe(), 1);
ae(pe(), 1);
ae(pe(), 1);
ae(pe(), 1);
ae(pe(), 1);
ae(pe(), 1);
ae(pe(), 1);
ae(pe(), 1);
ae(pe(), 1);
ae(pe(), 1);
ae(pe(), 1);
ae(pe(), 1);
ae(pe(), 1);
ae(pe(), 1);
ae(pe(), 1);
ae(pe(), 1);
ae(pe(), 1);
ae(pe(), 1);
(0, A9.AloftEnum)()({
  shouldAllowTrialWithoutPayment(e) {
    return e.isEnabled("TRIAL_WITHOUT_PAYMENT");
  },
  shouldShowOffshoreQCBeta(e) {
    return e.isEnabled("OFFSHORE_QC_BETA");
  },
  shouldShowRecommendedCompsFiltering(e) {
    return e.isEnabled("RECOMMENDED_COMPS_FILTERING");
  },
  shouldShowFeatureGrid(e) {
    return e.isEnabled("SHOW_SALES_COMPARISON_GRID");
  },
  shouldShowAdjustmentsGrid(e) {
    return e.isEnabled("SHOW_ADJUSTMENTS_GRID");
  },
  shouldShowOrderDetails(e) {
    return e.isEnabled("SHOW_ORDER_DETAILS");
  },
  shouldShowCommentaryBeta(e) {
    return e.isEnabled("SHOW_COMMENTARY_BETA");
  },
  shouldShowSiteValueAdjuster(e) {
    return e.isEnabled("SHOW_SITE_VALUE_ADJUSTER");
  },
  shouldShowCreateInspectifyOrderModal(e) {
    return e.isEnabled("CREATE_INSPECTIFY_ORDER_MODAL");
  }
});
var l0e = [
  "0",
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "A",
  "B",
  "C",
  "D",
  "E",
  "F"
], u0e = [
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z"
], c0e = (e = 8) => `${new Array(2).fill(0).map(() => u0e[Math.floor(Math.random() * 26)]).join("")}-${new Array(e).fill(0).map(() => l0e[Math.floor(Math.random() * 16)]).join("")}`;
ae(pe(), 1);
var d0e = ae(pe(), 1);
(0, d0e.makeLookup)({
  cases: [
    ["reportPDF", "Report PDF"],
    ["orderDetailsPDF", "Order Details PDF"],
    ["loePDF", "Letter of Engagement PDF"],
    ["purchaseContractPDF", "Purchase Contract PDF"]
  ]
});
ae(pe(), 1);
ae(pe(), 1);
Dt.fromNumber(220, "sqft");
A9.AloftEnum;
A9.AloftEnumKeys;
Sr.applyIfNonEmptyString;
Sr.checkLength;
Sr.checkMinLength;
Sr.clamp;
Sr.enumerate;
Sr.expected;
Sr.hasDefinedValues;
Oi.isArray;
Oi.isBoolean;
var Mt = Sr.isDefined;
Oi.isFunction;
Sr.isNonEmptyString;
Oi.isNull;
Oi.isNumber;
Oi.isObject;
var f0e = Oi.isString;
Oi.isSymbol;
var Mo = Oi.isUndefined;
Sr.linJitter;
Sr.makeLookup;
Sr.noop;
Sr.orUndefined;
Sr.populated;
Sr.toPunctuatedPhoneFormat;
Sr.toTitleCase;
var h0e = Sr.unreachable;
const m0e = (e, t) => {
  const n = Ve(null);
  return st(() => {
    const r = (o) => {
      n != null && n.current && o.target && !n.current.contains(o.target) && (t == null || t(), n.current.blur());
    };
    return document.addEventListener("mouseup", r), () => {
      document.removeEventListener("mouseup", r);
    };
  }, [n.current]), Q(
    (r) => {
      typeof e == "function" ? e(r) : e !== null && (e.current = r), n.current = r;
    },
    [n, e]
  );
}, p0e = (e) => {
  if (Mo(e.paddingX) && Mo(e.paddingY) && Mo(e.paddingX) && Mo(e.paddingY))
    return e;
  const t = { ...e };
  return Mt(t.paddingX) && (t.paddingLeft = t.paddingLeft ?? t.paddingX, t.paddingRight = t.paddingRight ?? t.paddingX), Mt(t.paddingY) && (t.paddingTop = t.paddingTop ?? t.paddingY, t.paddingBottom = t.paddingBottom ?? t.paddingY), Mt(t.marginX) && (t.marginLeft = t.marginLeft ?? t.marginX, t.marginRight = t.marginRight ?? t.marginX), Mt(t.marginY) && (t.marginTop = t.marginTop ?? t.marginY, t.marginBottom = t.marginBottom ?? t.marginY), t;
}, g0e = 4, vL = (e) => `${e * g0e}px`, v0e = {
  borderRadius: !0,
  borderTopRadius: !0,
  borderBottomRadius: !0,
  borderLeftRadius: !0,
  borderRightRadius: !0,
  borderTopLeftRadius: !0,
  borderTopRightRadius: !0,
  borderBottomLeftRadius: !0,
  borderBottomRightRadius: !0,
  borderWidth: !0,
  borderTopWidth: !0,
  borderBottomWidth: !0,
  borderLeftWidth: !0,
  borderRightWidth: !0,
  bottom: !0,
  columnGap: !0,
  gap: !0,
  height: !0,
  left: !0,
  margin: !0,
  marginTop: !0,
  marginBottom: !0,
  marginLeft: !0,
  marginRight: !0,
  maxWidth: !0,
  maxHeight: !0,
  minHeight: !0,
  minWidth: !0,
  padding: !0,
  paddingY: !0,
  paddingX: !0,
  paddingTop: !0,
  paddingBottom: !0,
  paddingLeft: !0,
  paddingRight: !0,
  right: !0,
  rowGap: !0,
  top: !0,
  width: !0
}, C0e = (e) => Object.entries(e).reduce((t, [n, r]) => (v0e.hasOwnProperty(n) && typeof r == "number" ? t[n] = vL(r) : t[n] = r, t), {}), ds = (e) => Hr[e], b0e = (e) => {
  const [t, n, r] = Mt(e.border) ? e.border.split(" ") : [], o = parseInt(t, 10), a = Number.isNaN(parseInt(t, 10)) || o.toString() !== t ? t : vL(o), i = ds(r || "none"), l = Mt(r) ? i : void 0;
  if (Mo(e.border) && Mo(e.borderColor) && Mo(e.borderTopColor) && Mo(e.borderBottomColor) && Mo(e.borderLeftColor) && Mo(e.borderRightColor))
    return e;
  const u = [a, n, l].filter(
    (R) => Mt(R)
  ), d = u.length > 0 ? u.join(" ") : void 0, f = ds(e.borderColor || "none"), h = ds(e.borderTopColor || "none"), p = ds(e.borderBottomColor || "none"), g = ds(e.borderLeftColor || "none"), C = ds(e.borderRightColor || "none"), v = e.borderColor ? f : void 0, y = e.borderTopColor ? h : void 0, M = e.borderBottomColor ? p : void 0, x = e.borderLeftColor ? g : void 0, _ = e.borderRightColor ? C : void 0, L = { ...e };
  return Mt(d) && (L.border = d), Mt(v) && (L.borderColor = v), Mt(y) && (L.borderTopColor = y), Mt(M) && (L.borderBottomColor = M), Mt(x) && (L.borderLeftColor = x), Mt(_) && (L.borderRightColor = _), L;
}, Vb = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "A", "B", "C", "D", "E", "F"], y0e = (e) => `${Vb[Math.floor(Math.round(255 * e) / 16)]}${Vb[Math.round(Math.round(255 * e) % 16)]}`, S0e = (e) => {
  const t = ds(e.backgroundColor || "none");
  if (Mo(e.backgroundColor))
    return e;
  const n = Mt(e.backgroundOpacity) ? `${t}${y0e(e.backgroundOpacity)}` : t;
  return { ...e, backgroundColor: n };
}, A0e = (e) => {
  const t = p0e(e), n = C0e(t), r = b0e(n), o = S0e(r), a = Object.fromEntries(
    Object.entries(e).filter(([l]) => l.match(/^data-/))
  );
  return { adjustedProps: Object.fromEntries(
    Object.entries(o).filter(([l]) => !l.match(/^data-/))
  ), dataProps: a };
};
function M0e(e) {
  return e.colSpan !== void 0 || e.rowSpan !== void 0;
}
const Ob = Ke(
  (e, t) => /* @__PURE__ */ A.jsx("div", { ...e, ref: t })
), x0e = Ke(
  (e, t) => /* @__PURE__ */ A.jsx("li", { ...e, ref: t })
), w0e = Ke(
  (e, t) => /* @__PURE__ */ A.jsx("ul", { ...e, ref: t })
), _0e = Ke(
  (e, t) => /* @__PURE__ */ A.jsx("td", { ...e, ref: t })
), I0e = Ke(
  (e, t) => /* @__PURE__ */ A.jsx("th", { ...e, ref: t })
), L0e = Ke(
  (e, t) => /* @__PURE__ */ A.jsx("tr", { ...e, ref: t })
), R0e = Ke(
  (e, t) => /* @__PURE__ */ A.jsx("tbody", { ...e, ref: t })
), D0e = Ke(
  (e, t) => /* @__PURE__ */ A.jsx("thead", { ...e, ref: t })
), P0e = Ke(
  (e, t) => /* @__PURE__ */ A.jsx("table", { ...e, ref: t })
), E0e = (e) => {
  switch (e) {
    case "div":
      return Ob;
    case "li":
      return x0e;
    case "ul":
      return w0e;
    case "td":
      return _0e;
    case "th":
      return I0e;
    case "tr":
      return L0e;
    case "tbody":
      return R0e;
    case "thead":
      return D0e;
    case "table":
      return P0e;
    default:
      return Ob;
  }
}, Bi = Ke(
  ({
    id: e,
    __testId: t,
    children: n,
    className: r,
    onClick: o,
    onPress: a,
    onBlur: i,
    onFocus: l,
    onMouseDown: u,
    onMouseEnter: d,
    onMouseLeave: f,
    onClickOutside: h,
    onDragEnter: p,
    onDragLeave: g,
    onDragOver: C,
    onDrop: v,
    onKeyDown: y,
    onKeyUp: M,
    tabIndex: x,
    role: _,
    __dangerDoNotUseSx: L,
    ...R
  }, k) => {
    const { adjustedProps: P, dataProps: N } = A0e(R), O = m0e(k, h), H = E0e(_), $ = M0e(R) && Mt(_) && ["td", "th"].includes(_) ? { colSpan: R.colSpan, rowSpan: R.rowSpan } : {};
    return (
      // @ts-expect-error all of these things have children, hush
      /* @__PURE__ */ A.jsx(
        H,
        {
          id: e,
          className: r,
          tabIndex: x,
          ref: O,
          role: a && !_ ? "button" : void 0,
          onBlur: (ne) => {
            i && !ne.currentTarget.contains(ne.relatedTarget) && i(ne);
          },
          onFocus: l,
          onMouseDown: u,
          onMouseEnter: d,
          onMouseLeave: f,
          onDragEnter: p,
          onDragLeave: g,
          onDragOver: C,
          onDrop: v,
          onKeyDown: y,
          style: {
            ...P,
            ...L
          },
          "data-testid": t ?? e,
          onClick: o ?? a,
          onKeyUp: a && ((ne) => {
            (ne.key === " " || ne.code === "Space" || ne.key === "Enter" || ne.code === "Enter") && a(ne);
          }),
          ...$,
          ...N,
          children: n
        }
      )
    );
  }
), fc = Ke((e, t) => /* @__PURE__ */ A.jsx(Bi, { ref: t, ...e, display: "flex" })), [T0e, ym] = Tre({
  name: "form-size-context",
  strict: !0,
  errorMessage: "missing form size context. see SUI withFormWrapper."
}), Es = (e, t) => {
  const {
    id: n,
    infoText: r,
    helperText: o,
    errorText: a,
    internalFormWrapperErrorText: i,
    isDisabled: l,
    isReadonly: u,
    isRequired: d,
    isInvalid: f,
    label: h,
    size: p = "md",
    fullWidth: g = !0
  } = e;
  return /* @__PURE__ */ A.jsx(
    UM,
    {
      isDisabled: l,
      isReadOnly: u,
      isRequired: d,
      isInvalid: f || !!i,
      size: p,
      width: g ? "100%" : "initial",
      children: /* @__PURE__ */ A.jsxs(T0e, { value: p, children: [
        h && /* @__PURE__ */ A.jsx(Gx, { htmlFor: n, size: p, children: /* @__PURE__ */ A.jsxs("div", { style: { display: "inline-flex", alignItems: "center", gap: "0.5rem" }, children: [
          h,
          r && /* @__PURE__ */ A.jsx(g9, { label: r, placement: "auto", hasArrow: !0, children: /* @__PURE__ */ A.jsx(fc, { alignItems: "center", justifyContent: "center", children: /* @__PURE__ */ A.jsx(Xo, { icon: "information" }) }) })
        ] }) }),
        t,
        o && /* @__PURE__ */ A.jsx(XM, { children: o }),
        (f && a || !!i) && /* @__PURE__ */ A.jsx(Hx, { color: "textError", children: a ?? i })
      ] })
    }
  );
};
const N0e = ({
  variant: e,
  inline: t,
  children: n,
  ...r
}) => {
  if (t)
    return /* @__PURE__ */ A.jsx("span", { ...r, children: n });
  switch (e) {
    case "h1":
    case "displaySmall":
    case "displayMedium":
    case "displayLarge":
      return /* @__PURE__ */ A.jsx("h1", { ...r, children: n });
    case "h2":
      return /* @__PURE__ */ A.jsx("h2", { ...r, children: n });
    case "h3":
      return /* @__PURE__ */ A.jsx("h3", { ...r, children: n });
    case "h4":
      return /* @__PURE__ */ A.jsx("h4", { ...r, children: n });
    case "h5":
      return /* @__PURE__ */ A.jsx("h5", { ...r, children: n });
    default:
      return /* @__PURE__ */ A.jsx("p", { ...r, children: n });
  }
}, lo = ({
  children: e,
  color: t,
  variant: n = "body1",
  __dangerDoNotUseSx: r,
  truncate: o = !1,
  casing: a,
  id: i,
  textAlign: l,
  inline: u,
  title: d,
  __testId: f
}) => /* @__PURE__ */ A.jsx(
  N0e,
  {
    id: i,
    variant: n,
    inline: u,
    className: Ur("typography", n),
    title: d,
    "data-testid": f,
    style: {
      color: t ? Hr[t] : void 0,
      textAlign: l,
      textOverflow: o ? "ellipsis" : void 0,
      overflow: o ? "hidden" : void 0,
      textTransform: a,
      ...r
    },
    children: e
  }
), k0e = (e, t) => {
  if (e)
    return "boxed";
  if (t)
    return "__dangerDoNotUseCheckmarks";
}, V0e = ({
  __dangerDoNotUseSx: e,
  __testId: t,
  id: n,
  checked: r,
  label: o,
  multiselect: a,
  onChange: i,
  size: l = "lg",
  value: u,
  forceCheckboxes: d,
  __dangerDoNotUseCheckmarks: f,
  tooltip: h,
  textVariant: p = "h4"
}) => {
  const g = (y) => {
    i && i(u, y.target.checked);
  }, C = a || d ? N4 : Fw, v = /* @__PURE__ */ A.jsx(
    C,
    {
      id: n,
      "data-testid": t,
      isChecked: r,
      onChange: g,
      size: l,
      sx: e,
      value: a ? void 0 : u,
      variant: k0e(d, f),
      children: /* @__PURE__ */ A.jsx(lo, { variant: p, children: o })
    }
  );
  return h ? /* @__PURE__ */ A.jsx(m9, { label: h.content, ...h.props, children: v }) : v;
}, O0e = (e, t) => {
  const n = e.reduce((r, { value: o }) => (r[o] = !1, r), {});
  return t == null || t.forEach((r) => {
    n[r] = !0;
  }), n;
}, CL = ({
  __testId: e,
  items: t,
  multiselect: n,
  name: r,
  onChange: o,
  size: a,
  value: i,
  isDisabled: l,
  forceCheckboxes: u,
  forceHorizontal: d,
  title: f,
  columnGap: h = "0.5rem",
  gap: p,
  __dangerDoNotUseCheckmarks: g,
  textVariant: C
}) => {
  const v = (L) => {
    o && !n && o(L);
  }, y = (L, R) => {
    if (o && n) {
      const k = [...i || []], P = k.includes(L);
      !P && R ? k.push(L) : P && !R && k.splice(k.indexOf(L), 1), o(k);
    } else
      o && u && v(L);
  }, M = n ? O0e(t, i) : {}, x = t.map(
    ({ value: L, id: R, label: k, __testId: P, tooltip: N }) => /* @__PURE__ */ A.jsx(
      V0e,
      {
        __testId: P,
        id: R,
        label: k,
        multiselect: n,
        onChange: y,
        size: a,
        value: L,
        checked: u ? i === L : M[L],
        forceCheckboxes: u,
        tooltip: N,
        __dangerDoNotUseCheckmarks: g,
        textVariant: C
      },
      L
    )
  );
  if (n)
    return /* @__PURE__ */ A.jsx(JM, { isDisabled: l, children: /* @__PURE__ */ A.jsx("div", { "data-testid": e, style: { display: "flex", flexDirection: "column", gap: p, columnGap: h }, children: x }) });
  const _ = d || u && t.length < 3 ? "row" : "column";
  return /* @__PURE__ */ A.jsx(
    Vw,
    {
      isDisabled: l,
      "data-testid": e,
      value: i,
      onChange: v,
      name: r,
      title: f,
      children: /* @__PURE__ */ A.jsx("div", { style: { display: "flex", gap: p, columnGap: h, flexDirection: _ }, children: x })
    }
  );
}, F0e = ({
  __testId: e,
  items: t,
  onChange: n,
  size: r,
  value: o,
  forceHorizontal: a,
  title: i,
  columnGap: l,
  gap: u,
  textVariant: d,
  ...f
}) => /* @__PURE__ */ A.jsx(
  CL,
  {
    __testId: e,
    items: t,
    onChange: n,
    size: r,
    value: o,
    multiselect: !0,
    forceHorizontal: a,
    title: i,
    columnGap: l,
    gap: u,
    textVariant: d,
    ...f
  }
), o4e = Ke(
  (e, t) => Es(e, /* @__PURE__ */ A.jsx(F0e, { ...e }))
), a4e = [
  "Business",
  "Buildings",
  "Communication",
  "Design",
  "Device",
  "Document",
  "Editor",
  "Finance",
  "Logos",
  "Map",
  "Media",
  "Not In Figma",
  "Paired Sales",
  "System",
  "User",
  "Data Source"
], B0e = ({
  __testId: e,
  items: t,
  onChange: n,
  name: r,
  size: o = "lg",
  value: a,
  forceCheckboxes: i,
  forceHorizontal: l,
  title: u,
  columnGap: d,
  gap: f,
  __dangerDoNotUseCheckmarks: h,
  textVariant: p
}) => /* @__PURE__ */ A.jsx(
  CL,
  {
    __testId: e,
    value: a,
    items: t,
    name: r,
    onChange: n,
    size: o,
    multiselect: !1,
    forceCheckboxes: i,
    forceHorizontal: l,
    title: u,
    columnGap: d,
    gap: f,
    __dangerDoNotUseCheckmarks: h,
    textVariant: p
  }
), i4e = Ke(
  (e, t) => Es(e, /* @__PURE__ */ A.jsx(B0e, { ...e }))
), H0e = (e, t) => {
  if (t.length === 0)
    return [{ val: e, highlit: !1 }];
  const n = t.sort((a, i) => a[0] - i[0]), r = [t[0]];
  if (n.length > 1) {
    let a = 0, i = 1;
    for (; i < n.length; ) {
      const l = n[i];
      l[0] < r[a][1] ? r[a][1] = Math.max(
        l[1],
        r[a][1]
      ) : (r.push(l), a += 1), i += 1;
    }
  }
  const o = [
    { val: e.substring(0, r[0][0]), highlit: !1 }
  ];
  return r.forEach(([a, i], l, u) => {
    o.push({ val: e.substring(a, i), highlit: !0 }), o.push({
      val: e.substring(i, (u[l + 1] || [])[0]),
      highlit: !1
    });
  }), o;
}, G0e = (e, t) => {
  let n = [{ val: e, highlit: !1 }];
  return t.forEach((r) => {
    n = n.reduce(
      (o, { val: a, highlit: i }) => {
        if (!i && a.includes(r)) {
          const l = a.indexOf(r), u = l + r.length;
          o.push({ val: a.substring(0, l), highlit: !1 }), o.push({
            val: a.substring(l, u),
            highlit: !0
          }), o.push({ val: a.substring(u), highlit: !1 });
        } else
          o.push({ val: a, highlit: i });
        return o;
      },
      []
    );
  }), n;
}, $0e = (e, t, n, r) => {
  const o = ds("statusInProgress"), a = `${o}55`;
  if (!t && !n || typeof e != "string")
    return [/* @__PURE__ */ A.jsx("span", { children: e }, "default-span")];
  let i = [];
  t ? i = H0e(e, t) : n && (i = G0e(e, n));
  let l = 0;
  const u = [];
  return i.forEach(({ val: d, highlit: f }, h) => {
    const p = r && l % 2 === 1 ? a : o;
    u.push(
      /* @__PURE__ */ A.jsx("span", { style: { backgroundColor: f ? p : void 0 }, children: d }, h)
    ), f && (l += 1);
  }), u;
}, s4e = ({
  children: e,
  highlights: t,
  highlightIndices: n,
  alternateHighlights: r
}) => /* @__PURE__ */ A.jsx("span", { children: $0e(e, n, t, r) }), Z0e = Ke(
  ({
    href: e,
    children: t,
    isExternal: n = !1,
    variant: r = "default",
    __dangerDoNotUseSx: o,
    as: a,
    color: i
  }, l) => {
    const u = { color: i, textDecoration: "underline" };
    return n ? /* @__PURE__ */ A.jsx(
      X5,
      {
        ref: l,
        href: e,
        isExternal: n,
        variant: r,
        sx: o,
        as: a,
        color: i,
        _hover: u,
        _active: u,
        _focus: u,
        children: t
      }
    ) : /* @__PURE__ */ A.jsx(
      X5,
      {
        color: i,
        ref: l,
        as: a,
        to: e,
        variant: r,
        sx: o,
        _hover: u,
        _active: u,
        _focus: u,
        children: t
      }
    );
  }
);
Z0e.displayName = "Link";
const l4e = [
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "body1",
  "body2",
  "placeholder",
  "subtitle1",
  "subtitle2",
  "subtitle3",
  "link",
  "buttonSmall",
  "buttonRegular",
  "chip",
  "tableColumnTitle",
  "tableH1",
  "tableH2",
  "tableH3",
  "tableTag",
  "displayLarge",
  "displayMedium",
  "displaySmall",
  "label"
], j0e = (e, t, n) => {
  const r = Ve(!1);
  st(() => {
    var o;
    return e && !r.current && typeof t != "function" && ((o = (t || n).current) == null || o.focus(), r.current = !0), () => {
      r.current = !1;
    };
  }, [e, t]);
}, W0e = [
  "price",
  "percent",
  "number",
  "aloftPrice",
  "aloftCount",
  "aloftArea"
], z0e = (e) => W0e.includes(e), U0e = (e, t) => {
  st(() => {
    if (z0e(e) && typeof t == "object" && typeof t != "function") {
      const n = t == null ? void 0 : t.current, r = (o) => {
        document.activeElement === n && o.preventDefault();
      };
      return n == null || n.addEventListener("wheel", r), () => {
        n == null || n.removeEventListener("wheel", r);
      };
    }
  }, [t, e]);
}, X0e = Ke((e, t) => /* @__PURE__ */ A.jsx(
  Ns,
  {
    ...e,
    ref: t,
    type: "date",
    value: rr.isAloftDate(e.value) ? e.value.toIsoString() : void 0,
    onChange: (n) => {
      try {
        e.onChange(rr.fromIsoString(n));
      } catch {
        e.onClear();
      }
    },
    onClear: e.onClear,
    formatValue: (n) => Mt(n) ? e.formatValue ? e.formatValue(rr.fromIsoString(n)) : n : "",
    setInternalFormWrapperErrorText: () => null
  }
)), Fb = (e) => ({ $type: "AloftEmail", address: e }), Bb = (e) => ({ $type: "AloftPhone", number: e }), Y0e = Ke(({ ...e }, t) => {
  var n;
  return /* @__PURE__ */ A.jsx(
    Ns,
    {
      ...e,
      ref: t,
      type: "email",
      value: ((n = e.value) == null ? void 0 : n.address) ?? void 0,
      onChange: (r) => Mt(r) ? e.onChange(Fb(r)) : e.onClear(),
      onClear: e.onClear,
      formatValue: (r) => Mt(r) ? e.formatValue ? e.formatValue(Fb(r)) : r : "",
      setInternalFormWrapperErrorText: () => null
    }
  );
}), q0e = Ke((e, t) => /* @__PURE__ */ A.jsx(
  Ns,
  {
    ...e,
    ref: t,
    type: "month",
    value: rr.isAloftDate(e.value) ? e.value.toIsoString().substring(0, 7) : void 0,
    onChange: (n) => {
      try {
        e.onChange(rr.fromIsoString(`${n}-01`));
      } catch {
        e.onClear();
      }
    },
    onClear: e.onClear,
    formatValue: (n) => Mt(n) ? e.formatValue ? e.formatValue(rr.fromIsoString(n)) : n : "",
    setInternalFormWrapperErrorText: () => null
  }
)), J0e = Ke(({ ...e }, t) => {
  var n;
  return /* @__PURE__ */ A.jsx(
    Ns,
    {
      ...e,
      ref: t,
      type: "phone",
      value: ((n = e.value) == null ? void 0 : n.number) ?? void 0,
      onChange: (r) => Mt(r) ? e.onChange(Bb(r)) : e.onClear(),
      onClear: e.onClear,
      formatValue: (r) => Mt(r) ? e.formatValue ? e.formatValue(Bb(r)) : r : "",
      setInternalFormWrapperErrorText: () => null
    }
  );
}), K0e = Ke((e, t) => {
  const n = (o) => {
    Mt(o) ? e.onChange(Yt.fromNumericPrice(o)) : e.onClear();
  }, r = (o) => Mt(o) ? e.formatValue ? e.formatValue(Yt.fromNumericPrice(o)) : `${o}` : "";
  return /* @__PURE__ */ A.jsx(
    Ns,
    {
      ...e,
      ref: t,
      type: "price",
      onClear: e.onClear,
      onChange: n,
      value: Yt.isAloftPrice(e.value) ? e.value.toNumericPrice() : void 0,
      formatValue: r,
      setInternalFormWrapperErrorText: () => null
    }
  );
}), Q0e = (e, t) => {
  if (Mt(e) && Mt(t))
    return Dt.fromNumber(Xh.round(e.unitAmount, t), e.unit);
}, U9 = (e) => e.target.value;
function Ti(e) {
  return e !== void 0;
}
const X9 = Ke(({ leftAddon: e, rightAddon: t, input: n, leftAddonProps: r = {}, rightAddonProps: o = {} }, a) => {
  const i = ym();
  return /* @__PURE__ */ A.jsxs(X4, { size: i, children: [
    Ti(e) && /* @__PURE__ */ A.jsx(
      q4,
      {
        ...r,
        backgroundColor: "transparent",
        borderColor: "transparent",
        height: r.height || "2.75rem",
        children: e
      }
    ),
    n,
    Ti(t) && /* @__PURE__ */ A.jsx(
      J4,
      {
        ...o,
        backgroundColor: "transparent",
        borderColor: "transparent",
        children: t
      }
    )
  ] });
});
X9.displayName = "InputWithAddons";
const efe = ({
  commonProps: e,
  ...t
}) => {
  var u;
  const { prefix: n, suffix: r } = t, o = ((u = t.value) == null ? void 0 : u.unit) ?? t.unit, a = {};
  (o || r) && (a.rightAddon = r ?? o, a.rightAddonProps = {
    height: "100%",
    marginY: "auto"
  }), n && (a.leftAddon = n, a.leftAddonProps = {
    height: "100%",
    marginY: "auto"
  });
  const i = t.formatValue ?? ((d) => d == null ? void 0 : d.unitAmount), l = (d) => {
    var h;
    const f = U9(d);
    if (f === "")
      t.onClear();
    else {
      const p = Dt.fromString(f, ((h = t.value) == null ? void 0 : h.unit) ?? "sqft");
      t.onChange(p);
    }
  };
  return /* @__PURE__ */ A.jsx(
    X9,
    {
      ...a,
      input: /* @__PURE__ */ A.jsx(
        Pr,
        {
          ...e,
          paddingInlineStart: "8px",
          type: "number",
          precision: t.precision,
          onChange: l,
          onBlur: () => {
            var f;
            const d = Q0e(t.value, t.precision);
            (f = t.onBlur) == null || f.call(t, d);
          },
          value: Mt(t.value) && t.value !== "" ? i(t.value) : ""
        }
      )
    }
  );
}, tfe = Ke(({ ...e }, t) => {
  var n;
  return /* @__PURE__ */ A.jsx(
    Ns,
    {
      ...e,
      ref: t,
      type: "number",
      precision: 0,
      value: (n = e.value) == null ? void 0 : n.toNumber(),
      onChange: (r) => Mt(r) && r !== "" ? e.onChange(gt.fromNumber(r)) : e.onClear(),
      onClear: e.onClear,
      formatValue: (r) => Mt(r) ? e.formatValue && r !== "" ? e.formatValue(gt.fromNumber(r)) : `${r}` : "",
      setInternalFormWrapperErrorText: () => null
    }
  );
}), Lc = (e) => e ?? "", Ts = (e, t) => (n) => {
  const r = U9(n);
  r === "" ? t() : e(r);
}, nfe = ({
  commonProps: e,
  ...t
}) => {
  const n = t.formatValue ?? Lc;
  return /* @__PURE__ */ A.jsx(
    Pr,
    {
      ...e,
      type: "date",
      value: n(t.value),
      onChange: Ts(t.onChange, t.onClear)
    }
  );
}, rfe = ({
  commonProps: e,
  ...t
}) => {
  const n = t.formatValue ?? Lc;
  return /* @__PURE__ */ A.jsx(
    Pr,
    {
      ...e,
      type: "email",
      value: n(t.value),
      onChange: Ts(t.onChange, t.onClear)
    }
  );
}, Hb = {
  fields: ["address_components"],
  componentRestrictions: { country: ["us"] }
};
function bL(e, t) {
  const n = Ve(document.createElement("div")), r = Ve(null), o = Ve(null), a = Ve(null), i = Q(() => {
    var d;
    const l = a.current, u = l == null ? void 0 : l.getPlace();
    if (u) {
      t(u, (d = o.current) == null ? void 0 : d.value);
      return;
    }
    e && (async () => {
      var f;
      try {
        const { AutocompleteService: h, PlacesService: p } = await e.importLibrary("places"), g = ((f = o.current) == null ? void 0 : f.value) ?? "";
        new h().getPlacePredictions(
          { input: g },
          (v, y) => {
            y === google.maps.places.PlacesServiceStatus.OK && (v != null && v.length) && new p(
              r.current
            ).getDetails(
              { placeId: v[0].place_id, ...Hb },
              (x) => {
                x && t(x, g);
              }
            );
          }
        );
      } catch (h) {
        console.error("Google Maps fallback failed", h);
      }
    })();
  }, [t, e]);
  return st(() => {
    if (!e || !o.current)
      return;
    let l = null;
    return (async () => {
      try {
        const { Autocomplete: u } = await e.importLibrary("places");
        l = new u(o.current, Hb), a.current = l, l.addListener("place_changed", i);
        const { Map: d } = await e.importLibrary("maps");
        r.current = new d(n.current, {
          center: { lat: -33.866, lng: 151.196 },
          zoom: 15
        });
      } catch (u) {
        console.error("Google Maps initialization failed", u);
      }
    })(), () => {
      l && google.maps.event.clearInstanceListeners(l);
    };
  }, [i, e]), o;
}
const jo = (e, t) => {
  var n;
  return (n = e.address_components.find((r) => r.types.includes(t))) == null ? void 0 : n.short_name;
}, ofe = (e, t) => {
  var u;
  if (!e)
    return;
  const n = jo(e, "street_number") || ((u = t == null ? void 0 : t.match(/\d+/)) == null ? void 0 : u[0]);
  if (!n)
    return;
  const r = jo(e, "route");
  if (!r)
    return;
  const o = jo(e, "subpremise"), a = jo(e, "locality");
  if (!a)
    return;
  const i = jo(e, "administrative_area_level_1");
  if (!i)
    return;
  const l = jo(e, "postal_code");
  if (l)
    return {
      AddressLineText: `${n} ${r}`,
      unitNumber: o,
      CityName: a,
      StateCode: i,
      PostalCode: l
    };
}, jl = Ke(({ input: e, icon: t, placeIconRight: n }, r) => {
  const o = ym(), a = /* @__PURE__ */ A.jsx(Xo, { icon: t, size: o === "xs" ? "md" : "lg", color: "textTertiary" });
  return /* @__PURE__ */ A.jsxs(X4, { size: o, children: [
    !n && /* @__PURE__ */ A.jsx(K4, { height: "full", children: a }),
    e,
    n && /* @__PURE__ */ A.jsx(Q4, { height: "full", children: a })
  ] });
});
jl.displayName = "IconInput";
const afe = ({
  commonProps: e,
  ...t
}) => {
  const n = (o, a) => {
    const i = ofe(o, a);
    i && t.onPlaceChanged && t.onPlaceChanged(i);
  }, r = bL(t.mapsLoader, n);
  return /* @__PURE__ */ A.jsx(
    jl,
    {
      icon: "map-pin",
      input: /* @__PURE__ */ A.jsx(
        Pr,
        {
          ...e,
          ref: r,
          type: "text",
          value: t.value ?? "",
          onChange: Ts(t.onChange, t.onClear),
          placeholder: "Enter an address"
        }
      )
    }
  );
}, ife = (e, t) => {
  var u;
  if (!e)
    return;
  const n = jo(e, "street_number") || ((u = t == null ? void 0 : t.match(/\d+/)) == null ? void 0 : u[0]);
  if (!n)
    return;
  const r = jo(e, "route");
  if (!r)
    return;
  const o = jo(e, "subpremise"), a = jo(e, "locality");
  if (!a)
    return;
  const i = jo(e, "administrative_area_level_1");
  if (!i)
    return;
  const l = jo(e, "postal_code");
  if (l)
    return `${n} ${r}${o ? `, ${o}` : ""}, ${a}, ${i}, ${l}`;
}, sfe = ({
  commonProps: e,
  ...t
}) => {
  const [n, r] = He(
    t.value ? Uoe(t.value) : ""
  ), [o, a] = He(!0), i = (h) => {
    r(h.target.value);
  }, l = () => {
    var h;
    (h = t.onBlur) == null || h.call(t), o || t.setInternalFormWrapperErrorText("Address format isn't valid");
  }, u = (h, p) => {
    const g = ife(h, p);
    g && r(g);
  }, d = bL(t.mapsLoader, u), f = t.formatValue ?? ((h) => h);
  return st(() => {
    if (n)
      try {
        t.onChange(Xoe(n)), t.setInternalFormWrapperErrorText(void 0), a(!0);
      } catch {
        a(!1);
      }
    else
      t.onClear();
  }, [n]), /* @__PURE__ */ A.jsx(
    jl,
    {
      icon: "map-pin",
      input: /* @__PURE__ */ A.jsx(
        Pr,
        {
          ...e,
          ref: d,
          type: "text",
          value: f(n),
          onChange: i,
          onBlur: l
        }
      )
    }
  );
}, lfe = ({
  commonProps: e,
  ...t
}) => {
  const n = t.formatValue ?? Lc;
  return /* @__PURE__ */ A.jsx(
    Pr,
    {
      ...e,
      type: "month",
      value: n(t.value),
      onChange: Ts(t.onChange, t.onClear)
    }
  );
}, ufe = Ke(({ commonProps: e, ...t }, n) => {
  const r = t.formatValue ?? Lc;
  return /* @__PURE__ */ A.jsx(
    zw,
    {
      ...e,
      ref: n,
      onChange: Ts(t.onChange, t.onClear),
      value: r(t.value),
      inputMode: "text"
    }
  );
}), yL = (e, t, n) => {
  Mt(e) && Mt(t) && e !== "" && n(Xh.round(e, t));
}, Y9 = (e) => Number.isNaN(e) || !Mt(e) ? "" : e, q9 = (e, t) => (n) => {
  const r = U9(n);
  r === "" ? t() : e(+r);
}, cfe = ({
  commonProps: e,
  ...t
}) => {
  const n = q9(t.onChange, t.onClear), r = t.formatValue ?? Y9, { prefix: o, suffix: a } = t, i = {};
  return a && (i.rightAddon = a, i.rightAddonProps = {
    height: "100%",
    marginY: "auto"
  }), o && (i.leftAddon = o, i.leftAddonProps = {
    height: "100%",
    marginY: "auto"
  }), /* @__PURE__ */ A.jsx(
    X9,
    {
      ...i,
      input: /* @__PURE__ */ A.jsx(
        Pr,
        {
          ...e,
          value: r(t.value),
          onChange: n,
          onBlur: () => {
            var l;
            yL(t.value, t.precision, t.onChange), (l = t.onBlur) == null || l.call(t);
          },
          type: "number"
        }
      )
    }
  );
}, dfe = ({
  commonProps: e,
  ...t
}) => {
  const n = q9(t.onChange, t.onClear), r = t.formatValue ?? Y9;
  return /* @__PURE__ */ A.jsx(
    jl,
    {
      icon: "percent",
      placeIconRight: !0,
      input: /* @__PURE__ */ A.jsx(
        Pr,
        {
          type: "number",
          ...e,
          onChange: n,
          onBlur: () => {
            var o;
            yL(t.value, t.precision, t.onChange), (o = t.onBlur) == null || o.call(t);
          },
          value: r(t.value)
        }
      )
    }
  );
};
function Gb(e) {
  const { anchorOffset: t = 0, focusOffset: n = 0 } = e.ownerDocument.getSelection() || {}, r = Math.min(t, n), o = Math.max(t, n);
  return [r, o];
}
function ffe(e, [t, n]) {
  var r, o;
  const a = e.ownerDocument, i = a.createRange();
  i.setStart(e.firstChild || e, Math.min(t, ((r = e.textContent) === null || r === void 0 ? void 0 : r.length) || 0)), i.setEnd(e.lastChild || e, Math.min(n, ((o = e.textContent) === null || o === void 0 ? void 0 : o.length) || 0));
  const l = a.getSelection();
  l && (l.removeAllRanges(), l.addRange(i));
}
class hfe {
  constructor(t) {
    this.element = t, this.maxLength = 1 / 0;
  }
  get value() {
    return this.element.innerText.replace(/\n\n$/, `
`);
  }
  set value(t) {
    this.element.innerHTML = t.replace(/\n$/, `

`);
  }
  get selectionStart() {
    return Gb(this.element)[0];
  }
  get selectionEnd() {
    return Gb(this.element)[1];
  }
  setSelectionRange(t, n) {
    ffe(this.element, [t || 0, n || 0]);
  }
  select() {
    this.setSelectionRange(0, this.value.length);
  }
}
function mfe(e) {
  const t = new hfe(e);
  return new Proxy(e, {
    get(n, r) {
      if (r in t)
        return t[r];
      const o = n[r];
      return typeof o == "function" ? o.bind(n) : o;
    },
    set(n, r, o, a) {
      return Reflect.set(r in t ? t : n, r, o, a);
    }
  });
}
const pfe = (e) => e.isContentEditable ? mfe(e) : e.querySelector("input,textarea") || e, J9 = {
  mask: /^.*$/,
  preprocessors: [],
  postprocessors: [],
  plugins: [],
  overwriteMode: "shift"
};
class gfe {
  constructor() {
    this.now = null, this.past = [], this.future = [];
  }
  undo() {
    const t = this.past.pop();
    t && this.now && (this.future.push(this.now), this.updateElement(t, "historyUndo"));
  }
  redo() {
    const t = this.future.pop();
    t && this.now && (this.past.push(this.now), this.updateElement(t, "historyRedo"));
  }
  updateHistory(t) {
    if (!this.now) {
      this.now = t;
      return;
    }
    const n = this.now.value !== t.value, r = this.now.selection.some((o, a) => o !== t.selection[a]);
    !n && !r || (n && (this.past.push(this.now), this.future = []), this.now = t);
  }
  updateElement(t, n) {
    this.now = t, this.updateElementState(t, { inputType: n, data: null });
  }
}
function vfe(e, ...t) {
  return t.every(({ value: n }) => n === e.value);
}
function Cfe(e, ...t) {
  return t.every(({ value: n, selection: r }) => n === e.value && r[0] === e.selection[0] && r[1] === e.selection[1]);
}
function bfe({ value: e, selection: t }, n, r) {
  const [o, a] = t, i = typeof r == "function" ? r({ value: e, selection: t }) : r;
  return {
    value: e,
    selection: i === "replace" ? [o, o + n.length] : [o, a]
  };
}
function Sm(e) {
  return typeof e == "string";
}
function $b(e, t, n, r) {
  let o = "";
  for (let a = t.length; a < e.length; a++) {
    const i = e[a], l = (r == null ? void 0 : r.value[a]) === i;
    if (!Sm(i) || i === n && !l)
      return o;
    o += i;
  }
  return o;
}
function SL(e, t) {
  return Array.isArray(t) ? e.length === t.length && Array.from(e).every((n, r) => {
    const o = t[r];
    return Sm(o) ? n === o : n.match(o);
  }) : t.test(e);
}
function yfe(e, t, n) {
  let r = null, o = null;
  const a = Array.from(e.value).reduce((l, u, d) => {
    const f = $b(t, l, u, n), h = l + f, p = t[h.length];
    return Sm(p) ? h + p : u.match(p) ? (r === null && d >= e.selection[0] && (r = h.length), o === null && d >= e.selection[1] && (o = h.length), h + u) : h;
  }, ""), i = $b(t, a, "", n);
  return {
    value: SL(a + i, t) ? a + i : a,
    selection: [r ?? a.length, o ?? a.length]
  };
}
function Sfe({ value: e, selection: t }, n) {
  const [r, o] = t;
  let a = r, i = o;
  return { value: Array.from(e).reduce((u, d, f) => {
    const h = u + d;
    return r === f && (a = u.length), o === f && (i = u.length), h.match(n) ? h : u;
  }, ""), selection: [a, i] };
}
function Ef(e, t, n = null) {
  if (SL(e.value, t))
    return e;
  const { value: r, selection: o } = Array.isArray(t) ? yfe(e, t, n) : Sfe(e, t);
  return {
    selection: o,
    value: Array.isArray(t) ? r.slice(0, t.length) : r
  };
}
function Zb(e, t) {
  if (!Array.isArray(t))
    return e;
  const [n, r] = e.selection, o = [], a = Array.from(e.value).reduce((i, l, u) => {
    const d = t[u];
    return u === n && o.push(i.length), u === r && o.push(i.length), Sm(d) && d === l ? i : i + l;
  }, "");
  return o.length < 2 && o.push(...new Array(2 - o.length).fill(a.length)), {
    value: a,
    selection: [o[0], o[1]]
  };
}
class M3 {
  constructor(t, n) {
    this.initialElementState = t, this.maskOptions = n, this.value = "", this.selection = [0, 0];
    const { value: r, selection: o } = Ef(this.initialElementState, this.getMaskExpression(this.initialElementState));
    this.value = r, this.selection = o;
  }
  addCharacters([t, n], r) {
    const { value: o } = this, a = this.getMaskExpression({
      value: o.slice(0, t) + r + o.slice(n),
      selection: [t + r.length, t + r.length]
    }), i = { value: o, selection: [t, n] }, l = Zb(i, a), [u, d] = bfe(l, r, this.maskOptions.overwriteMode).selection, f = l.value.slice(0, u) + r, h = f.length, p = Ef({
      value: f + l.value.slice(d),
      selection: [h, h]
    }, a, i);
    if (// eslint-disable-next-line @typescript-eslint/prefer-string-starts-ends-with
    o.slice(0, u) === Ef({
      value: f,
      selection: [h, h]
    }, a, i).value || Cfe(this, p))
      throw new Error("Invalid mask value");
    this.value = p.value, this.selection = p.selection;
  }
  deleteCharacters([t, n]) {
    if (t === n || !n)
      return;
    const { value: r } = this, o = this.getMaskExpression({
      value: r.slice(0, t) + r.slice(n),
      selection: [t, t]
    }), a = { value: r, selection: [t, n] }, i = Zb(a, o), [l, u] = i.selection, d = i.value.slice(0, l) + i.value.slice(u), f = Ef({ value: d, selection: [l, l] }, o, a);
    this.value = f.value, this.selection = f.selection;
  }
  getMaskExpression(t) {
    const { mask: n } = this.maskOptions;
    return typeof n == "function" ? n(t) : n;
  }
}
class Afe {
  constructor(t) {
    this.element = t, this.listeners = [];
  }
  listen(t, n, r) {
    const o = n;
    this.element.addEventListener(t, o, r), this.listeners.push(() => this.element.removeEventListener(t, o));
  }
  destroy() {
    this.listeners.forEach((t) => t());
  }
}
const Ca = {
  CTRL: 1,
  ALT: 2,
  SHIFT: 4,
  META: 8
}, nd = {
  Y: 89,
  Z: 90
};
function rd(e, t, n) {
  return e.ctrlKey === !!(t & Ca.CTRL) && e.altKey === !!(t & Ca.ALT) && e.shiftKey === !!(t & Ca.SHIFT) && e.metaKey === !!(t & Ca.META) && /**
   * We intentionally use legacy {@link KeyboardEvent#keyCode `keyCode`} property. It is more
   * "keyboard-layout"-independent than {@link KeyboardEvent#key `key`} or {@link KeyboardEvent#code `code`} properties.
   * @see {@link https://github.com/taiga-family/maskito/issues/315 `KeyboardEvent#code` issue}
   */
  e.keyCode === n;
}
function Mfe(e) {
  return rd(e, Ca.CTRL, nd.Y) || // Windows
  rd(e, Ca.CTRL | Ca.SHIFT, nd.Z) || // Windows & Android
  rd(e, Ca.META | Ca.SHIFT, nd.Z);
}
function xfe(e) {
  return rd(e, Ca.CTRL, nd.Z) || // Windows & Android
  rd(e, Ca.META, nd.Z);
}
function hc(e, t) {
  var n;
  const r = e.value;
  if (typeof t == "string")
    e.value = t;
  else {
    const [o, a] = t.selection;
    e.value = t.value, e.matches(":focus") && ((n = e.setSelectionRange) === null || n === void 0 || n.call(e, o, a));
  }
  e.value !== r && e.dispatchEvent(new Event(
    "input",
    /**
     * React handles this event only on bubbling phase
     *
     * here is the list of events that are processed in the capture stage, others are processed in the bubbling stage
     * https://github.com/facebook/react/blob/cb2439624f43c510007f65aea5c50a8bb97917e4/packages/react-dom-bindings/src/events/DOMPluginEventSystem.js#L222
     */
    { bubbles: !0 }
  ));
}
function wfe({ value: e, selection: t }, n) {
  const [r, o] = t;
  if (r !== o)
    return [r, o];
  const a = n ? e.slice(r).indexOf(`
`) + 1 || e.length : e.slice(0, o).lastIndexOf(`
`) + 1;
  return [n ? r : a, n ? a : o];
}
function _fe({ value: e, selection: t }, n) {
  const [r, o] = t;
  return r !== o ? [r, o] : (n ? [r, o + 1] : [r - 1, o]).map((i) => Math.min(Math.max(i, 0), e.length));
}
const Ife = /\s+$/g, Lfe = /^\s+/g, jb = /\s/;
function Rfe({ value: e, selection: t }, n) {
  const [r, o] = t;
  if (r !== o)
    return [r, o];
  if (n) {
    const u = e.slice(r), [d] = u.match(Lfe) || [
      ""
    ], f = u.trimStart().search(jb);
    return [
      r,
      f !== -1 ? r + d.length + f : e.length
    ];
  }
  const a = e.slice(0, o), [i] = a.match(Ife) || [""], l = a.trimEnd().split("").reverse().findIndex((u) => u.match(jb));
  return [
    l !== -1 ? o - i.length - l : 0,
    o
  ];
}
function ih(e = []) {
  return (t, ...n) => e.reduce((r, o) => Object.assign(Object.assign({}, r), o(r, ...n)), t);
}
function zd(e, t) {
  const n = Object.assign(Object.assign({}, J9), t), r = ih(n.preprocessors), o = ih(n.postprocessors), a = typeof e == "string" ? { value: e, selection: [0, 0] } : e, { elementState: i } = r({ elementState: a, data: "" }, "validation"), l = new M3(i, n), { value: u, selection: d } = o(l, a);
  return typeof e == "string" ? u : { value: u, selection: d };
}
function Dfe(e) {
  return (t, n) => {
    const r = t.selectionStart || 0, o = t.selectionEnd || 0;
    hc(t, {
      value: zd(t.value, e || n),
      selection: [r, o]
    });
  };
}
class Pfe extends gfe {
  constructor(t, n) {
    super(), this.element = t, this.maskitoOptions = n, this.isTextArea = this.element.nodeName === "TEXTAREA", this.eventListener = new Afe(this.element), this.options = Object.assign(Object.assign({}, J9), this.maskitoOptions), this.preprocessor = ih(this.options.preprocessors), this.postprocessor = ih(this.options.postprocessors), this.teardowns = this.options.plugins.map((r) => r(this.element, this.options)), this.updateHistory(this.elementState), this.eventListener.listen("keydown", (r) => {
      if (Mfe(r))
        return r.preventDefault(), this.redo();
      if (xfe(r))
        return r.preventDefault(), this.undo();
    }), this.eventListener.listen("beforeinput", (r) => {
      var o;
      const a = r.inputType.includes("Forward");
      switch (this.updateHistory(this.elementState), r.inputType) {
        case "historyUndo":
          return r.preventDefault(), this.undo();
        case "historyRedo":
          return r.preventDefault(), this.redo();
        case "deleteByCut":
        case "deleteContentBackward":
        case "deleteContentForward":
          return this.handleDelete({
            event: r,
            isForward: a,
            selection: _fe(this.elementState, a)
          });
        case "deleteWordForward":
        case "deleteWordBackward":
          return this.handleDelete({
            event: r,
            isForward: a,
            selection: Rfe(this.elementState, a),
            force: !0
          });
        case "deleteSoftLineBackward":
        case "deleteSoftLineForward":
        case "deleteHardLineBackward":
        case "deleteHardLineForward":
          return this.handleDelete({
            event: r,
            isForward: a,
            selection: wfe(this.elementState, a),
            force: !0
          });
        case "insertCompositionText":
          return;
        case "insertReplacementText":
          return;
        case "insertLineBreak":
        case "insertParagraph":
          return this.handleEnter(r);
        case "insertFromPaste":
        case "insertText":
        case "insertFromDrop":
        default:
          return this.handleInsert(r, r.data || // `event.data` for `contentEditable` is always `null` for paste/drop events
          ((o = r.dataTransfer) === null || o === void 0 ? void 0 : o.getData("text/plain")) || "");
      }
    }), this.eventListener.listen("input", ({ inputType: r }) => {
      r !== "insertCompositionText" && (this.ensureValueFitsMask(), this.updateHistory(this.elementState));
    }), this.eventListener.listen("compositionend", () => {
      this.ensureValueFitsMask(), this.updateHistory(this.elementState);
    });
  }
  get elementState() {
    const { value: t, selectionStart: n, selectionEnd: r } = this.element;
    return {
      value: t,
      selection: [n || 0, r || 0]
    };
  }
  get maxLength() {
    const { maxLength: t } = this.element;
    return t === -1 ? 1 / 0 : t;
  }
  destroy() {
    this.eventListener.destroy(), this.teardowns.forEach((t) => t == null ? void 0 : t());
  }
  updateElementState({ value: t, selection: n }, r = {
    inputType: "insertText",
    data: null
  }) {
    const o = this.elementState.value;
    this.updateValue(t), this.updateSelectionRange(n), o !== t && this.dispatchInputEvent(r);
  }
  updateSelectionRange([t, n]) {
    var r;
    const { element: o } = this;
    o.matches(":focus") && (o.selectionStart !== t || o.selectionEnd !== n) && ((r = o.setSelectionRange) === null || r === void 0 || r.call(o, t, n));
  }
  updateValue(t) {
    this.element.value = t;
  }
  ensureValueFitsMask() {
    this.updateElementState(zd(this.elementState, this.options));
  }
  dispatchInputEvent(t = {
    inputType: "insertText",
    data: null
  }) {
    globalThis.InputEvent && this.element.dispatchEvent(new InputEvent("input", Object.assign(Object.assign({}, t), { bubbles: !0, cancelable: !1 })));
  }
  handleDelete({ event: t, selection: n, isForward: r, force: o = !1 }) {
    const a = {
      value: this.elementState.value,
      selection: n
    }, [i, l] = a.selection, { elementState: u } = this.preprocessor({
      elementState: a,
      data: ""
    }, r ? "deleteForward" : "deleteBackward"), d = new M3(u, this.options), [f, h] = u.selection;
    d.deleteCharacters([f, h]);
    const p = this.postprocessor(d, a);
    if (!(a.value.slice(0, i) + a.value.slice(l) === p.value && !o && !this.element.isContentEditable)) {
      if (t.preventDefault(), vfe(a, u, d, p))
        return this.updateSelectionRange(r ? [h, h] : [f, f]);
      this.updateElementState(p, {
        inputType: t.inputType,
        data: null
      }), this.updateHistory(p);
    }
  }
  handleInsert(t, n) {
    const r = this.elementState, { elementState: o, data: a = n } = this.preprocessor({
      data: n,
      elementState: r
    }, "insert"), i = new M3(o, this.options);
    try {
      i.addCharacters(o.selection, a);
    } catch {
      return t.preventDefault();
    }
    const [l, u] = o.selection, d = r.value.slice(0, l) + n + r.value.slice(u), f = this.postprocessor(i, r);
    if (f.value.length > this.maxLength)
      return t.preventDefault();
    (d !== f.value || this.element.isContentEditable) && (t.preventDefault(), this.updateElementState(f, {
      data: n,
      inputType: t.inputType
    }), this.updateHistory(f));
  }
  handleEnter(t) {
    (this.isTextArea || this.element.isContentEditable) && this.handleInsert(t, `
`);
  }
}
function mc(e, t, n) {
  const r = Math.min(Number(n), Math.max(Number(t), Number(e)));
  return e instanceof Date ? new Date(r) : r;
}
const Efe = [".", ",", "б", "ю"], Tfe = [":", "."], Nfe = " ", kfe = "​", AL = "–", ML = "—", sh = "-", x3 = "−", xL = "ー", wL = /[\\^$.*+?()[\]{}|]/g, Vfe = new RegExp(wL.source);
function zr(e) {
  return e && Vfe.test(e) ? e.replaceAll(wL, "\\$&") : e;
}
function wa(e, { prefix: t, postfix: n }) {
  var r, o;
  const a = new RegExp(`^${zr(t)}`), i = new RegExp(`${zr(n)}$`), [l = ""] = (r = e.match(a)) !== null && r !== void 0 ? r : [], [u = ""] = (o = e.match(i)) !== null && o !== void 0 ? o : [], d = e.replace(a, "").replace(i, "");
  return { extractedPrefix: l, extractedPostfix: u, cleanValue: d };
}
function Ofe(e, t) {
  let n = "";
  for (let r = 0; r < e.length; r++) {
    if (e[r] !== t[r])
      return n;
    n += e[r];
  }
  return n;
}
function Ud(e) {
  return e;
}
function Wb(e) {
  return e.replaceAll(/[０-９]/g, (t) => String.fromCharCode(t.charCodeAt(0) - 65248));
}
function Ffe() {
  return ({ elementState: e, data: t }) => {
    const { value: n, selection: r } = e;
    return {
      elementState: {
        selection: r,
        value: Wb(n)
      },
      data: Wb(t)
    };
  };
}
function Bfe(e) {
  const t = new RegExp(`${zr(e)}$`);
  return e ? ({ value: n, selection: r }, o) => {
    if (!n && !o.value.endsWith(e))
      return { value: n, selection: r };
    if (!n.endsWith(e) && !o.value.endsWith(e))
      return { selection: r, value: n + e };
    const a = o.value.replace(t, ""), i = o.selection[1] >= a.length, l = Ofe(a, n);
    return {
      selection: r,
      value: Array.from(e).reverse().reduce((u, d, f) => {
        const h = u.length - 1 - f, p = l[h] === d && i;
        return u[h] !== d || p ? u.slice(0, h + 1) + d + u.slice(h + 1) : u;
      }, n)
    };
  } : Ud;
}
function Hfe(e) {
  return e ? ({ value: t, selection: n }, r) => {
    if (t.startsWith(e) || // already valid
    !t && !r.value.startsWith(e))
      return { value: t, selection: n };
    const [o, a] = n, i = Array.from(e).reduce((u, d, f) => u[f] === d ? u : u.slice(0, f) + d + u.slice(f), t), l = i.length - t.length;
    return {
      selection: [o + l, a + l],
      value: i
    };
  } : Ud;
}
function yd(e, t, n) {
  return (r, o) => {
    const a = () => t(r, o);
    return r.addEventListener(e, a, n), () => r.removeEventListener(e, a, n);
  };
}
function _L(e) {
  return (t) => {
    const n = t.ownerDocument;
    let r = 0;
    const o = () => r++, a = () => {
      r = Math.max(--r, 0);
    }, i = () => {
      if (!t.matches(":focus"))
        return;
      if (r)
        return n.addEventListener("mouseup", i, {
          once: !0,
          passive: !0
        });
      const l = t.selectionStart || 0, u = t.selectionEnd || 0, [d, f] = e(t.value, [l, u]);
      (d > l || f < u) && t.setSelectionRange(mc(l, d, f), mc(u, d, f));
    };
    return n.addEventListener("selectionchange", i, { passive: !0 }), t.addEventListener("mousedown", o, { passive: !0 }), n.addEventListener("mouseup", a, { passive: !0 }), () => {
      n.removeEventListener("selectionchange", i), n.removeEventListener("mousedown", o), n.removeEventListener("mouseup", a);
    };
  };
}
function Gfe(e, t = !1) {
  let n = "", r = "validation";
  const o = (l) => {
    for (let u = l.length - 1; u >= n.length; u--)
      if (l[u] !== e[u])
        return l.slice(0, u + 1);
    return l.slice(0, n.length);
  }, a = [_L((l) => [0, o(l).length])];
  let i = !1;
  if (t) {
    const l = yd("focus", (d) => {
      i = !0, hc(d, d.value + e.slice(d.value.length));
    }, { capture: !0 }), u = yd("blur", (d) => {
      i = !1, hc(d, o(d.value));
    }, { capture: !0 });
    a.push(l, u);
  }
  return {
    plugins: a,
    removePlaceholder: o,
    preprocessors: [
      ({ elementState: l, data: u }, d) => {
        r = d;
        const { value: f, selection: h } = l;
        return {
          elementState: {
            selection: h,
            value: o(f)
          },
          data: u
        };
      }
    ],
    postprocessors: [
      ({ value: l, selection: u }, d) => {
        n = l;
        const f = l !== d.value && (i || !t) ? l + e.slice(l.length) : l;
        if (f === d.value && r === "deleteBackward") {
          const [h] = d.selection;
          return {
            value: f,
            selection: [h, h]
          };
        }
        return { value: f, selection: u };
      }
    ]
  };
}
new RegExp(`[${Tfe.map(zr).join("")}]$`);
function $fe({ prefix: e, postfix: t }) {
  return ({ elementState: n, data: r }) => {
    const { cleanValue: o } = wa(r, {
      prefix: e,
      postfix: t
    });
    return {
      elementState: n,
      data: o
    };
  };
}
function IL({ decimalSeparator: e, isNegativeAllowed: t, precision: n, thousandSeparator: r, prefix: o, postfix: a, decimalPseudoSeparators: i = [], pseudoMinuses: l = [], minusSign: u }) {
  const d = zb(o), f = "\\d", h = t ? `[${u}${l.map((v) => `\\${v}`).join("")}]?` : "", p = r ? `[${f}${zr(r).replaceAll(/\s/g, "\\s")}]*` : `[${f}]*`, g = n > 0 ? `([${zr(e)}${i.map(zr).join("")}]${f}{0,${Number.isFinite(n) ? n : ""}})?` : "", C = zb(a);
  return new RegExp(`^${d}${h}${p}${g}${C}$`);
}
function zb(e) {
  return e ? `${e.split("").map((t) => `${zr(t)}?`).join("")}` : "";
}
function K9(e, t = ".") {
  const n = !!e.match(new RegExp(`^\\D*[${x3}\\${sh}${AL}${ML}${xL}]`)), r = zr(t), o = e.replaceAll(new RegExp(`${r}(?!\\d)`, "g"), "").replaceAll(new RegExp(`[^\\d${r}]`, "g"), "").replace(t, ".");
  return o ? Number((n ? sh : "") + o) : NaN;
}
function Zfe(e) {
  const t = String(e), [n, r] = t.split("e-");
  let o = t;
  if (r) {
    const [, a] = n.split("."), i = Number(r) + ((a == null ? void 0 : a.length) || 0);
    o = e.toFixed(i);
  }
  return o;
}
function LL(e, { decimalSeparator: t, thousandSeparator: n }) {
  const [r = "", o = ""] = e.split(t), [, a = "", i = ""] = r.match(new RegExp(`([^\\d${zr(n)}]+)?(.*)`)) || [];
  return { minus: a, integerPart: i, decimalPart: o };
}
function jfe({ decimalSeparator: e, thousandSeparator: t, decimalPseudoSeparators: n = Efe }) {
  return n.filter((r) => r !== t && r !== e);
}
function Wfe({ decimalSeparator: e, precision: t, decimalZeroPadding: n, prefix: r, postfix: o }) {
  return t <= 0 || !n ? Ud : ({ value: a, selection: i }) => {
    const { cleanValue: l, extractedPrefix: u, extractedPostfix: d } = wa(a, {
      prefix: r,
      postfix: o
    });
    if (Number.isNaN(K9(l, e)))
      return { value: a, selection: i };
    const [f, h = ""] = l.split(e);
    return {
      value: u + f + e + h.padEnd(t, "0") + d,
      selection: i
    };
  };
}
function zfe({ prefix: e, postfix: t, decimalSeparator: n, thousandSeparator: r }) {
  return ({ value: o, selection: a }) => {
    const [i] = a, { cleanValue: l, extractedPrefix: u, extractedPostfix: d } = wa(o, {
      prefix: e,
      postfix: t
    }), { minus: f, integerPart: h, decimalPart: p } = LL(l, {
      decimalSeparator: n,
      thousandSeparator: r
    }), g = !h && !p && l.includes(n);
    return !h && !Number(p) && i === (f + u).length || g ? {
      selection: a,
      value: u + f + d
    } : { value: o, selection: a };
  };
}
function Ufe({ decimalSeparator: e, decimalPseudoSeparators: t, pseudoMinuses: n, prefix: r, postfix: o, minusSign: a }) {
  let i = !0;
  const l = IL({
    decimalSeparator: e,
    decimalPseudoSeparators: t,
    pseudoMinuses: n,
    prefix: "",
    postfix: "",
    thousandSeparator: "",
    precision: 1 / 0,
    isNegativeAllowed: !0,
    minusSign: a
  });
  return ({ elementState: u, data: d }) => {
    if (!i)
      return { elementState: u, data: d };
    i = !1;
    const { value: f, selection: h } = u, [p, g] = h, { extractedPrefix: C, cleanValue: v, extractedPostfix: y } = wa(f, {
      prefix: r,
      postfix: o
    }), M = zd({
      selection: [
        Math.max(p - C.length, 0),
        mc(g - C.length, 0, v.length)
      ],
      value: v
    }, {
      mask: l
    }), [x, _] = M.selection;
    return {
      elementState: {
        selection: [
          x + C.length,
          _ + C.length
        ],
        value: C + M.value + y
      },
      data: d
    };
  };
}
function Xfe({ decimalSeparator: e, thousandSeparator: t, prefix: n, postfix: r }) {
  const o = (i) => {
    const l = zr(t);
    return i.replace(
      // all leading zeroes followed by another zero
      new RegExp(`^(\\D+)?[0${l}]+(?=0)`),
      "$1"
    ).replace(
      // zero followed by not-zero digit
      new RegExp(`^(\\D+)?[0${l}]+(?=[1-9])`),
      "$1"
    );
  }, a = (i, l) => {
    const u = i.slice(0, l), d = i.slice(l).startsWith("0");
    return u.length - o(u).length + (d ? 1 : 0);
  };
  return ({ value: i, selection: l }) => {
    const [u, d] = l, { cleanValue: f, extractedPrefix: h, extractedPostfix: p } = wa(i, {
      prefix: n,
      postfix: r
    }), g = f.includes(e), [C, v = ""] = f.split(e), y = o(C);
    if (C === y)
      return { value: i, selection: l };
    const M = u - a(i, u), x = d - a(i, d);
    return {
      value: h + y + (g ? e : "") + v + p,
      selection: [Math.max(M, 0), Math.max(x, 0)]
    };
  };
}
function Yfe({ min: e, max: t, decimalSeparator: n, minusSign: r }) {
  return ({ value: o, selection: a }) => {
    const i = K9(o, n), l = (
      /**
       * We cannot limit lower bound if user enters positive number.
       * The same for upper bound and negative number.
       * ___
       * @example (min = 5)
       * Empty input => Without this condition user cannot type 42 (the first digit will be rejected)
       * ___
       * @example (max = -10)
       * Value is -10 => Without this condition user cannot delete 0 to enter another digit
       */
      i > 0 ? Math.min(i, t) : Math.max(i, e)
    );
    if (i && l !== i) {
      const u = `${l}`.replace(".", n).replace(sh, r);
      return {
        value: u,
        selection: [u.length, u.length]
      };
    }
    return {
      value: o,
      selection: a
    };
  };
}
function qfe({ decimalSeparator: e, thousandSeparator: t, decimalZeroPadding: n }) {
  return ({ elementState: r, data: o }, a) => {
    const { value: i, selection: l } = r, [u, d] = l, f = i.slice(u, d), h = n ? [e, t] : [t], p = n && u > i.indexOf(e) && !!f.match(/^0+$/gi);
    return a !== "deleteBackward" && a !== "deleteForward" || !h.includes(f) && !p ? {
      elementState: r,
      data: o
    } : {
      elementState: {
        value: i,
        selection: a === "deleteForward" ? [d, d] : [u, u]
      },
      data: o
    };
  };
}
function Jfe({ decimalSeparator: e, precision: t, prefix: n, postfix: r }) {
  const o = new RegExp(`^\\D*${zr(e)}`);
  return ({ elementState: a, data: i }) => {
    const { value: l, selection: u } = a, { cleanValue: d, extractedPrefix: f } = wa(l, {
      prefix: n,
      postfix: r
    }), [h, p] = u, g = mc(h - f.length, 0, d.length), C = mc(p - f.length, 0, d.length);
    if (t <= 0 || d.slice(0, g).includes(e) || d.slice(C).includes(e) || !i.match(o))
      return { elementState: a, data: i };
    const v = d.slice(0, g).match(/\d+/);
    return {
      elementState: a,
      data: v ? i : `0${i}`
    };
  };
}
function Ub({ validCharacter: e, pseudoCharacters: t, prefix: n, postfix: r }) {
  const o = new RegExp(`[${t.join("")}]`, "gi");
  return ({ elementState: a, data: i }) => {
    const { value: l, selection: u } = a, { cleanValue: d, extractedPostfix: f, extractedPrefix: h } = wa(l, {
      prefix: n,
      postfix: r
    });
    return {
      elementState: {
        selection: u,
        value: h + d.replace(o, e) + f
      },
      data: i.replace(o, e)
    };
  };
}
function Kfe({ decimalSeparator: e, prefix: t, postfix: n }) {
  return ({ elementState: r, data: o }) => {
    const { value: a, selection: i } = r, [l, u] = i, { cleanValue: d } = wa(a, { prefix: t, postfix: n });
    return {
      elementState: r,
      data: !d.includes(e) || a.slice(l, u + 1).includes(e) ? o : o.replaceAll(new RegExp(zr(e), "gi"), "")
    };
  };
}
function Qfe({ thousandSeparator: e, decimalSeparator: t, prefix: n, postfix: r }) {
  if (!e)
    return Ud;
  const o = (...a) => a.every((i) => /\s/.test(i));
  return ({ value: a, selection: i }) => {
    const { cleanValue: l, extractedPostfix: u, extractedPrefix: d } = wa(a, {
      prefix: n,
      postfix: r
    }), { minus: f, integerPart: h, decimalPart: p } = LL(l, {
      decimalSeparator: t,
      thousandSeparator: e
    }), [g, C] = i;
    let [v, y] = i;
    const M = Array.from(h).reduceRight((x, _, L) => {
      const k = !(!L && _ === e) && x.length && (x.length + 1) % 4 === 0;
      return k && (_ === e || o(_, e)) ? e + x : _ === e && !k ? (L && L <= g && v--, L && L <= C && y--, x) : k ? (L <= g && v++, L <= C && y++, _ + e + x) : _ + x;
    }, "");
    return {
      value: d + f + M + (l.includes(t) ? t : "") + p + u,
      selection: [v, y]
    };
  };
}
function e2e({ precision: e, decimalSeparator: t, prefix: n, postfix: r }) {
  if (e > 0)
    return Ud;
  const o = new RegExp(`${zr(t)}.*$`, "g");
  return ({ elementState: a, data: i }) => {
    const { value: l, selection: u } = a, { cleanValue: d, extractedPrefix: f, extractedPostfix: h } = wa(l, {
      prefix: n,
      postfix: r
    }), [p, g] = u, C = f + d.replace(o, "") + h;
    return {
      elementState: {
        selection: [
          Math.min(p, C.length),
          Math.min(g, C.length)
        ],
        value: C
      },
      data: i.replace(o, "")
    };
  };
}
const Xb = [0, 0];
function t2e({ decimalSeparator: e, thousandSeparator: t, prefix: n, postfix: r }) {
  const o = Xfe({
    decimalSeparator: e,
    thousandSeparator: t,
    prefix: n,
    postfix: r
  });
  return yd("blur", (a) => {
    const i = o({
      value: a.value,
      selection: Xb
    }, { value: "", selection: Xb }).value;
    hc(a, i);
  }, { capture: !0 });
}
function n2e({ min: e, max: t, decimalSeparator: n }) {
  return yd("blur", (r, o) => {
    const a = K9(r.value, n), i = mc(a, e, t);
    !Number.isNaN(a) && a !== i && hc(r, zd(Zfe(i), o));
  }, { capture: !0 });
}
function r2e({ decimalSeparator: e, prefix: t, postfix: n }) {
  return yd("blur", (r) => {
    const { cleanValue: o, extractedPostfix: a, extractedPrefix: i } = wa(r.value, { prefix: t, postfix: n }), l = i + o.replace(new RegExp(`^(\\D+)?${zr(e)}`), `$10${e}`) + a;
    hc(r, l);
  }, { capture: !0 });
}
function o2e({ max: e = Number.MAX_SAFE_INTEGER, min: t = Number.MIN_SAFE_INTEGER, precision: n = 0, thousandSeparator: r = Nfe, decimalSeparator: o = ".", decimalPseudoSeparators: a, decimalZeroPadding: i = !1, prefix: l = "", postfix: u = "", minusSign: d = x3 } = {}) {
  const f = [
    sh,
    AL,
    ML,
    xL,
    x3
  ].filter((g) => g !== r && g !== o && g !== d), h = jfe({
    decimalSeparator: o,
    thousandSeparator: r,
    decimalPseudoSeparators: a
  }), p = l.endsWith(o) && n > 0 ? `${l}${kfe}` : l;
  return Object.assign(Object.assign({}, J9), { mask: IL({
    decimalSeparator: o,
    precision: n,
    thousandSeparator: r,
    prefix: p,
    postfix: u,
    isNegativeAllowed: t < 0,
    minusSign: d
  }), preprocessors: [
    Ffe(),
    Ufe({
      decimalSeparator: o,
      decimalPseudoSeparators: h,
      pseudoMinuses: f,
      prefix: p,
      postfix: u,
      minusSign: d
    }),
    $fe({ prefix: p, postfix: u }),
    Ub({
      validCharacter: d,
      pseudoCharacters: f,
      prefix: p,
      postfix: u
    }),
    Ub({
      validCharacter: o,
      pseudoCharacters: h,
      prefix: p,
      postfix: u
    }),
    Jfe({
      decimalSeparator: o,
      precision: n,
      prefix: p,
      postfix: u
    }),
    qfe({
      decimalSeparator: o,
      decimalZeroPadding: i,
      thousandSeparator: r
    }),
    e2e({
      precision: n,
      decimalSeparator: o,
      prefix: p,
      postfix: u
    }),
    Kfe({
      decimalSeparator: o,
      prefix: p,
      postfix: u
    })
  ], postprocessors: [
    Yfe({ decimalSeparator: o, min: t, max: e, minusSign: d }),
    Hfe(p),
    Bfe(u),
    Qfe({
      decimalSeparator: o,
      thousandSeparator: r,
      prefix: p,
      postfix: u
    }),
    Wfe({
      decimalSeparator: o,
      decimalZeroPadding: i,
      precision: n,
      prefix: p,
      postfix: u
    }),
    zfe({ prefix: p, postfix: u, decimalSeparator: o, thousandSeparator: r })
  ], plugins: [
    t2e({
      decimalSeparator: o,
      thousandSeparator: r,
      prefix: p,
      postfix: u
    }),
    r2e({
      decimalSeparator: o,
      prefix: p,
      postfix: u
    }),
    n2e({ min: t, max: e, decimalSeparator: o })
  ], overwriteMode: i ? ({ value: g, selection: [C] }) => C <= g.indexOf(o) ? "shift" : "replace" : "shift" });
}
const Yb = typeof window < "u" ? Cc : st;
function a2e(e) {
  return e && typeof e == "object" && "then" in e;
}
const RL = ({
  options: e = null,
  elementPredicate: t = pfe
} = {}) => {
  const [n, r] = He(null), [o, a] = He(null), i = Q((u) => {
    r(u);
  }, []), l = Ve(t);
  return l.current = t, Yb(() => {
    if (!n)
      return;
    const u = t, d = u(n);
    a2e(d) ? d.then((f) => {
      l.current === u && a(f);
    }) : a(d);
  }, [n, t, l]), Yb(() => {
    if (!o || !e)
      return;
    const u = new Pfe(o, e);
    return () => {
      u.destroy();
    };
  }, [e, o]), i;
};
function i2e(e) {
  return e === "";
}
function DL(e) {
  return e === void 0;
}
function w3(e) {
  return DL(e) || typeof e == "string" && i2e(e);
}
const PL = "(___) ___-____", { removePlaceholder: s2e, ...l2e } = Gfe(PL), u2e = {
  ...l2e,
  mask: ["(", /\d/, /\d/, /\d/, ")", " ", /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/, /\d/]
}, c2e = ({
  commonProps: e,
  ...t
}) => {
  const n = RL({ options: u2e }), r = t.formatValue ?? Lc, o = () => {
    t.onChange(s2e(r(t.value)));
  }, a = w3(e.placeholder) ? PL : e.placeholder;
  return /* @__PURE__ */ A.jsx(
    jl,
    {
      icon: "phone",
      input: /* @__PURE__ */ A.jsx(
        Pr,
        {
          type: "tel",
          onInput: Ts(t.onChange, t.onClear),
          value: r(t.value),
          ...e,
          placeholder: a,
          ref: n,
          onBlur: o
        }
      )
    }
  );
}, d2e = ({
  commonProps: e,
  ...t
}) => {
  const n = q9(t.onChange, t.onClear), o = (t.formatValue ? t.formatValue : Y9)(t.value), a = /* @__PURE__ */ A.jsx(
    Pr,
    {
      ...e,
      value: o,
      onChange: n,
      type: "number",
      step: "any",
      autoComplete: "off"
    }
  );
  return t.noIcon ? a : /* @__PURE__ */ A.jsx(jl, { icon: "money-dollar-circle", input: a });
}, f2e = ({
  ref: e,
  ...t
}) => {
  const {
    min: n,
    max: r,
    resetValue: o,
    valueWhenEmpty: a,
    id: i,
    onClear: l,
    autoFocus: u,
    __dangerDoNotUseSx: d,
    ...f
  } = t, h = () => {
    if (!Mt(n) && !Mt(r))
      return;
    const v = parseFloat(t.value);
    let y;
    return Mt(n) && v < n && (y = o ?? n), Mt(r) && v > r && (y = o ?? r), y;
  }, p = () => {
    var y, M;
    const v = h();
    Mt(v) ? (t.onChange(v), (y = t.onBlur) == null || y.call(t)) : (M = t.onBlur) == null || M.call(t);
  }, g = f.onKeyDown ? (v) => {
    const y = h() ?? t.value;
    f.onKeyDown(v, y);
  } : void 0, C = {
    ...f,
    value: Mt(t.value) ? t.value : "",
    onBlur: p,
    onChange: (v, y) => {
      const M = Number.isNaN(y) ? a : y;
      t.onChange(M);
    },
    onKeyDown: g
  };
  return /* @__PURE__ */ A.jsxs(xw, { ...C, clampValueOnBlur: !1, children: [
    /* @__PURE__ */ A.jsx(_w, { ref: e }),
    Mt(C.step) && /* @__PURE__ */ A.jsxs(ww, { children: [
      /* @__PURE__ */ A.jsx(Rw, {}),
      /* @__PURE__ */ A.jsx(Lw, {})
    ] })
  ] });
}, h2e = ({
  commonProps: e,
  ...t
}) => {
  const n = t.formatValue ?? Lc, r = Ts(t.onChange, t.onClear);
  return /* @__PURE__ */ A.jsx(
    jl,
    {
      icon: "search",
      input: /* @__PURE__ */ A.jsx(
        Pr,
        {
          ...e,
          type: "text",
          onChange: r,
          value: n(t.value)
        }
      )
    }
  );
}, m2e = ({
  commonProps: e,
  ...t
}) => /* @__PURE__ */ A.jsx(
  Pr,
  {
    ...e,
    type: "text",
    value: t.formatValue ? t.formatValue(t.value) : t.value ?? "",
    onChange: Ts(t.onChange, t.onClear)
  }
), no = (e) => e, Ns = Ke(
  (e, t) => {
    const n = ym(), r = Ve(null), o = {
      id: e.id,
      sx: e.__dangerDoNotUseSx,
      ref: t ?? r,
      "data-testid": e.__testId ?? e.id,
      placeholder: e.placeholderText,
      onKeyDown: e.onKeyDown,
      onFocus: e.onFocus,
      onMouseDown: e.onMouseDown,
      onBlur: () => {
        var a;
        return (a = e.onBlur) == null ? void 0 : a.call(e);
      },
      border: e.border,
      borderRadius: e.borderRadius,
      boxShadow: e.boxShadow,
      size: n
    };
    switch (j0e(e.autoFocus, t, r), U0e(e.type, o.ref), e.type) {
      case "text": {
        const a = no(e.value);
        return /* @__PURE__ */ A.jsx(m2e, { ...e, commonProps: o, value: a });
      }
      case "search": {
        const a = no(e.value);
        return /* @__PURE__ */ A.jsx(h2e, { ...e, commonProps: o, value: a });
      }
      case "multiline": {
        const a = no(e.value), { ref: i, ...l } = o;
        return /* @__PURE__ */ A.jsx(
          ufe,
          {
            ...e,
            commonProps: l,
            value: a,
            ref: t
          }
        );
      }
      case "location": {
        const a = no(e.value);
        return /* @__PURE__ */ A.jsx(sfe, { ...e, commonProps: o, value: a });
      }
      case "locationAddressAutocomplete": {
        const a = no(e.value);
        return /* @__PURE__ */ A.jsx(afe, { ...e, commonProps: o, value: a });
      }
      case "number": {
        const a = no(e.value);
        return /* @__PURE__ */ A.jsx(cfe, { ...e, commonProps: o, value: a });
      }
      case "percent": {
        const a = no(e.value);
        return /* @__PURE__ */ A.jsx(dfe, { ...e, commonProps: o, value: a });
      }
      case "range":
        return /* @__PURE__ */ A.jsx(f2e, { ...e });
      case "aloftArea": {
        const a = no(e.value);
        return /* @__PURE__ */ A.jsx(efe, { ...e, commonProps: o, value: a });
      }
      case "aloftCount":
        return /* @__PURE__ */ A.jsx(tfe, { ...e, ref: t });
      case "price": {
        const a = no(e.value);
        return /* @__PURE__ */ A.jsx(d2e, { ...e, commonProps: o, value: a });
      }
      case "aloftPrice": {
        const a = no(e.value);
        return /* @__PURE__ */ A.jsx(K0e, { ...e, ref: t, value: a });
      }
      case "email": {
        const a = no(e.value);
        return /* @__PURE__ */ A.jsx(rfe, { ...e, commonProps: o, value: a });
      }
      case "aloftEmail":
        return /* @__PURE__ */ A.jsx(Y0e, { ...e, ref: t });
      case "date": {
        const a = no(e.value);
        return /* @__PURE__ */ A.jsx(nfe, { ...e, commonProps: o, value: a });
      }
      case "month": {
        const a = no(e.value);
        return /* @__PURE__ */ A.jsx(lfe, { ...e, commonProps: o, value: a });
      }
      case "aloftDate":
        return /* @__PURE__ */ A.jsx(X0e, { ...e, ref: t });
      case "aloftMonth":
        return /* @__PURE__ */ A.jsx(q0e, { ...e, ref: t });
      case "phone": {
        const a = no(e.value);
        return /* @__PURE__ */ A.jsx(c2e, { ...e, commonProps: o, value: a });
      }
      case "aloftPhone":
        return /* @__PURE__ */ A.jsx(J0e, { ...e, ref: t });
      default:
        return t_(e), null;
    }
  }
);
Ns.displayName = "BaseInput";
const u4e = Ke((e, t) => {
  const [n, r] = He(), {
    id: o,
    isDisabled: a,
    isReadonly: i,
    isInvalid: l,
    isRequired: u,
    helperText: d,
    errorText: f,
    label: h,
    ariaLabel: p,
    size: g = "md",
    variant: C,
    clearable: v,
    ...y
  } = e;
  return Es(
    {
      id: o,
      isDisabled: a,
      isReadonly: i,
      isRequired: u,
      isInvalid: l,
      helperText: d,
      errorText: f,
      internalFormWrapperErrorText: n,
      label: h,
      ariaLabel: p,
      size: g,
      variant: C,
      clearable: v
    },
    /* @__PURE__ */ A.jsx(
      Ns,
      {
        id: e.id,
        ref: t,
        ...y,
        setInternalFormWrapperErrorText: r
      }
    )
  );
}), p2e = (e, t) => {
  const n = ym(), {
    onChange: r,
    onFocus: o,
    onBlur: a,
    __dangerDoNotUseSx: i,
    placeholder: l,
    options: u,
    value: d,
    border: f = !0,
    radius: h = !0
  } = e;
  return /* @__PURE__ */ A.jsx(
    Hw,
    {
      border: f ? void 0 : "hidden",
      borderRadius: h ? void 0 : "none",
      ref: t,
      onChange: (p) => {
        const { value: g } = p.currentTarget;
        r(g === "" ? void 0 : g, p);
      },
      onFocus: o,
      onBlur: a,
      sx: i,
      size: n,
      placeholder: l,
      value: d,
      children: u.map(({ label: p, value: g }) => /* @__PURE__ */ A.jsx("option", { value: g, children: p }, g))
    }
  );
}, g2e = Ke(p2e), v2e = (e, t) => {
  const { variant: n = "native" } = e;
  switch (n) {
    case "native":
      return Es(e, /* @__PURE__ */ A.jsx(g2e, { ...e, ref: t }));
    default:
      return null;
  }
}, c4e = Ke(v2e), d4e = (e) => e.map((t) => ({ value: t, label: Xh.startCase(t) })), f4e = Ke((e, t) => /* @__PURE__ */ A.jsx(Bi, { ref: t, ...e, display: "grid" })), C2e = Ke((e, t) => /* @__PURE__ */ A.jsx(Bi, { ref: t, ...e, display: "block" })), b2e = ({ width: e, height: t }) => /* @__PURE__ */ A.jsxs("svg", { width: e, height: t, viewBox: "0 0 200 200", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ A.jsx("path", { d: "M72.3229 169.049L86.4221 165.965L62.4673 162.46L72.3229 169.049Z", fill: "#3C70A7" }),
  /* @__PURE__ */ A.jsx(
    "path",
    {
      d: "M43.6861 69.4804L64.0226 88.1552L77.2991 140.806L98.9435 98.7906L87.301 76.5295L43.6861 69.4804Z",
      fill: "#3C70A7"
    }
  ),
  /* @__PURE__ */ A.jsx("path", { d: "M41.653 65.4667L83.0325 71.8327L37.0788 47.4518L41.653 65.4667Z", fill: "#1F364E" }),
  /* @__PURE__ */ A.jsx("path", { d: "M117.659 54.2922L152.739 80.3563L126.191 26.4058L117.659 54.2922Z", fill: "#1F364E" }),
  /* @__PURE__ */ A.jsx(
    "path",
    {
      d: "M132.239 134.244L151.254 84.5434L116.486 58.3245L112.456 81.6043L78.2202 147.134L41.9506 155.788L111.571 165.116L154.879 148.766L168.363 150.105L167.04 147.462L157.788 143.938L149.417 136.447L132.239 134.244Z",
      fill: "#73A9EF"
    }
  )
] });
const h4e = ({ light: e, message: t, __testId: n }) => /* @__PURE__ */ A.jsxs("div", { className: "loading-indicator", "data-testid": n, children: [
  /* @__PURE__ */ A.jsx(b2e, { width: 100, height: 100 }),
  Ti(t) ? /* @__PURE__ */ A.jsx(lo, { color: e ? "textOffset" : void 0, children: t }) : null
] });
function y2e({ children: e }) {
  return /* @__PURE__ */ A.jsx(lo, { variant: "h3", __dangerDoNotUseSx: { fontWeight: "normal" }, children: e });
}
const S2e = ({ canDismiss: e, status: t, description: n, title: r }) => {
  const [o, a] = He(!0), i = () => {
    e && a(!1);
  };
  return o ? /* @__PURE__ */ A.jsxs(
    w4,
    {
      status: t,
      position: "sticky",
      top: 0,
      width: "100vw",
      zIndex: 999999,
      className: "sui-banner",
      children: [
        /* @__PURE__ */ A.jsx(_4, {}),
        /* @__PURE__ */ A.jsxs(fc, { gap: "8px", children: [
          !!r && /* @__PURE__ */ A.jsx(lo, { variant: "h3", children: r }),
          typeof n == "string" ? /* @__PURE__ */ A.jsx(y2e, { children: n }) : n
        ] }),
        e && /* @__PURE__ */ A.jsx(Td, { onClick: i, position: "absolute", right: "4" })
      ]
    }
  ) : null;
}, m4e = () => {
  const [e, t] = He(navigator.onLine);
  return st(() => {
    const n = () => t(!0), r = () => t(!1);
    return window.addEventListener("offline", r), window.addEventListener("online", n), () => {
      window.removeEventListener("online", n), window.removeEventListener("offline", r);
    };
  }, []), e ? null : /* @__PURE__ */ A.jsx(
    S2e,
    {
      status: "error",
      title: "You are Offline",
      description: "You are not connected to the internet. We cannot guarantee your changes will be saved! Please restore your internet connection before proceeding.",
      canDismiss: !1
    }
  );
}, A2e = ({
  content: e,
  title: t
}) => /* @__PURE__ */ A.jsx(fd, { borderWidth: "1px", borderBottomColor: "strokeDefault", children: /* @__PURE__ */ A.jsx(VM, { children: /* @__PURE__ */ A.jsxs(fd, { height: "1.5rem", width: "100%", justifyContent: "space-between", alignItems: "center", children: [
  e && e,
  t && /* @__PURE__ */ A.jsx(lo, { variant: "h5", children: t }),
  /* @__PURE__ */ A.jsx(OM, {})
] }) }) }), p4e = ({
  panels: e,
  panelState: t
}) => {
  const { index: n, onChange: r } = t || {}, [o, a] = He(
    () => Object.keys(e).map((u) => +u)
  ), i = n ?? o, l = r ?? a;
  return /* @__PURE__ */ A.jsx(
    kM,
    {
      variant: "default",
      width: "full",
      index: i,
      onChange: l,
      allowToggle: !0,
      children: e.map(({ id: u, body: d, ...f }) => /* @__PURE__ */ A.jsxs(FM, { children: [
        /* @__PURE__ */ A.jsx(A2e, { ...f }),
        /* @__PURE__ */ A.jsx(HM, { paddingBottom: 4, children: d })
      ] }, u))
    }
  );
}, g4e = (e) => {
  const {
    children: t,
    variant: n,
    header: r,
    headerProps: o,
    drawerContentProps: a,
    footer: i,
    footerProps: l,
    bodyProps: u,
    ...d
  } = e;
  return /* @__PURE__ */ A.jsxs(jte, { ...d, children: [
    n === "overlay" && /* @__PURE__ */ A.jsx(f9, {}),
    /* @__PURE__ */ A.jsxs(Mw, { ...a, children: [
      Ti(r) && /* @__PURE__ */ A.jsx(d9, { ...o, children: r }),
      /* @__PURE__ */ A.jsx(u9, { ...u, children: t }),
      Ti(i) && /* @__PURE__ */ A.jsx(c9, { ...l, children: i })
    ] })
  ] });
}, v4e = ({
  __testId: e,
  unit: t,
  stat: n,
  __dangerDoNotUseSx: r,
  labelSx: o,
  statSx: a
}) => /* @__PURE__ */ A.jsxs(xe.div, { "data-testid": e, sx: r, children: [
  /* @__PURE__ */ A.jsx(lo, { variant: "h2", __dangerDoNotUseSx: a, children: `${n}` }),
  /* @__PURE__ */ A.jsx(lo, { variant: "tableH3", color: "textTertiary", __dangerDoNotUseSx: o, truncate: !0, children: t })
] }), EL = Ke(
  (e, t) => {
    const {
      __testId: n,
      onChange: r,
      value: o,
      isDisabled: a,
      isReadonly: i,
      isInvalid: l,
      isRequired: u,
      size: d,
      __dangerDoNotUseSx: f
    } = e, h = (p) => {
      r(!!p.target.checked);
    };
    return /* @__PURE__ */ A.jsx(
      jw,
      {
        "data-testid": n,
        ref: t,
        isChecked: o,
        onChange: h,
        isDisabled: a,
        isReadOnly: i,
        isInvalid: l,
        isRequired: u,
        size: d,
        sx: f
      }
    );
  }
);
EL.displayName = "Switch";
const C4e = Ke((e, t) => {
  const { __testId: n, label: r, ...o } = e;
  return Es(
    o,
    /* @__PURE__ */ A.jsxs(fc, { alignItems: "center", gap: ".5rem", children: [
      /* @__PURE__ */ A.jsx(EL, { __testId: n, ref: t, ...o }),
      /* @__PURE__ */ A.jsx(lo, { variant: "h4", children: r })
    ] })
  );
});
function Sd() {
  return Sd = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Sd.apply(this, arguments);
}
function Q9(e, t) {
  if (e == null)
    return {};
  var n = {}, r = Object.keys(e), o, a;
  for (a = 0; a < r.length; a++)
    o = r[a], !(t.indexOf(o) >= 0) && (n[o] = e[o]);
  return n;
}
function M2e(e) {
  if (e === null || e === !0 || e === !1)
    return NaN;
  var t = Number(e);
  return isNaN(t) ? t : t < 0 ? Math.ceil(t) : Math.floor(t);
}
function pc(e) {
  if (arguments.length < 1)
    throw new TypeError("1 argument required, but only " + arguments.length + " present");
  var t = Object.prototype.toString.call(e);
  return e instanceof Date || typeof e == "object" && t === "[object Date]" ? new Date(e.getTime()) : typeof e == "number" || t === "[object Number]" ? new Date(e) : ((typeof e == "string" || t === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
}
function Am(e, t) {
  if (arguments.length < 2)
    throw new TypeError("2 arguments required, but only " + arguments.length + " present");
  var n = pc(e), r = M2e(t);
  return n.setDate(n.getDate() + r), n;
}
function gc(e, t) {
  if (arguments.length < 2)
    throw new TypeError("2 arguments required, but only " + arguments.length + " present");
  var n = pc(e), r = pc(t);
  return n.getTime() < r.getTime();
}
function Al(e) {
  if (arguments.length < 1)
    throw new TypeError("1 argument required, but only " + arguments.length + " present");
  var t = pc(e);
  return t.setHours(0, 0, 0, 0), t;
}
function x2e(e, t) {
  if (arguments.length < 2)
    throw new TypeError("2 arguments required, but only " + arguments.length + " present");
  var n = Al(e), r = Al(t);
  return n.getTime() === r.getTime();
}
function w2e(e) {
  if (arguments.length < 1)
    throw new TypeError("1 argument required, but only " + arguments.length + " present");
  return x2e(e, Date.now());
}
function TL(e, t) {
  if (arguments.length < 2)
    throw new TypeError("2 arguments required, but only " + arguments.length + " present");
  var n = pc(e), r = pc(t), o = n.getFullYear() - r.getFullYear(), a = n.getMonth() - r.getMonth();
  return o * 12 + a;
}
function e7() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return function(r) {
    for (var o = arguments.length, a = new Array(o > 1 ? o - 1 : 0), i = 1; i < o; i++)
      a[i - 1] = arguments[i];
    return t.some(function(l) {
      return l && l.apply(void 0, [r].concat(a)), r.defaultPrevented;
    });
  };
}
function t7(e, t) {
  throw new Error('The property "' + t + '" is required in "' + e + '"');
}
function _2e(e) {
  var t = e.calendars, n = e.offset, r = e.minDate;
  if (n > 1 && r) {
    var o = t[0].firstDayOfMonth, a = TL(o, r);
    a < n && (n = a);
  }
  return n;
}
function I2e(e) {
  var t = e.calendars, n = e.offset, r = e.maxDate;
  if (n > 1 && r) {
    var o = t[t.length - 1].lastDayOfMonth, a = TL(r, o);
    a < n && (n = a);
  }
  return n;
}
function L2e(e) {
  var t = e.calendars, n = e.minDate;
  if (!n)
    return !1;
  var r = t[0].firstDayOfMonth, o = Am(r, -1);
  return !!gc(o, n);
}
function R2e(e) {
  var t = e.calendars, n = e.maxDate;
  if (!n)
    return !1;
  var r = t[t.length - 1].lastDayOfMonth, o = Am(r, 1);
  return !!gc(n, o);
}
function D2e(e) {
  for (var t = e.date, n = e.selected, r = e.monthsToDisplay, o = e.offset, a = e.minDate, i = e.maxDate, l = e.firstDayOfWeek, u = e.showOutsideDays, d = [], f = P2e(t, a, i), h = 0; h < r; h++) {
    var p = E2e({
      month: f.getMonth() + h + o,
      year: f.getFullYear(),
      selectedDates: n,
      minDate: a,
      maxDate: i,
      firstDayOfWeek: l,
      showOutsideDays: u
    });
    d.push(p);
  }
  return d;
}
function P2e(e, t, n) {
  var r = Al(e);
  if (t) {
    var o = Al(t);
    gc(r, o) && (r = o);
  }
  if (n) {
    var a = Al(n);
    gc(a, r) && (r = a);
  }
  return r;
}
function E2e(e) {
  var t = e.month, n = e.year, r = e.selectedDates, o = e.minDate, a = e.maxDate, i = e.firstDayOfWeek, l = e.showOutsideDays, u = k2e(t, n), d = u.daysInMonth;
  t = u.month, n = u.year;
  for (var f = [], h = 1; h <= d; h++) {
    var p = new Date(n, t, h), g = {
      date: p,
      selected: n7(r, p),
      selectable: r7(o, a, p),
      today: w2e(p),
      prevMonth: !1,
      nextMonth: !1
    };
    f.push(g);
  }
  var C = new Date(n, t, 1), v = new Date(n, t, d), y = T2e({
    firstDayOfMonth: C,
    minDate: o,
    maxDate: a,
    selectedDates: r,
    firstDayOfWeek: i,
    showOutsideDays: l
  }), M = N2e({
    lastDayOfMonth: v,
    minDate: o,
    maxDate: a,
    selectedDates: r,
    firstDayOfWeek: i,
    showOutsideDays: l
  });
  f.unshift.apply(f, y), f.push.apply(f, M);
  var x = V2e(f);
  return {
    firstDayOfMonth: C,
    lastDayOfMonth: v,
    month: t,
    year: n,
    weeks: x
  };
}
function T2e(e) {
  var t = e.firstDayOfMonth, n = e.minDate, r = e.maxDate, o = e.selectedDates, a = e.firstDayOfWeek, i = e.showOutsideDays, l = [], u = (t.getDay() + 7 - a) % 7;
  if (i)
    for (var d = Am(t, -1), f = d.getDate(), h = d.getMonth(), p = d.getFullYear(), g = 0; g < u; ) {
      var C = new Date(p, h, f - g), v = {
        date: C,
        selected: n7(o, C),
        selectable: r7(n, r, C),
        today: !1,
        prevMonth: !0,
        nextMonth: !1
      };
      l.unshift(v), g++;
    }
  else
    for (; u > 0; )
      l.unshift(""), u--;
  return l;
}
function N2e(e) {
  var t = e.lastDayOfMonth, n = e.minDate, r = e.maxDate, o = e.selectedDates, a = e.firstDayOfWeek, i = e.showOutsideDays, l = [], u = (t.getDay() + 7 - a) % 7;
  if (i)
    for (var d = Am(t, 1), f = d.getMonth(), h = d.getFullYear(), p = 0; p < 6 - u; ) {
      var g = new Date(h, f, 1 + p), C = {
        date: g,
        selected: n7(o, g),
        selectable: r7(n, r, g),
        today: !1,
        prevMonth: !1,
        nextMonth: !0
      };
      l.push(C), p++;
    }
  else
    for (; u < 6; )
      l.push(""), u++;
  return l;
}
function k2e(e, t) {
  var n = new Date(t, e, 1);
  e = n.getMonth(), t = n.getFullYear();
  var r = 32 - new Date(t, e, 32).getDate();
  return {
    daysInMonth: r,
    month: e,
    year: t
  };
}
function V2e(e) {
  for (var t = Math.ceil(e.length / 7), n = [], r = 0; r < t; r++) {
    n[r] = [];
    for (var o = 0; o < 7; o++)
      n[r].push(e[r * 7 + o]);
  }
  return n;
}
function n7(e, t) {
  return e = Array.isArray(e) ? e : [e], e.some(function(n) {
    return n instanceof Date && Al(n).getTime() === Al(t).getTime();
  });
}
function r7(e, t, n) {
  return !(e && gc(n, e) || t && gc(t, n));
}
function NL(e) {
  return e !== void 0;
}
function O2e(e, t) {
  return NL(e) ? e : t;
}
function F2e(e, t) {
  var n = t === void 0 ? {} : t, r = n.onClick, o = n.dateObj, a = o === void 0 ? t7("getDateProps", "dateObj") : o, i = Q9(n, ["onClick", "dateObj"]);
  return Sd({
    onClick: e7(r, function(l) {
      e(a, l);
    }),
    disabled: !a.selectable,
    "aria-label": a.date.toDateString(),
    "aria-pressed": a.selected,
    role: "button"
  }, i);
}
function B2e(e, t) {
  var n = e.minDate, r = e.offsetMonth, o = e.handleOffsetChanged, a = t === void 0 ? {} : t, i = a.onClick, l = a.offset, u = l === void 0 ? 1 : l, d = a.calendars, f = d === void 0 ? t7("getBackProps", "calendars") : d, h = Q9(a, ["onClick", "offset", "calendars"]);
  return Sd({
    onClick: e7(i, function() {
      o(r - _2e({
        calendars: f,
        offset: u,
        minDate: n
      }));
    }),
    disabled: L2e({
      calendars: f,
      offset: u,
      minDate: n
    }),
    "aria-label": "Go back " + u + " month" + (u === 1 ? "" : "s")
  }, h);
}
function H2e(e, t) {
  var n = e.maxDate, r = e.offsetMonth, o = e.handleOffsetChanged, a = t === void 0 ? {} : t, i = a.onClick, l = a.offset, u = l === void 0 ? 1 : l, d = a.calendars, f = d === void 0 ? t7("getForwardProps", "calendars") : d, h = Q9(a, ["onClick", "offset", "calendars"]);
  return Sd({
    onClick: e7(i, function() {
      o(r + I2e({
        calendars: f,
        offset: u,
        maxDate: n
      }));
    }),
    disabled: R2e({
      calendars: f,
      offset: u,
      maxDate: n
    }),
    "aria-label": "Go forward " + u + " month" + (u === 1 ? "" : "s")
  }, h);
}
function G2e(e) {
  var t = e.date, n = t === void 0 ? /* @__PURE__ */ new Date() : t, r = e.maxDate, o = e.minDate, a = e.monthsToDisplay, i = a === void 0 ? 1 : a, l = e.firstDayOfWeek, u = l === void 0 ? 0 : l, d = e.showOutsideDays, f = d === void 0 ? !1 : d, h = e.offset, p = e.onDateSelected, g = e.onOffsetChanged, C = g === void 0 ? function() {
  } : g, v = e.selected, y = He(0), M = y[0], x = y[1], _ = O2e(h, M);
  function L(k) {
    NL(h) || x(k), C(k);
  }
  var R = D2e({
    date: n,
    selected: v,
    monthsToDisplay: i,
    minDate: o,
    maxDate: r,
    offset: _,
    firstDayOfWeek: u,
    showOutsideDays: f
  });
  return {
    calendars: R,
    getDateProps: F2e.bind(null, p),
    getBackProps: B2e.bind(null, {
      minDate: o,
      offsetMonth: _,
      handleOffsetChanged: L
    }),
    getForwardProps: H2e.bind(null, {
      maxDate: r,
      offsetMonth: _,
      handleOffsetChanged: L
    })
  };
}
Lr.func, Lr.func, Lr.instanceOf(Date), Lr.instanceOf(Date), Lr.instanceOf(Date), Lr.number, Lr.number, Lr.bool, Lr.number, Lr.func.isRequired, Lr.func, Lr.oneOfType([Lr.arrayOf(Date), Lr.instanceOf(Date)]);
function kl(e) {
  if (e === null || e === !0 || e === !1)
    return NaN;
  var t = Number(e);
  return isNaN(t) ? t : t < 0 ? Math.ceil(t) : Math.floor(t);
}
function qr(e, t) {
  if (t.length < e)
    throw new TypeError(e + " argument" + (e > 1 ? "s" : "") + " required, but only " + t.length + " present");
}
function Ya(e) {
  qr(1, arguments);
  var t = Object.prototype.toString.call(e);
  return e instanceof Date || Li(e) === "object" && t === "[object Date]" ? new Date(e.getTime()) : typeof e == "number" || t === "[object Number]" ? new Date(e) : ((typeof e == "string" || t === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
}
function $2e(e, t) {
  qr(2, arguments);
  var n = Ya(e).getTime(), r = kl(t);
  return new Date(n + r);
}
var Z2e = {};
function Mm() {
  return Z2e;
}
function j2e(e) {
  var t = new Date(Date.UTC(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes(), e.getSeconds(), e.getMilliseconds()));
  return t.setUTCFullYear(e.getFullYear()), e.getTime() - t.getTime();
}
function W2e(e) {
  return qr(1, arguments), e instanceof Date || Li(e) === "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function z2e(e) {
  if (qr(1, arguments), !W2e(e) && typeof e != "number")
    return !1;
  var t = Ya(e);
  return !isNaN(Number(t));
}
function U2e(e, t) {
  qr(2, arguments);
  var n = kl(t);
  return $2e(e, -n);
}
var X2e = 864e5;
function Y2e(e) {
  qr(1, arguments);
  var t = Ya(e), n = t.getTime();
  t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
  var r = t.getTime(), o = n - r;
  return Math.floor(o / X2e) + 1;
}
function lh(e) {
  qr(1, arguments);
  var t = 1, n = Ya(e), r = n.getUTCDay(), o = (r < t ? 7 : 0) + r - t;
  return n.setUTCDate(n.getUTCDate() - o), n.setUTCHours(0, 0, 0, 0), n;
}
function kL(e) {
  qr(1, arguments);
  var t = Ya(e), n = t.getUTCFullYear(), r = /* @__PURE__ */ new Date(0);
  r.setUTCFullYear(n + 1, 0, 4), r.setUTCHours(0, 0, 0, 0);
  var o = lh(r), a = /* @__PURE__ */ new Date(0);
  a.setUTCFullYear(n, 0, 4), a.setUTCHours(0, 0, 0, 0);
  var i = lh(a);
  return t.getTime() >= o.getTime() ? n + 1 : t.getTime() >= i.getTime() ? n : n - 1;
}
function q2e(e) {
  qr(1, arguments);
  var t = kL(e), n = /* @__PURE__ */ new Date(0);
  n.setUTCFullYear(t, 0, 4), n.setUTCHours(0, 0, 0, 0);
  var r = lh(n);
  return r;
}
var J2e = 6048e5;
function K2e(e) {
  qr(1, arguments);
  var t = Ya(e), n = lh(t).getTime() - q2e(t).getTime();
  return Math.round(n / J2e) + 1;
}
function uh(e, t) {
  var n, r, o, a, i, l, u, d;
  qr(1, arguments);
  var f = Mm(), h = kl((n = (r = (o = (a = t == null ? void 0 : t.weekStartsOn) !== null && a !== void 0 ? a : t == null || (i = t.locale) === null || i === void 0 || (l = i.options) === null || l === void 0 ? void 0 : l.weekStartsOn) !== null && o !== void 0 ? o : f.weekStartsOn) !== null && r !== void 0 ? r : (u = f.locale) === null || u === void 0 || (d = u.options) === null || d === void 0 ? void 0 : d.weekStartsOn) !== null && n !== void 0 ? n : 0);
  if (!(h >= 0 && h <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var p = Ya(e), g = p.getUTCDay(), C = (g < h ? 7 : 0) + g - h;
  return p.setUTCDate(p.getUTCDate() - C), p.setUTCHours(0, 0, 0, 0), p;
}
function VL(e, t) {
  var n, r, o, a, i, l, u, d;
  qr(1, arguments);
  var f = Ya(e), h = f.getUTCFullYear(), p = Mm(), g = kl((n = (r = (o = (a = t == null ? void 0 : t.firstWeekContainsDate) !== null && a !== void 0 ? a : t == null || (i = t.locale) === null || i === void 0 || (l = i.options) === null || l === void 0 ? void 0 : l.firstWeekContainsDate) !== null && o !== void 0 ? o : p.firstWeekContainsDate) !== null && r !== void 0 ? r : (u = p.locale) === null || u === void 0 || (d = u.options) === null || d === void 0 ? void 0 : d.firstWeekContainsDate) !== null && n !== void 0 ? n : 1);
  if (!(g >= 1 && g <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var C = /* @__PURE__ */ new Date(0);
  C.setUTCFullYear(h + 1, 0, g), C.setUTCHours(0, 0, 0, 0);
  var v = uh(C, t), y = /* @__PURE__ */ new Date(0);
  y.setUTCFullYear(h, 0, g), y.setUTCHours(0, 0, 0, 0);
  var M = uh(y, t);
  return f.getTime() >= v.getTime() ? h + 1 : f.getTime() >= M.getTime() ? h : h - 1;
}
function Q2e(e, t) {
  var n, r, o, a, i, l, u, d;
  qr(1, arguments);
  var f = Mm(), h = kl((n = (r = (o = (a = t == null ? void 0 : t.firstWeekContainsDate) !== null && a !== void 0 ? a : t == null || (i = t.locale) === null || i === void 0 || (l = i.options) === null || l === void 0 ? void 0 : l.firstWeekContainsDate) !== null && o !== void 0 ? o : f.firstWeekContainsDate) !== null && r !== void 0 ? r : (u = f.locale) === null || u === void 0 || (d = u.options) === null || d === void 0 ? void 0 : d.firstWeekContainsDate) !== null && n !== void 0 ? n : 1), p = VL(e, t), g = /* @__PURE__ */ new Date(0);
  g.setUTCFullYear(p, 0, h), g.setUTCHours(0, 0, 0, 0);
  var C = uh(g, t);
  return C;
}
var ehe = 6048e5;
function the(e, t) {
  qr(1, arguments);
  var n = Ya(e), r = uh(n, t).getTime() - Q2e(n, t).getTime();
  return Math.round(r / ehe) + 1;
}
function dn(e, t) {
  for (var n = e < 0 ? "-" : "", r = Math.abs(e).toString(); r.length < t; )
    r = "0" + r;
  return n + r;
}
var nhe = {
  // Year
  y: function(t, n) {
    var r = t.getUTCFullYear(), o = r > 0 ? r : 1 - r;
    return dn(n === "yy" ? o % 100 : o, n.length);
  },
  // Month
  M: function(t, n) {
    var r = t.getUTCMonth();
    return n === "M" ? String(r + 1) : dn(r + 1, 2);
  },
  // Day of the month
  d: function(t, n) {
    return dn(t.getUTCDate(), n.length);
  },
  // AM or PM
  a: function(t, n) {
    var r = t.getUTCHours() / 12 >= 1 ? "pm" : "am";
    switch (n) {
      case "a":
      case "aa":
        return r.toUpperCase();
      case "aaa":
        return r;
      case "aaaaa":
        return r[0];
      case "aaaa":
      default:
        return r === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h: function(t, n) {
    return dn(t.getUTCHours() % 12 || 12, n.length);
  },
  // Hour [0-23]
  H: function(t, n) {
    return dn(t.getUTCHours(), n.length);
  },
  // Minute
  m: function(t, n) {
    return dn(t.getUTCMinutes(), n.length);
  },
  // Second
  s: function(t, n) {
    return dn(t.getUTCSeconds(), n.length);
  },
  // Fraction of second
  S: function(t, n) {
    var r = n.length, o = t.getUTCMilliseconds(), a = Math.floor(o * Math.pow(10, r - 3));
    return dn(a, n.length);
  }
};
const os = nhe;
var _u = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, rhe = {
  // Era
  G: function(t, n, r) {
    var o = t.getUTCFullYear() > 0 ? 1 : 0;
    switch (n) {
      case "G":
      case "GG":
      case "GGG":
        return r.era(o, {
          width: "abbreviated"
        });
      case "GGGGG":
        return r.era(o, {
          width: "narrow"
        });
      case "GGGG":
      default:
        return r.era(o, {
          width: "wide"
        });
    }
  },
  // Year
  y: function(t, n, r) {
    if (n === "yo") {
      var o = t.getUTCFullYear(), a = o > 0 ? o : 1 - o;
      return r.ordinalNumber(a, {
        unit: "year"
      });
    }
    return os.y(t, n);
  },
  // Local week-numbering year
  Y: function(t, n, r, o) {
    var a = VL(t, o), i = a > 0 ? a : 1 - a;
    if (n === "YY") {
      var l = i % 100;
      return dn(l, 2);
    }
    return n === "Yo" ? r.ordinalNumber(i, {
      unit: "year"
    }) : dn(i, n.length);
  },
  // ISO week-numbering year
  R: function(t, n) {
    var r = kL(t);
    return dn(r, n.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(t, n) {
    var r = t.getUTCFullYear();
    return dn(r, n.length);
  },
  // Quarter
  Q: function(t, n, r) {
    var o = Math.ceil((t.getUTCMonth() + 1) / 3);
    switch (n) {
      case "Q":
        return String(o);
      case "QQ":
        return dn(o, 2);
      case "Qo":
        return r.ordinalNumber(o, {
          unit: "quarter"
        });
      case "QQQ":
        return r.quarter(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return r.quarter(o, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return r.quarter(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(t, n, r) {
    var o = Math.ceil((t.getUTCMonth() + 1) / 3);
    switch (n) {
      case "q":
        return String(o);
      case "qq":
        return dn(o, 2);
      case "qo":
        return r.ordinalNumber(o, {
          unit: "quarter"
        });
      case "qqq":
        return r.quarter(o, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return r.quarter(o, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return r.quarter(o, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(t, n, r) {
    var o = t.getUTCMonth();
    switch (n) {
      case "M":
      case "MM":
        return os.M(t, n);
      case "Mo":
        return r.ordinalNumber(o + 1, {
          unit: "month"
        });
      case "MMM":
        return r.month(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return r.month(o, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return r.month(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone month
  L: function(t, n, r) {
    var o = t.getUTCMonth();
    switch (n) {
      case "L":
        return String(o + 1);
      case "LL":
        return dn(o + 1, 2);
      case "Lo":
        return r.ordinalNumber(o + 1, {
          unit: "month"
        });
      case "LLL":
        return r.month(o, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return r.month(o, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return r.month(o, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Local week of year
  w: function(t, n, r, o) {
    var a = the(t, o);
    return n === "wo" ? r.ordinalNumber(a, {
      unit: "week"
    }) : dn(a, n.length);
  },
  // ISO week of year
  I: function(t, n, r) {
    var o = K2e(t);
    return n === "Io" ? r.ordinalNumber(o, {
      unit: "week"
    }) : dn(o, n.length);
  },
  // Day of the month
  d: function(t, n, r) {
    return n === "do" ? r.ordinalNumber(t.getUTCDate(), {
      unit: "date"
    }) : os.d(t, n);
  },
  // Day of year
  D: function(t, n, r) {
    var o = Y2e(t);
    return n === "Do" ? r.ordinalNumber(o, {
      unit: "dayOfYear"
    }) : dn(o, n.length);
  },
  // Day of week
  E: function(t, n, r) {
    var o = t.getUTCDay();
    switch (n) {
      case "E":
      case "EE":
      case "EEE":
        return r.day(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return r.day(o, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return r.day(o, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return r.day(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(t, n, r, o) {
    var a = t.getUTCDay(), i = (a - o.weekStartsOn + 8) % 7 || 7;
    switch (n) {
      case "e":
        return String(i);
      case "ee":
        return dn(i, 2);
      case "eo":
        return r.ordinalNumber(i, {
          unit: "day"
        });
      case "eee":
        return r.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return r.day(a, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return r.day(a, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return r.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(t, n, r, o) {
    var a = t.getUTCDay(), i = (a - o.weekStartsOn + 8) % 7 || 7;
    switch (n) {
      case "c":
        return String(i);
      case "cc":
        return dn(i, n.length);
      case "co":
        return r.ordinalNumber(i, {
          unit: "day"
        });
      case "ccc":
        return r.day(a, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return r.day(a, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return r.day(a, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return r.day(a, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(t, n, r) {
    var o = t.getUTCDay(), a = o === 0 ? 7 : o;
    switch (n) {
      case "i":
        return String(a);
      case "ii":
        return dn(a, n.length);
      case "io":
        return r.ordinalNumber(a, {
          unit: "day"
        });
      case "iii":
        return r.day(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return r.day(o, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return r.day(o, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return r.day(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(t, n, r) {
    var o = t.getUTCHours(), a = o / 12 >= 1 ? "pm" : "am";
    switch (n) {
      case "a":
      case "aa":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return r.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return r.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(t, n, r) {
    var o = t.getUTCHours(), a;
    switch (o === 12 ? a = _u.noon : o === 0 ? a = _u.midnight : a = o / 12 >= 1 ? "pm" : "am", n) {
      case "b":
      case "bb":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return r.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return r.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(t, n, r) {
    var o = t.getUTCHours(), a;
    switch (o >= 17 ? a = _u.evening : o >= 12 ? a = _u.afternoon : o >= 4 ? a = _u.morning : a = _u.night, n) {
      case "B":
      case "BB":
      case "BBB":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return r.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return r.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(t, n, r) {
    if (n === "ho") {
      var o = t.getUTCHours() % 12;
      return o === 0 && (o = 12), r.ordinalNumber(o, {
        unit: "hour"
      });
    }
    return os.h(t, n);
  },
  // Hour [0-23]
  H: function(t, n, r) {
    return n === "Ho" ? r.ordinalNumber(t.getUTCHours(), {
      unit: "hour"
    }) : os.H(t, n);
  },
  // Hour [0-11]
  K: function(t, n, r) {
    var o = t.getUTCHours() % 12;
    return n === "Ko" ? r.ordinalNumber(o, {
      unit: "hour"
    }) : dn(o, n.length);
  },
  // Hour [1-24]
  k: function(t, n, r) {
    var o = t.getUTCHours();
    return o === 0 && (o = 24), n === "ko" ? r.ordinalNumber(o, {
      unit: "hour"
    }) : dn(o, n.length);
  },
  // Minute
  m: function(t, n, r) {
    return n === "mo" ? r.ordinalNumber(t.getUTCMinutes(), {
      unit: "minute"
    }) : os.m(t, n);
  },
  // Second
  s: function(t, n, r) {
    return n === "so" ? r.ordinalNumber(t.getUTCSeconds(), {
      unit: "second"
    }) : os.s(t, n);
  },
  // Fraction of second
  S: function(t, n) {
    return os.S(t, n);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(t, n, r, o) {
    var a = o._originalDate || t, i = a.getTimezoneOffset();
    if (i === 0)
      return "Z";
    switch (n) {
      case "X":
        return Jb(i);
      case "XXXX":
      case "XX":
        return rl(i);
      case "XXXXX":
      case "XXX":
      default:
        return rl(i, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(t, n, r, o) {
    var a = o._originalDate || t, i = a.getTimezoneOffset();
    switch (n) {
      case "x":
        return Jb(i);
      case "xxxx":
      case "xx":
        return rl(i);
      case "xxxxx":
      case "xxx":
      default:
        return rl(i, ":");
    }
  },
  // Timezone (GMT)
  O: function(t, n, r, o) {
    var a = o._originalDate || t, i = a.getTimezoneOffset();
    switch (n) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + qb(i, ":");
      case "OOOO":
      default:
        return "GMT" + rl(i, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(t, n, r, o) {
    var a = o._originalDate || t, i = a.getTimezoneOffset();
    switch (n) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + qb(i, ":");
      case "zzzz":
      default:
        return "GMT" + rl(i, ":");
    }
  },
  // Seconds timestamp
  t: function(t, n, r, o) {
    var a = o._originalDate || t, i = Math.floor(a.getTime() / 1e3);
    return dn(i, n.length);
  },
  // Milliseconds timestamp
  T: function(t, n, r, o) {
    var a = o._originalDate || t, i = a.getTime();
    return dn(i, n.length);
  }
};
function qb(e, t) {
  var n = e > 0 ? "-" : "+", r = Math.abs(e), o = Math.floor(r / 60), a = r % 60;
  if (a === 0)
    return n + String(o);
  var i = t || "";
  return n + String(o) + i + dn(a, 2);
}
function Jb(e, t) {
  if (e % 60 === 0) {
    var n = e > 0 ? "-" : "+";
    return n + dn(Math.abs(e) / 60, 2);
  }
  return rl(e, t);
}
function rl(e, t) {
  var n = t || "", r = e > 0 ? "-" : "+", o = Math.abs(e), a = dn(Math.floor(o / 60), 2), i = dn(o % 60, 2);
  return r + a + n + i;
}
const ohe = rhe;
var Kb = function(t, n) {
  switch (t) {
    case "P":
      return n.date({
        width: "short"
      });
    case "PP":
      return n.date({
        width: "medium"
      });
    case "PPP":
      return n.date({
        width: "long"
      });
    case "PPPP":
    default:
      return n.date({
        width: "full"
      });
  }
}, OL = function(t, n) {
  switch (t) {
    case "p":
      return n.time({
        width: "short"
      });
    case "pp":
      return n.time({
        width: "medium"
      });
    case "ppp":
      return n.time({
        width: "long"
      });
    case "pppp":
    default:
      return n.time({
        width: "full"
      });
  }
}, ahe = function(t, n) {
  var r = t.match(/(P+)(p+)?/) || [], o = r[1], a = r[2];
  if (!a)
    return Kb(t, n);
  var i;
  switch (o) {
    case "P":
      i = n.dateTime({
        width: "short"
      });
      break;
    case "PP":
      i = n.dateTime({
        width: "medium"
      });
      break;
    case "PPP":
      i = n.dateTime({
        width: "long"
      });
      break;
    case "PPPP":
    default:
      i = n.dateTime({
        width: "full"
      });
      break;
  }
  return i.replace("{{date}}", Kb(o, n)).replace("{{time}}", OL(a, n));
}, ihe = {
  p: OL,
  P: ahe
};
const she = ihe;
var lhe = ["D", "DD"], uhe = ["YY", "YYYY"];
function che(e) {
  return lhe.indexOf(e) !== -1;
}
function dhe(e) {
  return uhe.indexOf(e) !== -1;
}
function Qb(e, t, n) {
  if (e === "YYYY")
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(t, "`) for formatting years to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "YY")
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(t, "`) for formatting years to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "D")
    throw new RangeError("Use `d` instead of `D` (in `".concat(t, "`) for formatting days of the month to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "DD")
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(t, "`) for formatting days of the month to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}
var fhe = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, hhe = function(t, n, r) {
  var o, a = fhe[t];
  return typeof a == "string" ? o = a : n === 1 ? o = a.one : o = a.other.replace("{{count}}", n.toString()), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "in " + o : o + " ago" : o;
};
const mhe = hhe;
function qg(e) {
  return function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = t.width ? String(t.width) : e.defaultWidth, r = e.formats[n] || e.formats[e.defaultWidth];
    return r;
  };
}
var phe = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, ghe = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, vhe = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Che = {
  date: qg({
    formats: phe,
    defaultWidth: "full"
  }),
  time: qg({
    formats: ghe,
    defaultWidth: "full"
  }),
  dateTime: qg({
    formats: vhe,
    defaultWidth: "full"
  })
};
const bhe = Che;
var yhe = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, She = function(t, n, r, o) {
  return yhe[t];
};
const Ahe = She;
function S1(e) {
  return function(t, n) {
    var r = n != null && n.context ? String(n.context) : "standalone", o;
    if (r === "formatting" && e.formattingValues) {
      var a = e.defaultFormattingWidth || e.defaultWidth, i = n != null && n.width ? String(n.width) : a;
      o = e.formattingValues[i] || e.formattingValues[a];
    } else {
      var l = e.defaultWidth, u = n != null && n.width ? String(n.width) : e.defaultWidth;
      o = e.values[u] || e.values[l];
    }
    var d = e.argumentCallback ? e.argumentCallback(t) : t;
    return o[d];
  };
}
var Mhe = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, xhe = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, whe = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
}, _he = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
}, Ihe = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, Lhe = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, Rhe = function(t, n) {
  var r = Number(t), o = r % 100;
  if (o > 20 || o < 10)
    switch (o % 10) {
      case 1:
        return r + "st";
      case 2:
        return r + "nd";
      case 3:
        return r + "rd";
    }
  return r + "th";
}, Dhe = {
  ordinalNumber: Rhe,
  era: S1({
    values: Mhe,
    defaultWidth: "wide"
  }),
  quarter: S1({
    values: xhe,
    defaultWidth: "wide",
    argumentCallback: function(t) {
      return t - 1;
    }
  }),
  month: S1({
    values: whe,
    defaultWidth: "wide"
  }),
  day: S1({
    values: _he,
    defaultWidth: "wide"
  }),
  dayPeriod: S1({
    values: Ihe,
    defaultWidth: "wide",
    formattingValues: Lhe,
    defaultFormattingWidth: "wide"
  })
};
const Phe = Dhe;
function A1(e) {
  return function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = n.width, o = r && e.matchPatterns[r] || e.matchPatterns[e.defaultMatchWidth], a = t.match(o);
    if (!a)
      return null;
    var i = a[0], l = r && e.parsePatterns[r] || e.parsePatterns[e.defaultParseWidth], u = Array.isArray(l) ? The(l, function(h) {
      return h.test(i);
    }) : Ehe(l, function(h) {
      return h.test(i);
    }), d;
    d = e.valueCallback ? e.valueCallback(u) : u, d = n.valueCallback ? n.valueCallback(d) : d;
    var f = t.slice(i.length);
    return {
      value: d,
      rest: f
    };
  };
}
function Ehe(e, t) {
  for (var n in e)
    if (e.hasOwnProperty(n) && t(e[n]))
      return n;
}
function The(e, t) {
  for (var n = 0; n < e.length; n++)
    if (t(e[n]))
      return n;
}
function Nhe(e) {
  return function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = t.match(e.matchPattern);
    if (!r)
      return null;
    var o = r[0], a = t.match(e.parsePattern);
    if (!a)
      return null;
    var i = e.valueCallback ? e.valueCallback(a[0]) : a[0];
    i = n.valueCallback ? n.valueCallback(i) : i;
    var l = t.slice(o.length);
    return {
      value: i,
      rest: l
    };
  };
}
var khe = /^(\d+)(th|st|nd|rd)?/i, Vhe = /\d+/i, Ohe = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, Fhe = {
  any: [/^b/i, /^(a|c)/i]
}, Bhe = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, Hhe = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Ghe = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, $he = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, Zhe = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, jhe = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, Whe = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, zhe = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, Uhe = {
  ordinalNumber: Nhe({
    matchPattern: khe,
    parsePattern: Vhe,
    valueCallback: function(t) {
      return parseInt(t, 10);
    }
  }),
  era: A1({
    matchPatterns: Ohe,
    defaultMatchWidth: "wide",
    parsePatterns: Fhe,
    defaultParseWidth: "any"
  }),
  quarter: A1({
    matchPatterns: Bhe,
    defaultMatchWidth: "wide",
    parsePatterns: Hhe,
    defaultParseWidth: "any",
    valueCallback: function(t) {
      return t + 1;
    }
  }),
  month: A1({
    matchPatterns: Ghe,
    defaultMatchWidth: "wide",
    parsePatterns: $he,
    defaultParseWidth: "any"
  }),
  day: A1({
    matchPatterns: Zhe,
    defaultMatchWidth: "wide",
    parsePatterns: jhe,
    defaultParseWidth: "any"
  }),
  dayPeriod: A1({
    matchPatterns: Whe,
    defaultMatchWidth: "any",
    parsePatterns: zhe,
    defaultParseWidth: "any"
  })
};
const Xhe = Uhe;
var Yhe = {
  code: "en-US",
  formatDistance: mhe,
  formatLong: bhe,
  formatRelative: Ahe,
  localize: Phe,
  match: Xhe,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
const qhe = Yhe;
var Jhe = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, Khe = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, Qhe = /^'([^]*?)'?$/, eme = /''/g, tme = /[a-zA-Z]/;
function _3(e, t, n) {
  var r, o, a, i, l, u, d, f, h, p, g, C, v, y, M, x, _, L;
  qr(2, arguments);
  var R = String(t), k = Mm(), P = (r = (o = n == null ? void 0 : n.locale) !== null && o !== void 0 ? o : k.locale) !== null && r !== void 0 ? r : qhe, N = kl((a = (i = (l = (u = n == null ? void 0 : n.firstWeekContainsDate) !== null && u !== void 0 ? u : n == null || (d = n.locale) === null || d === void 0 || (f = d.options) === null || f === void 0 ? void 0 : f.firstWeekContainsDate) !== null && l !== void 0 ? l : k.firstWeekContainsDate) !== null && i !== void 0 ? i : (h = k.locale) === null || h === void 0 || (p = h.options) === null || p === void 0 ? void 0 : p.firstWeekContainsDate) !== null && a !== void 0 ? a : 1);
  if (!(N >= 1 && N <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var O = kl((g = (C = (v = (y = n == null ? void 0 : n.weekStartsOn) !== null && y !== void 0 ? y : n == null || (M = n.locale) === null || M === void 0 || (x = M.options) === null || x === void 0 ? void 0 : x.weekStartsOn) !== null && v !== void 0 ? v : k.weekStartsOn) !== null && C !== void 0 ? C : (_ = k.locale) === null || _ === void 0 || (L = _.options) === null || L === void 0 ? void 0 : L.weekStartsOn) !== null && g !== void 0 ? g : 0);
  if (!(O >= 0 && O <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (!P.localize)
    throw new RangeError("locale must contain localize property");
  if (!P.formatLong)
    throw new RangeError("locale must contain formatLong property");
  var H = Ya(e);
  if (!z2e(H))
    throw new RangeError("Invalid time value");
  var $ = j2e(H), ne = U2e(H, $), ie = {
    firstWeekContainsDate: N,
    weekStartsOn: O,
    locale: P,
    _originalDate: H
  }, re = R.match(Khe).map(function(ve) {
    var ue = ve[0];
    if (ue === "p" || ue === "P") {
      var j = she[ue];
      return j(ve, P.formatLong);
    }
    return ve;
  }).join("").match(Jhe).map(function(ve) {
    if (ve === "''")
      return "'";
    var ue = ve[0];
    if (ue === "'")
      return nme(ve);
    var j = ohe[ue];
    if (j)
      return !(n != null && n.useAdditionalWeekYearTokens) && dhe(ve) && Qb(ve, t, String(e)), !(n != null && n.useAdditionalDayOfYearTokens) && che(ve) && Qb(ve, t, String(e)), j(ne, ve, P.localize, ie);
    if (ue.match(tme))
      throw new RangeError("Format string contains an unescaped latin alphabet character `" + ue + "`");
    return ve;
  }).join("");
  return re;
}
function nme(e) {
  var t = e.match(Qhe);
  return t ? t[1].replace(eme, "'") : e;
}
function I3(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function FL(e, t) {
  if (e) {
    if (typeof e == "string")
      return I3(e, t);
    var n = {}.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? I3(e, t) : void 0;
  }
}
function rme(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function ome(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(e, "prototype", {
    writable: !1
  }), t && M2(e, t);
}
function ch(e) {
  return ch = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, ch(e);
}
function BL() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (BL = function() {
    return !!e;
  })();
}
function ame(e, t) {
  if (t && (Li(t) == "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return rme(e);
}
function ime(e) {
  var t = BL();
  return function() {
    var n, r = ch(e);
    if (t) {
      var o = ch(this).constructor;
      n = Reflect.construct(r, arguments, o);
    } else
      n = r.apply(this, arguments);
    return ame(this, n);
  };
}
function sme(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function ey(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, mx(r.key), r);
  }
}
function lme(e, t, n) {
  return t && ey(e.prototype, t), n && ey(e, n), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
var HL = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"], GL = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
function hn() {
  return hn = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, hn.apply(this, arguments);
}
function $L(e, t) {
  if (e == null)
    return {};
  var n = {}, r = Object.keys(e), o, a;
  for (a = 0; a < r.length; a++)
    o = r[a], !(t.indexOf(o) >= 0) && (n[o] = e[o]);
  return n;
}
var ume = /* @__PURE__ */ function() {
  function e(n) {
    this.config = void 0, this.config = n;
  }
  var t = e.prototype;
  return t.getEvents = function() {
    var r = this;
    return {
      onKeyDown: function(a) {
        switch (a.key) {
          case "ArrowDown":
            r.config.down && r.config.down();
            break;
          case "ArrowLeft":
            r.config.left && r.config.left();
            break;
          case "ArrowRight":
            r.config.right && r.config.right();
            break;
          case "ArrowUp":
            r.config.up && r.config.up();
            break;
        }
      }
    };
  }, e;
}(), dh = {
  variant: "ghost",
  size: "sm"
}, cme = function(t) {
  var n, r = t.calendars, o = t.getBackProps, a = (n = t.propsConfigs) == null ? void 0 : n.dateNavBtnProps;
  return tt.createElement(Ml, null, tt.createElement(tc, hn({}, o({
    calendars: r,
    offset: 12
  }), dh, a), "<<"), tt.createElement(tc, hn({}, o({
    calendars: r
  }), dh, a), "<"));
}, dme = function(t) {
  var n, r = t.calendars, o = t.getForwardProps, a = (n = t.propsConfigs) == null ? void 0 : n.dateNavBtnProps;
  return tt.createElement(Ml, null, tt.createElement(tc, hn({}, o({
    calendars: r
  }), dh, a), ">"), tt.createElement(tc, hn({}, o({
    calendars: r,
    offset: 12
  }), dh, a), ">>"));
}, M1 = 0.125, fme = function(t) {
  var n = t.dateObj, r = t.propsConfigs, o = t.isInRange, a = t.disabledDates, i = t.renderProps, l = t.onMouseEnter, u = n.date, d = n.selected, f = n.selectable, h = n.today, p = i.getDateProps, g = (r == null ? void 0 : r.dayOfMonthBtnProps) || {}, C = g.defaultBtnProps, v = g.isInRangeBtnProps, y = g.selectedBtnProps, M = g.todayBtnProps, x = !f || (a == null ? void 0 : a.has(u.getTime())), _ = bt(function() {
    var L;
    return {
      defaultBtnProps: hn({
        size: "sm",
        variant: "ghost"
      }, C, {
        _after: hn({
          content: "''",
          position: "absolute",
          top: "-" + M1 + "rem",
          left: "-" + M1 + "rem",
          bottom: "-" + M1 + "rem",
          right: "-" + M1 + "rem",
          borderWidth: M1 + "rem",
          borderColor: "transparent"
        }, C == null ? void 0 : C._after),
        _hover: hn({
          bg: "purple.400"
        }, C == null ? void 0 : C._hover, {
          _disabled: hn({
            bg: "gray.100"
          }, C == null || (L = C._hover) == null ? void 0 : L._disabled)
        })
      }),
      isInRangeBtnProps: hn({
        background: "purple.200"
      }, v),
      selectedBtnProps: hn({
        background: "purple.200"
      }, y),
      todayBtnProps: hn({
        borderColor: "blue.400"
      }, M)
    };
  }, [C, v, y, M]);
  return tt.createElement(tc, hn({}, p({
    dateObj: n,
    disabled: x,
    onMouseEnter: l
  }), {
    isDisabled: x
  }, _.defaultBtnProps, o && !x && _.isInRangeBtnProps, d && !x && _.selectedBtnProps, h && _.todayBtnProps), u.getDate());
}, ZL = function(t) {
  var n, r = t.dayzedHookProps, o = t.configs, a = t.propsConfigs, i = t.disabledDates, l = t.onMouseEnterHighlight, u = t.isInRange, d = G2e(r), f = d.calendars, h = d.getBackProps, p = d.getForwardProps, g = bt(function() {
    var y = o.firstDayOfWeek, M = o.dayNames;
    return y && y > 0 ? o.dayNames.slice(y, M.length).concat(M.slice(0, y)) : M;
  }, [o.firstDayOfWeek, o.dayNames]), C = Q(function(y) {
    var M = document.activeElement, x = document.querySelectorAll("button");
    x.forEach(function(_, L) {
      var R = L + y;
      _ === M && (R <= x.length - 1 && R >= 0 ? x[R].focus() : x[0].focus());
    });
  }, []), v = new ume({
    left: function() {
      C(-1);
    },
    right: function() {
      C(1);
    },
    up: function() {
      C(-7);
    },
    down: function() {
      C(7);
    }
  });
  return f.length <= 0 ? null : tt.createElement(jh, hn({
    className: "datepicker-calendar",
    direction: ["column", "column", "row"]
  }, a == null || (n = a.calendarPanelProps) == null ? void 0 : n.wrapperProps, v.getEvents()), f.map(function(y, M) {
    var x, _, L, R;
    return tt.createElement(Zw, hn({
      key: M,
      height: "100%",
      borderWidth: "1px",
      padding: "0.5rem 0.75rem"
    }, a == null || (x = a.calendarPanelProps) == null ? void 0 : x.contentProps), tt.createElement(I2, hn({}, a == null || (_ = a.calendarPanelProps) == null ? void 0 : _.headerProps), tt.createElement(cme, {
      calendars: f,
      getBackProps: h,
      propsConfigs: a
    }), tt.createElement(Uw, hn({
      size: "sm",
      minWidth: "5rem",
      textAlign: "center"
    }, a == null ? void 0 : a.dateHeadingProps), o.monthNames[y.month], " ", y.year), tt.createElement(dme, {
      calendars: f,
      getForwardProps: p,
      propsConfigs: a
    })), tt.createElement(KM, hn({}, a == null || (L = a.calendarPanelProps) == null ? void 0 : L.dividerProps)), tt.createElement(jx, hn({
      columns: 7,
      spacing: 1,
      textAlign: "center"
    }, a == null || (R = a.calendarPanelProps) == null ? void 0 : R.bodyProps), g.map(function(k, P) {
      return tt.createElement(Ma, hn({
        fontSize: "sm",
        fontWeight: "semibold",
        key: P
      }, a == null ? void 0 : a.weekdayLabelProps), k);
    }), y.weeks.map(function(k, P) {
      return k.map(function(N, O) {
        var H = y.month + "-" + y.year + "-" + P + "-" + O;
        if (!N)
          return tt.createElement(Ma, {
            key: H
          });
        var $ = N.date;
        return tt.createElement(fme, {
          key: H,
          dateObj: N,
          propsConfigs: a,
          renderProps: d,
          isInRange: u && u($),
          disabledDates: i,
          onMouseEnter: function() {
            l && l($);
          }
        });
      });
    })));
  }));
}, hme = ["configs", "propsConfigs", "usePortal", "disabledDates", "defaultIsOpen", "closeOnSelect"], mme = {
  dateFormat: "yyyy-MM-dd",
  monthNames: HL,
  dayNames: GL,
  firstDayOfWeek: 0
}, pme = function(t) {
  var n, r, o = t.configs, a = t.propsConfigs, i = t.usePortal, l = t.disabledDates, u = t.defaultIsOpen, d = u === void 0 ? !1 : u, f = t.closeOnSelect, h = f === void 0 ? !0 : f, p = $L(t, hme), g = p.date, C = p.name, v = p.disabled, y = p.onDateChange, M = p.id, x = p.minDate, _ = p.maxDate, L = He(g), R = L[0], k = L[1], P = He(0), N = P[0], O = P[1], H = wd({
    defaultIsOpen: d
  }), $ = H.onOpen, ne = H.onClose, ie = H.isOpen, re = hn({}, mme, o), ve = function() {
    ne(), k(g), O(0);
  }, ue = function(ce) {
    var U = ce.selectable, q = ce.date;
    if (U && q instanceof Date && !isNaN(q.getTime())) {
      y(q), h && ne();
      return;
    }
  }, j = i ? ki : tt.Fragment;
  return tt.createElement(Hh, {
    placement: "bottom-start",
    variant: "responsive",
    isOpen: ie,
    onOpen: $,
    onClose: ve,
    isLazy: !0
  }, tt.createElement(Zh, null, tt.createElement(Pr, hn({
    onKeyPress: function(ce) {
      ce.key === " " && !ie && (ce.preventDefault(), $());
    },
    id: M,
    autoComplete: "off",
    isDisabled: v,
    name: C,
    value: g ? _3(g, re.dateFormat) : "",
    onChange: function(ce) {
      return ce.target.value;
    }
  }, a == null ? void 0 : a.inputProps))), tt.createElement(j, null, tt.createElement($h, hn({
    width: "100%"
  }, a == null || (n = a.popoverCompProps) == null ? void 0 : n.popoverContentProps), tt.createElement(Gh, hn({}, a == null || (r = a.popoverCompProps) == null ? void 0 : r.popoverBodyProps), tt.createElement(w2, null, tt.createElement(ZL, {
    dayzedHookProps: {
      showOutsideDays: !0,
      onDateSelected: ue,
      selected: g,
      date: R,
      minDate: x,
      maxDate: _,
      offset: N,
      onOffsetChanged: O,
      firstDayOfWeek: re.firstDayOfWeek
    },
    configs: re,
    propsConfigs: a,
    disabledDates: l
  }))))));
}, gme = ["configs", "propsConfigs", "id", "name", "usePortal", "defaultIsOpen", "closeOnSelect"], vme = function(t) {
  var n = t.dayzedHookProps, r = t.configs, o = t.propsConfigs, a = t.selected, i = He(null), l = i[0], u = i[1], d = function() {
    u(null);
  }, f = function(g) {
    !Array.isArray(a) || !(a != null && a.length) || u(g);
  }, h = function(g) {
    if (!Array.isArray(a) || !(a != null && a.length))
      return !1;
    var C = a[0];
    if (a.length === 2) {
      var v = a[1];
      return C < g && v > g;
    } else
      return l && (C < g && l >= g || g < C && g >= l);
  };
  return tt.createElement(fd, {
    onMouseLeave: d
  }, tt.createElement(ZL, {
    dayzedHookProps: n,
    configs: r,
    propsConfigs: o,
    isInRange: h,
    onMouseEnterHighlight: f
  }));
}, Cme = {
  dateFormat: "MM/dd/yyyy",
  monthNames: HL,
  dayNames: GL,
  firstDayOfWeek: 0
}, bme = function(t) {
  var n, r, o = t.configs, a = t.propsConfigs, i = a === void 0 ? {} : a, l = t.id, u = t.name, d = t.usePortal, f = t.defaultIsOpen, h = f === void 0 ? !1 : f, p = t.closeOnSelect, g = p === void 0 ? !0 : p, C = $L(t, gme), v = C.selectedDates, y = C.minDate, M = C.maxDate, x = C.onDateChange, _ = C.disabled, L = He(v[0] || /* @__PURE__ */ new Date()), R = L[0], k = L[1], P = He(0), N = P[0], O = P[1], H = wd({
    defaultIsOpen: h
  }), $ = H.onOpen, ne = H.onClose, ie = H.isOpen, re = hn({}, Cme, o), ve = function() {
    ne(), k(v[0] || /* @__PURE__ */ new Date()), O(0);
  }, ue = function(U) {
    var q = U.selectable, ge = U.date;
    if (q) {
      var X = [].concat(v);
      if (v.length) {
        if (v.length === 1) {
          var he = v[0];
          he < ge ? X.push(ge) : X.unshift(ge), x(X), g && ne();
          return;
        }
        if (X.length === 2) {
          x([ge]);
          return;
        }
      } else
        X.push(ge), x(X);
    }
  }, j = v[0] ? "" + _3(v[0], re.dateFormat) : "";
  j += v[1] ? " - " + _3(v[1], re.dateFormat) : "";
  var K = d ? ki : tt.Fragment;
  return tt.createElement(Hh, {
    placement: "bottom-start",
    variant: "responsive",
    isOpen: ie,
    onOpen: $,
    onClose: ve,
    isLazy: !0
  }, tt.createElement(Zh, null, tt.createElement(Pr, hn({
    onKeyPress: function(U) {
      U.key === " " && !ie && (U.preventDefault(), $());
    },
    id: l,
    autoComplete: "off",
    isDisabled: _,
    name: u,
    value: j,
    onChange: function(U) {
      return U.target.value;
    }
  }, i.inputProps))), tt.createElement(K, null, tt.createElement($h, hn({
    width: "100%"
  }, i == null || (n = i.popoverCompProps) == null ? void 0 : n.popoverContentProps), tt.createElement(Gh, hn({}, (r = i.popoverCompProps) == null ? void 0 : r.popoverBodyProps), tt.createElement(w2, null, tt.createElement(vme, {
    dayzedHookProps: {
      onDateSelected: ue,
      selected: v,
      monthsToDisplay: 2,
      date: R,
      minDate: y,
      maxDate: M,
      offset: N,
      onOffsetChanged: O,
      firstDayOfWeek: re.firstDayOfWeek
    },
    configs: re,
    propsConfigs: i,
    selected: v
  }))))));
};
const yme = ({ value: e, onChange: t, ...n }) => Es(
  n,
  /* @__PURE__ */ A.jsx(
    bme,
    {
      selectedDates: e.map(
        (r) => new Date(new Date(r.isoString).getTime() + (/* @__PURE__ */ new Date()).getTimezoneOffset() * 6e4)
      ),
      onDateChange: (r) => t(r.map((o) => wi.fromNativeDate(o).toAloftDate().toJSON())),
      ...n
    }
  )
), b4e = (e) => {
  if (e.variant === "range")
    return /* @__PURE__ */ A.jsx(yme, { ...e });
  const { value: t, onChange: n, ...r } = e;
  return Es(
    r,
    /* @__PURE__ */ A.jsx(
      pme,
      {
        date: new Date(rr.schema.parse(t).toEndOfDay().toIsoString()),
        onDateChange: (o) => n(rr.fromIsoString(o.toISOString().split("T")[0]).toJSON()),
        ...r
      }
    )
  );
}, Sme = ({
  size: e,
  isOpen: t,
  onClose: n,
  variant: r,
  title: o,
  children: a,
  primaryAction: i,
  secondaryAction: l,
  closeOnEsc: u = !0,
  showCloseButton: d = !0,
  overflow: f,
  modalBodyProps: h = {},
  titleBadge: p,
  fullHeight: g = !1,
  leftFooterContent: C
}) => {
  const v = i || l || C;
  return /* @__PURE__ */ A.jsxs(
    l9,
    {
      isOpen: t,
      onClose: n,
      scrollBehavior: "inside",
      size: e || "lg",
      isCentered: !0,
      closeOnEsc: u,
      closeOnOverlayClick: u,
      children: [
        /* @__PURE__ */ A.jsx(f9, {}),
        /* @__PURE__ */ A.jsxs(
          bw,
          {
            onKeyDown: (y) => {
              y.stopPropagation();
            },
            height: g ? "100%" : "auto",
            children: [
              /* @__PURE__ */ A.jsxs(d9, { borderBottom: "1px solid border", children: [
                /* @__PURE__ */ A.jsxs(fc, { alignItems: "center", justifyContent: "flex-start", flexGrow: 1, gap: 2, children: [
                  o,
                  p && /* @__PURE__ */ A.jsx(Qw, { ...p, size: "md" })
                ] }),
                d && /* @__PURE__ */ A.jsx(yw, { onClick: n })
              ] }),
              /* @__PURE__ */ A.jsx(u9, { overflow: f, ...h, children: a }),
              /* @__PURE__ */ A.jsx(c9, { borderTop: "1px solid border", children: v && /* @__PURE__ */ A.jsxs(fc, { justifyContent: "space-between", flex: 1, children: [
                /* @__PURE__ */ A.jsx(I2, { gap: 2, children: C }),
                /* @__PURE__ */ A.jsxs(I2, { gap: 2, children: [
                  l && /* @__PURE__ */ A.jsx(o3, { variant: "secondary", ...l }),
                  i && /* @__PURE__ */ A.jsx(
                    g9,
                    {
                      isDisabled: DL(i.tooltipText),
                      label: i.tooltipText,
                      children: /* @__PURE__ */ A.jsx(
                        o3,
                        {
                          variant: r === "danger" ? "danger" : "primary",
                          ...i
                        }
                      )
                    }
                  )
                ] })
              ] }) })
            ]
          }
        )
      ]
    }
  );
}, y4e = (e) => {
  const [t, n] = He(!1);
  return {
    Modal: Sme,
    isModalOpen: t,
    openModal: () => {
      var a;
      n(!0), (a = e == null ? void 0 : e.onOpen) == null || a.call(e);
    },
    closeModal: () => {
      var a;
      n(!1), (a = e == null ? void 0 : e.onClose) == null || a.call(e);
    }
  };
};
/**
   * table-core
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */
function S4e() {
  return {
    accessor: (e, t) => typeof e == "function" ? {
      ...t,
      accessorFn: e
    } : {
      ...t,
      accessorKey: e
    },
    display: (e) => e,
    group: (e) => e
  };
}
function vs(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Io(e, t) {
  return (n) => {
    t.setState((r) => ({
      ...r,
      [e]: vs(n, r[e])
    }));
  };
}
function xm(e) {
  return e instanceof Function;
}
function Ame(e) {
  return Array.isArray(e) && e.every((t) => typeof t == "number");
}
function Mme(e, t) {
  const n = [], r = (o) => {
    o.forEach((a) => {
      n.push(a);
      const i = t(a);
      i != null && i.length && r(i);
    });
  };
  return r(e), n;
}
function ht(e, t, n) {
  let r = [], o;
  return (a) => {
    let i;
    n.key && n.debug && (i = Date.now());
    const l = e(a);
    if (!(l.length !== r.length || l.some((f, h) => r[h] !== f)))
      return o;
    r = l;
    let d;
    if (n.key && n.debug && (d = Date.now()), o = t(...l), n == null || n.onChange == null || n.onChange(o), n.key && n.debug && n != null && n.debug()) {
      const f = Math.round((Date.now() - i) * 100) / 100, h = Math.round((Date.now() - d) * 100) / 100, p = h / 16, g = (C, v) => {
        for (C = String(C); C.length < v; )
          C = " " + C;
        return C;
      };
      console.info(`%c⏱ ${g(h, 5)} /${g(f, 5)} ms`, `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(0, Math.min(120 - 120 * p, 120))}deg 100% 31%);`, n == null ? void 0 : n.key);
    }
    return o;
  };
}
function mt(e, t, n, r) {
  return {
    debug: () => {
      var o;
      return (o = e == null ? void 0 : e.debugAll) != null ? o : e[t];
    },
    key: process.env.NODE_ENV === "development" && n,
    onChange: r
  };
}
function xme(e, t, n, r) {
  const o = () => {
    var i;
    return (i = a.getValue()) != null ? i : e.options.renderFallbackValue;
  }, a = {
    id: `${t.id}_${n.id}`,
    row: t,
    column: n,
    getValue: () => t.getValue(r),
    renderValue: o,
    getContext: ht(() => [e, n, t, a], (i, l, u, d) => ({
      table: i,
      column: l,
      row: u,
      cell: d,
      getValue: d.getValue,
      renderValue: d.renderValue
    }), mt(e.options, "debugCells", "cell.getContext"))
  };
  return e._features.forEach((i) => {
    i.createCell == null || i.createCell(a, n, t, e);
  }, {}), a;
}
function wme(e, t, n, r) {
  var o, a;
  const l = {
    ...e._getDefaultColumnDef(),
    ...t
  }, u = l.accessorKey;
  let d = (o = (a = l.id) != null ? a : u ? typeof String.prototype.replaceAll == "function" ? u.replaceAll(".", "_") : u.replace(/\./g, "_") : void 0) != null ? o : typeof l.header == "string" ? l.header : void 0, f;
  if (l.accessorFn ? f = l.accessorFn : u && (u.includes(".") ? f = (p) => {
    let g = p;
    for (const v of u.split(".")) {
      var C;
      g = (C = g) == null ? void 0 : C[v], process.env.NODE_ENV !== "production" && g === void 0 && console.warn(`"${v}" in deeply nested key "${u}" returned undefined.`);
    }
    return g;
  } : f = (p) => p[l.accessorKey]), !d)
    throw process.env.NODE_ENV !== "production" ? new Error(l.accessorFn ? "Columns require an id when using an accessorFn" : "Columns require an id when using a non-string header") : new Error();
  let h = {
    id: `${String(d)}`,
    accessorFn: f,
    parent: r,
    depth: n,
    columnDef: l,
    columns: [],
    getFlatColumns: ht(() => [!0], () => {
      var p;
      return [h, ...(p = h.columns) == null ? void 0 : p.flatMap((g) => g.getFlatColumns())];
    }, mt(e.options, "debugColumns", "column.getFlatColumns")),
    getLeafColumns: ht(() => [e._getOrderColumnsFn()], (p) => {
      var g;
      if ((g = h.columns) != null && g.length) {
        let C = h.columns.flatMap((v) => v.getLeafColumns());
        return p(C);
      }
      return [h];
    }, mt(e.options, "debugColumns", "column.getLeafColumns"))
  };
  for (const p of e._features)
    p.createColumn == null || p.createColumn(h, e);
  return h;
}
const Ir = "debugHeaders";
function ty(e, t, n) {
  var r;
  let a = {
    id: (r = n.id) != null ? r : t.id,
    column: t,
    index: n.index,
    isPlaceholder: !!n.isPlaceholder,
    placeholderId: n.placeholderId,
    depth: n.depth,
    subHeaders: [],
    colSpan: 0,
    rowSpan: 0,
    headerGroup: null,
    getLeafHeaders: () => {
      const i = [], l = (u) => {
        u.subHeaders && u.subHeaders.length && u.subHeaders.map(l), i.push(u);
      };
      return l(a), i;
    },
    getContext: () => ({
      table: e,
      header: a,
      column: t
    })
  };
  return e._features.forEach((i) => {
    i.createHeader == null || i.createHeader(a, e);
  }), a;
}
const _me = {
  createTable: (e) => {
    e.getHeaderGroups = ht(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.left, e.getState().columnPinning.right], (t, n, r, o) => {
      var a, i;
      const l = (a = r == null ? void 0 : r.map((h) => n.find((p) => p.id === h)).filter(Boolean)) != null ? a : [], u = (i = o == null ? void 0 : o.map((h) => n.find((p) => p.id === h)).filter(Boolean)) != null ? i : [], d = n.filter((h) => !(r != null && r.includes(h.id)) && !(o != null && o.includes(h.id)));
      return Tf(t, [...l, ...d, ...u], e);
    }, mt(e.options, Ir, "getHeaderGroups")), e.getCenterHeaderGroups = ht(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.left, e.getState().columnPinning.right], (t, n, r, o) => (n = n.filter((a) => !(r != null && r.includes(a.id)) && !(o != null && o.includes(a.id))), Tf(t, n, e, "center")), mt(e.options, Ir, "getCenterHeaderGroups")), e.getLeftHeaderGroups = ht(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.left], (t, n, r) => {
      var o;
      const a = (o = r == null ? void 0 : r.map((i) => n.find((l) => l.id === i)).filter(Boolean)) != null ? o : [];
      return Tf(t, a, e, "left");
    }, mt(e.options, Ir, "getLeftHeaderGroups")), e.getRightHeaderGroups = ht(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.right], (t, n, r) => {
      var o;
      const a = (o = r == null ? void 0 : r.map((i) => n.find((l) => l.id === i)).filter(Boolean)) != null ? o : [];
      return Tf(t, a, e, "right");
    }, mt(e.options, Ir, "getRightHeaderGroups")), e.getFooterGroups = ht(() => [e.getHeaderGroups()], (t) => [...t].reverse(), mt(e.options, Ir, "getFooterGroups")), e.getLeftFooterGroups = ht(() => [e.getLeftHeaderGroups()], (t) => [...t].reverse(), mt(e.options, Ir, "getLeftFooterGroups")), e.getCenterFooterGroups = ht(() => [e.getCenterHeaderGroups()], (t) => [...t].reverse(), mt(e.options, Ir, "getCenterFooterGroups")), e.getRightFooterGroups = ht(() => [e.getRightHeaderGroups()], (t) => [...t].reverse(), mt(e.options, Ir, "getRightFooterGroups")), e.getFlatHeaders = ht(() => [e.getHeaderGroups()], (t) => t.map((n) => n.headers).flat(), mt(e.options, Ir, "getFlatHeaders")), e.getLeftFlatHeaders = ht(() => [e.getLeftHeaderGroups()], (t) => t.map((n) => n.headers).flat(), mt(e.options, Ir, "getLeftFlatHeaders")), e.getCenterFlatHeaders = ht(() => [e.getCenterHeaderGroups()], (t) => t.map((n) => n.headers).flat(), mt(e.options, Ir, "getCenterFlatHeaders")), e.getRightFlatHeaders = ht(() => [e.getRightHeaderGroups()], (t) => t.map((n) => n.headers).flat(), mt(e.options, Ir, "getRightFlatHeaders")), e.getCenterLeafHeaders = ht(() => [e.getCenterFlatHeaders()], (t) => t.filter((n) => {
      var r;
      return !((r = n.subHeaders) != null && r.length);
    }), mt(e.options, Ir, "getCenterLeafHeaders")), e.getLeftLeafHeaders = ht(() => [e.getLeftFlatHeaders()], (t) => t.filter((n) => {
      var r;
      return !((r = n.subHeaders) != null && r.length);
    }), mt(e.options, Ir, "getLeftLeafHeaders")), e.getRightLeafHeaders = ht(() => [e.getRightFlatHeaders()], (t) => t.filter((n) => {
      var r;
      return !((r = n.subHeaders) != null && r.length);
    }), mt(e.options, Ir, "getRightLeafHeaders")), e.getLeafHeaders = ht(() => [e.getLeftHeaderGroups(), e.getCenterHeaderGroups(), e.getRightHeaderGroups()], (t, n, r) => {
      var o, a, i, l, u, d;
      return [...(o = (a = t[0]) == null ? void 0 : a.headers) != null ? o : [], ...(i = (l = n[0]) == null ? void 0 : l.headers) != null ? i : [], ...(u = (d = r[0]) == null ? void 0 : d.headers) != null ? u : []].map((f) => f.getLeafHeaders()).flat();
    }, mt(e.options, Ir, "getLeafHeaders"));
  }
};
function Tf(e, t, n, r) {
  var o, a;
  let i = 0;
  const l = function(p, g) {
    g === void 0 && (g = 1), i = Math.max(i, g), p.filter((C) => C.getIsVisible()).forEach((C) => {
      var v;
      (v = C.columns) != null && v.length && l(C.columns, g + 1);
    }, 0);
  };
  l(e);
  let u = [];
  const d = (p, g) => {
    const C = {
      depth: g,
      id: [r, `${g}`].filter(Boolean).join("_"),
      headers: []
    }, v = [];
    p.forEach((y) => {
      const M = [...v].reverse()[0], x = y.column.depth === C.depth;
      let _, L = !1;
      if (x && y.column.parent ? _ = y.column.parent : (_ = y.column, L = !0), M && (M == null ? void 0 : M.column) === _)
        M.subHeaders.push(y);
      else {
        const R = ty(n, _, {
          id: [r, g, _.id, y == null ? void 0 : y.id].filter(Boolean).join("_"),
          isPlaceholder: L,
          placeholderId: L ? `${v.filter((k) => k.column === _).length}` : void 0,
          depth: g,
          index: v.length
        });
        R.subHeaders.push(y), v.push(R);
      }
      C.headers.push(y), y.headerGroup = C;
    }), u.push(C), g > 0 && d(v, g - 1);
  }, f = t.map((p, g) => ty(n, p, {
    depth: i,
    index: g
  }));
  d(f, i - 1), u.reverse();
  const h = (p) => p.filter((C) => C.column.getIsVisible()).map((C) => {
    let v = 0, y = 0, M = [0];
    C.subHeaders && C.subHeaders.length ? (M = [], h(C.subHeaders).forEach((_) => {
      let {
        colSpan: L,
        rowSpan: R
      } = _;
      v += L, M.push(R);
    })) : v = 1;
    const x = Math.min(...M);
    return y = y + x, C.colSpan = v, C.rowSpan = y, {
      colSpan: v,
      rowSpan: y
    };
  });
  return h((o = (a = u[0]) == null ? void 0 : a.headers) != null ? o : []), u;
}
const Ime = (e, t, n, r, o, a, i) => {
  let l = {
    id: t,
    index: r,
    original: n,
    depth: o,
    parentId: i,
    _valuesCache: {},
    _uniqueValuesCache: {},
    getValue: (u) => {
      if (l._valuesCache.hasOwnProperty(u))
        return l._valuesCache[u];
      const d = e.getColumn(u);
      if (d != null && d.accessorFn)
        return l._valuesCache[u] = d.accessorFn(l.original, r), l._valuesCache[u];
    },
    getUniqueValues: (u) => {
      if (l._uniqueValuesCache.hasOwnProperty(u))
        return l._uniqueValuesCache[u];
      const d = e.getColumn(u);
      if (d != null && d.accessorFn)
        return d.columnDef.getUniqueValues ? (l._uniqueValuesCache[u] = d.columnDef.getUniqueValues(l.original, r), l._uniqueValuesCache[u]) : (l._uniqueValuesCache[u] = [l.getValue(u)], l._uniqueValuesCache[u]);
    },
    renderValue: (u) => {
      var d;
      return (d = l.getValue(u)) != null ? d : e.options.renderFallbackValue;
    },
    subRows: a ?? [],
    getLeafRows: () => Mme(l.subRows, (u) => u.subRows),
    getParentRow: () => l.parentId ? e.getRow(l.parentId, !0) : void 0,
    getParentRows: () => {
      let u = [], d = l;
      for (; ; ) {
        const f = d.getParentRow();
        if (!f)
          break;
        u.push(f), d = f;
      }
      return u.reverse();
    },
    getAllCells: ht(() => [e.getAllLeafColumns()], (u) => u.map((d) => xme(e, l, d, d.id)), mt(e.options, "debugRows", "getAllCells")),
    _getAllCellsByColumnId: ht(() => [l.getAllCells()], (u) => u.reduce((d, f) => (d[f.column.id] = f, d), {}), mt(e.options, "debugRows", "getAllCellsByColumnId"))
  };
  for (let u = 0; u < e._features.length; u++) {
    const d = e._features[u];
    d == null || d.createRow == null || d.createRow(l, e);
  }
  return l;
}, Lme = {
  createColumn: (e, t) => {
    e._getFacetedRowModel = t.options.getFacetedRowModel && t.options.getFacetedRowModel(t, e.id), e.getFacetedRowModel = () => e._getFacetedRowModel ? e._getFacetedRowModel() : t.getPreFilteredRowModel(), e._getFacetedUniqueValues = t.options.getFacetedUniqueValues && t.options.getFacetedUniqueValues(t, e.id), e.getFacetedUniqueValues = () => e._getFacetedUniqueValues ? e._getFacetedUniqueValues() : /* @__PURE__ */ new Map(), e._getFacetedMinMaxValues = t.options.getFacetedMinMaxValues && t.options.getFacetedMinMaxValues(t, e.id), e.getFacetedMinMaxValues = () => {
      if (e._getFacetedMinMaxValues)
        return e._getFacetedMinMaxValues();
    };
  }
}, jL = (e, t, n) => {
  var r, o;
  const a = n == null || (r = n.toString()) == null ? void 0 : r.toLowerCase();
  return !!(!((o = e.getValue(t)) == null || (o = o.toString()) == null || (o = o.toLowerCase()) == null) && o.includes(a));
};
jL.autoRemove = (e) => ya(e);
const WL = (e, t, n) => {
  var r;
  return !!(!((r = e.getValue(t)) == null || (r = r.toString()) == null) && r.includes(n));
};
WL.autoRemove = (e) => ya(e);
const zL = (e, t, n) => {
  var r;
  return ((r = e.getValue(t)) == null || (r = r.toString()) == null ? void 0 : r.toLowerCase()) === (n == null ? void 0 : n.toLowerCase());
};
zL.autoRemove = (e) => ya(e);
const UL = (e, t, n) => {
  var r;
  return (r = e.getValue(t)) == null ? void 0 : r.includes(n);
};
UL.autoRemove = (e) => ya(e);
const XL = (e, t, n) => !n.some((r) => {
  var o;
  return !((o = e.getValue(t)) != null && o.includes(r));
});
XL.autoRemove = (e) => ya(e) || !(e != null && e.length);
const YL = (e, t, n) => n.some((r) => {
  var o;
  return (o = e.getValue(t)) == null ? void 0 : o.includes(r);
});
YL.autoRemove = (e) => ya(e) || !(e != null && e.length);
const qL = (e, t, n) => e.getValue(t) === n;
qL.autoRemove = (e) => ya(e);
const JL = (e, t, n) => e.getValue(t) == n;
JL.autoRemove = (e) => ya(e);
const o7 = (e, t, n) => {
  let [r, o] = n;
  const a = e.getValue(t);
  return a >= r && a <= o;
};
o7.resolveFilterValue = (e) => {
  let [t, n] = e, r = typeof t != "number" ? parseFloat(t) : t, o = typeof n != "number" ? parseFloat(n) : n, a = t === null || Number.isNaN(r) ? -1 / 0 : r, i = n === null || Number.isNaN(o) ? 1 / 0 : o;
  if (a > i) {
    const l = a;
    a = i, i = l;
  }
  return [a, i];
};
o7.autoRemove = (e) => ya(e) || ya(e[0]) && ya(e[1]);
const ci = {
  includesString: jL,
  includesStringSensitive: WL,
  equalsString: zL,
  arrIncludes: UL,
  arrIncludesAll: XL,
  arrIncludesSome: YL,
  equals: qL,
  weakEquals: JL,
  inNumberRange: o7
};
function ya(e) {
  return e == null || e === "";
}
const Rme = {
  getDefaultColumnDef: () => ({
    filterFn: "auto"
  }),
  getInitialState: (e) => ({
    columnFilters: [],
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnFiltersChange: Io("columnFilters", e),
    filterFromLeafRows: !1,
    maxLeafRowFilterDepth: 100
  }),
  createColumn: (e, t) => {
    e.getAutoFilterFn = () => {
      const n = t.getCoreRowModel().flatRows[0], r = n == null ? void 0 : n.getValue(e.id);
      return typeof r == "string" ? ci.includesString : typeof r == "number" ? ci.inNumberRange : typeof r == "boolean" || r !== null && typeof r == "object" ? ci.equals : Array.isArray(r) ? ci.arrIncludes : ci.weakEquals;
    }, e.getFilterFn = () => {
      var n, r;
      return xm(e.columnDef.filterFn) ? e.columnDef.filterFn : e.columnDef.filterFn === "auto" ? e.getAutoFilterFn() : (
        // @ts-ignore
        (n = (r = t.options.filterFns) == null ? void 0 : r[e.columnDef.filterFn]) != null ? n : ci[e.columnDef.filterFn]
      );
    }, e.getCanFilter = () => {
      var n, r, o;
      return ((n = e.columnDef.enableColumnFilter) != null ? n : !0) && ((r = t.options.enableColumnFilters) != null ? r : !0) && ((o = t.options.enableFilters) != null ? o : !0) && !!e.accessorFn;
    }, e.getIsFiltered = () => e.getFilterIndex() > -1, e.getFilterValue = () => {
      var n;
      return (n = t.getState().columnFilters) == null || (n = n.find((r) => r.id === e.id)) == null ? void 0 : n.value;
    }, e.getFilterIndex = () => {
      var n, r;
      return (n = (r = t.getState().columnFilters) == null ? void 0 : r.findIndex((o) => o.id === e.id)) != null ? n : -1;
    }, e.setFilterValue = (n) => {
      t.setColumnFilters((r) => {
        const o = e.getFilterFn(), a = r == null ? void 0 : r.find((f) => f.id === e.id), i = vs(n, a ? a.value : void 0);
        if (ny(o, i, e)) {
          var l;
          return (l = r == null ? void 0 : r.filter((f) => f.id !== e.id)) != null ? l : [];
        }
        const u = {
          id: e.id,
          value: i
        };
        if (a) {
          var d;
          return (d = r == null ? void 0 : r.map((f) => f.id === e.id ? u : f)) != null ? d : [];
        }
        return r != null && r.length ? [...r, u] : [u];
      });
    };
  },
  createRow: (e, t) => {
    e.columnFilters = {}, e.columnFiltersMeta = {};
  },
  createTable: (e) => {
    e.setColumnFilters = (t) => {
      const n = e.getAllLeafColumns(), r = (o) => {
        var a;
        return (a = vs(t, o)) == null ? void 0 : a.filter((i) => {
          const l = n.find((u) => u.id === i.id);
          if (l) {
            const u = l.getFilterFn();
            if (ny(u, i.value, l))
              return !1;
          }
          return !0;
        });
      };
      e.options.onColumnFiltersChange == null || e.options.onColumnFiltersChange(r);
    }, e.resetColumnFilters = (t) => {
      var n, r;
      e.setColumnFilters(t ? [] : (n = (r = e.initialState) == null ? void 0 : r.columnFilters) != null ? n : []);
    }, e.getPreFilteredRowModel = () => e.getCoreRowModel(), e.getFilteredRowModel = () => (!e._getFilteredRowModel && e.options.getFilteredRowModel && (e._getFilteredRowModel = e.options.getFilteredRowModel(e)), e.options.manualFiltering || !e._getFilteredRowModel ? e.getPreFilteredRowModel() : e._getFilteredRowModel());
  }
};
function ny(e, t, n) {
  return (e && e.autoRemove ? e.autoRemove(t, n) : !1) || typeof t > "u" || typeof t == "string" && !t;
}
const Dme = (e, t, n) => n.reduce((r, o) => {
  const a = o.getValue(e);
  return r + (typeof a == "number" ? a : 0);
}, 0), Pme = (e, t, n) => {
  let r;
  return n.forEach((o) => {
    const a = o.getValue(e);
    a != null && (r > a || r === void 0 && a >= a) && (r = a);
  }), r;
}, Eme = (e, t, n) => {
  let r;
  return n.forEach((o) => {
    const a = o.getValue(e);
    a != null && (r < a || r === void 0 && a >= a) && (r = a);
  }), r;
}, Tme = (e, t, n) => {
  let r, o;
  return n.forEach((a) => {
    const i = a.getValue(e);
    i != null && (r === void 0 ? i >= i && (r = o = i) : (r > i && (r = i), o < i && (o = i)));
  }), [r, o];
}, Nme = (e, t) => {
  let n = 0, r = 0;
  if (t.forEach((o) => {
    let a = o.getValue(e);
    a != null && (a = +a) >= a && (++n, r += a);
  }), n)
    return r / n;
}, kme = (e, t) => {
  if (!t.length)
    return;
  const n = t.map((a) => a.getValue(e));
  if (!Ame(n))
    return;
  if (n.length === 1)
    return n[0];
  const r = Math.floor(n.length / 2), o = n.sort((a, i) => a - i);
  return n.length % 2 !== 0 ? o[r] : (o[r - 1] + o[r]) / 2;
}, Vme = (e, t) => Array.from(new Set(t.map((n) => n.getValue(e))).values()), Ome = (e, t) => new Set(t.map((n) => n.getValue(e))).size, Fme = (e, t) => t.length, Jg = {
  sum: Dme,
  min: Pme,
  max: Eme,
  extent: Tme,
  mean: Nme,
  median: kme,
  unique: Vme,
  uniqueCount: Ome,
  count: Fme
}, Bme = {
  getDefaultColumnDef: () => ({
    aggregatedCell: (e) => {
      var t, n;
      return (t = (n = e.getValue()) == null || n.toString == null ? void 0 : n.toString()) != null ? t : null;
    },
    aggregationFn: "auto"
  }),
  getInitialState: (e) => ({
    grouping: [],
    ...e
  }),
  getDefaultOptions: (e) => ({
    onGroupingChange: Io("grouping", e),
    groupedColumnMode: "reorder"
  }),
  createColumn: (e, t) => {
    e.toggleGrouping = () => {
      t.setGrouping((n) => n != null && n.includes(e.id) ? n.filter((r) => r !== e.id) : [...n ?? [], e.id]);
    }, e.getCanGroup = () => {
      var n, r;
      return ((n = e.columnDef.enableGrouping) != null ? n : !0) && ((r = t.options.enableGrouping) != null ? r : !0) && (!!e.accessorFn || !!e.columnDef.getGroupingValue);
    }, e.getIsGrouped = () => {
      var n;
      return (n = t.getState().grouping) == null ? void 0 : n.includes(e.id);
    }, e.getGroupedIndex = () => {
      var n;
      return (n = t.getState().grouping) == null ? void 0 : n.indexOf(e.id);
    }, e.getToggleGroupingHandler = () => {
      const n = e.getCanGroup();
      return () => {
        n && e.toggleGrouping();
      };
    }, e.getAutoAggregationFn = () => {
      const n = t.getCoreRowModel().flatRows[0], r = n == null ? void 0 : n.getValue(e.id);
      if (typeof r == "number")
        return Jg.sum;
      if (Object.prototype.toString.call(r) === "[object Date]")
        return Jg.extent;
    }, e.getAggregationFn = () => {
      var n, r;
      if (!e)
        throw new Error();
      return xm(e.columnDef.aggregationFn) ? e.columnDef.aggregationFn : e.columnDef.aggregationFn === "auto" ? e.getAutoAggregationFn() : (n = (r = t.options.aggregationFns) == null ? void 0 : r[e.columnDef.aggregationFn]) != null ? n : Jg[e.columnDef.aggregationFn];
    };
  },
  createTable: (e) => {
    e.setGrouping = (t) => e.options.onGroupingChange == null ? void 0 : e.options.onGroupingChange(t), e.resetGrouping = (t) => {
      var n, r;
      e.setGrouping(t ? [] : (n = (r = e.initialState) == null ? void 0 : r.grouping) != null ? n : []);
    }, e.getPreGroupedRowModel = () => e.getFilteredRowModel(), e.getGroupedRowModel = () => (!e._getGroupedRowModel && e.options.getGroupedRowModel && (e._getGroupedRowModel = e.options.getGroupedRowModel(e)), e.options.manualGrouping || !e._getGroupedRowModel ? e.getPreGroupedRowModel() : e._getGroupedRowModel());
  },
  createRow: (e, t) => {
    e.getIsGrouped = () => !!e.groupingColumnId, e.getGroupingValue = (n) => {
      if (e._groupingValuesCache.hasOwnProperty(n))
        return e._groupingValuesCache[n];
      const r = t.getColumn(n);
      return r != null && r.columnDef.getGroupingValue ? (e._groupingValuesCache[n] = r.columnDef.getGroupingValue(e.original), e._groupingValuesCache[n]) : e.getValue(n);
    }, e._groupingValuesCache = {};
  },
  createCell: (e, t, n, r) => {
    e.getIsGrouped = () => t.getIsGrouped() && t.id === n.groupingColumnId, e.getIsPlaceholder = () => !e.getIsGrouped() && t.getIsGrouped(), e.getIsAggregated = () => {
      var o;
      return !e.getIsGrouped() && !e.getIsPlaceholder() && !!((o = n.subRows) != null && o.length);
    };
  }
};
function Hme(e, t, n) {
  if (!(t != null && t.length) || !n)
    return e;
  const r = e.filter((a) => !t.includes(a.id));
  return n === "remove" ? r : [...t.map((a) => e.find((i) => i.id === a)).filter(Boolean), ...r];
}
const Gme = {
  getInitialState: (e) => ({
    columnOrder: [],
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnOrderChange: Io("columnOrder", e)
  }),
  createColumn: (e, t) => {
    e.getIndex = ht((n) => [od(t, n)], (n) => n.findIndex((r) => r.id === e.id), mt(t.options, "debugColumns", "getIndex")), e.getIsFirstColumn = (n) => {
      var r;
      return ((r = od(t, n)[0]) == null ? void 0 : r.id) === e.id;
    }, e.getIsLastColumn = (n) => {
      var r;
      const o = od(t, n);
      return ((r = o[o.length - 1]) == null ? void 0 : r.id) === e.id;
    };
  },
  createTable: (e) => {
    e.setColumnOrder = (t) => e.options.onColumnOrderChange == null ? void 0 : e.options.onColumnOrderChange(t), e.resetColumnOrder = (t) => {
      var n;
      e.setColumnOrder(t ? [] : (n = e.initialState.columnOrder) != null ? n : []);
    }, e._getOrderColumnsFn = ht(() => [e.getState().columnOrder, e.getState().grouping, e.options.groupedColumnMode], (t, n, r) => (o) => {
      let a = [];
      if (!(t != null && t.length))
        a = o;
      else {
        const i = [...t], l = [...o];
        for (; l.length && i.length; ) {
          const u = i.shift(), d = l.findIndex((f) => f.id === u);
          d > -1 && a.push(l.splice(d, 1)[0]);
        }
        a = [...a, ...l];
      }
      return Hme(a, n, r);
    }, mt(e.options, "debugTable", "_getOrderColumnsFn"));
  }
}, Kg = () => ({
  left: [],
  right: []
}), $me = {
  getInitialState: (e) => ({
    columnPinning: Kg(),
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnPinningChange: Io("columnPinning", e)
  }),
  createColumn: (e, t) => {
    e.pin = (n) => {
      const r = e.getLeafColumns().map((o) => o.id).filter(Boolean);
      t.setColumnPinning((o) => {
        var a, i;
        if (n === "right") {
          var l, u;
          return {
            left: ((l = o == null ? void 0 : o.left) != null ? l : []).filter((h) => !(r != null && r.includes(h))),
            right: [...((u = o == null ? void 0 : o.right) != null ? u : []).filter((h) => !(r != null && r.includes(h))), ...r]
          };
        }
        if (n === "left") {
          var d, f;
          return {
            left: [...((d = o == null ? void 0 : o.left) != null ? d : []).filter((h) => !(r != null && r.includes(h))), ...r],
            right: ((f = o == null ? void 0 : o.right) != null ? f : []).filter((h) => !(r != null && r.includes(h)))
          };
        }
        return {
          left: ((a = o == null ? void 0 : o.left) != null ? a : []).filter((h) => !(r != null && r.includes(h))),
          right: ((i = o == null ? void 0 : o.right) != null ? i : []).filter((h) => !(r != null && r.includes(h)))
        };
      });
    }, e.getCanPin = () => e.getLeafColumns().some((r) => {
      var o, a, i;
      return ((o = r.columnDef.enablePinning) != null ? o : !0) && ((a = (i = t.options.enableColumnPinning) != null ? i : t.options.enablePinning) != null ? a : !0);
    }), e.getIsPinned = () => {
      const n = e.getLeafColumns().map((l) => l.id), {
        left: r,
        right: o
      } = t.getState().columnPinning, a = n.some((l) => r == null ? void 0 : r.includes(l)), i = n.some((l) => o == null ? void 0 : o.includes(l));
      return a ? "left" : i ? "right" : !1;
    }, e.getPinnedIndex = () => {
      var n, r;
      const o = e.getIsPinned();
      return o ? (n = (r = t.getState().columnPinning) == null || (r = r[o]) == null ? void 0 : r.indexOf(e.id)) != null ? n : -1 : 0;
    };
  },
  createRow: (e, t) => {
    e.getCenterVisibleCells = ht(() => [e._getAllVisibleCells(), t.getState().columnPinning.left, t.getState().columnPinning.right], (n, r, o) => {
      const a = [...r ?? [], ...o ?? []];
      return n.filter((i) => !a.includes(i.column.id));
    }, mt(t.options, "debugRows", "getCenterVisibleCells")), e.getLeftVisibleCells = ht(() => [e._getAllVisibleCells(), t.getState().columnPinning.left], (n, r) => (r ?? []).map((a) => n.find((i) => i.column.id === a)).filter(Boolean).map((a) => ({
      ...a,
      position: "left"
    })), mt(t.options, "debugRows", "getLeftVisibleCells")), e.getRightVisibleCells = ht(() => [e._getAllVisibleCells(), t.getState().columnPinning.right], (n, r) => (r ?? []).map((a) => n.find((i) => i.column.id === a)).filter(Boolean).map((a) => ({
      ...a,
      position: "right"
    })), mt(t.options, "debugRows", "getRightVisibleCells"));
  },
  createTable: (e) => {
    e.setColumnPinning = (t) => e.options.onColumnPinningChange == null ? void 0 : e.options.onColumnPinningChange(t), e.resetColumnPinning = (t) => {
      var n, r;
      return e.setColumnPinning(t ? Kg() : (n = (r = e.initialState) == null ? void 0 : r.columnPinning) != null ? n : Kg());
    }, e.getIsSomeColumnsPinned = (t) => {
      var n;
      const r = e.getState().columnPinning;
      if (!t) {
        var o, a;
        return !!((o = r.left) != null && o.length || (a = r.right) != null && a.length);
      }
      return !!((n = r[t]) != null && n.length);
    }, e.getLeftLeafColumns = ht(() => [e.getAllLeafColumns(), e.getState().columnPinning.left], (t, n) => (n ?? []).map((r) => t.find((o) => o.id === r)).filter(Boolean), mt(e.options, "debugColumns", "getLeftLeafColumns")), e.getRightLeafColumns = ht(() => [e.getAllLeafColumns(), e.getState().columnPinning.right], (t, n) => (n ?? []).map((r) => t.find((o) => o.id === r)).filter(Boolean), mt(e.options, "debugColumns", "getRightLeafColumns")), e.getCenterLeafColumns = ht(() => [e.getAllLeafColumns(), e.getState().columnPinning.left, e.getState().columnPinning.right], (t, n, r) => {
      const o = [...n ?? [], ...r ?? []];
      return t.filter((a) => !o.includes(a.id));
    }, mt(e.options, "debugColumns", "getCenterLeafColumns"));
  }
};
function Zme(e) {
  return e || (typeof document < "u" ? document : null);
}
const Nf = {
  size: 150,
  minSize: 20,
  maxSize: Number.MAX_SAFE_INTEGER
}, Qg = () => ({
  startOffset: null,
  startSize: null,
  deltaOffset: null,
  deltaPercentage: null,
  isResizingColumn: !1,
  columnSizingStart: []
}), jme = {
  getDefaultColumnDef: () => Nf,
  getInitialState: (e) => ({
    columnSizing: {},
    columnSizingInfo: Qg(),
    ...e
  }),
  getDefaultOptions: (e) => ({
    columnResizeMode: "onEnd",
    columnResizeDirection: "ltr",
    onColumnSizingChange: Io("columnSizing", e),
    onColumnSizingInfoChange: Io("columnSizingInfo", e)
  }),
  createColumn: (e, t) => {
    e.getSize = () => {
      var n, r, o;
      const a = t.getState().columnSizing[e.id];
      return Math.min(Math.max((n = e.columnDef.minSize) != null ? n : Nf.minSize, (r = a ?? e.columnDef.size) != null ? r : Nf.size), (o = e.columnDef.maxSize) != null ? o : Nf.maxSize);
    }, e.getStart = ht((n) => [n, od(t, n), t.getState().columnSizing], (n, r) => r.slice(0, e.getIndex(n)).reduce((o, a) => o + a.getSize(), 0), mt(t.options, "debugColumns", "getStart")), e.getAfter = ht((n) => [n, od(t, n), t.getState().columnSizing], (n, r) => r.slice(e.getIndex(n) + 1).reduce((o, a) => o + a.getSize(), 0), mt(t.options, "debugColumns", "getAfter")), e.resetSize = () => {
      t.setColumnSizing((n) => {
        let {
          [e.id]: r,
          ...o
        } = n;
        return o;
      });
    }, e.getCanResize = () => {
      var n, r;
      return ((n = e.columnDef.enableResizing) != null ? n : !0) && ((r = t.options.enableColumnResizing) != null ? r : !0);
    }, e.getIsResizing = () => t.getState().columnSizingInfo.isResizingColumn === e.id;
  },
  createHeader: (e, t) => {
    e.getSize = () => {
      let n = 0;
      const r = (o) => {
        if (o.subHeaders.length)
          o.subHeaders.forEach(r);
        else {
          var a;
          n += (a = o.column.getSize()) != null ? a : 0;
        }
      };
      return r(e), n;
    }, e.getStart = () => {
      if (e.index > 0) {
        const n = e.headerGroup.headers[e.index - 1];
        return n.getStart() + n.getSize();
      }
      return 0;
    }, e.getResizeHandler = (n) => {
      const r = t.getColumn(e.column.id), o = r == null ? void 0 : r.getCanResize();
      return (a) => {
        if (!r || !o || (a.persist == null || a.persist(), e5(a) && a.touches && a.touches.length > 1))
          return;
        const i = e.getSize(), l = e ? e.getLeafHeaders().map((M) => [M.column.id, M.column.getSize()]) : [[r.id, r.getSize()]], u = e5(a) ? Math.round(a.touches[0].clientX) : a.clientX, d = {}, f = (M, x) => {
          typeof x == "number" && (t.setColumnSizingInfo((_) => {
            var L, R;
            const k = t.options.columnResizeDirection === "rtl" ? -1 : 1, P = (x - ((L = _ == null ? void 0 : _.startOffset) != null ? L : 0)) * k, N = Math.max(P / ((R = _ == null ? void 0 : _.startSize) != null ? R : 0), -0.999999);
            return _.columnSizingStart.forEach((O) => {
              let [H, $] = O;
              d[H] = Math.round(Math.max($ + $ * N, 0) * 100) / 100;
            }), {
              ..._,
              deltaOffset: P,
              deltaPercentage: N
            };
          }), (t.options.columnResizeMode === "onChange" || M === "end") && t.setColumnSizing((_) => ({
            ..._,
            ...d
          })));
        }, h = (M) => f("move", M), p = (M) => {
          f("end", M), t.setColumnSizingInfo((x) => ({
            ...x,
            isResizingColumn: !1,
            startOffset: null,
            startSize: null,
            deltaOffset: null,
            deltaPercentage: null,
            columnSizingStart: []
          }));
        }, g = Zme(n), C = {
          moveHandler: (M) => h(M.clientX),
          upHandler: (M) => {
            g == null || g.removeEventListener("mousemove", C.moveHandler), g == null || g.removeEventListener("mouseup", C.upHandler), p(M.clientX);
          }
        }, v = {
          moveHandler: (M) => (M.cancelable && (M.preventDefault(), M.stopPropagation()), h(M.touches[0].clientX), !1),
          upHandler: (M) => {
            var x;
            g == null || g.removeEventListener("touchmove", v.moveHandler), g == null || g.removeEventListener("touchend", v.upHandler), M.cancelable && (M.preventDefault(), M.stopPropagation()), p((x = M.touches[0]) == null ? void 0 : x.clientX);
          }
        }, y = Wme() ? {
          passive: !1
        } : !1;
        e5(a) ? (g == null || g.addEventListener("touchmove", v.moveHandler, y), g == null || g.addEventListener("touchend", v.upHandler, y)) : (g == null || g.addEventListener("mousemove", C.moveHandler, y), g == null || g.addEventListener("mouseup", C.upHandler, y)), t.setColumnSizingInfo((M) => ({
          ...M,
          startOffset: u,
          startSize: i,
          deltaOffset: 0,
          deltaPercentage: 0,
          columnSizingStart: l,
          isResizingColumn: r.id
        }));
      };
    };
  },
  createTable: (e) => {
    e.setColumnSizing = (t) => e.options.onColumnSizingChange == null ? void 0 : e.options.onColumnSizingChange(t), e.setColumnSizingInfo = (t) => e.options.onColumnSizingInfoChange == null ? void 0 : e.options.onColumnSizingInfoChange(t), e.resetColumnSizing = (t) => {
      var n;
      e.setColumnSizing(t ? {} : (n = e.initialState.columnSizing) != null ? n : {});
    }, e.resetHeaderSizeInfo = (t) => {
      var n;
      e.setColumnSizingInfo(t ? Qg() : (n = e.initialState.columnSizingInfo) != null ? n : Qg());
    }, e.getTotalSize = () => {
      var t, n;
      return (t = (n = e.getHeaderGroups()[0]) == null ? void 0 : n.headers.reduce((r, o) => r + o.getSize(), 0)) != null ? t : 0;
    }, e.getLeftTotalSize = () => {
      var t, n;
      return (t = (n = e.getLeftHeaderGroups()[0]) == null ? void 0 : n.headers.reduce((r, o) => r + o.getSize(), 0)) != null ? t : 0;
    }, e.getCenterTotalSize = () => {
      var t, n;
      return (t = (n = e.getCenterHeaderGroups()[0]) == null ? void 0 : n.headers.reduce((r, o) => r + o.getSize(), 0)) != null ? t : 0;
    }, e.getRightTotalSize = () => {
      var t, n;
      return (t = (n = e.getRightHeaderGroups()[0]) == null ? void 0 : n.headers.reduce((r, o) => r + o.getSize(), 0)) != null ? t : 0;
    };
  }
};
let kf = null;
function Wme() {
  if (typeof kf == "boolean")
    return kf;
  let e = !1;
  try {
    const t = {
      get passive() {
        return e = !0, !1;
      }
    }, n = () => {
    };
    window.addEventListener("test", n, t), window.removeEventListener("test", n);
  } catch {
    e = !1;
  }
  return kf = e, kf;
}
function e5(e) {
  return e.type === "touchstart";
}
const zme = {
  getInitialState: (e) => ({
    columnVisibility: {},
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnVisibilityChange: Io("columnVisibility", e)
  }),
  createColumn: (e, t) => {
    e.toggleVisibility = (n) => {
      e.getCanHide() && t.setColumnVisibility((r) => ({
        ...r,
        [e.id]: n ?? !e.getIsVisible()
      }));
    }, e.getIsVisible = () => {
      var n, r;
      const o = e.columns;
      return (n = o.length ? o.some((a) => a.getIsVisible()) : (r = t.getState().columnVisibility) == null ? void 0 : r[e.id]) != null ? n : !0;
    }, e.getCanHide = () => {
      var n, r;
      return ((n = e.columnDef.enableHiding) != null ? n : !0) && ((r = t.options.enableHiding) != null ? r : !0);
    }, e.getToggleVisibilityHandler = () => (n) => {
      e.toggleVisibility == null || e.toggleVisibility(n.target.checked);
    };
  },
  createRow: (e, t) => {
    e._getAllVisibleCells = ht(() => [e.getAllCells(), t.getState().columnVisibility], (n) => n.filter((r) => r.column.getIsVisible()), mt(t.options, "debugRows", "_getAllVisibleCells")), e.getVisibleCells = ht(() => [e.getLeftVisibleCells(), e.getCenterVisibleCells(), e.getRightVisibleCells()], (n, r, o) => [...n, ...r, ...o], mt(t.options, "debugRows", "getVisibleCells"));
  },
  createTable: (e) => {
    const t = (n, r) => ht(() => [r(), r().filter((o) => o.getIsVisible()).map((o) => o.id).join("_")], (o) => o.filter((a) => a.getIsVisible == null ? void 0 : a.getIsVisible()), mt(e.options, "debugColumns", n));
    e.getVisibleFlatColumns = t("getVisibleFlatColumns", () => e.getAllFlatColumns()), e.getVisibleLeafColumns = t("getVisibleLeafColumns", () => e.getAllLeafColumns()), e.getLeftVisibleLeafColumns = t("getLeftVisibleLeafColumns", () => e.getLeftLeafColumns()), e.getRightVisibleLeafColumns = t("getRightVisibleLeafColumns", () => e.getRightLeafColumns()), e.getCenterVisibleLeafColumns = t("getCenterVisibleLeafColumns", () => e.getCenterLeafColumns()), e.setColumnVisibility = (n) => e.options.onColumnVisibilityChange == null ? void 0 : e.options.onColumnVisibilityChange(n), e.resetColumnVisibility = (n) => {
      var r;
      e.setColumnVisibility(n ? {} : (r = e.initialState.columnVisibility) != null ? r : {});
    }, e.toggleAllColumnsVisible = (n) => {
      var r;
      n = (r = n) != null ? r : !e.getIsAllColumnsVisible(), e.setColumnVisibility(e.getAllLeafColumns().reduce((o, a) => ({
        ...o,
        [a.id]: n || !(a.getCanHide != null && a.getCanHide())
      }), {}));
    }, e.getIsAllColumnsVisible = () => !e.getAllLeafColumns().some((n) => !(n.getIsVisible != null && n.getIsVisible())), e.getIsSomeColumnsVisible = () => e.getAllLeafColumns().some((n) => n.getIsVisible == null ? void 0 : n.getIsVisible()), e.getToggleAllColumnsVisibilityHandler = () => (n) => {
      var r;
      e.toggleAllColumnsVisible((r = n.target) == null ? void 0 : r.checked);
    };
  }
};
function od(e, t) {
  return t ? t === "center" ? e.getCenterVisibleLeafColumns() : t === "left" ? e.getLeftVisibleLeafColumns() : e.getRightVisibleLeafColumns() : e.getVisibleLeafColumns();
}
const Ume = {
  createTable: (e) => {
    e._getGlobalFacetedRowModel = e.options.getFacetedRowModel && e.options.getFacetedRowModel(e, "__global__"), e.getGlobalFacetedRowModel = () => e.options.manualFiltering || !e._getGlobalFacetedRowModel ? e.getPreFilteredRowModel() : e._getGlobalFacetedRowModel(), e._getGlobalFacetedUniqueValues = e.options.getFacetedUniqueValues && e.options.getFacetedUniqueValues(e, "__global__"), e.getGlobalFacetedUniqueValues = () => e._getGlobalFacetedUniqueValues ? e._getGlobalFacetedUniqueValues() : /* @__PURE__ */ new Map(), e._getGlobalFacetedMinMaxValues = e.options.getFacetedMinMaxValues && e.options.getFacetedMinMaxValues(e, "__global__"), e.getGlobalFacetedMinMaxValues = () => {
      if (e._getGlobalFacetedMinMaxValues)
        return e._getGlobalFacetedMinMaxValues();
    };
  }
}, Xme = {
  getInitialState: (e) => ({
    globalFilter: void 0,
    ...e
  }),
  getDefaultOptions: (e) => ({
    onGlobalFilterChange: Io("globalFilter", e),
    globalFilterFn: "auto",
    getColumnCanGlobalFilter: (t) => {
      var n;
      const r = (n = e.getCoreRowModel().flatRows[0]) == null || (n = n._getAllCellsByColumnId()[t.id]) == null ? void 0 : n.getValue();
      return typeof r == "string" || typeof r == "number";
    }
  }),
  createColumn: (e, t) => {
    e.getCanGlobalFilter = () => {
      var n, r, o, a;
      return ((n = e.columnDef.enableGlobalFilter) != null ? n : !0) && ((r = t.options.enableGlobalFilter) != null ? r : !0) && ((o = t.options.enableFilters) != null ? o : !0) && ((a = t.options.getColumnCanGlobalFilter == null ? void 0 : t.options.getColumnCanGlobalFilter(e)) != null ? a : !0) && !!e.accessorFn;
    };
  },
  createTable: (e) => {
    e.getGlobalAutoFilterFn = () => ci.includesString, e.getGlobalFilterFn = () => {
      var t, n;
      const {
        globalFilterFn: r
      } = e.options;
      return xm(r) ? r : r === "auto" ? e.getGlobalAutoFilterFn() : (t = (n = e.options.filterFns) == null ? void 0 : n[r]) != null ? t : ci[r];
    }, e.setGlobalFilter = (t) => {
      e.options.onGlobalFilterChange == null || e.options.onGlobalFilterChange(t);
    }, e.resetGlobalFilter = (t) => {
      e.setGlobalFilter(t ? void 0 : e.initialState.globalFilter);
    };
  }
}, Yme = {
  getInitialState: (e) => ({
    expanded: {},
    ...e
  }),
  getDefaultOptions: (e) => ({
    onExpandedChange: Io("expanded", e),
    paginateExpandedRows: !0
  }),
  createTable: (e) => {
    let t = !1, n = !1;
    e._autoResetExpanded = () => {
      var r, o;
      if (!t) {
        e._queue(() => {
          t = !0;
        });
        return;
      }
      if ((r = (o = e.options.autoResetAll) != null ? o : e.options.autoResetExpanded) != null ? r : !e.options.manualExpanding) {
        if (n)
          return;
        n = !0, e._queue(() => {
          e.resetExpanded(), n = !1;
        });
      }
    }, e.setExpanded = (r) => e.options.onExpandedChange == null ? void 0 : e.options.onExpandedChange(r), e.toggleAllRowsExpanded = (r) => {
      r ?? !e.getIsAllRowsExpanded() ? e.setExpanded(!0) : e.setExpanded({});
    }, e.resetExpanded = (r) => {
      var o, a;
      e.setExpanded(r ? {} : (o = (a = e.initialState) == null ? void 0 : a.expanded) != null ? o : {});
    }, e.getCanSomeRowsExpand = () => e.getPrePaginationRowModel().flatRows.some((r) => r.getCanExpand()), e.getToggleAllRowsExpandedHandler = () => (r) => {
      r.persist == null || r.persist(), e.toggleAllRowsExpanded();
    }, e.getIsSomeRowsExpanded = () => {
      const r = e.getState().expanded;
      return r === !0 || Object.values(r).some(Boolean);
    }, e.getIsAllRowsExpanded = () => {
      const r = e.getState().expanded;
      return typeof r == "boolean" ? r === !0 : !(!Object.keys(r).length || e.getRowModel().flatRows.some((o) => !o.getIsExpanded()));
    }, e.getExpandedDepth = () => {
      let r = 0;
      return (e.getState().expanded === !0 ? Object.keys(e.getRowModel().rowsById) : Object.keys(e.getState().expanded)).forEach((a) => {
        const i = a.split(".");
        r = Math.max(r, i.length);
      }), r;
    }, e.getPreExpandedRowModel = () => e.getSortedRowModel(), e.getExpandedRowModel = () => (!e._getExpandedRowModel && e.options.getExpandedRowModel && (e._getExpandedRowModel = e.options.getExpandedRowModel(e)), e.options.manualExpanding || !e._getExpandedRowModel ? e.getPreExpandedRowModel() : e._getExpandedRowModel());
  },
  createRow: (e, t) => {
    e.toggleExpanded = (n) => {
      t.setExpanded((r) => {
        var o;
        const a = r === !0 ? !0 : !!(r != null && r[e.id]);
        let i = {};
        if (r === !0 ? Object.keys(t.getRowModel().rowsById).forEach((l) => {
          i[l] = !0;
        }) : i = r, n = (o = n) != null ? o : !a, !a && n)
          return {
            ...i,
            [e.id]: !0
          };
        if (a && !n) {
          const {
            [e.id]: l,
            ...u
          } = i;
          return u;
        }
        return r;
      });
    }, e.getIsExpanded = () => {
      var n;
      const r = t.getState().expanded;
      return !!((n = t.options.getIsRowExpanded == null ? void 0 : t.options.getIsRowExpanded(e)) != null ? n : r === !0 || r != null && r[e.id]);
    }, e.getCanExpand = () => {
      var n, r, o;
      return (n = t.options.getRowCanExpand == null ? void 0 : t.options.getRowCanExpand(e)) != null ? n : ((r = t.options.enableExpanding) != null ? r : !0) && !!((o = e.subRows) != null && o.length);
    }, e.getIsAllParentsExpanded = () => {
      let n = !0, r = e;
      for (; n && r.parentId; )
        r = t.getRow(r.parentId, !0), n = r.getIsExpanded();
      return n;
    }, e.getToggleExpandedHandler = () => {
      const n = e.getCanExpand();
      return () => {
        n && e.toggleExpanded();
      };
    };
  }
}, L3 = 0, R3 = 10, t5 = () => ({
  pageIndex: L3,
  pageSize: R3
}), qme = {
  getInitialState: (e) => ({
    ...e,
    pagination: {
      ...t5(),
      ...e == null ? void 0 : e.pagination
    }
  }),
  getDefaultOptions: (e) => ({
    onPaginationChange: Io("pagination", e)
  }),
  createTable: (e) => {
    let t = !1, n = !1;
    e._autoResetPageIndex = () => {
      var r, o;
      if (!t) {
        e._queue(() => {
          t = !0;
        });
        return;
      }
      if ((r = (o = e.options.autoResetAll) != null ? o : e.options.autoResetPageIndex) != null ? r : !e.options.manualPagination) {
        if (n)
          return;
        n = !0, e._queue(() => {
          e.resetPageIndex(), n = !1;
        });
      }
    }, e.setPagination = (r) => {
      const o = (a) => vs(r, a);
      return e.options.onPaginationChange == null ? void 0 : e.options.onPaginationChange(o);
    }, e.resetPagination = (r) => {
      var o;
      e.setPagination(r ? t5() : (o = e.initialState.pagination) != null ? o : t5());
    }, e.setPageIndex = (r) => {
      e.setPagination((o) => {
        let a = vs(r, o.pageIndex);
        const i = typeof e.options.pageCount > "u" || e.options.pageCount === -1 ? Number.MAX_SAFE_INTEGER : e.options.pageCount - 1;
        return a = Math.max(0, Math.min(a, i)), {
          ...o,
          pageIndex: a
        };
      });
    }, e.resetPageIndex = (r) => {
      var o, a;
      e.setPageIndex(r ? L3 : (o = (a = e.initialState) == null || (a = a.pagination) == null ? void 0 : a.pageIndex) != null ? o : L3);
    }, e.resetPageSize = (r) => {
      var o, a;
      e.setPageSize(r ? R3 : (o = (a = e.initialState) == null || (a = a.pagination) == null ? void 0 : a.pageSize) != null ? o : R3);
    }, e.setPageSize = (r) => {
      e.setPagination((o) => {
        const a = Math.max(1, vs(r, o.pageSize)), i = o.pageSize * o.pageIndex, l = Math.floor(i / a);
        return {
          ...o,
          pageIndex: l,
          pageSize: a
        };
      });
    }, e.setPageCount = (r) => e.setPagination((o) => {
      var a;
      let i = vs(r, (a = e.options.pageCount) != null ? a : -1);
      return typeof i == "number" && (i = Math.max(-1, i)), {
        ...o,
        pageCount: i
      };
    }), e.getPageOptions = ht(() => [e.getPageCount()], (r) => {
      let o = [];
      return r && r > 0 && (o = [...new Array(r)].fill(null).map((a, i) => i)), o;
    }, mt(e.options, "debugTable", "getPageOptions")), e.getCanPreviousPage = () => e.getState().pagination.pageIndex > 0, e.getCanNextPage = () => {
      const {
        pageIndex: r
      } = e.getState().pagination, o = e.getPageCount();
      return o === -1 ? !0 : o === 0 ? !1 : r < o - 1;
    }, e.previousPage = () => e.setPageIndex((r) => r - 1), e.nextPage = () => e.setPageIndex((r) => r + 1), e.firstPage = () => e.setPageIndex(0), e.lastPage = () => e.setPageIndex(e.getPageCount() - 1), e.getPrePaginationRowModel = () => e.getExpandedRowModel(), e.getPaginationRowModel = () => (!e._getPaginationRowModel && e.options.getPaginationRowModel && (e._getPaginationRowModel = e.options.getPaginationRowModel(e)), e.options.manualPagination || !e._getPaginationRowModel ? e.getPrePaginationRowModel() : e._getPaginationRowModel()), e.getPageCount = () => {
      var r;
      return (r = e.options.pageCount) != null ? r : Math.ceil(e.getRowCount() / e.getState().pagination.pageSize);
    }, e.getRowCount = () => {
      var r;
      return (r = e.options.rowCount) != null ? r : e.getPrePaginationRowModel().rows.length;
    };
  }
}, n5 = () => ({
  top: [],
  bottom: []
}), Jme = {
  getInitialState: (e) => ({
    rowPinning: n5(),
    ...e
  }),
  getDefaultOptions: (e) => ({
    onRowPinningChange: Io("rowPinning", e)
  }),
  createRow: (e, t) => {
    e.pin = (n, r, o) => {
      const a = r ? e.getLeafRows().map((u) => {
        let {
          id: d
        } = u;
        return d;
      }) : [], i = o ? e.getParentRows().map((u) => {
        let {
          id: d
        } = u;
        return d;
      }) : [], l = /* @__PURE__ */ new Set([...i, e.id, ...a]);
      t.setRowPinning((u) => {
        var d, f;
        if (n === "bottom") {
          var h, p;
          return {
            top: ((h = u == null ? void 0 : u.top) != null ? h : []).filter((v) => !(l != null && l.has(v))),
            bottom: [...((p = u == null ? void 0 : u.bottom) != null ? p : []).filter((v) => !(l != null && l.has(v))), ...Array.from(l)]
          };
        }
        if (n === "top") {
          var g, C;
          return {
            top: [...((g = u == null ? void 0 : u.top) != null ? g : []).filter((v) => !(l != null && l.has(v))), ...Array.from(l)],
            bottom: ((C = u == null ? void 0 : u.bottom) != null ? C : []).filter((v) => !(l != null && l.has(v)))
          };
        }
        return {
          top: ((d = u == null ? void 0 : u.top) != null ? d : []).filter((v) => !(l != null && l.has(v))),
          bottom: ((f = u == null ? void 0 : u.bottom) != null ? f : []).filter((v) => !(l != null && l.has(v)))
        };
      });
    }, e.getCanPin = () => {
      var n;
      const {
        enableRowPinning: r,
        enablePinning: o
      } = t.options;
      return typeof r == "function" ? r(e) : (n = r ?? o) != null ? n : !0;
    }, e.getIsPinned = () => {
      const n = [e.id], {
        top: r,
        bottom: o
      } = t.getState().rowPinning, a = n.some((l) => r == null ? void 0 : r.includes(l)), i = n.some((l) => o == null ? void 0 : o.includes(l));
      return a ? "top" : i ? "bottom" : !1;
    }, e.getPinnedIndex = () => {
      var n, r;
      const o = e.getIsPinned();
      if (!o)
        return -1;
      const a = (n = o === "top" ? t.getTopRows() : t.getBottomRows()) == null ? void 0 : n.map((i) => {
        let {
          id: l
        } = i;
        return l;
      });
      return (r = a == null ? void 0 : a.indexOf(e.id)) != null ? r : -1;
    };
  },
  createTable: (e) => {
    e.setRowPinning = (t) => e.options.onRowPinningChange == null ? void 0 : e.options.onRowPinningChange(t), e.resetRowPinning = (t) => {
      var n, r;
      return e.setRowPinning(t ? n5() : (n = (r = e.initialState) == null ? void 0 : r.rowPinning) != null ? n : n5());
    }, e.getIsSomeRowsPinned = (t) => {
      var n;
      const r = e.getState().rowPinning;
      if (!t) {
        var o, a;
        return !!((o = r.top) != null && o.length || (a = r.bottom) != null && a.length);
      }
      return !!((n = r[t]) != null && n.length);
    }, e._getPinnedRows = (t, n, r) => {
      var o;
      return ((o = e.options.keepPinnedRows) == null || o ? (
        //get all rows that are pinned even if they would not be otherwise visible
        //account for expanded parent rows, but not pagination or filtering
        (n ?? []).map((i) => {
          const l = e.getRow(i, !0);
          return l.getIsAllParentsExpanded() ? l : null;
        })
      ) : (
        //else get only visible rows that are pinned
        (n ?? []).map((i) => t.find((l) => l.id === i))
      )).filter(Boolean).map((i) => ({
        ...i,
        position: r
      }));
    }, e.getTopRows = ht(() => [e.getRowModel().rows, e.getState().rowPinning.top], (t, n) => e._getPinnedRows(t, n, "top"), mt(e.options, "debugRows", "getTopRows")), e.getBottomRows = ht(() => [e.getRowModel().rows, e.getState().rowPinning.bottom], (t, n) => e._getPinnedRows(t, n, "bottom"), mt(e.options, "debugRows", "getBottomRows")), e.getCenterRows = ht(() => [e.getRowModel().rows, e.getState().rowPinning.top, e.getState().rowPinning.bottom], (t, n, r) => {
      const o = /* @__PURE__ */ new Set([...n ?? [], ...r ?? []]);
      return t.filter((a) => !o.has(a.id));
    }, mt(e.options, "debugRows", "getCenterRows"));
  }
}, Kme = {
  getInitialState: (e) => ({
    rowSelection: {},
    ...e
  }),
  getDefaultOptions: (e) => ({
    onRowSelectionChange: Io("rowSelection", e),
    enableRowSelection: !0,
    enableMultiRowSelection: !0,
    enableSubRowSelection: !0
    // enableGroupingRowSelection: false,
    // isAdditiveSelectEvent: (e: unknown) => !!e.metaKey,
    // isInclusiveSelectEvent: (e: unknown) => !!e.shiftKey,
  }),
  createTable: (e) => {
    e.setRowSelection = (t) => e.options.onRowSelectionChange == null ? void 0 : e.options.onRowSelectionChange(t), e.resetRowSelection = (t) => {
      var n;
      return e.setRowSelection(t ? {} : (n = e.initialState.rowSelection) != null ? n : {});
    }, e.toggleAllRowsSelected = (t) => {
      e.setRowSelection((n) => {
        t = typeof t < "u" ? t : !e.getIsAllRowsSelected();
        const r = {
          ...n
        }, o = e.getPreGroupedRowModel().flatRows;
        return t ? o.forEach((a) => {
          a.getCanSelect() && (r[a.id] = !0);
        }) : o.forEach((a) => {
          delete r[a.id];
        }), r;
      });
    }, e.toggleAllPageRowsSelected = (t) => e.setRowSelection((n) => {
      const r = typeof t < "u" ? t : !e.getIsAllPageRowsSelected(), o = {
        ...n
      };
      return e.getRowModel().rows.forEach((a) => {
        D3(o, a.id, r, !0, e);
      }), o;
    }), e.getPreSelectedRowModel = () => e.getCoreRowModel(), e.getSelectedRowModel = ht(() => [e.getState().rowSelection, e.getCoreRowModel()], (t, n) => Object.keys(t).length ? r5(e, n) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, mt(e.options, "debugTable", "getSelectedRowModel")), e.getFilteredSelectedRowModel = ht(() => [e.getState().rowSelection, e.getFilteredRowModel()], (t, n) => Object.keys(t).length ? r5(e, n) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, mt(e.options, "debugTable", "getFilteredSelectedRowModel")), e.getGroupedSelectedRowModel = ht(() => [e.getState().rowSelection, e.getSortedRowModel()], (t, n) => Object.keys(t).length ? r5(e, n) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, mt(e.options, "debugTable", "getGroupedSelectedRowModel")), e.getIsAllRowsSelected = () => {
      const t = e.getFilteredRowModel().flatRows, {
        rowSelection: n
      } = e.getState();
      let r = !!(t.length && Object.keys(n).length);
      return r && t.some((o) => o.getCanSelect() && !n[o.id]) && (r = !1), r;
    }, e.getIsAllPageRowsSelected = () => {
      const t = e.getPaginationRowModel().flatRows.filter((o) => o.getCanSelect()), {
        rowSelection: n
      } = e.getState();
      let r = !!t.length;
      return r && t.some((o) => !n[o.id]) && (r = !1), r;
    }, e.getIsSomeRowsSelected = () => {
      var t;
      const n = Object.keys((t = e.getState().rowSelection) != null ? t : {}).length;
      return n > 0 && n < e.getFilteredRowModel().flatRows.length;
    }, e.getIsSomePageRowsSelected = () => {
      const t = e.getPaginationRowModel().flatRows;
      return e.getIsAllPageRowsSelected() ? !1 : t.filter((n) => n.getCanSelect()).some((n) => n.getIsSelected() || n.getIsSomeSelected());
    }, e.getToggleAllRowsSelectedHandler = () => (t) => {
      e.toggleAllRowsSelected(t.target.checked);
    }, e.getToggleAllPageRowsSelectedHandler = () => (t) => {
      e.toggleAllPageRowsSelected(t.target.checked);
    };
  },
  createRow: (e, t) => {
    e.toggleSelected = (n, r) => {
      const o = e.getIsSelected();
      t.setRowSelection((a) => {
        var i;
        if (n = typeof n < "u" ? n : !o, e.getCanSelect() && o === n)
          return a;
        const l = {
          ...a
        };
        return D3(l, e.id, n, (i = r == null ? void 0 : r.selectChildren) != null ? i : !0, t), l;
      });
    }, e.getIsSelected = () => {
      const {
        rowSelection: n
      } = t.getState();
      return a7(e, n);
    }, e.getIsSomeSelected = () => {
      const {
        rowSelection: n
      } = t.getState();
      return P3(e, n) === "some";
    }, e.getIsAllSubRowsSelected = () => {
      const {
        rowSelection: n
      } = t.getState();
      return P3(e, n) === "all";
    }, e.getCanSelect = () => {
      var n;
      return typeof t.options.enableRowSelection == "function" ? t.options.enableRowSelection(e) : (n = t.options.enableRowSelection) != null ? n : !0;
    }, e.getCanSelectSubRows = () => {
      var n;
      return typeof t.options.enableSubRowSelection == "function" ? t.options.enableSubRowSelection(e) : (n = t.options.enableSubRowSelection) != null ? n : !0;
    }, e.getCanMultiSelect = () => {
      var n;
      return typeof t.options.enableMultiRowSelection == "function" ? t.options.enableMultiRowSelection(e) : (n = t.options.enableMultiRowSelection) != null ? n : !0;
    }, e.getToggleSelectedHandler = () => {
      const n = e.getCanSelect();
      return (r) => {
        var o;
        n && e.toggleSelected((o = r.target) == null ? void 0 : o.checked);
      };
    };
  }
}, D3 = (e, t, n, r, o) => {
  var a;
  const i = o.getRow(t, !0);
  n ? (i.getCanMultiSelect() || Object.keys(e).forEach((l) => delete e[l]), i.getCanSelect() && (e[t] = !0)) : delete e[t], r && (a = i.subRows) != null && a.length && i.getCanSelectSubRows() && i.subRows.forEach((l) => D3(e, l.id, n, r, o));
};
function r5(e, t) {
  const n = e.getState().rowSelection, r = [], o = {}, a = function(i, l) {
    return i.map((u) => {
      var d;
      const f = a7(u, n);
      if (f && (r.push(u), o[u.id] = u), (d = u.subRows) != null && d.length && (u = {
        ...u,
        subRows: a(u.subRows)
      }), f)
        return u;
    }).filter(Boolean);
  };
  return {
    rows: a(t.rows),
    flatRows: r,
    rowsById: o
  };
}
function a7(e, t) {
  var n;
  return (n = t[e.id]) != null ? n : !1;
}
function P3(e, t, n) {
  var r;
  if (!((r = e.subRows) != null && r.length))
    return !1;
  let o = !0, a = !1;
  return e.subRows.forEach((i) => {
    if (!(a && !o) && (i.getCanSelect() && (a7(i, t) ? a = !0 : o = !1), i.subRows && i.subRows.length)) {
      const l = P3(i, t);
      l === "all" ? a = !0 : (l === "some" && (a = !0), o = !1);
    }
  }), o ? "all" : a ? "some" : !1;
}
const E3 = /([0-9]+)/gm, Qme = (e, t, n) => KL(Is(e.getValue(n)).toLowerCase(), Is(t.getValue(n)).toLowerCase()), epe = (e, t, n) => KL(Is(e.getValue(n)), Is(t.getValue(n))), tpe = (e, t, n) => i7(Is(e.getValue(n)).toLowerCase(), Is(t.getValue(n)).toLowerCase()), npe = (e, t, n) => i7(Is(e.getValue(n)), Is(t.getValue(n))), rpe = (e, t, n) => {
  const r = e.getValue(n), o = t.getValue(n);
  return r > o ? 1 : r < o ? -1 : 0;
}, ope = (e, t, n) => i7(e.getValue(n), t.getValue(n));
function i7(e, t) {
  return e === t ? 0 : e > t ? 1 : -1;
}
function Is(e) {
  return typeof e == "number" ? isNaN(e) || e === 1 / 0 || e === -1 / 0 ? "" : String(e) : typeof e == "string" ? e : "";
}
function KL(e, t) {
  const n = e.split(E3).filter(Boolean), r = t.split(E3).filter(Boolean);
  for (; n.length && r.length; ) {
    const o = n.shift(), a = r.shift(), i = parseInt(o, 10), l = parseInt(a, 10), u = [i, l].sort();
    if (isNaN(u[0])) {
      if (o > a)
        return 1;
      if (a > o)
        return -1;
      continue;
    }
    if (isNaN(u[1]))
      return isNaN(i) ? -1 : 1;
    if (i > l)
      return 1;
    if (l > i)
      return -1;
  }
  return n.length - r.length;
}
const x1 = {
  alphanumeric: Qme,
  alphanumericCaseSensitive: epe,
  text: tpe,
  textCaseSensitive: npe,
  datetime: rpe,
  basic: ope
}, ape = {
  getInitialState: (e) => ({
    sorting: [],
    ...e
  }),
  getDefaultColumnDef: () => ({
    sortingFn: "auto",
    sortUndefined: 1
  }),
  getDefaultOptions: (e) => ({
    onSortingChange: Io("sorting", e),
    isMultiSortEvent: (t) => t.shiftKey
  }),
  createColumn: (e, t) => {
    e.getAutoSortingFn = () => {
      const n = t.getFilteredRowModel().flatRows.slice(10);
      let r = !1;
      for (const o of n) {
        const a = o == null ? void 0 : o.getValue(e.id);
        if (Object.prototype.toString.call(a) === "[object Date]")
          return x1.datetime;
        if (typeof a == "string" && (r = !0, a.split(E3).length > 1))
          return x1.alphanumeric;
      }
      return r ? x1.text : x1.basic;
    }, e.getAutoSortDir = () => {
      const n = t.getFilteredRowModel().flatRows[0];
      return typeof (n == null ? void 0 : n.getValue(e.id)) == "string" ? "asc" : "desc";
    }, e.getSortingFn = () => {
      var n, r;
      if (!e)
        throw new Error();
      return xm(e.columnDef.sortingFn) ? e.columnDef.sortingFn : e.columnDef.sortingFn === "auto" ? e.getAutoSortingFn() : (n = (r = t.options.sortingFns) == null ? void 0 : r[e.columnDef.sortingFn]) != null ? n : x1[e.columnDef.sortingFn];
    }, e.toggleSorting = (n, r) => {
      const o = e.getNextSortingOrder(), a = typeof n < "u" && n !== null;
      t.setSorting((i) => {
        const l = i == null ? void 0 : i.find((g) => g.id === e.id), u = i == null ? void 0 : i.findIndex((g) => g.id === e.id);
        let d = [], f, h = a ? n : o === "desc";
        if (i != null && i.length && e.getCanMultiSort() && r ? l ? f = "toggle" : f = "add" : i != null && i.length && u !== i.length - 1 ? f = "replace" : l ? f = "toggle" : f = "replace", f === "toggle" && (a || o || (f = "remove")), f === "add") {
          var p;
          d = [...i, {
            id: e.id,
            desc: h
          }], d.splice(0, d.length - ((p = t.options.maxMultiSortColCount) != null ? p : Number.MAX_SAFE_INTEGER));
        } else
          f === "toggle" ? d = i.map((g) => g.id === e.id ? {
            ...g,
            desc: h
          } : g) : f === "remove" ? d = i.filter((g) => g.id !== e.id) : d = [{
            id: e.id,
            desc: h
          }];
        return d;
      });
    }, e.getFirstSortDir = () => {
      var n, r;
      return ((n = (r = e.columnDef.sortDescFirst) != null ? r : t.options.sortDescFirst) != null ? n : e.getAutoSortDir() === "desc") ? "desc" : "asc";
    }, e.getNextSortingOrder = (n) => {
      var r, o;
      const a = e.getFirstSortDir(), i = e.getIsSorted();
      return i ? i !== a && ((r = t.options.enableSortingRemoval) == null || r) && // If enableSortRemove, enable in general
      (!(n && (o = t.options.enableMultiRemove) != null) || o) ? !1 : i === "desc" ? "asc" : "desc" : a;
    }, e.getCanSort = () => {
      var n, r;
      return ((n = e.columnDef.enableSorting) != null ? n : !0) && ((r = t.options.enableSorting) != null ? r : !0) && !!e.accessorFn;
    }, e.getCanMultiSort = () => {
      var n, r;
      return (n = (r = e.columnDef.enableMultiSort) != null ? r : t.options.enableMultiSort) != null ? n : !!e.accessorFn;
    }, e.getIsSorted = () => {
      var n;
      const r = (n = t.getState().sorting) == null ? void 0 : n.find((o) => o.id === e.id);
      return r ? r.desc ? "desc" : "asc" : !1;
    }, e.getSortIndex = () => {
      var n, r;
      return (n = (r = t.getState().sorting) == null ? void 0 : r.findIndex((o) => o.id === e.id)) != null ? n : -1;
    }, e.clearSorting = () => {
      t.setSorting((n) => n != null && n.length ? n.filter((r) => r.id !== e.id) : []);
    }, e.getToggleSortingHandler = () => {
      const n = e.getCanSort();
      return (r) => {
        n && (r.persist == null || r.persist(), e.toggleSorting == null || e.toggleSorting(void 0, e.getCanMultiSort() ? t.options.isMultiSortEvent == null ? void 0 : t.options.isMultiSortEvent(r) : !1));
      };
    };
  },
  createTable: (e) => {
    e.setSorting = (t) => e.options.onSortingChange == null ? void 0 : e.options.onSortingChange(t), e.resetSorting = (t) => {
      var n, r;
      e.setSorting(t ? [] : (n = (r = e.initialState) == null ? void 0 : r.sorting) != null ? n : []);
    }, e.getPreSortedRowModel = () => e.getGroupedRowModel(), e.getSortedRowModel = () => (!e._getSortedRowModel && e.options.getSortedRowModel && (e._getSortedRowModel = e.options.getSortedRowModel(e)), e.options.manualSorting || !e._getSortedRowModel ? e.getPreSortedRowModel() : e._getSortedRowModel());
  }
}, ipe = [
  _me,
  zme,
  Gme,
  $me,
  Lme,
  Rme,
  Ume,
  //depends on ColumnFaceting
  Xme,
  //depends on ColumnFiltering
  ape,
  Bme,
  //depends on RowSorting
  Yme,
  qme,
  Jme,
  Kme,
  jme
];
function spe(e) {
  var t, n;
  process.env.NODE_ENV !== "production" && (e.debugAll || e.debugTable) && console.info("Creating Table Instance...");
  const r = [...ipe, ...(t = e._features) != null ? t : []];
  let o = {
    _features: r
  };
  const a = o._features.reduce((p, g) => Object.assign(p, g.getDefaultOptions == null ? void 0 : g.getDefaultOptions(o)), {}), i = (p) => o.options.mergeOptions ? o.options.mergeOptions(a, p) : {
    ...a,
    ...p
  };
  let u = {
    ...{},
    ...(n = e.initialState) != null ? n : {}
  };
  o._features.forEach((p) => {
    var g;
    u = (g = p.getInitialState == null ? void 0 : p.getInitialState(u)) != null ? g : u;
  });
  const d = [];
  let f = !1;
  const h = {
    _features: r,
    options: {
      ...a,
      ...e
    },
    initialState: u,
    _queue: (p) => {
      d.push(p), f || (f = !0, Promise.resolve().then(() => {
        for (; d.length; )
          d.shift()();
        f = !1;
      }).catch((g) => setTimeout(() => {
        throw g;
      })));
    },
    reset: () => {
      o.setState(o.initialState);
    },
    setOptions: (p) => {
      const g = vs(p, o.options);
      o.options = i(g);
    },
    getState: () => o.options.state,
    setState: (p) => {
      o.options.onStateChange == null || o.options.onStateChange(p);
    },
    _getRowId: (p, g, C) => {
      var v;
      return (v = o.options.getRowId == null ? void 0 : o.options.getRowId(p, g, C)) != null ? v : `${C ? [C.id, g].join(".") : g}`;
    },
    getCoreRowModel: () => (o._getCoreRowModel || (o._getCoreRowModel = o.options.getCoreRowModel(o)), o._getCoreRowModel()),
    // The final calls start at the bottom of the model,
    // expanded rows, which then work their way up
    getRowModel: () => o.getPaginationRowModel(),
    //in next version, we should just pass in the row model as the optional 2nd arg
    getRow: (p, g) => {
      let C = (g ? o.getPrePaginationRowModel() : o.getRowModel()).rowsById[p];
      if (!C && (C = o.getCoreRowModel().rowsById[p], !C))
        throw process.env.NODE_ENV !== "production" ? new Error(`getRow could not find row with ID: ${p}`) : new Error();
      return C;
    },
    _getDefaultColumnDef: ht(() => [o.options.defaultColumn], (p) => {
      var g;
      return p = (g = p) != null ? g : {}, {
        header: (C) => {
          const v = C.header.column.columnDef;
          return v.accessorKey ? v.accessorKey : v.accessorFn ? v.id : null;
        },
        // footer: props => props.header.column.id,
        cell: (C) => {
          var v, y;
          return (v = (y = C.renderValue()) == null || y.toString == null ? void 0 : y.toString()) != null ? v : null;
        },
        ...o._features.reduce((C, v) => Object.assign(C, v.getDefaultColumnDef == null ? void 0 : v.getDefaultColumnDef()), {}),
        ...p
      };
    }, mt(e, "debugColumns", "_getDefaultColumnDef")),
    _getColumnDefs: () => o.options.columns,
    getAllColumns: ht(() => [o._getColumnDefs()], (p) => {
      const g = function(C, v, y) {
        return y === void 0 && (y = 0), C.map((M) => {
          const x = wme(o, M, y, v), _ = M;
          return x.columns = _.columns ? g(_.columns, x, y + 1) : [], x;
        });
      };
      return g(p);
    }, mt(e, "debugColumns", "getAllColumns")),
    getAllFlatColumns: ht(() => [o.getAllColumns()], (p) => p.flatMap((g) => g.getFlatColumns()), mt(e, "debugColumns", "getAllFlatColumns")),
    _getAllFlatColumnsById: ht(() => [o.getAllFlatColumns()], (p) => p.reduce((g, C) => (g[C.id] = C, g), {}), mt(e, "debugColumns", "getAllFlatColumnsById")),
    getAllLeafColumns: ht(() => [o.getAllColumns(), o._getOrderColumnsFn()], (p, g) => {
      let C = p.flatMap((v) => v.getLeafColumns());
      return g(C);
    }, mt(e, "debugColumns", "getAllLeafColumns")),
    getColumn: (p) => {
      const g = o._getAllFlatColumnsById()[p];
      return process.env.NODE_ENV !== "production" && !g && console.error(`[Table] Column with id '${p}' does not exist.`), g;
    }
  };
  Object.assign(o, h);
  for (let p = 0; p < o._features.length; p++) {
    const g = o._features[p];
    g == null || g.createTable == null || g.createTable(o);
  }
  return o;
}
function lpe() {
  return (e) => ht(() => [e.options.data], (t) => {
    const n = {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, r = function(o, a, i) {
      a === void 0 && (a = 0);
      const l = [];
      for (let d = 0; d < o.length; d++) {
        const f = Ime(e, e._getRowId(o[d], d, i), o[d], d, a, void 0, i == null ? void 0 : i.id);
        if (n.flatRows.push(f), n.rowsById[f.id] = f, l.push(f), e.options.getSubRows) {
          var u;
          f.originalSubRows = e.options.getSubRows(o[d], d), (u = f.originalSubRows) != null && u.length && (f.subRows = r(f.originalSubRows, a + 1, f));
        }
      }
      return l;
    };
    return n.rows = r(t), n;
  }, mt(e.options, "debugTable", "getRowModel", () => e._autoResetPageIndex()));
}
function upe(e) {
  const t = [], n = (r) => {
    var o;
    t.push(r), (o = r.subRows) != null && o.length && r.getIsExpanded() && r.subRows.forEach(n);
  };
  return e.rows.forEach(n), {
    rows: t,
    flatRows: e.flatRows,
    rowsById: e.rowsById
  };
}
function cpe(e) {
  return (t) => ht(() => [t.getState().pagination, t.getPrePaginationRowModel(), t.options.paginateExpandedRows ? void 0 : t.getState().expanded], (n, r) => {
    if (!r.rows.length)
      return r;
    const {
      pageSize: o,
      pageIndex: a
    } = n;
    let {
      rows: i,
      flatRows: l,
      rowsById: u
    } = r;
    const d = o * a, f = d + o;
    i = i.slice(d, f);
    let h;
    t.options.paginateExpandedRows ? h = {
      rows: i,
      flatRows: l,
      rowsById: u
    } : h = upe({
      rows: i,
      flatRows: l,
      rowsById: u
    }), h.flatRows = [];
    const p = (g) => {
      h.flatRows.push(g), g.subRows.length && g.subRows.forEach(p);
    };
    return h.rows.forEach(p), h;
  }, mt(t.options, "debugTable", "getPaginationRowModel"));
}
function dpe() {
  return (e) => ht(() => [e.getState().sorting, e.getPreSortedRowModel()], (t, n) => {
    if (!n.rows.length || !(t != null && t.length))
      return n;
    const r = e.getState().sorting, o = [], a = r.filter((u) => {
      var d;
      return (d = e.getColumn(u.id)) == null ? void 0 : d.getCanSort();
    }), i = {};
    a.forEach((u) => {
      const d = e.getColumn(u.id);
      d && (i[u.id] = {
        sortUndefined: d.columnDef.sortUndefined,
        invertSorting: d.columnDef.invertSorting,
        sortingFn: d.getSortingFn()
      });
    });
    const l = (u) => {
      const d = u.map((f) => ({
        ...f
      }));
      return d.sort((f, h) => {
        for (let g = 0; g < a.length; g += 1) {
          var p;
          const C = a[g], v = i[C.id], y = v.sortUndefined, M = (p = C == null ? void 0 : C.desc) != null ? p : !1;
          let x = 0;
          if (y) {
            const _ = f.getValue(C.id), L = h.getValue(C.id), R = _ === void 0, k = L === void 0;
            if (R || k) {
              if (y === "first")
                return R ? -1 : 1;
              if (y === "last")
                return R ? 1 : -1;
              x = R && k ? 0 : R ? y : -y;
            }
          }
          if (x === 0 && (x = v.sortingFn(f, h, C.id)), x !== 0)
            return M && (x *= -1), v.invertSorting && (x *= -1), x;
        }
        return f.index - h.index;
      }), d.forEach((f) => {
        var h;
        o.push(f), (h = f.subRows) != null && h.length && (f.subRows = l(f.subRows));
      }), d;
    };
    return {
      rows: l(n.rows),
      flatRows: o,
      rowsById: n.rowsById
    };
  }, mt(e.options, "debugTable", "getSortedRowModel", () => e._autoResetPageIndex()));
}
/**
   * react-table
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */
function ry(e, t) {
  return e ? fpe(e) ? /* @__PURE__ */ Ee.createElement(e, t) : e : null;
}
function fpe(e) {
  return hpe(e) || typeof e == "function" || mpe(e);
}
function hpe(e) {
  return typeof e == "function" && (() => {
    const t = Object.getPrototypeOf(e);
    return t.prototype && t.prototype.isReactComponent;
  })();
}
function mpe(e) {
  return typeof e == "object" && typeof e.$$typeof == "symbol" && ["react.memo", "react.forward_ref"].includes(e.$$typeof.description);
}
function ppe(e) {
  const t = {
    state: {},
    // Dummy state
    onStateChange: () => {
    },
    // noop
    renderFallbackValue: null,
    ...e
  }, [n] = Ee.useState(() => ({
    current: spe(t)
  })), [r, o] = Ee.useState(() => n.current.initialState);
  return n.current.setOptions((a) => ({
    ...a,
    ...e,
    state: {
      ...r,
      ...e.state
    },
    // Similarly, we'll maintain both our internal state and any user-provided
    // state.
    onStateChange: (i) => {
      o(i), e.onStateChange == null || e.onStateChange(i);
    }
  })), n.current;
}
function gpe(e) {
  if (!e.getCanSort())
    return null;
  const t = e.getIsSorted();
  return t === !1 ? /* @__PURE__ */ A.jsx(Xo, { icon: "arrow-up-down", size: "md" }) : t === "desc" ? /* @__PURE__ */ A.jsx(Xo, { icon: "arrow-down", size: "md" }) : /* @__PURE__ */ A.jsx(Xo, { icon: "arrow-up", size: "md" });
}
const A4e = ({
  columns: e,
  data: t,
  onClick: n,
  onHover: r,
  initialState: o,
  determineRowColor: a,
  size: i,
  whiteSpace: l
}) => {
  const u = tt.useMemo(() => t, [t]), d = tt.useMemo(() => e, [e]), {
    getPageCount: f,
    getHeaderGroups: h,
    previousPage: p,
    nextPage: g,
    getCanPreviousPage: C,
    getCanNextPage: v,
    getState: y,
    getRowModel: M
  } = ppe({
    columns: d,
    data: u,
    getCoreRowModel: lpe(),
    getPaginationRowModel: cpe(),
    getSortedRowModel: dpe(),
    enableSorting: !0,
    initialState: {
      pagination: {
        pageIndex: (o == null ? void 0 : o.pageIndex) ?? 0,
        pageSize: (o == null ? void 0 : o.pageSize) ?? 50
      },
      sorting: o != null && o.sortBy ? o.sortBy : []
    }
  }), x = y(), _ = f(), L = x.pagination.pageIndex + 1, R = _ > 1, k = h(), P = v(), N = C(), O = Ti(r), H = Ti(n);
  return /* @__PURE__ */ A.jsxs(
    Ma,
    {
      sx: {
        table: {
          "td.sm": { width: "1%", paddingLeft: "6px", paddingRight: "6px" },
          "td.md": { width: "2%" },
          "td.lg": { width: "5%" },
          "th.sm": { width: "1%", paddingLeft: "6px", paddingRight: "6px" },
          "th.md": { width: "2%" },
          "th.lg": { width: "5%" }
        }
      },
      children: [
        /* @__PURE__ */ A.jsxs(Ww, { size: i, whiteSpace: l, role: "table", children: [
          /* @__PURE__ */ A.jsx(bne, { children: k.map(($) => /* @__PURE__ */ A.jsx(WC, { role: "row", children: $.headers.map((ne) => {
            const ie = ne.column.getCanSort(), { isPlaceholder: re } = ne, ve = ie ? {
              onClick: ne.column.getToggleSortingHandler(),
              cursor: "pointer",
              userSelect: "none"
            } : {};
            return /* @__PURE__ */ A.jsx(Cne, { role: "columnheader", children: re ? null : /* @__PURE__ */ A.jsxs(Ma, { ...ve, display: "flex", alignItems: "center", children: [
              ry(ne.column.columnDef.header, ne.getContext()),
              ie && /* @__PURE__ */ A.jsx(xe.span, { pl: "4", children: gpe(ne.column) })
            ] }) }, ne.id);
          }) }, $.id)) }),
          /* @__PURE__ */ A.jsx(gne, { role: "rowgroup", children: M().rows.map(($) => {
            const ne = H ? {
              sx: {
                ":hover td": {
                  cursor: "pointer"
                }
              },
              onClick: () => n($.original)
            } : {};
            return /* @__PURE__ */ A.jsx(
              WC,
              {
                role: "row",
                onMouseOver: O ? () => r($.original) : void 0,
                backgroundColor: a ? a($.original) : "transparent",
                ...ne,
                children: $.getVisibleCells().map((ie) => /* @__PURE__ */ A.jsx(vne, { children: ry(ie.column.columnDef.cell, ie.getContext()) }, ie.id))
              },
              $.id
            );
          }) })
        ] }),
        R && /* @__PURE__ */ A.jsxs(fd, { justifyContent: "center", alignItems: "center", gap: 6, paddingTop: 4, children: [
          /* @__PURE__ */ A.jsx(
            R2,
            {
              onClick: p,
              disabled: !N,
              ariaLabel: "Back",
              icon: "arrow-left"
            }
          ),
          /* @__PURE__ */ A.jsx(lo, { children: `${L} of ${_}` }),
          /* @__PURE__ */ A.jsx(
            R2,
            {
              onClick: g,
              disabled: !P,
              ariaLabel: "Next",
              icon: "arrow-right"
            }
          )
        ] })
      ]
    }
  );
}, {
  createElement: vc,
  createContext: vpe,
  forwardRef: QL,
  useCallback: ss,
  useContext: eR,
  useEffect: Mi,
  useImperativeHandle: tR,
  useLayoutEffect: Cpe,
  useMemo: bpe,
  useRef: Ao,
  useState: ad
} = Ee, oy = Ee["useId".toString()], fh = Cpe, ype = typeof oy == "function" ? oy : () => null;
let Spe = 0;
function s7(e = null) {
  const t = ype(), n = Ao(e || t || null);
  return n.current === null && (n.current = "" + Spe++), n.current;
}
const wm = vpe(null);
wm.displayName = "PanelGroupContext";
function nR({
  children: e = null,
  className: t = "",
  collapsedSize: n = 0,
  collapsible: r = !1,
  defaultSize: o = null,
  forwardedRef: a,
  id: i = null,
  maxSize: l = 100,
  minSize: u = 10,
  onCollapse: d = null,
  onResize: f = null,
  order: h = null,
  style: p = {},
  tagName: g = "div"
}) {
  const C = eR(wm);
  if (C === null)
    throw Error("Panel components must be rendered within a PanelGroup container");
  const v = s7(i), {
    collapsePanel: y,
    expandPanel: M,
    getPanelStyle: x,
    registerPanel: _,
    resizePanel: L,
    unregisterPanel: R
  } = C, k = Ao({
    onCollapse: d,
    onResize: f
  });
  if (Mi(() => {
    k.current.onCollapse = d, k.current.onResize = f;
  }), u < 0 || u > 100)
    throw Error(`Panel minSize must be between 0 and 100, but was ${u}`);
  if (l < 0 || l > 100)
    throw Error(`Panel maxSize must be between 0 and 100, but was ${l}`);
  if (o !== null) {
    if (o < 0 || o > 100)
      throw Error(`Panel defaultSize must be between 0 and 100, but was ${o}`);
    u > o && !r && (console.error(`Panel minSize ${u} cannot be greater than defaultSize ${o}`), o = u);
  }
  const P = x(v, o), N = Ao({
    size: ay(P)
  }), O = Ao({
    callbacksRef: k,
    collapsedSize: n,
    collapsible: r,
    defaultSize: o,
    id: v,
    idWasAutoGenerated: i == null,
    maxSize: l,
    minSize: u,
    order: h
  });
  return fh(() => {
    N.current.size = ay(P), O.current.callbacksRef = k, O.current.collapsedSize = n, O.current.collapsible = r, O.current.defaultSize = o, O.current.id = v, O.current.idWasAutoGenerated = i == null, O.current.maxSize = l, O.current.minSize = u, O.current.order = h;
  }), fh(() => (_(v, O), () => {
    R(v);
  }), [h, v, _, R]), tR(a, () => ({
    collapse: () => y(v),
    expand: () => M(v),
    getCollapsed() {
      return N.current.size === 0;
    },
    getSize() {
      return N.current.size;
    },
    resize: (H) => L(v, H)
  }), [y, M, v, L]), vc(g, {
    children: e,
    className: t,
    "data-panel": "",
    "data-panel-collapsible": r || void 0,
    "data-panel-id": v,
    "data-panel-size": parseFloat("" + P.flexGrow).toFixed(1),
    id: `data-panel-id-${v}`,
    style: {
      ...P,
      ...p
    }
  });
}
const T3 = QL((e, t) => vc(nR, {
  ...e,
  forwardedRef: t
}));
nR.displayName = "Panel";
T3.displayName = "forwardRef(Panel)";
function ay(e) {
  const {
    flexGrow: t
  } = e;
  return typeof t == "string" ? parseFloat(t) : t;
}
const Vl = 10;
function F1(e, t, n, r, o, a, i, l) {
  const {
    sizes: u
  } = l || {}, d = u || a;
  if (o === 0)
    return d;
  const f = Zo(t), h = d.concat();
  let p = 0;
  {
    const v = o < 0 ? r : n, y = f.findIndex((L) => L.current.id === v), M = f[y], x = d[y], _ = iy(M, Math.abs(o), x, e);
    if (x === _)
      return d;
    _ === 0 && x > 0 && i.set(v, x), o = o < 0 ? x - _ : _ - x;
  }
  let g = o < 0 ? n : r, C = f.findIndex((v) => v.current.id === g);
  for (; ; ) {
    const v = f[C], y = d[C], M = Math.abs(o) - Math.abs(p), x = iy(v, 0 - M, y, e);
    if (y !== x && (x === 0 && y > 0 && i.set(v.current.id, y), p += y - x, h[C] = x, p.toPrecision(Vl).localeCompare(Math.abs(o).toPrecision(Vl), void 0, {
      numeric: !0
    }) >= 0))
      break;
    if (o < 0) {
      if (--C < 0)
        break;
    } else if (++C >= f.length)
      break;
  }
  return p === 0 ? d : (g = o < 0 ? r : n, C = f.findIndex((v) => v.current.id === g), h[C] = d[C] + p, h);
}
function Iu(e, t, n) {
  t.forEach((r, o) => {
    const a = e[o];
    if (!a)
      return;
    const {
      callbacksRef: i,
      collapsedSize: l,
      collapsible: u,
      id: d
    } = a.current, f = n[d];
    if (f !== r) {
      n[d] = r;
      const {
        onCollapse: h,
        onResize: p
      } = i.current;
      p && p(r, f), u && h && ((f == null || f === l) && r !== l ? h(!1) : f !== l && r === l && h(!0));
    }
  });
}
function o5(e, t) {
  if (t.length < 2)
    return [null, null];
  const n = t.findIndex((i) => i.current.id === e);
  if (n < 0)
    return [null, null];
  const r = n === t.length - 1, o = r ? t[n - 1].current.id : e, a = r ? e : t[n + 1].current.id;
  return [o, a];
}
function rR(e, t, n) {
  if (e.size === 1)
    return "100";
  const o = Zo(e).findIndex((i) => i.current.id === t), a = n[o];
  return a == null ? "0" : a.toPrecision(Vl);
}
function Ape(e) {
  const t = document.querySelector(`[data-panel-id="${e}"]`);
  return t || null;
}
function l7(e) {
  const t = document.querySelector(`[data-panel-group-id="${e}"]`);
  return t || null;
}
function _m(e) {
  const t = document.querySelector(`[data-panel-resize-handle-id="${e}"]`);
  return t || null;
}
function Mpe(e) {
  return oR().findIndex((r) => r.getAttribute("data-panel-resize-handle-id") === e) ?? null;
}
function oR() {
  return Array.from(document.querySelectorAll("[data-panel-resize-handle-id]"));
}
function aR(e) {
  return Array.from(document.querySelectorAll(`[data-panel-resize-handle-id][data-panel-group-id="${e}"]`));
}
function u7(e, t, n) {
  var u, d, f, h;
  const r = _m(t), o = aR(e), a = r ? o.indexOf(r) : -1, i = ((d = (u = n[a]) == null ? void 0 : u.current) == null ? void 0 : d.id) ?? null, l = ((h = (f = n[a + 1]) == null ? void 0 : f.current) == null ? void 0 : h.id) ?? null;
  return [i, l];
}
function Zo(e) {
  return Array.from(e.values()).sort((t, n) => {
    const r = t.current.order, o = n.current.order;
    return r == null && o == null ? 0 : r == null ? -1 : o == null ? 1 : r - o;
  });
}
function iy(e, t, n, r) {
  var f;
  const o = n + t, {
    collapsedSize: a,
    collapsible: i,
    maxSize: l,
    minSize: u
  } = e.current;
  if (i) {
    if (n > a) {
      if (o <= u / 2 + a)
        return a;
    } else if (!((f = r == null ? void 0 : r.type) == null ? void 0 : f.startsWith("key")) && o < u)
      return a;
  }
  return Math.min(l, Math.max(u, o));
}
function iR(e, t = "Assertion failed!") {
  if (!e)
    throw console.error(t), Error(t);
}
function xpe({
  committedValuesRef: e,
  groupId: t,
  panels: n,
  setSizes: r,
  sizes: o,
  panelSizeBeforeCollapse: a
}) {
  Mi(() => {
    const {
      direction: i,
      panels: l
    } = e.current, u = l7(t), {
      height: d,
      width: f
    } = u.getBoundingClientRect(), p = aR(t).map((g) => {
      const C = g.getAttribute("data-panel-resize-handle-id"), v = Zo(l), [y, M] = u7(t, C, v);
      if (y == null || M == null)
        return () => {
        };
      let x = 0, _ = 100, L = 0, R = 0;
      v.forEach(($) => {
        $.current.id === y ? (_ = $.current.maxSize, x = $.current.minSize) : (L += $.current.minSize, R += $.current.maxSize);
      });
      const k = Math.min(_, 100 - L), P = Math.max(x, (v.length - 1) * 100 - R), N = rR(l, y, o);
      g.setAttribute("aria-valuemax", "" + Math.round(k)), g.setAttribute("aria-valuemin", "" + Math.round(P)), g.setAttribute("aria-valuenow", "" + Math.round(parseInt(N)));
      const O = ($) => {
        if (!$.defaultPrevented)
          switch ($.key) {
            case "Enter": {
              $.preventDefault();
              const ne = v.findIndex((ie) => ie.current.id === y);
              if (ne >= 0) {
                const ie = v[ne], re = o[ne];
                if (re != null) {
                  let ve = 0;
                  re.toPrecision(Vl) <= ie.current.minSize.toPrecision(Vl) ? ve = i === "horizontal" ? f : d : ve = -(i === "horizontal" ? f : d);
                  const ue = F1($, l, y, M, ve, o, a.current, null);
                  o !== ue && r(ue);
                }
              }
              break;
            }
          }
      };
      g.addEventListener("keydown", O);
      const H = Ape(y);
      return H != null && g.setAttribute("aria-controls", H.id), () => {
        g.removeAttribute("aria-valuemax"), g.removeAttribute("aria-valuemin"), g.removeAttribute("aria-valuenow"), g.removeEventListener("keydown", O), H != null && g.removeAttribute("aria-controls");
      };
    });
    return () => {
      p.forEach((g) => g());
    };
  }, [e, t, n, a, r, o]);
}
function wpe({
  disabled: e,
  handleId: t,
  resizeHandler: n
}) {
  Mi(() => {
    if (e || n == null)
      return;
    const r = _m(t);
    if (r == null)
      return;
    const o = (a) => {
      if (!a.defaultPrevented)
        switch (a.key) {
          case "ArrowDown":
          case "ArrowLeft":
          case "ArrowRight":
          case "ArrowUp":
          case "End":
          case "Home": {
            a.preventDefault(), n(a);
            break;
          }
          case "F6": {
            a.preventDefault();
            const i = oR(), l = Mpe(t);
            iR(l !== null);
            const u = a.shiftKey ? l > 0 ? l - 1 : i.length - 1 : l + 1 < i.length ? l + 1 : 0;
            i[u].focus();
            break;
          }
        }
    };
    return r.addEventListener("keydown", o), () => {
      r.removeEventListener("keydown", o);
    };
  }, [e, t, n]);
}
function _pe(e, t) {
  if (e.length !== t.length)
    return !1;
  for (let n = 0; n < e.length; n++)
    if (e[n] !== t[n])
      return !1;
  return !0;
}
function sR(e, t, n, r = 0, o = null) {
  const a = n === "horizontal";
  let i = 0;
  if (N3(e))
    i = a ? e.clientX : e.clientY;
  else if (k3(e)) {
    const f = e.touches[0];
    i = a ? f.screenX : f.screenY;
  } else
    return 0;
  const l = _m(t), u = o || l.getBoundingClientRect(), d = a ? u.left : u.top;
  return i - d - r;
}
function Ipe(e, t, n, r, o, a, i) {
  const {
    dragOffset: l = 0,
    dragHandleRect: u,
    sizes: d
  } = i || {}, f = d || a;
  if (Lpe(e)) {
    const h = o === "horizontal", g = l7(t).getBoundingClientRect(), C = h ? g.width : g.height, v = e.shiftKey ? 10 : 100, y = C / v;
    let M = 0;
    switch (e.key) {
      case "ArrowDown":
        M = h ? 0 : y;
        break;
      case "ArrowLeft":
        M = h ? -y : 0;
        break;
      case "ArrowRight":
        M = h ? y : 0;
        break;
      case "ArrowUp":
        M = h ? 0 : -y;
        break;
      case "End":
        M = C;
        break;
      case "Home":
        M = -C;
        break;
    }
    const [x, _] = u7(t, n, r), L = M < 0 ? x : _, R = r.findIndex((P) => P.current.id === L), k = r[R];
    if (k.current.collapsible) {
      const P = f[R];
      (P === 0 || P.toPrecision(Vl) === k.current.minSize.toPrecision(Vl)) && (M = M < 0 ? -k.current.minSize * C : k.current.minSize * C);
    }
    return M;
  } else
    return sR(e, n, o, l, u);
}
function Lpe(e) {
  return e.type === "keydown";
}
function N3(e) {
  return e.type.startsWith("mouse");
}
function k3(e) {
  return e.type.startsWith("touch");
}
let V3 = null, fl = null;
function lR(e) {
  switch (e) {
    case "horizontal":
      return "ew-resize";
    case "horizontal-max":
      return "w-resize";
    case "horizontal-min":
      return "e-resize";
    case "vertical":
      return "ns-resize";
    case "vertical-max":
      return "n-resize";
    case "vertical-min":
      return "s-resize";
  }
}
function Rpe() {
  fl !== null && (document.head.removeChild(fl), V3 = null, fl = null);
}
function a5(e) {
  if (V3 === e)
    return;
  V3 = e;
  const t = lR(e);
  fl === null && (fl = document.createElement("style"), document.head.appendChild(fl)), fl.innerHTML = `*{cursor: ${t}!important;}`;
}
function Dpe(e, t = 10) {
  let n = null;
  return (...o) => {
    n !== null && clearTimeout(n), n = setTimeout(() => {
      e(...o);
    }, t);
  };
}
function uR(e) {
  return e.map((t) => {
    const {
      minSize: n,
      order: r
    } = t.current;
    return r ? `${r}:${n}` : `${n}`;
  }).sort((t, n) => t.localeCompare(n)).join(",");
}
function cR(e, t) {
  try {
    const n = t.getItem(`PanelGroup:sizes:${e}`);
    if (n) {
      const r = JSON.parse(n);
      if (typeof r == "object" && r != null)
        return r;
    }
  } catch {
  }
  return null;
}
function Ppe(e, t, n) {
  const r = cR(e, n);
  if (r) {
    const o = uR(t);
    return r[o] ?? null;
  }
  return null;
}
function Epe(e, t, n, r) {
  const o = uR(t), a = cR(e, r) || {};
  a[o] = n;
  try {
    r.setItem(`PanelGroup:sizes:${e}`, JSON.stringify(a));
  } catch (i) {
    console.error(i);
  }
}
const i5 = {};
function sy(e) {
  try {
    if (typeof localStorage < "u")
      e.getItem = (t) => localStorage.getItem(t), e.setItem = (t, n) => {
        localStorage.setItem(t, n);
      };
    else
      throw new Error("localStorage not supported in this environment");
  } catch (t) {
    console.error(t), e.getItem = () => null, e.setItem = () => {
    };
  }
}
const B1 = {
  getItem: (e) => (sy(B1), B1.getItem(e)),
  setItem: (e, t) => {
    sy(B1), B1.setItem(e, t);
  }
};
function dR({
  autoSaveId: e,
  children: t = null,
  className: n = "",
  direction: r,
  disablePointerEventsDuringResize: o = !1,
  forwardedRef: a,
  id: i = null,
  onLayout: l,
  storage: u = B1,
  style: d = {},
  tagName: f = "div"
}) {
  const h = s7(i), [p, g] = ad(null), [C, v] = ad(/* @__PURE__ */ new Map()), y = Ao(null);
  Ao({
    didLogDefaultSizeWarning: !1,
    didLogIdAndOrderWarning: !1,
    prevPanelIds: []
  });
  const M = Ao({
    onLayout: l
  });
  Mi(() => {
    M.current.onLayout = l;
  });
  const x = Ao({}), [_, L] = ad([]), R = Ao(/* @__PURE__ */ new Map()), k = Ao(0), P = Ao({
    direction: r,
    panels: C,
    sizes: _
  });
  tR(a, () => ({
    getLayout: () => {
      const {
        sizes: j
      } = P.current;
      return j;
    },
    setLayout: (j) => {
      const K = j.reduce((ge, X) => ge + X, 0);
      iR(K === 100, "Panel sizes must add up to 100%");
      const {
        panels: ce
      } = P.current, U = x.current, q = Zo(ce);
      L(j), Iu(q, j, U);
    }
  }), []), fh(() => {
    P.current.direction = r, P.current.panels = C, P.current.sizes = _;
  }), xpe({
    committedValuesRef: P,
    groupId: h,
    panels: C,
    setSizes: L,
    sizes: _,
    panelSizeBeforeCollapse: R
  }), Mi(() => {
    const {
      onLayout: j
    } = M.current, {
      panels: K,
      sizes: ce
    } = P.current;
    if (ce.length > 0) {
      j && j(ce);
      const U = x.current, q = Zo(K);
      Iu(q, ce, U);
    }
  }, [_]), fh(() => {
    if (P.current.sizes.length === C.size)
      return;
    let K = null;
    if (e) {
      const ce = Zo(C);
      K = Ppe(e, ce, u);
    }
    if (K != null)
      L(K);
    else {
      const ce = Zo(C);
      let U = 0, q = 0, ge = 0;
      if (ce.forEach((X) => {
        ge += X.current.minSize, X.current.defaultSize === null ? U++ : q += X.current.defaultSize;
      }), q > 100)
        throw new Error("Default panel sizes cannot exceed 100%");
      if (ce.length > 1 && U === 0 && q !== 100)
        throw new Error("Invalid default sizes specified for panels");
      if (ge > 100)
        throw new Error("Minimum panel sizes cannot exceed 100%");
      L(ce.map((X) => X.current.defaultSize === null ? (100 - q) / U : X.current.defaultSize));
    }
  }, [e, C, u]), Mi(() => {
    if (e) {
      if (_.length === 0 || _.length !== C.size)
        return;
      const j = Zo(C);
      i5[e] || (i5[e] = Dpe(Epe, 100)), i5[e](e, j, _, u);
    }
  }, [e, C, _, u]);
  const N = ss((j, K) => {
    const {
      panels: ce
    } = P.current;
    return ce.size === 0 ? {
      flexBasis: 0,
      flexGrow: K ?? void 0,
      flexShrink: 1,
      // Without this, Panel sizes may be unintentionally overridden by their content.
      overflow: "hidden"
    } : {
      flexBasis: 0,
      flexGrow: rR(ce, j, _),
      flexShrink: 1,
      // Without this, Panel sizes may be unintentionally overridden by their content.
      overflow: "hidden",
      // Disable pointer events inside of a panel during resize.
      // This avoid edge cases like nested iframes.
      pointerEvents: o && p !== null ? "none" : void 0
    };
  }, [p, o, _]), O = ss((j, K) => {
    v((ce) => {
      if (ce.has(j))
        return ce;
      const U = new Map(ce);
      return U.set(j, K), U;
    });
  }, []), H = ss((j) => (ce) => {
    ce.preventDefault();
    const {
      direction: U,
      panels: q,
      sizes: ge
    } = P.current, X = Zo(q), [he, me] = u7(h, j, X);
    if (he == null || me == null)
      return;
    let de = Ipe(ce, h, j, X, U, ge, y.current);
    if (de === 0)
      return;
    const Ie = l7(h).getBoundingClientRect(), Ne = U === "horizontal";
    document.dir === "rtl" && Ne && (de = -de);
    const ye = Ne ? Ie.width : Ie.height, ke = de / ye * 100, oe = F1(ce, q, he, me, ke, ge, R.current, y.current), lt = !_pe(ge, oe);
    if ((N3(ce) || k3(ce)) && k.current != ke && a5(lt ? Ne ? "horizontal" : "vertical" : Ne ? de < 0 ? "horizontal-min" : "horizontal-max" : de < 0 ? "vertical-min" : "vertical-max"), lt) {
      const Re = x.current;
      L(oe), Iu(X, oe, Re);
    }
    k.current = ke;
  }, [h]), $ = ss((j) => {
    v((K) => {
      if (!K.has(j))
        return K;
      const ce = new Map(K);
      return ce.delete(j), ce;
    });
  }, []), ne = ss((j) => {
    const {
      panels: K,
      sizes: ce
    } = P.current, U = K.get(j);
    if (U == null)
      return;
    const {
      collapsedSize: q,
      collapsible: ge
    } = U.current;
    if (!ge)
      return;
    const X = Zo(K), he = X.indexOf(U);
    if (he < 0)
      return;
    const me = ce[he];
    if (me === q)
      return;
    R.current.set(j, me);
    const [de, Le] = o5(j, X);
    if (de == null || Le == null)
      return;
    const Ne = he === X.length - 1 ? me : q - me, ye = F1(null, K, de, Le, Ne, ce, R.current, null);
    if (ce !== ye) {
      const ke = x.current;
      L(ye), Iu(X, ye, ke);
    }
  }, []), ie = ss((j) => {
    const {
      panels: K,
      sizes: ce
    } = P.current, U = K.get(j);
    if (U == null)
      return;
    const {
      collapsedSize: q,
      minSize: ge
    } = U.current, X = R.current.get(j) || ge;
    if (!X)
      return;
    const he = Zo(K), me = he.indexOf(U);
    if (me < 0 || ce[me] !== q)
      return;
    const [Le, Ie] = o5(j, he);
    if (Le == null || Ie == null)
      return;
    const ye = me === he.length - 1 ? q - X : X, ke = F1(null, K, Le, Ie, ye, ce, R.current, null);
    if (ce !== ke) {
      const oe = x.current;
      L(ke), Iu(he, ke, oe);
    }
  }, []), re = ss((j, K) => {
    const {
      panels: ce,
      sizes: U
    } = P.current, q = ce.get(j);
    if (q == null)
      return;
    const {
      collapsedSize: ge,
      collapsible: X,
      maxSize: he,
      minSize: me
    } = q.current, de = Zo(ce), Le = de.indexOf(q);
    if (Le < 0)
      return;
    const Ie = U[Le];
    if (Ie === K)
      return;
    X && K === ge || (K = Math.min(he, Math.max(me, K)));
    const [Ne, ye] = o5(j, de);
    if (Ne == null || ye == null)
      return;
    const oe = Le === de.length - 1 ? Ie - K : K - Ie, lt = F1(null, ce, Ne, ye, oe, U, R.current, null);
    if (U !== lt) {
      const Re = x.current;
      L(lt), Iu(de, lt, Re);
    }
  }, []), ve = bpe(() => ({
    activeHandleId: p,
    collapsePanel: ne,
    direction: r,
    expandPanel: ie,
    getPanelStyle: N,
    groupId: h,
    registerPanel: O,
    registerResizeHandle: H,
    resizePanel: re,
    startDragging: (j, K) => {
      if (g(j), N3(K) || k3(K)) {
        const ce = _m(j);
        y.current = {
          dragHandleRect: ce.getBoundingClientRect(),
          dragOffset: sR(K, j, r),
          sizes: P.current.sizes
        };
      }
    },
    stopDragging: () => {
      Rpe(), g(null), y.current = null;
    },
    unregisterPanel: $
  }), [p, ne, r, ie, N, h, O, H, re, $]), ue = {
    display: "flex",
    flexDirection: r === "horizontal" ? "row" : "column",
    height: "100%",
    overflow: "hidden",
    width: "100%"
  };
  return vc(wm.Provider, {
    children: vc(f, {
      children: t,
      className: n,
      "data-panel-group": "",
      "data-panel-group-direction": r,
      "data-panel-group-id": h,
      style: {
        ...ue,
        ...d
      }
    }),
    value: ve
  });
}
const fR = QL((e, t) => vc(dR, {
  ...e,
  forwardedRef: t
}));
dR.displayName = "PanelGroup";
fR.displayName = "forwardRef(PanelGroup)";
function hR({
  children: e = null,
  className: t = "",
  disabled: n = !1,
  id: r = null,
  onDragging: o,
  style: a = {},
  tagName: i = "div"
}) {
  const l = Ao(null), u = Ao({
    onDragging: o
  });
  Mi(() => {
    u.current.onDragging = o;
  });
  const d = eR(wm);
  if (d === null)
    throw Error("PanelResizeHandle components must be rendered within a PanelGroup container");
  const {
    activeHandleId: f,
    direction: h,
    groupId: p,
    registerResizeHandle: g,
    startDragging: C,
    stopDragging: v
  } = d, y = s7(r), M = f === y, [x, _] = ad(!1), [L, R] = ad(null), k = ss(() => {
    l.current.blur(), v();
    const {
      onDragging: O
    } = u.current;
    O && O(!1);
  }, [v]);
  Mi(() => {
    if (n)
      R(null);
    else {
      const N = g(y);
      R(() => N);
    }
  }, [n, y, g]), Mi(() => {
    if (n || L == null || !M)
      return;
    const N = (ne) => {
      L(ne);
    }, O = (ne) => {
      L(ne);
    }, $ = l.current.ownerDocument;
    return $.body.addEventListener("contextmenu", k), $.body.addEventListener("mousemove", N), $.body.addEventListener("touchmove", N), $.body.addEventListener("mouseleave", O), window.addEventListener("mouseup", k), window.addEventListener("touchend", k), () => {
      $.body.removeEventListener("contextmenu", k), $.body.removeEventListener("mousemove", N), $.body.removeEventListener("touchmove", N), $.body.removeEventListener("mouseleave", O), window.removeEventListener("mouseup", k), window.removeEventListener("touchend", k);
    };
  }, [h, n, M, L, k]), wpe({
    disabled: n,
    handleId: y,
    resizeHandler: L
  });
  const P = {
    cursor: lR(h),
    touchAction: "none",
    userSelect: "none"
  };
  return vc(i, {
    children: e,
    className: t,
    "data-resize-handle-active": M ? "pointer" : x ? "keyboard" : void 0,
    "data-panel-group-direction": h,
    "data-panel-group-id": p,
    "data-panel-resize-handle-enabled": !n,
    "data-panel-resize-handle-id": y,
    onBlur: () => _(!1),
    onFocus: () => _(!0),
    onMouseDown: (N) => {
      C(y, N.nativeEvent);
      const {
        onDragging: O
      } = u.current;
      O && O(!0);
    },
    onMouseUp: k,
    onTouchCancel: k,
    onTouchEnd: k,
    onTouchStart: (N) => {
      C(y, N.nativeEvent);
      const {
        onDragging: O
      } = u.current;
      O && O(!0);
    },
    ref: l,
    role: "separator",
    style: {
      ...P,
      ...a
    },
    tabIndex: 0
  });
}
hR.displayName = "PanelResizeHandle";
const M4e = ({ direction: e, config: t = {}, panelA: n, panelB: r }) => {
  var o;
  return /* @__PURE__ */ A.jsxs(fR, { direction: e, ...t.panelGroupProps, ref: t.panelGroupRef, children: [
    /* @__PURE__ */ A.jsx(T3, { ...t.panelAProps, ref: t.panelARef, children: n }),
    t.isResizable && /* @__PURE__ */ A.jsx(
      hR,
      {
        style: {
          ...e === "vertical" ? { maxHeight: "10px" } : { maxWidth: "10px" }
        },
        children: /* @__PURE__ */ A.jsx(
          Ma,
          {
            height: e === "vertical" ? "10px" : "full",
            width: e === "vertical" ? "full" : "10px",
            backgroundColor: "hoverTransparentLight",
            _hover: { backgroundColor: "hoverTransparentLight" },
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            role: "group",
            children: /* @__PURE__ */ A.jsx(
              Ma,
              {
                ...e === "vertical" ? {
                  width: "20",
                  height: 1
                } : { height: "20", width: 1 },
                borderRadius: "lg",
                backgroundColor: "strokeDefault",
                _groupHover: { backgroundColor: "hoverTransparentLight" }
              }
            )
          }
        )
      }
    ),
    /* @__PURE__ */ A.jsx(
      T3,
      {
        ...t.panelBProps,
        ref: t.panelBRef,
        ...(o = t.panelBProps) != null && o.isCollapsed ? { defaultSize: 0 } : {},
        children: r
      }
    )
  ] });
}, x4e = ({
  wrapperProps: e = {},
  children: t,
  footer: n,
  header: r,
  bodyProps: o,
  footerProps: a,
  headerProps: i
}) => /* @__PURE__ */ A.jsxs($q, { ...e, children: [
  Ti(r) && /* @__PURE__ */ A.jsx(Wq, { ...i, children: r }),
  /* @__PURE__ */ A.jsx(Zq, { ...o, children: t }),
  Ti(n) && /* @__PURE__ */ A.jsx(jq, { ...a, children: n })
] }), w4e = ({ __testId: e, alt: t = "", fit: n, width: r, height: o, src: a }) => /* @__PURE__ */ A.jsx("img", { alt: t, "data-testid": e, style: { objectFit: n, width: r, height: o }, src: a }), _4e = (e) => /* @__PURE__ */ A.jsx(nw, { ...e }), I4e = (e) => /* @__PURE__ */ A.jsx(rw, { ...e }), L4e = (e) => /* @__PURE__ */ A.jsx(iw, { ...e }), R4e = (e) => /* @__PURE__ */ A.jsx(sw, { ...e }), Tpe = ({
  tab: e,
  onClick: t,
  isSelected: n,
  variant: r
}) => {
  let o = "textTertiary";
  n && (o = r === "primary" ? "textOffset" : "textPrimary");
  const a = (i) => {
    (i.key === "Enter" || i.key === " ") && (i.preventDefault(), t());
  };
  return /* @__PURE__ */ A.jsx(
    "div",
    {
      "data-tab-value": e.value,
      onClick: t,
      onKeyDown: a,
      role: "tab",
      tabIndex: 0,
      "aria-selected": n,
      className: Ur("tab", n && "selected"),
      children: f0e(e.label) ? /* @__PURE__ */ A.jsx(lo, { variant: "h3", color: o, __dangerDoNotUseSx: { whiteSpace: "nowrap" }, children: e.label }) : e.label
    }
  );
};
const D4e = ({
  tabs: e,
  activeTab: t,
  setActiveTab: n,
  variant: r = "primary"
}) => /* @__PURE__ */ A.jsx("div", { className: `tabs wrapper ${r}`, "data-active-tab": t, children: e.map((o) => /* @__PURE__ */ A.jsx(
  Tpe,
  {
    variant: r,
    isSelected: o.value === t,
    tab: o,
    onClick: () => n(o.value)
  },
  `${o.label}-${o.value}`
)) }), P4e = ({
  children: e,
  dismiss: t,
  isOpen: n,
  placement: r,
  text: o
}) => {
  const a = Ve({ focus: () => null });
  return /* @__PURE__ */ A.jsxs(Hh, { isOpen: n ?? !1, placement: r, initialFocusRef: a, children: [
    /* @__PURE__ */ A.jsx(Zh, { children: e }),
    /* @__PURE__ */ A.jsx(ki, { children: /* @__PURE__ */ A.jsxs(
      $h,
      {
        sx: {
          backgroundColor: Hr.textPrimary,
          borderRadius: ".25rem",
          paddingRight: "1rem"
        },
        children: [
          t && /* @__PURE__ */ A.jsx(Ew, { onClick: t, color: Hr.textOffset }),
          /* @__PURE__ */ A.jsx(Pw, { backgroundColor: Hr.textPrimary }),
          /* @__PURE__ */ A.jsx(Gh, { children: /* @__PURE__ */ A.jsx(lo, { variant: "body1", color: "textOffset", children: o }) })
        ]
      }
    ) })
  ] });
}, E4e = (e) => `${e}px`;
function T4e({ items: e, value: t, onChange: n, ...r }) {
  const { getRootProps: o, getRadioProps: a } = Nw({
    defaultValue: void 0,
    value: t,
    onChange: n
  });
  return Es(
    { ...r, fullWidth: !1 },
    /* @__PURE__ */ A.jsx(Ma, { display: "flex", gap: "8px", ...o(), children: e.map(({ label: i, value: l }) => {
      const u = a({ value: l });
      return /* @__PURE__ */ A.jsx(Npe, { ...u, children: i }, l);
    }) })
  );
}
const Npe = (e) => {
  const { getInputProps: t, getRadioProps: n } = Ow(e), { isChecked: r, children: o } = e, a = t(), i = n();
  return /* @__PURE__ */ A.jsxs(Ma, { as: "label", flexShrink: "0", children: [
    /* @__PURE__ */ A.jsx("input", { ...a }),
    /* @__PURE__ */ A.jsx(
      Ma,
      {
        ...i,
        cursor: "pointer",
        borderWidth: "1px",
        borderRadius: "20px",
        border: "1px solid",
        borderColor: "strokeDefault",
        paddingX: "16px",
        paddingY: "6px",
        width: "fit-content",
        backgroundColor: "surface1",
        children: /* @__PURE__ */ A.jsx(
          lo,
          {
            variant: "chip",
            color: r ? "buttonDefault" : void 0,
            children: o
          }
        )
      }
    )
  ] });
}, kpe = (e) => e.type === "number" || e.type === "date" || e.type === "month" || e.type === "count", Vpe = (e) => e.type === "number" || e.type === "count", Xd = (e, t, n) => n ? ["simple-field-filler"] : e === "grid" ? ["simple-field-sizer", "simple-field-size-grid"] : ["simple-field-sizer", `simple-field-size-${t}`], Yd = (e, t = "100%") => e ? {} : { width: t };
const ly = ({
  addon: e,
  variant: t = "outline"
}) => {
  const n = Ur("simple-addon", t), r = { flex: "0 0 auto" };
  return /* @__PURE__ */ A.jsx("div", { style: r, className: n, children: e });
};
function Ope(e) {
  const t = e;
  return t.leftAddon !== void 0 || t.rightAddon !== void 0;
}
const Fpe = (e) => {
  const {
    width: t = "100%",
    leftAddon: n,
    rightAddon: r,
    children: o,
    variant: a = "outline",
    size: i = "md",
    isWrapped: l
  } = e, u = Yd(l, t), d = Xd(a, i, l);
  return /* @__PURE__ */ A.jsxs("div", { style: u, className: Ur("simple-addon-wrapper", ...d), children: [
    n && /* @__PURE__ */ A.jsx(ly, { addon: n, ...e }),
    o,
    r && /* @__PURE__ */ A.jsx(ly, { addon: r, ...e })
  ] });
};
function Bpe(e) {
  const t = e;
  return (t.errorMessage !== void 0 || t.label !== void 0) && t.variant !== "grid";
}
const Hpe = ({
  label: e,
  labelTypographyVariant: t = "label",
  id: n,
  children: r,
  errorMessage: o,
  required: a
}) => /* @__PURE__ */ A.jsxs("div", { className: "simple-field-wrapper", children: [
  /* @__PURE__ */ A.jsxs("div", { className: "simple-field-input-with-label", children: [
    e && /* @__PURE__ */ A.jsxs("label", { htmlFor: n, className: "simple-field-label", children: [
      /* @__PURE__ */ A.jsx(lo, { variant: t, children: e }),
      a && /* @__PURE__ */ A.jsx("span", { className: "simple-field-required", children: "*" })
    ] }),
    r
  ] }),
  o && /* @__PURE__ */ A.jsx("div", { className: "simple-field-error-message", children: /* @__PURE__ */ A.jsx(lo, { variant: "body2", color: "alertError", children: o }) })
] });
function uy(e) {
  return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
const mR = ",", Gpe = ".", $pe = 10, Zpe = 0, jpe = ({
  prefix: e = "",
  postfix: t = "",
  useSeparator: n = !1,
  type: r = "number",
  precision: o,
  min: a,
  max: i
}) => {
  const { plugins: l, ...u } = o2e({
    postfix: t,
    prefix: e,
    thousandSeparator: n ? mR : "",
    decimalSeparator: Gpe,
    precision: Mt(o) ? o : r === "number" ? $pe : Zpe,
    min: Mt(a) ? +a : void 0,
    max: Mt(i) ? +i : void 0
  });
  return {
    ...u,
    plugins: [
      ...l,
      // Forbids caret to be placed in pre or postfix
      _L((d) => [e.length - 1, d.length - t.length]),
      Dfe()
    ]
  };
}, Wpe = ({ postfix: e, prefix: t, useSeparator: n }) => {
  const r = [];
  return w3(t) || r.push((o) => o.replace(new RegExp(`^${uy(t)}`), "")), w3(e) || r.push((o) => o.replace(new RegExp(`${uy(e)}$`), "")), n && r.push(
    (o) => o.replace(new RegExp(`(?!^)${mR}(?!$)`, "g"), "")
  ), r;
}, zpe = (e) => {
  const {
    postfix: t,
    prefix: n,
    useSeparator: r,
    type: o,
    precision: a,
    width: i,
    variant: l = "outline",
    size: u = "md",
    min: d,
    max: f,
    isWrapped: h,
    placeholder: p,
    value: g
  } = e, C = bt(
    () => jpe({
      postfix: t,
      prefix: n,
      useSeparator: r,
      type: o,
      precision: a,
      min: d,
      max: f
    }),
    [t, n, r, o, a, d, f]
  ), v = RL({ options: C }), y = zd(Mt(g) ? g : "", C), M = Q(
    (R) => {
      const k = (P) => Wpe({ postfix: t, prefix: n, useSeparator: r }).reduce(
        (N, O) => O(N),
        P
      );
      if (e.onChange) {
        const P = k(R.currentTarget.value);
        e.onChange({
          // Emit unmasked val
          ...R,
          target: { ...R.target, value: P },
          currentTarget: { ...R.currentTarget, value: P }
        });
      }
    },
    [e.onChange, t, n, r]
  ), x = p || `${n || ""} ${t || ""}`, _ = Yd(h, i), L = Xd(l, u, h);
  return /* @__PURE__ */ A.jsx("div", { ref: v, style: _, className: Ur("simple-field-mask", ...L), children: Yo(
    e.children,
    {
      onInput: M,
      // this is the html input element inside of simple input, so onInput is a valid prop
      placeholder: x,
      value: y
    },
    null
  ) });
}, Upe = [
  {
    isSizerWrapper: !1,
    predicate: (e) => Bpe(e),
    decorator: (e, t) => (n) => /* @__PURE__ */ A.jsx(Hpe, { ...t, isWrapped: e, children: n })
  },
  {
    isSizerWrapper: !0,
    predicate: (e) => Ope(e),
    decorator: (e, t) => (n) => /* @__PURE__ */ A.jsx(Fpe, { ...t, isWrapped: e, children: n })
  },
  {
    isSizerWrapper: !0,
    predicate: (e) => Vpe(e),
    decorator: (e, t) => (n) => /* @__PURE__ */ A.jsx(zpe, { ...t, isWrapped: e, children: n })
  }
], Rc = (e) => {
  const t = [];
  let n = !1;
  for (const { predicate: o, decorator: a, isSizerWrapper: i } of Upe)
    o(e) && (t.push(a(n, e)), i && (n = !0));
  return { decorate: (o) => t.reduceRight((a, i) => i(a), o), isWrapped: n };
}, Dc = (e) => Ve(e ?? c0e()).current;
const Xpe = {
  text: "text",
  number: "text",
  count: "text",
  date: "date",
  month: "month"
}, Ype = (e) => Xpe[e || "text"], N4e = Ke((e, t) => {
  const {
    id: n,
    name: r,
    type: o,
    value: a,
    onChange: i,
    onBlur: l,
    invalid: u,
    width: d = "100%",
    variant: f = "outline",
    size: h = "md",
    placeholder: p,
    disabled: g,
    errorMessage: C
  } = e, v = Dc(n), { decorate: y, isWrapped: M } = Rc({ ...e, id: v }), { min: x, max: _ } = kpe(e) ? e : { min: void 0, max: void 0 }, L = Yd(M, d), R = [
    "simple-field",
    "simple-input",
    f,
    u || Mt(C) ? "invalid" : "",
    ...Xd(f, h, M)
  ];
  return y(
    /* @__PURE__ */ A.jsx(
      "input",
      {
        className: Ur(...R),
        ref: t,
        id: v,
        name: r,
        type: Ype(o),
        value: a,
        onChange: i,
        onBlur: l,
        style: L,
        min: x,
        max: _,
        placeholder: p,
        autoComplete: "off",
        disabled: g
      }
    )
  );
});
const k4e = Ke(
  (e, t) => {
    const {
      children: n,
      id: r,
      name: o,
      value: a,
      invalid: i,
      onChange: l,
      onBlur: u,
      variant: d = "outline",
      size: f = "md",
      width: h = "100%",
      disabled: p
    } = e, g = Dc(r), { decorate: C, isWrapped: v } = Rc({ ...e, id: g });
    return C(
      /* @__PURE__ */ A.jsx(
        "select",
        {
          className: Ur(
            "simple-field",
            "simple-select",
            d,
            i && "invalid",
            ...Xd(d, f, v)
          ),
          style: Yd(v, h),
          ref: t,
          id: g,
          name: o,
          value: a,
          onChange: l,
          onBlur: u,
          disabled: p,
          children: n
        }
      )
    );
  }
);
const V4e = Ke((e, t) => {
  const {
    id: n,
    name: r,
    value: o,
    onChange: a,
    onBlur: i,
    invalid: l,
    width: u = "100%",
    variant: d = "outline",
    size: f = "md",
    resize: h = "both",
    disabled: p
  } = e, g = Dc(n), { decorate: C, isWrapped: v } = Rc({ ...e, id: g });
  return C(
    /* @__PURE__ */ A.jsx(
      "textarea",
      {
        className: Ur(
          "simple-field",
          "simple-textarea",
          d,
          l && "invalid",
          "simple-field-sizer",
          ...Xd(d, f, v)
        ),
        style: { resize: h, ...Yd(v, u) },
        ref: t,
        id: g,
        name: r,
        value: o,
        onChange: a,
        onBlur: i,
        disabled: p
      }
    )
  );
});
function cy(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function ot(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? cy(Object(n), !0).forEach(function(r) {
      $u(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : cy(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function qpe(e) {
  if (Array.isArray(e))
    return e;
}
function Jpe(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r, o, a, i, l = [], u = !0, d = !1;
    try {
      if (a = (n = n.call(e)).next, t === 0) {
        if (Object(n) !== n)
          return;
        u = !1;
      } else
        for (; !(u = (r = a.call(n)).done) && (l.push(r.value), l.length !== t); u = !0)
          ;
    } catch (f) {
      d = !0, o = f;
    } finally {
      try {
        if (!u && n.return != null && (i = n.return(), Object(i) !== i))
          return;
      } finally {
        if (d)
          throw o;
      }
    }
    return l;
  }
}
function Kpe() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function xi(e, t) {
  return qpe(e) || Jpe(e, t) || FL(e, t) || Kpe();
}
function Hi(e, t) {
  if (e == null)
    return {};
  var n, r, o = ex(e, t);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (r = 0; r < a.length; r++)
      n = a[r], t.indexOf(n) === -1 && {}.propertyIsEnumerable.call(e, n) && (o[n] = e[n]);
  }
  return o;
}
var Qpe = ["defaultInputValue", "defaultMenuIsOpen", "defaultValue", "inputValue", "menuIsOpen", "onChange", "onInputChange", "onMenuClose", "onMenuOpen", "value"];
function ege(e) {
  var t = e.defaultInputValue, n = t === void 0 ? "" : t, r = e.defaultMenuIsOpen, o = r === void 0 ? !1 : r, a = e.defaultValue, i = a === void 0 ? null : a, l = e.inputValue, u = e.menuIsOpen, d = e.onChange, f = e.onInputChange, h = e.onMenuClose, p = e.onMenuOpen, g = e.value, C = Hi(e, Qpe), v = He(l !== void 0 ? l : n), y = xi(v, 2), M = y[0], x = y[1], _ = He(u !== void 0 ? u : o), L = xi(_, 2), R = L[0], k = L[1], P = He(g !== void 0 ? g : i), N = xi(P, 2), O = N[0], H = N[1], $ = Q(function(K, ce) {
    typeof d == "function" && d(K, ce), H(K);
  }, [d]), ne = Q(function(K, ce) {
    var U;
    typeof f == "function" && (U = f(K, ce)), x(U !== void 0 ? U : K);
  }, [f]), ie = Q(function() {
    typeof p == "function" && p(), k(!0);
  }, [p]), re = Q(function() {
    typeof h == "function" && h(), k(!1);
  }, [h]), ve = l !== void 0 ? l : M, ue = u !== void 0 ? u : R, j = g !== void 0 ? g : O;
  return ot(ot({}, C), {}, {
    inputValue: ve,
    menuIsOpen: ue,
    onChange: $,
    onInputChange: ne,
    onMenuClose: re,
    onMenuOpen: ie,
    value: j
  });
}
function tge(e) {
  if (Array.isArray(e))
    return I3(e);
}
function nge(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function rge() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function c7(e) {
  return tge(e) || nge(e) || FL(e) || rge();
}
function oge(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
    raw: {
      value: Object.freeze(t)
    }
  }));
}
const age = Math.min, ige = Math.max, hh = Math.round, Vf = Math.floor, mh = (e) => ({
  x: e,
  y: e
});
function sge(e) {
  const {
    x: t,
    y: n,
    width: r,
    height: o
  } = e;
  return {
    width: r,
    height: o,
    top: n,
    left: t,
    right: t + r,
    bottom: n + o,
    x: t,
    y: n
  };
}
function Im() {
  return typeof window < "u";
}
function pR(e) {
  return vR(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function Sa(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function gR(e) {
  var t;
  return (t = (vR(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function vR(e) {
  return Im() ? e instanceof Node || e instanceof Sa(e).Node : !1;
}
function O3(e) {
  return Im() ? e instanceof Element || e instanceof Sa(e).Element : !1;
}
function d7(e) {
  return Im() ? e instanceof HTMLElement || e instanceof Sa(e).HTMLElement : !1;
}
function dy(e) {
  return !Im() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof Sa(e).ShadowRoot;
}
function CR(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: r,
    display: o
  } = f7(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && !["inline", "contents"].includes(o);
}
function lge() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function uge(e) {
  return ["html", "body", "#document"].includes(pR(e));
}
function f7(e) {
  return Sa(e).getComputedStyle(e);
}
function cge(e) {
  if (pR(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    dy(e) && e.host || // Fallback.
    gR(e)
  );
  return dy(t) ? t.host : t;
}
function bR(e) {
  const t = cge(e);
  return uge(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : d7(t) && CR(t) ? t : bR(t);
}
function ph(e, t, n) {
  var r;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const o = bR(e), a = o === ((r = e.ownerDocument) == null ? void 0 : r.body), i = Sa(o);
  if (a) {
    const l = F3(i);
    return t.concat(i, i.visualViewport || [], CR(o) ? o : [], l && n ? ph(l) : []);
  }
  return t.concat(o, ph(o, [], n));
}
function F3(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function dge(e) {
  const t = f7(e);
  let n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0;
  const o = d7(e), a = o ? e.offsetWidth : n, i = o ? e.offsetHeight : r, l = hh(n) !== a || hh(r) !== i;
  return l && (n = a, r = i), {
    width: n,
    height: r,
    $: l
  };
}
function h7(e) {
  return O3(e) ? e : e.contextElement;
}
function s5(e) {
  const t = h7(e);
  if (!d7(t))
    return mh(1);
  const n = t.getBoundingClientRect(), {
    width: r,
    height: o,
    $: a
  } = dge(t);
  let i = (a ? hh(n.width) : n.width) / r, l = (a ? hh(n.height) : n.height) / o;
  return (!i || !Number.isFinite(i)) && (i = 1), (!l || !Number.isFinite(l)) && (l = 1), {
    x: i,
    y: l
  };
}
const fge = /* @__PURE__ */ mh(0);
function hge(e) {
  const t = Sa(e);
  return !lge() || !t.visualViewport ? fge : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function mge(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== Sa(e) ? !1 : t;
}
function fy(e, t, n, r) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const o = e.getBoundingClientRect(), a = h7(e);
  let i = mh(1);
  t && (r ? O3(r) && (i = s5(r)) : i = s5(e));
  const l = mge(a, n, r) ? hge(a) : mh(0);
  let u = (o.left + l.x) / i.x, d = (o.top + l.y) / i.y, f = o.width / i.x, h = o.height / i.y;
  if (a) {
    const p = Sa(a), g = r && O3(r) ? Sa(r) : r;
    let C = p, v = F3(C);
    for (; v && r && g !== C; ) {
      const y = s5(v), M = v.getBoundingClientRect(), x = f7(v), _ = M.left + (v.clientLeft + parseFloat(x.paddingLeft)) * y.x, L = M.top + (v.clientTop + parseFloat(x.paddingTop)) * y.y;
      u *= y.x, d *= y.y, f *= y.x, h *= y.y, u += _, d += L, C = Sa(v), v = F3(C);
    }
  }
  return sge({
    width: f,
    height: h,
    x: u,
    y: d
  });
}
function yR(e, t) {
  return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function pge(e, t) {
  let n = null, r;
  const o = gR(e);
  function a() {
    var l;
    clearTimeout(r), (l = n) == null || l.disconnect(), n = null;
  }
  function i(l, u) {
    l === void 0 && (l = !1), u === void 0 && (u = 1), a();
    const d = e.getBoundingClientRect(), {
      left: f,
      top: h,
      width: p,
      height: g
    } = d;
    if (l || t(), !p || !g)
      return;
    const C = Vf(h), v = Vf(o.clientWidth - (f + p)), y = Vf(o.clientHeight - (h + g)), M = Vf(f), _ = {
      rootMargin: -C + "px " + -v + "px " + -y + "px " + -M + "px",
      threshold: ige(0, age(1, u)) || 1
    };
    let L = !0;
    function R(k) {
      const P = k[0].intersectionRatio;
      if (P !== u) {
        if (!L)
          return i();
        P ? i(!1, P) : r = setTimeout(() => {
          i(!1, 1e-7);
        }, 1e3);
      }
      P === 1 && !yR(d, e.getBoundingClientRect()) && i(), L = !1;
    }
    try {
      n = new IntersectionObserver(R, {
        ..._,
        // Handle <iframe>s
        root: o.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(R, _);
    }
    n.observe(e);
  }
  return i(!0), a;
}
function gge(e, t, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: o = !0,
    ancestorResize: a = !0,
    elementResize: i = typeof ResizeObserver == "function",
    layoutShift: l = typeof IntersectionObserver == "function",
    animationFrame: u = !1
  } = r, d = h7(e), f = o || a ? [...d ? ph(d) : [], ...ph(t)] : [];
  f.forEach((M) => {
    o && M.addEventListener("scroll", n, {
      passive: !0
    }), a && M.addEventListener("resize", n);
  });
  const h = d && l ? pge(d, n) : null;
  let p = -1, g = null;
  i && (g = new ResizeObserver((M) => {
    let [x] = M;
    x && x.target === d && g && (g.unobserve(t), cancelAnimationFrame(p), p = requestAnimationFrame(() => {
      var _;
      (_ = g) == null || _.observe(t);
    })), n();
  }), d && !u && g.observe(d), g.observe(t));
  let C, v = u ? fy(e) : null;
  u && y();
  function y() {
    const M = fy(e);
    v && !yR(v, M) && n(), v = M, C = requestAnimationFrame(y);
  }
  return n(), () => {
    var M;
    f.forEach((x) => {
      o && x.removeEventListener("scroll", n), a && x.removeEventListener("resize", n);
    }), h == null || h(), (M = g) == null || M.disconnect(), g = null, u && cancelAnimationFrame(C);
  };
}
var B3 = Cc, vge = ["className", "clearValue", "cx", "getStyles", "getClassNames", "getValue", "hasValue", "isMulti", "isRtl", "options", "selectOption", "selectProps", "setValue", "theme"], gh = function() {
};
function Cge(e, t) {
  return t ? t[0] === "-" ? e + t : e + "__" + t : e;
}
function bge(e, t) {
  for (var n = arguments.length, r = new Array(n > 2 ? n - 2 : 0), o = 2; o < n; o++)
    r[o - 2] = arguments[o];
  var a = [].concat(r);
  if (t && e)
    for (var i in t)
      t.hasOwnProperty(i) && t[i] && a.push("".concat(Cge(e, i)));
  return a.filter(function(l) {
    return l;
  }).map(function(l) {
    return String(l).trim();
  }).join(" ");
}
var hy = function(t) {
  return Lge(t) ? t.filter(Boolean) : Li(t) === "object" && t !== null ? [t] : [];
}, SR = function(t) {
  t.className, t.clearValue, t.cx, t.getStyles, t.getClassNames, t.getValue, t.hasValue, t.isMulti, t.isRtl, t.options, t.selectOption, t.selectProps, t.setValue, t.theme;
  var n = Hi(t, vge);
  return ot({}, n);
}, jn = function(t, n, r) {
  var o = t.cx, a = t.getStyles, i = t.getClassNames, l = t.className;
  return {
    css: a(n, t),
    className: o(r ?? {}, i(n, t), l)
  };
};
function Lm(e) {
  return [document.documentElement, document.body, window].indexOf(e) > -1;
}
function yge(e) {
  return Lm(e) ? window.innerHeight : e.clientHeight;
}
function AR(e) {
  return Lm(e) ? window.pageYOffset : e.scrollTop;
}
function vh(e, t) {
  if (Lm(e)) {
    window.scrollTo(0, t);
    return;
  }
  e.scrollTop = t;
}
function Sge(e) {
  var t = getComputedStyle(e), n = t.position === "absolute", r = /(auto|scroll)/;
  if (t.position === "fixed")
    return document.documentElement;
  for (var o = e; o = o.parentElement; )
    if (t = getComputedStyle(o), !(n && t.position === "static") && r.test(t.overflow + t.overflowY + t.overflowX))
      return o;
  return document.documentElement;
}
function Age(e, t, n, r) {
  return n * ((e = e / r - 1) * e * e + 1) + t;
}
function Of(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 200, r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : gh, o = AR(e), a = t - o, i = 10, l = 0;
  function u() {
    l += i;
    var d = Age(l, o, a, n);
    vh(e, d), l < n ? window.requestAnimationFrame(u) : r(e);
  }
  u();
}
function my(e, t) {
  var n = e.getBoundingClientRect(), r = t.getBoundingClientRect(), o = t.offsetHeight / 3;
  r.bottom + o > n.bottom ? vh(e, Math.min(t.offsetTop + t.clientHeight - e.offsetHeight + o, e.scrollHeight)) : r.top - o < n.top && vh(e, Math.max(t.offsetTop - o, 0));
}
function Mge(e) {
  var t = e.getBoundingClientRect();
  return {
    bottom: t.bottom,
    height: t.height,
    left: t.left,
    right: t.right,
    top: t.top,
    width: t.width
  };
}
function py() {
  try {
    return document.createEvent("TouchEvent"), !0;
  } catch {
    return !1;
  }
}
function xge() {
  try {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  } catch {
    return !1;
  }
}
var MR = !1, wge = {
  get passive() {
    return MR = !0;
  }
}, Ff = typeof window < "u" ? window : {};
Ff.addEventListener && Ff.removeEventListener && (Ff.addEventListener("p", gh, wge), Ff.removeEventListener("p", gh, !1));
var _ge = MR;
function Ige(e) {
  return e != null;
}
function Lge(e) {
  return Array.isArray(e);
}
function Bf(e, t, n) {
  return e ? t : n;
}
var Rge = function(t) {
  for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), o = 1; o < n; o++)
    r[o - 1] = arguments[o];
  var a = Object.entries(t).filter(function(i) {
    var l = xi(i, 1), u = l[0];
    return !r.includes(u);
  });
  return a.reduce(function(i, l) {
    var u = xi(l, 2), d = u[0], f = u[1];
    return i[d] = f, i;
  }, {});
}, Dge = ["children", "innerProps"], Pge = ["children", "innerProps"];
function Ege(e) {
  var t = e.maxHeight, n = e.menuEl, r = e.minHeight, o = e.placement, a = e.shouldScroll, i = e.isFixedPosition, l = e.controlHeight, u = Sge(n), d = {
    placement: "bottom",
    maxHeight: t
  };
  if (!n || !n.offsetParent)
    return d;
  var f = u.getBoundingClientRect(), h = f.height, p = n.getBoundingClientRect(), g = p.bottom, C = p.height, v = p.top, y = n.offsetParent.getBoundingClientRect(), M = y.top, x = i ? window.innerHeight : yge(u), _ = AR(u), L = parseInt(getComputedStyle(n).marginBottom, 10), R = parseInt(getComputedStyle(n).marginTop, 10), k = M - R, P = x - v, N = k + _, O = h - _ - v, H = g - x + _ + L, $ = _ + v - R, ne = 160;
  switch (o) {
    case "auto":
    case "bottom":
      if (P >= C)
        return {
          placement: "bottom",
          maxHeight: t
        };
      if (O >= C && !i)
        return a && Of(u, H, ne), {
          placement: "bottom",
          maxHeight: t
        };
      if (!i && O >= r || i && P >= r) {
        a && Of(u, H, ne);
        var ie = i ? P - L : O - L;
        return {
          placement: "bottom",
          maxHeight: ie
        };
      }
      if (o === "auto" || i) {
        var re = t, ve = i ? k : N;
        return ve >= r && (re = Math.min(ve - L - l, t)), {
          placement: "top",
          maxHeight: re
        };
      }
      if (o === "bottom")
        return a && vh(u, H), {
          placement: "bottom",
          maxHeight: t
        };
      break;
    case "top":
      if (k >= C)
        return {
          placement: "top",
          maxHeight: t
        };
      if (N >= C && !i)
        return a && Of(u, $, ne), {
          placement: "top",
          maxHeight: t
        };
      if (!i && N >= r || i && k >= r) {
        var ue = t;
        return (!i && N >= r || i && k >= r) && (ue = i ? k - R : N - R), a && Of(u, $, ne), {
          placement: "top",
          maxHeight: ue
        };
      }
      return {
        placement: "bottom",
        maxHeight: t
      };
    default:
      throw new Error('Invalid placement provided "'.concat(o, '".'));
  }
  return d;
}
function Tge(e) {
  var t = {
    bottom: "top",
    top: "bottom"
  };
  return e ? t[e] : "bottom";
}
var xR = function(t) {
  return t === "auto" ? "bottom" : t;
}, Nge = function(t, n) {
  var r, o = t.placement, a = t.theme, i = a.borderRadius, l = a.spacing, u = a.colors;
  return ot((r = {
    label: "menu"
  }, $u(r, Tge(o), "100%"), $u(r, "position", "absolute"), $u(r, "width", "100%"), $u(r, "zIndex", 1), r), n ? {} : {
    backgroundColor: u.neutral0,
    borderRadius: i,
    boxShadow: "0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)",
    marginBottom: l.menuGutter,
    marginTop: l.menuGutter
  });
}, wR = /* @__PURE__ */ ea(null), kge = function(t) {
  var n = t.children, r = t.minMenuHeight, o = t.maxMenuHeight, a = t.menuPlacement, i = t.menuPosition, l = t.menuShouldScrollIntoView, u = t.theme, d = Yn(wR) || {}, f = d.setPortalPlacement, h = Ve(null), p = He(o), g = xi(p, 2), C = g[0], v = g[1], y = He(null), M = xi(y, 2), x = M[0], _ = M[1], L = u.spacing.controlHeight;
  return B3(function() {
    var R = h.current;
    if (R) {
      var k = i === "fixed", P = l && !k, N = Ege({
        maxHeight: o,
        menuEl: R,
        minHeight: r,
        placement: a,
        shouldScroll: P,
        isFixedPosition: k,
        controlHeight: L
      });
      v(N.maxHeight), _(N.placement), f == null || f(N.placement);
    }
  }, [o, a, i, l, r, f, L]), n({
    ref: h,
    placerProps: ot(ot({}, t), {}, {
      placement: x || xR(a),
      maxHeight: C
    })
  });
}, Vge = function(t) {
  var n = t.children, r = t.innerRef, o = t.innerProps;
  return nt("div", et({}, jn(t, "menu", {
    menu: !0
  }), {
    ref: r
  }, o), n);
}, Oge = Vge, Fge = function(t, n) {
  var r = t.maxHeight, o = t.theme.spacing.baseUnit;
  return ot({
    maxHeight: r,
    overflowY: "auto",
    position: "relative",
    // required for offset[Height, Top] > keyboard scroll
    WebkitOverflowScrolling: "touch"
  }, n ? {} : {
    paddingBottom: o,
    paddingTop: o
  });
}, Bge = function(t) {
  var n = t.children, r = t.innerProps, o = t.innerRef, a = t.isMulti;
  return nt("div", et({}, jn(t, "menuList", {
    "menu-list": !0,
    "menu-list--is-multi": a
  }), {
    ref: o
  }, r), n);
}, _R = function(t, n) {
  var r = t.theme, o = r.spacing.baseUnit, a = r.colors;
  return ot({
    textAlign: "center"
  }, n ? {} : {
    color: a.neutral40,
    padding: "".concat(o * 2, "px ").concat(o * 3, "px")
  });
}, Hge = _R, Gge = _R, $ge = function(t) {
  var n = t.children, r = n === void 0 ? "No options" : n, o = t.innerProps, a = Hi(t, Dge);
  return nt("div", et({}, jn(ot(ot({}, a), {}, {
    children: r,
    innerProps: o
  }), "noOptionsMessage", {
    "menu-notice": !0,
    "menu-notice--no-options": !0
  }), o), r);
}, Zge = function(t) {
  var n = t.children, r = n === void 0 ? "Loading..." : n, o = t.innerProps, a = Hi(t, Pge);
  return nt("div", et({}, jn(ot(ot({}, a), {}, {
    children: r,
    innerProps: o
  }), "loadingMessage", {
    "menu-notice": !0,
    "menu-notice--loading": !0
  }), o), r);
}, jge = function(t) {
  var n = t.rect, r = t.offset, o = t.position;
  return {
    left: n.left,
    position: o,
    top: r,
    width: n.width,
    zIndex: 1
  };
}, Wge = function(t) {
  var n = t.appendTo, r = t.children, o = t.controlElement, a = t.innerProps, i = t.menuPlacement, l = t.menuPosition, u = Ve(null), d = Ve(null), f = He(xR(i)), h = xi(f, 2), p = h[0], g = h[1], C = bt(function() {
    return {
      setPortalPlacement: g
    };
  }, []), v = He(null), y = xi(v, 2), M = y[0], x = y[1], _ = Q(function() {
    if (o) {
      var P = Mge(o), N = l === "fixed" ? 0 : window.pageYOffset, O = P[p] + N;
      (O !== (M == null ? void 0 : M.offset) || P.left !== (M == null ? void 0 : M.rect.left) || P.width !== (M == null ? void 0 : M.rect.width)) && x({
        offset: O,
        rect: P
      });
    }
  }, [o, l, p, M == null ? void 0 : M.offset, M == null ? void 0 : M.rect.left, M == null ? void 0 : M.rect.width]);
  B3(function() {
    _();
  }, [_]);
  var L = Q(function() {
    typeof d.current == "function" && (d.current(), d.current = null), o && u.current && (d.current = gge(o, u.current, _, {
      elementResize: "ResizeObserver" in window
    }));
  }, [o, _]);
  B3(function() {
    L();
  }, [L]);
  var R = Q(function(P) {
    u.current = P, L();
  }, [L]);
  if (!n && l !== "fixed" || !M)
    return null;
  var k = nt("div", et({
    ref: R
  }, jn(ot(ot({}, t), {}, {
    offset: M.offset,
    position: l,
    rect: M.rect
  }), "menuPortal", {
    "menu-portal": !0
  }), a), r);
  return nt(wR.Provider, {
    value: C
  }, n ? /* @__PURE__ */ G3(k, n) : k);
}, zge = function(t) {
  var n = t.isDisabled, r = t.isRtl;
  return {
    label: "container",
    direction: r ? "rtl" : void 0,
    pointerEvents: n ? "none" : void 0,
    // cancel mouse events when disabled
    position: "relative"
  };
}, Uge = function(t) {
  var n = t.children, r = t.innerProps, o = t.isDisabled, a = t.isRtl;
  return nt("div", et({}, jn(t, "container", {
    "--is-disabled": o,
    "--is-rtl": a
  }), r), n);
}, Xge = function(t, n) {
  var r = t.theme.spacing, o = t.isMulti, a = t.hasValue, i = t.selectProps.controlShouldRenderValue;
  return ot({
    alignItems: "center",
    display: o && a && i ? "flex" : "grid",
    flex: 1,
    flexWrap: "wrap",
    WebkitOverflowScrolling: "touch",
    position: "relative",
    overflow: "hidden"
  }, n ? {} : {
    padding: "".concat(r.baseUnit / 2, "px ").concat(r.baseUnit * 2, "px")
  });
}, Yge = function(t) {
  var n = t.children, r = t.innerProps, o = t.isMulti, a = t.hasValue;
  return nt("div", et({}, jn(t, "valueContainer", {
    "value-container": !0,
    "value-container--is-multi": o,
    "value-container--has-value": a
  }), r), n);
}, qge = function() {
  return {
    alignItems: "center",
    alignSelf: "stretch",
    display: "flex",
    flexShrink: 0
  };
}, Jge = function(t) {
  var n = t.children, r = t.innerProps;
  return nt("div", et({}, jn(t, "indicatorsContainer", {
    indicators: !0
  }), r), n);
}, gy, Kge = ["size"], Qge = ["innerProps", "isRtl", "size"];
function e5e() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var t5e = process.env.NODE_ENV === "production" ? {
  name: "8mmkcg",
  styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
} : {
  name: "tj5bde-Svg",
  styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0;label:Svg;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: e5e
}, IR = function(t) {
  var n = t.size, r = Hi(t, Kge);
  return nt("svg", et({
    height: n,
    width: n,
    viewBox: "0 0 20 20",
    "aria-hidden": "true",
    focusable: "false",
    css: t5e
  }, r));
}, m7 = function(t) {
  return nt(IR, et({
    size: 20
  }, t), nt("path", {
    d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
  }));
}, LR = function(t) {
  return nt(IR, et({
    size: 20
  }, t), nt("path", {
    d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
  }));
}, RR = function(t, n) {
  var r = t.isFocused, o = t.theme, a = o.spacing.baseUnit, i = o.colors;
  return ot({
    label: "indicatorContainer",
    display: "flex",
    transition: "color 150ms"
  }, n ? {} : {
    color: r ? i.neutral60 : i.neutral20,
    padding: a * 2,
    ":hover": {
      color: r ? i.neutral80 : i.neutral40
    }
  });
}, n5e = RR, r5e = function(t) {
  var n = t.children, r = t.innerProps;
  return nt("div", et({}, jn(t, "dropdownIndicator", {
    indicator: !0,
    "dropdown-indicator": !0
  }), r), n || nt(LR, null));
}, o5e = RR, a5e = function(t) {
  var n = t.children, r = t.innerProps;
  return nt("div", et({}, jn(t, "clearIndicator", {
    indicator: !0,
    "clear-indicator": !0
  }), r), n || nt(m7, null));
}, i5e = function(t, n) {
  var r = t.isDisabled, o = t.theme, a = o.spacing.baseUnit, i = o.colors;
  return ot({
    label: "indicatorSeparator",
    alignSelf: "stretch",
    width: 1
  }, n ? {} : {
    backgroundColor: r ? i.neutral10 : i.neutral20,
    marginBottom: a * 2,
    marginTop: a * 2
  });
}, s5e = function(t) {
  var n = t.innerProps;
  return nt("span", et({}, n, jn(t, "indicatorSeparator", {
    "indicator-separator": !0
  })));
}, l5e = Md(gy || (gy = oge([`
  0%, 80%, 100% { opacity: 0; }
  40% { opacity: 1; }
`]))), u5e = function(t, n) {
  var r = t.isFocused, o = t.size, a = t.theme, i = a.colors, l = a.spacing.baseUnit;
  return ot({
    label: "loadingIndicator",
    display: "flex",
    transition: "color 150ms",
    alignSelf: "center",
    fontSize: o,
    lineHeight: 1,
    marginRight: o,
    textAlign: "center",
    verticalAlign: "middle"
  }, n ? {} : {
    color: r ? i.neutral60 : i.neutral20,
    padding: l * 2
  });
}, l5 = function(t) {
  var n = t.delay, r = t.offset;
  return nt("span", {
    css: /* @__PURE__ */ cS({
      animation: "".concat(l5e, " 1s ease-in-out ").concat(n, "ms infinite;"),
      backgroundColor: "currentColor",
      borderRadius: "1em",
      display: "inline-block",
      marginLeft: r ? "1em" : void 0,
      height: "1em",
      verticalAlign: "top",
      width: "1em"
    }, process.env.NODE_ENV === "production" ? "" : ";label:LoadingDot;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")
  });
}, c5e = function(t) {
  var n = t.innerProps, r = t.isRtl, o = t.size, a = o === void 0 ? 4 : o, i = Hi(t, Qge);
  return nt("div", et({}, jn(ot(ot({}, i), {}, {
    innerProps: n,
    isRtl: r,
    size: a
  }), "loadingIndicator", {
    indicator: !0,
    "loading-indicator": !0
  }), n), nt(l5, {
    delay: 0,
    offset: r
  }), nt(l5, {
    delay: 160,
    offset: !0
  }), nt(l5, {
    delay: 320,
    offset: !r
  }));
}, d5e = function(t, n) {
  var r = t.isDisabled, o = t.isFocused, a = t.theme, i = a.colors, l = a.borderRadius, u = a.spacing;
  return ot({
    label: "control",
    alignItems: "center",
    cursor: "default",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    minHeight: u.controlHeight,
    outline: "0 !important",
    position: "relative",
    transition: "all 100ms"
  }, n ? {} : {
    backgroundColor: r ? i.neutral5 : i.neutral0,
    borderColor: r ? i.neutral10 : o ? i.primary : i.neutral20,
    borderRadius: l,
    borderStyle: "solid",
    borderWidth: 1,
    boxShadow: o ? "0 0 0 1px ".concat(i.primary) : void 0,
    "&:hover": {
      borderColor: o ? i.primary : i.neutral30
    }
  });
}, f5e = function(t) {
  var n = t.children, r = t.isDisabled, o = t.isFocused, a = t.innerRef, i = t.innerProps, l = t.menuIsOpen;
  return nt("div", et({
    ref: a
  }, jn(t, "control", {
    control: !0,
    "control--is-disabled": r,
    "control--is-focused": o,
    "control--menu-is-open": l
  }), i, {
    "aria-disabled": r || void 0
  }), n);
}, h5e = f5e, m5e = ["data"], p5e = function(t, n) {
  var r = t.theme.spacing;
  return n ? {} : {
    paddingBottom: r.baseUnit * 2,
    paddingTop: r.baseUnit * 2
  };
}, g5e = function(t) {
  var n = t.children, r = t.cx, o = t.getStyles, a = t.getClassNames, i = t.Heading, l = t.headingProps, u = t.innerProps, d = t.label, f = t.theme, h = t.selectProps;
  return nt("div", et({}, jn(t, "group", {
    group: !0
  }), u), nt(i, et({}, l, {
    selectProps: h,
    theme: f,
    getStyles: o,
    getClassNames: a,
    cx: r
  }), d), nt("div", null, n));
}, v5e = function(t, n) {
  var r = t.theme, o = r.colors, a = r.spacing;
  return ot({
    label: "group",
    cursor: "default",
    display: "block"
  }, n ? {} : {
    color: o.neutral40,
    fontSize: "75%",
    fontWeight: 500,
    marginBottom: "0.25em",
    paddingLeft: a.baseUnit * 3,
    paddingRight: a.baseUnit * 3,
    textTransform: "uppercase"
  });
}, C5e = function(t) {
  var n = SR(t);
  n.data;
  var r = Hi(n, m5e);
  return nt("div", et({}, jn(t, "groupHeading", {
    "group-heading": !0
  }), r));
}, b5e = g5e, y5e = ["innerRef", "isDisabled", "isHidden", "inputClassName"], S5e = function(t, n) {
  var r = t.isDisabled, o = t.value, a = t.theme, i = a.spacing, l = a.colors;
  return ot(ot({
    visibility: r ? "hidden" : "visible",
    // force css to recompute when value change due to @emotion bug.
    // We can remove it whenever the bug is fixed.
    transform: o ? "translateZ(0)" : ""
  }, A5e), n ? {} : {
    margin: i.baseUnit / 2,
    paddingBottom: i.baseUnit / 2,
    paddingTop: i.baseUnit / 2,
    color: l.neutral80
  });
}, DR = {
  gridArea: "1 / 2",
  font: "inherit",
  minWidth: "2px",
  border: 0,
  margin: 0,
  outline: 0,
  padding: 0
}, A5e = {
  flex: "1 1 auto",
  display: "inline-grid",
  gridArea: "1 / 1 / 2 / 3",
  gridTemplateColumns: "0 min-content",
  "&:after": ot({
    content: 'attr(data-value) " "',
    visibility: "hidden",
    whiteSpace: "pre"
  }, DR)
}, M5e = function(t) {
  return ot({
    label: "input",
    color: "inherit",
    background: 0,
    opacity: t ? 0 : 1,
    width: "100%"
  }, DR);
}, x5e = function(t) {
  var n = t.cx, r = t.value, o = SR(t), a = o.innerRef, i = o.isDisabled, l = o.isHidden, u = o.inputClassName, d = Hi(o, y5e);
  return nt("div", et({}, jn(t, "input", {
    "input-container": !0
  }), {
    "data-value": r || ""
  }), nt("input", et({
    className: n({
      input: !0
    }, u),
    ref: a,
    style: M5e(l),
    disabled: i
  }, d)));
}, w5e = x5e, _5e = function(t, n) {
  var r = t.theme, o = r.spacing, a = r.borderRadius, i = r.colors;
  return ot({
    label: "multiValue",
    display: "flex",
    minWidth: 0
  }, n ? {} : {
    backgroundColor: i.neutral10,
    borderRadius: a / 2,
    margin: o.baseUnit / 2
  });
}, I5e = function(t, n) {
  var r = t.theme, o = r.borderRadius, a = r.colors, i = t.cropWithEllipsis;
  return ot({
    overflow: "hidden",
    textOverflow: i || i === void 0 ? "ellipsis" : void 0,
    whiteSpace: "nowrap"
  }, n ? {} : {
    borderRadius: o / 2,
    color: a.neutral80,
    fontSize: "85%",
    padding: 3,
    paddingLeft: 6
  });
}, L5e = function(t, n) {
  var r = t.theme, o = r.spacing, a = r.borderRadius, i = r.colors, l = t.isFocused;
  return ot({
    alignItems: "center",
    display: "flex"
  }, n ? {} : {
    borderRadius: a / 2,
    backgroundColor: l ? i.dangerLight : void 0,
    paddingLeft: o.baseUnit,
    paddingRight: o.baseUnit,
    ":hover": {
      backgroundColor: i.dangerLight,
      color: i.danger
    }
  });
}, PR = function(t) {
  var n = t.children, r = t.innerProps;
  return nt("div", r, n);
}, R5e = PR, D5e = PR;
function P5e(e) {
  var t = e.children, n = e.innerProps;
  return nt("div", et({
    role: "button"
  }, n), t || nt(m7, {
    size: 14
  }));
}
var E5e = function(t) {
  var n = t.children, r = t.components, o = t.data, a = t.innerProps, i = t.isDisabled, l = t.removeProps, u = t.selectProps, d = r.Container, f = r.Label, h = r.Remove;
  return nt(d, {
    data: o,
    innerProps: ot(ot({}, jn(t, "multiValue", {
      "multi-value": !0,
      "multi-value--is-disabled": i
    })), a),
    selectProps: u
  }, nt(f, {
    data: o,
    innerProps: ot({}, jn(t, "multiValueLabel", {
      "multi-value__label": !0
    })),
    selectProps: u
  }, n), nt(h, {
    data: o,
    innerProps: ot(ot({}, jn(t, "multiValueRemove", {
      "multi-value__remove": !0
    })), {}, {
      "aria-label": "Remove ".concat(n || "option")
    }, l),
    selectProps: u
  }));
}, T5e = E5e, N5e = function(t, n) {
  var r = t.isDisabled, o = t.isFocused, a = t.isSelected, i = t.theme, l = i.spacing, u = i.colors;
  return ot({
    label: "option",
    cursor: "default",
    display: "block",
    fontSize: "inherit",
    width: "100%",
    userSelect: "none",
    WebkitTapHighlightColor: "rgba(0, 0, 0, 0)"
  }, n ? {} : {
    backgroundColor: a ? u.primary : o ? u.primary25 : "transparent",
    color: r ? u.neutral20 : a ? u.neutral0 : "inherit",
    padding: "".concat(l.baseUnit * 2, "px ").concat(l.baseUnit * 3, "px"),
    // provide some affordance on touch devices
    ":active": {
      backgroundColor: r ? void 0 : a ? u.primary : u.primary50
    }
  });
}, k5e = function(t) {
  var n = t.children, r = t.isDisabled, o = t.isFocused, a = t.isSelected, i = t.innerRef, l = t.innerProps;
  return nt("div", et({}, jn(t, "option", {
    option: !0,
    "option--is-disabled": r,
    "option--is-focused": o,
    "option--is-selected": a
  }), {
    ref: i,
    "aria-disabled": r
  }, l), n);
}, V5e = k5e, O5e = function(t, n) {
  var r = t.theme, o = r.spacing, a = r.colors;
  return ot({
    label: "placeholder",
    gridArea: "1 / 1 / 2 / 3"
  }, n ? {} : {
    color: a.neutral50,
    marginLeft: o.baseUnit / 2,
    marginRight: o.baseUnit / 2
  });
}, F5e = function(t) {
  var n = t.children, r = t.innerProps;
  return nt("div", et({}, jn(t, "placeholder", {
    placeholder: !0
  }), r), n);
}, B5e = F5e, H5e = function(t, n) {
  var r = t.isDisabled, o = t.theme, a = o.spacing, i = o.colors;
  return ot({
    label: "singleValue",
    gridArea: "1 / 1 / 2 / 3",
    maxWidth: "100%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  }, n ? {} : {
    color: r ? i.neutral40 : i.neutral80,
    marginLeft: a.baseUnit / 2,
    marginRight: a.baseUnit / 2
  });
}, G5e = function(t) {
  var n = t.children, r = t.isDisabled, o = t.innerProps;
  return nt("div", et({}, jn(t, "singleValue", {
    "single-value": !0,
    "single-value--is-disabled": r
  }), o), n);
}, $5e = G5e, Z5e = {
  ClearIndicator: a5e,
  Control: h5e,
  DropdownIndicator: r5e,
  DownChevron: LR,
  CrossIcon: m7,
  Group: b5e,
  GroupHeading: C5e,
  IndicatorsContainer: Jge,
  IndicatorSeparator: s5e,
  Input: w5e,
  LoadingIndicator: c5e,
  Menu: Oge,
  MenuList: Bge,
  MenuPortal: Wge,
  LoadingMessage: Zge,
  NoOptionsMessage: $ge,
  MultiValue: T5e,
  MultiValueContainer: R5e,
  MultiValueLabel: D5e,
  MultiValueRemove: P5e,
  Option: V5e,
  Placeholder: B5e,
  SelectContainer: Uge,
  SingleValue: $5e,
  ValueContainer: Yge
}, j5e = function(t) {
  return ot(ot({}, Z5e), t.components);
}, vy = Number.isNaN || function(t) {
  return typeof t == "number" && t !== t;
};
function W5e(e, t) {
  return !!(e === t || vy(e) && vy(t));
}
function z5e(e, t) {
  if (e.length !== t.length)
    return !1;
  for (var n = 0; n < e.length; n++)
    if (!W5e(e[n], t[n]))
      return !1;
  return !0;
}
function U5e(e, t) {
  t === void 0 && (t = z5e);
  var n = null;
  function r() {
    for (var o = [], a = 0; a < arguments.length; a++)
      o[a] = arguments[a];
    if (n && n.lastThis === this && t(o, n.lastArgs))
      return n.lastResult;
    var i = e.apply(this, o);
    return n = {
      lastResult: i,
      lastArgs: o,
      lastThis: this
    }, i;
  }
  return r.clear = function() {
    n = null;
  }, r;
}
function X5e() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var Y5e = process.env.NODE_ENV === "production" ? {
  name: "7pg0cj-a11yText",
  styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
} : {
  name: "1f43avz-a11yText-A11yText",
  styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap;label:A11yText;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkExMXlUZXh0LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFNSSIsImZpbGUiOiJBMTF5VGV4dC50c3giLCJzb3VyY2VzQ29udGVudCI6WyIvKiogQGpzeCBqc3ggKi9cbmltcG9ydCB7IGpzeCB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcblxuLy8gQXNzaXN0aXZlIHRleHQgdG8gZGVzY3JpYmUgdmlzdWFsIGVsZW1lbnRzLiBIaWRkZW4gZm9yIHNpZ2h0ZWQgdXNlcnMuXG5jb25zdCBBMTF5VGV4dCA9IChwcm9wczogSlNYLkludHJpbnNpY0VsZW1lbnRzWydzcGFuJ10pID0+IChcbiAgPHNwYW5cbiAgICBjc3M9e3tcbiAgICAgIGxhYmVsOiAnYTExeVRleHQnLFxuICAgICAgekluZGV4OiA5OTk5LFxuICAgICAgYm9yZGVyOiAwLFxuICAgICAgY2xpcDogJ3JlY3QoMXB4LCAxcHgsIDFweCwgMXB4KScsXG4gICAgICBoZWlnaHQ6IDEsXG4gICAgICB3aWR0aDogMSxcbiAgICAgIHBvc2l0aW9uOiAnYWJzb2x1dGUnLFxuICAgICAgb3ZlcmZsb3c6ICdoaWRkZW4nLFxuICAgICAgcGFkZGluZzogMCxcbiAgICAgIHdoaXRlU3BhY2U6ICdub3dyYXAnLFxuICAgIH19XG4gICAgey4uLnByb3BzfVxuICAvPlxuKTtcblxuZXhwb3J0IGRlZmF1bHQgQTExeVRleHQ7XG4iXX0= */",
  toString: X5e
}, q5e = function(t) {
  return nt("span", et({
    css: Y5e
  }, t));
}, Cy = q5e, J5e = {
  guidance: function(t) {
    var n = t.isSearchable, r = t.isMulti, o = t.tabSelectsValue, a = t.context, i = t.isInitialFocus;
    switch (a) {
      case "menu":
        return "Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu".concat(o ? ", press Tab to select the option and exit the menu" : "", ".");
      case "input":
        return i ? "".concat(t["aria-label"] || "Select", " is focused ").concat(n ? ",type to refine list" : "", ", press Down to open the menu, ").concat(r ? " press left to focus selected values" : "") : "";
      case "value":
        return "Use left and right to toggle between focused values, press Backspace to remove the currently focused value";
      default:
        return "";
    }
  },
  onChange: function(t) {
    var n = t.action, r = t.label, o = r === void 0 ? "" : r, a = t.labels, i = t.isDisabled;
    switch (n) {
      case "deselect-option":
      case "pop-value":
      case "remove-value":
        return "option ".concat(o, ", deselected.");
      case "clear":
        return "All selected options have been cleared.";
      case "initial-input-focus":
        return "option".concat(a.length > 1 ? "s" : "", " ").concat(a.join(","), ", selected.");
      case "select-option":
        return i ? "option ".concat(o, " is disabled. Select another option.") : "option ".concat(o, ", selected.");
      default:
        return "";
    }
  },
  onFocus: function(t) {
    var n = t.context, r = t.focused, o = t.options, a = t.label, i = a === void 0 ? "" : a, l = t.selectValue, u = t.isDisabled, d = t.isSelected, f = t.isAppleDevice, h = function(v, y) {
      return v && v.length ? "".concat(v.indexOf(y) + 1, " of ").concat(v.length) : "";
    };
    if (n === "value" && l)
      return "value ".concat(i, " focused, ").concat(h(l, r), ".");
    if (n === "menu" && f) {
      var p = u ? " disabled" : "", g = "".concat(d ? " selected" : "").concat(p);
      return "".concat(i).concat(g, ", ").concat(h(o, r), ".");
    }
    return "";
  },
  onFilter: function(t) {
    var n = t.inputValue, r = t.resultsMessage;
    return "".concat(r).concat(n ? " for search term " + n : "", ".");
  }
}, K5e = function(t) {
  var n = t.ariaSelection, r = t.focusedOption, o = t.focusedValue, a = t.focusableOptions, i = t.isFocused, l = t.selectValue, u = t.selectProps, d = t.id, f = t.isAppleDevice, h = u.ariaLiveMessages, p = u.getOptionLabel, g = u.inputValue, C = u.isMulti, v = u.isOptionDisabled, y = u.isSearchable, M = u.menuIsOpen, x = u.options, _ = u.screenReaderStatus, L = u.tabSelectsValue, R = u.isLoading, k = u["aria-label"], P = u["aria-live"], N = bt(function() {
    return ot(ot({}, J5e), h || {});
  }, [h]), O = bt(function() {
    var ve = "";
    if (n && N.onChange) {
      var ue = n.option, j = n.options, K = n.removedValue, ce = n.removedValues, U = n.value, q = function(Ie) {
        return Array.isArray(Ie) ? null : Ie;
      }, ge = K || ue || q(U), X = ge ? p(ge) : "", he = j || ce || void 0, me = he ? he.map(p) : [], de = ot({
        // multiSelected items are usually items that have already been selected
        // or set by the user as a default value so we assume they are not disabled
        isDisabled: ge && v(ge, l),
        label: X,
        labels: me
      }, n);
      ve = N.onChange(de);
    }
    return ve;
  }, [n, N, v, l, p]), H = bt(function() {
    var ve = "", ue = r || o, j = !!(r && l && l.includes(r));
    if (ue && N.onFocus) {
      var K = {
        focused: ue,
        label: p(ue),
        isDisabled: v(ue, l),
        isSelected: j,
        options: a,
        context: ue === r ? "menu" : "value",
        selectValue: l,
        isAppleDevice: f
      };
      ve = N.onFocus(K);
    }
    return ve;
  }, [r, o, p, v, N, a, l, f]), $ = bt(function() {
    var ve = "";
    if (M && x.length && !R && N.onFilter) {
      var ue = _({
        count: a.length
      });
      ve = N.onFilter({
        inputValue: g,
        resultsMessage: ue
      });
    }
    return ve;
  }, [a, g, M, N, x, _, R]), ne = (n == null ? void 0 : n.action) === "initial-input-focus", ie = bt(function() {
    var ve = "";
    if (N.guidance) {
      var ue = o ? "value" : M ? "menu" : "input";
      ve = N.guidance({
        "aria-label": k,
        context: ue,
        isDisabled: r && v(r, l),
        isMulti: C,
        isSearchable: y,
        tabSelectsValue: L,
        isInitialFocus: ne
      });
    }
    return ve;
  }, [k, r, o, C, v, y, M, N, l, L, ne]), re = nt(Ml, null, nt("span", {
    id: "aria-selection"
  }, O), nt("span", {
    id: "aria-focused"
  }, H), nt("span", {
    id: "aria-results"
  }, $), nt("span", {
    id: "aria-guidance"
  }, ie));
  return nt(Ml, null, nt(Cy, {
    id: d
  }, ne && re), nt(Cy, {
    "aria-live": P,
    "aria-atomic": "false",
    "aria-relevant": "additions text",
    role: "log"
  }, i && !ne && re));
}, Q5e = K5e, H3 = [{
  base: "A",
  letters: "AⒶＡÀÁÂẦẤẪẨÃĀĂẰẮẴẲȦǠÄǞẢÅǺǍȀȂẠẬẶḀĄȺⱯ"
}, {
  base: "AA",
  letters: "Ꜳ"
}, {
  base: "AE",
  letters: "ÆǼǢ"
}, {
  base: "AO",
  letters: "Ꜵ"
}, {
  base: "AU",
  letters: "Ꜷ"
}, {
  base: "AV",
  letters: "ꜸꜺ"
}, {
  base: "AY",
  letters: "Ꜽ"
}, {
  base: "B",
  letters: "BⒷＢḂḄḆɃƂƁ"
}, {
  base: "C",
  letters: "CⒸＣĆĈĊČÇḈƇȻꜾ"
}, {
  base: "D",
  letters: "DⒹＤḊĎḌḐḒḎĐƋƊƉꝹ"
}, {
  base: "DZ",
  letters: "ǱǄ"
}, {
  base: "Dz",
  letters: "ǲǅ"
}, {
  base: "E",
  letters: "EⒺＥÈÉÊỀẾỄỂẼĒḔḖĔĖËẺĚȄȆẸỆȨḜĘḘḚƐƎ"
}, {
  base: "F",
  letters: "FⒻＦḞƑꝻ"
}, {
  base: "G",
  letters: "GⒼＧǴĜḠĞĠǦĢǤƓꞠꝽꝾ"
}, {
  base: "H",
  letters: "HⒽＨĤḢḦȞḤḨḪĦⱧⱵꞍ"
}, {
  base: "I",
  letters: "IⒾＩÌÍÎĨĪĬİÏḮỈǏȈȊỊĮḬƗ"
}, {
  base: "J",
  letters: "JⒿＪĴɈ"
}, {
  base: "K",
  letters: "KⓀＫḰǨḲĶḴƘⱩꝀꝂꝄꞢ"
}, {
  base: "L",
  letters: "LⓁＬĿĹĽḶḸĻḼḺŁȽⱢⱠꝈꝆꞀ"
}, {
  base: "LJ",
  letters: "Ǉ"
}, {
  base: "Lj",
  letters: "ǈ"
}, {
  base: "M",
  letters: "MⓂＭḾṀṂⱮƜ"
}, {
  base: "N",
  letters: "NⓃＮǸŃÑṄŇṆŅṊṈȠƝꞐꞤ"
}, {
  base: "NJ",
  letters: "Ǌ"
}, {
  base: "Nj",
  letters: "ǋ"
}, {
  base: "O",
  letters: "OⓄＯÒÓÔỒỐỖỔÕṌȬṎŌṐṒŎȮȰÖȪỎŐǑȌȎƠỜỚỠỞỢỌỘǪǬØǾƆƟꝊꝌ"
}, {
  base: "OI",
  letters: "Ƣ"
}, {
  base: "OO",
  letters: "Ꝏ"
}, {
  base: "OU",
  letters: "Ȣ"
}, {
  base: "P",
  letters: "PⓅＰṔṖƤⱣꝐꝒꝔ"
}, {
  base: "Q",
  letters: "QⓆＱꝖꝘɊ"
}, {
  base: "R",
  letters: "RⓇＲŔṘŘȐȒṚṜŖṞɌⱤꝚꞦꞂ"
}, {
  base: "S",
  letters: "SⓈＳẞŚṤŜṠŠṦṢṨȘŞⱾꞨꞄ"
}, {
  base: "T",
  letters: "TⓉＴṪŤṬȚŢṰṮŦƬƮȾꞆ"
}, {
  base: "TZ",
  letters: "Ꜩ"
}, {
  base: "U",
  letters: "UⓊＵÙÚÛŨṸŪṺŬÜǛǗǕǙỦŮŰǓȔȖƯỪỨỮỬỰỤṲŲṶṴɄ"
}, {
  base: "V",
  letters: "VⓋＶṼṾƲꝞɅ"
}, {
  base: "VY",
  letters: "Ꝡ"
}, {
  base: "W",
  letters: "WⓌＷẀẂŴẆẄẈⱲ"
}, {
  base: "X",
  letters: "XⓍＸẊẌ"
}, {
  base: "Y",
  letters: "YⓎＹỲÝŶỸȲẎŸỶỴƳɎỾ"
}, {
  base: "Z",
  letters: "ZⓏＺŹẐŻŽẒẔƵȤⱿⱫꝢ"
}, {
  base: "a",
  letters: "aⓐａẚàáâầấẫẩãāăằắẵẳȧǡäǟảåǻǎȁȃạậặḁąⱥɐ"
}, {
  base: "aa",
  letters: "ꜳ"
}, {
  base: "ae",
  letters: "æǽǣ"
}, {
  base: "ao",
  letters: "ꜵ"
}, {
  base: "au",
  letters: "ꜷ"
}, {
  base: "av",
  letters: "ꜹꜻ"
}, {
  base: "ay",
  letters: "ꜽ"
}, {
  base: "b",
  letters: "bⓑｂḃḅḇƀƃɓ"
}, {
  base: "c",
  letters: "cⓒｃćĉċčçḉƈȼꜿↄ"
}, {
  base: "d",
  letters: "dⓓｄḋďḍḑḓḏđƌɖɗꝺ"
}, {
  base: "dz",
  letters: "ǳǆ"
}, {
  base: "e",
  letters: "eⓔｅèéêềếễểẽēḕḗĕėëẻěȅȇẹệȩḝęḙḛɇɛǝ"
}, {
  base: "f",
  letters: "fⓕｆḟƒꝼ"
}, {
  base: "g",
  letters: "gⓖｇǵĝḡğġǧģǥɠꞡᵹꝿ"
}, {
  base: "h",
  letters: "hⓗｈĥḣḧȟḥḩḫẖħⱨⱶɥ"
}, {
  base: "hv",
  letters: "ƕ"
}, {
  base: "i",
  letters: "iⓘｉìíîĩīĭïḯỉǐȉȋịįḭɨı"
}, {
  base: "j",
  letters: "jⓙｊĵǰɉ"
}, {
  base: "k",
  letters: "kⓚｋḱǩḳķḵƙⱪꝁꝃꝅꞣ"
}, {
  base: "l",
  letters: "lⓛｌŀĺľḷḹļḽḻſłƚɫⱡꝉꞁꝇ"
}, {
  base: "lj",
  letters: "ǉ"
}, {
  base: "m",
  letters: "mⓜｍḿṁṃɱɯ"
}, {
  base: "n",
  letters: "nⓝｎǹńñṅňṇņṋṉƞɲŉꞑꞥ"
}, {
  base: "nj",
  letters: "ǌ"
}, {
  base: "o",
  letters: "oⓞｏòóôồốỗổõṍȭṏōṑṓŏȯȱöȫỏőǒȍȏơờớỡởợọộǫǭøǿɔꝋꝍɵ"
}, {
  base: "oi",
  letters: "ƣ"
}, {
  base: "ou",
  letters: "ȣ"
}, {
  base: "oo",
  letters: "ꝏ"
}, {
  base: "p",
  letters: "pⓟｐṕṗƥᵽꝑꝓꝕ"
}, {
  base: "q",
  letters: "qⓠｑɋꝗꝙ"
}, {
  base: "r",
  letters: "rⓡｒŕṙřȑȓṛṝŗṟɍɽꝛꞧꞃ"
}, {
  base: "s",
  letters: "sⓢｓßśṥŝṡšṧṣṩșşȿꞩꞅẛ"
}, {
  base: "t",
  letters: "tⓣｔṫẗťṭțţṱṯŧƭʈⱦꞇ"
}, {
  base: "tz",
  letters: "ꜩ"
}, {
  base: "u",
  letters: "uⓤｕùúûũṹūṻŭüǜǘǖǚủůűǔȕȗưừứữửựụṳųṷṵʉ"
}, {
  base: "v",
  letters: "vⓥｖṽṿʋꝟʌ"
}, {
  base: "vy",
  letters: "ꝡ"
}, {
  base: "w",
  letters: "wⓦｗẁẃŵẇẅẘẉⱳ"
}, {
  base: "x",
  letters: "xⓧｘẋẍ"
}, {
  base: "y",
  letters: "yⓨｙỳýŷỹȳẏÿỷẙỵƴɏỿ"
}, {
  base: "z",
  letters: "zⓩｚźẑżžẓẕƶȥɀⱬꝣ"
}], e3e = new RegExp("[" + H3.map(function(e) {
  return e.letters;
}).join("") + "]", "g"), ER = {};
for (var u5 = 0; u5 < H3.length; u5++)
  for (var c5 = H3[u5], d5 = 0; d5 < c5.letters.length; d5++)
    ER[c5.letters[d5]] = c5.base;
var TR = function(t) {
  return t.replace(e3e, function(n) {
    return ER[n];
  });
}, t3e = U5e(TR), by = function(t) {
  return t.replace(/^\s+|\s+$/g, "");
}, n3e = function(t) {
  return "".concat(t.label, " ").concat(t.value);
}, r3e = function(t) {
  return function(n, r) {
    if (n.data.__isNew__)
      return !0;
    var o = ot({
      ignoreCase: !0,
      ignoreAccents: !0,
      stringify: n3e,
      trim: !0,
      matchFrom: "any"
    }, t), a = o.ignoreCase, i = o.ignoreAccents, l = o.stringify, u = o.trim, d = o.matchFrom, f = u ? by(r) : r, h = u ? by(l(n)) : l(n);
    return a && (f = f.toLowerCase(), h = h.toLowerCase()), i && (f = t3e(f), h = TR(h)), d === "start" ? h.substr(0, f.length) === f : h.indexOf(f) > -1;
  };
}, o3e = ["innerRef"];
function a3e(e) {
  var t = e.innerRef, n = Hi(e, o3e), r = Rge(n, "onExited", "in", "enter", "exit", "appear");
  return nt("input", et({
    ref: t
  }, r, {
    css: /* @__PURE__ */ cS({
      label: "dummyInput",
      // get rid of any default styles
      background: 0,
      border: 0,
      // important! this hides the flashing cursor
      caretColor: "transparent",
      fontSize: "inherit",
      gridArea: "1 / 1 / 2 / 3",
      outline: 0,
      padding: 0,
      // important! without `width` browsers won't allow focus
      width: 1,
      // remove cursor on desktop
      color: "transparent",
      // remove cursor on mobile whilst maintaining "scroll into view" behaviour
      left: -100,
      opacity: 0,
      position: "relative",
      transform: "scale(.01)"
    }, process.env.NODE_ENV === "production" ? "" : ";label:DummyInput;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkR1bW15SW5wdXQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQXlCTSIsImZpbGUiOiJEdW1teUlucHV0LnRzeCIsInNvdXJjZXNDb250ZW50IjpbIi8qKiBAanN4IGpzeCAqL1xuaW1wb3J0IHsgUmVmIH0gZnJvbSAncmVhY3QnO1xuaW1wb3J0IHsganN4IH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuaW1wb3J0IHsgcmVtb3ZlUHJvcHMgfSBmcm9tICcuLi91dGlscyc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIER1bW15SW5wdXQoe1xuICBpbm5lclJlZixcbiAgLi4ucHJvcHNcbn06IEpTWC5JbnRyaW5zaWNFbGVtZW50c1snaW5wdXQnXSAmIHtcbiAgcmVhZG9ubHkgaW5uZXJSZWY6IFJlZjxIVE1MSW5wdXRFbGVtZW50Pjtcbn0pIHtcbiAgLy8gUmVtb3ZlIGFuaW1hdGlvbiBwcm9wcyBub3QgbWVhbnQgZm9yIEhUTUwgZWxlbWVudHNcbiAgY29uc3QgZmlsdGVyZWRQcm9wcyA9IHJlbW92ZVByb3BzKFxuICAgIHByb3BzLFxuICAgICdvbkV4aXRlZCcsXG4gICAgJ2luJyxcbiAgICAnZW50ZXInLFxuICAgICdleGl0JyxcbiAgICAnYXBwZWFyJ1xuICApO1xuXG4gIHJldHVybiAoXG4gICAgPGlucHV0XG4gICAgICByZWY9e2lubmVyUmVmfVxuICAgICAgey4uLmZpbHRlcmVkUHJvcHN9XG4gICAgICBjc3M9e3tcbiAgICAgICAgbGFiZWw6ICdkdW1teUlucHV0JyxcbiAgICAgICAgLy8gZ2V0IHJpZCBvZiBhbnkgZGVmYXVsdCBzdHlsZXNcbiAgICAgICAgYmFja2dyb3VuZDogMCxcbiAgICAgICAgYm9yZGVyOiAwLFxuICAgICAgICAvLyBpbXBvcnRhbnQhIHRoaXMgaGlkZXMgdGhlIGZsYXNoaW5nIGN1cnNvclxuICAgICAgICBjYXJldENvbG9yOiAndHJhbnNwYXJlbnQnLFxuICAgICAgICBmb250U2l6ZTogJ2luaGVyaXQnLFxuICAgICAgICBncmlkQXJlYTogJzEgLyAxIC8gMiAvIDMnLFxuICAgICAgICBvdXRsaW5lOiAwLFxuICAgICAgICBwYWRkaW5nOiAwLFxuICAgICAgICAvLyBpbXBvcnRhbnQhIHdpdGhvdXQgYHdpZHRoYCBicm93c2VycyB3b24ndCBhbGxvdyBmb2N1c1xuICAgICAgICB3aWR0aDogMSxcblxuICAgICAgICAvLyByZW1vdmUgY3Vyc29yIG9uIGRlc2t0b3BcbiAgICAgICAgY29sb3I6ICd0cmFuc3BhcmVudCcsXG5cbiAgICAgICAgLy8gcmVtb3ZlIGN1cnNvciBvbiBtb2JpbGUgd2hpbHN0IG1haW50YWluaW5nIFwic2Nyb2xsIGludG8gdmlld1wiIGJlaGF2aW91clxuICAgICAgICBsZWZ0OiAtMTAwLFxuICAgICAgICBvcGFjaXR5OiAwLFxuICAgICAgICBwb3NpdGlvbjogJ3JlbGF0aXZlJyxcbiAgICAgICAgdHJhbnNmb3JtOiAnc2NhbGUoLjAxKScsXG4gICAgICB9fVxuICAgIC8+XG4gICk7XG59XG4iXX0= */")
  }));
}
var i3e = function(t) {
  t.cancelable && t.preventDefault(), t.stopPropagation();
};
function s3e(e) {
  var t = e.isEnabled, n = e.onBottomArrive, r = e.onBottomLeave, o = e.onTopArrive, a = e.onTopLeave, i = Ve(!1), l = Ve(!1), u = Ve(0), d = Ve(null), f = Q(function(y, M) {
    if (d.current !== null) {
      var x = d.current, _ = x.scrollTop, L = x.scrollHeight, R = x.clientHeight, k = d.current, P = M > 0, N = L - R - _, O = !1;
      N > M && i.current && (r && r(y), i.current = !1), P && l.current && (a && a(y), l.current = !1), P && M > N ? (n && !i.current && n(y), k.scrollTop = L, O = !0, i.current = !0) : !P && -M > _ && (o && !l.current && o(y), k.scrollTop = 0, O = !0, l.current = !0), O && i3e(y);
    }
  }, [n, r, o, a]), h = Q(function(y) {
    f(y, y.deltaY);
  }, [f]), p = Q(function(y) {
    u.current = y.changedTouches[0].clientY;
  }, []), g = Q(function(y) {
    var M = u.current - y.changedTouches[0].clientY;
    f(y, M);
  }, [f]), C = Q(function(y) {
    if (y) {
      var M = _ge ? {
        passive: !1
      } : !1;
      y.addEventListener("wheel", h, M), y.addEventListener("touchstart", p, M), y.addEventListener("touchmove", g, M);
    }
  }, [g, p, h]), v = Q(function(y) {
    y && (y.removeEventListener("wheel", h, !1), y.removeEventListener("touchstart", p, !1), y.removeEventListener("touchmove", g, !1));
  }, [g, p, h]);
  return st(function() {
    if (t) {
      var y = d.current;
      return C(y), function() {
        v(y);
      };
    }
  }, [t, C, v]), function(y) {
    d.current = y;
  };
}
var yy = ["boxSizing", "height", "overflow", "paddingRight", "position"], Sy = {
  boxSizing: "border-box",
  // account for possible declaration `width: 100%;` on body
  overflow: "hidden",
  position: "relative",
  height: "100%"
};
function Ay(e) {
  e.preventDefault();
}
function My(e) {
  e.stopPropagation();
}
function xy() {
  var e = this.scrollTop, t = this.scrollHeight, n = e + this.offsetHeight;
  e === 0 ? this.scrollTop = 1 : n === t && (this.scrollTop = e - 1);
}
function wy() {
  return "ontouchstart" in window || navigator.maxTouchPoints;
}
var _y = !!(typeof window < "u" && window.document && window.document.createElement), w1 = 0, Lu = {
  capture: !1,
  passive: !1
};
function l3e(e) {
  var t = e.isEnabled, n = e.accountForScrollbars, r = n === void 0 ? !0 : n, o = Ve({}), a = Ve(null), i = Q(function(u) {
    if (_y) {
      var d = document.body, f = d && d.style;
      if (r && yy.forEach(function(C) {
        var v = f && f[C];
        o.current[C] = v;
      }), r && w1 < 1) {
        var h = parseInt(o.current.paddingRight, 10) || 0, p = document.body ? document.body.clientWidth : 0, g = window.innerWidth - p + h || 0;
        Object.keys(Sy).forEach(function(C) {
          var v = Sy[C];
          f && (f[C] = v);
        }), f && (f.paddingRight = "".concat(g, "px"));
      }
      d && wy() && (d.addEventListener("touchmove", Ay, Lu), u && (u.addEventListener("touchstart", xy, Lu), u.addEventListener("touchmove", My, Lu))), w1 += 1;
    }
  }, [r]), l = Q(function(u) {
    if (_y) {
      var d = document.body, f = d && d.style;
      w1 = Math.max(w1 - 1, 0), r && w1 < 1 && yy.forEach(function(h) {
        var p = o.current[h];
        f && (f[h] = p);
      }), d && wy() && (d.removeEventListener("touchmove", Ay, Lu), u && (u.removeEventListener("touchstart", xy, Lu), u.removeEventListener("touchmove", My, Lu)));
    }
  }, [r]);
  return st(function() {
    if (t) {
      var u = a.current;
      return i(u), function() {
        l(u);
      };
    }
  }, [t, i, l]), function(u) {
    a.current = u;
  };
}
function u3e() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var c3e = function(t) {
  var n = t.target;
  return n.ownerDocument.activeElement && n.ownerDocument.activeElement.blur();
}, d3e = process.env.NODE_ENV === "production" ? {
  name: "1kfdb0e",
  styles: "position:fixed;left:0;bottom:0;right:0;top:0"
} : {
  name: "bp8cua-ScrollManager",
  styles: "position:fixed;left:0;bottom:0;right:0;top:0;label:ScrollManager;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: u3e
};
function f3e(e) {
  var t = e.children, n = e.lockEnabled, r = e.captureEnabled, o = r === void 0 ? !0 : r, a = e.onBottomArrive, i = e.onBottomLeave, l = e.onTopArrive, u = e.onTopLeave, d = s3e({
    isEnabled: o,
    onBottomArrive: a,
    onBottomLeave: i,
    onTopArrive: l,
    onTopLeave: u
  }), f = l3e({
    isEnabled: n
  }), h = function(g) {
    d(g), f(g);
  };
  return nt(Ml, null, n && nt("div", {
    onClick: c3e,
    css: d3e
  }), t(h));
}
function h3e() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var m3e = process.env.NODE_ENV === "production" ? {
  name: "1a0ro4n-requiredInput",
  styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%"
} : {
  name: "5kkxb2-requiredInput-RequiredInput",
  styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%;label:RequiredInput;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlJlcXVpcmVkSW5wdXQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWNJIiwiZmlsZSI6IlJlcXVpcmVkSW5wdXQudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiLyoqIEBqc3gganN4ICovXG5pbXBvcnQgeyBGb2N1c0V2ZW50SGFuZGxlciwgRnVuY3Rpb25Db21wb25lbnQgfSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgeyBqc3ggfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5cbmNvbnN0IFJlcXVpcmVkSW5wdXQ6IEZ1bmN0aW9uQ29tcG9uZW50PHtcbiAgcmVhZG9ubHkgbmFtZT86IHN0cmluZztcbiAgcmVhZG9ubHkgb25Gb2N1czogRm9jdXNFdmVudEhhbmRsZXI8SFRNTElucHV0RWxlbWVudD47XG59PiA9ICh7IG5hbWUsIG9uRm9jdXMgfSkgPT4gKFxuICA8aW5wdXRcbiAgICByZXF1aXJlZFxuICAgIG5hbWU9e25hbWV9XG4gICAgdGFiSW5kZXg9ey0xfVxuICAgIGFyaWEtaGlkZGVuPVwidHJ1ZVwiXG4gICAgb25Gb2N1cz17b25Gb2N1c31cbiAgICBjc3M9e3tcbiAgICAgIGxhYmVsOiAncmVxdWlyZWRJbnB1dCcsXG4gICAgICBvcGFjaXR5OiAwLFxuICAgICAgcG9pbnRlckV2ZW50czogJ25vbmUnLFxuICAgICAgcG9zaXRpb246ICdhYnNvbHV0ZScsXG4gICAgICBib3R0b206IDAsXG4gICAgICBsZWZ0OiAwLFxuICAgICAgcmlnaHQ6IDAsXG4gICAgICB3aWR0aDogJzEwMCUnLFxuICAgIH19XG4gICAgLy8gUHJldmVudCBgU3dpdGNoaW5nIGZyb20gdW5jb250cm9sbGVkIHRvIGNvbnRyb2xsZWRgIGVycm9yXG4gICAgdmFsdWU9XCJcIlxuICAgIG9uQ2hhbmdlPXsoKSA9PiB7fX1cbiAgLz5cbik7XG5cbmV4cG9ydCBkZWZhdWx0IFJlcXVpcmVkSW5wdXQ7XG4iXX0= */",
  toString: h3e
}, p3e = function(t) {
  var n = t.name, r = t.onFocus;
  return nt("input", {
    required: !0,
    name: n,
    tabIndex: -1,
    "aria-hidden": "true",
    onFocus: r,
    css: m3e,
    value: "",
    onChange: function() {
    }
  });
}, g3e = p3e;
function p7(e) {
  var t;
  return typeof window < "u" && window.navigator != null ? e.test(((t = window.navigator.userAgentData) === null || t === void 0 ? void 0 : t.platform) || window.navigator.platform) : !1;
}
function v3e() {
  return p7(/^iPhone/i);
}
function NR() {
  return p7(/^Mac/i);
}
function C3e() {
  return p7(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
  NR() && navigator.maxTouchPoints > 1;
}
function b3e() {
  return v3e() || C3e();
}
function y3e() {
  return NR() || b3e();
}
var S3e = function(t) {
  return t.label;
}, A3e = function(t) {
  return t.label;
}, M3e = function(t) {
  return t.value;
}, x3e = function(t) {
  return !!t.isDisabled;
}, w3e = {
  clearIndicator: o5e,
  container: zge,
  control: d5e,
  dropdownIndicator: n5e,
  group: p5e,
  groupHeading: v5e,
  indicatorsContainer: qge,
  indicatorSeparator: i5e,
  input: S5e,
  loadingIndicator: u5e,
  loadingMessage: Gge,
  menu: Nge,
  menuList: Fge,
  menuPortal: jge,
  multiValue: _5e,
  multiValueLabel: I5e,
  multiValueRemove: L5e,
  noOptionsMessage: Hge,
  option: N5e,
  placeholder: O5e,
  singleValue: H5e,
  valueContainer: Xge
}, _3e = {
  primary: "#2684FF",
  primary75: "#4C9AFF",
  primary50: "#B2D4FF",
  primary25: "#DEEBFF",
  danger: "#DE350B",
  dangerLight: "#FFBDAD",
  neutral0: "hsl(0, 0%, 100%)",
  neutral5: "hsl(0, 0%, 95%)",
  neutral10: "hsl(0, 0%, 90%)",
  neutral20: "hsl(0, 0%, 80%)",
  neutral30: "hsl(0, 0%, 70%)",
  neutral40: "hsl(0, 0%, 60%)",
  neutral50: "hsl(0, 0%, 50%)",
  neutral60: "hsl(0, 0%, 40%)",
  neutral70: "hsl(0, 0%, 30%)",
  neutral80: "hsl(0, 0%, 20%)",
  neutral90: "hsl(0, 0%, 10%)"
}, I3e = 4, kR = 4, L3e = 38, R3e = kR * 2, D3e = {
  baseUnit: kR,
  controlHeight: L3e,
  menuGutter: R3e
}, f5 = {
  borderRadius: I3e,
  colors: _3e,
  spacing: D3e
}, P3e = {
  "aria-live": "polite",
  backspaceRemovesValue: !0,
  blurInputOnSelect: py(),
  captureMenuScroll: !py(),
  classNames: {},
  closeMenuOnSelect: !0,
  closeMenuOnScroll: !1,
  components: {},
  controlShouldRenderValue: !0,
  escapeClearsValue: !1,
  filterOption: r3e(),
  formatGroupLabel: S3e,
  getOptionLabel: A3e,
  getOptionValue: M3e,
  isDisabled: !1,
  isLoading: !1,
  isMulti: !1,
  isRtl: !1,
  isSearchable: !0,
  isOptionDisabled: x3e,
  loadingMessage: function() {
    return "Loading...";
  },
  maxMenuHeight: 300,
  minMenuHeight: 140,
  menuIsOpen: !1,
  menuPlacement: "bottom",
  menuPosition: "absolute",
  menuShouldBlockScroll: !1,
  menuShouldScrollIntoView: !xge(),
  noOptionsMessage: function() {
    return "No options";
  },
  openMenuOnFocus: !1,
  openMenuOnClick: !0,
  options: [],
  pageSize: 5,
  placeholder: "Select...",
  screenReaderStatus: function(t) {
    var n = t.count;
    return "".concat(n, " result").concat(n !== 1 ? "s" : "", " available");
  },
  styles: {},
  tabIndex: 0,
  tabSelectsValue: !0,
  unstyled: !1
};
function Iy(e, t, n, r) {
  var o = FR(e, t, n), a = BR(e, t, n), i = OR(e, t), l = Ch(e, t);
  return {
    type: "option",
    data: t,
    isDisabled: o,
    isSelected: a,
    label: i,
    value: l,
    index: r
  };
}
function u2(e, t) {
  return e.options.map(function(n, r) {
    if ("options" in n) {
      var o = n.options.map(function(i, l) {
        return Iy(e, i, t, l);
      }).filter(function(i) {
        return Ry(e, i);
      });
      return o.length > 0 ? {
        type: "group",
        data: n,
        options: o,
        index: r
      } : void 0;
    }
    var a = Iy(e, n, t, r);
    return Ry(e, a) ? a : void 0;
  }).filter(Ige);
}
function VR(e) {
  return e.reduce(function(t, n) {
    return n.type === "group" ? t.push.apply(t, c7(n.options.map(function(r) {
      return r.data;
    }))) : t.push(n.data), t;
  }, []);
}
function Ly(e, t) {
  return e.reduce(function(n, r) {
    return r.type === "group" ? n.push.apply(n, c7(r.options.map(function(o) {
      return {
        data: o.data,
        id: "".concat(t, "-").concat(r.index, "-").concat(o.index)
      };
    }))) : n.push({
      data: r.data,
      id: "".concat(t, "-").concat(r.index)
    }), n;
  }, []);
}
function E3e(e, t) {
  return VR(u2(e, t));
}
function Ry(e, t) {
  var n = e.inputValue, r = n === void 0 ? "" : n, o = t.data, a = t.isSelected, i = t.label, l = t.value;
  return (!GR(e) || !a) && HR(e, {
    label: i,
    value: l,
    data: o
  }, r);
}
function T3e(e, t) {
  var n = e.focusedValue, r = e.selectValue, o = r.indexOf(n);
  if (o > -1) {
    var a = t.indexOf(n);
    if (a > -1)
      return n;
    if (o < t.length)
      return t[o];
  }
  return null;
}
function N3e(e, t) {
  var n = e.focusedOption;
  return n && t.indexOf(n) > -1 ? n : t[0];
}
var h5 = function(t, n) {
  var r, o = (r = t.find(function(a) {
    return a.data === n;
  })) === null || r === void 0 ? void 0 : r.id;
  return o || null;
}, OR = function(t, n) {
  return t.getOptionLabel(n);
}, Ch = function(t, n) {
  return t.getOptionValue(n);
};
function FR(e, t, n) {
  return typeof e.isOptionDisabled == "function" ? e.isOptionDisabled(t, n) : !1;
}
function BR(e, t, n) {
  if (n.indexOf(t) > -1)
    return !0;
  if (typeof e.isOptionSelected == "function")
    return e.isOptionSelected(t, n);
  var r = Ch(e, t);
  return n.some(function(o) {
    return Ch(e, o) === r;
  });
}
function HR(e, t, n) {
  return e.filterOption ? e.filterOption(t, n) : !0;
}
var GR = function(t) {
  var n = t.hideSelectedOptions, r = t.isMulti;
  return n === void 0 ? r : n;
}, k3e = 1, $R = /* @__PURE__ */ function(e) {
  ome(n, e);
  var t = ime(n);
  function n(r) {
    var o;
    if (sme(this, n), o = t.call(this, r), o.state = {
      ariaSelection: null,
      focusedOption: null,
      focusedOptionId: null,
      focusableOptionsWithIds: [],
      focusedValue: null,
      inputIsHidden: !1,
      isFocused: !1,
      selectValue: [],
      clearFocusValueOnUpdate: !1,
      prevWasFocused: !1,
      inputIsHiddenAfterUpdate: void 0,
      prevProps: void 0,
      instancePrefix: ""
    }, o.blockOptionHover = !1, o.isComposing = !1, o.commonProps = void 0, o.initialTouchX = 0, o.initialTouchY = 0, o.openAfterFocus = !1, o.scrollToFocusedOptionOnUpdate = !1, o.userIsDragging = void 0, o.isAppleDevice = y3e(), o.controlRef = null, o.getControlRef = function(u) {
      o.controlRef = u;
    }, o.focusedOptionRef = null, o.getFocusedOptionRef = function(u) {
      o.focusedOptionRef = u;
    }, o.menuListRef = null, o.getMenuListRef = function(u) {
      o.menuListRef = u;
    }, o.inputRef = null, o.getInputRef = function(u) {
      o.inputRef = u;
    }, o.focus = o.focusInput, o.blur = o.blurInput, o.onChange = function(u, d) {
      var f = o.props, h = f.onChange, p = f.name;
      d.name = p, o.ariaOnChange(u, d), h(u, d);
    }, o.setValue = function(u, d, f) {
      var h = o.props, p = h.closeMenuOnSelect, g = h.isMulti, C = h.inputValue;
      o.onInputChange("", {
        action: "set-value",
        prevInputValue: C
      }), p && (o.setState({
        inputIsHiddenAfterUpdate: !g
      }), o.onMenuClose()), o.setState({
        clearFocusValueOnUpdate: !0
      }), o.onChange(u, {
        action: d,
        option: f
      });
    }, o.selectOption = function(u) {
      var d = o.props, f = d.blurInputOnSelect, h = d.isMulti, p = d.name, g = o.state.selectValue, C = h && o.isOptionSelected(u, g), v = o.isOptionDisabled(u, g);
      if (C) {
        var y = o.getOptionValue(u);
        o.setValue(g.filter(function(M) {
          return o.getOptionValue(M) !== y;
        }), "deselect-option", u);
      } else if (!v)
        h ? o.setValue([].concat(c7(g), [u]), "select-option", u) : o.setValue(u, "select-option");
      else {
        o.ariaOnChange(u, {
          action: "select-option",
          option: u,
          name: p
        });
        return;
      }
      f && o.blurInput();
    }, o.removeValue = function(u) {
      var d = o.props.isMulti, f = o.state.selectValue, h = o.getOptionValue(u), p = f.filter(function(C) {
        return o.getOptionValue(C) !== h;
      }), g = Bf(d, p, p[0] || null);
      o.onChange(g, {
        action: "remove-value",
        removedValue: u
      }), o.focusInput();
    }, o.clearValue = function() {
      var u = o.state.selectValue;
      o.onChange(Bf(o.props.isMulti, [], null), {
        action: "clear",
        removedValues: u
      });
    }, o.popValue = function() {
      var u = o.props.isMulti, d = o.state.selectValue, f = d[d.length - 1], h = d.slice(0, d.length - 1), p = Bf(u, h, h[0] || null);
      o.onChange(p, {
        action: "pop-value",
        removedValue: f
      });
    }, o.getFocusedOptionId = function(u) {
      return h5(o.state.focusableOptionsWithIds, u);
    }, o.getFocusableOptionsWithIds = function() {
      return Ly(u2(o.props, o.state.selectValue), o.getElementId("option"));
    }, o.getValue = function() {
      return o.state.selectValue;
    }, o.cx = function() {
      for (var u = arguments.length, d = new Array(u), f = 0; f < u; f++)
        d[f] = arguments[f];
      return bge.apply(void 0, [o.props.classNamePrefix].concat(d));
    }, o.getOptionLabel = function(u) {
      return OR(o.props, u);
    }, o.getOptionValue = function(u) {
      return Ch(o.props, u);
    }, o.getStyles = function(u, d) {
      var f = o.props.unstyled, h = w3e[u](d, f);
      h.boxSizing = "border-box";
      var p = o.props.styles[u];
      return p ? p(h, d) : h;
    }, o.getClassNames = function(u, d) {
      var f, h;
      return (f = (h = o.props.classNames)[u]) === null || f === void 0 ? void 0 : f.call(h, d);
    }, o.getElementId = function(u) {
      return "".concat(o.state.instancePrefix, "-").concat(u);
    }, o.getComponents = function() {
      return j5e(o.props);
    }, o.buildCategorizedOptions = function() {
      return u2(o.props, o.state.selectValue);
    }, o.getCategorizedOptions = function() {
      return o.props.menuIsOpen ? o.buildCategorizedOptions() : [];
    }, o.buildFocusableOptions = function() {
      return VR(o.buildCategorizedOptions());
    }, o.getFocusableOptions = function() {
      return o.props.menuIsOpen ? o.buildFocusableOptions() : [];
    }, o.ariaOnChange = function(u, d) {
      o.setState({
        ariaSelection: ot({
          value: u
        }, d)
      });
    }, o.onMenuMouseDown = function(u) {
      u.button === 0 && (u.stopPropagation(), u.preventDefault(), o.focusInput());
    }, o.onMenuMouseMove = function(u) {
      o.blockOptionHover = !1;
    }, o.onControlMouseDown = function(u) {
      if (!u.defaultPrevented) {
        var d = o.props.openMenuOnClick;
        o.state.isFocused ? o.props.menuIsOpen ? u.target.tagName !== "INPUT" && u.target.tagName !== "TEXTAREA" && o.onMenuClose() : d && o.openMenu("first") : (d && (o.openAfterFocus = !0), o.focusInput()), u.target.tagName !== "INPUT" && u.target.tagName !== "TEXTAREA" && u.preventDefault();
      }
    }, o.onDropdownIndicatorMouseDown = function(u) {
      if (!(u && u.type === "mousedown" && u.button !== 0) && !o.props.isDisabled) {
        var d = o.props, f = d.isMulti, h = d.menuIsOpen;
        o.focusInput(), h ? (o.setState({
          inputIsHiddenAfterUpdate: !f
        }), o.onMenuClose()) : o.openMenu("first"), u.preventDefault();
      }
    }, o.onClearIndicatorMouseDown = function(u) {
      u && u.type === "mousedown" && u.button !== 0 || (o.clearValue(), u.preventDefault(), o.openAfterFocus = !1, u.type === "touchend" ? o.focusInput() : setTimeout(function() {
        return o.focusInput();
      }));
    }, o.onScroll = function(u) {
      typeof o.props.closeMenuOnScroll == "boolean" ? u.target instanceof HTMLElement && Lm(u.target) && o.props.onMenuClose() : typeof o.props.closeMenuOnScroll == "function" && o.props.closeMenuOnScroll(u) && o.props.onMenuClose();
    }, o.onCompositionStart = function() {
      o.isComposing = !0;
    }, o.onCompositionEnd = function() {
      o.isComposing = !1;
    }, o.onTouchStart = function(u) {
      var d = u.touches, f = d && d.item(0);
      f && (o.initialTouchX = f.clientX, o.initialTouchY = f.clientY, o.userIsDragging = !1);
    }, o.onTouchMove = function(u) {
      var d = u.touches, f = d && d.item(0);
      if (f) {
        var h = Math.abs(f.clientX - o.initialTouchX), p = Math.abs(f.clientY - o.initialTouchY), g = 5;
        o.userIsDragging = h > g || p > g;
      }
    }, o.onTouchEnd = function(u) {
      o.userIsDragging || (o.controlRef && !o.controlRef.contains(u.target) && o.menuListRef && !o.menuListRef.contains(u.target) && o.blurInput(), o.initialTouchX = 0, o.initialTouchY = 0);
    }, o.onControlTouchEnd = function(u) {
      o.userIsDragging || o.onControlMouseDown(u);
    }, o.onClearIndicatorTouchEnd = function(u) {
      o.userIsDragging || o.onClearIndicatorMouseDown(u);
    }, o.onDropdownIndicatorTouchEnd = function(u) {
      o.userIsDragging || o.onDropdownIndicatorMouseDown(u);
    }, o.handleInputChange = function(u) {
      var d = o.props.inputValue, f = u.currentTarget.value;
      o.setState({
        inputIsHiddenAfterUpdate: !1
      }), o.onInputChange(f, {
        action: "input-change",
        prevInputValue: d
      }), o.props.menuIsOpen || o.onMenuOpen();
    }, o.onInputFocus = function(u) {
      o.props.onFocus && o.props.onFocus(u), o.setState({
        inputIsHiddenAfterUpdate: !1,
        isFocused: !0
      }), (o.openAfterFocus || o.props.openMenuOnFocus) && o.openMenu("first"), o.openAfterFocus = !1;
    }, o.onInputBlur = function(u) {
      var d = o.props.inputValue;
      if (o.menuListRef && o.menuListRef.contains(document.activeElement)) {
        o.inputRef.focus();
        return;
      }
      o.props.onBlur && o.props.onBlur(u), o.onInputChange("", {
        action: "input-blur",
        prevInputValue: d
      }), o.onMenuClose(), o.setState({
        focusedValue: null,
        isFocused: !1
      });
    }, o.onOptionHover = function(u) {
      if (!(o.blockOptionHover || o.state.focusedOption === u)) {
        var d = o.getFocusableOptions(), f = d.indexOf(u);
        o.setState({
          focusedOption: u,
          focusedOptionId: f > -1 ? o.getFocusedOptionId(u) : null
        });
      }
    }, o.shouldHideSelectedOptions = function() {
      return GR(o.props);
    }, o.onValueInputFocus = function(u) {
      u.preventDefault(), u.stopPropagation(), o.focus();
    }, o.onKeyDown = function(u) {
      var d = o.props, f = d.isMulti, h = d.backspaceRemovesValue, p = d.escapeClearsValue, g = d.inputValue, C = d.isClearable, v = d.isDisabled, y = d.menuIsOpen, M = d.onKeyDown, x = d.tabSelectsValue, _ = d.openMenuOnFocus, L = o.state, R = L.focusedOption, k = L.focusedValue, P = L.selectValue;
      if (!v && !(typeof M == "function" && (M(u), u.defaultPrevented))) {
        switch (o.blockOptionHover = !0, u.key) {
          case "ArrowLeft":
            if (!f || g)
              return;
            o.focusValue("previous");
            break;
          case "ArrowRight":
            if (!f || g)
              return;
            o.focusValue("next");
            break;
          case "Delete":
          case "Backspace":
            if (g)
              return;
            if (k)
              o.removeValue(k);
            else {
              if (!h)
                return;
              f ? o.popValue() : C && o.clearValue();
            }
            break;
          case "Tab":
            if (o.isComposing || u.shiftKey || !y || !x || !R || // don't capture the event if the menu opens on focus and the focused
            // option is already selected; it breaks the flow of navigation
            _ && o.isOptionSelected(R, P))
              return;
            o.selectOption(R);
            break;
          case "Enter":
            if (u.keyCode === 229)
              break;
            if (y) {
              if (!R || o.isComposing)
                return;
              o.selectOption(R);
              break;
            }
            return;
          case "Escape":
            y ? (o.setState({
              inputIsHiddenAfterUpdate: !1
            }), o.onInputChange("", {
              action: "menu-close",
              prevInputValue: g
            }), o.onMenuClose()) : C && p && o.clearValue();
            break;
          case " ":
            if (g)
              return;
            if (!y) {
              o.openMenu("first");
              break;
            }
            if (!R)
              return;
            o.selectOption(R);
            break;
          case "ArrowUp":
            y ? o.focusOption("up") : o.openMenu("last");
            break;
          case "ArrowDown":
            y ? o.focusOption("down") : o.openMenu("first");
            break;
          case "PageUp":
            if (!y)
              return;
            o.focusOption("pageup");
            break;
          case "PageDown":
            if (!y)
              return;
            o.focusOption("pagedown");
            break;
          case "Home":
            if (!y)
              return;
            o.focusOption("first");
            break;
          case "End":
            if (!y)
              return;
            o.focusOption("last");
            break;
          default:
            return;
        }
        u.preventDefault();
      }
    }, o.state.instancePrefix = "react-select-" + (o.props.instanceId || ++k3e), o.state.selectValue = hy(r.value), r.menuIsOpen && o.state.selectValue.length) {
      var a = o.getFocusableOptionsWithIds(), i = o.buildFocusableOptions(), l = i.indexOf(o.state.selectValue[0]);
      o.state.focusableOptionsWithIds = a, o.state.focusedOption = i[l], o.state.focusedOptionId = h5(a, i[l]);
    }
    return o;
  }
  return lme(n, [{
    key: "componentDidMount",
    value: function() {
      this.startListeningComposition(), this.startListeningToTouch(), this.props.closeMenuOnScroll && document && document.addEventListener && document.addEventListener("scroll", this.onScroll, !0), this.props.autoFocus && this.focusInput(), this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef && my(this.menuListRef, this.focusedOptionRef);
    }
  }, {
    key: "componentDidUpdate",
    value: function(o) {
      var a = this.props, i = a.isDisabled, l = a.menuIsOpen, u = this.state.isFocused;
      // ensure focus is restored correctly when the control becomes enabled
      (u && !i && o.isDisabled || // ensure focus is on the Input when the menu opens
      u && l && !o.menuIsOpen) && this.focusInput(), u && i && !o.isDisabled ? this.setState({
        isFocused: !1
      }, this.onMenuClose) : !u && !i && o.isDisabled && this.inputRef === document.activeElement && this.setState({
        isFocused: !0
      }), this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate && (my(this.menuListRef, this.focusedOptionRef), this.scrollToFocusedOptionOnUpdate = !1);
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.stopListeningComposition(), this.stopListeningToTouch(), document.removeEventListener("scroll", this.onScroll, !0);
    }
    // ==============================
    // Consumer Handlers
    // ==============================
  }, {
    key: "onMenuOpen",
    value: function() {
      this.props.onMenuOpen();
    }
  }, {
    key: "onMenuClose",
    value: function() {
      this.onInputChange("", {
        action: "menu-close",
        prevInputValue: this.props.inputValue
      }), this.props.onMenuClose();
    }
  }, {
    key: "onInputChange",
    value: function(o, a) {
      this.props.onInputChange(o, a);
    }
    // ==============================
    // Methods
    // ==============================
  }, {
    key: "focusInput",
    value: function() {
      this.inputRef && this.inputRef.focus();
    }
  }, {
    key: "blurInput",
    value: function() {
      this.inputRef && this.inputRef.blur();
    }
    // aliased for consumers
  }, {
    key: "openMenu",
    value: function(o) {
      var a = this, i = this.state, l = i.selectValue, u = i.isFocused, d = this.buildFocusableOptions(), f = o === "first" ? 0 : d.length - 1;
      if (!this.props.isMulti) {
        var h = d.indexOf(l[0]);
        h > -1 && (f = h);
      }
      this.scrollToFocusedOptionOnUpdate = !(u && this.menuListRef), this.setState({
        inputIsHiddenAfterUpdate: !1,
        focusedValue: null,
        focusedOption: d[f],
        focusedOptionId: this.getFocusedOptionId(d[f])
      }, function() {
        return a.onMenuOpen();
      });
    }
  }, {
    key: "focusValue",
    value: function(o) {
      var a = this.state, i = a.selectValue, l = a.focusedValue;
      if (this.props.isMulti) {
        this.setState({
          focusedOption: null
        });
        var u = i.indexOf(l);
        l || (u = -1);
        var d = i.length - 1, f = -1;
        if (i.length) {
          switch (o) {
            case "previous":
              u === 0 ? f = 0 : u === -1 ? f = d : f = u - 1;
              break;
            case "next":
              u > -1 && u < d && (f = u + 1);
              break;
          }
          this.setState({
            inputIsHidden: f !== -1,
            focusedValue: i[f]
          });
        }
      }
    }
  }, {
    key: "focusOption",
    value: function() {
      var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "first", a = this.props.pageSize, i = this.state.focusedOption, l = this.getFocusableOptions();
      if (l.length) {
        var u = 0, d = l.indexOf(i);
        i || (d = -1), o === "up" ? u = d > 0 ? d - 1 : l.length - 1 : o === "down" ? u = (d + 1) % l.length : o === "pageup" ? (u = d - a, u < 0 && (u = 0)) : o === "pagedown" ? (u = d + a, u > l.length - 1 && (u = l.length - 1)) : o === "last" && (u = l.length - 1), this.scrollToFocusedOptionOnUpdate = !0, this.setState({
          focusedOption: l[u],
          focusedValue: null,
          focusedOptionId: this.getFocusedOptionId(l[u])
        });
      }
    }
  }, {
    key: "getTheme",
    value: (
      // ==============================
      // Getters
      // ==============================
      function() {
        return this.props.theme ? typeof this.props.theme == "function" ? this.props.theme(f5) : ot(ot({}, f5), this.props.theme) : f5;
      }
    )
  }, {
    key: "getCommonProps",
    value: function() {
      var o = this.clearValue, a = this.cx, i = this.getStyles, l = this.getClassNames, u = this.getValue, d = this.selectOption, f = this.setValue, h = this.props, p = h.isMulti, g = h.isRtl, C = h.options, v = this.hasValue();
      return {
        clearValue: o,
        cx: a,
        getStyles: i,
        getClassNames: l,
        getValue: u,
        hasValue: v,
        isMulti: p,
        isRtl: g,
        options: C,
        selectOption: d,
        selectProps: h,
        setValue: f,
        theme: this.getTheme()
      };
    }
  }, {
    key: "hasValue",
    value: function() {
      var o = this.state.selectValue;
      return o.length > 0;
    }
  }, {
    key: "hasOptions",
    value: function() {
      return !!this.getFocusableOptions().length;
    }
  }, {
    key: "isClearable",
    value: function() {
      var o = this.props, a = o.isClearable, i = o.isMulti;
      return a === void 0 ? i : a;
    }
  }, {
    key: "isOptionDisabled",
    value: function(o, a) {
      return FR(this.props, o, a);
    }
  }, {
    key: "isOptionSelected",
    value: function(o, a) {
      return BR(this.props, o, a);
    }
  }, {
    key: "filterOption",
    value: function(o, a) {
      return HR(this.props, o, a);
    }
  }, {
    key: "formatOptionLabel",
    value: function(o, a) {
      if (typeof this.props.formatOptionLabel == "function") {
        var i = this.props.inputValue, l = this.state.selectValue;
        return this.props.formatOptionLabel(o, {
          context: a,
          inputValue: i,
          selectValue: l
        });
      } else
        return this.getOptionLabel(o);
    }
  }, {
    key: "formatGroupLabel",
    value: function(o) {
      return this.props.formatGroupLabel(o);
    }
    // ==============================
    // Mouse Handlers
    // ==============================
  }, {
    key: "startListeningComposition",
    value: (
      // ==============================
      // Composition Handlers
      // ==============================
      function() {
        document && document.addEventListener && (document.addEventListener("compositionstart", this.onCompositionStart, !1), document.addEventListener("compositionend", this.onCompositionEnd, !1));
      }
    )
  }, {
    key: "stopListeningComposition",
    value: function() {
      document && document.removeEventListener && (document.removeEventListener("compositionstart", this.onCompositionStart), document.removeEventListener("compositionend", this.onCompositionEnd));
    }
  }, {
    key: "startListeningToTouch",
    value: (
      // ==============================
      // Touch Handlers
      // ==============================
      function() {
        document && document.addEventListener && (document.addEventListener("touchstart", this.onTouchStart, !1), document.addEventListener("touchmove", this.onTouchMove, !1), document.addEventListener("touchend", this.onTouchEnd, !1));
      }
    )
  }, {
    key: "stopListeningToTouch",
    value: function() {
      document && document.removeEventListener && (document.removeEventListener("touchstart", this.onTouchStart), document.removeEventListener("touchmove", this.onTouchMove), document.removeEventListener("touchend", this.onTouchEnd));
    }
  }, {
    key: "renderInput",
    value: (
      // ==============================
      // Renderers
      // ==============================
      function() {
        var o = this.props, a = o.isDisabled, i = o.isSearchable, l = o.inputId, u = o.inputValue, d = o.tabIndex, f = o.form, h = o.menuIsOpen, p = o.required, g = this.getComponents(), C = g.Input, v = this.state, y = v.inputIsHidden, M = v.ariaSelection, x = this.commonProps, _ = l || this.getElementId("input"), L = ot(ot(ot({
          "aria-autocomplete": "list",
          "aria-expanded": h,
          "aria-haspopup": !0,
          "aria-errormessage": this.props["aria-errormessage"],
          "aria-invalid": this.props["aria-invalid"],
          "aria-label": this.props["aria-label"],
          "aria-labelledby": this.props["aria-labelledby"],
          "aria-required": p,
          role: "combobox",
          "aria-activedescendant": this.isAppleDevice ? void 0 : this.state.focusedOptionId || ""
        }, h && {
          "aria-controls": this.getElementId("listbox")
        }), !i && {
          "aria-readonly": !0
        }), this.hasValue() ? (M == null ? void 0 : M.action) === "initial-input-focus" && {
          "aria-describedby": this.getElementId("live-region")
        } : {
          "aria-describedby": this.getElementId("placeholder")
        });
        return i ? /* @__PURE__ */ Ee.createElement(C, et({}, x, {
          autoCapitalize: "none",
          autoComplete: "off",
          autoCorrect: "off",
          id: _,
          innerRef: this.getInputRef,
          isDisabled: a,
          isHidden: y,
          onBlur: this.onInputBlur,
          onChange: this.handleInputChange,
          onFocus: this.onInputFocus,
          spellCheck: "false",
          tabIndex: d,
          form: f,
          type: "text",
          value: u
        }, L)) : /* @__PURE__ */ Ee.createElement(a3e, et({
          id: _,
          innerRef: this.getInputRef,
          onBlur: this.onInputBlur,
          onChange: gh,
          onFocus: this.onInputFocus,
          disabled: a,
          tabIndex: d,
          inputMode: "none",
          form: f,
          value: ""
        }, L));
      }
    )
  }, {
    key: "renderPlaceholderOrValue",
    value: function() {
      var o = this, a = this.getComponents(), i = a.MultiValue, l = a.MultiValueContainer, u = a.MultiValueLabel, d = a.MultiValueRemove, f = a.SingleValue, h = a.Placeholder, p = this.commonProps, g = this.props, C = g.controlShouldRenderValue, v = g.isDisabled, y = g.isMulti, M = g.inputValue, x = g.placeholder, _ = this.state, L = _.selectValue, R = _.focusedValue, k = _.isFocused;
      if (!this.hasValue() || !C)
        return M ? null : /* @__PURE__ */ Ee.createElement(h, et({}, p, {
          key: "placeholder",
          isDisabled: v,
          isFocused: k,
          innerProps: {
            id: this.getElementId("placeholder")
          }
        }), x);
      if (y)
        return L.map(function(N, O) {
          var H = N === R, $ = "".concat(o.getOptionLabel(N), "-").concat(o.getOptionValue(N));
          return /* @__PURE__ */ Ee.createElement(i, et({}, p, {
            components: {
              Container: l,
              Label: u,
              Remove: d
            },
            isFocused: H,
            isDisabled: v,
            key: $,
            index: O,
            removeProps: {
              onClick: function() {
                return o.removeValue(N);
              },
              onTouchEnd: function() {
                return o.removeValue(N);
              },
              onMouseDown: function(ie) {
                ie.preventDefault();
              }
            },
            data: N
          }), o.formatOptionLabel(N, "value"));
        });
      if (M)
        return null;
      var P = L[0];
      return /* @__PURE__ */ Ee.createElement(f, et({}, p, {
        data: P,
        isDisabled: v
      }), this.formatOptionLabel(P, "value"));
    }
  }, {
    key: "renderClearIndicator",
    value: function() {
      var o = this.getComponents(), a = o.ClearIndicator, i = this.commonProps, l = this.props, u = l.isDisabled, d = l.isLoading, f = this.state.isFocused;
      if (!this.isClearable() || !a || u || !this.hasValue() || d)
        return null;
      var h = {
        onMouseDown: this.onClearIndicatorMouseDown,
        onTouchEnd: this.onClearIndicatorTouchEnd,
        "aria-hidden": "true"
      };
      return /* @__PURE__ */ Ee.createElement(a, et({}, i, {
        innerProps: h,
        isFocused: f
      }));
    }
  }, {
    key: "renderLoadingIndicator",
    value: function() {
      var o = this.getComponents(), a = o.LoadingIndicator, i = this.commonProps, l = this.props, u = l.isDisabled, d = l.isLoading, f = this.state.isFocused;
      if (!a || !d)
        return null;
      var h = {
        "aria-hidden": "true"
      };
      return /* @__PURE__ */ Ee.createElement(a, et({}, i, {
        innerProps: h,
        isDisabled: u,
        isFocused: f
      }));
    }
  }, {
    key: "renderIndicatorSeparator",
    value: function() {
      var o = this.getComponents(), a = o.DropdownIndicator, i = o.IndicatorSeparator;
      if (!a || !i)
        return null;
      var l = this.commonProps, u = this.props.isDisabled, d = this.state.isFocused;
      return /* @__PURE__ */ Ee.createElement(i, et({}, l, {
        isDisabled: u,
        isFocused: d
      }));
    }
  }, {
    key: "renderDropdownIndicator",
    value: function() {
      var o = this.getComponents(), a = o.DropdownIndicator;
      if (!a)
        return null;
      var i = this.commonProps, l = this.props.isDisabled, u = this.state.isFocused, d = {
        onMouseDown: this.onDropdownIndicatorMouseDown,
        onTouchEnd: this.onDropdownIndicatorTouchEnd,
        "aria-hidden": "true"
      };
      return /* @__PURE__ */ Ee.createElement(a, et({}, i, {
        innerProps: d,
        isDisabled: l,
        isFocused: u
      }));
    }
  }, {
    key: "renderMenu",
    value: function() {
      var o = this, a = this.getComponents(), i = a.Group, l = a.GroupHeading, u = a.Menu, d = a.MenuList, f = a.MenuPortal, h = a.LoadingMessage, p = a.NoOptionsMessage, g = a.Option, C = this.commonProps, v = this.state.focusedOption, y = this.props, M = y.captureMenuScroll, x = y.inputValue, _ = y.isLoading, L = y.loadingMessage, R = y.minMenuHeight, k = y.maxMenuHeight, P = y.menuIsOpen, N = y.menuPlacement, O = y.menuPosition, H = y.menuPortalTarget, $ = y.menuShouldBlockScroll, ne = y.menuShouldScrollIntoView, ie = y.noOptionsMessage, re = y.onMenuScrollToTop, ve = y.onMenuScrollToBottom;
      if (!P)
        return null;
      var ue = function(X, he) {
        var me = X.type, de = X.data, Le = X.isDisabled, Ie = X.isSelected, Ne = X.label, ye = X.value, ke = v === de, oe = Le ? void 0 : function() {
          return o.onOptionHover(de);
        }, lt = Le ? void 0 : function() {
          return o.selectOption(de);
        }, Re = "".concat(o.getElementId("option"), "-").concat(he), _t = {
          id: Re,
          onClick: lt,
          onMouseMove: oe,
          onMouseOver: oe,
          tabIndex: -1,
          role: "option",
          "aria-selected": o.isAppleDevice ? void 0 : Ie
          // is not supported on Apple devices
        };
        return /* @__PURE__ */ Ee.createElement(g, et({}, C, {
          innerProps: _t,
          data: de,
          isDisabled: Le,
          isSelected: Ie,
          key: Re,
          label: Ne,
          type: me,
          value: ye,
          isFocused: ke,
          innerRef: ke ? o.getFocusedOptionRef : void 0
        }), o.formatOptionLabel(X.data, "menu"));
      }, j;
      if (this.hasOptions())
        j = this.getCategorizedOptions().map(function(ge) {
          if (ge.type === "group") {
            var X = ge.data, he = ge.options, me = ge.index, de = "".concat(o.getElementId("group"), "-").concat(me), Le = "".concat(de, "-heading");
            return /* @__PURE__ */ Ee.createElement(i, et({}, C, {
              key: de,
              data: X,
              options: he,
              Heading: l,
              headingProps: {
                id: Le,
                data: ge.data
              },
              label: o.formatGroupLabel(ge.data)
            }), ge.options.map(function(Ie) {
              return ue(Ie, "".concat(me, "-").concat(Ie.index));
            }));
          } else if (ge.type === "option")
            return ue(ge, "".concat(ge.index));
        });
      else if (_) {
        var K = L({
          inputValue: x
        });
        if (K === null)
          return null;
        j = /* @__PURE__ */ Ee.createElement(h, C, K);
      } else {
        var ce = ie({
          inputValue: x
        });
        if (ce === null)
          return null;
        j = /* @__PURE__ */ Ee.createElement(p, C, ce);
      }
      var U = {
        minMenuHeight: R,
        maxMenuHeight: k,
        menuPlacement: N,
        menuPosition: O,
        menuShouldScrollIntoView: ne
      }, q = /* @__PURE__ */ Ee.createElement(kge, et({}, C, U), function(ge) {
        var X = ge.ref, he = ge.placerProps, me = he.placement, de = he.maxHeight;
        return /* @__PURE__ */ Ee.createElement(u, et({}, C, U, {
          innerRef: X,
          innerProps: {
            onMouseDown: o.onMenuMouseDown,
            onMouseMove: o.onMenuMouseMove
          },
          isLoading: _,
          placement: me
        }), /* @__PURE__ */ Ee.createElement(f3e, {
          captureEnabled: M,
          onTopArrive: re,
          onBottomArrive: ve,
          lockEnabled: $
        }, function(Le) {
          return /* @__PURE__ */ Ee.createElement(d, et({}, C, {
            innerRef: function(Ne) {
              o.getMenuListRef(Ne), Le(Ne);
            },
            innerProps: {
              role: "listbox",
              "aria-multiselectable": C.isMulti,
              id: o.getElementId("listbox")
            },
            isLoading: _,
            maxHeight: de,
            focusedOption: v
          }), j);
        }));
      });
      return H || O === "fixed" ? /* @__PURE__ */ Ee.createElement(f, et({}, C, {
        appendTo: H,
        controlElement: this.controlRef,
        menuPlacement: N,
        menuPosition: O
      }), q) : q;
    }
  }, {
    key: "renderFormField",
    value: function() {
      var o = this, a = this.props, i = a.delimiter, l = a.isDisabled, u = a.isMulti, d = a.name, f = a.required, h = this.state.selectValue;
      if (f && !this.hasValue() && !l)
        return /* @__PURE__ */ Ee.createElement(g3e, {
          name: d,
          onFocus: this.onValueInputFocus
        });
      if (!(!d || l))
        if (u)
          if (i) {
            var p = h.map(function(v) {
              return o.getOptionValue(v);
            }).join(i);
            return /* @__PURE__ */ Ee.createElement("input", {
              name: d,
              type: "hidden",
              value: p
            });
          } else {
            var g = h.length > 0 ? h.map(function(v, y) {
              return /* @__PURE__ */ Ee.createElement("input", {
                key: "i-".concat(y),
                name: d,
                type: "hidden",
                value: o.getOptionValue(v)
              });
            }) : /* @__PURE__ */ Ee.createElement("input", {
              name: d,
              type: "hidden",
              value: ""
            });
            return /* @__PURE__ */ Ee.createElement("div", null, g);
          }
        else {
          var C = h[0] ? this.getOptionValue(h[0]) : "";
          return /* @__PURE__ */ Ee.createElement("input", {
            name: d,
            type: "hidden",
            value: C
          });
        }
    }
  }, {
    key: "renderLiveRegion",
    value: function() {
      var o = this.commonProps, a = this.state, i = a.ariaSelection, l = a.focusedOption, u = a.focusedValue, d = a.isFocused, f = a.selectValue, h = this.getFocusableOptions();
      return /* @__PURE__ */ Ee.createElement(Q5e, et({}, o, {
        id: this.getElementId("live-region"),
        ariaSelection: i,
        focusedOption: l,
        focusedValue: u,
        isFocused: d,
        selectValue: f,
        focusableOptions: h,
        isAppleDevice: this.isAppleDevice
      }));
    }
  }, {
    key: "render",
    value: function() {
      var o = this.getComponents(), a = o.Control, i = o.IndicatorsContainer, l = o.SelectContainer, u = o.ValueContainer, d = this.props, f = d.className, h = d.id, p = d.isDisabled, g = d.menuIsOpen, C = this.state.isFocused, v = this.commonProps = this.getCommonProps();
      return /* @__PURE__ */ Ee.createElement(l, et({}, v, {
        className: f,
        innerProps: {
          id: h,
          onKeyDown: this.onKeyDown
        },
        isDisabled: p,
        isFocused: C
      }), this.renderLiveRegion(), /* @__PURE__ */ Ee.createElement(a, et({}, v, {
        innerRef: this.getControlRef,
        innerProps: {
          onMouseDown: this.onControlMouseDown,
          onTouchEnd: this.onControlTouchEnd
        },
        isDisabled: p,
        isFocused: C,
        menuIsOpen: g
      }), /* @__PURE__ */ Ee.createElement(u, et({}, v, {
        isDisabled: p
      }), this.renderPlaceholderOrValue(), this.renderInput()), /* @__PURE__ */ Ee.createElement(i, et({}, v, {
        isDisabled: p
      }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(o, a) {
      var i = a.prevProps, l = a.clearFocusValueOnUpdate, u = a.inputIsHiddenAfterUpdate, d = a.ariaSelection, f = a.isFocused, h = a.prevWasFocused, p = a.instancePrefix, g = o.options, C = o.value, v = o.menuIsOpen, y = o.inputValue, M = o.isMulti, x = hy(C), _ = {};
      if (i && (C !== i.value || g !== i.options || v !== i.menuIsOpen || y !== i.inputValue)) {
        var L = v ? E3e(o, x) : [], R = v ? Ly(u2(o, x), "".concat(p, "-option")) : [], k = l ? T3e(a, x) : null, P = N3e(a, L), N = h5(R, P);
        _ = {
          selectValue: x,
          focusedOption: P,
          focusedOptionId: N,
          focusableOptionsWithIds: R,
          focusedValue: k,
          clearFocusValueOnUpdate: !1
        };
      }
      var O = u != null && o !== i ? {
        inputIsHidden: u,
        inputIsHiddenAfterUpdate: void 0
      } : {}, H = d, $ = f && h;
      return f && !$ && (H = {
        value: Bf(M, x, x[0] || null),
        options: x,
        action: "initial-input-focus"
      }, $ = !h), (d == null ? void 0 : d.action) === "initial-input-focus" && (H = null), ot(ot(ot({}, _), O), {}, {
        prevProps: o,
        ariaSelection: H,
        prevWasFocused: $
      });
    }
  }]), n;
}(NV);
$R.defaultProps = P3e;
var V3e = /* @__PURE__ */ Ke(function(e, t) {
  var n = ege(e);
  return /* @__PURE__ */ Ee.createElement($R, et({
    ref: t
  }, n));
}), ZR = V3e;
const jR = ({
  children: e,
  onMouseDown: t
}) => /* @__PURE__ */ A.jsx(
  fc,
  {
    paddingX: "5px",
    height: "100%",
    justifyContent: "center",
    alignItems: "center",
    onMouseDown: t,
    children: e
  }
), WR = ({
  innerProps: e
}) => /* @__PURE__ */ A.jsx(jR, { ...e, children: /* @__PURE__ */ A.jsx(Xo, { icon: "close" }) }), zR = () => /* @__PURE__ */ A.jsx(jR, { children: /* @__PURE__ */ A.jsx(Xo, { icon: "arrow-down-s" }) }), Dy = (e, { isFocused: t }) => ({
  "&:hover": {
    borderColor: e ? Hr.alertError : t ? Hr.selected2 : Hr.hover2
  },
  boxShadow: t ? e ? `inset 0 0 0 1px ${Hr.alertError}` : `inset 0 0 0 1px ${Hr.selected2}` : "none"
}), O3e = (e, t, n, r) => e === "grid" ? {
  borderRadius: "0px",
  border: "1px solid transparent",
  minHeight: "25px",
  height: "100%",
  // consume all space if grid row is more than one line
  // body-2
  fontSize: "0.75rem",
  fontWeight: "400",
  backgroundColor: n ? Hr.alertWarningLight : "transparent",
  outline: "none !important",
  ...Dy(n, r)
} : {
  minHeight: {
    xs: "1.5rem",
    sm: "2rem",
    md: "2.75rem",
    lg: "3rem"
  }[t],
  height: "100%",
  borderColor: n ? Hr.alertError : Hr.strokeDefault,
  ...Dy(n, r)
}, UR = (e, t, n, r) => ({ minHeight: o, ...a }, i) => ({
  ...a,
  ...O3e(e, t, n, i),
  ...r,
  alignItems: "center"
}), F3e = (e, t) => e === "grid" ? { fontSize: "12px" } : { fontSize: {
  xs: "12px",
  sm: "14px",
  md: "16px",
  lg: "18px"
}[t] }, XR = (e, t) => ({ margin: n, ...r }, o) => ({ ...r, ...F3e(e, t) }), YR = (e, t, n, r) => ({ ...o }) => ({
  ...o,
  ...r
}), B3e = (e, t) => e === "grid" ? { fontSize: "12px" } : { fontSize: {
  xs: "12px",
  sm: "14px",
  md: "16px",
  lg: "18px"
}[t] }, qR = (e, t) => ({ margin: n, ...r }, o) => ({ ...r, ...B3e(e, t) }), H3e = (e, t) => {
  if (e === "grid")
    return { padding: ".125rem", gap: ".125rem" };
  switch (t) {
    case "xs":
      return { padding: ".125rem", gap: ".125rem", minHeight: "1.5rem" };
    case "sm":
      return { padding: ".25rem", gap: ".25rem" };
    case "md":
      return { padding: ".5rem", gap: ".375rem" };
    case "lg":
      return { padding: ".625Rem", gap: ".5rem" };
    default:
      h0e(t);
  }
}, JR = (e, t) => (n, r) => ({
  ...n,
  ...H3e(e, t),
  lineHeight: "normal"
}), G3e = (e) => {
  const t = bt(
    () => e.reduce((n, r) => (n[r.value] = r, n), {}),
    [e]
  );
  return Q(
    (n) => Mo(n) ? void 0 : n.map((r) => t[r]),
    []
  );
};
const O4e = Ke((e, t) => {
  const {
    id: n,
    name: r,
    value: o,
    invalid: a,
    onChange: i,
    variant: l = "outline",
    size: u = "md",
    width: d = "100%",
    disabled: f,
    options: h,
    filterOption: p,
    placeholder: g,
    defaultMenuIsOpen: C,
    isClearable: v = !0
  } = e, y = G3e(h), M = Dc(n), { decorate: x } = Rc({ ...e, id: M }), _ = (L) => {
    i == null || i(L.map((R) => R.value));
  };
  return x(
    /* @__PURE__ */ A.jsx(
      ZR,
      {
        id: M,
        ref: t,
        name: r,
        isMulti: !0,
        defaultMenuIsOpen: C ?? !1,
        options: h,
        filterOption: p,
        value: y(o),
        onChange: _,
        isDisabled: f,
        placeholder: g,
        isClearable: v,
        menuShouldScrollIntoView: !1,
        components: { ClearIndicator: WR, DropdownIndicator: zR },
        styles: {
          control: UR(l, u, a, { width: d }),
          input: XR(l, u),
          menu: YR(l, u, a, { width: d }),
          multiValue: qR(l, u),
          valueContainer: JR(l, u)
        }
      }
    )
  );
}), $3e = (e) => {
  const t = bt(
    () => e.reduce((n, r) => (n[r.value] = r, n), {}),
    [e]
  );
  return Q(
    (n) => Mo(n) ? null : t[n],
    []
  );
}, F4e = Ke((e, t) => {
  const {
    id: n,
    name: r,
    value: o,
    invalid: a,
    onChange: i,
    variant: l = "outline",
    size: u = "md",
    width: d = "100%",
    disabled: f,
    options: h,
    filterOption: p,
    placeholder: g,
    defaultMenuIsOpen: C,
    isClearable: v = !0
  } = e, y = $3e(h), M = Dc(n), { decorate: x } = Rc({ ...e, id: M }), _ = (L) => {
    i == null || i((L == null ? void 0 : L.value) ?? "");
  };
  return x(
    /* @__PURE__ */ A.jsx(
      ZR,
      {
        id: M,
        ref: t,
        name: r,
        defaultMenuIsOpen: C ?? !1,
        options: h,
        filterOption: p,
        value: y(o),
        onChange: _,
        isDisabled: f,
        placeholder: g,
        isClearable: v,
        menuShouldScrollIntoView: !1,
        components: { ClearIndicator: WR, DropdownIndicator: zR },
        styles: {
          control: UR(l, u, a, { width: d }),
          input: XR(l, u),
          menu: YR(l, u, a, { width: d }),
          multiValue: qR(l, u),
          valueContainer: JR(l, u)
        }
      }
    )
  );
});
const B4e = Ke((e, t) => {
  const {
    id: n,
    name: r,
    value: o,
    onChange: a,
    onBlur: i,
    width: l = "100%",
    disabled: u,
    min: d,
    max: f,
    step: h = 1
  } = e, p = Dc(n), { decorate: g } = Rc({ ...e, id: p });
  return g(
    /* @__PURE__ */ A.jsxs("div", { className: "simple-range-wrapper", style: { width: l }, children: [
      /* @__PURE__ */ A.jsx("div", { className: "simple-range-selected-fill", children: /* @__PURE__ */ A.jsx(
        "input",
        {
          type: "range",
          min: d,
          max: f,
          value: o,
          step: h,
          onChange: () => null,
          disabled: u,
          tabIndex: -1
        }
      ) }),
      /* @__PURE__ */ A.jsx("div", { className: "simple-range-input", children: /* @__PURE__ */ A.jsx(
        "input",
        {
          id: p,
          ref: t,
          type: "range",
          name: r,
          min: d,
          max: f,
          value: o,
          step: h,
          onChange: a,
          onBlur: i,
          disabled: u
        }
      ) })
    ] })
  );
}), H4e = ({
  children: e,
  className: t,
  ...n
}) => /* @__PURE__ */ A.jsx(C2e, { className: Ur("sound-ui-table-container", t), ...n, children: e }), G4e = ({
  children: e,
  stickyFirstColumn: t,
  variant: n,
  className: r,
  ...o
}) => {
  const a = ["sound-ui-table", r];
  return t && a.push("sticky-first-column"), n === "grid" ? a.push("grid") : a.push("default"), /* @__PURE__ */ A.jsx(Bi, { role: "table", className: Ur(a), ...o, children: e });
}, $4e = ({ children: e, ...t }) => /* @__PURE__ */ A.jsx(Bi, { role: "tbody", ...t, children: e }), Z4e = ({ children: e, ...t }) => /* @__PURE__ */ A.jsx(Bi, { role: "thead", ...t, children: e }), j4e = ({ children: e, ...t }) => /* @__PURE__ */ A.jsx(Bi, { role: "tr", ...t, children: e }), W4e = Ke(
  ({ children: e, ...t }, n) => /* @__PURE__ */ A.jsx(Bi, { role: "th", ref: n, ...t, children: e })
), z4e = Ke(
  ({ children: e, ...t }, n) => /* @__PURE__ */ A.jsx(Bi, { role: "td", ref: n, ...t, children: e })
), U4e = ({
  items: e,
  value: t,
  size: n,
  variant: r,
  disabled: o = !1,
  onChange: a
}) => /* @__PURE__ */ A.jsx("div", { className: "mode-switcher", children: e.map((i) => /* @__PURE__ */ A.jsx(
  o3,
  {
    text: i.label,
    onClick: () => a(i.id),
    disabled: t === i.id || o,
    size: n,
    variant: r,
    icon: i.icon
  },
  i.id
)) });
export {
  p4e as Accordion,
  t4e as Avatar,
  Qw as Badge,
  S2e as Banner,
  y2e as BannerDescription,
  C2e as Block,
  o3 as Button,
  x4e as Card,
  Ere as Checkbox,
  o4e as CheckboxGroup,
  Pre as CopyButton,
  b4e as DatePicker,
  xre as Dot,
  g4e as Drawer,
  P4e as FirstTimeUserExperienceTooltip,
  fc as Flex,
  f4e as Grid,
  s4e as Highlights,
  Xo as Icon,
  R2 as IconButton,
  w4e as Image,
  u4e as Input,
  Z0e as Link,
  h4e as LoadingIndicator,
  b2e as Logo,
  _4e as Menu,
  I4e as MenuButton,
  L4e as MenuItem,
  R4e as MenuList,
  Sme as Modal,
  U4e as ModeSwitcher,
  m4e as OfflineBanner,
  T4e as RadioCardGroup,
  i4e as RadioGroup,
  A4e as ReactTableUI,
  c4e as Select,
  N4e as SimpleInput,
  O4e as SimpleMultiCombo,
  B4e as SimpleRange,
  k4e as SimpleSelect,
  F4e as SimpleSingleCombo,
  V4e as SimpleTextArea,
  e_ as SmallLoader,
  e4e as SoundUIProvider,
  M4e as SplitLayout,
  v4e as Stat,
  n4e as StatusIndicator,
  C4e as Switch,
  EL as SwitchInternalDoNotUse,
  G4e as Table,
  H4e as TableContainer,
  D4e as Tabs,
  $4e as Tbody,
  z4e as Td,
  W4e as Th,
  Z4e as Thead,
  g9 as Tooltip,
  j4e as Tr,
  lo as Typography,
  Vne as appraisifyColors,
  Q3e as appraisifyPDFTheme,
  r4e as buttonSizeToIconSize,
  Hr as colors,
  S4e as createColumnHelper,
  _re as getFillRule,
  gpe as getSortIcon,
  Vpe as hasMask,
  kpe as hasMinMax,
  a4e as iconCategories,
  Ire as icons,
  M0e as isCellProps,
  z0e as isNumberLikeInputType,
  lre as legacyInputStyle,
  E4e as makePxlStr,
  W0e as numberLikeInputTypes,
  Mre as theme,
  d4e as toOpts,
  l4e as typographyVariants,
  m0e as useClickOutside,
  ym as useFormSizeContext,
  y4e as useModal,
  ds as useThemeColor,
  Es as withFormWrapper
};
//# sourceMappingURL=main.mjs.map
